import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AccountForEmail = {
  callerMayLink: Scalars['Boolean'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  isStaffAccount: Scalars['Boolean'];
  linkedBooker?: Maybe<AccountForEmailLinkedBooker>;
  roles: Array<Scalars['String']>;
  userId: Scalars['ID'];
};

export type AccountForEmailLinkedBooker = {
  customerNumber?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
};

export type AccountLinks = {
  bookers: Array<AccountForEmailLinkedBooker>;
  staff: Array<AccountLinksStaff>;
};

export type AccountLinksStaff = {
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
};

export type ActiveDunning = {
  createDate: Scalars['DateTime'];
  currentOpenAmount: Scalars['Float'];
  id: Scalars['ID'];
  level: DunningLevel;
  openAmount: Scalars['Float'];
  scheduledPaymentId?: Maybe<Scalars['ID']>;
  totalAmount: Scalars['Float'];
};

export enum AdditionalItemMode {
  Mandatory = 'Mandatory',
  MandatoryFirstBooking = 'MandatoryFirstBooking',
  Optional = 'Optional'
}

export type AddNamedScheduledPaymentInput = {
  bookingId: Scalars['ID'];
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDue?: Maybe<Scalars['DateTime']>;
  sepaClearance?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type?: Maybe<ScheduledPaymentType>;
};

export type AddPaymentMethodInput = {
  bank?: Maybe<Scalars['String']>;
  bankTransfer?: Maybe<Scalars['Boolean']>;
  bic?: Maybe<Scalars['String']>;
  bookerId: Scalars['String'];
  cash?: Maybe<Scalars['Boolean']>;
  creditCardAccountholder?: Maybe<Scalars['String']>;
  creditcardNumber?: Maybe<Scalars['String']>;
  cvc?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  esr?: Maybe<Scalars['Boolean']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  onlinePayment?: Maybe<Scalars['Boolean']>;
  paypalAccountholder?: Maybe<Scalars['String']>;
  sepaAccountholder?: Maybe<Scalars['String']>;
  type?: Maybe<PaymentTransferType>;
  validFrom?: Maybe<Scalars['DateTime']>;
};

export type Admin = {
  accountHolder?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  joinDate?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  leaveDate?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  salutation?: Maybe<SalutationType>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type AdminManagementEmailInfo = {
  displayName?: Maybe<Scalars['String']>;
  status: AdminManagementEmailStatus;
};

export enum AdminManagementEmailStatus {
  AlreadyAdmin = 'ALREADY_ADMIN',
  ExistingAccount = 'EXISTING_ACCOUNT',
  ExistingStaff = 'EXISTING_STAFF',
  Free = 'FREE',
  Unavailable = 'UNAVAILABLE'
}

export type AdminManagementOverview = {
  adminSeatsLimit: Scalars['Int'];
  adminSeatsUsed: Scalars['Int'];
  users: Array<AdminManagementUser>;
};

export type AdminManagementUser = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  isSelf: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  staffNames: Array<Scalars['String']>;
  userId: Scalars['ID'];
};

export enum AgeError {
  TooOld = 'TooOld',
  TooYoung = 'TooYoung'
}

export type AnalyticsParams = {
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type Announcement = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isDismissible: Scalars['Boolean'];
  isMinimizable: Scalars['Boolean'];
  koOrganizationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  priority: AnnouncementPriority;
  targetUrl?: Maybe<Scalars['String']>;
  targetUrlLabel?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: AnnouncementType;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export enum AnnouncementPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum AnnouncementType {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning'
}

export type AreaIssue = {
  id: Scalars['ID'];
  kind: Scalars['String'];
  lesson: AreaIssueLesson;
  location: AreaIssueLocation;
  person?: Maybe<AreaIssuePerson>;
};

export type AreaIssueLesson = {
  courseName: Scalars['String'];
  id: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
};

export type AreaIssueLocation = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AreaIssuePerson = {
  email?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type AreaManagerAssignedAssistant = {
  assistantId: Scalars['ID'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type AreaManagerAssistantCourseGroup = {
  courseId: Scalars['ID'];
  courseNumber: Scalars['String'];
  courseTypeColor?: Maybe<Scalars['String']>;
  courseTypeName: Scalars['String'];
  dateRangeEnd: Scalars['DateTime'];
  dateRangeStart: Scalars['DateTime'];
  filledSlots: Scalars['Int'];
  lessonCount: Scalars['Int'];
  lessonsFullyStaffed: Scalars['Int'];
  lessonsPartiallyStaffed: Scalars['Int'];
  lessonsWithAssistants: Scalars['Int'];
  maxAssistantsPerLesson: Scalars['Int'];
  needsAssistants: Scalars['Boolean'];
  openSlots: Scalars['Int'];
  totalSlots: Scalars['Int'];
};

export type AreaManagerAssistantHierarchyResult = {
  locations: Array<AreaManagerAssistantLocationGroup>;
};

export type AreaManagerAssistantLessonsInput = {
  courseId: Scalars['ID'];
};

export type AreaManagerAssistantLocationGroup = {
  courseCount: Scalars['Int'];
  courseGroups: Array<AreaManagerAssistantCourseGroup>;
  filledSlots: Scalars['Int'];
  lessonCount: Scalars['Int'];
  lessonsFullyStaffed: Scalars['Int'];
  lessonsPartiallyStaffed: Scalars['Int'];
  lessonsWithAssistants: Scalars['Int'];
  locationId: Scalars['ID'];
  locationName: Scalars['String'];
  openSlots: Scalars['Int'];
  totalSlots: Scalars['Int'];
};

export type AreaManagerAssistantOverview = {
  assignedAssistants: Array<AreaManagerAssignedAssistant>;
  courseLessonId: Scalars['ID'];
  courseName: Scalars['String'];
  courseNumber: Scalars['String'];
  filledSlots: Scalars['Int'];
  openSlots: Scalars['Int'];
  startDateTime: Scalars['DateTime'];
  totalSlots: Scalars['Int'];
};

export type AreaManagerAssistantOverviewResult = {
  items: Array<AreaManagerAssistantOverview>;
  total: Scalars['Int'];
};

export type AreaManagerCourseStats = {
  bookedAttendees: Scalars['Int'];
  courseId: Scalars['ID'];
  courseName?: Maybe<Scalars['String']>;
  courseNumber: Scalars['String'];
  isActive: Scalars['Boolean'];
  locationName: Scalars['String'];
  maxAttendees: Scalars['Int'];
  utilizationPercent: Scalars['Float'];
};

export type AreaManagerCourseStatsResult = {
  items: Array<AreaManagerCourseStats>;
  total: Scalars['Int'];
};

export type AreaManagerInstructorStats = {
  courseCount: Scalars['Int'];
  firstname: Scalars['String'];
  instructorId: Scalars['ID'];
  lastname: Scalars['String'];
  lessonCount: Scalars['Int'];
  totalHours: Scalars['Float'];
};

export type AreaManagerInstructorStatsResult = {
  items: Array<AreaManagerInstructorStats>;
  total: Scalars['Int'];
};

export type AreaManagerLocationStats = {
  activeCourseCount: Scalars['Int'];
  location: Location;
  totalBookedAttendees: Scalars['Int'];
  totalMaxAttendees: Scalars['Int'];
  utilizationPercent: Scalars['Float'];
};

export type AreaManagerLocationStatsResult = {
  items: Array<AreaManagerLocationStats>;
  total: Scalars['Int'];
};

export type AreaManagerStatsInput = {
  locationId?: Maybe<Scalars['ID']>;
  options?: Maybe<ArrayDataOptions>;
};

export type AreaManagerUpcomingLesson = {
  courseName: Scalars['String'];
  courseNumber: Scalars['String'];
  endDateTime: Scalars['DateTime'];
  id: Scalars['ID'];
  prefixedCourseNumber: Scalars['String'];
  startDateTime: Scalars['DateTime'];
};

export type AreaManagerVenueUtilization = {
  locationName: Scalars['String'];
  usedHours: Scalars['Float'];
  venue: Venue;
};

export type AreaManagerVenueUtilizationResult = {
  items: Array<AreaManagerVenueUtilization>;
  total: Scalars['Int'];
};

export type AreaOverviewPool = {
  attendanceRecordedRate: Scalars['Float'];
  city: Scalars['String'];
  id: Scalars['ID'];
  issueCount: Scalars['Int'];
  lessonsToday: Scalars['Int'];
  name: Scalars['String'];
  peopleCount: Scalars['Int'];
};

export type AreaOverviewResult = {
  pools: Array<AreaOverviewPool>;
  week: AreaOverviewWeek;
};

export type AreaOverviewWeek = {
  attendanceRate: Scalars['Float'];
  lessonCount: Scalars['Int'];
  staffedRate: Scalars['Float'];
};

export type AreaPerson = {
  email?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  hasOpenSubstitution: Scalars['Boolean'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
  locations: Array<AreaPersonLocation>;
  phone?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
};

export type AreaPersonLocation = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ArrayDataOptions = {
  filter?: Maybe<Array<FilterOption>>;
  limit?: Maybe<Scalars['Float']>;
  offset?: Maybe<Scalars['Float']>;
  sortColumn?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<SortOrder>;
};

export type AssignAmbiguousPaymentDistributionInput = {
  amount: Scalars['Float'];
  scheduledPaymentId: Scalars['ID'];
};

export type AssignAreaManagerLocationsInput = {
  locationIds: Array<Scalars['ID']>;
  staffId: Scalars['ID'];
};

export type AssignAssistantInput = {
  assistantId: Scalars['ID'];
  courseLessonId: Scalars['ID'];
};

export type AssignedLocationIdInput = {
  id: Scalars['ID'];
};

export type AssignInstructorToLessonInput = {
  courseLessonId: Scalars['ID'];
  instructorId: Scalars['ID'];
};

export type AssistantCourseLesson = {
  assignedAssistants: Array<AssistantInfo>;
  assistantSlotsMax?: Maybe<Scalars['Float']>;
  assistantSlotsUsed: Scalars['Float'];
  courseLesson: CourseLesson;
  isAssignedToMe: Scalars['Boolean'];
};

export type AssistantCourseLessonFilterInput = {
  additionalLocationIds?: Maybe<Array<Scalars['ID']>>;
  city?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  locationId?: Maybe<Scalars['ID']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
};

export type AssistantInfo = {
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type AssistantSelectableLocation = {
  city: Scalars['String'];
  id: Scalars['ID'];
  isAssigned: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Attachment = {
  Base64Content: Scalars['String'];
  ContentType: Scalars['String'];
  Filename: Scalars['String'];
};

export type AttendanceListArchive = {
  courseCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdByUserEmail?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  createdByUserName?: Maybe<Scalars['String']>;
  dateRangeEnd?: Maybe<Scalars['DateTime']>;
  dateRangeStart?: Maybe<Scalars['DateTime']>;
  downloadUrl: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  fileSize: Scalars['Int'];
  instructorNames?: Maybe<Scalars['String']>;
  jobGroupId: Scalars['ID'];
  locationName?: Maybe<Scalars['String']>;
};

export enum AttendanceListFontSize {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small'
}

export type Attendee = {
  addition?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  badgeXAttendee?: Maybe<Array<AttendeeBadge>>;
  billingAddition?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCompanyName?: Maybe<Scalars['String']>;
  billingFirstname?: Maybe<Scalars['String']>;
  billingLastname?: Maybe<Scalars['String']>;
  billingPostCode?: Maybe<Scalars['String']>;
  billingStreet?: Maybe<Scalars['String']>;
  birthday: Scalars['DateTime'];
  booker?: Maybe<Booker>;
  bookerId?: Maybe<Scalars['ID']>;
  bookings?: Maybe<Array<Booking>>;
  bookingsKo9?: Maybe<Array<BookingsKo9>>;
  createDate: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByUserId?: Maybe<Scalars['String']>;
  customer: Customer;
  customerId: Scalars['ID'];
  customerNumber: Scalars['Float'];
  customerNumberPrefix: Scalars['String'];
  defaultPaymentMethod: PaymentMethod;
  defaultPaymentMethodId: Scalars['ID'];
  deletable: Scalars['Boolean'];
  erasedAt?: Maybe<Scalars['DateTime']>;
  firstname: Scalars['String'];
  gender: Gender;
  hasBillingAddress?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastname: Scalars['String'];
  member: Scalars['Boolean'];
  startedCourses: Array<Course>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type AttendeeBadge = {
  allRequirementsFulfilled?: Maybe<Scalars['Boolean']>;
  attendee: Attendee;
  attendeeBadgeRequirements?: Maybe<Array<AttendeeBadgeRequirement>>;
  attendeeId?: Maybe<Scalars['ID']>;
  badge: Badge;
  badgeId?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  dateOfAchivement?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type AttendeeBadgeAssignmentInput = {
  attendeeId: Scalars['ID'];
  requirements: Array<AttendeeRequirementFulfillmentInput>;
};

export type AttendeeBadgeRequirement = {
  attendeeBadgeId: Scalars['ID'];
  badgeRequirement: BadgeRequirement;
  badgeRequirementId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  dateOfFulfillment?: Maybe<Scalars['DateTime']>;
  fulfilled: Scalars['Boolean'];
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type AttendeeMergeFieldsInput = {
  addition?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  billingAddition?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCompanyName?: Maybe<Scalars['String']>;
  billingFirstname?: Maybe<Scalars['String']>;
  billingLastname?: Maybe<Scalars['String']>;
  billingPostCode?: Maybe<Scalars['String']>;
  billingStreet?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasBillingAddress?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  member?: Maybe<Scalars['Boolean']>;
};

export type AttendeeMergeHistory = {
  booker?: Maybe<Booker>;
  bookerId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  loserSnapshot: Scalars['JSONObject'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  winnerAttendee?: Maybe<Attendee>;
  winnerAttendeeId?: Maybe<Scalars['ID']>;
};

export type AttendeeMergeResult = {
  bookingsTransferred: Scalars['Int'];
  duplicateBookingsInSameCourse: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  winnerAttendeeId: Scalars['ID'];
};

export type AttendeeRequirementFulfillmentInput = {
  badgeRequirementId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  dateOfFulfillment?: Maybe<Scalars['DateTime']>;
  fulfilled: Scalars['Boolean'];
};

export type AttendeesAgeAtCourseStart = {
  ageError?: Maybe<AgeError>;
  attendeeAge: Scalars['Float'];
  attendeeBirthday: Scalars['DateTime'];
  attendeesAgeAtFirstCourseLessonDate: Scalars['Float'];
  firstCourseLessonDate: Scalars['DateTime'];
  maxAge?: Maybe<Scalars['Float']>;
  maxAgeAnniversary?: Maybe<Scalars['DateTime']>;
  minAge?: Maybe<Scalars['Float']>;
  minAgeAnniversary?: Maybe<Scalars['DateTime']>;
};

export type AttendeeWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<Attendee>;
  total: Scalars['Float'];
};

export type AutoMergeDryRunInput = {
  confidenceThreshold: Scalars['Float'];
};

export type AutoMergeDryRunPair = {
  loserEmail?: Maybe<Scalars['String']>;
  loserId: Scalars['ID'];
  loserName: Scalars['String'];
  matchScore: Scalars['Float'];
  scoreBreakdown?: Maybe<ScoreBreakdownType>;
  winnerEmail?: Maybe<Scalars['String']>;
  winnerId: Scalars['ID'];
  winnerName: Scalars['String'];
};

export type AutoMergeDryRunResult = {
  pairs: Array<AutoMergeDryRunPair>;
  totalBookersAffected: Scalars['Float'];
  totalPairs: Scalars['Float'];
};

export type AutoMergeFailureType = {
  error: Scalars['String'];
  loserId: Scalars['String'];
  loserName: Scalars['String'];
  winnerId: Scalars['String'];
  winnerName: Scalars['String'];
};

export type AutoMergeInput = {
  confidenceThreshold: Scalars['Float'];
};

export type AutoMergeRun = {
  completedAt?: Maybe<Scalars['DateTime']>;
  confidenceThreshold: Scalars['Float'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  durationMs?: Maybe<Scalars['Float']>;
  failedMerges: Scalars['Float'];
  id: Scalars['ID'];
  mergedSoFar: Scalars['Float'];
  skippedMerges: Scalars['Float'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AutoMergeRunStatus;
  totalGroupsToMerge: Scalars['Float'];
  triggeredByUserId?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export enum AutoMergeRunStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type AutoMergeStartResult = {
  message: Scalars['String'];
  runId?: Maybe<Scalars['ID']>;
};

export type AutoMergeStatus = {
  completedAt?: Maybe<Scalars['DateTime']>;
  confidenceThreshold: Scalars['Float'];
  durationMs?: Maybe<Scalars['Float']>;
  failedMerges: Scalars['Float'];
  failures?: Maybe<Array<AutoMergeFailureType>>;
  mergedSoFar: Scalars['Float'];
  skippedMerges: Scalars['Float'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AutoMergeRunStatus;
  totalGroupsToMerge: Scalars['Float'];
};

export type Badge = {
  abbreviation?: Maybe<Scalars['String']>;
  badgeGroupId?: Maybe<Scalars['ID']>;
  badgeRequirements?: Maybe<Array<BadgeRequirement>>;
  badgeXAttendee?: Maybe<Array<AttendeeBadge>>;
  certificateTemplateId?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  graphicUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rank: Scalars['Float'];
  signedGraphicUrl?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type BadgeGroup = {
  color?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rank: Scalars['Float'];
  type: BadgeGroupType;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export enum BadgeGroupType {
  Kategorie = 'KATEGORIE',
  Stufenfolge = 'STUFENFOLGE'
}

export type BadgeRequirement = {
  badgeId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortOrder: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type BadgeRequirementInlineInput = {
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
};

export type BankCollectionRun = {
  collectedRates: Scalars['Int'];
  collectionDate?: Maybe<Scalars['DateTime']>;
  createDate: Scalars['DateTime'];
  creditAmount?: Maybe<Scalars['Float']>;
  creditBookingDate?: Maybe<Scalars['DateTime']>;
  creditId?: Maybe<Scalars['ID']>;
  creditMissing: Scalars['Boolean'];
  creditStatus?: Maybe<BankTransactionStatus>;
  debitCount: Scalars['Int'];
  exportedSepaXmlId: Scalars['ID'];
  fileName?: Maybe<Scalars['String']>;
  linkedRates: Scalars['Int'];
  openReturns: Scalars['Int'];
  returnDeadline?: Maybe<Scalars['DateTime']>;
  returnedAmount: Scalars['Float'];
  returnedRates: Scalars['Int'];
  total: Scalars['Float'];
};

export enum BankCounterpartKind {
  Customer = 'Customer',
  Other = 'Other'
}

export type BankImportFile = {
  accountIban: Scalars['String'];
  balanceGap?: Maybe<Scalars['Float']>;
  balanceGapFrom?: Maybe<Scalars['String']>;
  balanceGapTo?: Maybe<Scalars['String']>;
  closingBalance?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  entryCount: Scalars['Int'];
  filename: Scalars['String'];
  format: Scalars['String'];
  id: Scalars['ID'];
  knownCount: Scalars['Int'];
  newCount: Scalars['Int'];
  openingBalance?: Maybe<Scalars['Float']>;
  periodFrom?: Maybe<Scalars['DateTime']>;
  periodTo?: Maybe<Scalars['DateTime']>;
  transactions?: Maybe<Array<BankTransaction>>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type BankImportRematchAllResult = {
  cursor?: Maybe<Scalars['String']>;
  failed: Scalars['Int'];
  rematched: Scalars['Int'];
  total: Scalars['Int'];
};

export type BankTransaction = {
  accountIban: Scalars['String'];
  acctSvcrRef: Scalars['String'];
  amount: Scalars['Float'];
  bankImportFileId: Scalars['ID'];
  bankText?: Maybe<Scalars['String']>;
  bankTransactionCode?: Maybe<Scalars['String']>;
  bookingDate: Scalars['DateTime'];
  candidateRates: Array<ScheduledPayment>;
  candidates: Array<BankTransactionCandidate>;
  comment?: Maybe<Scalars['String']>;
  confirmWarning?: Maybe<Scalars['String']>;
  counterpartIban?: Maybe<Scalars['String']>;
  counterpartName?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  decidedAt?: Maybe<Scalars['DateTime']>;
  decidedByUserId?: Maybe<Scalars['ID']>;
  decision?: Maybe<BankTransactionDecision>;
  endToEndId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isReversal: Scalars['Boolean'];
  kind: BankTransactionKind;
  likelyRecordedScheduledPaymentIds: Array<Scalars['ID']>;
  likelyRecordedScheduledPayments: Array<ScheduledPayment>;
  mandateId?: Maybe<Scalars['String']>;
  matchedExportedSepaXmlId?: Maybe<Scalars['ID']>;
  matchKind: BankTransactionMatchKind;
  matchNote?: Maybe<Scalars['String']>;
  proposedScheduledPaymentIds: Array<Scalars['ID']>;
  proposedScheduledPayments: Array<ScheduledPayment>;
  rejectNote?: Maybe<Scalars['String']>;
  rejectReason?: Maybe<BankTransactionRejectReason>;
  remittanceText?: Maybe<Scalars['String']>;
  returnReasonCode?: Maybe<Scalars['String']>;
  settledScheduledPaymentIds: Array<Scalars['ID']>;
  status: BankTransactionStatus;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['DateTime']>;
};

export type BankTransactionCandidate = {
  amountMatches: Scalars['Boolean'];
  attendeeName?: Maybe<Scalars['String']>;
  bookerName?: Maybe<Scalars['String']>;
  bookingId: Scalars['ID'];
  bookingLabel: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  courseNumber?: Maybe<Scalars['String']>;
  evidence: Array<BankTransactionCandidateEvidence>;
  hits?: Maybe<Array<BankTransactionSearchHit>>;
  level: BankTransactionCandidateLevel;
  noticeStaff?: Maybe<Scalars['String']>;
  rates: Array<ScheduledPayment>;
  warning?: Maybe<Scalars['String']>;
};

export enum BankTransactionCandidateEvidence {
  CourseNumber = 'CourseNumber',
  CustomerNumber = 'CustomerNumber',
  FirstName = 'FirstName',
  InvoiceNumber = 'InvoiceNumber',
  LastName = 'LastName',
  PayerIban = 'PayerIban'
}

export enum BankTransactionCandidateLevel {
  Certain = 'Certain',
  Likely = 'Likely',
  Possible = 'Possible'
}

export enum BankTransactionDecision {
  ConfirmedAsProposed = 'ConfirmedAsProposed',
  ConfirmedOtherTarget = 'ConfirmedOtherTarget',
  Rejected = 'Rejected'
}

export type BankTransactionDistributionInput = {
  amount: Scalars['Float'];
  scheduledPaymentId: Scalars['ID'];
};

export enum BankTransactionKind {
  CollectionBatch = 'CollectionBatch',
  Credit = 'Credit',
  Debit = 'Debit',
  Return = 'Return'
}

export enum BankTransactionMatchKind {
  CollectionBatch = 'CollectionBatch',
  CourseNumber = 'CourseNumber',
  CustomerNumber = 'CustomerNumber',
  None = 'None',
  PayerIban = 'PayerIban',
  PayerName = 'PayerName',
  Reference = 'Reference',
  ReferenceAmountDiffers = 'ReferenceAmountDiffers',
  Return = 'Return'
}

export type BankTransactionRecordAllResult = {
  cursor?: Maybe<Scalars['String']>;
  recorded: Scalars['Int'];
  skipped: Scalars['Int'];
};

export enum BankTransactionRejectReason {
  AlreadyRecorded = 'AlreadyRecorded',
  Clarify = 'Clarify',
  NotCourseRelated = 'NotCourseRelated',
  Other = 'Other'
}

export enum BankTransactionSearchField {
  AttendeeName = 'AttendeeName',
  BookerName = 'BookerName',
  BookingNumber = 'BookingNumber',
  CourseNumber = 'CourseNumber',
  InvoiceNumber = 'InvoiceNumber'
}

export type BankTransactionSearchHit = {
  exact: Scalars['Boolean'];
  field: BankTransactionSearchField;
  term: Scalars['String'];
  value: Scalars['String'];
};

export type BankTransactionsFilterInput = {
  bankImportFileId?: Maybe<Scalars['ID']>;
  likelyRecorded?: Maybe<Scalars['Boolean']>;
  otherMovements?: Maybe<Scalars['Boolean']>;
  skip?: Maybe<Scalars['Int']>;
  statuses?: Maybe<Array<BankTransactionStatus>>;
  take?: Maybe<Scalars['Int']>;
};

export type BankTransactionsPage = {
  items: Array<BankTransaction>;
  total: Scalars['Int'];
};

export enum BankTransactionStatus {
  AlreadySettled = 'AlreadySettled',
  Confirmed = 'Confirmed',
  Irrelevant = 'Irrelevant',
  Proposed = 'Proposed',
  Rejected = 'Rejected',
  Unmatched = 'Unmatched'
}

export type Base = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type BaseInput = {
  id: Scalars['ID'];
};

export type BaseLookupInput = {
  number: Scalars['String'];
  type: LookupType;
};

export type BasicEmailVariables = {
  footerText: Scalars['String'];
  headerText: Scalars['String'];
  replyTo: Scalars['String'];
  signature: Scalars['String'];
  subject: Scalars['String'];
};

export type BillingAddressTemplate = {
  addition?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  koOrganizationId: Scalars['String'];
  lastname?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type BillingStatusByInstructor = {
  billedLessonCount: Scalars['Float'];
  billedTotalAmount?: Maybe<Scalars['Float']>;
  courseLessonCount: Scalars['Float'];
  courseLessons: Array<BillingStatusCoursLessons>;
  instructor: Instructor;
  instructorCost?: Maybe<Scalars['Float']>;
  instructorId: Scalars['ID'];
  lastBillingDate?: Maybe<Scalars['DateTime']>;
  sumBillingAmount?: Maybe<Scalars['Float']>;
};

export type BillingStatusByInstructorWithCourseGroups = {
  billedLessonCount: Scalars['Float'];
  billedTotalAmount?: Maybe<Scalars['Float']>;
  courseGroups: Array<CourseSummaryForBilling>;
  courseLessonCount: Scalars['Float'];
  instructor: Instructor;
  instructorCost?: Maybe<Scalars['Float']>;
  instructorId: Scalars['ID'];
  lastBillingDate?: Maybe<Scalars['DateTime']>;
  sumBillingAmount?: Maybe<Scalars['Float']>;
};

export type BillingStatusCoursLessons = {
  billingAmount?: Maybe<Scalars['Float']>;
  billingDate?: Maybe<Scalars['DateTime']>;
  bookings?: Maybe<Array<Booking>>;
  costForLesson: Scalars['Float'];
  course: Course;
  courseId: Scalars['ID'];
  courseLessonAssistants?: Maybe<Array<CourseLessonAssistant>>;
  courseLessonBookingCount: Scalars['Float'];
  courseLessonBookings: Array<CourseLessonBooking>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  durationInMinutes: Scalars['Float'];
  endDateTime: Scalars['DateTime'];
  freePlaces: Scalars['Float'];
  id: Scalars['ID'];
  indexOfLessonInCourse?: Maybe<Scalars['Float']>;
  instructorInvoice?: Maybe<InstructorInvoice>;
  instructorInvoiceId?: Maybe<Scalars['String']>;
  instructors: Array<Instructor>;
  location: Location;
  locationId: Scalars['ID'];
  revenueGross: Scalars['Float'];
  roomCost?: Maybe<Scalars['Float']>;
  startDateTime: Scalars['DateTime'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  venue: Venue;
  venueId: Scalars['ID'];
};

export type BlankMailInputTypes = {
  bcc: Array<Scalars['String']>;
  cc: Array<Scalars['String']>;
  receivers: Array<BlankMailReceiversInput>;
  subject: Scalars['String'];
  text: Scalars['String'];
  type: BlankMailTypes;
};

export type BlankMailReceiversInput = {
  email: Scalars['String'];
  ids?: Maybe<Array<Scalars['String']>>;
};

export enum BlankMailTypes {
  Attendee = 'Attendee',
  Booker = 'Booker',
  Booking = 'Booking',
  Course = 'Course',
  Invoice = 'Invoice'
}

export type BookableOptions = {
  hasFreeSlots: Scalars['Boolean'];
  hasWaitlistSlots: Scalars['Boolean'];
};

export enum BookableOptionsError {
  BookingNotPossible = 'BookingNotPossible',
  DuplicateBooking = 'DuplicateBooking',
  NoFreeSlots = 'NoFreeSlots',
  PlaceReservationNotPossible = 'PlaceReservationNotPossible',
  WaitlistFull = 'WaitlistFull',
  WaitlistNotPossible = 'WaitlistNotPossible'
}

export type BookableOptionsResult = {
  errors: Array<BookableOptionsError>;
  options: BookableOptions;
};

export type BookAttendees = {
  selectedAttendee?: Maybe<SelectedAttendee>;
  selectedCourseId?: Maybe<Scalars['ID']>;
};

export enum BookedBy {
  Booker = 'Booker',
  Staff = 'Staff'
}

export type Booker = {
  addition?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  attendees?: Maybe<Array<Attendee>>;
  billingAddition?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCompanyName?: Maybe<Scalars['String']>;
  billingFirstname?: Maybe<Scalars['String']>;
  billingLastname?: Maybe<Scalars['String']>;
  billingPostCode?: Maybe<Scalars['String']>;
  billingStreet?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByUser?: Maybe<UserType>;
  createdByUserId?: Maybe<Scalars['String']>;
  credit?: Maybe<Scalars['Float']>;
  customer: Customer;
  customerId: Scalars['ID'];
  customerNumber: Scalars['Float'];
  customerNumberPrefix: Scalars['String'];
  dsgvo: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  erasedAt?: Maybe<Scalars['DateTime']>;
  firstname: Scalars['String'];
  gender?: Maybe<Gender>;
  hasBillingAddress?: Maybe<Scalars['Boolean']>;
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialContact: Scalars['DateTime'];
  lastname: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  newsletter: Scalars['Boolean'];
  nonDisclosureNotice?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type BookerAttendeeBookingInput = {
  bookingNumberPrefix?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  courseLessons: Array<BaseInput>;
  id: Scalars['ID'];
  payDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<BaseInput>;
  paymentType?: Maybe<PaymentType>;
};

export type BookerAttendeeCount = {
  attendeeCount: Scalars['Int'];
  bookerCount: Scalars['Int'];
};

export type BookerAttendeeInput = {
  addition?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<NewAttendeeBadgeInput>>;
  billingAddition?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCompanyName?: Maybe<Scalars['String']>;
  billingFirstname?: Maybe<Scalars['String']>;
  billingLastname?: Maybe<Scalars['String']>;
  billingPostCode?: Maybe<Scalars['String']>;
  billingStreet?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  bookings?: Maybe<Array<BookerAttendeeBookingInput>>;
  bookingsKo9?: Maybe<Array<NewBookingsKo9Input>>;
  customer: BaseInput;
  defaultPaymentMethod?: Maybe<BaseInput>;
  deletable?: Maybe<Scalars['Boolean']>;
  firstname: Scalars['String'];
  gender: Gender;
  hasBillingAddress?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastname: Scalars['String'];
  member: Scalars['Boolean'];
};

export type BookerCustomerInput = {
  customer: BaseInput;
  firstname: Scalars['String'];
  gender: Gender;
  id: Scalars['ID'];
  lastname: Scalars['String'];
};

export type BookerCustomerUpdateInput = {
  customer?: Maybe<BaseInput>;
  customerNumber?: Maybe<Scalars['Float']>;
  firstname?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
};

export type BookerDeletionProgressType = {
  deletedAttendees: Scalars['Int'];
  deletedBookers: Scalars['Int'];
  errorMessage?: Maybe<Scalars['String']>;
  phase: Scalars['String'];
  totalAttendees: Scalars['Int'];
  totalBookers: Scalars['Int'];
};

export type BookerIdMissmatch = {
  attachments?: Maybe<Array<Scalars['JSONObject']>>;
  bookerId?: Maybe<Scalars['String']>;
  booking?: Maybe<Booking>;
  bookingDeleted?: Maybe<Scalars['DateTime']>;
  bookingId?: Maybe<Scalars['ID']>;
  courseDetailsSnapshot?: Maybe<Array<Scalars['JSONObject']>>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  currentBooker?: Maybe<Booker>;
  email: Scalars['String'];
  foundByMailBooker?: Maybe<Booker>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastMessageStatus?: Maybe<MessageStatus>;
  mailjetTemplateId?: Maybe<Scalars['Float']>;
  messageHistory?: Maybe<MessageHistory>;
  messageHref?: Maybe<Scalars['String']>;
  messageID?: Maybe<Scalars['ID']>;
  messageStatus?: Maybe<MessageStatusData>;
  receiverName?: Maybe<Scalars['String']>;
  renderVariablesSnapshot?: Maybe<Scalars['JSONObject']>;
  status: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type BookerIdMissmatchWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<BookerIdMissmatch>;
  total: Scalars['Float'];
};

export type BookerInput = {
  addition?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  attendees?: Maybe<Array<BookerAttendeeInput>>;
  billingAddition?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCompanyName?: Maybe<Scalars['String']>;
  billingFirstname?: Maybe<Scalars['String']>;
  billingLastname?: Maybe<Scalars['String']>;
  billingPostCode?: Maybe<Scalars['String']>;
  billingStreet?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  createdBy?: Maybe<CreatedBy>;
  credit?: Maybe<Scalars['Float']>;
  customer: BaseInput;
  customerNumber?: Maybe<Scalars['Float']>;
  dsgvo: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  gender: Gender;
  hasBillingAddress?: Maybe<Scalars['Boolean']>;
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialContact: Scalars['DateTime'];
  lastname: Scalars['String'];
  linkExistingAccountConfirmed?: Maybe<Scalars['Boolean']>;
  mobileNumber?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  nonDisclosureNotice?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<Array<BookerPaymentMethodInput>>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type BookerMergeHistory = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  loserSnapshot: Scalars['JSONObject'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  winnerBooker?: Maybe<Booker>;
  winnerBookerId: Scalars['ID'];
};

export type BookerPaymentMethodInput = {
  bank?: Maybe<Scalars['String']>;
  bankTransfer?: Maybe<Scalars['Boolean']>;
  bic?: Maybe<Scalars['String']>;
  cash?: Maybe<Scalars['Boolean']>;
  creditCardAccountholder?: Maybe<Scalars['String']>;
  creditcardNumber?: Maybe<Scalars['String']>;
  cvc?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  esr?: Maybe<Scalars['Boolean']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  onlinePayment?: Maybe<Scalars['Boolean']>;
  paypalAccountholder?: Maybe<Scalars['String']>;
  sepaAccountholder?: Maybe<Scalars['String']>;
  type?: Maybe<PaymentTransferType>;
  validFrom?: Maybe<Scalars['DateTime']>;
};

export type BookerWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<Booker>;
  total: Scalars['Float'];
};

export type Booking = {
  additionalInfo?: Maybe<Scalars['String']>;
  agbConfirmed?: Maybe<Scalars['Boolean']>;
  attendanceListNote?: Maybe<Scalars['String']>;
  attendee?: Maybe<Attendee>;
  attendeeId?: Maybe<Scalars['ID']>;
  bookedBy: BookedBy;
  bookedLessonCount?: Maybe<Scalars['Float']>;
  bookingConfirmationSent?: Maybe<Scalars['DateTime']>;
  bookingHistory?: Maybe<Array<BookingHistory>>;
  bookingNumber: Scalars['Float'];
  bookingNumberPrefix: Scalars['String'];
  bookingType: Scalars['String'];
  cancelationSent?: Maybe<Scalars['DateTime']>;
  canceled?: Maybe<Scalars['DateTime']>;
  cancelRestAmount?: Maybe<Scalars['Float']>;
  cancelRestHandling?: Maybe<Scalars['String']>;
  cancelSettledAmount?: Maybe<Scalars['Float']>;
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['ID']>;
  courseLessonBookings?: Maybe<Array<CourseLessonBooking>>;
  courseLessons: Array<CourseLesson>;
  coursePrice: CoursePrice;
  coursePriceId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  creditedBalance?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<DiscountCode>;
  discountCodeId?: Maybe<Scalars['ID']>;
  discountCodeText?: Maybe<Scalars['String']>;
  discountName?: Maybe<Scalars['String']>;
  emailNotifications?: Maybe<Array<EmailNotification>>;
  foundUs?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  hasDiscountCode: Scalars['Boolean'];
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  invoiceSent?: Maybe<Scalars['DateTime']>;
  isSettled: Scalars['Boolean'];
  isSpecial: Scalars['Boolean'];
  lessonLegacyGap?: Maybe<Scalars['Float']>;
  lessonPricingMode?: Maybe<LessonPricingMode>;
  lessonRateMonthOffset?: Maybe<Scalars['Int']>;
  lessonSelectionMode?: Maybe<BookingLessonSelectionMode>;
  lessonUnitPrice?: Maybe<Scalars['Float']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  mergedBookingIds?: Maybe<Array<Scalars['String']>>;
  molliePaymentAttempts: Array<MolliePaymentAttempt>;
  monthlySchedule: MonthlySchedule;
  netPrice?: Maybe<Scalars['Float']>;
  noticeBooker?: Maybe<Scalars['String']>;
  noticeStaff?: Maybe<Scalars['String']>;
  payDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  paymentType?: Maybe<PaymentType>;
  pricingCalculatedAt?: Maybe<Scalars['DateTime']>;
  pricingCalculationVersion?: Maybe<Scalars['String']>;
  pricingFingerprint?: Maybe<Scalars['String']>;
  pricingReason?: Maybe<BookingPricingReason>;
  pricingSnapshot?: Maybe<Scalars['JSONObject']>;
  privacyStatementConfirmed?: Maybe<Scalars['Boolean']>;
  reversalInvoice?: Maybe<ReversalInvoice>;
  scheduledPayments?: Maybe<Array<ScheduledPayment>>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  transferIn?: Maybe<BookingTransferIn>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  vat: Scalars['Float'];
  waitingListConfirmationSent?: Maybe<Scalars['DateTime']>;
  waitListCount?: Maybe<Scalars['Float']>;
};

export type BookingDeleteAction = {
  bookingId?: Maybe<Scalars['ID']>;
  type: BookingDeleteActionType;
};

export enum BookingDeleteActionType {
  DoNothing = 'DO_NOTHING',
  NextFromWaitingList = 'NEXT_FROM_WAITING_LIST',
  PlaceReservation = 'PLACE_RESERVATION',
  SelectFromWaitingList = 'SELECT_FROM_WAITING_LIST'
}

export type BookingDunningStatus = {
  bookingId: Scalars['ID'];
  due: Scalars['Boolean'];
  level?: Maybe<DunningLevel>;
  levelDate?: Maybe<Scalars['DateTime']>;
  nextDate?: Maybe<Scalars['String']>;
  nextLevel?: Maybe<DunningLevel>;
  pausedUntil?: Maybe<Scalars['String']>;
};

/** Fuer einen Teilnehmer ueber einen Voraussetzungskurs freigegebener Kurs samt Diagnose */
export type BookingEligibilityCandidate = {
  courseId: Scalars['ID'];
  courseTypeColor?: Maybe<Scalars['String']>;
  courseTypeName?: Maybe<Scalars['String']>;
  diagnosis: BookingEligibilityDiagnosis;
  freePlaces?: Maybe<Scalars['Float']>;
  locationName?: Maybe<Scalars['String']>;
  prefixedCourseNumber?: Maybe<Scalars['String']>;
  prerequisiteCourseIds: Array<Scalars['ID']>;
  prerequisitePrefixedCourseNumbers: Array<Scalars['String']>;
  satisfiedByAttendeeIds: Array<Scalars['ID']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
};

/** Antwort auf: Kann Teilnehmer X Kurs Y jetzt online buchen und sehen? */
export type BookingEligibilityDiagnosis = {
  attendeeId: Scalars['ID'];
  blockingCheckKeys: Array<EligibilityCheckKey>;
  canBook: Scalars['Boolean'];
  checks: Array<EligibilityCheck>;
  courseId: Scalars['ID'];
  reason: BookingRestrictionErrors;
  visibleInStandardList: Scalars['Boolean'];
  visibleViaPrerequisiteLinks: Array<PrerequisiteLinkVisibility>;
};

export type BookingHistory = {
  action: BookingHistoryAction;
  attendee?: Maybe<Attendee>;
  attendeeId?: Maybe<Scalars['ID']>;
  bookedBy: BookedBy;
  bookerId?: Maybe<Scalars['ID']>;
  booking?: Maybe<Booking>;
  bookingId: Scalars['ID'];
  bookingNumber?: Maybe<Scalars['Float']>;
  bookingNumberPrefix: Scalars['String'];
  bookingType: BookingType;
  canceled?: Maybe<Scalars['DateTime']>;
  correlationId?: Maybe<Scalars['ID']>;
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['ID']>;
  createDate: Scalars['DateTime'];
  createdBy?: Maybe<UserDetailsType>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  id: Scalars['ID'];
  netPrice?: Maybe<Scalars['Float']>;
  newValues?: Maybe<Scalars['JSONObject']>;
  oldValues?: Maybe<Scalars['JSONObject']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  user?: Maybe<UserDetailsType>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  vat: Scalars['Float'];
};

export enum BookingHistoryAction {
  AttendanceChanged = 'AttendanceChanged',
  BookingCancle = 'BookingCancle',
  BookingCorrected = 'BookingCorrected',
  BookingCreate = 'BookingCreate',
  BookingCreateTransfer = 'BookingCreateTransfer',
  BookingCreateTransferCopy = 'BookingCreateTransferCopy',
  BookingCreateTransferMove = 'BookingCreateTransferMove',
  BookingDelete = 'BookingDelete',
  BookingDeleteTransfer = 'BookingDeleteTransfer',
  BookingOrphanDelete = 'BookingOrphanDelete',
  BookingOrphanRestore = 'BookingOrphanRestore',
  BookingSettle = 'BookingSettle',
  BookingToWaitlist = 'BookingToWaitlist',
  Canceled = 'Canceled',
  CorrectionInvoice = 'CorrectionInvoice',
  Created = 'Created',
  Custom = 'Custom',
  DiscountChanged = 'DiscountChanged',
  EmailSent = 'EmailSent',
  LessonAdded = 'LessonAdded',
  LessonRemoved = 'LessonRemoved',
  MolliePaymentLinkVoided = 'MolliePaymentLinkVoided',
  PaymentChanged = 'PaymentChanged',
  PaymentLinkSent = 'PaymentLinkSent',
  PaymentMethodChanged = 'PaymentMethodChanged',
  PaymentPlanReset = 'PaymentPlanReset',
  PlaceReservationCreate = 'PlaceReservationCreate',
  PlaceReservationCreateByMaxAttendeesIncrease = 'PlaceReservationCreateByMaxAttendeesIncrease',
  PlaceReservationDelete = 'PlaceReservationDelete',
  PlaceReservationToBooking = 'PlaceReservationToBooking',
  PriceChanged = 'PriceChanged',
  RefundCompleted = 'RefundCompleted',
  RefundInitiated = 'RefundInitiated',
  ScheduledPaymentCreated = 'ScheduledPaymentCreated',
  ScheduledPaymentDeleted = 'ScheduledPaymentDeleted',
  ScheduledPaymentPaid = 'ScheduledPaymentPaid',
  ScheduledPaymentUnpaid = 'ScheduledPaymentUnpaid',
  ScheduledPaymentUpdated = 'ScheduledPaymentUpdated',
  SendBookingConfirmation = 'SendBookingConfirmation',
  SendInvoice = 'SendInvoice',
  SendWaitlistConfirmation = 'SendWaitlistConfirmation',
  StatusChanged = 'StatusChanged',
  Unknown = 'Unknown',
  Updated = 'Updated',
  WaitlistCreate = 'WaitlistCreate',
  WaitlistCreateTransfer = 'WaitlistCreateTransfer',
  WaitlistCreateTransferCopy = 'WaitlistCreateTransferCopy',
  WaitlistCreateTransferMove = 'WaitlistCreateTransferMove',
  WaitlistDelete = 'WaitlistDelete',
  WaitlistDeleteTransfer = 'WaitlistDeleteTransfer',
  WaitlistToBooking = 'WaitlistToBooking',
  WaitlistToBookingByMaxAttendeesIncrease = 'WaitlistToBookingByMaxAttendeesIncrease'
}

export type BookingHistoryWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<BookingHistory>;
  total: Scalars['Float'];
};

export enum BookingLessonSelectionMode {
  ExplicitSelection = 'EXPLICIT_SELECTION',
  FullCourse = 'FULL_COURSE',
  RemainingAtBooking = 'REMAINING_AT_BOOKING'
}

export type BookingOptions = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};

export enum BookingPostKind {
  AdditionalItem = 'AdditionalItem',
  CourseFee = 'CourseFee',
  Fee = 'Fee'
}

export enum BookingPricingReason {
  ExplicitLessonSelection = 'EXPLICIT_LESSON_SELECTION',
  LateEntryRemainingLessons = 'LATE_ENTRY_REMAINING_LESSONS',
  Standard = 'STANDARD'
}

export type BookingRestriction = {
  active: Scalars['Boolean'];
  allowWaitlistWithoutPrerequisite: Scalars['Boolean'];
  blockedPlaces?: Maybe<Scalars['Float']>;
  course?: Maybe<Course>;
  courseId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  expireAction?: Maybe<ExpireAction>;
  id: Scalars['ID'];
  includeBookingList: Scalars['Boolean'];
  includeWaitingList: Scalars['Boolean'];
  membersOnly: Scalars['Boolean'];
  prerequisiteCourses?: Maybe<Array<Course>>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  visibleForAll: Scalars['Boolean'];
};

export type BookingRestrictionError = {
  errorMessage?: Maybe<BookingRestrictionErrors>;
};

export enum BookingRestrictionErrors {
  AllowedToBook = 'AllowedToBook',
  AttendeeHasBookingInPrerequisiteCourse = 'AttendeeHasBookingInPrerequisiteCourse',
  AttendeeHasNoBookingInPrerequisiteCourse = 'AttendeeHasNoBookingInPrerequisiteCourse',
  AttendeeHasWaitlistBookingInPrerequisiteCourse = 'AttendeeHasWaitlistBookingInPrerequisiteCourse',
  AttendeeIsNotAMember = 'AttendeeIsNotAMember',
  BookingRestrictionExpiredAndShowToAllIsSet = 'BookingRestrictionExpiredAndShowToAllIsSet',
  BookingRestrictionNotWithinTimeFrame = 'BookingRestrictionNotWithinTimeFrame',
  NoBookingRestrictionFound = 'NoBookingRestrictionFound'
}

export type BookingsKo9 = {
  attendee?: Maybe<Attendee>;
  attendeeId: Scalars['String'];
  courseName: Scalars['String'];
  courseNumber: Scalars['String'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  firstCourseLesson: Scalars['String'];
  id: Scalars['ID'];
  teilnahmeId: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type BookingTransferIn = {
  appliedAmount: Scalars['Float'];
  sourceBookingNumber: Scalars['String'];
};

export enum BookingType {
  Booking = 'Booking',
  PlaceReservation = 'PlaceReservation',
  Waitlist = 'Waitlist'
}

export type BookingWithCourseLessons = {
  additionalInfo?: Maybe<Scalars['String']>;
  agbConfirmed?: Maybe<Scalars['Boolean']>;
  attendanceListNote?: Maybe<Scalars['String']>;
  attendee?: Maybe<Attendee>;
  attendeeId?: Maybe<Scalars['ID']>;
  bookedBy: BookedBy;
  bookedLessonCount?: Maybe<Scalars['Float']>;
  bookingConfirmationSent?: Maybe<Scalars['DateTime']>;
  bookingHistory?: Maybe<Array<BookingHistory>>;
  bookingNumber: Scalars['Float'];
  bookingNumberPrefix: Scalars['String'];
  bookingType: Scalars['String'];
  cancelationSent?: Maybe<Scalars['DateTime']>;
  canceled?: Maybe<Scalars['DateTime']>;
  cancelRestAmount?: Maybe<Scalars['Float']>;
  cancelRestHandling?: Maybe<Scalars['String']>;
  cancelSettledAmount?: Maybe<Scalars['Float']>;
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['ID']>;
  courseLessonBookings?: Maybe<Array<CourseLessonBooking>>;
  courseLessons: Array<CourseLesson>;
  coursePrice: CoursePrice;
  coursePriceId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  creditedBalance?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<DiscountCode>;
  discountCodeId?: Maybe<Scalars['ID']>;
  discountCodeText?: Maybe<Scalars['String']>;
  discountName?: Maybe<Scalars['String']>;
  emailNotifications?: Maybe<Array<EmailNotification>>;
  foundUs?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  hasDiscountCode: Scalars['Boolean'];
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  invoiceSent?: Maybe<Scalars['DateTime']>;
  isSettled: Scalars['Boolean'];
  isSpecial: Scalars['Boolean'];
  lessonLegacyGap?: Maybe<Scalars['Float']>;
  lessonPricingMode?: Maybe<LessonPricingMode>;
  lessonRateMonthOffset?: Maybe<Scalars['Int']>;
  lessonSelectionMode?: Maybe<BookingLessonSelectionMode>;
  lessonUnitPrice?: Maybe<Scalars['Float']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  mergedBookingIds?: Maybe<Array<Scalars['String']>>;
  molliePaymentAttempts: Array<MolliePaymentAttempt>;
  monthlySchedule: MonthlySchedule;
  netPrice?: Maybe<Scalars['Float']>;
  noticeBooker?: Maybe<Scalars['String']>;
  noticeStaff?: Maybe<Scalars['String']>;
  overpaymentCredit?: Maybe<Scalars['Float']>;
  payDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  paymentType?: Maybe<PaymentType>;
  pricingCalculatedAt?: Maybe<Scalars['DateTime']>;
  pricingCalculationVersion?: Maybe<Scalars['String']>;
  pricingFingerprint?: Maybe<Scalars['String']>;
  pricingReason?: Maybe<BookingPricingReason>;
  pricingSnapshot?: Maybe<Scalars['JSONObject']>;
  privacyStatementConfirmed?: Maybe<Scalars['Boolean']>;
  reversalInvoice?: Maybe<ReversalInvoice>;
  scheduledPayments: Array<ScheduledPayment>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  transferIn?: Maybe<BookingTransferIn>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  vat: Scalars['Float'];
  waitingListConfirmationSent?: Maybe<Scalars['DateTime']>;
  waitListCount?: Maybe<Scalars['Float']>;
};

export type BookingWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<Booking>;
  total: Scalars['Float'];
};

export type BookingWithPaymentAction = {
  bookingId: Scalars['String'];
  paymentAction?: Maybe<MolliePaymentAction>;
};

export type BroadcastTenantNotificationInput = {
  attachments?: Maybe<Array<Attachment>>;
  htmlPart: Scalars['String'];
  recipients: Array<TenantRecipientInput>;
  subject: Scalars['String'];
  textPart?: Maybe<Scalars['String']>;
};

export type BroadcastTenantNotificationResult = {
  failureCount: Scalars['Int'];
  results: Array<TenantNotificationResultType>;
  skippedCount: Scalars['Int'];
  successCount: Scalars['Int'];
};

export type BulkCreateAttendeeBadgeInput = {
  attendeeIds: Array<Scalars['ID']>;
  badgeId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  dateOfAchivement?: Maybe<Scalars['DateTime']>;
};

export type BulkJobResult = {
  courseCount: Scalars['Int'];
  estimatedDurationSeconds: Scalars['Int'];
  jobGroupId: Scalars['ID'];
  message: Scalars['String'];
};

export type BulkJobStatus = {
  active: Scalars['Int'];
  completed: Scalars['Int'];
  downloadUrl?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  failed: Scalars['Int'];
  jobGroupId: Scalars['ID'];
  total: Scalars['Int'];
};

export type BulkToggleAttendeeBadgeRequirementInput = {
  attendeeBadgeRequirementIds: Array<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  fulfilled: Scalars['Boolean'];
};

export type BundesbankImportInfo = {
  count: Scalars['Float'];
  lastImport?: Maybe<Scalars['DateTime']>;
};

export type BundesbankImportResult = {
  count: Scalars['Float'];
  importedAt: Scalars['DateTime'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CacheStatsOutput = {
  cacheHitRatio: Scalars['Float'];
  diskReads: Scalars['Float'];
  sharedBuffersSize: Scalars['String'];
  totalReads: Scalars['Float'];
};

export type CamtGeneratorInput = {
  amountOfTransactions: Scalars['String'];
  createDateTime: Scalars['String'];
  creditorIban: Scalars['String'];
  creditorName: Scalars['String'];
  entryBookDate: Scalars['String'];
  entryReference: Scalars['String'];
  entrySumAmount: Scalars['String'];
  entryValuaDate: Scalars['String'];
  msgId: Scalars['String'];
  notificationId: Scalars['String'];
  rangeEnd: Scalars['String'];
  rangeStart: Scalars['String'];
  transactions?: Maybe<Array<CamtGeneratorTransactionInput>>;
};

export type CamtGeneratorTransactionInput = {
  deptorCity: Scalars['String'];
  deptorCountry: Scalars['String'];
  deptorHouseNumber: Scalars['String'];
  deptorIban: Scalars['String'];
  deptorName: Scalars['String'];
  deptorPostalCode: Scalars['String'];
  deptorStreet: Scalars['String'];
  invoiceAmount: Scalars['String'];
  packageId: Scalars['String'];
  qrReference: Scalars['String'];
  transactionReference: Scalars['String'];
};

export type CamtScheduledPaymentInput = {
  amount?: Maybe<Scalars['Float']>;
  scheduledPaymentId: Scalars['ID'];
};

export type CancelBookingOptionsInput = {
  cancelationFeeAmount?: Maybe<Scalars['Float']>;
  feeDecisions?: Maybe<Array<CancelFeeDecisionInput>>;
  mollieRefundedAmount?: Maybe<Scalars['Float']>;
  restHandling?: Maybe<CancelRestHandling>;
  restNote?: Maybe<Scalars['String']>;
  settleFeesFromPayments?: Maybe<Scalars['Boolean']>;
};

export type CancelFeeDecisionInput = {
  keep: Scalars['Boolean'];
  scheduledPaymentId: Scalars['String'];
};

export enum CancelRestHandling {
  Credit = 'Credit',
  KeptBySchool = 'KeptBySchool',
  ManualRefund = 'ManualRefund',
  MollieRefund = 'MollieRefund'
}

export type CertificateAlign = {
  footer: Scalars['String'];
  logo: Scalars['String'];
};

export type CertificateAlignInput = {
  footer?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

export type CertificateBlockAlignments = {
  abschluss?: Maybe<Scalars['String']>;
  akkreditierung?: Maybe<Scalars['String']>;
  beilage?: Maybe<Scalars['String']>;
  beschreibung?: Maybe<Scalars['String']>;
  docMid?: Maybe<Scalars['String']>;
  geburtsdatum?: Maybe<Scalars['String']>;
  grat?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  kurs?: Maybe<Scalars['String']>;
  kursSub?: Maybe<Scalars['String']>;
  letterBadge?: Maybe<Scalars['String']>;
  letterBody?: Maybe<Scalars['String']>;
  letterHead?: Maybe<Scalars['String']>;
  letterSalutation?: Maybe<Scalars['String']>;
  letterSig?: Maybe<Scalars['String']>;
  letterZert?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mittel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['String']>;
  ortDatum?: Maybe<Scalars['String']>;
  teilnCaption?: Maybe<Scalars['String']>;
  teilnehmer?: Maybe<Scalars['String']>;
  titel?: Maybe<Scalars['String']>;
  untertitel?: Maybe<Scalars['String']>;
  zert?: Maybe<Scalars['String']>;
};

export type CertificateBlockAlignmentsInput = {
  abschluss?: Maybe<Scalars['String']>;
  akkreditierung?: Maybe<Scalars['String']>;
  beilage?: Maybe<Scalars['String']>;
  beschreibung?: Maybe<Scalars['String']>;
  docMid?: Maybe<Scalars['String']>;
  geburtsdatum?: Maybe<Scalars['String']>;
  grat?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  kurs?: Maybe<Scalars['String']>;
  kursSub?: Maybe<Scalars['String']>;
  letterBadge?: Maybe<Scalars['String']>;
  letterBody?: Maybe<Scalars['String']>;
  letterHead?: Maybe<Scalars['String']>;
  letterSalutation?: Maybe<Scalars['String']>;
  letterSig?: Maybe<Scalars['String']>;
  letterZert?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mittel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['String']>;
  ortDatum?: Maybe<Scalars['String']>;
  teilnCaption?: Maybe<Scalars['String']>;
  teilnehmer?: Maybe<Scalars['String']>;
  titel?: Maybe<Scalars['String']>;
  untertitel?: Maybe<Scalars['String']>;
  zert?: Maybe<Scalars['String']>;
};

export type CertificateBlockLayout = {
  alignments?: Maybe<CertificateBlockAlignments>;
  density?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Scalars['String']>>;
  spacing?: Maybe<CertificateBlockSpacing>;
};

export type CertificateBlockLayoutInput = {
  alignments?: Maybe<CertificateBlockAlignmentsInput>;
  density?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Scalars['String']>>;
  spacing?: Maybe<CertificateBlockSpacingInput>;
};

export type CertificateBlockSpacing = {
  abschluss?: Maybe<Scalars['String']>;
  akkreditierung?: Maybe<Scalars['String']>;
  bandContact?: Maybe<Scalars['String']>;
  bandStufen?: Maybe<Scalars['String']>;
  bandTitle?: Maybe<Scalars['String']>;
  beilage?: Maybe<Scalars['String']>;
  beschreibung?: Maybe<Scalars['String']>;
  docMid?: Maybe<Scalars['String']>;
  geburtsdatum?: Maybe<Scalars['String']>;
  grat?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  kurs?: Maybe<Scalars['String']>;
  kursSub?: Maybe<Scalars['String']>;
  letterBadge?: Maybe<Scalars['String']>;
  letterBody?: Maybe<Scalars['String']>;
  letterHead?: Maybe<Scalars['String']>;
  letterSalutation?: Maybe<Scalars['String']>;
  letterSig?: Maybe<Scalars['String']>;
  letterZert?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mittel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['String']>;
  ortDatum?: Maybe<Scalars['String']>;
  teilnCaption?: Maybe<Scalars['String']>;
  teilnehmer?: Maybe<Scalars['String']>;
  titel?: Maybe<Scalars['String']>;
  untertitel?: Maybe<Scalars['String']>;
  zert?: Maybe<Scalars['String']>;
};

export type CertificateBlockSpacingInput = {
  abschluss?: Maybe<Scalars['String']>;
  akkreditierung?: Maybe<Scalars['String']>;
  bandContact?: Maybe<Scalars['String']>;
  bandStufen?: Maybe<Scalars['String']>;
  bandTitle?: Maybe<Scalars['String']>;
  beilage?: Maybe<Scalars['String']>;
  beschreibung?: Maybe<Scalars['String']>;
  docMid?: Maybe<Scalars['String']>;
  geburtsdatum?: Maybe<Scalars['String']>;
  grat?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  kurs?: Maybe<Scalars['String']>;
  kursSub?: Maybe<Scalars['String']>;
  letterBadge?: Maybe<Scalars['String']>;
  letterBody?: Maybe<Scalars['String']>;
  letterHead?: Maybe<Scalars['String']>;
  letterSalutation?: Maybe<Scalars['String']>;
  letterSig?: Maybe<Scalars['String']>;
  letterZert?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mittel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['String']>;
  ortDatum?: Maybe<Scalars['String']>;
  teilnCaption?: Maybe<Scalars['String']>;
  teilnehmer?: Maybe<Scalars['String']>;
  titel?: Maybe<Scalars['String']>;
  untertitel?: Maybe<Scalars['String']>;
  zert?: Maybe<Scalars['String']>;
};

export enum CertificateDesignVariant {
  Bescheinigung = 'BESCHEINIGUNG',
  Brief = 'BRIEF',
  Classic = 'CLASSIC',
  Elegant = 'ELEGANT',
  Maritime = 'MARITIME',
  Modern = 'MODERN',
  Playful = 'PLAYFUL',
  Vibrant = 'VIBRANT'
}

export type CertificateDocFields = {
  abschluss: CertificateDocText;
  akkreditierung: CertificateDocText;
  align: CertificateAlign;
  beschreibung: CertificateDocText;
  docMid: CertificateDocText;
  kursSub: CertificateDocText;
  ort: CertificateDocText;
  teilnCaption: CertificateDocText;
  untertitel: CertificateDocText;
  veranstalter: CertificateDocText;
};

export type CertificateDocFieldsInput = {
  abschluss?: Maybe<CertificateDocTextInput>;
  akkreditierung?: Maybe<CertificateDocTextInput>;
  align?: Maybe<CertificateAlignInput>;
  beschreibung?: Maybe<CertificateDocTextInput>;
  docMid?: Maybe<CertificateDocTextInput>;
  kursSub?: Maybe<CertificateDocTextInput>;
  ort?: Maybe<CertificateDocTextInput>;
  teilnCaption?: Maybe<CertificateDocTextInput>;
  untertitel?: Maybe<CertificateDocTextInput>;
  veranstalter?: Maybe<CertificateDocTextInput>;
};

export type CertificateDocText = {
  show: Scalars['Boolean'];
  v: Scalars['String'];
};

export type CertificateDocTextInput = {
  show?: Maybe<Scalars['Boolean']>;
  v?: Maybe<Scalars['String']>;
};

export type CertificateIssuePreflightAttendee = {
  attendeeId: Scalars['ID'];
  attendeeName: Scalars['String'];
  missingKeys: Array<Scalars['String']>;
};

export type CertificateIssuePreflightInput = {
  attendeeBadgeId?: Maybe<Scalars['ID']>;
  attendeeIds?: Maybe<Array<Scalars['ID']>>;
  badgeId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  onlyFulfilled?: Maybe<Scalars['Boolean']>;
};

export type CertificateIssuePreflightResult = {
  attendeesWithMissingValues: Array<CertificateIssuePreflightAttendee>;
  usedVariableKeys: Array<Scalars['String']>;
};

export type CertificateLetterFields = {
  beilage: CertificateDocText;
  contactLine: Scalars['String'];
  contactShow?: Maybe<Scalars['Boolean']>;
  senderLine: Scalars['String'];
  stufenList: Scalars['String'];
  stufenShow?: Maybe<Scalars['Boolean']>;
  stufenTitle?: Maybe<Scalars['String']>;
  window?: Maybe<Scalars['String']>;
};

export type CertificateLetterFieldsInput = {
  beilage?: Maybe<CertificateDocTextInput>;
  contactLine?: Maybe<Scalars['String']>;
  contactShow?: Maybe<Scalars['Boolean']>;
  senderLine?: Maybe<Scalars['String']>;
  stufenList?: Maybe<Scalars['String']>;
  stufenShow?: Maybe<Scalars['Boolean']>;
  stufenTitle?: Maybe<Scalars['String']>;
  window?: Maybe<Scalars['String']>;
};

export type CertificateSigner = {
  name: Scalars['String'];
  role: Scalars['String'];
};

export type CertificateSignerInput = {
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CertificateSizes = {
  abschluss?: Maybe<Scalars['String']>;
  akkreditierung?: Maybe<Scalars['String']>;
  badge?: Maybe<Scalars['String']>;
  bandContact?: Maybe<Scalars['String']>;
  bandStufen?: Maybe<Scalars['String']>;
  bandTitle?: Maybe<Scalars['String']>;
  beschreibung?: Maybe<Scalars['String']>;
  docMid?: Maybe<Scalars['String']>;
  fuss?: Maybe<Scalars['String']>;
  grat?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  kl?: Maybe<Scalars['String']>;
  kurs?: Maybe<Scalars['String']>;
  kursSub?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mittel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  org?: Maybe<Scalars['String']>;
  titel?: Maybe<Scalars['String']>;
  untertitel?: Maybe<Scalars['String']>;
  veranstalter?: Maybe<Scalars['String']>;
  zert?: Maybe<Scalars['String']>;
};

export type CertificateSizesInput = {
  abschluss?: Maybe<Scalars['String']>;
  akkreditierung?: Maybe<Scalars['String']>;
  badge?: Maybe<Scalars['String']>;
  bandContact?: Maybe<Scalars['String']>;
  bandStufen?: Maybe<Scalars['String']>;
  bandTitle?: Maybe<Scalars['String']>;
  beschreibung?: Maybe<Scalars['String']>;
  docMid?: Maybe<Scalars['String']>;
  fuss?: Maybe<Scalars['String']>;
  grat?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  kl?: Maybe<Scalars['String']>;
  kurs?: Maybe<Scalars['String']>;
  kursSub?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mittel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  org?: Maybe<Scalars['String']>;
  titel?: Maybe<Scalars['String']>;
  untertitel?: Maybe<Scalars['String']>;
  veranstalter?: Maybe<Scalars['String']>;
  zert?: Maybe<Scalars['String']>;
};

export type CertificateTemplate = {
  accentColor?: Maybe<Scalars['String']>;
  badgeImage?: Maybe<Scalars['String']>;
  blockLayout?: Maybe<CertificateBlockLayout>;
  congratulationText?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  designVariant: CertificateDesignVariant;
  docFields?: Maybe<CertificateDocFields>;
  footerText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructorName?: Maybe<Scalars['String']>;
  introText?: Maybe<Scalars['String']>;
  letterFields?: Maybe<CertificateLetterFields>;
  logo?: Maybe<Scalars['String']>;
  middleText?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organisationName?: Maybe<Scalars['String']>;
  signers?: Maybe<Array<CertificateSigner>>;
  sizes?: Maybe<CertificateSizes>;
  titleText?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  visibility?: Maybe<CertificateTemplateVisibility>;
};

export type CertificateTemplateVisibility = {
  datum: Scalars['Boolean'];
  fuss: Scalars['Boolean'];
  geburtsdatum: Scalars['Boolean'];
  grat: Scalars['Boolean'];
  intro: Scalars['Boolean'];
  kl: Scalars['Boolean'];
  kurs: Scalars['Boolean'];
  logo: Scalars['Boolean'];
  mittel: Scalars['Boolean'];
  nummer: Scalars['Boolean'];
  organisation: Scalars['Boolean'];
  signers: Scalars['Boolean'];
  titel: Scalars['Boolean'];
  zertifikat: Scalars['Boolean'];
};

export type CertificateTemplateVisibilityInput = {
  datum?: Maybe<Scalars['Boolean']>;
  fuss?: Maybe<Scalars['Boolean']>;
  geburtsdatum?: Maybe<Scalars['Boolean']>;
  grat?: Maybe<Scalars['Boolean']>;
  intro?: Maybe<Scalars['Boolean']>;
  kl?: Maybe<Scalars['Boolean']>;
  kurs?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['Boolean']>;
  mittel?: Maybe<Scalars['Boolean']>;
  nummer?: Maybe<Scalars['Boolean']>;
  organisation?: Maybe<Scalars['Boolean']>;
  signers?: Maybe<Scalars['Boolean']>;
  titel?: Maybe<Scalars['Boolean']>;
  zertifikat?: Maybe<Scalars['Boolean']>;
};

export type Chargeback = {
  chargebackedAt?: Maybe<Scalars['DateTime']>;
  fee?: Maybe<Scalars['Float']>;
  mollieChargebackId: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
};

export type ChargebackFilterInput = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  includeManualRetries?: Maybe<Scalars['Boolean']>;
  onlyOpen?: Maybe<Scalars['Boolean']>;
};

export type ChargebackSummary = {
  totalChargebackCount30d: Scalars['Int'];
  totalChargebackFee30d: Scalars['Float'];
};

export type CheckboxItemInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

/** Grund, warum der Submit im EUA-Checkout gesperrt war */
export enum CheckoutBlockerCode {
  AgbUnconfirmed = 'AgbUnconfirmed',
  AllAttendeesAlreadyBooked = 'AllAttendeesAlreadyBooked',
  AttendeeAgeDoesNotFit = 'AttendeeAgeDoesNotFit',
  AttendeeCreationPending = 'AttendeeCreationPending',
  AttendeeMissing = 'AttendeeMissing',
  BookerBirthdayMissing = 'BookerBirthdayMissing',
  BookerHasNoAttendees = 'BookerHasNoAttendees',
  LateEntryGate = 'LateEntryGate',
  MollieMethodMissing = 'MollieMethodMissing',
  NoAttendeeFitsCourse = 'NoAttendeeFitsCourse',
  PaymentMethodMissing = 'PaymentMethodMissing',
  PrivacyUnconfirmed = 'PrivacyUnconfirmed',
  RequiredInputMissing = 'RequiredInputMissing',
  RequirementGroupsUnmet = 'RequirementGroupsUnmet',
  SepaDataInvalid = 'SepaDataInvalid'
}

export type ChronologicalLessonsResult = {
  lessons: Array<BillingStatusCoursLessons>;
  total: Scalars['Float'];
};

export type CollitionCheckInput = {
  courseId?: Maybe<Scalars['ID']>;
  courseLessonId?: Maybe<Scalars['ID']>;
  courseLessonIndex?: Maybe<Scalars['Float']>;
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
  venueId: Scalars['ID'];
};

export type ColorsInput = {
  enabeld?: Maybe<Scalars['Boolean']>;
  primary?: Maybe<Scalars['String']>;
  secondary?: Maybe<Scalars['String']>;
  tertiary?: Maybe<Scalars['String']>;
};

export type CompanySetting = {
  agb?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  bankAccountHolder?: Maybe<Scalars['String']>;
  BIC?: Maybe<Scalars['String']>;
  businessForm?: Maybe<Scalars['String']>;
  commercialRegister?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId: Scalars['String'];
  creditorId?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  IBAN?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  koOrganization: KoOrganization;
  localCourt?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mailjetSenderId: Scalars['String'];
  name: Scalars['String'];
  ownerCity: Scalars['String'];
  ownerCountry: Scalars['String'];
  ownerEmail: Scalars['String'];
  ownerFax?: Maybe<Scalars['String']>;
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  ownerPhone?: Maybe<Scalars['String']>;
  ownerStreet: Scalars['String'];
  ownerStreetNumber: Scalars['String'];
  ownerZip: Scalars['String'];
  privacyStatement?: Maybe<Scalars['String']>;
  qrIban?: Maybe<Scalars['String']>;
  sendFromEmail: Scalars['String'];
  taxId?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

export type CompanySettingInput = {
  agb?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  bankAccountHolder?: Maybe<Scalars['String']>;
  BIC?: Maybe<Scalars['String']>;
  businessForm?: Maybe<Scalars['String']>;
  commercialRegister?: Maybe<Scalars['String']>;
  creditorId?: Maybe<Scalars['String']>;
  IBAN?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  localCourt?: Maybe<Scalars['String']>;
  logo?: Maybe<LogoInput>;
  name: Scalars['String'];
  ownerCity: Scalars['String'];
  ownerCountry: Scalars['String'];
  ownerEmail: Scalars['String'];
  ownerFax?: Maybe<Scalars['String']>;
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  ownerPhone?: Maybe<Scalars['String']>;
  ownerStreet: Scalars['String'];
  ownerStreetNumber: Scalars['String'];
  ownerZip: Scalars['String'];
  privacyStatement?: Maybe<Scalars['String']>;
  qrIban?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type Content = {
  ETag?: Maybe<Scalars['String']>;
  Key: Scalars['String'];
  LastModified?: Maybe<Scalars['DateTime']>;
  Name?: Maybe<Scalars['String']>;
  pdfBlob?: Maybe<Scalars['String']>;
  signedImageUrl?: Maybe<Scalars['String']>;
  Size?: Maybe<Scalars['Float']>;
  StorageClass?: Maybe<Array<Scalars['JSONObject']>>;
};

export type ContentOfBucket = {
  ContentOfBucketResponse?: Maybe<ContentOfBucketResponse>;
  Files?: Maybe<Array<Content>>;
  Folders?: Maybe<Array<Content>>;
};

export type ContentOfBucketResponse = {
  CommonPrefixes?: Maybe<Array<Scalars['JSONObject']>>;
  Contents?: Maybe<Array<Scalars['JSONObject']>>;
  Delimiter?: Maybe<Scalars['String']>;
  EncodingType?: Maybe<Scalars['String']>;
  IsTruncated?: Maybe<Scalars['Boolean']>;
  Marker?: Maybe<Scalars['String']>;
  MaxKeys?: Maybe<Scalars['Float']>;
  Name?: Maybe<Scalars['String']>;
  NextMarker?: Maybe<Scalars['String']>;
  Prefix?: Maybe<Scalars['String']>;
};

/** Wie eine Überzahlung bei der Korrektur ausgeglichen wird. */
export enum CorrectionRefundMode {
  BookerCredit = 'BookerCredit',
  MollieRefund = 'MollieRefund'
}

export enum CountryCode {
  At = 'At',
  Be = 'Be',
  Ch = 'Ch',
  De = 'De',
  Dk = 'Dk',
  Nl = 'Nl'
}

export type CountryNetwork = {
  comment?: Maybe<Scalars['String']>;
  features: Array<Scalars['String']>;
  mcc: Scalars['String'];
  mncs?: Maybe<Array<Scalars['String']>>;
  networkName?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
};

export type Course = {
  additionalItems: Array<CourseAdditionalItem>;
  additionalShortInfo?: Maybe<Scalars['String']>;
  allowLessonBooking: Scalars['Boolean'];
  allowMolliePayment?: Maybe<Scalars['Boolean']>;
  allowMonthlyPayment?: Maybe<Scalars['Boolean']>;
  allowUpFrontPayment?: Maybe<Scalars['Boolean']>;
  annotation: Scalars['String'];
  billedBookingCount: Scalars['Float'];
  blockBookingOnline: Scalars['Boolean'];
  bookingCount: Scalars['Float'];
  bookingCountWithoutWaitlist: Scalars['Float'];
  bookingPriceQuote?: Maybe<CourseBookingPriceQuote>;
  bookingRestriction?: Maybe<BookingRestriction>;
  bookingRestrictionId?: Maybe<Scalars['ID']>;
  canceledBookingsCount: Scalars['Float'];
  courseNumber: Scalars['Float'];
  courseNumberFormat: CourseNumberFormat;
  coursePrice: Array<CoursePrice>;
  coursePrices: Array<CoursePrice>;
  courseType: CourseType;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  customCourseNumberPrefix: Scalars['String'];
  customInvoiceDueDays?: Maybe<Scalars['Float']>;
  cycle: CourseCycle;
  dateOfFirstInstallment?: Maybe<Scalars['DateTime']>;
  enabledCourses?: Maybe<Array<EnabledCourse>>;
  endDateTime: Scalars['DateTime'];
  endDateTimeFirstCourseLesson: Scalars['DateTime'];
  freePlaces: Scalars['Float'];
  id: Scalars['ID'];
  installmentRates: Array<InstallmentRate>;
  instructors: Array<Instructor>;
  isActive: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isPrerequisiteForCourseCount: Scalars['Float'];
  lateEntryPricingMode: CourseLateEntryPricingMode;
  lessonCount?: Maybe<Scalars['Float']>;
  lessons: Array<CourseLesson>;
  location: Location;
  locationId: Scalars['ID'];
  maxAssistantsPerLesson?: Maybe<Scalars['Float']>;
  maxAttendees: Scalars['Float'];
  maxWaitlist?: Maybe<Scalars['Float']>;
  minAttendees: Scalars['Float'];
  minimumPartialBookingLessonCount?: Maybe<Scalars['Int']>;
  mollieOptional?: Maybe<Scalars['Boolean']>;
  monthlySchedule: MonthlySchedule;
  paymentInterval?: Maybe<PaymentInterval>;
  paymentType?: Maybe<PaymentType>;
  placeReservationsCount: Scalars['Float'];
  prefixedCourseNumber?: Maybe<Scalars['String']>;
  /** @deprecated Immer null. Freigabekurse über bookingRestriction.prerequisiteCourses lesen. */
  prerequisiteCourses?: Maybe<Array<Course>>;
  settledBookingCount: Scalars['Float'];
  settledBookings: Array<Booking>;
  showInWeb: Scalars['Boolean'];
  startDateTime: Scalars['DateTime'];
  unSettledBookings: Array<Booking>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  venue: Venue;
  venueId: Scalars['ID'];
  visibility: CourseVisibilityResult;
  waitListCount: Scalars['Float'];
  websiteInfo?: Maybe<Scalars['String']>;
};

export type CourseAdditionalItem = {
  courseId?: Maybe<Scalars['ID']>;
  courseTypeId?: Maybe<Scalars['ID']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  id: Scalars['ID'];
  mode: AdditionalItemMode;
  title: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type CourseAdditionalItemInput = {
  description?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  id?: Maybe<Scalars['ID']>;
  mode: AdditionalItemMode;
  title: Scalars['String'];
  updateDate?: Maybe<Scalars['DateTime']>;
  vat?: Maybe<Scalars['Float']>;
};

export enum CourseBookingBasePriceBlockingReason {
  MinimumPartialBookingLessonCountNotReached = 'MinimumPartialBookingLessonCountNotReached',
  NoEligibleLessons = 'NoEligibleLessons'
}

export type CourseBookingPriceQuote = {
  blockingReason?: Maybe<CourseBookingBasePriceBlockingReason>;
  calculationVersion: Scalars['String'];
  courseId: Scalars['ID'];
  coursePriceId: Scalars['ID'];
  effectiveMinimum: Scalars['Int'];
  effectiveMode: CourseLateEntryPricingMode;
  eligibleLessonCount: Scalars['Int'];
  eligibleLessonIds: Array<Scalars['ID']>;
  fingerprint: Scalars['String'];
  isBookable: Scalars['Boolean'];
  isPartialBooking: Scalars['Boolean'];
  originalGrossPrice: Scalars['Float'];
  pricedAt: Scalars['DateTime'];
  reduction: Scalars['Float'];
  serviceGrossPrice: Scalars['Float'];
  totalLessonCount: Scalars['Int'];
  totalLessonIds: Array<Scalars['ID']>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type CourseCategory = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  linkedCourseTypes: Array<CourseType>;
  name: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export enum CourseCycle {
  Custom = 'Custom',
  EveryTwoWeeks = 'EveryTwoWeeks',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type CourseDetails = {
  billedBookings: Array<Booking>;
  canceledBookings: Array<Booking>;
  course: Course;
  courseId: Scalars['ID'];
  placeReservations: Array<Booking>;
  unbilledBookings: Array<Booking>;
  waitlistBookings: Array<Booking>;
};

export type CourseDetailsInput = {
  age?: Maybe<Scalars['JSONObject']>;
  calendar?: Maybe<Scalars['JSONObject']>;
  city?: Maybe<Scalars['JSONObject']>;
  courseFee?: Maybe<Scalars['JSONObject']>;
  courseInfos?: Maybe<Scalars['JSONObject']>;
  courseLessons?: Maybe<Scalars['JSONObject']>;
  entranceFee?: Maybe<Scalars['JSONObject']>;
  firstCourseLesson?: Maybe<Scalars['JSONObject']>;
  freePlaces?: Maybe<Scalars['JSONObject']>;
  instructor?: Maybe<Scalars['JSONObject']>;
  lessonCount?: Maybe<Scalars['JSONObject']>;
  location?: Maybe<Scalars['JSONObject']>;
  status?: Maybe<Scalars['JSONObject']>;
};

export type CourseDetailsLessonBookings = {
  bookings?: Maybe<Array<Booking>>;
  bookingType: BookingType;
  courseLessonBookings?: Maybe<Array<CourseLessonBooking>>;
};

export type CourseHistory = {
  action: CourseHistoryAction;
  course?: Maybe<Course>;
  courseId: Scalars['ID'];
  courseStartDateTime?: Maybe<Scalars['DateTime']>;
  createDate: Scalars['DateTime'];
  createdBy?: Maybe<UserDetailsType>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  newValues?: Maybe<Scalars['JSONObject']>;
  oldValues?: Maybe<Scalars['JSONObject']>;
  prefixedCourseNumber?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  user?: Maybe<UserDetailsType>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export enum CourseHistoryAction {
  CourseArchive = 'CourseArchive',
  CourseCreate = 'CourseCreate',
  CourseDelete = 'CourseDelete',
  CourseLessonAdded = 'CourseLessonAdded',
  CourseLessonDeleted = 'CourseLessonDeleted',
  CourseLessonsAdded = 'CourseLessonsAdded',
  CourseLessonsDeleted = 'CourseLessonsDeleted',
  CourseLessonUpdated = 'CourseLessonUpdated',
  CoursePriceAdded = 'CoursePriceAdded',
  CoursePriceDeleted = 'CoursePriceDeleted',
  CoursePricesBulkChanged = 'CoursePricesBulkChanged',
  CoursePriceUpdated = 'CoursePriceUpdated',
  CourseUnarchive = 'CourseUnarchive',
  CourseUpdate = 'CourseUpdate',
  InstallmentRateAdded = 'InstallmentRateAdded',
  InstallmentRateDeleted = 'InstallmentRateDeleted',
  InstallmentRatesAdded = 'InstallmentRatesAdded',
  InstallmentRatesDeleted = 'InstallmentRatesDeleted',
  InstallmentRatesRecalculated = 'InstallmentRatesRecalculated',
  InstallmentRateUpdated = 'InstallmentRateUpdated',
  InstructorsChanged = 'InstructorsChanged',
  Unknown = 'Unknown',
  Updated = 'Updated',
  VisibilityChanged = 'VisibilityChanged'
}

export type CourseHistoryFilterInput = {
  action?: Maybe<CourseHistoryAction>;
  courseId?: Maybe<Scalars['ID']>;
  prefixedCourseNumber?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  startDateFrom?: Maybe<Scalars['DateTime']>;
  startDateTo?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CourseHistoryPaginationInput = {
  orderBy?: Maybe<Scalars['String']>;
  orderDirection?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type CourseHistoryWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<CourseHistory>;
  total: Scalars['Float'];
};

export type CourseIdInput = {
  id: Scalars['ID'];
};

export type CourseInstructorIdInput = {
  id: Scalars['ID'];
};

export enum CourseLateEntryPricingMode {
  OriginalPrice = 'ORIGINAL_PRICE',
  RemainingLessons = 'REMAINING_LESSONS'
}

export type CourseLesson = {
  billingAmount?: Maybe<Scalars['Float']>;
  billingDate?: Maybe<Scalars['DateTime']>;
  bookings?: Maybe<Array<Booking>>;
  course: Course;
  courseId: Scalars['ID'];
  courseLessonAssistants?: Maybe<Array<CourseLessonAssistant>>;
  courseLessonBookingCount: Scalars['Float'];
  courseLessonBookings: Array<CourseLessonBooking>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  endDateTime: Scalars['DateTime'];
  freePlaces: Scalars['Float'];
  id: Scalars['ID'];
  indexOfLessonInCourse?: Maybe<Scalars['Float']>;
  instructorInvoice?: Maybe<InstructorInvoice>;
  instructorInvoiceId?: Maybe<Scalars['String']>;
  instructors: Array<Instructor>;
  location: Location;
  locationId: Scalars['ID'];
  revenueGross: Scalars['Float'];
  roomCost?: Maybe<Scalars['Float']>;
  startDateTime: Scalars['DateTime'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  venue: Venue;
  venueId: Scalars['ID'];
};

export type CourseLessonAssistant = {
  assignedAt: Scalars['DateTime'];
  assistantId: Scalars['ID'];
  courseLessonId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type CourseLessonBooking = {
  attendance?: Maybe<Scalars['Boolean']>;
  booking: Booking;
  bookingDate?: Maybe<Scalars['DateTime']>;
  bookingId: Scalars['ID'];
  bookingType?: Maybe<BookingType>;
  courseId?: Maybe<Scalars['String']>;
  courseLesson: CourseLesson;
  courseLessonId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type CourseLessonBookingAttendanceList = {
  attendee: Attendee;
  booker: Booker;
  bookingId: Scalars['String'];
  courseLessonBooking: Array<CourseLessonBooking>;
};

export type CourseLessonBookingsPreview = {
  bookingId?: Maybe<Scalars['String']>;
  courseLessonBookings?: Maybe<Array<CourseLessonBooking>>;
};

export type CourseLessonForBillingStatusInput = {
  groupBillingStatusBy?: Maybe<GroupBillingStatusBy>;
  options?: Maybe<ArrayDataOptions>;
};

export type CourseLessonIdInput = {
  id: Scalars['ID'];
};

export type CourseLessonWithIndexOfCourseLessonInCourse = {
  billingAmount?: Maybe<Scalars['Float']>;
  billingDate?: Maybe<Scalars['DateTime']>;
  bookings?: Maybe<Array<Booking>>;
  course: Course;
  courseId: Scalars['ID'];
  courseLessonAssistants?: Maybe<Array<CourseLessonAssistant>>;
  courseLessonBookingCount: Scalars['Float'];
  courseLessonBookings: Array<CourseLessonBooking>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  endDateTime: Scalars['DateTime'];
  freePlaces: Scalars['Float'];
  id: Scalars['ID'];
  indexOfLessonInCourse: Scalars['Float'];
  instructorInvoice?: Maybe<InstructorInvoice>;
  instructorInvoiceId?: Maybe<Scalars['String']>;
  instructors: Array<Instructor>;
  location: Location;
  locationId: Scalars['ID'];
  originalCourseLessonId: Scalars['ID'];
  revenueGross: Scalars['Float'];
  roomCost?: Maybe<Scalars['Float']>;
  startDateTime: Scalars['DateTime'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  venue: Venue;
  venueId: Scalars['ID'];
};

export type CourseLessonWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<CourseLesson>;
  total: Scalars['Float'];
};

export type CourseListFilters = {
  city?: Maybe<Scalars['String']>;
  courseCategoryId?: Maybe<Scalars['String']>;
  courseCategoryIds?: Maybe<Array<Scalars['String']>>;
  courseTypeId?: Maybe<Scalars['String']>;
  courseTypeIds?: Maybe<Array<Scalars['String']>>;
  dayFilter?: Maybe<Array<DayFilter>>;
  ids?: Maybe<Array<Scalars['String']>>;
  instructorId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  monthFilter?: Maybe<Array<MonthFilter>>;
  prerequisiteCourseId?: Maybe<Scalars['String']>;
  restrictiveCourses?: Maybe<Array<RestrictiveCourses>>;
  showOnlyInWebActive?: Maybe<Scalars['Boolean']>;
};

export enum CourseNotVisibleReason {
  CourseShowInWeb = 'CourseShowInWeb',
  CourseTypeShowInWeb = 'CourseTypeShowInWeb',
  HideAfterDays = 'HideAfterDays',
  HideAfterRestrictionEnd = 'HideAfterRestrictionEnd',
  IsArchived = 'IsArchived',
  LocationIsPublic = 'LocationIsPublic',
  MembersOnly = 'MembersOnly',
  PrerequisiteCourses = 'PrerequisiteCourses'
}

export enum CourseNumberFormat {
  CourseLocationPrefix = 'CourseLocationPrefix',
  CourseTypePrefix = 'CourseTypePrefix',
  CustomPrefix = 'CustomPrefix',
  NoPrefix = 'NoPrefix'
}

export type CoursePrice = {
  bookings?: Maybe<Array<Booking>>;
  course: Course;
  courseId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  id: Scalars['ID'];
  includedEntranceFee?: Maybe<Scalars['Float']>;
  isSpecial: Scalars['Boolean'];
  netPrice?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  vat: Scalars['Float'];
};

export type CoursePriceIdInput = {
  id: Scalars['ID'];
};

export enum CourseSearchDisplayMode {
  Grid = 'Grid',
  Table = 'Table'
}

export type CourseSummaryForBilling = {
  courseId: Scalars['ID'];
  coursePrefixedNumber: Scalars['String'];
  courseTypeColor?: Maybe<Scalars['String']>;
  courseTypeName: Scalars['String'];
  hourlyRate: Scalars['Float'];
  lessonCount: Scalars['Float'];
  locationName?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  totalAmount: Scalars['Float'];
  totalMinutes: Scalars['Float'];
};

export type CourseTableInput = {
  columns?: Maybe<Array<Scalars['JSONObject']>>;
};

export type CourseType = {
  additionalItems: Array<CourseAdditionalItem>;
  annotation?: Maybe<Scalars['String']>;
  bold: Scalars['Boolean'];
  category?: Maybe<CourseCategory>;
  color: Scalars['String'];
  courseCount: Scalars['Float'];
  courses?: Maybe<Array<Course>>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
  inWeekPlanner: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  maxAge?: Maybe<Scalars['Float']>;
  maxAttendees?: Maybe<Scalars['Float']>;
  minAge?: Maybe<Scalars['Float']>;
  minAttendees?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  participationPrerequisites?: Maybe<Array<ParticipationPrerequisites>>;
  paymentInterval?: Maybe<PaymentInterval>;
  selfBookerCourse?: Maybe<Scalars['Boolean']>;
  shortHandId: Scalars['String'];
  showInWeb: Scalars['Boolean'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
  websiteInfo?: Maybe<Scalars['String']>;
};

export type CourseTypeWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<CourseType>;
  total: Scalars['Float'];
};

export type CourseVisibilityRestriction = {
  endDateTime?: Maybe<Scalars['DateTime']>;
  expireAction: ExpireAction;
  inTimeRange: Scalars['Boolean'];
  membersOnly: Scalars['Boolean'];
  prerequisiteCourses: Array<Course>;
  startDateTime?: Maybe<Scalars['DateTime']>;
};

export type CourseVisibilityResult = {
  hideAfterDays?: Maybe<Scalars['Float']>;
  reason: Array<CourseNotVisibleReason>;
  restriction: CourseVisibilityRestriction;
  visibleForAll: Scalars['Boolean'];
};

export type CourseWithPagination = {
  existsMore: Scalars['Boolean'];
  hiddenMembersOnlyCount?: Maybe<Scalars['Float']>;
  hiddenPrerequisiteCount?: Maybe<Scalars['Float']>;
  items: Array<Course>;
  total: Scalars['Float'];
};

export type CourseWithPaginationWithEnabledCourses = {
  existsMore: Scalars['Boolean'];
  items: Array<Course>;
  total: Scalars['Float'];
};

export type CreateAdminManagementUserInput = {
  confirmMerge?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  sendNotification?: Maybe<Scalars['Boolean']>;
};

export type CreateAnnouncementInput = {
  isActive: Scalars['Boolean'];
  isDismissible: Scalars['Boolean'];
  isMinimizable: Scalars['Boolean'];
  koOrganizationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  priority: AnnouncementPriority;
  targetUrl?: Maybe<Scalars['String']>;
  targetUrlLabel?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: AnnouncementType;
  validFrom?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type CreateAttendanceListBulkByInstructorInput = {
  columnsToShow?: Maybe<Array<Scalars['String']>>;
  endDate: Scalars['DateTime'];
  instructorId: Scalars['ID'];
  sendEmail?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
};

export type CreateAttendanceListBulkByLocationInput = {
  columnsToShow?: Maybe<Array<Scalars['String']>>;
  endDate: Scalars['DateTime'];
  locationId: Scalars['ID'];
  sendEmail?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
};

export type CreateBillingAddressTemplateInput = {
  addition?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type CreateCertificateTemplateInput = {
  accentColor?: Maybe<Scalars['String']>;
  badgeImage?: Maybe<Scalars['String']>;
  blockLayout?: Maybe<CertificateBlockLayoutInput>;
  congratulationText?: Maybe<Scalars['String']>;
  designVariant?: Maybe<CertificateDesignVariant>;
  docFields?: Maybe<CertificateDocFieldsInput>;
  footerText?: Maybe<Scalars['String']>;
  instructorName?: Maybe<Scalars['String']>;
  introText?: Maybe<Scalars['String']>;
  letterFields?: Maybe<CertificateLetterFieldsInput>;
  logo?: Maybe<Scalars['String']>;
  middleText?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organisationName?: Maybe<Scalars['String']>;
  signers?: Maybe<Array<CertificateSignerInput>>;
  sizes?: Maybe<CertificateSizesInput>;
  titleText?: Maybe<Scalars['String']>;
  visibility?: Maybe<CertificateTemplateVisibilityInput>;
};

export type CreateCourse = {
  locationId?: Maybe<Scalars['ID']>;
};

export enum CreatedBy {
  AdminApp = 'ADMIN_APP',
  DummyData = 'DUMMY_DATA',
  EndUserApp = 'END_USER_APP',
  Import = 'IMPORT'
}

export type CreateDummySwissCamtByScheduledPaymentsInput = {
  scheduledPayments?: Maybe<Array<CamtScheduledPaymentInput>>;
};

export type CreateDunningInput = {
  bookingId: Scalars['ID'];
  feeAmount?: Maybe<Scalars['Float']>;
  force?: Maybe<Scalars['Boolean']>;
  level?: Maybe<DunningLevel>;
  sendMail: Scalars['Boolean'];
};

export type CreateFeeLetterInput = {
  bookingId: Scalars['ID'];
  letterNumber: Scalars['String'];
  sendMail: Scalars['Boolean'];
  totalAmount: Scalars['Float'];
};

export type CreateInstallmentRateByCourseCreateInput = {
  id?: Maybe<Scalars['ID']>;
  installmentAmount?: Maybe<Scalars['Float']>;
  installmentDue?: Maybe<Scalars['DateTime']>;
  installmentType?: Maybe<InstallmentType>;
};

export type CreateInstructorInvoiceInput = {
  courseLessonIds: Array<Scalars['ID']>;
  instructorId: Scalars['ID'];
};

export type CreateInterestListInput = {
  courseTypeId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  maxEntries?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  showNoteField?: Maybe<Scalars['Boolean']>;
  timeSlots?: Maybe<Array<InterestListTimeSlotInput>>;
};

export type CreateInterestRegistrationInput = {
  allTimesPossible?: Maybe<Scalars['Boolean']>;
  attendeeId: Scalars['ID'];
  bookerId: Scalars['ID'];
  interestListId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  selectedTimeSlotIds?: Maybe<Array<Scalars['ID']>>;
};

export type CreateMailjetSenderInput = {
  Email: Scalars['String'];
  EmailType?: Maybe<EmailTypeEnum>;
  IsDefaultSender?: Maybe<Scalars['Boolean']>;
  Name: Scalars['String'];
};

export type CreateMailjetSenderOutput = {
  CreatedAt: Scalars['String'];
  DNSID: Scalars['Float'];
  Email: Scalars['String'];
  EmailType: Scalars['String'];
  Filename: Scalars['String'];
  ID: Scalars['Float'];
  IsDefaultSender: Scalars['Boolean'];
  Name: Scalars['String'];
  Status: Scalars['String'];
};

export type CreateMultipleSepaXmlInput = {
  collectionDate: Scalars['DateTime'];
  ids: Array<Scalars['String']>;
};

export type CreateOrganizationResult = {
  adminErrors?: Maybe<Array<Scalars['String']>>;
  createdAdmins?: Maybe<Array<Scalars['String']>>;
  host: Scalars['String'];
  organizationId: Scalars['String'];
  sendFromEmail: Scalars['String'];
};

export type CreatePrefixedCourseNumberInput = {
  courseNumber: Scalars['Float'];
  courseNumberFormat: CourseNumberFormat;
  courseTypeId: Scalars['ID'];
  customCourseNumberPrefix?: Maybe<Scalars['String']>;
  koOrganizationId: Scalars['ID'];
  locationId: Scalars['ID'];
  prefixedCourseNumber?: Maybe<Scalars['String']>;
};

export type CreateSepaXmlByTimeRangeInput = {
  collectionDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxMoneyAmount?: Maybe<Scalars['Float']>;
  saveFile?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CreateSingleSepaXmlInput = {
  collectionDate: Scalars['DateTime'];
  id: Scalars['String'];
};

export type CreateWithdrawalEndUserAppInput = {
  bookingReference: Scalars['String'];
  email: Scalars['String'];
  honeypot?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
};

export type CreditEntry = {
  amount: Scalars['Float'];
  balanceAfter: Scalars['Float'];
  bookerId: Scalars['ID'];
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mollieRefundId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  reason: CreditEntryReason;
  scheduledPaymentId?: Maybe<Scalars['ID']>;
  sourceBookerId?: Maybe<Scalars['ID']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export enum CreditEntryReason {
  BookingCredited = 'BookingCredited',
  BookingReleased = 'BookingReleased',
  CancelRest = 'CancelRest',
  CancelRestKept = 'CancelRestKept',
  CancelRestManualRefund = 'CancelRestManualRefund',
  Correction = 'Correction',
  EditOverpayment = 'EditOverpayment',
  Manual = 'Manual',
  Merge = 'Merge',
  OpeningBalance = 'OpeningBalance',
  Overpayment = 'Overpayment',
  Transfer = 'Transfer',
  TransferSurplus = 'TransferSurplus',
  TransferSurplusManualRefund = 'TransferSurplusManualRefund',
  TransferSurplusRefund = 'TransferSurplusRefund',
  TransferSurplusRefundReverted = 'TransferSurplusRefundReverted'
}

export enum Currency {
  Chf = 'Chf',
  Eur = 'Eur',
  Gbp = 'Gbp',
  Usd = 'Usd'
}

export type CustomBankData = {
  bankCode: Scalars['String'];
  bic: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Customer = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  customerNumber: Scalars['Float'];
  customerNumberPrefix: Scalars['String'];
  erasedAt?: Maybe<Scalars['DateTime']>;
  firstname: Scalars['String'];
  gender: Gender;
  id: Scalars['ID'];
  lastname: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

/** Ein Eintrag der Kunden-Zeitleiste (Kundenakte) */
export type CustomerTimelineEntry = {
  actorName?: Maybe<Scalars['String']>;
  at: Scalars['DateTime'];
  attendeeId?: Maybe<Scalars['ID']>;
  bookingAllowsLessonBooking?: Maybe<Scalars['Boolean']>;
  bookingId?: Maybe<Scalars['ID']>;
  bookingIsSettled?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  kind: CustomerTimelineKind;
  params?: Maybe<Scalars['JSONObject']>;
  source?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Quelle eines Eintrags der Kunden-Zeitleiste */
export enum CustomerTimelineKind {
  AttendeeMerge = 'AttendeeMerge',
  BookerMerge = 'BookerMerge',
  BookingHistory = 'BookingHistory',
  CreditEntry = 'CreditEntry',
  CustomerEvent = 'CustomerEvent',
  EmailSent = 'EmailSent',
  MagicLinkLogin = 'MagicLinkLogin',
  Milestone = 'Milestone'
}

export type DatabaseBackup = {
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  fusionAuthIncluded: Scalars['Boolean'];
  fusionDbCustomKey: Scalars['String'];
  fusionDbPlainKey: Scalars['String'];
  id: Scalars['ID'];
  koDbCustomKey: Scalars['String'];
  koDbPlainKey: Scalars['String'];
  koOrganizationId: Scalars['String'];
  status: Scalars['String'];
  totalSize: Scalars['Int'];
};

export type DataExport = {
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  koOrganizationId: Scalars['String'];
  progress: Scalars['Int'];
  recordCount: Scalars['Int'];
  s3Key: Scalars['String'];
  status: Scalars['String'];
  totalSize: Scalars['Int'];
};


export enum DayFilter {
  Dienstag = 'Dienstag',
  Donnerstag = 'Donnerstag',
  Freitag = 'Freitag',
  Mittwoch = 'Mittwoch',
  Montag = 'Montag',
  Samstag = 'Samstag',
  Sonntag = 'Sonntag'
}

export type DetailsCheckboxInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
};

export enum DetectionRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type DiscountCode = {
  allowWithMemberDiscount: Scalars['Boolean'];
  bookings: Array<Booking>;
  code: Scalars['String'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  deactivatedReason?: Maybe<Scalars['String']>;
  discountUnit: DiscountUnit;
  discountValue: Scalars['Float'];
  effectiveValidUntil?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  redemptionCount: Scalars['Int'];
  referenceCount: Scalars['Int'];
  scopeIds: Array<Scalars['ID']>;
  scopeLabels: Array<Scalars['String']>;
  scopeType: DiscountCodeScopeType;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  validFrom: Scalars['DateTime'];
  validUntil?: Maybe<Scalars['DateTime']>;
  validUntilCourseEnd: Scalars['Boolean'];
};

export type DiscountCodeCheckResult = {
  discountCode?: Maybe<DiscountCode>;
  reason?: Maybe<DiscountCodeRejectReason>;
  redemptionCount: Scalars['Int'];
  valid: Scalars['Boolean'];
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type DiscountCodeInput = {
  allowWithMemberDiscount?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  discountUnit: DiscountUnit;
  discountValue: Scalars['Float'];
  internalName?: Maybe<Scalars['String']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  scopeIds?: Maybe<Array<Scalars['ID']>>;
  scopeType: DiscountCodeScopeType;
  validFrom?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  validUntilCourseEnd?: Maybe<Scalars['Boolean']>;
};

export enum DiscountCodeRejectReason {
  Deactivated = 'Deactivated',
  Exhausted = 'Exhausted',
  Expired = 'Expired',
  NotYetValid = 'NotYetValid',
  Unknown = 'Unknown',
  WrongCourse = 'WrongCourse'
}

export enum DiscountCodeScopeType {
  All = 'All',
  Courses = 'Courses',
  CourseTypes = 'CourseTypes',
  Locations = 'Locations'
}

export type DiscountCodeUpdateInput = {
  allowWithMemberDiscount?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  discountUnit?: Maybe<DiscountUnit>;
  discountValue?: Maybe<Scalars['Float']>;
  internalName?: Maybe<Scalars['String']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  scopeIds?: Maybe<Array<Scalars['ID']>>;
  scopeType?: Maybe<DiscountCodeScopeType>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  validUntilCourseEnd?: Maybe<Scalars['Boolean']>;
};

export enum DiscountUnit {
  Euro = 'Euro',
  Percentage = 'Percentage'
}

export type DismissDuplicatePairInput = {
  bookerId1: Scalars['ID'];
  bookerId2: Scalars['ID'];
};

export type DownloadBackupInput = {
  backupId: Scalars['ID'];
  database: Scalars['String'];
  format: Scalars['String'];
};

export type Dunning = {
  bookingId: Scalars['ID'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  dunningNumber: Scalars['String'];
  feeAmount: Scalars['Float'];
  feeDeleted?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceId: Scalars['ID'];
  level: DunningLevel;
  openAmount: Scalars['Float'];
  paymentDue: Scalars['String'];
  scheduledPaymentId?: Maybe<Scalars['ID']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  totalAmount: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  voidedAt?: Maybe<Scalars['DateTime']>;
  withdrawnAt?: Maybe<Scalars['DateTime']>;
  withdrawnReason?: Maybe<Scalars['String']>;
};

export enum DunningLevel {
  Level1 = 'Level1',
  Level2 = 'Level2',
  Level3 = 'Level3',
  Reminder = 'Reminder'
}

export type DunningPause = {
  note?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['String']>;
};

export type DunningProposal = {
  blocker?: Maybe<Scalars['String']>;
  dunningNumber?: Maybe<Scalars['String']>;
  earliestDate?: Maybe<Scalars['String']>;
  feeAmount: Scalars['Float'];
  items: Array<DunningProposalItem>;
  level?: Maybe<DunningLevel>;
  levelLabel?: Maybe<Scalars['String']>;
  openAmount: Scalars['Float'];
  paymentDue?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  tooEarly: Scalars['Boolean'];
  totalAmount: Scalars['Float'];
};

export type DunningProposalItem = {
  openAmount: Scalars['Float'];
  paymentDue: Scalars['DateTime'];
  scheduledPaymentId: Scalars['ID'];
  title: Scalars['String'];
};

export type DuplicateDetectionRun = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  duplicateMatchesFound?: Maybe<Scalars['Float']>;
  durationMs?: Maybe<Scalars['Float']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: DetectionRunStatus;
  totalBookersProcessed?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type DuplicateException = {
  booker1?: Maybe<Booker>;
  booker2?: Maybe<Booker>;
  bookerId1: Scalars['ID'];
  bookerId2: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type DuplicateGroupMatchInfo = {
  bestMatchType: DuplicateMatchType;
  score: Scalars['Float'];
  scoreBreakdown?: Maybe<ScoreBreakdownType>;
};

export type DuplicateGroupWithMetadata = {
  bookers: Array<Booker>;
  matchInfo: DuplicateGroupMatchInfo;
};

export type DuplicateMatch = {
  booker1?: Maybe<Booker>;
  booker2?: Maybe<Booker>;
  bookerId1?: Maybe<Scalars['ID']>;
  bookerId2?: Maybe<Scalars['ID']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  detectedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  matchType: DuplicateMatchType;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  score: Scalars['Float'];
  scoreBreakdown?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type DuplicateMatchStats = {
  affectedBookerCount: Scalars['Float'];
  autoMergeableGroups: Scalars['Float'];
  totalGroups: Scalars['Float'];
};

export enum DuplicateMatchType {
  Composite = 'COMPOSITE',
  ExactEmail = 'EXACT_EMAIL',
  ExactName = 'EXACT_NAME',
  FuzzyName = 'FUZZY_NAME'
}

export type EditAttendeeBadgeInput = {
  attendeeBadgeId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  dateOfAchivement?: Maybe<Scalars['DateTime']>;
};

export type EditBookingInput = {
  additionalInfo?: Maybe<Scalars['String']>;
  additionalItemIds?: Maybe<Array<Scalars['ID']>>;
  agbConfirmed?: Maybe<Scalars['Boolean']>;
  attendeeId?: Maybe<Scalars['ID']>;
  bookingNumberPrefix?: Maybe<Scalars['String']>;
  bookingType?: Maybe<BookingType>;
  courseId?: Maybe<Scalars['ID']>;
  coursePriceId?: Maybe<Scalars['ID']>;
  creditedBalance?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountName?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  grossPrice?: Maybe<Scalars['Float']>;
  isSpecial?: Maybe<Scalars['Boolean']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  netPrice?: Maybe<Scalars['Float']>;
  noticeBooker?: Maybe<Scalars['String']>;
  noticeStaff?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  paymentType?: Maybe<PaymentType>;
  privacyStatementConfirmed?: Maybe<Scalars['Boolean']>;
  scheduledPayments?: Maybe<Array<UpdateScheduledPaymentByBookingInput>>;
  specialPrice?: Maybe<Scalars['Float']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  vat?: Maybe<Scalars['Float']>;
};

export type EditBookingInputBookableLessons = {
  additionalInfo?: Maybe<Scalars['String']>;
  additionalItemIds?: Maybe<Array<Scalars['ID']>>;
  agbConfirmed?: Maybe<Scalars['Boolean']>;
  attendeeId?: Maybe<Scalars['ID']>;
  bookingNumber?: Maybe<Scalars['Float']>;
  bookingNumberPrefix?: Maybe<Scalars['String']>;
  bookingType?: Maybe<BookingType>;
  courseId: Scalars['ID'];
  courseLessonIds?: Maybe<Array<Scalars['ID']>>;
  coursePriceId?: Maybe<Scalars['ID']>;
  creditedBalance?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<Scalars['String']>;
  discountName?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  forceWaitlist?: Maybe<Scalars['Boolean']>;
  foundUs?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isSpecial?: Maybe<Scalars['Boolean']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  netPrice?: Maybe<Scalars['Float']>;
  newsLetter?: Maybe<Scalars['Boolean']>;
  noticeBooker?: Maybe<Scalars['String']>;
  noticeStaff?: Maybe<Scalars['String']>;
  notifyUser?: Maybe<Scalars['Boolean']>;
  omitMemberDiscount?: Maybe<Scalars['Boolean']>;
  overbook?: Maybe<Scalars['Boolean']>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  paymentType?: Maybe<PaymentType>;
  pricingCalculationVersion?: Maybe<Scalars['String']>;
  pricingFingerprint?: Maybe<Scalars['String']>;
  privacyStatementConfirmed?: Maybe<Scalars['Boolean']>;
  scheduledPayments?: Maybe<Array<UpdateScheduledPaymentByBookingInput>>;
  specialPrice?: Maybe<Scalars['Float']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  utmSource?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type EditCourseInput = {
  additionalItems?: Maybe<Array<CourseAdditionalItemInput>>;
  additionalItemsKnownIds?: Maybe<Array<Scalars['ID']>>;
  additionalShortInfo?: Maybe<Scalars['String']>;
  allowLessonBooking?: Maybe<Scalars['Boolean']>;
  allowMolliePayment?: Maybe<Scalars['Boolean']>;
  allowMonthlyPayment?: Maybe<Scalars['Boolean']>;
  allowUpFrontPayment?: Maybe<Scalars['Boolean']>;
  annotation?: Maybe<Scalars['String']>;
  blockBookingOnline?: Maybe<Scalars['Boolean']>;
  courseNumberFormat?: Maybe<CourseNumberFormat>;
  coursePrices?: Maybe<Array<EditCoursePriceInput>>;
  courseTypeId?: Maybe<Scalars['ID']>;
  customCourseNumberPrefix?: Maybe<Scalars['String']>;
  customInvoiceDueDays?: Maybe<Scalars['Float']>;
  cycle?: Maybe<CourseCycle>;
  dateOfFirstInstallment?: Maybe<Scalars['DateTime']>;
  defaultLessonCount?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  installmentRates?: Maybe<Array<UpdateInstallmentRateInput>>;
  instructors?: Maybe<Array<CourseInstructorIdInput>>;
  isActive?: Maybe<Scalars['Boolean']>;
  lateEntryPricingMode?: Maybe<CourseLateEntryPricingMode>;
  lessons: Array<EditCourseLessonInput>;
  locationId?: Maybe<Scalars['ID']>;
  maxAssistantsPerLesson?: Maybe<Scalars['Float']>;
  maxAttendees?: Maybe<Scalars['Float']>;
  maxWaitlist?: Maybe<Scalars['Float']>;
  minAttendees?: Maybe<Scalars['Float']>;
  minimumPartialBookingLessonCount?: Maybe<Scalars['Int']>;
  mollieOptional?: Maybe<Scalars['Boolean']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  paymentInterval?: Maybe<PaymentInterval>;
  paymentType?: Maybe<PaymentType>;
  showInWeb?: Maybe<Scalars['Boolean']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  vat?: Maybe<Scalars['Float']>;
  venueId?: Maybe<Scalars['ID']>;
  websiteInfo?: Maybe<Scalars['String']>;
};

export type EditCourseLessonInput = {
  courseId?: Maybe<Scalars['ID']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  instructors?: Maybe<Array<CourseInstructorIdInput>>;
  locationId?: Maybe<Scalars['ID']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  venueId?: Maybe<Scalars['ID']>;
};

export type EditCoursePriceInput = {
  courseId: Scalars['ID'];
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<DiscountUnit>;
  grossPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  includedEntranceFee?: Maybe<Scalars['Float']>;
  isSpecial?: Maybe<Scalars['Boolean']>;
  netPrice?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

export type EditInvoiceInput = {
  billed?: Maybe<Scalars['DateTime']>;
  qrReference?: Maybe<Scalars['String']>;
};

export type EditLocationContactInput = {
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  salutation?: Maybe<SalutationType>;
};

export type EditLocationInput = {
  abbreviation?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<Scalars['JSONObject']>>;
  emailVariableInfo?: Maybe<Scalars['String']>;
  generalLocationContact?: Maybe<GeneralLocationContactInput>;
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  locationContacts?: Maybe<Array<LocationContactIdInput>>;
  name?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  venues?: Maybe<Array<EditVenueInput>>;
  website?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type EditPageInput = {
  content: Scalars['JSONObject'];
  id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type EditScheduledPaymentInput = {
  openAmount?: Maybe<Scalars['Float']>;
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentTransferType?: Maybe<PaymentTransferType>;
};

export type EditTemplateInput = {
  footerText?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type EditVenueInput = {
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  rent?: Maybe<Scalars['Float']>;
  rentType?: Maybe<RentType>;
};

/** Einzelner Check der Buchbarkeits-Diagnose */
export type EligibilityCheck = {
  key: EligibilityCheckKey;
  params?: Maybe<Scalars['JSONObject']>;
  status: EligibilityCheckStatus;
};

/** Schluessel eines Buchbarkeits-Checks; der Client uebersetzt ihn per i18n */
export enum EligibilityCheckKey {
  AgeAtCourseStart = 'AgeAtCourseStart',
  AttendeeAlreadyBooked = 'AttendeeAlreadyBooked',
  AttendeeCustomerMatchesBooker = 'AttendeeCustomerMatchesBooker',
  BookerHasPaymentMethod = 'BookerHasPaymentMethod',
  CourseHasFreePlaces = 'CourseHasFreePlaces',
  CourseOnlineBookable = 'CourseOnlineBookable',
  DuplicateAttendeesOnBooker = 'DuplicateAttendeesOnBooker',
  MembersOnly = 'MembersOnly',
  MolliePaymentAvailable = 'MolliePaymentAvailable',
  PrerequisiteBookingOnOtherAttendee = 'PrerequisiteBookingOnOtherAttendee',
  PrerequisiteBookingPresent = 'PrerequisiteBookingPresent',
  RestrictionActive = 'RestrictionActive',
  RestrictionTimeWindow = 'RestrictionTimeWindow'
}

/** Ergebnis eines einzelnen Buchbarkeits-Checks */
export enum EligibilityCheckStatus {
  Fail = 'Fail',
  NotApplicable = 'NotApplicable',
  Ok = 'Ok',
  Warn = 'Warn'
}

export type EmailData = {
  attachInvoices?: Maybe<Scalars['Boolean']>;
  attachReversalInvoices?: Maybe<Scalars['Boolean']>;
  ids: Array<Scalars['String']>;
  mailDataType: MailDataType;
  receivers: Array<Scalars['String']>;
};

export type EmailNotification = {
  attachments?: Maybe<Array<Scalars['JSONObject']>>;
  bookerId?: Maybe<Scalars['String']>;
  booking?: Maybe<Booking>;
  bookingDeleted?: Maybe<Scalars['DateTime']>;
  bookingId?: Maybe<Scalars['ID']>;
  courseDetailsSnapshot?: Maybe<Array<Scalars['JSONObject']>>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  html?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastMessageStatus?: Maybe<MessageStatus>;
  mailjetTemplateId?: Maybe<Scalars['Float']>;
  messageHistory?: Maybe<MessageHistory>;
  messageHref?: Maybe<Scalars['String']>;
  messageID?: Maybe<Scalars['ID']>;
  messageStatus?: Maybe<MessageStatusData>;
  receiverName?: Maybe<Scalars['String']>;
  renderVariablesSnapshot?: Maybe<Scalars['JSONObject']>;
  status: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type EmailNotificationWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<EmailNotification>;
  total: Scalars['Float'];
};

export enum EmailTypeEnum {
  Bulk = 'Bulk',
  Transactional = 'Transactional',
  Unknown = 'Unknown'
}

export type EnabledCourse = {
  bookingRestriction?: Maybe<BookingRestriction>;
  courseType: CourseType;
  enabledPrerequisites?: Maybe<Array<Course>>;
  enabledRestriction?: Maybe<BookingRestriction>;
  id: Scalars['ID'];
  prefixedCourseNumber: Scalars['String'];
  visibility?: Maybe<CourseVisibilityResult>;
};

export enum EndUserEmailRegistrationStatus {
  Available = 'AVAILABLE',
  Confirmable = 'CONFIRMABLE',
  Taken = 'TAKEN',
  TakenByStaff = 'TAKEN_BY_STAFF'
}

/** Vom Kunden gesetzte Listenfilter zum Zeitpunkt der leeren Kursliste */
export type EndUserEventCourseFilterInput = {
  city?: Maybe<Scalars['String']>;
  courseCategoryId?: Maybe<Scalars['String']>;
  courseCategoryIds?: Maybe<Array<Scalars['String']>>;
  courseTypeId?: Maybe<Scalars['String']>;
  courseTypeIds?: Maybe<Array<Scalars['String']>>;
  dayFilter?: Maybe<Array<DayFilter>>;
  instructorId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  monthFilter?: Maybe<Array<MonthFilter>>;
  prerequisiteCourseId?: Maybe<Scalars['String']>;
};

/** Client-Zustand der End-User-App fuer die Kundenakte */
export type EndUserEventInput = {
  attendeeId?: Maybe<Scalars['ID']>;
  blockerCodes?: Maybe<Array<CheckoutBlockerCode>>;
  courseId?: Maybe<Scalars['ID']>;
  filters?: Maybe<EndUserEventCourseFilterInput>;
  hasPaymentMethod?: Maybe<Scalars['Boolean']>;
  step?: Maybe<EndUserEventStep>;
  type: EndUserReportedEventType;
};

/** Schritt der End-User-App, in dem der Zustand auftrat */
export enum EndUserEventStep {
  BookingSummary = 'BookingSummary',
  CourseList = 'CourseList'
}

export type EndUserPasswordlessLoginInputType = {
  companyName?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
  sendFromMail?: Maybe<Scalars['String']>;
};

/** Von der End-User-App gemeldeter Client-Zustand fuer die Kundenakte */
export enum EndUserReportedEventType {
  CheckoutAbandoned = 'CheckoutAbandoned',
  CheckoutBlocked = 'CheckoutBlocked',
  CourseListEmpty = 'CourseListEmpty'
}

export type EntityCount = {
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type ErasureCounterType = {
  action: Scalars['String'];
  rows: Scalars['Int'];
  table: Scalars['String'];
};

export type ErasureLinkedBookerType = {
  customerNumber: Scalars['Int'];
  customerNumberPrefix: Scalars['String'];
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
};

export type ErasureReportType = {
  attendeeCount: Scalars['Int'];
  bookerIds: Array<Scalars['ID']>;
  bookingCount: Scalars['Int'];
  counters: Array<ErasureCounterType>;
  customerNumbers: Array<Scalars['String']>;
  deletedWaitlistBookingCount: Scalars['Int'];
  dryRun: Scalars['Boolean'];
  erasedAt?: Maybe<Scalars['DateTime']>;
  fusionAuthAccountDeleted?: Maybe<Scalars['Boolean']>;
  hasLoginAccount: Scalars['Boolean'];
  invoiceNumbers: Array<Scalars['String']>;
  linkedBookers: Array<ErasureLinkedBookerType>;
  retentionEndsAt?: Maybe<Scalars['DateTime']>;
  warnings: Array<ErasureWarningType>;
};

export type ErasureWarningType = {
  amount?: Maybe<Scalars['Float']>;
  /** Ausführung lehnt ab, bis der Punkt erledigt ist. */
  blocking?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  message: Scalars['String'];
};

export type ExecuteBulkTransferInput = {
  /** Kommunikation nach der Umbuchung, für alle Buchungen gleich; fehlende Felder nehmen je Buchung den Default. */
  communication?: Maybe<TransferCommunicationInput>;
  /** Notizfelder der alten Buchungen nicht übernehmen. */
  deleteNotes?: Maybe<Scalars['Boolean']>;
  /** Eine Erwartung je Quellbuchung aus der Vorschau. */
  expected: Array<TransferBulkRowExpectationInput>;
  plan: TransferBulkPlanInput;
};

export type ExecuteBulkTransferResult = {
  results: Array<ExecuteBulkTransferRowResult>;
  /** Nacharbeiten, die nach dem Commit fehlgeschlagen sind, je mit Buchungsnummer. Die Umbuchungen selbst sind verbucht. */
  warnings: Array<Scalars['String']>;
};

export type ExecuteBulkTransferRowResult = {
  /** Die neue Buchung im Zielkurs. */
  booking: Booking;
  /** Rechnung der neuen Buchung, wenn sie sofort erzeugt wurde. */
  invoiceB?: Maybe<TransferInvoiceRef>;
  /** true, wenn die Umbuchungs-E-Mail versendet wurde (#664). */
  mailSent?: Maybe<Scalars['Boolean']>;
  /** Hinweise des Plans (Preisfindung, Rabatte) — rein informativ. */
  messages: Array<Scalars['String']>;
  /** true, wenn die alte Buchung gelöscht wurde (statt storniert). */
  oldBookingDeleted: Scalars['Boolean'];
  /** Der tatsächlich ausgeführte, serverseitig neu berechnete Plan. */
  plan: TransferPlanPreview;
  /** Wartelistenplatz aus dem Quellkurs, der durch das Löschen nachgerückt ist. */
  promotedBookingId?: Maybe<Scalars['ID']>;
  /** Stornobeleg der bisherigen Buchung (nur bei Storno mit Beleg). */
  reversalInvoice?: Maybe<TransferInvoiceRef>;
  sourceBookingId: Scalars['ID'];
  sourceBookingNumber: Scalars['String'];
  /** Was mit dem Überschuss geschehen ist (#665): Guthaben, Mollie-Refund (angelegt oder gescheitert) oder manuell erstattet. */
  surplusOutcome?: Maybe<TransferSurplusOutcome>;
  /** Vorgangs-Token des Übertrags (Idempotenz-Schlüssel). */
  transferOperationId: Scalars['ID'];
  /**
   * Nacharbeiten, die nach dem Commit fehlgeschlagen sind (Stornobeleg, Rechnung,
   * E-Mail, Online-Zahlung, Nachrücken). Die Umbuchung selbst ist verbucht.
   */
  warnings: Array<Scalars['String']>;
};

export type ExecuteTransferInput = {
  /** Kommunikation nach der Umbuchung: Mail, Anhänge, Rechnung sofort (#664). */
  communication?: Maybe<TransferCommunicationInput>;
  /** Bestätigung der vollständigen Posten- und Ratenvorschau. Bei expliziten Postenentscheidungen erforderlich. */
  confirmationToken?: Maybe<Scalars['String']>;
  /** Notizfelder der alten Buchung nicht auf die neue übernehmen. */
  deleteNotes?: Maybe<Scalars['Boolean']>;
  /** Optimistic-Concurrency-Precondition: auf die neue Buchung übertragener Betrag. */
  expectedAppliedToB: Scalars['Float'];
  /** Optimistic-Concurrency-Precondition: übernommene offene Posten aus der alten Buchung. */
  expectedCarriedOverItems?: Maybe<Array<TransferCarriedOverItemInput>>;
  /** Optimistic-Concurrency-Precondition: Rabatt der neuen Buchung aus der Vorschau (ohne Mitgliederrabatt). */
  expectedDiscountB?: Maybe<Scalars['Float']>;
  /** Optimistic-Concurrency-Precondition: geplante Behandlung der alten Buchung. */
  expectedOldBookingTreatment: TransferOldBookingTreatment;
  /** Optimistic-Concurrency-Precondition: Preis der neuen Buchung aus der Vorschau (inkl. abgezogenem Mitgliederrabatt). */
  expectedPriceB: Scalars['Float'];
  /** Optimistic-Concurrency-Precondition: Überschuss, der Guthaben bleibt. */
  expectedSurplus: Scalars['Float'];
  plan: TransferPlanInput;
  /** Nachrücken im Quellkurs (nur wirksam, wenn die alte Buchung gelöscht wird). */
  sourceDeleteAction?: Maybe<TransferSourceDeleteActionInput>;
};

export type ExecuteTransferResult = {
  /** Die neue Buchung im Zielkurs. */
  booking: Booking;
  /** Rechnung der neuen Buchung, wenn sie sofort erzeugt wurde. */
  invoiceB?: Maybe<TransferInvoiceRef>;
  /** true, wenn die Umbuchungs-E-Mail versendet wurde (#664). */
  mailSent?: Maybe<Scalars['Boolean']>;
  /** Hinweise des Plans (Preisfindung, Rabatte) — rein informativ. */
  messages: Array<Scalars['String']>;
  /** true, wenn die alte Buchung gelöscht wurde (statt storniert). */
  oldBookingDeleted: Scalars['Boolean'];
  /** Der tatsächlich ausgeführte, serverseitig neu berechnete Plan. */
  plan: TransferPlanPreview;
  /** Wartelistenplatz aus dem Quellkurs, der durch das Löschen nachgerückt ist. */
  promotedBookingId?: Maybe<Scalars['ID']>;
  /** Stornobeleg der bisherigen Buchung (nur bei Storno mit Beleg). */
  reversalInvoice?: Maybe<TransferInvoiceRef>;
  /** Was mit dem Überschuss geschehen ist (#665): Guthaben, Mollie-Refund (angelegt oder gescheitert) oder manuell erstattet. */
  surplusOutcome?: Maybe<TransferSurplusOutcome>;
  /** Vorgangs-Token des Übertrags (Idempotenz-Schlüssel). */
  transferOperationId: Scalars['ID'];
  /**
   * Nacharbeiten, die nach dem Commit fehlgeschlagen sind (Stornobeleg, Rechnung,
   * E-Mail, Online-Zahlung, Nachrücken). Die Umbuchung selbst ist verbucht.
   */
  warnings: Array<Scalars['String']>;
};

export enum ExpireAction {
  HideFromAll = 'HideFromAll',
  ShowToAll = 'ShowToAll'
}

export type ExportedSepaXml = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  koOrganizationId: Scalars['ID'];
  object?: Maybe<Scalars['JSONObject']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  xml?: Maybe<Scalars['String']>;
};

export type ExportedSepaXmlWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<ExportedSepaXml>;
  total: Scalars['Float'];
};

export type FaUser = {
  active?: Maybe<Scalars['Boolean']>;
  birthDate?: Maybe<Scalars['String']>;
  breachedPasswordLastCheckedInstant?: Maybe<Scalars['Float']>;
  cleanSpeakId?: Maybe<Scalars['ID']>;
  connectorId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSONObject']>;
  email?: Maybe<Scalars['String']>;
  encryptionScheme?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Float']>;
  factor?: Maybe<Scalars['Float']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  insertInstant?: Maybe<Scalars['Float']>;
  lastLoginInstant?: Maybe<Scalars['Float']>;
  lastName?: Maybe<Scalars['String']>;
  lastUpdateInstant?: Maybe<Scalars['Float']>;
  middleName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  parentEmail?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  passwordChangeReason?: Maybe<Scalars['String']>;
  passwordChangeRequired?: Maybe<Scalars['Boolean']>;
  passwordLastUpdateInstant?: Maybe<Scalars['Float']>;
  preferredLanguages?: Maybe<Array<Scalars['String']>>;
  registrations?: Maybe<Array<UserRegistration>>;
  salt?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
  timezone?: Maybe<Scalars['String']>;
  uniqueUsername?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type FeeLetter = {
  bookingId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  letterNumber: Scalars['String'];
  paymentDue: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  totalAmount: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type FeeLetterItem = {
  amount: Scalars['Float'];
  scheduledPaymentId: Scalars['ID'];
  title: Scalars['String'];
};

export type FeeLetterProposal = {
  blocker?: Maybe<Scalars['String']>;
  items: Array<FeeLetterItem>;
  letterNumber?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  totalAmount: Scalars['Float'];
};

export enum FilterCompareOperation {
  Eq = 'EQ',
  Gr = 'GR',
  Greq = 'GREQ',
  Lo = 'LO',
  Loeq = 'LOEQ'
}

export type FilterExpressionInput = {
  childExpressions?: Maybe<Array<FilterExpressionInput>>;
  filters: Array<FilterInput>;
  operator: Operator;
};

export type FilterInput = {
  field: Scalars['String'];
  op: Operation;
  relationField?: Maybe<Scalars['String']>;
  values: Array<Scalars['String']>;
};

export enum FilterOperation {
  Compare = 'COMPARE',
  Search = 'SEARCH'
}

export type FilterOption = {
  column: Scalars['String'];
  compareOperation?: Maybe<FilterCompareOperation>;
  operation?: Maybe<FilterOperation>;
  table: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type FiltersInput = {
  age?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  courseCategory?: Maybe<Scalars['String']>;
  courseType?: Maybe<Scalars['String']>;
  instructor?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  weekDay?: Maybe<Scalars['String']>;
};

export type FindUnpaidInSepaInput = {
  paymentDueEnd?: Maybe<Scalars['DateTime']>;
  paymentDueStart?: Maybe<Scalars['DateTime']>;
  sepaExportIds: Array<Scalars['ID']>;
};

export type ForgotPasswordInput = {
  changePasswordId: Scalars['String'];
  newPassword: Scalars['String'];
};

export type ForgotPasswordWithApiKeyInput = {
  applicationId: Scalars['String'];
  loginId: Scalars['String'];
  sendFogotPasswordEmail?: Maybe<Scalars['Boolean']>;
  state: ResetPasswordStateType;
};

export type ForgotPasswordWithStateInput = {
  loginId: Scalars['String'];
  sendForgotPasswordEmail?: Maybe<Scalars['Boolean']>;
  state: ResetPasswordStateType;
};

export enum Gender {
  Diverse = 'Diverse',
  Female = 'Female',
  Male = 'Male',
  NotDefined = 'NotDefined'
}

export type GeneralLocationContact = {
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type GeneralLocationContactInput = {
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type GetAnnouncementsInput = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  includeGlobal?: Maybe<Scalars['Boolean']>;
  koOrganizationId?: Maybe<Scalars['String']>;
};

export type GetBookableOptionsInput = {
  attendeeId: Scalars['ID'];
  bookingType: BookingType;
  courseId: Scalars['ID'];
};

export type GetReceiversForCourseInput = {
  courseIds: Array<Scalars['String']>;
  notifyBookings: Scalars['Boolean'];
  notifyCancelations: Scalars['Boolean'];
  notifyWaitlist: Scalars['Boolean'];
};

export enum GrossNet {
  Gross = 'Gross',
  Net = 'Net'
}

export enum GroupBillingStatusBy {
  Instructor = 'INSTRUCTOR'
}

/** Quelle eines Updates über updateCourseAndBookings — steuert das Suffix in History-Einträgen. */
export enum HistorySource {
  BookingAdjustment = 'BookingAdjustment',
  CourseEdit = 'CourseEdit'
}

export type Holiday = {
  color?: Maybe<Scalars['String']>;
  countryCode?: Maybe<CountryCode>;
  end: Scalars['DateTime'];
  holidayStateColor: Scalars['String'];
  id: Scalars['ID'];
  koOrganizationId: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  start: Scalars['DateTime'];
  stateCode: StateCode;
  type: HolidayType;
  year: Scalars['Float'];
};

export type HolidayInput = {
  color?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  holidayStateColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  stateCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  year: Scalars['Float'];
};

export enum HolidayType {
  Custom = 'CUSTOM',
  Public = 'PUBLIC',
  School = 'SCHOOL'
}

export type HolidayWithDays = {
  color?: Maybe<Scalars['String']>;
  countryCode?: Maybe<CountryCode>;
  days: Array<Scalars['DateTime']>;
  end: Scalars['DateTime'];
  holidayStateColor: Scalars['String'];
  id: Scalars['ID'];
  koOrganizationId: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  start: Scalars['DateTime'];
  stateCode: StateCode;
  type: HolidayType;
  year: Scalars['Float'];
};

export enum I18n {
  De = 'De',
  DeDu = 'DeDU',
  DeSie = 'DeSIE',
  En = 'En'
}

export type ImportBookerInput = {
  annotation?: Maybe<Scalars['String']>;
  attendeeAddition: Scalars['String'];
  attendeeAnnotation: Scalars['String'];
  attendeeBirthDate: Scalars['String'];
  attendeeFirstName: Scalars['String'];
  attendeeGender?: Maybe<Scalars['String']>;
  attendeeId?: Maybe<Scalars['Float']>;
  attendeeLastName: Scalars['String'];
  badges?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  BIC?: Maybe<Scalars['String']>;
  bookerAddition: Scalars['String'];
  bookerAnnotation: Scalars['String'];
  bookerBirthDate?: Maybe<Scalars['String']>;
  bookerCity: Scalars['String'];
  bookerEmail?: Maybe<Scalars['String']>;
  bookerFirstName: Scalars['String'];
  bookerGender: Scalars['String'];
  bookerHouseNumber?: Maybe<Scalars['String']>;
  bookerId?: Maybe<Scalars['Float']>;
  bookerLastName: Scalars['String'];
  bookerMobileNumber: Scalars['String'];
  bookerPhoneNumber: Scalars['String'];
  bookerPostCode: Scalars['String'];
  bookerStreet: Scalars['String'];
  bookingsKo9?: Maybe<Scalars['String']>;
  credit?: Maybe<Scalars['Float']>;
  defaultPaymentMethod: Scalars['String'];
  dsgvo: Scalars['String'];
  healthInsuranceFund: Scalars['String'];
  IBAN?: Maybe<Scalars['String']>;
  initialContact: Scalars['String'];
  ko9DatabaseHash?: Maybe<Scalars['String']>;
  koOrganizationId: Scalars['String'];
  member: Scalars['String'];
  newsletter: Scalars['String'];
  nonDisclosureNotice?: Maybe<Scalars['String']>;
  sepaAccountholder?: Maybe<Scalars['String']>;
};

export type ImportBookersInput = {
  bookers: Array<ImportBookerInput>;
};

export type InlinedAttachment = {
  Base64Content: Scalars['String'];
  ContentID: Scalars['String'];
  ContentType: Scalars['String'];
  Filename: Scalars['String'];
};

export type InstallmentChangePreview = {
  newAmount?: Maybe<Scalars['Float']>;
  oldAmount?: Maybe<Scalars['Float']>;
  /** Fälligkeit einer neu erzeugten Rate (Wechsel der Zahlweise). */
  paymentDue?: Maybe<Scalars['DateTime']>;
  spId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  type: InstallmentChangeType;
};

/** Art der vorgeschlagenen Raten-Änderung in der Korrektur-Vorschau. */
export enum InstallmentChangeType {
  Adjust = 'Adjust',
  Create = 'Create',
  NewLink = 'NewLink',
  Refund = 'Refund',
  Remove = 'Remove',
  Settle = 'Settle',
  VoidLink = 'VoidLink'
}

export type InstallmentRate = {
  course: Course;
  courseId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  installmentAmount: Scalars['Float'];
  installmentDue: Scalars['DateTime'];
  installmentType: InstallmentType;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export enum InstallmentType {
  Discount = 'Discount',
  Standard = 'Standard'
}

export type Instructor = {
  accountHolder?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  activeCourseCount: Scalars['Float'];
  allowLogin: Scalars['Boolean'];
  annotation?: Maybe<Scalars['String']>;
  assignedLocations: Array<Location>;
  bank?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<Scalars['JSONObject']>>;
  email?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoices: Array<InstructorInvoice>;
  isAreaManager: Scalars['Boolean'];
  joinDate?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  leaveDate?: Maybe<Scalars['String']>;
  level: Scalars['Float'];
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  salutation: SalutationType;
  showInWeb: Scalars['Boolean'];
  socialSecurityNumber?: Maybe<Scalars['String']>;
  staff: Staff;
  staffId: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  testColumn?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  vat?: Maybe<Scalars['Float']>;
};

export type InstructorCourseGroup = {
  courseCount: Scalars['Int'];
  courseIds: Array<Scalars['String']>;
  instructorEmail: Scalars['String'];
  instructorId: Scalars['ID'];
  instructorName: Scalars['String'];
};

export type InstructorDetailsView = {
  active: Scalars['Boolean'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  joinDate?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  leaveDate?: Maybe<Scalars['String']>;
  level: Scalars['Float'];
  showInWeb: Scalars['Boolean'];
};

export type InstructorInvoice = {
  courseLessons: Array<CourseLesson>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  instructor: Instructor;
  instructorId: Scalars['ID'];
  invoiceDate: Scalars['DateTime'];
  invoiceNumber: Scalars['String'];
  lessonCount: Scalars['Float'];
  pdfPath: Scalars['String'];
  pdfUrl?: Maybe<Scalars['String']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  totalAmount: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type InstructorInvoicesByDateRangeInput = {
  endDate: Scalars['DateTime'];
  instructorId: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type InstructorsWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<Instructor>;
  total: Scalars['Float'];
};

export type InterestList = {
  courseType: CourseType;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isFull: Scalars['Boolean'];
  location: Location;
  maxEntries?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  showNoteField: Scalars['Boolean'];
  timeSlots?: Maybe<Array<InterestListTimeSlot>>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type InterestListTimeSlot = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interestList: InterestList;
  sortOrder: Scalars['Float'];
  startTime?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  weekday: DayFilter;
};

export type InterestListTimeSlotInput = {
  endTime?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['String']>;
  weekday: DayFilter;
};

export type InterestRegistration = {
  allTimesPossible: Scalars['Boolean'];
  attendee: Attendee;
  booker: Booker;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interestList: InterestList;
  internalNote?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  selectedTimeSlots: Array<InterestListTimeSlot>;
  status: InterestRegistrationStatus;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export enum InterestRegistrationStatus {
  Contacted = 'Contacted',
  Done = 'Done',
  New = 'New'
}

export type InterestRegistrationWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<InterestRegistration>;
  total: Scalars['Int'];
};

export type Invoice = {
  billed?: Maybe<Scalars['DateTime']>;
  booking: Booking;
  bookingId: Scalars['ID'];
  correctionDate?: Maybe<Scalars['DateTime']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceBody: Scalars['String'];
  invoiceFileName: Scalars['String'];
  invoiceNumber: Scalars['Float'];
  invoiceNumberPrefix: Scalars['String'];
  koOrganization: KoOrganization;
  mollieGenerated: Scalars['Boolean'];
  paymentDue?: Maybe<Scalars['DateTime']>;
  qrReference?: Maybe<Scalars['String']>;
  scheduledPayments?: Maybe<Array<ScheduledPayment>>;
  sentAt?: Maybe<Scalars['DateTime']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type InvoiceExport = {
  courseId?: Maybe<Scalars['ID']>;
  courseLabel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  includeReversals: Scalars['Boolean'];
  koOrganizationId: Scalars['String'];
  month?: Maybe<Scalars['Int']>;
  progress: Scalars['Int'];
  recordCount: Scalars['Int'];
  s3Key: Scalars['String'];
  status: Scalars['String'];
  totalSize: Scalars['Int'];
  year?: Maybe<Scalars['Int']>;
};

export type InvoiceInput = {
  bookingId: Scalars['ID'];
};

export enum InvoiceLayoutVariant {
  Din_5008 = 'DIN_5008',
  SwissSn_010_130 = 'SWISS_SN_010_130'
}

export enum InvoiceLogoPosition {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type InvoiceTemplateSet = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  customLogo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  layoutVariant: InvoiceLayoutVariant;
  logoPosition: InvoiceLogoPosition;
  name: Scalars['String'];
  secondLogo?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type InvoiceWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<Invoice>;
  total: Scalars['Float'];
};

export type IssueCertificateInput = {
  attendeeBadgeId: Scalars['String'];
  courseId?: Maybe<Scalars['String']>;
  sendEmail: Scalars['Boolean'];
};

export type IssueCertificatesByAttendeesInput = {
  attendeeIds: Array<Scalars['ID']>;
  badgeId: Scalars['ID'];
  onlyFulfilled?: Maybe<Scalars['Boolean']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
};

export type IssueCertificatesByCourseInput = {
  badgeId: Scalars['String'];
  courseId: Scalars['String'];
  onlyFulfilled: Scalars['Boolean'];
  sendEmail: Scalars['Boolean'];
};

export type IssuedCertificate = {
  attendeeBadgeId: Scalars['ID'];
  attendeeName?: Maybe<Scalars['String']>;
  certificateNumber: Scalars['String'];
  certificateTemplateId: Scalars['ID'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  emailSentAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  issuedAt: Scalars['DateTime'];
  issuedByUserId?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type IssuedCertificatesFilterInput = {
  badgeId?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['String']>;
};

export type JournalParams = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  type: JournalType;
};

export enum JournalType {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  Replies = 'Replies',
  Voice = 'Voice'
}


export type KeyValue = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Ko9ConnectionTestResult = {
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Ko9DbCredentialsInput = {
  database: Scalars['String'];
  host: Scalars['String'];
  password: Scalars['String'];
  port: Scalars['Int'];
  user: Scalars['String'];
};

export type Ko9ImportConfigInput = {
  defaultDsgvo: Scalars['Boolean'];
  defaultNewsletter: Scalars['Boolean'];
  defaultPaymentMethod: Scalars['String'];
  skipBadges: Scalars['Boolean'];
  skipBookingsKo9: Scalars['Boolean'];
};

export type Ko9ImportCredentials = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  database: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['ID'];
  port: Scalars['Int'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  user: Scalars['String'];
};

export type Ko9ImportProgressType = {
  errorMessage?: Maybe<Scalars['String']>;
  importedAttendees: Scalars['Int'];
  importedBookers: Scalars['Int'];
  phase: Scalars['String'];
  result?: Maybe<Scalars['JSONObject']>;
  skippedBookers: Scalars['Int'];
  totalAttendees: Scalars['Int'];
  totalBookers: Scalars['Int'];
};

export type Ko9LoadedCredentials = {
  database: Scalars['String'];
  host: Scalars['String'];
  port: Scalars['Int'];
  user: Scalars['String'];
};

export type Ko9PreviewResultType = {
  previewRows: Array<Ko9PreviewRowType>;
  schema: Ko9SchemaInfoType;
  totalAttendees: Scalars['Int'];
  totalBookers: Scalars['Int'];
  totalRows: Scalars['Int'];
};

export type Ko9PreviewRowType = {
  attendeeName: Scalars['String'];
  badgesCount: Scalars['Int'];
  birthday: Scalars['String'];
  bookerName: Scalars['String'];
  bookingsCount: Scalars['Int'];
  city: Scalars['String'];
  email: Scalars['String'];
  sepaInfo: Scalars['String'];
};

export type Ko9RollbackResultType = {
  deletedAttendees: Scalars['Int'];
  deletedBookers: Scalars['Int'];
  deletedPaymentMethods: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Ko9SaveResult = {
  success: Scalars['Boolean'];
};

export type Ko9SchemaInfoType = {
  adressenPkColumn?: Maybe<Scalars['String']>;
  allTables: Array<Scalars['String']>;
  hasAbzeichen: Scalars['Boolean'];
  hasAdressen: Scalars['Boolean'];
  hasKinder: Scalars['Boolean'];
  hasKonto: Scalars['Boolean'];
  hasKursBezeichnungen: Scalars['Boolean'];
  hasKursstandorte: Scalars['Boolean'];
  hasTeilnahme: Scalars['Boolean'];
  hasTeilnehmer: Scalars['Boolean'];
  kinderPkColumn?: Maybe<Scalars['String']>;
};

export type KoOrganization = {
  companySettings: CompanySetting;
  companySettingsId: Scalars['ID'];
  createdByUserId: Scalars['String'];
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  deactivatedByUserId?: Maybe<Scalars['String']>;
  deletionState: Scalars['String'];
  emailSignature?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  scheduledDeletionAt?: Maybe<Scalars['DateTime']>;
  settings: Setting;
  settingsId: Scalars['ID'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['ID']>;
  subscriptionType: SubscriptionType;
  updatedByUserId: Scalars['String'];
};

export type KoOrganizationInputType = {
  admins?: Maybe<Array<TenantAdminInput>>;
  customerEmail?: Maybe<Scalars['String']>;
  emailSignature?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
};

export type KoOrganizationWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<KoOrganization>;
  total: Scalars['Float'];
};

export enum Language {
  De = 'DE'
}

export type LatestMollieAttemptBadge = {
  linkExpiresAt?: Maybe<Scalars['DateTime']>;
  mollieMethod?: Maybe<Scalars['String']>;
};

export type LessonBookingIntentInput = {
  bookingId: Scalars['ID'];
  chargeUnitChanges?: Maybe<Scalars['Boolean']>;
  courseLessonIds?: Maybe<Array<Scalars['ID']>>;
  individualPrice?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  rateMonthOffset?: Maybe<Scalars['Int']>;
  staffNote?: Maybe<Scalars['String']>;
};

export enum LessonBookingPlanApplies {
  Money = 'Money',
  None = 'None',
  Units = 'Units'
}

export type LessonBookingPlanFingerprintInput = {
  bookingId: Scalars['ID'];
  fingerprint: Scalars['String'];
};

export type LessonBookingPlannerAdjustment = {
  amount: Scalars['Float'];
  reason: Scalars['String'];
};

export type LessonBookingPlannerComponent = {
  amount: Scalars['Float'];
  lessonDate: Scalars['DateTime'];
  reason: Scalars['String'];
};

export type LessonBookingPlannerPreview = {
  ambiguousOffset: Scalars['Boolean'];
  bookedUnitsAfter: Scalars['Int'];
  bookedUnitsBefore: Scalars['Int'];
  canceled: Scalars['Boolean'];
  components: Array<LessonBookingPlannerComponent>;
  credit: Scalars['Float'];
  legacyGap: Scalars['Float'];
  nonCoursePostsSum: Scalars['Float'];
  priceAfter: Scalars['Float'];
  priceBefore: Scalars['Float'];
  pricingMode: LessonPricingMode;
  rateMonthOffset: Scalars['Int'];
  rates: Array<LessonBookingPlannerRate>;
  regenerated: Scalars['Boolean'];
  unitPrice?: Maybe<Scalars['Float']>;
  units: Array<LessonBookingPlannerUnit>;
  warnings: Array<Scalars['String']>;
};

export type LessonBookingPlannerRate = {
  adjustments: Array<LessonBookingPlannerAdjustment>;
  amountAfter: Scalars['Float'];
  amountBefore: Scalars['Float'];
  boundReason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  paymentDue: Scalars['DateTime'];
  status: LessonBookingPlannerRateStatus;
};

export enum LessonBookingPlannerRateStatus {
  Bound = 'Bound',
  New = 'New',
  Open = 'Open'
}

export type LessonBookingPlannerUnit = {
  lessonDate: Scalars['DateTime'];
  lessonId: Scalars['String'];
  movedTo?: Maybe<Scalars['DateTime']>;
  status: LessonBookingPlannerUnitStatus;
};

export enum LessonBookingPlannerUnitStatus {
  Added = 'Added',
  Kept = 'Kept',
  Removed = 'Removed'
}

export type LessonBookingPlanSummary = {
  applies: LessonBookingPlanApplies;
  blocker?: Maybe<Scalars['String']>;
  bookingId: Scalars['ID'];
  bookingLabel: Scalars['String'];
  correctionInvoice: Scalars['Boolean'];
  correctionInvoiceMail: Scalars['Boolean'];
  credit: Scalars['Float'];
  fingerprint: Scalars['String'];
  priceAfter: Scalars['Float'];
  priceBefore: Scalars['Float'];
  ratesChanged: Scalars['Int'];
  regenerated: Scalars['Boolean'];
  staffNoteChanged: Scalars['Boolean'];
  unitsAdded: Scalars['Int'];
  unitsRemoved: Scalars['Int'];
  warnings: Array<Scalars['String']>;
};

export type LessonBookingScheduledPaymentPreviewInput = {
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
  creditedBalance?: Maybe<Scalars['Float']>;
  customScheduledPayments?: Maybe<Array<ScheduledPaymentSimpleInput>>;
  discount?: Maybe<Scalars['Float']>;
  omitMemberDiscount?: Maybe<Scalars['Boolean']>;
  paymentType: PaymentType;
};

export enum LessonInstructorScope {
  ThisAndFollowing = 'ThisAndFollowing',
  ThisLesson = 'ThisLesson'
}

export enum LessonPricingMode {
  Formula = 'Formula',
  Individual = 'Individual'
}

export type LetterPdfCourseDetails = {
  attendeeName?: Maybe<Scalars['String']>;
  courseEndDate?: Maybe<Scalars['String']>;
  courseLessonsCount?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  courseNumber?: Maybe<Scalars['String']>;
  coursePrice?: Maybe<Scalars['String']>;
  courseStartDate?: Maybe<Scalars['String']>;
  courseTime?: Maybe<Scalars['String']>;
  locationCity?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  locationStreet?: Maybe<Scalars['String']>;
};

export type LocalState = {
  bookAttendees: BookAttendees;
  createCourse: CreateCourse;
};

export type Location = {
  abbreviation: Scalars['String'];
  city: Scalars['String'];
  courses?: Maybe<Array<Course>>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<Scalars['JSONObject']>>;
  emailVariableInfo?: Maybe<Scalars['String']>;
  generalLocationContact: GeneralLocationContact;
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  instructors: Array<Instructor>;
  isPublished: Scalars['Boolean'];
  lessons?: Maybe<Array<CourseLesson>>;
  locationContacts: Array<LocationContact>;
  name: Scalars['String'];
  street: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  venues: Array<Venue>;
  website?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type LocationCity = {
  city: Scalars['String'];
};

export type LocationContact = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
  locations: Array<Location>;
  mobileNumber?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  salutation: SalutationType;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type LocationContactIdInput = {
  id: Scalars['ID'];
};

export type LocationGroupedByCityLocation = {
  city: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  venues: Array<LocationGroupedByCityVenue>;
};

export type LocationGroupedByCityVenue = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LocationsGroupedByCity = {
  city: Scalars['String'];
  locations: Array<LocationGroupedByCityLocation>;
};

export type LocationsWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<Location>;
  total: Scalars['Float'];
};

export type LoggingInput = {
  additionalInfo?: Maybe<Scalars['String']>;
  level?: Maybe<LogLevelType>;
  msg: Scalars['String'];
};

export type LoginAttempt = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  loginCode: Scalars['String'];
  status: LoginStatus;
  tenantId: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  usedAt?: Maybe<Scalars['DateTime']>;
};

/** Status eines Login-Versuchs */
export enum LoginStatus {
  AlreadyUsed = 'AlreadyUsed',
  Created = 'Created',
  Expired = 'Expired',
  Invalid = 'Invalid',
  Used = 'Used'
}

export enum LogLevelType {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Silly = 'SILLY',
  Verbose = 'VERBOSE',
  Warn = 'WARN'
}

export type LogoInput = {
  uid: Scalars['String'];
};

export enum LookupType {
  CallingNameDelivery = 'CallingNameDelivery',
  Format = 'Format',
  HomeLocationRegister = 'HomeLocationRegister',
  MobileNumberPortability = 'MobileNumberPortability'
}

export enum MailDataType {
  AttendanceList = 'AttendanceList',
  Attendee = 'Attendee',
  Booker = 'Booker',
  Booking = 'Booking',
  Course = 'Course',
  Invoice = 'Invoice',
  InvoicePdf = 'InvoicePdf',
  ScheduledPayment = 'ScheduledPayment',
  Staff = 'Staff'
}

export enum MailjetEmailTemplates {
  Blank = 'Blank',
  BookingCancellation = 'BookingCancellation',
  BookingConfirmation = 'BookingConfirmation',
  FreeText = 'FreeText',
  InvoiceSettlement = 'InvoiceSettlement',
  StandardTemplateWithoutCourseDetails = 'StandardTemplateWithoutCourseDetails',
  WaitingListConfirmation = 'WaitingListConfirmation'
}

export type MailjetSender = {
  CreatedAt: Scalars['String'];
  DNSID: Scalars['Float'];
  Email: Scalars['String'];
  EmailType: Scalars['String'];
  Filename?: Maybe<Scalars['String']>;
  ID: Scalars['Float'];
  IsDefaultSender: Scalars['Boolean'];
  Name?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
};

export type MailjetSenderQueryParams = {
  countOnly?: Maybe<Scalars['Boolean']>;
  DnsID?: Maybe<Scalars['Float']>;
  Domain?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  IsDomainSender?: Maybe<Scalars['Boolean']>;
  Limit?: Maybe<Scalars['Float']>;
  LocalPart?: Maybe<Scalars['String']>;
  Offset?: Maybe<Scalars['Float']>;
  ShowDeleted?: Maybe<Scalars['Boolean']>;
  Sort?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
};

export type MailjetSenderResponse = {
  Count: Scalars['Float'];
  Data: Array<MailjetSender>;
  Total: Scalars['Float'];
};

export enum MailjetStatus {
  Blocked = 'blocked',
  BookingDeleted = 'bookingDeleted',
  Bounce = 'bounce',
  Clicked = 'clicked',
  Deferred = 'deferred',
  Hardbounced = 'hardbounced',
  Opened = 'opened',
  Queued = 'queued',
  Sent = 'sent',
  Softbounced = 'softbounced',
  Spam = 'spam',
  Unknown = 'unknown',
  Unsub = 'unsub'
}

export type MailjetVariables = {
  attendee?: Maybe<KeyValue>;
  booker?: Maybe<KeyValue>;
  bookerId?: Maybe<Scalars['String']>;
  booking?: Maybe<KeyValue>;
  bookingId?: Maybe<Scalars['String']>;
  course?: Maybe<KeyValue>;
  customId: Scalars['String'];
  footerText: Scalars['String'];
  headerText: Scalars['String'];
  instructorId?: Maybe<Scalars['String']>;
  location?: Maybe<KeyValue>;
  mollieBankTransferBIC?: Maybe<Scalars['String']>;
  mollieBankTransferIBAN?: Maybe<Scalars['String']>;
  mollieBankTransferRecipient?: Maybe<Scalars['String']>;
  mollieBankTransferReference?: Maybe<Scalars['String']>;
  molliePaymentUrl?: Maybe<Scalars['String']>;
  replyTo: Scalars['String'];
  signature: Scalars['String'];
  subject: Scalars['String'];
};

export type MailReplacementData = {
  email: Scalars['String'];
  receiverName: Scalars['String'];
  secondaryEmail?: Maybe<Scalars['String']>;
  textBlocks?: Maybe<Array<BasicEmailVariables>>;
};

export enum MailSentStatus {
  Error = 'Error',
  Pending = 'Pending',
  Success = 'Success'
}

export type MaintenanceEnableInput = {
  message?: Maybe<Scalars['String']>;
  untilIso?: Maybe<Scalars['String']>;
};

export type MaintenanceStatus = {
  enabled: Scalars['Boolean'];
  message: Scalars['String'];
  untilIso?: Maybe<Scalars['String']>;
  updatedAtIso?: Maybe<Scalars['String']>;
};

export type MarkPaidFromSepaInput = {
  scheduledPaymentIds: Array<Scalars['ID']>;
  sepaExportId: Scalars['ID'];
};

export enum MatchConfidence {
  High = 'HIGH',
  Medium = 'MEDIUM'
}

export type MessageHistory = {
  Count: Scalars['Float'];
  Data: Array<MessageHistoryData>;
  Total: Scalars['Float'];
};

export type MessageHistoryData = {
  Comment: Scalars['String'];
  EventAt: Scalars['Float'];
  EventType: Scalars['String'];
  State: Scalars['String'];
  Useragent: Scalars['String'];
  UseragentID: Scalars['String'];
};

export type MessageStatus = {
  Count: Scalars['Float'];
  Data: Array<MessageStatusData>;
  Total: Scalars['Float'];
};

export type MessageStatusData = {
  ArrivedAt: Scalars['String'];
  AttachmentCount: Scalars['Float'];
  AttemptCount: Scalars['Float'];
  ContactAlt: Scalars['String'];
  ContactID: Scalars['Float'];
  Delay: Scalars['Float'];
  DestinationID: Scalars['Float'];
  FilterTime: Scalars['Float'];
  ID: Scalars['String'];
  IsClickTracked: Scalars['Boolean'];
  IsHTMLPartIncluded: Scalars['Boolean'];
  IsOpenTracked: Scalars['Boolean'];
  IsTextPartIncluded: Scalars['Boolean'];
  IsUnsubTracked: Scalars['Boolean'];
  MessageSize: Scalars['Float'];
  SenderID: Scalars['Float'];
  SpamassassinScore: Scalars['Float'];
  SpamassRules: Scalars['String'];
  StatePermanent: Scalars['Boolean'];
  Status: MailjetStatus;
  Subject: Scalars['String'];
  UUID: Scalars['String'];
};

export type MissingBankData = {
  bankCode: Scalars['String'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  firstSeen: Scalars['DateTime'];
  hitCount: Scalars['Float'];
  iban: Scalars['String'];
  id: Scalars['ID'];
  lastSeen: Scalars['DateTime'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type MissingIndexCandidateOutput = {
  avgRowsPerScan: Scalars['Float'];
  idxScan: Scalars['Float'];
  schemaname: Scalars['String'];
  seqScan: Scalars['Float'];
  seqTupRead: Scalars['Float'];
  tablename: Scalars['String'];
};

export type MjmlTemplate = {
  Count: Scalars['Float'];
  Data: Scalars['String'];
  Total: Scalars['Float'];
};

export type ModifyScheduledPaymentInput = {
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  openAmount?: Maybe<Scalars['Float']>;
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentDue?: Maybe<Scalars['DateTime']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  sepaClearance?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ScheduledPaymentType>;
};

export type MollieAmount = {
  currency: Scalars['String'];
  value: Scalars['String'];
};

export type MollieBankDetails = {
  bic?: Maybe<Scalars['String']>;
  iban: Scalars['String'];
  recipient: Scalars['String'];
  reference: Scalars['String'];
};

export type MollieClientLinkAddressInput = {
  city?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  streetAndNumber?: Maybe<Scalars['String']>;
};

export type MollieClientLinkOwnerInput = {
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
};

export type MollieConnection = {
  canReceivePayments: Scalars['Boolean'];
  canReceiveSettlements: Scalars['Boolean'];
  connectedAt: Scalars['DateTime'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<Scalars['DateTime']>;
  hasNextGenPaymentWebhook: Scalars['Boolean'];
  hasNextGenWebhook: Scalars['Boolean'];
  id: Scalars['ID'];
  isDisconnected: Scalars['Boolean'];
  mollieOrganizationId: Scalars['String'];
  mollieProfileId?: Maybe<Scalars['String']>;
  tokenExpiresAt: Scalars['DateTime'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type MollieConnectionStatus = {
  canReceivePayments: Scalars['Boolean'];
  canReceiveSettlements: Scalars['Boolean'];
  capabilitiesHint?: Maybe<Scalars['String']>;
  connectedAt?: Maybe<Scalars['DateTime']>;
  dashboardUrl?: Maybe<Scalars['String']>;
  isConnected: Scalars['Boolean'];
  isTestMode: Scalars['Boolean'];
  mollieOrganizationId?: Maybe<Scalars['String']>;
  mollieProfileId?: Maybe<Scalars['String']>;
  needsReconnect: Scalars['Boolean'];
  /** @deprecated Use needsReconnect (#1399); only kept for already loaded admin bundles. */
  needsReconnectForPaymentLinks: Scalars['Boolean'];
  onboardingStatus?: Maybe<Scalars['String']>;
};

export type MollieCreateClientLinkInput = {
  address: MollieClientLinkAddressInput;
  incorporationDate?: Maybe<Scalars['String']>;
  legalEntity?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner: MollieClientLinkOwnerInput;
  registrationNumber?: Maybe<Scalars['String']>;
  registrationOffice?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type MollieCreateClientLinkResult = {
  clientLinkId: Scalars['String'];
  clientLinkUrl: Scalars['String'];
};

export type MollieDowngradeImpact = {
  activePaymentLinks: Scalars['Int'];
  affectedBookers: Scalars['Int'];
  openMolliePayments: Scalars['Int'];
};

export enum MollieInvoiceSendMode {
  AfterPaid = 'AfterPaid',
  Immediately = 'Immediately'
}

export type MollieKpis = {
  avgCheckoutToPaidHours: Scalars['Float'];
  chargebacks30dCount: Scalars['Int'];
  chargebacks30dFee: Scalars['Float'];
  openLinksCount: Scalars['Int'];
  openLinksSum: Scalars['Float'];
  successRate30d: Scalars['Float'];
};

export type MollieManualReconciliationResult = {
  checked: Scalars['Int'];
  errors: Scalars['Int'];
  updated: Scalars['Int'];
};

export type MollieMethodInfo = {
  description: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isAvailableInProfile: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  profileStatus?: Maybe<Scalars['String']>;
};

export type MolliePaymentAction = {
  bankDetails?: Maybe<MollieBankDetails>;
  checkoutUrl?: Maybe<Scalars['String']>;
  molliePaymentId: Scalars['String'];
  molliePaymentStatus: Scalars['String'];
  type: Scalars['String'];
};

export type MolliePaymentAttempt = {
  amount?: Maybe<Scalars['Float']>;
  bundleScheduledPaymentIds?: Maybe<Array<Scalars['String']>>;
  chargebackedAt?: Maybe<Scalars['DateTime']>;
  chargebackFee?: Maybe<Scalars['Float']>;
  chargebackId?: Maybe<Scalars['String']>;
  chargebackReason?: Maybe<Scalars['String']>;
  chargebackResolvedAt?: Maybe<Scalars['DateTime']>;
  chargebackResolvedByUserId?: Maybe<Scalars['String']>;
  chargebacks: Array<Chargeback>;
  checkoutUrl?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCurrentAttempt: Scalars['Boolean'];
  isTestPayment: Scalars['Boolean'];
  lastWebhookAt?: Maybe<Scalars['DateTime']>;
  linkExpiresAt?: Maybe<Scalars['DateTime']>;
  mollieMethod: Scalars['String'];
  molliePaymentId: Scalars['String'];
  molliePaymentLinkId?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentUrl?: Maybe<Scalars['String']>;
  refunds: Array<MollieRefund>;
  requiresManualRetry: Scalars['Boolean'];
  scheduledPayment: ScheduledPayment;
  scheduledPaymentId: Scalars['String'];
  status: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type MolliePaymentFilterInput = {
  amountMax?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  bookerEmail?: Maybe<Scalars['String']>;
  bookerName?: Maybe<Scalars['String']>;
  bookingNumber?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  searchQuery?: Maybe<Scalars['String']>;
  sortColumn?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<SortOrder>;
  status?: Maybe<Scalars['String']>;
  tab: MolliePaymentTab;
};

export type MolliePaymentResult = {
  bookerEmail?: Maybe<Scalars['String']>;
  checkoutUrl: Scalars['String'];
  dispatchKind?: Maybe<Scalars['String']>;
  linkExpiresAt?: Maybe<Scalars['DateTime']>;
  molliePaymentId: Scalars['String'];
  status: Scalars['String'];
};

export type MolliePaymentsPage = {
  hasMore: Scalars['Boolean'];
  items: Array<ScheduledPayment>;
  total: Scalars['Int'];
};

export type MolliePaymentStatus = {
  amount: Scalars['Float'];
  amountDetails?: Maybe<MollieAmount>;
  availableMollieMethods?: Maybe<Array<Scalars['String']>>;
  bankTransferDetails?: Maybe<MollieBankDetails>;
  bookingId?: Maybe<Scalars['String']>;
  checkoutUrl?: Maybe<Scalars['String']>;
  courseStartDate?: Maybe<Scalars['DateTime']>;
  courseTitle?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  failureReason?: Maybe<Scalars['String']>;
  molliePaymentId: Scalars['String'];
  paidAt?: Maybe<Scalars['DateTime']>;
  payOnlineUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusUrl?: Maybe<Scalars['String']>;
};

export type MolliePaymentStatusPublic = {
  amount: Scalars['Float'];
  amountDetails?: Maybe<MollieAmount>;
  bankTransferDetails?: Maybe<MollieBankDetails>;
  checkoutUrl?: Maybe<Scalars['String']>;
  courseStartDate?: Maybe<Scalars['DateTime']>;
  courseTitle?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  failureReason?: Maybe<Scalars['String']>;
  molliePaymentId: Scalars['String'];
  paidAt?: Maybe<Scalars['DateTime']>;
  payOnlineUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusUrl?: Maybe<Scalars['String']>;
};

export enum MolliePaymentTab {
  All = 'All',
  Chargebacks = 'Chargebacks',
  Failed = 'Failed',
  OpenLinks = 'OpenLinks',
  Paid = 'Paid',
  Refunds = 'Refunds'
}

export type MolliePaymentTabCounts = {
  all: Scalars['Int'];
  chargebacks: Scalars['Int'];
  failed: Scalars['Int'];
  openLinks: Scalars['Int'];
  paid: Scalars['Int'];
  refunds: Scalars['Int'];
};

export type MollieRefund = {
  adminUserId?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  attendeeNameSnapshot?: Maybe<Scalars['String']>;
  bookerNameSnapshot?: Maybe<Scalars['String']>;
  bookingIdSnapshot?: Maybe<Scalars['String']>;
  bookingNumberSnapshot?: Maybe<Scalars['String']>;
  canceledAtProvider: Scalars['Boolean'];
  courseNumberSnapshot?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mollieCreatedAt?: Maybe<Scalars['DateTime']>;
  mollieRefundId?: Maybe<Scalars['String']>;
  origin: MollieRefundOrigin;
  paymentAmountSnapshot?: Maybe<Scalars['Float']>;
  reason?: Maybe<Scalars['String']>;
  scheduledPayment?: Maybe<ScheduledPayment>;
  scheduledPaymentId?: Maybe<Scalars['String']>;
  status: MollieRefundStatus;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export enum MollieRefundMode {
  Auto = 'Auto',
  Manual = 'Manual'
}

export enum MollieRefundOrigin {
  External = 'External',
  Internal = 'Internal'
}

export enum MollieRefundStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processed = 'Processed'
}

export type MollieRefundsWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<MollieRefund>;
  total: Scalars['Int'];
};

export type MollieRetryQueueEntry = {
  amount: Scalars['Float'];
  attemptId: Scalars['ID'];
  bookerEmail: Scalars['String'];
  bookerName: Scalars['String'];
  bookingId: Scalars['ID'];
  chargebackedAt?: Maybe<Scalars['DateTime']>;
  chargebackReason?: Maybe<Scalars['String']>;
  chargebackRetryCount: Scalars['Float'];
  currency: Scalars['String'];
  isNonRetriable: Scalars['Boolean'];
  scheduledPaymentId: Scalars['ID'];
  sepaDisabled: Scalars['Boolean'];
};

export enum MonthFilter {
  April = 'April',
  August = 'August',
  December = 'December',
  February = 'February',
  January = 'January',
  July = 'July',
  June = 'June',
  March = 'March',
  May = 'May',
  November = 'November',
  October = 'October',
  September = 'September'
}

export enum MonthlySchedule {
  Consistent = 'Consistent',
  Custom = 'Custom',
  Dynamic = 'Dynamic'
}

export type Mutation = {
  addBookableCourses: Scalars['Boolean'];
  addBookerAsAttendee: Booker;
  addCourseIdAndStartDateTime: SetupScriptResult;
  addDefaultTemplate: Template;
  addFaUserByBookerId: FaUser;
  addFolderDo: Scalars['JSONObject'];
  addMultiplePlaceReservations: Array<Booking>;
  addNamedScheduledPayment: ScheduledPayment;
  addPage: PageStructure;
  addPaymentMethod: PaymentMethod;
  addRoleToOrganization: Scalars['Boolean'];
  applyLessonBookingPlan: Array<LessonBookingPlanSummary>;
  assignAmbiguousSwissQRPayment: SwissQrFileRecord;
  assignAreaManagerLocations: Scalars['Boolean'];
  assignAssistantFromControlBoard: Scalars['Boolean'];
  assignCourseTypeToInvoiceTemplateSet: CourseType;
  assignInstructorToLessonFromControlBoard: Scalars['Boolean'];
  assignMyselfToCourseLessonAssistantApp: Scalars['Boolean'];
  autoMergeDuplicates: AutoMergeStartResult;
  autoMergeDuplicatesDryRun: AutoMergeDryRunResult;
  bookAttendeeSetSelectedAttendee?: Maybe<Scalars['ID']>;
  bookAttendeeSetSelectedCourse?: Maybe<Scalars['ID']>;
  broadcastTenantNotification: BroadcastTenantNotificationResult;
  bulkCreateAttendeeBadges: Array<AttendeeBadge>;
  bulkToggleAttendeeBadgeRequirement: Array<AttendeeBadgeRequirement>;
  cancelBookingAndGenerateReversalInvoice: Scalars['Boolean'];
  cancelMolliePaymentFromAdmin?: Maybe<MolliePaymentResult>;
  captureMolliePaymentFromAdmin?: Maybe<MolliePaymentResult>;
  changeAttendeeMemberStatus: Attendee;
  changeDefaultPaymentMethod: Attendee;
  changeForgottenPassword: Scalars['Boolean'];
  changeMultipleAttendeesDefaultPaymentMethods: Array<Attendee>;
  clearManuallyAdjusted: ScheduledPayment;
  completeBookerLinkRegistration: UserType;
  completePasswordlessFlow: UserType;
  completePasswordlessFlowEndUserApp: UserType;
  confirmAGB: Scalars['Boolean'];
  confirmBankTransaction: BankTransaction;
  confirmPrivacyStatement: Scalars['Boolean'];
  convertBookingToWaitlist: Booking;
  convertPhoneNumbersToInternationalFormat: Array<Sms77FormatApiResponse>;
  convertWaitlistToBooking: Booking;
  copyAttendeeToCourse: Booking;
  createAdminManagementUser: Scalars['Boolean'];
  createAndRegisterAdmin: UserType;
  createAndRegisterThirdPartyUser: UserType;
  createAndRegisterThirdPartyUserAndBooker: UserType;
  createAnnouncement: Announcement;
  createAttendanceListBulkByInstructor: BulkJobResult;
  createAttendanceListBulkByLocation: BulkJobResult;
  createAttendeeBadge: AttendeeBadge;
  createAttendeeBadgeByBadgeName: AttendeeBadge;
  createBadge: Badge;
  createBadgeGroup: BadgeGroup;
  createBillingAddressTemplate: BillingAddressTemplate;
  createBooker: Booker;
  createBooking: Booking;
  createBookingRestriction: BookingRestriction;
  createBookingWithCourseLessonBookings: Booking;
  createCertificateTemplate: CertificateTemplate;
  createCorrectionInvoice: Invoice;
  createCourse: Course;
  createCourseCategory: CourseCategory;
  createCourseLesson: CourseLesson;
  createCourseLessonBooking: CourseLessonBooking;
  createCourseLessonBookingsByCourseId: Scalars['JSONObject'];
  createCourseLessons: Array<CourseLesson>;
  createCourseType: CourseType;
  createCustomBankData: CustomBankData;
  createDatabaseBackup: DatabaseBackup;
  createDataExport: DataExport;
  createDiscountCode: DiscountCode;
  createDummyCamtFileForMultiplePayments: Scalars['String'];
  createDunning: Dunning;
  createFaUserWithOrAddEndUserRights: FaUser;
  createFeeLetter: FeeLetter;
  createInstallmentRate: InstallmentRate;
  createInstructorInvoice: Scalars['String'];
  createInterestList: InterestList;
  createInterestRegistration: InterestRegistration;
  createInvoice: Invoice;
  createInvoiceExport: InvoiceExport;
  createInvoicesByBookingIds: Array<Invoice>;
  createInvoicesByCourseId: Array<Invoice>;
  createInvoiceTemplateSet: InvoiceTemplateSet;
  createLessonBooking: BookingWithCourseLessons;
  createLocation: Location;
  createLocationContact: LocationContact;
  createMailjetSender: CreateMailjetSenderOutput;
  createMolliePayment?: Maybe<MolliePaymentResult>;
  createNewMolliePaymentAttemptFromAdmin?: Maybe<MolliePaymentResult>;
  createNewsletterCustomList: NewsletterLocationList;
  createOrganization: CreateOrganizationResult;
  createParticipationPrerequisite: ParticipationPrerequisites;
  createSepaXmlById: Scalars['String'];
  createSepaXmlByTimeRange: Scalars['JSONObject'];
  createSettingEndUserApp: Scalars['JSONObject'];
  createSettingEndUserAppWithDefaultValues: SettingEndUserApp;
  createTemplate: Template;
  createWithdrawalEndUserApp: WithdrawalEndUserAppResult;
  createYearEndExport: YearEndExport;
  deactivateCoursesAllowLessonBooking: Array<Course>;
  deactivateDiscountCode: DiscountCode;
  deactivateTenant: KoOrganization;
  deleteAllAttendanceListArchives: Scalars['Boolean'];
  deleteAllMissingBankData: Scalars['Boolean'];
  deleteAllPlaceReservationsByCourseId: Scalars['Float'];
  deleteAnnouncement: Scalars['Boolean'];
  deleteAttendanceListArchive: Scalars['Boolean'];
  deleteAttendee: Scalars['Boolean'];
  deleteAttendeeBadge: Scalars['Boolean'];
  deleteBadge: Scalars['Boolean'];
  deleteBadgeGraphic: Badge;
  deleteBadgeGroup: Scalars['Boolean'];
  deleteBillingAddressTemplate: Scalars['Boolean'];
  deleteBooker: Scalars['Boolean'];
  deleteBookingRestriction: Scalars['Boolean'];
  deleteCategoryById: CourseCategory;
  deleteCertificateTemplate: Scalars['Boolean'];
  deleteCompanyLogo: CompanySetting;
  deleteCourseLessonBooking: Scalars['Boolean'];
  deleteCustomBankData: Scalars['Boolean'];
  deleteDatabaseBackup: Scalars['Boolean'];
  deleteDataExport: Scalars['Boolean'];
  deleteDiscountCode: Scalars['Boolean'];
  deleteFileDo: Scalars['JSONObject'];
  deleteFolderDo: Scalars['JSONObject'];
  deleteFusionAuthUserByIds: Scalars['Boolean'];
  deleteFusionAuthUsersByEmails: Scalars['JSONObject'];
  deleteInstallmentRate: Scalars['Boolean'];
  deleteInstallmentRatesByCourseId: Scalars['Float'];
  deleteInstructorInvoice: Scalars['Boolean'];
  deleteInvoiceExport: Scalars['Boolean'];
  deleteInvoiceTemplateSet: Scalars['Boolean'];
  deleteMissingBankData: Scalars['Boolean'];
  deleteNewsletterCustomList: Scalars['Boolean'];
  deletePage: PageStructure;
  deleteScheduledPayment: ScheduledPayment;
  deleteSelectionOfWaitlist: Scalars['Float'];
  deleteTemplate: Scalars['Boolean'];
  deleteYearEndExport: Scalars['Boolean'];
  disableMaintenance: MaintenanceStatus;
  disablePasswordlessLoginEndUserApp: Scalars['JSONObject'];
  dismissDuplicatePair: Scalars['Boolean'];
  downloadFileDo: Scalars['JSONObject'];
  editLessonBooking: BookingWithCourseLessons;
  enableMaintenance: MaintenanceStatus;
  enablePasswordlessLoginEndUserApp: Scalars['JSONObject'];
  eraseBookerData: ErasureReportType;
  erasurePreview: ErasureReportType;
  executeBulkTransfer: ExecuteBulkTransferResult;
  executeSettledBookingCorrection: SettledBookingCorrectionResult;
  executeTransfer: ExecuteTransferResult;
  fetchByYear: Array<Holiday>;
  fetchByYearAndStateCode: Array<Holiday>;
  fetchPublicHolidaysByYear: Array<Holiday>;
  fixMissingInvoiceIds: Scalars['Float'];
  forceRollbackAllowMolliePayment: Course;
  forgetPassword: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  generatePasswordResetLink: PasswordResetLinkType;
  generatePaymentSchedulePreview: Array<Scalars['JSONObject']>;
  generateScheduledPaymentsByCourse: ScheduledPaymentPreview;
  generateScheduledPaymentsForSettledBooking: Array<ScheduledPayment>;
  generateUpdatedSchedulesNewBookingPrice: Array<ScheduledPayment>;
  getMyCalendarFeedUrl: Scalars['String'];
  hardDeleteTenant: TenantDeletionResult;
  importBookers: Scalars['JSONObject'];
  importNewsletterUnsubscribesFromMailjet: NewsletterUnsubscribeImportResult;
  initiateMolliePaymentForBookingFromEndUserApp?: Maybe<MolliePaymentResult>;
  issueCertificate: IssuedCertificate;
  issueCertificatesByAttendees: Array<IssuedCertificate>;
  issueCertificatesByCourse: Array<IssuedCertificate>;
  ko9DetectSchema: Ko9SchemaInfoType;
  ko9DryRun: Scalars['JSONObject'];
  ko9ExecuteImport: Scalars['JSONObject'];
  ko9FetchPreview: Ko9PreviewResultType;
  ko9RollbackImport: Ko9RollbackResultType;
  ko9SaveCredentials: Ko9SaveResult;
  ko9TestConnection: Ko9ConnectionTestResult;
  linkAttendeeToBooker: Attendee;
  logging: Scalars['Boolean'];
  loginWithPassword: UserType;
  logoutUser: Scalars['Boolean'];
  markScheduledPaymentsAsPaidFromSepaExport: Scalars['Float'];
  mergeAttendees: AttendeeMergeResult;
  mergeBookers: Booker;
  modifyScheduledPayment: ScheduledPayment;
  mollieCreateClientLink: MollieCreateClientLinkResult;
  mollieDisconnect: Scalars['Boolean'];
  mollieGetConnectUrl: Scalars['String'];
  moveBadge: Scalars['Boolean'];
  passwordlessLogin: Scalars['Boolean'];
  passwordlessLoginEndUserApp: Scalars['Boolean'];
  previewInstructorInvoice: Scalars['String'];
  reactivateBookerNewsletter: NewsletterBookerStatus;
  reactivateDiscountCode: DiscountCode;
  reactivateTenant: KoOrganization;
  recordExternalPaymentForScheduledPayment: ScheduledPayment;
  recordLikelyBankTransactions: BankTransactionRecordAllResult;
  refactoredCourseDetails: Scalars['Boolean'];
  refreshAccessToken: Scalars['String'];
  refreshMolliePaymentStatusFromAdmin?: Maybe<MolliePaymentAttempt>;
  refundMolliePaymentFromAdmin: MollieRefund;
  rejectBankTransaction: BankTransaction;
  rematchAllBankImportFiles: BankImportRematchAllResult;
  rematchBankImportFile: BankImportFile;
  removeAdminManagementUser: Scalars['Boolean'];
  removeAllBookersOfTenant: Scalars['JSONObject'];
  removeAllBookings: Scalars['Boolean'];
  removeAssistantFromControlBoard: Scalars['Boolean'];
  removeBookableCourse: Scalars['Boolean'];
  removeBooking: Scalars['Boolean'];
  removeBookings: Scalars['Boolean'];
  removeCourse: Scalars['Boolean'];
  removeCourseLesson: Scalars['Boolean'];
  removeCourseType: Scalars['Boolean'];
  removeInstructor: Scalars['Boolean'];
  removeInterestList: Scalars['Boolean'];
  removeInterestRegistration: Scalars['Boolean'];
  removeLocation: Scalars['Boolean'];
  removeLocationContact: Scalars['Boolean'];
  removeParticipationPrerequisite: Scalars['Boolean'];
  renameFileDo: Scalars['JSONObject'];
  renameFolderDo: Scalars['JSONObject'];
  renewNewsletterWebhookToken: NewsletterSettings;
  reOrderBadgeGroups: Scalars['Boolean'];
  reOrderBadges: Scalars['Boolean'];
  /** Zählt, ob die Conversion-Meldung der End-User-App an die Kundenseite möglich war (Abdeckung je Mandant). */
  reportEmbedConversion: Scalars['Boolean'];
  /** Meldet einen Client-Zustand der End-User-App an die Kundenakte (fire-and-forget). */
  reportEndUserEvent: Scalars['Boolean'];
  requestAdminOrgDiscovery: Scalars['Boolean'];
  requestBookerLinkRegistration: Scalars['Boolean'];
  requestStaffMobileOrgDiscovery: Scalars['Boolean'];
  requestStaffMobilePasswordReset: Scalars['Boolean'];
  resendBookingConfirmation: Scalars['JSONObject'];
  resendCertificateEmail: Scalars['Boolean'];
  resendDunning: Dunning;
  resendEmailVerification: Scalars['Boolean'];
  resetAllUnsetteledScheduledPaymentsOfCourse: ResetScheduledPaymentsOfCourseResult;
  resetMyCalendarFeedToken: Scalars['String'];
  resetNewsletterLocationListLink: NewsletterLocationList;
  resetPaymentPlanOfInvoicedLessonBooking: ResetPaymentPlanOfInvoicedLessonBookingResult;
  resetPerformanceStats: Scalars['Boolean'];
  resetScheduledPaymentsOfBooking: ResetScheduledPaymentsOfBookingResult;
  resolveAmbiguousSwissQRPayment: SwissQrFileRecord;
  resolveChargeback: MolliePaymentAttempt;
  resolveSurplusMolliePayments: Scalars['Boolean'];
  restoreDatabaseBackup: DatabaseBackup;
  restoreOrphanBooking: Booking;
  restoreScheduledPayment: ScheduledPayment;
  retryMolliePayment?: Maybe<MolliePaymentResult>;
  retryMolliePaymentManually: Scalars['Boolean'];
  retryTenantMetricsAiSummary: TenantMetricsAiSummary;
  rollbackPaymentStatus: Scalars['Boolean'];
  runMollieReconciliationNow: MollieManualReconciliationResult;
  saveAdmin: Admin;
  saveInstructor: Instructor;
  sendAttendanceListArchive: Scalars['Boolean'];
  sendAttendanceListArchiveTestEmail: Scalars['Boolean'];
  sendBlankMailToMultipleBookers: Scalars['Boolean'];
  sendBookingConfirmation: Scalars['JSONObject'];
  sendBookingInvoice: Scalars['JSONObject'];
  sendBookingInvoicesByBookingIds: Scalars['JSONObject'];
  sendEmailsToSelectionOfCourse: Scalars['JSONObject'];
  sendEmailTemplate: Scalars['JSONObject'];
  sendEmailToSelectionOfAttendees: Scalars['JSONObject'];
  sendEmailToSelectionOfBookers: Scalars['JSONObject'];
  sendEmailToSelectionOfScheduledPayments: Scalars['JSONObject'];
  sendEmailToSelectionOfStaff: Scalars['JSONObject'];
  sendInvoicesToSelectionOfBookings: Scalars['JSONObject'];
  sendMail: Array<Scalars['JSONObject']>;
  sendMailToSelectionOfBookings: Scalars['JSONObject'];
  sendMolliePaymentLinkForBookingFromAdmin?: Maybe<MolliePaymentResult>;
  sendMolliePaymentLinkFromAdmin?: Maybe<MolliePaymentResult>;
  sendPasswordResetLinkEmail: Scalars['Boolean'];
  sendSms: Sms77JsonResponse;
  sendTestMail: Scalars['JSONObject'];
  sendTestMailBooker: Scalars['JSONObject'];
  setBankTransactionCounterpart: BankTransaction;
  setDunningPause: DunningPause;
  setIncludeCourseDetails: Template;
  setInterestListNoteFieldDefault: Setting;
  setMultipleScheduledPaymentsPaid: Scalars['Boolean'];
  setNewCustomerNumber: Customer;
  setNewPaymentAmount: ScheduledPayment;
  setNewPaymentDoneDate: ScheduledPayment;
  setNewsletterLocationListEnabled: NewsletterLocationList;
  setNewsletterLocationListExcluded: NewsletterLocationList;
  setScheduledPaymentPaid: ScheduledPayment;
  setScheduledPaymentUnpaid: ScheduledPayment;
  setSepaClearance: ScheduledPayment;
  setupNewsletterWebhook: NewsletterSettings;
  simulateMollieLinkWebhookForTesting: Scalars['Boolean'];
  simulateMollieWebhookForTesting: Scalars['Boolean'];
  singleUpload: Scalars['JSONObject'];
  softDeleteBadge: Badge;
  submitSupportReport: Scalars['Boolean'];
  syncAllNewsletterLocationLists: Scalars['Int'];
  syncNewsletterLocationList: NewsletterLocationList;
  testLogin: UserType;
  testNewsletterConnection: NewsletterSettings;
  thirdPartyLogin: UserType;
  toggleAreaManagerRoleFromAdminManagement: Scalars['Boolean'];
  toggleAttendeeBadgeRequirement: AttendeeBadgeRequirement;
  toggleUserRole: Scalars['Boolean'];
  transferAttendeeToBooker: Attendee;
  transferAttendeeToCourse: Booking;
  transferMultipleBookings: Array<Booking>;
  triggerDuplicateDetection: Scalars['Boolean'];
  unassignMyselfFromCourseLessonAssistantApp: Scalars['Boolean'];
  undoDuplicateException: Scalars['Boolean'];
  unsubscribeBookerFromNewsletter: NewsletterBookerStatus;
  updateAdminManagementUserEmail: Scalars['Boolean'];
  updateAdminManagementUserName: Scalars['Boolean'];
  updateAllowedMollieMethods: PlatformConfig;
  updateAnnouncement: Announcement;
  updateAttendanceListNote: Booking;
  updateAttendanceListSettings: UserSetting;
  updateAttendeeBadge: AttendeeBadge;
  updateBadge: Badge;
  updateBadgeGroup: BadgeGroup;
  updateBankTransactionComment: BankTransaction;
  updateBillingAddressTemplate: BillingAddressTemplate;
  updateBillingAmountForCourse: Scalars['Boolean'];
  updateBillingAmountForCourseLesson: CourseLesson;
  updateBooker: Booker;
  updateBookerAccountEndUserApp: Booker;
  updateBookerCredit: Booker;
  updateBookerIdMissmatch: EmailNotification;
  updateBooking: Booking;
  updateBookingPaymentMethod: Booking;
  updateBookingRestriction: BookingRestriction;
  updateCertificateTemplate: CertificateTemplate;
  updateCompanyAgb: CompanySetting;
  updateCompanyPrivacyStatement: CompanySetting;
  updateCompanySettings: CompanySetting;
  updateCourse: Course;
  updateCourseAndBookings: UpdateCourseAndBookingsResult;
  updateCourseAnnotation: Course;
  updateCourseArchived: Course;
  updateCourseBlockBookingOnline: Course;
  updateCourseCategory: CourseCategory;
  updateCourseLessonBooking: CourseLessonBooking;
  updateCourseLessonInstructors: Array<CourseLesson>;
  updateCoursesStartDateTime: Scalars['JSONObject'];
  updateCourseType: CourseType;
  updateCustomBankData: CustomBankData;
  updateCustomCompanyHolidays: Array<Holiday>;
  updateDiscountCode: DiscountCode;
  updateInstallmentRate: InstallmentRate;
  updateInterestList: InterestList;
  updateInterestRegistration: InterestRegistration;
  updateInvoice: Invoice;
  updateInvoiceTemplateSet: InvoiceTemplateSet;
  updateLateEntryPricingConfiguration: SettingEndUserApp;
  updateLocalLocationId?: Maybe<Scalars['ID']>;
  updateLocation: Location;
  updateLocationContact: LocationContact;
  updateLocationPublishedStatus: Location;
  updateManyScheduledPaymentIds: Array<ScheduledPayment>;
  updateMollieEnabledMethods: Array<MollieMethodInfo>;
  updateMultipleBookerIdMissmatches: Array<EmailNotification>;
  updateMultipleCoursesArchived: Array<Course>;
  updateMultipleCoursesShowInWeb: Array<Course>;
  updateMyProfile: MyProfileType;
  updateNewsletterCustomList: NewsletterLocationList;
  updateNewsletterRules: NewsletterSettings;
  updateNewsletterSettings: NewsletterSettings;
  updateNoticeStaff: Booking;
  updateOrganizationSubscriptionType: KoOrganization;
  updatePage: PageStructure;
  updateParticipationPrerequisite: ParticipationPrerequisites;
  updateScheduledPayment: ScheduledPayment;
  updateSepaPaymentMethod: PaymentMethod;
  updateSettingEndUserApp: SettingEndUserApp;
  updateSettings: Setting;
  updateSettledBookingDiscount: Booking;
  updateShowArchivedCourses: UserSetting;
  updateStaffVisibilityRules: StaffVisibilityRules;
  updateSubscriptionFeatures: Subscription;
  updateSwissQRFileNote: SwissQrFile;
  updateTableColumnSettings: UserSetting;
  updateTemplate: Template;
  updateWithdrawalStatus: WithdrawalRequest;
  uploadBadgeGraphic: Badge;
  uploadBankImportFile: BankImportFile;
  uploadBundesbankBlz: BundesbankImportResult;
  uploadCompanyLogo: Scalars['JSONObject'];
  uploadContentImage: UploadedContentImage;
  uploadDummyFile: Scalars['JSONObject'];
  uploadFilesDo: Scalars['JSONObject'];
  uploadProfilePicture: MyProfileType;
  uploadSingleFileDo: Scalars['JSONObject'];
  upsertAttendeeBadgesWithRequirements: Array<AttendeeBadge>;
  userSettingSetOptimizedCourseCalendar: UserSetting;
  userSettingsUpdateOrCreate: UserSetting;
  verifyBookersData: Scalars['JSONObject'];
  voidMolliePaymentLinkForBooking: Booking;
  voidMolliePaymentLinksForBookings: Array<VoidPaymentLinkResult>;
  withdrawDunning: Dunning;
};


export type MutationAddBookableCoursesArgs = {
  bookableCourseIds: Array<Scalars['String']>;
  prerequisiteCourseId: Scalars['String'];
};


export type MutationAddBookerAsAttendeeArgs = {
  bookerId: Scalars['ID'];
};


export type MutationAddDefaultTemplateArgs = {
  newTemplateData: NewTemplateInput;
};


export type MutationAddFaUserByBookerIdArgs = {
  bookerId: Scalars['String'];
  linkExistingAccountConfirmed?: Maybe<Scalars['Boolean']>;
};


export type MutationAddFolderDoArgs = {
  folderName: Scalars['String'];
};


export type MutationAddMultiplePlaceReservationsArgs = {
  count: Scalars['Float'];
  courseId: Scalars['ID'];
};


export type MutationAddNamedScheduledPaymentArgs = {
  addNamedScheduledPaymentInput: AddNamedScheduledPaymentInput;
};


export type MutationAddPageArgs = {
  newPageInput: NewPageInput;
};


export type MutationAddPaymentMethodArgs = {
  bookerId: Scalars['String'];
  paymentMethodType: Scalars['String'];
  sepaDebitIntput?: Maybe<SepaDebitIntput>;
};


export type MutationAddRoleToOrganizationArgs = {
  role: Scalars['String'];
};


export type MutationApplyLessonBookingPlanArgs = {
  fingerprints: Array<LessonBookingPlanFingerprintInput>;
  intents?: Maybe<Array<LessonBookingIntentInput>>;
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
};


export type MutationAssignAmbiguousSwissQrPaymentArgs = {
  distributions: Array<AssignAmbiguousPaymentDistributionInput>;
  recordId: Scalars['ID'];
};


export type MutationAssignAreaManagerLocationsArgs = {
  input: AssignAreaManagerLocationsInput;
};


export type MutationAssignAssistantFromControlBoardArgs = {
  input: AssignAssistantInput;
};


export type MutationAssignCourseTypeToInvoiceTemplateSetArgs = {
  courseTypeId: Scalars['ID'];
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
};


export type MutationAssignInstructorToLessonFromControlBoardArgs = {
  input: AssignInstructorToLessonInput;
};


export type MutationAssignMyselfToCourseLessonAssistantAppArgs = {
  courseLessonId: Scalars['ID'];
};


export type MutationAutoMergeDuplicatesArgs = {
  input: AutoMergeInput;
};


export type MutationAutoMergeDuplicatesDryRunArgs = {
  input: AutoMergeDryRunInput;
};


export type MutationBookAttendeeSetSelectedAttendeeArgs = {
  bookedCourseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};


export type MutationBookAttendeeSetSelectedCourseArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationBroadcastTenantNotificationArgs = {
  input: BroadcastTenantNotificationInput;
};


export type MutationBulkCreateAttendeeBadgesArgs = {
  input: BulkCreateAttendeeBadgeInput;
};


export type MutationBulkToggleAttendeeBadgeRequirementArgs = {
  input: BulkToggleAttendeeBadgeRequirementInput;
};


export type MutationCancelBookingAndGenerateReversalInvoiceArgs = {
  id: Scalars['String'];
  options?: Maybe<CancelBookingOptionsInput>;
  sendMail?: Maybe<Scalars['Boolean']>;
};


export type MutationCancelMolliePaymentFromAdminArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type MutationCaptureMolliePaymentFromAdminArgs = {
  amount?: Maybe<Scalars['Float']>;
  scheduledPaymentId: Scalars['ID'];
};


export type MutationChangeAttendeeMemberStatusArgs = {
  id: Scalars['ID'];
  member: Scalars['Boolean'];
};


export type MutationChangeDefaultPaymentMethodArgs = {
  attendeeId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
};


export type MutationChangeForgottenPasswordArgs = {
  changePasswordId: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationChangeMultipleAttendeesDefaultPaymentMethodsArgs = {
  attendeeIds: Array<Scalars['ID']>;
  koOrganizationId: Scalars['ID'];
  targetPaymentTransferType: PaymentTransferType;
};


export type MutationClearManuallyAdjustedArgs = {
  id: Scalars['String'];
};


export type MutationCompleteBookerLinkRegistrationArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCompletePasswordlessFlowArgs = {
  loginCode: Scalars['String'];
};


export type MutationCompletePasswordlessFlowEndUserAppArgs = {
  loginCode: Scalars['String'];
};


export type MutationConfirmAgbArgs = {
  agbConfirmed: Scalars['Boolean'];
  bookingId: Scalars['ID'];
};


export type MutationConfirmBankTransactionArgs = {
  distributions: Array<BankTransactionDistributionInput>;
  guardWarned?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationConfirmPrivacyStatementArgs = {
  bookingId: Scalars['ID'];
  privacyStatementConfirmed: Scalars['Boolean'];
};


export type MutationConvertBookingToWaitlistArgs = {
  bookingId: Scalars['ID'];
};


export type MutationConvertPhoneNumbersToInternationalFormatArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationConvertWaitlistToBookingArgs = {
  bookingId: Scalars['ID'];
};


export type MutationCopyAttendeeToCourseArgs = {
  bookingId: Scalars['ID'];
  deleteNotes?: Maybe<Scalars['Boolean']>;
  targetCourseId: Scalars['ID'];
  usePlaceReservation?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateAdminManagementUserArgs = {
  input: CreateAdminManagementUserInput;
};


export type MutationCreateAndRegisterAdminArgs = {
  tenantId: Scalars['String'];
  userInput: UserInput;
};


export type MutationCreateAndRegisterThirdPartyUserArgs = {
  tenantId: Scalars['String'];
  thirdPartyUserInput: ThirdPartyUserInput;
};


export type MutationCreateAndRegisterThirdPartyUserAndBookerArgs = {
  newBookingData: BookerInput;
  thirdPartyUserInput: ThirdPartyUserInput;
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationCreateAttendanceListBulkByInstructorArgs = {
  input: CreateAttendanceListBulkByInstructorInput;
};


export type MutationCreateAttendanceListBulkByLocationArgs = {
  input: CreateAttendanceListBulkByLocationInput;
};


export type MutationCreateAttendeeBadgeArgs = {
  newAttendeeBadgeInput: NewAttendeeBadgeInput;
};


export type MutationCreateAttendeeBadgeByBadgeNameArgs = {
  newAttendeeBadgeByBadgeNameInput: NewAttendeeBadgeByBadgeNameInput;
};


export type MutationCreateBadgeArgs = {
  newBadgeInput: NewBadgeInput;
};


export type MutationCreateBadgeGroupArgs = {
  newBadgeGroupInput: NewBadgeGroupInput;
};


export type MutationCreateBillingAddressTemplateArgs = {
  input: CreateBillingAddressTemplateInput;
};


export type MutationCreateBookerArgs = {
  newBookerData: BookerInput;
};


export type MutationCreateBookingArgs = {
  newBookingData: NewBookingInput;
  onlineBooking?: Maybe<Scalars['Boolean']>;
  sendMail: Scalars['Boolean'];
};


export type MutationCreateBookingRestrictionArgs = {
  newBookingRestrictionInput: NewBookingRestrictionInput;
};


export type MutationCreateBookingWithCourseLessonBookingsArgs = {
  newBookingInputBookableLessons: NewBookingInputBookableLessons;
};


export type MutationCreateCertificateTemplateArgs = {
  input: CreateCertificateTemplateInput;
};


export type MutationCreateCorrectionInvoiceArgs = {
  bookingId: Scalars['String'];
  sendMail?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateCourseArgs = {
  newCourseData: NewCourseInput;
};


export type MutationCreateCourseCategoryArgs = {
  newCourseCategoryData: NewCourseCategoryInput;
};


export type MutationCreateCourseLessonArgs = {
  newCourseLessonData: NewCourseLessonInput;
};


export type MutationCreateCourseLessonBookingArgs = {
  newCourseLessonBookingInput: NewCourseLessonBookingInput;
};


export type MutationCreateCourseLessonBookingsByCourseIdArgs = {
  courseId: Scalars['String'];
};


export type MutationCreateCourseLessonsArgs = {
  newCourseLessonData: Array<NewCourseLessonInput>;
};


export type MutationCreateCourseTypeArgs = {
  newCourseTypeData: NewCourseTypeInput;
};


export type MutationCreateCustomBankDataArgs = {
  newCustomBankDataInput: NewCustomBankDataInput;
};


export type MutationCreateDiscountCodeArgs = {
  input: DiscountCodeInput;
};


export type MutationCreateDummyCamtFileForMultiplePaymentsArgs = {
  createDummySwissCamtByScheduledPaymentsInput: CreateDummySwissCamtByScheduledPaymentsInput;
};


export type MutationCreateDunningArgs = {
  input: CreateDunningInput;
};


export type MutationCreateFaUserWithOrAddEndUserRightsArgs = {
  email: Scalars['String'];
};


export type MutationCreateFeeLetterArgs = {
  input: CreateFeeLetterInput;
};


export type MutationCreateInstallmentRateArgs = {
  newInstallmentRateInput: NewInstallmentRateInput;
};


export type MutationCreateInstructorInvoiceArgs = {
  input: CreateInstructorInvoiceInput;
};


export type MutationCreateInterestListArgs = {
  input: CreateInterestListInput;
};


export type MutationCreateInterestRegistrationArgs = {
  input: CreateInterestRegistrationInput;
  sendConfirmationMail?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateInvoiceArgs = {
  newInvoiceData: InvoiceInput;
  sendMail?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateInvoiceExportArgs = {
  courseId?: Maybe<Scalars['ID']>;
  includeReversals?: Maybe<Scalars['Boolean']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};


export type MutationCreateInvoicesByBookingIdsArgs = {
  bookingIds: Array<Scalars['ID']>;
  sendMail?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateInvoicesByCourseIdArgs = {
  courseId: Scalars['String'];
  sendMail?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateInvoiceTemplateSetArgs = {
  name: Scalars['String'];
};


export type MutationCreateLessonBookingArgs = {
  newBookingData: NewBookingInputBookableLessons;
  onlineBooking?: Maybe<Scalars['Boolean']>;
  sendMail: Scalars['Boolean'];
};


export type MutationCreateLocationArgs = {
  newLocationData: NewLocationInput;
};


export type MutationCreateLocationContactArgs = {
  newLocationContactData: NewLocationContactInput;
};


export type MutationCreateMailjetSenderArgs = {
  createMailjetSenderInput: CreateMailjetSenderInput;
};


export type MutationCreateMolliePaymentArgs = {
  method: Scalars['String'];
  scheduledPaymentId: Scalars['ID'];
};


export type MutationCreateNewMolliePaymentAttemptFromAdminArgs = {
  locale?: Maybe<Scalars['String']>;
  scheduledPaymentId: Scalars['ID'];
};


export type MutationCreateNewsletterCustomListArgs = {
  locationIds: Array<Scalars['ID']>;
  name: Scalars['String'];
};


export type MutationCreateOrganizationArgs = {
  koOrganizationData: KoOrganizationInputType;
};


export type MutationCreateParticipationPrerequisiteArgs = {
  newParticipationPrerequisitesInput: NewParticipationPrerequisitesInput;
};


export type MutationCreateSepaXmlByIdArgs = {
  createSingleSepaXmlInput: CreateSingleSepaXmlInput;
};


export type MutationCreateSepaXmlByTimeRangeArgs = {
  createSepaXmlByTimeRangeInput: CreateSepaXmlByTimeRangeInput;
};


export type MutationCreateSettingEndUserAppArgs = {
  settingEndUserAppInput: SettingEndUserAppInput;
};


export type MutationCreateTemplateArgs = {
  newTemplateData: NewTemplateInput;
};


export type MutationCreateWithdrawalEndUserAppArgs = {
  input: CreateWithdrawalEndUserAppInput;
};


export type MutationCreateYearEndExportArgs = {
  year: Scalars['Int'];
};


export type MutationDeactivateCoursesAllowLessonBookingArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationDeactivateDiscountCodeArgs = {
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};


export type MutationDeactivateTenantArgs = {
  koOrganizationId: Scalars['ID'];
};


export type MutationDeleteAllPlaceReservationsByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAttendanceListArchiveArgs = {
  jobGroupId: Scalars['ID'];
};


export type MutationDeleteAttendeeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAttendeeBadgeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBadgeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBadgeGraphicArgs = {
  badgeId: Scalars['String'];
};


export type MutationDeleteBadgeGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBillingAddressTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBookerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBookingRestrictionArgs = {
  bookingRestrictionId: Scalars['String'];
};


export type MutationDeleteCategoryByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCertificateTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCourseLessonBookingArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCustomBankDataArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDatabaseBackupArgs = {
  backupId: Scalars['ID'];
};


export type MutationDeleteDataExportArgs = {
  exportId: Scalars['ID'];
};


export type MutationDeleteDiscountCodeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFileDoArgs = {
  fileName: Scalars['String'];
};


export type MutationDeleteFolderDoArgs = {
  folderName: Scalars['String'];
};


export type MutationDeleteFusionAuthUserByIdsArgs = {
  koOrganizationId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationDeleteFusionAuthUsersByEmailsArgs = {
  emailAddresses: Array<Scalars['String']>;
};


export type MutationDeleteInstallmentRateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInstallmentRatesByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type MutationDeleteInstructorInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationDeleteInvoiceExportArgs = {
  exportId: Scalars['ID'];
};


export type MutationDeleteInvoiceTemplateSetArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMissingBankDataArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNewsletterCustomListArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePageArgs = {
  pageId: Scalars['String'];
};


export type MutationDeleteScheduledPaymentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSelectionOfWaitlistArgs = {
  bookingIds: Array<Scalars['ID']>;
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteYearEndExportArgs = {
  exportId: Scalars['ID'];
};


export type MutationDismissDuplicatePairArgs = {
  input: DismissDuplicatePairInput;
};


export type MutationDownloadFileDoArgs = {
  fileName: Scalars['String'];
};


export type MutationEditLessonBookingArgs = {
  editBookingInputBookableLessons: EditBookingInputBookableLessons;
};


export type MutationEnableMaintenanceArgs = {
  input?: Maybe<MaintenanceEnableInput>;
};


export type MutationEnablePasswordlessLoginEndUserAppArgs = {
  passwordlessIdCodeLength: Scalars['Float'];
};


export type MutationEraseBookerDataArgs = {
  bookerId: Scalars['ID'];
  includeLinkedBookers?: Maybe<Scalars['Boolean']>;
};


export type MutationErasurePreviewArgs = {
  bookerId: Scalars['ID'];
  includeLinkedBookers?: Maybe<Scalars['Boolean']>;
};


export type MutationExecuteBulkTransferArgs = {
  input: ExecuteBulkTransferInput;
};


export type MutationExecuteSettledBookingCorrectionArgs = {
  bookingId: Scalars['ID'];
  input: SettledBookingCorrectionInput;
  sendCorrectionInvoiceMail?: Maybe<Scalars['Boolean']>;
};


export type MutationExecuteTransferArgs = {
  input: ExecuteTransferInput;
};


export type MutationFetchByYearArgs = {
  year: Scalars['String'];
};


export type MutationFetchByYearAndStateCodeArgs = {
  stateCode: StateCode;
  year: Scalars['String'];
};


export type MutationFetchPublicHolidaysByYearArgs = {
  year: Scalars['String'];
};


export type MutationFixMissingInvoiceIdsArgs = {
  scheduledPaymentIds?: Maybe<Array<Scalars['ID']>>;
};


export type MutationForceRollbackAllowMolliePaymentArgs = {
  courseId: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationForgetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  forgotPasswordWithStateInput: ForgotPasswordWithStateInput;
};


export type MutationGeneratePasswordResetLinkArgs = {
  forgotPasswordWithStateInput: ForgotPasswordWithStateInput;
};


export type MutationGeneratePaymentSchedulePreviewArgs = {
  bookingPrice: Scalars['Float'];
  courseId?: Maybe<Scalars['ID']>;
  lessonDates: Array<Scalars['DateTime']>;
  monthlySchedule: MonthlySchedule;
  paymentType: PaymentType;
};


export type MutationGenerateScheduledPaymentsByCourseArgs = {
  additionalItemIds?: Maybe<Array<Scalars['ID']>>;
  attendeeId?: Maybe<Scalars['ID']>;
  courseId: Scalars['ID'];
  creditedBalance?: Maybe<Scalars['Float']>;
  currentScheduledPayments?: Maybe<Array<ScheduledPaymentSimpleInput>>;
  discount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<Scalars['String']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  omitMemberDiscount?: Maybe<Scalars['Boolean']>;
  paymentType?: Maybe<PaymentType>;
};


export type MutationGenerateScheduledPaymentsForSettledBookingArgs = {
  bookingId: Scalars['ID'];
  savePayments?: Maybe<Scalars['Boolean']>;
};


export type MutationGenerateUpdatedSchedulesNewBookingPriceArgs = {
  bookingPrice: Scalars['Float'];
  scheduledPayments: Array<UpdateScheduledPaymentByBookingInput>;
};


export type MutationHardDeleteTenantArgs = {
  confirmationCode: Scalars['String'];
  koOrganizationId: Scalars['ID'];
};


export type MutationImportBookersArgs = {
  importBookersInput: ImportBookersInput;
};


export type MutationInitiateMolliePaymentForBookingFromEndUserAppArgs = {
  bookingId: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  method: Scalars['String'];
  returnBaseUrl?: Maybe<Scalars['String']>;
  scheduledPaymentId?: Maybe<Scalars['ID']>;
};


export type MutationIssueCertificateArgs = {
  input: IssueCertificateInput;
};


export type MutationIssueCertificatesByAttendeesArgs = {
  input: IssueCertificatesByAttendeesInput;
};


export type MutationIssueCertificatesByCourseArgs = {
  input: IssueCertificatesByCourseInput;
};


export type MutationKo9DetectSchemaArgs = {
  credentials: Ko9DbCredentialsInput;
};


export type MutationKo9DryRunArgs = {
  config: Ko9ImportConfigInput;
  credentials: Ko9DbCredentialsInput;
};


export type MutationKo9ExecuteImportArgs = {
  config: Ko9ImportConfigInput;
  credentials: Ko9DbCredentialsInput;
};


export type MutationKo9FetchPreviewArgs = {
  config: Ko9ImportConfigInput;
  credentials: Ko9DbCredentialsInput;
  limit?: Maybe<Scalars['Int']>;
};


export type MutationKo9RollbackImportArgs = {
  bookerIds: Array<Scalars['String']>;
};


export type MutationKo9SaveCredentialsArgs = {
  credentials: Ko9DbCredentialsInput;
};


export type MutationKo9TestConnectionArgs = {
  credentials: Ko9DbCredentialsInput;
};


export type MutationLinkAttendeeToBookerArgs = {
  attendeeId: Scalars['ID'];
  birthday?: Maybe<Scalars['DateTime']>;
};


export type MutationLoggingArgs = {
  input: LoggingInput;
};


export type MutationLoginWithPasswordArgs = {
  loginInput: PasswordLoginInputType;
};


export type MutationMarkScheduledPaymentsAsPaidFromSepaExportArgs = {
  input: MarkPaidFromSepaInput;
};


export type MutationMergeAttendeesArgs = {
  loserAttendeeId: Scalars['ID'];
  selectedFields?: Maybe<AttendeeMergeFieldsInput>;
  winnerAttendeeId: Scalars['ID'];
};


export type MutationMergeBookersArgs = {
  mergedBookerId: Scalars['ID'];
  updateBookerData: BookerInput;
};


export type MutationModifyScheduledPaymentArgs = {
  modifyScheduledPaymentInput: ModifyScheduledPaymentInput;
};


export type MutationMollieCreateClientLinkArgs = {
  input: MollieCreateClientLinkInput;
  returnTo?: Maybe<Scalars['String']>;
};


export type MutationMoveBadgeArgs = {
  badgeGroupId?: Maybe<Scalars['ID']>;
  movedBadgeId: Scalars['ID'];
  targetBadgeId?: Maybe<Scalars['ID']>;
};


export type MutationPasswordlessLoginArgs = {
  loginData: PasswordlessLoginInputType;
};


export type MutationPasswordlessLoginEndUserAppArgs = {
  endUserPasswordlessLoginInput: EndUserPasswordlessLoginInputType;
};


export type MutationPreviewInstructorInvoiceArgs = {
  input: CreateInstructorInvoiceInput;
};


export type MutationReactivateBookerNewsletterArgs = {
  bookerId: Scalars['ID'];
};


export type MutationReactivateDiscountCodeArgs = {
  id: Scalars['ID'];
};


export type MutationReactivateTenantArgs = {
  koOrganizationId: Scalars['ID'];
};


export type MutationRecordExternalPaymentForScheduledPaymentArgs = {
  input: RecordExternalPaymentForScheduledPaymentInput;
};


export type MutationRecordLikelyBankTransactionsArgs = {
  after?: Maybe<Scalars['String']>;
};


export type MutationRefactoredCourseDetailsArgs = {
  courseId: Scalars['ID'];
};


export type MutationRefreshAccessTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRefreshMolliePaymentStatusFromAdminArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type MutationRefundMolliePaymentFromAdminArgs = {
  amount: Scalars['Float'];
  notifyBooker?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  scheduledPaymentId: Scalars['ID'];
};


export type MutationRejectBankTransactionArgs = {
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  reason: BankTransactionRejectReason;
  recordedScheduledPaymentId?: Maybe<Scalars['ID']>;
};


export type MutationRematchAllBankImportFilesArgs = {
  after?: Maybe<Scalars['String']>;
};


export type MutationRematchBankImportFileArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveAdminManagementUserArgs = {
  input: RemoveAdminManagementUserInput;
};


export type MutationRemoveAssistantFromControlBoardArgs = {
  input: AssignAssistantInput;
};


export type MutationRemoveBookableCourseArgs = {
  bookableCourseId: Scalars['String'];
  prerquisiteCourseId: Scalars['String'];
};


export type MutationRemoveBookingArgs = {
  bookingDeleteAction?: Maybe<BookingDeleteAction>;
  id: Scalars['ID'];
  notifyBooker?: Maybe<Scalars['Boolean']>;
};


export type MutationRemoveBookingsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRemoveCourseArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCourseLessonArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCourseTypeArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveInstructorArgs = {
  id: Scalars['String'];
};


export type MutationRemoveInterestListArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveInterestRegistrationArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveLocationArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveLocationContactArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveParticipationPrerequisiteArgs = {
  id: Scalars['ID'];
};


export type MutationRenameFileDoArgs = {
  fileName: Scalars['String'];
  newFileName: Scalars['String'];
};


export type MutationRenameFolderDoArgs = {
  folderName: Scalars['String'];
  newFolderName: Scalars['String'];
};


export type MutationReOrderBadgeGroupsArgs = {
  movedGroupId: Scalars['ID'];
  targetGroupId: Scalars['ID'];
};


export type MutationReOrderBadgesArgs = {
  movedBadgeId: Scalars['ID'];
  targetBadgeId: Scalars['ID'];
};


export type MutationReportEmbedConversionArgs = {
  reported: Scalars['Boolean'];
};


export type MutationReportEndUserEventArgs = {
  input: EndUserEventInput;
};


export type MutationRequestAdminOrgDiscoveryArgs = {
  email: Scalars['String'];
};


export type MutationRequestBookerLinkRegistrationArgs = {
  email: Scalars['String'];
};


export type MutationRequestStaffMobileOrgDiscoveryArgs = {
  email: Scalars['String'];
};


export type MutationRequestStaffMobilePasswordResetArgs = {
  email: Scalars['String'];
};


export type MutationResendBookingConfirmationArgs = {
  bookingId: Scalars['ID'];
};


export type MutationResendCertificateEmailArgs = {
  issuedCertificateId: Scalars['String'];
};


export type MutationResendDunningArgs = {
  id: Scalars['ID'];
};


export type MutationResendEmailVerificationArgs = {
  userId: Scalars['String'];
};


export type MutationResetAllUnsetteledScheduledPaymentsOfCourseArgs = {
  courseId: Scalars['ID'];
  preview?: Maybe<Scalars['Boolean']>;
};


export type MutationResetNewsletterLocationListLinkArgs = {
  id: Scalars['ID'];
};


export type MutationResetPaymentPlanOfInvoicedLessonBookingArgs = {
  bookingId: Scalars['ID'];
  previewOnly?: Maybe<Scalars['Boolean']>;
};


export type MutationResetScheduledPaymentsOfBookingArgs = {
  bookingId: Scalars['ID'];
  preview?: Maybe<Scalars['Boolean']>;
};


export type MutationResolveAmbiguousSwissQrPaymentArgs = {
  comment: Scalars['String'];
  recordId: Scalars['ID'];
};


export type MutationResolveChargebackArgs = {
  attemptId: Scalars['String'];
};


export type MutationResolveSurplusMolliePaymentsArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type MutationRestoreDatabaseBackupArgs = {
  input: RestoreBackupInput;
};


export type MutationRestoreOrphanBookingArgs = {
  bookingId: Scalars['ID'];
  koOrganizationId: Scalars['String'];
};


export type MutationRestoreScheduledPaymentArgs = {
  id: Scalars['String'];
};


export type MutationRetryMolliePaymentArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type MutationRetryMolliePaymentManuallyArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type MutationRollbackPaymentStatusArgs = {
  id: Scalars['ID'];
};


export type MutationSaveAdminArgs = {
  saveAdminData: SaveAdminInput;
};


export type MutationSaveInstructorArgs = {
  saveInstructorData: SaveInstructorInput;
};


export type MutationSendAttendanceListArchiveArgs = {
  input: SendAttendanceListArchiveInput;
};


export type MutationSendAttendanceListArchiveTestEmailArgs = {
  input: SendAttendanceListArchiveInput;
};


export type MutationSendBlankMailToMultipleBookersArgs = {
  file?: Maybe<Scalars['Upload']>;
  input: BlankMailInputTypes;
};


export type MutationSendBookingConfirmationArgs = {
  bookingId: Scalars['ID'];
  editedTemplateInput?: Maybe<EditTemplateInput>;
};


export type MutationSendBookingInvoiceArgs = {
  bookingId: Scalars['ID'];
  reversal?: Maybe<Scalars['Boolean']>;
};


export type MutationSendBookingInvoicesByBookingIdsArgs = {
  bookingIds: Array<Scalars['ID']>;
  reversal?: Maybe<Scalars['Boolean']>;
};


export type MutationSendEmailsToSelectionOfCourseArgs = {
  sendMailToSelectionOfCourseInput: SendMailToSelectionOfCourseInput;
};


export type MutationSendEmailTemplateArgs = {
  sendTemplateInput: SendTemplateInput;
};


export type MutationSendEmailToSelectionOfAttendeesArgs = {
  sendMailToSelectionOfAttendeesInput: SendMailToSelectionOfAttendeesInput;
};


export type MutationSendEmailToSelectionOfBookersArgs = {
  sendMailToSelectionOfBookersInput: SendMailToSelectionOfBookersInput;
};


export type MutationSendEmailToSelectionOfScheduledPaymentsArgs = {
  sendMailToSelectionOfScheduledPaymentsInput: SendMailToSelectionOfScheduledPaymentsInput;
};


export type MutationSendEmailToSelectionOfStaffArgs = {
  sendMailToSelectionOfStaffInput: SendMailToSelectionOfStaffInput;
};


export type MutationSendInvoicesToSelectionOfBookingsArgs = {
  sendInvoicesToSelectionOfBookingsInput: SendInvoicesToSelectionOfBookingInput;
};


export type MutationSendMailArgs = {
  sandboxMode?: Maybe<Scalars['Boolean']>;
  sendParamsMessageInput: SendParamsMessageInput;
};


export type MutationSendMailToSelectionOfBookingsArgs = {
  sendMailToSelectionOfBookingInput: SendMailToSelectionOfBookingInput;
};


export type MutationSendMolliePaymentLinkForBookingFromAdminArgs = {
  bookingId: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
};


export type MutationSendMolliePaymentLinkFromAdminArgs = {
  locale?: Maybe<Scalars['String']>;
  scheduledPaymentId: Scalars['ID'];
};


export type MutationSendPasswordResetLinkEmailArgs = {
  input: SendPasswordResetLinkEmailInput;
};


export type MutationSendSmsArgs = {
  smsParams: SendSmsInput;
};


export type MutationSendTestMailArgs = {
  sandboxMode?: Maybe<Scalars['Boolean']>;
};


export type MutationSendTestMailBookerArgs = {
  bookerId: Scalars['ID'];
};


export type MutationSetBankTransactionCounterpartArgs = {
  id: Scalars['ID'];
  treatAs: BankCounterpartKind;
};


export type MutationSetDunningPauseArgs = {
  input: SetDunningPauseInput;
};


export type MutationSetIncludeCourseDetailsArgs = {
  includeCourseDetails: Scalars['Boolean'];
  templateId: Scalars['ID'];
};


export type MutationSetInterestListNoteFieldDefaultArgs = {
  applyToExisting: Scalars['Boolean'];
  showNoteField: Scalars['Boolean'];
};


export type MutationSetMultipleScheduledPaymentsPaidArgs = {
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentIds: Array<Scalars['ID']>;
};


export type MutationSetNewCustomerNumberArgs = {
  newCustomerNumber: Scalars['Float'];
};


export type MutationSetNewPaymentAmountArgs = {
  id: Scalars['String'];
  paymentAmount: Scalars['Float'];
};


export type MutationSetNewPaymentDoneDateArgs = {
  id: Scalars['String'];
  paymentDoneDate: Scalars['DateTime'];
};


export type MutationSetNewsletterLocationListEnabledArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationSetNewsletterLocationListExcludedArgs = {
  excluded: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationSetScheduledPaymentPaidArgs = {
  id: Scalars['String'];
  paymentDone?: Maybe<Scalars['DateTime']>;
};


export type MutationSetScheduledPaymentUnpaidArgs = {
  id: Scalars['String'];
};


export type MutationSetSepaClearanceArgs = {
  id: Scalars['ID'];
  sepaClearance: Scalars['Boolean'];
};


export type MutationSimulateMollieLinkWebhookForTestingArgs = {
  attemptId: Scalars['String'];
  simulatedFailureReason?: Maybe<Scalars['String']>;
  simulatedStatus: Scalars['String'];
};


export type MutationSimulateMollieWebhookForTestingArgs = {
  molliePaymentId: Scalars['String'];
  simulatedChargebackReason?: Maybe<Scalars['String']>;
  simulatedFailureReason?: Maybe<Scalars['String']>;
  simulatedStatus: Scalars['String'];
};


export type MutationSingleUploadArgs = {
  analysis?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
};


export type MutationSoftDeleteBadgeArgs = {
  id: Scalars['String'];
};


export type MutationSubmitSupportReportArgs = {
  input: SupportReportInput;
};


export type MutationSyncNewsletterLocationListArgs = {
  id: Scalars['ID'];
  release?: Maybe<Scalars['Boolean']>;
};


export type MutationTestLoginArgs = {
  email: Scalars['String'];
};


export type MutationThirdPartyLoginArgs = {
  thirdPartyLoginInput: ThirdPartyLoginInput;
};


export type MutationToggleAreaManagerRoleFromAdminManagementArgs = {
  input: ToggleAreaManagerRoleInput;
};


export type MutationToggleAttendeeBadgeRequirementArgs = {
  input: ToggleAttendeeBadgeRequirementInput;
};


export type MutationToggleUserRoleArgs = {
  toggleUserRoleInput: ToggleUserRoleInput;
};


export type MutationTransferAttendeeToBookerArgs = {
  attendeeId: Scalars['ID'];
  newBookerId: Scalars['ID'];
};


export type MutationTransferAttendeeToCourseArgs = {
  bookingDeleteAction?: Maybe<BookingDeleteAction>;
  bookingId: Scalars['ID'];
  deleteNotes?: Maybe<Scalars['Boolean']>;
  targetCourseId: Scalars['ID'];
  usePlaceReservation?: Maybe<Scalars['Boolean']>;
};


export type MutationTransferMultipleBookingsArgs = {
  deleteNotes?: Maybe<Scalars['Boolean']>;
  transferMultipleBookingsInput: TransferMultipleBookingsInput;
};


export type MutationUnassignMyselfFromCourseLessonAssistantAppArgs = {
  courseLessonId: Scalars['ID'];
};


export type MutationUndoDuplicateExceptionArgs = {
  id: Scalars['String'];
};


export type MutationUnsubscribeBookerFromNewsletterArgs = {
  bookerId: Scalars['ID'];
};


export type MutationUpdateAdminManagementUserEmailArgs = {
  input: UpdateAdminManagementUserEmailInput;
};


export type MutationUpdateAdminManagementUserNameArgs = {
  input: UpdateAdminManagementUserNameInput;
};


export type MutationUpdateAllowedMollieMethodsArgs = {
  methods: Array<Scalars['String']>;
};


export type MutationUpdateAnnouncementArgs = {
  id: Scalars['String'];
  input: UpdateAnnouncementInput;
};


export type MutationUpdateAttendanceListNoteArgs = {
  attendanceListNote?: Maybe<Scalars['String']>;
  bookingId: Scalars['ID'];
};


export type MutationUpdateAttendanceListSettingsArgs = {
  updateAttendanceListSettingsInput: UpdateAttendanceListSettingsInput;
};


export type MutationUpdateAttendeeBadgeArgs = {
  editAttendeeBadgeInput: EditAttendeeBadgeInput;
};


export type MutationUpdateBadgeArgs = {
  updateBadgeInput: UpdateBadgeInput;
};


export type MutationUpdateBadgeGroupArgs = {
  updateBadgeGroupInput: UpdateBadgeGroupInput;
};


export type MutationUpdateBankTransactionCommentArgs = {
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationUpdateBillingAddressTemplateArgs = {
  input: UpdateBillingAddressTemplateInput;
};


export type MutationUpdateBillingAmountForCourseArgs = {
  billingAmount?: Maybe<Scalars['Float']>;
  courseId: Scalars['ID'];
};


export type MutationUpdateBillingAmountForCourseLessonArgs = {
  billingAmount?: Maybe<Scalars['Float']>;
  courseLessonId: Scalars['ID'];
};


export type MutationUpdateBookerArgs = {
  fromEndUserApp?: Maybe<Scalars['Boolean']>;
  updateBookerData: BookerInput;
};


export type MutationUpdateBookerAccountEndUserAppArgs = {
  fromEndUserApp?: Maybe<Scalars['Boolean']>;
  updateBookerEndUserAppData: UpdateBookerAccountEndUserAppInput;
};


export type MutationUpdateBookerCreditArgs = {
  amount: Scalars['Float'];
  bookerId: Scalars['ID'];
  note: Scalars['String'];
};


export type MutationUpdateBookerIdMissmatchArgs = {
  newBookerId: Scalars['ID'];
  notificationId: Scalars['ID'];
  oldBookerId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateBookingArgs = {
  editBookingData: EditBookingInput;
  id: Scalars['String'];
};


export type MutationUpdateBookingPaymentMethodArgs = {
  bookingId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
};


export type MutationUpdateBookingRestrictionArgs = {
  updateBookingRestrictionInput: UpdateBookingRestrictionInput;
};


export type MutationUpdateCertificateTemplateArgs = {
  input: UpdateCertificateTemplateInput;
};


export type MutationUpdateCompanyAgbArgs = {
  agb: Scalars['String'];
};


export type MutationUpdateCompanyPrivacyStatementArgs = {
  privacyStatement: Scalars['String'];
};


export type MutationUpdateCompanySettingsArgs = {
  newCompanyData: CompanySettingInput;
};


export type MutationUpdateCourseArgs = {
  editCourseData: EditCourseInput;
  fillFromWaitingList?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  notifyBooker?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateCourseAndBookingsArgs = {
  dryRun: Scalars['Boolean'];
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
};


export type MutationUpdateCourseAnnotationArgs = {
  annotation?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationUpdateCourseArchivedArgs = {
  courseId: Scalars['String'];
  isArchived: Scalars['Boolean'];
};


export type MutationUpdateCourseBlockBookingOnlineArgs = {
  blockBookingOnline: Scalars['Boolean'];
  courseId: Scalars['String'];
};


export type MutationUpdateCourseCategoryArgs = {
  id: Scalars['String'];
  newCourseCategoryData: NewCourseCategoryInput;
};


export type MutationUpdateCourseLessonBookingArgs = {
  updateCourseLessonBookingInput: UpdateCourseLessonBookingInput;
};


export type MutationUpdateCourseLessonInstructorsArgs = {
  courseLessonId: Scalars['ID'];
  instructorIds: Array<Scalars['ID']>;
  scope: LessonInstructorScope;
};


export type MutationUpdateCoursesStartDateTimeArgs = {
  saveResult?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateCourseTypeArgs = {
  id: Scalars['String'];
  newCourseTypeData: NewCourseTypeInput;
};


export type MutationUpdateCustomBankDataArgs = {
  updateCustomBankDataInput: UpdateCustomBankDataInput;
};


export type MutationUpdateCustomCompanyHolidaysArgs = {
  holidayInputs: Array<HolidayInput>;
};


export type MutationUpdateDiscountCodeArgs = {
  id: Scalars['ID'];
  input: DiscountCodeUpdateInput;
};


export type MutationUpdateInstallmentRateArgs = {
  updateInstallmentRateInput: UpdateInstallmentRateInput;
};


export type MutationUpdateInterestListArgs = {
  input: UpdateInterestListInput;
};


export type MutationUpdateInterestRegistrationArgs = {
  input: UpdateInterestRegistrationInput;
};


export type MutationUpdateInvoiceArgs = {
  editInvoiceData: EditInvoiceInput;
  id: Scalars['String'];
};


export type MutationUpdateInvoiceTemplateSetArgs = {
  input: UpdateInvoiceTemplateSetInput;
};


export type MutationUpdateLateEntryPricingConfigurationArgs = {
  input: UpdateLateEntryPricingConfigurationInput;
};


export type MutationUpdateLocalLocationIdArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationUpdateLocationArgs = {
  editLocationData: EditLocationInput;
};


export type MutationUpdateLocationContactArgs = {
  editLocationContactData: EditLocationContactInput;
};


export type MutationUpdateLocationPublishedStatusArgs = {
  isPublished: Scalars['Boolean'];
  locationId: Scalars['ID'];
};


export type MutationUpdateManyScheduledPaymentIdsArgs = {
  editScheduledPaymentData: EditScheduledPaymentInput;
  paymentIds: Array<Scalars['ID']>;
};


export type MutationUpdateMollieEnabledMethodsArgs = {
  methodIds: Array<Scalars['String']>;
};


export type MutationUpdateMultipleBookerIdMissmatchesArgs = {
  updateMultipleBookerIdMissmatchesInput: Array<UpdateBookerIdMissmatchesInput>;
};


export type MutationUpdateMultipleCoursesArchivedArgs = {
  courseIds: Array<Scalars['ID']>;
  isArchived: Scalars['Boolean'];
};


export type MutationUpdateMultipleCoursesShowInWebArgs = {
  courseIds: Array<Scalars['ID']>;
  showInWeb: Scalars['Boolean'];
};


export type MutationUpdateMyProfileArgs = {
  input: UpdateMyProfileInput;
};


export type MutationUpdateNewsletterCustomListArgs = {
  id: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
  name: Scalars['String'];
};


export type MutationUpdateNewsletterRulesArgs = {
  input: NewsletterRulesInput;
};


export type MutationUpdateNewsletterSettingsArgs = {
  input: NewsletterSettingsInput;
};


export type MutationUpdateNoticeStaffArgs = {
  id: Scalars['String'];
  noticeStaff: Scalars['String'];
};


export type MutationUpdateOrganizationSubscriptionTypeArgs = {
  koOrganizationId: Scalars['ID'];
  subscriptionType: SubscriptionType;
};


export type MutationUpdatePageArgs = {
  editPageInput: EditPageInput;
};


export type MutationUpdateParticipationPrerequisiteArgs = {
  updateParticipationPrerequisitesInput: UpdateParticipationPrerequisitesInput;
};


export type MutationUpdateScheduledPaymentArgs = {
  editScheduledPaymentData: EditScheduledPaymentInput;
  id: Scalars['String'];
};


export type MutationUpdateSepaPaymentMethodArgs = {
  input: UpdatePaymentMethodInput;
};


export type MutationUpdateSettingEndUserAppArgs = {
  updateSettingEndUserAppInput: UpdateSettingEndUserAppInput;
};


export type MutationUpdateSettingsArgs = {
  newSettingsData: SettingInput;
};


export type MutationUpdateSettledBookingDiscountArgs = {
  bookingId: Scalars['ID'];
  creditedBalance?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountName?: Maybe<Scalars['String']>;
  memberDiscount?: Maybe<Scalars['Float']>;
};


export type MutationUpdateShowArchivedCoursesArgs = {
  showArchivedCourses: Scalars['Boolean'];
};


export type MutationUpdateStaffVisibilityRulesArgs = {
  input: StaffVisibilityRulesInput;
};


export type MutationUpdateSubscriptionFeaturesArgs = {
  features: SubscriptionFeaturesInput;
  subscriptionId: Scalars['ID'];
};


export type MutationUpdateSwissQrFileNoteArgs = {
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
};


export type MutationUpdateTableColumnSettingsArgs = {
  updateTableColumnSettingsInput: UpdateTableColumnSettingsInput;
};


export type MutationUpdateTemplateArgs = {
  editTemplateData: EditTemplateInput;
  id: Scalars['String'];
};


export type MutationUpdateWithdrawalStatusArgs = {
  input: UpdateWithdrawalStatusInput;
};


export type MutationUploadBadgeGraphicArgs = {
  badgeId: Scalars['String'];
  file: Scalars['Upload'];
};


export type MutationUploadBankImportFileArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadBundesbankBlzArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadCompanyLogoArgs = {
  analysis?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
};


export type MutationUploadContentImageArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadFilesDoArgs = {
  fileArray: Array<Scalars['Upload']>;
  metadata?: Maybe<UploadMetadataInput>;
  path: Scalars['String'];
};


export type MutationUploadProfilePictureArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadSingleFileDoArgs = {
  file: Scalars['Upload'];
  path: Scalars['String'];
};


export type MutationUpsertAttendeeBadgesWithRequirementsArgs = {
  input: UpsertAttendeeBadgesWithRequirementsInput;
};


export type MutationUserSettingSetOptimizedCourseCalendarArgs = {
  optimize: Scalars['Boolean'];
};


export type MutationUserSettingsUpdateOrCreateArgs = {
  userSettingsInput: UserSettingsInputTypes;
};


export type MutationVerifyBookersDataArgs = {
  importBookersInput: ImportBookersInput;
};


export type MutationVoidMolliePaymentLinkForBookingArgs = {
  bookingId: Scalars['ID'];
};


export type MutationVoidMolliePaymentLinksForBookingsArgs = {
  bookingIds: Array<Scalars['ID']>;
};


export type MutationWithdrawDunningArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};

export type MyProfileType = {
  birthDate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  houseNumber?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  salutation?: Maybe<SalutationType>;
  signedProfilePictureUrl?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type NewAttendeeBadgeByBadgeNameInput = {
  attendeeId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  dateOfAchivement?: Maybe<Scalars['DateTime']>;
  name: Scalars['ID'];
};

export type NewAttendeeBadgeInput = {
  attendeeId: Scalars['ID'];
  badgeId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  dateOfAchivement?: Maybe<Scalars['DateTime']>;
  fulfilledBadgeRequirementIds?: Maybe<Array<Scalars['ID']>>;
};

export type NewBadgeGroupInput = {
  color?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: BadgeGroupType;
};

export type NewBadgeInput = {
  abbreviation?: Maybe<Scalars['String']>;
  badgeGroupId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requirements?: Maybe<Array<BadgeRequirementInlineInput>>;
};

export type NewBookingInput = {
  additionalInfo?: Maybe<Scalars['String']>;
  additionalItemIds?: Maybe<Array<Scalars['ID']>>;
  agbConfirmed?: Maybe<Scalars['Boolean']>;
  attendeeId?: Maybe<Scalars['ID']>;
  bookingNumber?: Maybe<Scalars['Float']>;
  bookingNumberPrefix?: Maybe<Scalars['String']>;
  bookingType?: Maybe<BookingType>;
  courseId: Scalars['ID'];
  courseLessonIds?: Maybe<Array<Scalars['ID']>>;
  coursePriceId?: Maybe<Scalars['ID']>;
  creditedBalance?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<Scalars['String']>;
  discountName?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  forceWaitlist?: Maybe<Scalars['Boolean']>;
  foundUs?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  isSpecial?: Maybe<Scalars['Boolean']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  netPrice?: Maybe<Scalars['Float']>;
  newsLetter?: Maybe<Scalars['Boolean']>;
  noticeBooker?: Maybe<Scalars['String']>;
  noticeStaff?: Maybe<Scalars['String']>;
  notifyUser?: Maybe<Scalars['Boolean']>;
  overbook?: Maybe<Scalars['Boolean']>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  paymentType?: Maybe<PaymentType>;
  pricingCalculationVersion?: Maybe<Scalars['String']>;
  pricingFingerprint?: Maybe<Scalars['String']>;
  privacyStatementConfirmed?: Maybe<Scalars['Boolean']>;
  scheduledPayments?: Maybe<Array<UpdateScheduledPaymentByBookingInput>>;
  specialPrice?: Maybe<Scalars['Float']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  utmSource?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type NewBookingInputBookableLessons = {
  additionalInfo?: Maybe<Scalars['String']>;
  additionalItemIds?: Maybe<Array<Scalars['ID']>>;
  agbConfirmed?: Maybe<Scalars['Boolean']>;
  attendeeId?: Maybe<Scalars['ID']>;
  bookingNumber?: Maybe<Scalars['Float']>;
  bookingNumberPrefix?: Maybe<Scalars['String']>;
  bookingType?: Maybe<BookingType>;
  courseId: Scalars['ID'];
  courseLessonIds?: Maybe<Array<Scalars['ID']>>;
  coursePriceId?: Maybe<Scalars['ID']>;
  creditedBalance?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<Scalars['String']>;
  discountName?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  forceWaitlist?: Maybe<Scalars['Boolean']>;
  foundUs?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  isSpecial?: Maybe<Scalars['Boolean']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  netPrice?: Maybe<Scalars['Float']>;
  newsLetter?: Maybe<Scalars['Boolean']>;
  noticeBooker?: Maybe<Scalars['String']>;
  noticeStaff?: Maybe<Scalars['String']>;
  notifyUser?: Maybe<Scalars['Boolean']>;
  omitMemberDiscount?: Maybe<Scalars['Boolean']>;
  overbook?: Maybe<Scalars['Boolean']>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  paymentType?: Maybe<PaymentType>;
  pricingCalculationVersion?: Maybe<Scalars['String']>;
  pricingFingerprint?: Maybe<Scalars['String']>;
  privacyStatementConfirmed?: Maybe<Scalars['Boolean']>;
  scheduledPayments?: Maybe<Array<UpdateScheduledPaymentByBookingInput>>;
  specialPrice?: Maybe<Scalars['Float']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  utmSource?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type NewBookingRestrictionInput = {
  active: Scalars['Boolean'];
  allowWaitlistWithoutPrerequisite?: Maybe<Scalars['Boolean']>;
  blockedPlaces?: Maybe<Scalars['Float']>;
  courseId: Scalars['ID'];
  endDateTime?: Maybe<Scalars['DateTime']>;
  expireAction?: Maybe<ExpireAction>;
  includeBookingList?: Maybe<Scalars['Boolean']>;
  includeWaitingList?: Maybe<Scalars['Boolean']>;
  membersOnly: Scalars['Boolean'];
  prerequisiteCourseIds?: Maybe<Array<Scalars['ID']>>;
  prerequisiteCourses?: Maybe<Array<Scalars['ID']>>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  visibleForAll: Scalars['Boolean'];
};

export type NewBookingsKo9Input = {
  courseName: Scalars['String'];
  courseNumber: Scalars['String'];
  firstCourseLesson: Scalars['DateTime'];
  teilnahmeId: Scalars['String'];
};

export type NewCourseCategoryInput = {
  description?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type NewCourseInput = {
  additionalItems?: Maybe<Array<CourseAdditionalItemInput>>;
  additionalShortInfo?: Maybe<Scalars['String']>;
  allowLessonBooking?: Maybe<Scalars['Boolean']>;
  allowMolliePayment?: Maybe<Scalars['Boolean']>;
  allowMonthlyPayment?: Maybe<Scalars['Boolean']>;
  allowUpFrontPayment?: Maybe<Scalars['Boolean']>;
  annotation: Scalars['String'];
  blockBookingOnline?: Maybe<Scalars['Boolean']>;
  courseNumberFormat: CourseNumberFormat;
  coursePrices: Array<NewCoursePriceInput>;
  courseTypeId: Scalars['ID'];
  customCourseNumberPrefix?: Maybe<Scalars['String']>;
  customInvoiceDueDays?: Maybe<Scalars['Float']>;
  cycle: CourseCycle;
  dateOfFirstInstallment?: Maybe<Scalars['DateTime']>;
  defaultLessonCount: Scalars['Float'];
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<Scalars['String']>;
  endDateTime: Scalars['DateTime'];
  fee?: Maybe<Scalars['Float']>;
  installmentRates?: Maybe<Array<CreateInstallmentRateByCourseCreateInput>>;
  instructors: Array<CourseInstructorIdInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  lateEntryPricingMode?: Maybe<CourseLateEntryPricingMode>;
  lessons: Array<NewCourseLessonInput>;
  locationId: Scalars['ID'];
  maxAssistantsPerLesson?: Maybe<Scalars['Float']>;
  maxAttendees: Scalars['Float'];
  maxWaitlist?: Maybe<Scalars['Float']>;
  minAttendees: Scalars['Float'];
  minimumPartialBookingLessonCount?: Maybe<Scalars['Int']>;
  mollieOptional?: Maybe<Scalars['Boolean']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  paymentInterval: PaymentInterval;
  paymentType?: Maybe<PaymentType>;
  showInWeb?: Maybe<Scalars['Boolean']>;
  startDateTime: Scalars['DateTime'];
  vat?: Maybe<Scalars['Float']>;
  venueId: Scalars['ID'];
  websiteInfo?: Maybe<Scalars['String']>;
};

export type NewCourseLessonBookingInput = {
  attendance?: Maybe<Scalars['Boolean']>;
  bookingId: Scalars['String'];
  bookingType?: Maybe<BookingType>;
  courseId?: Maybe<Scalars['String']>;
  courseLessonId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type NewCourseLessonInput = {
  courseId?: Maybe<Scalars['ID']>;
  endDateTime: Scalars['DateTime'];
  instructors: Array<CourseInstructorIdInput>;
  locationId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  venueId: Scalars['ID'];
};

export type NewCoursePriceInput = {
  bookings?: Maybe<Array<NewBookingInput>>;
  course?: Maybe<NewCourseInput>;
  courseId?: Maybe<Scalars['ID']>;
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<DiscountUnit>;
  grossPrice: Scalars['Float'];
  includedEntranceFee?: Maybe<Scalars['Float']>;
  isSpecial?: Maybe<Scalars['Boolean']>;
  netPrice?: Maybe<Scalars['Float']>;
  vat: Scalars['Float'];
};

export type NewCourseTypeInput = {
  additionalItems?: Maybe<Array<CourseAdditionalItemInput>>;
  additionalItemsKnownIds?: Maybe<Array<Scalars['ID']>>;
  annotation?: Maybe<Scalars['String']>;
  bold: Scalars['Boolean'];
  categoryId?: Maybe<Scalars['ID']>;
  color: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Float']>;
  inWeekPlanner: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  maxAge?: Maybe<Scalars['Float']>;
  maxAttendees?: Maybe<Scalars['Float']>;
  minAge?: Maybe<Scalars['Float']>;
  minAttendees?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  participationPrerequisites?: Maybe<Array<UpdateParticipationPrerequisitesInput>>;
  paymentInterval?: Maybe<PaymentInterval>;
  selfBookerCourse: Scalars['Boolean'];
  shortHandId: Scalars['String'];
  showInWeb: Scalars['Boolean'];
  vat?: Maybe<Scalars['Float']>;
  websiteInfo?: Maybe<Scalars['String']>;
};

export type NewCustomBankDataInput = {
  bankCode: Scalars['String'];
  bic: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type NewInstallmentPlanInput = {
  courseId?: Maybe<Scalars['String']>;
  courseLessonStartDates: Array<Scalars['DateTime']>;
  coursePrice: Scalars['Float'];
  customInvoiceDueDays?: Maybe<Scalars['Float']>;
  dateOfFirstInstallment?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<Scalars['String']>;
  monthCount?: Maybe<Scalars['Float']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  paymentInterval: PaymentInterval;
  paymentType: PaymentType;
  vat: Scalars['Float'];
};

export type NewInstallmentRateInput = {
  courseId: Scalars['String'];
  installmentAmount: Scalars['Float'];
  installmentDue: Scalars['DateTime'];
  installmentType?: Maybe<InstallmentType>;
};

export type NewLessonBookingInput = {
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
  courseLessonId: Scalars['ID'];
};

export type NewLocationContactInput = {
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  salutation: SalutationType;
};

export type NewLocationInput = {
  abbreviation: Scalars['String'];
  city: Scalars['String'];
  customFields?: Maybe<Array<Scalars['JSONObject']>>;
  emailVariableInfo?: Maybe<Scalars['String']>;
  generalLocationContact: GeneralLocationContactInput;
  info?: Maybe<Scalars['String']>;
  isPublished: Scalars['Boolean'];
  locationContacts: Array<LocationContactIdInput>;
  name: Scalars['String'];
  street: Scalars['String'];
  venues: Array<NewVenueInput>;
  website: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NewMultipleLessonBookingInput = {
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
  courseLessonIds: Array<Scalars['ID']>;
};

export type NewNotificationInput = {
  attachments?: Maybe<Array<Scalars['JSONObject']>>;
  bcc: PostInputTo;
  bookerId?: Maybe<Scalars['String']>;
  bookingId?: Maybe<Scalars['String']>;
  cc: PostInputTo;
  courseDetailsSnapshot?: Maybe<Array<Scalars['JSONObject']>>;
  email: Scalars['String'];
  html: Scalars['String'];
  mailjetTemplateId?: Maybe<Scalars['Float']>;
  messageHref?: Maybe<Scalars['String']>;
  messageID: Scalars['ID'];
  receiverName: Scalars['String'];
  renderVariablesSnapshot?: Maybe<Scalars['JSONObject']>;
  status: MailSentStatus;
  subject: Scalars['String'];
  templateName: Scalars['String'];
  templateType: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type NewPageInput = {
  content: Scalars['JSONObject'];
  url: Scalars['String'];
};

export type NewParticipationPrerequisitesInput = {
  courseTypeId: Scalars['String'];
  enabled: Scalars['Boolean'];
  groupDescription?: Maybe<Scalars['String']>;
  groupLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  minCheckCount?: Maybe<Scalars['Float']>;
  optionalInputFields?: Maybe<Array<OptionalInputFieldsInput>>;
};

export type NewSepaXmlInput = {
  collectionDate: Scalars['DateTime'];
  creationDate: Scalars['DateTime'];
  initiatorId: Scalars['String'];
  initiatorName: Scalars['String'];
  positions: Array<SepaXmlPositionInput>;
};

export enum NewsletterAssignment {
  EveryList = 'EveryList',
  HomeLocation = 'HomeLocation'
}

export type NewsletterBookerStatus = {
  bookerId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  optIn: Scalars['Boolean'];
  unsubscribe?: Maybe<NewsletterUnsubscribe>;
};

export enum NewsletterListRule {
  AllBookers = 'AllBookers',
  OptInOnly = 'OptInOnly'
}

export type NewsletterLocationList = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excluded: Scalars['Boolean'];
  id: Scalars['ID'];
  lastSyncAdded?: Maybe<Scalars['Int']>;
  lastSyncAt?: Maybe<Scalars['DateTime']>;
  lastSyncBlocked: Scalars['Boolean'];
  lastSyncError?: Maybe<Scalars['String']>;
  lastSyncInList?: Maybe<Scalars['Int']>;
  lastSyncOk?: Maybe<Scalars['Boolean']>;
  lastSyncRecipients?: Maybe<Scalars['Int']>;
  lastSyncRemoved?: Maybe<Scalars['Int']>;
  lastSyncUnsubscribed?: Maybe<Scalars['Int']>;
  location?: Maybe<Location>;
  locationIds: Array<Scalars['String']>;
  mailjetListId?: Maybe<Scalars['Int']>;
  mailjetListName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type NewsletterLog = {
  count?: Maybe<Scalars['Int']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  durationMs?: Maybe<Scalars['Int']>;
  failed?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  kind: NewsletterLogKind;
  listId?: Maybe<Scalars['ID']>;
  listName?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export enum NewsletterLogKind {
  ErrorMail = 'ErrorMail',
  ListDisabled = 'ListDisabled',
  ListEnabled = 'ListEnabled',
  ListExcluded = 'ListExcluded',
  ListIncluded = 'ListIncluded',
  ListLinkReset = 'ListLinkReset',
  OfficeUnsubscribe = 'OfficeUnsubscribe',
  Reactivated = 'Reactivated',
  RulesChanged = 'RulesChanged',
  SyncFailed = 'SyncFailed',
  SyncRun = 'SyncRun',
  UnsubscribeImport = 'UnsubscribeImport',
  WebhookRegistered = 'WebhookRegistered',
  WebhookUnsubscribe = 'WebhookUnsubscribe'
}

export type NewsletterOverviewResult = {
  addressesAll: Scalars['Int'];
  addressesEnabled: Scalars['Int'];
  blockedBounce: Scalars['Int'];
  blockedOffice: Scalars['Int'];
  blockedSpam: Scalars['Int'];
  blockedTotal: Scalars['Int'];
  blockedUnsub: Scalars['Int'];
  connectionOk: Scalars['Boolean'];
  lastRunAt?: Maybe<Scalars['DateTime']>;
  lastRunDurationMs?: Maybe<Scalars['Int']>;
  lastSyncAt?: Maybe<Scalars['DateTime']>;
  listsEnabled: Scalars['Int'];
  listsExcluded: Scalars['Int'];
  listsFailed: Scalars['Int'];
  listsNever: Scalars['Int'];
  listsOk: Scalars['Int'];
  listsStuck: Scalars['Int'];
  listsTotal: Scalars['Int'];
  locationsEnabled: Scalars['Int'];
  locationsTotal: Scalars['Int'];
  unsubscribedLast7Days: Scalars['Int'];
  unsubscribesImported: Scalars['Boolean'];
  webhookRegistered: Scalars['Boolean'];
};

export type NewsletterRecipientCount = {
  count: Scalars['Int'];
  listId: Scalars['ID'];
  locationId?: Maybe<Scalars['ID']>;
  radiusCount: Scalars['Int'];
};

export type NewsletterRulesInput = {
  assignment?: Maybe<NewsletterAssignment>;
  bookingsSince?: Maybe<Scalars['String']>;
  homeLocationMaxKm?: Maybe<Scalars['Int']>;
  listRule?: Maybe<NewsletterListRule>;
  residenceRadiusKm?: Maybe<Scalars['Int']>;
};

export type NewsletterRulesPreview = {
  addedCount: Scalars['Int'];
  multiListCount: Scalars['Int'];
  otherListRuleCount: Scalars['Int'];
  radiusCount: Scalars['Int'];
  removedCount: Scalars['Int'];
  shrinkingListCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type NewsletterSettings = {
  assignment: NewsletterAssignment;
  bookingsSince?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  defaultErrorEmail?: Maybe<Scalars['String']>;
  errorEmail?: Maybe<Scalars['String']>;
  hasMailjetApiSecret: Scalars['Boolean'];
  homeLocationMaxKm: Scalars['Int'];
  id: Scalars['ID'];
  lastConnectionCheckAt?: Maybe<Scalars['DateTime']>;
  lastConnectionError?: Maybe<Scalars['String']>;
  lastConnectionOk?: Maybe<Scalars['Boolean']>;
  listRule: NewsletterListRule;
  mailjetApiKeyName?: Maybe<Scalars['String']>;
  mailjetApiKeyPublic?: Maybe<Scalars['String']>;
  optOutBlocks: Scalars['Boolean'];
  residenceRadiusKm?: Maybe<Scalars['Int']>;
  rulesChangedAt?: Maybe<Scalars['DateTime']>;
  rulesChangedByName?: Maybe<Scalars['String']>;
  unsubscribesImportedAt?: Maybe<Scalars['DateTime']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  webhookRegisteredAt?: Maybe<Scalars['DateTime']>;
  webhookUrl: Scalars['String'];
};

export type NewsletterSettingsInput = {
  assignment?: Maybe<NewsletterAssignment>;
  bookingsSince?: Maybe<Scalars['String']>;
  errorEmail?: Maybe<Scalars['String']>;
  homeLocationMaxKm?: Maybe<Scalars['Int']>;
  listRule?: Maybe<NewsletterListRule>;
  mailjetApiKeyPublic?: Maybe<Scalars['String']>;
  mailjetApiSecret?: Maybe<Scalars['String']>;
  optOutBlocks?: Maybe<Scalars['Boolean']>;
  residenceRadiusKm?: Maybe<Scalars['Int']>;
};

export type NewsletterUnsubscribe = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  mailjetListId?: Maybe<Scalars['Int']>;
  reactivatedAt?: Maybe<Scalars['DateTime']>;
  source: NewsletterUnsubscribeSource;
  unsubscribedAt: Scalars['DateTime'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type NewsletterUnsubscribeImportResult = {
  found: Scalars['Int'];
  stored: Scalars['Int'];
};

export enum NewsletterUnsubscribeSource {
  MailjetBounce = 'MailjetBounce',
  MailjetSpam = 'MailjetSpam',
  MailjetUnsub = 'MailjetUnsub',
  Office = 'Office'
}

export type NewTemplateInput = {
  footerText?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  mailDataType?: Maybe<MailDataType>;
  name?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  templateType: TemplateType;
};

export type NewVenueInput = {
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  rent: Scalars['Float'];
  rentType: RentType;
};

export type OnlineRegisteredBooker = {
  activeBookingsCount: Scalars['Int'];
  attendees: Array<OnlineRegisteredBookerAttendee>;
  attendeesCount: Scalars['Int'];
  createDate: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
  leadStatus: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
};

export type OnlineRegisteredBookerAttendee = {
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
};

export type OnlineRegisteredBookersResult = {
  items: Array<OnlineRegisteredBooker>;
  total: Scalars['Int'];
};

export type OpenAttendanceSummary = {
  count: Scalars['Float'];
  lessonIds: Array<Scalars['ID']>;
};

export enum Operation {
  Eq = 'EQ',
  Gte = 'GTE',
  In = 'IN',
  Like = 'LIKE',
  Lte = 'LTE'
}

export enum Operator {
  And = 'AND',
  Or = 'OR'
}

export type OptionalInputFieldsInput = {
  checkboxItems?: Maybe<Array<Scalars['JSONObject']>>;
  description?: Maybe<Scalars['String']>;
  enabeld?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  minCheckCount?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Scalars['JSONObject']>>;
  placeholder?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type Page = {
  content: PageContent;
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type PageContent = {
  body: Scalars['String'];
  subPages?: Maybe<Array<Page>>;
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PageContentInput = {
  body: Scalars['String'];
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PageStructure = {
  pages: Array<Page>;
};

export type PaginationInput = {
  limit?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  sortBy?: Maybe<Scalars['String']>;
};

export type ParticipationPrerequisites = {
  courseType: CourseType;
  courseTypeId?: Maybe<Scalars['ID']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  groupDescription?: Maybe<Scalars['String']>;
  groupLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  minCheckCount?: Maybe<Scalars['Float']>;
  optionalInputFields?: Maybe<Array<Scalars['JSONObject']>>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type PasswordlessLoginInputType = {
  email: Scalars['String'];
};

export type PasswordLoginInputType = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type PasswordResetLinkType = {
  changePasswordId: Scalars['String'];
  resetLink: Scalars['String'];
};

export type Payment = {
  amount: Scalars['Float'];
  bankTransactionId?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  molliePaymentId?: Maybe<Scalars['String']>;
  mollieStatus?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
  scheduledPayment?: Maybe<ScheduledPayment>;
  scheduledPaymentId?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  swissQRFile?: Maybe<SwissQrFile>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  valutaDate: Scalars['DateTime'];
};

export type PaymentActionLog = {
  action: Scalars['String'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONObject']>;
  scheduledPaymentId?: Maybe<Scalars['ID']>;
  timestamp: Scalars['DateTime'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type PaymentInput = {
  bookingId: Scalars['ID'];
};

export enum PaymentInterval {
  PerCourse = 'PerCourse',
  PerLesson = 'PerLesson'
}

export type PaymentMethod = {
  bank?: Maybe<Scalars['String']>;
  bankTransfer?: Maybe<Scalars['Boolean']>;
  bic?: Maybe<Scalars['String']>;
  booker?: Maybe<Booker>;
  bookerId?: Maybe<Scalars['ID']>;
  bookings?: Maybe<Array<Booking>>;
  cash?: Maybe<Scalars['Boolean']>;
  createDate: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByUserId?: Maybe<Scalars['String']>;
  creditCardAccountholder?: Maybe<Scalars['String']>;
  creditcardNumber?: Maybe<Scalars['String']>;
  cvc?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  esr?: Maybe<Scalars['Boolean']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  onlinePayment?: Maybe<Scalars['Boolean']>;
  paypalAccountholder?: Maybe<Scalars['String']>;
  scheduledPayments?: Maybe<Array<ScheduledPayment>>;
  sepaAccountholder?: Maybe<Scalars['String']>;
  type?: Maybe<PaymentTransferType>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
};

export enum PaymentProvider {
  Manual = 'Manual',
  Mollie = 'Mollie'
}

export enum PaymentTransferType {
  BankTransfer = 'BankTransfer',
  Cash = 'Cash',
  Creditcard = 'Creditcard',
  Esr = 'Esr',
  None = 'None',
  Online = 'Online',
  Paypal = 'Paypal',
  SepaDebit = 'SepaDebit'
}

export enum PaymentType {
  Bill = 'Bill',
  Custom = 'Custom',
  Monthly = 'Monthly',
  OnTheSpot = 'OnTheSpot',
  PrePaid = 'PrePaid'
}

export type PerformanceStatsOutput = {
  cacheStats: CacheStatsOutput;
  missingIndexCandidates: Array<MissingIndexCandidateOutput>;
  slowQueries: Array<SlowQueryOutput>;
  tableStats: Array<TableStatsOutput>;
};

export type PlatformConfig = {
  allowedMollieMethods: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type PostInputTo = {
  Email: Scalars['String'];
  MessageHref: Scalars['String'];
  MessageID: Scalars['Float'];
  MessageUUID: Scalars['String'];
};

/** Sichtbarkeit des Zielkurses ueber den Freigabe-Link eines Voraussetzungskurses */
export type PrerequisiteLinkVisibility = {
  courseId: Scalars['ID'];
  link: Scalars['String'];
  prefixedCourseNumber?: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
};

export type PricingParams = {
  country?: Maybe<Scalars['String']>;
};

export type Query = {
  accountForEmail?: Maybe<AccountForEmail>;
  accountLinks: AccountLinks;
  activeAnnouncements: Array<Announcement>;
  activeDunning?: Maybe<ActiveDunning>;
  adminManagementEmailStatus: AdminManagementEmailInfo;
  adminManagementOverview: AdminManagementOverview;
  announcement: Announcement;
  announcements: Array<Announcement>;
  attendanceListArchiveInstructors: Array<InstructorCourseGroup>;
  attendanceListArchives: Array<AttendanceListArchive>;
  attendanceListBulkJobStatus: BulkJobStatus;
  attendanceListByCourse: Array<Booking>;
  attendee: Attendee;
  attendeeCount: Scalars['Float'];
  attendeeMergeHistoryByBookerId: Array<AttendeeMergeHistory>;
  attendees: AttendeeWithPagination;
  attendeesByBookerFirstLast: AttendeeWithPagination;
  attendeesByIds: Array<Attendee>;
  authenticate: UserType;
  badge: Badge;
  badgeGroups: Array<BadgeGroup>;
  badges: Array<Badge>;
  bankCollectionRuns: Array<BankCollectionRun>;
  bankImportFiles: Array<BankImportFile>;
  bankTransaction: BankTransaction;
  bankTransactions: BankTransactionsPage;
  bankTransactionsForScheduledPayment: Array<BankTransaction>;
  billingAddressTemplates: Array<BillingAddressTemplate>;
  bookedAttendeesByCourseId: Array<Attendee>;
  bookedSpots: Scalars['Float'];
  booker: Booker;
  bookerByUserId: Booker;
  bookerDeletionProgress?: Maybe<BookerDeletionProgressType>;
  bookerExistsAsAttendeeEndUserApp: Scalars['Boolean'];
  bookerMergeHistoryByBookerId: Array<BookerMergeHistory>;
  bookers: BookerWithPagination;
  bookersById: Array<Booker>;
  bookersDynamic: BookerWithPagination;
  bookersExport: Array<Booker>;
  booking: Array<Booking>;
  bookingById: Booking;
  bookingByIdWithCourseLessonBookings: Booking;
  bookingDunningStatuses: Array<BookingDunningStatus>;
  bookingEligibilityCandidates: Array<BookingEligibilityCandidate>;
  bookingEligibilityDiagnosis: BookingEligibilityDiagnosis;
  bookingHistoryByBookingId: Array<BookingHistory>;
  bookingHistoryByCourseId: Array<BookingHistory>;
  bookingHistoryByIdWithBookingInfo: Array<BookingHistory>;
  bookingHistoryDetailsByBookingIdAndOrganizationId: Array<BookingHistory>;
  bookingHistoryOrphanBookings: Array<BookingHistory>;
  bookingRestrictions: Array<BookingRestriction>;
  bookings: BookingWithPagination;
  bookingsByCourseIdWithCourseLessonBookings: Array<Booking>;
  bookingsByUser: Array<Booking>;
  bookingsDynamic: BookingWithPagination;
  bookingsInStartedCourses: BookingWithPagination;
  bookingsKo9: Array<BookingsKo9>;
  bookingsKo9ByAttendeeId: Array<BookingsKo9>;
  bundesbankBlzImportInfo: BundesbankImportInfo;
  canBecomeInstructor: Scalars['Boolean'];
  certificateIssuePreflight: CertificateIssuePreflightResult;
  certificateTemplate: CertificateTemplate;
  certificateTemplates: Array<CertificateTemplate>;
  checkAttendeesAgeAtCourseStart: AttendeesAgeAtCourseStart;
  checkDiscountCode: DiscountCodeCheckResult;
  checkEmailUniqueness: Scalars['Boolean'];
  checkIfIsBookedIntoCourse: Scalars['Boolean'];
  checkIfTemplateOfTypeExists: Scalars['JSONObject'];
  checkSmsApiKey: SmsBalanceResponse;
  cities: Array<LocationCity>;
  companyCurrencyPublic: Setting;
  companyInfo: KoOrganization;
  companyPublic: CompanySetting;
  companySettings: CompanySetting;
  courseById: Course;
  courseByIdPublic: Course;
  courseByLocationId: Array<Course>;
  courseCategories: Array<CourseCategory>;
  courseCategoriesPublic: Array<CourseType>;
  courseCategoryById: CourseCategory;
  courseDetailsById: CourseDetails;
  courseHasAtLeastOneCourseLessonBooking: Scalars['Boolean'];
  courseHistoryByCourseId: Array<CourseHistory>;
  courseHistoryByCourseIdAndOrganizationId: Array<CourseHistory>;
  courseIsPrerequisiteCourseFor: Array<Course>;
  courseLessonBooking: CourseLessonBooking;
  courseLessonBookingByCourseLessonAndBooking: CourseLessonBooking;
  courseLessonBookingsByBookingId: Array<CourseLessonBooking>;
  courseLessonBookingsByCourse: Array<CourseLessonBooking>;
  courseLessonById: CourseLesson;
  courseLessons: Array<CourseLesson>;
  courseLessonsByCalendarWeek: Array<CourseLesson>;
  courseLessonsByCourseAndInstructor: Array<BillingStatusCoursLessons>;
  courseLessonsByCourseId: Array<CourseLesson>;
  courseLessonsByCourseIdPublic: Array<CourseLesson>;
  courseLessonsByDate: Array<CourseLesson>;
  courseLessonsByInstructorChronological: ChronologicalLessonsResult;
  courseLessonsForBillingStatus: Array<CourseLesson>;
  courseLessonsForBillingStatusByInstructor: Array<BillingStatusByInstructor>;
  courseLessonsForBillingStatusByInstructorGrouped: Array<BillingStatusByInstructorWithCourseGroups>;
  courseLessonsForMonthView: Array<CourseLesson>;
  courseLessonsOfMonthForExport: Array<CourseLesson>;
  courseLessonsOfMonthWithPagination: CourseLessonWithPagination;
  courseLessonsWithCollitions: Array<CourseLessonWithIndexOfCourseLessonInCourse>;
  courseLessonsWithPagination: CourseLessonWithPagination;
  courses: Array<Course>;
  coursesByIds: Array<Course>;
  coursesPublic: Array<Course>;
  coursesWithPagination: CourseWithPagination;
  coursesWithPaginationPublic: CourseWithPagination;
  coursesWithPrerequisiteCourses: CourseWithPagination;
  courseTypeById: CourseType;
  courseTypes: Array<CourseType>;
  courseTypesPublic: Array<CourseType>;
  courseTypeStateById: CourseType;
  courseTypesWithPagination: CourseTypeWithPagination;
  creditEntriesByBookerId: Array<CreditEntry>;
  currentUser: UserType;
  customBankData?: Maybe<CustomBankData>;
  customBankDataList: Array<CustomBankData>;
  customerById: Customer;
  customerTimeline: Array<CustomerTimelineEntry>;
  customHolidaysByCompany: Array<Holiday>;
  defaultInvoiceTemplateSet: InvoiceTemplateSet;
  detectBundleConflictsFromAdmin: Array<Scalars['ID']>;
  discountCode: DiscountCode;
  discountCodes: Array<DiscountCode>;
  downloadCertificate: Scalars['String'];
  dunningPause: DunningPause;
  dunningPdf: Scalars['String'];
  dunningProposal: DunningProposal;
  dunningsByBooking: Array<Dunning>;
  emailNotificationById: EmailNotification;
  emailNotifications: EmailNotificationWithPagination;
  emailRegistrationStatusForEndUserApp: EndUserEmailRegistrationStatus;
  exportedSepaXml: ExportedSepaXml;
  exportedSepaXmls: ExportedSepaXmlWithPagination;
  faUserByEmail: FaUser;
  faUserByUserId?: Maybe<FaUser>;
  feeLetterPdf: Scalars['String'];
  feeLetterProposal: FeeLetterProposal;
  feeLettersByBooking: Array<FeeLetter>;
  findByCourseId: Instructor;
  findInstructorById: Instructor;
  findInstructorByIds: Array<Instructor>;
  findInstructorsByLocation: Array<Instructor>;
  findSimilarBookers: Array<SimilarBookerResult>;
  findUnpaidScheduledPaymentsInSepaExports: UnpaidScheduledPaymentMatchResult;
  getAdminAndInstructorUsers: Array<UserType>;
  getAllBookingsByAttendeeIdAndCourseId: Array<CourseLessonBooking>;
  getAllCoursesWithAllowMonthlyPayment: Array<Course>;
  getAnalyticsByDate: Array<Sms77AnalyticGroupByDate>;
  getAreaIssuesForAreaManagerApp: Array<AreaIssue>;
  getAreaManagerAssistantHierarchy: AreaManagerAssistantHierarchyResult;
  getAreaManagerAssistantLessonsByCourse: Array<AreaManagerAssistantOverview>;
  getAreaManagerAssistantOverview: AreaManagerAssistantOverviewResult;
  getAreaManagerCourses: AreaManagerCourseStatsResult;
  getAreaManagerInstructorStats: AreaManagerInstructorStatsResult;
  getAreaManagerLocations: Array<Location>;
  getAreaManagerLocationsByStaffId: Array<Location>;
  getAreaManagerLocationStats: AreaManagerLocationStatsResult;
  getAreaManagerUpcomingLessons: Array<AreaManagerUpcomingLesson>;
  getAreaManagerVenueUtilization: AreaManagerVenueUtilizationResult;
  getAreaOverviewForAreaManagerApp: AreaOverviewResult;
  getAreaPeopleForAreaManagerApp: Array<AreaPerson>;
  getAssistantAssignedLocations: Array<Location>;
  getAttendanceListSettings: UserSetting;
  getAttendeeBadge: AttendeeBadge;
  getAttendeeBadges: Array<AttendeeBadge>;
  getAttendeeBadgesByAttendeeId: Array<AttendeeBadge>;
  getAttendeeBadgesByBadgeId: Array<AttendeeBadge>;
  getAttendeeInfosForBooking: Attendee;
  getAttendeesWithByStandardPaymentMethod: AttendeeWithPagination;
  getAutoMergeStatus?: Maybe<AutoMergeStatus>;
  getAvailablePaymentMethodsFromEndUserApp: Array<MollieMethodInfo>;
  getBankData: Scalars['JSONObject'];
  getBilledBookings: Array<Booking>;
  getBookerAndAttendeeCount: BookerAttendeeCount;
  getBookerByEmail?: Maybe<Booker>;
  getBookerIdMissmatchesWithPagination: BookerIdMissmatchWithPagination;
  getBookersByBookingIds: Array<Booker>;
  getBookersByCourseIds: Array<Booker>;
  getBookersByCourseWithBookingType: Array<Booker>;
  getBookingRestrictionByCourseId?: Maybe<BookingRestriction>;
  getBookingsAsCsv: Scalars['String'];
  getBookingsByAttendeeId: Array<Booking>;
  getBookingsByAttendeeIdWithOptions: Array<Booking>;
  getBookingsByCourse: BookingWithPagination;
  getBookingsByCourseAndAttendee: Booking;
  getBookingsByCourseIds: BookingWithPagination;
  getBookingsByIds: Array<Booking>;
  getBookingsByInvoiceIds: Array<Booking>;
  getBookingsByScheduledPaymentIds: Array<Booking>;
  getCacheStats: CacheStatsOutput;
  getCanceledBookings: BookingWithPagination;
  getChargebackCount: Scalars['Int'];
  getChargebacks: Array<MolliePaymentAttempt>;
  getChargebackSummary: ChargebackSummary;
  getColumnsForTable: Array<Scalars['String']>;
  getContentByPathDo: ContentOfBucket;
  getContentOfBucketDo: ContentOfBucket;
  getContentOfFolderDo: ContentOfBucket;
  getCourseInfosForBooking: Course;
  getCourseLessonBookingsByBookingId: Array<CourseLessonBooking>;
  getCourseLessonsForAssistantApp: Array<AssistantCourseLesson>;
  getCourseMinMaxAge: Scalars['JSONObject'];
  getCoursesWithHighDemand: CourseWithPagination;
  getCourseVisibility: CourseVisibilityResult;
  getDatabaseBackupDownloadUrl: Scalars['String'];
  getDataExportDownloadUrl: Scalars['String'];
  getDuplicateBookerGroups: Array<DuplicateGroupWithMetadata>;
  getDuplicateBookers: Array<Array<Booker>>;
  getDuplicateDetectionStatus?: Maybe<DuplicateDetectionRun>;
  getDuplicateExceptions: Array<DuplicateException>;
  getDuplicateMatchStats: DuplicateMatchStats;
  getEmailTemplateById: MjmlTemplate;
  getFileDo: Content;
  getInfoUserByUserId: UserType;
  getInstallmentPlanPreview: Scalars['JSONObject'];
  getInvoiceDummyPreview: Scalars['JSONObject'];
  getInvoiceExportDownloadUrl: Scalars['String'];
  getInvoicePreview: Scalars['JSONObject'];
  getLastCustomer: Customer;
  getLessonsThatAreNotDeletable: Array<Scalars['String']>;
  getMailjetSenderById: MailjetSenderResponse;
  getMailjetSenders: MailjetSenderResponse;
  getMissingIndexCandidates: Array<MissingIndexCandidateOutput>;
  getMollieKpis: MollieKpis;
  getMolliePayments: MolliePaymentsPage;
  getMolliePaymentTabCounts: MolliePaymentTabCounts;
  getMollieRetryQueueEntries: Array<MollieRetryQueueEntry>;
  getMonthlyPaymentPreview: Scalars['JSONObject'];
  getMyAssignmentsAssistantApp: Array<AssistantCourseLesson>;
  getOnlineBookingsByTimeRangeCount: Scalars['Float'];
  getOnlineBookingsByTimeRangeSeries: Array<Scalars['Float']>;
  getOnlineRegisteredBookers: OnlineRegisteredBookersResult;
  getOpenAttendanceSummaryForStaffApp: OpenAttendanceSummary;
  getPages: PageStructure;
  getPasswordlessLoginSettings: Scalars['JSONObject'];
  getPaymentActionLogs: Array<PaymentActionLog>;
  getPaymentMethodsByBookerId: Array<PaymentMethod>;
  getPaymentMethodTypeById: Scalars['String'];
  getPerformanceStats: PerformanceStatsOutput;
  getReferenceCoursesLink: Scalars['String'];
  getSelectableLocationsForAssistantApp: Array<AssistantSelectableLocation>;
  getSentSmsMessages: Array<Sms77JournalOutbound>;
  getSettledBookings: BookingWithPagination;
  getSignedUrlDo: Scalars['String'];
  getSlowQueries: Array<SlowQueryOutput>;
  getSmsAccountBalance: SmsBalanceResponse;
  getSmsPricing: Sms77PricingResponse;
  getSmsPricingByCountryCode: Sms77PricingResponse;
  getSmsReceivers: Array<SmsReceiver>;
  getSmsReceiversCourse: Array<SmsReceiver>;
  getTableStats: Array<TableStatsOutput>;
  getTenantUsers: Array<UserType>;
  getUnBilledBookings: Array<Booking>;
  getUnSettledBookings: BookingWithPagination;
  getUpcomingCoursesByTimeRange: CourseWithPagination;
  getUpcomingCoursesOccupancy: UpcomingCoursesOccupancy;
  getUserDetails: UserDetailsType;
  getUserRoles: Scalars['JSONObject'];
  getWaitlistByCourse: BookingWithPagination;
  getWaitlistCountOfCourse: Scalars['Float'];
  getYearEndExportDownloadUrl: Scalars['String'];
  holidays: Array<Holiday>;
  holidaysByCompany: Array<HolidayWithDays>;
  holidaysByCompanyAndDateRange: Array<HolidayWithDays>;
  holidaysByStateCode: Array<HolidayWithDays>;
  installmentRate: InstallmentRate;
  installmentRates: Array<InstallmentRate>;
  installmentRatesByCourseId: Array<InstallmentRate>;
  instructor: Instructor;
  instructorInvoiceById?: Maybe<InstructorInvoice>;
  instructorInvoices: Array<InstructorInvoice>;
  instructorInvoicesByInstructorAndDateRange: Array<InstructorInvoice>;
  instructors: Array<Instructor>;
  instructorsByStaffIds: Array<Instructor>;
  instructorsPublic: Array<Instructor>;
  instructorsWithPagination: InstructorsWithPagination;
  interestListById: InterestList;
  interestLists: Array<InterestList>;
  interestListsPublic: Array<InterestList>;
  interestRegistrations: InterestRegistrationWithPagination;
  interestRegistrationsByAttendeeAndCourseType: Array<InterestRegistration>;
  invoice: Invoice;
  invoiceBodyByBookingId: Invoice;
  invoiceBodyById: Invoice;
  invoiceExportCourses: Array<Course>;
  invoices: InvoiceWithPagination;
  invoiceTemplateSet: InvoiceTemplateSet;
  invoiceTemplateSets: Array<InvoiceTemplateSet>;
  isBadgeNameUnique: Scalars['Boolean'];
  isCourseNameUnique: Scalars['Boolean'];
  isCustomBankCodeUnique: Scalars['Boolean'];
  isInstructor: Scalars['Boolean'];
  issuedCertificates: Array<IssuedCertificate>;
  issuedCertificatesByAttendee: Array<IssuedCertificate>;
  issuedCertificatesByCourse: Array<IssuedCertificate>;
  isUniqueEmail: Scalars['Boolean'];
  isUserEmailVerified: Scalars['Boolean'];
  ko9ImportProgress?: Maybe<Ko9ImportProgressType>;
  ko9LoadCredentials?: Maybe<Ko9LoadedCredentials>;
  koOrganizations: Array<KoOrganization>;
  lateEntryPricingConfiguration: SettingEndUserApp;
  lateEntryPricingConfigurationPublic: SettingEndUserApp;
  lessonBookingPlannerPreview: LessonBookingPlannerPreview;
  lessonBookingPlanSummary: Array<LessonBookingPlanSummary>;
  listBucketsDO: Scalars['JSONObject'];
  listDatabaseBackups: Array<DatabaseBackup>;
  listDataExports: Array<DataExport>;
  listInvoiceExports: Array<InvoiceExport>;
  listYearEndExports: Array<YearEndExport>;
  LocalState: LocalState;
  locationById: Location;
  locationContactById: LocationContact;
  locationContacts: Array<LocationContact>;
  locationContactsByLocation: Array<LocationContact>;
  locations: Array<Location>;
  locationsByCity: Array<Location>;
  locationsByLocationContactId: Array<Location>;
  locationsPublic: Array<Location>;
  locationsSortedByCity: Array<LocationsGroupedByCity>;
  locationsWithPagination: LocationsWithPagination;
  maintenanceStatus: MaintenanceStatus;
  missingBankDataList: Array<MissingBankData>;
  mollieAllMethodsForWhitelist: Array<MollieMethodInfo>;
  mollieAvailableMethods: Array<MollieMethodInfo>;
  mollieConnectionStatus: MollieConnectionStatus;
  mollieDowngradeImpact: MollieDowngradeImpact;
  molliePaymentStatus?: Maybe<MolliePaymentStatus>;
  molliePaymentStatusFromEndUserApp?: Maybe<MolliePaymentStatus>;
  molliePaymentStatusFromEndUserAppPublic?: Maybe<MolliePaymentStatusPublic>;
  mollieRefunds: MollieRefundsWithPagination;
  multipleCourseLessonsCollisionCheck: Array<CourseLessonWithIndexOfCourseLessonInCourse>;
  myProfile: MyProfileType;
  newsletterBookerStatus: NewsletterBookerStatus;
  newsletterLocationLists: Array<NewsletterLocationList>;
  newsletterLog: Array<NewsletterLog>;
  newsletterOverview: NewsletterOverviewResult;
  newsletterRecipientCounts: Array<NewsletterRecipientCount>;
  newsletterRulesPreview: NewsletterRulesPreview;
  newsletterSettings: NewsletterSettings;
  notificationsByBookerId: EmailNotificationWithPagination;
  notificationsByBookerOrEmail: EmailNotificationWithPagination;
  notificationsByBooking: Array<EmailNotification>;
  ownerEmail: CompanySetting;
  paidScheduledPayments: ScheduledPaymentsWithPagination;
  participationPrerequisite: ParticipationPrerequisites;
  participationPrerequisites: Array<ParticipationPrerequisites>;
  participationPrerequisitesByCourseTypeId: Array<ParticipationPrerequisites>;
  paymentMethod: PaymentMethod;
  paymentMethods: Array<PaymentMethod>;
  payments: Array<Payment>;
  platformConfig: PlatformConfig;
  prerequisiteCourses: CourseWithPagination;
  previewCertificatePdf: Scalars['String'];
  previewSettledBookingCorrection: SettledBookingCorrectionPreview;
  renderBatchTemplateForBookingsLetterPdf: RenderedBatchLetterPdfData;
  renderBatchTemplateForCourseLetterPdf: RenderedBatchLetterPdfData;
  renderTemplateForLetterPdf: RenderedLetterPdfData;
  renderTextBlockPreview: TextBlockPreviewResult;
  resolveTenantRecipients: Array<TenantRecipientType>;
  reversalInvoiceBodyById: ReversalInvoice;
  reversalInvoices: ReversalInvoiceWithPagination;
  scheduledPayment: Array<ScheduledPayment>;
  scheduledPaymentById: ScheduledPayment;
  scheduledPayments: ScheduledPaymentsWithPagination;
  scheduledPaymentsByBookerId: Array<ScheduledPayment>;
  scheduledPaymentsByBookingId: Array<ScheduledPayment>;
  scheduledPaymentSummary: ScheduledPaymentSummary;
  scheduledPaymentsWithMissingInvoiceIds: Array<ScheduledPayment>;
  searchAttendeesByFullName: Array<Attendee>;
  searchBankTransactionCandidates: Array<BankTransactionCandidate>;
  searchBilledPayments: Array<PaymentMethod>;
  searchBookerByStreetAndHouseNumberAndPpostCodeAndCity: Array<Booker>;
  searchBookersByFirstAndLastName: Array<Booker>;
  searchBookersByStreetAndHouseNumberAndPostCodeAndCity: Array<Booker>;
  searchBookingByBookingNumberAndBookingNumberPrefix: Array<Booking>;
  searchBookingByCourseLocationPrefixAndCourseNumber: Array<Booking>;
  searchCourseByCourseLocationPrefixAndCourseNumber: Array<Course>;
  searchCourseByInstructorFirstNameAndLastName: Array<Course>;
  searchCourseHistory: CourseHistoryWithPagination;
  searchCustomerByCustomerNumberPrefixAndCustomerNumber: Array<Customer>;
  searchCustomerByFirstNameAndLastName: Array<Customer>;
  searchInvoicesByCourseNumber: Array<Invoice>;
  searchInvoicesByInvoiceNumberAndInvoiceNumberPrefix: Array<Invoice>;
  searchLocationsByName: Array<Location>;
  searchLocationsByPhoneNumberAndEmail: Array<Location>;
  searchStaffByFullnameAndAddress: Array<Staff>;
  searchUnBilledPayments: Array<PaymentMethod>;
  searchUnSettledBooking: Array<Booking>;
  sentEmailStatusFromMailjet: Scalars['JSONObject'];
  settingEndUserApp: SettingEndUserApp;
  settingEndUserAppHistory: Array<SettingEndUserAppHistory>;
  settingEndUserAppPublic: SettingEndUserApp;
  settings: Setting;
  staffSharingLogin: Array<SharedLoginStaff>;
  staffVisibilityRules: StaffVisibilityRules;
  staffVisibilityRulesHistory: Array<StaffVisibilityRulesHistoryEntry>;
  stressTestUserQuery: Array<UserType>;
  superuserDocs: Scalars['String'];
  superuserDocsIndex: Array<Scalars['String']>;
  swissQRFileById?: Maybe<SwissQrFile>;
  swissQRFiles: Array<SwissQrFile>;
  swissQRFilesOverview: SwissQrFileOverviewWithPagination;
  swissQRRecordContext: SwissQrRecordContext;
  template: Template;
  templateByType: Template;
  templates: Array<Template>;
  templatesWithPagination: TemplatesWithPagination;
  tenantActivitySummaries: Array<TenantActivitySummary>;
  tenantActivitySummary: TenantActivitySummary;
  tenantChangeVersion: Scalars['Int'];
  tenantDeletionImpact: TenantDeletionImpact;
  tenantDeletionStatus: TenantDeletionStatus;
  tenantMetrics: Array<TenantMetrics>;
  tenantMetricsAiSummary: TenantMetricsAiSummary;
  tenantNotifications: Array<TenantNotification>;
  tenantSeatUsage: Array<TenantSeatUsage>;
  tenantStaffMetrics: Array<TenantStaffMember>;
  tenantsWithPagination: KoOrganizationWithPagination;
  testFusioAuthFunctions: Scalars['JSONObject'];
  transferBulkPlanPreview: TransferBulkPlanPreview;
  transferPlanPreview: TransferPlanPreview;
  unpaidScheduledPayments: ScheduledPaymentsWithPagination;
  unpaidScheduledPaymentsZeroValues: Array<ScheduledPayment>;
  userSettings?: Maybe<UserSetting>;
  withdrawals: Array<WithdrawalRequest>;
};


export type QueryAccountForEmailArgs = {
  email: Scalars['String'];
  excludeBookerId?: Maybe<Scalars['String']>;
};


export type QueryAccountLinksArgs = {
  userId: Scalars['String'];
};


export type QueryActiveDunningArgs = {
  bookingId: Scalars['ID'];
};


export type QueryAdminManagementEmailStatusArgs = {
  email: Scalars['String'];
};


export type QueryAnnouncementArgs = {
  id: Scalars['String'];
};


export type QueryAnnouncementsArgs = {
  input?: Maybe<GetAnnouncementsInput>;
};


export type QueryAttendanceListArchiveInstructorsArgs = {
  jobGroupId: Scalars['ID'];
};


export type QueryAttendanceListBulkJobStatusArgs = {
  jobGroupId: Scalars['ID'];
};


export type QueryAttendanceListByCourseArgs = {
  courseId: Scalars['String'];
};


export type QueryAttendeeArgs = {
  id: Scalars['String'];
};


export type QueryAttendeeCountArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryAttendeeMergeHistoryByBookerIdArgs = {
  bookerId: Scalars['String'];
};


export type QueryAttendeesArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryAttendeesByBookerFirstLastArgs = {
  searchKey: Scalars['String'];
};


export type QueryAttendeesByIdsArgs = {
  attendeeIds: Array<Scalars['ID']>;
};


export type QueryBadgeArgs = {
  id: Scalars['String'];
};


export type QueryBankTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryBankTransactionsArgs = {
  filter?: Maybe<BankTransactionsFilterInput>;
};


export type QueryBankTransactionsForScheduledPaymentArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type QueryBookedAttendeesByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type QueryBookedSpotsArgs = {
  courseId: Scalars['String'];
};


export type QueryBookerArgs = {
  id: Scalars['String'];
};


export type QueryBookerByUserIdArgs = {
  id: Scalars['String'];
};


export type QueryBookerExistsAsAttendeeEndUserAppArgs = {
  bookerId: Scalars['ID'];
};


export type QueryBookerMergeHistoryByBookerIdArgs = {
  bookerId: Scalars['String'];
};


export type QueryBookersArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryBookersByIdArgs = {
  bookerIds: Array<Scalars['String']>;
};


export type QueryBookersDynamicArgs = {
  includeAttendees?: Maybe<Scalars['Boolean']>;
  includePayment?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryBookersExportArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryBookingArgs = {
  id: Scalars['String'];
};


export type QueryBookingByIdArgs = {
  id: Scalars['ID'];
};


export type QueryBookingByIdWithCourseLessonBookingsArgs = {
  id: Scalars['ID'];
};


export type QueryBookingDunningStatusesArgs = {
  bookingIds: Array<Scalars['ID']>;
};


export type QueryBookingEligibilityCandidatesArgs = {
  attendeeId: Scalars['ID'];
};


export type QueryBookingEligibilityDiagnosisArgs = {
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
};


export type QueryBookingHistoryByBookingIdArgs = {
  bookingId: Scalars['String'];
};


export type QueryBookingHistoryByCourseIdArgs = {
  courseId: Scalars['String'];
};


export type QueryBookingHistoryByIdWithBookingInfoArgs = {
  bookingId: Scalars['String'];
};


export type QueryBookingHistoryDetailsByBookingIdAndOrganizationIdArgs = {
  bookingId: Scalars['String'];
  koOrganizationId: Scalars['String'];
};


export type QueryBookingHistoryOrphanBookingsArgs = {
  koOrganizationId: Scalars['String'];
};


export type QueryBookingsArgs = {
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryBookingsByCourseIdWithCourseLessonBookingsArgs = {
  courseId: Scalars['ID'];
};


export type QueryBookingsByUserArgs = {
  userId: Scalars['String'];
};


export type QueryBookingsDynamicArgs = {
  includeAttendee?: Maybe<Scalars['Boolean']>;
  includeCourseLessons?: Maybe<Scalars['Boolean']>;
  includeCoursePrice?: Maybe<Scalars['Boolean']>;
  includeEmailNotifications?: Maybe<Scalars['Boolean']>;
  includeInvoice?: Maybe<Scalars['Boolean']>;
  includePaymentMethod?: Maybe<Scalars['Boolean']>;
  includeReversalInvoice?: Maybe<Scalars['Boolean']>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryBookingsInStartedCoursesArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryBookingsKo9ByAttendeeIdArgs = {
  attendeeId: Scalars['String'];
};


export type QueryCanBecomeInstructorArgs = {
  email: Scalars['String'];
};


export type QueryCertificateIssuePreflightArgs = {
  input: CertificateIssuePreflightInput;
};


export type QueryCertificateTemplateArgs = {
  id: Scalars['String'];
};


export type QueryCheckAttendeesAgeAtCourseStartArgs = {
  attendeeId: Scalars['String'];
  courseId: Scalars['String'];
};


export type QueryCheckDiscountCodeArgs = {
  code: Scalars['String'];
  courseId: Scalars['ID'];
};


export type QueryCheckEmailUniquenessArgs = {
  email: Scalars['String'];
};


export type QueryCheckIfIsBookedIntoCourseArgs = {
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
};


export type QueryCheckIfTemplateOfTypeExistsArgs = {
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
  templateType: TemplateType;
};


export type QueryCheckSmsApiKeyArgs = {
  apiKey: Scalars['String'];
};


export type QueryCourseByIdArgs = {
  id: Scalars['String'];
};


export type QueryCourseByIdPublicArgs = {
  id: Scalars['String'];
};


export type QueryCourseByLocationIdArgs = {
  id: Scalars['ID'];
};


export type QueryCourseCategoryByIdArgs = {
  id: Scalars['String'];
};


export type QueryCourseDetailsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCourseHasAtLeastOneCourseLessonBookingArgs = {
  courseId: Scalars['String'];
};


export type QueryCourseHistoryByCourseIdArgs = {
  courseId: Scalars['String'];
};


export type QueryCourseHistoryByCourseIdAndOrganizationIdArgs = {
  courseId: Scalars['String'];
  koOrganizationId: Scalars['String'];
};


export type QueryCourseIsPrerequisiteCourseForArgs = {
  courseId: Scalars['ID'];
};


export type QueryCourseLessonBookingArgs = {
  id: Scalars['String'];
};


export type QueryCourseLessonBookingByCourseLessonAndBookingArgs = {
  bookingId: Scalars['String'];
  courseLessonId: Scalars['String'];
};


export type QueryCourseLessonBookingsByBookingIdArgs = {
  bookingId: Scalars['String'];
};


export type QueryCourseLessonBookingsByCourseArgs = {
  courseId: Scalars['String'];
};


export type QueryCourseLessonByIdArgs = {
  id: Scalars['String'];
};


export type QueryCourseLessonsArgs = {
  ids?: Maybe<Array<Scalars['String']>>;
};


export type QueryCourseLessonsByCalendarWeekArgs = {
  calendarWeek: Scalars['Float'];
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
  year: Scalars['Float'];
};


export type QueryCourseLessonsByCourseAndInstructorArgs = {
  courseId: Scalars['ID'];
  instructorId: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCourseLessonsByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type QueryCourseLessonsByCourseIdPublicArgs = {
  courseId: Scalars['ID'];
};


export type QueryCourseLessonsByDateArgs = {
  date: Scalars['DateTime'];
};


export type QueryCourseLessonsByInstructorChronologicalArgs = {
  instructorId: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCourseLessonsForBillingStatusArgs = {
  courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
};


export type QueryCourseLessonsForBillingStatusByInstructorArgs = {
  courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
};


export type QueryCourseLessonsForBillingStatusByInstructorGroupedArgs = {
  courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
};


export type QueryCourseLessonsForMonthViewArgs = {
  month: Scalars['Float'];
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
  year: Scalars['Float'];
};


export type QueryCourseLessonsOfMonthForExportArgs = {
  date: Scalars['DateTime'];
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCourseLessonsOfMonthWithPaginationArgs = {
  date: Scalars['DateTime'];
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCourseLessonsWithCollitionsArgs = {
  collitionCheckInput: CollitionCheckInput;
};


export type QueryCourseLessonsWithPaginationArgs = {
  date?: Maybe<Scalars['DateTime']>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCoursesArgs = {
  filterExpression?: Maybe<FilterExpressionInput>;
  ids?: Maybe<Array<Scalars['String']>>;
};


export type QueryCoursesByIdsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryCoursesPublicArgs = {
  courseCategoryId?: Maybe<Scalars['ID']>;
  dayFilter?: Maybe<Array<DayFilter>>;
  filterExpression?: Maybe<FilterExpressionInput>;
  ids?: Maybe<Array<Scalars['String']>>;
  instructorId?: Maybe<Scalars['ID']>;
  showOnlyInWebActive?: Maybe<Scalars['Boolean']>;
};


export type QueryCoursesWithPaginationArgs = {
  currentUserOnly?: Maybe<Scalars['Boolean']>;
  excludedCourseIds?: Maybe<Array<Scalars['String']>>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCoursesWithPaginationPublicArgs = {
  filterExpression?: Maybe<FilterExpressionInput>;
  filters?: Maybe<CourseListFilters>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCoursesWithPrerequisiteCoursesArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCourseTypeByIdArgs = {
  id: Scalars['String'];
};


export type QueryCourseTypeStateByIdArgs = {
  id: Scalars['String'];
};


export type QueryCourseTypesWithPaginationArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryCreditEntriesByBookerIdArgs = {
  bookerId: Scalars['ID'];
};


export type QueryCustomBankDataArgs = {
  id: Scalars['String'];
};


export type QueryCustomerByIdArgs = {
  id: Scalars['String'];
};


export type QueryCustomerTimelineArgs = {
  bookerId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  since?: Maybe<Scalars['DateTime']>;
};


export type QueryDetectBundleConflictsFromAdminArgs = {
  bookingId: Scalars['ID'];
};


export type QueryDiscountCodeArgs = {
  id: Scalars['ID'];
};


export type QueryDownloadCertificateArgs = {
  issuedCertificateId: Scalars['String'];
};


export type QueryDunningPauseArgs = {
  bookingId: Scalars['ID'];
};


export type QueryDunningPdfArgs = {
  id: Scalars['ID'];
};


export type QueryDunningProposalArgs = {
  bookingId: Scalars['ID'];
  level?: Maybe<DunningLevel>;
};


export type QueryDunningsByBookingArgs = {
  bookingId: Scalars['ID'];
};


export type QueryEmailNotificationByIdArgs = {
  id: Scalars['String'];
};


export type QueryEmailNotificationsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryEmailRegistrationStatusForEndUserAppArgs = {
  email: Scalars['String'];
};


export type QueryExportedSepaXmlArgs = {
  id: Scalars['String'];
};


export type QueryExportedSepaXmlsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryFaUserByEmailArgs = {
  email: Scalars['String'];
};


export type QueryFaUserByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryFeeLetterPdfArgs = {
  id: Scalars['ID'];
};


export type QueryFeeLetterProposalArgs = {
  bookingId: Scalars['ID'];
};


export type QueryFeeLettersByBookingArgs = {
  bookingId: Scalars['ID'];
};


export type QueryFindByCourseIdArgs = {
  id: Scalars['String'];
};


export type QueryFindInstructorByIdArgs = {
  instructorId: Scalars['String'];
};


export type QueryFindInstructorByIdsArgs = {
  instructorIds: Array<Scalars['ID']>;
};


export type QueryFindInstructorsByLocationArgs = {
  locationId: Scalars['String'];
};


export type QueryFindSimilarBookersArgs = {
  email?: Maybe<Scalars['String']>;
  excludeBookerId?: Maybe<Scalars['ID']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};


export type QueryFindUnpaidScheduledPaymentsInSepaExportsArgs = {
  input: FindUnpaidInSepaInput;
};


export type QueryGetAdminAndInstructorUsersArgs = {
  koOrganizationId: Scalars['String'];
};


export type QueryGetAllBookingsByAttendeeIdAndCourseIdArgs = {
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
};


export type QueryGetAnalyticsByDateArgs = {
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};


export type QueryGetAreaManagerAssistantLessonsByCourseArgs = {
  input: AreaManagerAssistantLessonsInput;
};


export type QueryGetAreaManagerAssistantOverviewArgs = {
  input?: Maybe<AreaManagerStatsInput>;
};


export type QueryGetAreaManagerCoursesArgs = {
  input?: Maybe<AreaManagerStatsInput>;
};


export type QueryGetAreaManagerInstructorStatsArgs = {
  input?: Maybe<AreaManagerStatsInput>;
};


export type QueryGetAreaManagerLocationsByStaffIdArgs = {
  staffId: Scalars['String'];
};


export type QueryGetAreaManagerLocationStatsArgs = {
  input?: Maybe<AreaManagerStatsInput>;
};


export type QueryGetAreaManagerUpcomingLessonsArgs = {
  input?: Maybe<AreaManagerStatsInput>;
};


export type QueryGetAreaManagerVenueUtilizationArgs = {
  input?: Maybe<AreaManagerStatsInput>;
};


export type QueryGetAttendeeBadgeArgs = {
  id: Scalars['String'];
};


export type QueryGetAttendeeBadgesByAttendeeIdArgs = {
  attendeeId: Scalars['String'];
};


export type QueryGetAttendeeBadgesByBadgeIdArgs = {
  badgeId: Scalars['String'];
};


export type QueryGetAttendeeInfosForBookingArgs = {
  attendeeId: Scalars['ID'];
};


export type QueryGetAttendeesWithByStandardPaymentMethodArgs = {
  koOrganizationId: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
  paymentTransferType: PaymentTransferType;
  targetPaymentTransferType: PaymentTransferType;
};


export type QueryGetAvailablePaymentMethodsFromEndUserAppArgs = {
  courseId?: Maybe<Scalars['ID']>;
};


export type QueryGetBankDataArgs = {
  iban: Scalars['String'];
};


export type QueryGetBilledBookingsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type QueryGetBookerByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetBookerIdMissmatchesWithPaginationArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetBookersByBookingIdsArgs = {
  bookingIds: Array<Scalars['String']>;
};


export type QueryGetBookersByCourseIdsArgs = {
  courseIds: Array<Scalars['String']>;
};


export type QueryGetBookersByCourseWithBookingTypeArgs = {
  courseId: Scalars['String'];
};


export type QueryGetBookingRestrictionByCourseIdArgs = {
  courseId: Scalars['String'];
};


export type QueryGetBookingsAsCsvArgs = {
  bookingIds: Array<Scalars['String']>;
  filterFields: Array<Scalars['String']>;
};


export type QueryGetBookingsByAttendeeIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetBookingsByAttendeeIdWithOptionsArgs = {
  canceledBookings?: Maybe<Scalars['Boolean']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  startDateTime?: Maybe<Scalars['DateTime']>;
};


export type QueryGetBookingsByCourseArgs = {
  id: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetBookingsByCourseAndAttendeeArgs = {
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
};


export type QueryGetBookingsByCourseIdsArgs = {
  ids: Array<Scalars['ID']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetBookingsByIdsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryGetBookingsByInvoiceIdsArgs = {
  invoiceIds: Array<Scalars['String']>;
};


export type QueryGetBookingsByScheduledPaymentIdsArgs = {
  scheduledPaymentIds: Array<Scalars['String']>;
};


export type QueryGetCanceledBookingsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetChargebackCountArgs = {
  filter: ChargebackFilterInput;
};


export type QueryGetChargebacksArgs = {
  filter: ChargebackFilterInput;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetColumnsForTableArgs = {
  table: TablesEnum;
};


export type QueryGetContentByPathDoArgs = {
  options?: Maybe<ArrayDataOptions>;
  path: Scalars['String'];
};


export type QueryGetContentOfFolderDoArgs = {
  folderName?: Maybe<Scalars['String']>;
};


export type QueryGetCourseInfosForBookingArgs = {
  courseId: Scalars['ID'];
};


export type QueryGetCourseLessonBookingsByBookingIdArgs = {
  bookingId: Scalars['ID'];
};


export type QueryGetCourseLessonsForAssistantAppArgs = {
  filters?: Maybe<AssistantCourseLessonFilterInput>;
};


export type QueryGetCourseMinMaxAgeArgs = {
  courseId: Scalars['String'];
};


export type QueryGetCoursesWithHighDemandArgs = {
  onlyUpcoming?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetCourseVisibilityArgs = {
  courseId: Scalars['String'];
};


export type QueryGetDatabaseBackupDownloadUrlArgs = {
  input: DownloadBackupInput;
};


export type QueryGetDataExportDownloadUrlArgs = {
  exportId: Scalars['ID'];
};


export type QueryGetDuplicateBookerGroupsArgs = {
  limit?: Maybe<Scalars['Float']>;
};


export type QueryGetDuplicateBookersArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetEmailTemplateByIdArgs = {
  templateId: Scalars['String'];
};


export type QueryGetFileDoArgs = {
  fileName: Scalars['String'];
};


export type QueryGetInfoUserByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryGetInstallmentPlanPreviewArgs = {
  newInstallmentPlanInput: NewInstallmentPlanInput;
};


export type QueryGetInvoiceDummyPreviewArgs = {
  editTemplateInput?: Maybe<EditTemplateInput>;
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  paymentType?: Maybe<PaymentType>;
  reversal?: Maybe<Scalars['Boolean']>;
};


export type QueryGetInvoiceExportDownloadUrlArgs = {
  exportId: Scalars['ID'];
};


export type QueryGetInvoicePreviewArgs = {
  invoiceId: Scalars['String'];
};


export type QueryGetLessonsThatAreNotDeletableArgs = {
  courseLessonIds: Array<Scalars['ID']>;
};


export type QueryGetMailjetSenderByIdArgs = {
  mailjetSenderId: Scalars['Float'];
};


export type QueryGetMailjetSendersArgs = {
  queryParameters?: Maybe<MailjetSenderQueryParams>;
};


export type QueryGetMolliePaymentsArgs = {
  filter: MolliePaymentFilterInput;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetMolliePaymentTabCountsArgs = {
  filter: MolliePaymentFilterInput;
};


export type QueryGetMonthlyPaymentPreviewArgs = {
  monthlyPaymentPreviewOptions: ScheduledPaymentPreviewInput;
};


export type QueryGetMyAssignmentsAssistantAppArgs = {
  includePast?: Maybe<Scalars['Boolean']>;
};


export type QueryGetOnlineBookingsByTimeRangeCountArgs = {
  endDateTime?: Maybe<Scalars['DateTime']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
};


export type QueryGetOnlineBookingsByTimeRangeSeriesArgs = {
  buckets: Scalars['Int'];
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
};


export type QueryGetOnlineRegisteredBookersArgs = {
  endDateTime?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
};


export type QueryGetPaymentActionLogsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  scheduledPaymentId: Scalars['String'];
};


export type QueryGetPaymentMethodsByBookerIdArgs = {
  bookerId: Scalars['String'];
};


export type QueryGetPaymentMethodTypeByIdArgs = {
  paymentMethodId: Scalars['String'];
};


export type QueryGetReferenceCoursesLinkArgs = {
  courseId: Scalars['ID'];
};


export type QueryGetSentSmsMessagesArgs = {
  journalParams: JournalParams;
};


export type QueryGetSettledBookingsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetSignedUrlDoArgs = {
  fileName: Scalars['String'];
};


export type QueryGetSmsPricingArgs = {
  country?: Maybe<Scalars['String']>;
};


export type QueryGetSmsPricingByCountryCodeArgs = {
  countryCode: Scalars['String'];
};


export type QueryGetSmsReceiversArgs = {
  mailDataType: MailDataType;
  selectedIds: Array<Scalars['String']>;
};


export type QueryGetSmsReceiversCourseArgs = {
  getReceiversForCourseInput: GetReceiversForCourseInput;
};


export type QueryGetTenantUsersArgs = {
  tenantId: Scalars['ID'];
};


export type QueryGetUnBilledBookingsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type QueryGetUnSettledBookingsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetUpcomingCoursesByTimeRangeArgs = {
  endDateTime: Scalars['DateTime'];
  options?: Maybe<ArrayDataOptions>;
  startDateTime: Scalars['DateTime'];
};


export type QueryGetUpcomingCoursesOccupancyArgs = {
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
};


export type QueryGetUserDetailsArgs = {
  userId: Scalars['String'];
};


export type QueryGetWaitlistByCourseArgs = {
  id: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
};


export type QueryGetWaitlistCountOfCourseArgs = {
  id: Scalars['ID'];
};


export type QueryGetYearEndExportDownloadUrlArgs = {
  exportId: Scalars['ID'];
};


export type QueryHolidaysByCompanyAndDateRangeArgs = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};


export type QueryHolidaysByStateCodeArgs = {
  stateCode: StateCode;
};


export type QueryInstallmentRateArgs = {
  id: Scalars['ID'];
};


export type QueryInstallmentRatesByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type QueryInstructorArgs = {
  id: Scalars['String'];
};


export type QueryInstructorInvoiceByIdArgs = {
  invoiceId: Scalars['ID'];
};


export type QueryInstructorInvoicesArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryInstructorInvoicesByInstructorAndDateRangeArgs = {
  input: InstructorInvoicesByDateRangeInput;
};


export type QueryInstructorsByStaffIdsArgs = {
  staffIds: Array<Scalars['ID']>;
};


export type QueryInstructorsWithPaginationArgs = {
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryInterestListByIdArgs = {
  id: Scalars['ID'];
};


export type QueryInterestRegistrationsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryInterestRegistrationsByAttendeeAndCourseTypeArgs = {
  attendeeId: Scalars['ID'];
  courseTypeId: Scalars['ID'];
};


export type QueryInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryInvoiceBodyByBookingIdArgs = {
  bookingId: Scalars['String'];
};


export type QueryInvoiceBodyByIdArgs = {
  id: Scalars['String'];
};


export type QueryInvoiceExportCoursesArgs = {
  includeReversals?: Maybe<Scalars['Boolean']>;
  month?: Maybe<Scalars['Int']>;
  year: Scalars['Int'];
};


export type QueryInvoicesArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryInvoiceTemplateSetArgs = {
  id: Scalars['ID'];
};


export type QueryIsBadgeNameUniqueArgs = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


export type QueryIsCourseNameUniqueArgs = {
  courseId: Scalars['String'];
  customCourseNumberPrefix: Scalars['String'];
};


export type QueryIsCustomBankCodeUniqueArgs = {
  bankCode: Scalars['String'];
  countryCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type QueryIssuedCertificatesArgs = {
  filter?: Maybe<IssuedCertificatesFilterInput>;
};


export type QueryIssuedCertificatesByAttendeeArgs = {
  attendeeId: Scalars['String'];
};


export type QueryIssuedCertificatesByCourseArgs = {
  courseId: Scalars['String'];
};


export type QueryIsUniqueEmailArgs = {
  email: Scalars['String'];
};


export type QueryIsUserEmailVerifiedArgs = {
  userId: Scalars['String'];
};


export type QueryLessonBookingPlannerPreviewArgs = {
  bookingId: Scalars['ID'];
  intents?: Maybe<Array<LessonBookingIntentInput>>;
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
};


export type QueryLessonBookingPlanSummaryArgs = {
  intents?: Maybe<Array<LessonBookingIntentInput>>;
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
};


export type QueryLocationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryLocationContactByIdArgs = {
  id: Scalars['String'];
};


export type QueryLocationContactsByLocationArgs = {
  locationId: Scalars['ID'];
};


export type QueryLocationsByCityArgs = {
  city: Scalars['String'];
};


export type QueryLocationsByLocationContactIdArgs = {
  id: Scalars['ID'];
};


export type QueryLocationsWithPaginationArgs = {
  currentUserOnly?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryMollieDowngradeImpactArgs = {
  koOrganizationId: Scalars['ID'];
};


export type QueryMolliePaymentStatusArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type QueryMolliePaymentStatusFromEndUserAppArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type QueryMolliePaymentStatusFromEndUserAppPublicArgs = {
  scheduledPaymentId: Scalars['ID'];
};


export type QueryMollieRefundsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryMultipleCourseLessonsCollisionCheckArgs = {
  collitionCheckInput: Array<CollitionCheckInput>;
};


export type QueryNewsletterBookerStatusArgs = {
  bookerId: Scalars['ID'];
};


export type QueryNewsletterLogArgs = {
  limit?: Maybe<Scalars['Int']>;
  listId?: Maybe<Scalars['ID']>;
};


export type QueryNewsletterRulesPreviewArgs = {
  input: NewsletterRulesInput;
};


export type QueryNotificationsByBookerIdArgs = {
  bookerId: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
};


export type QueryNotificationsByBookerOrEmailArgs = {
  bookerId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryNotificationsByBookingArgs = {
  bookingId: Scalars['ID'];
};


export type QueryPaidScheduledPaymentsArgs = {
  bookingId?: Maybe<Scalars['ID']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
  respectArchiveSetting?: Maybe<Scalars['Boolean']>;
};


export type QueryParticipationPrerequisiteArgs = {
  id: Scalars['ID'];
};


export type QueryParticipationPrerequisitesByCourseTypeIdArgs = {
  courseTypeId: Scalars['ID'];
};


export type QueryPaymentMethodArgs = {
  id: Scalars['String'];
};


export type QueryPrerequisiteCoursesArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryPreviewCertificatePdfArgs = {
  input: CreateCertificateTemplateInput;
};


export type QueryPreviewSettledBookingCorrectionArgs = {
  bookingId: Scalars['ID'];
  input: SettledBookingCorrectionInput;
};


export type QueryRenderBatchTemplateForBookingsLetterPdfArgs = {
  input: RenderBatchLetterPdfForBookingsInput;
};


export type QueryRenderBatchTemplateForCourseLetterPdfArgs = {
  input: RenderBatchLetterPdfForCourseInput;
};


export type QueryRenderTemplateForLetterPdfArgs = {
  input: RenderTemplateForLetterPdfInput;
};


export type QueryRenderTextBlockPreviewArgs = {
  input: TextBlockPreviewInput;
};


export type QueryResolveTenantRecipientsArgs = {
  tenantIds: Array<Scalars['ID']>;
};


export type QueryReversalInvoiceBodyByIdArgs = {
  id: Scalars['String'];
};


export type QueryReversalInvoicesArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryScheduledPaymentArgs = {
  id: Scalars['String'];
};


export type QueryScheduledPaymentByIdArgs = {
  id: Scalars['ID'];
};


export type QueryScheduledPaymentsArgs = {
  options?: Maybe<ArrayDataOptions>;
};


export type QueryScheduledPaymentsByBookerIdArgs = {
  bookerId: Scalars['ID'];
};


export type QueryScheduledPaymentsByBookingIdArgs = {
  bookingId: Scalars['ID'];
};


export type QueryScheduledPaymentSummaryArgs = {
  options?: Maybe<ArrayDataOptions>;
  paymentDone: Scalars['Boolean'];
  respectArchiveSetting?: Maybe<Scalars['Boolean']>;
};


export type QuerySearchAttendeesByFullNameArgs = {
  name: Scalars['String'];
};


export type QuerySearchBankTransactionCandidatesArgs = {
  id: Scalars['ID'];
  searchKey: Scalars['String'];
};


export type QuerySearchBilledPaymentsArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchBookerByStreetAndHouseNumberAndPpostCodeAndCityArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchBookersByFirstAndLastNameArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchBookersByStreetAndHouseNumberAndPostCodeAndCityArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchBookingByBookingNumberAndBookingNumberPrefixArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchBookingByCourseLocationPrefixAndCourseNumberArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchCourseByCourseLocationPrefixAndCourseNumberArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchCourseByInstructorFirstNameAndLastNameArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchCourseHistoryArgs = {
  filter?: Maybe<CourseHistoryFilterInput>;
  pagination?: Maybe<CourseHistoryPaginationInput>;
};


export type QuerySearchCustomerByCustomerNumberPrefixAndCustomerNumberArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchCustomerByFirstNameAndLastNameArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchInvoicesByCourseNumberArgs = {
  courseNumber: Scalars['Float'];
};


export type QuerySearchInvoicesByInvoiceNumberAndInvoiceNumberPrefixArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchLocationsByNameArgs = {
  name: Scalars['String'];
};


export type QuerySearchLocationsByPhoneNumberAndEmailArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchStaffByFullnameAndAddressArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchUnBilledPaymentsArgs = {
  searchKey: Scalars['String'];
};


export type QuerySearchUnSettledBookingArgs = {
  searchKey: Scalars['String'];
};


export type QuerySentEmailStatusFromMailjetArgs = {
  messageID: Scalars['String'];
};


export type QueryStaffSharingLoginArgs = {
  userId: Scalars['String'];
};


export type QueryStressTestUserQueryArgs = {
  tenantId: Scalars['String'];
};


export type QuerySuperuserDocsArgs = {
  slug: Scalars['String'];
};


export type QuerySwissQrFileByIdArgs = {
  id: Scalars['ID'];
};


export type QuerySwissQrFilesOverviewArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  onlyOpen?: Maybe<Scalars['Boolean']>;
};


export type QuerySwissQrRecordContextArgs = {
  recordId: Scalars['ID'];
};


export type QueryTemplateArgs = {
  id: Scalars['String'];
};


export type QueryTemplateByTypeArgs = {
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
  templateType: TemplateType;
};


export type QueryTemplatesArgs = {
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
};


export type QueryTemplatesWithPaginationArgs = {
  icludeStandardTemplates?: Maybe<Scalars['Boolean']>;
  includeInvoiceTemplates?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
};


export type QueryTenantActivitySummaryArgs = {
  koOrganizationId: Scalars['ID'];
};


export type QueryTenantDeletionImpactArgs = {
  koOrganizationId: Scalars['ID'];
};


export type QueryTenantDeletionStatusArgs = {
  koOrganizationId: Scalars['ID'];
};


export type QueryTenantMetricsArgs = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type QueryTenantNotificationsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryTenantStaffMetricsArgs = {
  from: Scalars['DateTime'];
  koOrganizationId: Scalars['ID'];
  to: Scalars['DateTime'];
};


export type QueryTenantsWithPaginationArgs = {
  koOrganizationId?: Maybe<Scalars['String']>;
  options?: Maybe<ArrayDataOptions>;
  searchTerm?: Maybe<Scalars['String']>;
};


export type QueryTestFusioAuthFunctionsArgs = {
  userId: Scalars['String'];
};


export type QueryTransferBulkPlanPreviewArgs = {
  input: TransferBulkPlanInput;
};


export type QueryTransferPlanPreviewArgs = {
  input: TransferPlanInput;
};


export type QueryUnpaidScheduledPaymentsArgs = {
  bookingId?: Maybe<Scalars['ID']>;
  dunningDue?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  options?: Maybe<ArrayDataOptions>;
  respectArchiveSetting?: Maybe<Scalars['Boolean']>;
};


export type QueryUnpaidScheduledPaymentsZeroValuesArgs = {
  options?: Maybe<ArrayDataOptions>;
};

export type Rate = {
  key: Scalars['String'];
  value: RateDetail;
};

export type RateDetail = {
  amount: Scalars['String'];
  due: Scalars['String'];
};

export type RecentLoginEntry = {
  applicationName?: Maybe<Scalars['String']>;
  instant?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export type RecordExternalPaymentForScheduledPaymentInput = {
  id: Scalars['ID'];
  paymentDone: Scalars['DateTime'];
  paymentTransferType: PaymentTransferType;
  reference?: Maybe<Scalars['String']>;
};

export type RemoveAdminManagementUserInput = {
  userId: Scalars['ID'];
};

export type RenderBatchLetterPdfForBookingsInput = {
  bookingIds: Array<Scalars['String']>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  templateId: Scalars['String'];
};

export type RenderBatchLetterPdfForCourseInput = {
  courseId: Scalars['String'];
  editedTemplateInput?: Maybe<EditTemplateInput>;
  notifyBookings?: Maybe<Scalars['Boolean']>;
  notifyCancelations?: Maybe<Scalars['Boolean']>;
  notifyWaitlist?: Maybe<Scalars['Boolean']>;
  templateId: Scalars['String'];
};

export type RenderedBatchLetterPdfData = {
  items: Array<RenderedLetterPdfData>;
  totalCount: Scalars['Float'];
};

export type RenderedLetterPdfData = {
  courseDetails?: Maybe<LetterPdfCourseDetails>;
  footerText: Scalars['String'];
  headerText: Scalars['String'];
  recipientAddition?: Maybe<Scalars['String']>;
  recipientCity?: Maybe<Scalars['String']>;
  recipientFirstName?: Maybe<Scalars['String']>;
  recipientHouseNumber?: Maybe<Scalars['String']>;
  recipientLastName?: Maybe<Scalars['String']>;
  recipientPostCode?: Maybe<Scalars['String']>;
  recipientStreet?: Maybe<Scalars['String']>;
  senderBankName?: Maybe<Scalars['String']>;
  senderBic?: Maybe<Scalars['String']>;
  senderCity?: Maybe<Scalars['String']>;
  senderEmail?: Maybe<Scalars['String']>;
  senderIban?: Maybe<Scalars['String']>;
  senderLogoBase64?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  senderPhone?: Maybe<Scalars['String']>;
  senderStreet?: Maybe<Scalars['String']>;
  senderStreetNumber?: Maybe<Scalars['String']>;
  senderTaxId?: Maybe<Scalars['String']>;
  senderTaxNumber?: Maybe<Scalars['String']>;
  senderWebsite?: Maybe<Scalars['String']>;
  senderZip?: Maybe<Scalars['String']>;
  signature: Scalars['String'];
  subject: Scalars['String'];
};

export type RenderTemplateForLetterPdfInput = {
  attendeeId?: Maybe<Scalars['String']>;
  bookerId?: Maybe<Scalars['String']>;
  bookingId?: Maybe<Scalars['String']>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  scheduledPaymentId?: Maybe<Scalars['String']>;
  templateId: Scalars['String'];
};

export enum RentType {
  Per45Minutes = 'Per45Minutes',
  Per60Minutes = 'Per60Minutes',
  PerCourse = 'PerCourse',
  PerCourseHour = 'PerCourseHour',
  PerDay = 'PerDay'
}

export type ResetPasswordStateType = {
  resetPasswordUrl: Scalars['String'];
};

export enum ResetPaymentPlanBlockedReason {
  ActiveMollie = 'ACTIVE_MOLLIE',
  NoBookedLessons = 'NO_BOOKED_LESSONS',
  PaidExceedsStandard = 'PAID_EXCEEDS_STANDARD',
  PartiallyPaid = 'PARTIALLY_PAID',
  UnsupportedPaymentType = 'UNSUPPORTED_PAYMENT_TYPE'
}

export type ResetPaymentPlanOfInvoicedLessonBookingResult = {
  blockedMessage?: Maybe<Scalars['String']>;
  blockedReason?: Maybe<ResetPaymentPlanBlockedReason>;
  bookingId: Scalars['String'];
  newScheduledPayments: Array<ResetPaymentPlanRateSnapshot>;
  newTotalGrossPrice: Scalars['Float'];
  oldCreditedBalance?: Maybe<Scalars['Float']>;
  oldDiscount?: Maybe<Scalars['Float']>;
  oldScheduledPayments: Array<ResetPaymentPlanRateSnapshot>;
  oldTotalGrossPrice: Scalars['Float'];
  previewOnly: Scalars['Boolean'];
};

export type ResetPaymentPlanRateSnapshot = {
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  manuallyAdjustedAt?: Maybe<Scalars['DateTime']>;
  paid: Scalars['Boolean'];
  paymentAmount: Scalars['Float'];
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentDue: Scalars['DateTime'];
  refundedAmount: Scalars['Float'];
};

export type ResetScheduledPaymentsOfBookingResult = {
  bookingId: Scalars['String'];
  bookingNumber: Scalars['String'];
  bookingPrice: Scalars['Float'];
  coursePrice: Scalars['Float'];
  creditedBalance?: Maybe<Scalars['Float']>;
  currentScheduledPaymentsAmountsAndDueDates: Array<Rate>;
  currentScheduledPaymentsCount: Scalars['Float'];
  currentScheduledPaymnetsCount: Scalars['Float'];
  installmentPlanAmountsAndDueDates: Array<Rate>;
  newScheduledPaymentsAmountsAndDueDates: Array<Rate>;
  newScheduledPaymentsCount: Scalars['Float'];
};

export type ResetScheduledPaymentsOfCourseResult = {
  bookings: Array<ResetScheduledPaymentsOfBookingResult>;
  courseDueDates: Array<Rate>;
  courseId: Scalars['String'];
  courseNumber: Scalars['String'];
  coursePrice: Scalars['Float'];
};

export type RestoreBackupInput = {
  backupId: Scalars['ID'];
  confirmRestore?: Maybe<Scalars['Boolean']>;
  format: Scalars['String'];
};

export enum RestrictiveCourses {
  All = 'All',
  MembersOnly = 'MembersOnly',
  PrerequisiteCourses = 'PrerequisiteCourses',
  StandardCourses = 'StandardCourses'
}

export type ReversalInvoice = {
  booking: Booking;
  bookingId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceNumber: Scalars['Float'];
  invoiceNumberPrefix: Scalars['String'];
  koOrganization: KoOrganization;
  mollieGenerated: Scalars['Boolean'];
  qrReference?: Maybe<Scalars['String']>;
  reversalInvoiceBody: Scalars['String'];
  reversalInvoiceFileName: Scalars['String'];
  scheduledPayments?: Maybe<Array<ScheduledPayment>>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type ReversalInvoiceWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<ReversalInvoice>;
  total: Scalars['Float'];
};

export enum SalutationType {
  Mr = 'Mr',
  Ms = 'Ms',
  Mx = 'Mx'
}

export type SaveAdminInput = {
  accountHolder?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  customFields?: Maybe<Array<Scalars['JSONObject']>>;
  firstname: Scalars['String'];
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber: Scalars['String'];
  iban?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  joinDate?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  leaveDate?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode: Scalars['String'];
  rate?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Scalars['String']>>;
  salutation: SalutationType;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  userId: Scalars['String'];
  vat?: Maybe<Scalars['Float']>;
};

export type SaveInstructorInput = {
  accountHolder?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  allowLogin?: Maybe<Scalars['Boolean']>;
  annotation?: Maybe<Scalars['String']>;
  assignedLocations: Array<AssignedLocationIdInput>;
  bank?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  confirmLoginMerge?: Maybe<Scalars['Boolean']>;
  customFields?: Maybe<Array<Scalars['JSONObject']>>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  joinDate?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  leaveDate?: Maybe<Scalars['String']>;
  level: Scalars['Float'];
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  salutation: SalutationType;
  showInWeb: Scalars['Boolean'];
  socialSecurityNumber?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  vat?: Maybe<Scalars['Float']>;
};

export type ScheduledPayment = {
  additionalItemId?: Maybe<Scalars['ID']>;
  booking: Booking;
  bookingId: Scalars['ID'];
  carriedOverAt?: Maybe<Scalars['DateTime']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<ScheduledPaymentMethodChangeUser>;
  deletedByUserId?: Maybe<Scalars['String']>;
  dunningStatus?: Maybe<BookingDunningStatus>;
  exportedSepaXmlId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['ID']>;
  isWaitlistBooking: Scalars['Boolean'];
  keptOnCancelAt?: Maybe<Scalars['DateTime']>;
  latestMolliePaymentAttempt?: Maybe<LatestMollieAttemptBadge>;
  manuallyAddedAt?: Maybe<Scalars['DateTime']>;
  manuallyAdjustedAt?: Maybe<Scalars['DateTime']>;
  manuallyAdjustedBy?: Maybe<ScheduledPaymentMethodChangeUser>;
  manuallyAdjustedByUserId?: Maybe<Scalars['String']>;
  methodChangedAt?: Maybe<Scalars['DateTime']>;
  methodChangedBy?: Maybe<ScheduledPaymentMethodChangeUser>;
  methodChangedByUserId?: Maybe<Scalars['String']>;
  mollieErrorMessage?: Maybe<Scalars['String']>;
  mollieManagedFlow: Scalars['Boolean'];
  mollieMethod?: Maybe<Scalars['String']>;
  molliePaidAmount?: Maybe<Scalars['Float']>;
  molliePaymentId?: Maybe<Scalars['String']>;
  molliePaymentStatus?: Maybe<Scalars['String']>;
  molliePaymentUrl?: Maybe<Scalars['String']>;
  mollieRetryCount: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
  openAmount?: Maybe<Scalars['Float']>;
  paymentAmount: Scalars['Float'];
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentDue: Scalars['DateTime'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  paymentProvider: PaymentProvider;
  paymentTransferType?: Maybe<PaymentTransferType>;
  postKind: BookingPostKind;
  providerRefundedAmount: Scalars['Float'];
  refundedAmount: Scalars['Float'];
  sepaClearance: Scalars['Boolean'];
  sepaCollectionDate?: Maybe<Scalars['DateTime']>;
  sepaCollectionStatus?: Maybe<SepaCollectionStatus>;
  surplusMolliePaymentCount: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  transferFromBookingNumber?: Maybe<Scalars['String']>;
  transferPaidAmount?: Maybe<Scalars['Float']>;
  type: ScheduledPaymentType;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type ScheduledPaymentMethodChangeUser = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type ScheduledPaymentPreview = {
  blockingReason?: Maybe<CourseBookingBasePriceBlockingReason>;
  calculationVersion?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  discountCode?: Maybe<Scalars['String']>;
  discountName?: Maybe<Scalars['String']>;
  effectiveMinimum?: Maybe<Scalars['Int']>;
  effectiveMode?: Maybe<CourseLateEntryPricingMode>;
  eligibleLessonCount?: Maybe<Scalars['Int']>;
  eligibleLessonIds?: Maybe<Array<Scalars['ID']>>;
  fingerprint?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  isBookable?: Maybe<Scalars['Boolean']>;
  isPartialBooking?: Maybe<Scalars['Boolean']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  netPrice: Scalars['Float'];
  originalGrossPrice?: Maybe<Scalars['Float']>;
  pricedAt?: Maybe<Scalars['DateTime']>;
  reduction?: Maybe<Scalars['Float']>;
  scheduledPayments: Array<ScheduledPaymentSimple>;
  serviceGrossPrice?: Maybe<Scalars['Float']>;
  totalLessonCount?: Maybe<Scalars['Int']>;
  totalLessonIds?: Maybe<Array<Scalars['ID']>>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type ScheduledPaymentPreviewInput = {
  courseId: Scalars['ID'];
  editMode?: Maybe<Scalars['Boolean']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  specialPrice?: Maybe<Scalars['Float']>;
};

export type ScheduledPaymentSimple = {
  additionalItemId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  molliePaymentStatus?: Maybe<Scalars['String']>;
  paymentAmount: Scalars['Float'];
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentDue: Scalars['DateTime'];
  paymentProvider?: Maybe<PaymentProvider>;
  title?: Maybe<Scalars['String']>;
  type: ScheduledPaymentType;
  vat?: Maybe<Scalars['Float']>;
};

export type ScheduledPaymentSimpleInput = {
  additionalItemId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  paymentAmount: Scalars['Float'];
  paymentDue: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  type: ScheduledPaymentType;
  vat?: Maybe<Scalars['Float']>;
};

export type ScheduledPaymentSummary = {
  filtered: ScheduledPaymentSummaryPart;
  total: ScheduledPaymentSummaryPart;
};

export type ScheduledPaymentSummaryPart = {
  count: Scalars['Float'];
  sum: Scalars['Float'];
};

export type ScheduledPaymentsWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<ScheduledPayment>;
  total: Scalars['Float'];
};

export enum ScheduledPaymentType {
  AdditionalItem = 'AdditionalItem',
  CancelationFee = 'CancelationFee',
  Chargeback = 'Chargeback',
  Custom = 'Custom',
  Discount = 'Discount',
  DunningLevel1 = 'DunningLevel1',
  DunningLevel2 = 'DunningLevel2',
  DunningLevel3 = 'DunningLevel3',
  Standard = 'Standard'
}

export type ScoreBreakdownType = {
  differentAddress: Scalars['Float'];
  differentEmail: Scalars['Float'];
  differentName: Scalars['Float'];
  differentPhone: Scalars['Float'];
  exactEmail: Scalars['Float'];
  exactName: Scalars['Float'];
  fuzzyName: Scalars['Float'];
  missingName?: Maybe<Scalars['Float']>;
  sameAddress: Scalars['Float'];
  sameAttendee?: Maybe<Scalars['Float']>;
  sameAttendeeMultiple?: Maybe<Scalars['Float']>;
  samePhone: Scalars['Float'];
  total: Scalars['Float'];
};

export type SecureIdentity = {
  breachedPasswordLastCheckedInstant?: Maybe<Scalars['Float']>;
  connectorId?: Maybe<Scalars['String']>;
  encryptionScheme?: Maybe<Scalars['String']>;
  factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  lastLoginInstant?: Maybe<Scalars['Float']>;
  password?: Maybe<Scalars['String']>;
  passwordChangeReason?: Maybe<Scalars['String']>;
  passwordChangeRequired?: Maybe<Scalars['Boolean']>;
  passwordLastUpdateInstant?: Maybe<Scalars['Float']>;
  salt?: Maybe<Scalars['String']>;
  uniqueUsername?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type SelectedAttendee = {
  bookedCourseIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  firstname: Scalars['String'];
  id: Scalars['ID'];
};

export type SendArchiveRecipientInput = {
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type SendAttendanceListArchiveInput = {
  customText?: Maybe<Scalars['String']>;
  jobGroupId: Scalars['ID'];
  recipients?: Maybe<Array<SendArchiveRecipientInput>>;
};

export type SendInvoicesToSelectionOfBookingInput = {
  bookingIds: Array<Scalars['String']>;
  defaultTemplateType?: Maybe<TemplateType>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  reversal?: Maybe<Scalars['Boolean']>;
};

export type SendMailToSelectionOfAttendeesInput = {
  attachments?: Maybe<Array<Attachment>>;
  attendeeIds: Array<Scalars['String']>;
  defaultTemplateType?: Maybe<TemplateType>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  templateId: Scalars['String'];
};

export type SendMailToSelectionOfBookersInput = {
  attachments?: Maybe<Array<Attachment>>;
  bookerIds: Array<Scalars['String']>;
  defaultTemplateType?: Maybe<TemplateType>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  templateId: Scalars['String'];
};

export type SendMailToSelectionOfBookingInput = {
  attachInvoices?: Maybe<Scalars['Boolean']>;
  attachments?: Maybe<Array<Attachment>>;
  attachReversalInvoices?: Maybe<Scalars['Boolean']>;
  bookingIds: Array<Scalars['String']>;
  defaultTemplateType?: Maybe<TemplateType>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  templateId: Scalars['String'];
};

export type SendMailToSelectionOfCourseInput = {
  additionalReceivers?: Maybe<Array<Scalars['String']>>;
  attachInvoices?: Maybe<Scalars['Boolean']>;
  attachments?: Maybe<Array<Attachment>>;
  attachReversalInvoices?: Maybe<Scalars['Boolean']>;
  courseId: Scalars['String'];
  defaultTemplateType?: Maybe<TemplateType>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  notifyBookings?: Maybe<Scalars['Boolean']>;
  notifyCancelations?: Maybe<Scalars['Boolean']>;
  notifyWaitlist?: Maybe<Scalars['Boolean']>;
  receiverIds?: Maybe<Array<Scalars['String']>>;
  templateId: Scalars['String'];
};

export type SendMailToSelectionOfScheduledPaymentsInput = {
  attachInvoices?: Maybe<Scalars['Boolean']>;
  attachments?: Maybe<Array<Attachment>>;
  attachReversalInvoices?: Maybe<Scalars['Boolean']>;
  defaultTemplateType?: Maybe<TemplateType>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  scheduledPaymentIds: Array<Scalars['String']>;
  templateId: Scalars['String'];
};

export type SendMailToSelectionOfStaffInput = {
  attachments?: Maybe<Array<Attachment>>;
  defaultTemplateType?: Maybe<TemplateType>;
  editedTemplateInput?: Maybe<EditTemplateInput>;
  staffIds: Array<Scalars['String']>;
  templateId: Scalars['String'];
};

export type SendParamsMessageInput = {
  Attachments?: Maybe<Array<Attachment>>;
  Bcc?: Maybe<Array<SendParamsRecipient>>;
  Cc?: Maybe<Array<SendParamsRecipient>>;
  CustomCampaign?: Maybe<Scalars['String']>;
  CustomID?: Maybe<Scalars['String']>;
  DeduplicateCampaign?: Maybe<Scalars['Boolean']>;
  EventPayload?: Maybe<Scalars['String']>;
  From: SendParamsRecipient;
  HTMLPart?: Maybe<Scalars['String']>;
  InlinedAttachments?: Maybe<Array<InlinedAttachment>>;
  MonitoringCategory?: Maybe<Scalars['String']>;
  ReplyTo?: Maybe<SendParamsRecipient>;
  Sender?: Maybe<SendParamsRecipient>;
  Subject: Scalars['String'];
  TemplateID?: Maybe<Scalars['Float']>;
  TemplateLanguage?: Maybe<Scalars['Boolean']>;
  TextPart?: Maybe<Scalars['String']>;
  To: Array<SendParamsRecipient>;
  URLTags?: Maybe<Scalars['String']>;
  Variables?: Maybe<MailjetVariables>;
};

export type SendParamsRecipient = {
  Email: Scalars['String'];
  Name?: Maybe<Scalars['String']>;
};

export type SendPasswordResetLinkEmailInput = {
  recipientEmail: Scalars['String'];
  resetLink: Scalars['String'];
  staffName: Scalars['String'];
};

export type SendSmsInput = {
  from?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  to: Scalars['String'];
};

export type SendTemplateInput = {
  emailData: EmailData;
  mailjetTemplateId: MailjetEmailTemplates;
  messages: Array<SendParamsMessageInput>;
  templateName: Scalars['String'];
  templateType: TemplateType;
};

export enum SepaCollectionStatus {
  Collected = 'Collected',
  Requested = 'Requested',
  Returned = 'Returned'
}

export type SepaDebitIntput = {
  bank: Scalars['String'];
  bic: Scalars['String'];
  iban: Scalars['String'];
  sepaAccountholder: Scalars['String'];
};

export type SepaXmlPaymentInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  debtorBIC: Scalars['String'];
  debtorIBAN: Scalars['String'];
  debtorName: Scalars['String'];
  end2endId: Scalars['String'];
  mandateId: Scalars['String'];
  mandateSignatureDate: Scalars['DateTime'];
  remittanceInfo: Scalars['String'];
};

export type SepaXmlPositionInput = {
  batchBooking: Scalars['Boolean'];
  collectionDate: Scalars['DateTime'];
  creditorBIC: Scalars['String'];
  creditorIBAN: Scalars['String'];
  creditorId: Scalars['String'];
  creditorName: Scalars['String'];
  payments: Array<SepaXmlPaymentInput>;
};

export type SetDunningPauseInput = {
  bookingId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['String']>;
};

export type Setting = {
  autoIssuePaymentLinkOnExpiry: Scalars['Boolean'];
  autoSendMollieReminderMails: Scalars['Boolean'];
  bankTransfer: Scalars['Boolean'];
  bankTransferProvider: PaymentProvider;
  cancelationFeeDefault: Scalars['Float'];
  cash: Scalars['Boolean'];
  courseEditCorrectionInvoice: Scalars['Boolean'];
  courseEditCorrectionInvoiceMail: Scalars['Boolean'];
  courseNumberFormat: CourseNumberFormat;
  createDate: Scalars['DateTime'];
  createdByUserId: Scalars['String'];
  currency: Currency;
  customerNumberPrefix: Scalars['String'];
  defaultVat: Scalars['Float'];
  dunningAttachInvoice: Scalars['Boolean'];
  dunningLevel1Days: Scalars['Float'];
  dunningLevel1Enabled: Scalars['Boolean'];
  dunningLevel1Fee: Scalars['Float'];
  dunningLevel2Days: Scalars['Float'];
  dunningLevel2Enabled: Scalars['Boolean'];
  dunningLevel2Fee: Scalars['Float'];
  dunningLevel3Days: Scalars['Float'];
  dunningLevel3Enabled: Scalars['Boolean'];
  dunningLevel3Fee: Scalars['Float'];
  dunningNewDueDays: Scalars['Float'];
  dunningReminderDays: Scalars['Float'];
  dunningReminderEnabled: Scalars['Boolean'];
  enabledMollieMethods: Array<Scalars['String']>;
  esr: Scalars['Boolean'];
  featureMollie: Scalars['Boolean'];
  firstInstallmentDayOfMonth: Scalars['Float'];
  firstInstallmentMonth: Scalars['Float'];
  grossNet: GrossNet;
  holidayCountryCode?: Maybe<CountryCode>;
  holidayStateCode?: Maybe<StateCode>;
  holidayStateColor: Scalars['String'];
  id: Scalars['ID'];
  interestListShowNoteFieldDefault: Scalars['Boolean'];
  invoiceDueDays: Scalars['Float'];
  invoiceNumberPrefix: Scalars['String'];
  mollieAutoInvoice: Scalars['Boolean'];
  mollieChargebackFeePassthrough: Scalars['Boolean'];
  mollieInvoiceSendMode: Scalars['String'];
  mollieRefundMode: Scalars['String'];
  newCustomerDetectionEnabled: Scalars['Boolean'];
  paymentLinkValidityDays: Scalars['Float'];
  restrictStaffPaymentMethods: Scalars['Boolean'];
  sendPaymentLinkOnAdminBooking: Scalars['Boolean'];
  sendReversalInvoice: Scalars['Boolean'];
  sepaDebit: Scalars['Boolean'];
  sepaDebitProvider: PaymentProvider;
  sevenIoApiKey?: Maybe<Scalars['String']>;
  smsSenderName?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  transferDefaultOldBookingOption: TransferOldBookingDefault;
  transferDefaultPriceOption: TransferPriceDefault;
  transferMode: TransferMode;
  transferSendMail: Scalars['Boolean'];
  updateDate: Scalars['DateTime'];
  updatedByUserId: Scalars['String'];
  vatAppearance: Scalars['String'];
};

export type SettingEndUserApp = {
  additionalItemsEnabled: Scalars['Boolean'];
  calendarFeedEnabled: Scalars['Boolean'];
  colors?: Maybe<Scalars['JSONObject']>;
  courseDetails?: Maybe<Scalars['JSONObject']>;
  courseSearchDisplayMode: CourseSearchDisplayMode;
  courseSearchGridGap: Scalars['Float'];
  courseSearchGridMaxColumns: Scalars['Float'];
  courseSearchPageSize: Scalars['Float'];
  courseTable?: Maybe<Scalars['JSONObject']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  creditRedemptionEnabled: Scalars['Boolean'];
  discountCodesEnabled: Scalars['Boolean'];
  filters?: Maybe<Scalars['JSONObject']>;
  hideAfterDays: Scalars['Float'];
  i18n?: Maybe<I18n>;
  id: Scalars['ID'];
  lateEntryPricingPolicy: TenantLateEntryPricingPolicy;
  minimumPartialBookingLessonCount: Scalars['Int'];
  optionalInputFields?: Maybe<Array<Scalars['JSONObject']>>;
  passwordlessIdCodeLength: Scalars['Float'];
  passwordlessLoginEnabled: Scalars['Boolean'];
  showInterestListsByDefault: Scalars['Boolean'];
  showTotalPriceInCheckout: Scalars['Boolean'];
  textEntries?: Maybe<Scalars['JSONObject']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  withdrawalButtonEnabled: Scalars['Boolean'];
};

export type SettingEndUserAppHistory = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  newValues?: Maybe<Scalars['JSONObject']>;
  oldValues?: Maybe<Scalars['JSONObject']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SettingEndUserAppInput = {
  colors: ColorsInput;
  courseDetails: CourseDetailsInput;
  courseSearchDisplayMode?: Maybe<CourseSearchDisplayMode>;
  courseSearchGridGap?: Maybe<Scalars['Float']>;
  courseSearchGridMaxColumns?: Maybe<Scalars['Float']>;
  courseSearchPageSize?: Maybe<Scalars['Float']>;
  courseTable: CourseTableInput;
  creditRedemptionEnabled?: Maybe<Scalars['Boolean']>;
  filters: FiltersInput;
  hideAfterDays?: Maybe<Scalars['Float']>;
  lateEntryPricingPolicy?: Maybe<TenantLateEntryPricingPolicy>;
  minimumPartialBookingLessonCount?: Maybe<Scalars['Int']>;
  optionalInputFields?: Maybe<Array<Scalars['JSONObject']>>;
  showInterestListsByDefault?: Maybe<Scalars['Boolean']>;
  showTotalPriceInCheckout?: Maybe<Scalars['Boolean']>;
  textEntries: TextEntriesInput;
};

export type SettingInput = {
  autoIssuePaymentLinkOnExpiry?: Maybe<Scalars['Boolean']>;
  autoSendMollieReminderMails?: Maybe<Scalars['Boolean']>;
  bankTransfer: Scalars['Boolean'];
  bankTransferProvider?: Maybe<PaymentProvider>;
  cancelationFeeDefault?: Maybe<Scalars['Float']>;
  cash: Scalars['Boolean'];
  courseEditCorrectionInvoice?: Maybe<Scalars['Boolean']>;
  courseEditCorrectionInvoiceMail?: Maybe<Scalars['Boolean']>;
  courseNumberFormat: CourseNumberFormat;
  currency: Currency;
  customerNumberPrefix?: Maybe<Scalars['String']>;
  defaultVat: Scalars['Float'];
  dunningAttachInvoice?: Maybe<Scalars['Boolean']>;
  dunningLevel1Days?: Maybe<Scalars['Float']>;
  dunningLevel1Enabled?: Maybe<Scalars['Boolean']>;
  dunningLevel1Fee?: Maybe<Scalars['Float']>;
  dunningLevel2Days?: Maybe<Scalars['Float']>;
  dunningLevel2Enabled?: Maybe<Scalars['Boolean']>;
  dunningLevel2Fee?: Maybe<Scalars['Float']>;
  dunningLevel3Days?: Maybe<Scalars['Float']>;
  dunningLevel3Enabled?: Maybe<Scalars['Boolean']>;
  dunningLevel3Fee?: Maybe<Scalars['Float']>;
  dunningNewDueDays?: Maybe<Scalars['Float']>;
  dunningReminderDays?: Maybe<Scalars['Float']>;
  dunningReminderEnabled?: Maybe<Scalars['Boolean']>;
  enabledMollieMethods?: Maybe<Array<Scalars['String']>>;
  esr: Scalars['Boolean'];
  firstInstallmentDayOfMonth: Scalars['Float'];
  firstInstallmentMonth: Scalars['Float'];
  grossNet: GrossNet;
  holidayCountryCode?: Maybe<CountryCode>;
  holidayStateCode?: Maybe<StateCode>;
  holidayStateColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceDueDays: Scalars['Float'];
  invoiceNumberPrefix?: Maybe<Scalars['String']>;
  mollieAutoInvoice?: Maybe<Scalars['Boolean']>;
  mollieInvoiceSendMode?: Maybe<MollieInvoiceSendMode>;
  mollieRefundMode?: Maybe<MollieRefundMode>;
  newCustomerDetectionEnabled?: Maybe<Scalars['Boolean']>;
  paymentLinkValidityDays?: Maybe<Scalars['Float']>;
  restrictStaffPaymentMethods?: Maybe<Scalars['Boolean']>;
  sendPaymentLinkOnAdminBooking?: Maybe<Scalars['Boolean']>;
  sendReversalInvoice?: Maybe<Scalars['Boolean']>;
  sepaDebit: Scalars['Boolean'];
  sepaDebitProvider?: Maybe<PaymentProvider>;
  sevenIoApiKey?: Maybe<Scalars['String']>;
  smsSenderName?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  transferDefaultOldBookingOption?: Maybe<TransferOldBookingDefault>;
  transferDefaultPriceOption?: Maybe<TransferPriceDefault>;
  transferMode?: Maybe<TransferMode>;
  transferSendMail?: Maybe<Scalars['Boolean']>;
  vatAppearance: VatAppearance;
};

export type SettledBookingCorrectionInput = {
  /** Neuer GESAMT-Wert der Guthaben-Verrechnung. */
  creditedBalance?: Maybe<Scalars['Float']>;
  /** Optimistic-Concurrency-Precondition: erwarteter aktueller grossPrice. */
  expectedGrossPrice: Scalars['Float'];
  /** Neuer Basispreis (vor Abzügen). Default: aktueller Basispreis. */
  newBasePrice?: Maybe<Scalars['Float']>;
  /** Ziel-Zahlweise (PrePaid/Monthly). Weggelassen oder gleich der aktuellen = kein Wechsel. Optional für alte Bundles. */
  newPaymentType?: Maybe<PaymentType>;
  /** Freitext-Begründung für die Historie. Wird serverseitig auf 200 Zeichen gekürzt. Optional für alte Bundles. */
  reason?: Maybe<Scalars['String']>;
  /** Pflicht sobald eine Überzahlung entsteht. */
  refundMode?: Maybe<CorrectionRefundMode>;
};

export type SettledBookingCorrectionPreview = {
  alreadyPaid: Scalars['Float'];
  blockers: Array<Scalars['String']>;
  creditedBalanceDelta: Scalars['Float'];
  creditToBooker: Scalars['Float'];
  installmentChanges: Array<InstallmentChangePreview>;
  newGrossPrice: Scalars['Float'];
  newOpenAmount: Scalars['Float'];
  newPaymentLinkAmount: Scalars['Float'];
  overpayment: Scalars['Float'];
  refundAmount: Scalars['Float'];
  warnings: Array<Scalars['String']>;
};

export type SettledBookingCorrectionResult = {
  booking: Booking;
  correctionInvoiceOk: Scalars['Boolean'];
  messages: Array<Scalars['String']>;
  paymentLinkOk: Scalars['Boolean'];
  refundOk: Scalars['Boolean'];
};

export type SetupScriptResult = {
  message: Scalars['String'];
  success: Scalars['Boolean'];
  updatedCount: Scalars['Float'];
};

export type SharedLoginStaff = {
  active: Scalars['Boolean'];
  firstname: Scalars['String'];
  id: Scalars['String'];
  lastname: Scalars['String'];
};

export type SimilarBookerResult = {
  booker: Booker;
  matchReason: Scalars['String'];
  score: Scalars['Int'];
};

export type SlowQueryOutput = {
  avgTimeMs: Scalars['Float'];
  calls: Scalars['Float'];
  maxTimeMs: Scalars['Float'];
  percentTotal: Scalars['Float'];
  query: Scalars['String'];
  totalTimeMs: Scalars['Float'];
};

export type Sms77AnalyticBase = {
  hlr: Scalars['Float'];
  inbound: Scalars['Float'];
  mnp: Scalars['Float'];
  sms: Scalars['Float'];
  usageEur: Scalars['Float'];
  voice: Scalars['Float'];
};

export type Sms77AnalyticGroupByDate = {
  date: Scalars['String'];
  hlr: Scalars['Float'];
  inbound: Scalars['Float'];
  mnp: Scalars['Float'];
  sms: Scalars['Float'];
  usageEur: Scalars['Float'];
  voice: Scalars['Float'];
};

export type Sms77CountryPricing = {
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  countryPrefix: Scalars['String'];
  networks: Array<CountryNetwork>;
};

export type Sms77FormatApiResponse = {
  carrier: Scalars['String'];
  countryCode: Scalars['String'];
  countryIso: Scalars['String'];
  countryName: Scalars['String'];
  international: Scalars['String'];
  internationalFormatted: Scalars['String'];
  national: Scalars['String'];
  networkType: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Sms77JournalBase = {
  from: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['String'];
  text: Scalars['String'];
  timestamp: Scalars['String'];
  to: Scalars['String'];
};

export type Sms77JournalOutbound = {
  channel: Scalars['String'];
  dlr: Scalars['String'];
  dlrTimestamp: Scalars['String'];
  foreignId?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  latency: Scalars['String'];
  mccmnc: Scalars['String'];
  price: Scalars['String'];
  text: Scalars['String'];
  timestamp: Scalars['String'];
  to: Scalars['String'];
  type: Scalars['String'];
};

export type Sms77JsonResponse = {
  balance: Scalars['String'];
  debug: Scalars['String'];
  description: Scalars['String'];
  messages: Array<Sms77Message>;
  smsType: Scalars['String'];
  success: Scalars['String'];
  totalPrice: Scalars['Float'];
};

export type Sms77Message = {
  encoding: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  errorText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isBinary: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  parts: Scalars['Float'];
  price: Scalars['Float'];
  recipient: Scalars['String'];
  sender: Scalars['String'];
  success: Scalars['Boolean'];
  text: Scalars['String'];
  udh?: Maybe<Scalars['String']>;
};

export type Sms77PricingResponse = {
  countCountries: Scalars['Float'];
  countNetworks: Scalars['Float'];
  countries: Array<Sms77CountryPricing>;
};

export type SmsBalanceResponse = {
  balance: Scalars['Float'];
};

export type SmsReceiver = {
  bookerId: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  prefixedBookingNumber?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['String']>;
};

export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type Staff = {
  accountHolder?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  areaManagerLocations?: Maybe<Array<Location>>;
  bank?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  joinDate?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  leaveDate?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  salutation?: Maybe<SalutationType>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  vat?: Maybe<Scalars['Float']>;
};

export type StaffLogin = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pages: Array<Scalars['JSONObject']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export enum StaffVisibilityLevel {
  All = 'All',
  ColleagueList = 'ColleagueList',
  NoAccess = 'NoAccess',
  OwnCourses = 'OwnCourses'
}

export type StaffVisibilityRow = {
  assistant: StaffVisibilityLevel;
  instructor: StaffVisibilityLevel;
};

export type StaffVisibilityRowInput = {
  assistant: StaffVisibilityLevel;
  instructor: StaffVisibilityLevel;
};

export type StaffVisibilityRules = {
  bookingActions: StaffVisibilityRow;
  courses: StaffVisibilityRow;
  courseTypes: StaffVisibilityRow;
  customers: StaffVisibilityRow;
  interestLists: StaffVisibilityRow;
  invoices: StaffVisibilityRow;
  locations: StaffVisibilityRow;
  staff: StaffVisibilityRow;
  version: Scalars['Int'];
};

export type StaffVisibilityRulesHistoryEntry = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  newValues?: Maybe<Scalars['JSONObject']>;
  oldValues?: Maybe<Scalars['JSONObject']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type StaffVisibilityRulesInput = {
  bookingActions?: Maybe<StaffVisibilityRowInput>;
  courses: StaffVisibilityRowInput;
  courseTypes?: Maybe<StaffVisibilityRowInput>;
  customers?: Maybe<StaffVisibilityRowInput>;
  interestLists?: Maybe<StaffVisibilityRowInput>;
  invoices?: Maybe<StaffVisibilityRowInput>;
  locations?: Maybe<StaffVisibilityRowInput>;
  staff?: Maybe<StaffVisibilityRowInput>;
};

export enum StateCode {
  AtKae = 'AtKae',
  AtNoe = 'AtNoe',
  AtOoe = 'AtOoe',
  Bl = 'BL',
  Custom = 'CUSTOM',
  DeBb = 'DeBb',
  DeBe = 'DeBe',
  DeBw = 'DeBw',
  DeBy = 'DeBy',
  DeHb = 'DeHb',
  DeHe = 'DeHe',
  DeHh = 'DeHh',
  DeMv = 'DeMv',
  DeNi = 'DeNi',
  DeNw = 'DeNw',
  DeRp = 'DeRp',
  DeSh = 'DeSh',
  DeSl = 'DeSl',
  DeSn = 'DeSn',
  DeSt = 'DeSt',
  DeTh = 'DeTh',
  National = 'NATIONAL',
  Sb = 'SB',
  Sm = 'SM',
  Ti = 'TI',
  Va = 'VA',
  Wi = 'WI'
}

export type Subscription = {
  createDate: Scalars['DateTime'];
  featureAdditionalItems: Scalars['Boolean'];
  featureAdminManagement: Scalars['Boolean'];
  featureAreaManager: Scalars['Boolean'];
  featureAssistantApp: Scalars['Boolean'];
  featureAttendanceListBulk: Scalars['Boolean'];
  featureBankImport: Scalars['Boolean'];
  featureBillingStatus: Scalars['Boolean'];
  featureCalendarFeed: Scalars['Boolean'];
  featureDataErasure: Scalars['Boolean'];
  featureDataExport: Scalars['Boolean'];
  featureDiscountCodes: Scalars['Boolean'];
  featureDunning: Scalars['Boolean'];
  featureExport: Scalars['Boolean'];
  featureExportInstructorLessons: Scalars['Boolean'];
  featureExtendedBadges: Scalars['Boolean'];
  featureHelpLinks: Scalars['Boolean'];
  featureInterestList: Scalars['Boolean'];
  featureInvoicePdfPuppeteer: Scalars['Boolean'];
  featureLessonBooking: Scalars['Boolean'];
  featureLiveRefresh: Scalars['Boolean'];
  featureMailMerge: Scalars['Boolean'];
  featureMollie: Scalars['Boolean'];
  featureNewsletter: Scalars['Boolean'];
  featurePrerequisiteCourses: Scalars['Boolean'];
  featureRefactoredCourseDetails: Scalars['Boolean'];
  featureSms: Scalars['Boolean'];
  featureStaffLogin: Scalars['Boolean'];
  featureTransferWizard: Scalars['Boolean'];
  featureWebModulAdminAccess: Scalars['Boolean'];
  featureWeekPlaner: Scalars['Boolean'];
  holidays: Scalars['Boolean'];
  id: Scalars['ID'];
  maxBookingsPerYear?: Maybe<Scalars['Int']>;
  maxLocations?: Maybe<Scalars['Int']>;
  mollieApplicationFeeFixed: Scalars['Float'];
  mollieApplicationFeePercent: Scalars['Float'];
  monthlyFee: Scalars['Float'];
  seatsAdmin: Scalars['Float'];
  seatsInstructor: Scalars['Float'];
  subscriptionType: SubscriptionType;
  updateDate: Scalars['DateTime'];
};

export type SubscriptionFeaturesInput = {
  featureAdditionalItems?: Maybe<Scalars['Boolean']>;
  featureAdminManagement?: Maybe<Scalars['Boolean']>;
  featureAreaManager?: Maybe<Scalars['Boolean']>;
  featureAssistantApp?: Maybe<Scalars['Boolean']>;
  featureAttendanceListBulk?: Maybe<Scalars['Boolean']>;
  featureBankImport?: Maybe<Scalars['Boolean']>;
  featureBillingStatus?: Maybe<Scalars['Boolean']>;
  featureCalendarFeed?: Maybe<Scalars['Boolean']>;
  featureDataErasure?: Maybe<Scalars['Boolean']>;
  featureDataExport?: Maybe<Scalars['Boolean']>;
  featureDiscountCodes?: Maybe<Scalars['Boolean']>;
  featureDunning?: Maybe<Scalars['Boolean']>;
  featureExport?: Maybe<Scalars['Boolean']>;
  featureExportInstructorLessons?: Maybe<Scalars['Boolean']>;
  featureExtendedBadges?: Maybe<Scalars['Boolean']>;
  featureHelpLinks?: Maybe<Scalars['Boolean']>;
  featureInterestList?: Maybe<Scalars['Boolean']>;
  featureInvoicePdfPuppeteer?: Maybe<Scalars['Boolean']>;
  featureLessonBooking?: Maybe<Scalars['Boolean']>;
  featureLiveRefresh?: Maybe<Scalars['Boolean']>;
  featureMailMerge?: Maybe<Scalars['Boolean']>;
  featureMollie?: Maybe<Scalars['Boolean']>;
  featureNewsletter?: Maybe<Scalars['Boolean']>;
  featurePrerequisiteCourses?: Maybe<Scalars['Boolean']>;
  featureRefactoredCourseDetails?: Maybe<Scalars['Boolean']>;
  featureSms?: Maybe<Scalars['Boolean']>;
  featureStaffLogin?: Maybe<Scalars['Boolean']>;
  featureTransferWizard?: Maybe<Scalars['Boolean']>;
  featureWebModulAdminAccess?: Maybe<Scalars['Boolean']>;
  featureWeekPlaner?: Maybe<Scalars['Boolean']>;
  holidays?: Maybe<Scalars['Boolean']>;
  maxBookingsPerYear?: Maybe<Scalars['Int']>;
  maxLocations?: Maybe<Scalars['Int']>;
  mollieApplicationFeeFixed?: Maybe<Scalars['Float']>;
  mollieApplicationFeePercent?: Maybe<Scalars['Float']>;
  monthlyFee?: Maybe<Scalars['Float']>;
  seatsAdmin?: Maybe<Scalars['Float']>;
  seatsInstructor?: Maybe<Scalars['Float']>;
};

export enum SubscriptionType {
  StandardSubscription = 'StandardSubscription',
  TestSubscription = 'TestSubscription'
}

export type SupportReportInput = {
  context: Scalars['String'];
  description: Scalars['String'];
  kind: SupportReportKind;
  reporterName?: Maybe<Scalars['String']>;
  screenshot?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export enum SupportReportKind {
  Bug = 'Bug',
  Idea = 'Idea',
  Question = 'Question'
}

export type SwissQrFile = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  fileContent: Scalars['String'];
  fileId: Scalars['String'];
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  records?: Maybe<Array<SwissQrFileRecord>>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type SwissQrFileOverview = {
  ambiguousCount: Scalars['Float'];
  createDate?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  errorCount: Scalars['Float'];
  fileId?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  overpaidCount: Scalars['Float'];
  paidCount: Scalars['Float'];
  resolvedCount: Scalars['Float'];
  totalAmount: Scalars['Float'];
  totalRecords: Scalars['Float'];
  underpaidCount: Scalars['Float'];
};

export type SwissQrFileOverviewWithPagination = {
  items: Array<SwissQrFileOverview>;
  openRecordCount: Scalars['Int'];
  total: Scalars['Int'];
};

export type SwissQrFileRecord = {
  amount: Scalars['Float'];
  comment: Scalars['String'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  creditAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  originalOpenAmount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  result: Scalars['String'];
  scheduledPayment?: Maybe<ScheduledPayment>;
  scheduledPaymentId?: Maybe<Scalars['ID']>;
  successful: Scalars['Boolean'];
  swissQRFile?: Maybe<SwissQrFile>;
  swissQRFileId?: Maybe<Scalars['ID']>;
  swissQrRef: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  valutaDate: Scalars['DateTime'];
};

export type SwissQrRecordContext = {
  invoiceEvents: Array<SwissQrRecordContextEvent>;
  otherRates: Array<SwissQrRecordContextRate>;
};

export type SwissQrRecordContextEvent = {
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  kind: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

export type SwissQrRecordContextRate = {
  amount: Scalars['Float'];
  attendeeName?: Maybe<Scalars['String']>;
  bookingId: Scalars['ID'];
  bookingNumber: Scalars['String'];
  invoiceNumber?: Maybe<Scalars['String']>;
  openAmount: Scalars['Float'];
  paidWithoutReceipt: Scalars['Boolean'];
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentDue?: Maybe<Scalars['DateTime']>;
  scheduledPaymentId: Scalars['ID'];
};

export type TableColumnsInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sortIndex?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['String']>;
};

export enum TablesEnum {
  AreaManagerAssistantOverview = 'AreaManagerAssistantOverview',
  AreaManagerCourseUtilization = 'AreaManagerCourseUtilization',
  AreaManagerInstructorUtilization = 'AreaManagerInstructorUtilization',
  AreaManagerLocationOverview = 'AreaManagerLocationOverview',
  AreaManagerVenueUtilization = 'AreaManagerVenueUtilization',
  AttendanceList = 'AttendanceList',
  AttendanceListBulk = 'AttendanceListBulk',
  Attendees = 'Attendees',
  AttendeesOverview = 'AttendeesOverview',
  AttendeeTransferToBooker = 'AttendeeTransferToBooker',
  BillingStatusByInstructor = 'BillingStatusByInstructor',
  BillingStatusChronological = 'BillingStatusChronological',
  BookerExportModal = 'BookerExportModal',
  BookerOverview = 'BookerOverview',
  Bookers = 'Bookers',
  Bookings = 'Bookings',
  BookingsAttendeeDetails = 'BookingsAttendeeDetails',
  BookingsByCourse = 'BookingsByCourse',
  BookingsByCourseExpandedBookings = 'BookingsByCourseExpandedBookings',
  BookingsInStartedCourses = 'BookingsInStartedCourses',
  BookingsOverview = 'BookingsOverview',
  BookingsShow = 'BookingsShow',
  BookingsShowall = 'BookingsShowall',
  BookingsShowlastMonth = 'BookingsShowlastMonth',
  BookingsShowlastWeek = 'BookingsShowlastWeek',
  BookingsShowthisMonth = 'BookingsShowthisMonth',
  BookingsShowthisWeek = 'BookingsShowthisWeek',
  BookingsShowthisYear = 'BookingsShowthisYear',
  BookingsShowtoday = 'BookingsShowtoday',
  BookingsShowtwentyFour = 'BookingsShowtwentyFour',
  BookingsShowyesterday = 'BookingsShowyesterday',
  CanceledBookingsListExport = 'CanceledBookingsListExport',
  CertificateAssignByAttendeeColumns = 'CertificateAssignByAttendeeColumns',
  CertificateAssignByCourseAttendeeColumns = 'CertificateAssignByCourseAttendeeColumns',
  CertificateAssignCourseSelector = 'CertificateAssignCourseSelector',
  CourseCategories = 'CourseCategories',
  CourseDetailsCanceledBookingsList = 'CourseDetailsCanceledBookingsList',
  CourseDetailsCanceledBookingsList2 = 'CourseDetailsCanceledBookingsList2',
  CourseDetailsPlaceReservations = 'CourseDetailsPlaceReservations',
  CourseDetailsPlacereservationsList2 = 'CourseDetailsPlacereservationsList2',
  CourseDetailsSettledBookings = 'CourseDetailsSettledBookings',
  CourseDetailsSettledBookingsList2 = 'CourseDetailsSettledBookingsList2',
  CourseDetailsSettledPlacereservations = 'CourseDetailsSettledPlacereservations',
  CourseDetailsUnsettledBookings = 'CourseDetailsUnsettledBookings',
  CourseDetailsUnsettledBookingsList2 = 'CourseDetailsUnsettledBookingsList2',
  CourseDetailsWaitlist = 'CourseDetailsWaitlist',
  CourseDetailsWaitlistList2 = 'CourseDetailsWaitlistList2',
  CourseLessonTable = 'CourseLessonTable',
  CourseOverview = 'CourseOverview',
  CourseOverviewExport = 'CourseOverviewExport',
  Courses = 'Courses',
  CourseSelectPrerequisiteCourses = 'CourseSelectPrerequisiteCourses',
  CourseTransferAttendeeToCourse = 'CourseTransferAttendeeToCourse',
  CourseTypes = 'CourseTypes',
  CreateLessonBookingAttendeeList = 'CreateLessonBookingAttendeeList',
  CreateLessonBookingCourseList = 'CreateLessonBookingCourseList',
  DonePaymentsList = 'DonePaymentsList',
  DonePaymentsListExport = 'DonePaymentsListExport',
  EmailTemplatePicker = 'EmailTemplatePicker',
  EmailTemplatesList = 'EmailTemplatesList',
  Instructors = 'Instructors',
  InterestLists = 'InterestLists',
  InterestRegistrations = 'InterestRegistrations',
  InvoiceListByBookingUnsetteled = 'InvoiceListByBookingUnsetteled',
  InvoiceListByCourse = 'InvoiceListByCourse',
  InvoicesByCourse = 'InvoicesByCourse',
  InvoicesReversals = 'InvoicesReversals',
  InvoicesSettled = 'InvoicesSettled',
  InvoicesUnsetteled = 'InvoicesUnsetteled',
  LessonBookingDetails = 'LessonBookingDetails',
  LessonBookings = 'LessonBookings',
  LocationOverviewTable = 'LocationOverviewTable',
  Locations = 'Locations',
  MolliePaymentsList = 'MolliePaymentsList',
  MyBookings = 'MyBookings',
  MyBookingsByCourse = 'MyBookingsByCourse',
  MyBookingsOverview = 'MyBookingsOverview',
  NotificationBookerMissmatch = 'NotificationBookerMissmatch',
  NotificationsByBookerId = 'NotificationsByBookerId',
  NotificationsByBookingId = 'NotificationsByBookingId',
  NotificationsSent = 'NotificationsSent',
  OpenPaymentsList = 'OpenPaymentsList',
  OpenPaymentsListExport = 'OpenPaymentsListExport',
  PaymentsOpen = 'PaymentsOpen',
  PaymentsPaid = 'PaymentsPaid',
  PrerequisiteCourses = 'PrerequisiteCourses',
  SelectAttendee = 'SelectAttendee',
  SettledBookingDonePaymentsList = 'SettledBookingDonePaymentsList',
  SettledBookingOpenPaymentsList = 'SettledBookingOpenPaymentsList',
  SettledBookingsListExport = 'SettledBookingsListExport',
  Staff = 'Staff',
  StaffAll = 'StaffAll',
  StaffAllInstructor = 'StaffAllInstructor',
  StepSelectCourse = 'StepSelectCourse',
  TodaysCourseLessonsExport = 'TodaysCourseLessonsExport',
  TodaysCourseLessonsList = 'TodaysCourseLessonsList',
  TransferCourseSelector = 'TransferCourseSelector',
  TransferMultipleAttendeesSelectCourse = 'TransferMultipleAttendeesSelectCourse',
  TransferSimpleCourseSelector = 'TransferSimpleCourseSelector',
  UnsettledBookingsListExport = 'UnsettledBookingsListExport',
  ZeroValuePayments = 'ZeroValuePayments'
}

export type TableStatsOutput = {
  deletes: Scalars['Float'];
  idxScan: Scalars['Float'];
  indexUsagePercent: Scalars['Float'];
  inserts: Scalars['Float'];
  schemaname: Scalars['String'];
  seqScan: Scalars['Float'];
  size: Scalars['String'];
  tablename: Scalars['String'];
  updates: Scalars['Float'];
};

export type Template = {
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  footerText?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  includeCourseDetails: Scalars['Boolean'];
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
  isDefault: Scalars['Boolean'];
  mailDataType?: Maybe<MailDataType>;
  name?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  templateType: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type TemplatesWithPagination = {
  existsMore: Scalars['Boolean'];
  items: Array<Template>;
  total: Scalars['Float'];
};

export enum TemplateType {
  AttendanceList = 'AttendanceList',
  BookingCancellation = 'BookingCancellation',
  BookingConfirmation = 'BookingConfirmation',
  BookingConfirmationMollie = 'BookingConfirmationMollie',
  DunningLevel1 = 'DunningLevel1',
  DunningLevel2 = 'DunningLevel2',
  DunningLevel3 = 'DunningLevel3',
  DunningReminder = 'DunningReminder',
  FreeText = 'FreeText',
  InterestListConfirmation = 'InterestListConfirmation',
  Invoice = 'Invoice',
  InvoiceMonthly = 'InvoiceMonthly',
  InvoiceMonthlyConsistent = 'InvoiceMonthlyConsistent',
  InvoiceReversal = 'InvoiceReversal',
  InvoiceReversalMonthly = 'InvoiceReversalMonthly',
  InvoiceReversalMonthlyConsistent = 'InvoiceReversalMonthlyConsistent',
  MolliePaymentCanceled = 'MolliePaymentCanceled',
  MolliePaymentExpired = 'MolliePaymentExpired',
  MolliePaymentFailed = 'MolliePaymentFailed',
  NoTemplate = 'NoTemplate',
  Reminder = 'Reminder',
  SettledBookingCancellation = 'SettledBookingCancellation',
  SettlementConfirmation = 'SettlementConfirmation',
  Transfer = 'Transfer',
  WaitingListConfirmation = 'WaitingListConfirmation',
  Warning = 'Warning'
}

export type TenantActivitySummary = {
  activeCourses: Scalars['Int'];
  activityStatus: Scalars['String'];
  daysSinceLastActivity: Scalars['Int'];
  koOrganizationId: Scalars['String'];
  lastBookingCreated?: Maybe<Scalars['DateTime']>;
  lastCourseCreated?: Maybe<Scalars['DateTime']>;
  lastDataModification?: Maybe<Scalars['DateTime']>;
  lastInvoiceCreated?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  tenantName: Scalars['String'];
  totalAttendees: Scalars['Int'];
  totalBookings: Scalars['Int'];
  totalCourses: Scalars['Int'];
  totalInvoices: Scalars['Int'];
};

export type TenantAdminInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  role: Scalars['String'];
};

export type TenantDeletionImpact = {
  entityCounts: Array<EntityCount>;
  koOrganizationId: Scalars['String'];
  tenantName: Scalars['String'];
  totalDatabaseRecords: Scalars['Int'];
};

export type TenantDeletionLog = {
  action: Scalars['String'];
  id: Scalars['ID'];
  koOrganizationId: Scalars['String'];
  performedAt: Scalars['DateTime'];
  performedByUserId: Scalars['String'];
  stepName?: Maybe<Scalars['String']>;
  tenantName: Scalars['String'];
};

export type TenantDeletionResult = {
  deletedRecordCounts: Array<EntityCount>;
  errors?: Maybe<Array<Scalars['String']>>;
  startedAsync?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
  tenantName: Scalars['String'];
};

export type TenantDeletionStatus = {
  deletedRecordCounts?: Maybe<Array<EntityCount>>;
  deletionState: Scalars['String'];
  externalErrors?: Maybe<Array<Scalars['String']>>;
  lastAction?: Maybe<Scalars['String']>;
  lastErrorMessage?: Maybe<Scalars['String']>;
  lastStepName?: Maybe<Scalars['String']>;
};

export enum TenantLateEntryPricingPolicy {
  Individual = 'INDIVIDUAL',
  OriginalPrice = 'ORIGINAL_PRICE',
  RemainingLessons = 'REMAINING_LESSONS'
}

export type TenantMetrics = {
  bookersTotal: Scalars['Float'];
  bookersTotalOnline: Scalars['Float'];
  bookings: Scalars['Float'];
  bookingsAdmin: Scalars['Float'];
  bookingsCurrentYear: Scalars['Int'];
  bookingsOnline: Scalars['Float'];
  bookingVolume: Scalars['Float'];
  cancellations: Scalars['Float'];
  courses: Scalars['Float'];
  emailsSent: Scalars['Float'];
  koOrganizationId: Scalars['String'];
  locationsCount: Scalars['Int'];
  maxBookingsPerYear?: Maybe<Scalars['Int']>;
  maxLocations?: Maybe<Scalars['Int']>;
  monthlyFee?: Maybe<Scalars['Float']>;
  newBookers: Scalars['Float'];
  newBookersOnline: Scalars['Float'];
  revenuePaid: Scalars['Float'];
  seatsAdmin: Scalars['Int'];
  seatsInstructor: Scalars['Int'];
  subscriptionType?: Maybe<Scalars['String']>;
  tenantName: Scalars['String'];
  waitlist: Scalars['Float'];
};

export type TenantMetricsAiEvidence = {
  changePercent?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  currentValue: Scalars['Float'];
  direction: Scalars['String'];
  factRef: Scalars['String'];
  metric: Scalars['String'];
  previousValue: Scalars['Float'];
  scope: Scalars['String'];
  tenantId?: Maybe<Scalars['ID']>;
  tenantName?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
  windowDays: Scalars['Int'];
};

export type TenantMetricsAiInsight = {
  category: Scalars['String'];
  evidence: Array<TenantMetricsAiEvidence>;
  explanation: Scalars['String'];
  observationRef: Scalars['String'];
  severity: Scalars['String'];
  tenantName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type TenantMetricsAiSummary = {
  caveats: Array<Scalars['String']>;
  dataThrough?: Maybe<Scalars['String']>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  headline?: Maybe<Scalars['String']>;
  insights: Array<TenantMetricsAiInsight>;
  isAiGenerated: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  status: TenantMetricsAiSummaryStatus;
};

export enum TenantMetricsAiSummaryStatus {
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Stale = 'STALE'
}

export type TenantNotification = {
  broadcastId: Scalars['String'];
  createDate: Scalars['DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  koOrganizationId?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  sendDate: Scalars['DateTime'];
  senderId?: Maybe<Scalars['String']>;
  status: TenantNotificationStatus;
  subject: Scalars['String'];
  tenantName?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
};

export type TenantNotificationResultType = {
  email?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  status: TenantNotificationStatus;
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};

export enum TenantNotificationStatus {
  Failed = 'Failed',
  Sent = 'Sent',
  Skipped = 'Skipped'
}

export type TenantRecipientInput = {
  email: Scalars['String'];
  koOrganizationId: Scalars['ID'];
  tenantName: Scalars['String'];
};

export type TenantRecipientType = {
  isDefaultRecipient: Scalars['Boolean'];
  ownerEmail?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  tenantName: Scalars['String'];
};

export type TenantSeatUsage = {
  adminCount?: Maybe<Scalars['Int']>;
  instructorCount?: Maybe<Scalars['Int']>;
  koOrganizationId: Scalars['String'];
};

export type TenantStaffMember = {
  actionCount: Scalars['Float'];
  activeDays: Scalars['Float'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  userId: Scalars['String'];
};

export type TextBlockPreviewCurrent = {
  empty: Array<Scalars['String']>;
  footerText: Scalars['String'];
  headerText: Scalars['String'];
  index: Scalars['Int'];
  replaced: Array<Scalars['String']>;
  signature: Scalars['String'];
  subject: Scalars['String'];
  unknown: Array<Scalars['String']>;
};

export type TextBlockPreviewInput = {
  editedTemplateInput?: Maybe<EditTemplateInput>;
  ids: Array<Scalars['ID']>;
  mailDataType: MailDataType;
  notifyBookings?: Maybe<Scalars['Boolean']>;
  notifyCancelations?: Maybe<Scalars['Boolean']>;
  notifyWaitlist?: Maybe<Scalars['Boolean']>;
  recipientIndex?: Maybe<Scalars['Int']>;
  sampleData?: Maybe<Scalars['Boolean']>;
  summary?: Maybe<Scalars['Boolean']>;
  templateId: Scalars['String'];
};

export type TextBlockPreviewRecipient = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TextBlockPreviewResult = {
  current?: Maybe<TextBlockPreviewCurrent>;
  recipients: Array<TextBlockPreviewRecipient>;
  summary?: Maybe<TextBlockPreviewSummary>;
};

export type TextBlockPreviewSummary = {
  emptyVariables: Array<Scalars['String']>;
  recipientsWithEmpty: Scalars['Int'];
  recipientsWithUnknown: Scalars['Int'];
  total: Scalars['Int'];
};

export type TextEntriesInput = {
  header?: Maybe<Scalars['String']>;
  memberDiscountTitle?: Maybe<Scalars['String']>;
};

export type ThirdPartyLoginInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ThirdPartyUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ToggleAreaManagerRoleInput = {
  enabled: Scalars['Boolean'];
  sendNotification?: Maybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type ToggleAttendeeBadgeRequirementInput = {
  attendeeBadgeRequirementId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  fulfilled: Scalars['Boolean'];
};

export type ToggleUserRoleInput = {
  enabled: Scalars['Boolean'];
  role: Scalars['String'];
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};

export type TransferAttendedLessonsPreview = {
  /** Betrag des Lektions-Postens (brutto, Steuersatz der bisherigen Buchung). */
  amount: Scalars['Float'];
  /** Bis zum Umbuchungstag begonnene Lektionen des bisherigen Kurses. */
  lessonsAttended: Scalars['Int'];
  lessonsTotal: Scalars['Int'];
  /** Bezeichnung des Postens, z. B. „Teilnahme Kurs SK-1, 3 von 10 Lektionen“. */
  title: Scalars['String'];
};

export type TransferBookingInput = {
  bookingId: Scalars['ID'];
  isSettled: Scalars['Boolean'];
  originBookingType: BookingType;
  targetBookingType: BookingType;
  usePlaceReservation: Scalars['Boolean'];
};

export type TransferBulkPlanInput = {
  /**
   * Auto (Default, Geld folgt der Buchung) oder CutoffRule (Teilnahme bis zum
   * Stichtag ist abgegolten) — Vorgabe für alle Buchungen, wirkt je Buchung nur,
   * wo sie anwendbar ist.
   */
  oldBookingOption?: Maybe<TransferOldBookingOption>;
  /** Nur CoursePrice oder ProRataRemainingLessons; gilt für alle Buchungen. */
  priceOption: TransferPriceOptionInput;
  /** Quellbuchungen in Auswahlreihenfolge (höchstens 10). */
  sourceBookingIds: Array<Scalars['ID']>;
  targetBookingType: BookingType;
  targetCourseId: Scalars['ID'];
};

export type TransferBulkPlanPreview = {
  /** Blocker des gesamten Laufs (Limit, Doppelungen, Freigabe); Blocker je Buchung stehen in rows[].plan.blockers. */
  blockers: Array<Scalars['String']>;
  maxBookings: Scalars['Int'];
  rows: Array<TransferBulkPlanRow>;
  /** Vorlage „Umbuchung“ existiert — sonst ist kein Versand möglich. */
  templateAvailable: Scalars['Boolean'];
};

export type TransferBulkPlanRow = {
  attendeeName: Scalars['String'];
  /**
   * Plan dieser Buchung — Preis B, gezahlt, angewandt, Überschuss, Behandlung der
   * alten Buchung, Hinweise, Blocker, Kommunikations-Defaults.
   */
  plan: TransferPlanPreview;
  sourceBookingId: Scalars['ID'];
  sourceBookingNumber: Scalars['String'];
};

export type TransferBulkRowExpectationInput = {
  /** Bestätigungstoken der Vorschau dieser Buchung. */
  confirmationToken: Scalars['String'];
  expectedAppliedToB: Scalars['Float'];
  expectedCarriedOverItems?: Maybe<Array<TransferCarriedOverItemInput>>;
  expectedDiscountB?: Maybe<Scalars['Float']>;
  expectedOldBookingTreatment: TransferOldBookingTreatment;
  expectedPriceB: Scalars['Float'];
  expectedSurplus: Scalars['Float'];
  sourceBookingId: Scalars['ID'];
};

export type TransferCarriedOverItem = {
  amount: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  type: ScheduledPaymentType;
};

export type TransferCarriedOverItemInput = {
  amount: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  type: ScheduledPaymentType;
};

export type TransferCommunicationDefaults = {
  attachInvoiceB: Scalars['Boolean'];
  attachReversalInvoice: Scalars['Boolean'];
  createInvoiceBNow: Scalars['Boolean'];
  sendMail: Scalars['Boolean'];
  /** Vorlage „Umbuchung“ existiert in der Organisation; ohne sie ist kein Versand möglich. */
  templateAvailable: Scalars['Boolean'];
};

export type TransferCommunicationInput = {
  /** Rechnung der neuen Buchung anhängen (Default: ja, wenn sie sofort erzeugt wird). */
  attachInvoiceB?: Maybe<Scalars['Boolean']>;
  /** Stornobeleg der bisherigen Buchung anhängen (Default: ja bei Storno mit Beleg). */
  attachReversalInvoice?: Maybe<Scalars['Boolean']>;
  /**
   * Rechnung der neuen Buchung sofort erzeugen (Default: ja, wenn die bisherige
   * Buchung abgerechnet war; nie für Wartelistenplätze).
   */
  createInvoiceBNow?: Maybe<Scalars['Boolean']>;
  /**
   * Umbuchungs-E-Mail an den Bucher senden (Default: ja, wenn die Vorlage
   * „Umbuchung“ existiert und Setting.transferSendMail an ist; Standard aus).
   */
  sendMail?: Maybe<Scalars['Boolean']>;
};

/**
 * Verrechnetes Guthaben der bisherigen Buchung: ReapplyToTarget verrechnet
 * denselben Betrag auf die neue Buchung, KeepAsCredit (und fehlendes Feld) lässt
 * ihn im Guthaben. Bei Warteliste immer Guthaben.
 */
export enum TransferCreditedBalanceHandling {
  KeepAsCredit = 'KeepAsCredit',
  ReapplyToTarget = 'ReapplyToTarget'
}

export type TransferCutoffPreview = {
  /**
   * Die bisherige Buchung hat bis zum Stichtag verbrauchte Raten — Stichtag-Regel
   * wählbar. Ob sie Vorschlag ist, entscheidet der Client aus mode und carriedOpen
   * (ADR 0017, Ergänzung 26.10.2026).
   */
  applicable: Scalars['Boolean'];
  carriedOpen: Scalars['Float'];
  lessonsAttended?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  /** dueDate (Raten fällig vor dem Stichtag) oder lessonShare (Einmalzahler: Anteil begonnener Lektionen der Buchung). */
  mode: Scalars['String'];
  rates: Array<TransferCutoffRatePreview>;
  retainedPaid: Scalars['Float'];
};

export type TransferCutoffRatePreview = {
  /** Davon offen: wird Posten auf der neuen Buchung. */
  carriedOpen: Scalars['Float'];
  /** Verbrauchter Betrag der Rate. */
  consumed: Scalars['Float'];
  due?: Maybe<Scalars['DateTime']>;
  /** Davon bezahlt: bleibt auf der bisherigen Buchung (bei abgerechneter Buchung bezahlter Posten auf der neuen). */
  retainedPaid: Scalars['Float'];
  sourceRateId: Scalars['String'];
};

/** Beleg-Referenz im Umbuchungsergebnis (Stornobeleg oder Rechnung) — reicht für Anzeige und PDF-Vorschau. */
export type TransferInvoiceRef = {
  id: Scalars['ID'];
  invoiceNumber: Scalars['Float'];
  invoiceNumberPrefix: Scalars['String'];
};

export type TransferItemDecisionInput = {
  carry: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  sourceRateId: Scalars['ID'];
};

export type TransferItemReview = {
  amount: Scalars['Float'];
  carried: Scalars['Float'];
  carry: Scalars['Boolean'];
  open: Scalars['Float'];
  paid: Scalars['Float'];
  reason?: Maybe<Scalars['String']>;
  sourceRateId: Scalars['ID'];
  title: Scalars['String'];
  type: ScheduledPaymentType;
  vat: Scalars['Float'];
  waived: Scalars['Float'];
};

/** Verfahren des Umbuchen-Dialogs: bisheriges Verfahren (Legacy) oder Umbuchungs-Engine (Wizard). */
export enum TransferMode {
  Legacy = 'Legacy',
  Wizard = 'Wizard'
}

export type TransferMultipleBookingsInput = {
  bookings: Array<TransferBookingInput>;
  copyBookings: Scalars['Boolean'];
  notifyBooker: Scalars['Boolean'];
  originCourseId: Scalars['ID'];
  targetCourseId: Scalars['ID'];
};

/**
 * Standard-Wahl zur bisherigen Buchung beim Umbuchen: Auto (Stichtag-Regel
 * vorschlagen, wo anwendbar) oder MoneyFollowsBooking (Geld folgt der Buchung).
 */
export enum TransferOldBookingDefault {
  Auto = 'Auto',
  MoneyFollowsBooking = 'MoneyFollowsBooking'
}

/**
 * Alte Buchung: Geld folgt der Buchung (Auto) oder Teilnahme bis zum Stichtag ist
 * abgegolten (CutoffRule). ChargeAttendedLessons ist veraltet und wirkt wie Auto.
 */
export enum TransferOldBookingOption {
  Auto = 'Auto',
  ChargeAttendedLessons = 'ChargeAttendedLessons',
  CutoffRule = 'CutoffRule'
}

export type TransferOldBookingOptionPreview = {
  /** Buchungspreis der neuen Buchung (alle Raten und Posten). */
  bookingPrice: Scalars['Float'];
  /** Fälligkeit der ersten Kursrate der neuen Buchung. */
  firstDue?: Maybe<Scalars['DateTime']>;
  kind: TransferOldBookingOption;
  /** Nach dem Übertrag offen auf der neuen Buchung. */
  open: Scalars['Float'];
  surplus: Scalars['Float'];
  /** Aus der bisherigen Buchung übertragenes Geld (angewandt plus Überschuss). */
  transferred: Scalars['Float'];
};

export type TransferOldBookingPlan = {
  reason: Scalars['String'];
  treatment: TransferOldBookingTreatment;
};

/** Was mit der alten Buchung geschieht: Storno mit Beleg, Storno ohne Beleg oder Löschen. */
export enum TransferOldBookingTreatment {
  CancelWithoutReceipt = 'CancelWithoutReceipt',
  CancelWithReceipt = 'CancelWithReceipt',
  Delete = 'Delete'
}

/** Teilbuchung als Quelle (#1558): der Rest der Karte zieht auf die neue Buchung mit. */
export type TransferPartialSourcePreview = {
  /** Davon bis zum Stichtag begonnen. */
  attended: Scalars['Int'];
  /** Gebuchte Lektionen der bisherigen Buchung (die Karte). */
  cardLessons: Scalars['Int'];
  /** Auf die neue Buchung gebuchte Lektionen (höchstens der Rest, begrenzt durch die künftigen Lektionen des Zielkurses). */
  chosen: Scalars['Int'];
  /** Kurspreis des Zielkurses je Lektion. */
  lessonPrice: Scalars['Float'];
  /** Preis der neuen Buchung = gewählte Lektionen × Lektionspreis. */
  price: Scalars['Float'];
  /** Rest der Karte. */
  remaining: Scalars['Int'];
};

export type TransferPlanInput = {
  /** Verrechnetes Guthaben der bisherigen Buchung: ReapplyToTarget oder KeepAsCredit (Default, wie ohne Feld). */
  creditedBalanceHandling?: Maybe<TransferCreditedBalanceHandling>;
  /** Entscheidung je ursprünglichem Posten. Ohne Auswahl werden offene Posten übernommen. */
  itemDecisions?: Maybe<Array<TransferItemDecisionInput>>;
  /**
   * Wahl zur alten Buchung: Auto (Default, Geld folgt der Buchung) oder CutoffRule
   * (Teilnahme bis zum Stichtag ist abgegolten).
   */
  oldBookingOption?: Maybe<TransferOldBookingOption>;
  priceOption: TransferPriceOptionInput;
  sourceBookingId: Scalars['ID'];
  /** Schritt 4 (#665): Verwendung des Überschusses — Credit (Default), MollieRefund oder ManualRefund mit Grund. */
  surplusHandling?: Maybe<TransferSurplusHandlingInput>;
  targetBookingType: BookingType;
  targetCourseId: Scalars['ID'];
};

export type TransferPlannedRate = {
  amount: Scalars['Float'];
  due: Scalars['DateTime'];
  fullyCovered: Scalars['Boolean'];
  /** "plan" = Staffel des Zielkurses, "carriedOver" = offener Posten aus der alten Buchung. */
  origin: Scalars['String'];
  /** Aus dem Übertrag getilgter Teil dieser Rate. */
  settledByTransfer: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  type: ScheduledPaymentType;
};

export type TransferPlanPreview = {
  /** Davon per Übertrag auf die Raten der neuen Buchung angewandt. */
  appliedToB: Scalars['Float'];
  /** @deprecated #1557: Lektions-Posten entfallen, immer null. */
  attendedLessons?: Maybe<TransferAttendedLessonsPreview>;
  blockers: Array<Scalars['String']>;
  carriedOverItems: Array<TransferCarriedOverItem>;
  /** Effektive Vorbelegung für Wizard-Schritt 5 (Mail, Anhänge, Rechnung sofort); null in der Ausführungs-Antwort. */
  communicationDefaults?: Maybe<TransferCommunicationDefaults>;
  confirmationToken: Scalars['String'];
  /** Listenpreis des Zielkurses (bei Abrechnung pro Lektion × Lektionen) — Bezug für den manuellen Preis. */
  coursePrice: Scalars['Float'];
  /** Guthaben-Saldo des Buchers nach der Umbuchung (nach der gewählten Überschuss-Verwendung). */
  creditAfter: Scalars['Float'];
  /** Davon auf die neue Buchung verrechnet (Kursraten entsprechend gemindert). */
  creditReapplied: Scalars['Float'];
  /** Stichtag-Regel (#1557), unabhängig von der Wahl berechnet. */
  cutoff: TransferCutoffPreview;
  /** Die Stichtag-Regel ist gewählt und wirkt. */
  cutoffApplied: Scalars['Boolean'];
  /** Rabatt aus der Preisoption (anteilig/manuell) — ohne Mitgliederrabatt. */
  discountB: Scalars['Float'];
  discountReason?: Maybe<Scalars['String']>;
  /**
   * Offene Mollie-Zahlung (Zahlungslink oder begonnene Direktzahlung) auf einer
   * Rate der bisherigen Buchung (steht auch in blockers) — per
   * voidMolliePaymentLinkForBooking entwerten.
   */
  hasActivePaymentLink: Scalars['Boolean'];
  hints: Array<Scalars['String']>;
  itemReview: Array<TransferItemReview>;
  /** Mitgliederrabatt des Zielkurses, in priceB bereits abgezogen (0, wenn keiner greift). */
  memberDiscountB: Scalars['Float'];
  oldBooking: TransferOldBookingPlan;
  /** Folge beider Wahlen zur alten Buchung; leer, wenn die Stichtag-Regel nicht anwendbar ist. */
  oldBookingOptions: Array<TransferOldBookingOptionPreview>;
  /** In der alten Buchung tatsächlich gezahltes Geld. */
  paidA: Scalars['Float'];
  /** Teilbuchung als Quelle (#1558); null bei Vollbuchungen. */
  partialSource?: Maybe<TransferPartialSourcePreview>;
  /** Preis der neuen Buchung (brutto) nach Preisoption UND abgezogenem Mitgliederrabatt. */
  priceB: Scalars['Float'];
  /**
   * Beträge je wählbarer Preisoption (Kurspreis, anteilig, Rabatt übernehmen —
   * letztere nur bei Rabatt in A) aus EINER Vorschau.
   */
  priceOptions: Array<TransferPriceOptionPreview>;
  rates: Array<TransferPlannedRate>;
  /** Verrechnetes Guthaben der bisherigen Buchung (fließt beim Storno/Löschen ins Journal zurück). */
  sourceCreditedBalance: Scalars['Float'];
  /** Manueller Rabatt der bisherigen Buchung (0, wenn keiner vergeben ist) — Grundlage der Frage „Rabatt übernehmen?“. */
  sourceDiscount: Scalars['Float'];
  /** Grund des manuellen Rabatts der bisherigen Buchung. */
  sourceDiscountName?: Maybe<Scalars['String']>;
  /** Nicht angewandter Rest — bleibt Guthaben, sofern surplusHandling nichts anderes wählt. */
  surplus: Scalars['Float'];
  /** Gewählte (oder Default-)Verwendung des Überschusses mit Beträgen (#665). */
  surplusHandling: TransferSurplusHandlingPreview;
  /** Möglich-Prüfung für die Mollie-Erstattung des Überschusses (#665), unabhängig von der Wahl. */
  surplusMollieRefund: TransferSurplusMollieRefundPreview;
  /**
   * Verwendeter Umbuchungstag (Stichtag für priceOptions und die Stichtag-Regel).
   * Bei der Ausführung als priceOption.transferDate zurücksenden, damit Vorschau
   * und Ausführung denselben Stichtag rechnen.
   */
  transferDate: Scalars['DateTime'];
  vatB: Scalars['Float'];
};

/** Standard-Preisoption des Umbuchungs-Wizards (Kurspreis des Zielkurses oder Rabatt der bisherigen Buchung uebernehmen). */
export enum TransferPriceDefault {
  CoursePrice = 'CoursePrice',
  KeepSourceDiscount = 'KeepSourceDiscount'
}

/**
 * Preisfindung für die neue Buchung: Kurspreis, anteilig nach verbleibenden
 * Lektionen, manuell oder Kurspreis abzüglich des übernommenen Rabatts der
 * bisherigen Buchung.
 */
export enum TransferPriceKind {
  CoursePrice = 'CoursePrice',
  KeepSourceDiscount = 'KeepSourceDiscount',
  Manual = 'Manual',
  ProRataRemainingLessons = 'ProRataRemainingLessons'
}

export type TransferPriceOptionInput = {
  /** Manueller Bruttopreis (Pflicht bei Manual). */
  amount?: Maybe<Scalars['Float']>;
  kind: TransferPriceKind;
  /** Begründung des manuellen Preises (Pflicht bei Manual). */
  reason?: Maybe<Scalars['String']>;
  /**
   * Umbuchungstag. Pflicht bei ProRataRemainingLessons; bei jeder anderen Preisart
   * optionaler Stichtag für die Vorschau der anteiligen Option (priceOptions) und
   * der besuchten Lektionen (attendedLessons). Fehlt er, gilt der Aufrufzeitpunkt.
   */
  transferDate?: Maybe<Scalars['DateTime']>;
};

export type TransferPriceOptionPreview = {
  /** Rabatt aus der Preisoption (ohne Mitgliederrabatt). */
  discountB: Scalars['Float'];
  kind: TransferPriceKind;
  /** Nur bei ProRataRemainingLessons: ab Umbuchungstag verbleibende Lektionen. */
  lessonsRemaining?: Maybe<Scalars['Int']>;
  /** Nur bei ProRataRemainingLessons: Lektionen des Zielkurses gesamt. */
  lessonsTotal?: Maybe<Scalars['Int']>;
  /** Mitgliederrabatt des Zielkurses, in priceB bereits abgezogen. */
  memberDiscountB: Scalars['Float'];
  /** Preis der neuen Buchung mit dieser Option (nach Preisoption UND Mitgliederrabatt). */
  priceB: Scalars['Float'];
};

export type TransferSourceDeleteActionInput = {
  /** Nur bei SELECT_FROM_WAITING_LIST: der ausgewählte Wartelistenplatz. */
  bookingId?: Maybe<Scalars['ID']>;
  /** Bestätigungsmail an den nachgerückten Bucher (Default: nein). */
  notifyPromotedBooker?: Maybe<Scalars['Boolean']>;
  type: BookingDeleteActionType;
};

/**
 * Überschuss der Umbuchung: Guthaben (Default), sofortige Mollie-Erstattung (nur
 * Überschuss, jüngste Zahlung) oder manuell erstattet (nur Journal-Vermerk mit Grund).
 */
export enum TransferSurplusHandling {
  Credit = 'Credit',
  ManualRefund = 'ManualRefund',
  MollieRefund = 'MollieRefund'
}

export type TransferSurplusHandlingInput = {
  kind: TransferSurplusHandling;
  /** Pflicht bei ManualRefund: wohin/wie das Geld außerhalb erstattet wurde. */
  reason?: Maybe<Scalars['String']>;
};

export type TransferSurplusHandlingPreview = {
  /** Teil des Überschusses, der Guthaben bleibt. */
  creditAmount: Scalars['Float'];
  kind: TransferSurplusHandling;
  /** Grund der manuellen Erstattung. */
  reason?: Maybe<Scalars['String']>;
  /** Über Mollie zu erstattender Betrag (0 außer bei MollieRefund). */
  refundAmount: Scalars['Float'];
};

export type TransferSurplusMollieRefundPreview = {
  /** Betrag, der über Mollie erstattet würde — nie mehr als der Überschuss. */
  amount: Scalars['Float'];
  /** Betroffene Zahlung(en), jüngste zuerst. */
  payments: Array<TransferSurplusRefundPayment>;
  /** Mollie-Erstattung des Überschusses möglich (Überschuss > 0, erstattbare Mollie-Zahlung auf der bisherigen Buchung). */
  possible: Scalars['Boolean'];
  /** Warum nicht oder nur teilweise möglich. */
  reason?: Maybe<Scalars['String']>;
  /** Rest des Überschusses, der auch bei Mollie-Erstattung Guthaben bliebe. */
  remainingCredit: Scalars['Float'];
};

export type TransferSurplusOutcome = {
  /** Teil des Überschusses, der nach der Umbuchung Guthaben ist. */
  creditRemaining: Scalars['Float'];
  kind: TransferSurplusHandling;
  /** Erster angelegter Refund — die vollständige Liste steht in refunds. */
  mollieRefundId?: Maybe<Scalars['String']>;
  /** Grund der manuellen Erstattung. */
  reason?: Maybe<Scalars['String']>;
  /** Summe der tatsächlich bei Mollie angelegten Refunds (0, wenn alle scheiterten). */
  refunded: Scalars['Float'];
  /** Ein Eintrag je angelegtem Refund, jüngste Zahlung zuerst (Kaskade über mehrere Zahlungen). */
  refunds: Array<TransferSurplusRefundResult>;
  /** Über Mollie angeforderter Betrag. */
  requestedRefund: Scalars['Float'];
};

export type TransferSurplusRefundPayment = {
  /** Davon für diesen Überschuss vorgesehen. */
  amount: Scalars['Float'];
  /** Lokal noch erstattbar (Zahlbetrag abzüglich bereits erstattet). */
  capacity: Scalars['Float'];
  molliePaymentId: Scalars['String'];
  paidAt: Scalars['DateTime'];
  scheduledPaymentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type TransferSurplusRefundResult = {
  amount: Scalars['Float'];
  molliePaymentId: Scalars['String'];
  mollieRefundId?: Maybe<Scalars['String']>;
  scheduledPaymentId: Scalars['ID'];
};

export type UnpaidScheduledPaymentMatch = {
  allowLessonBooking: Scalars['Boolean'];
  attendeeName: Scalars['String'];
  bookingId: Scalars['ID'];
  bookingNumber: Scalars['Float'];
  bookingNumberPrefix: Scalars['String'];
  confidence: MatchConfidence;
  courseNumber: Scalars['String'];
  invoiceNumber: Scalars['Float'];
  invoiceNumberPrefix: Scalars['String'];
  koOrganizationId: Scalars['ID'];
  mandateId: Scalars['String'];
  paymentAmount: Scalars['Float'];
  paymentDue: Scalars['DateTime'];
  scheduledPaymentId: Scalars['ID'];
  sepaExportDate: Scalars['DateTime'];
  sepaExportFileName: Scalars['String'];
  sepaExportId: Scalars['ID'];
};

export type UnpaidScheduledPaymentMatchResult = {
  matches: Array<UnpaidScheduledPaymentMatch>;
  totalMatchesFound: Scalars['Float'];
  totalSepaExportsSearched: Scalars['Float'];
};

export type UpcomingCoursesOccupancy = {
  bookedPlaces: Scalars['Int'];
  courseCount: Scalars['Int'];
  totalPlaces: Scalars['Int'];
};

export type UpdateAdminManagementUserEmailInput = {
  newEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type UpdateAdminManagementUserNameInput = {
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  userId: Scalars['ID'];
};

export type UpdateAnnouncementInput = {
  isActive?: Maybe<Scalars['Boolean']>;
  isDismissible?: Maybe<Scalars['Boolean']>;
  isMinimizable?: Maybe<Scalars['Boolean']>;
  koOrganizationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  priority?: Maybe<AnnouncementPriority>;
  targetUrl?: Maybe<Scalars['String']>;
  targetUrlLabel?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<AnnouncementType>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type UpdateAttendanceListSettingsInput = {
  fontSize: AttendanceListFontSize;
  lessonIndexEnd: Scalars['Float'];
  lessonIndexStart: Scalars['Float'];
  showCourseLessons: Scalars['Boolean'];
};

export type UpdateBadgeGroupInput = {
  color?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<BadgeGroupType>;
};

export type UpdateBadgeInput = {
  abbreviation?: Maybe<Scalars['String']>;
  badgeGroupId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  requirements?: Maybe<Array<BadgeRequirementInlineInput>>;
};

export type UpdateBillingAddressTemplateInput = {
  addition?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastname?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type UpdateBookerAccountEndUserAppInput = {
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  customer?: Maybe<BaseInput>;
  customerNumber?: Maybe<Scalars['Float']>;
  dsgvo?: Maybe<Scalars['Boolean']>;
  firstname?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  healthInsuranceFund?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  paymentMethods?: Maybe<Array<BookerPaymentMethodInput>>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type UpdateBookerIdMissmatchesInput = {
  newBookerId: Scalars['ID'];
  notificationId: Scalars['ID'];
  oldBookerId?: Maybe<Scalars['ID']>;
};

export type UpdateBookingRestrictionInput = {
  active?: Maybe<Scalars['Boolean']>;
  allowWaitlistWithoutPrerequisite?: Maybe<Scalars['Boolean']>;
  blockedPlaces?: Maybe<Scalars['Float']>;
  courseId: Scalars['ID'];
  endDateTime?: Maybe<Scalars['DateTime']>;
  expireAction?: Maybe<ExpireAction>;
  id: Scalars['ID'];
  includeBookingList?: Maybe<Scalars['Boolean']>;
  includeWaitingList?: Maybe<Scalars['Boolean']>;
  membersOnly?: Maybe<Scalars['Boolean']>;
  prerequisiteCourseIds?: Maybe<Array<Scalars['ID']>>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  visibleForAll?: Maybe<Scalars['Boolean']>;
};

export type UpdateCertificateTemplateInput = {
  accentColor?: Maybe<Scalars['String']>;
  badgeImage?: Maybe<Scalars['String']>;
  blockLayout?: Maybe<CertificateBlockLayoutInput>;
  congratulationText?: Maybe<Scalars['String']>;
  designVariant?: Maybe<CertificateDesignVariant>;
  docFields?: Maybe<CertificateDocFieldsInput>;
  footerText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instructorName?: Maybe<Scalars['String']>;
  introText?: Maybe<Scalars['String']>;
  letterFields?: Maybe<CertificateLetterFieldsInput>;
  logo?: Maybe<Scalars['String']>;
  middleText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organisationName?: Maybe<Scalars['String']>;
  signers?: Maybe<Array<CertificateSignerInput>>;
  sizes?: Maybe<CertificateSizesInput>;
  titleText?: Maybe<Scalars['String']>;
  visibility?: Maybe<CertificateTemplateVisibilityInput>;
};

export type UpdateCourseAndBookingsInput = {
  additionalItems?: Maybe<Array<CourseAdditionalItemInput>>;
  additionalItemsKnownIds?: Maybe<Array<Scalars['ID']>>;
  additionalShortInfo?: Maybe<Scalars['String']>;
  allowLessonBooking?: Maybe<Scalars['Boolean']>;
  allowMolliePayment?: Maybe<Scalars['Boolean']>;
  allowMonthlyPayment?: Maybe<Scalars['Boolean']>;
  allowUpFrontPayment?: Maybe<Scalars['Boolean']>;
  annotation?: Maybe<Scalars['String']>;
  blockBookingOnline?: Maybe<Scalars['Boolean']>;
  courseId: Scalars['ID'];
  courseNumberFormat?: Maybe<CourseNumberFormat>;
  coursePrices?: Maybe<Array<EditCoursePriceInput>>;
  courseTypeId?: Maybe<Scalars['ID']>;
  customCourseNumberPrefix?: Maybe<Scalars['String']>;
  customInvoiceDueDays?: Maybe<Scalars['Float']>;
  cycle?: Maybe<CourseCycle>;
  dateOfFirstInstallment?: Maybe<Scalars['DateTime']>;
  defaultLessonCount?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  fee?: Maybe<Scalars['Float']>;
  historySource?: Maybe<HistorySource>;
  id?: Maybe<Scalars['ID']>;
  installmentRates?: Maybe<Array<UpdateInstallmentRateInput>>;
  instructors?: Maybe<Array<CourseInstructorIdInput>>;
  isActive?: Maybe<Scalars['Boolean']>;
  lateEntryPricingMode?: Maybe<CourseLateEntryPricingMode>;
  lessons: Array<EditCourseLessonInput>;
  locationId?: Maybe<Scalars['ID']>;
  maxAssistantsPerLesson?: Maybe<Scalars['Float']>;
  maxAttendees?: Maybe<Scalars['Float']>;
  maxWaitlist?: Maybe<Scalars['Float']>;
  minAttendees?: Maybe<Scalars['Float']>;
  minimumPartialBookingLessonCount?: Maybe<Scalars['Int']>;
  mollieOptional?: Maybe<Scalars['Boolean']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  paymentInterval?: Maybe<PaymentInterval>;
  paymentType?: Maybe<PaymentType>;
  showInWeb?: Maybe<Scalars['Boolean']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  updatedBookingsData?: Maybe<Array<EditBookingInputBookableLessons>>;
  vat?: Maybe<Scalars['Float']>;
  venueId?: Maybe<Scalars['ID']>;
  websiteInfo?: Maybe<Scalars['String']>;
};

export type UpdateCourseAndBookingsResult = {
  /** skipFieldResolver */
  bookings: Array<Booking>;
  course: Course;
  courseLessonBookingsPreview?: Maybe<Array<CourseLessonBookingsPreview>>;
  courseLessonsPreview?: Maybe<Array<CourseLesson>>;
  dryRun: Scalars['Boolean'];
};

export type UpdateCourseLessonBookingInput = {
  attendance?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type UpdateCustomBankDataInput = {
  bankCode?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type UpdateInstallmentRateInput = {
  courseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  installmentAmount?: Maybe<Scalars['Float']>;
  installmentDue?: Maybe<Scalars['DateTime']>;
  installmentType?: Maybe<InstallmentType>;
};

export type UpdateInterestListInput = {
  courseTypeId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  maxEntries?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  showNoteField?: Maybe<Scalars['Boolean']>;
  timeSlots?: Maybe<Array<InterestListTimeSlotInput>>;
};

export type UpdateInterestRegistrationInput = {
  id: Scalars['ID'];
  internalNote?: Maybe<Scalars['String']>;
  status?: Maybe<InterestRegistrationStatus>;
};

export type UpdateInvoiceTemplateSetInput = {
  customLogo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  layoutVariant?: Maybe<InvoiceLayoutVariant>;
  logoPosition?: Maybe<InvoiceLogoPosition>;
  name?: Maybe<Scalars['String']>;
  secondLogo?: Maybe<Scalars['String']>;
};

export type UpdateLateEntryPricingConfigurationInput = {
  expectedUpdateDate: Scalars['DateTime'];
  lateEntryPricingPolicy: TenantLateEntryPricingPolicy;
  minimumPartialBookingLessonCount: Scalars['Int'];
};

export type UpdateMyProfileInput = {
  birthDate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  houseNumber?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  salutation?: Maybe<SalutationType>;
  street?: Maybe<Scalars['String']>;
};

export type UpdateParticipationPrerequisitesInput = {
  courseTypeId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  groupDescription?: Maybe<Scalars['String']>;
  groupLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  minCheckCount?: Maybe<Scalars['Float']>;
  optionalInputFields?: Maybe<Array<OptionalInputFieldsInput>>;
};

export type UpdatePaymentMethodInput = {
  bank?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sepaAccountholder?: Maybe<Scalars['String']>;
};

export type UpdateScheduledPaymentByBookingInput = {
  additionalItemId?: Maybe<Scalars['ID']>;
  bookingId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  invoiceId?: Maybe<Scalars['String']>;
  mollieMethod?: Maybe<Scalars['String']>;
  openAmount?: Maybe<Scalars['Float']>;
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDone?: Maybe<Scalars['DateTime']>;
  paymentDue?: Maybe<Scalars['DateTime']>;
  paymentProvider?: Maybe<PaymentProvider>;
  paymentTransferType?: Maybe<PaymentTransferType>;
  refundedAmount?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ScheduledPaymentType>;
  vat?: Maybe<Scalars['Float']>;
};

export type UpdateSettingEndUserAppInput = {
  colors?: Maybe<ColorsInput>;
  courseDetails?: Maybe<CourseDetailsInput>;
  courseSearchDisplayMode?: Maybe<CourseSearchDisplayMode>;
  courseSearchGridGap?: Maybe<Scalars['Float']>;
  courseSearchGridMaxColumns?: Maybe<Scalars['Float']>;
  courseSearchPageSize?: Maybe<Scalars['Float']>;
  courseTable?: Maybe<CourseTableInput>;
  creditRedemptionEnabled?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<FiltersInput>;
  hideAfterDays?: Maybe<Scalars['Float']>;
  i18n?: Maybe<I18n>;
  lateEntryPricingPolicy?: Maybe<TenantLateEntryPricingPolicy>;
  minimumPartialBookingLessonCount?: Maybe<Scalars['Int']>;
  optionalInputFields?: Maybe<Array<Scalars['JSONObject']>>;
  passwordlessIdCodeLength?: Maybe<Scalars['Float']>;
  passwordlessLoginEnabled?: Maybe<Scalars['Boolean']>;
  showInterestListsByDefault?: Maybe<Scalars['Boolean']>;
  showTotalPriceInCheckout?: Maybe<Scalars['Boolean']>;
  textEntries?: Maybe<TextEntriesInput>;
  withdrawalButtonEnabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateTableColumnSettingsInput = {
  columns?: Maybe<Array<Scalars['String']>>;
  table: TablesEnum;
};

export type UpdateWithdrawalStatusInput = {
  id: Scalars['ID'];
  status: WithdrawalStatus;
};


export type UploadedContentImage = {
  height: Scalars['Int'];
  id: Scalars['ID'];
  width: Scalars['Int'];
};

export type UploadFileInput = {
  cacheControl?: Maybe<Scalars['String']>;
  contentDisposition?: Maybe<Scalars['String']>;
  contentEncoding?: Maybe<Scalars['String']>;
  contentLength: Scalars['Float'];
  contentType: Scalars['String'];
  fileContent: Scalars['Upload'];
  fileName: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
};

export type UploadMetadataInput = {
  cacheControl?: Maybe<Scalars['String']>;
  contentDisposition?: Maybe<Scalars['String']>;
  contentEncoding?: Maybe<Scalars['String']>;
  contentLength?: Maybe<Scalars['Float']>;
  contentType?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type UpsertAttendeeBadgesWithRequirementsInput = {
  assignments: Array<AttendeeBadgeAssignmentInput>;
  badgeId: Scalars['ID'];
  courseId?: Maybe<Scalars['ID']>;
};

export type UserDetailsType = {
  birthDate?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insertInstant: Scalars['String'];
  instructorDetails?: Maybe<InstructorDetailsView>;
  lastLoginInstant?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  loginAttempts?: Maybe<Array<LoginAttempt>>;
  mobilePhone?: Maybe<Scalars['String']>;
  recentLogins?: Maybe<Array<RecentLoginEntry>>;
  roles: Array<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  userSettings?: Maybe<UserSetting>;
  verified: Scalars['Boolean'];
};

export type UserInput = {
  email: Scalars['String'];
  id: Scalars['String'];
};

export type UserRegistration = {
  applicationId?: Maybe<Scalars['ID']>;
  authenticationToken?: Maybe<Scalars['String']>;
  cleanSpeakId?: Maybe<Scalars['ID']>;
  data?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['String']>;
  insertInstant?: Maybe<Scalars['Float']>;
  lastLoginInstant?: Maybe<Scalars['Float']>;
  lastUpdateInstant?: Maybe<Scalars['Float']>;
  preferredLanguages?: Maybe<Array<Scalars['String']>>;
  roles?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type UserSetting = {
  attendanceListSettings: Scalars['JSONObject'];
  columnSettings?: Maybe<Scalars['JSONObject']>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Language>;
  optimizedCourseCalendar: Scalars['Boolean'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  showArchivedCourses: Scalars['Boolean'];
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type UserSettingsInputTypes = {
  columnSettings?: Maybe<Scalars['JSONObject']>;
  language?: Maybe<Language>;
};

export type UserType = {
  accessToken?: Maybe<Scalars['String']>;
  booker?: Maybe<Booker>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hasProfile: Scalars['Boolean'];
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
};

export enum VatAppearance {
  Hide = 'Hide',
  Mention = 'Mention',
  Show = 'Show'
}

export type Venue = {
  courses?: Maybe<Array<Course>>;
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  lessons?: Maybe<Array<CourseLesson>>;
  location?: Maybe<Location>;
  name: Scalars['String'];
  rent?: Maybe<Scalars['Float']>;
  rentType?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

export type VoidPaymentLinkResult = {
  bookingId: Scalars['ID'];
  error?: Maybe<Scalars['String']>;
  voided: Scalars['Boolean'];
};

export type WithdrawalEndUserAppResult = {
  id?: Maybe<Scalars['ID']>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  success: Scalars['Boolean'];
};

export type WithdrawalRequest = {
  bookingReference: Scalars['String'];
  createDate: Scalars['DateTime'];
  createdByUserId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  matchedBookingId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  receivedAt: Scalars['DateTime'];
  source: Scalars['String'];
  status: WithdrawalStatus;
  updateDate: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
};

/** Bearbeitungsstatus einer Widerrufserklärung */
export enum WithdrawalStatus {
  Done = 'Done',
  InProgress = 'InProgress',
  New = 'New',
  Rejected = 'Rejected'
}

export type WithEnabledCourse = {
  course: Course;
  enabledCourses: Array<EnabledCourse>;
};

export type YearEndExport = {
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  koOrganizationId: Scalars['String'];
  progress: Scalars['Int'];
  recordCount: Scalars['Int'];
  status: Scalars['String'];
  totalSize: Scalars['Float'];
  year: Scalars['Int'];
};

export type GetAreaManagerLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAreaManagerLocationsQuery = { getAreaManagerLocations: Array<Pick<Location, 'id' | 'name' | 'city'>> };

export type GetAreaManagerLocationStatsQueryVariables = Exact<{
  input?: Maybe<AreaManagerStatsInput>;
}>;


export type GetAreaManagerLocationStatsQuery = { getAreaManagerLocationStats: (
    Pick<AreaManagerLocationStatsResult, 'total'>
    & { items: Array<(
      Pick<AreaManagerLocationStats, 'activeCourseCount' | 'totalMaxAttendees' | 'totalBookedAttendees' | 'utilizationPercent'>
      & { location: Pick<Location, 'id' | 'name' | 'city'> }
    )> }
  ) };

export type GetAreaManagerCoursesQueryVariables = Exact<{
  input?: Maybe<AreaManagerStatsInput>;
}>;


export type GetAreaManagerCoursesQuery = { getAreaManagerCourses: (
    Pick<AreaManagerCourseStatsResult, 'total'>
    & { items: Array<Pick<AreaManagerCourseStats, 'courseId' | 'courseNumber' | 'courseName' | 'locationName' | 'maxAttendees' | 'bookedAttendees' | 'utilizationPercent' | 'isActive'>> }
  ) };

export type GetAreaManagerInstructorStatsQueryVariables = Exact<{
  input?: Maybe<AreaManagerStatsInput>;
}>;


export type GetAreaManagerInstructorStatsQuery = { getAreaManagerInstructorStats: (
    Pick<AreaManagerInstructorStatsResult, 'total'>
    & { items: Array<Pick<AreaManagerInstructorStats, 'instructorId' | 'firstname' | 'lastname' | 'courseCount' | 'lessonCount' | 'totalHours'>> }
  ) };

export type GetAreaManagerAssistantOverviewQueryVariables = Exact<{
  input?: Maybe<AreaManagerStatsInput>;
}>;


export type GetAreaManagerAssistantOverviewQuery = { getAreaManagerAssistantOverview: (
    Pick<AreaManagerAssistantOverviewResult, 'total'>
    & { items: Array<(
      Pick<AreaManagerAssistantOverview, 'courseLessonId' | 'courseName' | 'courseNumber' | 'startDateTime' | 'totalSlots' | 'filledSlots' | 'openSlots'>
      & { assignedAssistants: Array<Pick<AreaManagerAssignedAssistant, 'assistantId' | 'firstname' | 'lastname'>> }
    )> }
  ) };

export type GetAreaManagerVenueUtilizationQueryVariables = Exact<{
  input?: Maybe<AreaManagerStatsInput>;
}>;


export type GetAreaManagerVenueUtilizationQuery = { getAreaManagerVenueUtilization: (
    Pick<AreaManagerVenueUtilizationResult, 'total'>
    & { items: Array<(
      Pick<AreaManagerVenueUtilization, 'locationName' | 'usedHours'>
      & { venue: Pick<Venue, 'id' | 'name'> }
    )> }
  ) };

export type GetAreaManagerUpcomingLessonsQueryVariables = Exact<{
  input?: Maybe<AreaManagerStatsInput>;
}>;


export type GetAreaManagerUpcomingLessonsQuery = { getAreaManagerUpcomingLessons: Array<Pick<AreaManagerUpcomingLesson, 'id' | 'startDateTime' | 'endDateTime' | 'courseNumber' | 'prefixedCourseNumber' | 'courseName'>> };

export type GetAreaManagerAssistantHierarchyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAreaManagerAssistantHierarchyQuery = { getAreaManagerAssistantHierarchy: { locations: Array<(
      Pick<AreaManagerAssistantLocationGroup, 'locationId' | 'locationName' | 'courseCount' | 'lessonCount' | 'totalSlots' | 'filledSlots' | 'openSlots' | 'lessonsWithAssistants' | 'lessonsFullyStaffed' | 'lessonsPartiallyStaffed'>
      & { courseGroups: Array<Pick<AreaManagerAssistantCourseGroup, 'courseId' | 'courseNumber' | 'courseTypeName' | 'courseTypeColor' | 'dateRangeStart' | 'dateRangeEnd' | 'maxAssistantsPerLesson' | 'lessonCount' | 'totalSlots' | 'filledSlots' | 'openSlots' | 'needsAssistants' | 'lessonsWithAssistants' | 'lessonsFullyStaffed' | 'lessonsPartiallyStaffed'>> }
    )> } };

export type GetAreaManagerAssistantLessonsByCourseQueryVariables = Exact<{
  input: AreaManagerAssistantLessonsInput;
}>;


export type GetAreaManagerAssistantLessonsByCourseQuery = { getAreaManagerAssistantLessonsByCourse: Array<(
    Pick<AreaManagerAssistantOverview, 'courseLessonId' | 'courseName' | 'courseNumber' | 'startDateTime' | 'totalSlots' | 'filledSlots' | 'openSlots'>
    & { assignedAssistants: Array<Pick<AreaManagerAssignedAssistant, 'assistantId' | 'firstname' | 'lastname'>> }
  )> };

export type AssignInstructorToLessonFromControlBoardMutationVariables = Exact<{
  input: AssignInstructorToLessonInput;
}>;


export type AssignInstructorToLessonFromControlBoardMutation = Pick<Mutation, 'assignInstructorToLessonFromControlBoard'>;

export type AssignAssistantFromControlBoardMutationVariables = Exact<{
  input: AssignAssistantInput;
}>;


export type AssignAssistantFromControlBoardMutation = Pick<Mutation, 'assignAssistantFromControlBoard'>;

export type RemoveAssistantFromControlBoardMutationVariables = Exact<{
  input: AssignAssistantInput;
}>;


export type RemoveAssistantFromControlBoardMutation = Pick<Mutation, 'removeAssistantFromControlBoard'>;

export type GetCourseLessonsForAssistantAppQueryVariables = Exact<{
  filters?: Maybe<AssistantCourseLessonFilterInput>;
}>;


export type GetCourseLessonsForAssistantAppQuery = { getCourseLessonsForAssistantApp: Array<(
    Pick<AssistantCourseLesson, 'assistantSlotsUsed' | 'assistantSlotsMax' | 'isAssignedToMe'>
    & { courseLesson: (
      Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'maxAssistantsPerLesson'>
        & { courseType: Pick<CourseType, 'id' | 'name'> }
      ), location: Pick<Location, 'id' | 'name' | 'city'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
    ), assignedAssistants: Array<Pick<AssistantInfo, 'firstname' | 'lastname'>> }
  )> };

export type GetMyAssignmentsAssistantAppQueryVariables = Exact<{
  includePast?: Maybe<Scalars['Boolean']>;
}>;


export type GetMyAssignmentsAssistantAppQuery = { getMyAssignmentsAssistantApp: Array<(
    Pick<AssistantCourseLesson, 'assistantSlotsUsed' | 'assistantSlotsMax' | 'isAssignedToMe'>
    & { courseLesson: (
      Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'maxAssistantsPerLesson'>
        & { courseType: Pick<CourseType, 'id' | 'name'> }
      ), location: Pick<Location, 'id' | 'name' | 'city'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
    ), assignedAssistants: Array<Pick<AssistantInfo, 'firstname' | 'lastname'>> }
  )> };

export type AssignMyselfToCourseLessonAssistantAppMutationVariables = Exact<{
  courseLessonId: Scalars['ID'];
}>;


export type AssignMyselfToCourseLessonAssistantAppMutation = Pick<Mutation, 'assignMyselfToCourseLessonAssistantApp'>;

export type UnassignMyselfFromCourseLessonAssistantAppMutationVariables = Exact<{
  courseLessonId: Scalars['ID'];
}>;


export type UnassignMyselfFromCourseLessonAssistantAppMutation = Pick<Mutation, 'unassignMyselfFromCourseLessonAssistantApp'>;

export type GetAssistantAssignedLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssistantAssignedLocationsQuery = { getAssistantAssignedLocations: Array<Pick<Location, 'id' | 'name' | 'city'>> };

export type GetSelectableLocationsForAssistantAppQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectableLocationsForAssistantAppQuery = { getSelectableLocationsForAssistantApp: Array<Pick<AssistantSelectableLocation, 'id' | 'name' | 'city' | 'isAssigned'>> };

export type GetAttendeesForCertificateAssignQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetAttendeesForCertificateAssignQuery = { attendees: (
    Pick<AttendeeWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Attendee, 'id' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname' | 'birthday' | 'gender' | 'member' | 'addition' | 'annotation'>
      & { bookingsKo9?: Maybe<Array<Pick<BookingsKo9, 'id' | 'courseNumber' | 'courseName' | 'firstCourseLesson'>>>, booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'nonDisclosureNotice'>>, badgeXAttendee?: Maybe<Array<(
        Pick<AttendeeBadge, 'id'>
        & { badge: (
          Pick<Badge, 'id' | 'name' | 'color' | 'abbreviation'>
          & { badgeRequirements?: Maybe<Array<Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'>>> }
        ), attendeeBadgeRequirements?: Maybe<Array<Pick<AttendeeBadgeRequirement, 'id' | 'fulfilled'>>> }
      )>> }
    )> }
  ) };

export type CertCourseAttendanceListQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type CertCourseAttendanceListQuery = { attendanceListByCourse: Array<(
    Pick<Booking, 'id' | 'courseId'>
    & { attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'birthday' | 'gender' | 'member' | 'addition' | 'annotation'>
      & { bookingsKo9?: Maybe<Array<Pick<BookingsKo9, 'id' | 'courseNumber' | 'courseName' | 'firstCourseLesson'>>>, booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'nonDisclosureNotice'>>, badgeXAttendee?: Maybe<Array<(
        Pick<AttendeeBadge, 'id'>
        & { badge: (
          Pick<Badge, 'id' | 'name' | 'color' | 'abbreviation'>
          & { badgeRequirements?: Maybe<Array<Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'>>> }
        ), attendeeBadgeRequirements?: Maybe<Array<Pick<AttendeeBadgeRequirement, 'id' | 'fulfilled'>>> }
      )>> }
    )> }
  )> };

export type CreateAttendeeBadgeMutationVariables = Exact<{
  newAttendeeBadgeInput: NewAttendeeBadgeInput;
}>;


export type CreateAttendeeBadgeMutation = { createAttendeeBadge: Pick<AttendeeBadge, 'id'> };

export type UpdateAttendeeBadgeMutationVariables = Exact<{
  editAttendeeBadgeInput: EditAttendeeBadgeInput;
}>;


export type UpdateAttendeeBadgeMutation = { updateAttendeeBadge: Pick<AttendeeBadge, 'id'> };

export type DeleteAttendeeBadgeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAttendeeBadgeMutation = Pick<Mutation, 'deleteAttendeeBadge'>;

export type GetAttendeeBadgeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAttendeeBadgeQuery = { getAttendeeBadge: (
    Pick<AttendeeBadge, 'id' | 'comment' | 'dateOfAchivement' | 'courseId' | 'allRequirementsFulfilled'>
    & { badge: Pick<Badge, 'id' | 'name' | 'certificateTemplateId'>, attendee: Pick<Attendee, 'id'>, attendeeBadgeRequirements?: Maybe<Array<(
      Pick<AttendeeBadgeRequirement, 'id' | 'badgeRequirementId' | 'fulfilled' | 'dateOfFulfillment' | 'comment'>
      & { badgeRequirement: Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'> }
    )>> }
  ) };

export type GetAttendeeBadgesByAttendeeIdQueryVariables = Exact<{
  attendeeId: Scalars['String'];
}>;


export type GetAttendeeBadgesByAttendeeIdQuery = { getAttendeeBadgesByAttendeeId: Array<(
    Pick<AttendeeBadge, 'id' | 'comment' | 'dateOfAchivement' | 'courseId' | 'allRequirementsFulfilled'>
    & { badge: Pick<Badge, 'id' | 'name' | 'color' | 'abbreviation' | 'graphicUrl' | 'signedGraphicUrl'>, attendee: Pick<Attendee, 'id'>, attendeeBadgeRequirements?: Maybe<Array<(
      Pick<AttendeeBadgeRequirement, 'id' | 'badgeRequirementId' | 'fulfilled' | 'dateOfFulfillment' | 'comment'>
      & { badgeRequirement: Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'> }
    )>> }
  )> };

export type ToggleAttendeeBadgeRequirementMutationVariables = Exact<{
  input: ToggleAttendeeBadgeRequirementInput;
}>;


export type ToggleAttendeeBadgeRequirementMutation = { toggleAttendeeBadgeRequirement: Pick<AttendeeBadgeRequirement, 'id' | 'fulfilled' | 'dateOfFulfillment' | 'comment'> };

export type GetAttendeeBadgesByBadgeIdQueryVariables = Exact<{
  badgeId: Scalars['String'];
}>;


export type GetAttendeeBadgesByBadgeIdQuery = { getAttendeeBadgesByBadgeId: Array<(
    Pick<AttendeeBadge, 'id' | 'allRequirementsFulfilled' | 'dateOfAchivement'>
    & { attendee: Pick<Attendee, 'id' | 'firstname' | 'lastname'>, attendeeBadgeRequirements?: Maybe<Array<(
      Pick<AttendeeBadgeRequirement, 'id' | 'badgeRequirementId' | 'fulfilled' | 'dateOfFulfillment' | 'comment'>
      & { badgeRequirement: Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'> }
    )>> }
  )> };

export type BulkToggleAttendeeBadgeRequirementMutationVariables = Exact<{
  input: BulkToggleAttendeeBadgeRequirementInput;
}>;


export type BulkToggleAttendeeBadgeRequirementMutation = { bulkToggleAttendeeBadgeRequirement: Array<Pick<AttendeeBadgeRequirement, 'id' | 'fulfilled' | 'dateOfFulfillment'>> };

export type BulkCreateAttendeeBadgesMutationVariables = Exact<{
  input: BulkCreateAttendeeBadgeInput;
}>;


export type BulkCreateAttendeeBadgesMutation = { bulkCreateAttendeeBadges: Array<Pick<AttendeeBadge, 'id'>> };

export type UpsertAttendeeBadgesWithRequirementsMutationVariables = Exact<{
  input: UpsertAttendeeBadgesWithRequirementsInput;
}>;


export type UpsertAttendeeBadgesWithRequirementsMutation = { upsertAttendeeBadgesWithRequirements: Array<(
    Pick<AttendeeBadge, 'id' | 'attendeeId' | 'badgeId' | 'dateOfAchivement' | 'allRequirementsFulfilled'>
    & { attendeeBadgeRequirements?: Maybe<Array<Pick<AttendeeBadgeRequirement, 'id' | 'badgeRequirementId' | 'fulfilled' | 'dateOfFulfillment' | 'comment'>>> }
  )> };

export type GetBadgeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBadgeQuery = { badge: (
    Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color' | 'graphicUrl' | 'signedGraphicUrl' | 'description' | 'certificateTemplateId' | 'badgeGroupId' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId' | 'rank'>
    & { badgeRequirements?: Maybe<Array<Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'>>> }
  ) };

export type GetBadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBadgesQuery = { badges: Array<(
    Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color' | 'graphicUrl' | 'signedGraphicUrl' | 'description' | 'certificateTemplateId' | 'badgeGroupId' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId' | 'rank'>
    & { badgeRequirements?: Maybe<Array<Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'>>> }
  )> };

export type CreateBadgeMutationVariables = Exact<{
  newBadgeInput: NewBadgeInput;
}>;


export type CreateBadgeMutation = { createBadge: (
    Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color' | 'description' | 'certificateTemplateId' | 'badgeGroupId' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId'>
    & { badgeRequirements?: Maybe<Array<Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'>>> }
  ) };

export type UpdateBadgeMutationVariables = Exact<{
  updateBadgeInput: UpdateBadgeInput;
}>;


export type UpdateBadgeMutation = { updateBadge: (
    Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color' | 'description' | 'certificateTemplateId' | 'badgeGroupId' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId'>
    & { badgeRequirements?: Maybe<Array<Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'>>> }
  ) };

export type DeleteBadgeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBadgeMutation = Pick<Mutation, 'deleteBadge'>;

export type SoftDeleteBadgeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftDeleteBadgeMutation = { softDeleteBadge: Pick<Badge, 'id'> };

export type IsBadgeNameUniqueQueryVariables = Exact<{
  name: Scalars['String'];
  id?: Maybe<Scalars['String']>;
}>;


export type IsBadgeNameUniqueQuery = Pick<Query, 'isBadgeNameUnique'>;

export type ReOrderBadgesMutationVariables = Exact<{
  movedBadgeId: Scalars['ID'];
  targetBadgeId: Scalars['ID'];
}>;


export type ReOrderBadgesMutation = Pick<Mutation, 'reOrderBadges'>;

export type MoveBadgeMutationVariables = Exact<{
  movedBadgeId: Scalars['ID'];
  badgeGroupId?: Maybe<Scalars['ID']>;
  targetBadgeId?: Maybe<Scalars['ID']>;
}>;


export type MoveBadgeMutation = Pick<Mutation, 'moveBadge'>;

export type UploadBadgeGraphicMutationVariables = Exact<{
  badgeId: Scalars['String'];
  file: Scalars['Upload'];
}>;


export type UploadBadgeGraphicMutation = { uploadBadgeGraphic: Pick<Badge, 'id' | 'graphicUrl' | 'signedGraphicUrl'> };

export type DeleteBadgeGraphicMutationVariables = Exact<{
  badgeId: Scalars['String'];
}>;


export type DeleteBadgeGraphicMutation = { deleteBadgeGraphic: Pick<Badge, 'id' | 'graphicUrl' | 'signedGraphicUrl'> };

export type BadgeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type BadgeGroupsQuery = { badgeGroups: Array<Pick<BadgeGroup, 'id' | 'name' | 'type' | 'color' | 'rank'>> };

export type CreateBadgeGroupMutationVariables = Exact<{
  newBadgeGroupInput: NewBadgeGroupInput;
}>;


export type CreateBadgeGroupMutation = { createBadgeGroup: Pick<BadgeGroup, 'id' | 'name' | 'type' | 'color' | 'rank'> };

export type UpdateBadgeGroupMutationVariables = Exact<{
  updateBadgeGroupInput: UpdateBadgeGroupInput;
}>;


export type UpdateBadgeGroupMutation = { updateBadgeGroup: Pick<BadgeGroup, 'id' | 'name' | 'type' | 'color' | 'rank'> };

export type DeleteBadgeGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBadgeGroupMutation = Pick<Mutation, 'deleteBadgeGroup'>;

export type ReOrderBadgeGroupsMutationVariables = Exact<{
  movedGroupId: Scalars['ID'];
  targetGroupId: Scalars['ID'];
}>;


export type ReOrderBadgeGroupsMutation = Pick<Mutation, 'reOrderBadgeGroups'>;

export type BookingHistoryByIdWithBookingInfoQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type BookingHistoryByIdWithBookingInfoQuery = { bookingHistoryByIdWithBookingInfo: Array<(
    Pick<BookingHistory, 'id' | 'createDate' | 'createdByUserId' | 'userId' | 'userName' | 'action' | 'description' | 'bookingId' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'attendeeId' | 'bookerId' | 'grossPrice' | 'canceled' | 'oldValues' | 'newValues' | 'correlationId' | 'bookedBy'>
    & { user?: Maybe<Pick<UserDetailsType, 'id' | 'email'>>, createdBy?: Maybe<(
      Pick<UserDetailsType, 'id' | 'email'>
      & { instructorDetails?: Maybe<Pick<InstructorDetailsView, 'email' | 'firstname' | 'lastname' | 'level'>> }
    )>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'email' | 'firstname' | 'lastname'>> }
    )>, course?: Maybe<Pick<Course, 'id' | 'courseNumber' | 'courseNumberFormat' | 'customCourseNumberPrefix'>>, booking?: Maybe<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>> }
  )> };

export type BookingHistoryByBookingIdQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type BookingHistoryByBookingIdQuery = { bookingHistoryByBookingId: Array<Pick<BookingHistory, 'id' | 'bookingId' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'startDateTime' | 'attendeeId' | 'bookerId' | 'courseId' | 'email' | 'grossPrice' | 'canceled' | 'bookedBy' | 'action' | 'createDate'>> };

export type BookingHistoryDetailsByBookingIdAndOrganizationIdQueryVariables = Exact<{
  bookingId: Scalars['String'];
  koOrganizationId: Scalars['String'];
}>;


export type BookingHistoryDetailsByBookingIdAndOrganizationIdQuery = { bookingHistoryDetailsByBookingIdAndOrganizationId: Array<(
    Pick<BookingHistory, 'id' | 'bookingId' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'startDateTime' | 'attendeeId' | 'bookerId' | 'courseId' | 'email' | 'grossPrice' | 'canceled' | 'bookedBy' | 'action' | 'createDate' | 'createdByUserId'>
    & { createdBy?: Maybe<(
      Pick<UserDetailsType, 'id' | 'email'>
      & { instructorDetails?: Maybe<Pick<InstructorDetailsView, 'email' | 'firstname' | 'lastname' | 'level'>> }
    )>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'email' | 'firstname' | 'lastname'>> }
    )>, course?: Maybe<Pick<Course, 'id' | 'courseNumber' | 'courseNumberFormat' | 'customCourseNumberPrefix'>>, booking?: Maybe<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>> }
  )> };

export type BookingHistoryOrphanBookingsQueryVariables = Exact<{
  koOrganizationId: Scalars['String'];
}>;


export type BookingHistoryOrphanBookingsQuery = { bookingHistoryOrphanBookings: Array<(
    Pick<BookingHistory, 'id' | 'bookingId' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'startDateTime' | 'attendeeId' | 'bookerId' | 'courseId' | 'email' | 'grossPrice' | 'canceled' | 'bookedBy' | 'action' | 'createDate'>
    & { course?: Maybe<Pick<Course, 'id' | 'courseNumber' | 'courseNumberFormat' | 'customCourseNumberPrefix'>>, booking?: Maybe<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>> }
  )> };

export type BookingHistoryByCourseIdQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type BookingHistoryByCourseIdQuery = { bookingHistoryByCourseId: Array<(
    Pick<BookingHistory, 'id' | 'createDate' | 'createdByUserId' | 'userId' | 'userName' | 'action' | 'description' | 'bookingId' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'attendeeId' | 'bookerId' | 'grossPrice' | 'canceled' | 'oldValues' | 'newValues' | 'correlationId' | 'bookedBy'>
    & { user?: Maybe<Pick<UserDetailsType, 'id' | 'email'>>, createdBy?: Maybe<(
      Pick<UserDetailsType, 'id' | 'email'>
      & { instructorDetails?: Maybe<Pick<InstructorDetailsView, 'email' | 'firstname' | 'lastname' | 'level'>> }
    )>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'email' | 'firstname' | 'lastname'>> }
    )>, course?: Maybe<Pick<Course, 'id' | 'courseNumber' | 'courseNumberFormat' | 'customCourseNumberPrefix'>>, booking?: Maybe<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>> }
  )> };

export type GetBookinsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetBookinsQuery = { bookings: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'pricingReason' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'additionalInfo' | 'foundUs' | 'utmSource' | 'bookedLessonCount'>
      & { coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, courseLessons: Array<(
        Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId' | 'indexOfLessonInCourse'>
        & { course: (
          Pick<Course, 'id' | 'freePlaces' | 'startDateTime' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'prefixedCourseNumber' | 'allowMonthlyPayment' | 'lessonCount' | 'allowLessonBooking'>
          & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
        ), location: Pick<Location, 'id' | 'city' | 'name'> }
      )>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>>, badgeXAttendee?: Maybe<Array<(
          Pick<AttendeeBadge, 'id' | 'createDate' | 'dateOfAchivement'>
          & { badge: Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color'> }
        )>> }
      )>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>> }
    )> }
  ) };

export type GetBookingsOverviewOptimizedQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetBookingsOverviewOptimizedQuery = { bookings: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'isSettled' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'pricingReason' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'discountCodeText' | 'canceled' | 'waitListCount' | 'additionalInfo' | 'foundUs' | 'utmSource' | 'bookedLessonCount' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent'>
      & { paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>, course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance'>>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'paymentProvider' | 'mollieMethod'>>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'city' | 'credit' | 'phoneNumber' | 'mobileNumber' | 'nonDisclosureNotice'>> }
      )>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>> }
    )> }
  ) };

export type BookingCoreFieldsFragment = Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'additionalInfo'>;

export type BookingCoursePriceFieldsFragment = { coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'> };

export type BookingInvoiceFieldsFragment = { invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>> };

export type BookingReversalInvoiceFieldsFragment = { reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>> };

export type BookingCourseLessonsFieldsFragment = { courseLessons: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId'>
    & { course: (
      Pick<Course, 'id' | 'freePlaces' | 'startDateTime' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'prefixedCourseNumber' | 'allowMonthlyPayment' | 'lessonCount' | 'allowLessonBooking' | 'allowMolliePayment' | 'mollieOptional'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
    ), location: Pick<Location, 'id' | 'city' | 'name'> }
  )> };

export type BookingAttendeeFieldsFragment = { attendee?: Maybe<(
    Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
    & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>> }
  )> };

export type BookingEmailNotificationsFieldsFragment = { emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>> };

export type BookingPaymentMethodFieldsFragment = { paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>> };

export type GetBookingsDynamicQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  includeCoursePrice: Scalars['Boolean'];
  includeInvoice: Scalars['Boolean'];
  includeReversalInvoice: Scalars['Boolean'];
  includeCourseLessons: Scalars['Boolean'];
  includeAttendee: Scalars['Boolean'];
  includeEmailNotifications: Scalars['Boolean'];
  includePaymentMethod: Scalars['Boolean'];
}>;


export type GetBookingsDynamicQuery = { bookingsDynamic: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      BookingCoreFieldsFragment
      & BookingCoursePriceFieldsFragment
      & BookingInvoiceFieldsFragment
      & BookingReversalInvoiceFieldsFragment
      & BookingCourseLessonsFieldsFragment
      & BookingAttendeeFieldsFragment
      & BookingEmailNotificationsFieldsFragment
      & BookingPaymentMethodFieldsFragment
    )> }
  ) };

export type CreateBookingMutationVariables = Exact<{
  newBookingData: NewBookingInput;
  sendMail: Scalars['Boolean'];
}>;


export type CreateBookingMutation = { createBooking: (
    Pick<Booking, 'id' | 'bookingType' | 'paymentType'>
    & { scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'paymentProvider' | 'mollieMethod' | 'type'>>> }
  ) };

export type RemoveBookingMutationVariables = Exact<{
  id: Scalars['ID'];
  bookingDeleteAction?: Maybe<BookingDeleteAction>;
  notifyBooker?: Maybe<Scalars['Boolean']>;
}>;


export type RemoveBookingMutation = Pick<Mutation, 'removeBooking'>;

export type RemoveBookingsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveBookingsMutation = Pick<Mutation, 'removeBookings'>;

export type UpdateBookingMutationVariables = Exact<{
  editBookingData: EditBookingInput;
  id: Scalars['String'];
}>;


export type UpdateBookingMutation = { updateBooking: Pick<Booking, 'id' | 'bookingType'> };

export type UpdateNoticeStaffMutationVariables = Exact<{
  id: Scalars['String'];
  noticeStaff: Scalars['String'];
}>;


export type UpdateNoticeStaffMutation = { updateNoticeStaff: Pick<Booking, 'id' | 'noticeStaff'> };

export type GetMonthlyPaymentPreviewQueryVariables = Exact<{
  monthlyPaymentPreviewOptions: ScheduledPaymentPreviewInput;
}>;


export type GetMonthlyPaymentPreviewQuery = Pick<Query, 'getMonthlyPaymentPreview'>;

export type GetBookingByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookingByIdQuery = { bookingById: (
    Pick<Booking, 'isSettled' | 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'noticeStaff' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'pricingReason' | 'pricingCalculatedAt' | 'pricingSnapshot' | 'lessonSelectionMode' | 'memberDiscount' | 'discount' | 'discountName' | 'hasDiscountCode' | 'isSpecial' | 'startDateTime' | 'courseId' | 'paymentMethodId' | 'bookedBy' | 'canceled' | 'monthlySchedule' | 'paymentType' | 'creditedBalance' | 'waitListCount' | 'additionalInfo' | 'foundUs' | 'bookedLessonCount'>
    & { transferIn?: Maybe<Pick<BookingTransferIn, 'sourceBookingNumber' | 'appliedAmount'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate' | 'correctionDate' | 'id'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, courseLessons: Array<(
      Pick<CourseLesson, 'startDateTime' | 'endDateTime' | 'id' | 'locationId'>
      & { course: (
        Pick<Course, 'id' | 'freePlaces' | 'bookingCount' | 'startDateTime' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'prefixedCourseNumber' | 'allowMonthlyPayment' | 'allowUpFrontPayment' | 'monthlySchedule' | 'paymentType' | 'allowLessonBooking' | 'allowMolliePayment' | 'mollieOptional'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat' | 'discount' | 'discountUnit' | 'isSpecial'>>, installmentRates: Array<Pick<InstallmentRate, 'id' | 'installmentAmount' | 'installmentDue'>>, lessons: Array<Pick<CourseLesson, 'id' | 'startDateTime'>> }
      ), location: Pick<Location, 'id' | 'city' | 'name'> }
    )>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { booker?: Maybe<(
        Pick<Booker, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'gender' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity' | 'nonDisclosureNotice' | 'credit'>
        & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>> }
      )>, defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'> }
    )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditcardNumber' | 'creditCardAccountholder' | 'expirationDate' | 'sepaAccountholder' | 'iban' | 'bic' | 'bank' | 'paypalAccountholder' | 'email' | 'bankTransfer' | 'onlinePayment'>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'refundedAmount' | 'providerRefundedAmount' | 'molliePaidAmount' | 'paymentDue' | 'paymentDone' | 'openAmount' | 'type' | 'title' | 'postKind' | 'carriedOverAt' | 'additionalItemId' | 'vat' | 'paymentProvider' | 'mollieMethod'>>>, molliePaymentAttempts: Array<Pick<MolliePaymentAttempt, 'id' | 'scheduledPaymentId' | 'status' | 'mollieMethod' | 'linkExpiresAt' | 'checkoutUrl' | 'isCurrentAttempt' | 'createDate'>> }
  ) };

export type GetBookingsByCourseQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  id: Scalars['ID'];
}>;


export type GetBookingsByCourseQuery = { getBookingsByCourse: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'waitListCount' | 'additionalInfo' | 'foundUs' | 'bookedLessonCount' | 'lessonSelectionMode' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance'>>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'city' | 'street' | 'houseNumber' | 'postCode' | 'credit' | 'phoneNumber' | 'mobileNumber' | 'nonDisclosureNotice'>>, badgeXAttendee?: Maybe<Array<(
          Pick<AttendeeBadge, 'id' | 'createDate' | 'dateOfAchivement'>
          & { badge: Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color'> }
        )>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type'>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, molliePaymentAttempts: Array<Pick<MolliePaymentAttempt, 'id' | 'molliePaymentLinkId' | 'linkExpiresAt' | 'status' | 'paidAt' | 'isCurrentAttempt' | 'createDate'>> }
    )> }
  ) };

export type GetWaitlistByCourseQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  id: Scalars['ID'];
}>;


export type GetWaitlistByCourseQuery = { getWaitlistByCourse: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'coursePriceId' | 'courseId' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'canceled' | 'waitListCount' | 'bookedLessonCount'>
      & { coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, courseLessons: Array<(
        Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
        & { course: Pick<Course, 'id' | 'paymentInterval' | 'allowLessonBooking'> }
      )>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice'>> }
      )> }
    )> }
  ) };

export type GetWaitlistCountOfCourseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWaitlistCountOfCourseQuery = Pick<Query, 'getWaitlistCountOfCourse'>;

export type GetBookingsByCourseMinimalQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  id: Scalars['ID'];
}>;


export type GetBookingsByCourseMinimalQuery = { getBookingsByCourse: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled' | 'waitListCount'>
      & { attendee?: Maybe<(
        Pick<Attendee, 'id' | 'gender' | 'birthday' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'nonDisclosureNotice'>> }
      )> }
    )> }
  ) };

export type GetBookingsByCourseForTransferQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  id: Scalars['ID'];
}>;


export type GetBookingsByCourseForTransferQuery = { getBookingsByCourse: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled' | 'waitListCount' | 'bookedLessonCount'>
      & { attendee?: Maybe<(
        Pick<Attendee, 'id' | 'gender' | 'birthday' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'nonDisclosureNotice'>> }
      )>, invoice?: Maybe<Pick<Invoice, 'id'>> }
    )> }
  ) };

export type GetBookingsCountByCourseQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  id: Scalars['ID'];
}>;


export type GetBookingsCountByCourseQuery = { getBookingsByCourse: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingType' | 'canceled' | 'waitListCount'>> }
  ) };

export type RemoveAllBookingsMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAllBookingsMutation = Pick<Mutation, 'removeAllBookings'>;

export type SendBookingConfirmationMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  editedTemplateInput?: Maybe<EditTemplateInput>;
}>;


export type SendBookingConfirmationMutation = Pick<Mutation, 'sendBookingConfirmation'>;

export type GetVariablesForBookingWithCourseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetVariablesForBookingWithCourseQuery = { bookingById: (
    Pick<Booking, 'id' | 'creditedBalance' | 'memberDiscount' | 'discount' | 'discountName' | 'bookedLessonCount'>
    & { attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday' | 'member'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname'>> }
    )>, courseLessons: Array<(
      Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'description'> }
      ), location: Pick<Location, 'id' | 'city' | 'name'> }
    )> }
  ) };

export type ConvertBookingToWaitlistMutationVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type ConvertBookingToWaitlistMutation = { convertBookingToWaitlist: (
    Pick<Booking, 'id' | 'bookingType' | 'bookingNumberPrefix' | 'bookingNumber'>
    & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member'>> }
  ) };

export type ConvertWaitlistToBookingMutationVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type ConvertWaitlistToBookingMutation = { convertWaitlistToBooking: (
    Pick<Booking, 'id' | 'bookingType' | 'bookingNumberPrefix' | 'bookingNumber'>
    & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member'>> }
  ) };

export type TransferAttendeeToCourseMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  targetCourseId: Scalars['ID'];
  bookingDeleteAction?: Maybe<BookingDeleteAction>;
  usePlaceReservation?: Maybe<Scalars['Boolean']>;
  deleteNotes?: Maybe<Scalars['Boolean']>;
}>;


export type TransferAttendeeToCourseMutation = { transferAttendeeToCourse: (
    Pick<Booking, 'id' | 'bookingType' | 'bookingNumberPrefix' | 'grossPrice' | 'netPrice' | 'vat' | 'noticeStaff' | 'bookedLessonCount'>
    & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member'>>, courseLessons: Array<(
      Pick<CourseLesson, 'id'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking'>
        & { courseType: Pick<CourseType, 'id' | 'name'> }
      ) }
    )>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'openAmount'>>> }
  ) };

export type VoidMolliePaymentLinkForBookingMutationVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type VoidMolliePaymentLinkForBookingMutation = { voidMolliePaymentLinkForBooking: Pick<Booking, 'id'> };

export type VoidMolliePaymentLinksForBookingsMutationVariables = Exact<{
  bookingIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type VoidMolliePaymentLinksForBookingsMutation = { voidMolliePaymentLinksForBookings: Array<Pick<VoidPaymentLinkResult, 'bookingId' | 'voided' | 'error'>> };

export type CopyAttendeeToCourseMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  targetCourseId: Scalars['ID'];
  usePlaceReservation?: Maybe<Scalars['Boolean']>;
  deleteNotes?: Maybe<Scalars['Boolean']>;
}>;


export type CopyAttendeeToCourseMutation = { copyAttendeeToCourse: (
    Pick<Booking, 'id' | 'bookingType' | 'bookingNumberPrefix' | 'bookedLessonCount'>
    & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member'>>, courseLessons: Array<(
      Pick<CourseLesson, 'id'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking'>
        & { courseType: Pick<CourseType, 'id' | 'name'> }
      ) }
    )> }
  ) };

export type GetBookingsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetBookingsByIdsQuery = { getBookingsByIds: Array<(
    Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'courseId' | 'canceled' | 'waitListCount' | 'bookedLessonCount'>
    & { attendee?: Maybe<(
      Pick<Attendee, 'id' | 'member'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'mobileNumber'>> }
    )> }
  )> };

export type GetBookingsByScheduledPaymentIdsQueryVariables = Exact<{
  scheduledPaymentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetBookingsByScheduledPaymentIdsQuery = { getBookingsByScheduledPaymentIds: Array<(
    Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'canceled' | 'bookedLessonCount'>
    & { attendee?: Maybe<(
      Pick<Attendee, 'id' | 'member'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email'>> }
    )> }
  )> };

export type GetBookingsByInvoiceIdsQueryVariables = Exact<{
  invoiceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetBookingsByInvoiceIdsQuery = { getBookingsByInvoiceIds: Array<Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'bookedLessonCount'>> };

export type GetBookingsByAttendeeIdWithOptionsQueryVariables = Exact<{
  id: Scalars['ID'];
  startDateTime?: Maybe<Scalars['DateTime']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  canceledBookings?: Maybe<Scalars['Boolean']>;
}>;


export type GetBookingsByAttendeeIdWithOptionsQuery = { getBookingsByAttendeeIdWithOptions: Array<(
    Pick<Booking, 'id' | 'isSettled' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent'>
    & { course?: Maybe<(
      Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
    )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance'>>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'city' | 'credit' | 'phoneNumber' | 'mobileNumber' | 'nonDisclosureNotice'>> }
    )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>> }
  )> };

export type UpdateAttendanceListNoteMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  attendanceListNote?: Maybe<Scalars['String']>;
}>;


export type UpdateAttendanceListNoteMutation = { updateAttendanceListNote: Pick<Booking, 'id' | 'attendanceListNote'> };

export type UpdateBookingPaymentMethodMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
}>;


export type UpdateBookingPaymentMethodMutation = { updateBookingPaymentMethod: Pick<Booking, 'id' | 'paymentMethodId'> };

export type AddMultiplePlaceReservationsMutationVariables = Exact<{
  courseId: Scalars['ID'];
  count: Scalars['Float'];
}>;


export type AddMultiplePlaceReservationsMutation = { addMultiplePlaceReservations: Array<Pick<Booking, 'id'>> };

export type DeleteAllPlaceReservationsByCourseIdMutationVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type DeleteAllPlaceReservationsByCourseIdMutation = Pick<Mutation, 'deleteAllPlaceReservationsByCourseId'>;

export type DeleteSelectionOfWaitlistMutationVariables = Exact<{
  bookingIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteSelectionOfWaitlistMutation = Pick<Mutation, 'deleteSelectionOfWaitlist'>;

export type GetBookingsByCourseRefactoredQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  id: Scalars['ID'];
}>;


export type GetBookingsByCourseRefactoredQuery = { getBookingsByCourse: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'isSettled' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'noticeStaff' | 'noticeBooker' | 'attendanceListNote' | 'coursePriceId' | 'courseId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'bookedLessonCount'>
      & { coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, courseLessons: Array<(
        Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId'>
        & { course: (
          Pick<Course, 'id' | 'freePlaces' | 'startDateTime' | 'endDateTimeFirstCourseLesson' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'prefixedCourseNumber' | 'allowMonthlyPayment' | 'allowLessonBooking'>
          & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
        ), location: Pick<Location, 'id' | 'city' | 'name'> }
      )>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>> }
      )>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>> }
    )> }
  ) };

export type TransferMultipleBookingsMutationVariables = Exact<{
  transferMultipleBookingsInput: TransferMultipleBookingsInput;
  deleteNotes?: Maybe<Scalars['Boolean']>;
}>;


export type TransferMultipleBookingsMutation = { transferMultipleBookings: Array<(
    Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber' | 'grossPrice' | 'courseId'>
    & { scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'type'>>>, attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member'>> }
  )> };

export type GetBookingsInStartedCoursesQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetBookingsInStartedCoursesQuery = { bookingsInStartedCourses: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'isSettled' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'waitListCount' | 'additionalInfo' | 'foundUs' | 'bookedLessonCount' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance'>>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'city' | 'credit' | 'phoneNumber' | 'mobileNumber' | 'nonDisclosureNotice'>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type'>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>> }
    )> }
  ) };

export type BookingMolliePaymentAttemptsFieldsFragment = { molliePaymentAttempts: Array<(
    Pick<MolliePaymentAttempt, 'id' | 'molliePaymentId' | 'scheduledPaymentId' | 'molliePaymentLinkId' | 'bundleScheduledPaymentIds' | 'mollieMethod' | 'status' | 'checkoutUrl' | 'paymentUrl' | 'isCurrentAttempt' | 'amount' | 'linkExpiresAt' | 'paidAt' | 'createDate' | 'errorMessage' | 'chargebackId' | 'chargebackReason' | 'chargebackFee' | 'chargebackedAt'>
    & { refunds: Array<Pick<MollieRefund, 'id' | 'mollieRefundId' | 'amount' | 'reason' | 'status' | 'canceledAtProvider' | 'mollieCreatedAt' | 'adminUserId' | 'createDate'>>, chargebacks: Array<Pick<Chargeback, 'mollieChargebackId' | 'reason' | 'fee' | 'chargebackedAt'>> }
  )> };

export type TransferPlanPreviewQueryVariables = Exact<{
  input: TransferPlanInput;
}>;


export type TransferPlanPreviewQuery = { transferPlanPreview: (
    Pick<TransferPlanPreview, 'confirmationToken' | 'coursePrice' | 'transferDate' | 'cutoffApplied' | 'priceB' | 'discountB' | 'discountReason' | 'sourceDiscount' | 'sourceDiscountName' | 'memberDiscountB' | 'vatB' | 'paidA' | 'appliedToB' | 'surplus' | 'creditAfter' | 'sourceCreditedBalance' | 'creditReapplied' | 'hints' | 'blockers' | 'hasActivePaymentLink'>
    & { itemReview: Array<Pick<TransferItemReview, 'sourceRateId' | 'type' | 'title' | 'amount' | 'paid' | 'open' | 'carried' | 'waived' | 'carry' | 'reason' | 'vat'>>, priceOptions: Array<Pick<TransferPriceOptionPreview, 'kind' | 'priceB' | 'discountB' | 'memberDiscountB' | 'lessonsTotal' | 'lessonsRemaining'>>, cutoff: (
      Pick<TransferCutoffPreview, 'applicable' | 'mode' | 'lessonsTotal' | 'lessonsAttended' | 'retainedPaid' | 'carriedOpen'>
      & { rates: Array<Pick<TransferCutoffRatePreview, 'sourceRateId' | 'due' | 'consumed' | 'retainedPaid' | 'carriedOpen'>> }
    ), oldBookingOptions: Array<Pick<TransferOldBookingOptionPreview, 'kind' | 'transferred' | 'bookingPrice' | 'open' | 'surplus' | 'firstDue'>>, partialSource?: Maybe<Pick<TransferPartialSourcePreview, 'cardLessons' | 'attended' | 'remaining' | 'chosen' | 'lessonPrice' | 'price'>>, rates: Array<Pick<TransferPlannedRate, 'type' | 'amount' | 'due' | 'title' | 'origin' | 'settledByTransfer' | 'fullyCovered'>>, surplusHandling: Pick<TransferSurplusHandlingPreview, 'kind' | 'creditAmount' | 'refundAmount' | 'reason'>, surplusMollieRefund: (
      Pick<TransferSurplusMollieRefundPreview, 'possible' | 'amount' | 'remainingCredit' | 'reason'>
      & { payments: Array<Pick<TransferSurplusRefundPayment, 'scheduledPaymentId' | 'molliePaymentId' | 'paidAt' | 'amount' | 'capacity' | 'title'>> }
    ), oldBooking: Pick<TransferOldBookingPlan, 'treatment' | 'reason'>, carriedOverItems: Array<Pick<TransferCarriedOverItem, 'type' | 'amount' | 'title'>>, communicationDefaults?: Maybe<Pick<TransferCommunicationDefaults, 'sendMail' | 'attachReversalInvoice' | 'attachInvoiceB' | 'createInvoiceBNow' | 'templateAvailable'>> }
  ) };

export type ExecuteTransferMutationVariables = Exact<{
  input: ExecuteTransferInput;
}>;


export type ExecuteTransferMutation = { executeTransfer: (
    Pick<ExecuteTransferResult, 'transferOperationId' | 'oldBookingDeleted' | 'promotedBookingId' | 'messages' | 'mailSent' | 'warnings'>
    & { reversalInvoice?: Maybe<Pick<TransferInvoiceRef, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix'>>, invoiceB?: Maybe<Pick<TransferInvoiceRef, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix'>>, surplusOutcome?: Maybe<(
      Pick<TransferSurplusOutcome, 'kind' | 'requestedRefund' | 'refunded' | 'creditRemaining' | 'mollieRefundId' | 'reason'>
      & { refunds: Array<Pick<TransferSurplusRefundResult, 'scheduledPaymentId' | 'molliePaymentId' | 'amount' | 'mollieRefundId'>> }
    )>, booking: Pick<Booking, 'id' | 'bookingType' | 'bookingNumber' | 'bookingNumberPrefix' | 'grossPrice' | 'netPrice' | 'vat' | 'courseId'>, plan: (
      Pick<TransferPlanPreview, 'confirmationToken' | 'paidA' | 'priceB' | 'discountB' | 'discountReason' | 'appliedToB' | 'surplus' | 'creditAfter' | 'sourceCreditedBalance' | 'creditReapplied' | 'hints' | 'blockers'>
      & { itemReview: Array<Pick<TransferItemReview, 'sourceRateId' | 'type' | 'title' | 'amount' | 'paid' | 'open' | 'carried' | 'waived' | 'carry' | 'reason' | 'vat'>>, rates: Array<Pick<TransferPlannedRate, 'type' | 'amount' | 'due' | 'title' | 'origin' | 'settledByTransfer' | 'fullyCovered'>>, carriedOverItems: Array<Pick<TransferCarriedOverItem, 'type' | 'amount' | 'title'>>, surplusHandling: Pick<TransferSurplusHandlingPreview, 'kind' | 'creditAmount' | 'refundAmount' | 'reason'>, oldBooking: Pick<TransferOldBookingPlan, 'treatment' | 'reason'> }
    ) }
  ) };

export type TransferBulkPlanPreviewQueryVariables = Exact<{
  input: TransferBulkPlanInput;
}>;


export type TransferBulkPlanPreviewQuery = { transferBulkPlanPreview: (
    Pick<TransferBulkPlanPreview, 'blockers' | 'maxBookings' | 'templateAvailable'>
    & { rows: Array<(
      Pick<TransferBulkPlanRow, 'sourceBookingId' | 'sourceBookingNumber' | 'attendeeName'>
      & { plan: (
        Pick<TransferPlanPreview, 'confirmationToken' | 'transferDate' | 'cutoffApplied' | 'priceB' | 'discountB' | 'discountReason' | 'paidA' | 'appliedToB' | 'surplus' | 'creditAfter' | 'sourceCreditedBalance' | 'creditReapplied' | 'hints' | 'blockers' | 'hasActivePaymentLink'>
        & { priceOptions: Array<Pick<TransferPriceOptionPreview, 'kind' | 'priceB' | 'discountB' | 'memberDiscountB' | 'lessonsTotal' | 'lessonsRemaining'>>, cutoff: (
          Pick<TransferCutoffPreview, 'applicable' | 'mode' | 'lessonsTotal' | 'lessonsAttended' | 'retainedPaid' | 'carriedOpen'>
          & { rates: Array<Pick<TransferCutoffRatePreview, 'sourceRateId' | 'due' | 'consumed' | 'retainedPaid' | 'carriedOpen'>> }
        ), oldBookingOptions: Array<Pick<TransferOldBookingOptionPreview, 'kind' | 'transferred' | 'bookingPrice' | 'open' | 'surplus' | 'firstDue'>>, partialSource?: Maybe<Pick<TransferPartialSourcePreview, 'cardLessons' | 'attended' | 'remaining' | 'chosen' | 'lessonPrice' | 'price'>>, oldBooking: Pick<TransferOldBookingPlan, 'treatment' | 'reason'>, carriedOverItems: Array<Pick<TransferCarriedOverItem, 'type' | 'amount' | 'title'>>, communicationDefaults?: Maybe<Pick<TransferCommunicationDefaults, 'sendMail' | 'attachReversalInvoice' | 'attachInvoiceB' | 'createInvoiceBNow' | 'templateAvailable'>> }
      ) }
    )> }
  ) };

export type ExecuteBulkTransferMutationVariables = Exact<{
  input: ExecuteBulkTransferInput;
}>;


export type ExecuteBulkTransferMutation = { executeBulkTransfer: (
    Pick<ExecuteBulkTransferResult, 'warnings'>
    & { results: Array<(
      Pick<ExecuteBulkTransferRowResult, 'sourceBookingId' | 'sourceBookingNumber' | 'transferOperationId' | 'oldBookingDeleted' | 'mailSent' | 'warnings'>
      & { reversalInvoice?: Maybe<Pick<TransferInvoiceRef, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix'>>, invoiceB?: Maybe<Pick<TransferInvoiceRef, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix'>>, booking: Pick<Booking, 'id' | 'bookingType' | 'bookingNumber' | 'bookingNumberPrefix' | 'grossPrice' | 'courseId'>, plan: (
        Pick<TransferPlanPreview, 'priceB' | 'appliedToB' | 'surplus' | 'creditAfter'>
        & { oldBooking: Pick<TransferOldBookingPlan, 'treatment' | 'reason'> }
      ) }
    )> }
  ) };

export type CreateLessonBookingMutationVariables = Exact<{
  newBookingData: NewBookingInputBookableLessons;
  sendMail: Scalars['Boolean'];
  onlineBooking?: Maybe<Scalars['Boolean']>;
}>;


export type CreateLessonBookingMutation = { createLessonBooking: (
    Pick<BookingWithCourseLessons, 'id' | 'createdByUserId' | 'updatedByUserId' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'startDateTime' | 'attendeeId' | 'paymentMethodId' | 'paymentType' | 'coursePriceId' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'courseId' | 'monthlySchedule' | 'memberDiscount' | 'noticeBooker' | 'additionalInfo' | 'noticeStaff' | 'attendanceListNote' | 'payDate' | 'canceled' | 'creditedBalance' | 'discount' | 'discountName' | 'agbConfirmed' | 'privacyStatementConfirmed' | 'createDate' | 'updateDate' | 'bookedBy'>
    & { attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member'>
      & { defaultPaymentMethod: Pick<PaymentMethod, 'id'> }
    )>, coursePrice: Pick<CoursePrice, 'id' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'discount' | 'discountUnit' | 'courseId' | 'includedEntranceFee'>, scheduledPayments: Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'type' | 'title' | 'openAmount' | 'paymentProvider' | 'mollieMethod'>> }
  ) };

export type EditLessonBookingMutationVariables = Exact<{
  editBookingInputBookableLessons: EditBookingInputBookableLessons;
}>;


export type EditLessonBookingMutation = { editLessonBooking: (
    Pick<BookingWithCourseLessons, 'id' | 'createdByUserId' | 'updatedByUserId' | 'bookingNumberPrefix' | 'bookingType' | 'startDateTime' | 'attendeeId' | 'paymentMethodId' | 'paymentType' | 'coursePriceId' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'courseId' | 'monthlySchedule' | 'memberDiscount' | 'noticeBooker' | 'additionalInfo' | 'noticeStaff' | 'attendanceListNote' | 'payDate' | 'canceled' | 'creditedBalance' | 'discount' | 'discountName' | 'agbConfirmed' | 'privacyStatementConfirmed' | 'createDate' | 'updateDate' | 'bookedBy' | 'overpaymentCredit'>
    & { attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member'>
      & { defaultPaymentMethod: Pick<PaymentMethod, 'id'>, booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email'>> }
    )>, course?: Maybe<Pick<Course, 'id' | 'allowLessonBooking'>>, coursePrice: Pick<CoursePrice, 'id' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'discount' | 'discountUnit' | 'courseId' | 'includedEntranceFee'>, scheduledPayments: Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'type' | 'title' | 'openAmount' | 'paymentProvider' | 'mollieMethod'>> }
  ) };

export type GetCourseInfosForBookingQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseInfosForBookingQuery = { getCourseInfosForBooking: (
    Pick<Course, 'id' | 'prefixedCourseNumber' | 'startDateTime' | 'endDateTime' | 'maxAttendees' | 'paymentType' | 'allowMonthlyPayment' | 'allowUpFrontPayment' | 'allowLessonBooking' | 'allowMolliePayment' | 'mollieOptional'>
    & { courseType: Pick<CourseType, 'id' | 'name'>, lessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse' | 'courseLessonBookingCount'>>, coursePrices: Array<Pick<CoursePrice, 'netPrice' | 'grossPrice' | 'vat'>> }
  ) };

export type GetAttendeeInfosForBookingQueryVariables = Exact<{
  attendeeId: Scalars['ID'];
}>;


export type GetAttendeeInfosForBookingQuery = { getAttendeeInfosForBooking: (
    Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
    & { defaultPaymentMethod: Pick<PaymentMethod, 'id'>, booker?: Maybe<(
      Pick<Booker, 'id' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>> }
    )> }
  ) };

export type GetBookingByIdWithCourseLessonBookingsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookingByIdWithCourseLessonBookingsQuery = { bookingByIdWithCourseLessonBookings: (
    Pick<Booking, 'isSettled' | 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'noticeStaff' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'pricingReason' | 'pricingCalculatedAt' | 'pricingSnapshot' | 'memberDiscount' | 'isSpecial' | 'startDateTime' | 'courseId' | 'paymentType' | 'paymentMethodId' | 'bookedBy' | 'canceled' | 'monthlySchedule' | 'creditedBalance' | 'discount' | 'discountName' | 'hasDiscountCode' | 'waitListCount' | 'additionalInfo' | 'foundUs'>
    & { transferIn?: Maybe<Pick<BookingTransferIn, 'sourceBookingNumber' | 'appliedAmount'>>, molliePaymentAttempts: Array<(
      Pick<MolliePaymentAttempt, 'id' | 'molliePaymentId' | 'scheduledPaymentId' | 'molliePaymentLinkId' | 'bundleScheduledPaymentIds' | 'mollieMethod' | 'status' | 'checkoutUrl' | 'paymentUrl' | 'isCurrentAttempt' | 'amount' | 'linkExpiresAt' | 'paidAt' | 'createDate' | 'errorMessage' | 'chargebackId' | 'chargebackReason' | 'chargebackFee' | 'chargebackedAt'>
      & { refunds: Array<Pick<MollieRefund, 'id' | 'mollieRefundId' | 'scheduledPaymentId' | 'amount' | 'reason' | 'status' | 'canceledAtProvider' | 'mollieCreatedAt' | 'adminUserId' | 'createDate'>>, chargebacks: Array<Pick<Chargeback, 'mollieChargebackId' | 'reason' | 'fee' | 'chargebackedAt'>> }
    )>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate' | 'correctionDate'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, courseLessons: Array<(
      Pick<CourseLesson, 'startDateTime' | 'endDateTime' | 'id' | 'locationId' | 'indexOfLessonInCourse' | 'courseLessonBookingCount'>
      & { course: (
        Pick<Course, 'id' | 'freePlaces' | 'bookingCount' | 'startDateTime' | 'endDateTime' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'prefixedCourseNumber' | 'allowMonthlyPayment' | 'allowUpFrontPayment' | 'monthlySchedule' | 'paymentType' | 'allowLessonBooking' | 'allowMolliePayment' | 'mollieOptional' | 'additionalShortInfo' | 'endDateTimeFirstCourseLesson' | 'waitListCount' | 'placeReservationsCount'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, installmentRates: Array<Pick<InstallmentRate, 'id' | 'installmentAmount' | 'installmentDue'>>, location: Pick<Location, 'id' | 'city' | 'name'>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      ) }
    )>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate'>>>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { booker?: Maybe<(
        Pick<Booker, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'gender' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity' | 'nonDisclosureNotice' | 'credit' | 'newsletter'>
        & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>> }
      )>, defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'> }
    )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditcardNumber' | 'creditCardAccountholder' | 'expirationDate' | 'sepaAccountholder' | 'iban' | 'bic' | 'bank' | 'paypalAccountholder' | 'email' | 'bankTransfer' | 'onlinePayment'>>, scheduledPayments?: Maybe<Array<(
      Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'refundedAmount' | 'paymentDue' | 'paymentDone' | 'type' | 'title' | 'postKind' | 'carriedOverAt' | 'openAmount' | 'paymentProvider' | 'mollieMethod' | 'manuallyAdjustedAt' | 'manuallyAdjustedByUserId' | 'deletedAt'>
      & { manuallyAdjustedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>> }
    )>> }
  ) };

export type GetBookingsByCourseIdWithCourseLessonBookingsQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetBookingsByCourseIdWithCourseLessonBookingsQuery = { bookingsByCourseIdWithCourseLessonBookings: Array<(
    Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'noticeStaff' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'memberDiscount' | 'creditedBalance' | 'discount' | 'discountName' | 'isSpecial' | 'startDateTime' | 'courseId' | 'paymentType' | 'paymentMethodId' | 'bookedBy' | 'canceled' | 'monthlySchedule' | 'waitListCount' | 'additionalInfo'>
    & { invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate' | 'correctionDate'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, courseLessons: Array<(
      Pick<CourseLesson, 'startDateTime' | 'endDateTime' | 'id' | 'locationId' | 'indexOfLessonInCourse' | 'courseLessonBookingCount'>
      & { course: (
        Pick<Course, 'id' | 'freePlaces' | 'bookingCount' | 'startDateTime' | 'endDateTime' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'prefixedCourseNumber' | 'allowMonthlyPayment' | 'allowUpFrontPayment' | 'monthlySchedule' | 'paymentType' | 'allowLessonBooking' | 'additionalShortInfo' | 'endDateTimeFirstCourseLesson' | 'waitListCount' | 'placeReservationsCount'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, installmentRates: Array<Pick<InstallmentRate, 'id' | 'installmentAmount' | 'installmentDue'>>, location: Pick<Location, 'id' | 'city' | 'name'>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      ) }
    )>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType'>>>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
      & { booker?: Maybe<(
        Pick<Booker, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'gender' | 'nonDisclosureNotice' | 'credit' | 'newsletter'>
        & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>> }
      )>, defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'> }
    )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditcardNumber' | 'creditCardAccountholder' | 'expirationDate' | 'sepaAccountholder' | 'iban' | 'bic' | 'bank' | 'paypalAccountholder' | 'email' | 'bankTransfer' | 'onlinePayment'>>, scheduledPayments?: Maybe<Array<(
      Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'refundedAmount' | 'paymentDue' | 'paymentDone' | 'type' | 'title' | 'openAmount' | 'paymentProvider' | 'mollieMethod' | 'manuallyAdjustedAt' | 'manuallyAdjustedByUserId' | 'deletedAt'>
      & { manuallyAdjustedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>> }
    )>> }
  )> };

export type GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery = { bookingsByCourseIdWithCourseLessonBookings: Array<(
    Pick<Booking, 'id' | 'isSettled' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'noticeStaff' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'memberDiscount' | 'creditedBalance' | 'discount' | 'discountName' | 'isSpecial' | 'startDateTime' | 'courseId' | 'canceled' | 'paymentType' | 'paymentMethodId' | 'bookedBy' | 'monthlySchedule' | 'additionalInfo'>
    & { invoice?: Maybe<Pick<Invoice, 'id'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType'>>>, attendee?: Maybe<(
      Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
      & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'gender' | 'nonDisclosureNotice' | 'credit' | 'newsletter'>>, defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'> }
    )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditcardNumber' | 'creditCardAccountholder' | 'expirationDate' | 'sepaAccountholder' | 'iban' | 'bic' | 'bank' | 'paypalAccountholder' | 'email' | 'bankTransfer' | 'onlinePayment'>>, scheduledPayments?: Maybe<Array<(
      Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'refundedAmount' | 'paymentDue' | 'paymentDone' | 'type' | 'title' | 'openAmount' | 'paymentProvider' | 'mollieMethod' | 'manuallyAdjustedAt' | 'manuallyAdjustedByUserId' | 'deletedAt'>
      & { manuallyAdjustedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>> }
    )>> }
  )> };

export type GetAllBookingsByAttendeeIdAndCourseIdQueryVariables = Exact<{
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
}>;


export type GetAllBookingsByAttendeeIdAndCourseIdQuery = { getAllBookingsByAttendeeIdAndCourseId: Array<(
    Pick<CourseLessonBooking, 'id' | 'bookingId' | 'courseLessonId' | 'bookingType'>
    & { booking: Pick<Booking, 'bookingNumberPrefix' | 'bookingNumber'> }
  )> };

export type ResetPaymentPlanOfInvoicedLessonBookingMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  previewOnly?: Maybe<Scalars['Boolean']>;
}>;


export type ResetPaymentPlanOfInvoicedLessonBookingMutation = { resetPaymentPlanOfInvoicedLessonBooking: (
    Pick<ResetPaymentPlanOfInvoicedLessonBookingResult, 'bookingId' | 'previewOnly' | 'blockedReason' | 'blockedMessage' | 'oldTotalGrossPrice' | 'newTotalGrossPrice' | 'oldDiscount' | 'oldCreditedBalance'>
    & { oldScheduledPayments: Array<Pick<ResetPaymentPlanRateSnapshot, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'paid' | 'manuallyAdjustedAt' | 'deletedAt' | 'refundedAmount'>>, newScheduledPayments: Array<Pick<ResetPaymentPlanRateSnapshot, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'paid' | 'manuallyAdjustedAt' | 'deletedAt' | 'refundedAmount'>> }
  ) };

export type LessonBookingPlannerPreviewQueryVariables = Exact<{
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
  bookingId: Scalars['ID'];
  intents?: Maybe<Array<LessonBookingIntentInput> | LessonBookingIntentInput>;
}>;


export type LessonBookingPlannerPreviewQuery = { lessonBookingPlannerPreview: (
    Pick<LessonBookingPlannerPreview, 'unitPrice' | 'bookedUnitsBefore' | 'bookedUnitsAfter' | 'priceBefore' | 'priceAfter' | 'legacyGap' | 'nonCoursePostsSum' | 'credit' | 'canceled' | 'regenerated' | 'warnings' | 'pricingMode' | 'rateMonthOffset' | 'ambiguousOffset'>
    & { units: Array<Pick<LessonBookingPlannerUnit, 'lessonId' | 'lessonDate' | 'status' | 'movedTo'>>, components: Array<Pick<LessonBookingPlannerComponent, 'amount' | 'reason' | 'lessonDate'>>, rates: Array<(
      Pick<LessonBookingPlannerRate, 'id' | 'paymentDue' | 'amountBefore' | 'amountAfter' | 'status' | 'boundReason'>
      & { adjustments: Array<Pick<LessonBookingPlannerAdjustment, 'amount' | 'reason'>> }
    )> }
  ) };

export type LessonBookingPlanSummaryQueryVariables = Exact<{
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
  intents?: Maybe<Array<LessonBookingIntentInput> | LessonBookingIntentInput>;
}>;


export type LessonBookingPlanSummaryQuery = { lessonBookingPlanSummary: Array<Pick<LessonBookingPlanSummary, 'bookingId' | 'bookingLabel' | 'applies' | 'fingerprint' | 'priceBefore' | 'priceAfter' | 'credit' | 'unitsAdded' | 'unitsRemoved' | 'ratesChanged' | 'regenerated' | 'warnings' | 'blocker' | 'correctionInvoice' | 'correctionInvoiceMail' | 'staffNoteChanged'>> };

export type ApplyLessonBookingPlanMutationVariables = Exact<{
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
  fingerprints: Array<LessonBookingPlanFingerprintInput> | LessonBookingPlanFingerprintInput;
  intents?: Maybe<Array<LessonBookingIntentInput> | LessonBookingIntentInput>;
}>;


export type ApplyLessonBookingPlanMutation = { applyLessonBookingPlan: Array<Pick<LessonBookingPlanSummary, 'bookingId' | 'applies'>> };

export type CertificateTemplateFieldsFragment = (
  { __typename: 'CertificateTemplate' }
  & Pick<CertificateTemplate, 'id' | 'name' | 'designVariant' | 'logo' | 'badgeImage' | 'instructorName' | 'congratulationText' | 'titleText' | 'introText' | 'middleText' | 'footerText' | 'organisationName' | 'accentColor' | 'createDate' | 'updateDate'>
  & { visibility?: Maybe<Pick<CertificateTemplateVisibility, 'logo' | 'organisation' | 'kurs' | 'zertifikat' | 'datum' | 'nummer' | 'titel' | 'intro' | 'mittel' | 'grat' | 'kl' | 'fuss' | 'geburtsdatum' | 'signers'>>, sizes?: Maybe<Pick<CertificateSizes, 'titel' | 'org' | 'kurs' | 'intro' | 'name' | 'mittel' | 'zert' | 'grat' | 'kl' | 'untertitel' | 'docMid' | 'kursSub' | 'abschluss' | 'beschreibung' | 'akkreditierung' | 'veranstalter' | 'fuss' | 'badge' | 'logo' | 'bandTitle' | 'bandStufen' | 'bandContact'>>, signers?: Maybe<Array<Pick<CertificateSigner, 'name' | 'role'>>>, docFields?: Maybe<{ untertitel: Pick<CertificateDocText, 'v' | 'show'>, teilnCaption: Pick<CertificateDocText, 'v' | 'show'>, docMid: Pick<CertificateDocText, 'v' | 'show'>, kursSub: Pick<CertificateDocText, 'v' | 'show'>, abschluss: Pick<CertificateDocText, 'v' | 'show'>, beschreibung: Pick<CertificateDocText, 'v' | 'show'>, akkreditierung: Pick<CertificateDocText, 'v' | 'show'>, ort: Pick<CertificateDocText, 'v' | 'show'>, veranstalter: Pick<CertificateDocText, 'v' | 'show'>, align: Pick<CertificateAlign, 'logo' | 'footer'> }>, blockLayout?: Maybe<(
    Pick<CertificateBlockLayout, 'density' | 'order'>
    & { alignments?: Maybe<Pick<CertificateBlockAlignments, 'organisation' | 'titel' | 'kurs' | 'intro' | 'teilnehmer' | 'geburtsdatum' | 'mittel' | 'zert' | 'grat' | 'untertitel' | 'name' | 'teilnCaption' | 'docMid' | 'kursSub' | 'abschluss' | 'beschreibung' | 'akkreditierung' | 'ortDatum' | 'logo' | 'letterHead' | 'letterSalutation' | 'letterZert' | 'beilage' | 'letterBody' | 'letterBadge' | 'letterSig'>>, spacing?: Maybe<Pick<CertificateBlockSpacing, 'organisation' | 'titel' | 'kurs' | 'intro' | 'teilnehmer' | 'geburtsdatum' | 'mittel' | 'zert' | 'grat' | 'untertitel' | 'name' | 'teilnCaption' | 'docMid' | 'kursSub' | 'abschluss' | 'beschreibung' | 'akkreditierung' | 'ortDatum' | 'logo' | 'letterHead' | 'letterSalutation' | 'letterZert' | 'beilage' | 'letterBody' | 'letterBadge' | 'letterSig' | 'bandTitle' | 'bandStufen' | 'bandContact'>> }
  )>, letterFields?: Maybe<(
    Pick<CertificateLetterFields, 'senderLine' | 'stufenList' | 'stufenShow' | 'stufenTitle' | 'contactLine' | 'contactShow' | 'window'>
    & { beilage: Pick<CertificateDocText, 'v' | 'show'> }
  )> }
);

export type IssuedCertificateFieldsFragment = (
  { __typename: 'IssuedCertificate' }
  & Pick<IssuedCertificate, 'id' | 'attendeeBadgeId' | 'courseId' | 'certificateTemplateId' | 'certificateNumber' | 'issuedAt' | 'issuedByUserId' | 'emailSentAt' | 'createDate'>
);

export type GetCertificateTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCertificateTemplatesQuery = { certificateTemplates: Array<CertificateTemplateFieldsFragment> };

export type GetCertificateTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCertificateTemplateQuery = { certificateTemplate: CertificateTemplateFieldsFragment };

export type GetIssuedCertificatesByAttendeeQueryVariables = Exact<{
  attendeeId: Scalars['String'];
}>;


export type GetIssuedCertificatesByAttendeeQuery = { issuedCertificatesByAttendee: Array<IssuedCertificateFieldsFragment> };

export type GetIssuedCertificatesByCourseQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type GetIssuedCertificatesByCourseQuery = { issuedCertificatesByCourse: Array<IssuedCertificateFieldsFragment> };

export type GetIssuedCertificatesQueryVariables = Exact<{
  filter?: Maybe<IssuedCertificatesFilterInput>;
}>;


export type GetIssuedCertificatesQuery = { issuedCertificates: Array<(
    Pick<IssuedCertificate, 'attendeeName' | 'courseName' | 'templateName'>
    & IssuedCertificateFieldsFragment
  )> };

export type PreviewCertificatePdfQueryQueryVariables = Exact<{
  input: CreateCertificateTemplateInput;
}>;


export type PreviewCertificatePdfQueryQuery = Pick<Query, 'previewCertificatePdf'>;

export type DownloadCertificateQueryQueryVariables = Exact<{
  issuedCertificateId: Scalars['String'];
}>;


export type DownloadCertificateQueryQuery = Pick<Query, 'downloadCertificate'>;

export type CreateCertificateTemplateMutationMutationVariables = Exact<{
  input: CreateCertificateTemplateInput;
}>;


export type CreateCertificateTemplateMutationMutation = { createCertificateTemplate: CertificateTemplateFieldsFragment };

export type UpdateCertificateTemplateMutationMutationVariables = Exact<{
  input: UpdateCertificateTemplateInput;
}>;


export type UpdateCertificateTemplateMutationMutation = { updateCertificateTemplate: CertificateTemplateFieldsFragment };

export type DeleteCertificateTemplateMutationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCertificateTemplateMutationMutation = Pick<Mutation, 'deleteCertificateTemplate'>;

export type CertificateIssuePreflightQueryVariables = Exact<{
  input: CertificateIssuePreflightInput;
}>;


export type CertificateIssuePreflightQuery = { certificateIssuePreflight: (
    Pick<CertificateIssuePreflightResult, 'usedVariableKeys'>
    & { attendeesWithMissingValues: Array<Pick<CertificateIssuePreflightAttendee, 'attendeeId' | 'attendeeName' | 'missingKeys'>> }
  ) };

export type IssueCertificateMutationMutationVariables = Exact<{
  input: IssueCertificateInput;
}>;


export type IssueCertificateMutationMutation = { issueCertificate: IssuedCertificateFieldsFragment };

export type IssueCertificatesByCourseMutationMutationVariables = Exact<{
  input: IssueCertificatesByCourseInput;
}>;


export type IssueCertificatesByCourseMutationMutation = { issueCertificatesByCourse: Array<IssuedCertificateFieldsFragment> };

export type IssueCertificatesByAttendeesMutationMutationVariables = Exact<{
  input: IssueCertificatesByAttendeesInput;
}>;


export type IssueCertificatesByAttendeesMutationMutation = { issueCertificatesByAttendees: Array<IssuedCertificateFieldsFragment> };

export type ResendCertificateEmailMutationMutationVariables = Exact<{
  issuedCertificateId: Scalars['String'];
}>;


export type ResendCertificateEmailMutationMutation = Pick<Mutation, 'resendCertificateEmail'>;

export type AuthenticateQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthenticateQuery = { authenticate: Pick<UserType, 'id' | 'email' | 'firstName' | 'lastName' | 'roles' | 'hasProfile'> };

export type GetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRolesQuery = Pick<Query, 'getUserRoles'>;

export type DebugDefaultCourseDetailsMutationVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type DebugDefaultCourseDetailsMutation = Pick<Mutation, 'refactoredCourseDetails'>;

export type GetPaymentMethodTypeByIdQueryVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type GetPaymentMethodTypeByIdQuery = Pick<Query, 'getPaymentMethodTypeById'>;

export type GetUserInfoByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserInfoByIdQuery = { getInfoUserByUserId: Pick<UserType, 'id' | 'email' | 'firstName' | 'lastName'> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { currentUser: Pick<UserType, 'id' | 'email' | 'firstName' | 'lastName'> };

export type GetAdminAndInstructorUsersQueryVariables = Exact<{
  koOrganizationId: Scalars['String'];
}>;


export type GetAdminAndInstructorUsersQuery = { getAdminAndInstructorUsers: Array<Pick<UserType, 'id' | 'email' | 'firstName' | 'lastName' | 'hasProfile' | 'roles'>> };

export type GetUserDetailsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserDetailsQuery = { userDetails: (
    Pick<UserDetailsType, 'id' | 'email' | 'verified' | 'insertInstant' | 'lastLoginInstant' | 'firstName' | 'lastName' | 'username' | 'mobilePhone' | 'birthDate' | 'roles'>
    & { recentLogins?: Maybe<Array<Pick<RecentLoginEntry, 'applicationName' | 'instant' | 'ipAddress'>>>, loginAttempts?: Maybe<Array<Pick<LoginAttempt, 'status' | 'createDate' | 'usedAt' | 'errorMessage'>>>, instructorDetails?: Maybe<Pick<InstructorDetailsView, 'level' | 'active' | 'showInWeb' | 'firstname' | 'lastname' | 'email' | 'joinDate' | 'leaveDate'>> }
  ) };

export type ToggleUserRoleMutationVariables = Exact<{
  toggleUserRoleInput: ToggleUserRoleInput;
}>;


export type ToggleUserRoleMutation = Pick<Mutation, 'toggleUserRole'>;

export type CourseHistoryByCourseIdQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type CourseHistoryByCourseIdQuery = { courseHistoryByCourseId: Array<(
    Pick<CourseHistory, 'id' | 'createDate' | 'updateDate' | 'createdByUserId' | 'userId' | 'userName' | 'action' | 'description' | 'courseId' | 'oldValues' | 'newValues' | 'prefixedCourseNumber' | 'courseStartDateTime'>
    & { user?: Maybe<(
      Pick<UserDetailsType, 'id' | 'email'>
      & { instructorDetails?: Maybe<Pick<InstructorDetailsView, 'email' | 'firstname' | 'lastname' | 'level'>> }
    )>, course?: Maybe<(
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'courseNumberFormat' | 'customCourseNumberPrefix' | 'paymentInterval'>
      & { lessons: Array<Pick<CourseLesson, 'id'>> }
    )> }
  )> };

export type CourseLessonBookingsByCourseQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type CourseLessonBookingsByCourseQuery = { courseLessonBookingsByCourse: Array<(
    Pick<CourseLessonBooking, 'id' | 'attendance' | 'courseLessonId' | 'bookingId'>
    & { booking: (
      Pick<Booking, 'id'>
      & { attendee?: Maybe<(
        Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname'>> }
      )> }
    ) }
  )> };

export type CourseLessonBookingsByBookingIdQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type CourseLessonBookingsByBookingIdQuery = { courseLessonBookingsByBookingId: Array<(
    Pick<CourseLessonBooking, 'id' | 'bookingDate' | 'bookingType' | 'attendance' | 'courseLessonId' | 'bookingId'>
    & { courseLesson: Pick<CourseLesson, 'id' | 'startDateTime'> }
  )> };

export type AttendanceListByCourseQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type AttendanceListByCourseQuery = { attendanceListByCourse: Array<(
    Pick<Booking, 'id' | 'mergedBookingIds' | 'noticeStaff' | 'noticeBooker' | 'attendanceListNote' | 'courseId' | 'payDate' | 'lessonSelectionMode'>
    & { attendee?: Maybe<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday' | 'customerNumber' | 'customerNumberPrefix'>
      & { badgeXAttendee?: Maybe<Array<(
        Pick<AttendeeBadge, 'id' | 'createDate' | 'dateOfAchivement'>
        & { badge: (
          Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color' | 'graphicUrl' | 'signedGraphicUrl'>
          & { badgeRequirements?: Maybe<Array<Pick<BadgeRequirement, 'id' | 'name' | 'sortOrder'>>> }
        ), attendeeBadgeRequirements?: Maybe<Array<Pick<AttendeeBadgeRequirement, 'id' | 'fulfilled'>>> }
      )>>, customer: Pick<Customer, 'firstname' | 'lastname'>, booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'phoneNumber' | 'mobileNumber' | 'email' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'gender'>> }
    )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'attendance' | 'note' | 'courseLessonId' | 'bookingId' | 'bookingDate'>>> }
  )> };

export type UpdateCourseLessonBookingMutationVariables = Exact<{
  updateCourseLessonBookingInput: UpdateCourseLessonBookingInput;
}>;


export type UpdateCourseLessonBookingMutation = { updateCourseLessonBooking: Pick<CourseLessonBooking, 'id' | 'attendance' | 'note'> };

export type CreateCourseLessonBookingMutationVariables = Exact<{
  newCourseLessonBookingInput: NewCourseLessonBookingInput;
}>;


export type CreateCourseLessonBookingMutation = { createCourseLessonBooking: Pick<CourseLessonBooking, 'id' | 'attendance' | 'note' | 'courseLessonId' | 'bookingId'> };

export type CreateCourseLessonBookingsByCourseIdMutationVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type CreateCourseLessonBookingsByCourseIdMutation = Pick<Mutation, 'createCourseLessonBookingsByCourseId'>;

export type GetCourseLessonBookingByCourseLessonAndBookingQueryVariables = Exact<{
  courseLessonId: Scalars['String'];
  bookingId: Scalars['String'];
}>;


export type GetCourseLessonBookingByCourseLessonAndBookingQuery = { courseLessonBookingByCourseLessonAndBooking: Pick<CourseLessonBooking, 'id' | 'bookingId' | 'attendance' | 'courseLessonId'> };

export type GetLessonsThatAreNotDeletableQueryVariables = Exact<{
  courseLessonIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetLessonsThatAreNotDeletableQuery = Pick<Query, 'getLessonsThatAreNotDeletable'>;

export type GetCourseTypeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseTypeQuery = { courseTypeById: (
    Pick<CourseType, 'id' | 'isActive' | 'showInWeb' | 'name' | 'shortHandId' | 'description' | 'minAge' | 'maxAge' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'annotation' | 'websiteInfo' | 'inWeekPlanner' | 'bold' | 'color' | 'fee' | 'vat' | 'invoiceTemplateSetId' | 'selfBookerCourse'>
    & { category?: Maybe<Pick<CourseCategory, 'id'>>, participationPrerequisites?: Maybe<Array<Pick<ParticipationPrerequisites, 'id' | 'groupLabel' | 'groupDescription' | 'optionalInputFields' | 'minCheckCount' | 'courseTypeId'>>>, additionalItems: Array<Pick<CourseAdditionalItem, 'id' | 'updateDate' | 'courseTypeId' | 'title' | 'grossPrice' | 'mode' | 'vat' | 'description'>> }
  ) };

export type GetDetailedCourseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDetailedCourseTypesQuery = { courseTypes: Array<(
    Pick<CourseType, 'id' | 'courseCount' | 'shortHandId' | 'name' | 'updateDate' | 'description' | 'minAge' | 'maxAge' | 'paymentInterval' | 'fee' | 'vat' | 'minAttendees' | 'maxAttendees' | 'annotation' | 'websiteInfo' | 'color' | 'isActive' | 'showInWeb' | 'selfBookerCourse'>
    & { participationPrerequisites?: Maybe<Array<Pick<ParticipationPrerequisites, 'id' | 'groupLabel' | 'groupDescription' | 'optionalInputFields' | 'minCheckCount' | 'courseTypeId'>>>, additionalItems: Array<Pick<CourseAdditionalItem, 'id' | 'updateDate' | 'courseTypeId' | 'title' | 'grossPrice' | 'mode' | 'vat' | 'description'>> }
  )> };

export type GetCourseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseTypesQuery = { courseTypes: Array<Pick<CourseType, 'id' | 'name' | 'description' | 'courseCount' | 'color' | 'invoiceTemplateSetId'>> };

export type GetCourseTypesWithPaginationQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetCourseTypesWithPaginationQuery = { courseTypesWithPagination: (
    Pick<CourseTypeWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<CourseType, 'id' | 'courseCount' | 'shortHandId' | 'name' | 'updateDate' | 'description' | 'minAge' | 'maxAge' | 'paymentInterval' | 'fee' | 'vat' | 'minAttendees' | 'maxAttendees' | 'annotation' | 'websiteInfo' | 'color' | 'isActive' | 'showInWeb' | 'invoiceTemplateSetId' | 'selfBookerCourse'>
      & { participationPrerequisites?: Maybe<Array<Pick<ParticipationPrerequisites, 'id' | 'groupLabel' | 'groupDescription' | 'optionalInputFields' | 'minCheckCount' | 'courseTypeId'>>> }
    )> }
  ) };

export type GetDiscountCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountCodesQuery = { discountCodes: Array<Pick<DiscountCode, 'id' | 'code' | 'internalName' | 'discountUnit' | 'discountValue' | 'scopeType' | 'scopeIds' | 'scopeLabels' | 'validFrom' | 'validUntil' | 'validUntilCourseEnd' | 'maxRedemptions' | 'allowWithMemberDiscount' | 'deactivatedAt' | 'deactivatedReason' | 'createDate' | 'redemptionCount' | 'referenceCount' | 'effectiveValidUntil'>> };

export type GetDiscountCodeFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountCodeFilterOptionsQuery = { discountCodes: Array<Pick<DiscountCode, 'id' | 'code'>> };

export type GetDiscountCodeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDiscountCodeQuery = { discountCode: (
    Pick<DiscountCode, 'id' | 'code' | 'internalName' | 'discountUnit' | 'discountValue' | 'scopeType' | 'scopeIds' | 'validFrom' | 'validUntil' | 'validUntilCourseEnd' | 'maxRedemptions' | 'allowWithMemberDiscount' | 'deactivatedAt' | 'deactivatedReason' | 'createDate' | 'redemptionCount' | 'referenceCount' | 'effectiveValidUntil' | 'scopeLabels'>
    & { bookings: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'createDate' | 'canceled' | 'bookedBy' | 'discount' | 'grossPrice'>
      & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname'>>, course?: Maybe<Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking'>> }
    )> }
  ) };

export type GetDiscountCodeForFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDiscountCodeForFormQuery = { discountCode: Pick<DiscountCode, 'id' | 'code' | 'internalName' | 'discountUnit' | 'discountValue' | 'scopeType' | 'scopeIds' | 'validFrom' | 'validUntil' | 'validUntilCourseEnd' | 'maxRedemptions' | 'allowWithMemberDiscount' | 'redemptionCount' | 'referenceCount' | 'effectiveValidUntil' | 'scopeLabels'> };

export type GetDiscountCodeScopeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountCodeScopeOptionsQuery = { locations: Array<Pick<Location, 'id' | 'name' | 'city'>>, courseTypes: Array<Pick<CourseType, 'id' | 'name'>>, coursesWithPagination: { items: Array<(
      Pick<Course, 'id' | 'prefixedCourseNumber' | 'startDateTime' | 'isArchived' | 'endDateTime'>
      & { courseType: Pick<CourseType, 'id' | 'name'>, location: Pick<Location, 'id' | 'name'> }
    )> } };

export type CreateDiscountCodeMutationVariables = Exact<{
  input: DiscountCodeInput;
}>;


export type CreateDiscountCodeMutation = { createDiscountCode: Pick<DiscountCode, 'id'> };

export type UpdateDiscountCodeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: DiscountCodeUpdateInput;
}>;


export type UpdateDiscountCodeMutation = { updateDiscountCode: Pick<DiscountCode, 'id'> };

export type DeactivateDiscountCodeMutationVariables = Exact<{
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
}>;


export type DeactivateDiscountCodeMutation = { deactivateDiscountCode: Pick<DiscountCode, 'id' | 'deactivatedAt' | 'deactivatedReason'> };

export type ReactivateDiscountCodeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReactivateDiscountCodeMutation = { reactivateDiscountCode: Pick<DiscountCode, 'id' | 'deactivatedAt' | 'deactivatedReason'> };

export type DeleteDiscountCodeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDiscountCodeMutation = Pick<Mutation, 'deleteDiscountCode'>;

export type GetPrerequisiteCoursesQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetPrerequisiteCoursesQuery = { prerequisiteCourses: (
    Pick<CourseWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'bookingCountWithoutWaitlist' | 'billedBookingCount' | 'freePlaces' | 'waitListCount' | 'bookingCount' | 'placeReservationsCount' | 'canceledBookingsCount' | 'settledBookingCount' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson' | 'annotation' | 'maxAttendees' | 'paymentInterval' | 'allowMonthlyPayment' | 'monthlySchedule' | 'isActive' | 'showInWeb' | 'paymentType' | 'lessonCount'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'description' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat' | 'discount' | 'discountUnit' | 'isSpecial'>>, installmentRates: Array<Pick<InstallmentRate, 'id' | 'courseId' | 'installmentAmount' | 'installmentDue' | 'installmentType'>>, lessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>>, visibility: (
        Pick<CourseVisibilityResult, 'visibleForAll' | 'reason' | 'hideAfterDays'>
        & { restriction: (
          Pick<CourseVisibilityRestriction, 'membersOnly' | 'startDateTime' | 'endDateTime' | 'inTimeRange' | 'expireAction'>
          & { prerequisiteCourses: Array<Pick<Course, 'id'>> }
        ) }
      ), enabledCourses?: Maybe<Array<(
        Pick<EnabledCourse, 'id' | 'prefixedCourseNumber'>
        & { courseType: Pick<CourseType, 'id' | 'color'>, enabledRestriction?: Maybe<Pick<BookingRestriction, 'id' | 'includeBookingList' | 'includeWaitingList' | 'membersOnly'>> }
      )>>, bookingRestriction?: Maybe<Pick<BookingRestriction, 'id' | 'active' | 'visibleForAll' | 'includeBookingList' | 'includeWaitingList' | 'membersOnly' | 'blockedPlaces' | 'startDateTime' | 'endDateTime'>> }
    )> }
  ) };

export type CourseLateEntryPricingConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type CourseLateEntryPricingConfigurationQuery = { lateEntryPricingConfigurationPublic: Pick<SettingEndUserApp, 'lateEntryPricingPolicy' | 'minimumPartialBookingLessonCount'> };

export type GetLocalStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocalStateQuery = { LocalState: { createCourse: Pick<CreateCourse, 'locationId'>, bookAttendees: (
      Pick<BookAttendees, 'selectedCourseId'>
      & { selectedAttendee?: Maybe<Pick<SelectedAttendee, 'id' | 'firstname' | 'bookedCourseIds'>> }
    ) } };

export type GetInstructorsByIdQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetInstructorsByIdQuery = { findInstructorByIds: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> };

export type GetReferenceCoursesLinkQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetReferenceCoursesLinkQuery = Pick<Query, 'getReferenceCoursesLink'>;

export type CourseIsPrerequisiteCourseForQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type CourseIsPrerequisiteCourseForQuery = { courseIsPrerequisiteCourseFor: Array<(
    Pick<Course, 'id' | 'prefixedCourseNumber' | 'blockBookingOnline'>
    & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, bookingRestriction?: Maybe<Pick<BookingRestriction, 'id' | 'includeWaitingList' | 'includeBookingList'>>, visibility: (
      Pick<CourseVisibilityResult, 'visibleForAll' | 'reason'>
      & { restriction: Pick<CourseVisibilityRestriction, 'membersOnly' | 'inTimeRange' | 'expireAction'> }
    ) }
  )> };

export type RemoveCourseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCourseMutation = Pick<Mutation, 'removeCourse'>;

export type BookAttendeeGetLocalStateQueryVariables = Exact<{ [key: string]: never; }>;


export type BookAttendeeGetLocalStateQuery = { LocalState: { bookAttendees: (
      Pick<BookAttendees, 'selectedCourseId'>
      & { selectedAttendee?: Maybe<Pick<SelectedAttendee, 'id' | 'firstname' | 'bookedCourseIds'>> }
    ) } };

export type BookAttendeeGetSelectedAttendeeQueryVariables = Exact<{ [key: string]: never; }>;


export type BookAttendeeGetSelectedAttendeeQuery = { LocalState: { bookAttendees: { selectedAttendee?: Maybe<Pick<SelectedAttendee, 'id' | 'firstname' | 'bookedCourseIds'>> } } };

export type BookAttendeeGetSelectedCourseQueryVariables = Exact<{ [key: string]: never; }>;


export type BookAttendeeGetSelectedCourseQuery = { LocalState: { bookAttendees: Pick<BookAttendees, 'selectedCourseId'> } };

export type BookAttendeeSetSelectedAttendeeMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  firstname?: Maybe<Scalars['String']>;
  bookedCourseIds?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type BookAttendeeSetSelectedAttendeeMutation = Pick<Mutation, 'bookAttendeeSetSelectedAttendee'>;

export type BookAttendeeSetSelectedCourseMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type BookAttendeeSetSelectedCourseMutation = Pick<Mutation, 'bookAttendeeSetSelectedCourse'>;

export type UpdateLocalLocationIdMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type UpdateLocalLocationIdMutation = Pick<Mutation, 'updateLocalLocationId'>;

export type GetCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoursesQuery = { courses: Array<(
    Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'bookingCount' | 'billedBookingCount' | 'freePlaces' | 'settledBookingCount' | 'startDateTime' | 'endDateTime' | 'annotation' | 'maxAttendees' | 'paymentInterval' | 'allowMonthlyPayment' | 'monthlySchedule' | 'isActive' | 'showInWeb' | 'blockBookingOnline'>
    & { courseType: Pick<CourseType, 'id' | 'name' | 'description' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat' | 'discount' | 'discountUnit' | 'isSpecial'>> }
  )> };

export type GetCoursesWithPaginationQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  currentUserOnly?: Maybe<Scalars['Boolean']>;
  excludedCourseIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCoursesWithPaginationQuery = { coursesWithPagination: (
    Pick<CourseWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'bookingCountWithoutWaitlist' | 'billedBookingCount' | 'freePlaces' | 'waitListCount' | 'bookingCount' | 'placeReservationsCount' | 'canceledBookingsCount' | 'settledBookingCount' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson' | 'annotation' | 'maxAttendees' | 'paymentInterval' | 'allowMonthlyPayment' | 'monthlySchedule' | 'isActive' | 'showInWeb' | 'blockBookingOnline' | 'paymentType' | 'customInvoiceDueDays' | 'lessonCount' | 'allowLessonBooking' | 'allowMolliePayment' | 'mollieOptional' | 'isArchived'>
      & { courseType: (
        Pick<CourseType, 'id' | 'name' | 'description' | 'color'>
        & { category?: Maybe<Pick<CourseCategory, 'id' | 'name'>> }
      ), location: Pick<Location, 'id' | 'city' | 'name'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat' | 'discount' | 'discountUnit' | 'isSpecial'>>, installmentRates: Array<Pick<InstallmentRate, 'id' | 'courseId' | 'installmentAmount' | 'installmentDue' | 'installmentType'>>, lessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>>, visibility: (
        Pick<CourseVisibilityResult, 'visibleForAll' | 'reason' | 'hideAfterDays'>
        & { restriction: (
          Pick<CourseVisibilityRestriction, 'membersOnly' | 'startDateTime' | 'endDateTime' | 'inTimeRange' | 'expireAction'>
          & { prerequisiteCourses: Array<Pick<Course, 'id'>> }
        ) }
      ) }
    )> }
  ) };

export type GetCourseByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseByIdQuery = { courseById: (
    Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'courseNumberFormat' | 'customCourseNumberPrefix' | 'paymentInterval' | 'lateEntryPricingMode' | 'minimumPartialBookingLessonCount' | 'minAttendees' | 'maxAttendees' | 'maxAssistantsPerLesson' | 'maxWaitlist' | 'bookingCount' | 'canceledBookingsCount' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson' | 'cycle' | 'annotation' | 'websiteInfo' | 'additionalShortInfo' | 'allowMonthlyPayment' | 'allowUpFrontPayment' | 'allowMolliePayment' | 'mollieOptional' | 'monthlySchedule' | 'isActive' | 'showInWeb' | 'blockBookingOnline' | 'freePlaces' | 'paymentType' | 'allowLessonBooking' | 'customInvoiceDueDays' | 'dateOfFirstInstallment'>
    & { courseType: Pick<CourseType, 'id' | 'name' | 'description' | 'showInWeb'>, location: (
      Pick<Location, 'id' | 'city' | 'name'>
      & { venues: Array<Pick<Venue, 'id' | 'name'>> }
    ), venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level' | 'email'>>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'vat' | 'discount' | 'discountUnit' | 'isSpecial' | 'includedEntranceFee'>>, lessons: Array<(
      Pick<CourseLesson, 'id' | 'locationId' | 'venueId' | 'startDateTime' | 'endDateTime' | 'billingDate'>
      & { location: Pick<Location, 'id' | 'city'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>>, courseLessonBookings: Array<Pick<CourseLessonBooking, 'id' | 'bookingId' | 'attendance' | 'courseLessonId'>> }
    )>, installmentRates: Array<Pick<InstallmentRate, 'id' | 'courseId' | 'installmentAmount' | 'installmentDue' | 'installmentType'>>, additionalItems: Array<Pick<CourseAdditionalItem, 'id' | 'updateDate' | 'courseId' | 'title' | 'grossPrice' | 'mode' | 'vat' | 'description'>>, visibility: (
      Pick<CourseVisibilityResult, 'visibleForAll' | 'reason' | 'hideAfterDays'>
      & { restriction: (
        Pick<CourseVisibilityRestriction, 'membersOnly' | 'startDateTime' | 'endDateTime' | 'inTimeRange' | 'expireAction'>
        & { prerequisiteCourses: Array<Pick<Course, 'id'>> }
      ) }
    ) }
  ) };

export type GetCourseStartEndByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseStartEndByIdQuery = { courseById: Pick<Course, 'id' | 'startDateTime' | 'endDateTime' | 'blockBookingOnline'> };

export type GetCourseByLocationIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCourseByLocationIdQuery = { courseByLocationId: Array<(
    Pick<Course, 'id'>
    & { lessons: Array<Pick<CourseLesson, 'startDateTime' | 'endDateTime'>>, courseType: Pick<CourseType, 'name' | 'description' | 'annotation' | 'websiteInfo'> }
  )> };

export type UpdateCourseMutationVariables = Exact<{
  id: Scalars['String'];
  editCourseData: EditCourseInput;
  fillFromWaitingList?: Maybe<Scalars['Boolean']>;
  notifyBooker?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateCourseMutation = { updateCourse: (
    Pick<Course, 'id' | 'paymentInterval' | 'lateEntryPricingMode' | 'minimumPartialBookingLessonCount' | 'minAttendees' | 'maxAttendees' | 'maxAssistantsPerLesson' | 'maxWaitlist' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson' | 'cycle' | 'annotation' | 'websiteInfo' | 'allowMonthlyPayment' | 'allowUpFrontPayment' | 'allowMolliePayment' | 'mollieOptional' | 'paymentType' | 'monthlySchedule' | 'isActive' | 'showInWeb' | 'blockBookingOnline' | 'customInvoiceDueDays'>
    & { coursePrice: Array<Pick<CoursePrice, 'id' | 'vat' | 'grossPrice' | 'discount' | 'discountUnit' | 'courseId' | 'includedEntranceFee'>> }
  ) };

export type UpdateCourseAndBookingsMutationVariables = Exact<{
  updateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
  dryRun: Scalars['Boolean'];
}>;


export type UpdateCourseAndBookingsMutation = { updateCourseAndBookings: (
    Pick<UpdateCourseAndBookingsResult, 'dryRun'>
    & { course: (
      Pick<Course, 'id' | 'lateEntryPricingMode' | 'minimumPartialBookingLessonCount'>
      & { lessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>> }
    ), bookings: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'noticeStaff' | 'noticeBooker' | 'additionalInfo' | 'bookingType' | 'startDateTime' | 'paymentType' | 'payDate' | 'grossPrice' | 'canceled' | 'monthlySchedule' | 'creditedBalance' | 'memberDiscount' | 'discount' | 'discountName' | 'bookedLessonCount' | 'isSettled' | 'paymentMethodId'>
      & { invoice?: Maybe<Pick<Invoice, 'id'>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount' | 'paymentDue' | 'paymentDone' | 'title' | 'type'>>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditcardNumber' | 'creditCardAccountholder' | 'expirationDate' | 'sepaAccountholder' | 'iban' | 'bic' | 'bank' | 'paypalAccountholder' | 'email' | 'bankTransfer' | 'onlinePayment'>> }
    )>, courseLessonsPreview?: Maybe<Array<Pick<CourseLesson, 'id' | 'indexOfLessonInCourse' | 'startDateTime' | 'endDateTime'>>>, courseLessonBookingsPreview?: Maybe<Array<(
      Pick<CourseLessonBookingsPreview, 'bookingId'>
      & { courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId'>>> }
    )>> }
  ) };

export type GetCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCitiesQuery = { cities: Array<Pick<LocationCity, 'city'>> };

export type GetLocationsSortedByCityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsSortedByCityQuery = { locationsSortedByCity: Array<(
    Pick<LocationsGroupedByCity, 'city'>
    & { locations: Array<(
      Pick<LocationGroupedByCityLocation, 'id' | 'city' | 'name'>
      & { venues: Array<Pick<LocationGroupedByCityVenue, 'id' | 'name'>> }
    )> }
  )> };

export type GetLocationsByCityQueryVariables = Exact<{
  city: Scalars['String'];
}>;


export type GetLocationsByCityQuery = { locationsByCity: Array<(
    Pick<Location, 'id' | 'name'>
    & { venues: Array<Pick<Venue, 'id' | 'name'>> }
  )> };

export type GetInstructorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstructorsQuery = { instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level' | 'leaveDate' | 'active'>> };

export type CreateCourseMutationVariables = Exact<{
  newCourseData: NewCourseInput;
}>;


export type CreateCourseMutation = { createCourse: Pick<Course, 'id' | 'lateEntryPricingMode' | 'minimumPartialBookingLessonCount'> };

export type GetCourseTypeStateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseTypeStateQuery = { courseTypeStateById: Pick<CourseType, 'id' | 'isActive' | 'showInWeb' | 'name'> };

export type RemoveCourseTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCourseTypeMutation = Pick<Mutation, 'removeCourseType'>;

export type CreateCourseTypeMutationVariables = Exact<{
  newCourseTypeData: NewCourseTypeInput;
}>;


export type CreateCourseTypeMutation = { createCourseType: (
    Pick<CourseType, 'id' | 'isActive' | 'showInWeb' | 'name' | 'shortHandId' | 'description' | 'minAge' | 'maxAge' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'annotation' | 'websiteInfo' | 'inWeekPlanner' | 'bold' | 'color'>
    & { category?: Maybe<Pick<CourseCategory, 'id'>>, participationPrerequisites?: Maybe<Array<Pick<ParticipationPrerequisites, 'id' | 'groupLabel' | 'groupDescription' | 'optionalInputFields' | 'minCheckCount' | 'courseTypeId'>>> }
  ) };

export type UpdateCourseTypeMutationVariables = Exact<{
  id: Scalars['String'];
  newCourseTypeData: NewCourseTypeInput;
}>;


export type UpdateCourseTypeMutation = { updateCourseType: (
    Pick<CourseType, 'id' | 'isActive' | 'showInWeb' | 'name' | 'shortHandId' | 'description' | 'minAge' | 'maxAge' | 'paymentInterval' | 'minAttendees' | 'maxAttendees' | 'annotation' | 'websiteInfo' | 'inWeekPlanner' | 'bold' | 'color'>
    & { category?: Maybe<Pick<CourseCategory, 'id'>> }
  ) };

export type CourseTypeGetCourseCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CourseTypeGetCourseCategoriesQuery = { courseCategories: Array<Pick<CourseCategory, 'id' | 'name'>> };

export type GetCourseCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseCategoriesQuery = { courseCategories: Array<(
    Pick<CourseCategory, 'id' | 'isActive' | 'name' | 'description'>
    & { linkedCourseTypes: Array<Pick<CourseType, 'id' | 'name' | 'color' | 'showInWeb'>> }
  )> };

export type GetCourseCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseCategoryQuery = { courseCategoryById: (
    Pick<CourseCategory, 'id' | 'isActive' | 'name' | 'description'>
    & { linkedCourseTypes: Array<Pick<CourseType, 'id' | 'name'>> }
  ) };

export type CreateCourseCategoryMutationVariables = Exact<{
  newCourseCategoryData: NewCourseCategoryInput;
}>;


export type CreateCourseCategoryMutation = { createCourseCategory: (
    Pick<CourseCategory, 'id' | 'name' | 'isActive' | 'description'>
    & { linkedCourseTypes: Array<Pick<CourseType, 'id'>> }
  ) };

export type UpdateCourseCategoryMutationVariables = Exact<{
  id: Scalars['String'];
  newCourseCategoryData: NewCourseCategoryInput;
}>;


export type UpdateCourseCategoryMutation = { updateCourseCategory: (
    Pick<CourseCategory, 'id' | 'name' | 'isActive' | 'description'>
    & { linkedCourseTypes: Array<Pick<CourseType, 'id'>> }
  ) };

export type CourseGetInstructorsQueryVariables = Exact<{ [key: string]: never; }>;


export type CourseGetInstructorsQuery = { instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level' | 'active'>> };

export type CourseGetInstructorsByLocationQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type CourseGetInstructorsByLocationQuery = { findInstructorsByLocation: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level' | 'active' | 'leaveDate'>> };

export type GetCourseLessonsByCourseIdQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseLessonsByCourseIdQuery = { courseLessonsByCourseId: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>> };

export type GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseLessonsByCourseIdWithCourseLessonBookingsQuery = { courseLessonsByCourseId: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
    & { bookings?: Maybe<Array<(
      Pick<Booking, 'id'>
      & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname'>> }
    )>>, courseLessonBookings: Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'attendance' | 'bookingId'>> }
  )> };

export type GetCourseLessonsByCourseIdWithLocationQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseLessonsByCourseIdWithLocationQuery = { courseLessonsByCourseId: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
    & { location: Pick<Location, 'id' | 'city' | 'name'> }
  )> };

export type GetCourseVariablesForTemplateQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseVariablesForTemplateQuery = { courseLessonsByCourseId: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
    & { location: Pick<Location, 'id' | 'city' | 'name'>, course: (
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'description'> }
    ) }
  )> };

export type IsCourseNumberAvailableQueryVariables = Exact<{
  customCourseNumberPrefix: Scalars['String'];
  courseId: Scalars['String'];
}>;


export type IsCourseNumberAvailableQuery = Pick<Query, 'isCourseNameUnique'>;

export type GetFreePlacesByCourseIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFreePlacesByCourseIdQuery = { courseById: Pick<Course, 'id' | 'freePlaces' | 'bookingCount'> };

export type GetMaxAttendeesByCourseIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMaxAttendeesByCourseIdQuery = { courseById: Pick<Course, 'id' | 'maxAttendees'> };

export type GetAllCoursesWithAllowMonthlyPaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCoursesWithAllowMonthlyPaymentQuery = { getAllCoursesWithAllowMonthlyPayment: Array<Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowMonthlyPayment'>> };

export type GetCourseAnnotationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseAnnotationQuery = { courseById: Pick<Course, 'id' | 'annotation'> };

export type UpdateCourseAnnotationMutationVariables = Exact<{
  id: Scalars['String'];
  annotation?: Maybe<Scalars['String']>;
}>;


export type UpdateCourseAnnotationMutation = { updateCourseAnnotation: Pick<Course, 'id' | 'annotation'> };

export type GetCourseMemberDiscountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseMemberDiscountQuery = { courseById: (
    Pick<Course, 'id'>
    & { coursePrice: Array<Pick<CoursePrice, 'id' | 'discount' | 'discountUnit'>> }
  ) };

export type GetCoursesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCoursesByIdsQuery = { coursesByIds: Array<(
    Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'bookingCount' | 'billedBookingCount' | 'freePlaces' | 'settledBookingCount' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson' | 'annotation' | 'maxAttendees' | 'paymentInterval' | 'allowMonthlyPayment' | 'monthlySchedule' | 'isActive' | 'showInWeb' | 'blockBookingOnline'>
    & { courseType: Pick<CourseType, 'id' | 'name' | 'description' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat' | 'discount' | 'discountUnit' | 'isSpecial'>> }
  )> };

export type GetCoursesByIdsMinimalQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCoursesByIdsMinimalQuery = { coursesByIds: Array<(
    Pick<Course, 'id' | 'prefixedCourseNumber' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
    & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
  )> };

export type UpdateMultipleCoursesShowInWebMutationVariables = Exact<{
  courseIds: Array<Scalars['ID']> | Scalars['ID'];
  showInWeb: Scalars['Boolean'];
}>;


export type UpdateMultipleCoursesShowInWebMutation = { updateMultipleCoursesShowInWeb: Array<Pick<Course, 'id' | 'showInWeb'>> };

export type UpdateCourseBlockBookingOnlineMutationVariables = Exact<{
  courseId: Scalars['String'];
  blockBookingOnline: Scalars['Boolean'];
}>;


export type UpdateCourseBlockBookingOnlineMutation = { updateCourseBlockBookingOnline: Pick<Course, 'id' | 'blockBookingOnline' | 'prefixedCourseNumber'> };

export type DeactivateCoursesAllowLessonBookingMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type DeactivateCoursesAllowLessonBookingMutation = { deactivateCoursesAllowLessonBooking: Array<Pick<Course, 'id' | 'allowLessonBooking'>> };

export type UpdateCourseArchivedMutationVariables = Exact<{
  courseId: Scalars['String'];
  isArchived: Scalars['Boolean'];
}>;


export type UpdateCourseArchivedMutation = { updateCourseArchived: Pick<Course, 'id' | 'isArchived'> };

export type UpdateMultipleCoursesArchivedMutationVariables = Exact<{
  courseIds: Array<Scalars['ID']> | Scalars['ID'];
  isArchived: Scalars['Boolean'];
}>;


export type UpdateMultipleCoursesArchivedMutation = { updateMultipleCoursesArchived: Array<Pick<Course, 'id' | 'isArchived'>> };

export type GetCourseDetailsByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCourseDetailsByIdQuery = { courseDetailsById: (
    Pick<CourseDetails, 'courseId'>
    & { course: (
      Pick<Course, 'id' | 'prefixedCourseNumber' | 'additionalShortInfo' | 'startDateTime' | 'paymentInterval' | 'waitListCount' | 'maxAttendees' | 'bookingCount' | 'placeReservationsCount' | 'canceledBookingsCount' | 'lessonCount' | 'allowLessonBooking' | 'allowMolliePayment' | 'mollieOptional' | 'freePlaces' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
      & { location: Pick<Location, 'id' | 'city' | 'name'>, coursePrice: Array<Pick<CoursePrice, 'id' | 'grossPrice'>>, courseType: Pick<CourseType, 'id' | 'name'>, lessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'courseLessonBookingCount' | 'freePlaces' | 'indexOfLessonInCourse'>>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'email'>> }
    ), placeReservations: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'isSettled'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>> }
      )>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance' | 'bookingId'>>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId' | 'indexOfLessonInCourse'>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'paymentProvider' | 'mollieMethod'>>> }
    )>, waitlistBookings: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'isSettled'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>> }
      )>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance' | 'bookingId'>>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId' | 'indexOfLessonInCourse'>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'paymentProvider' | 'mollieMethod'>>> }
    )>, unbilledBookings: Array<(
      Pick<Booking, 'lessonSelectionMode' | 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'isSettled'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>>, badgeXAttendee?: Maybe<Array<(
          Pick<AttendeeBadge, 'id' | 'createDate' | 'dateOfAchivement'>
          & { badge: Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color'> }
        )>> }
      )>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance' | 'bookingId'>>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId' | 'indexOfLessonInCourse'>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'paymentProvider' | 'mollieMethod'>>> }
    )>, billedBookings: Array<(
      Pick<Booking, 'lessonSelectionMode' | 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'isSettled'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>>, badgeXAttendee?: Maybe<Array<(
          Pick<AttendeeBadge, 'id' | 'createDate' | 'dateOfAchivement'>
          & { badge: Pick<Badge, 'id' | 'name' | 'abbreviation' | 'color'> }
        )>> }
      )>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance' | 'bookingId'>>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId' | 'indexOfLessonInCourse'>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'paymentProvider' | 'mollieMethod'>>> }
    )>, canceledBookings: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'isSettled'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'nonDisclosureNotice' | 'credit'>> }
      )>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance' | 'bookingId'>>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'locationId' | 'indexOfLessonInCourse'>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'paymentProvider' | 'mollieMethod'>>> }
    )> }
  ) };

export type GetInstallmentPlanQueryVariables = Exact<{
  newInstallmentPlanInput: NewInstallmentPlanInput;
}>;


export type GetInstallmentPlanQuery = Pick<Query, 'getInstallmentPlanPreview'>;

export type GetInstallmentRatesByCourseIdQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetInstallmentRatesByCourseIdQuery = { installmentRatesByCourseId: Array<Pick<InstallmentRate, 'id' | 'courseId' | 'installmentAmount' | 'installmentDue'>> };

export type ErasurePreviewMutationVariables = Exact<{
  bookerId: Scalars['ID'];
  includeLinkedBookers?: Maybe<Scalars['Boolean']>;
}>;


export type ErasurePreviewMutation = { erasurePreview: (
    Pick<ErasureReportType, 'dryRun' | 'bookerIds' | 'customerNumbers' | 'attendeeCount' | 'bookingCount' | 'deletedWaitlistBookingCount' | 'invoiceNumbers' | 'hasLoginAccount' | 'retentionEndsAt'>
    & { warnings: Array<Pick<ErasureWarningType, 'code' | 'message' | 'count' | 'amount' | 'blocking'>>, linkedBookers: Array<Pick<ErasureLinkedBookerType, 'id' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname'>> }
  ) };

export type EraseBookerDataMutationVariables = Exact<{
  bookerId: Scalars['ID'];
  includeLinkedBookers?: Maybe<Scalars['Boolean']>;
}>;


export type EraseBookerDataMutation = { eraseBookerData: (
    Pick<ErasureReportType, 'dryRun' | 'bookerIds' | 'customerNumbers' | 'attendeeCount' | 'bookingCount' | 'deletedWaitlistBookingCount' | 'invoiceNumbers' | 'hasLoginAccount' | 'fusionAuthAccountDeleted' | 'retentionEndsAt' | 'erasedAt'>
    & { warnings: Array<Pick<ErasureWarningType, 'code' | 'message' | 'count' | 'amount' | 'blocking'>>, linkedBookers: Array<Pick<ErasureLinkedBookerType, 'id' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname'>> }
  ) };

export type AutoMergeDuplicatesDryRunMutationVariables = Exact<{
  input: AutoMergeDryRunInput;
}>;


export type AutoMergeDuplicatesDryRunMutation = { autoMergeDuplicatesDryRun: (
    Pick<AutoMergeDryRunResult, 'totalPairs' | 'totalBookersAffected'>
    & { pairs: Array<(
      Pick<AutoMergeDryRunPair, 'winnerId' | 'winnerName' | 'winnerEmail' | 'loserId' | 'loserName' | 'loserEmail' | 'matchScore'>
      & { scoreBreakdown?: Maybe<Pick<ScoreBreakdownType, 'exactEmail' | 'exactName' | 'fuzzyName' | 'samePhone' | 'sameAddress' | 'sameAttendee' | 'sameAttendeeMultiple' | 'differentEmail' | 'differentName' | 'differentPhone' | 'differentAddress' | 'missingName' | 'total'>> }
    )> }
  ) };

export type AutoMergeDuplicatesMutationVariables = Exact<{
  input: AutoMergeInput;
}>;


export type AutoMergeDuplicatesMutation = { autoMergeDuplicates: Pick<AutoMergeStartResult, 'runId' | 'message'> };

export type GetAutoMergeStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutoMergeStatusQuery = { getAutoMergeStatus?: Maybe<(
    Pick<AutoMergeStatus, 'status' | 'totalGroupsToMerge' | 'mergedSoFar' | 'failedMerges' | 'skippedMerges' | 'startedAt' | 'completedAt' | 'durationMs' | 'confidenceThreshold'>
    & { failures?: Maybe<Array<Pick<AutoMergeFailureType, 'winnerId' | 'loserId' | 'winnerName' | 'loserName' | 'error'>>> }
  )> };

export type GetDuplicateMatchStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDuplicateMatchStatsQuery = { getDuplicateMatchStats: Pick<DuplicateMatchStats, 'totalGroups' | 'affectedBookerCount' | 'autoMergeableGroups'> };

export type GetAttendeeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAttendeeQuery = { attendee: (
    Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday' | 'gender'>
    & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender'>> }
  ) };

export type GetAttendeesByIdsQueryVariables = Exact<{
  attendeeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetAttendeesByIdsQuery = { attendeesByIds: Array<(
    Pick<Attendee, 'id' | 'firstname' | 'lastname'>
    & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email'>> }
  )> };

export type AttendeeOverviewGetAttendeesMinimalQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type AttendeeOverviewGetAttendeesMinimalQuery = { attendees: (
    Pick<AttendeeWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Attendee, 'id' | 'erasedAt' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname' | 'birthday' | 'gender' | 'deletable' | 'member' | 'addition' | 'annotation' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { booker?: Maybe<(
        Pick<Booker, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'initialContact' | 'addition' | 'annotation' | 'credit' | 'nonDisclosureNotice' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
        & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>> }
      )>, defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'>, bookingsKo9?: Maybe<Array<Pick<BookingsKo9, 'id' | 'courseNumber' | 'courseName' | 'firstCourseLesson'>>> }
    )> }
  ) };

export type CheckIfIsBookedIntoCourseQueryVariables = Exact<{
  courseId: Scalars['ID'];
  attendeeId: Scalars['ID'];
}>;


export type CheckIfIsBookedIntoCourseQuery = Pick<Query, 'checkIfIsBookedIntoCourse'>;

export type GetBookedAttendeesByCourseIdQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetBookedAttendeesByCourseIdQuery = { bookedAttendeesByCourseId: Array<Pick<Attendee, 'id'>> };

export type GetAttendeeVariableForTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAttendeeVariableForTemplateQuery = { attendee: (
    Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday'>
    & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname'>> }
  ) };

export type GetAttendeeDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAttendeeDetailsQuery = { attendee: (
    Pick<Attendee, 'id' | 'erasedAt' | 'firstname' | 'lastname' | 'birthday' | 'gender' | 'member' | 'customerNumberPrefix' | 'customerNumber'>
    & { defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'>, booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender'>> }
  ) };

export type GetAttendeeDetailsByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAttendeeDetailsByIdQuery = { attendee: (
    Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday' | 'gender' | 'member' | 'customerNumberPrefix' | 'customerNumber'>
    & { defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'>, booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender'>> }
  ) };

export type TransferAttendeeToBookerMutationVariables = Exact<{
  attendeeId: Scalars['ID'];
  newBookerId: Scalars['ID'];
}>;


export type TransferAttendeeToBookerMutation = { transferAttendeeToBooker: Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber'> };

export type LinkAttendeeToBookerMutationVariables = Exact<{
  attendeeId: Scalars['ID'];
  birthday?: Maybe<Scalars['DateTime']>;
}>;


export type LinkAttendeeToBookerMutation = { linkAttendeeToBooker: Pick<Attendee, 'id' | 'customerId' | 'birthday' | 'customerNumberPrefix' | 'customerNumber'> };

export type GetAttendeeMemberStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAttendeeMemberStatusQuery = { attendee: Pick<Attendee, 'id' | 'member'> };

export type ChangeAttendeeMemberStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  member: Scalars['Boolean'];
}>;


export type ChangeAttendeeMemberStatusMutation = { changeAttendeeMemberStatus: Pick<Attendee, 'id' | 'member'> };

export type ChangeDefaultPaymentMethodMutationVariables = Exact<{
  attendeeId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
}>;


export type ChangeDefaultPaymentMethodMutation = { changeDefaultPaymentMethod: (
    Pick<Attendee, 'id'>
    & { defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditcardNumber' | 'creditCardAccountholder' | 'expirationDate' | 'sepaAccountholder' | 'iban' | 'bic' | 'bank' | 'paypalAccountholder' | 'email' | 'bankTransfer' | 'onlinePayment'> }
  ) };

export type GetAttendeesWithByStandardPaymentMethodQueryVariables = Exact<{
  paymentTransferType: PaymentTransferType;
  koOrganizationId: Scalars['ID'];
  targetPaymentTransferType: PaymentTransferType;
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetAttendeesWithByStandardPaymentMethodQuery = { getAttendeesWithByStandardPaymentMethod: (
    Pick<AttendeeWithPagination, 'total' | 'existsMore'>
    & { items: Array<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname'>
      & { defaultPaymentMethod: Pick<PaymentMethod, 'id' | 'type'>, booker?: Maybe<(
        Pick<Booker, 'id' | 'firstname' | 'lastname'>
        & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'type'>>> }
      )> }
    )> }
  ) };

export type ChangeMultipleAttendeesDefaultPaymentMethodsMutationVariables = Exact<{
  attendeeIds: Array<Scalars['ID']> | Scalars['ID'];
  targetPaymentTransferType: PaymentTransferType;
  koOrganizationId: Scalars['ID'];
}>;


export type ChangeMultipleAttendeesDefaultPaymentMethodsMutation = { changeMultipleAttendeesDefaultPaymentMethods: Array<Pick<Attendee, 'id'>> };

export type GetBillingAddressTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingAddressTemplatesQuery = { billingAddressTemplates: Array<Pick<BillingAddressTemplate, 'id' | 'name' | 'companyName' | 'firstname' | 'lastname' | 'addition' | 'street' | 'postCode' | 'city'>> };

export type CreateBillingAddressTemplateMutationVariables = Exact<{
  input: CreateBillingAddressTemplateInput;
}>;


export type CreateBillingAddressTemplateMutation = { createBillingAddressTemplate: Pick<BillingAddressTemplate, 'id' | 'name' | 'companyName' | 'firstname' | 'lastname' | 'addition' | 'street' | 'postCode' | 'city'> };

export type UpdateBillingAddressTemplateMutationVariables = Exact<{
  input: UpdateBillingAddressTemplateInput;
}>;


export type UpdateBillingAddressTemplateMutation = { updateBillingAddressTemplate: Pick<BillingAddressTemplate, 'id' | 'name' | 'companyName' | 'firstname' | 'lastname' | 'addition' | 'street' | 'postCode' | 'city'> };

export type DeleteBillingAddressTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBillingAddressTemplateMutation = Pick<Mutation, 'deleteBillingAddressTemplate'>;

export type CreateBookerMutationVariables = Exact<{
  newBookerData: BookerInput;
}>;


export type CreateBookerMutation = { createBooker: (
    Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'secondaryEmail' | 'initialContact' | 'dsgvo' | 'newsletter' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'credit' | 'nonDisclosureNotice' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
    & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>>, attendees?: Maybe<Array<(
      Pick<Attendee, 'id' | 'gender' | 'lastname' | 'firstname' | 'birthday' | 'member' | 'addition' | 'annotation' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { defaultPaymentMethod: Pick<PaymentMethod, 'id'>, bookings?: Maybe<Array<(
        Pick<Booking, 'id' | 'paymentType' | 'payDate'>
        & { courseLessons: Array<Pick<CourseLesson, 'id'>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id'>> }
      )>> }
    )>> }
  ) };

export type GetBookerWithAttendeeBookingsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBookerWithAttendeeBookingsQuery = { booker: (
    Pick<Booker, 'id' | 'customerId' | 'gender' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'secondaryEmail' | 'initialContact' | 'birthday' | 'dsgvo' | 'newsletter' | 'credit' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'nonDisclosureNotice' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity' | 'customerNumber' | 'userId'>
    & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>>, attendees?: Maybe<Array<(
      Pick<Attendee, 'id' | 'customerId' | 'gender' | 'lastname' | 'firstname' | 'birthday' | 'member' | 'addition' | 'annotation' | 'deletable' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { defaultPaymentMethod: Pick<PaymentMethod, 'id'>, bookings?: Maybe<Array<(
        Pick<Booking, 'id' | 'paymentType' | 'payDate'>
        & { courseLessons: Array<(
          Pick<CourseLesson, 'id' | 'courseId'>
          & { course: Pick<Course, 'id' | 'maxAttendees'> }
        )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id'>> }
      )>> }
    )>> }
  ) };

export type GetBookerForDuplicateBookerOverviewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBookerForDuplicateBookerOverviewQuery = { booker: (
    Pick<Booker, 'id' | 'customerId' | 'gender' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'initialContact' | 'dsgvo' | 'newsletter' | 'credit' | 'healthInsuranceFund' | 'annotation' | 'customerNumber' | 'customerNumberPrefix' | 'userId'>
    & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>>, attendees?: Maybe<Array<(
      Pick<Attendee, 'id' | 'customerId' | 'customerNumberPrefix' | 'customerNumber' | 'gender' | 'lastname' | 'firstname' | 'birthday' | 'member' | 'annotation'>
      & { defaultPaymentMethod: Pick<PaymentMethod, 'id'>, bookings?: Maybe<Array<(
        Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingType' | 'bookingNumber' | 'canceled'>
        & { invoice?: Maybe<Pick<Invoice, 'id'>>, courseLessons: Array<(
          Pick<CourseLesson, 'id' | 'courseId'>
          & { course: (
            Pick<Course, 'id' | 'courseNumber' | 'allowLessonBooking'>
            & { courseType: Pick<CourseType, 'id' | 'color' | 'name'> }
          ) }
        )> }
      )>> }
    )>> }
  ) };

export type UpdateBookerMutationVariables = Exact<{
  updateBookerData: BookerInput;
}>;


export type UpdateBookerMutation = { updateBooker: (
    Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'secondaryEmail' | 'initialContact' | 'dsgvo' | 'newsletter' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'credit' | 'nonDisclosureNotice' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
    & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>>, attendees?: Maybe<Array<(
      Pick<Attendee, 'id' | 'customerId' | 'gender' | 'lastname' | 'firstname' | 'birthday' | 'member' | 'deletable' | 'addition' | 'annotation' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { startedCourses: Array<Pick<Course, 'id' | 'prefixedCourseNumber'>>, defaultPaymentMethod: Pick<PaymentMethod, 'id'> }
    )>> }
  ) };

export type AttendeeTableGetCourseLessonsQueryVariables = Exact<{
  ids?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AttendeeTableGetCourseLessonsQuery = { courseLessons: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime'>
    & { course: (
      Pick<Course, 'id' | 'prefixedCourseNumber'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
    ), location: Pick<Location, 'id' | 'name' | 'city'> }
  )> };

export type GetBookingsByAttendeeQueryVariables = Exact<{
  attendeeId: Scalars['ID'];
}>;


export type GetBookingsByAttendeeQuery = { getBookingsByAttendeeId: Array<(
    Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled' | 'noticeStaff' | 'startDateTime'>
    & { course?: Maybe<(
      Pick<Course, 'id' | 'prefixedCourseNumber' | 'courseNumber'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
    )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'indexOfLessonInCourse'>> }
  )> };

export type DeleteAttendeeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAttendeeMutation = Pick<Mutation, 'deleteAttendee'>;

export type GetCourseLessonStartDatesQueryVariables = Exact<{
  ids?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCourseLessonStartDatesQuery = { courseLessons: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime'>
    & { course: Pick<Course, 'id' | 'prefixedCourseNumber'> }
  )> };

export type GetBookersOverviewQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetBookersOverviewQuery = { bookers: (
    Pick<BookerWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booker, 'id' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'dsgvo' | 'newsletter' | 'email' | 'mobileNumber' | 'phoneNumber' | 'birthday' | 'gender' | 'initialContact' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'credit' | 'nonDisclosureNotice' | 'userId'>
      & { attendees?: Maybe<Array<Pick<Attendee, 'firstname' | 'lastname' | 'id' | 'deletable' | 'addition' | 'annotation' | 'member'>>>, paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'bankTransfer' | 'onlinePayment' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'>>> }
    )> }
  ) };

export type BookerCoreFieldsFragment = (
  { __typename: 'Booker' }
  & Pick<Booker, 'id' | 'erasedAt' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'dsgvo' | 'newsletter' | 'email' | 'mobileNumber' | 'phoneNumber' | 'birthday' | 'gender' | 'initialContact' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'credit' | 'nonDisclosureNotice' | 'userId'>
);

export type BookerPaymentMethodsFieldsFragment = { paymentMethods?: Maybe<Array<(
    { __typename: 'PaymentMethod' }
    & Pick<PaymentMethod, 'id' | 'bankTransfer' | 'onlinePayment' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'>
  )>> };

export type BookerAttendeesFieldsFragment = { attendees?: Maybe<Array<(
    { __typename: 'Attendee' }
    & Pick<Attendee, 'firstname' | 'lastname' | 'id' | 'deletable' | 'addition' | 'annotation' | 'member'>
  )>> };

export type GetDynamicBookersQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  includePayment: Scalars['Boolean'];
  includeAttendees: Scalars['Boolean'];
}>;


export type GetDynamicBookersQuery = { bookersDynamic: (
    { __typename: 'BookerWithPagination' }
    & Pick<BookerWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      BookerCoreFieldsFragment
      & BookerPaymentMethodsFieldsFragment
      & BookerAttendeesFieldsFragment
    )> }
  ) };

export type GetBookerByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetBookerByEmailQuery = { getBookerByEmail?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email'>> };

export type GetBookersByIdQueryVariables = Exact<{
  bookerIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetBookersByIdQuery = { bookersById: Array<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email'>> };

export type SendBlankMailToMultipleBookersMutationVariables = Exact<{
  input: BlankMailInputTypes;
  file?: Maybe<Scalars['Upload']>;
}>;


export type SendBlankMailToMultipleBookersMutation = Pick<Mutation, 'sendBlankMailToMultipleBookers'>;

export type GetBookersByCourseIdsQueryVariables = Exact<{
  courseIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetBookersByCourseIdsQuery = { getBookersByCourseIds: Array<(
    Pick<Booker, 'id' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'dsgvo' | 'newsletter' | 'email' | 'mobileNumber' | 'phoneNumber' | 'birthday' | 'gender' | 'initialContact' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'credit' | 'nonDisclosureNotice'>
    & { attendees?: Maybe<Array<(
      Pick<Attendee, 'firstname' | 'lastname' | 'id' | 'deletable' | 'addition' | 'annotation' | 'member'>
      & { startedCourses: Array<Pick<Course, 'id' | 'prefixedCourseNumber'>> }
    )>>, paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'bankTransfer' | 'onlinePayment' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder'>>> }
  )> };

export type GetReceiversByCourseIdsQueryVariables = Exact<{
  courseIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetReceiversByCourseIdsQuery = { getBookersByCourseIds: Array<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email'>> };

export type DeleteBookerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBookerMutation = Pick<Mutation, 'deleteBooker'>;

export type RemoveAllBookersOfTenantMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAllBookersOfTenantMutation = Pick<Mutation, 'removeAllBookersOfTenant'>;

export type AddPaymentMethodMutationVariables = Exact<{
  bookerId: Scalars['String'];
  paymentMethodType: Scalars['String'];
  sepaDebitInput?: Maybe<SepaDebitIntput>;
}>;


export type AddPaymentMethodMutation = { addPaymentMethod: Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'> };

export type GetPaymentMethodsByBookerIdQueryVariables = Exact<{
  bookerId: Scalars['String'];
}>;


export type GetPaymentMethodsByBookerIdQuery = { getPaymentMethodsByBookerId: Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditcardNumber' | 'creditCardAccountholder' | 'expirationDate' | 'sepaAccountholder' | 'iban' | 'bic' | 'bank' | 'paypalAccountholder' | 'email' | 'bankTransfer' | 'onlinePayment'>> };

export type GetBookerDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBookerDetailsQuery = { booker: (
    Pick<Booker, 'id' | 'erasedAt' | 'customerId' | 'gender' | 'birthday' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'secondaryEmail' | 'initialContact' | 'dsgvo' | 'newsletter' | 'credit' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'nonDisclosureNotice' | 'customerNumber' | 'customerNumberPrefix'>
    & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>>, attendees?: Maybe<Array<(
      Pick<Attendee, 'id' | 'erasedAt' | 'customerId' | 'gender' | 'lastname' | 'firstname' | 'birthday' | 'member' | 'addition' | 'annotation' | 'customerNumber' | 'customerNumberPrefix' | 'createDate' | 'updateDate' | 'createdBy' | 'hasBillingAddress' | 'billingCompanyName' | 'billingFirstname' | 'billingLastname' | 'billingAddition' | 'billingStreet' | 'billingPostCode' | 'billingCity'>
      & { defaultPaymentMethod: Pick<PaymentMethod, 'id'>, bookings?: Maybe<Array<(
        Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled' | 'courseId' | 'paymentType' | 'payDate'>
        & { course?: Maybe<(
          Pick<Course, 'id' | 'prefixedCourseNumber'>
          & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
        )>, courseLessons: Array<(
          Pick<CourseLesson, 'id' | 'courseId'>
          & { course: (
            Pick<Course, 'id' | 'maxAttendees' | 'prefixedCourseNumber'>
            & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
          ) }
        )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id'>> }
      )>> }
    )>> }
  ) };

export type GetDuplicateBookersQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetDuplicateBookersQuery = { getDuplicateBookers: Array<Array<(
    Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender' | 'customerNumber' | 'customerNumberPrefix' | 'email' | 'userId' | 'addition' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'initialContact' | 'dsgvo' | 'newsletter' | 'healthInsuranceFund' | 'annotation' | 'nonDisclosureNotice' | 'credit' | 'birthday' | 'updateDate' | 'createdBy'>
    & { createdByUser?: Maybe<Pick<UserType, 'id' | 'email'>> }
  )>> };

export type MergeBookersMutationVariables = Exact<{
  updateBookerData: BookerInput;
  mergedBookerId: Scalars['ID'];
}>;


export type MergeBookersMutation = { mergeBookers: (
    Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender' | 'customerNumber' | 'email' | 'userId' | 'addition' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'initialContact' | 'dsgvo' | 'newsletter' | 'healthInsuranceFund' | 'annotation' | 'nonDisclosureNotice' | 'credit' | 'birthday' | 'updateDate' | 'createdBy'>
    & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>>, attendees?: Maybe<Array<(
      Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'customerNumber'>
      & { bookings?: Maybe<Array<(
        Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'startDateTime' | 'canceled'>
        & { courseLessons: Array<(
          Pick<CourseLesson, 'id'>
          & { course: (
            Pick<Course, 'id'>
            & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
          ) }
        )> }
      )>> }
    )>> }
  ) };

export type UpdateBookerCreditMutationVariables = Exact<{
  bookerId: Scalars['ID'];
  amount: Scalars['Float'];
  note: Scalars['String'];
}>;


export type UpdateBookerCreditMutation = { updateBookerCredit: Pick<Booker, 'id' | 'credit'> };

export type GetCreditEntriesByBookerIdQueryVariables = Exact<{
  bookerId: Scalars['ID'];
}>;


export type GetCreditEntriesByBookerIdQuery = { creditEntriesByBookerId: Array<(
    Pick<CreditEntry, 'id' | 'createDate' | 'amount' | 'balanceAfter' | 'reason' | 'note' | 'bookingId' | 'scheduledPaymentId' | 'userId' | 'userName' | 'sourceBookerId'>
    & { booking?: Maybe<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>> }
  )> };

export type DismissDuplicatePairMutationVariables = Exact<{
  input: DismissDuplicatePairInput;
}>;


export type DismissDuplicatePairMutation = Pick<Mutation, 'dismissDuplicatePair'>;

export type GetDuplicateExceptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDuplicateExceptionsQuery = { getDuplicateExceptions: Array<(
    Pick<DuplicateException, 'id' | 'bookerId1' | 'bookerId2' | 'createDate'>
    & { booker1?: Maybe<(
      Pick<Booker, 'id' | 'email'>
      & { customer: Pick<Customer, 'firstname' | 'lastname'> }
    )>, booker2?: Maybe<(
      Pick<Booker, 'id' | 'email'>
      & { customer: Pick<Customer, 'firstname' | 'lastname'> }
    )> }
  )> };

export type UndoDuplicateExceptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UndoDuplicateExceptionMutation = Pick<Mutation, 'undoDuplicateException'>;

export type GetBookersExportQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetBookersExportQuery = { bookersExport: Array<(
    Pick<Booker, 'id' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'email' | 'mobileNumber' | 'phoneNumber' | 'birthday' | 'gender' | 'initialContact' | 'healthInsuranceFund' | 'addition' | 'annotation' | 'credit' | 'nonDisclosureNotice'>
    & { attendees?: Maybe<Array<Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'member' | 'addition' | 'annotation'>>> }
  )> };

export type FindSimilarBookersQueryVariables = Exact<{
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  excludeBookerId?: Maybe<Scalars['ID']>;
}>;


export type FindSimilarBookersQuery = { findSimilarBookers: Array<(
    Pick<SimilarBookerResult, 'score' | 'matchReason'>
    & { booker: Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'customerNumber' | 'customerNumberPrefix'> }
  )> };

export type GetDuplicateBookerGroupsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Float']>;
}>;


export type GetDuplicateBookerGroupsQuery = { getDuplicateBookerGroups: Array<{ bookers: Array<(
      Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender' | 'customerNumber' | 'customerNumberPrefix' | 'email' | 'userId' | 'addition' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'initialContact' | 'dsgvo' | 'newsletter' | 'healthInsuranceFund' | 'annotation' | 'nonDisclosureNotice' | 'credit' | 'birthday' | 'updateDate' | 'createdBy'>
      & { createdByUser?: Maybe<Pick<UserType, 'id' | 'email'>> }
    )>, matchInfo: (
      Pick<DuplicateGroupMatchInfo, 'score' | 'bestMatchType'>
      & { scoreBreakdown?: Maybe<Pick<ScoreBreakdownType, 'exactEmail' | 'exactName' | 'fuzzyName' | 'samePhone' | 'sameAddress' | 'sameAttendee' | 'sameAttendeeMultiple' | 'differentEmail' | 'differentPhone' | 'differentAddress' | 'differentName' | 'missingName' | 'total'>> }
    ) }> };

export type GetDuplicateDetectionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDuplicateDetectionStatusQuery = { getDuplicateDetectionStatus?: Maybe<Pick<DuplicateDetectionRun, 'id' | 'status' | 'startedAt' | 'completedAt' | 'totalBookersProcessed' | 'duplicateMatchesFound' | 'errorMessage' | 'durationMs'>> };

export type TriggerDuplicateDetectionMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerDuplicateDetectionMutation = Pick<Mutation, 'triggerDuplicateDetection'>;

export type GetBookerMergeHistoryQueryVariables = Exact<{
  bookerId: Scalars['String'];
}>;


export type GetBookerMergeHistoryQuery = { bookerMergeHistoryByBookerId: Array<Pick<BookerMergeHistory, 'id' | 'description' | 'winnerBookerId' | 'userId' | 'userName' | 'loserSnapshot' | 'createDate'>> };

export type MergeAttendeesMutationVariables = Exact<{
  winnerAttendeeId: Scalars['ID'];
  loserAttendeeId: Scalars['ID'];
  selectedFields?: Maybe<AttendeeMergeFieldsInput>;
}>;


export type MergeAttendeesMutation = { mergeAttendees: Pick<AttendeeMergeResult, 'success' | 'bookingsTransferred' | 'duplicateBookingsInSameCourse' | 'winnerAttendeeId'> };

export type BookingEligibilityDiagnosisQueryVariables = Exact<{
  attendeeId: Scalars['ID'];
  courseId: Scalars['ID'];
}>;


export type BookingEligibilityDiagnosisQuery = { bookingEligibilityDiagnosis: (
    Pick<BookingEligibilityDiagnosis, 'attendeeId' | 'courseId' | 'canBook' | 'reason' | 'blockingCheckKeys' | 'visibleInStandardList'>
    & { visibleViaPrerequisiteLinks: Array<Pick<PrerequisiteLinkVisibility, 'courseId' | 'prefixedCourseNumber' | 'visible' | 'link'>>, checks: Array<Pick<EligibilityCheck, 'key' | 'status' | 'params'>> }
  ) };

export type BookingEligibilityCandidatesQueryVariables = Exact<{
  attendeeId: Scalars['ID'];
}>;


export type BookingEligibilityCandidatesQuery = { bookingEligibilityCandidates: Array<(
    Pick<BookingEligibilityCandidate, 'courseId' | 'prefixedCourseNumber' | 'courseTypeName' | 'courseTypeColor' | 'locationName' | 'startDateTime' | 'freePlaces' | 'prerequisiteCourseIds' | 'prerequisitePrefixedCourseNumbers' | 'satisfiedByAttendeeIds'>
    & { diagnosis: (
      Pick<BookingEligibilityDiagnosis, 'attendeeId' | 'courseId' | 'canBook' | 'reason' | 'blockingCheckKeys' | 'visibleInStandardList'>
      & { visibleViaPrerequisiteLinks: Array<Pick<PrerequisiteLinkVisibility, 'courseId' | 'prefixedCourseNumber' | 'visible' | 'link'>>, checks: Array<Pick<EligibilityCheck, 'key' | 'status' | 'params'>> }
    ) }
  )> };

export type GetAttendeeMergeHistoryByBookerIdQueryVariables = Exact<{
  bookerId: Scalars['String'];
}>;


export type GetAttendeeMergeHistoryByBookerIdQuery = { attendeeMergeHistoryByBookerId: Array<Pick<AttendeeMergeHistory, 'id' | 'description' | 'loserSnapshot' | 'winnerAttendeeId' | 'bookerId' | 'userId' | 'userName' | 'createDate'>> };

export type CustomerTimelineQueryVariables = Exact<{
  bookerId: Scalars['ID'];
  since?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type CustomerTimelineQuery = { customerTimeline: Array<Pick<CustomerTimelineEntry, 'id' | 'at' | 'kind' | 'type' | 'code' | 'source' | 'params' | 'actorName' | 'attendeeId' | 'courseId' | 'bookingId' | 'bookingIsSettled' | 'bookingAllowsLessonBooking'>> };

export type GetMollieKpisQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMollieKpisQuery = { getMollieKpis: Pick<MollieKpis, 'openLinksCount' | 'openLinksSum' | 'chargebacks30dCount' | 'chargebacks30dFee' | 'successRate30d' | 'avgCheckoutToPaidHours'> };

export type GetOnlineRegisteredBookersQueryVariables = Exact<{
  startDateTime?: Maybe<Scalars['DateTime']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetOnlineRegisteredBookersQuery = { getOnlineRegisteredBookers: (
    Pick<OnlineRegisteredBookersResult, 'total'>
    & { items: Array<(
      Pick<OnlineRegisteredBooker, 'id' | 'firstname' | 'lastname' | 'email' | 'mobileNumber' | 'createDate' | 'attendeesCount' | 'activeBookingsCount' | 'leadStatus'>
      & { attendees: Array<Pick<OnlineRegisteredBookerAttendee, 'id' | 'firstname' | 'lastname'>> }
    )> }
  ) };

export type GetOnlineBookingsByTimeRangeCountQueryVariables = Exact<{
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type GetOnlineBookingsByTimeRangeCountQuery = Pick<Query, 'getOnlineBookingsByTimeRangeCount'>;

export type GetOnlineBookingsByTimeRangeSeriesQueryVariables = Exact<{
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  buckets: Scalars['Int'];
}>;


export type GetOnlineBookingsByTimeRangeSeriesQuery = Pick<Query, 'getOnlineBookingsByTimeRangeSeries'>;

export type GetUpcomingCoursesByTimeRangeQueryVariables = Exact<{
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetUpcomingCoursesByTimeRangeQuery = { getUpcomingCoursesByTimeRange: (
    Pick<CourseWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Course, 'id' | 'startDateTime' | 'prefixedCourseNumber' | 'maxAttendees' | 'minAttendees' | 'freePlaces' | 'bookingCount' | 'waitListCount' | 'placeReservationsCount'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'name' | 'city'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
    )> }
  ) };

export type GetUpcomingCoursesOccupancyQueryVariables = Exact<{
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type GetUpcomingCoursesOccupancyQuery = { getUpcomingCoursesOccupancy: Pick<UpcomingCoursesOccupancy, 'courseCount' | 'bookedPlaces' | 'totalPlaces'> };

export type GetCoursesWithHighDemandQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  onlyUpcoming?: Maybe<Scalars['Boolean']>;
}>;


export type GetCoursesWithHighDemandQuery = { getCoursesWithHighDemand: (
    Pick<CourseWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Course, 'id' | 'maxAttendees' | 'waitListCount' | 'bookingCount' | 'prefixedCourseNumber' | 'startDateTime'>
      & { location: Pick<Location, 'id' | 'name'>, courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
    )> }
  ) };

export type SendSimpleEmailMutationVariables = Exact<{
  sendParamsMessageInput: SendParamsMessageInput;
  sandboxMode: Scalars['Boolean'];
}>;


export type SendSimpleEmailMutation = Pick<Mutation, 'sendMail'>;

export type FaUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type FaUserByEmailQuery = { faUserByEmail: (
    Pick<FaUser, 'id' | 'lastLoginInstant' | 'passwordLastUpdateInstant' | 'verified' | 'active' | 'email' | 'firstName' | 'lastName' | 'fullName' | 'imageUrl' | 'insertInstant' | 'lastUpdateInstant' | 'tenantId' | 'timezone'>
    & { registrations?: Maybe<Array<Pick<UserRegistration, 'applicationId' | 'data' | 'id' | 'insertInstant' | 'lastLoginInstant' | 'lastUpdateInstant' | 'roles' | 'username' | 'verified'>>> }
  ) };

export type FaUserByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FaUserByUserIdQuery = { faUserByUserId?: Maybe<(
    Pick<FaUser, 'id' | 'lastLoginInstant' | 'passwordLastUpdateInstant' | 'verified' | 'active' | 'email' | 'firstName' | 'lastName' | 'fullName' | 'imageUrl' | 'insertInstant' | 'lastUpdateInstant' | 'tenantId' | 'timezone'>
    & { registrations?: Maybe<Array<Pick<UserRegistration, 'applicationId' | 'data' | 'id' | 'insertInstant' | 'lastLoginInstant' | 'lastUpdateInstant' | 'roles' | 'username' | 'verified'>>> }
  )> };

export type CreateFaUserWithOrAddEndUserRightsMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type CreateFaUserWithOrAddEndUserRightsMutation = { createFaUserWithOrAddEndUserRights: (
    Pick<FaUser, 'id' | 'lastLoginInstant' | 'passwordLastUpdateInstant' | 'verified' | 'active' | 'email' | 'firstName' | 'lastName' | 'fullName' | 'imageUrl' | 'insertInstant' | 'lastUpdateInstant' | 'tenantId' | 'timezone'>
    & { registrations?: Maybe<Array<Pick<UserRegistration, 'applicationId' | 'data' | 'id' | 'insertInstant' | 'lastLoginInstant' | 'lastUpdateInstant' | 'roles' | 'username' | 'verified'>>> }
  ) };

export type AddFaUserByBookerIdMutationVariables = Exact<{
  bookerId: Scalars['String'];
  linkExistingAccountConfirmed?: Maybe<Scalars['Boolean']>;
}>;


export type AddFaUserByBookerIdMutation = { addFaUserByBookerId: (
    Pick<FaUser, 'id' | 'lastLoginInstant' | 'passwordLastUpdateInstant' | 'verified' | 'active' | 'email' | 'firstName' | 'lastName' | 'fullName' | 'imageUrl' | 'insertInstant' | 'lastUpdateInstant' | 'tenantId' | 'timezone'>
    & { registrations?: Maybe<Array<Pick<UserRegistration, 'applicationId' | 'data' | 'id' | 'insertInstant' | 'lastLoginInstant' | 'lastUpdateInstant' | 'roles' | 'username' | 'verified'>>> }
  ) };

export type CheckEmailUniquenessQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckEmailUniquenessQuery = Pick<Query, 'checkEmailUniqueness'>;

export type AccountLinksQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AccountLinksQuery = { accountLinks: { bookers: Array<Pick<AccountForEmailLinkedBooker, 'id' | 'firstname' | 'lastname' | 'customerNumber'>>, staff: Array<Pick<AccountLinksStaff, 'id' | 'firstname' | 'lastname' | 'roles'>> } };

export type AccountForEmailQueryVariables = Exact<{
  email: Scalars['String'];
  excludeBookerId?: Maybe<Scalars['String']>;
}>;


export type AccountForEmailQuery = { accountForEmail?: Maybe<(
    Pick<AccountForEmail, 'userId' | 'email' | 'roles' | 'displayName' | 'isStaffAccount' | 'callerMayLink'>
    & { linkedBooker?: Maybe<Pick<AccountForEmailLinkedBooker, 'id' | 'firstname' | 'lastname' | 'customerNumber'>> }
  )> };

export type GetHolidaysByStateCodeQueryVariables = Exact<{
  stateCode: StateCode;
}>;


export type GetHolidaysByStateCodeQuery = { holidaysByStateCode: Array<Pick<HolidayWithDays, 'id' | 'name' | 'slug' | 'start' | 'end' | 'year' | 'stateCode' | 'countryCode' | 'holidayStateColor' | 'type' | 'days' | 'color'>> };

export type GetHolidaysByCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHolidaysByCompanyQuery = { holidaysByCompany: Array<Pick<HolidayWithDays, 'id' | 'name' | 'slug' | 'start' | 'end' | 'year' | 'stateCode' | 'countryCode' | 'holidayStateColor' | 'type' | 'days' | 'color'>> };

export type GetHolidaysByCompanyAndDateRangeQueryVariables = Exact<{
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type GetHolidaysByCompanyAndDateRangeQuery = { holidaysByCompanyAndDateRange: Array<Pick<HolidayWithDays, 'id' | 'name' | 'slug' | 'start' | 'end' | 'year' | 'stateCode' | 'countryCode' | 'holidayStateColor' | 'type' | 'days' | 'color'>> };

export type GetCustomHolidaysByCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomHolidaysByCompanyQuery = { customHolidaysByCompany: Array<Pick<Holiday, 'id' | 'name' | 'slug' | 'start' | 'end' | 'year' | 'stateCode' | 'countryCode' | 'holidayStateColor' | 'type' | 'color'>> };

export type UpdateCustomCompanyHolidaysMutationVariables = Exact<{
  holidayInputs: Array<HolidayInput> | HolidayInput;
}>;


export type UpdateCustomCompanyHolidaysMutation = { updateCustomCompanyHolidays: Array<Pick<Holiday, 'id' | 'name' | 'slug' | 'start' | 'end' | 'year' | 'stateCode' | 'countryCode' | 'holidayStateColor' | 'type' | 'color'>> };

export type GetInterestListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterestListsQuery = { interestLists: Array<(
    Pick<InterestList, 'id' | 'description' | 'maxEntries' | 'isActive' | 'showNoteField' | 'isFull' | 'createDate'>
    & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'name' | 'city'>, timeSlots?: Maybe<Array<Pick<InterestListTimeSlot, 'id' | 'weekday' | 'startTime' | 'endTime' | 'sortOrder'>>> }
  )> };

export type GetInterestListByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetInterestListByIdQuery = { interestListById: (
    Pick<InterestList, 'id' | 'description' | 'maxEntries' | 'isActive' | 'showNoteField'>
    & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'name' | 'city'>, timeSlots?: Maybe<Array<Pick<InterestListTimeSlot, 'id' | 'weekday' | 'startTime' | 'endTime' | 'sortOrder'>>> }
  ) };

export type CreateInterestListMutationVariables = Exact<{
  input: CreateInterestListInput;
}>;


export type CreateInterestListMutation = { createInterestList: Pick<InterestList, 'id'> };

export type UpdateInterestListMutationVariables = Exact<{
  input: UpdateInterestListInput;
}>;


export type UpdateInterestListMutation = { updateInterestList: Pick<InterestList, 'id'> };

export type GetInterestListNoteDefaultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterestListNoteDefaultQuery = { settings: Pick<Setting, 'id' | 'interestListShowNoteFieldDefault'> };

export type SetInterestListNoteFieldDefaultMutationVariables = Exact<{
  showNoteField: Scalars['Boolean'];
  applyToExisting: Scalars['Boolean'];
}>;


export type SetInterestListNoteFieldDefaultMutation = { setInterestListNoteFieldDefault: Pick<Setting, 'id' | 'interestListShowNoteFieldDefault'> };

export type RemoveInterestListMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveInterestListMutation = Pick<Mutation, 'removeInterestList'>;

export type GetInterestRegistrationsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetInterestRegistrationsQuery = { interestRegistrations: (
    Pick<InterestRegistrationWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<InterestRegistration, 'id' | 'allTimesPossible' | 'note' | 'status' | 'internalNote' | 'createDate'>
      & { interestList: (
        Pick<InterestList, 'id'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'name' | 'city'> }
      ), booker: (
        Pick<Booker, 'id' | 'email' | 'phoneNumber' | 'mobileNumber'>
        & { customer: Pick<Customer, 'firstname' | 'lastname'> }
      ), attendee: (
        Pick<Attendee, 'id'>
        & { customer: Pick<Customer, 'firstname' | 'lastname'> }
      ), selectedTimeSlots: Array<Pick<InterestListTimeSlot, 'id' | 'weekday' | 'startTime' | 'endTime' | 'sortOrder'>> }
    )> }
  ) };

export type CreateInterestRegistrationAdminMutationVariables = Exact<{
  input: CreateInterestRegistrationInput;
  sendConfirmationMail?: Maybe<Scalars['Boolean']>;
}>;


export type CreateInterestRegistrationAdminMutation = { createInterestRegistration: Pick<InterestRegistration, 'id'> };

export type GetInterestRegistrationsByAttendeeAndCourseTypeQueryVariables = Exact<{
  attendeeId: Scalars['ID'];
  courseTypeId: Scalars['ID'];
}>;


export type GetInterestRegistrationsByAttendeeAndCourseTypeQuery = { interestRegistrationsByAttendeeAndCourseType: Array<(
    Pick<InterestRegistration, 'id' | 'createDate' | 'allTimesPossible'>
    & { interestList: (
      Pick<InterestList, 'id'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'name' | 'city'> }
    ), selectedTimeSlots: Array<Pick<InterestListTimeSlot, 'id' | 'weekday' | 'startTime' | 'endTime' | 'sortOrder'>> }
  )> };

export type UpdateInterestRegistrationMutationVariables = Exact<{
  input: UpdateInterestRegistrationInput;
}>;


export type UpdateInterestRegistrationMutation = { updateInterestRegistration: Pick<InterestRegistration, 'id' | 'status' | 'internalNote'> };

export type RemoveInterestRegistrationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveInterestRegistrationMutation = Pick<Mutation, 'removeInterestRegistration'>;

export type GetBookingDunningsQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type GetBookingDunningsQuery = { dunningsByBooking: Array<Pick<Dunning, 'id' | 'createDate' | 'level' | 'dunningNumber' | 'openAmount' | 'feeAmount' | 'totalAmount' | 'paymentDue' | 'completedAt' | 'sentAt' | 'withdrawnAt' | 'withdrawnReason' | 'voidedAt' | 'feeDeleted'>>, dunningPause: Pick<DunningPause, 'until' | 'note'>, activeDunning?: Maybe<Pick<ActiveDunning, 'id' | 'level' | 'createDate' | 'openAmount' | 'totalAmount' | 'currentOpenAmount' | 'scheduledPaymentId'>> };

export type GetActiveDunningQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type GetActiveDunningQuery = { activeDunning?: Maybe<Pick<ActiveDunning, 'id' | 'level' | 'createDate' | 'openAmount' | 'totalAmount' | 'currentOpenAmount' | 'scheduledPaymentId'>> };

export type GetDunningProposalQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  level?: Maybe<DunningLevel>;
}>;


export type GetDunningProposalQuery = { dunningProposal: (
    Pick<DunningProposal, 'level' | 'levelLabel' | 'dunningNumber' | 'openAmount' | 'feeAmount' | 'totalAmount' | 'paymentDue' | 'earliestDate' | 'tooEarly' | 'recipientEmail' | 'blocker'>
    & { items: Array<Pick<DunningProposalItem, 'scheduledPaymentId' | 'title' | 'paymentDue' | 'openAmount'>> }
  ) };

export type GetDunningPdfQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDunningPdfQuery = Pick<Query, 'dunningPdf'>;

export type CreateDunningMutationVariables = Exact<{
  input: CreateDunningInput;
}>;


export type CreateDunningMutation = { createDunning: Pick<Dunning, 'id' | 'dunningNumber' | 'sentAt'> };

export type WithdrawDunningMutationVariables = Exact<{
  id: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type WithdrawDunningMutation = { withdrawDunning: Pick<Dunning, 'id'> };

export type ResendDunningMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendDunningMutation = { resendDunning: Pick<Dunning, 'id' | 'sentAt'> };

export type SetDunningPauseMutationVariables = Exact<{
  input: SetDunningPauseInput;
}>;


export type SetDunningPauseMutation = { setDunningPause: Pick<DunningPause, 'until' | 'note'> };

export type GetBookingDunningStatusesQueryVariables = Exact<{
  bookingIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetBookingDunningStatusesQuery = { bookingDunningStatuses: Array<Pick<BookingDunningStatus, 'bookingId' | 'level' | 'levelDate'>> };

export type GetBookingCorrectionContextQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookingCorrectionContextQuery = { bookingById: (
    Pick<Booking, 'id' | 'discount' | 'discountName' | 'memberDiscount'>
    & { scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'id' | 'paymentDue'>>> }
  ) };

export type PreviewSettledBookingCorrectionQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  input: SettledBookingCorrectionInput;
}>;


export type PreviewSettledBookingCorrectionQuery = { previewSettledBookingCorrection: (
    Pick<SettledBookingCorrectionPreview, 'newGrossPrice' | 'alreadyPaid' | 'newOpenAmount' | 'overpayment' | 'refundAmount' | 'creditToBooker' | 'creditedBalanceDelta' | 'newPaymentLinkAmount' | 'warnings' | 'blockers'>
    & { installmentChanges: Array<Pick<InstallmentChangePreview, 'type' | 'spId' | 'title' | 'oldAmount' | 'newAmount' | 'paymentDue'>> }
  ) };

export type ExecuteSettledBookingCorrectionMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  input: SettledBookingCorrectionInput;
  sendCorrectionInvoiceMail: Scalars['Boolean'];
}>;


export type ExecuteSettledBookingCorrectionMutation = { executeSettledBookingCorrection: (
    Pick<SettledBookingCorrectionResult, 'refundOk' | 'paymentLinkOk' | 'correctionInvoiceOk' | 'messages'>
    & { booking: Pick<Booking, 'id'> }
  ) };

export type GetBookingFeeLettersQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type GetBookingFeeLettersQuery = { feeLettersByBooking: Array<Pick<FeeLetter, 'id' | 'createDate' | 'letterNumber' | 'totalAmount' | 'paymentDue' | 'sentAt'>>, feeLetterProposal: (
    Pick<FeeLetterProposal, 'totalAmount' | 'letterNumber' | 'blocker' | 'recipientEmail'>
    & { items: Array<Pick<FeeLetterItem, 'scheduledPaymentId' | 'title' | 'amount'>> }
  ) };

export type GetFeeLetterPdfQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetFeeLetterPdfQuery = Pick<Query, 'feeLetterPdf'>;

export type CreateFeeLetterMutationVariables = Exact<{
  input: CreateFeeLetterInput;
}>;


export type CreateFeeLetterMutation = { createFeeLetter: Pick<FeeLetter, 'id' | 'letterNumber' | 'sentAt'> };

export type CreateInvoiceMutationVariables = Exact<{
  newInvoiceData: InvoiceInput;
  sendMail?: Maybe<Scalars['Boolean']>;
}>;


export type CreateInvoiceMutation = { createInvoice: Pick<Invoice, 'id'> };

export type CreateInvoicesByCourseIdMutationVariables = Exact<{
  courseId: Scalars['String'];
  sendMail?: Maybe<Scalars['Boolean']>;
}>;


export type CreateInvoicesByCourseIdMutation = { createInvoicesByCourseId: Array<Pick<Invoice, 'id'>> };

export type CreateInvoicesByBookingIdsMutationVariables = Exact<{
  bookingIds: Array<Scalars['ID']> | Scalars['ID'];
  sendMail?: Maybe<Scalars['Boolean']>;
}>;


export type CreateInvoicesByBookingIdsMutation = { createInvoicesByBookingIds: Array<Pick<Invoice, 'id' | 'bookingId'>> };

export type GetInvoicesQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetInvoicesQuery = { invoices: (
    Pick<InvoiceWithPagination, 'existsMore' | 'total'>
    & { items: Array<Pick<Invoice, 'id' | 'invoiceBody' | 'invoiceFileName'>> }
  ) };

export type GetInvoiceBodyByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInvoiceBodyByIdQuery = { invoiceBodyById: Pick<Invoice, 'id' | 'invoiceBody' | 'invoiceFileName'> };

export type GetInvoiceBodyByBookingIdQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type GetInvoiceBodyByBookingIdQuery = { invoiceBodyByBookingId: Pick<Invoice, 'id' | 'invoiceBody' | 'invoiceFileName'> };

export type GetCoursesDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoursesDetailsQuery = { courses: Array<(
    Pick<Course, 'id'>
    & { settledBookings: Array<(
      Pick<Booking, 'id' | 'canceled' | 'bookingType'>
      & { attendee?: Maybe<(
        Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber'>> }
      )>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'createDate' | 'invoiceNumberPrefix' | 'invoiceNumber'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>> }
    )>, unSettledBookings: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'canceled' | 'bookingType' | 'bookedBy'>
      & { attendee?: Maybe<(
        Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber'>> }
      )>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'createDate' | 'invoiceNumberPrefix' | 'invoiceNumber'>> }
    )> }
  )> };

export type GetUnsettledBookingsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetUnsettledBookingsQuery = { getUnSettledBookings: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent'>
      & { paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>, course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance'>>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'city' | 'credit' | 'phoneNumber' | 'mobileNumber' | 'nonDisclosureNotice'>> }
      )>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>> }
    )> }
  ) };

export type GetSettledBookingsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetSettledBookingsQuery = { getSettledBookings: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent'>
      & { paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type' | 'cash' | 'esr' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>, course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance'>>>, scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'paymentProvider'>>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'city' | 'credit' | 'phoneNumber' | 'mobileNumber' | 'nonDisclosureNotice'>> }
      )>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>> }
    )> }
  ) };

export type GetCanceledBookingsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetCanceledBookingsQuery = { getCanceledBookings: (
    Pick<BookingWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'updateDate' | 'createDate' | 'startDateTime' | 'courseId' | 'noticeStaff' | 'attendanceListNote' | 'noticeBooker' | 'coursePriceId' | 'payDate' | 'grossPrice' | 'netPrice' | 'vat' | 'isSpecial' | 'paymentType' | 'bookedBy' | 'canceled' | 'waitListCount' | 'additionalInfo' | 'bookedLessonCount' | 'bookingConfirmationSent' | 'waitingListConfirmationSent' | 'cancelationSent' | 'invoiceSent'>
      & { course?: Maybe<(
        Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking' | 'lessonCount' | 'paymentInterval' | 'freePlaces' | 'maxAttendees' | 'startDateTime' | 'endDateTime' | 'endDateTimeFirstCourseLesson'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, location: Pick<Location, 'id' | 'city' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
      )>, courseLessons: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>>, courseLessonBookings?: Maybe<Array<Pick<CourseLessonBooking, 'id' | 'courseLessonId' | 'bookingType' | 'bookingDate' | 'attendance'>>>, coursePrice: Pick<CoursePrice, 'id' | 'grossPrice' | 'netPrice' | 'vat'>, invoice?: Maybe<Pick<Invoice, 'id' | 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'gender' | 'firstname' | 'lastname' | 'birthday' | 'customerNumberPrefix' | 'customerNumber' | 'member'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'customerNumberPrefix' | 'customerNumber' | 'email' | 'city' | 'credit' | 'phoneNumber' | 'mobileNumber' | 'nonDisclosureNotice'>> }
      )>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type'>>, emailNotifications?: Maybe<Array<Pick<EmailNotification, 'id' | 'templateType' | 'subject' | 'createDate' | 'bookingId' | 'email'>>> }
    )> }
  ) };

export type GetBookersByCourseWithBookingTypeQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type GetBookersByCourseWithBookingTypeQuery = { getBookersByCourseWithBookingType: Array<(
    Pick<Booker, 'id' | 'customerNumberPrefix' | 'customerNumber' | 'firstname' | 'lastname' | 'email' | 'gender' | 'phoneNumber'>
    & { attendees?: Maybe<Array<Pick<Attendee, 'id' | 'firstname' | 'lastname' | 'birthday'>>> }
  )> };

export type GetInvoicePreviewQueryVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type GetInvoicePreviewQuery = Pick<Query, 'getInvoicePreview'>;

export type GetInvoiceDummyPreviewQueryVariables = Exact<{
  editTemplateInput?: Maybe<EditTemplateInput>;
  reversal?: Maybe<Scalars['Boolean']>;
  paymentType?: Maybe<PaymentType>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
}>;


export type GetInvoiceDummyPreviewQuery = Pick<Query, 'getInvoiceDummyPreview'>;

export type SendBookingInvoiceMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  reversal?: Maybe<Scalars['Boolean']>;
}>;


export type SendBookingInvoiceMutation = Pick<Mutation, 'sendBookingInvoice'>;

export type SendBookingInvoicesByBookingIdsMutationVariables = Exact<{
  bookingIds: Array<Scalars['ID']> | Scalars['ID'];
  reversal?: Maybe<Scalars['Boolean']>;
}>;


export type SendBookingInvoicesByBookingIdsMutation = Pick<Mutation, 'sendBookingInvoicesByBookingIds'>;

export type CreateCorrectionInvoiceMutationVariables = Exact<{
  bookingId: Scalars['String'];
  sendMail?: Maybe<Scalars['Boolean']>;
}>;


export type CreateCorrectionInvoiceMutation = { createCorrectionInvoice: Pick<Invoice, 'id' | 'invoiceFileName'> };

export type GetReversalInvoicesQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetReversalInvoicesQuery = { reversalInvoices: (
    Pick<ReversalInvoiceWithPagination, 'existsMore' | 'total'>
    & { items: Array<Pick<ReversalInvoice, 'id' | 'reversalInvoiceBody' | 'reversalInvoiceFileName'>> }
  ) };

export type GetReversalInvoiceBodyByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReversalInvoiceBodyByIdQuery = { reversalInvoiceBodyById: Pick<ReversalInvoice, 'id' | 'reversalInvoiceBody' | 'reversalInvoiceFileName'> };

export type CancelBookingAndGenerateReversalInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
  sendMail?: Maybe<Scalars['Boolean']>;
  options?: Maybe<CancelBookingOptionsInput>;
}>;


export type CancelBookingAndGenerateReversalInvoiceMutation = Pick<Mutation, 'cancelBookingAndGenerateReversalInvoice'>;

export type GetCourseLessonsByDateQueryVariables = Exact<{
  date: Scalars['DateTime'];
}>;


export type GetCourseLessonsByDateQuery = { courseLessonsByDate: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>
    & { course: (
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
    ), location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'> }
  )> };

export type GetCourseLessonsWithPaginationQueryVariables = Exact<{
  date?: Maybe<Scalars['DateTime']>;
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetCourseLessonsWithPaginationQuery = { courseLessonsWithPagination: (
    Pick<CourseLessonWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>
      & { course: (
        Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'bookingCount'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
      ), location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
    )> }
  ) };

export type GetCourseLessonsWithOfMonthPaginationQueryVariables = Exact<{
  date: Scalars['DateTime'];
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetCourseLessonsWithOfMonthPaginationQuery = { courseLessonsOfMonthWithPagination: (
    Pick<CourseLessonWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>
      & { course: (
        Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'bookingCount'>
        & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
      ), location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
    )> }
  ) };

export type GetCourseLessonsOfMonthForExportQueryVariables = Exact<{
  date: Scalars['DateTime'];
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
  withFinancials?: Maybe<Scalars['Boolean']>;
}>;


export type GetCourseLessonsOfMonthForExportQuery = { courseLessonsOfMonthForExport: Array<(
    MakeOptional<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'revenueGross' | 'roomCost' | 'indexOfLessonInCourse'>, 'revenueGross' | 'roomCost'>
    & { course: (
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'bookingCount' | 'maxAttendees' | 'lessonCount' | 'paymentInterval'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, coursePrice?: Maybe<Array<Pick<CoursePrice, 'id' | 'grossPrice' | 'isSpecial'>>> }
    ), venue: MakeOptional<Pick<Venue, 'id' | 'name' | 'rent' | 'rentType'>, 'rent' | 'rentType'>, location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
  )> };

export type GetCourseLessonsForMonthViewQueryVariables = Exact<{
  month: Scalars['Float'];
  year: Scalars['Float'];
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetCourseLessonsForMonthViewQuery = { courseLessonsForMonthView: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime'>
    & { course: (
      Pick<Course, 'id' | 'prefixedCourseNumber'>
      & { courseType: Pick<CourseType, 'id' | 'color'> }
    ) }
  )> };

export type GetCourseLessonsByCalendarWeekQueryVariables = Exact<{
  calendarWeek: Scalars['Float'];
  year: Scalars['Float'];
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetCourseLessonsByCalendarWeekQuery = { courseLessonsByCalendarWeek: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>
    & { course: (
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
    ), location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
  )> };

export type GetCourseLessonsByCourseIdAttendanceQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseLessonsByCourseIdAttendanceQuery = { courseLessonsByCourseId: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>
    & { course: (
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'allowLessonBooking'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
    ), location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'> }
  )> };

export type GetCourseLessonsWithCollitionsQueryVariables = Exact<{
  collitionCheckInput: CollitionCheckInput;
}>;


export type GetCourseLessonsWithCollitionsQuery = { courseLessonsWithCollitions: Array<(
    Pick<CourseLessonWithIndexOfCourseLessonInCourse, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse' | 'originalCourseLessonId'>
    & { course: Pick<Course, 'id' | 'prefixedCourseNumber'> }
  )> };

export type GetMultipleCourseLessonsCollisionCheckQueryVariables = Exact<{
  collitionCheckInput: Array<CollitionCheckInput> | CollitionCheckInput;
}>;


export type GetMultipleCourseLessonsCollisionCheckQuery = { multipleCourseLessonsCollisionCheck: Array<(
    Pick<CourseLessonWithIndexOfCourseLessonInCourse, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse' | 'originalCourseLessonId'>
    & { course: Pick<Course, 'id' | 'prefixedCourseNumber'> }
  )> };

export type GetCourseLessonByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseLessonByIdQuery = { courseLessonById: (
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>
    & { course: (
      Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber' | 'freePlaces' | 'waitListCount' | 'bookingCount' | 'placeReservationsCount' | 'lessonCount' | 'maxAttendees' | 'maxWaitlist' | 'startDateTime' | 'endDateTime'>
      & { courseType: Pick<CourseType, 'id' | 'name' | 'color'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
    ), location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
  ) };

export type GetCourseLessonsForInstructorEditorQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseLessonsForInstructorEditorQuery = { courseLessonsByCourseId: Array<(
    Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'billingDate'>
    & { instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
  )> };

export type UpdateCourseLessonInstructorsMutationVariables = Exact<{
  courseLessonId: Scalars['ID'];
  instructorIds: Array<Scalars['ID']> | Scalars['ID'];
  scope: LessonInstructorScope;
}>;


export type UpdateCourseLessonInstructorsMutation = { updateCourseLessonInstructors: Array<Pick<CourseLesson, 'id'>> };

export type GetCourseLessonsByCourseIdMinimalQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type GetCourseLessonsByCourseIdMinimalQuery = { courseLessonsByCourseId: Array<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>> };

export type GetCourseLessonsForBillingStatusQueryVariables = Exact<{
  courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
}>;


export type GetCourseLessonsForBillingStatusQuery = { courseLessonsForBillingStatus: Array<(
    Pick<CourseLesson, 'id' | 'courseId' | 'locationId' | 'venueId' | 'startDateTime' | 'endDateTime' | 'indexOfLessonInCourse'>
    & { course: Pick<Course, 'id' | 'courseNumber' | 'prefixedCourseNumber'>, location: Pick<Location, 'id' | 'city' | 'name' | 'abbreviation'>, venue: Pick<Venue, 'id' | 'name'>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'level'>> }
  )> };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { locations: Array<(
    Pick<Location, 'id' | 'abbreviation' | 'city' | 'name'>
    & { venues: Array<Pick<Venue, 'id' | 'name'>>, generalLocationContact: Pick<GeneralLocationContact, 'email' | 'phoneNumber'>, courses?: Maybe<Array<Pick<Course, 'id' | 'prefixedCourseNumber'>>> }
  )> };

export type GetLocationsWithPaginationQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  currentUserOnly?: Maybe<Scalars['Boolean']>;
}>;


export type GetLocationsWithPaginationQuery = { locationsWithPagination: (
    Pick<LocationsWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Location, 'id' | 'abbreviation' | 'city' | 'name' | 'isPublished'>
      & { venues: Array<Pick<Venue, 'id' | 'name'>>, generalLocationContact: Pick<GeneralLocationContact, 'email' | 'phoneNumber'>, courses?: Maybe<Array<Pick<Course, 'id' | 'prefixedCourseNumber'>>>, instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname'>> }
    )> }
  ) };

export type CreateLocationMutationVariables = Exact<{
  newLocationData: NewLocationInput;
}>;


export type CreateLocationMutation = { createLocation: (
    Pick<Location, 'id' | 'name' | 'isPublished' | 'zipCode' | 'city' | 'street' | 'website' | 'abbreviation' | 'info'>
    & { venues: Array<Pick<Venue, 'id' | 'name' | 'isActive' | 'rent' | 'rentType'>>, generalLocationContact: Pick<GeneralLocationContact, 'phoneNumber' | 'mobileNumber' | 'fax' | 'email' | 'note'>, locationContacts: Array<Pick<LocationContact, 'id' | 'firstname' | 'lastname' | 'phoneNumber' | 'mobileNumber' | 'fax' | 'email'>> }
  ) };

export type GetLocationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationByIdQuery = { locationById: (
    Pick<Location, 'id' | 'name' | 'isPublished' | 'zipCode' | 'city' | 'street' | 'website' | 'abbreviation' | 'info' | 'emailVariableInfo' | 'customFields'>
    & { venues: Array<Pick<Venue, 'id' | 'name' | 'isActive' | 'rent' | 'rentType'>>, generalLocationContact: Pick<GeneralLocationContact, 'phoneNumber' | 'mobileNumber' | 'fax' | 'email' | 'note'>, locationContacts: Array<Pick<LocationContact, 'id' | 'salutation' | 'firstname' | 'lastname' | 'department' | 'phoneNumber' | 'mobileNumber' | 'fax' | 'email' | 'note'>>, courses?: Maybe<Array<Pick<Course, 'id' | 'locationId' | 'venueId' | 'courseNumber'>>> }
  ) };

export type UpdateLocationMutationVariables = Exact<{
  editLocationData: EditLocationInput;
}>;


export type UpdateLocationMutation = { updateLocation: (
    Pick<Location, 'id' | 'name' | 'isPublished' | 'zipCode' | 'city' | 'street' | 'website' | 'abbreviation' | 'info'>
    & { venues: Array<Pick<Venue, 'id' | 'name' | 'isActive' | 'rent' | 'rentType'>>, generalLocationContact: Pick<GeneralLocationContact, 'phoneNumber' | 'mobileNumber' | 'fax' | 'email' | 'note'>, locationContacts: Array<Pick<LocationContact, 'id' | 'salutation' | 'firstname' | 'lastname' | 'department' | 'phoneNumber' | 'mobileNumber' | 'fax' | 'email' | 'note'>> }
  ) };

export type RemoveLocationByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveLocationByIdMutation = Pick<Mutation, 'removeLocation'>;

export type CreateLocationContactMutationVariables = Exact<{
  newLocationContactData: NewLocationContactInput;
}>;


export type CreateLocationContactMutation = { createLocationContact: Pick<LocationContact, 'id' | 'salutation' | 'firstname' | 'lastname' | 'department' | 'phoneNumber' | 'mobileNumber' | 'fax' | 'email' | 'note'> };

export type UpdateLocationContactMutationVariables = Exact<{
  editLocationContactData: EditLocationContactInput;
}>;


export type UpdateLocationContactMutation = { updateLocationContact: Pick<LocationContact, 'id' | 'salutation' | 'firstname' | 'lastname' | 'department' | 'phoneNumber' | 'mobileNumber' | 'fax' | 'email' | 'note'> };

export type GetLocationContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationContactsQuery = { locationContacts: Array<Pick<LocationContact, 'id' | 'salutation' | 'firstname' | 'lastname' | 'department' | 'phoneNumber' | 'mobileNumber' | 'email' | 'fax' | 'note'>> };

export type GetLocationsByLocationContactIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationsByLocationContactIdQuery = { locationsByLocationContactId: Array<Pick<Location, 'name'>> };

export type RemoveLocationContactMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveLocationContactMutation = Pick<Mutation, 'removeLocationContact'>;

export type UpdateLocationPublishedStatusMutationVariables = Exact<{
  locationId: Scalars['ID'];
  isPublished: Scalars['Boolean'];
}>;


export type UpdateLocationPublishedStatusMutation = { updateLocationPublishedStatus: Pick<Location, 'id' | 'isPublished'> };

export type GetLocationsPublicQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsPublicQuery = { locationsPublic: Array<(
    Pick<Location, 'id' | 'abbreviation' | 'city' | 'name'>
    & { generalLocationContact: Pick<GeneralLocationContact, 'email' | 'phoneNumber'> }
  )> };

export type PasswordlessLoginMutationVariables = Exact<{
  loginData: PasswordlessLoginInputType;
}>;


export type PasswordlessLoginMutation = Pick<Mutation, 'passwordlessLogin'>;

export type CompletePasswordlessFlowMutationVariables = Exact<{
  loginCode: Scalars['String'];
}>;


export type CompletePasswordlessFlowMutation = { completePasswordlessFlow: Pick<UserType, 'id' | 'roles' | 'email'> };

export type RequestAdminOrgDiscoveryMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestAdminOrgDiscoveryMutation = Pick<Mutation, 'requestAdminOrgDiscovery'>;

export type ChangeForgottenPasswordMutationVariables = Exact<{
  changePasswordId: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangeForgottenPasswordMutation = Pick<Mutation, 'changeForgottenPassword'>;

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = Pick<Mutation, 'logoutUser'>;

export type GetMollieRetryQueueEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMollieRetryQueueEntriesQuery = { getMollieRetryQueueEntries: Array<Pick<MollieRetryQueueEntry, 'attemptId' | 'scheduledPaymentId' | 'bookingId' | 'bookerName' | 'bookerEmail' | 'amount' | 'currency' | 'chargebackReason' | 'chargebackedAt' | 'chargebackRetryCount' | 'sepaDisabled' | 'isNonRetriable'>> };

export type RetryMolliePaymentManuallyMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
}>;


export type RetryMolliePaymentManuallyMutation = Pick<Mutation, 'retryMolliePaymentManually'>;

export type GetNewsletterSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsletterSettingsQuery = { newsletterSettings: Pick<NewsletterSettings, 'id' | 'mailjetApiKeyPublic' | 'hasMailjetApiSecret' | 'mailjetApiKeyName' | 'listRule' | 'optOutBlocks' | 'bookingsSince' | 'assignment' | 'homeLocationMaxKm' | 'residenceRadiusKm' | 'errorEmail' | 'defaultErrorEmail' | 'lastConnectionCheckAt' | 'lastConnectionOk' | 'lastConnectionError' | 'webhookUrl' | 'webhookRegisteredAt' | 'rulesChangedAt' | 'rulesChangedByName'> };

export type UpdateNewsletterSettingsMutationVariables = Exact<{
  input: NewsletterSettingsInput;
}>;


export type UpdateNewsletterSettingsMutation = { updateNewsletterSettings: Pick<NewsletterSettings, 'id' | 'mailjetApiKeyPublic' | 'hasMailjetApiSecret' | 'mailjetApiKeyName' | 'listRule' | 'optOutBlocks' | 'bookingsSince' | 'assignment' | 'homeLocationMaxKm' | 'residenceRadiusKm' | 'errorEmail' | 'defaultErrorEmail' | 'lastConnectionCheckAt' | 'lastConnectionOk' | 'lastConnectionError' | 'webhookUrl' | 'webhookRegisteredAt' | 'rulesChangedAt' | 'rulesChangedByName'> };

export type TestNewsletterConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type TestNewsletterConnectionMutation = { testNewsletterConnection: Pick<NewsletterSettings, 'id' | 'mailjetApiKeyPublic' | 'hasMailjetApiSecret' | 'mailjetApiKeyName' | 'listRule' | 'optOutBlocks' | 'bookingsSince' | 'assignment' | 'homeLocationMaxKm' | 'residenceRadiusKm' | 'errorEmail' | 'defaultErrorEmail' | 'lastConnectionCheckAt' | 'lastConnectionOk' | 'lastConnectionError' | 'webhookUrl' | 'webhookRegisteredAt' | 'rulesChangedAt' | 'rulesChangedByName'> };

export type UpdateNewsletterRulesMutationVariables = Exact<{
  input: NewsletterRulesInput;
}>;


export type UpdateNewsletterRulesMutation = { updateNewsletterRules: Pick<NewsletterSettings, 'id' | 'mailjetApiKeyPublic' | 'hasMailjetApiSecret' | 'mailjetApiKeyName' | 'listRule' | 'optOutBlocks' | 'bookingsSince' | 'assignment' | 'homeLocationMaxKm' | 'residenceRadiusKm' | 'errorEmail' | 'defaultErrorEmail' | 'lastConnectionCheckAt' | 'lastConnectionOk' | 'lastConnectionError' | 'webhookUrl' | 'webhookRegisteredAt' | 'rulesChangedAt' | 'rulesChangedByName'> };

export type NewsletterRulesPreviewQueryVariables = Exact<{
  input: NewsletterRulesInput;
}>;


export type NewsletterRulesPreviewQuery = { newsletterRulesPreview: Pick<NewsletterRulesPreview, 'totalCount' | 'otherListRuleCount' | 'multiListCount' | 'radiusCount' | 'addedCount' | 'removedCount' | 'shrinkingListCount'> };

export type GetNewsletterLocationListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsletterLocationListsQuery = { newsletterLocationLists: Array<(
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  )>, newsletterRecipientCounts: Array<Pick<NewsletterRecipientCount, 'listId' | 'count' | 'radiusCount'>>, newsletterOverview: Pick<NewsletterOverviewResult, 'addressesEnabled' | 'lastRunAt' | 'lastRunDurationMs'> };

export type GetNewsletterListLogQueryVariables = Exact<{
  listId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetNewsletterListLogQuery = { newsletterLog: Array<(
    Pick<NewsletterLog, 'id' | 'createDate' | 'kind' | 'listName' | 'count' | 'failed' | 'detail' | 'durationMs' | 'userName'>
    & { location?: Maybe<Pick<Location, 'id' | 'name'>> }
  )> };

export type GetNewsletterLocationListRowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsletterLocationListRowsQuery = { newsletterLocationLists: Array<(
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  )> };

export type SetNewsletterLocationListEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetNewsletterLocationListEnabledMutation = { setNewsletterLocationListEnabled: (
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  ) };

export type SetNewsletterLocationListExcludedMutationVariables = Exact<{
  id: Scalars['ID'];
  excluded: Scalars['Boolean'];
}>;


export type SetNewsletterLocationListExcludedMutation = { setNewsletterLocationListExcluded: (
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  ) };

export type SyncNewsletterLocationListMutationVariables = Exact<{
  id: Scalars['ID'];
  release?: Maybe<Scalars['Boolean']>;
}>;


export type SyncNewsletterLocationListMutation = { syncNewsletterLocationList: (
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  ) };

export type SyncAllNewsletterLocationListsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncAllNewsletterLocationListsMutation = Pick<Mutation, 'syncAllNewsletterLocationLists'>;

export type ResetNewsletterLocationListLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResetNewsletterLocationListLinkMutation = { resetNewsletterLocationListLink: (
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  ) };

export type CreateNewsletterCustomListMutationVariables = Exact<{
  name: Scalars['String'];
  locationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CreateNewsletterCustomListMutation = { createNewsletterCustomList: (
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  ) };

export type UpdateNewsletterCustomListMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  locationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateNewsletterCustomListMutation = { updateNewsletterCustomList: (
    Pick<NewsletterLocationList, 'id' | 'enabled' | 'excluded' | 'mailjetListId' | 'mailjetListName' | 'lastSyncAt' | 'lastSyncOk' | 'lastSyncError' | 'lastSyncBlocked' | 'syncStartedAt' | 'lastSyncRecipients' | 'lastSyncInList' | 'lastSyncUnsubscribed' | 'lastSyncAdded' | 'lastSyncRemoved' | 'name' | 'locationIds'>
    & { location?: Maybe<Pick<Location, 'id' | 'name' | 'city'>> }
  ) };

export type DeleteNewsletterCustomListMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNewsletterCustomListMutation = Pick<Mutation, 'deleteNewsletterCustomList'>;

export type SetupNewsletterWebhookMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupNewsletterWebhookMutation = { setupNewsletterWebhook: Pick<NewsletterSettings, 'id' | 'mailjetApiKeyPublic' | 'hasMailjetApiSecret' | 'mailjetApiKeyName' | 'listRule' | 'optOutBlocks' | 'bookingsSince' | 'assignment' | 'homeLocationMaxKm' | 'residenceRadiusKm' | 'errorEmail' | 'defaultErrorEmail' | 'lastConnectionCheckAt' | 'lastConnectionOk' | 'lastConnectionError' | 'webhookUrl' | 'webhookRegisteredAt' | 'rulesChangedAt' | 'rulesChangedByName'> };

export type GetNewsletterBookerStatusQueryVariables = Exact<{
  bookerId: Scalars['ID'];
}>;


export type GetNewsletterBookerStatusQuery = { newsletterBookerStatus: (
    Pick<NewsletterBookerStatus, 'bookerId' | 'email' | 'optIn'>
    & { unsubscribe?: Maybe<Pick<NewsletterUnsubscribe, 'id' | 'source' | 'unsubscribedAt' | 'mailjetListId'>> }
  ) };

export type UnsubscribeBookerFromNewsletterMutationVariables = Exact<{
  bookerId: Scalars['ID'];
}>;


export type UnsubscribeBookerFromNewsletterMutation = { unsubscribeBookerFromNewsletter: (
    Pick<NewsletterBookerStatus, 'bookerId' | 'email' | 'optIn'>
    & { unsubscribe?: Maybe<Pick<NewsletterUnsubscribe, 'id' | 'source' | 'unsubscribedAt' | 'mailjetListId'>> }
  ) };

export type ReactivateBookerNewsletterMutationVariables = Exact<{
  bookerId: Scalars['ID'];
}>;


export type ReactivateBookerNewsletterMutation = { reactivateBookerNewsletter: (
    Pick<NewsletterBookerStatus, 'bookerId' | 'email' | 'optIn'>
    & { unsubscribe?: Maybe<Pick<NewsletterUnsubscribe, 'id' | 'source' | 'unsubscribedAt' | 'mailjetListId'>> }
  ) };

export type ImportNewsletterUnsubscribesFromMailjetMutationVariables = Exact<{ [key: string]: never; }>;


export type ImportNewsletterUnsubscribesFromMailjetMutation = { importNewsletterUnsubscribesFromMailjet: Pick<NewsletterUnsubscribeImportResult, 'found' | 'stored'> };

export type RenewNewsletterWebhookTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RenewNewsletterWebhookTokenMutation = { renewNewsletterWebhookToken: Pick<NewsletterSettings, 'id' | 'mailjetApiKeyPublic' | 'hasMailjetApiSecret' | 'mailjetApiKeyName' | 'listRule' | 'optOutBlocks' | 'bookingsSince' | 'assignment' | 'homeLocationMaxKm' | 'residenceRadiusKm' | 'errorEmail' | 'defaultErrorEmail' | 'lastConnectionCheckAt' | 'lastConnectionOk' | 'lastConnectionError' | 'webhookUrl' | 'webhookRegisteredAt' | 'rulesChangedAt' | 'rulesChangedByName'> };

export type GetNewsletterOverviewQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetNewsletterOverviewQuery = { newsletterOverview: Pick<NewsletterOverviewResult, 'lastSyncAt' | 'listsOk' | 'listsFailed' | 'listsNever' | 'listsStuck' | 'listsEnabled' | 'listsExcluded' | 'listsTotal' | 'locationsEnabled' | 'locationsTotal' | 'addressesEnabled' | 'addressesAll' | 'blockedTotal' | 'blockedUnsub' | 'blockedSpam' | 'blockedBounce' | 'blockedOffice' | 'unsubscribedLast7Days' | 'connectionOk' | 'webhookRegistered' | 'unsubscribesImported'>, newsletterLog: Array<(
    Pick<NewsletterLog, 'id' | 'createDate' | 'kind' | 'listName' | 'count' | 'failed' | 'detail' | 'durationMs' | 'userName'>
    & { location?: Maybe<Pick<Location, 'id' | 'name'>> }
  )> };

export type GetEmailNotificationsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetEmailNotificationsQuery = { emailNotifications: (
    Pick<EmailNotificationWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<EmailNotification, 'id' | 'createDate' | 'status' | 'email' | 'receiverName' | 'subject' | 'templateType' | 'mailjetTemplateId' | 'messageHref' | 'text' | 'messageID' | 'templateName' | 'bookerId' | 'bookingId' | 'attachments' | 'bookingDeleted'>
      & { booking?: Maybe<(
        Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled'>
        & { invoice?: Maybe<Pick<Invoice, 'id'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id'>> }
      )>, messageHistory?: Maybe<(
        Pick<MessageHistory, 'Count'>
        & { Data: Array<Pick<MessageHistoryData, 'EventAt' | 'EventType' | 'State'>> }
      )>, messageStatus?: Maybe<Pick<MessageStatusData, 'ArrivedAt' | 'Status'>>, lastMessageStatus?: Maybe<{ Data: Array<Pick<MessageStatusData, 'ArrivedAt' | 'Status'>> }> }
    )> }
  ) };

export type GetEmailNotificationsByBookingIdQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type GetEmailNotificationsByBookingIdQuery = { notificationsByBooking: Array<(
    Pick<EmailNotification, 'id' | 'createDate' | 'status' | 'email' | 'receiverName' | 'subject' | 'templateType' | 'mailjetTemplateId' | 'messageHref' | 'text' | 'messageID' | 'templateName' | 'attachments'>
    & { messageHistory?: Maybe<(
      Pick<MessageHistory, 'Count'>
      & { Data: Array<Pick<MessageHistoryData, 'EventAt' | 'EventType' | 'State'>> }
    )>, messageStatus?: Maybe<Pick<MessageStatusData, 'ArrivedAt' | 'Status'>> }
  )> };

export type GetEmailNotificationsByBookingIdOrEmailQueryVariables = Exact<{
  bookerId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetEmailNotificationsByBookingIdOrEmailQuery = { notificationsByBookerOrEmail: (
    Pick<EmailNotificationWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<EmailNotification, 'id' | 'createDate' | 'status' | 'email' | 'receiverName' | 'subject' | 'templateType' | 'mailjetTemplateId' | 'messageHref' | 'text' | 'messageID' | 'templateName' | 'bookerId' | 'bookingId' | 'attachments'>
      & { booking?: Maybe<(
        Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled'>
        & { invoice?: Maybe<Pick<Invoice, 'id'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id'>> }
      )>, messageHistory?: Maybe<(
        Pick<MessageHistory, 'Count'>
        & { Data: Array<Pick<MessageHistoryData, 'EventAt' | 'EventType' | 'State'>> }
      )>, messageStatus?: Maybe<Pick<MessageStatusData, 'ArrivedAt' | 'Status'>> }
    )> }
  ) };

export type GetSentEmailStatusFromMailjetQueryVariables = Exact<{
  messageID: Scalars['String'];
}>;


export type GetSentEmailStatusFromMailjetQuery = Pick<Query, 'sentEmailStatusFromMailjet'>;

export type GetEmailNotificationByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEmailNotificationByIdQuery = { emailNotificationById: (
    Pick<EmailNotification, 'id' | 'createDate' | 'status' | 'email' | 'receiverName' | 'subject' | 'html' | 'text' | 'templateType' | 'templateName' | 'mailjetTemplateId' | 'courseDetailsSnapshot' | 'renderVariablesSnapshot' | 'messageHref' | 'messageID' | 'bookerId' | 'bookingId' | 'attachments'>
    & { booking?: Maybe<(
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled'>
      & { invoice?: Maybe<Pick<Invoice, 'id'>>, reversalInvoice?: Maybe<Pick<ReversalInvoice, 'id'>> }
    )>, messageHistory?: Maybe<(
      Pick<MessageHistory, 'Count'>
      & { Data: Array<Pick<MessageHistoryData, 'Comment' | 'EventAt' | 'EventType' | 'State' | 'Useragent'>> }
    )>, messageStatus?: Maybe<Pick<MessageStatusData, 'ArrivedAt' | 'Status' | 'AttemptCount'>> }
  ) };

export type GetBookerIdMissmatchQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetBookerIdMissmatchQuery = { getBookerIdMissmatchesWithPagination: (
    Pick<BookerIdMissmatchWithPagination, 'total' | 'existsMore'>
    & { items: Array<(
      Pick<BookerIdMissmatch, 'id' | 'email' | 'receiverName' | 'createDate' | 'subject' | 'templateName' | 'bookerId' | 'bookingId'>
      & { currentBooker?: Maybe<Pick<Booker, 'firstname' | 'lastname' | 'email' | 'id'>>, foundByMailBooker?: Maybe<Pick<Booker, 'firstname' | 'lastname' | 'email' | 'id'>> }
    )> }
  ) };

export type UpdateBookerIdMissmatchMutationVariables = Exact<{
  notificationId: Scalars['ID'];
  oldBookerId?: Maybe<Scalars['ID']>;
  newBookerId: Scalars['ID'];
}>;


export type UpdateBookerIdMissmatchMutation = { updateBookerIdMissmatch: Pick<EmailNotification, 'id' | 'email' | 'receiverName' | 'createDate' | 'subject' | 'templateName' | 'bookerId' | 'bookingId'> };

export type UpdateMultipleBookerIdMissmatchesMutationVariables = Exact<{
  updateMultipleBookerIdMissmatchesInput: Array<UpdateBookerIdMissmatchesInput> | UpdateBookerIdMissmatchesInput;
}>;


export type UpdateMultipleBookerIdMissmatchesMutation = { updateMultipleBookerIdMissmatches: Array<Pick<EmailNotification, 'id' | 'email' | 'receiverName' | 'createDate' | 'subject' | 'templateName' | 'bookerId' | 'bookingId'>> };

export type CreateParticipationPrerequisiteMutationVariables = Exact<{
  newParticipationPrerequisitesInput: NewParticipationPrerequisitesInput;
}>;


export type CreateParticipationPrerequisiteMutation = { createParticipationPrerequisite: Pick<ParticipationPrerequisites, 'id' | 'enabled' | 'groupDescription' | 'groupLabel' | 'minCheckCount' | 'optionalInputFields' | 'courseTypeId'> };

export type UpdateParticipationPrerequisiteMutationVariables = Exact<{
  updateParticipationPrerequisitesInput: UpdateParticipationPrerequisitesInput;
}>;


export type UpdateParticipationPrerequisiteMutation = { updateParticipationPrerequisite: Pick<ParticipationPrerequisites, 'id' | 'enabled' | 'groupDescription' | 'groupLabel' | 'minCheckCount' | 'optionalInputFields' | 'courseTypeId'> };

export type RemoveParticipationPrerequisiteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveParticipationPrerequisiteMutation = Pick<Mutation, 'removeParticipationPrerequisite'>;

export type GetParticipationPrerequisitesByCourseTypeIdQueryVariables = Exact<{
  courseTypeId: Scalars['ID'];
}>;


export type GetParticipationPrerequisitesByCourseTypeIdQuery = { participationPrerequisitesByCourseTypeId: Array<Pick<ParticipationPrerequisites, 'id' | 'enabled' | 'groupDescription' | 'groupLabel' | 'minCheckCount' | 'optionalInputFields' | 'courseTypeId'>> };

export type GetBankTransactionsQueryVariables = Exact<{
  filter?: Maybe<BankTransactionsFilterInput>;
}>;


export type GetBankTransactionsQuery = { bankTransactions: (
    Pick<BankTransactionsPage, 'total'>
    & { items: Array<(
      Pick<BankTransaction, 'id' | 'bankImportFileId' | 'acctSvcrRef' | 'bankTransactionCode' | 'bookingDate' | 'valueDate' | 'amount' | 'currency' | 'kind' | 'counterpartName' | 'counterpartIban' | 'remittanceText' | 'endToEndId' | 'mandateId' | 'returnReasonCode' | 'bankText' | 'isReversal' | 'status' | 'matchKind' | 'proposedScheduledPaymentIds' | 'matchedExportedSepaXmlId' | 'likelyRecordedScheduledPaymentIds' | 'matchNote' | 'comment' | 'decision' | 'decidedAt' | 'rejectReason' | 'rejectNote' | 'settledScheduledPaymentIds'>
      & { proposedScheduledPayments: Array<(
        Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'openAmount'>
        & { invoice?: Maybe<Pick<Invoice, 'id' | 'invoiceNumberPrefix' | 'invoiceNumber'>>, booking: (
          Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber' | 'noticeStaff'>
          & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname'>> }
        ) }
      )>, likelyRecordedScheduledPayments: Array<(
        Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'openAmount'>
        & { invoice?: Maybe<Pick<Invoice, 'id' | 'invoiceNumberPrefix' | 'invoiceNumber'>>, booking: (
          Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber' | 'noticeStaff'>
          & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname'>> }
        ) }
      )> }
    )> }
  ) };

export type GetBankTransactionConfirmContextQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBankTransactionConfirmContextQuery = { bankTransaction: (
    Pick<BankTransaction, 'id' | 'confirmWarning'>
    & { candidateRates: Array<(
      Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'openAmount' | 'paymentProvider'>
      & { invoice?: Maybe<Pick<Invoice, 'id' | 'invoiceNumberPrefix' | 'invoiceNumber'>>, booking: (
        Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber'>
        & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname'>> }
      ) }
    )> }
  ) };

export type GetBankTransactionCandidatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBankTransactionCandidatesQuery = { bankTransaction: (
    Pick<BankTransaction, 'id'>
    & { candidates: Array<(
      Pick<BankTransactionCandidate, 'bookingId' | 'bookingLabel' | 'attendeeName' | 'bookerName' | 'courseNumber' | 'courseName' | 'noticeStaff' | 'level' | 'evidence' | 'amountMatches' | 'warning'>
      & { rates: Array<(
        Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'openAmount' | 'paymentProvider'>
        & { invoice?: Maybe<Pick<Invoice, 'id' | 'invoiceNumberPrefix' | 'invoiceNumber'>>, booking: (
          Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber'>
          & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname'>> }
        ) }
      )> }
    )> }
  ) };

export type SearchBankTransactionCandidatesQueryVariables = Exact<{
  id: Scalars['ID'];
  searchKey: Scalars['String'];
}>;


export type SearchBankTransactionCandidatesQuery = { searchBankTransactionCandidates: Array<(
    Pick<BankTransactionCandidate, 'bookingId' | 'bookingLabel' | 'attendeeName' | 'bookerName' | 'courseNumber' | 'courseName' | 'noticeStaff' | 'level' | 'evidence' | 'amountMatches' | 'warning'>
    & { hits?: Maybe<Array<Pick<BankTransactionSearchHit, 'field' | 'term' | 'value' | 'exact'>>>, rates: Array<(
      Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'paymentDue' | 'paymentDone' | 'openAmount' | 'paymentProvider'>
      & { invoice?: Maybe<Pick<Invoice, 'id' | 'invoiceNumberPrefix' | 'invoiceNumber'>>, booking: (
        Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber'>
        & { attendee?: Maybe<Pick<Attendee, 'id' | 'firstname' | 'lastname'>> }
      ) }
    )> }
  )> };

export type ConfirmBankTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
  distributions: Array<BankTransactionDistributionInput> | BankTransactionDistributionInput;
  guardWarned?: Maybe<Scalars['Boolean']>;
}>;


export type ConfirmBankTransactionMutation = { confirmBankTransaction: Pick<BankTransaction, 'id' | 'status' | 'decision'> };

export type RejectBankTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
  reason: BankTransactionRejectReason;
  note?: Maybe<Scalars['String']>;
  recordedScheduledPaymentId?: Maybe<Scalars['ID']>;
}>;


export type RejectBankTransactionMutation = { rejectBankTransaction: Pick<BankTransaction, 'id' | 'status' | 'rejectReason'> };

export type GetBankImportFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankImportFilesQuery = { bankImportFiles: Array<Pick<BankImportFile, 'id' | 'createDate' | 'filename' | 'format' | 'accountIban' | 'periodFrom' | 'periodTo' | 'openingBalance' | 'closingBalance' | 'balanceGap' | 'balanceGapFrom' | 'balanceGapTo' | 'entryCount' | 'newCount' | 'knownCount'>> };

export type UpdateBankTransactionCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
}>;


export type UpdateBankTransactionCommentMutation = { updateBankTransactionComment: Pick<BankTransaction, 'id' | 'comment'> };

export type RematchBankImportFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RematchBankImportFileMutation = { rematchBankImportFile: Pick<BankImportFile, 'id'> };

export type RematchAllBankImportFilesMutationVariables = Exact<{
  after?: Maybe<Scalars['String']>;
}>;


export type RematchAllBankImportFilesMutation = { rematchAllBankImportFiles: Pick<BankImportRematchAllResult, 'rematched' | 'failed' | 'cursor' | 'total'> };

export type GetBankImportSepaExportQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBankImportSepaExportQuery = { exportedSepaXml: Pick<ExportedSepaXml, 'id' | 'fileName' | 'createDate' | 'object'> };

export type GetBankTransactionsForScheduledPaymentQueryVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
}>;


export type GetBankTransactionsForScheduledPaymentQuery = { bankTransactionsForScheduledPayment: Array<(
    Pick<BankTransaction, 'id' | 'bookingDate' | 'valueDate' | 'amount' | 'currency' | 'counterpartName'>
    & { proposedScheduledPayments: Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount'>> }
  )> };

export type SetBankTransactionCounterpartMutationVariables = Exact<{
  id: Scalars['ID'];
  treatAs: BankCounterpartKind;
}>;


export type SetBankTransactionCounterpartMutation = { setBankTransactionCounterpart: Pick<BankTransaction, 'id' | 'status' | 'matchNote'> };

export type RecordLikelyBankTransactionsMutationVariables = Exact<{
  after?: Maybe<Scalars['String']>;
}>;


export type RecordLikelyBankTransactionsMutation = { recordLikelyBankTransactions: Pick<BankTransactionRecordAllResult, 'recorded' | 'skipped' | 'cursor'> };

export type GetBankCollectionRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankCollectionRunsQuery = { bankCollectionRuns: Array<Pick<BankCollectionRun, 'exportedSepaXmlId' | 'fileName' | 'createDate' | 'collectionDate' | 'debitCount' | 'total' | 'linkedRates' | 'collectedRates' | 'returnedRates' | 'returnedAmount' | 'openReturns' | 'creditId' | 'creditBookingDate' | 'creditAmount' | 'creditStatus' | 'creditMissing' | 'returnDeadline'>> };

export type GetChargebacksQueryVariables = Exact<{
  filter: ChargebackFilterInput;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetChargebacksQuery = { getChargebacks: Array<(
    Pick<MolliePaymentAttempt, 'id' | 'scheduledPaymentId' | 'chargebackId' | 'chargebackReason' | 'chargebackFee' | 'chargebackedAt' | 'chargebackResolvedAt' | 'chargebackResolvedByUserId' | 'requiresManualRetry' | 'mollieMethod' | 'status' | 'isCurrentAttempt' | 'createDate'>
    & { scheduledPayment: (
      Pick<ScheduledPayment, 'id' | 'paymentAmount'>
      & { booking: (
        Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled'>
        & { invoice?: Maybe<Pick<Invoice, 'id'>>, courseLessons: Array<(
          Pick<CourseLesson, 'id'>
          & { course: Pick<Course, 'id' | 'allowLessonBooking'> }
        )>, attendee?: Maybe<(
          Pick<Attendee, 'id'>
          & { booker?: Maybe<Pick<Booker, 'id' | 'email' | 'firstname' | 'lastname'>> }
        )> }
      ) }
    ) }
  )> };

export type GetChargebackSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChargebackSummaryQuery = { getChargebackSummary: Pick<ChargebackSummary, 'totalChargebackFee30d' | 'totalChargebackCount30d'> };

export type ResolveChargebackMutationVariables = Exact<{
  attemptId: Scalars['String'];
}>;


export type ResolveChargebackMutation = { resolveChargeback: Pick<MolliePaymentAttempt, 'id' | 'chargebackResolvedAt' | 'chargebackResolvedByUserId'> };

export type GetChargebackCountQueryVariables = Exact<{
  filter: ChargebackFilterInput;
}>;


export type GetChargebackCountQuery = Pick<Query, 'getChargebackCount'>;

export type RefundMolliePaymentFromAdminMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
  amount: Scalars['Float'];
  reason?: Maybe<Scalars['String']>;
  notifyBooker?: Maybe<Scalars['Boolean']>;
}>;


export type RefundMolliePaymentFromAdminMutation = { refundMolliePaymentFromAdmin: Pick<MollieRefund, 'id' | 'scheduledPaymentId' | 'mollieRefundId' | 'amount' | 'reason' | 'status' | 'createDate'> };

export type GetMollieRefundsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetMollieRefundsQuery = { mollieRefunds: (
    Pick<MollieRefundsWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<MollieRefund, 'id' | 'createDate' | 'mollieRefundId' | 'amount' | 'reason' | 'status' | 'canceledAtProvider' | 'mollieCreatedAt' | 'adminUserId' | 'bookingNumberSnapshot' | 'bookingIdSnapshot' | 'bookerNameSnapshot' | 'attendeeNameSnapshot' | 'courseNumberSnapshot' | 'paymentAmountSnapshot'>
      & { scheduledPayment?: Maybe<(
        Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'refundedAmount' | 'paymentDone'>
        & { booking: (
          Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'bookingType' | 'canceled'>
          & { invoice?: Maybe<Pick<Invoice, 'id'>>, attendee?: Maybe<(
            Pick<Attendee, 'id' | 'firstname' | 'lastname'>
            & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email'>> }
          )>, courseLessons: Array<(
            Pick<CourseLesson, 'id'>
            & { course: (
              Pick<Course, 'id' | 'prefixedCourseNumber' | 'allowLessonBooking'>
              & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
            ) }
          )> }
        ) }
      )> }
    )> }
  ) };

export type ListYearEndExportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListYearEndExportsQuery = { listYearEndExports: Array<Pick<YearEndExport, 'id' | 'createdAt' | 'koOrganizationId' | 'totalSize' | 'status' | 'errorMessage' | 'createdBy' | 'recordCount' | 'progress' | 'year'>> };

export type GetYearEndExportDownloadUrlQueryVariables = Exact<{
  exportId: Scalars['ID'];
}>;


export type GetYearEndExportDownloadUrlQuery = Pick<Query, 'getYearEndExportDownloadUrl'>;

export type CreateYearEndExportMutationVariables = Exact<{
  year: Scalars['Int'];
}>;


export type CreateYearEndExportMutation = { createYearEndExport: Pick<YearEndExport, 'id' | 'createdAt' | 'koOrganizationId' | 'totalSize' | 'status' | 'errorMessage' | 'createdBy' | 'recordCount' | 'progress' | 'year'> };

export type DeleteYearEndExportMutationVariables = Exact<{
  exportId: Scalars['ID'];
}>;


export type DeleteYearEndExportMutation = Pick<Mutation, 'deleteYearEndExport'>;

export type GetExportedSepaXmlsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetExportedSepaXmlsQuery = { exportedSepaXmls: (
    Pick<ExportedSepaXmlWithPagination, 'existsMore' | 'total'>
    & { items: Array<Pick<ExportedSepaXml, 'id' | 'object' | 'xml' | 'createDate' | 'createdByUserId' | 'updateDate' | 'updatedByUserId' | 'fileName'>> }
  ) };

export type GetExportedSepaXmlQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetExportedSepaXmlQuery = { exportedSepaXml: Pick<ExportedSepaXml, 'id' | 'object' | 'xml' | 'createDate' | 'createdByUserId' | 'updateDate' | 'updatedByUserId' | 'fileName'> };

export type SendMolliePaymentLinkFromAdminMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
}>;


export type SendMolliePaymentLinkFromAdminMutation = { sendMolliePaymentLinkFromAdmin?: Maybe<Pick<MolliePaymentResult, 'molliePaymentId' | 'checkoutUrl' | 'status' | 'linkExpiresAt' | 'bookerEmail' | 'dispatchKind'>> };

export type SendMolliePaymentLinkForBookingFromAdminMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
}>;


export type SendMolliePaymentLinkForBookingFromAdminMutation = { sendMolliePaymentLinkForBookingFromAdmin?: Maybe<Pick<MolliePaymentResult, 'molliePaymentId' | 'checkoutUrl' | 'status' | 'linkExpiresAt' | 'bookerEmail' | 'dispatchKind'>> };

export type DetectBundleConflictsFromAdminQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type DetectBundleConflictsFromAdminQuery = Pick<Query, 'detectBundleConflictsFromAdmin'>;

export type CancelMolliePaymentFromAdminMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
}>;


export type CancelMolliePaymentFromAdminMutation = { cancelMolliePaymentFromAdmin?: Maybe<Pick<MolliePaymentResult, 'molliePaymentId' | 'checkoutUrl' | 'status'>> };

export type RefreshMolliePaymentStatusFromAdminMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
}>;


export type RefreshMolliePaymentStatusFromAdminMutation = { refreshMolliePaymentStatusFromAdmin?: Maybe<Pick<MolliePaymentAttempt, 'id' | 'status' | 'paidAt' | 'molliePaymentId'>> };

export type CaptureMolliePaymentFromAdminMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
}>;


export type CaptureMolliePaymentFromAdminMutation = { captureMolliePaymentFromAdmin?: Maybe<Pick<MolliePaymentResult, 'molliePaymentId' | 'checkoutUrl' | 'status'>> };

export type CreateNewMolliePaymentAttemptFromAdminMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
}>;


export type CreateNewMolliePaymentAttemptFromAdminMutation = { createNewMolliePaymentAttemptFromAdmin?: Maybe<Pick<MolliePaymentResult, 'molliePaymentId' | 'checkoutUrl' | 'status' | 'linkExpiresAt'>> };

export type RecordExternalPaymentForScheduledPaymentMutationVariables = Exact<{
  input: RecordExternalPaymentForScheduledPaymentInput;
}>;


export type RecordExternalPaymentForScheduledPaymentMutation = { recordExternalPaymentForScheduledPayment: Pick<ScheduledPayment, 'id' | 'bookingId' | 'paymentProvider' | 'paymentDone' | 'paymentTransferType' | 'paymentAmount' | 'openAmount' | 'molliePaymentUrl' | 'molliePaymentStatus' | 'methodChangedAt' | 'note'> };

export type GetBilledBookingsQueryVariables = Exact<{
  courseType: Scalars['Boolean'];
  courseNumber: Scalars['Boolean'];
  booker: Scalars['Boolean'];
  attendee: Scalars['Boolean'];
  location: Scalars['Boolean'];
  firstCourse: Scalars['Boolean'];
  paymentType: Scalars['Boolean'];
  amount: Scalars['Boolean'];
  paymentDate: Scalars['Boolean'];
  invoice: Scalars['Boolean'];
  due: Scalars['Boolean'];
  discount: Scalars['Boolean'];
}>;


export type GetBilledBookingsQuery = { getBilledBookings: Array<(
    MakeOptional<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'paymentType'>, 'paymentType'>
    & { courseLessons: Array<(
      MakeOptional<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>, 'startDateTime' | 'endDateTime'>
      & { course: (
        MakeOptional<Pick<Course, 'id' | 'prefixedCourseNumber'>, 'prefixedCourseNumber'>
        & { courseType?: Maybe<Pick<CourseType, 'id' | 'name' | 'color'>> }
      ) }
    )>, attendee?: Maybe<(
      MakeOptional<Pick<Attendee, 'firstname' | 'lastname' | 'id'>, 'firstname' | 'lastname'>
      & { booker?: Maybe<MakeOptional<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'city'>, 'firstname' | 'lastname' | 'city'>> }
    )>, coursePrice: MakeOptional<Pick<CoursePrice, 'id' | 'grossPrice' | 'discount'>, 'grossPrice' | 'discount'>, invoice?: Maybe<MakeOptional<Pick<Invoice, 'id' | 'billed' | 'paymentDue' | 'invoiceNumber' | 'invoiceNumberPrefix'>, 'billed' | 'paymentDue' | 'invoiceNumber' | 'invoiceNumberPrefix'>> }
  )> };

export type GetUnBilledBookingsQueryVariables = Exact<{
  courseType: Scalars['Boolean'];
  courseNumber: Scalars['Boolean'];
  booker: Scalars['Boolean'];
  attendee: Scalars['Boolean'];
  location: Scalars['Boolean'];
  firstCourse: Scalars['Boolean'];
  paymentType: Scalars['Boolean'];
  amount: Scalars['Boolean'];
  paymentDate: Scalars['Boolean'];
  invoice: Scalars['Boolean'];
  due: Scalars['Boolean'];
  discount: Scalars['Boolean'];
  place: Scalars['Boolean'];
  invoiceDate: Scalars['Boolean'];
}>;


export type GetUnBilledBookingsQuery = { getUnBilledBookings: Array<(
    MakeOptional<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix' | 'paymentType' | 'payDate'>, 'paymentType' | 'payDate'>
    & { courseLessons: Array<(
      MakeOptional<Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>, 'startDateTime' | 'endDateTime'>
      & { location?: Maybe<Pick<Location, 'id' | 'city'>>, course: (
        MakeOptional<Pick<Course, 'id' | 'prefixedCourseNumber'>, 'prefixedCourseNumber'>
        & { courseType?: Maybe<Pick<CourseType, 'id' | 'name' | 'color'>> }
      ) }
    )>, attendee?: Maybe<(
      MakeOptional<Pick<Attendee, 'firstname' | 'lastname' | 'id'>, 'firstname' | 'lastname'>
      & { booker?: Maybe<MakeOptional<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'city'>, 'firstname' | 'lastname' | 'city'>> }
    )>, coursePrice: MakeOptional<Pick<CoursePrice, 'id' | 'grossPrice' | 'discount'>, 'grossPrice' | 'discount'>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'type'>>, invoice?: Maybe<MakeOptional<Pick<Invoice, 'id' | 'billed' | 'paymentDue' | 'invoiceNumber' | 'invoiceNumberPrefix'>, 'billed' | 'paymentDue' | 'invoiceNumber' | 'invoiceNumberPrefix'>> }
  )> };

export type GetUnBilledBookingsMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnBilledBookingsMinimalQuery = { getUnBilledBookings: Array<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>> };

export type GetBilledBookingsMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBilledBookingsMinimalQuery = { getBilledBookings: Array<Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>> };

export type UpdateInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
  editInvoiceData: EditInvoiceInput;
}>;


export type UpdateInvoiceMutation = { updateInvoice: Pick<Invoice, 'id'> };

export type GetScheduledPaymentsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetScheduledPaymentsQuery = { scheduledPayments: (
    Pick<ScheduledPaymentsWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'refundedAmount' | 'providerRefundedAmount' | 'molliePaidAmount' | 'surplusMolliePaymentCount' | 'openAmount' | 'createDate' | 'paymentDone' | 'note' | 'paymentTransferType' | 'paymentMethodId' | 'title' | 'type' | 'paymentProvider' | 'mollieMethod' | 'molliePaymentStatus' | 'molliePaymentUrl' | 'mollieErrorMessage' | 'mollieRetryCount' | 'methodChangedAt'>
      & { invoice?: Maybe<Pick<Invoice, 'billed' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'createDate' | 'updateDate' | 'id'>>, booking: (
        Pick<Booking, 'id' | 'courseId' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'bookedBy' | 'paymentType' | 'canceled' | 'noticeStaff'>
        & { invoice?: Maybe<Pick<Invoice, 'id'>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, attendee?: Maybe<(
          Pick<Attendee, 'id' | 'erasedAt' | 'firstname' | 'lastname'>
          & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'nonDisclosureNotice'>> }
        )>, courseLessons: Array<(
          Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
          & { course: (
            Pick<Course, 'id' | 'startDateTime' | 'paymentInterval' | 'prefixedCourseNumber'>
            & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
          ), location: Pick<Location, 'id' | 'city' | 'name'> }
        )> }
      ), paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, methodChangedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>> }
    )> }
  ) };

export type GetUnpaidScheduledPaymentsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  bookingId?: Maybe<Scalars['ID']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  respectArchiveSetting?: Maybe<Scalars['Boolean']>;
  dunningDue?: Maybe<Scalars['Boolean']>;
}>;


export type GetUnpaidScheduledPaymentsQuery = { unpaidScheduledPayments: (
    Pick<ScheduledPaymentsWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'refundedAmount' | 'providerRefundedAmount' | 'molliePaidAmount' | 'openAmount' | 'createDate' | 'paymentDone' | 'sepaClearance' | 'paymentTransferType' | 'paymentMethodId' | 'title' | 'type' | 'note' | 'paymentProvider' | 'mollieMethod' | 'molliePaymentStatus' | 'molliePaymentUrl' | 'mollieErrorMessage' | 'mollieRetryCount' | 'methodChangedAt' | 'manuallyAdjustedAt' | 'manuallyAdjustedByUserId' | 'manuallyAddedAt' | 'transferFromBookingNumber' | 'transferPaidAmount' | 'deletedAt' | 'deletedByUserId'>
      & { dunningStatus?: Maybe<Pick<BookingDunningStatus, 'bookingId' | 'level' | 'levelDate' | 'nextLevel' | 'nextDate' | 'due' | 'pausedUntil'>>, invoice?: Maybe<Pick<Invoice, 'id' | 'createDate' | 'updateDate' | 'invoiceNumber' | 'invoiceNumberPrefix'>>, booking: (
        Pick<Booking, 'id' | 'courseId' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'bookedBy' | 'paymentType' | 'canceled' | 'noticeStaff'>
        & { invoice?: Maybe<Pick<Invoice, 'id'>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, attendee?: Maybe<(
          Pick<Attendee, 'id' | 'erasedAt' | 'firstname' | 'lastname'>
          & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'nonDisclosureNotice'>> }
        )>, courseLessons: Array<(
          Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
          & { course: (
            Pick<Course, 'id' | 'startDateTime' | 'paymentInterval' | 'prefixedCourseNumber'>
            & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
          ), location: Pick<Location, 'id' | 'city' | 'name'> }
        )> }
      ), paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, methodChangedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>>, manuallyAdjustedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>>, deletedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>> }
    )> }
  ) };

export type GetUnpaidScheduledPaymentsZeroValuesQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetUnpaidScheduledPaymentsZeroValuesQuery = { unpaidScheduledPaymentsZeroValues: Array<(
    Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'refundedAmount' | 'providerRefundedAmount' | 'molliePaidAmount' | 'openAmount' | 'createDate' | 'paymentDone' | 'sepaClearance' | 'paymentTransferType' | 'paymentMethodId' | 'title' | 'type' | 'note' | 'paymentProvider' | 'mollieMethod' | 'molliePaymentStatus' | 'molliePaymentUrl' | 'mollieErrorMessage' | 'mollieRetryCount' | 'methodChangedAt'>
    & { invoice?: Maybe<Pick<Invoice, 'id' | 'createDate' | 'updateDate' | 'invoiceNumber' | 'invoiceNumberPrefix'>>, booking: (
      Pick<Booking, 'id' | 'courseId' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'bookedBy' | 'paymentType' | 'canceled' | 'noticeStaff'>
      & { invoice?: Maybe<Pick<Invoice, 'id'>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, attendee?: Maybe<(
        Pick<Attendee, 'id' | 'erasedAt' | 'firstname' | 'lastname'>
        & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'nonDisclosureNotice'>> }
      )>, courseLessons: Array<(
        Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
        & { course: (
          Pick<Course, 'id' | 'startDateTime' | 'paymentInterval' | 'prefixedCourseNumber'>
          & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
        ), location: Pick<Location, 'id' | 'city' | 'name'> }
      )> }
    ), paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, methodChangedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>> }
  )> };

export type ResolveSurplusMolliePaymentsMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
}>;


export type ResolveSurplusMolliePaymentsMutation = Pick<Mutation, 'resolveSurplusMolliePayments'>;

export type GetPaidScheduledPaymentsQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  bookingId?: Maybe<Scalars['ID']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  respectArchiveSetting?: Maybe<Scalars['Boolean']>;
}>;


export type GetPaidScheduledPaymentsQuery = { paidScheduledPayments: (
    Pick<ScheduledPaymentsWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'refundedAmount' | 'providerRefundedAmount' | 'molliePaidAmount' | 'surplusMolliePaymentCount' | 'openAmount' | 'createDate' | 'paymentDone' | 'note' | 'sepaClearance' | 'paymentTransferType' | 'paymentMethodId' | 'title' | 'type' | 'paymentProvider' | 'mollieMethod' | 'molliePaymentStatus' | 'molliePaymentUrl' | 'mollieErrorMessage' | 'mollieRetryCount' | 'methodChangedAt' | 'manuallyAdjustedAt' | 'manuallyAdjustedByUserId' | 'manuallyAddedAt' | 'transferFromBookingNumber' | 'transferPaidAmount' | 'deletedAt' | 'deletedByUserId'>
      & { invoice?: Maybe<Pick<Invoice, 'id' | 'createDate' | 'updateDate' | 'invoiceNumber' | 'invoiceNumberPrefix'>>, booking: (
        Pick<Booking, 'id' | 'courseId' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'isSpecial' | 'vat' | 'netPrice' | 'grossPrice' | 'bookedBy' | 'paymentType' | 'canceled' | 'noticeStaff'>
        & { invoice?: Maybe<Pick<Invoice, 'id'>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, attendee?: Maybe<(
          Pick<Attendee, 'id' | 'erasedAt' | 'firstname' | 'lastname'>
          & { booker?: Maybe<Pick<Booker, 'id' | 'firstname' | 'lastname' | 'email' | 'nonDisclosureNotice'>> }
        )>, courseLessons: Array<(
          Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime'>
          & { course: (
            Pick<Course, 'id' | 'startDateTime' | 'paymentInterval' | 'prefixedCourseNumber'>
            & { courseType: Pick<CourseType, 'id' | 'name' | 'color'> }
          ), location: Pick<Location, 'id' | 'city' | 'name'> }
        )> }
      ), paymentMethod?: Maybe<Pick<PaymentMethod, 'id' | 'cash' | 'esr' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'type' | 'bankTransfer' | 'onlinePayment'>>, methodChangedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>>, manuallyAdjustedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>>, deletedBy?: Maybe<Pick<ScheduledPaymentMethodChangeUser, 'id' | 'email'>> }
    )> }
  ) };

export type GetScheduledPaymentsSummaryQueryVariables = Exact<{
  paymentDone: Scalars['Boolean'];
  options?: Maybe<ArrayDataOptions>;
  respectArchiveSetting?: Maybe<Scalars['Boolean']>;
}>;


export type GetScheduledPaymentsSummaryQuery = { scheduledPaymentSummary: { filtered: Pick<ScheduledPaymentSummaryPart, 'count' | 'sum'>, total: Pick<ScheduledPaymentSummaryPart, 'count' | 'sum'> } };

export type GetScheduledPaymentsMinQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetScheduledPaymentsMinQuery = { scheduledPayments: (
    Pick<ScheduledPaymentsWithPagination, 'existsMore' | 'total'>
    & { items: Array<Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'openAmount' | 'paymentTransferType' | 'title'>> }
  ) };

export type GetScheduledPaymentByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetScheduledPaymentByIdQuery = { scheduledPaymentById: Pick<ScheduledPayment, 'id'> };

export type DeleteScheduledPaymentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteScheduledPaymentMutation = { deleteScheduledPayment: Pick<ScheduledPayment, 'id'> };

export type UpdateScheduledPaymentMutationVariables = Exact<{
  editScheduledPaymentData: EditScheduledPaymentInput;
  id: Scalars['String'];
}>;


export type UpdateScheduledPaymentMutation = { updateScheduledPayment: Pick<ScheduledPayment, 'id' | 'paymentDone'> };

export type UpdateManyScheduledPaymentIdsMutationVariables = Exact<{
  paymentIds: Array<Scalars['ID']> | Scalars['ID'];
  editScheduledPaymentData: EditScheduledPaymentInput;
}>;


export type UpdateManyScheduledPaymentIdsMutation = { updateManyScheduledPaymentIds: Array<Pick<ScheduledPayment, 'id' | 'paymentDone'>> };

export type SetMultipleScheduledPaymentsPaidMutationVariables = Exact<{
  paymentIds: Array<Scalars['ID']> | Scalars['ID'];
  paymentDone: Scalars['DateTime'];
}>;


export type SetMultipleScheduledPaymentsPaidMutation = Pick<Mutation, 'setMultipleScheduledPaymentsPaid'>;

export type SetSepaClearanceMutationVariables = Exact<{
  id: Scalars['ID'];
  sepaClearance: Scalars['Boolean'];
}>;


export type SetSepaClearanceMutation = { setSepaClearance: Pick<ScheduledPayment, 'id' | 'sepaClearance'> };

export type GetScheduledPaymentsByBookingIdQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type GetScheduledPaymentsByBookingIdQuery = { scheduledPaymentsByBookingId: Array<(
    Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'openAmount' | 'createDate' | 'paymentDone' | 'paymentTransferType' | 'title'>
    & { invoice?: Maybe<Pick<Invoice, 'id' | 'createDate' | 'invoiceNumber' | 'invoiceNumberPrefix'>> }
  )> };

export type GeneratePaymentSchedulePreviewMutationVariables = Exact<{
  lessonDates: Array<Scalars['DateTime']> | Scalars['DateTime'];
  bookingPrice: Scalars['Float'];
  monthlySchedule: MonthlySchedule;
  paymentType: PaymentType;
  courseId?: Maybe<Scalars['ID']>;
}>;


export type GeneratePaymentSchedulePreviewMutation = Pick<Mutation, 'generatePaymentSchedulePreview'>;

export type GenerateUpdatedSchedulesNewBookingPriceMutationVariables = Exact<{
  scheduledPayments: Array<UpdateScheduledPaymentByBookingInput> | UpdateScheduledPaymentByBookingInput;
  bookingPrice: Scalars['Float'];
}>;


export type GenerateUpdatedSchedulesNewBookingPriceMutation = { generateUpdatedSchedulesNewBookingPrice: Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount' | 'paymentDue'>> };

export type ResetScheduledPaymentsOfBookingMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type ResetScheduledPaymentsOfBookingMutation = { resetScheduledPaymentsOfBooking: (
    Pick<ResetScheduledPaymentsOfBookingResult, 'bookingId' | 'bookingNumber' | 'bookingPrice' | 'coursePrice' | 'creditedBalance' | 'currentScheduledPaymentsCount' | 'newScheduledPaymentsCount' | 'currentScheduledPaymnetsCount'>
    & { installmentPlanAmountsAndDueDates: Array<(
      Pick<Rate, 'key'>
      & { value: Pick<RateDetail, 'due' | 'amount'> }
    )>, newScheduledPaymentsAmountsAndDueDates: Array<(
      Pick<Rate, 'key'>
      & { value: Pick<RateDetail, 'due' | 'amount'> }
    )>, currentScheduledPaymentsAmountsAndDueDates: Array<(
      Pick<Rate, 'key'>
      & { value: Pick<RateDetail, 'due' | 'amount'> }
    )> }
  ) };

export type ResetAllUnsetteledScheduledPaymentsOfCourseMutationVariables = Exact<{
  courseId: Scalars['ID'];
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type ResetAllUnsetteledScheduledPaymentsOfCourseMutation = { resetAllUnsetteledScheduledPaymentsOfCourse: (
    Pick<ResetScheduledPaymentsOfCourseResult, 'courseId' | 'coursePrice'>
    & { courseDueDates: Array<(
      Pick<Rate, 'key'>
      & { value: Pick<RateDetail, 'due' | 'amount'> }
    )>, bookings: Array<(
      Pick<ResetScheduledPaymentsOfBookingResult, 'bookingId' | 'bookingNumber' | 'bookingPrice' | 'creditedBalance' | 'currentScheduledPaymentsCount' | 'newScheduledPaymentsCount' | 'currentScheduledPaymnetsCount'>
      & { newScheduledPaymentsAmountsAndDueDates: Array<(
        Pick<Rate, 'key'>
        & { value: Pick<RateDetail, 'due' | 'amount'> }
      )>, currentScheduledPaymentsAmountsAndDueDates: Array<(
        Pick<Rate, 'key'>
        & { value: Pick<RateDetail, 'due' | 'amount'> }
      )> }
    )> }
  ) };

export type ScheduledPaymentsByBookerIdQueryVariables = Exact<{
  bookerId: Scalars['ID'];
}>;


export type ScheduledPaymentsByBookerIdQuery = { scheduledPaymentsByBookerId: Array<Pick<ScheduledPayment, 'id' | 'paymentDue' | 'paymentAmount' | 'openAmount' | 'paymentDone' | 'createDate' | 'sepaClearance' | 'paymentMethodId'>> };

export type SetScheduledPaymentPaidMutationVariables = Exact<{
  id: Scalars['String'];
  paymentDone: Scalars['DateTime'];
}>;


export type SetScheduledPaymentPaidMutation = { setScheduledPaymentPaid: Pick<ScheduledPayment, 'id' | 'paymentDone'> };

export type SetScheduledPaymentUnpaidMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SetScheduledPaymentUnpaidMutation = { setScheduledPaymentUnpaid: Pick<ScheduledPayment, 'id' | 'paymentDone'> };

export type SetNewPaymentDoneDateMutationVariables = Exact<{
  id: Scalars['String'];
  paymentDoneDate: Scalars['DateTime'];
}>;


export type SetNewPaymentDoneDateMutation = { setNewPaymentDoneDate: Pick<ScheduledPayment, 'id' | 'paymentDone'> };

export type SetNewPaymentAmountMutationVariables = Exact<{
  id: Scalars['String'];
  paymentAmount: Scalars['Float'];
}>;


export type SetNewPaymentAmountMutation = { setNewPaymentAmount: Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount'> };

export type ModifyScheduledPaymentMutationVariables = Exact<{
  modifyScheduledPaymentInput: ModifyScheduledPaymentInput;
}>;


export type ModifyScheduledPaymentMutation = { modifyScheduledPayment: Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount' | 'paymentDue' | 'paymentDone' | 'paymentMethodId' | 'sepaClearance' | 'title' | 'type'> };

export type GenerateScheduledPaymentsForSettledBookingMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  savePayments?: Maybe<Scalars['Boolean']>;
}>;


export type GenerateScheduledPaymentsForSettledBookingMutation = { generateScheduledPaymentsForSettledBooking: Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount' | 'paymentDue' | 'paymentDone' | 'paymentMethodId' | 'sepaClearance'>> };

export type AddNamedScheduledPaymentMutationVariables = Exact<{
  addNamedScheduledPaymentInput: AddNamedScheduledPaymentInput;
}>;


export type AddNamedScheduledPaymentMutation = { addNamedScheduledPayment: Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount' | 'paymentDue' | 'paymentDone' | 'paymentMethodId' | 'sepaClearance'> };

export type UpdateSettledBookingDiscountMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  discount?: Maybe<Scalars['Float']>;
  discountName?: Maybe<Scalars['String']>;
  memberDiscount?: Maybe<Scalars['Float']>;
  creditedBalance?: Maybe<Scalars['Float']>;
}>;


export type UpdateSettledBookingDiscountMutation = { updateSettledBookingDiscount: (
    Pick<Booking, 'id' | 'discount' | 'discountName' | 'memberDiscount' | 'creditedBalance' | 'grossPrice' | 'netPrice'>
    & { scheduledPayments?: Maybe<Array<Pick<ScheduledPayment, 'id' | 'paymentAmount' | 'openAmount' | 'paymentDone' | 'type'>>> }
  ) };

export type GenerateScheduledPaymentsByCourseMutationVariables = Exact<{
  courseId: Scalars['ID'];
  attendeeId?: Maybe<Scalars['ID']>;
  omitMemberDiscount?: Maybe<Scalars['Boolean']>;
  creditedBalance?: Maybe<Scalars['Float']>;
  currentScheduledPayments?: Maybe<Array<ScheduledPaymentSimpleInput> | ScheduledPaymentSimpleInput>;
  paymentType?: Maybe<PaymentType>;
  memberDiscount?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  additionalItemIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  discountCode?: Maybe<Scalars['String']>;
}>;


export type GenerateScheduledPaymentsByCourseMutation = { generateScheduledPaymentsByCourse: (
    Pick<ScheduledPaymentPreview, 'grossPrice' | 'netPrice' | 'memberDiscount' | 'discountCode' | 'discount' | 'discountName'>
    & { scheduledPayments: Array<Pick<ScheduledPaymentSimple, 'id' | 'paymentAmount' | 'paymentDue' | 'type' | 'title' | 'additionalItemId' | 'vat'>> }
  ) };

export type GetScheduledPaymentsWithMissingInvoiceIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScheduledPaymentsWithMissingInvoiceIdsQuery = { scheduledPaymentsWithMissingInvoiceIds: Array<(
    Pick<ScheduledPayment, 'id' | 'bookingId' | 'paymentAmount' | 'paymentDue' | 'invoiceId'>
    & { booking: (
      Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'>
      & { courseLessons: Array<{ course: Pick<Course, 'prefixedCourseNumber'> }> }
    ) }
  )> };

export type FixMissingInvoiceIdsMutationVariables = Exact<{
  scheduledPaymentIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FixMissingInvoiceIdsMutation = Pick<Mutation, 'fixMissingInvoiceIds'>;

export type ClearManuallyAdjustedMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ClearManuallyAdjustedMutation = { clearManuallyAdjusted: Pick<ScheduledPayment, 'id' | 'manuallyAdjustedAt' | 'manuallyAdjustedByUserId' | 'paymentAmount' | 'paymentDue'> };

export type RestoreScheduledPaymentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreScheduledPaymentMutation = { restoreScheduledPayment: Pick<ScheduledPayment, 'id' | 'deletedAt' | 'deletedByUserId' | 'paymentAmount' | 'paymentDue'> };

export type CreateSepaXmlByIdMutationVariables = Exact<{
  createSingleSepaXmlInput: CreateSingleSepaXmlInput;
}>;


export type CreateSepaXmlByIdMutation = Pick<Mutation, 'createSepaXmlById'>;

export type CreateSepaXmlByTimeRangeMutationVariables = Exact<{
  createSepaXmlByTimeRangeInput: CreateSepaXmlByTimeRangeInput;
}>;


export type CreateSepaXmlByTimeRangeMutation = Pick<Mutation, 'createSepaXmlByTimeRange'>;

export type GetBankDataQueryVariables = Exact<{
  iban: Scalars['String'];
}>;


export type GetBankDataQuery = Pick<Query, 'getBankData'>;

export type GetRestrictiveBookingsByCourseIdQueryVariables = Exact<{
  courseId: Scalars['String'];
}>;


export type GetRestrictiveBookingsByCourseIdQuery = { getBookingRestrictionByCourseId?: Maybe<(
    Pick<BookingRestriction, 'id' | 'courseId' | 'active' | 'visibleForAll' | 'blockedPlaces' | 'startDateTime' | 'endDateTime' | 'includeWaitingList' | 'includeBookingList' | 'membersOnly' | 'allowWaitlistWithoutPrerequisite' | 'expireAction'>
    & { prerequisiteCourses?: Maybe<Array<Pick<Course, 'id'>>> }
  )> };

export type CreateBookingRestrictionMutationVariables = Exact<{
  newBookingRestrictionInput: NewBookingRestrictionInput;
}>;


export type CreateBookingRestrictionMutation = { createBookingRestriction: (
    Pick<BookingRestriction, 'id' | 'active' | 'visibleForAll' | 'blockedPlaces' | 'startDateTime' | 'endDateTime' | 'includeWaitingList' | 'includeBookingList' | 'membersOnly' | 'allowWaitlistWithoutPrerequisite' | 'expireAction'>
    & { prerequisiteCourses?: Maybe<Array<Pick<Course, 'id'>>> }
  ) };

export type UpdateBookingRestrictionMutationVariables = Exact<{
  updateBookingRestrictionInput: UpdateBookingRestrictionInput;
}>;


export type UpdateBookingRestrictionMutation = { updateBookingRestriction: (
    Pick<BookingRestriction, 'id' | 'active' | 'visibleForAll' | 'blockedPlaces' | 'startDateTime' | 'endDateTime' | 'includeWaitingList' | 'includeBookingList' | 'membersOnly' | 'allowWaitlistWithoutPrerequisite' | 'expireAction'>
    & { prerequisiteCourses?: Maybe<Array<Pick<Course, 'id'>>> }
  ) };

export type DeleteBookingRestrictionMutationVariables = Exact<{
  bookingRestrictionId: Scalars['String'];
}>;


export type DeleteBookingRestrictionMutation = Pick<Mutation, 'deleteBookingRestriction'>;

export type AddBookableCoursesMutationVariables = Exact<{
  prerequisiteCourseId: Scalars['String'];
  bookableCourseIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AddBookableCoursesMutation = Pick<Mutation, 'addBookableCourses'>;

export type RemoveBookableCourseMutationVariables = Exact<{
  bookableCourseId: Scalars['String'];
  prerquisiteCourseId: Scalars['String'];
}>;


export type RemoveBookableCourseMutation = Pick<Mutation, 'removeBookableCourse'>;

export type Ko9TestConnectionMutationVariables = Exact<{
  credentials: Ko9DbCredentialsInput;
}>;


export type Ko9TestConnectionMutation = { ko9TestConnection: Pick<Ko9ConnectionTestResult, 'success' | 'error'> };

export type Ko9DetectSchemaMutationVariables = Exact<{
  credentials: Ko9DbCredentialsInput;
}>;


export type Ko9DetectSchemaMutation = { ko9DetectSchema: Pick<Ko9SchemaInfoType, 'hasKinder' | 'hasTeilnehmer' | 'hasAdressen' | 'hasKonto' | 'hasAbzeichen' | 'hasTeilnahme' | 'hasKursBezeichnungen' | 'hasKursstandorte' | 'allTables'> };

export type Ko9FetchPreviewMutationVariables = Exact<{
  credentials: Ko9DbCredentialsInput;
  config: Ko9ImportConfigInput;
  limit?: Maybe<Scalars['Int']>;
}>;


export type Ko9FetchPreviewMutation = { ko9FetchPreview: (
    Pick<Ko9PreviewResultType, 'totalRows' | 'totalBookers' | 'totalAttendees'>
    & { previewRows: Array<Pick<Ko9PreviewRowType, 'bookerName' | 'email' | 'attendeeName' | 'birthday' | 'city' | 'sepaInfo' | 'badgesCount' | 'bookingsCount'>>, schema: Pick<Ko9SchemaInfoType, 'hasKinder' | 'hasTeilnehmer' | 'hasAdressen' | 'hasKonto' | 'hasAbzeichen' | 'hasTeilnahme' | 'hasKursBezeichnungen' | 'hasKursstandorte' | 'allTables'> }
  ) };

export type Ko9DryRunMutationVariables = Exact<{
  credentials: Ko9DbCredentialsInput;
  config: Ko9ImportConfigInput;
}>;


export type Ko9DryRunMutation = Pick<Mutation, 'ko9DryRun'>;

export type Ko9ExecuteImportMutationVariables = Exact<{
  credentials: Ko9DbCredentialsInput;
  config: Ko9ImportConfigInput;
}>;


export type Ko9ExecuteImportMutation = Pick<Mutation, 'ko9ExecuteImport'>;

export type Ko9SaveCredentialsMutationVariables = Exact<{
  credentials: Ko9DbCredentialsInput;
}>;


export type Ko9SaveCredentialsMutation = { ko9SaveCredentials: Pick<Ko9SaveResult, 'success'> };

export type Ko9LoadCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type Ko9LoadCredentialsQuery = { ko9LoadCredentials?: Maybe<Pick<Ko9LoadedCredentials, 'host' | 'port' | 'user' | 'database'>> };

export type Ko9ImportProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type Ko9ImportProgressQuery = { ko9ImportProgress?: Maybe<Pick<Ko9ImportProgressType, 'phase' | 'totalBookers' | 'importedBookers' | 'totalAttendees' | 'importedAttendees' | 'skippedBookers' | 'errorMessage' | 'result'>> };

export type Ko9RollbackImportMutationVariables = Exact<{
  bookerIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type Ko9RollbackImportMutation = { ko9RollbackImport: Pick<Ko9RollbackResultType, 'success' | 'deletedBookers' | 'deletedAttendees' | 'deletedPaymentMethods' | 'error'> };

export type GetBookerAndAttendeeCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookerAndAttendeeCountQuery = { getBookerAndAttendeeCount: Pick<BookerAttendeeCount, 'bookerCount' | 'attendeeCount'> };

export type BookerDeletionProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type BookerDeletionProgressQuery = { bookerDeletionProgress?: Maybe<Pick<BookerDeletionProgressType, 'phase' | 'totalBookers' | 'deletedBookers' | 'totalAttendees' | 'deletedAttendees' | 'errorMessage'>> };

export type GetAnnouncementsQueryVariables = Exact<{
  input?: Maybe<GetAnnouncementsInput>;
}>;


export type GetAnnouncementsQuery = { announcements: Array<Pick<Announcement, 'id' | 'title' | 'message' | 'type' | 'priority' | 'isActive' | 'validFrom' | 'validUntil' | 'isDismissible' | 'isMinimizable' | 'koOrganizationId' | 'targetUrl' | 'targetUrlLabel' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId'>> };

export type GetActiveAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveAnnouncementsQuery = { activeAnnouncements: Array<Pick<Announcement, 'id' | 'title' | 'message' | 'type' | 'priority' | 'isActive' | 'validFrom' | 'validUntil' | 'isDismissible' | 'isMinimizable' | 'koOrganizationId' | 'targetUrl' | 'targetUrlLabel' | 'createDate'>> };

export type CreateAnnouncementMutationVariables = Exact<{
  input: CreateAnnouncementInput;
}>;


export type CreateAnnouncementMutation = { createAnnouncement: Pick<Announcement, 'id' | 'title' | 'message' | 'type' | 'priority' | 'isActive' | 'validFrom' | 'validUntil' | 'isDismissible' | 'isMinimizable' | 'koOrganizationId' | 'targetUrl' | 'targetUrlLabel'> };

export type UpdateAnnouncementMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateAnnouncementInput;
}>;


export type UpdateAnnouncementMutation = { updateAnnouncement: Pick<Announcement, 'id' | 'title' | 'message' | 'type' | 'priority' | 'isActive' | 'validFrom' | 'validUntil' | 'isDismissible' | 'isMinimizable' | 'koOrganizationId' | 'targetUrl' | 'targetUrlLabel'> };

export type DeleteAnnouncementMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAnnouncementMutation = Pick<Mutation, 'deleteAnnouncement'>;

export type GetBundesbankBlzImportInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBundesbankBlzImportInfoQuery = { bundesbankBlzImportInfo: Pick<BundesbankImportInfo, 'count' | 'lastImport'> };

export type UploadBundesbankBlzMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadBundesbankBlzMutation = { uploadBundesbankBlz: Pick<BundesbankImportResult, 'success' | 'count' | 'importedAt' | 'message'> };

export type GetCustomBankDataQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCustomBankDataQuery = { customBankData?: Maybe<Pick<CustomBankData, 'id' | 'bankCode' | 'countryCode' | 'name' | 'zip' | 'city' | 'bic' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId'>> };

export type GetCustomBankDataListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomBankDataListQuery = { customBankDataList: Array<Pick<CustomBankData, 'id' | 'bankCode' | 'countryCode' | 'name' | 'zip' | 'city' | 'bic' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId'>> };

export type CreateCustomBankDataMutationVariables = Exact<{
  newCustomBankDataInput: NewCustomBankDataInput;
}>;


export type CreateCustomBankDataMutation = { createCustomBankData: Pick<CustomBankData, 'id' | 'bankCode' | 'countryCode' | 'name' | 'zip' | 'city' | 'bic' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId'> };

export type UpdateCustomBankDataMutationVariables = Exact<{
  updateCustomBankDataInput: UpdateCustomBankDataInput;
}>;


export type UpdateCustomBankDataMutation = { updateCustomBankData: Pick<CustomBankData, 'id' | 'bankCode' | 'countryCode' | 'name' | 'zip' | 'city' | 'bic' | 'createDate' | 'updateDate' | 'createdByUserId' | 'updatedByUserId'> };

export type DeleteCustomBankDataMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCustomBankDataMutation = Pick<Mutation, 'deleteCustomBankData'>;

export type IsCustomBankCodeUniqueQueryVariables = Exact<{
  bankCode: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
}>;


export type IsCustomBankCodeUniqueQuery = Pick<Query, 'isCustomBankCodeUnique'>;

export type ListDataExportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDataExportsQuery = { listDataExports: Array<Pick<DataExport, 'id' | 'createdAt' | 'totalSize' | 'status' | 'errorMessage' | 'createdBy' | 'recordCount' | 'progress'>> };

export type CreateDataExportMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateDataExportMutation = { createDataExport: Pick<DataExport, 'id' | 'createdAt' | 'status'> };

export type DeleteDataExportMutationVariables = Exact<{
  exportId: Scalars['ID'];
}>;


export type DeleteDataExportMutation = Pick<Mutation, 'deleteDataExport'>;

export type GetDataExportDownloadUrlQueryVariables = Exact<{
  exportId: Scalars['ID'];
}>;


export type GetDataExportDownloadUrlQuery = Pick<Query, 'getDataExportDownloadUrl'>;

export type ListDatabaseBackupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDatabaseBackupsQuery = { listDatabaseBackups: Array<Pick<DatabaseBackup, 'id' | 'createdAt' | 'koOrganizationId' | 'koDbPlainKey' | 'koDbCustomKey' | 'fusionDbPlainKey' | 'fusionDbCustomKey' | 'totalSize' | 'status' | 'errorMessage' | 'createdBy' | 'fusionAuthIncluded'>> };

export type CreateDatabaseBackupMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateDatabaseBackupMutation = { createDatabaseBackup: Pick<DatabaseBackup, 'id' | 'createdAt' | 'status'> };

export type RestoreDatabaseBackupMutationVariables = Exact<{
  input: RestoreBackupInput;
}>;


export type RestoreDatabaseBackupMutation = { restoreDatabaseBackup: Pick<DatabaseBackup, 'id' | 'status'> };

export type DeleteDatabaseBackupMutationVariables = Exact<{
  backupId: Scalars['ID'];
}>;


export type DeleteDatabaseBackupMutation = Pick<Mutation, 'deleteDatabaseBackup'>;

export type GetDatabaseBackupDownloadUrlQueryVariables = Exact<{
  input: DownloadBackupInput;
}>;


export type GetDatabaseBackupDownloadUrlQuery = Pick<Query, 'getDatabaseBackupDownloadUrl'>;

export type ListInvoiceExportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInvoiceExportsQuery = { listInvoiceExports: Array<Pick<InvoiceExport, 'id' | 'createdAt' | 'status' | 'totalSize' | 'recordCount' | 'progress' | 'errorMessage' | 'year' | 'month' | 'includeReversals' | 'courseLabel' | 's3Key'>> };

export type GetInvoiceExportCoursesQueryVariables = Exact<{
  year: Scalars['Int'];
  month?: Maybe<Scalars['Int']>;
  includeReversals: Scalars['Boolean'];
}>;


export type GetInvoiceExportCoursesQuery = { invoiceExportCourses: Array<(
    Pick<Course, 'id' | 'prefixedCourseNumber'>
    & { courseType: Pick<CourseType, 'id' | 'name'> }
  )> };

export type CreateInvoiceExportMutationVariables = Exact<{
  year?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  includeReversals: Scalars['Boolean'];
  courseId?: Maybe<Scalars['ID']>;
}>;


export type CreateInvoiceExportMutation = { createInvoiceExport: Pick<InvoiceExport, 'id' | 'createdAt' | 'status' | 'year' | 'month' | 'includeReversals' | 'courseLabel'> };

export type DeleteInvoiceExportMutationVariables = Exact<{
  exportId: Scalars['ID'];
}>;


export type DeleteInvoiceExportMutation = Pick<Mutation, 'deleteInvoiceExport'>;

export type GetInvoiceExportDownloadUrlQueryVariables = Exact<{
  exportId: Scalars['ID'];
}>;


export type GetInvoiceExportDownloadUrlQuery = Pick<Query, 'getInvoiceExportDownloadUrl'>;

export type GetMissingBankDataListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMissingBankDataListQuery = { missingBankDataList: Array<Pick<MissingBankData, 'id' | 'bankCode' | 'iban' | 'hitCount' | 'firstSeen' | 'lastSeen' | 'createDate' | 'updateDate'>> };

export type DeleteMissingBankDataMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMissingBankDataMutation = Pick<Mutation, 'deleteMissingBankData'>;

export type DeleteAllMissingBankDataMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllMissingBankDataMutation = Pick<Mutation, 'deleteAllMissingBankData'>;

export type RestoreOrphanBookingMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  koOrganizationId: Scalars['String'];
}>;


export type RestoreOrphanBookingMutation = { restoreOrphanBooking: Pick<Booking, 'id' | 'bookingNumber' | 'bookingNumberPrefix'> };

export type GetPerformanceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPerformanceStatsQuery = { getPerformanceStats: { slowQueries: Array<Pick<SlowQueryOutput, 'query' | 'calls' | 'totalTimeMs' | 'avgTimeMs' | 'maxTimeMs' | 'percentTotal'>>, tableStats: Array<Pick<TableStatsOutput, 'schemaname' | 'tablename' | 'size' | 'inserts' | 'updates' | 'deletes' | 'seqScan' | 'idxScan' | 'indexUsagePercent'>>, missingIndexCandidates: Array<Pick<MissingIndexCandidateOutput, 'schemaname' | 'tablename' | 'seqScan' | 'seqTupRead' | 'idxScan' | 'avgRowsPerScan'>>, cacheStats: Pick<CacheStatsOutput, 'sharedBuffersSize' | 'cacheHitRatio' | 'totalReads' | 'diskReads'> } };

export type ResetPerformanceStatsMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetPerformanceStatsMutation = Pick<Mutation, 'resetPerformanceStats'>;

export type GetExportedSepaXmlsWithOrgQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetExportedSepaXmlsWithOrgQuery = { exportedSepaXmls: (
    Pick<ExportedSepaXmlWithPagination, 'existsMore' | 'total'>
    & { items: Array<Pick<ExportedSepaXml, 'id' | 'createDate' | 'fileName' | 'koOrganizationId'>> }
  ) };

export type FindUnpaidScheduledPaymentsInSepaExportsQueryVariables = Exact<{
  input: FindUnpaidInSepaInput;
}>;


export type FindUnpaidScheduledPaymentsInSepaExportsQuery = { findUnpaidScheduledPaymentsInSepaExports: (
    Pick<UnpaidScheduledPaymentMatchResult, 'totalSepaExportsSearched' | 'totalMatchesFound'>
    & { matches: Array<Pick<UnpaidScheduledPaymentMatch, 'scheduledPaymentId' | 'bookingId' | 'bookingNumber' | 'bookingNumberPrefix' | 'invoiceNumber' | 'invoiceNumberPrefix' | 'paymentAmount' | 'paymentDue' | 'attendeeName' | 'courseNumber' | 'allowLessonBooking' | 'sepaExportId' | 'sepaExportFileName' | 'sepaExportDate' | 'mandateId' | 'confidence' | 'koOrganizationId'>> }
  ) };

export type MarkScheduledPaymentsAsPaidFromSepaExportMutationVariables = Exact<{
  input: MarkPaidFromSepaInput;
}>;


export type MarkScheduledPaymentsAsPaidFromSepaExportMutation = Pick<Mutation, 'markScheduledPaymentsAsPaidFromSepaExport'>;

export type ResolveTenantRecipientsQueryVariables = Exact<{
  tenantIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ResolveTenantRecipientsQuery = { resolveTenantRecipients: Array<Pick<TenantRecipientType, 'tenantId' | 'tenantName' | 'ownerEmail' | 'isDefaultRecipient'>> };

export type BroadcastTenantNotificationMutationVariables = Exact<{
  input: BroadcastTenantNotificationInput;
}>;


export type BroadcastTenantNotificationMutation = { broadcastTenantNotification: (
    Pick<BroadcastTenantNotificationResult, 'successCount' | 'failureCount' | 'skippedCount'>
    & { results: Array<Pick<TenantNotificationResultType, 'tenantId' | 'tenantName' | 'email' | 'status' | 'errorMessage'>> }
  ) };

export type TenantNotificationsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type TenantNotificationsQuery = { tenantNotifications: Array<Pick<TenantNotification, 'id' | 'koOrganizationId' | 'tenantName' | 'recipientEmail' | 'subject' | 'status' | 'errorMessage' | 'senderId' | 'broadcastId' | 'sendDate' | 'createDate'>> };

export type AddCourseIdAndStartDateTimeMutationVariables = Exact<{ [key: string]: never; }>;


export type AddCourseIdAndStartDateTimeMutation = { addCourseIdAndStartDateTime: Pick<SetupScriptResult, 'success' | 'updatedCount' | 'message'> };

export type GetMaintenanceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceStatusQuery = { maintenanceStatus: Pick<MaintenanceStatus, 'enabled' | 'message' | 'untilIso' | 'updatedAtIso'> };

export type EnableMaintenanceMutationVariables = Exact<{
  input?: Maybe<MaintenanceEnableInput>;
}>;


export type EnableMaintenanceMutation = { enableMaintenance: Pick<MaintenanceStatus, 'enabled' | 'message' | 'untilIso' | 'updatedAtIso'> };

export type DisableMaintenanceMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableMaintenanceMutation = { disableMaintenance: Pick<MaintenanceStatus, 'enabled' | 'message' | 'untilIso' | 'updatedAtIso'> };

export type DeleteFusionAuthUsersByEmailsMutationVariables = Exact<{
  emailAddresses: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteFusionAuthUsersByEmailsMutation = Pick<Mutation, 'deleteFusionAuthUsersByEmails'>;

export type SuperuserDocsIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserDocsIndexQuery = Pick<Query, 'superuserDocsIndex'>;

export type SuperuserDocQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type SuperuserDocQuery = Pick<Query, 'superuserDocs'>;

export type SettingEndUserAppQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingEndUserAppQuery = { settingEndUserApp: Pick<SettingEndUserApp, 'colors' | 'courseTable' | 'courseDetails' | 'filters' | 'textEntries' | 'optionalInputFields' | 'i18n' | 'hideAfterDays' | 'passwordlessLoginEnabled' | 'withdrawalButtonEnabled' | 'creditRedemptionEnabled' | 'showTotalPriceInCheckout' | 'showInterestListsByDefault' | 'passwordlessIdCodeLength' | 'courseSearchDisplayMode' | 'courseSearchPageSize' | 'courseSearchGridMaxColumns' | 'courseSearchGridGap'> };

export type SettingEndUserAppPublicQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingEndUserAppPublicQuery = { settingEndUserAppPublic: Pick<SettingEndUserApp, 'hideAfterDays' | 'withdrawalButtonEnabled' | 'creditRedemptionEnabled' | 'showTotalPriceInCheckout' | 'showInterestListsByDefault'> };

export type SettingEndUserAppHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingEndUserAppHistoryQuery = { settingEndUserAppHistory: Array<Pick<SettingEndUserAppHistory, 'id' | 'createDate' | 'userId' | 'userName' | 'oldValues' | 'newValues'>> };

export type LateEntryPricingConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type LateEntryPricingConfigurationQuery = { lateEntryPricingConfiguration: Pick<SettingEndUserApp, 'id' | 'lateEntryPricingPolicy' | 'minimumPartialBookingLessonCount' | 'updateDate'> };

export type UpdateLateEntryPricingConfigurationMutationVariables = Exact<{
  input: UpdateLateEntryPricingConfigurationInput;
}>;


export type UpdateLateEntryPricingConfigurationMutation = { updateLateEntryPricingConfiguration: Pick<SettingEndUserApp, 'id' | 'lateEntryPricingPolicy' | 'minimumPartialBookingLessonCount' | 'updateDate'> };

export type UpdateSettingEndUserAppMutationVariables = Exact<{
  updateSettingEndUserAppInput: UpdateSettingEndUserAppInput;
}>;


export type UpdateSettingEndUserAppMutation = { updateSettingEndUserApp: Pick<SettingEndUserApp, 'id' | 'colors' | 'courseTable' | 'courseDetails' | 'filters' | 'textEntries' | 'optionalInputFields' | 'i18n' | 'hideAfterDays' | 'passwordlessLoginEnabled' | 'withdrawalButtonEnabled' | 'creditRedemptionEnabled' | 'showTotalPriceInCheckout' | 'showInterestListsByDefault' | 'passwordlessIdCodeLength' | 'courseSearchDisplayMode' | 'courseSearchPageSize' | 'courseSearchGridMaxColumns' | 'courseSearchGridGap'> };

export type CreateSettingEndUserAppWithDefaultValuesMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSettingEndUserAppWithDefaultValuesMutation = { createSettingEndUserAppWithDefaultValues: Pick<SettingEndUserApp, 'id' | 'colors' | 'courseTable' | 'courseDetails' | 'filters' | 'textEntries' | 'optionalInputFields' | 'i18n' | 'hideAfterDays' | 'passwordlessLoginEnabled' | 'withdrawalButtonEnabled' | 'creditRedemptionEnabled' | 'showTotalPriceInCheckout' | 'showInterestListsByDefault' | 'passwordlessIdCodeLength' | 'courseSearchDisplayMode' | 'courseSearchPageSize' | 'courseSearchGridMaxColumns' | 'courseSearchGridGap'> };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadFileMutation = Pick<Mutation, 'uploadCompanyLogo'>;

export type DeleteCompanyLogoMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCompanyLogoMutation = { deleteCompanyLogo: Pick<CompanySetting, 'id' | 'logo'> };

export type MollieConnectionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MollieConnectionStatusQuery = { mollieConnectionStatus: Pick<MollieConnectionStatus, 'isConnected' | 'canReceivePayments' | 'canReceiveSettlements' | 'connectedAt' | 'mollieOrganizationId' | 'mollieProfileId' | 'capabilitiesHint' | 'isTestMode' | 'needsReconnect' | 'onboardingStatus' | 'dashboardUrl'> };

export type MollieAvailableMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type MollieAvailableMethodsQuery = { mollieAvailableMethods: Array<Pick<MollieMethodInfo, 'id' | 'description' | 'imageUrl' | 'isEnabled' | 'isAvailableInProfile' | 'profileStatus'>> };

export type MolliePaymentStatusQueryVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
}>;


export type MolliePaymentStatusQuery = { molliePaymentStatus?: Maybe<Pick<MolliePaymentStatus, 'molliePaymentId' | 'status' | 'paidAt' | 'amount'>> };

export type MollieGetConnectUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type MollieGetConnectUrlMutation = Pick<Mutation, 'mollieGetConnectUrl'>;

export type MollieDisconnectMutationVariables = Exact<{ [key: string]: never; }>;


export type MollieDisconnectMutation = Pick<Mutation, 'mollieDisconnect'>;

export type MollieCreateClientLinkMutationVariables = Exact<{
  input: MollieCreateClientLinkInput;
  returnTo?: Maybe<Scalars['String']>;
}>;


export type MollieCreateClientLinkMutation = { mollieCreateClientLink: Pick<MollieCreateClientLinkResult, 'clientLinkUrl' | 'clientLinkId'> };

export type CreateMolliePaymentMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
  method: Scalars['String'];
}>;


export type CreateMolliePaymentMutation = { createMolliePayment?: Maybe<Pick<MolliePaymentResult, 'molliePaymentId' | 'checkoutUrl' | 'status'>> };

export type RetryMolliePaymentMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID'];
}>;


export type RetryMolliePaymentMutation = { retryMolliePayment?: Maybe<Pick<MolliePaymentResult, 'molliePaymentId' | 'checkoutUrl' | 'status'>> };

export type UpdateMollieEnabledMethodsMutationVariables = Exact<{
  methodIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateMollieEnabledMethodsMutation = { updateMollieEnabledMethods: Array<Pick<MollieMethodInfo, 'id' | 'description' | 'imageUrl' | 'isEnabled' | 'isAvailableInProfile' | 'profileStatus'>> };

export type MollieAllMethodsForWhitelistQueryVariables = Exact<{ [key: string]: never; }>;


export type MollieAllMethodsForWhitelistQuery = { mollieAllMethodsForWhitelist: Array<Pick<MollieMethodInfo, 'id' | 'description' | 'imageUrl' | 'isEnabled' | 'isAvailableInProfile' | 'profileStatus'>> };

export type UpdateAllowedMollieMethodsMutationVariables = Exact<{
  methods: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateAllowedMollieMethodsMutation = { updateAllowedMollieMethods: Pick<PlatformConfig, 'id' | 'allowedMollieMethods'> };

export type MollieDowngradeImpactQueryVariables = Exact<{
  koOrganizationId: Scalars['ID'];
}>;


export type MollieDowngradeImpactQuery = { mollieDowngradeImpact: Pick<MollieDowngradeImpact, 'openMolliePayments' | 'activePaymentLinks' | 'affectedBookers'> };

export type GetAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppSettingsQuery = { settings: Pick<Setting, 'id' | 'courseNumberFormat' | 'customerNumberPrefix' | 'invoiceNumberPrefix' | 'currency' | 'grossNet' | 'defaultVat' | 'cash' | 'bankTransfer' | 'sepaDebit' | 'esr' | 'restrictStaffPaymentMethods' | 'newCustomerDetectionEnabled' | 'featureMollie' | 'invoiceDueDays' | 'firstInstallmentDayOfMonth' | 'firstInstallmentMonth' | 'vatAppearance' | 'holidayStateCode' | 'holidayStateColor' | 'holidayCountryCode' | 'sevenIoApiKey' | 'smsSenderName' | 'sendReversalInvoice' | 'sepaDebitProvider' | 'bankTransferProvider' | 'enabledMollieMethods' | 'timezone' | 'mollieInvoiceSendMode' | 'mollieRefundMode' | 'sendPaymentLinkOnAdminBooking' | 'autoSendMollieReminderMails' | 'autoIssuePaymentLinkOnExpiry' | 'paymentLinkValidityDays' | 'dunningReminderEnabled' | 'dunningReminderDays' | 'dunningLevel1Enabled' | 'dunningLevel1Days' | 'dunningLevel1Fee' | 'dunningLevel2Enabled' | 'dunningLevel2Days' | 'dunningLevel2Fee' | 'dunningLevel3Enabled' | 'dunningLevel3Days' | 'dunningLevel3Fee' | 'dunningNewDueDays' | 'dunningAttachInvoice' | 'cancelationFeeDefault' | 'courseEditCorrectionInvoice' | 'courseEditCorrectionInvoiceMail' | 'transferMode' | 'transferDefaultPriceOption' | 'transferDefaultOldBookingOption' | 'transferSendMail'> };

export type GetAppSettingsInvoiceDueDaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppSettingsInvoiceDueDaysQuery = { settings: Pick<Setting, 'id' | 'invoiceDueDays'> };

export type GetCourseNumberFormatQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseNumberFormatQuery = { settings: Pick<Setting, 'courseNumberFormat'> };

export type UpdateSettingsMutationVariables = Exact<{
  newSettingsData: SettingInput;
}>;


export type UpdateSettingsMutation = { updateSettings: Pick<Setting, 'id' | 'courseNumberFormat' | 'customerNumberPrefix' | 'invoiceNumberPrefix' | 'currency' | 'grossNet' | 'defaultVat' | 'cash' | 'bankTransfer' | 'sepaDebit' | 'esr' | 'restrictStaffPaymentMethods' | 'newCustomerDetectionEnabled' | 'invoiceDueDays' | 'holidayStateCode' | 'holidayStateColor' | 'holidayCountryCode' | 'sendReversalInvoice' | 'sepaDebitProvider' | 'bankTransferProvider' | 'enabledMollieMethods' | 'timezone' | 'mollieInvoiceSendMode' | 'mollieRefundMode' | 'sendPaymentLinkOnAdminBooking' | 'autoSendMollieReminderMails' | 'autoIssuePaymentLinkOnExpiry' | 'paymentLinkValidityDays' | 'dunningReminderEnabled' | 'dunningReminderDays' | 'dunningLevel1Enabled' | 'dunningLevel1Days' | 'dunningLevel1Fee' | 'dunningLevel2Enabled' | 'dunningLevel2Days' | 'dunningLevel2Fee' | 'dunningLevel3Enabled' | 'dunningLevel3Days' | 'dunningLevel3Fee' | 'dunningNewDueDays' | 'dunningAttachInvoice' | 'cancelationFeeDefault' | 'courseEditCorrectionInvoice' | 'courseEditCorrectionInvoiceMail' | 'transferMode' | 'transferDefaultPriceOption' | 'transferDefaultOldBookingOption' | 'transferSendMail'> };

export type GetCompanySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanySettingsQuery = { companySettings: (
    Pick<CompanySetting, 'id' | 'name' | 'businessForm' | 'website' | 'agb' | 'privacyStatement' | 'ownerFirstName' | 'ownerLastName' | 'ownerStreet' | 'ownerStreetNumber' | 'ownerZip' | 'ownerCity' | 'ownerCountry' | 'ownerPhone' | 'ownerFax' | 'ownerEmail' | 'industry' | 'localCourt' | 'commercialRegister' | 'taxId' | 'taxNumber' | 'bank' | 'bankAccountHolder' | 'IBAN' | 'BIC' | 'creditorId' | 'qrIban' | 'logo'>
    & { koOrganization: Pick<KoOrganization, 'id'> }
  ) };

export type UpdateCompanySettingsMutationVariables = Exact<{
  editCompanyData: CompanySettingInput;
}>;


export type UpdateCompanySettingsMutation = { updateCompanySettings: Pick<CompanySetting, 'id' | 'name' | 'businessForm' | 'website' | 'agb' | 'privacyStatement' | 'ownerFirstName' | 'ownerLastName' | 'ownerStreet' | 'ownerStreetNumber' | 'ownerZip' | 'ownerCity' | 'ownerCountry' | 'ownerPhone' | 'ownerFax' | 'ownerEmail' | 'industry' | 'localCourt' | 'commercialRegister' | 'taxId' | 'taxNumber' | 'bank' | 'bankAccountHolder' | 'IBAN' | 'BIC' | 'creditorId' | 'qrIban'> };

export type CreateTenantMutationVariables = Exact<{
  koOrganizationData: KoOrganizationInputType;
}>;


export type CreateTenantMutation = { createOrganization: Pick<CreateOrganizationResult, 'organizationId' | 'host' | 'sendFromEmail' | 'createdAdmins' | 'adminErrors'> };

export type CreateAndRegisterAdminUserMutationVariables = Exact<{
  userInput: UserInput;
  tenantId: Scalars['String'];
}>;


export type CreateAndRegisterAdminUserMutation = { createAndRegisterAdmin: Pick<UserType, 'id'> };

export type GetTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantsQuery = { koOrganizations: Array<(
    Pick<KoOrganization, 'id' | 'name' | 'subscriptionType'>
    & { subscription?: Maybe<Pick<Subscription, 'id' | 'featureSms' | 'featureStaffLogin' | 'featureRefactoredCourseDetails' | 'featureWeekPlaner' | 'featurePrerequisiteCourses' | 'featureExportInstructorLessons' | 'featureExport' | 'featureLessonBooking' | 'featureBillingStatus' | 'featureAttendanceListBulk' | 'featureCalendarFeed' | 'featureAssistantApp' | 'featureDataExport' | 'featureWebModulAdminAccess' | 'featureAreaManager' | 'featureMailMerge' | 'featureExtendedBadges' | 'featureInterestList' | 'featureHelpLinks' | 'featureAdditionalItems' | 'featureAdminManagement' | 'featureMollie' | 'featureTransferWizard' | 'featureDataErasure' | 'featureBankImport' | 'featureDiscountCodes' | 'featureNewsletter' | 'featureLiveRefresh' | 'featureDunning' | 'featureInvoicePdfPuppeteer' | 'mollieApplicationFeePercent' | 'mollieApplicationFeeFixed' | 'holidays' | 'seatsAdmin' | 'seatsInstructor' | 'maxBookingsPerYear' | 'maxLocations' | 'monthlyFee'>> }
  )> };

export type GetTenantsWithPaginationQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  koOrganizationId?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type GetTenantsWithPaginationQuery = { tenantsWithPagination: (
    Pick<KoOrganizationWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<KoOrganization, 'id' | 'name' | 'subscriptionType' | 'deletionState' | 'deactivatedAt' | 'scheduledDeletionAt'>
      & { companySettings: Pick<CompanySetting, 'host'>, subscription?: Maybe<Pick<Subscription, 'id' | 'featureSms' | 'featureStaffLogin' | 'featureRefactoredCourseDetails' | 'featureWeekPlaner' | 'featurePrerequisiteCourses' | 'featureExportInstructorLessons' | 'featureExport' | 'featureLessonBooking' | 'featureBillingStatus' | 'featureAttendanceListBulk' | 'featureCalendarFeed' | 'featureAssistantApp' | 'featureDataExport' | 'featureWebModulAdminAccess' | 'featureAreaManager' | 'featureMailMerge' | 'featureExtendedBadges' | 'featureInterestList' | 'featureHelpLinks' | 'featureAdditionalItems' | 'featureAdminManagement' | 'featureMollie' | 'featureTransferWizard' | 'featureDataErasure' | 'featureBankImport' | 'featureDiscountCodes' | 'featureNewsletter' | 'featureLiveRefresh' | 'featureDunning' | 'featureInvoicePdfPuppeteer' | 'mollieApplicationFeePercent' | 'mollieApplicationFeeFixed' | 'holidays' | 'seatsAdmin' | 'seatsInstructor' | 'maxBookingsPerYear' | 'maxLocations' | 'monthlyFee'>> }
    )> }
  ) };

export type GetCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyQuery = { companySettings: Pick<CompanySetting, 'id' | 'name'> };

export type GetCompanyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyInfoQuery = { companyInfo: (
    Pick<KoOrganization, 'id' | 'name' | 'subscriptionType'>
    & { subscription?: Maybe<Pick<Subscription, 'seatsAdmin' | 'seatsInstructor' | 'featureSms' | 'featureRefactoredCourseDetails' | 'featureStaffLogin' | 'featureWeekPlaner' | 'featurePrerequisiteCourses' | 'featureExportInstructorLessons' | 'featureBillingStatus' | 'featureAttendanceListBulk' | 'featureCalendarFeed' | 'featureExport' | 'featureLessonBooking' | 'featureAssistantApp' | 'featureDataExport' | 'featureWebModulAdminAccess' | 'featureAreaManager' | 'featureMailMerge' | 'featureExtendedBadges' | 'featureInterestList' | 'featureHelpLinks' | 'featureAdditionalItems' | 'featureAdminManagement' | 'featureMollie' | 'featureTransferWizard' | 'featureDataErasure' | 'featureBankImport' | 'featureDiscountCodes' | 'featureNewsletter' | 'featureLiveRefresh' | 'featureDunning' | 'featureInvoicePdfPuppeteer' | 'holidays' | 'mollieApplicationFeePercent' | 'mollieApplicationFeeFixed' | 'monthlyFee'>>, companySettings: Pick<CompanySetting, 'logo'> }
  ) };

export type GetOwnerEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnerEmailQuery = { ownerEmail: Pick<CompanySetting, 'id' | 'ownerEmail'> };

export type GetCompanyPublicQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyPublicQuery = { companyPublic: Pick<CompanySetting, 'name' | 'host' | 'website' | 'agb' | 'privacyStatement'> };

export type GetCurrencySettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencySettingQuery = { settings: Pick<Setting, 'currency'> };

export type UpdateCompanyAgbMutationVariables = Exact<{
  agb: Scalars['String'];
}>;


export type UpdateCompanyAgbMutation = { updateCompanyAgb: Pick<CompanySetting, 'agb'> };

export type UpdateCompanyPrivacyStatementMutationVariables = Exact<{
  privacyStatement: Scalars['String'];
}>;


export type UpdateCompanyPrivacyStatementMutation = { updateCompanyPrivacyStatement: Pick<CompanySetting, 'privacyStatement'> };

export type UpdateSubscriptionFeaturesMutationVariables = Exact<{
  subscriptionId: Scalars['ID'];
  features: SubscriptionFeaturesInput;
}>;


export type UpdateSubscriptionFeaturesMutation = { updateSubscriptionFeatures: Pick<Subscription, 'id' | 'featureSms' | 'featureStaffLogin' | 'featureRefactoredCourseDetails' | 'featureWeekPlaner' | 'featurePrerequisiteCourses' | 'featureExportInstructorLessons' | 'featureExport' | 'featureBillingStatus' | 'featureAttendanceListBulk' | 'featureCalendarFeed' | 'featureAssistantApp' | 'featureDataExport' | 'featureWebModulAdminAccess' | 'featureAreaManager' | 'featureMailMerge' | 'featureExtendedBadges' | 'featureInterestList' | 'featureHelpLinks' | 'featureAdditionalItems' | 'featureAdminManagement' | 'featureMollie' | 'featureTransferWizard' | 'featureDataErasure' | 'featureBankImport' | 'featureDiscountCodes' | 'featureNewsletter' | 'featureLiveRefresh' | 'featureDunning' | 'featureInvoicePdfPuppeteer' | 'mollieApplicationFeePercent' | 'mollieApplicationFeeFixed' | 'holidays' | 'seatsAdmin' | 'seatsInstructor' | 'maxBookingsPerYear' | 'maxLocations' | 'monthlyFee'> };

export type GetTenantUsersQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type GetTenantUsersQuery = { getTenantUsers: Array<Pick<UserType, 'id' | 'firstName' | 'lastName' | 'email' | 'roles'>> };

export type UpdateOrganizationSubscriptionTypeMutationVariables = Exact<{
  koOrganizationId: Scalars['ID'];
  subscriptionType: SubscriptionType;
}>;


export type UpdateOrganizationSubscriptionTypeMutation = { updateOrganizationSubscriptionType: Pick<KoOrganization, 'id' | 'subscriptionType'> };

export type GetTenantActivitySummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantActivitySummariesQuery = { tenantActivitySummaries: Array<Pick<TenantActivitySummary, 'koOrganizationId' | 'tenantName' | 'totalCourses' | 'activeCourses' | 'totalBookings' | 'totalAttendees' | 'totalInvoices' | 'lastLoginDate' | 'lastDataModification' | 'lastBookingCreated' | 'lastInvoiceCreated' | 'lastCourseCreated' | 'activityStatus' | 'daysSinceLastActivity'>> };

export type GetTenantActivitySummaryQueryVariables = Exact<{
  koOrganizationId: Scalars['ID'];
}>;


export type GetTenantActivitySummaryQuery = { tenantActivitySummary: Pick<TenantActivitySummary, 'koOrganizationId' | 'tenantName' | 'totalCourses' | 'activeCourses' | 'totalBookings' | 'totalAttendees' | 'totalInvoices' | 'lastLoginDate' | 'lastDataModification' | 'lastBookingCreated' | 'lastInvoiceCreated' | 'lastCourseCreated' | 'activityStatus' | 'daysSinceLastActivity'> };

export type GetTenantDeletionImpactQueryVariables = Exact<{
  koOrganizationId: Scalars['ID'];
}>;


export type GetTenantDeletionImpactQuery = { tenantDeletionImpact: (
    Pick<TenantDeletionImpact, 'koOrganizationId' | 'tenantName' | 'totalDatabaseRecords'>
    & { entityCounts: Array<Pick<EntityCount, 'name' | 'count'>> }
  ) };

export type DeactivateTenantMutationVariables = Exact<{
  koOrganizationId: Scalars['ID'];
}>;


export type DeactivateTenantMutation = { deactivateTenant: Pick<KoOrganization, 'id' | 'name' | 'isActive' | 'deletionState' | 'deactivatedAt' | 'scheduledDeletionAt'> };

export type ReactivateTenantMutationVariables = Exact<{
  koOrganizationId: Scalars['ID'];
}>;


export type ReactivateTenantMutation = { reactivateTenant: Pick<KoOrganization, 'id' | 'name' | 'isActive' | 'deletionState'> };

export type HardDeleteTenantMutationVariables = Exact<{
  koOrganizationId: Scalars['ID'];
  confirmationCode: Scalars['String'];
}>;


export type HardDeleteTenantMutation = { hardDeleteTenant: (
    Pick<TenantDeletionResult, 'success' | 'tenantName' | 'errors' | 'startedAsync'>
    & { deletedRecordCounts: Array<Pick<EntityCount, 'name' | 'count'>> }
  ) };

export type GetTenantDeletionStatusQueryVariables = Exact<{
  koOrganizationId: Scalars['ID'];
}>;


export type GetTenantDeletionStatusQuery = { tenantDeletionStatus: (
    Pick<TenantDeletionStatus, 'deletionState' | 'lastAction' | 'lastStepName' | 'lastErrorMessage' | 'externalErrors'>
    & { deletedRecordCounts?: Maybe<Array<Pick<EntityCount, 'name' | 'count'>>> }
  ) };

export type GetTenantMetricsQueryVariables = Exact<{
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type GetTenantMetricsQuery = { tenantMetrics: Array<Pick<TenantMetrics, 'koOrganizationId' | 'tenantName' | 'subscriptionType' | 'monthlyFee' | 'courses' | 'bookings' | 'bookingsOnline' | 'bookingsAdmin' | 'waitlist' | 'cancellations' | 'emailsSent' | 'revenuePaid' | 'bookingVolume' | 'bookersTotal' | 'bookersTotalOnline' | 'newBookers' | 'newBookersOnline' | 'seatsAdmin' | 'seatsInstructor' | 'maxBookingsPerYear' | 'maxLocations' | 'bookingsCurrentYear' | 'locationsCount'>> };

export type GetTenantSeatUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantSeatUsageQuery = { tenantSeatUsage: Array<Pick<TenantSeatUsage, 'koOrganizationId' | 'adminCount' | 'instructorCount'>> };

export type GetTenantStaffMetricsQueryVariables = Exact<{
  koOrganizationId: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type GetTenantStaffMetricsQuery = { tenantStaffMetrics: Array<Pick<TenantStaffMember, 'userId' | 'email' | 'firstName' | 'lastName' | 'roles' | 'lastLogin' | 'activeDays' | 'actionCount'>> };

export type GetTenantMetricsAiSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantMetricsAiSummaryQuery = { tenantMetricsAiSummary: (
    Pick<TenantMetricsAiSummary, 'status' | 'message' | 'headline' | 'generatedAt' | 'dataThrough' | 'isAiGenerated' | 'caveats'>
    & { insights: Array<(
      Pick<TenantMetricsAiInsight, 'observationRef' | 'category' | 'severity' | 'title' | 'explanation' | 'tenantName'>
      & { evidence: Array<Pick<TenantMetricsAiEvidence, 'factRef' | 'scope' | 'tenantId' | 'tenantName' | 'metric' | 'windowDays' | 'currentValue' | 'previousValue' | 'changePercent' | 'direction' | 'unit' | 'currency'>> }
    )> }
  ) };

export type RetryTenantMetricsAiSummaryMutationVariables = Exact<{ [key: string]: never; }>;


export type RetryTenantMetricsAiSummaryMutation = { retryTenantMetricsAiSummary: Pick<TenantMetricsAiSummary, 'status' | 'message'> };

export type GetStaffVisibilityRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffVisibilityRulesQuery = { staffVisibilityRules: (
    Pick<StaffVisibilityRules, 'version'>
    & { courses: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, customers: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, invoices: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, staff: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, locations: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, courseTypes: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, interestLists: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, bookingActions: Pick<StaffVisibilityRow, 'instructor' | 'assistant'> }
  ) };

export type UpdateStaffVisibilityRulesMutationVariables = Exact<{
  input: StaffVisibilityRulesInput;
}>;


export type UpdateStaffVisibilityRulesMutation = { updateStaffVisibilityRules: (
    Pick<StaffVisibilityRules, 'version'>
    & { courses: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, customers: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, invoices: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, staff: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, locations: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, courseTypes: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, interestLists: Pick<StaffVisibilityRow, 'instructor' | 'assistant'>, bookingActions: Pick<StaffVisibilityRow, 'instructor' | 'assistant'> }
  ) };

export type GetStaffVisibilityRulesHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffVisibilityRulesHistoryQuery = { staffVisibilityRulesHistory: Array<Pick<StaffVisibilityRulesHistoryEntry, 'id' | 'createDate' | 'userId' | 'userName' | 'oldValues' | 'newValues'>> };

export type SaveAdminMutationVariables = Exact<{
  adminInput: SaveAdminInput;
}>;


export type SaveAdminMutation = { saveAdmin: Pick<Admin, 'id'> };

export type CheckSmsApiKeyQueryVariables = Exact<{
  apiKey: Scalars['String'];
}>;


export type CheckSmsApiKeyQuery = { checkSmsApiKey: Pick<SmsBalanceResponse, 'balance'> };

export type GetSmsAccountBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmsAccountBalanceQuery = { getSmsAccountBalance: Pick<SmsBalanceResponse, 'balance'> };

export type GetSmsReceiversQueryVariables = Exact<{
  mailDataType: MailDataType;
  selectedIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetSmsReceiversQuery = { getSmsReceivers: Array<Pick<SmsReceiver, 'bookerId' | 'fullName' | 'mobileNumber' | 'valid' | 'prefixedBookingNumber'>> };

export type GetSmsReceiversCourseQueryVariables = Exact<{
  getReceiversForCourseInput: GetReceiversForCourseInput;
}>;


export type GetSmsReceiversCourseQuery = { getSmsReceiversCourse: Array<Pick<SmsReceiver, 'bookerId' | 'fullName' | 'mobileNumber' | 'valid' | 'prefixedBookingNumber'>> };

export type SendSmsMutationVariables = Exact<{
  smsParams: SendSmsInput;
}>;


export type SendSmsMutation = { sendSms: Pick<Sms77JsonResponse, 'success' | 'totalPrice' | 'balance'> };

export type CourseLessonsForBillingStatusByInstructorQueryVariables = Exact<{
  courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
}>;


export type CourseLessonsForBillingStatusByInstructorQuery = { courseLessonsForBillingStatusByInstructor: Array<(
    Pick<BillingStatusByInstructor, 'instructorId' | 'courseLessonCount' | 'instructorCost' | 'sumBillingAmount' | 'billedLessonCount' | 'billedTotalAmount' | 'lastBillingDate'>
    & { instructor: (
      Pick<Instructor, 'id'>
      & { staff: Pick<Staff, 'id' | 'firstname' | 'lastname' | 'rate'> }
    ), courseLessons: Array<(
      Pick<BillingStatusCoursLessons, 'id' | 'startDateTime' | 'endDateTime' | 'costForLesson' | 'durationInMinutes' | 'billingDate' | 'billingAmount'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber'>
        & { courseType: Pick<CourseType, 'id' | 'name'>, location: Pick<Location, 'id' | 'name'> }
      ) }
    )> }
  )> };

export type UpdateBillingAmountForCourseLessonMutationVariables = Exact<{
  courseLessonId: Scalars['ID'];
  billingAmount?: Maybe<Scalars['Float']>;
}>;


export type UpdateBillingAmountForCourseLessonMutation = { updateBillingAmountForCourseLesson: Pick<CourseLesson, 'id' | 'billingAmount'> };

export type UpdateBillingAmountForCourseMutationVariables = Exact<{
  courseId: Scalars['ID'];
  billingAmount?: Maybe<Scalars['Float']>;
}>;


export type UpdateBillingAmountForCourseMutation = Pick<Mutation, 'updateBillingAmountForCourse'>;

export type CreateInstructorInvoiceMutationVariables = Exact<{
  input: CreateInstructorInvoiceInput;
}>;


export type CreateInstructorInvoiceMutation = Pick<Mutation, 'createInstructorInvoice'>;

export type PreviewInstructorInvoiceMutationVariables = Exact<{
  input: CreateInstructorInvoiceInput;
}>;


export type PreviewInstructorInvoiceMutation = Pick<Mutation, 'previewInstructorInvoice'>;

export type CourseLessonsForBillingStatusByInstructorGroupedQueryVariables = Exact<{
  courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
}>;


export type CourseLessonsForBillingStatusByInstructorGroupedQuery = { courseLessonsForBillingStatusByInstructorGrouped: Array<(
    Pick<BillingStatusByInstructorWithCourseGroups, 'instructorId' | 'courseLessonCount' | 'instructorCost' | 'sumBillingAmount' | 'billedLessonCount' | 'billedTotalAmount' | 'lastBillingDate'>
    & { instructor: (
      Pick<Instructor, 'id'>
      & { staff: Pick<Staff, 'id' | 'firstname' | 'lastname' | 'rate'> }
    ), courseGroups: Array<Pick<CourseSummaryForBilling, 'courseId' | 'coursePrefixedNumber' | 'courseTypeName' | 'courseTypeColor' | 'locationName' | 'lessonCount' | 'periodStart' | 'periodEnd' | 'totalAmount' | 'totalMinutes' | 'hourlyRate'>> }
  )> };

export type CourseLessonsByCourseAndInstructorQueryVariables = Exact<{
  courseId: Scalars['ID'];
  instructorId: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
}>;


export type CourseLessonsByCourseAndInstructorQuery = { courseLessonsByCourseAndInstructor: Array<(
    Pick<BillingStatusCoursLessons, 'id' | 'startDateTime' | 'endDateTime' | 'costForLesson' | 'durationInMinutes' | 'billingDate' | 'billingAmount'>
    & { course: (
      Pick<Course, 'id' | 'prefixedCourseNumber'>
      & { courseType: Pick<CourseType, 'id' | 'name'>, location: Pick<Location, 'id' | 'name'> }
    ) }
  )> };

export type CourseLessonsByInstructorChronologicalQueryVariables = Exact<{
  instructorId: Scalars['ID'];
  options?: Maybe<ArrayDataOptions>;
}>;


export type CourseLessonsByInstructorChronologicalQuery = { courseLessonsByInstructorChronological: (
    Pick<ChronologicalLessonsResult, 'total'>
    & { lessons: Array<(
      Pick<BillingStatusCoursLessons, 'id' | 'startDateTime' | 'endDateTime' | 'costForLesson' | 'durationInMinutes' | 'billingDate' | 'billingAmount'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber'>
        & { courseType: Pick<CourseType, 'id' | 'name'>, location: Pick<Location, 'id' | 'name'> }
      ) }
    )> }
  ) };

export type InstructorInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type InstructorInvoicesQuery = { instructorInvoices: Array<(
    Pick<InstructorInvoice, 'id' | 'instructorId' | 'lessonCount' | 'totalAmount' | 'periodStart' | 'periodEnd' | 'invoiceDate' | 'createdByUserId' | 'pdfPath' | 'pdfUrl' | 'fileSize' | 'createDate'>
    & { instructor: (
      Pick<Instructor, 'id'>
      & { staff: Pick<Staff, 'id' | 'firstname' | 'lastname'> }
    ) }
  )> };

export type DeleteInstructorInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type DeleteInstructorInvoiceMutation = Pick<Mutation, 'deleteInstructorInvoice'>;

export type InstructorInvoicesByInstructorAndDateRangeQueryVariables = Exact<{
  input: InstructorInvoicesByDateRangeInput;
}>;


export type InstructorInvoicesByInstructorAndDateRangeQuery = { instructorInvoicesByInstructorAndDateRange: Array<Pick<InstructorInvoice, 'id' | 'invoiceDate' | 'lessonCount' | 'totalAmount' | 'periodStart' | 'periodEnd' | 'pdfUrl'>> };

export type InstructorInvoiceByIdQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type InstructorInvoiceByIdQuery = { instructorInvoiceById?: Maybe<(
    Pick<InstructorInvoice, 'id' | 'instructorId' | 'lessonCount' | 'totalAmount' | 'periodStart' | 'periodEnd' | 'invoiceDate' | 'createdByUserId' | 'pdfPath' | 'pdfUrl' | 'fileSize' | 'createDate'>
    & { instructor: (
      Pick<Instructor, 'id'>
      & { staff: Pick<Staff, 'id' | 'firstname' | 'lastname' | 'rate'> }
    ), courseLessons: Array<(
      Pick<CourseLesson, 'id' | 'startDateTime' | 'endDateTime' | 'billingDate' | 'billingAmount'>
      & { course: (
        Pick<Course, 'id' | 'prefixedCourseNumber'>
        & { courseType: Pick<CourseType, 'id' | 'name'>, location: Pick<Location, 'id' | 'name'> }
      ) }
    )> }
  )> };

export type AdminManagementOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminManagementOverviewQuery = { adminManagementOverview: (
    Pick<AdminManagementOverview, 'adminSeatsUsed' | 'adminSeatsLimit'>
    & { users: Array<Pick<AdminManagementUser, 'userId' | 'email' | 'roles' | 'firstName' | 'lastName' | 'staffNames' | 'isSelf'>> }
  ) };

export type AdminManagementEmailStatusQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type AdminManagementEmailStatusQuery = { adminManagementEmailStatus: Pick<AdminManagementEmailInfo, 'status' | 'displayName'> };

export type AdminManagementStaffOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminManagementStaffOptionsQuery = { instructors: Array<Pick<Instructor, 'id' | 'userId' | 'firstname' | 'lastname' | 'email'>> };

export type CreateAdminManagementUserMutationVariables = Exact<{
  input: CreateAdminManagementUserInput;
}>;


export type CreateAdminManagementUserMutation = Pick<Mutation, 'createAdminManagementUser'>;

export type UpdateAdminManagementUserEmailMutationVariables = Exact<{
  input: UpdateAdminManagementUserEmailInput;
}>;


export type UpdateAdminManagementUserEmailMutation = Pick<Mutation, 'updateAdminManagementUserEmail'>;

export type UpdateAdminManagementUserNameMutationVariables = Exact<{
  input: UpdateAdminManagementUserNameInput;
}>;


export type UpdateAdminManagementUserNameMutation = Pick<Mutation, 'updateAdminManagementUserName'>;

export type RemoveAdminManagementUserMutationVariables = Exact<{
  input: RemoveAdminManagementUserInput;
}>;


export type RemoveAdminManagementUserMutation = Pick<Mutation, 'removeAdminManagementUser'>;

export type ToggleAreaManagerRoleFromAdminManagementMutationVariables = Exact<{
  input: ToggleAreaManagerRoleInput;
}>;


export type ToggleAreaManagerRoleFromAdminManagementMutation = Pick<Mutation, 'toggleAreaManagerRoleFromAdminManagement'>;

export type GetAreaManagerLocationsByStaffIdQueryVariables = Exact<{
  staffId: Scalars['String'];
}>;


export type GetAreaManagerLocationsByStaffIdQuery = { getAreaManagerLocationsByStaffId: Array<Pick<Location, 'id' | 'name'>> };

export type AssignAreaManagerLocationsMutationVariables = Exact<{
  input: AssignAreaManagerLocationsInput;
}>;


export type AssignAreaManagerLocationsMutation = Pick<Mutation, 'assignAreaManagerLocations'>;

export type StaffSaveInstructorMutationVariables = Exact<{
  saveInstructorData: SaveInstructorInput;
}>;


export type StaffSaveInstructorMutation = { saveInstructor: (
    Pick<Instructor, 'id' | 'level' | 'salutation' | 'firstname' | 'lastname' | 'active' | 'showInWeb' | 'birthDate' | 'birthPlace' | 'annotation' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'joinDate' | 'leaveDate' | 'socialSecurityNumber' | 'healthInsuranceFund' | 'rate' | 'vat' | 'accountHolder' | 'iban' | 'bic' | 'bank' | 'taxId' | 'allowLogin'>
    & { assignedLocations: Array<Pick<Location, 'id'>> }
  ) };

export type StaffGetInstructorQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type StaffGetInstructorQuery = { instructor: (
    Pick<Instructor, 'id' | 'userId' | 'staffId' | 'level' | 'salutation' | 'firstname' | 'lastname' | 'active' | 'showInWeb' | 'birthDate' | 'birthPlace' | 'annotation' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'joinDate' | 'leaveDate' | 'socialSecurityNumber' | 'healthInsuranceFund' | 'rate' | 'vat' | 'accountHolder' | 'iban' | 'bic' | 'bank' | 'taxId' | 'allowLogin' | 'customFields'>
    & { assignedLocations: Array<Pick<Location, 'id'>> }
  ) };

export type StaffGetInstructorsQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffGetInstructorsQuery = { instructors: Array<Pick<Instructor, 'id' | 'firstname' | 'lastname' | 'email' | 'active'>> };

export type GetInstructorsByStaffIdsQueryVariables = Exact<{
  staffIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetInstructorsByStaffIdsQuery = { instructorsByStaffIds: Array<(
    Pick<Instructor, 'id' | 'userId' | 'activeCourseCount' | 'level' | 'salutation' | 'firstname' | 'lastname' | 'active' | 'showInWeb' | 'birthDate' | 'birthPlace' | 'annotation' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'joinDate' | 'leaveDate' | 'socialSecurityNumber' | 'healthInsuranceFund' | 'rate' | 'vat' | 'accountHolder' | 'iban' | 'bic' | 'bank' | 'allowLogin'>
    & { assignedLocations: Array<Pick<Location, 'id' | 'name'>> }
  )> };

export type GetInstructorsWithPaginationQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetInstructorsWithPaginationQuery = { instructorsWithPagination: (
    Pick<InstructorsWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Instructor, 'id' | 'userId' | 'activeCourseCount' | 'level' | 'isAreaManager' | 'salutation' | 'firstname' | 'lastname' | 'active' | 'showInWeb' | 'birthDate' | 'birthPlace' | 'annotation' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'joinDate' | 'leaveDate' | 'socialSecurityNumber' | 'healthInsuranceFund' | 'rate' | 'vat' | 'accountHolder' | 'iban' | 'bic' | 'bank' | 'allowLogin'>
      & { assignedLocations: Array<Pick<Location, 'id' | 'name'>> }
    )> }
  ) };

export type GetInstructorsWithPaginationInstructorQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
  onlyCurrentUser?: Maybe<Scalars['Boolean']>;
}>;


export type GetInstructorsWithPaginationInstructorQuery = { instructorsWithPagination: (
    Pick<InstructorsWithPagination, 'existsMore' | 'total'>
    & { items: Array<(
      Pick<Instructor, 'id' | 'level' | 'firstname' | 'lastname' | 'active' | 'birthDate' | 'annotation' | 'phoneNumber' | 'mobileNumber' | 'email' | 'allowLogin'>
      & { assignedLocations: Array<Pick<Location, 'id' | 'name'>> }
    )> }
  ) };

export type IsInstructorQueryVariables = Exact<{ [key: string]: never; }>;


export type IsInstructorQuery = Pick<Query, 'isInstructor'>;

export type CanBecomeInstructorQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CanBecomeInstructorQuery = Pick<Query, 'canBecomeInstructor'>;

export type StaffGetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffGetLocationsQuery = { locations: Array<Pick<Location, 'id' | 'name' | 'city' | 'zipCode'>> };

export type RemoveInstructorMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveInstructorMutation = Pick<Mutation, 'removeInstructor'>;

export type StaffSharingLoginQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type StaffSharingLoginQuery = { staffSharingLogin: Array<Pick<SharedLoginStaff, 'id' | 'firstname' | 'lastname' | 'active'>> };

export type GetContentOfBucketDoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentOfBucketDoQuery = { getContentOfBucketDo: { ContentOfBucketResponse?: Maybe<Pick<ContentOfBucketResponse, 'IsTruncated' | 'Marker' | 'NextMarker' | 'Name' | 'Prefix' | 'Delimiter' | 'MaxKeys' | 'CommonPrefixes' | 'EncodingType'>>, Folders?: Maybe<Array<Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size'>>>, Files?: Maybe<Array<Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size' | 'signedImageUrl'>>> } };

export type GetContentOfFolderDoQueryVariables = Exact<{
  folderName?: Maybe<Scalars['String']>;
}>;


export type GetContentOfFolderDoQuery = { getContentOfFolderDo: { ContentOfBucketResponse?: Maybe<Pick<ContentOfBucketResponse, 'IsTruncated' | 'Marker' | 'NextMarker' | 'Name' | 'Prefix' | 'Delimiter' | 'MaxKeys' | 'CommonPrefixes' | 'EncodingType'>>, Folders?: Maybe<Array<Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size'>>>, Files?: Maybe<Array<Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size' | 'signedImageUrl'>>> } };

export type GetContentByPathDoQueryVariables = Exact<{
  path: Scalars['String'];
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetContentByPathDoQuery = { getContentByPathDo: { ContentOfBucketResponse?: Maybe<Pick<ContentOfBucketResponse, 'IsTruncated' | 'Marker' | 'NextMarker' | 'Name' | 'Prefix' | 'Delimiter' | 'MaxKeys' | 'CommonPrefixes' | 'EncodingType'>>, Folders?: Maybe<Array<Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size'>>>, Files?: Maybe<Array<Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size' | 'signedImageUrl'>>> } };

export type GetPdfDoQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetPdfDoQuery = { getFileDo: Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size' | 'pdfBlob' | 'signedImageUrl'> };

export type GetFileDoQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetFileDoQuery = { getFileDo: Pick<Content, 'Name' | 'Key' | 'LastModified' | 'ETag' | 'Size' | 'pdfBlob' | 'signedImageUrl'> };

export type AddFolderDoMutationVariables = Exact<{
  folderName: Scalars['String'];
}>;


export type AddFolderDoMutation = Pick<Mutation, 'addFolderDo'>;

export type DeleteFolderDoMutationVariables = Exact<{
  folderName: Scalars['String'];
}>;


export type DeleteFolderDoMutation = Pick<Mutation, 'deleteFolderDo'>;

export type UploadFilesDoMutationVariables = Exact<{
  fileArray: Array<Scalars['Upload']> | Scalars['Upload'];
  path: Scalars['String'];
  metadata: UploadMetadataInput;
}>;


export type UploadFilesDoMutation = Pick<Mutation, 'uploadFilesDo'>;

export type UploadSingleFileDoMutationVariables = Exact<{
  file: Scalars['Upload'];
  path: Scalars['String'];
}>;


export type UploadSingleFileDoMutation = Pick<Mutation, 'uploadSingleFileDo'>;

export type DeleteFileDoMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type DeleteFileDoMutation = Pick<Mutation, 'deleteFileDo'>;

export type RenameFileDoMutationVariables = Exact<{
  fileName: Scalars['String'];
  newFileName: Scalars['String'];
}>;


export type RenameFileDoMutation = Pick<Mutation, 'renameFileDo'>;

export type RenameFolderDoMutationVariables = Exact<{
  folderName: Scalars['String'];
  newFolderName: Scalars['String'];
}>;


export type RenameFolderDoMutation = Pick<Mutation, 'renameFolderDo'>;

export type GetSignedUrlDoQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetSignedUrlDoQuery = Pick<Query, 'getSignedUrlDo'>;

export type DownloadFileDoMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type DownloadFileDoMutation = Pick<Mutation, 'downloadFileDo'>;

export type GetPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPagesQuery = { getPages: { pages: Array<(
      Pick<Page, 'id' | 'url'>
      & { content: Pick<PageContent, 'title' | 'subTitle' | 'body'> }
    )> } };

export type UpdatePageMutationVariables = Exact<{
  editPageInput: EditPageInput;
}>;


export type UpdatePageMutation = { updatePage: { pages: Array<(
      Pick<Page, 'id' | 'url'>
      & { content: Pick<PageContent, 'title' | 'subTitle' | 'body'> }
    )> } };

export type AddPageMutationVariables = Exact<{
  newPageInput: NewPageInput;
}>;


export type AddPageMutation = { addPage: { pages: Array<(
      Pick<Page, 'id' | 'url'>
      & { content: Pick<PageContent, 'title' | 'subTitle' | 'body'> }
    )> } };

export type DeletePageMutationVariables = Exact<{
  pageId: Scalars['String'];
}>;


export type DeletePageMutation = { deletePage: { pages: Array<(
      Pick<Page, 'id' | 'url'>
      & { content: Pick<PageContent, 'title' | 'subTitle' | 'body'> }
    )> } };

export type SubmitSupportReportMutationVariables = Exact<{
  input: SupportReportInput;
}>;


export type SubmitSupportReportMutation = Pick<Mutation, 'submitSupportReport'>;

export type UploadSingleCamtFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  analysis?: Maybe<Scalars['Boolean']>;
}>;


export type UploadSingleCamtFileMutation = Pick<Mutation, 'singleUpload'>;

export type GetSwissQrFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSwissQrFilesQuery = { swissQRFiles: Array<(
    Pick<SwissQrFile, 'id' | 'fileId' | 'filename' | 'createDate' | 'createdByUserId'>
    & { records?: Maybe<Array<(
      Pick<SwissQrFileRecord, 'id' | 'amount' | 'result' | 'valutaDate' | 'swissQrRef' | 'successful' | 'comment' | 'creditAmount' | 'originalOpenAmount'>
      & { scheduledPayment?: Maybe<Pick<ScheduledPayment, 'id' | 'bookingId' | 'paymentAmount' | 'openAmount'>> }
    )>> }
  )> };

export type UpdateSwissQrFileNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
}>;


export type UpdateSwissQrFileNoteMutation = { updateSwissQRFileNote: Pick<SwissQrFile, 'id' | 'note'> };

export type GetSwissQrFilesOverviewQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  onlyOpen?: Maybe<Scalars['Boolean']>;
}>;


export type GetSwissQrFilesOverviewQuery = { swissQRFilesOverview: (
    Pick<SwissQrFileOverviewWithPagination, 'total' | 'openRecordCount'>
    & { items: Array<Pick<SwissQrFileOverview, 'id' | 'fileId' | 'filename' | 'createDate' | 'createdByUserId' | 'note' | 'totalRecords' | 'paidCount' | 'overpaidCount' | 'underpaidCount' | 'ambiguousCount' | 'resolvedCount' | 'errorCount' | 'totalAmount'>> }
  ) };

export type GetSwissQrFileByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSwissQrFileByIdQuery = { swissQRFileById?: Maybe<(
    Pick<SwissQrFile, 'id' | 'fileId' | 'filename' | 'createDate'>
    & { records?: Maybe<Array<(
      Pick<SwissQrFileRecord, 'id' | 'amount' | 'result' | 'valutaDate' | 'swissQrRef' | 'successful' | 'comment' | 'creditAmount' | 'originalOpenAmount'>
      & { scheduledPayment?: Maybe<(
        Pick<ScheduledPayment, 'id' | 'bookingId' | 'paymentAmount' | 'openAmount'>
        & { invoice?: Maybe<Pick<Invoice, 'id' | 'invoiceNumberPrefix' | 'invoiceNumber'>>, booking: (
          Pick<Booking, 'id' | 'bookingNumberPrefix' | 'bookingNumber' | 'bookingType' | 'canceled'>
          & { attendee?: Maybe<(
            Pick<Attendee, 'id' | 'customerId' | 'firstname' | 'lastname'>
            & { booker?: Maybe<Pick<Booker, 'id' | 'customerId' | 'firstname' | 'lastname'>> }
          )>, course?: Maybe<(
            Pick<Course, 'id' | 'prefixedCourseNumber'>
            & { courseType: Pick<CourseType, 'id' | 'name'> }
          )> }
        ) }
      )> }
    )>> }
  )> };

export type AssignAmbiguousSwissQrPaymentMutationVariables = Exact<{
  recordId: Scalars['ID'];
  distributions: Array<AssignAmbiguousPaymentDistributionInput> | AssignAmbiguousPaymentDistributionInput;
}>;


export type AssignAmbiguousSwissQrPaymentMutation = { assignAmbiguousSwissQRPayment: Pick<SwissQrFileRecord, 'id' | 'result' | 'comment' | 'creditAmount'> };

export type ResolveAmbiguousSwissQrPaymentMutationVariables = Exact<{
  recordId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type ResolveAmbiguousSwissQrPaymentMutation = { resolveAmbiguousSwissQRPayment: Pick<SwissQrFileRecord, 'id' | 'result' | 'comment'> };

export type GetSwissQrRecordContextQueryVariables = Exact<{
  recordId: Scalars['ID'];
}>;


export type GetSwissQrRecordContextQuery = { swissQRRecordContext: { invoiceEvents: Array<Pick<SwissQrRecordContextEvent, 'kind' | 'date' | 'amount' | 'source'>>, otherRates: Array<Pick<SwissQrRecordContextRate, 'scheduledPaymentId' | 'bookingId' | 'bookingNumber' | 'invoiceNumber' | 'attendeeName' | 'amount' | 'openAmount' | 'paymentDue' | 'paymentDone' | 'paidWithoutReceipt'>> } };

export type CreateDummyCamtFileForMultiplePaymentsMutationVariables = Exact<{
  createDummySwissCamtByScheduledPaymentsInput: CreateDummySwissCamtByScheduledPaymentsInput;
}>;


export type CreateDummyCamtFileForMultiplePaymentsMutation = Pick<Mutation, 'createDummyCamtFileForMultiplePayments'>;

export type SendEmailToSelectionOfCourseMutationVariables = Exact<{
  sendMailToSelectionOfCourseInput: SendMailToSelectionOfCourseInput;
}>;


export type SendEmailToSelectionOfCourseMutation = Pick<Mutation, 'sendEmailsToSelectionOfCourse'>;

export type SendEmailToSelectionOfBookingsMutationVariables = Exact<{
  sendMailToSelectionOfBookingInput: SendMailToSelectionOfBookingInput;
}>;


export type SendEmailToSelectionOfBookingsMutation = Pick<Mutation, 'sendMailToSelectionOfBookings'>;

export type SendEmailToSelectionOfBookersMutationVariables = Exact<{
  sendMailToSelectionOfBookersInput: SendMailToSelectionOfBookersInput;
}>;


export type SendEmailToSelectionOfBookersMutation = Pick<Mutation, 'sendEmailToSelectionOfBookers'>;

export type SendEmailToSelectionOfStaffMutationVariables = Exact<{
  sendMailToSelectionOfStaffInput: SendMailToSelectionOfStaffInput;
}>;


export type SendEmailToSelectionOfStaffMutation = Pick<Mutation, 'sendEmailToSelectionOfStaff'>;

export type SendEmailToSelectionOfAttendeesMutationVariables = Exact<{
  sendMailToSelectionOfAttendeesInput: SendMailToSelectionOfAttendeesInput;
}>;


export type SendEmailToSelectionOfAttendeesMutation = Pick<Mutation, 'sendEmailToSelectionOfAttendees'>;

export type SendEmailToSelectionOfScheduledPaymentsMutationVariables = Exact<{
  sendMailToSelectionOfScheduledPaymentsInput: SendMailToSelectionOfScheduledPaymentsInput;
}>;


export type SendEmailToSelectionOfScheduledPaymentsMutation = Pick<Mutation, 'sendEmailToSelectionOfScheduledPayments'>;

export type SendInvoicesToSelectionOfBookingsMutationVariables = Exact<{
  sendInvoicesToSelectionOfBookingsInput: SendInvoicesToSelectionOfBookingInput;
}>;


export type SendInvoicesToSelectionOfBookingsMutation = Pick<Mutation, 'sendInvoicesToSelectionOfBookings'>;

export type RenderTemplateForLetterPdfQueryVariables = Exact<{
  input: RenderTemplateForLetterPdfInput;
}>;


export type RenderTemplateForLetterPdfQuery = { renderTemplateForLetterPdf: (
    Pick<RenderedLetterPdfData, 'subject' | 'headerText' | 'footerText' | 'signature' | 'recipientFirstName' | 'recipientLastName' | 'recipientStreet' | 'recipientHouseNumber' | 'recipientPostCode' | 'recipientCity' | 'recipientAddition' | 'senderName' | 'senderStreet' | 'senderStreetNumber' | 'senderZip' | 'senderCity' | 'senderLogoBase64' | 'senderPhone' | 'senderEmail' | 'senderWebsite' | 'senderBankName' | 'senderIban' | 'senderBic' | 'senderTaxId' | 'senderTaxNumber'>
    & { courseDetails?: Maybe<Pick<LetterPdfCourseDetails, 'courseName' | 'courseNumber' | 'locationName' | 'locationStreet' | 'locationCity' | 'courseStartDate' | 'courseEndDate' | 'courseTime' | 'coursePrice' | 'courseLessonsCount' | 'attendeeName'>> }
  ) };

export type RenderBatchTemplateForCourseLetterPdfQueryVariables = Exact<{
  input: RenderBatchLetterPdfForCourseInput;
}>;


export type RenderBatchTemplateForCourseLetterPdfQuery = { renderBatchTemplateForCourseLetterPdf: (
    Pick<RenderedBatchLetterPdfData, 'totalCount'>
    & { items: Array<(
      Pick<RenderedLetterPdfData, 'subject' | 'headerText' | 'footerText' | 'signature' | 'recipientFirstName' | 'recipientLastName' | 'recipientStreet' | 'recipientHouseNumber' | 'recipientPostCode' | 'recipientCity' | 'recipientAddition' | 'senderName' | 'senderStreet' | 'senderStreetNumber' | 'senderZip' | 'senderCity' | 'senderLogoBase64' | 'senderPhone' | 'senderEmail' | 'senderWebsite' | 'senderBankName' | 'senderIban' | 'senderBic' | 'senderTaxId' | 'senderTaxNumber'>
      & { courseDetails?: Maybe<Pick<LetterPdfCourseDetails, 'courseName' | 'courseNumber' | 'locationName' | 'locationStreet' | 'locationCity' | 'courseStartDate' | 'courseEndDate' | 'courseTime' | 'coursePrice' | 'courseLessonsCount' | 'attendeeName'>> }
    )> }
  ) };

export type RenderBatchTemplateForBookingsLetterPdfQueryVariables = Exact<{
  input: RenderBatchLetterPdfForBookingsInput;
}>;


export type RenderBatchTemplateForBookingsLetterPdfQuery = { renderBatchTemplateForBookingsLetterPdf: (
    Pick<RenderedBatchLetterPdfData, 'totalCount'>
    & { items: Array<(
      Pick<RenderedLetterPdfData, 'subject' | 'headerText' | 'footerText' | 'signature' | 'recipientFirstName' | 'recipientLastName' | 'recipientStreet' | 'recipientHouseNumber' | 'recipientPostCode' | 'recipientCity' | 'recipientAddition' | 'senderName' | 'senderStreet' | 'senderStreetNumber' | 'senderZip' | 'senderCity' | 'senderLogoBase64' | 'senderPhone' | 'senderEmail' | 'senderWebsite' | 'senderBankName' | 'senderIban' | 'senderBic' | 'senderTaxId' | 'senderTaxNumber'>
      & { courseDetails?: Maybe<Pick<LetterPdfCourseDetails, 'courseName' | 'courseNumber' | 'locationName' | 'locationStreet' | 'locationCity' | 'courseStartDate' | 'courseEndDate' | 'courseTime' | 'coursePrice' | 'courseLessonsCount' | 'attendeeName'>> }
    )> }
  ) };

export type SendEmailTemplateMutationVariables = Exact<{
  sendTemplateInput: SendTemplateInput;
}>;


export type SendEmailTemplateMutation = Pick<Mutation, 'sendEmailTemplate'>;

export type GetDefaultInvoiceTemplateSetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultInvoiceTemplateSetQuery = { defaultInvoiceTemplateSet: Pick<InvoiceTemplateSet, 'id' | 'name' | 'isDefault' | 'layoutVariant' | 'logoPosition' | 'customLogo' | 'secondLogo'> };

export type UpdateInvoiceTemplateSetMutationVariables = Exact<{
  input: UpdateInvoiceTemplateSetInput;
}>;


export type UpdateInvoiceTemplateSetMutation = { updateInvoiceTemplateSet: Pick<InvoiceTemplateSet, 'id' | 'name' | 'isDefault' | 'layoutVariant' | 'logoPosition' | 'customLogo' | 'secondLogo'> };

export type GetInvoiceTemplateSetByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetInvoiceTemplateSetByIdQuery = { invoiceTemplateSet: Pick<InvoiceTemplateSet, 'id' | 'name' | 'isDefault' | 'layoutVariant' | 'logoPosition' | 'customLogo' | 'secondLogo'> };

export type GetInvoiceTemplateSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceTemplateSetsQuery = { invoiceTemplateSets: Array<Pick<InvoiceTemplateSet, 'id' | 'name' | 'isDefault' | 'layoutVariant' | 'logoPosition'>> };

export type CreateInvoiceTemplateSetMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateInvoiceTemplateSetMutation = { createInvoiceTemplateSet: Pick<InvoiceTemplateSet, 'id' | 'name' | 'isDefault'> };

export type DeleteInvoiceTemplateSetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInvoiceTemplateSetMutation = Pick<Mutation, 'deleteInvoiceTemplateSet'>;

export type AssignCourseTypeToInvoiceTemplateSetMutationVariables = Exact<{
  courseTypeId: Scalars['ID'];
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
}>;


export type AssignCourseTypeToInvoiceTemplateSetMutation = { assignCourseTypeToInvoiceTemplateSet: Pick<CourseType, 'id' | 'name' | 'invoiceTemplateSetId'> };

export type GetInvoiceTemplateSetOverridesQueryVariables = Exact<{
  invoiceTemplateSetId: Scalars['ID'];
}>;


export type GetInvoiceTemplateSetOverridesQuery = { templates: Array<Pick<Template, 'id' | 'templateType'>> };

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = { templates: Array<Pick<Template, 'id' | 'templateType' | 'name' | 'isDefault' | 'mailDataType' | 'createDate' | 'updateDate' | 'includeCourseDetails'>> };

export type GetTemplatesWithPaginationQueryVariables = Exact<{
  options?: Maybe<ArrayDataOptions>;
}>;


export type GetTemplatesWithPaginationQuery = { templatesWithPagination: (
    Pick<TemplatesWithPagination, 'existsMore' | 'total'>
    & { items: Array<Pick<Template, 'id' | 'templateType' | 'name' | 'subject' | 'isDefault' | 'mailDataType' | 'createDate' | 'updateDate' | 'includeCourseDetails'>> }
  ) };

export type CheckIfTemplateOfTypeExistsQueryVariables = Exact<{
  templateType: TemplateType;
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
}>;


export type CheckIfTemplateOfTypeExistsQuery = Pick<Query, 'checkIfTemplateOfTypeExists'>;

export type CreateTemplateMutationVariables = Exact<{
  newTemplateData: NewTemplateInput;
}>;


export type CreateTemplateMutation = { createTemplate: Pick<Template, 'id'> };

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTemplateMutation = Pick<Mutation, 'deleteTemplate'>;

export type GetTemplateByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTemplateByIdQuery = { template: Pick<Template, 'id' | 'name' | 'templateType' | 'headerText' | 'footerText' | 'signature' | 'subject' | 'isDefault' | 'includeCourseDetails'> };

export type UpdateTemplateMutationVariables = Exact<{
  editTemplateData: EditTemplateInput;
  id: Scalars['String'];
}>;


export type UpdateTemplateMutation = { updateTemplate: Pick<Template, 'id' | 'name' | 'templateType' | 'headerText' | 'footerText' | 'signature' | 'subject' | 'includeCourseDetails' | 'isDefault'> };

export type GetTemplateByTypeQueryVariables = Exact<{
  templateType: TemplateType;
  invoiceTemplateSetId?: Maybe<Scalars['ID']>;
}>;


export type GetTemplateByTypeQuery = { templateByType: Pick<Template, 'id' | 'name' | 'templateType' | 'headerText' | 'footerText' | 'signature' | 'subject' | 'includeCourseDetails' | 'isDefault'> };

export type SetIncludeCourseDetailsMutationVariables = Exact<{
  templateId: Scalars['ID'];
  includeCourseDetails: Scalars['Boolean'];
}>;


export type SetIncludeCourseDetailsMutation = { setIncludeCourseDetails: Pick<Template, 'id' | 'includeCourseDetails'> };

export type RenderTextBlockPreviewQueryVariables = Exact<{
  input: TextBlockPreviewInput;
}>;


export type RenderTextBlockPreviewQuery = { renderTextBlockPreview: { recipients: Array<Pick<TextBlockPreviewRecipient, 'id' | 'name' | 'email'>>, current?: Maybe<Pick<TextBlockPreviewCurrent, 'index' | 'subject' | 'headerText' | 'footerText' | 'signature' | 'replaced' | 'empty' | 'unknown'>>, summary?: Maybe<Pick<TextBlockPreviewSummary, 'recipientsWithEmpty' | 'recipientsWithUnknown' | 'emptyVariables' | 'total'>> } };

export type WithdrawalsQueryVariables = Exact<{ [key: string]: never; }>;


export type WithdrawalsQuery = { withdrawals: Array<Pick<WithdrawalRequest, 'id' | 'name' | 'bookingReference' | 'email' | 'reason' | 'receivedAt' | 'status' | 'matchedBookingId' | 'source'>> };

export type UpdateWithdrawalStatusMutationVariables = Exact<{
  input: UpdateWithdrawalStatusInput;
}>;


export type UpdateWithdrawalStatusMutation = { updateWithdrawalStatus: Pick<WithdrawalRequest, 'id' | 'name' | 'bookingReference' | 'email' | 'reason' | 'receivedAt' | 'status' | 'matchedBookingId' | 'source'> };

export type CreateAndRegisterThirdPartyUserAndBookerMutationVariables = Exact<{
  newBookingData: BookerInput;
  thirdPartyUserInput: ThirdPartyUserInput;
}>;


export type CreateAndRegisterThirdPartyUserAndBookerMutation = { createAndRegisterThirdPartyUserAndBooker: (
    Pick<UserType, 'id' | 'roles' | 'email' | 'refreshToken' | 'accessToken'>
    & { booker?: Maybe<(
      Pick<Booker, 'id' | 'firstname' | 'lastname' | 'gender' | 'createDate' | 'updateDate' | 'customerId' | 'addition' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'birthday' | 'initialContact' | 'dsgvo' | 'newsletter' | 'healthInsuranceFund' | 'annotation' | 'createdBy'>
      & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment' | 'esr'>>>, attendees?: Maybe<Array<(
        Pick<Attendee, 'id' | 'gender' | 'lastname' | 'firstname' | 'birthday' | 'member'>
        & { customer: Pick<Customer, 'id'>, defaultPaymentMethod: Pick<PaymentMethod, 'id'>, bookings?: Maybe<Array<(
          Pick<Booking, 'id' | 'paymentType' | 'payDate'>
          & { courseLessons: Array<Pick<CourseLesson, 'id'>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id'>> }
        )>> }
      )>> }
    )> }
  ) };

export type UpdateBookerFromEndUserAppMutationVariables = Exact<{
  updateBookerData: BookerInput;
  fromEndUserApp: Scalars['Boolean'];
}>;


export type UpdateBookerFromEndUserAppMutation = { updateBooker: (
    Pick<Booker, 'id' | 'gender' | 'firstname' | 'lastname' | 'street' | 'houseNumber' | 'postCode' | 'city' | 'phoneNumber' | 'mobileNumber' | 'email' | 'birthday' | 'initialContact' | 'dsgvo' | 'newsletter' | 'healthInsuranceFund' | 'annotation' | 'userId'>
    & { paymentMethods?: Maybe<Array<Pick<PaymentMethod, 'id' | 'cash' | 'creditCardAccountholder' | 'creditcardNumber' | 'expirationDate' | 'validFrom' | 'cvc' | 'paypalAccountholder' | 'email' | 'iban' | 'bank' | 'bic' | 'sepaAccountholder' | 'bankTransfer' | 'onlinePayment'>>>, attendees?: Maybe<Array<(
      Pick<Attendee, 'id' | 'gender' | 'lastname' | 'firstname' | 'birthday' | 'member' | 'deletable'>
      & { customer: Pick<Customer, 'id'>, startedCourses: Array<Pick<Course, 'id' | 'prefixedCourseNumber'>>, defaultPaymentMethod: Pick<PaymentMethod, 'id'>, bookings?: Maybe<Array<(
        Pick<Booking, 'id' | 'paymentType' | 'payDate'>
        & { courseLessons: Array<Pick<CourseLesson, 'id'>>, paymentMethod?: Maybe<Pick<PaymentMethod, 'id'>> }
      )>> }
    )>> }
  ) };

export type CreateBookingFromEndUserAppMutationVariables = Exact<{
  newBookingData: NewBookingInput;
  sendMail: Scalars['Boolean'];
}>;


export type CreateBookingFromEndUserAppMutation = { createBooking: Pick<Booking, 'id' | 'bookingType'> };

export type TenantChangeVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantChangeVersionQuery = Pick<Query, 'tenantChangeVersion'>;

export type LoggerMutationVariables = Exact<{
  input: LoggingInput;
}>;


export type LoggerMutation = Pick<Mutation, 'logging'>;

export type GetUserSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingQuery = { userSettings?: Maybe<Pick<UserSetting, 'id' | 'language' | 'profilePictureUrl' | 'columnSettings' | 'showArchivedCourses'>> };

export type GetUserSettingByIdAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingByIdAllQuery = { userSettings?: Maybe<Pick<UserSetting, 'id' | 'language' | 'profilePictureUrl' | 'columnSettings' | 'optimizedCourseCalendar'>> };

export type SetOptimizedCourseCalendarMutationVariables = Exact<{
  optimize: Scalars['Boolean'];
}>;


export type SetOptimizedCourseCalendarMutation = { userSettingSetOptimizedCourseCalendar: Pick<UserSetting, 'id'> };

export type UpdateUserSettingMutationVariables = Exact<{
  userSettingsInput: UserSettingsInputTypes;
}>;


export type UpdateUserSettingMutation = { userSettingsUpdateOrCreate: Pick<UserSetting, 'id' | 'language' | 'profilePictureUrl' | 'columnSettings'> };

export type UpdateTableColumnSettingsMutationVariables = Exact<{
  updateTableColumnSettingsInput: UpdateTableColumnSettingsInput;
}>;


export type UpdateTableColumnSettingsMutation = { updateTableColumnSettings: Pick<UserSetting, 'id' | 'columnSettings'> };

export type GetColumnsForTableQueryVariables = Exact<{
  table: TablesEnum;
}>;


export type GetColumnsForTableQuery = Pick<Query, 'getColumnsForTable'>;

export type GetAttendanceListSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAttendanceListSettingsQuery = { userSettings?: Maybe<Pick<UserSetting, 'id' | 'attendanceListSettings'>> };

export type UpdateAttendanceListSettingsMutationVariables = Exact<{
  updateAttendanceListSettingsInput: UpdateAttendanceListSettingsInput;
}>;


export type UpdateAttendanceListSettingsMutation = { updateAttendanceListSettings: Pick<UserSetting, 'id' | 'attendanceListSettings'> };

export type UpdateShowArchivedCoursesMutationVariables = Exact<{
  showArchivedCourses: Scalars['Boolean'];
}>;


export type UpdateShowArchivedCoursesMutation = { updateShowArchivedCourses: Pick<UserSetting, 'id' | 'showArchivedCourses'> };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { locations: Array<Pick<Location, 'id' | 'name'>> };

export type CreateAttendanceListBulkByLocationMutationVariables = Exact<{
  input: CreateAttendanceListBulkByLocationInput;
}>;


export type CreateAttendanceListBulkByLocationMutation = { createAttendanceListBulkByLocation: Pick<BulkJobResult, 'jobGroupId' | 'courseCount' | 'estimatedDurationSeconds' | 'message'> };

export type CreateAttendanceListBulkByInstructorMutationVariables = Exact<{
  input: CreateAttendanceListBulkByInstructorInput;
}>;


export type CreateAttendanceListBulkByInstructorMutation = { createAttendanceListBulkByInstructor: Pick<BulkJobResult, 'jobGroupId' | 'courseCount' | 'estimatedDurationSeconds' | 'message'> };

export type AttendanceListBulkJobStatusQueryVariables = Exact<{
  jobGroupId: Scalars['ID'];
}>;


export type AttendanceListBulkJobStatusQuery = { attendanceListBulkJobStatus: Pick<BulkJobStatus, 'jobGroupId' | 'total' | 'completed' | 'failed' | 'active' | 'downloadUrl' | 'expiresAt'> };

export type AttendanceListArchivesQueryVariables = Exact<{ [key: string]: never; }>;


export type AttendanceListArchivesQuery = { attendanceListArchives: Array<Pick<AttendanceListArchive, 'jobGroupId' | 'createdAt' | 'expiresAt' | 'downloadUrl' | 'courseCount' | 'fileSize' | 'locationName' | 'instructorNames' | 'dateRangeStart' | 'dateRangeEnd' | 'createdByUserId' | 'createdByUserEmail' | 'createdByUserName'>> };

export type GetArchiveInstructorsQueryVariables = Exact<{
  jobGroupId: Scalars['ID'];
}>;


export type GetArchiveInstructorsQuery = { attendanceListArchiveInstructors: Array<Pick<InstructorCourseGroup, 'instructorId' | 'instructorName' | 'instructorEmail' | 'courseIds' | 'courseCount'>> };

export type SendAttendanceListArchiveMutationVariables = Exact<{
  input: SendAttendanceListArchiveInput;
}>;


export type SendAttendanceListArchiveMutation = Pick<Mutation, 'sendAttendanceListArchive'>;

export type SendAttendanceListArchiveTestEmailMutationVariables = Exact<{
  input: SendAttendanceListArchiveInput;
}>;


export type SendAttendanceListArchiveTestEmailMutation = Pick<Mutation, 'sendAttendanceListArchiveTestEmail'>;

export type DeleteAttendanceListArchiveMutationVariables = Exact<{
  jobGroupId: Scalars['ID'];
}>;


export type DeleteAttendanceListArchiveMutation = Pick<Mutation, 'deleteAttendanceListArchive'>;

export type DeleteAllAttendanceListArchivesMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllAttendanceListArchivesMutation = Pick<Mutation, 'deleteAllAttendanceListArchives'>;

export type GetMjmlTemplateByIdQueryVariables = Exact<{
  templateId: Scalars['String'];
}>;


export type GetMjmlTemplateByIdQuery = { getEmailTemplateById: Pick<MjmlTemplate, 'Count' | 'Data' | 'Total'> };

export type GetPaymentActionLogsQueryVariables = Exact<{
  scheduledPaymentId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetPaymentActionLogsQuery = { getPaymentActionLogs: Array<Pick<PaymentActionLog, 'id' | 'scheduledPaymentId' | 'userId' | 'action' | 'metadata' | 'timestamp'>> };

export type ScheduledPaymentBadgeFragmentFragment = (
  Pick<ScheduledPayment, 'id' | 'paymentProvider' | 'molliePaymentStatus' | 'paymentDone' | 'paymentAmount' | 'providerRefundedAmount' | 'methodChangedAt' | 'methodChangedByUserId' | 'mollieMethod'>
  & { latestMolliePaymentAttempt?: Maybe<Pick<LatestMollieAttemptBadge, 'linkExpiresAt' | 'mollieMethod'>> }
);

export const BookingCoreFieldsFragmentDoc = gql`
    fragment BookingCoreFields on Booking {
  id
  bookingNumber
  bookingNumberPrefix
  bookingType
  updateDate
  createDate
  startDateTime
  courseId
  noticeStaff
  attendanceListNote
  noticeBooker
  coursePriceId
  payDate
  grossPrice
  netPrice
  vat
  isSpecial
  paymentType
  bookedBy
  canceled
  bookingConfirmationSent
  waitingListConfirmationSent
  cancelationSent
  invoiceSent
  waitListCount
  additionalInfo
}
    `;
export const BookingCoursePriceFieldsFragmentDoc = gql`
    fragment BookingCoursePriceFields on Booking {
  coursePrice {
    id
    grossPrice
    netPrice
    vat
  }
}
    `;
export const BookingInvoiceFieldsFragmentDoc = gql`
    fragment BookingInvoiceFields on Booking {
  invoice {
    id
    billed
    invoiceNumber
    invoiceNumberPrefix
    createDate
  }
}
    `;
export const BookingReversalInvoiceFieldsFragmentDoc = gql`
    fragment BookingReversalInvoiceFields on Booking {
  reversalInvoice {
    id
    invoiceNumber
    invoiceNumberPrefix
    createDate
  }
}
    `;
export const BookingCourseLessonsFieldsFragmentDoc = gql`
    fragment BookingCourseLessonsFields on Booking {
  courseLessons {
    id
    startDateTime
    endDateTime
    locationId
    course {
      id
      freePlaces
      startDateTime
      paymentInterval
      minAttendees
      maxAttendees
      prefixedCourseNumber
      allowMonthlyPayment
      paymentInterval
      courseType {
        id
        name
        color
      }
      instructors {
        id
        firstname
        lastname
      }
      lessonCount
      allowLessonBooking
      allowMolliePayment
      mollieOptional
    }
    location {
      id
      city
      name
    }
  }
}
    `;
export const BookingAttendeeFieldsFragmentDoc = gql`
    fragment BookingAttendeeFields on Booking {
  attendee {
    id
    erasedAt
    gender
    firstname
    lastname
    birthday
    customerNumberPrefix
    customerNumber
    member
    booker {
      id
      gender
      firstname
      lastname
      customerNumberPrefix
      customerNumber
      street
      houseNumber
      postCode
      city
      phoneNumber
      mobileNumber
      email
      gender
      nonDisclosureNotice
      credit
    }
  }
}
    `;
export const BookingEmailNotificationsFieldsFragmentDoc = gql`
    fragment BookingEmailNotificationsFields on Booking {
  emailNotifications {
    id
    templateType
    subject
    createDate
    bookingId
    email
  }
}
    `;
export const BookingPaymentMethodFieldsFragmentDoc = gql`
    fragment BookingPaymentMethodFields on Booking {
  paymentMethod {
    id
    type
    cash
    esr
    iban
    bank
    bic
    sepaAccountholder
    bankTransfer
    onlinePayment
  }
}
    `;
export const BookingMolliePaymentAttemptsFieldsFragmentDoc = gql`
    fragment BookingMolliePaymentAttemptsFields on Booking {
  molliePaymentAttempts {
    id
    molliePaymentId
    scheduledPaymentId
    molliePaymentLinkId
    bundleScheduledPaymentIds
    mollieMethod
    status
    checkoutUrl
    paymentUrl
    isCurrentAttempt
    amount
    linkExpiresAt
    paidAt
    createDate
    errorMessage
    chargebackId
    chargebackReason
    chargebackFee
    chargebackedAt
    refunds {
      id
      mollieRefundId
      amount
      reason
      status
      canceledAtProvider
      mollieCreatedAt
      adminUserId
      createDate
    }
    chargebacks {
      mollieChargebackId
      reason
      fee
      chargebackedAt
    }
  }
}
    `;
export const CertificateTemplateFieldsFragmentDoc = gql`
    fragment CertificateTemplateFields on CertificateTemplate {
  __typename
  id
  name
  designVariant
  logo
  badgeImage
  instructorName
  congratulationText
  titleText
  introText
  middleText
  footerText
  organisationName
  accentColor
  visibility {
    logo
    organisation
    kurs
    zertifikat
    datum
    nummer
    titel
    intro
    mittel
    grat
    kl
    fuss
    geburtsdatum
    signers
  }
  sizes {
    titel
    org
    kurs
    intro
    name
    mittel
    zert
    grat
    kl
    untertitel
    docMid
    kursSub
    abschluss
    beschreibung
    akkreditierung
    veranstalter
    fuss
    badge
    logo
    bandTitle
    bandStufen
    bandContact
  }
  signers {
    name
    role
  }
  docFields {
    untertitel {
      v
      show
    }
    teilnCaption {
      v
      show
    }
    docMid {
      v
      show
    }
    kursSub {
      v
      show
    }
    abschluss {
      v
      show
    }
    beschreibung {
      v
      show
    }
    akkreditierung {
      v
      show
    }
    ort {
      v
      show
    }
    veranstalter {
      v
      show
    }
    align {
      logo
      footer
    }
  }
  blockLayout {
    density
    alignments {
      organisation
      titel
      kurs
      intro
      teilnehmer
      geburtsdatum
      mittel
      zert
      grat
      untertitel
      name
      teilnCaption
      docMid
      kursSub
      abschluss
      beschreibung
      akkreditierung
      ortDatum
      logo
      letterHead
      letterSalutation
      letterZert
      beilage
      letterBody
      letterBadge
      letterSig
    }
    spacing {
      organisation
      titel
      kurs
      intro
      teilnehmer
      geburtsdatum
      mittel
      zert
      grat
      untertitel
      name
      teilnCaption
      docMid
      kursSub
      abschluss
      beschreibung
      akkreditierung
      ortDatum
      logo
      letterHead
      letterSalutation
      letterZert
      beilage
      letterBody
      letterBadge
      letterSig
      bandTitle
      bandStufen
      bandContact
    }
    order
  }
  letterFields {
    senderLine
    beilage {
      v
      show
    }
    stufenList
    stufenShow
    stufenTitle
    contactLine
    contactShow
    window
  }
  createDate
  updateDate
}
    `;
export const IssuedCertificateFieldsFragmentDoc = gql`
    fragment IssuedCertificateFields on IssuedCertificate {
  __typename
  id
  attendeeBadgeId
  courseId
  certificateTemplateId
  certificateNumber
  issuedAt
  issuedByUserId
  emailSentAt
  createDate
}
    `;
export const BookerCoreFieldsFragmentDoc = gql`
    fragment BookerCoreFields on Booker {
  __typename
  id
  erasedAt
  customerNumberPrefix
  customerNumber
  firstname
  lastname
  street
  houseNumber
  postCode
  city
  dsgvo
  newsletter
  email
  mobileNumber
  phoneNumber
  birthday
  gender
  initialContact
  healthInsuranceFund
  addition
  annotation
  credit
  nonDisclosureNotice
  userId
}
    `;
export const BookerPaymentMethodsFieldsFragmentDoc = gql`
    fragment BookerPaymentMethodsFields on Booker {
  paymentMethods {
    __typename
    id
    bankTransfer
    onlinePayment
    cash
    esr
    creditCardAccountholder
    creditcardNumber
    expirationDate
    validFrom
    cvc
    paypalAccountholder
    email
    iban
    bank
    bic
    sepaAccountholder
  }
}
    `;
export const BookerAttendeesFieldsFragmentDoc = gql`
    fragment BookerAttendeesFields on Booker {
  attendees {
    __typename
    firstname
    lastname
    id
    deletable
    addition
    annotation
    member
  }
}
    `;
export const ScheduledPaymentBadgeFragmentFragmentDoc = gql`
    fragment ScheduledPaymentBadgeFragment on ScheduledPayment {
  id
  paymentProvider
  molliePaymentStatus
  paymentDone
  paymentAmount
  providerRefundedAmount
  methodChangedAt
  methodChangedByUserId
  mollieMethod
  latestMolliePaymentAttempt {
    linkExpiresAt
    mollieMethod
  }
}
    `;
export const GetAreaManagerLocationsDocument = gql`
    query GetAreaManagerLocations {
  getAreaManagerLocations {
    id
    name
    city
  }
}
    `;

/**
 * __useGetAreaManagerLocationsQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAreaManagerLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerLocationsQuery, GetAreaManagerLocationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerLocationsQuery, GetAreaManagerLocationsQueryVariables>(GetAreaManagerLocationsDocument, baseOptions);
      }
export function useGetAreaManagerLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerLocationsQuery, GetAreaManagerLocationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerLocationsQuery, GetAreaManagerLocationsQueryVariables>(GetAreaManagerLocationsDocument, baseOptions);
        }
export type GetAreaManagerLocationsQueryHookResult = ReturnType<typeof useGetAreaManagerLocationsQuery>;
export type GetAreaManagerLocationsLazyQueryHookResult = ReturnType<typeof useGetAreaManagerLocationsLazyQuery>;
export type GetAreaManagerLocationsQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerLocationsQuery, GetAreaManagerLocationsQueryVariables>;
export const GetAreaManagerLocationStatsDocument = gql`
    query GetAreaManagerLocationStats($input: AreaManagerStatsInput) {
  getAreaManagerLocationStats(input: $input) {
    items {
      location {
        id
        name
        city
      }
      activeCourseCount
      totalMaxAttendees
      totalBookedAttendees
      utilizationPercent
    }
    total
  }
}
    `;

/**
 * __useGetAreaManagerLocationStatsQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerLocationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerLocationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerLocationStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAreaManagerLocationStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerLocationStatsQuery, GetAreaManagerLocationStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerLocationStatsQuery, GetAreaManagerLocationStatsQueryVariables>(GetAreaManagerLocationStatsDocument, baseOptions);
      }
export function useGetAreaManagerLocationStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerLocationStatsQuery, GetAreaManagerLocationStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerLocationStatsQuery, GetAreaManagerLocationStatsQueryVariables>(GetAreaManagerLocationStatsDocument, baseOptions);
        }
export type GetAreaManagerLocationStatsQueryHookResult = ReturnType<typeof useGetAreaManagerLocationStatsQuery>;
export type GetAreaManagerLocationStatsLazyQueryHookResult = ReturnType<typeof useGetAreaManagerLocationStatsLazyQuery>;
export type GetAreaManagerLocationStatsQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerLocationStatsQuery, GetAreaManagerLocationStatsQueryVariables>;
export const GetAreaManagerCoursesDocument = gql`
    query GetAreaManagerCourses($input: AreaManagerStatsInput) {
  getAreaManagerCourses(input: $input) {
    items {
      courseId
      courseNumber
      courseName
      locationName
      maxAttendees
      bookedAttendees
      utilizationPercent
      isActive
    }
    total
  }
}
    `;

/**
 * __useGetAreaManagerCoursesQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerCoursesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAreaManagerCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerCoursesQuery, GetAreaManagerCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerCoursesQuery, GetAreaManagerCoursesQueryVariables>(GetAreaManagerCoursesDocument, baseOptions);
      }
export function useGetAreaManagerCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerCoursesQuery, GetAreaManagerCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerCoursesQuery, GetAreaManagerCoursesQueryVariables>(GetAreaManagerCoursesDocument, baseOptions);
        }
export type GetAreaManagerCoursesQueryHookResult = ReturnType<typeof useGetAreaManagerCoursesQuery>;
export type GetAreaManagerCoursesLazyQueryHookResult = ReturnType<typeof useGetAreaManagerCoursesLazyQuery>;
export type GetAreaManagerCoursesQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerCoursesQuery, GetAreaManagerCoursesQueryVariables>;
export const GetAreaManagerInstructorStatsDocument = gql`
    query GetAreaManagerInstructorStats($input: AreaManagerStatsInput) {
  getAreaManagerInstructorStats(input: $input) {
    items {
      instructorId
      firstname
      lastname
      courseCount
      lessonCount
      totalHours
    }
    total
  }
}
    `;

/**
 * __useGetAreaManagerInstructorStatsQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerInstructorStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerInstructorStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerInstructorStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAreaManagerInstructorStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerInstructorStatsQuery, GetAreaManagerInstructorStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerInstructorStatsQuery, GetAreaManagerInstructorStatsQueryVariables>(GetAreaManagerInstructorStatsDocument, baseOptions);
      }
export function useGetAreaManagerInstructorStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerInstructorStatsQuery, GetAreaManagerInstructorStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerInstructorStatsQuery, GetAreaManagerInstructorStatsQueryVariables>(GetAreaManagerInstructorStatsDocument, baseOptions);
        }
export type GetAreaManagerInstructorStatsQueryHookResult = ReturnType<typeof useGetAreaManagerInstructorStatsQuery>;
export type GetAreaManagerInstructorStatsLazyQueryHookResult = ReturnType<typeof useGetAreaManagerInstructorStatsLazyQuery>;
export type GetAreaManagerInstructorStatsQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerInstructorStatsQuery, GetAreaManagerInstructorStatsQueryVariables>;
export const GetAreaManagerAssistantOverviewDocument = gql`
    query GetAreaManagerAssistantOverview($input: AreaManagerStatsInput) {
  getAreaManagerAssistantOverview(input: $input) {
    items {
      courseLessonId
      courseName
      courseNumber
      startDateTime
      totalSlots
      filledSlots
      openSlots
      assignedAssistants {
        assistantId
        firstname
        lastname
      }
    }
    total
  }
}
    `;

/**
 * __useGetAreaManagerAssistantOverviewQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerAssistantOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerAssistantOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerAssistantOverviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAreaManagerAssistantOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerAssistantOverviewQuery, GetAreaManagerAssistantOverviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerAssistantOverviewQuery, GetAreaManagerAssistantOverviewQueryVariables>(GetAreaManagerAssistantOverviewDocument, baseOptions);
      }
export function useGetAreaManagerAssistantOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerAssistantOverviewQuery, GetAreaManagerAssistantOverviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerAssistantOverviewQuery, GetAreaManagerAssistantOverviewQueryVariables>(GetAreaManagerAssistantOverviewDocument, baseOptions);
        }
export type GetAreaManagerAssistantOverviewQueryHookResult = ReturnType<typeof useGetAreaManagerAssistantOverviewQuery>;
export type GetAreaManagerAssistantOverviewLazyQueryHookResult = ReturnType<typeof useGetAreaManagerAssistantOverviewLazyQuery>;
export type GetAreaManagerAssistantOverviewQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerAssistantOverviewQuery, GetAreaManagerAssistantOverviewQueryVariables>;
export const GetAreaManagerVenueUtilizationDocument = gql`
    query GetAreaManagerVenueUtilization($input: AreaManagerStatsInput) {
  getAreaManagerVenueUtilization(input: $input) {
    items {
      venue {
        id
        name
      }
      locationName
      usedHours
    }
    total
  }
}
    `;

/**
 * __useGetAreaManagerVenueUtilizationQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerVenueUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerVenueUtilizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerVenueUtilizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAreaManagerVenueUtilizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerVenueUtilizationQuery, GetAreaManagerVenueUtilizationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerVenueUtilizationQuery, GetAreaManagerVenueUtilizationQueryVariables>(GetAreaManagerVenueUtilizationDocument, baseOptions);
      }
export function useGetAreaManagerVenueUtilizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerVenueUtilizationQuery, GetAreaManagerVenueUtilizationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerVenueUtilizationQuery, GetAreaManagerVenueUtilizationQueryVariables>(GetAreaManagerVenueUtilizationDocument, baseOptions);
        }
export type GetAreaManagerVenueUtilizationQueryHookResult = ReturnType<typeof useGetAreaManagerVenueUtilizationQuery>;
export type GetAreaManagerVenueUtilizationLazyQueryHookResult = ReturnType<typeof useGetAreaManagerVenueUtilizationLazyQuery>;
export type GetAreaManagerVenueUtilizationQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerVenueUtilizationQuery, GetAreaManagerVenueUtilizationQueryVariables>;
export const GetAreaManagerUpcomingLessonsDocument = gql`
    query GetAreaManagerUpcomingLessons($input: AreaManagerStatsInput) {
  getAreaManagerUpcomingLessons(input: $input) {
    id
    startDateTime
    endDateTime
    courseNumber
    prefixedCourseNumber
    courseName
  }
}
    `;

/**
 * __useGetAreaManagerUpcomingLessonsQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerUpcomingLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerUpcomingLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerUpcomingLessonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAreaManagerUpcomingLessonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerUpcomingLessonsQuery, GetAreaManagerUpcomingLessonsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerUpcomingLessonsQuery, GetAreaManagerUpcomingLessonsQueryVariables>(GetAreaManagerUpcomingLessonsDocument, baseOptions);
      }
export function useGetAreaManagerUpcomingLessonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerUpcomingLessonsQuery, GetAreaManagerUpcomingLessonsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerUpcomingLessonsQuery, GetAreaManagerUpcomingLessonsQueryVariables>(GetAreaManagerUpcomingLessonsDocument, baseOptions);
        }
export type GetAreaManagerUpcomingLessonsQueryHookResult = ReturnType<typeof useGetAreaManagerUpcomingLessonsQuery>;
export type GetAreaManagerUpcomingLessonsLazyQueryHookResult = ReturnType<typeof useGetAreaManagerUpcomingLessonsLazyQuery>;
export type GetAreaManagerUpcomingLessonsQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerUpcomingLessonsQuery, GetAreaManagerUpcomingLessonsQueryVariables>;
export const GetAreaManagerAssistantHierarchyDocument = gql`
    query GetAreaManagerAssistantHierarchy {
  getAreaManagerAssistantHierarchy {
    locations {
      locationId
      locationName
      courseCount
      lessonCount
      totalSlots
      filledSlots
      openSlots
      lessonsWithAssistants
      lessonsFullyStaffed
      lessonsPartiallyStaffed
      courseGroups {
        courseId
        courseNumber
        courseTypeName
        courseTypeColor
        dateRangeStart
        dateRangeEnd
        maxAssistantsPerLesson
        lessonCount
        totalSlots
        filledSlots
        openSlots
        needsAssistants
        lessonsWithAssistants
        lessonsFullyStaffed
        lessonsPartiallyStaffed
      }
    }
  }
}
    `;

/**
 * __useGetAreaManagerAssistantHierarchyQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerAssistantHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerAssistantHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerAssistantHierarchyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAreaManagerAssistantHierarchyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerAssistantHierarchyQuery, GetAreaManagerAssistantHierarchyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerAssistantHierarchyQuery, GetAreaManagerAssistantHierarchyQueryVariables>(GetAreaManagerAssistantHierarchyDocument, baseOptions);
      }
export function useGetAreaManagerAssistantHierarchyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerAssistantHierarchyQuery, GetAreaManagerAssistantHierarchyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerAssistantHierarchyQuery, GetAreaManagerAssistantHierarchyQueryVariables>(GetAreaManagerAssistantHierarchyDocument, baseOptions);
        }
export type GetAreaManagerAssistantHierarchyQueryHookResult = ReturnType<typeof useGetAreaManagerAssistantHierarchyQuery>;
export type GetAreaManagerAssistantHierarchyLazyQueryHookResult = ReturnType<typeof useGetAreaManagerAssistantHierarchyLazyQuery>;
export type GetAreaManagerAssistantHierarchyQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerAssistantHierarchyQuery, GetAreaManagerAssistantHierarchyQueryVariables>;
export const GetAreaManagerAssistantLessonsByCourseDocument = gql`
    query GetAreaManagerAssistantLessonsByCourse($input: AreaManagerAssistantLessonsInput!) {
  getAreaManagerAssistantLessonsByCourse(input: $input) {
    courseLessonId
    courseName
    courseNumber
    startDateTime
    totalSlots
    filledSlots
    openSlots
    assignedAssistants {
      assistantId
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useGetAreaManagerAssistantLessonsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerAssistantLessonsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerAssistantLessonsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerAssistantLessonsByCourseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAreaManagerAssistantLessonsByCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerAssistantLessonsByCourseQuery, GetAreaManagerAssistantLessonsByCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerAssistantLessonsByCourseQuery, GetAreaManagerAssistantLessonsByCourseQueryVariables>(GetAreaManagerAssistantLessonsByCourseDocument, baseOptions);
      }
export function useGetAreaManagerAssistantLessonsByCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerAssistantLessonsByCourseQuery, GetAreaManagerAssistantLessonsByCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerAssistantLessonsByCourseQuery, GetAreaManagerAssistantLessonsByCourseQueryVariables>(GetAreaManagerAssistantLessonsByCourseDocument, baseOptions);
        }
export type GetAreaManagerAssistantLessonsByCourseQueryHookResult = ReturnType<typeof useGetAreaManagerAssistantLessonsByCourseQuery>;
export type GetAreaManagerAssistantLessonsByCourseLazyQueryHookResult = ReturnType<typeof useGetAreaManagerAssistantLessonsByCourseLazyQuery>;
export type GetAreaManagerAssistantLessonsByCourseQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerAssistantLessonsByCourseQuery, GetAreaManagerAssistantLessonsByCourseQueryVariables>;
export const AssignInstructorToLessonFromControlBoardDocument = gql`
    mutation AssignInstructorToLessonFromControlBoard($input: AssignInstructorToLessonInput!) {
  assignInstructorToLessonFromControlBoard(input: $input)
}
    `;
export type AssignInstructorToLessonFromControlBoardMutationFn = ApolloReactCommon.MutationFunction<AssignInstructorToLessonFromControlBoardMutation, AssignInstructorToLessonFromControlBoardMutationVariables>;

/**
 * __useAssignInstructorToLessonFromControlBoardMutation__
 *
 * To run a mutation, you first call `useAssignInstructorToLessonFromControlBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignInstructorToLessonFromControlBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignInstructorToLessonFromControlBoardMutation, { data, loading, error }] = useAssignInstructorToLessonFromControlBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignInstructorToLessonFromControlBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignInstructorToLessonFromControlBoardMutation, AssignInstructorToLessonFromControlBoardMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignInstructorToLessonFromControlBoardMutation, AssignInstructorToLessonFromControlBoardMutationVariables>(AssignInstructorToLessonFromControlBoardDocument, baseOptions);
      }
export type AssignInstructorToLessonFromControlBoardMutationHookResult = ReturnType<typeof useAssignInstructorToLessonFromControlBoardMutation>;
export type AssignInstructorToLessonFromControlBoardMutationResult = ApolloReactCommon.MutationResult<AssignInstructorToLessonFromControlBoardMutation>;
export type AssignInstructorToLessonFromControlBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignInstructorToLessonFromControlBoardMutation, AssignInstructorToLessonFromControlBoardMutationVariables>;
export const AssignAssistantFromControlBoardDocument = gql`
    mutation AssignAssistantFromControlBoard($input: AssignAssistantInput!) {
  assignAssistantFromControlBoard(input: $input)
}
    `;
export type AssignAssistantFromControlBoardMutationFn = ApolloReactCommon.MutationFunction<AssignAssistantFromControlBoardMutation, AssignAssistantFromControlBoardMutationVariables>;

/**
 * __useAssignAssistantFromControlBoardMutation__
 *
 * To run a mutation, you first call `useAssignAssistantFromControlBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAssistantFromControlBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAssistantFromControlBoardMutation, { data, loading, error }] = useAssignAssistantFromControlBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignAssistantFromControlBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignAssistantFromControlBoardMutation, AssignAssistantFromControlBoardMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignAssistantFromControlBoardMutation, AssignAssistantFromControlBoardMutationVariables>(AssignAssistantFromControlBoardDocument, baseOptions);
      }
export type AssignAssistantFromControlBoardMutationHookResult = ReturnType<typeof useAssignAssistantFromControlBoardMutation>;
export type AssignAssistantFromControlBoardMutationResult = ApolloReactCommon.MutationResult<AssignAssistantFromControlBoardMutation>;
export type AssignAssistantFromControlBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignAssistantFromControlBoardMutation, AssignAssistantFromControlBoardMutationVariables>;
export const RemoveAssistantFromControlBoardDocument = gql`
    mutation RemoveAssistantFromControlBoard($input: AssignAssistantInput!) {
  removeAssistantFromControlBoard(input: $input)
}
    `;
export type RemoveAssistantFromControlBoardMutationFn = ApolloReactCommon.MutationFunction<RemoveAssistantFromControlBoardMutation, RemoveAssistantFromControlBoardMutationVariables>;

/**
 * __useRemoveAssistantFromControlBoardMutation__
 *
 * To run a mutation, you first call `useRemoveAssistantFromControlBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssistantFromControlBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssistantFromControlBoardMutation, { data, loading, error }] = useRemoveAssistantFromControlBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAssistantFromControlBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAssistantFromControlBoardMutation, RemoveAssistantFromControlBoardMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveAssistantFromControlBoardMutation, RemoveAssistantFromControlBoardMutationVariables>(RemoveAssistantFromControlBoardDocument, baseOptions);
      }
export type RemoveAssistantFromControlBoardMutationHookResult = ReturnType<typeof useRemoveAssistantFromControlBoardMutation>;
export type RemoveAssistantFromControlBoardMutationResult = ApolloReactCommon.MutationResult<RemoveAssistantFromControlBoardMutation>;
export type RemoveAssistantFromControlBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAssistantFromControlBoardMutation, RemoveAssistantFromControlBoardMutationVariables>;
export const GetCourseLessonsForAssistantAppDocument = gql`
    query GetCourseLessonsForAssistantApp($filters: AssistantCourseLessonFilterInput) {
  getCourseLessonsForAssistantApp(filters: $filters) {
    courseLesson {
      id
      startDateTime
      endDateTime
      course {
        id
        prefixedCourseNumber
        maxAssistantsPerLesson
        courseType {
          id
          name
        }
      }
      location {
        id
        name
        city
      }
      venue {
        id
        name
      }
      instructors {
        id
        firstname
        lastname
      }
    }
    assistantSlotsUsed
    assistantSlotsMax
    isAssignedToMe
    assignedAssistants {
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useGetCourseLessonsForAssistantAppQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsForAssistantAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsForAssistantAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsForAssistantAppQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCourseLessonsForAssistantAppQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsForAssistantAppQuery, GetCourseLessonsForAssistantAppQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsForAssistantAppQuery, GetCourseLessonsForAssistantAppQueryVariables>(GetCourseLessonsForAssistantAppDocument, baseOptions);
      }
export function useGetCourseLessonsForAssistantAppLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsForAssistantAppQuery, GetCourseLessonsForAssistantAppQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsForAssistantAppQuery, GetCourseLessonsForAssistantAppQueryVariables>(GetCourseLessonsForAssistantAppDocument, baseOptions);
        }
export type GetCourseLessonsForAssistantAppQueryHookResult = ReturnType<typeof useGetCourseLessonsForAssistantAppQuery>;
export type GetCourseLessonsForAssistantAppLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsForAssistantAppLazyQuery>;
export type GetCourseLessonsForAssistantAppQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsForAssistantAppQuery, GetCourseLessonsForAssistantAppQueryVariables>;
export const GetMyAssignmentsAssistantAppDocument = gql`
    query GetMyAssignmentsAssistantApp($includePast: Boolean) {
  getMyAssignmentsAssistantApp(includePast: $includePast) {
    courseLesson {
      id
      startDateTime
      endDateTime
      course {
        id
        prefixedCourseNumber
        maxAssistantsPerLesson
        courseType {
          id
          name
        }
      }
      location {
        id
        name
        city
      }
      venue {
        id
        name
      }
      instructors {
        id
        firstname
        lastname
      }
    }
    assistantSlotsUsed
    assistantSlotsMax
    isAssignedToMe
    assignedAssistants {
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useGetMyAssignmentsAssistantAppQuery__
 *
 * To run a query within a React component, call `useGetMyAssignmentsAssistantAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAssignmentsAssistantAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAssignmentsAssistantAppQuery({
 *   variables: {
 *      includePast: // value for 'includePast'
 *   },
 * });
 */
export function useGetMyAssignmentsAssistantAppQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyAssignmentsAssistantAppQuery, GetMyAssignmentsAssistantAppQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyAssignmentsAssistantAppQuery, GetMyAssignmentsAssistantAppQueryVariables>(GetMyAssignmentsAssistantAppDocument, baseOptions);
      }
export function useGetMyAssignmentsAssistantAppLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyAssignmentsAssistantAppQuery, GetMyAssignmentsAssistantAppQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyAssignmentsAssistantAppQuery, GetMyAssignmentsAssistantAppQueryVariables>(GetMyAssignmentsAssistantAppDocument, baseOptions);
        }
export type GetMyAssignmentsAssistantAppQueryHookResult = ReturnType<typeof useGetMyAssignmentsAssistantAppQuery>;
export type GetMyAssignmentsAssistantAppLazyQueryHookResult = ReturnType<typeof useGetMyAssignmentsAssistantAppLazyQuery>;
export type GetMyAssignmentsAssistantAppQueryResult = ApolloReactCommon.QueryResult<GetMyAssignmentsAssistantAppQuery, GetMyAssignmentsAssistantAppQueryVariables>;
export const AssignMyselfToCourseLessonAssistantAppDocument = gql`
    mutation AssignMyselfToCourseLessonAssistantApp($courseLessonId: ID!) {
  assignMyselfToCourseLessonAssistantApp(courseLessonId: $courseLessonId)
}
    `;
export type AssignMyselfToCourseLessonAssistantAppMutationFn = ApolloReactCommon.MutationFunction<AssignMyselfToCourseLessonAssistantAppMutation, AssignMyselfToCourseLessonAssistantAppMutationVariables>;

/**
 * __useAssignMyselfToCourseLessonAssistantAppMutation__
 *
 * To run a mutation, you first call `useAssignMyselfToCourseLessonAssistantAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMyselfToCourseLessonAssistantAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMyselfToCourseLessonAssistantAppMutation, { data, loading, error }] = useAssignMyselfToCourseLessonAssistantAppMutation({
 *   variables: {
 *      courseLessonId: // value for 'courseLessonId'
 *   },
 * });
 */
export function useAssignMyselfToCourseLessonAssistantAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignMyselfToCourseLessonAssistantAppMutation, AssignMyselfToCourseLessonAssistantAppMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignMyselfToCourseLessonAssistantAppMutation, AssignMyselfToCourseLessonAssistantAppMutationVariables>(AssignMyselfToCourseLessonAssistantAppDocument, baseOptions);
      }
export type AssignMyselfToCourseLessonAssistantAppMutationHookResult = ReturnType<typeof useAssignMyselfToCourseLessonAssistantAppMutation>;
export type AssignMyselfToCourseLessonAssistantAppMutationResult = ApolloReactCommon.MutationResult<AssignMyselfToCourseLessonAssistantAppMutation>;
export type AssignMyselfToCourseLessonAssistantAppMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignMyselfToCourseLessonAssistantAppMutation, AssignMyselfToCourseLessonAssistantAppMutationVariables>;
export const UnassignMyselfFromCourseLessonAssistantAppDocument = gql`
    mutation UnassignMyselfFromCourseLessonAssistantApp($courseLessonId: ID!) {
  unassignMyselfFromCourseLessonAssistantApp(courseLessonId: $courseLessonId)
}
    `;
export type UnassignMyselfFromCourseLessonAssistantAppMutationFn = ApolloReactCommon.MutationFunction<UnassignMyselfFromCourseLessonAssistantAppMutation, UnassignMyselfFromCourseLessonAssistantAppMutationVariables>;

/**
 * __useUnassignMyselfFromCourseLessonAssistantAppMutation__
 *
 * To run a mutation, you first call `useUnassignMyselfFromCourseLessonAssistantAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignMyselfFromCourseLessonAssistantAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignMyselfFromCourseLessonAssistantAppMutation, { data, loading, error }] = useUnassignMyselfFromCourseLessonAssistantAppMutation({
 *   variables: {
 *      courseLessonId: // value for 'courseLessonId'
 *   },
 * });
 */
export function useUnassignMyselfFromCourseLessonAssistantAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnassignMyselfFromCourseLessonAssistantAppMutation, UnassignMyselfFromCourseLessonAssistantAppMutationVariables>) {
        return ApolloReactHooks.useMutation<UnassignMyselfFromCourseLessonAssistantAppMutation, UnassignMyselfFromCourseLessonAssistantAppMutationVariables>(UnassignMyselfFromCourseLessonAssistantAppDocument, baseOptions);
      }
export type UnassignMyselfFromCourseLessonAssistantAppMutationHookResult = ReturnType<typeof useUnassignMyselfFromCourseLessonAssistantAppMutation>;
export type UnassignMyselfFromCourseLessonAssistantAppMutationResult = ApolloReactCommon.MutationResult<UnassignMyselfFromCourseLessonAssistantAppMutation>;
export type UnassignMyselfFromCourseLessonAssistantAppMutationOptions = ApolloReactCommon.BaseMutationOptions<UnassignMyselfFromCourseLessonAssistantAppMutation, UnassignMyselfFromCourseLessonAssistantAppMutationVariables>;
export const GetAssistantAssignedLocationsDocument = gql`
    query GetAssistantAssignedLocations {
  getAssistantAssignedLocations {
    id
    name
    city
  }
}
    `;

/**
 * __useGetAssistantAssignedLocationsQuery__
 *
 * To run a query within a React component, call `useGetAssistantAssignedLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantAssignedLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantAssignedLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssistantAssignedLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAssistantAssignedLocationsQuery, GetAssistantAssignedLocationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAssistantAssignedLocationsQuery, GetAssistantAssignedLocationsQueryVariables>(GetAssistantAssignedLocationsDocument, baseOptions);
      }
export function useGetAssistantAssignedLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAssistantAssignedLocationsQuery, GetAssistantAssignedLocationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAssistantAssignedLocationsQuery, GetAssistantAssignedLocationsQueryVariables>(GetAssistantAssignedLocationsDocument, baseOptions);
        }
export type GetAssistantAssignedLocationsQueryHookResult = ReturnType<typeof useGetAssistantAssignedLocationsQuery>;
export type GetAssistantAssignedLocationsLazyQueryHookResult = ReturnType<typeof useGetAssistantAssignedLocationsLazyQuery>;
export type GetAssistantAssignedLocationsQueryResult = ApolloReactCommon.QueryResult<GetAssistantAssignedLocationsQuery, GetAssistantAssignedLocationsQueryVariables>;
export const GetSelectableLocationsForAssistantAppDocument = gql`
    query GetSelectableLocationsForAssistantApp {
  getSelectableLocationsForAssistantApp {
    id
    name
    city
    isAssigned
  }
}
    `;

/**
 * __useGetSelectableLocationsForAssistantAppQuery__
 *
 * To run a query within a React component, call `useGetSelectableLocationsForAssistantAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectableLocationsForAssistantAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectableLocationsForAssistantAppQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelectableLocationsForAssistantAppQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSelectableLocationsForAssistantAppQuery, GetSelectableLocationsForAssistantAppQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSelectableLocationsForAssistantAppQuery, GetSelectableLocationsForAssistantAppQueryVariables>(GetSelectableLocationsForAssistantAppDocument, baseOptions);
      }
export function useGetSelectableLocationsForAssistantAppLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSelectableLocationsForAssistantAppQuery, GetSelectableLocationsForAssistantAppQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSelectableLocationsForAssistantAppQuery, GetSelectableLocationsForAssistantAppQueryVariables>(GetSelectableLocationsForAssistantAppDocument, baseOptions);
        }
export type GetSelectableLocationsForAssistantAppQueryHookResult = ReturnType<typeof useGetSelectableLocationsForAssistantAppQuery>;
export type GetSelectableLocationsForAssistantAppLazyQueryHookResult = ReturnType<typeof useGetSelectableLocationsForAssistantAppLazyQuery>;
export type GetSelectableLocationsForAssistantAppQueryResult = ApolloReactCommon.QueryResult<GetSelectableLocationsForAssistantAppQuery, GetSelectableLocationsForAssistantAppQueryVariables>;
export const GetAttendeesForCertificateAssignDocument = gql`
    query GetAttendeesForCertificateAssign($options: ArrayDataOptions) {
  attendees(options: $options) {
    existsMore
    total
    items {
      id
      customerNumberPrefix
      customerNumber
      firstname
      lastname
      birthday
      gender
      member
      addition
      annotation
      bookingsKo9 {
        id
        courseNumber
        courseName
        firstCourseLesson
      }
      booker {
        id
        firstname
        lastname
        email
        nonDisclosureNotice
      }
      badgeXAttendee {
        id
        badge {
          id
          name
          color
          abbreviation
          badgeRequirements {
            id
            name
            sortOrder
          }
        }
        attendeeBadgeRequirements {
          id
          fulfilled
        }
      }
    }
  }
}
    `;

/**
 * __useGetAttendeesForCertificateAssignQuery__
 *
 * To run a query within a React component, call `useGetAttendeesForCertificateAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeesForCertificateAssignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeesForCertificateAssignQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetAttendeesForCertificateAssignQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeesForCertificateAssignQuery, GetAttendeesForCertificateAssignQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeesForCertificateAssignQuery, GetAttendeesForCertificateAssignQueryVariables>(GetAttendeesForCertificateAssignDocument, baseOptions);
      }
export function useGetAttendeesForCertificateAssignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeesForCertificateAssignQuery, GetAttendeesForCertificateAssignQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeesForCertificateAssignQuery, GetAttendeesForCertificateAssignQueryVariables>(GetAttendeesForCertificateAssignDocument, baseOptions);
        }
export type GetAttendeesForCertificateAssignQueryHookResult = ReturnType<typeof useGetAttendeesForCertificateAssignQuery>;
export type GetAttendeesForCertificateAssignLazyQueryHookResult = ReturnType<typeof useGetAttendeesForCertificateAssignLazyQuery>;
export type GetAttendeesForCertificateAssignQueryResult = ApolloReactCommon.QueryResult<GetAttendeesForCertificateAssignQuery, GetAttendeesForCertificateAssignQueryVariables>;
export const CertCourseAttendanceListDocument = gql`
    query CertCourseAttendanceList($courseId: String!) {
  attendanceListByCourse(courseId: $courseId) {
    id
    courseId
    attendee {
      id
      firstname
      lastname
      customerNumberPrefix
      customerNumber
      birthday
      gender
      member
      addition
      annotation
      bookingsKo9 {
        id
        courseNumber
        courseName
        firstCourseLesson
      }
      booker {
        id
        firstname
        lastname
        email
        nonDisclosureNotice
      }
      badgeXAttendee {
        id
        badge {
          id
          name
          color
          abbreviation
          badgeRequirements {
            id
            name
            sortOrder
          }
        }
        attendeeBadgeRequirements {
          id
          fulfilled
        }
      }
    }
  }
}
    `;

/**
 * __useCertCourseAttendanceListQuery__
 *
 * To run a query within a React component, call `useCertCourseAttendanceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertCourseAttendanceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertCourseAttendanceListQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCertCourseAttendanceListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CertCourseAttendanceListQuery, CertCourseAttendanceListQueryVariables>) {
        return ApolloReactHooks.useQuery<CertCourseAttendanceListQuery, CertCourseAttendanceListQueryVariables>(CertCourseAttendanceListDocument, baseOptions);
      }
export function useCertCourseAttendanceListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CertCourseAttendanceListQuery, CertCourseAttendanceListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CertCourseAttendanceListQuery, CertCourseAttendanceListQueryVariables>(CertCourseAttendanceListDocument, baseOptions);
        }
export type CertCourseAttendanceListQueryHookResult = ReturnType<typeof useCertCourseAttendanceListQuery>;
export type CertCourseAttendanceListLazyQueryHookResult = ReturnType<typeof useCertCourseAttendanceListLazyQuery>;
export type CertCourseAttendanceListQueryResult = ApolloReactCommon.QueryResult<CertCourseAttendanceListQuery, CertCourseAttendanceListQueryVariables>;
export const CreateAttendeeBadgeDocument = gql`
    mutation createAttendeeBadge($newAttendeeBadgeInput: NewAttendeeBadgeInput!) {
  createAttendeeBadge(newAttendeeBadgeInput: $newAttendeeBadgeInput) {
    id
  }
}
    `;
export type CreateAttendeeBadgeMutationFn = ApolloReactCommon.MutationFunction<CreateAttendeeBadgeMutation, CreateAttendeeBadgeMutationVariables>;

/**
 * __useCreateAttendeeBadgeMutation__
 *
 * To run a mutation, you first call `useCreateAttendeeBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttendeeBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttendeeBadgeMutation, { data, loading, error }] = useCreateAttendeeBadgeMutation({
 *   variables: {
 *      newAttendeeBadgeInput: // value for 'newAttendeeBadgeInput'
 *   },
 * });
 */
export function useCreateAttendeeBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAttendeeBadgeMutation, CreateAttendeeBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAttendeeBadgeMutation, CreateAttendeeBadgeMutationVariables>(CreateAttendeeBadgeDocument, baseOptions);
      }
export type CreateAttendeeBadgeMutationHookResult = ReturnType<typeof useCreateAttendeeBadgeMutation>;
export type CreateAttendeeBadgeMutationResult = ApolloReactCommon.MutationResult<CreateAttendeeBadgeMutation>;
export type CreateAttendeeBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAttendeeBadgeMutation, CreateAttendeeBadgeMutationVariables>;
export const UpdateAttendeeBadgeDocument = gql`
    mutation updateAttendeeBadge($editAttendeeBadgeInput: EditAttendeeBadgeInput!) {
  updateAttendeeBadge(editAttendeeBadgeInput: $editAttendeeBadgeInput) {
    id
  }
}
    `;
export type UpdateAttendeeBadgeMutationFn = ApolloReactCommon.MutationFunction<UpdateAttendeeBadgeMutation, UpdateAttendeeBadgeMutationVariables>;

/**
 * __useUpdateAttendeeBadgeMutation__
 *
 * To run a mutation, you first call `useUpdateAttendeeBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendeeBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttendeeBadgeMutation, { data, loading, error }] = useUpdateAttendeeBadgeMutation({
 *   variables: {
 *      editAttendeeBadgeInput: // value for 'editAttendeeBadgeInput'
 *   },
 * });
 */
export function useUpdateAttendeeBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAttendeeBadgeMutation, UpdateAttendeeBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAttendeeBadgeMutation, UpdateAttendeeBadgeMutationVariables>(UpdateAttendeeBadgeDocument, baseOptions);
      }
export type UpdateAttendeeBadgeMutationHookResult = ReturnType<typeof useUpdateAttendeeBadgeMutation>;
export type UpdateAttendeeBadgeMutationResult = ApolloReactCommon.MutationResult<UpdateAttendeeBadgeMutation>;
export type UpdateAttendeeBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAttendeeBadgeMutation, UpdateAttendeeBadgeMutationVariables>;
export const DeleteAttendeeBadgeDocument = gql`
    mutation deleteAttendeeBadge($id: String!) {
  deleteAttendeeBadge(id: $id)
}
    `;
export type DeleteAttendeeBadgeMutationFn = ApolloReactCommon.MutationFunction<DeleteAttendeeBadgeMutation, DeleteAttendeeBadgeMutationVariables>;

/**
 * __useDeleteAttendeeBadgeMutation__
 *
 * To run a mutation, you first call `useDeleteAttendeeBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendeeBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendeeBadgeMutation, { data, loading, error }] = useDeleteAttendeeBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttendeeBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAttendeeBadgeMutation, DeleteAttendeeBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAttendeeBadgeMutation, DeleteAttendeeBadgeMutationVariables>(DeleteAttendeeBadgeDocument, baseOptions);
      }
export type DeleteAttendeeBadgeMutationHookResult = ReturnType<typeof useDeleteAttendeeBadgeMutation>;
export type DeleteAttendeeBadgeMutationResult = ApolloReactCommon.MutationResult<DeleteAttendeeBadgeMutation>;
export type DeleteAttendeeBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAttendeeBadgeMutation, DeleteAttendeeBadgeMutationVariables>;
export const GetAttendeeBadgeDocument = gql`
    query getAttendeeBadge($id: String!) {
  getAttendeeBadge(id: $id) {
    id
    badge {
      id
      name
      certificateTemplateId
    }
    attendee {
      id
    }
    comment
    dateOfAchivement
    courseId
    allRequirementsFulfilled
    attendeeBadgeRequirements {
      id
      badgeRequirementId
      badgeRequirement {
        id
        name
        sortOrder
      }
      fulfilled
      dateOfFulfillment
      comment
    }
  }
}
    `;

/**
 * __useGetAttendeeBadgeQuery__
 *
 * To run a query within a React component, call `useGetAttendeeBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeBadgeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttendeeBadgeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeBadgeQuery, GetAttendeeBadgeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeBadgeQuery, GetAttendeeBadgeQueryVariables>(GetAttendeeBadgeDocument, baseOptions);
      }
export function useGetAttendeeBadgeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeBadgeQuery, GetAttendeeBadgeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeBadgeQuery, GetAttendeeBadgeQueryVariables>(GetAttendeeBadgeDocument, baseOptions);
        }
export type GetAttendeeBadgeQueryHookResult = ReturnType<typeof useGetAttendeeBadgeQuery>;
export type GetAttendeeBadgeLazyQueryHookResult = ReturnType<typeof useGetAttendeeBadgeLazyQuery>;
export type GetAttendeeBadgeQueryResult = ApolloReactCommon.QueryResult<GetAttendeeBadgeQuery, GetAttendeeBadgeQueryVariables>;
export const GetAttendeeBadgesByAttendeeIdDocument = gql`
    query getAttendeeBadgesByAttendeeId($attendeeId: String!) {
  getAttendeeBadgesByAttendeeId(attendeeId: $attendeeId) {
    id
    badge {
      id
      name
      color
      abbreviation
      graphicUrl
      signedGraphicUrl
    }
    attendee {
      id
    }
    comment
    dateOfAchivement
    courseId
    allRequirementsFulfilled
    attendeeBadgeRequirements {
      id
      badgeRequirementId
      badgeRequirement {
        id
        name
        sortOrder
      }
      fulfilled
      dateOfFulfillment
      comment
    }
  }
}
    `;

/**
 * __useGetAttendeeBadgesByAttendeeIdQuery__
 *
 * To run a query within a React component, call `useGetAttendeeBadgesByAttendeeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeBadgesByAttendeeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeBadgesByAttendeeIdQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useGetAttendeeBadgesByAttendeeIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeBadgesByAttendeeIdQuery, GetAttendeeBadgesByAttendeeIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeBadgesByAttendeeIdQuery, GetAttendeeBadgesByAttendeeIdQueryVariables>(GetAttendeeBadgesByAttendeeIdDocument, baseOptions);
      }
export function useGetAttendeeBadgesByAttendeeIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeBadgesByAttendeeIdQuery, GetAttendeeBadgesByAttendeeIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeBadgesByAttendeeIdQuery, GetAttendeeBadgesByAttendeeIdQueryVariables>(GetAttendeeBadgesByAttendeeIdDocument, baseOptions);
        }
export type GetAttendeeBadgesByAttendeeIdQueryHookResult = ReturnType<typeof useGetAttendeeBadgesByAttendeeIdQuery>;
export type GetAttendeeBadgesByAttendeeIdLazyQueryHookResult = ReturnType<typeof useGetAttendeeBadgesByAttendeeIdLazyQuery>;
export type GetAttendeeBadgesByAttendeeIdQueryResult = ApolloReactCommon.QueryResult<GetAttendeeBadgesByAttendeeIdQuery, GetAttendeeBadgesByAttendeeIdQueryVariables>;
export const ToggleAttendeeBadgeRequirementDocument = gql`
    mutation toggleAttendeeBadgeRequirement($input: ToggleAttendeeBadgeRequirementInput!) {
  toggleAttendeeBadgeRequirement(input: $input) {
    id
    fulfilled
    dateOfFulfillment
    comment
  }
}
    `;
export type ToggleAttendeeBadgeRequirementMutationFn = ApolloReactCommon.MutationFunction<ToggleAttendeeBadgeRequirementMutation, ToggleAttendeeBadgeRequirementMutationVariables>;

/**
 * __useToggleAttendeeBadgeRequirementMutation__
 *
 * To run a mutation, you first call `useToggleAttendeeBadgeRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAttendeeBadgeRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAttendeeBadgeRequirementMutation, { data, loading, error }] = useToggleAttendeeBadgeRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleAttendeeBadgeRequirementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleAttendeeBadgeRequirementMutation, ToggleAttendeeBadgeRequirementMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleAttendeeBadgeRequirementMutation, ToggleAttendeeBadgeRequirementMutationVariables>(ToggleAttendeeBadgeRequirementDocument, baseOptions);
      }
export type ToggleAttendeeBadgeRequirementMutationHookResult = ReturnType<typeof useToggleAttendeeBadgeRequirementMutation>;
export type ToggleAttendeeBadgeRequirementMutationResult = ApolloReactCommon.MutationResult<ToggleAttendeeBadgeRequirementMutation>;
export type ToggleAttendeeBadgeRequirementMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleAttendeeBadgeRequirementMutation, ToggleAttendeeBadgeRequirementMutationVariables>;
export const GetAttendeeBadgesByBadgeIdDocument = gql`
    query getAttendeeBadgesByBadgeId($badgeId: String!) {
  getAttendeeBadgesByBadgeId(badgeId: $badgeId) {
    id
    attendee {
      id
      firstname
      lastname
    }
    allRequirementsFulfilled
    dateOfAchivement
    attendeeBadgeRequirements {
      id
      badgeRequirementId
      badgeRequirement {
        id
        name
        sortOrder
      }
      fulfilled
      dateOfFulfillment
      comment
    }
  }
}
    `;

/**
 * __useGetAttendeeBadgesByBadgeIdQuery__
 *
 * To run a query within a React component, call `useGetAttendeeBadgesByBadgeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeBadgesByBadgeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeBadgesByBadgeIdQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useGetAttendeeBadgesByBadgeIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeBadgesByBadgeIdQuery, GetAttendeeBadgesByBadgeIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeBadgesByBadgeIdQuery, GetAttendeeBadgesByBadgeIdQueryVariables>(GetAttendeeBadgesByBadgeIdDocument, baseOptions);
      }
export function useGetAttendeeBadgesByBadgeIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeBadgesByBadgeIdQuery, GetAttendeeBadgesByBadgeIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeBadgesByBadgeIdQuery, GetAttendeeBadgesByBadgeIdQueryVariables>(GetAttendeeBadgesByBadgeIdDocument, baseOptions);
        }
export type GetAttendeeBadgesByBadgeIdQueryHookResult = ReturnType<typeof useGetAttendeeBadgesByBadgeIdQuery>;
export type GetAttendeeBadgesByBadgeIdLazyQueryHookResult = ReturnType<typeof useGetAttendeeBadgesByBadgeIdLazyQuery>;
export type GetAttendeeBadgesByBadgeIdQueryResult = ApolloReactCommon.QueryResult<GetAttendeeBadgesByBadgeIdQuery, GetAttendeeBadgesByBadgeIdQueryVariables>;
export const BulkToggleAttendeeBadgeRequirementDocument = gql`
    mutation bulkToggleAttendeeBadgeRequirement($input: BulkToggleAttendeeBadgeRequirementInput!) {
  bulkToggleAttendeeBadgeRequirement(input: $input) {
    id
    fulfilled
    dateOfFulfillment
  }
}
    `;
export type BulkToggleAttendeeBadgeRequirementMutationFn = ApolloReactCommon.MutationFunction<BulkToggleAttendeeBadgeRequirementMutation, BulkToggleAttendeeBadgeRequirementMutationVariables>;

/**
 * __useBulkToggleAttendeeBadgeRequirementMutation__
 *
 * To run a mutation, you first call `useBulkToggleAttendeeBadgeRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkToggleAttendeeBadgeRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkToggleAttendeeBadgeRequirementMutation, { data, loading, error }] = useBulkToggleAttendeeBadgeRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkToggleAttendeeBadgeRequirementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkToggleAttendeeBadgeRequirementMutation, BulkToggleAttendeeBadgeRequirementMutationVariables>) {
        return ApolloReactHooks.useMutation<BulkToggleAttendeeBadgeRequirementMutation, BulkToggleAttendeeBadgeRequirementMutationVariables>(BulkToggleAttendeeBadgeRequirementDocument, baseOptions);
      }
export type BulkToggleAttendeeBadgeRequirementMutationHookResult = ReturnType<typeof useBulkToggleAttendeeBadgeRequirementMutation>;
export type BulkToggleAttendeeBadgeRequirementMutationResult = ApolloReactCommon.MutationResult<BulkToggleAttendeeBadgeRequirementMutation>;
export type BulkToggleAttendeeBadgeRequirementMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkToggleAttendeeBadgeRequirementMutation, BulkToggleAttendeeBadgeRequirementMutationVariables>;
export const BulkCreateAttendeeBadgesDocument = gql`
    mutation bulkCreateAttendeeBadges($input: BulkCreateAttendeeBadgeInput!) {
  bulkCreateAttendeeBadges(input: $input) {
    id
  }
}
    `;
export type BulkCreateAttendeeBadgesMutationFn = ApolloReactCommon.MutationFunction<BulkCreateAttendeeBadgesMutation, BulkCreateAttendeeBadgesMutationVariables>;

/**
 * __useBulkCreateAttendeeBadgesMutation__
 *
 * To run a mutation, you first call `useBulkCreateAttendeeBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateAttendeeBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateAttendeeBadgesMutation, { data, loading, error }] = useBulkCreateAttendeeBadgesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateAttendeeBadgesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkCreateAttendeeBadgesMutation, BulkCreateAttendeeBadgesMutationVariables>) {
        return ApolloReactHooks.useMutation<BulkCreateAttendeeBadgesMutation, BulkCreateAttendeeBadgesMutationVariables>(BulkCreateAttendeeBadgesDocument, baseOptions);
      }
export type BulkCreateAttendeeBadgesMutationHookResult = ReturnType<typeof useBulkCreateAttendeeBadgesMutation>;
export type BulkCreateAttendeeBadgesMutationResult = ApolloReactCommon.MutationResult<BulkCreateAttendeeBadgesMutation>;
export type BulkCreateAttendeeBadgesMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkCreateAttendeeBadgesMutation, BulkCreateAttendeeBadgesMutationVariables>;
export const UpsertAttendeeBadgesWithRequirementsDocument = gql`
    mutation upsertAttendeeBadgesWithRequirements($input: UpsertAttendeeBadgesWithRequirementsInput!) {
  upsertAttendeeBadgesWithRequirements(input: $input) {
    id
    attendeeId
    badgeId
    dateOfAchivement
    allRequirementsFulfilled
    attendeeBadgeRequirements {
      id
      badgeRequirementId
      fulfilled
      dateOfFulfillment
      comment
    }
  }
}
    `;
export type UpsertAttendeeBadgesWithRequirementsMutationFn = ApolloReactCommon.MutationFunction<UpsertAttendeeBadgesWithRequirementsMutation, UpsertAttendeeBadgesWithRequirementsMutationVariables>;

/**
 * __useUpsertAttendeeBadgesWithRequirementsMutation__
 *
 * To run a mutation, you first call `useUpsertAttendeeBadgesWithRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAttendeeBadgesWithRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAttendeeBadgesWithRequirementsMutation, { data, loading, error }] = useUpsertAttendeeBadgesWithRequirementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAttendeeBadgesWithRequirementsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertAttendeeBadgesWithRequirementsMutation, UpsertAttendeeBadgesWithRequirementsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpsertAttendeeBadgesWithRequirementsMutation, UpsertAttendeeBadgesWithRequirementsMutationVariables>(UpsertAttendeeBadgesWithRequirementsDocument, baseOptions);
      }
export type UpsertAttendeeBadgesWithRequirementsMutationHookResult = ReturnType<typeof useUpsertAttendeeBadgesWithRequirementsMutation>;
export type UpsertAttendeeBadgesWithRequirementsMutationResult = ApolloReactCommon.MutationResult<UpsertAttendeeBadgesWithRequirementsMutation>;
export type UpsertAttendeeBadgesWithRequirementsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertAttendeeBadgesWithRequirementsMutation, UpsertAttendeeBadgesWithRequirementsMutationVariables>;
export const GetBadgeDocument = gql`
    query getBadge($id: String!) {
  badge(id: $id) {
    id
    name
    abbreviation
    color
    graphicUrl
    signedGraphicUrl
    description
    certificateTemplateId
    badgeGroupId
    createDate
    updateDate
    createdByUserId
    updatedByUserId
    rank
    badgeRequirements {
      id
      name
      sortOrder
    }
  }
}
    `;

/**
 * __useGetBadgeQuery__
 *
 * To run a query within a React component, call `useGetBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBadgeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBadgeQuery, GetBadgeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBadgeQuery, GetBadgeQueryVariables>(GetBadgeDocument, baseOptions);
      }
export function useGetBadgeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBadgeQuery, GetBadgeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBadgeQuery, GetBadgeQueryVariables>(GetBadgeDocument, baseOptions);
        }
export type GetBadgeQueryHookResult = ReturnType<typeof useGetBadgeQuery>;
export type GetBadgeLazyQueryHookResult = ReturnType<typeof useGetBadgeLazyQuery>;
export type GetBadgeQueryResult = ApolloReactCommon.QueryResult<GetBadgeQuery, GetBadgeQueryVariables>;
export const GetBadgesDocument = gql`
    query getBadges {
  badges {
    id
    name
    abbreviation
    color
    graphicUrl
    signedGraphicUrl
    description
    certificateTemplateId
    badgeGroupId
    createDate
    updateDate
    createdByUserId
    updatedByUserId
    rank
    badgeRequirements {
      id
      name
      sortOrder
    }
  }
}
    `;

/**
 * __useGetBadgesQuery__
 *
 * To run a query within a React component, call `useGetBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBadgesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, baseOptions);
      }
export function useGetBadgesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, baseOptions);
        }
export type GetBadgesQueryHookResult = ReturnType<typeof useGetBadgesQuery>;
export type GetBadgesLazyQueryHookResult = ReturnType<typeof useGetBadgesLazyQuery>;
export type GetBadgesQueryResult = ApolloReactCommon.QueryResult<GetBadgesQuery, GetBadgesQueryVariables>;
export const CreateBadgeDocument = gql`
    mutation createBadge($newBadgeInput: NewBadgeInput!) {
  createBadge(newBadgeInput: $newBadgeInput) {
    id
    name
    abbreviation
    color
    description
    certificateTemplateId
    badgeGroupId
    createDate
    updateDate
    createdByUserId
    updatedByUserId
    badgeRequirements {
      id
      name
      sortOrder
    }
  }
}
    `;
export type CreateBadgeMutationFn = ApolloReactCommon.MutationFunction<CreateBadgeMutation, CreateBadgeMutationVariables>;

/**
 * __useCreateBadgeMutation__
 *
 * To run a mutation, you first call `useCreateBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBadgeMutation, { data, loading, error }] = useCreateBadgeMutation({
 *   variables: {
 *      newBadgeInput: // value for 'newBadgeInput'
 *   },
 * });
 */
export function useCreateBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBadgeMutation, CreateBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBadgeMutation, CreateBadgeMutationVariables>(CreateBadgeDocument, baseOptions);
      }
export type CreateBadgeMutationHookResult = ReturnType<typeof useCreateBadgeMutation>;
export type CreateBadgeMutationResult = ApolloReactCommon.MutationResult<CreateBadgeMutation>;
export type CreateBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBadgeMutation, CreateBadgeMutationVariables>;
export const UpdateBadgeDocument = gql`
    mutation updateBadge($updateBadgeInput: UpdateBadgeInput!) {
  updateBadge(updateBadgeInput: $updateBadgeInput) {
    id
    name
    abbreviation
    color
    description
    certificateTemplateId
    badgeGroupId
    createDate
    updateDate
    createdByUserId
    updatedByUserId
    badgeRequirements {
      id
      name
      sortOrder
    }
  }
}
    `;
export type UpdateBadgeMutationFn = ApolloReactCommon.MutationFunction<UpdateBadgeMutation, UpdateBadgeMutationVariables>;

/**
 * __useUpdateBadgeMutation__
 *
 * To run a mutation, you first call `useUpdateBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBadgeMutation, { data, loading, error }] = useUpdateBadgeMutation({
 *   variables: {
 *      updateBadgeInput: // value for 'updateBadgeInput'
 *   },
 * });
 */
export function useUpdateBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBadgeMutation, UpdateBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBadgeMutation, UpdateBadgeMutationVariables>(UpdateBadgeDocument, baseOptions);
      }
export type UpdateBadgeMutationHookResult = ReturnType<typeof useUpdateBadgeMutation>;
export type UpdateBadgeMutationResult = ApolloReactCommon.MutationResult<UpdateBadgeMutation>;
export type UpdateBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBadgeMutation, UpdateBadgeMutationVariables>;
export const DeleteBadgeDocument = gql`
    mutation deleteBadge($id: String!) {
  deleteBadge(id: $id)
}
    `;
export type DeleteBadgeMutationFn = ApolloReactCommon.MutationFunction<DeleteBadgeMutation, DeleteBadgeMutationVariables>;

/**
 * __useDeleteBadgeMutation__
 *
 * To run a mutation, you first call `useDeleteBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBadgeMutation, { data, loading, error }] = useDeleteBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBadgeMutation, DeleteBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBadgeMutation, DeleteBadgeMutationVariables>(DeleteBadgeDocument, baseOptions);
      }
export type DeleteBadgeMutationHookResult = ReturnType<typeof useDeleteBadgeMutation>;
export type DeleteBadgeMutationResult = ApolloReactCommon.MutationResult<DeleteBadgeMutation>;
export type DeleteBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBadgeMutation, DeleteBadgeMutationVariables>;
export const SoftDeleteBadgeDocument = gql`
    mutation softDeleteBadge($id: String!) {
  softDeleteBadge(id: $id) {
    id
  }
}
    `;
export type SoftDeleteBadgeMutationFn = ApolloReactCommon.MutationFunction<SoftDeleteBadgeMutation, SoftDeleteBadgeMutationVariables>;

/**
 * __useSoftDeleteBadgeMutation__
 *
 * To run a mutation, you first call `useSoftDeleteBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteBadgeMutation, { data, loading, error }] = useSoftDeleteBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftDeleteBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SoftDeleteBadgeMutation, SoftDeleteBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<SoftDeleteBadgeMutation, SoftDeleteBadgeMutationVariables>(SoftDeleteBadgeDocument, baseOptions);
      }
export type SoftDeleteBadgeMutationHookResult = ReturnType<typeof useSoftDeleteBadgeMutation>;
export type SoftDeleteBadgeMutationResult = ApolloReactCommon.MutationResult<SoftDeleteBadgeMutation>;
export type SoftDeleteBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<SoftDeleteBadgeMutation, SoftDeleteBadgeMutationVariables>;
export const IsBadgeNameUniqueDocument = gql`
    query isBadgeNameUnique($name: String!, $id: String) {
  isBadgeNameUnique(name: $name, id: $id)
}
    `;

/**
 * __useIsBadgeNameUniqueQuery__
 *
 * To run a query within a React component, call `useIsBadgeNameUniqueQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsBadgeNameUniqueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsBadgeNameUniqueQuery({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsBadgeNameUniqueQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsBadgeNameUniqueQuery, IsBadgeNameUniqueQueryVariables>) {
        return ApolloReactHooks.useQuery<IsBadgeNameUniqueQuery, IsBadgeNameUniqueQueryVariables>(IsBadgeNameUniqueDocument, baseOptions);
      }
export function useIsBadgeNameUniqueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsBadgeNameUniqueQuery, IsBadgeNameUniqueQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IsBadgeNameUniqueQuery, IsBadgeNameUniqueQueryVariables>(IsBadgeNameUniqueDocument, baseOptions);
        }
export type IsBadgeNameUniqueQueryHookResult = ReturnType<typeof useIsBadgeNameUniqueQuery>;
export type IsBadgeNameUniqueLazyQueryHookResult = ReturnType<typeof useIsBadgeNameUniqueLazyQuery>;
export type IsBadgeNameUniqueQueryResult = ApolloReactCommon.QueryResult<IsBadgeNameUniqueQuery, IsBadgeNameUniqueQueryVariables>;
export const ReOrderBadgesDocument = gql`
    mutation reOrderBadges($movedBadgeId: ID!, $targetBadgeId: ID!) {
  reOrderBadges(movedBadgeId: $movedBadgeId, targetBadgeId: $targetBadgeId)
}
    `;
export type ReOrderBadgesMutationFn = ApolloReactCommon.MutationFunction<ReOrderBadgesMutation, ReOrderBadgesMutationVariables>;

/**
 * __useReOrderBadgesMutation__
 *
 * To run a mutation, you first call `useReOrderBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReOrderBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reOrderBadgesMutation, { data, loading, error }] = useReOrderBadgesMutation({
 *   variables: {
 *      movedBadgeId: // value for 'movedBadgeId'
 *      targetBadgeId: // value for 'targetBadgeId'
 *   },
 * });
 */
export function useReOrderBadgesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReOrderBadgesMutation, ReOrderBadgesMutationVariables>) {
        return ApolloReactHooks.useMutation<ReOrderBadgesMutation, ReOrderBadgesMutationVariables>(ReOrderBadgesDocument, baseOptions);
      }
export type ReOrderBadgesMutationHookResult = ReturnType<typeof useReOrderBadgesMutation>;
export type ReOrderBadgesMutationResult = ApolloReactCommon.MutationResult<ReOrderBadgesMutation>;
export type ReOrderBadgesMutationOptions = ApolloReactCommon.BaseMutationOptions<ReOrderBadgesMutation, ReOrderBadgesMutationVariables>;
export const MoveBadgeDocument = gql`
    mutation moveBadge($movedBadgeId: ID!, $badgeGroupId: ID, $targetBadgeId: ID) {
  moveBadge(movedBadgeId: $movedBadgeId, badgeGroupId: $badgeGroupId, targetBadgeId: $targetBadgeId)
}
    `;
export type MoveBadgeMutationFn = ApolloReactCommon.MutationFunction<MoveBadgeMutation, MoveBadgeMutationVariables>;

/**
 * __useMoveBadgeMutation__
 *
 * To run a mutation, you first call `useMoveBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveBadgeMutation, { data, loading, error }] = useMoveBadgeMutation({
 *   variables: {
 *      movedBadgeId: // value for 'movedBadgeId'
 *      badgeGroupId: // value for 'badgeGroupId'
 *      targetBadgeId: // value for 'targetBadgeId'
 *   },
 * });
 */
export function useMoveBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveBadgeMutation, MoveBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<MoveBadgeMutation, MoveBadgeMutationVariables>(MoveBadgeDocument, baseOptions);
      }
export type MoveBadgeMutationHookResult = ReturnType<typeof useMoveBadgeMutation>;
export type MoveBadgeMutationResult = ApolloReactCommon.MutationResult<MoveBadgeMutation>;
export type MoveBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveBadgeMutation, MoveBadgeMutationVariables>;
export const UploadBadgeGraphicDocument = gql`
    mutation uploadBadgeGraphic($badgeId: String!, $file: Upload!) {
  uploadBadgeGraphic(badgeId: $badgeId, file: $file) {
    id
    graphicUrl
    signedGraphicUrl
  }
}
    `;
export type UploadBadgeGraphicMutationFn = ApolloReactCommon.MutationFunction<UploadBadgeGraphicMutation, UploadBadgeGraphicMutationVariables>;

/**
 * __useUploadBadgeGraphicMutation__
 *
 * To run a mutation, you first call `useUploadBadgeGraphicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBadgeGraphicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBadgeGraphicMutation, { data, loading, error }] = useUploadBadgeGraphicMutation({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadBadgeGraphicMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadBadgeGraphicMutation, UploadBadgeGraphicMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadBadgeGraphicMutation, UploadBadgeGraphicMutationVariables>(UploadBadgeGraphicDocument, baseOptions);
      }
export type UploadBadgeGraphicMutationHookResult = ReturnType<typeof useUploadBadgeGraphicMutation>;
export type UploadBadgeGraphicMutationResult = ApolloReactCommon.MutationResult<UploadBadgeGraphicMutation>;
export type UploadBadgeGraphicMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadBadgeGraphicMutation, UploadBadgeGraphicMutationVariables>;
export const DeleteBadgeGraphicDocument = gql`
    mutation deleteBadgeGraphic($badgeId: String!) {
  deleteBadgeGraphic(badgeId: $badgeId) {
    id
    graphicUrl
    signedGraphicUrl
  }
}
    `;
export type DeleteBadgeGraphicMutationFn = ApolloReactCommon.MutationFunction<DeleteBadgeGraphicMutation, DeleteBadgeGraphicMutationVariables>;

/**
 * __useDeleteBadgeGraphicMutation__
 *
 * To run a mutation, you first call `useDeleteBadgeGraphicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBadgeGraphicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBadgeGraphicMutation, { data, loading, error }] = useDeleteBadgeGraphicMutation({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useDeleteBadgeGraphicMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBadgeGraphicMutation, DeleteBadgeGraphicMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBadgeGraphicMutation, DeleteBadgeGraphicMutationVariables>(DeleteBadgeGraphicDocument, baseOptions);
      }
export type DeleteBadgeGraphicMutationHookResult = ReturnType<typeof useDeleteBadgeGraphicMutation>;
export type DeleteBadgeGraphicMutationResult = ApolloReactCommon.MutationResult<DeleteBadgeGraphicMutation>;
export type DeleteBadgeGraphicMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBadgeGraphicMutation, DeleteBadgeGraphicMutationVariables>;
export const BadgeGroupsDocument = gql`
    query badgeGroups {
  badgeGroups {
    id
    name
    type
    color
    rank
  }
}
    `;

/**
 * __useBadgeGroupsQuery__
 *
 * To run a query within a React component, call `useBadgeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBadgeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBadgeGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBadgeGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BadgeGroupsQuery, BadgeGroupsQueryVariables>) {
        return ApolloReactHooks.useQuery<BadgeGroupsQuery, BadgeGroupsQueryVariables>(BadgeGroupsDocument, baseOptions);
      }
export function useBadgeGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BadgeGroupsQuery, BadgeGroupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BadgeGroupsQuery, BadgeGroupsQueryVariables>(BadgeGroupsDocument, baseOptions);
        }
export type BadgeGroupsQueryHookResult = ReturnType<typeof useBadgeGroupsQuery>;
export type BadgeGroupsLazyQueryHookResult = ReturnType<typeof useBadgeGroupsLazyQuery>;
export type BadgeGroupsQueryResult = ApolloReactCommon.QueryResult<BadgeGroupsQuery, BadgeGroupsQueryVariables>;
export const CreateBadgeGroupDocument = gql`
    mutation createBadgeGroup($newBadgeGroupInput: NewBadgeGroupInput!) {
  createBadgeGroup(newBadgeGroupInput: $newBadgeGroupInput) {
    id
    name
    type
    color
    rank
  }
}
    `;
export type CreateBadgeGroupMutationFn = ApolloReactCommon.MutationFunction<CreateBadgeGroupMutation, CreateBadgeGroupMutationVariables>;

/**
 * __useCreateBadgeGroupMutation__
 *
 * To run a mutation, you first call `useCreateBadgeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBadgeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBadgeGroupMutation, { data, loading, error }] = useCreateBadgeGroupMutation({
 *   variables: {
 *      newBadgeGroupInput: // value for 'newBadgeGroupInput'
 *   },
 * });
 */
export function useCreateBadgeGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBadgeGroupMutation, CreateBadgeGroupMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBadgeGroupMutation, CreateBadgeGroupMutationVariables>(CreateBadgeGroupDocument, baseOptions);
      }
export type CreateBadgeGroupMutationHookResult = ReturnType<typeof useCreateBadgeGroupMutation>;
export type CreateBadgeGroupMutationResult = ApolloReactCommon.MutationResult<CreateBadgeGroupMutation>;
export type CreateBadgeGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBadgeGroupMutation, CreateBadgeGroupMutationVariables>;
export const UpdateBadgeGroupDocument = gql`
    mutation updateBadgeGroup($updateBadgeGroupInput: UpdateBadgeGroupInput!) {
  updateBadgeGroup(updateBadgeGroupInput: $updateBadgeGroupInput) {
    id
    name
    type
    color
    rank
  }
}
    `;
export type UpdateBadgeGroupMutationFn = ApolloReactCommon.MutationFunction<UpdateBadgeGroupMutation, UpdateBadgeGroupMutationVariables>;

/**
 * __useUpdateBadgeGroupMutation__
 *
 * To run a mutation, you first call `useUpdateBadgeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBadgeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBadgeGroupMutation, { data, loading, error }] = useUpdateBadgeGroupMutation({
 *   variables: {
 *      updateBadgeGroupInput: // value for 'updateBadgeGroupInput'
 *   },
 * });
 */
export function useUpdateBadgeGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBadgeGroupMutation, UpdateBadgeGroupMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBadgeGroupMutation, UpdateBadgeGroupMutationVariables>(UpdateBadgeGroupDocument, baseOptions);
      }
export type UpdateBadgeGroupMutationHookResult = ReturnType<typeof useUpdateBadgeGroupMutation>;
export type UpdateBadgeGroupMutationResult = ApolloReactCommon.MutationResult<UpdateBadgeGroupMutation>;
export type UpdateBadgeGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBadgeGroupMutation, UpdateBadgeGroupMutationVariables>;
export const DeleteBadgeGroupDocument = gql`
    mutation deleteBadgeGroup($id: String!) {
  deleteBadgeGroup(id: $id)
}
    `;
export type DeleteBadgeGroupMutationFn = ApolloReactCommon.MutationFunction<DeleteBadgeGroupMutation, DeleteBadgeGroupMutationVariables>;

/**
 * __useDeleteBadgeGroupMutation__
 *
 * To run a mutation, you first call `useDeleteBadgeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBadgeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBadgeGroupMutation, { data, loading, error }] = useDeleteBadgeGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBadgeGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBadgeGroupMutation, DeleteBadgeGroupMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBadgeGroupMutation, DeleteBadgeGroupMutationVariables>(DeleteBadgeGroupDocument, baseOptions);
      }
export type DeleteBadgeGroupMutationHookResult = ReturnType<typeof useDeleteBadgeGroupMutation>;
export type DeleteBadgeGroupMutationResult = ApolloReactCommon.MutationResult<DeleteBadgeGroupMutation>;
export type DeleteBadgeGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBadgeGroupMutation, DeleteBadgeGroupMutationVariables>;
export const ReOrderBadgeGroupsDocument = gql`
    mutation reOrderBadgeGroups($movedGroupId: ID!, $targetGroupId: ID!) {
  reOrderBadgeGroups(movedGroupId: $movedGroupId, targetGroupId: $targetGroupId)
}
    `;
export type ReOrderBadgeGroupsMutationFn = ApolloReactCommon.MutationFunction<ReOrderBadgeGroupsMutation, ReOrderBadgeGroupsMutationVariables>;

/**
 * __useReOrderBadgeGroupsMutation__
 *
 * To run a mutation, you first call `useReOrderBadgeGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReOrderBadgeGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reOrderBadgeGroupsMutation, { data, loading, error }] = useReOrderBadgeGroupsMutation({
 *   variables: {
 *      movedGroupId: // value for 'movedGroupId'
 *      targetGroupId: // value for 'targetGroupId'
 *   },
 * });
 */
export function useReOrderBadgeGroupsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReOrderBadgeGroupsMutation, ReOrderBadgeGroupsMutationVariables>) {
        return ApolloReactHooks.useMutation<ReOrderBadgeGroupsMutation, ReOrderBadgeGroupsMutationVariables>(ReOrderBadgeGroupsDocument, baseOptions);
      }
export type ReOrderBadgeGroupsMutationHookResult = ReturnType<typeof useReOrderBadgeGroupsMutation>;
export type ReOrderBadgeGroupsMutationResult = ApolloReactCommon.MutationResult<ReOrderBadgeGroupsMutation>;
export type ReOrderBadgeGroupsMutationOptions = ApolloReactCommon.BaseMutationOptions<ReOrderBadgeGroupsMutation, ReOrderBadgeGroupsMutationVariables>;
export const BookingHistoryByIdWithBookingInfoDocument = gql`
    query BookingHistoryByIdWithBookingInfo($bookingId: String!) {
  bookingHistoryByIdWithBookingInfo(bookingId: $bookingId) {
    id
    createDate
    createdByUserId
    userId
    userName
    action
    description
    bookingId
    bookingNumberPrefix
    bookingNumber
    bookingType
    attendeeId
    bookerId
    grossPrice
    canceled
    oldValues
    newValues
    correlationId
    bookedBy
    user {
      id
      email
    }
    createdBy {
      id
      email
      instructorDetails {
        email
        firstname
        lastname
        level
      }
    }
    attendee {
      id
      firstname
      lastname
      booker {
        id
        email
        firstname
        lastname
      }
    }
    course {
      id
      courseNumber
      courseNumberFormat
      customCourseNumberPrefix
    }
    booking {
      id
      bookingNumber
      bookingNumberPrefix
    }
  }
}
    `;

/**
 * __useBookingHistoryByIdWithBookingInfoQuery__
 *
 * To run a query within a React component, call `useBookingHistoryByIdWithBookingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingHistoryByIdWithBookingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingHistoryByIdWithBookingInfoQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingHistoryByIdWithBookingInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingHistoryByIdWithBookingInfoQuery, BookingHistoryByIdWithBookingInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<BookingHistoryByIdWithBookingInfoQuery, BookingHistoryByIdWithBookingInfoQueryVariables>(BookingHistoryByIdWithBookingInfoDocument, baseOptions);
      }
export function useBookingHistoryByIdWithBookingInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingHistoryByIdWithBookingInfoQuery, BookingHistoryByIdWithBookingInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookingHistoryByIdWithBookingInfoQuery, BookingHistoryByIdWithBookingInfoQueryVariables>(BookingHistoryByIdWithBookingInfoDocument, baseOptions);
        }
export type BookingHistoryByIdWithBookingInfoQueryHookResult = ReturnType<typeof useBookingHistoryByIdWithBookingInfoQuery>;
export type BookingHistoryByIdWithBookingInfoLazyQueryHookResult = ReturnType<typeof useBookingHistoryByIdWithBookingInfoLazyQuery>;
export type BookingHistoryByIdWithBookingInfoQueryResult = ApolloReactCommon.QueryResult<BookingHistoryByIdWithBookingInfoQuery, BookingHistoryByIdWithBookingInfoQueryVariables>;
export const BookingHistoryByBookingIdDocument = gql`
    query BookingHistoryByBookingId($bookingId: String!) {
  bookingHistoryByBookingId(bookingId: $bookingId) {
    id
    bookingId
    bookingNumber
    bookingNumberPrefix
    bookingType
    startDateTime
    attendeeId
    bookerId
    courseId
    email
    grossPrice
    canceled
    bookedBy
    action
    createDate
  }
}
    `;

/**
 * __useBookingHistoryByBookingIdQuery__
 *
 * To run a query within a React component, call `useBookingHistoryByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingHistoryByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingHistoryByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingHistoryByBookingIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingHistoryByBookingIdQuery, BookingHistoryByBookingIdQueryVariables>) {
        return ApolloReactHooks.useQuery<BookingHistoryByBookingIdQuery, BookingHistoryByBookingIdQueryVariables>(BookingHistoryByBookingIdDocument, baseOptions);
      }
export function useBookingHistoryByBookingIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingHistoryByBookingIdQuery, BookingHistoryByBookingIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookingHistoryByBookingIdQuery, BookingHistoryByBookingIdQueryVariables>(BookingHistoryByBookingIdDocument, baseOptions);
        }
export type BookingHistoryByBookingIdQueryHookResult = ReturnType<typeof useBookingHistoryByBookingIdQuery>;
export type BookingHistoryByBookingIdLazyQueryHookResult = ReturnType<typeof useBookingHistoryByBookingIdLazyQuery>;
export type BookingHistoryByBookingIdQueryResult = ApolloReactCommon.QueryResult<BookingHistoryByBookingIdQuery, BookingHistoryByBookingIdQueryVariables>;
export const BookingHistoryDetailsByBookingIdAndOrganizationIdDocument = gql`
    query BookingHistoryDetailsByBookingIdAndOrganizationId($bookingId: String!, $koOrganizationId: String!) {
  bookingHistoryDetailsByBookingIdAndOrganizationId(bookingId: $bookingId, koOrganizationId: $koOrganizationId) {
    id
    bookingId
    bookingNumber
    bookingNumberPrefix
    bookingType
    startDateTime
    attendeeId
    bookerId
    courseId
    email
    grossPrice
    canceled
    bookedBy
    action
    createDate
    createdByUserId
    createdBy {
      id
      email
      instructorDetails {
        email
        firstname
        lastname
        level
      }
    }
    attendee {
      id
      firstname
      lastname
      booker {
        id
        email
        firstname
        lastname
      }
    }
    course {
      id
      courseNumber
      courseNumberFormat
      customCourseNumberPrefix
    }
    booking {
      id
      bookingNumber
      bookingNumberPrefix
    }
  }
}
    `;

/**
 * __useBookingHistoryDetailsByBookingIdAndOrganizationIdQuery__
 *
 * To run a query within a React component, call `useBookingHistoryDetailsByBookingIdAndOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingHistoryDetailsByBookingIdAndOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingHistoryDetailsByBookingIdAndOrganizationIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useBookingHistoryDetailsByBookingIdAndOrganizationIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingHistoryDetailsByBookingIdAndOrganizationIdQuery, BookingHistoryDetailsByBookingIdAndOrganizationIdQueryVariables>) {
        return ApolloReactHooks.useQuery<BookingHistoryDetailsByBookingIdAndOrganizationIdQuery, BookingHistoryDetailsByBookingIdAndOrganizationIdQueryVariables>(BookingHistoryDetailsByBookingIdAndOrganizationIdDocument, baseOptions);
      }
export function useBookingHistoryDetailsByBookingIdAndOrganizationIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingHistoryDetailsByBookingIdAndOrganizationIdQuery, BookingHistoryDetailsByBookingIdAndOrganizationIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookingHistoryDetailsByBookingIdAndOrganizationIdQuery, BookingHistoryDetailsByBookingIdAndOrganizationIdQueryVariables>(BookingHistoryDetailsByBookingIdAndOrganizationIdDocument, baseOptions);
        }
export type BookingHistoryDetailsByBookingIdAndOrganizationIdQueryHookResult = ReturnType<typeof useBookingHistoryDetailsByBookingIdAndOrganizationIdQuery>;
export type BookingHistoryDetailsByBookingIdAndOrganizationIdLazyQueryHookResult = ReturnType<typeof useBookingHistoryDetailsByBookingIdAndOrganizationIdLazyQuery>;
export type BookingHistoryDetailsByBookingIdAndOrganizationIdQueryResult = ApolloReactCommon.QueryResult<BookingHistoryDetailsByBookingIdAndOrganizationIdQuery, BookingHistoryDetailsByBookingIdAndOrganizationIdQueryVariables>;
export const BookingHistoryOrphanBookingsDocument = gql`
    query BookingHistoryOrphanBookings($koOrganizationId: String!) {
  bookingHistoryOrphanBookings(koOrganizationId: $koOrganizationId) {
    id
    bookingId
    bookingNumber
    bookingNumberPrefix
    bookingType
    startDateTime
    attendeeId
    bookerId
    courseId
    email
    grossPrice
    canceled
    bookedBy
    action
    createDate
    course {
      id
      courseNumber
      courseNumberFormat
      customCourseNumberPrefix
    }
    booking {
      id
      bookingNumber
      bookingNumberPrefix
    }
  }
}
    `;

/**
 * __useBookingHistoryOrphanBookingsQuery__
 *
 * To run a query within a React component, call `useBookingHistoryOrphanBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingHistoryOrphanBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingHistoryOrphanBookingsQuery({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useBookingHistoryOrphanBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingHistoryOrphanBookingsQuery, BookingHistoryOrphanBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<BookingHistoryOrphanBookingsQuery, BookingHistoryOrphanBookingsQueryVariables>(BookingHistoryOrphanBookingsDocument, baseOptions);
      }
export function useBookingHistoryOrphanBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingHistoryOrphanBookingsQuery, BookingHistoryOrphanBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookingHistoryOrphanBookingsQuery, BookingHistoryOrphanBookingsQueryVariables>(BookingHistoryOrphanBookingsDocument, baseOptions);
        }
export type BookingHistoryOrphanBookingsQueryHookResult = ReturnType<typeof useBookingHistoryOrphanBookingsQuery>;
export type BookingHistoryOrphanBookingsLazyQueryHookResult = ReturnType<typeof useBookingHistoryOrphanBookingsLazyQuery>;
export type BookingHistoryOrphanBookingsQueryResult = ApolloReactCommon.QueryResult<BookingHistoryOrphanBookingsQuery, BookingHistoryOrphanBookingsQueryVariables>;
export const BookingHistoryByCourseIdDocument = gql`
    query BookingHistoryByCourseId($courseId: String!) {
  bookingHistoryByCourseId(courseId: $courseId) {
    id
    createDate
    createdByUserId
    userId
    userName
    action
    description
    bookingId
    bookingNumberPrefix
    bookingNumber
    bookingType
    attendeeId
    bookerId
    grossPrice
    canceled
    oldValues
    newValues
    correlationId
    bookedBy
    user {
      id
      email
    }
    createdBy {
      id
      email
      instructorDetails {
        email
        firstname
        lastname
        level
      }
    }
    attendee {
      id
      firstname
      lastname
      booker {
        id
        email
        firstname
        lastname
      }
    }
    course {
      id
      courseNumber
      courseNumberFormat
      customCourseNumberPrefix
    }
    booking {
      id
      bookingNumber
      bookingNumberPrefix
    }
  }
}
    `;

/**
 * __useBookingHistoryByCourseIdQuery__
 *
 * To run a query within a React component, call `useBookingHistoryByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingHistoryByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingHistoryByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useBookingHistoryByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingHistoryByCourseIdQuery, BookingHistoryByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<BookingHistoryByCourseIdQuery, BookingHistoryByCourseIdQueryVariables>(BookingHistoryByCourseIdDocument, baseOptions);
      }
export function useBookingHistoryByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingHistoryByCourseIdQuery, BookingHistoryByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookingHistoryByCourseIdQuery, BookingHistoryByCourseIdQueryVariables>(BookingHistoryByCourseIdDocument, baseOptions);
        }
export type BookingHistoryByCourseIdQueryHookResult = ReturnType<typeof useBookingHistoryByCourseIdQuery>;
export type BookingHistoryByCourseIdLazyQueryHookResult = ReturnType<typeof useBookingHistoryByCourseIdLazyQuery>;
export type BookingHistoryByCourseIdQueryResult = ApolloReactCommon.QueryResult<BookingHistoryByCourseIdQuery, BookingHistoryByCourseIdQueryVariables>;
export const GetBookinsDocument = gql`
    query GetBookins($options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  bookings(options: $options, onlyCurrentUser: $onlyCurrentUser) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      pricingReason
      isSpecial
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      paymentType
      courseLessons {
        id
        startDateTime
        endDateTime
        locationId
        indexOfLessonInCourse
        course {
          id
          freePlaces
          startDateTime
          paymentInterval
          minAttendees
          maxAttendees
          prefixedCourseNumber
          allowMonthlyPayment
          paymentInterval
          courseType {
            id
            name
            color
          }
          instructors {
            id
            firstname
            lastname
          }
          lessonCount
          allowLessonBooking
        }
        location {
          id
          city
          name
        }
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          gender
          nonDisclosureNotice
          credit
        }
        badgeXAttendee {
          id
          createDate
          dateOfAchivement
          badge {
            id
            name
            abbreviation
            color
          }
        }
      }
      bookedBy
      canceled
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      paymentMethod {
        id
        type
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
        bankTransfer
        onlinePayment
      }
      waitListCount
      additionalInfo
      foundUs
      utmSource
      bookedLessonCount
    }
  }
}
    `;

/**
 * __useGetBookinsQuery__
 *
 * To run a query within a React component, call `useGetBookinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookinsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetBookinsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookinsQuery, GetBookinsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookinsQuery, GetBookinsQueryVariables>(GetBookinsDocument, baseOptions);
      }
export function useGetBookinsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookinsQuery, GetBookinsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookinsQuery, GetBookinsQueryVariables>(GetBookinsDocument, baseOptions);
        }
export type GetBookinsQueryHookResult = ReturnType<typeof useGetBookinsQuery>;
export type GetBookinsLazyQueryHookResult = ReturnType<typeof useGetBookinsLazyQuery>;
export type GetBookinsQueryResult = ApolloReactCommon.QueryResult<GetBookinsQuery, GetBookinsQueryVariables>;
export const GetBookingsOverviewOptimizedDocument = gql`
    query GetBookingsOverviewOptimized($options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  bookings(options: $options, onlyCurrentUser: $onlyCurrentUser) {
    existsMore
    total
    items {
      id
      isSettled
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      pricingReason
      isSpecial
      paymentType
      bookedBy
      discountCodeText
      canceled
      waitListCount
      additionalInfo
      foundUs
      utmSource
      bookedLessonCount
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      paymentMethod {
        id
        type
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
        bankTransfer
        onlinePayment
      }
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        endDateTimeFirstCourseLesson
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        indexOfLessonInCourse
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
      }
      scheduledPayments {
        paymentProvider
        mollieMethod
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          email
          city
          credit
          phoneNumber
          mobileNumber
          nonDisclosureNotice
        }
      }
      paymentMethod {
        id
        type
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
    }
  }
}
    `;

/**
 * __useGetBookingsOverviewOptimizedQuery__
 *
 * To run a query within a React component, call `useGetBookingsOverviewOptimizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsOverviewOptimizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsOverviewOptimizedQuery({
 *   variables: {
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetBookingsOverviewOptimizedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsOverviewOptimizedQuery, GetBookingsOverviewOptimizedQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsOverviewOptimizedQuery, GetBookingsOverviewOptimizedQueryVariables>(GetBookingsOverviewOptimizedDocument, baseOptions);
      }
export function useGetBookingsOverviewOptimizedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsOverviewOptimizedQuery, GetBookingsOverviewOptimizedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsOverviewOptimizedQuery, GetBookingsOverviewOptimizedQueryVariables>(GetBookingsOverviewOptimizedDocument, baseOptions);
        }
export type GetBookingsOverviewOptimizedQueryHookResult = ReturnType<typeof useGetBookingsOverviewOptimizedQuery>;
export type GetBookingsOverviewOptimizedLazyQueryHookResult = ReturnType<typeof useGetBookingsOverviewOptimizedLazyQuery>;
export type GetBookingsOverviewOptimizedQueryResult = ApolloReactCommon.QueryResult<GetBookingsOverviewOptimizedQuery, GetBookingsOverviewOptimizedQueryVariables>;
export const GetBookingsDynamicDocument = gql`
    query GetBookingsDynamic($options: ArrayDataOptions, $includeCoursePrice: Boolean!, $includeInvoice: Boolean!, $includeReversalInvoice: Boolean!, $includeCourseLessons: Boolean!, $includeAttendee: Boolean!, $includeEmailNotifications: Boolean!, $includePaymentMethod: Boolean!) {
  bookingsDynamic(options: $options, includeCoursePrice: $includeCoursePrice, includeInvoice: $includeInvoice, includeReversalInvoice: $includeReversalInvoice, includeCourseLessons: $includeCourseLessons, includeAttendee: $includeAttendee, includeEmailNotifications: $includeEmailNotifications, includePaymentMethod: $includePaymentMethod) {
    existsMore
    total
    items {
      ...BookingCoreFields
      ...BookingCoursePriceFields @include(if: $includeCoursePrice)
      ...BookingInvoiceFields @include(if: $includeInvoice)
      ...BookingReversalInvoiceFields @include(if: $includeReversalInvoice)
      ...BookingCourseLessonsFields @include(if: $includeCourseLessons)
      ...BookingAttendeeFields @include(if: $includeAttendee)
      ...BookingEmailNotificationsFields @include(if: $includeEmailNotifications)
      ...BookingPaymentMethodFields @include(if: $includePaymentMethod)
    }
  }
}
    ${BookingCoreFieldsFragmentDoc}
${BookingCoursePriceFieldsFragmentDoc}
${BookingInvoiceFieldsFragmentDoc}
${BookingReversalInvoiceFieldsFragmentDoc}
${BookingCourseLessonsFieldsFragmentDoc}
${BookingAttendeeFieldsFragmentDoc}
${BookingEmailNotificationsFieldsFragmentDoc}
${BookingPaymentMethodFieldsFragmentDoc}`;

/**
 * __useGetBookingsDynamicQuery__
 *
 * To run a query within a React component, call `useGetBookingsDynamicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsDynamicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsDynamicQuery({
 *   variables: {
 *      options: // value for 'options'
 *      includeCoursePrice: // value for 'includeCoursePrice'
 *      includeInvoice: // value for 'includeInvoice'
 *      includeReversalInvoice: // value for 'includeReversalInvoice'
 *      includeCourseLessons: // value for 'includeCourseLessons'
 *      includeAttendee: // value for 'includeAttendee'
 *      includeEmailNotifications: // value for 'includeEmailNotifications'
 *      includePaymentMethod: // value for 'includePaymentMethod'
 *   },
 * });
 */
export function useGetBookingsDynamicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsDynamicQuery, GetBookingsDynamicQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsDynamicQuery, GetBookingsDynamicQueryVariables>(GetBookingsDynamicDocument, baseOptions);
      }
export function useGetBookingsDynamicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsDynamicQuery, GetBookingsDynamicQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsDynamicQuery, GetBookingsDynamicQueryVariables>(GetBookingsDynamicDocument, baseOptions);
        }
export type GetBookingsDynamicQueryHookResult = ReturnType<typeof useGetBookingsDynamicQuery>;
export type GetBookingsDynamicLazyQueryHookResult = ReturnType<typeof useGetBookingsDynamicLazyQuery>;
export type GetBookingsDynamicQueryResult = ApolloReactCommon.QueryResult<GetBookingsDynamicQuery, GetBookingsDynamicQueryVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($newBookingData: NewBookingInput!, $sendMail: Boolean!) {
  createBooking(newBookingData: $newBookingData, sendMail: $sendMail) {
    id
    bookingType
    paymentType
    scheduledPayments {
      id
      paymentAmount
      paymentDue
      paymentDone
      paymentProvider
      mollieMethod
      type
    }
  }
}
    `;
export type CreateBookingMutationFn = ApolloReactCommon.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      newBookingData: // value for 'newBookingData'
 *      sendMail: // value for 'sendMail'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, baseOptions);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = ApolloReactCommon.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const RemoveBookingDocument = gql`
    mutation RemoveBooking($id: ID!, $bookingDeleteAction: BookingDeleteAction, $notifyBooker: Boolean) {
  removeBooking(id: $id, bookingDeleteAction: $bookingDeleteAction, notifyBooker: $notifyBooker)
}
    `;
export type RemoveBookingMutationFn = ApolloReactCommon.MutationFunction<RemoveBookingMutation, RemoveBookingMutationVariables>;

/**
 * __useRemoveBookingMutation__
 *
 * To run a mutation, you first call `useRemoveBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookingMutation, { data, loading, error }] = useRemoveBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bookingDeleteAction: // value for 'bookingDeleteAction'
 *      notifyBooker: // value for 'notifyBooker'
 *   },
 * });
 */
export function useRemoveBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBookingMutation, RemoveBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveBookingMutation, RemoveBookingMutationVariables>(RemoveBookingDocument, baseOptions);
      }
export type RemoveBookingMutationHookResult = ReturnType<typeof useRemoveBookingMutation>;
export type RemoveBookingMutationResult = ApolloReactCommon.MutationResult<RemoveBookingMutation>;
export type RemoveBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveBookingMutation, RemoveBookingMutationVariables>;
export const RemoveBookingsDocument = gql`
    mutation RemoveBookings($ids: [ID!]!) {
  removeBookings(ids: $ids)
}
    `;
export type RemoveBookingsMutationFn = ApolloReactCommon.MutationFunction<RemoveBookingsMutation, RemoveBookingsMutationVariables>;

/**
 * __useRemoveBookingsMutation__
 *
 * To run a mutation, you first call `useRemoveBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookingsMutation, { data, loading, error }] = useRemoveBookingsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRemoveBookingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBookingsMutation, RemoveBookingsMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveBookingsMutation, RemoveBookingsMutationVariables>(RemoveBookingsDocument, baseOptions);
      }
export type RemoveBookingsMutationHookResult = ReturnType<typeof useRemoveBookingsMutation>;
export type RemoveBookingsMutationResult = ApolloReactCommon.MutationResult<RemoveBookingsMutation>;
export type RemoveBookingsMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveBookingsMutation, RemoveBookingsMutationVariables>;
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($editBookingData: EditBookingInput!, $id: String!) {
  updateBooking(editBookingData: $editBookingData, id: $id) {
    id
    bookingType
  }
}
    `;
export type UpdateBookingMutationFn = ApolloReactCommon.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      editBookingData: // value for 'editBookingData'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, baseOptions);
      }
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = ApolloReactCommon.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const UpdateNoticeStaffDocument = gql`
    mutation UpdateNoticeStaff($id: String!, $noticeStaff: String!) {
  updateNoticeStaff(id: $id, noticeStaff: $noticeStaff) {
    id
    noticeStaff
  }
}
    `;
export type UpdateNoticeStaffMutationFn = ApolloReactCommon.MutationFunction<UpdateNoticeStaffMutation, UpdateNoticeStaffMutationVariables>;

/**
 * __useUpdateNoticeStaffMutation__
 *
 * To run a mutation, you first call `useUpdateNoticeStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoticeStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoticeStaffMutation, { data, loading, error }] = useUpdateNoticeStaffMutation({
 *   variables: {
 *      id: // value for 'id'
 *      noticeStaff: // value for 'noticeStaff'
 *   },
 * });
 */
export function useUpdateNoticeStaffMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNoticeStaffMutation, UpdateNoticeStaffMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNoticeStaffMutation, UpdateNoticeStaffMutationVariables>(UpdateNoticeStaffDocument, baseOptions);
      }
export type UpdateNoticeStaffMutationHookResult = ReturnType<typeof useUpdateNoticeStaffMutation>;
export type UpdateNoticeStaffMutationResult = ApolloReactCommon.MutationResult<UpdateNoticeStaffMutation>;
export type UpdateNoticeStaffMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNoticeStaffMutation, UpdateNoticeStaffMutationVariables>;
export const GetMonthlyPaymentPreviewDocument = gql`
    query getMonthlyPaymentPreview($monthlyPaymentPreviewOptions: ScheduledPaymentPreviewInput!) {
  getMonthlyPaymentPreview(monthlyPaymentPreviewOptions: $monthlyPaymentPreviewOptions)
}
    `;

/**
 * __useGetMonthlyPaymentPreviewQuery__
 *
 * To run a query within a React component, call `useGetMonthlyPaymentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyPaymentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyPaymentPreviewQuery({
 *   variables: {
 *      monthlyPaymentPreviewOptions: // value for 'monthlyPaymentPreviewOptions'
 *   },
 * });
 */
export function useGetMonthlyPaymentPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMonthlyPaymentPreviewQuery, GetMonthlyPaymentPreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMonthlyPaymentPreviewQuery, GetMonthlyPaymentPreviewQueryVariables>(GetMonthlyPaymentPreviewDocument, baseOptions);
      }
export function useGetMonthlyPaymentPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMonthlyPaymentPreviewQuery, GetMonthlyPaymentPreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMonthlyPaymentPreviewQuery, GetMonthlyPaymentPreviewQueryVariables>(GetMonthlyPaymentPreviewDocument, baseOptions);
        }
export type GetMonthlyPaymentPreviewQueryHookResult = ReturnType<typeof useGetMonthlyPaymentPreviewQuery>;
export type GetMonthlyPaymentPreviewLazyQueryHookResult = ReturnType<typeof useGetMonthlyPaymentPreviewLazyQuery>;
export type GetMonthlyPaymentPreviewQueryResult = ApolloReactCommon.QueryResult<GetMonthlyPaymentPreviewQuery, GetMonthlyPaymentPreviewQueryVariables>;
export const GetBookingByIdDocument = gql`
    query getBookingById($id: ID!) {
  bookingById(id: $id) {
    isSettled
    transferIn {
      sourceBookingNumber
      appliedAmount
    }
    id
    bookingNumber
    bookingNumberPrefix
    bookingType
    updateDate
    createDate
    noticeStaff
    noticeBooker
    coursePriceId
    payDate
    grossPrice
    netPrice
    vat
    pricingReason
    pricingCalculatedAt
    pricingSnapshot
    lessonSelectionMode
    memberDiscount
    discount
    discountName
    hasDiscountCode
    isSpecial
    startDateTime
    courseId
    paymentMethodId
    bookedBy
    canceled
    monthlySchedule
    paymentType
    creditedBalance
    waitListCount
    additionalInfo
    foundUs
    bookedLessonCount
    coursePrice {
      id
      grossPrice
      netPrice
      vat
    }
    invoice {
      billed
      invoiceNumber
      invoiceNumberPrefix
      createDate
      correctionDate
      createDate
      id
    }
    reversalInvoice {
      id
      invoiceNumber
      invoiceNumberPrefix
      createDate
    }
    courseLessons {
      startDateTime
      endDateTime
      id
      locationId
      course {
        id
        freePlaces
        bookingCount
        startDateTime
        paymentInterval
        minAttendees
        maxAttendees
        prefixedCourseNumber
        allowMonthlyPayment
        allowUpFrontPayment
        monthlySchedule
        courseType {
          id
          name
          color
        }
        coursePrice {
          id
          grossPrice
          netPrice
          vat
          discount
          discountUnit
          isSpecial
        }
        installmentRates {
          id
          installmentAmount
          installmentDue
        }
        paymentType
        lessons {
          id
          startDateTime
        }
        allowLessonBooking
        allowMolliePayment
        mollieOptional
      }
      location {
        id
        city
        name
      }
    }
    attendee {
      id
      erasedAt
      gender
      firstname
      lastname
      birthday
      customerNumberPrefix
      customerNumber
      member
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
      booker {
        id
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        street
        houseNumber
        postCode
        city
        phoneNumber
        mobileNumber
        email
        gender
        hasBillingAddress
        billingCompanyName
        billingFirstname
        billingLastname
        billingAddition
        billingStreet
        billingPostCode
        billingCity
        paymentMethods {
          id
          type
          cash
          esr
          iban
          bank
          bic
          sepaAccountholder
          bankTransfer
          onlinePayment
        }
        nonDisclosureNotice
        credit
      }
      defaultPaymentMethod {
        id
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
      }
    }
    paymentMethod {
      id
      cash
      esr
      creditcardNumber
      creditCardAccountholder
      expirationDate
      sepaAccountholder
      iban
      bic
      bank
      paypalAccountholder
      email
      bankTransfer
      onlinePayment
    }
    scheduledPayments {
      id
      paymentAmount
      refundedAmount
      providerRefundedAmount
      molliePaidAmount
      paymentDue
      paymentDone
      openAmount
      type
      title
      postKind
      carriedOverAt
      additionalItemId
      vat
      paymentProvider
      mollieMethod
    }
    molliePaymentAttempts {
      id
      scheduledPaymentId
      status
      mollieMethod
      linkExpiresAt
      checkoutUrl
      isCurrentAttempt
      createDate
    }
  }
}
    `;

/**
 * __useGetBookingByIdQuery__
 *
 * To run a query within a React component, call `useGetBookingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingByIdQuery, GetBookingByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingByIdQuery, GetBookingByIdQueryVariables>(GetBookingByIdDocument, baseOptions);
      }
export function useGetBookingByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingByIdQuery, GetBookingByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingByIdQuery, GetBookingByIdQueryVariables>(GetBookingByIdDocument, baseOptions);
        }
export type GetBookingByIdQueryHookResult = ReturnType<typeof useGetBookingByIdQuery>;
export type GetBookingByIdLazyQueryHookResult = ReturnType<typeof useGetBookingByIdLazyQuery>;
export type GetBookingByIdQueryResult = ApolloReactCommon.QueryResult<GetBookingByIdQuery, GetBookingByIdQueryVariables>;
export const GetBookingsByCourseDocument = gql`
    query GetBookingsByCourse($options: ArrayDataOptions, $id: ID!) {
  getBookingsByCourse(options: $options, id: $id) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      waitListCount
      additionalInfo
      foundUs
      bookedLessonCount
      lessonSelectionMode
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        indexOfLessonInCourse
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          email
          city
          street
          houseNumber
          postCode
          credit
          phoneNumber
          mobileNumber
          nonDisclosureNotice
        }
        badgeXAttendee {
          id
          createDate
          dateOfAchivement
          badge {
            id
            name
            abbreviation
            color
          }
        }
      }
      paymentMethod {
        id
        type
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      molliePaymentAttempts {
        id
        molliePaymentLinkId
        linkExpiresAt
        status
        paidAt
        isCurrentAttempt
        createDate
      }
    }
  }
}
    `;

/**
 * __useGetBookingsByCourseQuery__
 *
 * To run a query within a React component, call `useGetBookingsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByCourseQuery({
 *   variables: {
 *      options: // value for 'options'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingsByCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByCourseQuery, GetBookingsByCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByCourseQuery, GetBookingsByCourseQueryVariables>(GetBookingsByCourseDocument, baseOptions);
      }
export function useGetBookingsByCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByCourseQuery, GetBookingsByCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByCourseQuery, GetBookingsByCourseQueryVariables>(GetBookingsByCourseDocument, baseOptions);
        }
export type GetBookingsByCourseQueryHookResult = ReturnType<typeof useGetBookingsByCourseQuery>;
export type GetBookingsByCourseLazyQueryHookResult = ReturnType<typeof useGetBookingsByCourseLazyQuery>;
export type GetBookingsByCourseQueryResult = ApolloReactCommon.QueryResult<GetBookingsByCourseQuery, GetBookingsByCourseQueryVariables>;
export const GetWaitlistByCourseDocument = gql`
    query GetWaitlistByCourse($options: ArrayDataOptions, $id: ID!) {
  getWaitlistByCourse(options: $options, id: $id) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      coursePriceId
      courseId
      grossPrice
      netPrice
      vat
      isSpecial
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        course {
          id
          paymentInterval
          allowLessonBooking
        }
      }
      paymentType
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          gender
          nonDisclosureNotice
        }
      }
      canceled
      waitListCount
      bookedLessonCount
    }
  }
}
    `;

/**
 * __useGetWaitlistByCourseQuery__
 *
 * To run a query within a React component, call `useGetWaitlistByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitlistByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitlistByCourseQuery({
 *   variables: {
 *      options: // value for 'options'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWaitlistByCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWaitlistByCourseQuery, GetWaitlistByCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWaitlistByCourseQuery, GetWaitlistByCourseQueryVariables>(GetWaitlistByCourseDocument, baseOptions);
      }
export function useGetWaitlistByCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWaitlistByCourseQuery, GetWaitlistByCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWaitlistByCourseQuery, GetWaitlistByCourseQueryVariables>(GetWaitlistByCourseDocument, baseOptions);
        }
export type GetWaitlistByCourseQueryHookResult = ReturnType<typeof useGetWaitlistByCourseQuery>;
export type GetWaitlistByCourseLazyQueryHookResult = ReturnType<typeof useGetWaitlistByCourseLazyQuery>;
export type GetWaitlistByCourseQueryResult = ApolloReactCommon.QueryResult<GetWaitlistByCourseQuery, GetWaitlistByCourseQueryVariables>;
export const GetWaitlistCountOfCourseDocument = gql`
    query GetWaitlistCountOfCourse($id: ID!) {
  getWaitlistCountOfCourse(id: $id)
}
    `;

/**
 * __useGetWaitlistCountOfCourseQuery__
 *
 * To run a query within a React component, call `useGetWaitlistCountOfCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitlistCountOfCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitlistCountOfCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWaitlistCountOfCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWaitlistCountOfCourseQuery, GetWaitlistCountOfCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWaitlistCountOfCourseQuery, GetWaitlistCountOfCourseQueryVariables>(GetWaitlistCountOfCourseDocument, baseOptions);
      }
export function useGetWaitlistCountOfCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWaitlistCountOfCourseQuery, GetWaitlistCountOfCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWaitlistCountOfCourseQuery, GetWaitlistCountOfCourseQueryVariables>(GetWaitlistCountOfCourseDocument, baseOptions);
        }
export type GetWaitlistCountOfCourseQueryHookResult = ReturnType<typeof useGetWaitlistCountOfCourseQuery>;
export type GetWaitlistCountOfCourseLazyQueryHookResult = ReturnType<typeof useGetWaitlistCountOfCourseLazyQuery>;
export type GetWaitlistCountOfCourseQueryResult = ApolloReactCommon.QueryResult<GetWaitlistCountOfCourseQuery, GetWaitlistCountOfCourseQueryVariables>;
export const GetBookingsByCourseMinimalDocument = gql`
    query GetBookingsByCourseMinimal($options: ArrayDataOptions, $id: ID!) {
  getBookingsByCourse(options: $options, id: $id) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      attendee {
        id
        gender
        birthday
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          firstname
          lastname
          gender
          customerNumberPrefix
          customerNumber
          email
          nonDisclosureNotice
        }
      }
      canceled
      waitListCount
    }
  }
}
    `;

/**
 * __useGetBookingsByCourseMinimalQuery__
 *
 * To run a query within a React component, call `useGetBookingsByCourseMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByCourseMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByCourseMinimalQuery({
 *   variables: {
 *      options: // value for 'options'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingsByCourseMinimalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByCourseMinimalQuery, GetBookingsByCourseMinimalQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByCourseMinimalQuery, GetBookingsByCourseMinimalQueryVariables>(GetBookingsByCourseMinimalDocument, baseOptions);
      }
export function useGetBookingsByCourseMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByCourseMinimalQuery, GetBookingsByCourseMinimalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByCourseMinimalQuery, GetBookingsByCourseMinimalQueryVariables>(GetBookingsByCourseMinimalDocument, baseOptions);
        }
export type GetBookingsByCourseMinimalQueryHookResult = ReturnType<typeof useGetBookingsByCourseMinimalQuery>;
export type GetBookingsByCourseMinimalLazyQueryHookResult = ReturnType<typeof useGetBookingsByCourseMinimalLazyQuery>;
export type GetBookingsByCourseMinimalQueryResult = ApolloReactCommon.QueryResult<GetBookingsByCourseMinimalQuery, GetBookingsByCourseMinimalQueryVariables>;
export const GetBookingsByCourseForTransferDocument = gql`
    query GetBookingsByCourseForTransfer($options: ArrayDataOptions, $id: ID!) {
  getBookingsByCourse(options: $options, id: $id) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      attendee {
        id
        gender
        birthday
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          firstname
          lastname
          gender
          customerNumberPrefix
          customerNumber
          email
          nonDisclosureNotice
        }
      }
      canceled
      waitListCount
      invoice {
        id
      }
      bookedLessonCount
    }
  }
}
    `;

/**
 * __useGetBookingsByCourseForTransferQuery__
 *
 * To run a query within a React component, call `useGetBookingsByCourseForTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByCourseForTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByCourseForTransferQuery({
 *   variables: {
 *      options: // value for 'options'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingsByCourseForTransferQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByCourseForTransferQuery, GetBookingsByCourseForTransferQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByCourseForTransferQuery, GetBookingsByCourseForTransferQueryVariables>(GetBookingsByCourseForTransferDocument, baseOptions);
      }
export function useGetBookingsByCourseForTransferLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByCourseForTransferQuery, GetBookingsByCourseForTransferQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByCourseForTransferQuery, GetBookingsByCourseForTransferQueryVariables>(GetBookingsByCourseForTransferDocument, baseOptions);
        }
export type GetBookingsByCourseForTransferQueryHookResult = ReturnType<typeof useGetBookingsByCourseForTransferQuery>;
export type GetBookingsByCourseForTransferLazyQueryHookResult = ReturnType<typeof useGetBookingsByCourseForTransferLazyQuery>;
export type GetBookingsByCourseForTransferQueryResult = ApolloReactCommon.QueryResult<GetBookingsByCourseForTransferQuery, GetBookingsByCourseForTransferQueryVariables>;
export const GetBookingsCountByCourseDocument = gql`
    query GetBookingsCountByCourse($options: ArrayDataOptions, $id: ID!) {
  getBookingsByCourse(options: $options, id: $id) {
    existsMore
    total
    items {
      id
      bookingNumberPrefix
      bookingType
      canceled
      waitListCount
    }
  }
}
    `;

/**
 * __useGetBookingsCountByCourseQuery__
 *
 * To run a query within a React component, call `useGetBookingsCountByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsCountByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsCountByCourseQuery({
 *   variables: {
 *      options: // value for 'options'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingsCountByCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsCountByCourseQuery, GetBookingsCountByCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsCountByCourseQuery, GetBookingsCountByCourseQueryVariables>(GetBookingsCountByCourseDocument, baseOptions);
      }
export function useGetBookingsCountByCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsCountByCourseQuery, GetBookingsCountByCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsCountByCourseQuery, GetBookingsCountByCourseQueryVariables>(GetBookingsCountByCourseDocument, baseOptions);
        }
export type GetBookingsCountByCourseQueryHookResult = ReturnType<typeof useGetBookingsCountByCourseQuery>;
export type GetBookingsCountByCourseLazyQueryHookResult = ReturnType<typeof useGetBookingsCountByCourseLazyQuery>;
export type GetBookingsCountByCourseQueryResult = ApolloReactCommon.QueryResult<GetBookingsCountByCourseQuery, GetBookingsCountByCourseQueryVariables>;
export const RemoveAllBookingsDocument = gql`
    mutation RemoveAllBookings {
  removeAllBookings
}
    `;
export type RemoveAllBookingsMutationFn = ApolloReactCommon.MutationFunction<RemoveAllBookingsMutation, RemoveAllBookingsMutationVariables>;

/**
 * __useRemoveAllBookingsMutation__
 *
 * To run a mutation, you first call `useRemoveAllBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllBookingsMutation, { data, loading, error }] = useRemoveAllBookingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveAllBookingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllBookingsMutation, RemoveAllBookingsMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveAllBookingsMutation, RemoveAllBookingsMutationVariables>(RemoveAllBookingsDocument, baseOptions);
      }
export type RemoveAllBookingsMutationHookResult = ReturnType<typeof useRemoveAllBookingsMutation>;
export type RemoveAllBookingsMutationResult = ApolloReactCommon.MutationResult<RemoveAllBookingsMutation>;
export type RemoveAllBookingsMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAllBookingsMutation, RemoveAllBookingsMutationVariables>;
export const SendBookingConfirmationDocument = gql`
    mutation SendBookingConfirmation($bookingId: ID!, $editedTemplateInput: EditTemplateInput) {
  sendBookingConfirmation(bookingId: $bookingId, editedTemplateInput: $editedTemplateInput)
}
    `;
export type SendBookingConfirmationMutationFn = ApolloReactCommon.MutationFunction<SendBookingConfirmationMutation, SendBookingConfirmationMutationVariables>;

/**
 * __useSendBookingConfirmationMutation__
 *
 * To run a mutation, you first call `useSendBookingConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingConfirmationMutation, { data, loading, error }] = useSendBookingConfirmationMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      editedTemplateInput: // value for 'editedTemplateInput'
 *   },
 * });
 */
export function useSendBookingConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendBookingConfirmationMutation, SendBookingConfirmationMutationVariables>) {
        return ApolloReactHooks.useMutation<SendBookingConfirmationMutation, SendBookingConfirmationMutationVariables>(SendBookingConfirmationDocument, baseOptions);
      }
export type SendBookingConfirmationMutationHookResult = ReturnType<typeof useSendBookingConfirmationMutation>;
export type SendBookingConfirmationMutationResult = ApolloReactCommon.MutationResult<SendBookingConfirmationMutation>;
export type SendBookingConfirmationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendBookingConfirmationMutation, SendBookingConfirmationMutationVariables>;
export const GetVariablesForBookingWithCourseDocument = gql`
    query getVariablesForBookingWithCourse($id: ID!) {
  bookingById(id: $id) {
    id
    attendee {
      id
      firstname
      lastname
      birthday
      member
      booker {
        id
        firstname
        lastname
      }
    }
    courseLessons {
      id
      startDateTime
      endDateTime
      course {
        id
        prefixedCourseNumber
        courseType {
          id
          name
          description
        }
        allowLessonBooking
      }
      location {
        id
        city
        name
      }
    }
    creditedBalance
    memberDiscount
    discount
    discountName
    bookedLessonCount
  }
}
    `;

/**
 * __useGetVariablesForBookingWithCourseQuery__
 *
 * To run a query within a React component, call `useGetVariablesForBookingWithCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariablesForBookingWithCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariablesForBookingWithCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVariablesForBookingWithCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVariablesForBookingWithCourseQuery, GetVariablesForBookingWithCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetVariablesForBookingWithCourseQuery, GetVariablesForBookingWithCourseQueryVariables>(GetVariablesForBookingWithCourseDocument, baseOptions);
      }
export function useGetVariablesForBookingWithCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVariablesForBookingWithCourseQuery, GetVariablesForBookingWithCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetVariablesForBookingWithCourseQuery, GetVariablesForBookingWithCourseQueryVariables>(GetVariablesForBookingWithCourseDocument, baseOptions);
        }
export type GetVariablesForBookingWithCourseQueryHookResult = ReturnType<typeof useGetVariablesForBookingWithCourseQuery>;
export type GetVariablesForBookingWithCourseLazyQueryHookResult = ReturnType<typeof useGetVariablesForBookingWithCourseLazyQuery>;
export type GetVariablesForBookingWithCourseQueryResult = ApolloReactCommon.QueryResult<GetVariablesForBookingWithCourseQuery, GetVariablesForBookingWithCourseQueryVariables>;
export const ConvertBookingToWaitlistDocument = gql`
    mutation convertBookingToWaitlist($bookingId: ID!) {
  convertBookingToWaitlist(bookingId: $bookingId) {
    id
    bookingType
    bookingNumberPrefix
    bookingNumber
    attendee {
      id
      firstname
      lastname
      member
    }
  }
}
    `;
export type ConvertBookingToWaitlistMutationFn = ApolloReactCommon.MutationFunction<ConvertBookingToWaitlistMutation, ConvertBookingToWaitlistMutationVariables>;

/**
 * __useConvertBookingToWaitlistMutation__
 *
 * To run a mutation, you first call `useConvertBookingToWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertBookingToWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertBookingToWaitlistMutation, { data, loading, error }] = useConvertBookingToWaitlistMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useConvertBookingToWaitlistMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertBookingToWaitlistMutation, ConvertBookingToWaitlistMutationVariables>) {
        return ApolloReactHooks.useMutation<ConvertBookingToWaitlistMutation, ConvertBookingToWaitlistMutationVariables>(ConvertBookingToWaitlistDocument, baseOptions);
      }
export type ConvertBookingToWaitlistMutationHookResult = ReturnType<typeof useConvertBookingToWaitlistMutation>;
export type ConvertBookingToWaitlistMutationResult = ApolloReactCommon.MutationResult<ConvertBookingToWaitlistMutation>;
export type ConvertBookingToWaitlistMutationOptions = ApolloReactCommon.BaseMutationOptions<ConvertBookingToWaitlistMutation, ConvertBookingToWaitlistMutationVariables>;
export const ConvertWaitlistToBookingDocument = gql`
    mutation convertWaitlistToBooking($bookingId: ID!) {
  convertWaitlistToBooking(bookingId: $bookingId) {
    id
    bookingType
    bookingNumberPrefix
    bookingNumber
    attendee {
      id
      firstname
      lastname
      member
    }
  }
}
    `;
export type ConvertWaitlistToBookingMutationFn = ApolloReactCommon.MutationFunction<ConvertWaitlistToBookingMutation, ConvertWaitlistToBookingMutationVariables>;

/**
 * __useConvertWaitlistToBookingMutation__
 *
 * To run a mutation, you first call `useConvertWaitlistToBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertWaitlistToBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertWaitlistToBookingMutation, { data, loading, error }] = useConvertWaitlistToBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useConvertWaitlistToBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertWaitlistToBookingMutation, ConvertWaitlistToBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<ConvertWaitlistToBookingMutation, ConvertWaitlistToBookingMutationVariables>(ConvertWaitlistToBookingDocument, baseOptions);
      }
export type ConvertWaitlistToBookingMutationHookResult = ReturnType<typeof useConvertWaitlistToBookingMutation>;
export type ConvertWaitlistToBookingMutationResult = ApolloReactCommon.MutationResult<ConvertWaitlistToBookingMutation>;
export type ConvertWaitlistToBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<ConvertWaitlistToBookingMutation, ConvertWaitlistToBookingMutationVariables>;
export const TransferAttendeeToCourseDocument = gql`
    mutation transferAttendeeToCourse($bookingId: ID!, $targetCourseId: ID!, $bookingDeleteAction: BookingDeleteAction, $usePlaceReservation: Boolean, $deleteNotes: Boolean) {
  transferAttendeeToCourse(bookingId: $bookingId, targetCourseId: $targetCourseId, bookingDeleteAction: $bookingDeleteAction, usePlaceReservation: $usePlaceReservation, deleteNotes: $deleteNotes) {
    id
    bookingType
    bookingNumberPrefix
    bookingType
    grossPrice
    netPrice
    vat
    noticeStaff
    attendee {
      id
      firstname
      lastname
      member
    }
    courseLessons {
      id
      course {
        id
        prefixedCourseNumber
        courseType {
          id
          name
        }
        allowLessonBooking
      }
    }
    bookedLessonCount
    scheduledPayments {
      id
      paymentAmount
      paymentDue
      paymentDone
      openAmount
    }
  }
}
    `;
export type TransferAttendeeToCourseMutationFn = ApolloReactCommon.MutationFunction<TransferAttendeeToCourseMutation, TransferAttendeeToCourseMutationVariables>;

/**
 * __useTransferAttendeeToCourseMutation__
 *
 * To run a mutation, you first call `useTransferAttendeeToCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferAttendeeToCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferAttendeeToCourseMutation, { data, loading, error }] = useTransferAttendeeToCourseMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      targetCourseId: // value for 'targetCourseId'
 *      bookingDeleteAction: // value for 'bookingDeleteAction'
 *      usePlaceReservation: // value for 'usePlaceReservation'
 *      deleteNotes: // value for 'deleteNotes'
 *   },
 * });
 */
export function useTransferAttendeeToCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferAttendeeToCourseMutation, TransferAttendeeToCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<TransferAttendeeToCourseMutation, TransferAttendeeToCourseMutationVariables>(TransferAttendeeToCourseDocument, baseOptions);
      }
export type TransferAttendeeToCourseMutationHookResult = ReturnType<typeof useTransferAttendeeToCourseMutation>;
export type TransferAttendeeToCourseMutationResult = ApolloReactCommon.MutationResult<TransferAttendeeToCourseMutation>;
export type TransferAttendeeToCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<TransferAttendeeToCourseMutation, TransferAttendeeToCourseMutationVariables>;
export const VoidMolliePaymentLinkForBookingDocument = gql`
    mutation VoidMolliePaymentLinkForBooking($bookingId: ID!) {
  voidMolliePaymentLinkForBooking(bookingId: $bookingId) {
    id
  }
}
    `;
export type VoidMolliePaymentLinkForBookingMutationFn = ApolloReactCommon.MutationFunction<VoidMolliePaymentLinkForBookingMutation, VoidMolliePaymentLinkForBookingMutationVariables>;

/**
 * __useVoidMolliePaymentLinkForBookingMutation__
 *
 * To run a mutation, you first call `useVoidMolliePaymentLinkForBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidMolliePaymentLinkForBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidMolliePaymentLinkForBookingMutation, { data, loading, error }] = useVoidMolliePaymentLinkForBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useVoidMolliePaymentLinkForBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VoidMolliePaymentLinkForBookingMutation, VoidMolliePaymentLinkForBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<VoidMolliePaymentLinkForBookingMutation, VoidMolliePaymentLinkForBookingMutationVariables>(VoidMolliePaymentLinkForBookingDocument, baseOptions);
      }
export type VoidMolliePaymentLinkForBookingMutationHookResult = ReturnType<typeof useVoidMolliePaymentLinkForBookingMutation>;
export type VoidMolliePaymentLinkForBookingMutationResult = ApolloReactCommon.MutationResult<VoidMolliePaymentLinkForBookingMutation>;
export type VoidMolliePaymentLinkForBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<VoidMolliePaymentLinkForBookingMutation, VoidMolliePaymentLinkForBookingMutationVariables>;
export const VoidMolliePaymentLinksForBookingsDocument = gql`
    mutation VoidMolliePaymentLinksForBookings($bookingIds: [ID!]!) {
  voidMolliePaymentLinksForBookings(bookingIds: $bookingIds) {
    bookingId
    voided
    error
  }
}
    `;
export type VoidMolliePaymentLinksForBookingsMutationFn = ApolloReactCommon.MutationFunction<VoidMolliePaymentLinksForBookingsMutation, VoidMolliePaymentLinksForBookingsMutationVariables>;

/**
 * __useVoidMolliePaymentLinksForBookingsMutation__
 *
 * To run a mutation, you first call `useVoidMolliePaymentLinksForBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidMolliePaymentLinksForBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidMolliePaymentLinksForBookingsMutation, { data, loading, error }] = useVoidMolliePaymentLinksForBookingsMutation({
 *   variables: {
 *      bookingIds: // value for 'bookingIds'
 *   },
 * });
 */
export function useVoidMolliePaymentLinksForBookingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VoidMolliePaymentLinksForBookingsMutation, VoidMolliePaymentLinksForBookingsMutationVariables>) {
        return ApolloReactHooks.useMutation<VoidMolliePaymentLinksForBookingsMutation, VoidMolliePaymentLinksForBookingsMutationVariables>(VoidMolliePaymentLinksForBookingsDocument, baseOptions);
      }
export type VoidMolliePaymentLinksForBookingsMutationHookResult = ReturnType<typeof useVoidMolliePaymentLinksForBookingsMutation>;
export type VoidMolliePaymentLinksForBookingsMutationResult = ApolloReactCommon.MutationResult<VoidMolliePaymentLinksForBookingsMutation>;
export type VoidMolliePaymentLinksForBookingsMutationOptions = ApolloReactCommon.BaseMutationOptions<VoidMolliePaymentLinksForBookingsMutation, VoidMolliePaymentLinksForBookingsMutationVariables>;
export const CopyAttendeeToCourseDocument = gql`
    mutation copyAttendeeToCourse($bookingId: ID!, $targetCourseId: ID!, $usePlaceReservation: Boolean, $deleteNotes: Boolean) {
  copyAttendeeToCourse(bookingId: $bookingId, targetCourseId: $targetCourseId, usePlaceReservation: $usePlaceReservation, deleteNotes: $deleteNotes) {
    id
    bookingType
    bookingNumberPrefix
    bookingType
    attendee {
      id
      firstname
      lastname
      member
    }
    courseLessons {
      id
      course {
        id
        prefixedCourseNumber
        courseType {
          id
          name
        }
        allowLessonBooking
      }
    }
    bookedLessonCount
  }
}
    `;
export type CopyAttendeeToCourseMutationFn = ApolloReactCommon.MutationFunction<CopyAttendeeToCourseMutation, CopyAttendeeToCourseMutationVariables>;

/**
 * __useCopyAttendeeToCourseMutation__
 *
 * To run a mutation, you first call `useCopyAttendeeToCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAttendeeToCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAttendeeToCourseMutation, { data, loading, error }] = useCopyAttendeeToCourseMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      targetCourseId: // value for 'targetCourseId'
 *      usePlaceReservation: // value for 'usePlaceReservation'
 *      deleteNotes: // value for 'deleteNotes'
 *   },
 * });
 */
export function useCopyAttendeeToCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyAttendeeToCourseMutation, CopyAttendeeToCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<CopyAttendeeToCourseMutation, CopyAttendeeToCourseMutationVariables>(CopyAttendeeToCourseDocument, baseOptions);
      }
export type CopyAttendeeToCourseMutationHookResult = ReturnType<typeof useCopyAttendeeToCourseMutation>;
export type CopyAttendeeToCourseMutationResult = ApolloReactCommon.MutationResult<CopyAttendeeToCourseMutation>;
export type CopyAttendeeToCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<CopyAttendeeToCourseMutation, CopyAttendeeToCourseMutationVariables>;
export const GetBookingsByIdsDocument = gql`
    query GetBookingsByIds($ids: [String!]!) {
  getBookingsByIds(ids: $ids) {
    id
    bookingNumberPrefix
    bookingNumber
    bookingType
    courseId
    attendee {
      id
      member
      booker {
        id
        firstname
        lastname
        email
        mobileNumber
      }
    }
    canceled
    waitListCount
    bookedLessonCount
  }
}
    `;

/**
 * __useGetBookingsByIdsQuery__
 *
 * To run a query within a React component, call `useGetBookingsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetBookingsByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByIdsQuery, GetBookingsByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByIdsQuery, GetBookingsByIdsQueryVariables>(GetBookingsByIdsDocument, baseOptions);
      }
export function useGetBookingsByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByIdsQuery, GetBookingsByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByIdsQuery, GetBookingsByIdsQueryVariables>(GetBookingsByIdsDocument, baseOptions);
        }
export type GetBookingsByIdsQueryHookResult = ReturnType<typeof useGetBookingsByIdsQuery>;
export type GetBookingsByIdsLazyQueryHookResult = ReturnType<typeof useGetBookingsByIdsLazyQuery>;
export type GetBookingsByIdsQueryResult = ApolloReactCommon.QueryResult<GetBookingsByIdsQuery, GetBookingsByIdsQueryVariables>;
export const GetBookingsByScheduledPaymentIdsDocument = gql`
    query GetBookingsByScheduledPaymentIds($scheduledPaymentIds: [String!]!) {
  getBookingsByScheduledPaymentIds(scheduledPaymentIds: $scheduledPaymentIds) {
    id
    bookingNumberPrefix
    bookingNumber
    bookingType
    attendee {
      id
      member
      booker {
        id
        firstname
        lastname
        email
      }
    }
    canceled
    bookedLessonCount
  }
}
    `;

/**
 * __useGetBookingsByScheduledPaymentIdsQuery__
 *
 * To run a query within a React component, call `useGetBookingsByScheduledPaymentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByScheduledPaymentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByScheduledPaymentIdsQuery({
 *   variables: {
 *      scheduledPaymentIds: // value for 'scheduledPaymentIds'
 *   },
 * });
 */
export function useGetBookingsByScheduledPaymentIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByScheduledPaymentIdsQuery, GetBookingsByScheduledPaymentIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByScheduledPaymentIdsQuery, GetBookingsByScheduledPaymentIdsQueryVariables>(GetBookingsByScheduledPaymentIdsDocument, baseOptions);
      }
export function useGetBookingsByScheduledPaymentIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByScheduledPaymentIdsQuery, GetBookingsByScheduledPaymentIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByScheduledPaymentIdsQuery, GetBookingsByScheduledPaymentIdsQueryVariables>(GetBookingsByScheduledPaymentIdsDocument, baseOptions);
        }
export type GetBookingsByScheduledPaymentIdsQueryHookResult = ReturnType<typeof useGetBookingsByScheduledPaymentIdsQuery>;
export type GetBookingsByScheduledPaymentIdsLazyQueryHookResult = ReturnType<typeof useGetBookingsByScheduledPaymentIdsLazyQuery>;
export type GetBookingsByScheduledPaymentIdsQueryResult = ApolloReactCommon.QueryResult<GetBookingsByScheduledPaymentIdsQuery, GetBookingsByScheduledPaymentIdsQueryVariables>;
export const GetBookingsByInvoiceIdsDocument = gql`
    query getBookingsByInvoiceIds($invoiceIds: [String!]!) {
  getBookingsByInvoiceIds(invoiceIds: $invoiceIds) {
    id
    bookingNumberPrefix
    bookingNumber
    bookingType
    bookedLessonCount
  }
}
    `;

/**
 * __useGetBookingsByInvoiceIdsQuery__
 *
 * To run a query within a React component, call `useGetBookingsByInvoiceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByInvoiceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByInvoiceIdsQuery({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useGetBookingsByInvoiceIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByInvoiceIdsQuery, GetBookingsByInvoiceIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByInvoiceIdsQuery, GetBookingsByInvoiceIdsQueryVariables>(GetBookingsByInvoiceIdsDocument, baseOptions);
      }
export function useGetBookingsByInvoiceIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByInvoiceIdsQuery, GetBookingsByInvoiceIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByInvoiceIdsQuery, GetBookingsByInvoiceIdsQueryVariables>(GetBookingsByInvoiceIdsDocument, baseOptions);
        }
export type GetBookingsByInvoiceIdsQueryHookResult = ReturnType<typeof useGetBookingsByInvoiceIdsQuery>;
export type GetBookingsByInvoiceIdsLazyQueryHookResult = ReturnType<typeof useGetBookingsByInvoiceIdsLazyQuery>;
export type GetBookingsByInvoiceIdsQueryResult = ApolloReactCommon.QueryResult<GetBookingsByInvoiceIdsQuery, GetBookingsByInvoiceIdsQueryVariables>;
export const GetBookingsByAttendeeIdWithOptionsDocument = gql`
    query GetBookingsByAttendeeIdWithOptions($id: ID!, $startDateTime: DateTime, $endDateTime: DateTime, $canceledBookings: Boolean) {
  getBookingsByAttendeeIdWithOptions(id: $id, startDateTime: $startDateTime, endDateTime: $endDateTime, canceledBookings: $canceledBookings) {
    id
    isSettled
    bookingNumber
    bookingNumberPrefix
    bookingType
    updateDate
    createDate
    startDateTime
    courseId
    noticeStaff
    attendanceListNote
    noticeBooker
    coursePriceId
    payDate
    grossPrice
    netPrice
    vat
    isSpecial
    paymentType
    bookedBy
    canceled
    waitListCount
    additionalInfo
    bookedLessonCount
    bookingConfirmationSent
    waitingListConfirmationSent
    cancelationSent
    invoiceSent
    course {
      id
      prefixedCourseNumber
      allowLessonBooking
      lessonCount
      paymentInterval
      freePlaces
      maxAttendees
      startDateTime
      endDateTime
      endDateTimeFirstCourseLesson
      courseType {
        id
        name
        color
      }
      location {
        id
        city
        name
      }
      instructors {
        id
        firstname
        lastname
      }
    }
    courseLessons {
      id
      startDateTime
      endDateTime
      indexOfLessonInCourse
    }
    courseLessonBookings {
      id
      courseLessonId
      bookingType
      bookingDate
      attendance
    }
    coursePrice {
      id
      grossPrice
      netPrice
      vat
    }
    invoice {
      id
      billed
      invoiceNumber
      invoiceNumberPrefix
      createDate
    }
    reversalInvoice {
      id
      invoiceNumber
      invoiceNumberPrefix
      createDate
    }
    attendee {
      id
      erasedAt
      gender
      firstname
      lastname
      birthday
      customerNumberPrefix
      customerNumber
      member
      booker {
        id
        gender
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        email
        city
        credit
        phoneNumber
        mobileNumber
        nonDisclosureNotice
      }
    }
    paymentMethod {
      id
      type
      cash
      esr
      iban
      bank
      bic
      sepaAccountholder
      bankTransfer
      onlinePayment
    }
    emailNotifications {
      id
      templateType
      subject
      createDate
      bookingId
      email
    }
  }
}
    `;

/**
 * __useGetBookingsByAttendeeIdWithOptionsQuery__
 *
 * To run a query within a React component, call `useGetBookingsByAttendeeIdWithOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByAttendeeIdWithOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByAttendeeIdWithOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      canceledBookings: // value for 'canceledBookings'
 *   },
 * });
 */
export function useGetBookingsByAttendeeIdWithOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByAttendeeIdWithOptionsQuery, GetBookingsByAttendeeIdWithOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByAttendeeIdWithOptionsQuery, GetBookingsByAttendeeIdWithOptionsQueryVariables>(GetBookingsByAttendeeIdWithOptionsDocument, baseOptions);
      }
export function useGetBookingsByAttendeeIdWithOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByAttendeeIdWithOptionsQuery, GetBookingsByAttendeeIdWithOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByAttendeeIdWithOptionsQuery, GetBookingsByAttendeeIdWithOptionsQueryVariables>(GetBookingsByAttendeeIdWithOptionsDocument, baseOptions);
        }
export type GetBookingsByAttendeeIdWithOptionsQueryHookResult = ReturnType<typeof useGetBookingsByAttendeeIdWithOptionsQuery>;
export type GetBookingsByAttendeeIdWithOptionsLazyQueryHookResult = ReturnType<typeof useGetBookingsByAttendeeIdWithOptionsLazyQuery>;
export type GetBookingsByAttendeeIdWithOptionsQueryResult = ApolloReactCommon.QueryResult<GetBookingsByAttendeeIdWithOptionsQuery, GetBookingsByAttendeeIdWithOptionsQueryVariables>;
export const UpdateAttendanceListNoteDocument = gql`
    mutation UpdateAttendanceListNote($bookingId: ID!, $attendanceListNote: String) {
  updateAttendanceListNote(bookingId: $bookingId, attendanceListNote: $attendanceListNote) {
    id
    attendanceListNote
  }
}
    `;
export type UpdateAttendanceListNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateAttendanceListNoteMutation, UpdateAttendanceListNoteMutationVariables>;

/**
 * __useUpdateAttendanceListNoteMutation__
 *
 * To run a mutation, you first call `useUpdateAttendanceListNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendanceListNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttendanceListNoteMutation, { data, loading, error }] = useUpdateAttendanceListNoteMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      attendanceListNote: // value for 'attendanceListNote'
 *   },
 * });
 */
export function useUpdateAttendanceListNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAttendanceListNoteMutation, UpdateAttendanceListNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAttendanceListNoteMutation, UpdateAttendanceListNoteMutationVariables>(UpdateAttendanceListNoteDocument, baseOptions);
      }
export type UpdateAttendanceListNoteMutationHookResult = ReturnType<typeof useUpdateAttendanceListNoteMutation>;
export type UpdateAttendanceListNoteMutationResult = ApolloReactCommon.MutationResult<UpdateAttendanceListNoteMutation>;
export type UpdateAttendanceListNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAttendanceListNoteMutation, UpdateAttendanceListNoteMutationVariables>;
export const UpdateBookingPaymentMethodDocument = gql`
    mutation UpdateBookingPaymentMethod($bookingId: ID!, $paymentMethodId: ID!) {
  updateBookingPaymentMethod(bookingId: $bookingId, paymentMethodId: $paymentMethodId) {
    id
    paymentMethodId
  }
}
    `;
export type UpdateBookingPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<UpdateBookingPaymentMethodMutation, UpdateBookingPaymentMethodMutationVariables>;

/**
 * __useUpdateBookingPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateBookingPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingPaymentMethodMutation, { data, loading, error }] = useUpdateBookingPaymentMethodMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useUpdateBookingPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookingPaymentMethodMutation, UpdateBookingPaymentMethodMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookingPaymentMethodMutation, UpdateBookingPaymentMethodMutationVariables>(UpdateBookingPaymentMethodDocument, baseOptions);
      }
export type UpdateBookingPaymentMethodMutationHookResult = ReturnType<typeof useUpdateBookingPaymentMethodMutation>;
export type UpdateBookingPaymentMethodMutationResult = ApolloReactCommon.MutationResult<UpdateBookingPaymentMethodMutation>;
export type UpdateBookingPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookingPaymentMethodMutation, UpdateBookingPaymentMethodMutationVariables>;
export const AddMultiplePlaceReservationsDocument = gql`
    mutation AddMultiplePlaceReservations($courseId: ID!, $count: Float!) {
  addMultiplePlaceReservations(courseId: $courseId, count: $count) {
    id
  }
}
    `;
export type AddMultiplePlaceReservationsMutationFn = ApolloReactCommon.MutationFunction<AddMultiplePlaceReservationsMutation, AddMultiplePlaceReservationsMutationVariables>;

/**
 * __useAddMultiplePlaceReservationsMutation__
 *
 * To run a mutation, you first call `useAddMultiplePlaceReservationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMultiplePlaceReservationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMultiplePlaceReservationsMutation, { data, loading, error }] = useAddMultiplePlaceReservationsMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useAddMultiplePlaceReservationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMultiplePlaceReservationsMutation, AddMultiplePlaceReservationsMutationVariables>) {
        return ApolloReactHooks.useMutation<AddMultiplePlaceReservationsMutation, AddMultiplePlaceReservationsMutationVariables>(AddMultiplePlaceReservationsDocument, baseOptions);
      }
export type AddMultiplePlaceReservationsMutationHookResult = ReturnType<typeof useAddMultiplePlaceReservationsMutation>;
export type AddMultiplePlaceReservationsMutationResult = ApolloReactCommon.MutationResult<AddMultiplePlaceReservationsMutation>;
export type AddMultiplePlaceReservationsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddMultiplePlaceReservationsMutation, AddMultiplePlaceReservationsMutationVariables>;
export const DeleteAllPlaceReservationsByCourseIdDocument = gql`
    mutation DeleteAllPlaceReservationsByCourseId($courseId: ID!) {
  deleteAllPlaceReservationsByCourseId(courseId: $courseId)
}
    `;
export type DeleteAllPlaceReservationsByCourseIdMutationFn = ApolloReactCommon.MutationFunction<DeleteAllPlaceReservationsByCourseIdMutation, DeleteAllPlaceReservationsByCourseIdMutationVariables>;

/**
 * __useDeleteAllPlaceReservationsByCourseIdMutation__
 *
 * To run a mutation, you first call `useDeleteAllPlaceReservationsByCourseIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllPlaceReservationsByCourseIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllPlaceReservationsByCourseIdMutation, { data, loading, error }] = useDeleteAllPlaceReservationsByCourseIdMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useDeleteAllPlaceReservationsByCourseIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAllPlaceReservationsByCourseIdMutation, DeleteAllPlaceReservationsByCourseIdMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAllPlaceReservationsByCourseIdMutation, DeleteAllPlaceReservationsByCourseIdMutationVariables>(DeleteAllPlaceReservationsByCourseIdDocument, baseOptions);
      }
export type DeleteAllPlaceReservationsByCourseIdMutationHookResult = ReturnType<typeof useDeleteAllPlaceReservationsByCourseIdMutation>;
export type DeleteAllPlaceReservationsByCourseIdMutationResult = ApolloReactCommon.MutationResult<DeleteAllPlaceReservationsByCourseIdMutation>;
export type DeleteAllPlaceReservationsByCourseIdMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAllPlaceReservationsByCourseIdMutation, DeleteAllPlaceReservationsByCourseIdMutationVariables>;
export const DeleteSelectionOfWaitlistDocument = gql`
    mutation DeleteSelectionOfWaitlist($bookingIds: [ID!]!) {
  deleteSelectionOfWaitlist(bookingIds: $bookingIds)
}
    `;
export type DeleteSelectionOfWaitlistMutationFn = ApolloReactCommon.MutationFunction<DeleteSelectionOfWaitlistMutation, DeleteSelectionOfWaitlistMutationVariables>;

/**
 * __useDeleteSelectionOfWaitlistMutation__
 *
 * To run a mutation, you first call `useDeleteSelectionOfWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSelectionOfWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSelectionOfWaitlistMutation, { data, loading, error }] = useDeleteSelectionOfWaitlistMutation({
 *   variables: {
 *      bookingIds: // value for 'bookingIds'
 *   },
 * });
 */
export function useDeleteSelectionOfWaitlistMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSelectionOfWaitlistMutation, DeleteSelectionOfWaitlistMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteSelectionOfWaitlistMutation, DeleteSelectionOfWaitlistMutationVariables>(DeleteSelectionOfWaitlistDocument, baseOptions);
      }
export type DeleteSelectionOfWaitlistMutationHookResult = ReturnType<typeof useDeleteSelectionOfWaitlistMutation>;
export type DeleteSelectionOfWaitlistMutationResult = ApolloReactCommon.MutationResult<DeleteSelectionOfWaitlistMutation>;
export type DeleteSelectionOfWaitlistMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSelectionOfWaitlistMutation, DeleteSelectionOfWaitlistMutationVariables>;
export const GetBookingsByCourseRefactoredDocument = gql`
    query GetBookingsByCourseRefactored($options: ArrayDataOptions, $id: ID!) {
  getBookingsByCourse(options: $options, id: $id) {
    existsMore
    total
    items {
      id
      isSettled
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      noticeStaff
      noticeBooker
      attendanceListNote
      coursePriceId
      courseId
      noticeBooker
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      paymentType
      courseLessons {
        id
        startDateTime
        endDateTime
        locationId
        course {
          id
          freePlaces
          startDateTime
          endDateTimeFirstCourseLesson
          paymentInterval
          minAttendees
          maxAttendees
          prefixedCourseNumber
          allowMonthlyPayment
          courseType {
            id
            name
            color
          }
          allowLessonBooking
        }
        location {
          id
          city
          name
        }
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          gender
          nonDisclosureNotice
          credit
        }
      }
      bookedBy
      canceled
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      paymentMethod {
        id
        type
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
        bankTransfer
        onlinePayment
      }
      waitListCount
      bookedLessonCount
    }
  }
}
    `;

/**
 * __useGetBookingsByCourseRefactoredQuery__
 *
 * To run a query within a React component, call `useGetBookingsByCourseRefactoredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByCourseRefactoredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByCourseRefactoredQuery({
 *   variables: {
 *      options: // value for 'options'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingsByCourseRefactoredQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByCourseRefactoredQuery, GetBookingsByCourseRefactoredQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByCourseRefactoredQuery, GetBookingsByCourseRefactoredQueryVariables>(GetBookingsByCourseRefactoredDocument, baseOptions);
      }
export function useGetBookingsByCourseRefactoredLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByCourseRefactoredQuery, GetBookingsByCourseRefactoredQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByCourseRefactoredQuery, GetBookingsByCourseRefactoredQueryVariables>(GetBookingsByCourseRefactoredDocument, baseOptions);
        }
export type GetBookingsByCourseRefactoredQueryHookResult = ReturnType<typeof useGetBookingsByCourseRefactoredQuery>;
export type GetBookingsByCourseRefactoredLazyQueryHookResult = ReturnType<typeof useGetBookingsByCourseRefactoredLazyQuery>;
export type GetBookingsByCourseRefactoredQueryResult = ApolloReactCommon.QueryResult<GetBookingsByCourseRefactoredQuery, GetBookingsByCourseRefactoredQueryVariables>;
export const TransferMultipleBookingsDocument = gql`
    mutation TransferMultipleBookings($transferMultipleBookingsInput: TransferMultipleBookingsInput!, $deleteNotes: Boolean) {
  transferMultipleBookings(transferMultipleBookingsInput: $transferMultipleBookingsInput, deleteNotes: $deleteNotes) {
    id
    bookingNumberPrefix
    bookingNumber
    grossPrice
    courseId
    scheduledPayments {
      id
      paymentDue
      paymentAmount
      type
    }
    attendee {
      id
      firstname
      lastname
      member
    }
  }
}
    `;
export type TransferMultipleBookingsMutationFn = ApolloReactCommon.MutationFunction<TransferMultipleBookingsMutation, TransferMultipleBookingsMutationVariables>;

/**
 * __useTransferMultipleBookingsMutation__
 *
 * To run a mutation, you first call `useTransferMultipleBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMultipleBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMultipleBookingsMutation, { data, loading, error }] = useTransferMultipleBookingsMutation({
 *   variables: {
 *      transferMultipleBookingsInput: // value for 'transferMultipleBookingsInput'
 *      deleteNotes: // value for 'deleteNotes'
 *   },
 * });
 */
export function useTransferMultipleBookingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferMultipleBookingsMutation, TransferMultipleBookingsMutationVariables>) {
        return ApolloReactHooks.useMutation<TransferMultipleBookingsMutation, TransferMultipleBookingsMutationVariables>(TransferMultipleBookingsDocument, baseOptions);
      }
export type TransferMultipleBookingsMutationHookResult = ReturnType<typeof useTransferMultipleBookingsMutation>;
export type TransferMultipleBookingsMutationResult = ApolloReactCommon.MutationResult<TransferMultipleBookingsMutation>;
export type TransferMultipleBookingsMutationOptions = ApolloReactCommon.BaseMutationOptions<TransferMultipleBookingsMutation, TransferMultipleBookingsMutationVariables>;
export const GetBookingsInStartedCoursesDocument = gql`
    query GetBookingsInStartedCourses($options: ArrayDataOptions) {
  bookingsInStartedCourses(options: $options) {
    existsMore
    total
    items {
      id
      isSettled
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      waitListCount
      additionalInfo
      foundUs
      bookedLessonCount
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        endDateTimeFirstCourseLesson
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        indexOfLessonInCourse
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          email
          city
          credit
          phoneNumber
          mobileNumber
          nonDisclosureNotice
        }
      }
      paymentMethod {
        id
        type
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
    }
  }
}
    `;

/**
 * __useGetBookingsInStartedCoursesQuery__
 *
 * To run a query within a React component, call `useGetBookingsInStartedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsInStartedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsInStartedCoursesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetBookingsInStartedCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsInStartedCoursesQuery, GetBookingsInStartedCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsInStartedCoursesQuery, GetBookingsInStartedCoursesQueryVariables>(GetBookingsInStartedCoursesDocument, baseOptions);
      }
export function useGetBookingsInStartedCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsInStartedCoursesQuery, GetBookingsInStartedCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsInStartedCoursesQuery, GetBookingsInStartedCoursesQueryVariables>(GetBookingsInStartedCoursesDocument, baseOptions);
        }
export type GetBookingsInStartedCoursesQueryHookResult = ReturnType<typeof useGetBookingsInStartedCoursesQuery>;
export type GetBookingsInStartedCoursesLazyQueryHookResult = ReturnType<typeof useGetBookingsInStartedCoursesLazyQuery>;
export type GetBookingsInStartedCoursesQueryResult = ApolloReactCommon.QueryResult<GetBookingsInStartedCoursesQuery, GetBookingsInStartedCoursesQueryVariables>;
export const TransferPlanPreviewDocument = gql`
    query TransferPlanPreview($input: TransferPlanInput!) {
  transferPlanPreview(input: $input) {
    confirmationToken
    itemReview {
      sourceRateId
      type
      title
      amount
      paid
      open
      carried
      waived
      carry
      reason
      vat
    }
    coursePrice
    transferDate
    priceOptions {
      kind
      priceB
      discountB
      memberDiscountB
      lessonsTotal
      lessonsRemaining
    }
    cutoff {
      applicable
      mode
      lessonsTotal
      lessonsAttended
      retainedPaid
      carriedOpen
      rates {
        sourceRateId
        due
        consumed
        retainedPaid
        carriedOpen
      }
    }
    cutoffApplied
    oldBookingOptions {
      kind
      transferred
      bookingPrice
      open
      surplus
      firstDue
    }
    partialSource {
      cardLessons
      attended
      remaining
      chosen
      lessonPrice
      price
    }
    priceB
    discountB
    discountReason
    sourceDiscount
    sourceDiscountName
    memberDiscountB
    vatB
    rates {
      type
      amount
      due
      title
      origin
      settledByTransfer
      fullyCovered
    }
    paidA
    appliedToB
    surplus
    creditAfter
    sourceCreditedBalance
    creditReapplied
    surplusHandling {
      kind
      creditAmount
      refundAmount
      reason
    }
    surplusMollieRefund {
      possible
      amount
      remainingCredit
      reason
      payments {
        scheduledPaymentId
        molliePaymentId
        paidAt
        amount
        capacity
        title
      }
    }
    oldBooking {
      treatment
      reason
    }
    carriedOverItems {
      type
      amount
      title
    }
    hints
    blockers
    hasActivePaymentLink
    communicationDefaults {
      sendMail
      attachReversalInvoice
      attachInvoiceB
      createInvoiceBNow
      templateAvailable
    }
  }
}
    `;

/**
 * __useTransferPlanPreviewQuery__
 *
 * To run a query within a React component, call `useTransferPlanPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferPlanPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferPlanPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferPlanPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransferPlanPreviewQuery, TransferPlanPreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<TransferPlanPreviewQuery, TransferPlanPreviewQueryVariables>(TransferPlanPreviewDocument, baseOptions);
      }
export function useTransferPlanPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransferPlanPreviewQuery, TransferPlanPreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TransferPlanPreviewQuery, TransferPlanPreviewQueryVariables>(TransferPlanPreviewDocument, baseOptions);
        }
export type TransferPlanPreviewQueryHookResult = ReturnType<typeof useTransferPlanPreviewQuery>;
export type TransferPlanPreviewLazyQueryHookResult = ReturnType<typeof useTransferPlanPreviewLazyQuery>;
export type TransferPlanPreviewQueryResult = ApolloReactCommon.QueryResult<TransferPlanPreviewQuery, TransferPlanPreviewQueryVariables>;
export const ExecuteTransferDocument = gql`
    mutation ExecuteTransfer($input: ExecuteTransferInput!) {
  executeTransfer(input: $input) {
    transferOperationId
    oldBookingDeleted
    promotedBookingId
    messages
    mailSent
    warnings
    reversalInvoice {
      id
      invoiceNumber
      invoiceNumberPrefix
    }
    invoiceB {
      id
      invoiceNumber
      invoiceNumberPrefix
    }
    surplusOutcome {
      kind
      requestedRefund
      refunded
      creditRemaining
      mollieRefundId
      reason
      refunds {
        scheduledPaymentId
        molliePaymentId
        amount
        mollieRefundId
      }
    }
    booking {
      id
      bookingType
      bookingNumber
      bookingNumberPrefix
      grossPrice
      netPrice
      vat
      courseId
    }
    plan {
      confirmationToken
      itemReview {
        sourceRateId
        type
        title
        amount
        paid
        open
        carried
        waived
        carry
        reason
        vat
      }
      rates {
        type
        amount
        due
        title
        origin
        settledByTransfer
        fullyCovered
      }
      paidA
      carriedOverItems {
        type
        amount
        title
      }
      priceB
      discountB
      discountReason
      appliedToB
      surplus
      creditAfter
      sourceCreditedBalance
      creditReapplied
      surplusHandling {
        kind
        creditAmount
        refundAmount
        reason
      }
      oldBooking {
        treatment
        reason
      }
      hints
      blockers
    }
  }
}
    `;
export type ExecuteTransferMutationFn = ApolloReactCommon.MutationFunction<ExecuteTransferMutation, ExecuteTransferMutationVariables>;

/**
 * __useExecuteTransferMutation__
 *
 * To run a mutation, you first call `useExecuteTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeTransferMutation, { data, loading, error }] = useExecuteTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteTransferMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExecuteTransferMutation, ExecuteTransferMutationVariables>) {
        return ApolloReactHooks.useMutation<ExecuteTransferMutation, ExecuteTransferMutationVariables>(ExecuteTransferDocument, baseOptions);
      }
export type ExecuteTransferMutationHookResult = ReturnType<typeof useExecuteTransferMutation>;
export type ExecuteTransferMutationResult = ApolloReactCommon.MutationResult<ExecuteTransferMutation>;
export type ExecuteTransferMutationOptions = ApolloReactCommon.BaseMutationOptions<ExecuteTransferMutation, ExecuteTransferMutationVariables>;
export const TransferBulkPlanPreviewDocument = gql`
    query TransferBulkPlanPreview($input: TransferBulkPlanInput!) {
  transferBulkPlanPreview(input: $input) {
    blockers
    maxBookings
    templateAvailable
    rows {
      sourceBookingId
      sourceBookingNumber
      attendeeName
      plan {
        confirmationToken
        transferDate
        priceOptions {
          kind
          priceB
          discountB
          memberDiscountB
          lessonsTotal
          lessonsRemaining
        }
        cutoff {
          applicable
          mode
          lessonsTotal
          lessonsAttended
          retainedPaid
          carriedOpen
          rates {
            sourceRateId
            due
            consumed
            retainedPaid
            carriedOpen
          }
        }
        cutoffApplied
        oldBookingOptions {
          kind
          transferred
          bookingPrice
          open
          surplus
          firstDue
        }
        partialSource {
          cardLessons
          attended
          remaining
          chosen
          lessonPrice
          price
        }
        priceB
        discountB
        discountReason
        paidA
        appliedToB
        surplus
        creditAfter
        sourceCreditedBalance
        creditReapplied
        oldBooking {
          treatment
          reason
        }
        carriedOverItems {
          type
          amount
          title
        }
        hints
        blockers
        hasActivePaymentLink
        communicationDefaults {
          sendMail
          attachReversalInvoice
          attachInvoiceB
          createInvoiceBNow
          templateAvailable
        }
      }
    }
  }
}
    `;

/**
 * __useTransferBulkPlanPreviewQuery__
 *
 * To run a query within a React component, call `useTransferBulkPlanPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferBulkPlanPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferBulkPlanPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferBulkPlanPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransferBulkPlanPreviewQuery, TransferBulkPlanPreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<TransferBulkPlanPreviewQuery, TransferBulkPlanPreviewQueryVariables>(TransferBulkPlanPreviewDocument, baseOptions);
      }
export function useTransferBulkPlanPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransferBulkPlanPreviewQuery, TransferBulkPlanPreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TransferBulkPlanPreviewQuery, TransferBulkPlanPreviewQueryVariables>(TransferBulkPlanPreviewDocument, baseOptions);
        }
export type TransferBulkPlanPreviewQueryHookResult = ReturnType<typeof useTransferBulkPlanPreviewQuery>;
export type TransferBulkPlanPreviewLazyQueryHookResult = ReturnType<typeof useTransferBulkPlanPreviewLazyQuery>;
export type TransferBulkPlanPreviewQueryResult = ApolloReactCommon.QueryResult<TransferBulkPlanPreviewQuery, TransferBulkPlanPreviewQueryVariables>;
export const ExecuteBulkTransferDocument = gql`
    mutation ExecuteBulkTransfer($input: ExecuteBulkTransferInput!) {
  executeBulkTransfer(input: $input) {
    warnings
    results {
      sourceBookingId
      sourceBookingNumber
      transferOperationId
      oldBookingDeleted
      mailSent
      warnings
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
      }
      invoiceB {
        id
        invoiceNumber
        invoiceNumberPrefix
      }
      booking {
        id
        bookingType
        bookingNumber
        bookingNumberPrefix
        grossPrice
        courseId
      }
      plan {
        priceB
        appliedToB
        surplus
        creditAfter
        oldBooking {
          treatment
          reason
        }
      }
    }
  }
}
    `;
export type ExecuteBulkTransferMutationFn = ApolloReactCommon.MutationFunction<ExecuteBulkTransferMutation, ExecuteBulkTransferMutationVariables>;

/**
 * __useExecuteBulkTransferMutation__
 *
 * To run a mutation, you first call `useExecuteBulkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteBulkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeBulkTransferMutation, { data, loading, error }] = useExecuteBulkTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteBulkTransferMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExecuteBulkTransferMutation, ExecuteBulkTransferMutationVariables>) {
        return ApolloReactHooks.useMutation<ExecuteBulkTransferMutation, ExecuteBulkTransferMutationVariables>(ExecuteBulkTransferDocument, baseOptions);
      }
export type ExecuteBulkTransferMutationHookResult = ReturnType<typeof useExecuteBulkTransferMutation>;
export type ExecuteBulkTransferMutationResult = ApolloReactCommon.MutationResult<ExecuteBulkTransferMutation>;
export type ExecuteBulkTransferMutationOptions = ApolloReactCommon.BaseMutationOptions<ExecuteBulkTransferMutation, ExecuteBulkTransferMutationVariables>;
export const CreateLessonBookingDocument = gql`
    mutation CreateLessonBooking($newBookingData: NewBookingInputBookableLessons!, $sendMail: Boolean!, $onlineBooking: Boolean) {
  createLessonBooking(newBookingData: $newBookingData, sendMail: $sendMail, onlineBooking: $onlineBooking) {
    id
    createdByUserId
    updatedByUserId
    bookingNumber
    bookingNumberPrefix
    bookingType
    startDateTime
    attendeeId
    attendee {
      id
      firstname
      lastname
      member
      defaultPaymentMethod {
        id
      }
    }
    paymentMethodId
    paymentType
    coursePriceId
    isSpecial
    vat
    netPrice
    grossPrice
    courseId
    monthlySchedule
    memberDiscount
    coursePrice {
      id
      createDate
      updateDate
      createdByUserId
      updatedByUserId
      isSpecial
      vat
      netPrice
      grossPrice
      discount
      discountUnit
      courseId
      includedEntranceFee
    }
    scheduledPayments {
      id
      paymentAmount
      paymentDue
      type
      title
      openAmount
      paymentProvider
      mollieMethod
    }
    noticeBooker
    additionalInfo
    noticeStaff
    attendanceListNote
    payDate
    canceled
    creditedBalance
    discount
    discountName
    agbConfirmed
    privacyStatementConfirmed
    createDate
    updateDate
    bookedBy
  }
}
    `;
export type CreateLessonBookingMutationFn = ApolloReactCommon.MutationFunction<CreateLessonBookingMutation, CreateLessonBookingMutationVariables>;

/**
 * __useCreateLessonBookingMutation__
 *
 * To run a mutation, you first call `useCreateLessonBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLessonBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLessonBookingMutation, { data, loading, error }] = useCreateLessonBookingMutation({
 *   variables: {
 *      newBookingData: // value for 'newBookingData'
 *      sendMail: // value for 'sendMail'
 *      onlineBooking: // value for 'onlineBooking'
 *   },
 * });
 */
export function useCreateLessonBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLessonBookingMutation, CreateLessonBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLessonBookingMutation, CreateLessonBookingMutationVariables>(CreateLessonBookingDocument, baseOptions);
      }
export type CreateLessonBookingMutationHookResult = ReturnType<typeof useCreateLessonBookingMutation>;
export type CreateLessonBookingMutationResult = ApolloReactCommon.MutationResult<CreateLessonBookingMutation>;
export type CreateLessonBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLessonBookingMutation, CreateLessonBookingMutationVariables>;
export const EditLessonBookingDocument = gql`
    mutation EditLessonBooking($editBookingInputBookableLessons: EditBookingInputBookableLessons!) {
  editLessonBooking(editBookingInputBookableLessons: $editBookingInputBookableLessons) {
    id
    createdByUserId
    updatedByUserId
    bookingNumberPrefix
    bookingType
    startDateTime
    attendeeId
    paymentMethodId
    paymentType
    coursePriceId
    isSpecial
    vat
    netPrice
    grossPrice
    courseId
    monthlySchedule
    memberDiscount
    noticeBooker
    additionalInfo
    noticeStaff
    attendanceListNote
    payDate
    canceled
    creditedBalance
    discount
    discountName
    agbConfirmed
    privacyStatementConfirmed
    createDate
    updateDate
    bookedBy
    overpaymentCredit
    attendee {
      id
      firstname
      lastname
      member
      defaultPaymentMethod {
        id
      }
      booker {
        id
        firstname
        lastname
        email
      }
    }
    course {
      id
      allowLessonBooking
    }
    coursePrice {
      id
      createDate
      updateDate
      createdByUserId
      updatedByUserId
      isSpecial
      vat
      netPrice
      grossPrice
      discount
      discountUnit
      courseId
      includedEntranceFee
    }
    scheduledPayments {
      id
      paymentAmount
      paymentDue
      type
      title
      openAmount
      paymentProvider
      mollieMethod
    }
  }
}
    `;
export type EditLessonBookingMutationFn = ApolloReactCommon.MutationFunction<EditLessonBookingMutation, EditLessonBookingMutationVariables>;

/**
 * __useEditLessonBookingMutation__
 *
 * To run a mutation, you first call `useEditLessonBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLessonBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLessonBookingMutation, { data, loading, error }] = useEditLessonBookingMutation({
 *   variables: {
 *      editBookingInputBookableLessons: // value for 'editBookingInputBookableLessons'
 *   },
 * });
 */
export function useEditLessonBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditLessonBookingMutation, EditLessonBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<EditLessonBookingMutation, EditLessonBookingMutationVariables>(EditLessonBookingDocument, baseOptions);
      }
export type EditLessonBookingMutationHookResult = ReturnType<typeof useEditLessonBookingMutation>;
export type EditLessonBookingMutationResult = ApolloReactCommon.MutationResult<EditLessonBookingMutation>;
export type EditLessonBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<EditLessonBookingMutation, EditLessonBookingMutationVariables>;
export const GetCourseInfosForBookingDocument = gql`
    query GetCourseInfosForBooking($courseId: ID!) {
  getCourseInfosForBooking(courseId: $courseId) {
    id
    prefixedCourseNumber
    courseType {
      id
      name
    }
    startDateTime
    endDateTime
    maxAttendees
    lessons {
      id
      startDateTime
      endDateTime
      indexOfLessonInCourse
      courseLessonBookingCount
    }
    coursePrices {
      netPrice
      grossPrice
      vat
    }
    paymentType
    allowMonthlyPayment
    allowUpFrontPayment
    allowLessonBooking
    allowMolliePayment
    mollieOptional
  }
}
    `;

/**
 * __useGetCourseInfosForBookingQuery__
 *
 * To run a query within a React component, call `useGetCourseInfosForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseInfosForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseInfosForBookingQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseInfosForBookingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseInfosForBookingQuery, GetCourseInfosForBookingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseInfosForBookingQuery, GetCourseInfosForBookingQueryVariables>(GetCourseInfosForBookingDocument, baseOptions);
      }
export function useGetCourseInfosForBookingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseInfosForBookingQuery, GetCourseInfosForBookingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseInfosForBookingQuery, GetCourseInfosForBookingQueryVariables>(GetCourseInfosForBookingDocument, baseOptions);
        }
export type GetCourseInfosForBookingQueryHookResult = ReturnType<typeof useGetCourseInfosForBookingQuery>;
export type GetCourseInfosForBookingLazyQueryHookResult = ReturnType<typeof useGetCourseInfosForBookingLazyQuery>;
export type GetCourseInfosForBookingQueryResult = ApolloReactCommon.QueryResult<GetCourseInfosForBookingQuery, GetCourseInfosForBookingQueryVariables>;
export const GetAttendeeInfosForBookingDocument = gql`
    query GetAttendeeInfosForBooking($attendeeId: ID!) {
  getAttendeeInfosForBooking(attendeeId: $attendeeId) {
    id
    firstname
    lastname
    member
    hasBillingAddress
    billingCompanyName
    billingFirstname
    billingLastname
    billingAddition
    billingStreet
    billingPostCode
    billingCity
    defaultPaymentMethod {
      id
    }
    booker {
      id
      firstname
      lastname
      street
      houseNumber
      postCode
      city
      phoneNumber
      mobileNumber
      email
      nonDisclosureNotice
      credit
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
      paymentMethods {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
    }
  }
}
    `;

/**
 * __useGetAttendeeInfosForBookingQuery__
 *
 * To run a query within a React component, call `useGetAttendeeInfosForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeInfosForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeInfosForBookingQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useGetAttendeeInfosForBookingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeInfosForBookingQuery, GetAttendeeInfosForBookingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeInfosForBookingQuery, GetAttendeeInfosForBookingQueryVariables>(GetAttendeeInfosForBookingDocument, baseOptions);
      }
export function useGetAttendeeInfosForBookingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeInfosForBookingQuery, GetAttendeeInfosForBookingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeInfosForBookingQuery, GetAttendeeInfosForBookingQueryVariables>(GetAttendeeInfosForBookingDocument, baseOptions);
        }
export type GetAttendeeInfosForBookingQueryHookResult = ReturnType<typeof useGetAttendeeInfosForBookingQuery>;
export type GetAttendeeInfosForBookingLazyQueryHookResult = ReturnType<typeof useGetAttendeeInfosForBookingLazyQuery>;
export type GetAttendeeInfosForBookingQueryResult = ApolloReactCommon.QueryResult<GetAttendeeInfosForBookingQuery, GetAttendeeInfosForBookingQueryVariables>;
export const GetBookingByIdWithCourseLessonBookingsDocument = gql`
    query GetBookingByIdWithCourseLessonBookings($id: ID!) {
  bookingByIdWithCourseLessonBookings(id: $id) {
    isSettled
    transferIn {
      sourceBookingNumber
      appliedAmount
    }
    molliePaymentAttempts {
      id
      molliePaymentId
      scheduledPaymentId
      molliePaymentLinkId
      bundleScheduledPaymentIds
      mollieMethod
      status
      checkoutUrl
      paymentUrl
      isCurrentAttempt
      amount
      linkExpiresAt
      paidAt
      createDate
      errorMessage
      chargebackId
      chargebackReason
      chargebackFee
      chargebackedAt
      refunds {
        id
        mollieRefundId
        scheduledPaymentId
        amount
        reason
        status
        canceledAtProvider
        mollieCreatedAt
        adminUserId
        createDate
      }
      chargebacks {
        mollieChargebackId
        reason
        fee
        chargebackedAt
      }
    }
    id
    bookingNumber
    bookingNumberPrefix
    bookingType
    updateDate
    createDate
    noticeStaff
    noticeBooker
    coursePriceId
    payDate
    grossPrice
    netPrice
    vat
    pricingReason
    pricingCalculatedAt
    pricingSnapshot
    memberDiscount
    isSpecial
    startDateTime
    courseId
    invoice {
      id
      billed
      invoiceNumber
      invoiceNumberPrefix
      createDate
      correctionDate
    }
    coursePrice {
      id
      grossPrice
      netPrice
      vat
    }
    invoice {
      billed
      invoiceNumber
      invoiceNumberPrefix
      createDate
      correctionDate
      createDate
      id
    }
    reversalInvoice {
      id
      invoiceNumber
      invoiceNumberPrefix
      createDate
    }
    courseLessons {
      startDateTime
      endDateTime
      id
      locationId
      indexOfLessonInCourse
      courseLessonBookingCount
      course {
        id
        freePlaces
        bookingCount
        startDateTime
        endDateTime
        paymentInterval
        minAttendees
        maxAttendees
        prefixedCourseNumber
        allowMonthlyPayment
        allowUpFrontPayment
        monthlySchedule
        paymentType
        allowLessonBooking
        allowMolliePayment
        mollieOptional
        additionalShortInfo
        endDateTimeFirstCourseLesson
        waitListCount
        placeReservationsCount
        courseType {
          id
          name
          color
        }
        installmentRates {
          id
          installmentAmount
          installmentDue
        }
        location {
          id
          city
          name
        }
        coursePrice {
          id
          grossPrice
          netPrice
          vat
        }
        instructors {
          id
          firstname
          lastname
        }
      }
    }
    courseLessonBookings {
      id
      courseLessonId
      bookingType
      bookingDate
    }
    attendee {
      id
      erasedAt
      gender
      firstname
      lastname
      birthday
      customerNumberPrefix
      customerNumber
      member
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
      booker {
        id
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        street
        houseNumber
        postCode
        city
        phoneNumber
        mobileNumber
        email
        gender
        hasBillingAddress
        billingCompanyName
        billingFirstname
        billingLastname
        billingAddition
        billingStreet
        billingPostCode
        billingCity
        paymentMethods {
          id
          type
          cash
          esr
          iban
          bank
          bic
          sepaAccountholder
          bankTransfer
          onlinePayment
        }
        nonDisclosureNotice
        credit
        newsletter
      }
      defaultPaymentMethod {
        id
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
      }
    }
    paymentType
    paymentMethod {
      id
      cash
      esr
      creditcardNumber
      creditCardAccountholder
      expirationDate
      sepaAccountholder
      iban
      bic
      bank
      paypalAccountholder
      email
      bankTransfer
      onlinePayment
    }
    paymentMethodId
    bookedBy
    canceled
    scheduledPayments {
      id
      paymentAmount
      refundedAmount
      paymentDue
      paymentDone
      type
      title
      postKind
      carriedOverAt
      openAmount
      paymentProvider
      mollieMethod
      manuallyAdjustedAt
      manuallyAdjustedByUserId
      manuallyAdjustedBy {
        id
        email
      }
      deletedAt
    }
    monthlySchedule
    paymentType
    creditedBalance
    discount
    discountName
    hasDiscountCode
    waitListCount
    additionalInfo
    foundUs
  }
}
    `;

/**
 * __useGetBookingByIdWithCourseLessonBookingsQuery__
 *
 * To run a query within a React component, call `useGetBookingByIdWithCourseLessonBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingByIdWithCourseLessonBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingByIdWithCourseLessonBookingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingByIdWithCourseLessonBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingByIdWithCourseLessonBookingsQuery, GetBookingByIdWithCourseLessonBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingByIdWithCourseLessonBookingsQuery, GetBookingByIdWithCourseLessonBookingsQueryVariables>(GetBookingByIdWithCourseLessonBookingsDocument, baseOptions);
      }
export function useGetBookingByIdWithCourseLessonBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingByIdWithCourseLessonBookingsQuery, GetBookingByIdWithCourseLessonBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingByIdWithCourseLessonBookingsQuery, GetBookingByIdWithCourseLessonBookingsQueryVariables>(GetBookingByIdWithCourseLessonBookingsDocument, baseOptions);
        }
export type GetBookingByIdWithCourseLessonBookingsQueryHookResult = ReturnType<typeof useGetBookingByIdWithCourseLessonBookingsQuery>;
export type GetBookingByIdWithCourseLessonBookingsLazyQueryHookResult = ReturnType<typeof useGetBookingByIdWithCourseLessonBookingsLazyQuery>;
export type GetBookingByIdWithCourseLessonBookingsQueryResult = ApolloReactCommon.QueryResult<GetBookingByIdWithCourseLessonBookingsQuery, GetBookingByIdWithCourseLessonBookingsQueryVariables>;
export const GetBookingsByCourseIdWithCourseLessonBookingsDocument = gql`
    query GetBookingsByCourseIdWithCourseLessonBookings($courseId: ID!) {
  bookingsByCourseIdWithCourseLessonBookings(courseId: $courseId) {
    id
    bookingNumber
    bookingNumberPrefix
    bookingType
    updateDate
    createDate
    noticeStaff
    noticeBooker
    coursePriceId
    payDate
    grossPrice
    netPrice
    vat
    memberDiscount
    creditedBalance
    discount
    discountName
    isSpecial
    startDateTime
    courseId
    invoice {
      id
      billed
      invoiceNumber
      invoiceNumberPrefix
      createDate
      correctionDate
    }
    coursePrice {
      id
      grossPrice
      netPrice
      vat
    }
    invoice {
      billed
      invoiceNumber
      invoiceNumberPrefix
      createDate
      correctionDate
      createDate
      id
    }
    reversalInvoice {
      id
      invoiceNumber
      invoiceNumberPrefix
      createDate
    }
    courseLessons {
      startDateTime
      endDateTime
      id
      locationId
      indexOfLessonInCourse
      courseLessonBookingCount
      course {
        id
        freePlaces
        bookingCount
        startDateTime
        endDateTime
        paymentInterval
        minAttendees
        maxAttendees
        prefixedCourseNumber
        allowMonthlyPayment
        allowUpFrontPayment
        monthlySchedule
        paymentType
        allowLessonBooking
        additionalShortInfo
        endDateTimeFirstCourseLesson
        waitListCount
        placeReservationsCount
        courseType {
          id
          name
          color
        }
        installmentRates {
          id
          installmentAmount
          installmentDue
        }
        location {
          id
          city
          name
        }
        coursePrice {
          id
          grossPrice
          netPrice
          vat
        }
        instructors {
          id
          firstname
          lastname
        }
      }
    }
    courseLessonBookings {
      id
      courseLessonId
      bookingType
    }
    attendee {
      id
      erasedAt
      gender
      firstname
      lastname
      birthday
      customerNumberPrefix
      customerNumber
      member
      booker {
        id
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        street
        houseNumber
        postCode
        city
        phoneNumber
        mobileNumber
        email
        gender
        paymentMethods {
          id
          type
          cash
          esr
          iban
          bank
          bic
          sepaAccountholder
          bankTransfer
          onlinePayment
        }
        nonDisclosureNotice
        credit
        newsletter
      }
      defaultPaymentMethod {
        id
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
      }
    }
    paymentType
    paymentMethod {
      id
      cash
      esr
      creditcardNumber
      creditCardAccountholder
      expirationDate
      sepaAccountholder
      iban
      bic
      bank
      paypalAccountholder
      email
      bankTransfer
      onlinePayment
    }
    paymentMethodId
    bookedBy
    canceled
    scheduledPayments {
      id
      paymentAmount
      refundedAmount
      paymentDue
      paymentDone
      type
      title
      openAmount
      paymentProvider
      mollieMethod
      manuallyAdjustedAt
      manuallyAdjustedByUserId
      manuallyAdjustedBy {
        id
        email
      }
      deletedAt
    }
    monthlySchedule
    paymentType
    creditedBalance
    waitListCount
    additionalInfo
  }
}
    `;

/**
 * __useGetBookingsByCourseIdWithCourseLessonBookingsQuery__
 *
 * To run a query within a React component, call `useGetBookingsByCourseIdWithCourseLessonBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByCourseIdWithCourseLessonBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByCourseIdWithCourseLessonBookingsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetBookingsByCourseIdWithCourseLessonBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByCourseIdWithCourseLessonBookingsQuery, GetBookingsByCourseIdWithCourseLessonBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByCourseIdWithCourseLessonBookingsQuery, GetBookingsByCourseIdWithCourseLessonBookingsQueryVariables>(GetBookingsByCourseIdWithCourseLessonBookingsDocument, baseOptions);
      }
export function useGetBookingsByCourseIdWithCourseLessonBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByCourseIdWithCourseLessonBookingsQuery, GetBookingsByCourseIdWithCourseLessonBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByCourseIdWithCourseLessonBookingsQuery, GetBookingsByCourseIdWithCourseLessonBookingsQueryVariables>(GetBookingsByCourseIdWithCourseLessonBookingsDocument, baseOptions);
        }
export type GetBookingsByCourseIdWithCourseLessonBookingsQueryHookResult = ReturnType<typeof useGetBookingsByCourseIdWithCourseLessonBookingsQuery>;
export type GetBookingsByCourseIdWithCourseLessonBookingsLazyQueryHookResult = ReturnType<typeof useGetBookingsByCourseIdWithCourseLessonBookingsLazyQuery>;
export type GetBookingsByCourseIdWithCourseLessonBookingsQueryResult = ApolloReactCommon.QueryResult<GetBookingsByCourseIdWithCourseLessonBookingsQuery, GetBookingsByCourseIdWithCourseLessonBookingsQueryVariables>;
export const GetBookingsByCourseIdWithCourseLessonBookingsOptimizedDocument = gql`
    query GetBookingsByCourseIdWithCourseLessonBookingsOptimized($courseId: ID!) {
  bookingsByCourseIdWithCourseLessonBookings(courseId: $courseId) {
    id
    isSettled
    bookingNumber
    bookingNumberPrefix
    bookingType
    updateDate
    createDate
    noticeStaff
    noticeBooker
    coursePriceId
    payDate
    grossPrice
    netPrice
    vat
    memberDiscount
    creditedBalance
    discount
    discountName
    isSpecial
    startDateTime
    courseId
    canceled
    invoice {
      id
    }
    courseLessonBookings {
      id
      courseLessonId
      bookingType
    }
    attendee {
      id
      erasedAt
      gender
      firstname
      lastname
      birthday
      customerNumberPrefix
      customerNumber
      member
      booker {
        id
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        street
        houseNumber
        postCode
        city
        phoneNumber
        mobileNumber
        email
        gender
        nonDisclosureNotice
        credit
        newsletter
      }
      defaultPaymentMethod {
        id
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
      }
    }
    paymentType
    paymentMethod {
      id
      cash
      esr
      creditcardNumber
      creditCardAccountholder
      expirationDate
      sepaAccountholder
      iban
      bic
      bank
      paypalAccountholder
      email
      bankTransfer
      onlinePayment
    }
    paymentMethodId
    bookedBy
    canceled
    scheduledPayments {
      id
      paymentAmount
      refundedAmount
      paymentDue
      paymentDone
      type
      title
      openAmount
      paymentProvider
      mollieMethod
      manuallyAdjustedAt
      manuallyAdjustedByUserId
      manuallyAdjustedBy {
        id
        email
      }
      deletedAt
    }
    monthlySchedule
    paymentType
    creditedBalance
    additionalInfo
  }
}
    `;

/**
 * __useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery__
 *
 * To run a query within a React component, call `useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery, GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery, GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryVariables>(GetBookingsByCourseIdWithCourseLessonBookingsOptimizedDocument, baseOptions);
      }
export function useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery, GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery, GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryVariables>(GetBookingsByCourseIdWithCourseLessonBookingsOptimizedDocument, baseOptions);
        }
export type GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryHookResult = ReturnType<typeof useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery>;
export type GetBookingsByCourseIdWithCourseLessonBookingsOptimizedLazyQueryHookResult = ReturnType<typeof useGetBookingsByCourseIdWithCourseLessonBookingsOptimizedLazyQuery>;
export type GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryResult = ApolloReactCommon.QueryResult<GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQuery, GetBookingsByCourseIdWithCourseLessonBookingsOptimizedQueryVariables>;
export const GetAllBookingsByAttendeeIdAndCourseIdDocument = gql`
    query GetAllBookingsByAttendeeIdAndCourseId($attendeeId: ID!, $courseId: ID!) {
  getAllBookingsByAttendeeIdAndCourseId(attendeeId: $attendeeId, courseId: $courseId) {
    id
    bookingId
    courseLessonId
    bookingType
    booking {
      bookingNumberPrefix
      bookingNumber
    }
  }
}
    `;

/**
 * __useGetAllBookingsByAttendeeIdAndCourseIdQuery__
 *
 * To run a query within a React component, call `useGetAllBookingsByAttendeeIdAndCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBookingsByAttendeeIdAndCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBookingsByAttendeeIdAndCourseIdQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllBookingsByAttendeeIdAndCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllBookingsByAttendeeIdAndCourseIdQuery, GetAllBookingsByAttendeeIdAndCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllBookingsByAttendeeIdAndCourseIdQuery, GetAllBookingsByAttendeeIdAndCourseIdQueryVariables>(GetAllBookingsByAttendeeIdAndCourseIdDocument, baseOptions);
      }
export function useGetAllBookingsByAttendeeIdAndCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllBookingsByAttendeeIdAndCourseIdQuery, GetAllBookingsByAttendeeIdAndCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllBookingsByAttendeeIdAndCourseIdQuery, GetAllBookingsByAttendeeIdAndCourseIdQueryVariables>(GetAllBookingsByAttendeeIdAndCourseIdDocument, baseOptions);
        }
export type GetAllBookingsByAttendeeIdAndCourseIdQueryHookResult = ReturnType<typeof useGetAllBookingsByAttendeeIdAndCourseIdQuery>;
export type GetAllBookingsByAttendeeIdAndCourseIdLazyQueryHookResult = ReturnType<typeof useGetAllBookingsByAttendeeIdAndCourseIdLazyQuery>;
export type GetAllBookingsByAttendeeIdAndCourseIdQueryResult = ApolloReactCommon.QueryResult<GetAllBookingsByAttendeeIdAndCourseIdQuery, GetAllBookingsByAttendeeIdAndCourseIdQueryVariables>;
export const ResetPaymentPlanOfInvoicedLessonBookingDocument = gql`
    mutation ResetPaymentPlanOfInvoicedLessonBooking($bookingId: ID!, $previewOnly: Boolean) {
  resetPaymentPlanOfInvoicedLessonBooking(bookingId: $bookingId, previewOnly: $previewOnly) {
    bookingId
    previewOnly
    blockedReason
    blockedMessage
    oldTotalGrossPrice
    newTotalGrossPrice
    oldDiscount
    oldCreditedBalance
    oldScheduledPayments {
      id
      paymentAmount
      paymentDue
      paymentDone
      paid
      manuallyAdjustedAt
      deletedAt
      refundedAmount
    }
    newScheduledPayments {
      id
      paymentAmount
      paymentDue
      paymentDone
      paid
      manuallyAdjustedAt
      deletedAt
      refundedAmount
    }
  }
}
    `;
export type ResetPaymentPlanOfInvoicedLessonBookingMutationFn = ApolloReactCommon.MutationFunction<ResetPaymentPlanOfInvoicedLessonBookingMutation, ResetPaymentPlanOfInvoicedLessonBookingMutationVariables>;

/**
 * __useResetPaymentPlanOfInvoicedLessonBookingMutation__
 *
 * To run a mutation, you first call `useResetPaymentPlanOfInvoicedLessonBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPaymentPlanOfInvoicedLessonBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPaymentPlanOfInvoicedLessonBookingMutation, { data, loading, error }] = useResetPaymentPlanOfInvoicedLessonBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      previewOnly: // value for 'previewOnly'
 *   },
 * });
 */
export function useResetPaymentPlanOfInvoicedLessonBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPaymentPlanOfInvoicedLessonBookingMutation, ResetPaymentPlanOfInvoicedLessonBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetPaymentPlanOfInvoicedLessonBookingMutation, ResetPaymentPlanOfInvoicedLessonBookingMutationVariables>(ResetPaymentPlanOfInvoicedLessonBookingDocument, baseOptions);
      }
export type ResetPaymentPlanOfInvoicedLessonBookingMutationHookResult = ReturnType<typeof useResetPaymentPlanOfInvoicedLessonBookingMutation>;
export type ResetPaymentPlanOfInvoicedLessonBookingMutationResult = ApolloReactCommon.MutationResult<ResetPaymentPlanOfInvoicedLessonBookingMutation>;
export type ResetPaymentPlanOfInvoicedLessonBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPaymentPlanOfInvoicedLessonBookingMutation, ResetPaymentPlanOfInvoicedLessonBookingMutationVariables>;
export const LessonBookingPlannerPreviewDocument = gql`
    query LessonBookingPlannerPreview($updateCourseAndBookingsInput: UpdateCourseAndBookingsInput!, $bookingId: ID!, $intents: [LessonBookingIntentInput!]) {
  lessonBookingPlannerPreview(updateCourseAndBookingsInput: $updateCourseAndBookingsInput, bookingId: $bookingId, intents: $intents) {
    unitPrice
    bookedUnitsBefore
    bookedUnitsAfter
    priceBefore
    priceAfter
    legacyGap
    nonCoursePostsSum
    credit
    canceled
    regenerated
    warnings
    pricingMode
    rateMonthOffset
    ambiguousOffset
    units {
      lessonId
      lessonDate
      status
      movedTo
    }
    components {
      amount
      reason
      lessonDate
    }
    rates {
      id
      paymentDue
      amountBefore
      amountAfter
      status
      boundReason
      adjustments {
        amount
        reason
      }
    }
  }
}
    `;

/**
 * __useLessonBookingPlannerPreviewQuery__
 *
 * To run a query within a React component, call `useLessonBookingPlannerPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonBookingPlannerPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonBookingPlannerPreviewQuery({
 *   variables: {
 *      updateCourseAndBookingsInput: // value for 'updateCourseAndBookingsInput'
 *      bookingId: // value for 'bookingId'
 *      intents: // value for 'intents'
 *   },
 * });
 */
export function useLessonBookingPlannerPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LessonBookingPlannerPreviewQuery, LessonBookingPlannerPreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<LessonBookingPlannerPreviewQuery, LessonBookingPlannerPreviewQueryVariables>(LessonBookingPlannerPreviewDocument, baseOptions);
      }
export function useLessonBookingPlannerPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LessonBookingPlannerPreviewQuery, LessonBookingPlannerPreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LessonBookingPlannerPreviewQuery, LessonBookingPlannerPreviewQueryVariables>(LessonBookingPlannerPreviewDocument, baseOptions);
        }
export type LessonBookingPlannerPreviewQueryHookResult = ReturnType<typeof useLessonBookingPlannerPreviewQuery>;
export type LessonBookingPlannerPreviewLazyQueryHookResult = ReturnType<typeof useLessonBookingPlannerPreviewLazyQuery>;
export type LessonBookingPlannerPreviewQueryResult = ApolloReactCommon.QueryResult<LessonBookingPlannerPreviewQuery, LessonBookingPlannerPreviewQueryVariables>;
export const LessonBookingPlanSummaryDocument = gql`
    query LessonBookingPlanSummary($updateCourseAndBookingsInput: UpdateCourseAndBookingsInput!, $intents: [LessonBookingIntentInput!]) {
  lessonBookingPlanSummary(updateCourseAndBookingsInput: $updateCourseAndBookingsInput, intents: $intents) {
    bookingId
    bookingLabel
    applies
    fingerprint
    priceBefore
    priceAfter
    credit
    unitsAdded
    unitsRemoved
    ratesChanged
    regenerated
    warnings
    blocker
    correctionInvoice
    correctionInvoiceMail
    staffNoteChanged
  }
}
    `;

/**
 * __useLessonBookingPlanSummaryQuery__
 *
 * To run a query within a React component, call `useLessonBookingPlanSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonBookingPlanSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonBookingPlanSummaryQuery({
 *   variables: {
 *      updateCourseAndBookingsInput: // value for 'updateCourseAndBookingsInput'
 *      intents: // value for 'intents'
 *   },
 * });
 */
export function useLessonBookingPlanSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LessonBookingPlanSummaryQuery, LessonBookingPlanSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<LessonBookingPlanSummaryQuery, LessonBookingPlanSummaryQueryVariables>(LessonBookingPlanSummaryDocument, baseOptions);
      }
export function useLessonBookingPlanSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LessonBookingPlanSummaryQuery, LessonBookingPlanSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LessonBookingPlanSummaryQuery, LessonBookingPlanSummaryQueryVariables>(LessonBookingPlanSummaryDocument, baseOptions);
        }
export type LessonBookingPlanSummaryQueryHookResult = ReturnType<typeof useLessonBookingPlanSummaryQuery>;
export type LessonBookingPlanSummaryLazyQueryHookResult = ReturnType<typeof useLessonBookingPlanSummaryLazyQuery>;
export type LessonBookingPlanSummaryQueryResult = ApolloReactCommon.QueryResult<LessonBookingPlanSummaryQuery, LessonBookingPlanSummaryQueryVariables>;
export const ApplyLessonBookingPlanDocument = gql`
    mutation ApplyLessonBookingPlan($updateCourseAndBookingsInput: UpdateCourseAndBookingsInput!, $fingerprints: [LessonBookingPlanFingerprintInput!]!, $intents: [LessonBookingIntentInput!]) {
  applyLessonBookingPlan(updateCourseAndBookingsInput: $updateCourseAndBookingsInput, fingerprints: $fingerprints, intents: $intents) {
    bookingId
    applies
  }
}
    `;
export type ApplyLessonBookingPlanMutationFn = ApolloReactCommon.MutationFunction<ApplyLessonBookingPlanMutation, ApplyLessonBookingPlanMutationVariables>;

/**
 * __useApplyLessonBookingPlanMutation__
 *
 * To run a mutation, you first call `useApplyLessonBookingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyLessonBookingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyLessonBookingPlanMutation, { data, loading, error }] = useApplyLessonBookingPlanMutation({
 *   variables: {
 *      updateCourseAndBookingsInput: // value for 'updateCourseAndBookingsInput'
 *      fingerprints: // value for 'fingerprints'
 *      intents: // value for 'intents'
 *   },
 * });
 */
export function useApplyLessonBookingPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyLessonBookingPlanMutation, ApplyLessonBookingPlanMutationVariables>) {
        return ApolloReactHooks.useMutation<ApplyLessonBookingPlanMutation, ApplyLessonBookingPlanMutationVariables>(ApplyLessonBookingPlanDocument, baseOptions);
      }
export type ApplyLessonBookingPlanMutationHookResult = ReturnType<typeof useApplyLessonBookingPlanMutation>;
export type ApplyLessonBookingPlanMutationResult = ApolloReactCommon.MutationResult<ApplyLessonBookingPlanMutation>;
export type ApplyLessonBookingPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<ApplyLessonBookingPlanMutation, ApplyLessonBookingPlanMutationVariables>;
export const GetCertificateTemplatesDocument = gql`
    query getCertificateTemplates {
  certificateTemplates {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useGetCertificateTemplatesQuery__
 *
 * To run a query within a React component, call `useGetCertificateTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCertificateTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCertificateTemplatesQuery, GetCertificateTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCertificateTemplatesQuery, GetCertificateTemplatesQueryVariables>(GetCertificateTemplatesDocument, baseOptions);
      }
export function useGetCertificateTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCertificateTemplatesQuery, GetCertificateTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCertificateTemplatesQuery, GetCertificateTemplatesQueryVariables>(GetCertificateTemplatesDocument, baseOptions);
        }
export type GetCertificateTemplatesQueryHookResult = ReturnType<typeof useGetCertificateTemplatesQuery>;
export type GetCertificateTemplatesLazyQueryHookResult = ReturnType<typeof useGetCertificateTemplatesLazyQuery>;
export type GetCertificateTemplatesQueryResult = ApolloReactCommon.QueryResult<GetCertificateTemplatesQuery, GetCertificateTemplatesQueryVariables>;
export const GetCertificateTemplateDocument = gql`
    query getCertificateTemplate($id: String!) {
  certificateTemplate(id: $id) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useGetCertificateTemplateQuery__
 *
 * To run a query within a React component, call `useGetCertificateTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCertificateTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCertificateTemplateQuery, GetCertificateTemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCertificateTemplateQuery, GetCertificateTemplateQueryVariables>(GetCertificateTemplateDocument, baseOptions);
      }
export function useGetCertificateTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCertificateTemplateQuery, GetCertificateTemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCertificateTemplateQuery, GetCertificateTemplateQueryVariables>(GetCertificateTemplateDocument, baseOptions);
        }
export type GetCertificateTemplateQueryHookResult = ReturnType<typeof useGetCertificateTemplateQuery>;
export type GetCertificateTemplateLazyQueryHookResult = ReturnType<typeof useGetCertificateTemplateLazyQuery>;
export type GetCertificateTemplateQueryResult = ApolloReactCommon.QueryResult<GetCertificateTemplateQuery, GetCertificateTemplateQueryVariables>;
export const GetIssuedCertificatesByAttendeeDocument = gql`
    query getIssuedCertificatesByAttendee($attendeeId: String!) {
  issuedCertificatesByAttendee(attendeeId: $attendeeId) {
    ...IssuedCertificateFields
  }
}
    ${IssuedCertificateFieldsFragmentDoc}`;

/**
 * __useGetIssuedCertificatesByAttendeeQuery__
 *
 * To run a query within a React component, call `useGetIssuedCertificatesByAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuedCertificatesByAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuedCertificatesByAttendeeQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useGetIssuedCertificatesByAttendeeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIssuedCertificatesByAttendeeQuery, GetIssuedCertificatesByAttendeeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetIssuedCertificatesByAttendeeQuery, GetIssuedCertificatesByAttendeeQueryVariables>(GetIssuedCertificatesByAttendeeDocument, baseOptions);
      }
export function useGetIssuedCertificatesByAttendeeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIssuedCertificatesByAttendeeQuery, GetIssuedCertificatesByAttendeeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetIssuedCertificatesByAttendeeQuery, GetIssuedCertificatesByAttendeeQueryVariables>(GetIssuedCertificatesByAttendeeDocument, baseOptions);
        }
export type GetIssuedCertificatesByAttendeeQueryHookResult = ReturnType<typeof useGetIssuedCertificatesByAttendeeQuery>;
export type GetIssuedCertificatesByAttendeeLazyQueryHookResult = ReturnType<typeof useGetIssuedCertificatesByAttendeeLazyQuery>;
export type GetIssuedCertificatesByAttendeeQueryResult = ApolloReactCommon.QueryResult<GetIssuedCertificatesByAttendeeQuery, GetIssuedCertificatesByAttendeeQueryVariables>;
export const GetIssuedCertificatesByCourseDocument = gql`
    query getIssuedCertificatesByCourse($courseId: String!) {
  issuedCertificatesByCourse(courseId: $courseId) {
    ...IssuedCertificateFields
  }
}
    ${IssuedCertificateFieldsFragmentDoc}`;

/**
 * __useGetIssuedCertificatesByCourseQuery__
 *
 * To run a query within a React component, call `useGetIssuedCertificatesByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuedCertificatesByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuedCertificatesByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetIssuedCertificatesByCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIssuedCertificatesByCourseQuery, GetIssuedCertificatesByCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetIssuedCertificatesByCourseQuery, GetIssuedCertificatesByCourseQueryVariables>(GetIssuedCertificatesByCourseDocument, baseOptions);
      }
export function useGetIssuedCertificatesByCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIssuedCertificatesByCourseQuery, GetIssuedCertificatesByCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetIssuedCertificatesByCourseQuery, GetIssuedCertificatesByCourseQueryVariables>(GetIssuedCertificatesByCourseDocument, baseOptions);
        }
export type GetIssuedCertificatesByCourseQueryHookResult = ReturnType<typeof useGetIssuedCertificatesByCourseQuery>;
export type GetIssuedCertificatesByCourseLazyQueryHookResult = ReturnType<typeof useGetIssuedCertificatesByCourseLazyQuery>;
export type GetIssuedCertificatesByCourseQueryResult = ApolloReactCommon.QueryResult<GetIssuedCertificatesByCourseQuery, GetIssuedCertificatesByCourseQueryVariables>;
export const GetIssuedCertificatesDocument = gql`
    query getIssuedCertificates($filter: IssuedCertificatesFilterInput) {
  issuedCertificates(filter: $filter) {
    ...IssuedCertificateFields
    attendeeName
    courseName
    templateName
  }
}
    ${IssuedCertificateFieldsFragmentDoc}`;

/**
 * __useGetIssuedCertificatesQuery__
 *
 * To run a query within a React component, call `useGetIssuedCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuedCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuedCertificatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetIssuedCertificatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIssuedCertificatesQuery, GetIssuedCertificatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetIssuedCertificatesQuery, GetIssuedCertificatesQueryVariables>(GetIssuedCertificatesDocument, baseOptions);
      }
export function useGetIssuedCertificatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIssuedCertificatesQuery, GetIssuedCertificatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetIssuedCertificatesQuery, GetIssuedCertificatesQueryVariables>(GetIssuedCertificatesDocument, baseOptions);
        }
export type GetIssuedCertificatesQueryHookResult = ReturnType<typeof useGetIssuedCertificatesQuery>;
export type GetIssuedCertificatesLazyQueryHookResult = ReturnType<typeof useGetIssuedCertificatesLazyQuery>;
export type GetIssuedCertificatesQueryResult = ApolloReactCommon.QueryResult<GetIssuedCertificatesQuery, GetIssuedCertificatesQueryVariables>;
export const PreviewCertificatePdfQueryDocument = gql`
    query previewCertificatePdfQuery($input: CreateCertificateTemplateInput!) {
  previewCertificatePdf(input: $input)
}
    `;

/**
 * __usePreviewCertificatePdfQueryQuery__
 *
 * To run a query within a React component, call `usePreviewCertificatePdfQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCertificatePdfQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCertificatePdfQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewCertificatePdfQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PreviewCertificatePdfQueryQuery, PreviewCertificatePdfQueryQueryVariables>) {
        return ApolloReactHooks.useQuery<PreviewCertificatePdfQueryQuery, PreviewCertificatePdfQueryQueryVariables>(PreviewCertificatePdfQueryDocument, baseOptions);
      }
export function usePreviewCertificatePdfQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviewCertificatePdfQueryQuery, PreviewCertificatePdfQueryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PreviewCertificatePdfQueryQuery, PreviewCertificatePdfQueryQueryVariables>(PreviewCertificatePdfQueryDocument, baseOptions);
        }
export type PreviewCertificatePdfQueryQueryHookResult = ReturnType<typeof usePreviewCertificatePdfQueryQuery>;
export type PreviewCertificatePdfQueryLazyQueryHookResult = ReturnType<typeof usePreviewCertificatePdfQueryLazyQuery>;
export type PreviewCertificatePdfQueryQueryResult = ApolloReactCommon.QueryResult<PreviewCertificatePdfQueryQuery, PreviewCertificatePdfQueryQueryVariables>;
export const DownloadCertificateQueryDocument = gql`
    query downloadCertificateQuery($issuedCertificateId: String!) {
  downloadCertificate(issuedCertificateId: $issuedCertificateId)
}
    `;

/**
 * __useDownloadCertificateQueryQuery__
 *
 * To run a query within a React component, call `useDownloadCertificateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCertificateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCertificateQueryQuery({
 *   variables: {
 *      issuedCertificateId: // value for 'issuedCertificateId'
 *   },
 * });
 */
export function useDownloadCertificateQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DownloadCertificateQueryQuery, DownloadCertificateQueryQueryVariables>) {
        return ApolloReactHooks.useQuery<DownloadCertificateQueryQuery, DownloadCertificateQueryQueryVariables>(DownloadCertificateQueryDocument, baseOptions);
      }
export function useDownloadCertificateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadCertificateQueryQuery, DownloadCertificateQueryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DownloadCertificateQueryQuery, DownloadCertificateQueryQueryVariables>(DownloadCertificateQueryDocument, baseOptions);
        }
export type DownloadCertificateQueryQueryHookResult = ReturnType<typeof useDownloadCertificateQueryQuery>;
export type DownloadCertificateQueryLazyQueryHookResult = ReturnType<typeof useDownloadCertificateQueryLazyQuery>;
export type DownloadCertificateQueryQueryResult = ApolloReactCommon.QueryResult<DownloadCertificateQueryQuery, DownloadCertificateQueryQueryVariables>;
export const CreateCertificateTemplateMutationDocument = gql`
    mutation createCertificateTemplateMutation($input: CreateCertificateTemplateInput!) {
  createCertificateTemplate(input: $input) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;
export type CreateCertificateTemplateMutationMutationFn = ApolloReactCommon.MutationFunction<CreateCertificateTemplateMutationMutation, CreateCertificateTemplateMutationMutationVariables>;

/**
 * __useCreateCertificateTemplateMutationMutation__
 *
 * To run a mutation, you first call `useCreateCertificateTemplateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateTemplateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificateTemplateMutationMutation, { data, loading, error }] = useCreateCertificateTemplateMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCertificateTemplateMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCertificateTemplateMutationMutation, CreateCertificateTemplateMutationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCertificateTemplateMutationMutation, CreateCertificateTemplateMutationMutationVariables>(CreateCertificateTemplateMutationDocument, baseOptions);
      }
export type CreateCertificateTemplateMutationMutationHookResult = ReturnType<typeof useCreateCertificateTemplateMutationMutation>;
export type CreateCertificateTemplateMutationMutationResult = ApolloReactCommon.MutationResult<CreateCertificateTemplateMutationMutation>;
export type CreateCertificateTemplateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCertificateTemplateMutationMutation, CreateCertificateTemplateMutationMutationVariables>;
export const UpdateCertificateTemplateMutationDocument = gql`
    mutation updateCertificateTemplateMutation($input: UpdateCertificateTemplateInput!) {
  updateCertificateTemplate(input: $input) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;
export type UpdateCertificateTemplateMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateCertificateTemplateMutationMutation, UpdateCertificateTemplateMutationMutationVariables>;

/**
 * __useUpdateCertificateTemplateMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCertificateTemplateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificateTemplateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificateTemplateMutationMutation, { data, loading, error }] = useUpdateCertificateTemplateMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCertificateTemplateMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCertificateTemplateMutationMutation, UpdateCertificateTemplateMutationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCertificateTemplateMutationMutation, UpdateCertificateTemplateMutationMutationVariables>(UpdateCertificateTemplateMutationDocument, baseOptions);
      }
export type UpdateCertificateTemplateMutationMutationHookResult = ReturnType<typeof useUpdateCertificateTemplateMutationMutation>;
export type UpdateCertificateTemplateMutationMutationResult = ApolloReactCommon.MutationResult<UpdateCertificateTemplateMutationMutation>;
export type UpdateCertificateTemplateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCertificateTemplateMutationMutation, UpdateCertificateTemplateMutationMutationVariables>;
export const DeleteCertificateTemplateMutationDocument = gql`
    mutation deleteCertificateTemplateMutation($id: String!) {
  deleteCertificateTemplate(id: $id)
}
    `;
export type DeleteCertificateTemplateMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteCertificateTemplateMutationMutation, DeleteCertificateTemplateMutationMutationVariables>;

/**
 * __useDeleteCertificateTemplateMutationMutation__
 *
 * To run a mutation, you first call `useDeleteCertificateTemplateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificateTemplateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificateTemplateMutationMutation, { data, loading, error }] = useDeleteCertificateTemplateMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCertificateTemplateMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCertificateTemplateMutationMutation, DeleteCertificateTemplateMutationMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCertificateTemplateMutationMutation, DeleteCertificateTemplateMutationMutationVariables>(DeleteCertificateTemplateMutationDocument, baseOptions);
      }
export type DeleteCertificateTemplateMutationMutationHookResult = ReturnType<typeof useDeleteCertificateTemplateMutationMutation>;
export type DeleteCertificateTemplateMutationMutationResult = ApolloReactCommon.MutationResult<DeleteCertificateTemplateMutationMutation>;
export type DeleteCertificateTemplateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCertificateTemplateMutationMutation, DeleteCertificateTemplateMutationMutationVariables>;
export const CertificateIssuePreflightDocument = gql`
    query certificateIssuePreflight($input: CertificateIssuePreflightInput!) {
  certificateIssuePreflight(input: $input) {
    usedVariableKeys
    attendeesWithMissingValues {
      attendeeId
      attendeeName
      missingKeys
    }
  }
}
    `;

/**
 * __useCertificateIssuePreflightQuery__
 *
 * To run a query within a React component, call `useCertificateIssuePreflightQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateIssuePreflightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateIssuePreflightQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCertificateIssuePreflightQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CertificateIssuePreflightQuery, CertificateIssuePreflightQueryVariables>) {
        return ApolloReactHooks.useQuery<CertificateIssuePreflightQuery, CertificateIssuePreflightQueryVariables>(CertificateIssuePreflightDocument, baseOptions);
      }
export function useCertificateIssuePreflightLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CertificateIssuePreflightQuery, CertificateIssuePreflightQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CertificateIssuePreflightQuery, CertificateIssuePreflightQueryVariables>(CertificateIssuePreflightDocument, baseOptions);
        }
export type CertificateIssuePreflightQueryHookResult = ReturnType<typeof useCertificateIssuePreflightQuery>;
export type CertificateIssuePreflightLazyQueryHookResult = ReturnType<typeof useCertificateIssuePreflightLazyQuery>;
export type CertificateIssuePreflightQueryResult = ApolloReactCommon.QueryResult<CertificateIssuePreflightQuery, CertificateIssuePreflightQueryVariables>;
export const IssueCertificateMutationDocument = gql`
    mutation issueCertificateMutation($input: IssueCertificateInput!) {
  issueCertificate(input: $input) {
    ...IssuedCertificateFields
  }
}
    ${IssuedCertificateFieldsFragmentDoc}`;
export type IssueCertificateMutationMutationFn = ApolloReactCommon.MutationFunction<IssueCertificateMutationMutation, IssueCertificateMutationMutationVariables>;

/**
 * __useIssueCertificateMutationMutation__
 *
 * To run a mutation, you first call `useIssueCertificateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueCertificateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueCertificateMutationMutation, { data, loading, error }] = useIssueCertificateMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueCertificateMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IssueCertificateMutationMutation, IssueCertificateMutationMutationVariables>) {
        return ApolloReactHooks.useMutation<IssueCertificateMutationMutation, IssueCertificateMutationMutationVariables>(IssueCertificateMutationDocument, baseOptions);
      }
export type IssueCertificateMutationMutationHookResult = ReturnType<typeof useIssueCertificateMutationMutation>;
export type IssueCertificateMutationMutationResult = ApolloReactCommon.MutationResult<IssueCertificateMutationMutation>;
export type IssueCertificateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<IssueCertificateMutationMutation, IssueCertificateMutationMutationVariables>;
export const IssueCertificatesByCourseMutationDocument = gql`
    mutation issueCertificatesByCourseMutation($input: IssueCertificatesByCourseInput!) {
  issueCertificatesByCourse(input: $input) {
    ...IssuedCertificateFields
  }
}
    ${IssuedCertificateFieldsFragmentDoc}`;
export type IssueCertificatesByCourseMutationMutationFn = ApolloReactCommon.MutationFunction<IssueCertificatesByCourseMutationMutation, IssueCertificatesByCourseMutationMutationVariables>;

/**
 * __useIssueCertificatesByCourseMutationMutation__
 *
 * To run a mutation, you first call `useIssueCertificatesByCourseMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueCertificatesByCourseMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueCertificatesByCourseMutationMutation, { data, loading, error }] = useIssueCertificatesByCourseMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueCertificatesByCourseMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IssueCertificatesByCourseMutationMutation, IssueCertificatesByCourseMutationMutationVariables>) {
        return ApolloReactHooks.useMutation<IssueCertificatesByCourseMutationMutation, IssueCertificatesByCourseMutationMutationVariables>(IssueCertificatesByCourseMutationDocument, baseOptions);
      }
export type IssueCertificatesByCourseMutationMutationHookResult = ReturnType<typeof useIssueCertificatesByCourseMutationMutation>;
export type IssueCertificatesByCourseMutationMutationResult = ApolloReactCommon.MutationResult<IssueCertificatesByCourseMutationMutation>;
export type IssueCertificatesByCourseMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<IssueCertificatesByCourseMutationMutation, IssueCertificatesByCourseMutationMutationVariables>;
export const IssueCertificatesByAttendeesMutationDocument = gql`
    mutation issueCertificatesByAttendeesMutation($input: IssueCertificatesByAttendeesInput!) {
  issueCertificatesByAttendees(input: $input) {
    ...IssuedCertificateFields
  }
}
    ${IssuedCertificateFieldsFragmentDoc}`;
export type IssueCertificatesByAttendeesMutationMutationFn = ApolloReactCommon.MutationFunction<IssueCertificatesByAttendeesMutationMutation, IssueCertificatesByAttendeesMutationMutationVariables>;

/**
 * __useIssueCertificatesByAttendeesMutationMutation__
 *
 * To run a mutation, you first call `useIssueCertificatesByAttendeesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueCertificatesByAttendeesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueCertificatesByAttendeesMutationMutation, { data, loading, error }] = useIssueCertificatesByAttendeesMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueCertificatesByAttendeesMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IssueCertificatesByAttendeesMutationMutation, IssueCertificatesByAttendeesMutationMutationVariables>) {
        return ApolloReactHooks.useMutation<IssueCertificatesByAttendeesMutationMutation, IssueCertificatesByAttendeesMutationMutationVariables>(IssueCertificatesByAttendeesMutationDocument, baseOptions);
      }
export type IssueCertificatesByAttendeesMutationMutationHookResult = ReturnType<typeof useIssueCertificatesByAttendeesMutationMutation>;
export type IssueCertificatesByAttendeesMutationMutationResult = ApolloReactCommon.MutationResult<IssueCertificatesByAttendeesMutationMutation>;
export type IssueCertificatesByAttendeesMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<IssueCertificatesByAttendeesMutationMutation, IssueCertificatesByAttendeesMutationMutationVariables>;
export const ResendCertificateEmailMutationDocument = gql`
    mutation resendCertificateEmailMutation($issuedCertificateId: String!) {
  resendCertificateEmail(issuedCertificateId: $issuedCertificateId)
}
    `;
export type ResendCertificateEmailMutationMutationFn = ApolloReactCommon.MutationFunction<ResendCertificateEmailMutationMutation, ResendCertificateEmailMutationMutationVariables>;

/**
 * __useResendCertificateEmailMutationMutation__
 *
 * To run a mutation, you first call `useResendCertificateEmailMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCertificateEmailMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCertificateEmailMutationMutation, { data, loading, error }] = useResendCertificateEmailMutationMutation({
 *   variables: {
 *      issuedCertificateId: // value for 'issuedCertificateId'
 *   },
 * });
 */
export function useResendCertificateEmailMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendCertificateEmailMutationMutation, ResendCertificateEmailMutationMutationVariables>) {
        return ApolloReactHooks.useMutation<ResendCertificateEmailMutationMutation, ResendCertificateEmailMutationMutationVariables>(ResendCertificateEmailMutationDocument, baseOptions);
      }
export type ResendCertificateEmailMutationMutationHookResult = ReturnType<typeof useResendCertificateEmailMutationMutation>;
export type ResendCertificateEmailMutationMutationResult = ApolloReactCommon.MutationResult<ResendCertificateEmailMutationMutation>;
export type ResendCertificateEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendCertificateEmailMutationMutation, ResendCertificateEmailMutationMutationVariables>;
export const AuthenticateDocument = gql`
    query Authenticate {
  authenticate {
    id
    email
    firstName
    lastName
    roles
    hasProfile
  }
}
    `;

/**
 * __useAuthenticateQuery__
 *
 * To run a query within a React component, call `useAuthenticateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AuthenticateQuery, AuthenticateQueryVariables>) {
        return ApolloReactHooks.useQuery<AuthenticateQuery, AuthenticateQueryVariables>(AuthenticateDocument, baseOptions);
      }
export function useAuthenticateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthenticateQuery, AuthenticateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AuthenticateQuery, AuthenticateQueryVariables>(AuthenticateDocument, baseOptions);
        }
export type AuthenticateQueryHookResult = ReturnType<typeof useAuthenticateQuery>;
export type AuthenticateLazyQueryHookResult = ReturnType<typeof useAuthenticateLazyQuery>;
export type AuthenticateQueryResult = ApolloReactCommon.QueryResult<AuthenticateQuery, AuthenticateQueryVariables>;
export const GetUserRolesDocument = gql`
    query GetUserRoles {
  getUserRoles
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, baseOptions);
      }
export function useGetUserRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, baseOptions);
        }
export type GetUserRolesQueryHookResult = ReturnType<typeof useGetUserRolesQuery>;
export type GetUserRolesLazyQueryHookResult = ReturnType<typeof useGetUserRolesLazyQuery>;
export type GetUserRolesQueryResult = ApolloReactCommon.QueryResult<GetUserRolesQuery, GetUserRolesQueryVariables>;
export const DebugDefaultCourseDetailsDocument = gql`
    mutation DebugDefaultCourseDetails($courseId: ID!) {
  refactoredCourseDetails(courseId: $courseId)
}
    `;
export type DebugDefaultCourseDetailsMutationFn = ApolloReactCommon.MutationFunction<DebugDefaultCourseDetailsMutation, DebugDefaultCourseDetailsMutationVariables>;

/**
 * __useDebugDefaultCourseDetailsMutation__
 *
 * To run a mutation, you first call `useDebugDefaultCourseDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDebugDefaultCourseDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [debugDefaultCourseDetailsMutation, { data, loading, error }] = useDebugDefaultCourseDetailsMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useDebugDefaultCourseDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DebugDefaultCourseDetailsMutation, DebugDefaultCourseDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<DebugDefaultCourseDetailsMutation, DebugDefaultCourseDetailsMutationVariables>(DebugDefaultCourseDetailsDocument, baseOptions);
      }
export type DebugDefaultCourseDetailsMutationHookResult = ReturnType<typeof useDebugDefaultCourseDetailsMutation>;
export type DebugDefaultCourseDetailsMutationResult = ApolloReactCommon.MutationResult<DebugDefaultCourseDetailsMutation>;
export type DebugDefaultCourseDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<DebugDefaultCourseDetailsMutation, DebugDefaultCourseDetailsMutationVariables>;
export const GetPaymentMethodTypeByIdDocument = gql`
    query GetPaymentMethodTypeById($paymentMethodId: String!) {
  getPaymentMethodTypeById(paymentMethodId: $paymentMethodId)
}
    `;

/**
 * __useGetPaymentMethodTypeByIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodTypeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodTypeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodTypeByIdQuery({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useGetPaymentMethodTypeByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentMethodTypeByIdQuery, GetPaymentMethodTypeByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPaymentMethodTypeByIdQuery, GetPaymentMethodTypeByIdQueryVariables>(GetPaymentMethodTypeByIdDocument, baseOptions);
      }
export function useGetPaymentMethodTypeByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentMethodTypeByIdQuery, GetPaymentMethodTypeByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPaymentMethodTypeByIdQuery, GetPaymentMethodTypeByIdQueryVariables>(GetPaymentMethodTypeByIdDocument, baseOptions);
        }
export type GetPaymentMethodTypeByIdQueryHookResult = ReturnType<typeof useGetPaymentMethodTypeByIdQuery>;
export type GetPaymentMethodTypeByIdLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodTypeByIdLazyQuery>;
export type GetPaymentMethodTypeByIdQueryResult = ApolloReactCommon.QueryResult<GetPaymentMethodTypeByIdQuery, GetPaymentMethodTypeByIdQueryVariables>;
export const GetUserInfoByIdDocument = gql`
    query GetUserInfoById($userId: String!) {
  getInfoUserByUserId(userId: $userId) {
    id
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useGetUserInfoByIdQuery__
 *
 * To run a query within a React component, call `useGetUserInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserInfoByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserInfoByIdQuery, GetUserInfoByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserInfoByIdQuery, GetUserInfoByIdQueryVariables>(GetUserInfoByIdDocument, baseOptions);
      }
export function useGetUserInfoByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserInfoByIdQuery, GetUserInfoByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserInfoByIdQuery, GetUserInfoByIdQueryVariables>(GetUserInfoByIdDocument, baseOptions);
        }
export type GetUserInfoByIdQueryHookResult = ReturnType<typeof useGetUserInfoByIdQuery>;
export type GetUserInfoByIdLazyQueryHookResult = ReturnType<typeof useGetUserInfoByIdLazyQuery>;
export type GetUserInfoByIdQueryResult = ApolloReactCommon.QueryResult<GetUserInfoByIdQuery, GetUserInfoByIdQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, baseOptions);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, baseOptions);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = ApolloReactCommon.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetAdminAndInstructorUsersDocument = gql`
    query GetAdminAndInstructorUsers($koOrganizationId: String!) {
  getAdminAndInstructorUsers(koOrganizationId: $koOrganizationId) {
    id
    email
    firstName
    lastName
    hasProfile
    roles
  }
}
    `;

/**
 * __useGetAdminAndInstructorUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminAndInstructorUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAndInstructorUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAndInstructorUsersQuery({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useGetAdminAndInstructorUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminAndInstructorUsersQuery, GetAdminAndInstructorUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAdminAndInstructorUsersQuery, GetAdminAndInstructorUsersQueryVariables>(GetAdminAndInstructorUsersDocument, baseOptions);
      }
export function useGetAdminAndInstructorUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminAndInstructorUsersQuery, GetAdminAndInstructorUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAdminAndInstructorUsersQuery, GetAdminAndInstructorUsersQueryVariables>(GetAdminAndInstructorUsersDocument, baseOptions);
        }
export type GetAdminAndInstructorUsersQueryHookResult = ReturnType<typeof useGetAdminAndInstructorUsersQuery>;
export type GetAdminAndInstructorUsersLazyQueryHookResult = ReturnType<typeof useGetAdminAndInstructorUsersLazyQuery>;
export type GetAdminAndInstructorUsersQueryResult = ApolloReactCommon.QueryResult<GetAdminAndInstructorUsersQuery, GetAdminAndInstructorUsersQueryVariables>;
export const GetUserDetailsDocument = gql`
    query GetUserDetails($userId: String!) {
  userDetails: getUserDetails(userId: $userId) {
    id
    email
    verified
    insertInstant
    lastLoginInstant
    firstName
    lastName
    username
    mobilePhone
    birthDate
    roles
    recentLogins {
      applicationName
      instant
      ipAddress
    }
    loginAttempts {
      status
      createDate
      usedAt
      errorMessage
    }
    instructorDetails {
      level
      active
      showInWeb
      firstname
      lastname
      email
      joinDate
      leaveDate
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, baseOptions);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, baseOptions);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsQueryResult = ApolloReactCommon.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const ToggleUserRoleDocument = gql`
    mutation ToggleUserRole($toggleUserRoleInput: ToggleUserRoleInput!) {
  toggleUserRole(toggleUserRoleInput: $toggleUserRoleInput)
}
    `;
export type ToggleUserRoleMutationFn = ApolloReactCommon.MutationFunction<ToggleUserRoleMutation, ToggleUserRoleMutationVariables>;

/**
 * __useToggleUserRoleMutation__
 *
 * To run a mutation, you first call `useToggleUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserRoleMutation, { data, loading, error }] = useToggleUserRoleMutation({
 *   variables: {
 *      toggleUserRoleInput: // value for 'toggleUserRoleInput'
 *   },
 * });
 */
export function useToggleUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleUserRoleMutation, ToggleUserRoleMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleUserRoleMutation, ToggleUserRoleMutationVariables>(ToggleUserRoleDocument, baseOptions);
      }
export type ToggleUserRoleMutationHookResult = ReturnType<typeof useToggleUserRoleMutation>;
export type ToggleUserRoleMutationResult = ApolloReactCommon.MutationResult<ToggleUserRoleMutation>;
export type ToggleUserRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleUserRoleMutation, ToggleUserRoleMutationVariables>;
export const CourseHistoryByCourseIdDocument = gql`
    query CourseHistoryByCourseId($courseId: String!) {
  courseHistoryByCourseId(courseId: $courseId) {
    id
    createDate
    updateDate
    createdByUserId
    userId
    userName
    action
    description
    courseId
    oldValues
    newValues
    prefixedCourseNumber
    courseStartDateTime
    user {
      id
      email
      instructorDetails {
        email
        firstname
        lastname
        level
      }
    }
    course {
      id
      courseNumber
      prefixedCourseNumber
      courseNumberFormat
      customCourseNumberPrefix
      paymentInterval
      lessons {
        id
      }
    }
  }
}
    `;

/**
 * __useCourseHistoryByCourseIdQuery__
 *
 * To run a query within a React component, call `useCourseHistoryByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseHistoryByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseHistoryByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseHistoryByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseHistoryByCourseIdQuery, CourseHistoryByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseHistoryByCourseIdQuery, CourseHistoryByCourseIdQueryVariables>(CourseHistoryByCourseIdDocument, baseOptions);
      }
export function useCourseHistoryByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseHistoryByCourseIdQuery, CourseHistoryByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseHistoryByCourseIdQuery, CourseHistoryByCourseIdQueryVariables>(CourseHistoryByCourseIdDocument, baseOptions);
        }
export type CourseHistoryByCourseIdQueryHookResult = ReturnType<typeof useCourseHistoryByCourseIdQuery>;
export type CourseHistoryByCourseIdLazyQueryHookResult = ReturnType<typeof useCourseHistoryByCourseIdLazyQuery>;
export type CourseHistoryByCourseIdQueryResult = ApolloReactCommon.QueryResult<CourseHistoryByCourseIdQuery, CourseHistoryByCourseIdQueryVariables>;
export const CourseLessonBookingsByCourseDocument = gql`
    query CourseLessonBookingsByCourse($courseId: String!) {
  courseLessonBookingsByCourse(courseId: $courseId) {
    id
    attendance
    booking {
      id
      attendee {
        id
        firstname
        lastname
        birthday
        booker {
          id
          firstname
          lastname
        }
      }
    }
    courseLessonId
    bookingId
  }
}
    `;

/**
 * __useCourseLessonBookingsByCourseQuery__
 *
 * To run a query within a React component, call `useCourseLessonBookingsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonBookingsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonBookingsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseLessonBookingsByCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseLessonBookingsByCourseQuery, CourseLessonBookingsByCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseLessonBookingsByCourseQuery, CourseLessonBookingsByCourseQueryVariables>(CourseLessonBookingsByCourseDocument, baseOptions);
      }
export function useCourseLessonBookingsByCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseLessonBookingsByCourseQuery, CourseLessonBookingsByCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseLessonBookingsByCourseQuery, CourseLessonBookingsByCourseQueryVariables>(CourseLessonBookingsByCourseDocument, baseOptions);
        }
export type CourseLessonBookingsByCourseQueryHookResult = ReturnType<typeof useCourseLessonBookingsByCourseQuery>;
export type CourseLessonBookingsByCourseLazyQueryHookResult = ReturnType<typeof useCourseLessonBookingsByCourseLazyQuery>;
export type CourseLessonBookingsByCourseQueryResult = ApolloReactCommon.QueryResult<CourseLessonBookingsByCourseQuery, CourseLessonBookingsByCourseQueryVariables>;
export const CourseLessonBookingsByBookingIdDocument = gql`
    query CourseLessonBookingsByBookingId($bookingId: String!) {
  courseLessonBookingsByBookingId(bookingId: $bookingId) {
    id
    bookingDate
    bookingType
    attendance
    courseLessonId
    bookingId
    courseLesson {
      id
      startDateTime
    }
  }
}
    `;

/**
 * __useCourseLessonBookingsByBookingIdQuery__
 *
 * To run a query within a React component, call `useCourseLessonBookingsByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonBookingsByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonBookingsByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useCourseLessonBookingsByBookingIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseLessonBookingsByBookingIdQuery, CourseLessonBookingsByBookingIdQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseLessonBookingsByBookingIdQuery, CourseLessonBookingsByBookingIdQueryVariables>(CourseLessonBookingsByBookingIdDocument, baseOptions);
      }
export function useCourseLessonBookingsByBookingIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseLessonBookingsByBookingIdQuery, CourseLessonBookingsByBookingIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseLessonBookingsByBookingIdQuery, CourseLessonBookingsByBookingIdQueryVariables>(CourseLessonBookingsByBookingIdDocument, baseOptions);
        }
export type CourseLessonBookingsByBookingIdQueryHookResult = ReturnType<typeof useCourseLessonBookingsByBookingIdQuery>;
export type CourseLessonBookingsByBookingIdLazyQueryHookResult = ReturnType<typeof useCourseLessonBookingsByBookingIdLazyQuery>;
export type CourseLessonBookingsByBookingIdQueryResult = ApolloReactCommon.QueryResult<CourseLessonBookingsByBookingIdQuery, CourseLessonBookingsByBookingIdQueryVariables>;
export const AttendanceListByCourseDocument = gql`
    query AttendanceListByCourse($courseId: String!) {
  attendanceListByCourse(courseId: $courseId) {
    id
    mergedBookingIds
    noticeStaff
    noticeBooker
    attendanceListNote
    courseId
    payDate
    lessonSelectionMode
    attendee {
      id
      firstname
      lastname
      birthday
      customerNumber
      customerNumberPrefix
      badgeXAttendee {
        id
        createDate
        dateOfAchivement
        badge {
          id
          name
          abbreviation
          color
          graphicUrl
          signedGraphicUrl
          badgeRequirements {
            id
            name
            sortOrder
          }
        }
        attendeeBadgeRequirements {
          id
          fulfilled
        }
      }
      customer {
        firstname
        lastname
      }
      booker {
        id
        firstname
        lastname
        phoneNumber
        mobileNumber
        email
        street
        houseNumber
        postCode
        city
        gender
      }
    }
    courseLessons {
      id
      startDateTime
    }
    courseLessonBookings {
      id
      attendance
      note
      courseLessonId
      bookingId
      bookingDate
    }
  }
}
    `;

/**
 * __useAttendanceListByCourseQuery__
 *
 * To run a query within a React component, call `useAttendanceListByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceListByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceListByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useAttendanceListByCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttendanceListByCourseQuery, AttendanceListByCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<AttendanceListByCourseQuery, AttendanceListByCourseQueryVariables>(AttendanceListByCourseDocument, baseOptions);
      }
export function useAttendanceListByCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttendanceListByCourseQuery, AttendanceListByCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AttendanceListByCourseQuery, AttendanceListByCourseQueryVariables>(AttendanceListByCourseDocument, baseOptions);
        }
export type AttendanceListByCourseQueryHookResult = ReturnType<typeof useAttendanceListByCourseQuery>;
export type AttendanceListByCourseLazyQueryHookResult = ReturnType<typeof useAttendanceListByCourseLazyQuery>;
export type AttendanceListByCourseQueryResult = ApolloReactCommon.QueryResult<AttendanceListByCourseQuery, AttendanceListByCourseQueryVariables>;
export const UpdateCourseLessonBookingDocument = gql`
    mutation UpdateCourseLessonBooking($updateCourseLessonBookingInput: UpdateCourseLessonBookingInput!) {
  updateCourseLessonBooking(updateCourseLessonBookingInput: $updateCourseLessonBookingInput) {
    id
    attendance
    note
  }
}
    `;
export type UpdateCourseLessonBookingMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseLessonBookingMutation, UpdateCourseLessonBookingMutationVariables>;

/**
 * __useUpdateCourseLessonBookingMutation__
 *
 * To run a mutation, you first call `useUpdateCourseLessonBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseLessonBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseLessonBookingMutation, { data, loading, error }] = useUpdateCourseLessonBookingMutation({
 *   variables: {
 *      updateCourseLessonBookingInput: // value for 'updateCourseLessonBookingInput'
 *   },
 * });
 */
export function useUpdateCourseLessonBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseLessonBookingMutation, UpdateCourseLessonBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseLessonBookingMutation, UpdateCourseLessonBookingMutationVariables>(UpdateCourseLessonBookingDocument, baseOptions);
      }
export type UpdateCourseLessonBookingMutationHookResult = ReturnType<typeof useUpdateCourseLessonBookingMutation>;
export type UpdateCourseLessonBookingMutationResult = ApolloReactCommon.MutationResult<UpdateCourseLessonBookingMutation>;
export type UpdateCourseLessonBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseLessonBookingMutation, UpdateCourseLessonBookingMutationVariables>;
export const CreateCourseLessonBookingDocument = gql`
    mutation CreateCourseLessonBooking($newCourseLessonBookingInput: NewCourseLessonBookingInput!) {
  createCourseLessonBooking(newCourseLessonBookingInput: $newCourseLessonBookingInput) {
    id
    attendance
    note
    courseLessonId
    bookingId
  }
}
    `;
export type CreateCourseLessonBookingMutationFn = ApolloReactCommon.MutationFunction<CreateCourseLessonBookingMutation, CreateCourseLessonBookingMutationVariables>;

/**
 * __useCreateCourseLessonBookingMutation__
 *
 * To run a mutation, you first call `useCreateCourseLessonBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseLessonBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseLessonBookingMutation, { data, loading, error }] = useCreateCourseLessonBookingMutation({
 *   variables: {
 *      newCourseLessonBookingInput: // value for 'newCourseLessonBookingInput'
 *   },
 * });
 */
export function useCreateCourseLessonBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCourseLessonBookingMutation, CreateCourseLessonBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCourseLessonBookingMutation, CreateCourseLessonBookingMutationVariables>(CreateCourseLessonBookingDocument, baseOptions);
      }
export type CreateCourseLessonBookingMutationHookResult = ReturnType<typeof useCreateCourseLessonBookingMutation>;
export type CreateCourseLessonBookingMutationResult = ApolloReactCommon.MutationResult<CreateCourseLessonBookingMutation>;
export type CreateCourseLessonBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCourseLessonBookingMutation, CreateCourseLessonBookingMutationVariables>;
export const CreateCourseLessonBookingsByCourseIdDocument = gql`
    mutation CreateCourseLessonBookingsByCourseId($courseId: String!) {
  createCourseLessonBookingsByCourseId(courseId: $courseId)
}
    `;
export type CreateCourseLessonBookingsByCourseIdMutationFn = ApolloReactCommon.MutationFunction<CreateCourseLessonBookingsByCourseIdMutation, CreateCourseLessonBookingsByCourseIdMutationVariables>;

/**
 * __useCreateCourseLessonBookingsByCourseIdMutation__
 *
 * To run a mutation, you first call `useCreateCourseLessonBookingsByCourseIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseLessonBookingsByCourseIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseLessonBookingsByCourseIdMutation, { data, loading, error }] = useCreateCourseLessonBookingsByCourseIdMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCreateCourseLessonBookingsByCourseIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCourseLessonBookingsByCourseIdMutation, CreateCourseLessonBookingsByCourseIdMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCourseLessonBookingsByCourseIdMutation, CreateCourseLessonBookingsByCourseIdMutationVariables>(CreateCourseLessonBookingsByCourseIdDocument, baseOptions);
      }
export type CreateCourseLessonBookingsByCourseIdMutationHookResult = ReturnType<typeof useCreateCourseLessonBookingsByCourseIdMutation>;
export type CreateCourseLessonBookingsByCourseIdMutationResult = ApolloReactCommon.MutationResult<CreateCourseLessonBookingsByCourseIdMutation>;
export type CreateCourseLessonBookingsByCourseIdMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCourseLessonBookingsByCourseIdMutation, CreateCourseLessonBookingsByCourseIdMutationVariables>;
export const GetCourseLessonBookingByCourseLessonAndBookingDocument = gql`
    query GetCourseLessonBookingByCourseLessonAndBooking($courseLessonId: String!, $bookingId: String!) {
  courseLessonBookingByCourseLessonAndBooking(courseLessonId: $courseLessonId, bookingId: $bookingId) {
    id
    bookingId
    attendance
    courseLessonId
  }
}
    `;

/**
 * __useGetCourseLessonBookingByCourseLessonAndBookingQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonBookingByCourseLessonAndBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonBookingByCourseLessonAndBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonBookingByCourseLessonAndBookingQuery({
 *   variables: {
 *      courseLessonId: // value for 'courseLessonId'
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetCourseLessonBookingByCourseLessonAndBookingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonBookingByCourseLessonAndBookingQuery, GetCourseLessonBookingByCourseLessonAndBookingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonBookingByCourseLessonAndBookingQuery, GetCourseLessonBookingByCourseLessonAndBookingQueryVariables>(GetCourseLessonBookingByCourseLessonAndBookingDocument, baseOptions);
      }
export function useGetCourseLessonBookingByCourseLessonAndBookingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonBookingByCourseLessonAndBookingQuery, GetCourseLessonBookingByCourseLessonAndBookingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonBookingByCourseLessonAndBookingQuery, GetCourseLessonBookingByCourseLessonAndBookingQueryVariables>(GetCourseLessonBookingByCourseLessonAndBookingDocument, baseOptions);
        }
export type GetCourseLessonBookingByCourseLessonAndBookingQueryHookResult = ReturnType<typeof useGetCourseLessonBookingByCourseLessonAndBookingQuery>;
export type GetCourseLessonBookingByCourseLessonAndBookingLazyQueryHookResult = ReturnType<typeof useGetCourseLessonBookingByCourseLessonAndBookingLazyQuery>;
export type GetCourseLessonBookingByCourseLessonAndBookingQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonBookingByCourseLessonAndBookingQuery, GetCourseLessonBookingByCourseLessonAndBookingQueryVariables>;
export const GetLessonsThatAreNotDeletableDocument = gql`
    query GetLessonsThatAreNotDeletable($courseLessonIds: [ID!]!) {
  getLessonsThatAreNotDeletable(courseLessonIds: $courseLessonIds)
}
    `;

/**
 * __useGetLessonsThatAreNotDeletableQuery__
 *
 * To run a query within a React component, call `useGetLessonsThatAreNotDeletableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonsThatAreNotDeletableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonsThatAreNotDeletableQuery({
 *   variables: {
 *      courseLessonIds: // value for 'courseLessonIds'
 *   },
 * });
 */
export function useGetLessonsThatAreNotDeletableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLessonsThatAreNotDeletableQuery, GetLessonsThatAreNotDeletableQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLessonsThatAreNotDeletableQuery, GetLessonsThatAreNotDeletableQueryVariables>(GetLessonsThatAreNotDeletableDocument, baseOptions);
      }
export function useGetLessonsThatAreNotDeletableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLessonsThatAreNotDeletableQuery, GetLessonsThatAreNotDeletableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLessonsThatAreNotDeletableQuery, GetLessonsThatAreNotDeletableQueryVariables>(GetLessonsThatAreNotDeletableDocument, baseOptions);
        }
export type GetLessonsThatAreNotDeletableQueryHookResult = ReturnType<typeof useGetLessonsThatAreNotDeletableQuery>;
export type GetLessonsThatAreNotDeletableLazyQueryHookResult = ReturnType<typeof useGetLessonsThatAreNotDeletableLazyQuery>;
export type GetLessonsThatAreNotDeletableQueryResult = ApolloReactCommon.QueryResult<GetLessonsThatAreNotDeletableQuery, GetLessonsThatAreNotDeletableQueryVariables>;
export const GetCourseTypeDocument = gql`
    query GetCourseType($id: String!) {
  courseTypeById(id: $id) {
    id
    isActive
    showInWeb
    name
    shortHandId
    category {
      id
    }
    description
    minAge
    maxAge
    paymentInterval
    minAttendees
    maxAttendees
    annotation
    websiteInfo
    inWeekPlanner
    bold
    color
    fee
    vat
    invoiceTemplateSetId
    participationPrerequisites {
      id
      groupLabel
      groupDescription
      optionalInputFields
      minCheckCount
      courseTypeId
    }
    additionalItems {
      id
      updateDate
      courseTypeId
      title
      grossPrice
      mode
      vat
      description
    }
    selfBookerCourse
  }
}
    `;

/**
 * __useGetCourseTypeQuery__
 *
 * To run a query within a React component, call `useGetCourseTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseTypeQuery, GetCourseTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseTypeQuery, GetCourseTypeQueryVariables>(GetCourseTypeDocument, baseOptions);
      }
export function useGetCourseTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseTypeQuery, GetCourseTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseTypeQuery, GetCourseTypeQueryVariables>(GetCourseTypeDocument, baseOptions);
        }
export type GetCourseTypeQueryHookResult = ReturnType<typeof useGetCourseTypeQuery>;
export type GetCourseTypeLazyQueryHookResult = ReturnType<typeof useGetCourseTypeLazyQuery>;
export type GetCourseTypeQueryResult = ApolloReactCommon.QueryResult<GetCourseTypeQuery, GetCourseTypeQueryVariables>;
export const GetDetailedCourseTypesDocument = gql`
    query GetDetailedCourseTypes {
  courseTypes {
    id
    courseCount
    shortHandId
    name
    updateDate
    description
    minAge
    maxAge
    paymentInterval
    fee
    vat
    minAttendees
    maxAttendees
    annotation
    websiteInfo
    color
    isActive
    showInWeb
    participationPrerequisites {
      id
      groupLabel
      groupDescription
      optionalInputFields
      minCheckCount
      courseTypeId
    }
    additionalItems {
      id
      updateDate
      courseTypeId
      title
      grossPrice
      mode
      vat
      description
    }
    selfBookerCourse
  }
}
    `;

/**
 * __useGetDetailedCourseTypesQuery__
 *
 * To run a query within a React component, call `useGetDetailedCourseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedCourseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedCourseTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDetailedCourseTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDetailedCourseTypesQuery, GetDetailedCourseTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDetailedCourseTypesQuery, GetDetailedCourseTypesQueryVariables>(GetDetailedCourseTypesDocument, baseOptions);
      }
export function useGetDetailedCourseTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDetailedCourseTypesQuery, GetDetailedCourseTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDetailedCourseTypesQuery, GetDetailedCourseTypesQueryVariables>(GetDetailedCourseTypesDocument, baseOptions);
        }
export type GetDetailedCourseTypesQueryHookResult = ReturnType<typeof useGetDetailedCourseTypesQuery>;
export type GetDetailedCourseTypesLazyQueryHookResult = ReturnType<typeof useGetDetailedCourseTypesLazyQuery>;
export type GetDetailedCourseTypesQueryResult = ApolloReactCommon.QueryResult<GetDetailedCourseTypesQuery, GetDetailedCourseTypesQueryVariables>;
export const GetCourseTypesDocument = gql`
    query GetCourseTypes {
  courseTypes {
    id
    name
    description
    courseCount
    color
    invoiceTemplateSetId
  }
}
    `;

/**
 * __useGetCourseTypesQuery__
 *
 * To run a query within a React component, call `useGetCourseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseTypesQuery, GetCourseTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseTypesQuery, GetCourseTypesQueryVariables>(GetCourseTypesDocument, baseOptions);
      }
export function useGetCourseTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseTypesQuery, GetCourseTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseTypesQuery, GetCourseTypesQueryVariables>(GetCourseTypesDocument, baseOptions);
        }
export type GetCourseTypesQueryHookResult = ReturnType<typeof useGetCourseTypesQuery>;
export type GetCourseTypesLazyQueryHookResult = ReturnType<typeof useGetCourseTypesLazyQuery>;
export type GetCourseTypesQueryResult = ApolloReactCommon.QueryResult<GetCourseTypesQuery, GetCourseTypesQueryVariables>;
export const GetCourseTypesWithPaginationDocument = gql`
    query GetCourseTypesWithPagination($options: ArrayDataOptions) {
  courseTypesWithPagination(options: $options) {
    existsMore
    total
    items {
      id
      courseCount
      shortHandId
      name
      updateDate
      description
      minAge
      maxAge
      paymentInterval
      fee
      vat
      minAttendees
      maxAttendees
      annotation
      websiteInfo
      color
      isActive
      showInWeb
      invoiceTemplateSetId
      participationPrerequisites {
        id
        groupLabel
        groupDescription
        optionalInputFields
        minCheckCount
        courseTypeId
      }
      selfBookerCourse
    }
  }
}
    `;

/**
 * __useGetCourseTypesWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetCourseTypesWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseTypesWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseTypesWithPaginationQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetCourseTypesWithPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseTypesWithPaginationQuery, GetCourseTypesWithPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseTypesWithPaginationQuery, GetCourseTypesWithPaginationQueryVariables>(GetCourseTypesWithPaginationDocument, baseOptions);
      }
export function useGetCourseTypesWithPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseTypesWithPaginationQuery, GetCourseTypesWithPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseTypesWithPaginationQuery, GetCourseTypesWithPaginationQueryVariables>(GetCourseTypesWithPaginationDocument, baseOptions);
        }
export type GetCourseTypesWithPaginationQueryHookResult = ReturnType<typeof useGetCourseTypesWithPaginationQuery>;
export type GetCourseTypesWithPaginationLazyQueryHookResult = ReturnType<typeof useGetCourseTypesWithPaginationLazyQuery>;
export type GetCourseTypesWithPaginationQueryResult = ApolloReactCommon.QueryResult<GetCourseTypesWithPaginationQuery, GetCourseTypesWithPaginationQueryVariables>;
export const GetDiscountCodesDocument = gql`
    query GetDiscountCodes {
  discountCodes {
    id
    code
    internalName
    discountUnit
    discountValue
    scopeType
    scopeIds
    scopeLabels
    validFrom
    validUntil
    validUntilCourseEnd
    maxRedemptions
    allowWithMemberDiscount
    deactivatedAt
    deactivatedReason
    createDate
    redemptionCount
    referenceCount
    effectiveValidUntil
  }
}
    `;

/**
 * __useGetDiscountCodesQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscountCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>(GetDiscountCodesDocument, baseOptions);
      }
export function useGetDiscountCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>(GetDiscountCodesDocument, baseOptions);
        }
export type GetDiscountCodesQueryHookResult = ReturnType<typeof useGetDiscountCodesQuery>;
export type GetDiscountCodesLazyQueryHookResult = ReturnType<typeof useGetDiscountCodesLazyQuery>;
export type GetDiscountCodesQueryResult = ApolloReactCommon.QueryResult<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>;
export const GetDiscountCodeFilterOptionsDocument = gql`
    query GetDiscountCodeFilterOptions {
  discountCodes {
    id
    code
  }
}
    `;

/**
 * __useGetDiscountCodeFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodeFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodeFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodeFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscountCodeFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountCodeFilterOptionsQuery, GetDiscountCodeFilterOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountCodeFilterOptionsQuery, GetDiscountCodeFilterOptionsQueryVariables>(GetDiscountCodeFilterOptionsDocument, baseOptions);
      }
export function useGetDiscountCodeFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountCodeFilterOptionsQuery, GetDiscountCodeFilterOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountCodeFilterOptionsQuery, GetDiscountCodeFilterOptionsQueryVariables>(GetDiscountCodeFilterOptionsDocument, baseOptions);
        }
export type GetDiscountCodeFilterOptionsQueryHookResult = ReturnType<typeof useGetDiscountCodeFilterOptionsQuery>;
export type GetDiscountCodeFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetDiscountCodeFilterOptionsLazyQuery>;
export type GetDiscountCodeFilterOptionsQueryResult = ApolloReactCommon.QueryResult<GetDiscountCodeFilterOptionsQuery, GetDiscountCodeFilterOptionsQueryVariables>;
export const GetDiscountCodeDocument = gql`
    query GetDiscountCode($id: ID!) {
  discountCode(id: $id) {
    id
    code
    internalName
    discountUnit
    discountValue
    scopeType
    scopeIds
    validFrom
    validUntil
    validUntilCourseEnd
    maxRedemptions
    allowWithMemberDiscount
    deactivatedAt
    deactivatedReason
    createDate
    redemptionCount
    referenceCount
    effectiveValidUntil
    scopeLabels
    bookings {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      createDate
      canceled
      bookedBy
      discount
      grossPrice
      attendee {
        id
        firstname
        lastname
      }
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
      }
    }
  }
}
    `;

/**
 * __useGetDiscountCodeQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDiscountCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>(GetDiscountCodeDocument, baseOptions);
      }
export function useGetDiscountCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>(GetDiscountCodeDocument, baseOptions);
        }
export type GetDiscountCodeQueryHookResult = ReturnType<typeof useGetDiscountCodeQuery>;
export type GetDiscountCodeLazyQueryHookResult = ReturnType<typeof useGetDiscountCodeLazyQuery>;
export type GetDiscountCodeQueryResult = ApolloReactCommon.QueryResult<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>;
export const GetDiscountCodeForFormDocument = gql`
    query GetDiscountCodeForForm($id: ID!) {
  discountCode(id: $id) {
    id
    code
    internalName
    discountUnit
    discountValue
    scopeType
    scopeIds
    validFrom
    validUntil
    validUntilCourseEnd
    maxRedemptions
    allowWithMemberDiscount
    redemptionCount
    referenceCount
    effectiveValidUntil
    scopeLabels
  }
}
    `;

/**
 * __useGetDiscountCodeForFormQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodeForFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodeForFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodeForFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDiscountCodeForFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountCodeForFormQuery, GetDiscountCodeForFormQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountCodeForFormQuery, GetDiscountCodeForFormQueryVariables>(GetDiscountCodeForFormDocument, baseOptions);
      }
export function useGetDiscountCodeForFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountCodeForFormQuery, GetDiscountCodeForFormQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountCodeForFormQuery, GetDiscountCodeForFormQueryVariables>(GetDiscountCodeForFormDocument, baseOptions);
        }
export type GetDiscountCodeForFormQueryHookResult = ReturnType<typeof useGetDiscountCodeForFormQuery>;
export type GetDiscountCodeForFormLazyQueryHookResult = ReturnType<typeof useGetDiscountCodeForFormLazyQuery>;
export type GetDiscountCodeForFormQueryResult = ApolloReactCommon.QueryResult<GetDiscountCodeForFormQuery, GetDiscountCodeForFormQueryVariables>;
export const GetDiscountCodeScopeOptionsDocument = gql`
    query GetDiscountCodeScopeOptions {
  locations {
    id
    name
    city
  }
  courseTypes {
    id
    name
  }
  coursesWithPagination(options: {limit: 2000, sortColumn: "startDateTime", sortOrder: Descending}) {
    items {
      id
      prefixedCourseNumber
      startDateTime
      isArchived
      endDateTime
      courseType {
        id
        name
      }
      location {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDiscountCodeScopeOptionsQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodeScopeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodeScopeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodeScopeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscountCodeScopeOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountCodeScopeOptionsQuery, GetDiscountCodeScopeOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountCodeScopeOptionsQuery, GetDiscountCodeScopeOptionsQueryVariables>(GetDiscountCodeScopeOptionsDocument, baseOptions);
      }
export function useGetDiscountCodeScopeOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountCodeScopeOptionsQuery, GetDiscountCodeScopeOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountCodeScopeOptionsQuery, GetDiscountCodeScopeOptionsQueryVariables>(GetDiscountCodeScopeOptionsDocument, baseOptions);
        }
export type GetDiscountCodeScopeOptionsQueryHookResult = ReturnType<typeof useGetDiscountCodeScopeOptionsQuery>;
export type GetDiscountCodeScopeOptionsLazyQueryHookResult = ReturnType<typeof useGetDiscountCodeScopeOptionsLazyQuery>;
export type GetDiscountCodeScopeOptionsQueryResult = ApolloReactCommon.QueryResult<GetDiscountCodeScopeOptionsQuery, GetDiscountCodeScopeOptionsQueryVariables>;
export const CreateDiscountCodeDocument = gql`
    mutation CreateDiscountCode($input: DiscountCodeInput!) {
  createDiscountCode(input: $input) {
    id
  }
}
    `;
export type CreateDiscountCodeMutationFn = ApolloReactCommon.MutationFunction<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>;

/**
 * __useCreateDiscountCodeMutation__
 *
 * To run a mutation, you first call `useCreateDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountCodeMutation, { data, loading, error }] = useCreateDiscountCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscountCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>(CreateDiscountCodeDocument, baseOptions);
      }
export type CreateDiscountCodeMutationHookResult = ReturnType<typeof useCreateDiscountCodeMutation>;
export type CreateDiscountCodeMutationResult = ApolloReactCommon.MutationResult<CreateDiscountCodeMutation>;
export type CreateDiscountCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>;
export const UpdateDiscountCodeDocument = gql`
    mutation UpdateDiscountCode($id: ID!, $input: DiscountCodeUpdateInput!) {
  updateDiscountCode(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateDiscountCodeMutationFn = ApolloReactCommon.MutationFunction<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>;

/**
 * __useUpdateDiscountCodeMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountCodeMutation, { data, loading, error }] = useUpdateDiscountCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscountCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>(UpdateDiscountCodeDocument, baseOptions);
      }
export type UpdateDiscountCodeMutationHookResult = ReturnType<typeof useUpdateDiscountCodeMutation>;
export type UpdateDiscountCodeMutationResult = ApolloReactCommon.MutationResult<UpdateDiscountCodeMutation>;
export type UpdateDiscountCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>;
export const DeactivateDiscountCodeDocument = gql`
    mutation DeactivateDiscountCode($id: ID!, $reason: String) {
  deactivateDiscountCode(id: $id, reason: $reason) {
    id
    deactivatedAt
    deactivatedReason
  }
}
    `;
export type DeactivateDiscountCodeMutationFn = ApolloReactCommon.MutationFunction<DeactivateDiscountCodeMutation, DeactivateDiscountCodeMutationVariables>;

/**
 * __useDeactivateDiscountCodeMutation__
 *
 * To run a mutation, you first call `useDeactivateDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateDiscountCodeMutation, { data, loading, error }] = useDeactivateDiscountCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeactivateDiscountCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateDiscountCodeMutation, DeactivateDiscountCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<DeactivateDiscountCodeMutation, DeactivateDiscountCodeMutationVariables>(DeactivateDiscountCodeDocument, baseOptions);
      }
export type DeactivateDiscountCodeMutationHookResult = ReturnType<typeof useDeactivateDiscountCodeMutation>;
export type DeactivateDiscountCodeMutationResult = ApolloReactCommon.MutationResult<DeactivateDiscountCodeMutation>;
export type DeactivateDiscountCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateDiscountCodeMutation, DeactivateDiscountCodeMutationVariables>;
export const ReactivateDiscountCodeDocument = gql`
    mutation ReactivateDiscountCode($id: ID!) {
  reactivateDiscountCode(id: $id) {
    id
    deactivatedAt
    deactivatedReason
  }
}
    `;
export type ReactivateDiscountCodeMutationFn = ApolloReactCommon.MutationFunction<ReactivateDiscountCodeMutation, ReactivateDiscountCodeMutationVariables>;

/**
 * __useReactivateDiscountCodeMutation__
 *
 * To run a mutation, you first call `useReactivateDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateDiscountCodeMutation, { data, loading, error }] = useReactivateDiscountCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateDiscountCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactivateDiscountCodeMutation, ReactivateDiscountCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactivateDiscountCodeMutation, ReactivateDiscountCodeMutationVariables>(ReactivateDiscountCodeDocument, baseOptions);
      }
export type ReactivateDiscountCodeMutationHookResult = ReturnType<typeof useReactivateDiscountCodeMutation>;
export type ReactivateDiscountCodeMutationResult = ApolloReactCommon.MutationResult<ReactivateDiscountCodeMutation>;
export type ReactivateDiscountCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactivateDiscountCodeMutation, ReactivateDiscountCodeMutationVariables>;
export const DeleteDiscountCodeDocument = gql`
    mutation DeleteDiscountCode($id: ID!) {
  deleteDiscountCode(id: $id)
}
    `;
export type DeleteDiscountCodeMutationFn = ApolloReactCommon.MutationFunction<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>;

/**
 * __useDeleteDiscountCodeMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountCodeMutation, { data, loading, error }] = useDeleteDiscountCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscountCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>(DeleteDiscountCodeDocument, baseOptions);
      }
export type DeleteDiscountCodeMutationHookResult = ReturnType<typeof useDeleteDiscountCodeMutation>;
export type DeleteDiscountCodeMutationResult = ApolloReactCommon.MutationResult<DeleteDiscountCodeMutation>;
export type DeleteDiscountCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>;
export const GetPrerequisiteCoursesDocument = gql`
    query GetPrerequisiteCourses($options: ArrayDataOptions) {
  prerequisiteCourses(options: $options) {
    existsMore
    total
    items {
      id
      courseNumber
      prefixedCourseNumber
      bookingCountWithoutWaitlist
      billedBookingCount
      freePlaces
      waitListCount
      bookingCount
      placeReservationsCount
      canceledBookingsCount
      settledBookingCount
      courseType {
        id
        name
        description
        color
      }
      startDateTime
      endDateTime
      endDateTimeFirstCourseLesson
      location {
        id
        city
        name
      }
      venue {
        id
        name
      }
      annotation
      instructors {
        id
        firstname
        lastname
      }
      maxAttendees
      coursePrice {
        id
        grossPrice
        netPrice
        vat
        discount
        discountUnit
        isSpecial
      }
      paymentInterval
      allowMonthlyPayment
      monthlySchedule
      isActive
      showInWeb
      paymentType
      installmentRates {
        id
        courseId
        installmentAmount
        installmentDue
        installmentType
      }
      lessonCount
      lessons {
        id
        startDateTime
        endDateTime
      }
      visibility {
        visibleForAll
        restriction {
          prerequisiteCourses {
            id
          }
          membersOnly
          startDateTime
          endDateTime
          inTimeRange
          expireAction
        }
        reason
        hideAfterDays
      }
      enabledCourses {
        id
        prefixedCourseNumber
        courseType {
          id
          color
        }
        enabledRestriction {
          id
          includeBookingList
          includeWaitingList
          membersOnly
        }
      }
      bookingRestriction {
        id
        active
        visibleForAll
        includeBookingList
        includeWaitingList
        membersOnly
        blockedPlaces
        startDateTime
        endDateTime
      }
    }
  }
}
    `;

/**
 * __useGetPrerequisiteCoursesQuery__
 *
 * To run a query within a React component, call `useGetPrerequisiteCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrerequisiteCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrerequisiteCoursesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetPrerequisiteCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPrerequisiteCoursesQuery, GetPrerequisiteCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPrerequisiteCoursesQuery, GetPrerequisiteCoursesQueryVariables>(GetPrerequisiteCoursesDocument, baseOptions);
      }
export function useGetPrerequisiteCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPrerequisiteCoursesQuery, GetPrerequisiteCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPrerequisiteCoursesQuery, GetPrerequisiteCoursesQueryVariables>(GetPrerequisiteCoursesDocument, baseOptions);
        }
export type GetPrerequisiteCoursesQueryHookResult = ReturnType<typeof useGetPrerequisiteCoursesQuery>;
export type GetPrerequisiteCoursesLazyQueryHookResult = ReturnType<typeof useGetPrerequisiteCoursesLazyQuery>;
export type GetPrerequisiteCoursesQueryResult = ApolloReactCommon.QueryResult<GetPrerequisiteCoursesQuery, GetPrerequisiteCoursesQueryVariables>;
export const CourseLateEntryPricingConfigurationDocument = gql`
    query CourseLateEntryPricingConfiguration {
  lateEntryPricingConfigurationPublic {
    lateEntryPricingPolicy
    minimumPartialBookingLessonCount
  }
}
    `;

/**
 * __useCourseLateEntryPricingConfigurationQuery__
 *
 * To run a query within a React component, call `useCourseLateEntryPricingConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLateEntryPricingConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLateEntryPricingConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCourseLateEntryPricingConfigurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseLateEntryPricingConfigurationQuery, CourseLateEntryPricingConfigurationQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseLateEntryPricingConfigurationQuery, CourseLateEntryPricingConfigurationQueryVariables>(CourseLateEntryPricingConfigurationDocument, baseOptions);
      }
export function useCourseLateEntryPricingConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseLateEntryPricingConfigurationQuery, CourseLateEntryPricingConfigurationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseLateEntryPricingConfigurationQuery, CourseLateEntryPricingConfigurationQueryVariables>(CourseLateEntryPricingConfigurationDocument, baseOptions);
        }
export type CourseLateEntryPricingConfigurationQueryHookResult = ReturnType<typeof useCourseLateEntryPricingConfigurationQuery>;
export type CourseLateEntryPricingConfigurationLazyQueryHookResult = ReturnType<typeof useCourseLateEntryPricingConfigurationLazyQuery>;
export type CourseLateEntryPricingConfigurationQueryResult = ApolloReactCommon.QueryResult<CourseLateEntryPricingConfigurationQuery, CourseLateEntryPricingConfigurationQueryVariables>;
export const GetLocalStateDocument = gql`
    query getLocalState {
  LocalState @client {
    createCourse {
      locationId
    }
    bookAttendees {
      selectedAttendee {
        id
        firstname
        bookedCourseIds
      }
      selectedCourseId
    }
  }
}
    `;

/**
 * __useGetLocalStateQuery__
 *
 * To run a query within a React component, call `useGetLocalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocalStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocalStateQuery, GetLocalStateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocalStateQuery, GetLocalStateQueryVariables>(GetLocalStateDocument, baseOptions);
      }
export function useGetLocalStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocalStateQuery, GetLocalStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocalStateQuery, GetLocalStateQueryVariables>(GetLocalStateDocument, baseOptions);
        }
export type GetLocalStateQueryHookResult = ReturnType<typeof useGetLocalStateQuery>;
export type GetLocalStateLazyQueryHookResult = ReturnType<typeof useGetLocalStateLazyQuery>;
export type GetLocalStateQueryResult = ApolloReactCommon.QueryResult<GetLocalStateQuery, GetLocalStateQueryVariables>;
export const GetInstructorsByIdDocument = gql`
    query getInstructorsById($ids: [ID!]!) {
  findInstructorByIds(instructorIds: $ids) {
    id
    firstname
    lastname
    level
  }
}
    `;

/**
 * __useGetInstructorsByIdQuery__
 *
 * To run a query within a React component, call `useGetInstructorsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetInstructorsByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInstructorsByIdQuery, GetInstructorsByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInstructorsByIdQuery, GetInstructorsByIdQueryVariables>(GetInstructorsByIdDocument, baseOptions);
      }
export function useGetInstructorsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstructorsByIdQuery, GetInstructorsByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInstructorsByIdQuery, GetInstructorsByIdQueryVariables>(GetInstructorsByIdDocument, baseOptions);
        }
export type GetInstructorsByIdQueryHookResult = ReturnType<typeof useGetInstructorsByIdQuery>;
export type GetInstructorsByIdLazyQueryHookResult = ReturnType<typeof useGetInstructorsByIdLazyQuery>;
export type GetInstructorsByIdQueryResult = ApolloReactCommon.QueryResult<GetInstructorsByIdQuery, GetInstructorsByIdQueryVariables>;
export const GetReferenceCoursesLinkDocument = gql`
    query getReferenceCoursesLink($courseId: ID!) {
  getReferenceCoursesLink(courseId: $courseId)
}
    `;

/**
 * __useGetReferenceCoursesLinkQuery__
 *
 * To run a query within a React component, call `useGetReferenceCoursesLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceCoursesLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferenceCoursesLinkQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetReferenceCoursesLinkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReferenceCoursesLinkQuery, GetReferenceCoursesLinkQueryVariables>) {
        return ApolloReactHooks.useQuery<GetReferenceCoursesLinkQuery, GetReferenceCoursesLinkQueryVariables>(GetReferenceCoursesLinkDocument, baseOptions);
      }
export function useGetReferenceCoursesLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReferenceCoursesLinkQuery, GetReferenceCoursesLinkQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetReferenceCoursesLinkQuery, GetReferenceCoursesLinkQueryVariables>(GetReferenceCoursesLinkDocument, baseOptions);
        }
export type GetReferenceCoursesLinkQueryHookResult = ReturnType<typeof useGetReferenceCoursesLinkQuery>;
export type GetReferenceCoursesLinkLazyQueryHookResult = ReturnType<typeof useGetReferenceCoursesLinkLazyQuery>;
export type GetReferenceCoursesLinkQueryResult = ApolloReactCommon.QueryResult<GetReferenceCoursesLinkQuery, GetReferenceCoursesLinkQueryVariables>;
export const CourseIsPrerequisiteCourseForDocument = gql`
    query courseIsPrerequisiteCourseFor($courseId: ID!) {
  courseIsPrerequisiteCourseFor(courseId: $courseId) {
    id
    prefixedCourseNumber
    courseType {
      id
      name
      color
    }
    bookingRestriction {
      id
      includeWaitingList
      includeBookingList
    }
    visibility {
      visibleForAll
      restriction {
        membersOnly
        inTimeRange
        expireAction
      }
      reason
    }
    blockBookingOnline
  }
}
    `;

/**
 * __useCourseIsPrerequisiteCourseForQuery__
 *
 * To run a query within a React component, call `useCourseIsPrerequisiteCourseForQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseIsPrerequisiteCourseForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseIsPrerequisiteCourseForQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseIsPrerequisiteCourseForQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseIsPrerequisiteCourseForQuery, CourseIsPrerequisiteCourseForQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseIsPrerequisiteCourseForQuery, CourseIsPrerequisiteCourseForQueryVariables>(CourseIsPrerequisiteCourseForDocument, baseOptions);
      }
export function useCourseIsPrerequisiteCourseForLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseIsPrerequisiteCourseForQuery, CourseIsPrerequisiteCourseForQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseIsPrerequisiteCourseForQuery, CourseIsPrerequisiteCourseForQueryVariables>(CourseIsPrerequisiteCourseForDocument, baseOptions);
        }
export type CourseIsPrerequisiteCourseForQueryHookResult = ReturnType<typeof useCourseIsPrerequisiteCourseForQuery>;
export type CourseIsPrerequisiteCourseForLazyQueryHookResult = ReturnType<typeof useCourseIsPrerequisiteCourseForLazyQuery>;
export type CourseIsPrerequisiteCourseForQueryResult = ApolloReactCommon.QueryResult<CourseIsPrerequisiteCourseForQuery, CourseIsPrerequisiteCourseForQueryVariables>;
export const RemoveCourseDocument = gql`
    mutation removeCourse($id: ID!) {
  removeCourse(id: $id)
}
    `;
export type RemoveCourseMutationFn = ApolloReactCommon.MutationFunction<RemoveCourseMutation, RemoveCourseMutationVariables>;

/**
 * __useRemoveCourseMutation__
 *
 * To run a mutation, you first call `useRemoveCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourseMutation, { data, loading, error }] = useRemoveCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCourseMutation, RemoveCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveCourseMutation, RemoveCourseMutationVariables>(RemoveCourseDocument, baseOptions);
      }
export type RemoveCourseMutationHookResult = ReturnType<typeof useRemoveCourseMutation>;
export type RemoveCourseMutationResult = ApolloReactCommon.MutationResult<RemoveCourseMutation>;
export type RemoveCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveCourseMutation, RemoveCourseMutationVariables>;
export const BookAttendeeGetLocalStateDocument = gql`
    query bookAttendeeGetLocalState {
  LocalState @client {
    bookAttendees {
      selectedAttendee {
        id
        firstname
        bookedCourseIds
      }
      selectedCourseId
    }
  }
}
    `;

/**
 * __useBookAttendeeGetLocalStateQuery__
 *
 * To run a query within a React component, call `useBookAttendeeGetLocalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookAttendeeGetLocalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookAttendeeGetLocalStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookAttendeeGetLocalStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookAttendeeGetLocalStateQuery, BookAttendeeGetLocalStateQueryVariables>) {
        return ApolloReactHooks.useQuery<BookAttendeeGetLocalStateQuery, BookAttendeeGetLocalStateQueryVariables>(BookAttendeeGetLocalStateDocument, baseOptions);
      }
export function useBookAttendeeGetLocalStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookAttendeeGetLocalStateQuery, BookAttendeeGetLocalStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookAttendeeGetLocalStateQuery, BookAttendeeGetLocalStateQueryVariables>(BookAttendeeGetLocalStateDocument, baseOptions);
        }
export type BookAttendeeGetLocalStateQueryHookResult = ReturnType<typeof useBookAttendeeGetLocalStateQuery>;
export type BookAttendeeGetLocalStateLazyQueryHookResult = ReturnType<typeof useBookAttendeeGetLocalStateLazyQuery>;
export type BookAttendeeGetLocalStateQueryResult = ApolloReactCommon.QueryResult<BookAttendeeGetLocalStateQuery, BookAttendeeGetLocalStateQueryVariables>;
export const BookAttendeeGetSelectedAttendeeDocument = gql`
    query bookAttendeeGetSelectedAttendee {
  LocalState @client {
    bookAttendees {
      selectedAttendee {
        id
        firstname
        bookedCourseIds
      }
    }
  }
}
    `;

/**
 * __useBookAttendeeGetSelectedAttendeeQuery__
 *
 * To run a query within a React component, call `useBookAttendeeGetSelectedAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookAttendeeGetSelectedAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookAttendeeGetSelectedAttendeeQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookAttendeeGetSelectedAttendeeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookAttendeeGetSelectedAttendeeQuery, BookAttendeeGetSelectedAttendeeQueryVariables>) {
        return ApolloReactHooks.useQuery<BookAttendeeGetSelectedAttendeeQuery, BookAttendeeGetSelectedAttendeeQueryVariables>(BookAttendeeGetSelectedAttendeeDocument, baseOptions);
      }
export function useBookAttendeeGetSelectedAttendeeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookAttendeeGetSelectedAttendeeQuery, BookAttendeeGetSelectedAttendeeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookAttendeeGetSelectedAttendeeQuery, BookAttendeeGetSelectedAttendeeQueryVariables>(BookAttendeeGetSelectedAttendeeDocument, baseOptions);
        }
export type BookAttendeeGetSelectedAttendeeQueryHookResult = ReturnType<typeof useBookAttendeeGetSelectedAttendeeQuery>;
export type BookAttendeeGetSelectedAttendeeLazyQueryHookResult = ReturnType<typeof useBookAttendeeGetSelectedAttendeeLazyQuery>;
export type BookAttendeeGetSelectedAttendeeQueryResult = ApolloReactCommon.QueryResult<BookAttendeeGetSelectedAttendeeQuery, BookAttendeeGetSelectedAttendeeQueryVariables>;
export const BookAttendeeGetSelectedCourseDocument = gql`
    query bookAttendeeGetSelectedCourse {
  LocalState @client {
    bookAttendees {
      selectedCourseId
    }
  }
}
    `;

/**
 * __useBookAttendeeGetSelectedCourseQuery__
 *
 * To run a query within a React component, call `useBookAttendeeGetSelectedCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookAttendeeGetSelectedCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookAttendeeGetSelectedCourseQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookAttendeeGetSelectedCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookAttendeeGetSelectedCourseQuery, BookAttendeeGetSelectedCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<BookAttendeeGetSelectedCourseQuery, BookAttendeeGetSelectedCourseQueryVariables>(BookAttendeeGetSelectedCourseDocument, baseOptions);
      }
export function useBookAttendeeGetSelectedCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookAttendeeGetSelectedCourseQuery, BookAttendeeGetSelectedCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookAttendeeGetSelectedCourseQuery, BookAttendeeGetSelectedCourseQueryVariables>(BookAttendeeGetSelectedCourseDocument, baseOptions);
        }
export type BookAttendeeGetSelectedCourseQueryHookResult = ReturnType<typeof useBookAttendeeGetSelectedCourseQuery>;
export type BookAttendeeGetSelectedCourseLazyQueryHookResult = ReturnType<typeof useBookAttendeeGetSelectedCourseLazyQuery>;
export type BookAttendeeGetSelectedCourseQueryResult = ApolloReactCommon.QueryResult<BookAttendeeGetSelectedCourseQuery, BookAttendeeGetSelectedCourseQueryVariables>;
export const BookAttendeeSetSelectedAttendeeDocument = gql`
    mutation bookAttendeeSetSelectedAttendee($id: ID, $firstname: String, $bookedCourseIds: [String]) {
  bookAttendeeSetSelectedAttendee(id: $id, firstname: $firstname, bookedCourseIds: $bookedCourseIds) @client
}
    `;
export type BookAttendeeSetSelectedAttendeeMutationFn = ApolloReactCommon.MutationFunction<BookAttendeeSetSelectedAttendeeMutation, BookAttendeeSetSelectedAttendeeMutationVariables>;

/**
 * __useBookAttendeeSetSelectedAttendeeMutation__
 *
 * To run a mutation, you first call `useBookAttendeeSetSelectedAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookAttendeeSetSelectedAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookAttendeeSetSelectedAttendeeMutation, { data, loading, error }] = useBookAttendeeSetSelectedAttendeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstname: // value for 'firstname'
 *      bookedCourseIds: // value for 'bookedCourseIds'
 *   },
 * });
 */
export function useBookAttendeeSetSelectedAttendeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BookAttendeeSetSelectedAttendeeMutation, BookAttendeeSetSelectedAttendeeMutationVariables>) {
        return ApolloReactHooks.useMutation<BookAttendeeSetSelectedAttendeeMutation, BookAttendeeSetSelectedAttendeeMutationVariables>(BookAttendeeSetSelectedAttendeeDocument, baseOptions);
      }
export type BookAttendeeSetSelectedAttendeeMutationHookResult = ReturnType<typeof useBookAttendeeSetSelectedAttendeeMutation>;
export type BookAttendeeSetSelectedAttendeeMutationResult = ApolloReactCommon.MutationResult<BookAttendeeSetSelectedAttendeeMutation>;
export type BookAttendeeSetSelectedAttendeeMutationOptions = ApolloReactCommon.BaseMutationOptions<BookAttendeeSetSelectedAttendeeMutation, BookAttendeeSetSelectedAttendeeMutationVariables>;
export const BookAttendeeSetSelectedCourseDocument = gql`
    mutation bookAttendeeSetSelectedCourse($id: ID) {
  bookAttendeeSetSelectedCourse(id: $id) @client
}
    `;
export type BookAttendeeSetSelectedCourseMutationFn = ApolloReactCommon.MutationFunction<BookAttendeeSetSelectedCourseMutation, BookAttendeeSetSelectedCourseMutationVariables>;

/**
 * __useBookAttendeeSetSelectedCourseMutation__
 *
 * To run a mutation, you first call `useBookAttendeeSetSelectedCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookAttendeeSetSelectedCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookAttendeeSetSelectedCourseMutation, { data, loading, error }] = useBookAttendeeSetSelectedCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookAttendeeSetSelectedCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BookAttendeeSetSelectedCourseMutation, BookAttendeeSetSelectedCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<BookAttendeeSetSelectedCourseMutation, BookAttendeeSetSelectedCourseMutationVariables>(BookAttendeeSetSelectedCourseDocument, baseOptions);
      }
export type BookAttendeeSetSelectedCourseMutationHookResult = ReturnType<typeof useBookAttendeeSetSelectedCourseMutation>;
export type BookAttendeeSetSelectedCourseMutationResult = ApolloReactCommon.MutationResult<BookAttendeeSetSelectedCourseMutation>;
export type BookAttendeeSetSelectedCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<BookAttendeeSetSelectedCourseMutation, BookAttendeeSetSelectedCourseMutationVariables>;
export const UpdateLocalLocationIdDocument = gql`
    mutation updateLocalLocationId($id: ID) {
  updateLocalLocationId(id: $id) @client
}
    `;
export type UpdateLocalLocationIdMutationFn = ApolloReactCommon.MutationFunction<UpdateLocalLocationIdMutation, UpdateLocalLocationIdMutationVariables>;

/**
 * __useUpdateLocalLocationIdMutation__
 *
 * To run a mutation, you first call `useUpdateLocalLocationIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalLocationIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalLocationIdMutation, { data, loading, error }] = useUpdateLocalLocationIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLocalLocationIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLocalLocationIdMutation, UpdateLocalLocationIdMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLocalLocationIdMutation, UpdateLocalLocationIdMutationVariables>(UpdateLocalLocationIdDocument, baseOptions);
      }
export type UpdateLocalLocationIdMutationHookResult = ReturnType<typeof useUpdateLocalLocationIdMutation>;
export type UpdateLocalLocationIdMutationResult = ApolloReactCommon.MutationResult<UpdateLocalLocationIdMutation>;
export type UpdateLocalLocationIdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLocalLocationIdMutation, UpdateLocalLocationIdMutationVariables>;
export const GetCoursesDocument = gql`
    query GetCourses {
  courses {
    id
    courseNumber
    prefixedCourseNumber
    bookingCount
    billedBookingCount
    freePlaces
    settledBookingCount
    courseType {
      id
      name
      description
      color
    }
    startDateTime
    endDateTime
    location {
      id
      city
      name
    }
    venue {
      id
      name
    }
    annotation
    instructors {
      id
      firstname
      lastname
    }
    maxAttendees
    coursePrice {
      id
      grossPrice
      netPrice
      vat
      discount
      discountUnit
      isSpecial
    }
    paymentInterval
    allowMonthlyPayment
    monthlySchedule
    isActive
    showInWeb
    blockBookingOnline
  }
}
    `;

/**
 * __useGetCoursesQuery__
 *
 * To run a query within a React component, call `useGetCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, baseOptions);
      }
export function useGetCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, baseOptions);
        }
export type GetCoursesQueryHookResult = ReturnType<typeof useGetCoursesQuery>;
export type GetCoursesLazyQueryHookResult = ReturnType<typeof useGetCoursesLazyQuery>;
export type GetCoursesQueryResult = ApolloReactCommon.QueryResult<GetCoursesQuery, GetCoursesQueryVariables>;
export const GetCoursesWithPaginationDocument = gql`
    query GetCoursesWithPagination($options: ArrayDataOptions, $currentUserOnly: Boolean, $excludedCourseIds: [String!]) {
  coursesWithPagination(options: $options, currentUserOnly: $currentUserOnly, excludedCourseIds: $excludedCourseIds) {
    existsMore
    total
    items {
      id
      courseNumber
      prefixedCourseNumber
      bookingCountWithoutWaitlist
      billedBookingCount
      freePlaces
      waitListCount
      bookingCount
      placeReservationsCount
      canceledBookingsCount
      settledBookingCount
      startDateTime
      endDateTime
      endDateTimeFirstCourseLesson
      annotation
      maxAttendees
      paymentInterval
      allowMonthlyPayment
      monthlySchedule
      isActive
      showInWeb
      blockBookingOnline
      paymentType
      customInvoiceDueDays
      lessonCount
      allowLessonBooking
      allowMolliePayment
      mollieOptional
      blockBookingOnline
      isArchived
      courseType {
        id
        name
        description
        color
        category {
          id
          name
        }
      }
      location {
        id
        city
        name
      }
      venue {
        id
        name
      }
      instructors {
        id
        firstname
        lastname
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
        discount
        discountUnit
        isSpecial
      }
      installmentRates {
        id
        courseId
        installmentAmount
        installmentDue
        installmentType
      }
      lessons {
        id
        startDateTime
        endDateTime
      }
      visibility {
        visibleForAll
        reason
        hideAfterDays
        restriction {
          membersOnly
          startDateTime
          endDateTime
          inTimeRange
          expireAction
          prerequisiteCourses {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCoursesWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetCoursesWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesWithPaginationQuery({
 *   variables: {
 *      options: // value for 'options'
 *      currentUserOnly: // value for 'currentUserOnly'
 *      excludedCourseIds: // value for 'excludedCourseIds'
 *   },
 * });
 */
export function useGetCoursesWithPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoursesWithPaginationQuery, GetCoursesWithPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoursesWithPaginationQuery, GetCoursesWithPaginationQueryVariables>(GetCoursesWithPaginationDocument, baseOptions);
      }
export function useGetCoursesWithPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoursesWithPaginationQuery, GetCoursesWithPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoursesWithPaginationQuery, GetCoursesWithPaginationQueryVariables>(GetCoursesWithPaginationDocument, baseOptions);
        }
export type GetCoursesWithPaginationQueryHookResult = ReturnType<typeof useGetCoursesWithPaginationQuery>;
export type GetCoursesWithPaginationLazyQueryHookResult = ReturnType<typeof useGetCoursesWithPaginationLazyQuery>;
export type GetCoursesWithPaginationQueryResult = ApolloReactCommon.QueryResult<GetCoursesWithPaginationQuery, GetCoursesWithPaginationQueryVariables>;
export const GetCourseByIdDocument = gql`
    query getCourseById($id: String!) {
  courseById(id: $id) {
    id
    courseType {
      id
      name
      description
      showInWeb
    }
    courseNumber
    prefixedCourseNumber
    courseNumberFormat
    customCourseNumberPrefix
    location {
      id
      city
      name
      venues {
        id
        name
      }
    }
    venue {
      id
      name
    }
    instructors {
      id
      firstname
      lastname
      level
      email
    }
    coursePrice {
      id
      grossPrice
      vat
      discount
      discountUnit
      isSpecial
      includedEntranceFee
    }
    paymentInterval
    lateEntryPricingMode
    minimumPartialBookingLessonCount
    minAttendees
    maxAttendees
    maxAssistantsPerLesson
    maxWaitlist
    bookingCount
    canceledBookingsCount
    startDateTime
    endDateTime
    endDateTimeFirstCourseLesson
    cycle
    annotation
    websiteInfo
    additionalShortInfo
    allowMonthlyPayment
    allowUpFrontPayment
    allowMolliePayment
    mollieOptional
    monthlySchedule
    lessons {
      id
      locationId
      location {
        id
        city
      }
      venueId
      venue {
        id
        name
      }
      startDateTime
      endDateTime
      instructors {
        id
        firstname
        lastname
      }
      billingDate
      courseLessonBookings {
        id
        bookingId
        attendance
        courseLessonId
      }
    }
    isActive
    showInWeb
    blockBookingOnline
    freePlaces
    installmentRates {
      id
      courseId
      installmentAmount
      installmentDue
      installmentType
    }
    additionalItems {
      id
      updateDate
      courseId
      title
      grossPrice
      mode
      vat
      description
    }
    paymentType
    visibility {
      visibleForAll
      restriction {
        prerequisiteCourses {
          id
        }
        membersOnly
        startDateTime
        endDateTime
        inTimeRange
        expireAction
      }
      reason
      hideAfterDays
    }
    allowLessonBooking
    customInvoiceDueDays
    dateOfFirstInstallment
  }
}
    `;

/**
 * __useGetCourseByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseByIdQuery, GetCourseByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseByIdQuery, GetCourseByIdQueryVariables>(GetCourseByIdDocument, baseOptions);
      }
export function useGetCourseByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseByIdQuery, GetCourseByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseByIdQuery, GetCourseByIdQueryVariables>(GetCourseByIdDocument, baseOptions);
        }
export type GetCourseByIdQueryHookResult = ReturnType<typeof useGetCourseByIdQuery>;
export type GetCourseByIdLazyQueryHookResult = ReturnType<typeof useGetCourseByIdLazyQuery>;
export type GetCourseByIdQueryResult = ApolloReactCommon.QueryResult<GetCourseByIdQuery, GetCourseByIdQueryVariables>;
export const GetCourseStartEndByIdDocument = gql`
    query getCourseStartEndById($id: String!) {
  courseById(id: $id) {
    id
    startDateTime
    endDateTime
    blockBookingOnline
  }
}
    `;

/**
 * __useGetCourseStartEndByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseStartEndByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseStartEndByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseStartEndByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseStartEndByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseStartEndByIdQuery, GetCourseStartEndByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseStartEndByIdQuery, GetCourseStartEndByIdQueryVariables>(GetCourseStartEndByIdDocument, baseOptions);
      }
export function useGetCourseStartEndByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseStartEndByIdQuery, GetCourseStartEndByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseStartEndByIdQuery, GetCourseStartEndByIdQueryVariables>(GetCourseStartEndByIdDocument, baseOptions);
        }
export type GetCourseStartEndByIdQueryHookResult = ReturnType<typeof useGetCourseStartEndByIdQuery>;
export type GetCourseStartEndByIdLazyQueryHookResult = ReturnType<typeof useGetCourseStartEndByIdLazyQuery>;
export type GetCourseStartEndByIdQueryResult = ApolloReactCommon.QueryResult<GetCourseStartEndByIdQuery, GetCourseStartEndByIdQueryVariables>;
export const GetCourseByLocationIdDocument = gql`
    query GetCourseByLocationId($id: ID!) {
  courseByLocationId(id: $id) {
    id
    lessons {
      startDateTime
      endDateTime
    }
    courseType {
      name
      description
      annotation
      websiteInfo
    }
  }
}
    `;

/**
 * __useGetCourseByLocationIdQuery__
 *
 * To run a query within a React component, call `useGetCourseByLocationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseByLocationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseByLocationIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseByLocationIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseByLocationIdQuery, GetCourseByLocationIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseByLocationIdQuery, GetCourseByLocationIdQueryVariables>(GetCourseByLocationIdDocument, baseOptions);
      }
export function useGetCourseByLocationIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseByLocationIdQuery, GetCourseByLocationIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseByLocationIdQuery, GetCourseByLocationIdQueryVariables>(GetCourseByLocationIdDocument, baseOptions);
        }
export type GetCourseByLocationIdQueryHookResult = ReturnType<typeof useGetCourseByLocationIdQuery>;
export type GetCourseByLocationIdLazyQueryHookResult = ReturnType<typeof useGetCourseByLocationIdLazyQuery>;
export type GetCourseByLocationIdQueryResult = ApolloReactCommon.QueryResult<GetCourseByLocationIdQuery, GetCourseByLocationIdQueryVariables>;
export const UpdateCourseDocument = gql`
    mutation updateCourse($id: String!, $editCourseData: EditCourseInput!, $fillFromWaitingList: Boolean, $notifyBooker: Boolean) {
  updateCourse(id: $id, editCourseData: $editCourseData, fillFromWaitingList: $fillFromWaitingList, notifyBooker: $notifyBooker) {
    id
    coursePrice {
      id
      vat
      grossPrice
      discount
      discountUnit
      courseId
      includedEntranceFee
    }
    paymentInterval
    lateEntryPricingMode
    minimumPartialBookingLessonCount
    minAttendees
    maxAttendees
    maxAssistantsPerLesson
    maxWaitlist
    startDateTime
    endDateTime
    endDateTimeFirstCourseLesson
    cycle
    annotation
    websiteInfo
    allowMonthlyPayment
    allowUpFrontPayment
    allowMolliePayment
    mollieOptional
    paymentType
    monthlySchedule
    isActive
    showInWeb
    blockBookingOnline
    customInvoiceDueDays
  }
}
    `;
export type UpdateCourseMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      editCourseData: // value for 'editCourseData'
 *      fillFromWaitingList: // value for 'fillFromWaitingList'
 *      notifyBooker: // value for 'notifyBooker'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, baseOptions);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = ApolloReactCommon.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const UpdateCourseAndBookingsDocument = gql`
    mutation UpdateCourseAndBookings($updateCourseAndBookingsInput: UpdateCourseAndBookingsInput!, $dryRun: Boolean!) {
  updateCourseAndBookings(updateCourseAndBookingsInput: $updateCourseAndBookingsInput, dryRun: $dryRun) {
    dryRun
    course {
      id
      lateEntryPricingMode
      minimumPartialBookingLessonCount
      lessons {
        id
        startDateTime
        endDateTime
      }
    }
    bookings {
      id
      bookingNumber
      bookingNumberPrefix
      noticeStaff
      noticeBooker
      additionalInfo
      bookingType
      startDateTime
      paymentType
      payDate
      grossPrice
      canceled
      monthlySchedule
      creditedBalance
      memberDiscount
      discount
      discountName
      bookedLessonCount
      isSettled
      invoice {
        id
      }
      scheduledPayments {
        id
        paymentAmount
        openAmount
        paymentDue
        paymentDone
        title
        type
      }
      paymentMethodId
      paymentMethod {
        id
        cash
        esr
        creditcardNumber
        creditCardAccountholder
        expirationDate
        sepaAccountholder
        iban
        bic
        bank
        paypalAccountholder
        email
        bankTransfer
        onlinePayment
      }
    }
    courseLessonsPreview {
      id
      indexOfLessonInCourse
      startDateTime
      endDateTime
    }
    courseLessonBookingsPreview {
      bookingId
      courseLessonBookings {
        id
        courseLessonId
      }
    }
  }
}
    `;
export type UpdateCourseAndBookingsMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseAndBookingsMutation, UpdateCourseAndBookingsMutationVariables>;

/**
 * __useUpdateCourseAndBookingsMutation__
 *
 * To run a mutation, you first call `useUpdateCourseAndBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseAndBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseAndBookingsMutation, { data, loading, error }] = useUpdateCourseAndBookingsMutation({
 *   variables: {
 *      updateCourseAndBookingsInput: // value for 'updateCourseAndBookingsInput'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useUpdateCourseAndBookingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseAndBookingsMutation, UpdateCourseAndBookingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseAndBookingsMutation, UpdateCourseAndBookingsMutationVariables>(UpdateCourseAndBookingsDocument, baseOptions);
      }
export type UpdateCourseAndBookingsMutationHookResult = ReturnType<typeof useUpdateCourseAndBookingsMutation>;
export type UpdateCourseAndBookingsMutationResult = ApolloReactCommon.MutationResult<UpdateCourseAndBookingsMutation>;
export type UpdateCourseAndBookingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseAndBookingsMutation, UpdateCourseAndBookingsMutationVariables>;
export const GetCitiesDocument = gql`
    query GetCities {
  cities {
    city
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, baseOptions);
      }
export function useGetCitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, baseOptions);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesQueryResult = ApolloReactCommon.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetLocationsSortedByCityDocument = gql`
    query GetLocationsSortedByCity {
  locationsSortedByCity {
    city
    locations {
      id
      city
      name
      venues {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetLocationsSortedByCityQuery__
 *
 * To run a query within a React component, call `useGetLocationsSortedByCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsSortedByCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsSortedByCityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsSortedByCityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationsSortedByCityQuery, GetLocationsSortedByCityQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationsSortedByCityQuery, GetLocationsSortedByCityQueryVariables>(GetLocationsSortedByCityDocument, baseOptions);
      }
export function useGetLocationsSortedByCityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationsSortedByCityQuery, GetLocationsSortedByCityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationsSortedByCityQuery, GetLocationsSortedByCityQueryVariables>(GetLocationsSortedByCityDocument, baseOptions);
        }
export type GetLocationsSortedByCityQueryHookResult = ReturnType<typeof useGetLocationsSortedByCityQuery>;
export type GetLocationsSortedByCityLazyQueryHookResult = ReturnType<typeof useGetLocationsSortedByCityLazyQuery>;
export type GetLocationsSortedByCityQueryResult = ApolloReactCommon.QueryResult<GetLocationsSortedByCityQuery, GetLocationsSortedByCityQueryVariables>;
export const GetLocationsByCityDocument = gql`
    query GetLocationsByCity($city: String!) {
  locationsByCity(city: $city) {
    id
    name
    venues {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLocationsByCityQuery__
 *
 * To run a query within a React component, call `useGetLocationsByCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByCityQuery({
 *   variables: {
 *      city: // value for 'city'
 *   },
 * });
 */
export function useGetLocationsByCityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationsByCityQuery, GetLocationsByCityQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationsByCityQuery, GetLocationsByCityQueryVariables>(GetLocationsByCityDocument, baseOptions);
      }
export function useGetLocationsByCityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationsByCityQuery, GetLocationsByCityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationsByCityQuery, GetLocationsByCityQueryVariables>(GetLocationsByCityDocument, baseOptions);
        }
export type GetLocationsByCityQueryHookResult = ReturnType<typeof useGetLocationsByCityQuery>;
export type GetLocationsByCityLazyQueryHookResult = ReturnType<typeof useGetLocationsByCityLazyQuery>;
export type GetLocationsByCityQueryResult = ApolloReactCommon.QueryResult<GetLocationsByCityQuery, GetLocationsByCityQueryVariables>;
export const GetInstructorsDocument = gql`
    query GetInstructors {
  instructors {
    id
    firstname
    lastname
    level
    leaveDate
    active
  }
}
    `;

/**
 * __useGetInstructorsQuery__
 *
 * To run a query within a React component, call `useGetInstructorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstructorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInstructorsQuery, GetInstructorsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInstructorsQuery, GetInstructorsQueryVariables>(GetInstructorsDocument, baseOptions);
      }
export function useGetInstructorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstructorsQuery, GetInstructorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInstructorsQuery, GetInstructorsQueryVariables>(GetInstructorsDocument, baseOptions);
        }
export type GetInstructorsQueryHookResult = ReturnType<typeof useGetInstructorsQuery>;
export type GetInstructorsLazyQueryHookResult = ReturnType<typeof useGetInstructorsLazyQuery>;
export type GetInstructorsQueryResult = ApolloReactCommon.QueryResult<GetInstructorsQuery, GetInstructorsQueryVariables>;
export const CreateCourseDocument = gql`
    mutation CreateCourse($newCourseData: NewCourseInput!) {
  createCourse(newCourseData: $newCourseData) {
    id
    lateEntryPricingMode
    minimumPartialBookingLessonCount
  }
}
    `;
export type CreateCourseMutationFn = ApolloReactCommon.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      newCourseData: // value for 'newCourseData'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, baseOptions);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = ApolloReactCommon.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const GetCourseTypeStateDocument = gql`
    query GetCourseTypeState($id: String!) {
  courseTypeStateById(id: $id) {
    id
    isActive
    showInWeb
    name
  }
}
    `;

/**
 * __useGetCourseTypeStateQuery__
 *
 * To run a query within a React component, call `useGetCourseTypeStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseTypeStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseTypeStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseTypeStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseTypeStateQuery, GetCourseTypeStateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseTypeStateQuery, GetCourseTypeStateQueryVariables>(GetCourseTypeStateDocument, baseOptions);
      }
export function useGetCourseTypeStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseTypeStateQuery, GetCourseTypeStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseTypeStateQuery, GetCourseTypeStateQueryVariables>(GetCourseTypeStateDocument, baseOptions);
        }
export type GetCourseTypeStateQueryHookResult = ReturnType<typeof useGetCourseTypeStateQuery>;
export type GetCourseTypeStateLazyQueryHookResult = ReturnType<typeof useGetCourseTypeStateLazyQuery>;
export type GetCourseTypeStateQueryResult = ApolloReactCommon.QueryResult<GetCourseTypeStateQuery, GetCourseTypeStateQueryVariables>;
export const RemoveCourseTypeDocument = gql`
    mutation RemoveCourseType($id: ID!) {
  removeCourseType(id: $id)
}
    `;
export type RemoveCourseTypeMutationFn = ApolloReactCommon.MutationFunction<RemoveCourseTypeMutation, RemoveCourseTypeMutationVariables>;

/**
 * __useRemoveCourseTypeMutation__
 *
 * To run a mutation, you first call `useRemoveCourseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourseTypeMutation, { data, loading, error }] = useRemoveCourseTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCourseTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCourseTypeMutation, RemoveCourseTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveCourseTypeMutation, RemoveCourseTypeMutationVariables>(RemoveCourseTypeDocument, baseOptions);
      }
export type RemoveCourseTypeMutationHookResult = ReturnType<typeof useRemoveCourseTypeMutation>;
export type RemoveCourseTypeMutationResult = ApolloReactCommon.MutationResult<RemoveCourseTypeMutation>;
export type RemoveCourseTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveCourseTypeMutation, RemoveCourseTypeMutationVariables>;
export const CreateCourseTypeDocument = gql`
    mutation CreateCourseType($newCourseTypeData: NewCourseTypeInput!) {
  createCourseType(newCourseTypeData: $newCourseTypeData) {
    id
    isActive
    showInWeb
    name
    shortHandId
    category {
      id
    }
    description
    minAge
    maxAge
    paymentInterval
    minAttendees
    maxAttendees
    annotation
    websiteInfo
    inWeekPlanner
    bold
    color
    participationPrerequisites {
      id
      groupLabel
      groupDescription
      optionalInputFields
      minCheckCount
      courseTypeId
    }
  }
}
    `;
export type CreateCourseTypeMutationFn = ApolloReactCommon.MutationFunction<CreateCourseTypeMutation, CreateCourseTypeMutationVariables>;

/**
 * __useCreateCourseTypeMutation__
 *
 * To run a mutation, you first call `useCreateCourseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseTypeMutation, { data, loading, error }] = useCreateCourseTypeMutation({
 *   variables: {
 *      newCourseTypeData: // value for 'newCourseTypeData'
 *   },
 * });
 */
export function useCreateCourseTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCourseTypeMutation, CreateCourseTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCourseTypeMutation, CreateCourseTypeMutationVariables>(CreateCourseTypeDocument, baseOptions);
      }
export type CreateCourseTypeMutationHookResult = ReturnType<typeof useCreateCourseTypeMutation>;
export type CreateCourseTypeMutationResult = ApolloReactCommon.MutationResult<CreateCourseTypeMutation>;
export type CreateCourseTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCourseTypeMutation, CreateCourseTypeMutationVariables>;
export const UpdateCourseTypeDocument = gql`
    mutation UpdateCourseType($id: String!, $newCourseTypeData: NewCourseTypeInput!) {
  updateCourseType(id: $id, newCourseTypeData: $newCourseTypeData) {
    id
    isActive
    showInWeb
    name
    shortHandId
    category {
      id
    }
    description
    minAge
    maxAge
    paymentInterval
    minAttendees
    maxAttendees
    annotation
    websiteInfo
    inWeekPlanner
    bold
    color
  }
}
    `;
export type UpdateCourseTypeMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseTypeMutation, UpdateCourseTypeMutationVariables>;

/**
 * __useUpdateCourseTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCourseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseTypeMutation, { data, loading, error }] = useUpdateCourseTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newCourseTypeData: // value for 'newCourseTypeData'
 *   },
 * });
 */
export function useUpdateCourseTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseTypeMutation, UpdateCourseTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseTypeMutation, UpdateCourseTypeMutationVariables>(UpdateCourseTypeDocument, baseOptions);
      }
export type UpdateCourseTypeMutationHookResult = ReturnType<typeof useUpdateCourseTypeMutation>;
export type UpdateCourseTypeMutationResult = ApolloReactCommon.MutationResult<UpdateCourseTypeMutation>;
export type UpdateCourseTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseTypeMutation, UpdateCourseTypeMutationVariables>;
export const CourseTypeGetCourseCategoriesDocument = gql`
    query CourseTypeGetCourseCategories {
  courseCategories {
    id
    name
  }
}
    `;

/**
 * __useCourseTypeGetCourseCategoriesQuery__
 *
 * To run a query within a React component, call `useCourseTypeGetCourseCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseTypeGetCourseCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseTypeGetCourseCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCourseTypeGetCourseCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseTypeGetCourseCategoriesQuery, CourseTypeGetCourseCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseTypeGetCourseCategoriesQuery, CourseTypeGetCourseCategoriesQueryVariables>(CourseTypeGetCourseCategoriesDocument, baseOptions);
      }
export function useCourseTypeGetCourseCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseTypeGetCourseCategoriesQuery, CourseTypeGetCourseCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseTypeGetCourseCategoriesQuery, CourseTypeGetCourseCategoriesQueryVariables>(CourseTypeGetCourseCategoriesDocument, baseOptions);
        }
export type CourseTypeGetCourseCategoriesQueryHookResult = ReturnType<typeof useCourseTypeGetCourseCategoriesQuery>;
export type CourseTypeGetCourseCategoriesLazyQueryHookResult = ReturnType<typeof useCourseTypeGetCourseCategoriesLazyQuery>;
export type CourseTypeGetCourseCategoriesQueryResult = ApolloReactCommon.QueryResult<CourseTypeGetCourseCategoriesQuery, CourseTypeGetCourseCategoriesQueryVariables>;
export const GetCourseCategoriesDocument = gql`
    query GetCourseCategories {
  courseCategories {
    id
    isActive
    name
    description
    linkedCourseTypes {
      id
      name
      color
      showInWeb
    }
  }
}
    `;

/**
 * __useGetCourseCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCourseCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseCategoriesQuery, GetCourseCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseCategoriesQuery, GetCourseCategoriesQueryVariables>(GetCourseCategoriesDocument, baseOptions);
      }
export function useGetCourseCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseCategoriesQuery, GetCourseCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseCategoriesQuery, GetCourseCategoriesQueryVariables>(GetCourseCategoriesDocument, baseOptions);
        }
export type GetCourseCategoriesQueryHookResult = ReturnType<typeof useGetCourseCategoriesQuery>;
export type GetCourseCategoriesLazyQueryHookResult = ReturnType<typeof useGetCourseCategoriesLazyQuery>;
export type GetCourseCategoriesQueryResult = ApolloReactCommon.QueryResult<GetCourseCategoriesQuery, GetCourseCategoriesQueryVariables>;
export const GetCourseCategoryDocument = gql`
    query GetCourseCategory($id: String!) {
  courseCategoryById(id: $id) {
    id
    isActive
    name
    description
    linkedCourseTypes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCourseCategoryQuery__
 *
 * To run a query within a React component, call `useGetCourseCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseCategoryQuery, GetCourseCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseCategoryQuery, GetCourseCategoryQueryVariables>(GetCourseCategoryDocument, baseOptions);
      }
export function useGetCourseCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseCategoryQuery, GetCourseCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseCategoryQuery, GetCourseCategoryQueryVariables>(GetCourseCategoryDocument, baseOptions);
        }
export type GetCourseCategoryQueryHookResult = ReturnType<typeof useGetCourseCategoryQuery>;
export type GetCourseCategoryLazyQueryHookResult = ReturnType<typeof useGetCourseCategoryLazyQuery>;
export type GetCourseCategoryQueryResult = ApolloReactCommon.QueryResult<GetCourseCategoryQuery, GetCourseCategoryQueryVariables>;
export const CreateCourseCategoryDocument = gql`
    mutation CreateCourseCategory($newCourseCategoryData: NewCourseCategoryInput!) {
  createCourseCategory(newCourseCategoryData: $newCourseCategoryData) {
    id
    name
    isActive
    description
    linkedCourseTypes {
      id
    }
  }
}
    `;
export type CreateCourseCategoryMutationFn = ApolloReactCommon.MutationFunction<CreateCourseCategoryMutation, CreateCourseCategoryMutationVariables>;

/**
 * __useCreateCourseCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCourseCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseCategoryMutation, { data, loading, error }] = useCreateCourseCategoryMutation({
 *   variables: {
 *      newCourseCategoryData: // value for 'newCourseCategoryData'
 *   },
 * });
 */
export function useCreateCourseCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCourseCategoryMutation, CreateCourseCategoryMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCourseCategoryMutation, CreateCourseCategoryMutationVariables>(CreateCourseCategoryDocument, baseOptions);
      }
export type CreateCourseCategoryMutationHookResult = ReturnType<typeof useCreateCourseCategoryMutation>;
export type CreateCourseCategoryMutationResult = ApolloReactCommon.MutationResult<CreateCourseCategoryMutation>;
export type CreateCourseCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCourseCategoryMutation, CreateCourseCategoryMutationVariables>;
export const UpdateCourseCategoryDocument = gql`
    mutation UpdateCourseCategory($id: String!, $newCourseCategoryData: NewCourseCategoryInput!) {
  updateCourseCategory(id: $id, newCourseCategoryData: $newCourseCategoryData) {
    id
    name
    isActive
    description
    linkedCourseTypes {
      id
    }
  }
}
    `;
export type UpdateCourseCategoryMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseCategoryMutation, UpdateCourseCategoryMutationVariables>;

/**
 * __useUpdateCourseCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCourseCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseCategoryMutation, { data, loading, error }] = useUpdateCourseCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newCourseCategoryData: // value for 'newCourseCategoryData'
 *   },
 * });
 */
export function useUpdateCourseCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseCategoryMutation, UpdateCourseCategoryMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseCategoryMutation, UpdateCourseCategoryMutationVariables>(UpdateCourseCategoryDocument, baseOptions);
      }
export type UpdateCourseCategoryMutationHookResult = ReturnType<typeof useUpdateCourseCategoryMutation>;
export type UpdateCourseCategoryMutationResult = ApolloReactCommon.MutationResult<UpdateCourseCategoryMutation>;
export type UpdateCourseCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseCategoryMutation, UpdateCourseCategoryMutationVariables>;
export const CourseGetInstructorsDocument = gql`
    query CourseGetInstructors {
  instructors {
    id
    firstname
    lastname
    level
    active
  }
}
    `;

/**
 * __useCourseGetInstructorsQuery__
 *
 * To run a query within a React component, call `useCourseGetInstructorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseGetInstructorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseGetInstructorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCourseGetInstructorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseGetInstructorsQuery, CourseGetInstructorsQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseGetInstructorsQuery, CourseGetInstructorsQueryVariables>(CourseGetInstructorsDocument, baseOptions);
      }
export function useCourseGetInstructorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseGetInstructorsQuery, CourseGetInstructorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseGetInstructorsQuery, CourseGetInstructorsQueryVariables>(CourseGetInstructorsDocument, baseOptions);
        }
export type CourseGetInstructorsQueryHookResult = ReturnType<typeof useCourseGetInstructorsQuery>;
export type CourseGetInstructorsLazyQueryHookResult = ReturnType<typeof useCourseGetInstructorsLazyQuery>;
export type CourseGetInstructorsQueryResult = ApolloReactCommon.QueryResult<CourseGetInstructorsQuery, CourseGetInstructorsQueryVariables>;
export const CourseGetInstructorsByLocationDocument = gql`
    query CourseGetInstructorsByLocation($locationId: String!) {
  findInstructorsByLocation(locationId: $locationId) {
    id
    firstname
    lastname
    level
    active
    leaveDate
  }
}
    `;

/**
 * __useCourseGetInstructorsByLocationQuery__
 *
 * To run a query within a React component, call `useCourseGetInstructorsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseGetInstructorsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseGetInstructorsByLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useCourseGetInstructorsByLocationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseGetInstructorsByLocationQuery, CourseGetInstructorsByLocationQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseGetInstructorsByLocationQuery, CourseGetInstructorsByLocationQueryVariables>(CourseGetInstructorsByLocationDocument, baseOptions);
      }
export function useCourseGetInstructorsByLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseGetInstructorsByLocationQuery, CourseGetInstructorsByLocationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseGetInstructorsByLocationQuery, CourseGetInstructorsByLocationQueryVariables>(CourseGetInstructorsByLocationDocument, baseOptions);
        }
export type CourseGetInstructorsByLocationQueryHookResult = ReturnType<typeof useCourseGetInstructorsByLocationQuery>;
export type CourseGetInstructorsByLocationLazyQueryHookResult = ReturnType<typeof useCourseGetInstructorsByLocationLazyQuery>;
export type CourseGetInstructorsByLocationQueryResult = ApolloReactCommon.QueryResult<CourseGetInstructorsByLocationQuery, CourseGetInstructorsByLocationQueryVariables>;
export const GetCourseLessonsByCourseIdDocument = gql`
    query GetCourseLessonsByCourseId($courseId: ID!) {
  courseLessonsByCourseId(courseId: $courseId) {
    id
    startDateTime
    endDateTime
  }
}
    `;

/**
 * __useGetCourseLessonsByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseLessonsByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsByCourseIdQuery, GetCourseLessonsByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsByCourseIdQuery, GetCourseLessonsByCourseIdQueryVariables>(GetCourseLessonsByCourseIdDocument, baseOptions);
      }
export function useGetCourseLessonsByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsByCourseIdQuery, GetCourseLessonsByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsByCourseIdQuery, GetCourseLessonsByCourseIdQueryVariables>(GetCourseLessonsByCourseIdDocument, baseOptions);
        }
export type GetCourseLessonsByCourseIdQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdQuery>;
export type GetCourseLessonsByCourseIdLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdLazyQuery>;
export type GetCourseLessonsByCourseIdQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsByCourseIdQuery, GetCourseLessonsByCourseIdQueryVariables>;
export const GetCourseLessonsByCourseIdWithCourseLessonBookingsDocument = gql`
    query GetCourseLessonsByCourseIdWithCourseLessonBookings($courseId: ID!) {
  courseLessonsByCourseId(courseId: $courseId) {
    id
    startDateTime
    endDateTime
    bookings {
      id
      attendee {
        id
        firstname
      }
    }
    courseLessonBookings {
      id
      courseLessonId
      attendance
      bookingId
    }
  }
}
    `;

/**
 * __useGetCourseLessonsByCourseIdWithCourseLessonBookingsQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsByCourseIdWithCourseLessonBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsByCourseIdWithCourseLessonBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsByCourseIdWithCourseLessonBookingsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseLessonsByCourseIdWithCourseLessonBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsByCourseIdWithCourseLessonBookingsQuery, GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsByCourseIdWithCourseLessonBookingsQuery, GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryVariables>(GetCourseLessonsByCourseIdWithCourseLessonBookingsDocument, baseOptions);
      }
export function useGetCourseLessonsByCourseIdWithCourseLessonBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsByCourseIdWithCourseLessonBookingsQuery, GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsByCourseIdWithCourseLessonBookingsQuery, GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryVariables>(GetCourseLessonsByCourseIdWithCourseLessonBookingsDocument, baseOptions);
        }
export type GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdWithCourseLessonBookingsQuery>;
export type GetCourseLessonsByCourseIdWithCourseLessonBookingsLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdWithCourseLessonBookingsLazyQuery>;
export type GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsByCourseIdWithCourseLessonBookingsQuery, GetCourseLessonsByCourseIdWithCourseLessonBookingsQueryVariables>;
export const GetCourseLessonsByCourseIdWithLocationDocument = gql`
    query GetCourseLessonsByCourseIdWithLocation($courseId: ID!) {
  courseLessonsByCourseId(courseId: $courseId) {
    id
    startDateTime
    endDateTime
    location {
      id
      city
      name
    }
  }
}
    `;

/**
 * __useGetCourseLessonsByCourseIdWithLocationQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsByCourseIdWithLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsByCourseIdWithLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsByCourseIdWithLocationQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseLessonsByCourseIdWithLocationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsByCourseIdWithLocationQuery, GetCourseLessonsByCourseIdWithLocationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsByCourseIdWithLocationQuery, GetCourseLessonsByCourseIdWithLocationQueryVariables>(GetCourseLessonsByCourseIdWithLocationDocument, baseOptions);
      }
export function useGetCourseLessonsByCourseIdWithLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsByCourseIdWithLocationQuery, GetCourseLessonsByCourseIdWithLocationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsByCourseIdWithLocationQuery, GetCourseLessonsByCourseIdWithLocationQueryVariables>(GetCourseLessonsByCourseIdWithLocationDocument, baseOptions);
        }
export type GetCourseLessonsByCourseIdWithLocationQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdWithLocationQuery>;
export type GetCourseLessonsByCourseIdWithLocationLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdWithLocationLazyQuery>;
export type GetCourseLessonsByCourseIdWithLocationQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsByCourseIdWithLocationQuery, GetCourseLessonsByCourseIdWithLocationQueryVariables>;
export const GetCourseVariablesForTemplateDocument = gql`
    query GetCourseVariablesForTemplate($courseId: ID!) {
  courseLessonsByCourseId(courseId: $courseId) {
    id
    startDateTime
    location {
      id
      city
      name
    }
    course {
      id
      courseNumber
      prefixedCourseNumber
      courseType {
        id
        name
        description
      }
    }
    endDateTime
  }
}
    `;

/**
 * __useGetCourseVariablesForTemplateQuery__
 *
 * To run a query within a React component, call `useGetCourseVariablesForTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseVariablesForTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseVariablesForTemplateQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseVariablesForTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseVariablesForTemplateQuery, GetCourseVariablesForTemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseVariablesForTemplateQuery, GetCourseVariablesForTemplateQueryVariables>(GetCourseVariablesForTemplateDocument, baseOptions);
      }
export function useGetCourseVariablesForTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseVariablesForTemplateQuery, GetCourseVariablesForTemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseVariablesForTemplateQuery, GetCourseVariablesForTemplateQueryVariables>(GetCourseVariablesForTemplateDocument, baseOptions);
        }
export type GetCourseVariablesForTemplateQueryHookResult = ReturnType<typeof useGetCourseVariablesForTemplateQuery>;
export type GetCourseVariablesForTemplateLazyQueryHookResult = ReturnType<typeof useGetCourseVariablesForTemplateLazyQuery>;
export type GetCourseVariablesForTemplateQueryResult = ApolloReactCommon.QueryResult<GetCourseVariablesForTemplateQuery, GetCourseVariablesForTemplateQueryVariables>;
export const IsCourseNumberAvailableDocument = gql`
    query IsCourseNumberAvailable($customCourseNumberPrefix: String!, $courseId: String!) {
  isCourseNameUnique(customCourseNumberPrefix: $customCourseNumberPrefix, courseId: $courseId)
}
    `;

/**
 * __useIsCourseNumberAvailableQuery__
 *
 * To run a query within a React component, call `useIsCourseNumberAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCourseNumberAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCourseNumberAvailableQuery({
 *   variables: {
 *      customCourseNumberPrefix: // value for 'customCourseNumberPrefix'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useIsCourseNumberAvailableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsCourseNumberAvailableQuery, IsCourseNumberAvailableQueryVariables>) {
        return ApolloReactHooks.useQuery<IsCourseNumberAvailableQuery, IsCourseNumberAvailableQueryVariables>(IsCourseNumberAvailableDocument, baseOptions);
      }
export function useIsCourseNumberAvailableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsCourseNumberAvailableQuery, IsCourseNumberAvailableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IsCourseNumberAvailableQuery, IsCourseNumberAvailableQueryVariables>(IsCourseNumberAvailableDocument, baseOptions);
        }
export type IsCourseNumberAvailableQueryHookResult = ReturnType<typeof useIsCourseNumberAvailableQuery>;
export type IsCourseNumberAvailableLazyQueryHookResult = ReturnType<typeof useIsCourseNumberAvailableLazyQuery>;
export type IsCourseNumberAvailableQueryResult = ApolloReactCommon.QueryResult<IsCourseNumberAvailableQuery, IsCourseNumberAvailableQueryVariables>;
export const GetFreePlacesByCourseIdDocument = gql`
    query getFreePlacesByCourseId($id: String!) {
  courseById(id: $id) {
    id
    freePlaces
    bookingCount
  }
}
    `;

/**
 * __useGetFreePlacesByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetFreePlacesByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreePlacesByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreePlacesByCourseIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFreePlacesByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFreePlacesByCourseIdQuery, GetFreePlacesByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFreePlacesByCourseIdQuery, GetFreePlacesByCourseIdQueryVariables>(GetFreePlacesByCourseIdDocument, baseOptions);
      }
export function useGetFreePlacesByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFreePlacesByCourseIdQuery, GetFreePlacesByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFreePlacesByCourseIdQuery, GetFreePlacesByCourseIdQueryVariables>(GetFreePlacesByCourseIdDocument, baseOptions);
        }
export type GetFreePlacesByCourseIdQueryHookResult = ReturnType<typeof useGetFreePlacesByCourseIdQuery>;
export type GetFreePlacesByCourseIdLazyQueryHookResult = ReturnType<typeof useGetFreePlacesByCourseIdLazyQuery>;
export type GetFreePlacesByCourseIdQueryResult = ApolloReactCommon.QueryResult<GetFreePlacesByCourseIdQuery, GetFreePlacesByCourseIdQueryVariables>;
export const GetMaxAttendeesByCourseIdDocument = gql`
    query getMaxAttendeesByCourseId($id: String!) {
  courseById(id: $id) {
    id
    maxAttendees
  }
}
    `;

/**
 * __useGetMaxAttendeesByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetMaxAttendeesByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaxAttendeesByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaxAttendeesByCourseIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMaxAttendeesByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMaxAttendeesByCourseIdQuery, GetMaxAttendeesByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMaxAttendeesByCourseIdQuery, GetMaxAttendeesByCourseIdQueryVariables>(GetMaxAttendeesByCourseIdDocument, baseOptions);
      }
export function useGetMaxAttendeesByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMaxAttendeesByCourseIdQuery, GetMaxAttendeesByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMaxAttendeesByCourseIdQuery, GetMaxAttendeesByCourseIdQueryVariables>(GetMaxAttendeesByCourseIdDocument, baseOptions);
        }
export type GetMaxAttendeesByCourseIdQueryHookResult = ReturnType<typeof useGetMaxAttendeesByCourseIdQuery>;
export type GetMaxAttendeesByCourseIdLazyQueryHookResult = ReturnType<typeof useGetMaxAttendeesByCourseIdLazyQuery>;
export type GetMaxAttendeesByCourseIdQueryResult = ApolloReactCommon.QueryResult<GetMaxAttendeesByCourseIdQuery, GetMaxAttendeesByCourseIdQueryVariables>;
export const GetAllCoursesWithAllowMonthlyPaymentDocument = gql`
    query GetAllCoursesWithAllowMonthlyPayment {
  getAllCoursesWithAllowMonthlyPayment {
    id
    prefixedCourseNumber
    allowMonthlyPayment
  }
}
    `;

/**
 * __useGetAllCoursesWithAllowMonthlyPaymentQuery__
 *
 * To run a query within a React component, call `useGetAllCoursesWithAllowMonthlyPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCoursesWithAllowMonthlyPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCoursesWithAllowMonthlyPaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCoursesWithAllowMonthlyPaymentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllCoursesWithAllowMonthlyPaymentQuery, GetAllCoursesWithAllowMonthlyPaymentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllCoursesWithAllowMonthlyPaymentQuery, GetAllCoursesWithAllowMonthlyPaymentQueryVariables>(GetAllCoursesWithAllowMonthlyPaymentDocument, baseOptions);
      }
export function useGetAllCoursesWithAllowMonthlyPaymentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllCoursesWithAllowMonthlyPaymentQuery, GetAllCoursesWithAllowMonthlyPaymentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllCoursesWithAllowMonthlyPaymentQuery, GetAllCoursesWithAllowMonthlyPaymentQueryVariables>(GetAllCoursesWithAllowMonthlyPaymentDocument, baseOptions);
        }
export type GetAllCoursesWithAllowMonthlyPaymentQueryHookResult = ReturnType<typeof useGetAllCoursesWithAllowMonthlyPaymentQuery>;
export type GetAllCoursesWithAllowMonthlyPaymentLazyQueryHookResult = ReturnType<typeof useGetAllCoursesWithAllowMonthlyPaymentLazyQuery>;
export type GetAllCoursesWithAllowMonthlyPaymentQueryResult = ApolloReactCommon.QueryResult<GetAllCoursesWithAllowMonthlyPaymentQuery, GetAllCoursesWithAllowMonthlyPaymentQueryVariables>;
export const GetCourseAnnotationDocument = gql`
    query getCourseAnnotation($id: String!) {
  courseById(id: $id) {
    id
    annotation
  }
}
    `;

/**
 * __useGetCourseAnnotationQuery__
 *
 * To run a query within a React component, call `useGetCourseAnnotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseAnnotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseAnnotationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseAnnotationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseAnnotationQuery, GetCourseAnnotationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseAnnotationQuery, GetCourseAnnotationQueryVariables>(GetCourseAnnotationDocument, baseOptions);
      }
export function useGetCourseAnnotationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseAnnotationQuery, GetCourseAnnotationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseAnnotationQuery, GetCourseAnnotationQueryVariables>(GetCourseAnnotationDocument, baseOptions);
        }
export type GetCourseAnnotationQueryHookResult = ReturnType<typeof useGetCourseAnnotationQuery>;
export type GetCourseAnnotationLazyQueryHookResult = ReturnType<typeof useGetCourseAnnotationLazyQuery>;
export type GetCourseAnnotationQueryResult = ApolloReactCommon.QueryResult<GetCourseAnnotationQuery, GetCourseAnnotationQueryVariables>;
export const UpdateCourseAnnotationDocument = gql`
    mutation updateCourseAnnotation($id: String!, $annotation: String) {
  updateCourseAnnotation(id: $id, annotation: $annotation) {
    id
    annotation
  }
}
    `;
export type UpdateCourseAnnotationMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseAnnotationMutation, UpdateCourseAnnotationMutationVariables>;

/**
 * __useUpdateCourseAnnotationMutation__
 *
 * To run a mutation, you first call `useUpdateCourseAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseAnnotationMutation, { data, loading, error }] = useUpdateCourseAnnotationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      annotation: // value for 'annotation'
 *   },
 * });
 */
export function useUpdateCourseAnnotationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseAnnotationMutation, UpdateCourseAnnotationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseAnnotationMutation, UpdateCourseAnnotationMutationVariables>(UpdateCourseAnnotationDocument, baseOptions);
      }
export type UpdateCourseAnnotationMutationHookResult = ReturnType<typeof useUpdateCourseAnnotationMutation>;
export type UpdateCourseAnnotationMutationResult = ApolloReactCommon.MutationResult<UpdateCourseAnnotationMutation>;
export type UpdateCourseAnnotationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseAnnotationMutation, UpdateCourseAnnotationMutationVariables>;
export const GetCourseMemberDiscountDocument = gql`
    query getCourseMemberDiscount($id: String!) {
  courseById(id: $id) {
    id
    coursePrice {
      id
      discount
      discountUnit
    }
  }
}
    `;

/**
 * __useGetCourseMemberDiscountQuery__
 *
 * To run a query within a React component, call `useGetCourseMemberDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseMemberDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseMemberDiscountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseMemberDiscountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseMemberDiscountQuery, GetCourseMemberDiscountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseMemberDiscountQuery, GetCourseMemberDiscountQueryVariables>(GetCourseMemberDiscountDocument, baseOptions);
      }
export function useGetCourseMemberDiscountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseMemberDiscountQuery, GetCourseMemberDiscountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseMemberDiscountQuery, GetCourseMemberDiscountQueryVariables>(GetCourseMemberDiscountDocument, baseOptions);
        }
export type GetCourseMemberDiscountQueryHookResult = ReturnType<typeof useGetCourseMemberDiscountQuery>;
export type GetCourseMemberDiscountLazyQueryHookResult = ReturnType<typeof useGetCourseMemberDiscountLazyQuery>;
export type GetCourseMemberDiscountQueryResult = ApolloReactCommon.QueryResult<GetCourseMemberDiscountQuery, GetCourseMemberDiscountQueryVariables>;
export const GetCoursesByIdsDocument = gql`
    query getCoursesByIds($ids: [String!]!) {
  coursesByIds(ids: $ids) {
    id
    courseNumber
    prefixedCourseNumber
    bookingCount
    billedBookingCount
    freePlaces
    settledBookingCount
    courseType {
      id
      name
      description
      color
    }
    startDateTime
    endDateTime
    endDateTimeFirstCourseLesson
    location {
      id
      city
      name
    }
    venue {
      id
      name
    }
    annotation
    instructors {
      id
      firstname
      lastname
    }
    maxAttendees
    coursePrice {
      id
      grossPrice
      netPrice
      vat
      discount
      discountUnit
      isSpecial
    }
    paymentInterval
    allowMonthlyPayment
    monthlySchedule
    isActive
    showInWeb
    blockBookingOnline
  }
}
    `;

/**
 * __useGetCoursesByIdsQuery__
 *
 * To run a query within a React component, call `useGetCoursesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCoursesByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoursesByIdsQuery, GetCoursesByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoursesByIdsQuery, GetCoursesByIdsQueryVariables>(GetCoursesByIdsDocument, baseOptions);
      }
export function useGetCoursesByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoursesByIdsQuery, GetCoursesByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoursesByIdsQuery, GetCoursesByIdsQueryVariables>(GetCoursesByIdsDocument, baseOptions);
        }
export type GetCoursesByIdsQueryHookResult = ReturnType<typeof useGetCoursesByIdsQuery>;
export type GetCoursesByIdsLazyQueryHookResult = ReturnType<typeof useGetCoursesByIdsLazyQuery>;
export type GetCoursesByIdsQueryResult = ApolloReactCommon.QueryResult<GetCoursesByIdsQuery, GetCoursesByIdsQueryVariables>;
export const GetCoursesByIdsMinimalDocument = gql`
    query getCoursesByIdsMinimal($ids: [String!]!) {
  coursesByIds(ids: $ids) {
    id
    prefixedCourseNumber
    courseType {
      id
      name
      color
    }
    startDateTime
    endDateTime
    endDateTimeFirstCourseLesson
  }
}
    `;

/**
 * __useGetCoursesByIdsMinimalQuery__
 *
 * To run a query within a React component, call `useGetCoursesByIdsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByIdsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByIdsMinimalQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCoursesByIdsMinimalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoursesByIdsMinimalQuery, GetCoursesByIdsMinimalQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoursesByIdsMinimalQuery, GetCoursesByIdsMinimalQueryVariables>(GetCoursesByIdsMinimalDocument, baseOptions);
      }
export function useGetCoursesByIdsMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoursesByIdsMinimalQuery, GetCoursesByIdsMinimalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoursesByIdsMinimalQuery, GetCoursesByIdsMinimalQueryVariables>(GetCoursesByIdsMinimalDocument, baseOptions);
        }
export type GetCoursesByIdsMinimalQueryHookResult = ReturnType<typeof useGetCoursesByIdsMinimalQuery>;
export type GetCoursesByIdsMinimalLazyQueryHookResult = ReturnType<typeof useGetCoursesByIdsMinimalLazyQuery>;
export type GetCoursesByIdsMinimalQueryResult = ApolloReactCommon.QueryResult<GetCoursesByIdsMinimalQuery, GetCoursesByIdsMinimalQueryVariables>;
export const UpdateMultipleCoursesShowInWebDocument = gql`
    mutation updateMultipleCoursesShowInWeb($courseIds: [ID!]!, $showInWeb: Boolean!) {
  updateMultipleCoursesShowInWeb(courseIds: $courseIds, showInWeb: $showInWeb) {
    id
    showInWeb
  }
}
    `;
export type UpdateMultipleCoursesShowInWebMutationFn = ApolloReactCommon.MutationFunction<UpdateMultipleCoursesShowInWebMutation, UpdateMultipleCoursesShowInWebMutationVariables>;

/**
 * __useUpdateMultipleCoursesShowInWebMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleCoursesShowInWebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleCoursesShowInWebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleCoursesShowInWebMutation, { data, loading, error }] = useUpdateMultipleCoursesShowInWebMutation({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *      showInWeb: // value for 'showInWeb'
 *   },
 * });
 */
export function useUpdateMultipleCoursesShowInWebMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMultipleCoursesShowInWebMutation, UpdateMultipleCoursesShowInWebMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMultipleCoursesShowInWebMutation, UpdateMultipleCoursesShowInWebMutationVariables>(UpdateMultipleCoursesShowInWebDocument, baseOptions);
      }
export type UpdateMultipleCoursesShowInWebMutationHookResult = ReturnType<typeof useUpdateMultipleCoursesShowInWebMutation>;
export type UpdateMultipleCoursesShowInWebMutationResult = ApolloReactCommon.MutationResult<UpdateMultipleCoursesShowInWebMutation>;
export type UpdateMultipleCoursesShowInWebMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMultipleCoursesShowInWebMutation, UpdateMultipleCoursesShowInWebMutationVariables>;
export const UpdateCourseBlockBookingOnlineDocument = gql`
    mutation updateCourseBlockBookingOnline($courseId: String!, $blockBookingOnline: Boolean!) {
  updateCourseBlockBookingOnline(courseId: $courseId, blockBookingOnline: $blockBookingOnline) {
    id
    blockBookingOnline
    prefixedCourseNumber
  }
}
    `;
export type UpdateCourseBlockBookingOnlineMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseBlockBookingOnlineMutation, UpdateCourseBlockBookingOnlineMutationVariables>;

/**
 * __useUpdateCourseBlockBookingOnlineMutation__
 *
 * To run a mutation, you first call `useUpdateCourseBlockBookingOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseBlockBookingOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseBlockBookingOnlineMutation, { data, loading, error }] = useUpdateCourseBlockBookingOnlineMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      blockBookingOnline: // value for 'blockBookingOnline'
 *   },
 * });
 */
export function useUpdateCourseBlockBookingOnlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseBlockBookingOnlineMutation, UpdateCourseBlockBookingOnlineMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseBlockBookingOnlineMutation, UpdateCourseBlockBookingOnlineMutationVariables>(UpdateCourseBlockBookingOnlineDocument, baseOptions);
      }
export type UpdateCourseBlockBookingOnlineMutationHookResult = ReturnType<typeof useUpdateCourseBlockBookingOnlineMutation>;
export type UpdateCourseBlockBookingOnlineMutationResult = ApolloReactCommon.MutationResult<UpdateCourseBlockBookingOnlineMutation>;
export type UpdateCourseBlockBookingOnlineMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseBlockBookingOnlineMutation, UpdateCourseBlockBookingOnlineMutationVariables>;
export const DeactivateCoursesAllowLessonBookingDocument = gql`
    mutation deactivateCoursesAllowLessonBooking($subscriptionId: String!) {
  deactivateCoursesAllowLessonBooking(subscriptionId: $subscriptionId) {
    id
    allowLessonBooking
  }
}
    `;
export type DeactivateCoursesAllowLessonBookingMutationFn = ApolloReactCommon.MutationFunction<DeactivateCoursesAllowLessonBookingMutation, DeactivateCoursesAllowLessonBookingMutationVariables>;

/**
 * __useDeactivateCoursesAllowLessonBookingMutation__
 *
 * To run a mutation, you first call `useDeactivateCoursesAllowLessonBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCoursesAllowLessonBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCoursesAllowLessonBookingMutation, { data, loading, error }] = useDeactivateCoursesAllowLessonBookingMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useDeactivateCoursesAllowLessonBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateCoursesAllowLessonBookingMutation, DeactivateCoursesAllowLessonBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<DeactivateCoursesAllowLessonBookingMutation, DeactivateCoursesAllowLessonBookingMutationVariables>(DeactivateCoursesAllowLessonBookingDocument, baseOptions);
      }
export type DeactivateCoursesAllowLessonBookingMutationHookResult = ReturnType<typeof useDeactivateCoursesAllowLessonBookingMutation>;
export type DeactivateCoursesAllowLessonBookingMutationResult = ApolloReactCommon.MutationResult<DeactivateCoursesAllowLessonBookingMutation>;
export type DeactivateCoursesAllowLessonBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateCoursesAllowLessonBookingMutation, DeactivateCoursesAllowLessonBookingMutationVariables>;
export const UpdateCourseArchivedDocument = gql`
    mutation updateCourseArchived($courseId: String!, $isArchived: Boolean!) {
  updateCourseArchived(courseId: $courseId, isArchived: $isArchived) {
    id
    isArchived
  }
}
    `;
export type UpdateCourseArchivedMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseArchivedMutation, UpdateCourseArchivedMutationVariables>;

/**
 * __useUpdateCourseArchivedMutation__
 *
 * To run a mutation, you first call `useUpdateCourseArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseArchivedMutation, { data, loading, error }] = useUpdateCourseArchivedMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useUpdateCourseArchivedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseArchivedMutation, UpdateCourseArchivedMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseArchivedMutation, UpdateCourseArchivedMutationVariables>(UpdateCourseArchivedDocument, baseOptions);
      }
export type UpdateCourseArchivedMutationHookResult = ReturnType<typeof useUpdateCourseArchivedMutation>;
export type UpdateCourseArchivedMutationResult = ApolloReactCommon.MutationResult<UpdateCourseArchivedMutation>;
export type UpdateCourseArchivedMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseArchivedMutation, UpdateCourseArchivedMutationVariables>;
export const UpdateMultipleCoursesArchivedDocument = gql`
    mutation updateMultipleCoursesArchived($courseIds: [ID!]!, $isArchived: Boolean!) {
  updateMultipleCoursesArchived(courseIds: $courseIds, isArchived: $isArchived) {
    id
    isArchived
  }
}
    `;
export type UpdateMultipleCoursesArchivedMutationFn = ApolloReactCommon.MutationFunction<UpdateMultipleCoursesArchivedMutation, UpdateMultipleCoursesArchivedMutationVariables>;

/**
 * __useUpdateMultipleCoursesArchivedMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleCoursesArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleCoursesArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleCoursesArchivedMutation, { data, loading, error }] = useUpdateMultipleCoursesArchivedMutation({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useUpdateMultipleCoursesArchivedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMultipleCoursesArchivedMutation, UpdateMultipleCoursesArchivedMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMultipleCoursesArchivedMutation, UpdateMultipleCoursesArchivedMutationVariables>(UpdateMultipleCoursesArchivedDocument, baseOptions);
      }
export type UpdateMultipleCoursesArchivedMutationHookResult = ReturnType<typeof useUpdateMultipleCoursesArchivedMutation>;
export type UpdateMultipleCoursesArchivedMutationResult = ApolloReactCommon.MutationResult<UpdateMultipleCoursesArchivedMutation>;
export type UpdateMultipleCoursesArchivedMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMultipleCoursesArchivedMutation, UpdateMultipleCoursesArchivedMutationVariables>;
export const GetCourseDetailsByIdDocument = gql`
    query GetCourseDetailsById($id: ID!) {
  courseDetailsById(id: $id) {
    courseId
    course {
      id
      prefixedCourseNumber
      additionalShortInfo
      startDateTime
      paymentInterval
      waitListCount
      maxAttendees
      bookingCount
      placeReservationsCount
      canceledBookingsCount
      lessonCount
      allowLessonBooking
      allowMolliePayment
      mollieOptional
      freePlaces
      startDateTime
      endDateTime
      endDateTimeFirstCourseLesson
      location {
        id
        city
        name
      }
      coursePrice {
        id
        grossPrice
      }
      courseType {
        id
        name
      }
      lessons {
        id
        startDateTime
        endDateTime
        courseLessonBookingCount
        freePlaces
        indexOfLessonInCourse
      }
      instructors {
        id
        firstname
        lastname
        email
      }
    }
    placeReservations {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      waitListCount
      additionalInfo
      bookedLessonCount
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      isSettled
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          nonDisclosureNotice
          credit
        }
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
        bookingId
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        locationId
        indexOfLessonInCourse
      }
      scheduledPayments {
        paymentProvider
        mollieMethod
      }
    }
    waitlistBookings {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      waitListCount
      additionalInfo
      bookedLessonCount
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      isSettled
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          nonDisclosureNotice
          credit
        }
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
        bookingId
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        locationId
        indexOfLessonInCourse
      }
      scheduledPayments {
        paymentProvider
        mollieMethod
      }
    }
    unbilledBookings {
      lessonSelectionMode
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      waitListCount
      additionalInfo
      bookedLessonCount
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      isSettled
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          nonDisclosureNotice
          credit
        }
        badgeXAttendee {
          id
          createDate
          dateOfAchivement
          badge {
            id
            name
            abbreviation
            color
          }
        }
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
        bookingId
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        locationId
        indexOfLessonInCourse
      }
      scheduledPayments {
        paymentProvider
        mollieMethod
      }
      attendee {
        badgeXAttendee {
          id
          createDate
          dateOfAchivement
          badge {
            id
            name
            abbreviation
            color
          }
        }
      }
    }
    billedBookings {
      lessonSelectionMode
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      waitListCount
      additionalInfo
      bookedLessonCount
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      isSettled
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          nonDisclosureNotice
          credit
        }
        badgeXAttendee {
          id
          createDate
          dateOfAchivement
          badge {
            id
            name
            abbreviation
            color
          }
        }
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
        bookingId
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        locationId
        indexOfLessonInCourse
      }
      scheduledPayments {
        paymentProvider
        mollieMethod
      }
      attendee {
        badgeXAttendee {
          id
          createDate
          dateOfAchivement
          badge {
            id
            name
            abbreviation
            color
          }
        }
      }
    }
    canceledBookings {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      waitListCount
      additionalInfo
      bookedLessonCount
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      isSettled
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          street
          houseNumber
          postCode
          city
          phoneNumber
          mobileNumber
          email
          nonDisclosureNotice
          credit
        }
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
        bookingId
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        locationId
        indexOfLessonInCourse
      }
      scheduledPayments {
        paymentProvider
        mollieMethod
      }
    }
  }
}
    `;

/**
 * __useGetCourseDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseDetailsByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseDetailsByIdQuery, GetCourseDetailsByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseDetailsByIdQuery, GetCourseDetailsByIdQueryVariables>(GetCourseDetailsByIdDocument, baseOptions);
      }
export function useGetCourseDetailsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseDetailsByIdQuery, GetCourseDetailsByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseDetailsByIdQuery, GetCourseDetailsByIdQueryVariables>(GetCourseDetailsByIdDocument, baseOptions);
        }
export type GetCourseDetailsByIdQueryHookResult = ReturnType<typeof useGetCourseDetailsByIdQuery>;
export type GetCourseDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetCourseDetailsByIdLazyQuery>;
export type GetCourseDetailsByIdQueryResult = ApolloReactCommon.QueryResult<GetCourseDetailsByIdQuery, GetCourseDetailsByIdQueryVariables>;
export const GetInstallmentPlanDocument = gql`
    query GetInstallmentPlan($newInstallmentPlanInput: NewInstallmentPlanInput!) {
  getInstallmentPlanPreview(newInstallmentPlanInput: $newInstallmentPlanInput)
}
    `;

/**
 * __useGetInstallmentPlanQuery__
 *
 * To run a query within a React component, call `useGetInstallmentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentPlanQuery({
 *   variables: {
 *      newInstallmentPlanInput: // value for 'newInstallmentPlanInput'
 *   },
 * });
 */
export function useGetInstallmentPlanQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInstallmentPlanQuery, GetInstallmentPlanQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInstallmentPlanQuery, GetInstallmentPlanQueryVariables>(GetInstallmentPlanDocument, baseOptions);
      }
export function useGetInstallmentPlanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstallmentPlanQuery, GetInstallmentPlanQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInstallmentPlanQuery, GetInstallmentPlanQueryVariables>(GetInstallmentPlanDocument, baseOptions);
        }
export type GetInstallmentPlanQueryHookResult = ReturnType<typeof useGetInstallmentPlanQuery>;
export type GetInstallmentPlanLazyQueryHookResult = ReturnType<typeof useGetInstallmentPlanLazyQuery>;
export type GetInstallmentPlanQueryResult = ApolloReactCommon.QueryResult<GetInstallmentPlanQuery, GetInstallmentPlanQueryVariables>;
export const GetInstallmentRatesByCourseIdDocument = gql`
    query GetInstallmentRatesByCourseId($courseId: ID!) {
  installmentRatesByCourseId(courseId: $courseId) {
    id
    courseId
    installmentAmount
    installmentDue
  }
}
    `;

/**
 * __useGetInstallmentRatesByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetInstallmentRatesByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentRatesByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentRatesByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetInstallmentRatesByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInstallmentRatesByCourseIdQuery, GetInstallmentRatesByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInstallmentRatesByCourseIdQuery, GetInstallmentRatesByCourseIdQueryVariables>(GetInstallmentRatesByCourseIdDocument, baseOptions);
      }
export function useGetInstallmentRatesByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstallmentRatesByCourseIdQuery, GetInstallmentRatesByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInstallmentRatesByCourseIdQuery, GetInstallmentRatesByCourseIdQueryVariables>(GetInstallmentRatesByCourseIdDocument, baseOptions);
        }
export type GetInstallmentRatesByCourseIdQueryHookResult = ReturnType<typeof useGetInstallmentRatesByCourseIdQuery>;
export type GetInstallmentRatesByCourseIdLazyQueryHookResult = ReturnType<typeof useGetInstallmentRatesByCourseIdLazyQuery>;
export type GetInstallmentRatesByCourseIdQueryResult = ApolloReactCommon.QueryResult<GetInstallmentRatesByCourseIdQuery, GetInstallmentRatesByCourseIdQueryVariables>;
export const ErasurePreviewDocument = gql`
    mutation ErasurePreview($bookerId: ID!, $includeLinkedBookers: Boolean) {
  erasurePreview(bookerId: $bookerId, includeLinkedBookers: $includeLinkedBookers) {
    dryRun
    bookerIds
    customerNumbers
    attendeeCount
    bookingCount
    deletedWaitlistBookingCount
    invoiceNumbers
    warnings {
      code
      message
      count
      amount
      blocking
    }
    linkedBookers {
      id
      customerNumberPrefix
      customerNumber
      firstname
      lastname
    }
    hasLoginAccount
    retentionEndsAt
  }
}
    `;
export type ErasurePreviewMutationFn = ApolloReactCommon.MutationFunction<ErasurePreviewMutation, ErasurePreviewMutationVariables>;

/**
 * __useErasurePreviewMutation__
 *
 * To run a mutation, you first call `useErasurePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErasurePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erasurePreviewMutation, { data, loading, error }] = useErasurePreviewMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      includeLinkedBookers: // value for 'includeLinkedBookers'
 *   },
 * });
 */
export function useErasurePreviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ErasurePreviewMutation, ErasurePreviewMutationVariables>) {
        return ApolloReactHooks.useMutation<ErasurePreviewMutation, ErasurePreviewMutationVariables>(ErasurePreviewDocument, baseOptions);
      }
export type ErasurePreviewMutationHookResult = ReturnType<typeof useErasurePreviewMutation>;
export type ErasurePreviewMutationResult = ApolloReactCommon.MutationResult<ErasurePreviewMutation>;
export type ErasurePreviewMutationOptions = ApolloReactCommon.BaseMutationOptions<ErasurePreviewMutation, ErasurePreviewMutationVariables>;
export const EraseBookerDataDocument = gql`
    mutation EraseBookerData($bookerId: ID!, $includeLinkedBookers: Boolean) {
  eraseBookerData(bookerId: $bookerId, includeLinkedBookers: $includeLinkedBookers) {
    dryRun
    bookerIds
    customerNumbers
    attendeeCount
    bookingCount
    deletedWaitlistBookingCount
    invoiceNumbers
    warnings {
      code
      message
      count
      amount
      blocking
    }
    linkedBookers {
      id
      customerNumberPrefix
      customerNumber
      firstname
      lastname
    }
    hasLoginAccount
    fusionAuthAccountDeleted
    retentionEndsAt
    erasedAt
  }
}
    `;
export type EraseBookerDataMutationFn = ApolloReactCommon.MutationFunction<EraseBookerDataMutation, EraseBookerDataMutationVariables>;

/**
 * __useEraseBookerDataMutation__
 *
 * To run a mutation, you first call `useEraseBookerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEraseBookerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eraseBookerDataMutation, { data, loading, error }] = useEraseBookerDataMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      includeLinkedBookers: // value for 'includeLinkedBookers'
 *   },
 * });
 */
export function useEraseBookerDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EraseBookerDataMutation, EraseBookerDataMutationVariables>) {
        return ApolloReactHooks.useMutation<EraseBookerDataMutation, EraseBookerDataMutationVariables>(EraseBookerDataDocument, baseOptions);
      }
export type EraseBookerDataMutationHookResult = ReturnType<typeof useEraseBookerDataMutation>;
export type EraseBookerDataMutationResult = ApolloReactCommon.MutationResult<EraseBookerDataMutation>;
export type EraseBookerDataMutationOptions = ApolloReactCommon.BaseMutationOptions<EraseBookerDataMutation, EraseBookerDataMutationVariables>;
export const AutoMergeDuplicatesDryRunDocument = gql`
    mutation AutoMergeDuplicatesDryRun($input: AutoMergeDryRunInput!) {
  autoMergeDuplicatesDryRun(input: $input) {
    totalPairs
    totalBookersAffected
    pairs {
      winnerId
      winnerName
      winnerEmail
      loserId
      loserName
      loserEmail
      matchScore
      scoreBreakdown {
        exactEmail
        exactName
        fuzzyName
        samePhone
        sameAddress
        sameAttendee
        sameAttendeeMultiple
        differentEmail
        differentName
        differentPhone
        differentAddress
        missingName
        total
      }
    }
  }
}
    `;
export type AutoMergeDuplicatesDryRunMutationFn = ApolloReactCommon.MutationFunction<AutoMergeDuplicatesDryRunMutation, AutoMergeDuplicatesDryRunMutationVariables>;

/**
 * __useAutoMergeDuplicatesDryRunMutation__
 *
 * To run a mutation, you first call `useAutoMergeDuplicatesDryRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoMergeDuplicatesDryRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoMergeDuplicatesDryRunMutation, { data, loading, error }] = useAutoMergeDuplicatesDryRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutoMergeDuplicatesDryRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AutoMergeDuplicatesDryRunMutation, AutoMergeDuplicatesDryRunMutationVariables>) {
        return ApolloReactHooks.useMutation<AutoMergeDuplicatesDryRunMutation, AutoMergeDuplicatesDryRunMutationVariables>(AutoMergeDuplicatesDryRunDocument, baseOptions);
      }
export type AutoMergeDuplicatesDryRunMutationHookResult = ReturnType<typeof useAutoMergeDuplicatesDryRunMutation>;
export type AutoMergeDuplicatesDryRunMutationResult = ApolloReactCommon.MutationResult<AutoMergeDuplicatesDryRunMutation>;
export type AutoMergeDuplicatesDryRunMutationOptions = ApolloReactCommon.BaseMutationOptions<AutoMergeDuplicatesDryRunMutation, AutoMergeDuplicatesDryRunMutationVariables>;
export const AutoMergeDuplicatesDocument = gql`
    mutation AutoMergeDuplicates($input: AutoMergeInput!) {
  autoMergeDuplicates(input: $input) {
    runId
    message
  }
}
    `;
export type AutoMergeDuplicatesMutationFn = ApolloReactCommon.MutationFunction<AutoMergeDuplicatesMutation, AutoMergeDuplicatesMutationVariables>;

/**
 * __useAutoMergeDuplicatesMutation__
 *
 * To run a mutation, you first call `useAutoMergeDuplicatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoMergeDuplicatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoMergeDuplicatesMutation, { data, loading, error }] = useAutoMergeDuplicatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutoMergeDuplicatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AutoMergeDuplicatesMutation, AutoMergeDuplicatesMutationVariables>) {
        return ApolloReactHooks.useMutation<AutoMergeDuplicatesMutation, AutoMergeDuplicatesMutationVariables>(AutoMergeDuplicatesDocument, baseOptions);
      }
export type AutoMergeDuplicatesMutationHookResult = ReturnType<typeof useAutoMergeDuplicatesMutation>;
export type AutoMergeDuplicatesMutationResult = ApolloReactCommon.MutationResult<AutoMergeDuplicatesMutation>;
export type AutoMergeDuplicatesMutationOptions = ApolloReactCommon.BaseMutationOptions<AutoMergeDuplicatesMutation, AutoMergeDuplicatesMutationVariables>;
export const GetAutoMergeStatusDocument = gql`
    query GetAutoMergeStatus {
  getAutoMergeStatus {
    status
    totalGroupsToMerge
    mergedSoFar
    failedMerges
    skippedMerges
    failures {
      winnerId
      loserId
      winnerName
      loserName
      error
    }
    startedAt
    completedAt
    durationMs
    confidenceThreshold
  }
}
    `;

/**
 * __useGetAutoMergeStatusQuery__
 *
 * To run a query within a React component, call `useGetAutoMergeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoMergeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoMergeStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoMergeStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAutoMergeStatusQuery, GetAutoMergeStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAutoMergeStatusQuery, GetAutoMergeStatusQueryVariables>(GetAutoMergeStatusDocument, baseOptions);
      }
export function useGetAutoMergeStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAutoMergeStatusQuery, GetAutoMergeStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAutoMergeStatusQuery, GetAutoMergeStatusQueryVariables>(GetAutoMergeStatusDocument, baseOptions);
        }
export type GetAutoMergeStatusQueryHookResult = ReturnType<typeof useGetAutoMergeStatusQuery>;
export type GetAutoMergeStatusLazyQueryHookResult = ReturnType<typeof useGetAutoMergeStatusLazyQuery>;
export type GetAutoMergeStatusQueryResult = ApolloReactCommon.QueryResult<GetAutoMergeStatusQuery, GetAutoMergeStatusQueryVariables>;
export const GetDuplicateMatchStatsDocument = gql`
    query GetDuplicateMatchStats {
  getDuplicateMatchStats {
    totalGroups
    affectedBookerCount
    autoMergeableGroups
  }
}
    `;

/**
 * __useGetDuplicateMatchStatsQuery__
 *
 * To run a query within a React component, call `useGetDuplicateMatchStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateMatchStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateMatchStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDuplicateMatchStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDuplicateMatchStatsQuery, GetDuplicateMatchStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDuplicateMatchStatsQuery, GetDuplicateMatchStatsQueryVariables>(GetDuplicateMatchStatsDocument, baseOptions);
      }
export function useGetDuplicateMatchStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDuplicateMatchStatsQuery, GetDuplicateMatchStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDuplicateMatchStatsQuery, GetDuplicateMatchStatsQueryVariables>(GetDuplicateMatchStatsDocument, baseOptions);
        }
export type GetDuplicateMatchStatsQueryHookResult = ReturnType<typeof useGetDuplicateMatchStatsQuery>;
export type GetDuplicateMatchStatsLazyQueryHookResult = ReturnType<typeof useGetDuplicateMatchStatsLazyQuery>;
export type GetDuplicateMatchStatsQueryResult = ApolloReactCommon.QueryResult<GetDuplicateMatchStatsQuery, GetDuplicateMatchStatsQueryVariables>;
export const GetAttendeeDocument = gql`
    query GetAttendee($id: String!) {
  attendee(id: $id) {
    id
    firstname
    lastname
    birthday
    gender
    booker {
      id
      firstname
      lastname
      gender
    }
  }
}
    `;

/**
 * __useGetAttendeeQuery__
 *
 * To run a query within a React component, call `useGetAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttendeeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeQuery, GetAttendeeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeQuery, GetAttendeeQueryVariables>(GetAttendeeDocument, baseOptions);
      }
export function useGetAttendeeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeQuery, GetAttendeeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeQuery, GetAttendeeQueryVariables>(GetAttendeeDocument, baseOptions);
        }
export type GetAttendeeQueryHookResult = ReturnType<typeof useGetAttendeeQuery>;
export type GetAttendeeLazyQueryHookResult = ReturnType<typeof useGetAttendeeLazyQuery>;
export type GetAttendeeQueryResult = ApolloReactCommon.QueryResult<GetAttendeeQuery, GetAttendeeQueryVariables>;
export const GetAttendeesByIdsDocument = gql`
    query GetAttendeesByIds($attendeeIds: [ID!]!) {
  attendeesByIds(attendeeIds: $attendeeIds) {
    id
    firstname
    lastname
    booker {
      id
      firstname
      lastname
      email
    }
  }
}
    `;

/**
 * __useGetAttendeesByIdsQuery__
 *
 * To run a query within a React component, call `useGetAttendeesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeesByIdsQuery({
 *   variables: {
 *      attendeeIds: // value for 'attendeeIds'
 *   },
 * });
 */
export function useGetAttendeesByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeesByIdsQuery, GetAttendeesByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeesByIdsQuery, GetAttendeesByIdsQueryVariables>(GetAttendeesByIdsDocument, baseOptions);
      }
export function useGetAttendeesByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeesByIdsQuery, GetAttendeesByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeesByIdsQuery, GetAttendeesByIdsQueryVariables>(GetAttendeesByIdsDocument, baseOptions);
        }
export type GetAttendeesByIdsQueryHookResult = ReturnType<typeof useGetAttendeesByIdsQuery>;
export type GetAttendeesByIdsLazyQueryHookResult = ReturnType<typeof useGetAttendeesByIdsLazyQuery>;
export type GetAttendeesByIdsQueryResult = ApolloReactCommon.QueryResult<GetAttendeesByIdsQuery, GetAttendeesByIdsQueryVariables>;
export const AttendeeOverviewGetAttendeesMinimalDocument = gql`
    query AttendeeOverviewGetAttendeesMinimal($options: ArrayDataOptions) {
  attendees(options: $options) {
    existsMore
    total
    items {
      id
      erasedAt
      customerNumberPrefix
      customerNumber
      firstname
      lastname
      birthday
      gender
      deletable
      member
      addition
      annotation
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
      booker {
        id
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        street
        houseNumber
        postCode
        city
        phoneNumber
        mobileNumber
        email
        initialContact
        addition
        annotation
        credit
        nonDisclosureNotice
        hasBillingAddress
        billingCompanyName
        billingFirstname
        billingLastname
        billingAddition
        billingStreet
        billingPostCode
        billingCity
        paymentMethods {
          id
          cash
          esr
          creditCardAccountholder
          creditcardNumber
          expirationDate
          validFrom
          cvc
          paypalAccountholder
          email
          iban
          bank
          bic
          sepaAccountholder
          bankTransfer
          onlinePayment
        }
        credit
      }
      defaultPaymentMethod {
        id
        type
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
      }
      bookingsKo9 {
        id
        courseNumber
        courseName
        firstCourseLesson
      }
    }
  }
}
    `;

/**
 * __useAttendeeOverviewGetAttendeesMinimalQuery__
 *
 * To run a query within a React component, call `useAttendeeOverviewGetAttendeesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendeeOverviewGetAttendeesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendeeOverviewGetAttendeesMinimalQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useAttendeeOverviewGetAttendeesMinimalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttendeeOverviewGetAttendeesMinimalQuery, AttendeeOverviewGetAttendeesMinimalQueryVariables>) {
        return ApolloReactHooks.useQuery<AttendeeOverviewGetAttendeesMinimalQuery, AttendeeOverviewGetAttendeesMinimalQueryVariables>(AttendeeOverviewGetAttendeesMinimalDocument, baseOptions);
      }
export function useAttendeeOverviewGetAttendeesMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttendeeOverviewGetAttendeesMinimalQuery, AttendeeOverviewGetAttendeesMinimalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AttendeeOverviewGetAttendeesMinimalQuery, AttendeeOverviewGetAttendeesMinimalQueryVariables>(AttendeeOverviewGetAttendeesMinimalDocument, baseOptions);
        }
export type AttendeeOverviewGetAttendeesMinimalQueryHookResult = ReturnType<typeof useAttendeeOverviewGetAttendeesMinimalQuery>;
export type AttendeeOverviewGetAttendeesMinimalLazyQueryHookResult = ReturnType<typeof useAttendeeOverviewGetAttendeesMinimalLazyQuery>;
export type AttendeeOverviewGetAttendeesMinimalQueryResult = ApolloReactCommon.QueryResult<AttendeeOverviewGetAttendeesMinimalQuery, AttendeeOverviewGetAttendeesMinimalQueryVariables>;
export const CheckIfIsBookedIntoCourseDocument = gql`
    query CheckIfIsBookedIntoCourse($courseId: ID!, $attendeeId: ID!) {
  checkIfIsBookedIntoCourse(courseId: $courseId, attendeeId: $attendeeId)
}
    `;

/**
 * __useCheckIfIsBookedIntoCourseQuery__
 *
 * To run a query within a React component, call `useCheckIfIsBookedIntoCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfIsBookedIntoCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfIsBookedIntoCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useCheckIfIsBookedIntoCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckIfIsBookedIntoCourseQuery, CheckIfIsBookedIntoCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckIfIsBookedIntoCourseQuery, CheckIfIsBookedIntoCourseQueryVariables>(CheckIfIsBookedIntoCourseDocument, baseOptions);
      }
export function useCheckIfIsBookedIntoCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckIfIsBookedIntoCourseQuery, CheckIfIsBookedIntoCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckIfIsBookedIntoCourseQuery, CheckIfIsBookedIntoCourseQueryVariables>(CheckIfIsBookedIntoCourseDocument, baseOptions);
        }
export type CheckIfIsBookedIntoCourseQueryHookResult = ReturnType<typeof useCheckIfIsBookedIntoCourseQuery>;
export type CheckIfIsBookedIntoCourseLazyQueryHookResult = ReturnType<typeof useCheckIfIsBookedIntoCourseLazyQuery>;
export type CheckIfIsBookedIntoCourseQueryResult = ApolloReactCommon.QueryResult<CheckIfIsBookedIntoCourseQuery, CheckIfIsBookedIntoCourseQueryVariables>;
export const GetBookedAttendeesByCourseIdDocument = gql`
    query GetBookedAttendeesByCourseId($courseId: ID!) {
  bookedAttendeesByCourseId(courseId: $courseId) {
    id
  }
}
    `;

/**
 * __useGetBookedAttendeesByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetBookedAttendeesByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookedAttendeesByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookedAttendeesByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetBookedAttendeesByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookedAttendeesByCourseIdQuery, GetBookedAttendeesByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookedAttendeesByCourseIdQuery, GetBookedAttendeesByCourseIdQueryVariables>(GetBookedAttendeesByCourseIdDocument, baseOptions);
      }
export function useGetBookedAttendeesByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookedAttendeesByCourseIdQuery, GetBookedAttendeesByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookedAttendeesByCourseIdQuery, GetBookedAttendeesByCourseIdQueryVariables>(GetBookedAttendeesByCourseIdDocument, baseOptions);
        }
export type GetBookedAttendeesByCourseIdQueryHookResult = ReturnType<typeof useGetBookedAttendeesByCourseIdQuery>;
export type GetBookedAttendeesByCourseIdLazyQueryHookResult = ReturnType<typeof useGetBookedAttendeesByCourseIdLazyQuery>;
export type GetBookedAttendeesByCourseIdQueryResult = ApolloReactCommon.QueryResult<GetBookedAttendeesByCourseIdQuery, GetBookedAttendeesByCourseIdQueryVariables>;
export const GetAttendeeVariableForTemplateDocument = gql`
    query GetAttendeeVariableForTemplate($id: String!) {
  attendee(id: $id) {
    id
    firstname
    lastname
    birthday
    booker {
      id
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useGetAttendeeVariableForTemplateQuery__
 *
 * To run a query within a React component, call `useGetAttendeeVariableForTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeVariableForTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeVariableForTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttendeeVariableForTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeVariableForTemplateQuery, GetAttendeeVariableForTemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeVariableForTemplateQuery, GetAttendeeVariableForTemplateQueryVariables>(GetAttendeeVariableForTemplateDocument, baseOptions);
      }
export function useGetAttendeeVariableForTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeVariableForTemplateQuery, GetAttendeeVariableForTemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeVariableForTemplateQuery, GetAttendeeVariableForTemplateQueryVariables>(GetAttendeeVariableForTemplateDocument, baseOptions);
        }
export type GetAttendeeVariableForTemplateQueryHookResult = ReturnType<typeof useGetAttendeeVariableForTemplateQuery>;
export type GetAttendeeVariableForTemplateLazyQueryHookResult = ReturnType<typeof useGetAttendeeVariableForTemplateLazyQuery>;
export type GetAttendeeVariableForTemplateQueryResult = ApolloReactCommon.QueryResult<GetAttendeeVariableForTemplateQuery, GetAttendeeVariableForTemplateQueryVariables>;
export const GetAttendeeDetailsDocument = gql`
    query GetAttendeeDetails($id: String!) {
  attendee(id: $id) {
    id
    erasedAt
    firstname
    lastname
    birthday
    gender
    member
    defaultPaymentMethod {
      id
      type
      cash
      esr
      iban
      bank
      bic
      sepaAccountholder
    }
    booker {
      id
      firstname
      lastname
      gender
    }
    customerNumberPrefix
    customerNumber
  }
}
    `;

/**
 * __useGetAttendeeDetailsQuery__
 *
 * To run a query within a React component, call `useGetAttendeeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttendeeDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeDetailsQuery, GetAttendeeDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeDetailsQuery, GetAttendeeDetailsQueryVariables>(GetAttendeeDetailsDocument, baseOptions);
      }
export function useGetAttendeeDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeDetailsQuery, GetAttendeeDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeDetailsQuery, GetAttendeeDetailsQueryVariables>(GetAttendeeDetailsDocument, baseOptions);
        }
export type GetAttendeeDetailsQueryHookResult = ReturnType<typeof useGetAttendeeDetailsQuery>;
export type GetAttendeeDetailsLazyQueryHookResult = ReturnType<typeof useGetAttendeeDetailsLazyQuery>;
export type GetAttendeeDetailsQueryResult = ApolloReactCommon.QueryResult<GetAttendeeDetailsQuery, GetAttendeeDetailsQueryVariables>;
export const GetAttendeeDetailsByIdDocument = gql`
    query GetAttendeeDetailsById($id: String!) {
  attendee(id: $id) {
    id
    firstname
    lastname
    birthday
    gender
    member
    defaultPaymentMethod {
      id
      type
      cash
      esr
      iban
      bank
      bic
      sepaAccountholder
    }
    booker {
      id
      firstname
      lastname
      gender
    }
    customerNumberPrefix
    customerNumber
  }
}
    `;

/**
 * __useGetAttendeeDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetAttendeeDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttendeeDetailsByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeDetailsByIdQuery, GetAttendeeDetailsByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeDetailsByIdQuery, GetAttendeeDetailsByIdQueryVariables>(GetAttendeeDetailsByIdDocument, baseOptions);
      }
export function useGetAttendeeDetailsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeDetailsByIdQuery, GetAttendeeDetailsByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeDetailsByIdQuery, GetAttendeeDetailsByIdQueryVariables>(GetAttendeeDetailsByIdDocument, baseOptions);
        }
export type GetAttendeeDetailsByIdQueryHookResult = ReturnType<typeof useGetAttendeeDetailsByIdQuery>;
export type GetAttendeeDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetAttendeeDetailsByIdLazyQuery>;
export type GetAttendeeDetailsByIdQueryResult = ApolloReactCommon.QueryResult<GetAttendeeDetailsByIdQuery, GetAttendeeDetailsByIdQueryVariables>;
export const TransferAttendeeToBookerDocument = gql`
    mutation TransferAttendeeToBooker($attendeeId: ID!, $newBookerId: ID!) {
  transferAttendeeToBooker(attendeeId: $attendeeId, newBookerId: $newBookerId) {
    id
    firstname
    lastname
    birthday
    customerNumberPrefix
    customerNumber
  }
}
    `;
export type TransferAttendeeToBookerMutationFn = ApolloReactCommon.MutationFunction<TransferAttendeeToBookerMutation, TransferAttendeeToBookerMutationVariables>;

/**
 * __useTransferAttendeeToBookerMutation__
 *
 * To run a mutation, you first call `useTransferAttendeeToBookerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferAttendeeToBookerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferAttendeeToBookerMutation, { data, loading, error }] = useTransferAttendeeToBookerMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      newBookerId: // value for 'newBookerId'
 *   },
 * });
 */
export function useTransferAttendeeToBookerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferAttendeeToBookerMutation, TransferAttendeeToBookerMutationVariables>) {
        return ApolloReactHooks.useMutation<TransferAttendeeToBookerMutation, TransferAttendeeToBookerMutationVariables>(TransferAttendeeToBookerDocument, baseOptions);
      }
export type TransferAttendeeToBookerMutationHookResult = ReturnType<typeof useTransferAttendeeToBookerMutation>;
export type TransferAttendeeToBookerMutationResult = ApolloReactCommon.MutationResult<TransferAttendeeToBookerMutation>;
export type TransferAttendeeToBookerMutationOptions = ApolloReactCommon.BaseMutationOptions<TransferAttendeeToBookerMutation, TransferAttendeeToBookerMutationVariables>;
export const LinkAttendeeToBookerDocument = gql`
    mutation LinkAttendeeToBooker($attendeeId: ID!, $birthday: DateTime) {
  linkAttendeeToBooker(attendeeId: $attendeeId, birthday: $birthday) {
    id
    customerId
    birthday
    customerNumberPrefix
    customerNumber
  }
}
    `;
export type LinkAttendeeToBookerMutationFn = ApolloReactCommon.MutationFunction<LinkAttendeeToBookerMutation, LinkAttendeeToBookerMutationVariables>;

/**
 * __useLinkAttendeeToBookerMutation__
 *
 * To run a mutation, you first call `useLinkAttendeeToBookerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAttendeeToBookerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAttendeeToBookerMutation, { data, loading, error }] = useLinkAttendeeToBookerMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useLinkAttendeeToBookerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkAttendeeToBookerMutation, LinkAttendeeToBookerMutationVariables>) {
        return ApolloReactHooks.useMutation<LinkAttendeeToBookerMutation, LinkAttendeeToBookerMutationVariables>(LinkAttendeeToBookerDocument, baseOptions);
      }
export type LinkAttendeeToBookerMutationHookResult = ReturnType<typeof useLinkAttendeeToBookerMutation>;
export type LinkAttendeeToBookerMutationResult = ApolloReactCommon.MutationResult<LinkAttendeeToBookerMutation>;
export type LinkAttendeeToBookerMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkAttendeeToBookerMutation, LinkAttendeeToBookerMutationVariables>;
export const GetAttendeeMemberStatusDocument = gql`
    query GetAttendeeMemberStatus($id: String!) {
  attendee(id: $id) {
    id
    member
  }
}
    `;

/**
 * __useGetAttendeeMemberStatusQuery__
 *
 * To run a query within a React component, call `useGetAttendeeMemberStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeMemberStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeMemberStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttendeeMemberStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeMemberStatusQuery, GetAttendeeMemberStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeMemberStatusQuery, GetAttendeeMemberStatusQueryVariables>(GetAttendeeMemberStatusDocument, baseOptions);
      }
export function useGetAttendeeMemberStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeMemberStatusQuery, GetAttendeeMemberStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeMemberStatusQuery, GetAttendeeMemberStatusQueryVariables>(GetAttendeeMemberStatusDocument, baseOptions);
        }
export type GetAttendeeMemberStatusQueryHookResult = ReturnType<typeof useGetAttendeeMemberStatusQuery>;
export type GetAttendeeMemberStatusLazyQueryHookResult = ReturnType<typeof useGetAttendeeMemberStatusLazyQuery>;
export type GetAttendeeMemberStatusQueryResult = ApolloReactCommon.QueryResult<GetAttendeeMemberStatusQuery, GetAttendeeMemberStatusQueryVariables>;
export const ChangeAttendeeMemberStatusDocument = gql`
    mutation ChangeAttendeeMemberStatus($id: ID!, $member: Boolean!) {
  changeAttendeeMemberStatus(id: $id, member: $member) {
    id
    member
  }
}
    `;
export type ChangeAttendeeMemberStatusMutationFn = ApolloReactCommon.MutationFunction<ChangeAttendeeMemberStatusMutation, ChangeAttendeeMemberStatusMutationVariables>;

/**
 * __useChangeAttendeeMemberStatusMutation__
 *
 * To run a mutation, you first call `useChangeAttendeeMemberStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAttendeeMemberStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAttendeeMemberStatusMutation, { data, loading, error }] = useChangeAttendeeMemberStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      member: // value for 'member'
 *   },
 * });
 */
export function useChangeAttendeeMemberStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeAttendeeMemberStatusMutation, ChangeAttendeeMemberStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeAttendeeMemberStatusMutation, ChangeAttendeeMemberStatusMutationVariables>(ChangeAttendeeMemberStatusDocument, baseOptions);
      }
export type ChangeAttendeeMemberStatusMutationHookResult = ReturnType<typeof useChangeAttendeeMemberStatusMutation>;
export type ChangeAttendeeMemberStatusMutationResult = ApolloReactCommon.MutationResult<ChangeAttendeeMemberStatusMutation>;
export type ChangeAttendeeMemberStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeAttendeeMemberStatusMutation, ChangeAttendeeMemberStatusMutationVariables>;
export const ChangeDefaultPaymentMethodDocument = gql`
    mutation ChangeDefaultPaymentMethod($attendeeId: ID!, $paymentMethodId: ID!) {
  changeDefaultPaymentMethod(attendeeId: $attendeeId, paymentMethodId: $paymentMethodId) {
    id
    defaultPaymentMethod {
      id
      cash
      esr
      creditcardNumber
      creditCardAccountholder
      expirationDate
      sepaAccountholder
      iban
      bic
      bank
      paypalAccountholder
      email
      bankTransfer
      onlinePayment
    }
  }
}
    `;
export type ChangeDefaultPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<ChangeDefaultPaymentMethodMutation, ChangeDefaultPaymentMethodMutationVariables>;

/**
 * __useChangeDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useChangeDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDefaultPaymentMethodMutation, { data, loading, error }] = useChangeDefaultPaymentMethodMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useChangeDefaultPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeDefaultPaymentMethodMutation, ChangeDefaultPaymentMethodMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeDefaultPaymentMethodMutation, ChangeDefaultPaymentMethodMutationVariables>(ChangeDefaultPaymentMethodDocument, baseOptions);
      }
export type ChangeDefaultPaymentMethodMutationHookResult = ReturnType<typeof useChangeDefaultPaymentMethodMutation>;
export type ChangeDefaultPaymentMethodMutationResult = ApolloReactCommon.MutationResult<ChangeDefaultPaymentMethodMutation>;
export type ChangeDefaultPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeDefaultPaymentMethodMutation, ChangeDefaultPaymentMethodMutationVariables>;
export const GetAttendeesWithByStandardPaymentMethodDocument = gql`
    query GetAttendeesWithByStandardPaymentMethod($paymentTransferType: PaymentTransferType!, $koOrganizationId: ID!, $targetPaymentTransferType: PaymentTransferType!, $options: ArrayDataOptions) {
  getAttendeesWithByStandardPaymentMethod(paymentTransferType: $paymentTransferType, koOrganizationId: $koOrganizationId, targetPaymentTransferType: $targetPaymentTransferType, options: $options) {
    total
    existsMore
    items {
      id
      firstname
      lastname
      defaultPaymentMethod {
        id
        type
      }
      booker {
        id
        firstname
        lastname
        paymentMethods {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetAttendeesWithByStandardPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetAttendeesWithByStandardPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeesWithByStandardPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeesWithByStandardPaymentMethodQuery({
 *   variables: {
 *      paymentTransferType: // value for 'paymentTransferType'
 *      koOrganizationId: // value for 'koOrganizationId'
 *      targetPaymentTransferType: // value for 'targetPaymentTransferType'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetAttendeesWithByStandardPaymentMethodQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeesWithByStandardPaymentMethodQuery, GetAttendeesWithByStandardPaymentMethodQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeesWithByStandardPaymentMethodQuery, GetAttendeesWithByStandardPaymentMethodQueryVariables>(GetAttendeesWithByStandardPaymentMethodDocument, baseOptions);
      }
export function useGetAttendeesWithByStandardPaymentMethodLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeesWithByStandardPaymentMethodQuery, GetAttendeesWithByStandardPaymentMethodQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeesWithByStandardPaymentMethodQuery, GetAttendeesWithByStandardPaymentMethodQueryVariables>(GetAttendeesWithByStandardPaymentMethodDocument, baseOptions);
        }
export type GetAttendeesWithByStandardPaymentMethodQueryHookResult = ReturnType<typeof useGetAttendeesWithByStandardPaymentMethodQuery>;
export type GetAttendeesWithByStandardPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetAttendeesWithByStandardPaymentMethodLazyQuery>;
export type GetAttendeesWithByStandardPaymentMethodQueryResult = ApolloReactCommon.QueryResult<GetAttendeesWithByStandardPaymentMethodQuery, GetAttendeesWithByStandardPaymentMethodQueryVariables>;
export const ChangeMultipleAttendeesDefaultPaymentMethodsDocument = gql`
    mutation ChangeMultipleAttendeesDefaultPaymentMethods($attendeeIds: [ID!]!, $targetPaymentTransferType: PaymentTransferType!, $koOrganizationId: ID!) {
  changeMultipleAttendeesDefaultPaymentMethods(attendeeIds: $attendeeIds, targetPaymentTransferType: $targetPaymentTransferType, koOrganizationId: $koOrganizationId) {
    id
  }
}
    `;
export type ChangeMultipleAttendeesDefaultPaymentMethodsMutationFn = ApolloReactCommon.MutationFunction<ChangeMultipleAttendeesDefaultPaymentMethodsMutation, ChangeMultipleAttendeesDefaultPaymentMethodsMutationVariables>;

/**
 * __useChangeMultipleAttendeesDefaultPaymentMethodsMutation__
 *
 * To run a mutation, you first call `useChangeMultipleAttendeesDefaultPaymentMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMultipleAttendeesDefaultPaymentMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMultipleAttendeesDefaultPaymentMethodsMutation, { data, loading, error }] = useChangeMultipleAttendeesDefaultPaymentMethodsMutation({
 *   variables: {
 *      attendeeIds: // value for 'attendeeIds'
 *      targetPaymentTransferType: // value for 'targetPaymentTransferType'
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useChangeMultipleAttendeesDefaultPaymentMethodsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeMultipleAttendeesDefaultPaymentMethodsMutation, ChangeMultipleAttendeesDefaultPaymentMethodsMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeMultipleAttendeesDefaultPaymentMethodsMutation, ChangeMultipleAttendeesDefaultPaymentMethodsMutationVariables>(ChangeMultipleAttendeesDefaultPaymentMethodsDocument, baseOptions);
      }
export type ChangeMultipleAttendeesDefaultPaymentMethodsMutationHookResult = ReturnType<typeof useChangeMultipleAttendeesDefaultPaymentMethodsMutation>;
export type ChangeMultipleAttendeesDefaultPaymentMethodsMutationResult = ApolloReactCommon.MutationResult<ChangeMultipleAttendeesDefaultPaymentMethodsMutation>;
export type ChangeMultipleAttendeesDefaultPaymentMethodsMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeMultipleAttendeesDefaultPaymentMethodsMutation, ChangeMultipleAttendeesDefaultPaymentMethodsMutationVariables>;
export const GetBillingAddressTemplatesDocument = gql`
    query GetBillingAddressTemplates {
  billingAddressTemplates {
    id
    name
    companyName
    firstname
    lastname
    addition
    street
    postCode
    city
  }
}
    `;

/**
 * __useGetBillingAddressTemplatesQuery__
 *
 * To run a query within a React component, call `useGetBillingAddressTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingAddressTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingAddressTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingAddressTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBillingAddressTemplatesQuery, GetBillingAddressTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBillingAddressTemplatesQuery, GetBillingAddressTemplatesQueryVariables>(GetBillingAddressTemplatesDocument, baseOptions);
      }
export function useGetBillingAddressTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBillingAddressTemplatesQuery, GetBillingAddressTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBillingAddressTemplatesQuery, GetBillingAddressTemplatesQueryVariables>(GetBillingAddressTemplatesDocument, baseOptions);
        }
export type GetBillingAddressTemplatesQueryHookResult = ReturnType<typeof useGetBillingAddressTemplatesQuery>;
export type GetBillingAddressTemplatesLazyQueryHookResult = ReturnType<typeof useGetBillingAddressTemplatesLazyQuery>;
export type GetBillingAddressTemplatesQueryResult = ApolloReactCommon.QueryResult<GetBillingAddressTemplatesQuery, GetBillingAddressTemplatesQueryVariables>;
export const CreateBillingAddressTemplateDocument = gql`
    mutation CreateBillingAddressTemplate($input: CreateBillingAddressTemplateInput!) {
  createBillingAddressTemplate(input: $input) {
    id
    name
    companyName
    firstname
    lastname
    addition
    street
    postCode
    city
  }
}
    `;
export type CreateBillingAddressTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateBillingAddressTemplateMutation, CreateBillingAddressTemplateMutationVariables>;

/**
 * __useCreateBillingAddressTemplateMutation__
 *
 * To run a mutation, you first call `useCreateBillingAddressTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingAddressTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingAddressTemplateMutation, { data, loading, error }] = useCreateBillingAddressTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillingAddressTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBillingAddressTemplateMutation, CreateBillingAddressTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBillingAddressTemplateMutation, CreateBillingAddressTemplateMutationVariables>(CreateBillingAddressTemplateDocument, baseOptions);
      }
export type CreateBillingAddressTemplateMutationHookResult = ReturnType<typeof useCreateBillingAddressTemplateMutation>;
export type CreateBillingAddressTemplateMutationResult = ApolloReactCommon.MutationResult<CreateBillingAddressTemplateMutation>;
export type CreateBillingAddressTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBillingAddressTemplateMutation, CreateBillingAddressTemplateMutationVariables>;
export const UpdateBillingAddressTemplateDocument = gql`
    mutation UpdateBillingAddressTemplate($input: UpdateBillingAddressTemplateInput!) {
  updateBillingAddressTemplate(input: $input) {
    id
    name
    companyName
    firstname
    lastname
    addition
    street
    postCode
    city
  }
}
    `;
export type UpdateBillingAddressTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateBillingAddressTemplateMutation, UpdateBillingAddressTemplateMutationVariables>;

/**
 * __useUpdateBillingAddressTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateBillingAddressTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingAddressTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingAddressTemplateMutation, { data, loading, error }] = useUpdateBillingAddressTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingAddressTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBillingAddressTemplateMutation, UpdateBillingAddressTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBillingAddressTemplateMutation, UpdateBillingAddressTemplateMutationVariables>(UpdateBillingAddressTemplateDocument, baseOptions);
      }
export type UpdateBillingAddressTemplateMutationHookResult = ReturnType<typeof useUpdateBillingAddressTemplateMutation>;
export type UpdateBillingAddressTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateBillingAddressTemplateMutation>;
export type UpdateBillingAddressTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBillingAddressTemplateMutation, UpdateBillingAddressTemplateMutationVariables>;
export const DeleteBillingAddressTemplateDocument = gql`
    mutation DeleteBillingAddressTemplate($id: String!) {
  deleteBillingAddressTemplate(id: $id)
}
    `;
export type DeleteBillingAddressTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteBillingAddressTemplateMutation, DeleteBillingAddressTemplateMutationVariables>;

/**
 * __useDeleteBillingAddressTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteBillingAddressTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillingAddressTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillingAddressTemplateMutation, { data, loading, error }] = useDeleteBillingAddressTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBillingAddressTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBillingAddressTemplateMutation, DeleteBillingAddressTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBillingAddressTemplateMutation, DeleteBillingAddressTemplateMutationVariables>(DeleteBillingAddressTemplateDocument, baseOptions);
      }
export type DeleteBillingAddressTemplateMutationHookResult = ReturnType<typeof useDeleteBillingAddressTemplateMutation>;
export type DeleteBillingAddressTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteBillingAddressTemplateMutation>;
export type DeleteBillingAddressTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBillingAddressTemplateMutation, DeleteBillingAddressTemplateMutationVariables>;
export const CreateBookerDocument = gql`
    mutation CreateBooker($newBookerData: BookerInput!) {
  createBooker(newBookerData: $newBookerData) {
    id
    gender
    firstname
    lastname
    birthday
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    secondaryEmail
    initialContact
    dsgvo
    newsletter
    healthInsuranceFund
    addition
    annotation
    credit
    nonDisclosureNotice
    hasBillingAddress
    billingCompanyName
    billingFirstname
    billingLastname
    billingAddition
    billingStreet
    billingPostCode
    billingCity
    paymentMethods {
      id
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      bankTransfer
      onlinePayment
    }
    attendees {
      id
      gender
      lastname
      firstname
      birthday
      member
      defaultPaymentMethod {
        id
      }
      bookings {
        id
        courseLessons {
          id
        }
        paymentMethod {
          id
        }
        paymentType
        payDate
      }
      addition
      annotation
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
    }
  }
}
    `;
export type CreateBookerMutationFn = ApolloReactCommon.MutationFunction<CreateBookerMutation, CreateBookerMutationVariables>;

/**
 * __useCreateBookerMutation__
 *
 * To run a mutation, you first call `useCreateBookerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookerMutation, { data, loading, error }] = useCreateBookerMutation({
 *   variables: {
 *      newBookerData: // value for 'newBookerData'
 *   },
 * });
 */
export function useCreateBookerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookerMutation, CreateBookerMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBookerMutation, CreateBookerMutationVariables>(CreateBookerDocument, baseOptions);
      }
export type CreateBookerMutationHookResult = ReturnType<typeof useCreateBookerMutation>;
export type CreateBookerMutationResult = ApolloReactCommon.MutationResult<CreateBookerMutation>;
export type CreateBookerMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBookerMutation, CreateBookerMutationVariables>;
export const GetBookerWithAttendeeBookingsDocument = gql`
    query GetBookerWithAttendeeBookings($id: String!) {
  booker(id: $id) {
    id
    customerId
    gender
    firstname
    lastname
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    secondaryEmail
    initialContact
    birthday
    dsgvo
    newsletter
    credit
    healthInsuranceFund
    addition
    annotation
    nonDisclosureNotice
    hasBillingAddress
    billingCompanyName
    billingFirstname
    billingLastname
    billingAddition
    billingStreet
    billingPostCode
    billingCity
    paymentMethods {
      id
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      bankTransfer
      onlinePayment
    }
    attendees {
      id
      customerId
      gender
      lastname
      firstname
      birthday
      member
      defaultPaymentMethod {
        id
      }
      bookings {
        id
        courseLessons {
          id
          courseId
          course {
            id
            maxAttendees
          }
        }
        paymentMethod {
          id
        }
        paymentType
        payDate
      }
      addition
      annotation
      deletable
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
    }
    customerNumber
    userId
  }
}
    `;

/**
 * __useGetBookerWithAttendeeBookingsQuery__
 *
 * To run a query within a React component, call `useGetBookerWithAttendeeBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookerWithAttendeeBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookerWithAttendeeBookingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookerWithAttendeeBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookerWithAttendeeBookingsQuery, GetBookerWithAttendeeBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookerWithAttendeeBookingsQuery, GetBookerWithAttendeeBookingsQueryVariables>(GetBookerWithAttendeeBookingsDocument, baseOptions);
      }
export function useGetBookerWithAttendeeBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookerWithAttendeeBookingsQuery, GetBookerWithAttendeeBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookerWithAttendeeBookingsQuery, GetBookerWithAttendeeBookingsQueryVariables>(GetBookerWithAttendeeBookingsDocument, baseOptions);
        }
export type GetBookerWithAttendeeBookingsQueryHookResult = ReturnType<typeof useGetBookerWithAttendeeBookingsQuery>;
export type GetBookerWithAttendeeBookingsLazyQueryHookResult = ReturnType<typeof useGetBookerWithAttendeeBookingsLazyQuery>;
export type GetBookerWithAttendeeBookingsQueryResult = ApolloReactCommon.QueryResult<GetBookerWithAttendeeBookingsQuery, GetBookerWithAttendeeBookingsQueryVariables>;
export const GetBookerForDuplicateBookerOverviewDocument = gql`
    query GetBookerForDuplicateBookerOverview($id: String!) {
  booker(id: $id) {
    id
    customerId
    gender
    firstname
    lastname
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    initialContact
    dsgvo
    newsletter
    credit
    healthInsuranceFund
    annotation
    paymentMethods {
      id
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      type
      bankTransfer
      onlinePayment
    }
    attendees {
      id
      customerId
      customerNumberPrefix
      customerNumber
      gender
      lastname
      firstname
      birthday
      member
      defaultPaymentMethod {
        id
      }
      bookings {
        id
        bookingNumberPrefix
        bookingType
        bookingNumber
        invoice {
          id
        }
        canceled
        courseLessons {
          id
          courseId
          course {
            id
            courseNumber
            allowLessonBooking
            courseType {
              id
              color
              name
            }
          }
        }
      }
      annotation
    }
    customerNumber
    customerNumberPrefix
    userId
  }
}
    `;

/**
 * __useGetBookerForDuplicateBookerOverviewQuery__
 *
 * To run a query within a React component, call `useGetBookerForDuplicateBookerOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookerForDuplicateBookerOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookerForDuplicateBookerOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookerForDuplicateBookerOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookerForDuplicateBookerOverviewQuery, GetBookerForDuplicateBookerOverviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookerForDuplicateBookerOverviewQuery, GetBookerForDuplicateBookerOverviewQueryVariables>(GetBookerForDuplicateBookerOverviewDocument, baseOptions);
      }
export function useGetBookerForDuplicateBookerOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookerForDuplicateBookerOverviewQuery, GetBookerForDuplicateBookerOverviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookerForDuplicateBookerOverviewQuery, GetBookerForDuplicateBookerOverviewQueryVariables>(GetBookerForDuplicateBookerOverviewDocument, baseOptions);
        }
export type GetBookerForDuplicateBookerOverviewQueryHookResult = ReturnType<typeof useGetBookerForDuplicateBookerOverviewQuery>;
export type GetBookerForDuplicateBookerOverviewLazyQueryHookResult = ReturnType<typeof useGetBookerForDuplicateBookerOverviewLazyQuery>;
export type GetBookerForDuplicateBookerOverviewQueryResult = ApolloReactCommon.QueryResult<GetBookerForDuplicateBookerOverviewQuery, GetBookerForDuplicateBookerOverviewQueryVariables>;
export const UpdateBookerDocument = gql`
    mutation UpdateBooker($updateBookerData: BookerInput!) {
  updateBooker(updateBookerData: $updateBookerData) {
    id
    gender
    firstname
    lastname
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    secondaryEmail
    initialContact
    dsgvo
    newsletter
    healthInsuranceFund
    addition
    annotation
    credit
    nonDisclosureNotice
    hasBillingAddress
    billingCompanyName
    billingFirstname
    billingLastname
    billingAddition
    billingStreet
    billingPostCode
    billingCity
    paymentMethods {
      id
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      bankTransfer
      onlinePayment
    }
    attendees {
      id
      customerId
      gender
      lastname
      firstname
      birthday
      member
      deletable
      startedCourses {
        id
        prefixedCourseNumber
      }
      defaultPaymentMethod {
        id
      }
      addition
      annotation
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
    }
  }
}
    `;
export type UpdateBookerMutationFn = ApolloReactCommon.MutationFunction<UpdateBookerMutation, UpdateBookerMutationVariables>;

/**
 * __useUpdateBookerMutation__
 *
 * To run a mutation, you first call `useUpdateBookerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookerMutation, { data, loading, error }] = useUpdateBookerMutation({
 *   variables: {
 *      updateBookerData: // value for 'updateBookerData'
 *   },
 * });
 */
export function useUpdateBookerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookerMutation, UpdateBookerMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookerMutation, UpdateBookerMutationVariables>(UpdateBookerDocument, baseOptions);
      }
export type UpdateBookerMutationHookResult = ReturnType<typeof useUpdateBookerMutation>;
export type UpdateBookerMutationResult = ApolloReactCommon.MutationResult<UpdateBookerMutation>;
export type UpdateBookerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookerMutation, UpdateBookerMutationVariables>;
export const AttendeeTableGetCourseLessonsDocument = gql`
    query AttendeeTableGetCourseLessons($ids: [String!]) {
  courseLessons(ids: $ids) {
    id
    course {
      id
      prefixedCourseNumber
      courseType {
        id
        name
        color
      }
    }
    location {
      id
      name
      city
    }
    startDateTime
  }
}
    `;

/**
 * __useAttendeeTableGetCourseLessonsQuery__
 *
 * To run a query within a React component, call `useAttendeeTableGetCourseLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendeeTableGetCourseLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendeeTableGetCourseLessonsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAttendeeTableGetCourseLessonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttendeeTableGetCourseLessonsQuery, AttendeeTableGetCourseLessonsQueryVariables>) {
        return ApolloReactHooks.useQuery<AttendeeTableGetCourseLessonsQuery, AttendeeTableGetCourseLessonsQueryVariables>(AttendeeTableGetCourseLessonsDocument, baseOptions);
      }
export function useAttendeeTableGetCourseLessonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttendeeTableGetCourseLessonsQuery, AttendeeTableGetCourseLessonsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AttendeeTableGetCourseLessonsQuery, AttendeeTableGetCourseLessonsQueryVariables>(AttendeeTableGetCourseLessonsDocument, baseOptions);
        }
export type AttendeeTableGetCourseLessonsQueryHookResult = ReturnType<typeof useAttendeeTableGetCourseLessonsQuery>;
export type AttendeeTableGetCourseLessonsLazyQueryHookResult = ReturnType<typeof useAttendeeTableGetCourseLessonsLazyQuery>;
export type AttendeeTableGetCourseLessonsQueryResult = ApolloReactCommon.QueryResult<AttendeeTableGetCourseLessonsQuery, AttendeeTableGetCourseLessonsQueryVariables>;
export const GetBookingsByAttendeeDocument = gql`
    query GetBookingsByAttendee($attendeeId: ID!) {
  getBookingsByAttendeeId(id: $attendeeId) {
    id
    bookingNumber
    bookingNumberPrefix
    bookingType
    canceled
    noticeStaff
    startDateTime
    course {
      id
      prefixedCourseNumber
      courseNumber
      courseType {
        id
        name
        color
      }
    }
    courseLessons {
      id
      startDateTime
      indexOfLessonInCourse
    }
  }
}
    `;

/**
 * __useGetBookingsByAttendeeQuery__
 *
 * To run a query within a React component, call `useGetBookingsByAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsByAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsByAttendeeQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useGetBookingsByAttendeeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingsByAttendeeQuery, GetBookingsByAttendeeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingsByAttendeeQuery, GetBookingsByAttendeeQueryVariables>(GetBookingsByAttendeeDocument, baseOptions);
      }
export function useGetBookingsByAttendeeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingsByAttendeeQuery, GetBookingsByAttendeeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingsByAttendeeQuery, GetBookingsByAttendeeQueryVariables>(GetBookingsByAttendeeDocument, baseOptions);
        }
export type GetBookingsByAttendeeQueryHookResult = ReturnType<typeof useGetBookingsByAttendeeQuery>;
export type GetBookingsByAttendeeLazyQueryHookResult = ReturnType<typeof useGetBookingsByAttendeeLazyQuery>;
export type GetBookingsByAttendeeQueryResult = ApolloReactCommon.QueryResult<GetBookingsByAttendeeQuery, GetBookingsByAttendeeQueryVariables>;
export const DeleteAttendeeDocument = gql`
    mutation DeleteAttendee($id: String!) {
  deleteAttendee(id: $id)
}
    `;
export type DeleteAttendeeMutationFn = ApolloReactCommon.MutationFunction<DeleteAttendeeMutation, DeleteAttendeeMutationVariables>;

/**
 * __useDeleteAttendeeMutation__
 *
 * To run a mutation, you first call `useDeleteAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendeeMutation, { data, loading, error }] = useDeleteAttendeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttendeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAttendeeMutation, DeleteAttendeeMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAttendeeMutation, DeleteAttendeeMutationVariables>(DeleteAttendeeDocument, baseOptions);
      }
export type DeleteAttendeeMutationHookResult = ReturnType<typeof useDeleteAttendeeMutation>;
export type DeleteAttendeeMutationResult = ApolloReactCommon.MutationResult<DeleteAttendeeMutation>;
export type DeleteAttendeeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAttendeeMutation, DeleteAttendeeMutationVariables>;
export const GetCourseLessonStartDatesDocument = gql`
    query GetCourseLessonStartDates($ids: [String!]) {
  courseLessons(ids: $ids) {
    id
    startDateTime
    course {
      id
      prefixedCourseNumber
    }
  }
}
    `;

/**
 * __useGetCourseLessonStartDatesQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonStartDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonStartDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonStartDatesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCourseLessonStartDatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonStartDatesQuery, GetCourseLessonStartDatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonStartDatesQuery, GetCourseLessonStartDatesQueryVariables>(GetCourseLessonStartDatesDocument, baseOptions);
      }
export function useGetCourseLessonStartDatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonStartDatesQuery, GetCourseLessonStartDatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonStartDatesQuery, GetCourseLessonStartDatesQueryVariables>(GetCourseLessonStartDatesDocument, baseOptions);
        }
export type GetCourseLessonStartDatesQueryHookResult = ReturnType<typeof useGetCourseLessonStartDatesQuery>;
export type GetCourseLessonStartDatesLazyQueryHookResult = ReturnType<typeof useGetCourseLessonStartDatesLazyQuery>;
export type GetCourseLessonStartDatesQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonStartDatesQuery, GetCourseLessonStartDatesQueryVariables>;
export const GetBookersOverviewDocument = gql`
    query GetBookersOverview($options: ArrayDataOptions) {
  bookers(options: $options) {
    existsMore
    total
    items {
      id
      customerNumberPrefix
      customerNumber
      firstname
      lastname
      attendees {
        firstname
        lastname
        id
        deletable
        addition
        annotation
        member
      }
      street
      houseNumber
      postCode
      city
      paymentMethods {
        id
        bankTransfer
        onlinePayment
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
      }
      dsgvo
      newsletter
      email
      mobileNumber
      phoneNumber
      birthday
      gender
      initialContact
      healthInsuranceFund
      addition
      annotation
      credit
      nonDisclosureNotice
      userId
    }
  }
}
    `;

/**
 * __useGetBookersOverviewQuery__
 *
 * To run a query within a React component, call `useGetBookersOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookersOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookersOverviewQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetBookersOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookersOverviewQuery, GetBookersOverviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookersOverviewQuery, GetBookersOverviewQueryVariables>(GetBookersOverviewDocument, baseOptions);
      }
export function useGetBookersOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookersOverviewQuery, GetBookersOverviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookersOverviewQuery, GetBookersOverviewQueryVariables>(GetBookersOverviewDocument, baseOptions);
        }
export type GetBookersOverviewQueryHookResult = ReturnType<typeof useGetBookersOverviewQuery>;
export type GetBookersOverviewLazyQueryHookResult = ReturnType<typeof useGetBookersOverviewLazyQuery>;
export type GetBookersOverviewQueryResult = ApolloReactCommon.QueryResult<GetBookersOverviewQuery, GetBookersOverviewQueryVariables>;
export const GetDynamicBookersDocument = gql`
    query GetDynamicBookers($options: ArrayDataOptions, $includePayment: Boolean!, $includeAttendees: Boolean!) {
  bookersDynamic(options: $options) {
    __typename
    existsMore
    total
    items {
      ...BookerCoreFields
      ...BookerPaymentMethodsFields @include(if: $includePayment)
      ...BookerAttendeesFields @include(if: $includeAttendees)
    }
  }
}
    ${BookerCoreFieldsFragmentDoc}
${BookerPaymentMethodsFieldsFragmentDoc}
${BookerAttendeesFieldsFragmentDoc}`;

/**
 * __useGetDynamicBookersQuery__
 *
 * To run a query within a React component, call `useGetDynamicBookersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicBookersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicBookersQuery({
 *   variables: {
 *      options: // value for 'options'
 *      includePayment: // value for 'includePayment'
 *      includeAttendees: // value for 'includeAttendees'
 *   },
 * });
 */
export function useGetDynamicBookersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDynamicBookersQuery, GetDynamicBookersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDynamicBookersQuery, GetDynamicBookersQueryVariables>(GetDynamicBookersDocument, baseOptions);
      }
export function useGetDynamicBookersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDynamicBookersQuery, GetDynamicBookersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDynamicBookersQuery, GetDynamicBookersQueryVariables>(GetDynamicBookersDocument, baseOptions);
        }
export type GetDynamicBookersQueryHookResult = ReturnType<typeof useGetDynamicBookersQuery>;
export type GetDynamicBookersLazyQueryHookResult = ReturnType<typeof useGetDynamicBookersLazyQuery>;
export type GetDynamicBookersQueryResult = ApolloReactCommon.QueryResult<GetDynamicBookersQuery, GetDynamicBookersQueryVariables>;
export const GetBookerByEmailDocument = gql`
    query GetBookerByEmail($email: String!) {
  getBookerByEmail(email: $email) {
    id
    firstname
    lastname
    email
  }
}
    `;

/**
 * __useGetBookerByEmailQuery__
 *
 * To run a query within a React component, call `useGetBookerByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookerByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookerByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetBookerByEmailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookerByEmailQuery, GetBookerByEmailQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookerByEmailQuery, GetBookerByEmailQueryVariables>(GetBookerByEmailDocument, baseOptions);
      }
export function useGetBookerByEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookerByEmailQuery, GetBookerByEmailQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookerByEmailQuery, GetBookerByEmailQueryVariables>(GetBookerByEmailDocument, baseOptions);
        }
export type GetBookerByEmailQueryHookResult = ReturnType<typeof useGetBookerByEmailQuery>;
export type GetBookerByEmailLazyQueryHookResult = ReturnType<typeof useGetBookerByEmailLazyQuery>;
export type GetBookerByEmailQueryResult = ApolloReactCommon.QueryResult<GetBookerByEmailQuery, GetBookerByEmailQueryVariables>;
export const GetBookersByIdDocument = gql`
    query GetBookersById($bookerIds: [String!]!) {
  bookersById(bookerIds: $bookerIds) {
    id
    firstname
    lastname
    email
  }
}
    `;

/**
 * __useGetBookersByIdQuery__
 *
 * To run a query within a React component, call `useGetBookersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookersByIdQuery({
 *   variables: {
 *      bookerIds: // value for 'bookerIds'
 *   },
 * });
 */
export function useGetBookersByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookersByIdQuery, GetBookersByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookersByIdQuery, GetBookersByIdQueryVariables>(GetBookersByIdDocument, baseOptions);
      }
export function useGetBookersByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookersByIdQuery, GetBookersByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookersByIdQuery, GetBookersByIdQueryVariables>(GetBookersByIdDocument, baseOptions);
        }
export type GetBookersByIdQueryHookResult = ReturnType<typeof useGetBookersByIdQuery>;
export type GetBookersByIdLazyQueryHookResult = ReturnType<typeof useGetBookersByIdLazyQuery>;
export type GetBookersByIdQueryResult = ApolloReactCommon.QueryResult<GetBookersByIdQuery, GetBookersByIdQueryVariables>;
export const SendBlankMailToMultipleBookersDocument = gql`
    mutation sendBlankMailToMultipleBookers($input: BlankMailInputTypes!, $file: Upload) {
  sendBlankMailToMultipleBookers(input: $input, file: $file)
}
    `;
export type SendBlankMailToMultipleBookersMutationFn = ApolloReactCommon.MutationFunction<SendBlankMailToMultipleBookersMutation, SendBlankMailToMultipleBookersMutationVariables>;

/**
 * __useSendBlankMailToMultipleBookersMutation__
 *
 * To run a mutation, you first call `useSendBlankMailToMultipleBookersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBlankMailToMultipleBookersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBlankMailToMultipleBookersMutation, { data, loading, error }] = useSendBlankMailToMultipleBookersMutation({
 *   variables: {
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSendBlankMailToMultipleBookersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendBlankMailToMultipleBookersMutation, SendBlankMailToMultipleBookersMutationVariables>) {
        return ApolloReactHooks.useMutation<SendBlankMailToMultipleBookersMutation, SendBlankMailToMultipleBookersMutationVariables>(SendBlankMailToMultipleBookersDocument, baseOptions);
      }
export type SendBlankMailToMultipleBookersMutationHookResult = ReturnType<typeof useSendBlankMailToMultipleBookersMutation>;
export type SendBlankMailToMultipleBookersMutationResult = ApolloReactCommon.MutationResult<SendBlankMailToMultipleBookersMutation>;
export type SendBlankMailToMultipleBookersMutationOptions = ApolloReactCommon.BaseMutationOptions<SendBlankMailToMultipleBookersMutation, SendBlankMailToMultipleBookersMutationVariables>;
export const GetBookersByCourseIdsDocument = gql`
    query getBookersByCourseIds($courseIds: [String!]!) {
  getBookersByCourseIds(courseIds: $courseIds) {
    id
    customerNumberPrefix
    customerNumber
    firstname
    lastname
    attendees {
      firstname
      lastname
      id
      deletable
      startedCourses {
        id
        prefixedCourseNumber
      }
      addition
      annotation
      member
    }
    street
    houseNumber
    postCode
    city
    paymentMethods {
      id
      bankTransfer
      onlinePayment
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
    }
    dsgvo
    newsletter
    email
    mobileNumber
    phoneNumber
    birthday
    gender
    initialContact
    healthInsuranceFund
    addition
    annotation
    credit
    nonDisclosureNotice
  }
}
    `;

/**
 * __useGetBookersByCourseIdsQuery__
 *
 * To run a query within a React component, call `useGetBookersByCourseIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookersByCourseIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookersByCourseIdsQuery({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useGetBookersByCourseIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookersByCourseIdsQuery, GetBookersByCourseIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookersByCourseIdsQuery, GetBookersByCourseIdsQueryVariables>(GetBookersByCourseIdsDocument, baseOptions);
      }
export function useGetBookersByCourseIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookersByCourseIdsQuery, GetBookersByCourseIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookersByCourseIdsQuery, GetBookersByCourseIdsQueryVariables>(GetBookersByCourseIdsDocument, baseOptions);
        }
export type GetBookersByCourseIdsQueryHookResult = ReturnType<typeof useGetBookersByCourseIdsQuery>;
export type GetBookersByCourseIdsLazyQueryHookResult = ReturnType<typeof useGetBookersByCourseIdsLazyQuery>;
export type GetBookersByCourseIdsQueryResult = ApolloReactCommon.QueryResult<GetBookersByCourseIdsQuery, GetBookersByCourseIdsQueryVariables>;
export const GetReceiversByCourseIdsDocument = gql`
    query getReceiversByCourseIds($courseIds: [String!]!) {
  getBookersByCourseIds(courseIds: $courseIds) {
    id
    firstname
    lastname
    email
  }
}
    `;

/**
 * __useGetReceiversByCourseIdsQuery__
 *
 * To run a query within a React component, call `useGetReceiversByCourseIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiversByCourseIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiversByCourseIdsQuery({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useGetReceiversByCourseIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReceiversByCourseIdsQuery, GetReceiversByCourseIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetReceiversByCourseIdsQuery, GetReceiversByCourseIdsQueryVariables>(GetReceiversByCourseIdsDocument, baseOptions);
      }
export function useGetReceiversByCourseIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReceiversByCourseIdsQuery, GetReceiversByCourseIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetReceiversByCourseIdsQuery, GetReceiversByCourseIdsQueryVariables>(GetReceiversByCourseIdsDocument, baseOptions);
        }
export type GetReceiversByCourseIdsQueryHookResult = ReturnType<typeof useGetReceiversByCourseIdsQuery>;
export type GetReceiversByCourseIdsLazyQueryHookResult = ReturnType<typeof useGetReceiversByCourseIdsLazyQuery>;
export type GetReceiversByCourseIdsQueryResult = ApolloReactCommon.QueryResult<GetReceiversByCourseIdsQuery, GetReceiversByCourseIdsQueryVariables>;
export const DeleteBookerDocument = gql`
    mutation DeleteBooker($id: String!) {
  deleteBooker(id: $id)
}
    `;
export type DeleteBookerMutationFn = ApolloReactCommon.MutationFunction<DeleteBookerMutation, DeleteBookerMutationVariables>;

/**
 * __useDeleteBookerMutation__
 *
 * To run a mutation, you first call `useDeleteBookerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookerMutation, { data, loading, error }] = useDeleteBookerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBookerMutation, DeleteBookerMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBookerMutation, DeleteBookerMutationVariables>(DeleteBookerDocument, baseOptions);
      }
export type DeleteBookerMutationHookResult = ReturnType<typeof useDeleteBookerMutation>;
export type DeleteBookerMutationResult = ApolloReactCommon.MutationResult<DeleteBookerMutation>;
export type DeleteBookerMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBookerMutation, DeleteBookerMutationVariables>;
export const RemoveAllBookersOfTenantDocument = gql`
    mutation RemoveAllBookersOfTenant {
  removeAllBookersOfTenant
}
    `;
export type RemoveAllBookersOfTenantMutationFn = ApolloReactCommon.MutationFunction<RemoveAllBookersOfTenantMutation, RemoveAllBookersOfTenantMutationVariables>;

/**
 * __useRemoveAllBookersOfTenantMutation__
 *
 * To run a mutation, you first call `useRemoveAllBookersOfTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllBookersOfTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllBookersOfTenantMutation, { data, loading, error }] = useRemoveAllBookersOfTenantMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveAllBookersOfTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllBookersOfTenantMutation, RemoveAllBookersOfTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveAllBookersOfTenantMutation, RemoveAllBookersOfTenantMutationVariables>(RemoveAllBookersOfTenantDocument, baseOptions);
      }
export type RemoveAllBookersOfTenantMutationHookResult = ReturnType<typeof useRemoveAllBookersOfTenantMutation>;
export type RemoveAllBookersOfTenantMutationResult = ApolloReactCommon.MutationResult<RemoveAllBookersOfTenantMutation>;
export type RemoveAllBookersOfTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAllBookersOfTenantMutation, RemoveAllBookersOfTenantMutationVariables>;
export const AddPaymentMethodDocument = gql`
    mutation AddPaymentMethod($bookerId: String!, $paymentMethodType: String!, $sepaDebitInput: SepaDebitIntput) {
  addPaymentMethod(bookerId: $bookerId, paymentMethodType: $paymentMethodType, sepaDebitIntput: $sepaDebitInput) {
    id
    cash
    esr
    creditCardAccountholder
    creditcardNumber
    expirationDate
    validFrom
    cvc
    paypalAccountholder
    email
    iban
    bank
    bic
    sepaAccountholder
    type
    bankTransfer
    onlinePayment
  }
}
    `;
export type AddPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;

/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *      sepaDebitInput: // value for 'sepaDebitInput'
 *   },
 * });
 */
export function useAddPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>) {
        return ApolloReactHooks.useMutation<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>(AddPaymentMethodDocument, baseOptions);
      }
export type AddPaymentMethodMutationHookResult = ReturnType<typeof useAddPaymentMethodMutation>;
export type AddPaymentMethodMutationResult = ApolloReactCommon.MutationResult<AddPaymentMethodMutation>;
export type AddPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const GetPaymentMethodsByBookerIdDocument = gql`
    query GetPaymentMethodsByBookerId($bookerId: String!) {
  getPaymentMethodsByBookerId(bookerId: $bookerId) {
    id
    cash
    esr
    creditcardNumber
    creditCardAccountholder
    expirationDate
    sepaAccountholder
    iban
    bic
    bank
    paypalAccountholder
    email
    bankTransfer
    onlinePayment
  }
}
    `;

/**
 * __useGetPaymentMethodsByBookerIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsByBookerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsByBookerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsByBookerIdQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useGetPaymentMethodsByBookerIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentMethodsByBookerIdQuery, GetPaymentMethodsByBookerIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPaymentMethodsByBookerIdQuery, GetPaymentMethodsByBookerIdQueryVariables>(GetPaymentMethodsByBookerIdDocument, baseOptions);
      }
export function useGetPaymentMethodsByBookerIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentMethodsByBookerIdQuery, GetPaymentMethodsByBookerIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPaymentMethodsByBookerIdQuery, GetPaymentMethodsByBookerIdQueryVariables>(GetPaymentMethodsByBookerIdDocument, baseOptions);
        }
export type GetPaymentMethodsByBookerIdQueryHookResult = ReturnType<typeof useGetPaymentMethodsByBookerIdQuery>;
export type GetPaymentMethodsByBookerIdLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsByBookerIdLazyQuery>;
export type GetPaymentMethodsByBookerIdQueryResult = ApolloReactCommon.QueryResult<GetPaymentMethodsByBookerIdQuery, GetPaymentMethodsByBookerIdQueryVariables>;
export const GetBookerDetailsDocument = gql`
    query GetBookerDetails($id: String!) {
  booker(id: $id) {
    id
    erasedAt
    customerId
    gender
    birthday
    firstname
    lastname
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    secondaryEmail
    initialContact
    dsgvo
    newsletter
    credit
    healthInsuranceFund
    addition
    annotation
    nonDisclosureNotice
    paymentMethods {
      id
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      bankTransfer
      onlinePayment
    }
    attendees {
      id
      erasedAt
      customerId
      gender
      lastname
      firstname
      birthday
      member
      defaultPaymentMethod {
        id
      }
      bookings {
        id
        bookingNumber
        bookingNumberPrefix
        bookingType
        canceled
        courseId
        course {
          id
          prefixedCourseNumber
          courseType {
            id
            name
            color
          }
        }
        courseLessons {
          id
          courseId
          course {
            id
            maxAttendees
            prefixedCourseNumber
            courseType {
              id
              name
              color
            }
          }
        }
        paymentMethod {
          id
        }
        paymentType
        payDate
      }
      addition
      annotation
      customerNumber
      customerNumberPrefix
      createDate
      updateDate
      createdBy
      hasBillingAddress
      billingCompanyName
      billingFirstname
      billingLastname
      billingAddition
      billingStreet
      billingPostCode
      billingCity
    }
    customerNumber
    customerNumberPrefix
  }
}
    `;

/**
 * __useGetBookerDetailsQuery__
 *
 * To run a query within a React component, call `useGetBookerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookerDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookerDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookerDetailsQuery, GetBookerDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookerDetailsQuery, GetBookerDetailsQueryVariables>(GetBookerDetailsDocument, baseOptions);
      }
export function useGetBookerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookerDetailsQuery, GetBookerDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookerDetailsQuery, GetBookerDetailsQueryVariables>(GetBookerDetailsDocument, baseOptions);
        }
export type GetBookerDetailsQueryHookResult = ReturnType<typeof useGetBookerDetailsQuery>;
export type GetBookerDetailsLazyQueryHookResult = ReturnType<typeof useGetBookerDetailsLazyQuery>;
export type GetBookerDetailsQueryResult = ApolloReactCommon.QueryResult<GetBookerDetailsQuery, GetBookerDetailsQueryVariables>;
export const GetDuplicateBookersDocument = gql`
    query GetDuplicateBookers($options: ArrayDataOptions) {
  getDuplicateBookers(options: $options) {
    id
    firstname
    lastname
    gender
    customerNumber
    customerNumberPrefix
    email
    userId
    addition
    street
    houseNumber
    postCode
    city
    initialContact
    dsgvo
    newsletter
    healthInsuranceFund
    annotation
    nonDisclosureNotice
    credit
    birthday
    updateDate
    createdBy
    createdByUser {
      id
      email
    }
  }
}
    `;

/**
 * __useGetDuplicateBookersQuery__
 *
 * To run a query within a React component, call `useGetDuplicateBookersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateBookersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateBookersQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetDuplicateBookersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDuplicateBookersQuery, GetDuplicateBookersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDuplicateBookersQuery, GetDuplicateBookersQueryVariables>(GetDuplicateBookersDocument, baseOptions);
      }
export function useGetDuplicateBookersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDuplicateBookersQuery, GetDuplicateBookersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDuplicateBookersQuery, GetDuplicateBookersQueryVariables>(GetDuplicateBookersDocument, baseOptions);
        }
export type GetDuplicateBookersQueryHookResult = ReturnType<typeof useGetDuplicateBookersQuery>;
export type GetDuplicateBookersLazyQueryHookResult = ReturnType<typeof useGetDuplicateBookersLazyQuery>;
export type GetDuplicateBookersQueryResult = ApolloReactCommon.QueryResult<GetDuplicateBookersQuery, GetDuplicateBookersQueryVariables>;
export const MergeBookersDocument = gql`
    mutation MergeBookers($updateBookerData: BookerInput!, $mergedBookerId: ID!) {
  mergeBookers(updateBookerData: $updateBookerData, mergedBookerId: $mergedBookerId) {
    id
    firstname
    lastname
    gender
    customerNumber
    email
    userId
    addition
    street
    houseNumber
    postCode
    city
    initialContact
    dsgvo
    newsletter
    healthInsuranceFund
    annotation
    nonDisclosureNotice
    credit
    birthday
    updateDate
    createdBy
    paymentMethods {
      id
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      type
      bankTransfer
      onlinePayment
    }
    attendees {
      id
      firstname
      lastname
      customerNumber
      bookings {
        id
        bookingNumber
        bookingNumberPrefix
        bookingType
        startDateTime
        canceled
        courseLessons {
          id
          course {
            id
            courseType {
              id
              name
              color
            }
          }
        }
      }
    }
  }
}
    `;
export type MergeBookersMutationFn = ApolloReactCommon.MutationFunction<MergeBookersMutation, MergeBookersMutationVariables>;

/**
 * __useMergeBookersMutation__
 *
 * To run a mutation, you first call `useMergeBookersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeBookersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeBookersMutation, { data, loading, error }] = useMergeBookersMutation({
 *   variables: {
 *      updateBookerData: // value for 'updateBookerData'
 *      mergedBookerId: // value for 'mergedBookerId'
 *   },
 * });
 */
export function useMergeBookersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeBookersMutation, MergeBookersMutationVariables>) {
        return ApolloReactHooks.useMutation<MergeBookersMutation, MergeBookersMutationVariables>(MergeBookersDocument, baseOptions);
      }
export type MergeBookersMutationHookResult = ReturnType<typeof useMergeBookersMutation>;
export type MergeBookersMutationResult = ApolloReactCommon.MutationResult<MergeBookersMutation>;
export type MergeBookersMutationOptions = ApolloReactCommon.BaseMutationOptions<MergeBookersMutation, MergeBookersMutationVariables>;
export const UpdateBookerCreditDocument = gql`
    mutation UpdateBookerCredit($bookerId: ID!, $amount: Float!, $note: String!) {
  updateBookerCredit(bookerId: $bookerId, amount: $amount, note: $note) {
    id
    credit
  }
}
    `;
export type UpdateBookerCreditMutationFn = ApolloReactCommon.MutationFunction<UpdateBookerCreditMutation, UpdateBookerCreditMutationVariables>;

/**
 * __useUpdateBookerCreditMutation__
 *
 * To run a mutation, you first call `useUpdateBookerCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookerCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookerCreditMutation, { data, loading, error }] = useUpdateBookerCreditMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      amount: // value for 'amount'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateBookerCreditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookerCreditMutation, UpdateBookerCreditMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookerCreditMutation, UpdateBookerCreditMutationVariables>(UpdateBookerCreditDocument, baseOptions);
      }
export type UpdateBookerCreditMutationHookResult = ReturnType<typeof useUpdateBookerCreditMutation>;
export type UpdateBookerCreditMutationResult = ApolloReactCommon.MutationResult<UpdateBookerCreditMutation>;
export type UpdateBookerCreditMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookerCreditMutation, UpdateBookerCreditMutationVariables>;
export const GetCreditEntriesByBookerIdDocument = gql`
    query GetCreditEntriesByBookerId($bookerId: ID!) {
  creditEntriesByBookerId(bookerId: $bookerId) {
    id
    createDate
    amount
    balanceAfter
    reason
    note
    bookingId
    booking {
      id
      bookingNumber
      bookingNumberPrefix
    }
    scheduledPaymentId
    userId
    userName
    sourceBookerId
  }
}
    `;

/**
 * __useGetCreditEntriesByBookerIdQuery__
 *
 * To run a query within a React component, call `useGetCreditEntriesByBookerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditEntriesByBookerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditEntriesByBookerIdQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useGetCreditEntriesByBookerIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditEntriesByBookerIdQuery, GetCreditEntriesByBookerIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCreditEntriesByBookerIdQuery, GetCreditEntriesByBookerIdQueryVariables>(GetCreditEntriesByBookerIdDocument, baseOptions);
      }
export function useGetCreditEntriesByBookerIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditEntriesByBookerIdQuery, GetCreditEntriesByBookerIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCreditEntriesByBookerIdQuery, GetCreditEntriesByBookerIdQueryVariables>(GetCreditEntriesByBookerIdDocument, baseOptions);
        }
export type GetCreditEntriesByBookerIdQueryHookResult = ReturnType<typeof useGetCreditEntriesByBookerIdQuery>;
export type GetCreditEntriesByBookerIdLazyQueryHookResult = ReturnType<typeof useGetCreditEntriesByBookerIdLazyQuery>;
export type GetCreditEntriesByBookerIdQueryResult = ApolloReactCommon.QueryResult<GetCreditEntriesByBookerIdQuery, GetCreditEntriesByBookerIdQueryVariables>;
export const DismissDuplicatePairDocument = gql`
    mutation DismissDuplicatePair($input: DismissDuplicatePairInput!) {
  dismissDuplicatePair(input: $input)
}
    `;
export type DismissDuplicatePairMutationFn = ApolloReactCommon.MutationFunction<DismissDuplicatePairMutation, DismissDuplicatePairMutationVariables>;

/**
 * __useDismissDuplicatePairMutation__
 *
 * To run a mutation, you first call `useDismissDuplicatePairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissDuplicatePairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissDuplicatePairMutation, { data, loading, error }] = useDismissDuplicatePairMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissDuplicatePairMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissDuplicatePairMutation, DismissDuplicatePairMutationVariables>) {
        return ApolloReactHooks.useMutation<DismissDuplicatePairMutation, DismissDuplicatePairMutationVariables>(DismissDuplicatePairDocument, baseOptions);
      }
export type DismissDuplicatePairMutationHookResult = ReturnType<typeof useDismissDuplicatePairMutation>;
export type DismissDuplicatePairMutationResult = ApolloReactCommon.MutationResult<DismissDuplicatePairMutation>;
export type DismissDuplicatePairMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissDuplicatePairMutation, DismissDuplicatePairMutationVariables>;
export const GetDuplicateExceptionsDocument = gql`
    query GetDuplicateExceptions {
  getDuplicateExceptions {
    id
    bookerId1
    bookerId2
    booker1 {
      id
      customer {
        firstname
        lastname
      }
      email
    }
    booker2 {
      id
      customer {
        firstname
        lastname
      }
      email
    }
    createDate
  }
}
    `;

/**
 * __useGetDuplicateExceptionsQuery__
 *
 * To run a query within a React component, call `useGetDuplicateExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateExceptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDuplicateExceptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDuplicateExceptionsQuery, GetDuplicateExceptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDuplicateExceptionsQuery, GetDuplicateExceptionsQueryVariables>(GetDuplicateExceptionsDocument, baseOptions);
      }
export function useGetDuplicateExceptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDuplicateExceptionsQuery, GetDuplicateExceptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDuplicateExceptionsQuery, GetDuplicateExceptionsQueryVariables>(GetDuplicateExceptionsDocument, baseOptions);
        }
export type GetDuplicateExceptionsQueryHookResult = ReturnType<typeof useGetDuplicateExceptionsQuery>;
export type GetDuplicateExceptionsLazyQueryHookResult = ReturnType<typeof useGetDuplicateExceptionsLazyQuery>;
export type GetDuplicateExceptionsQueryResult = ApolloReactCommon.QueryResult<GetDuplicateExceptionsQuery, GetDuplicateExceptionsQueryVariables>;
export const UndoDuplicateExceptionDocument = gql`
    mutation UndoDuplicateException($id: String!) {
  undoDuplicateException(id: $id)
}
    `;
export type UndoDuplicateExceptionMutationFn = ApolloReactCommon.MutationFunction<UndoDuplicateExceptionMutation, UndoDuplicateExceptionMutationVariables>;

/**
 * __useUndoDuplicateExceptionMutation__
 *
 * To run a mutation, you first call `useUndoDuplicateExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoDuplicateExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoDuplicateExceptionMutation, { data, loading, error }] = useUndoDuplicateExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndoDuplicateExceptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndoDuplicateExceptionMutation, UndoDuplicateExceptionMutationVariables>) {
        return ApolloReactHooks.useMutation<UndoDuplicateExceptionMutation, UndoDuplicateExceptionMutationVariables>(UndoDuplicateExceptionDocument, baseOptions);
      }
export type UndoDuplicateExceptionMutationHookResult = ReturnType<typeof useUndoDuplicateExceptionMutation>;
export type UndoDuplicateExceptionMutationResult = ApolloReactCommon.MutationResult<UndoDuplicateExceptionMutation>;
export type UndoDuplicateExceptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UndoDuplicateExceptionMutation, UndoDuplicateExceptionMutationVariables>;
export const GetBookersExportDocument = gql`
    query GetBookersExport($options: ArrayDataOptions) {
  bookersExport(options: $options) {
    id
    customerNumberPrefix
    customerNumber
    firstname
    lastname
    street
    houseNumber
    postCode
    city
    email
    mobileNumber
    phoneNumber
    birthday
    gender
    initialContact
    healthInsuranceFund
    addition
    annotation
    credit
    nonDisclosureNotice
    attendees {
      id
      firstname
      lastname
      member
      addition
      annotation
    }
  }
}
    `;

/**
 * __useGetBookersExportQuery__
 *
 * To run a query within a React component, call `useGetBookersExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookersExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookersExportQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetBookersExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookersExportQuery, GetBookersExportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookersExportQuery, GetBookersExportQueryVariables>(GetBookersExportDocument, baseOptions);
      }
export function useGetBookersExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookersExportQuery, GetBookersExportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookersExportQuery, GetBookersExportQueryVariables>(GetBookersExportDocument, baseOptions);
        }
export type GetBookersExportQueryHookResult = ReturnType<typeof useGetBookersExportQuery>;
export type GetBookersExportLazyQueryHookResult = ReturnType<typeof useGetBookersExportLazyQuery>;
export type GetBookersExportQueryResult = ApolloReactCommon.QueryResult<GetBookersExportQuery, GetBookersExportQueryVariables>;
export const FindSimilarBookersDocument = gql`
    query FindSimilarBookers($firstname: String!, $lastname: String!, $email: String, $excludeBookerId: ID) {
  findSimilarBookers(firstname: $firstname, lastname: $lastname, email: $email, excludeBookerId: $excludeBookerId) {
    booker {
      id
      firstname
      lastname
      email
      customerNumber
      customerNumberPrefix
    }
    score
    matchReason
  }
}
    `;

/**
 * __useFindSimilarBookersQuery__
 *
 * To run a query within a React component, call `useFindSimilarBookersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSimilarBookersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSimilarBookersQuery({
 *   variables: {
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      email: // value for 'email'
 *      excludeBookerId: // value for 'excludeBookerId'
 *   },
 * });
 */
export function useFindSimilarBookersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindSimilarBookersQuery, FindSimilarBookersQueryVariables>) {
        return ApolloReactHooks.useQuery<FindSimilarBookersQuery, FindSimilarBookersQueryVariables>(FindSimilarBookersDocument, baseOptions);
      }
export function useFindSimilarBookersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindSimilarBookersQuery, FindSimilarBookersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindSimilarBookersQuery, FindSimilarBookersQueryVariables>(FindSimilarBookersDocument, baseOptions);
        }
export type FindSimilarBookersQueryHookResult = ReturnType<typeof useFindSimilarBookersQuery>;
export type FindSimilarBookersLazyQueryHookResult = ReturnType<typeof useFindSimilarBookersLazyQuery>;
export type FindSimilarBookersQueryResult = ApolloReactCommon.QueryResult<FindSimilarBookersQuery, FindSimilarBookersQueryVariables>;
export const GetDuplicateBookerGroupsDocument = gql`
    query GetDuplicateBookerGroups($limit: Float) {
  getDuplicateBookerGroups(limit: $limit) {
    bookers {
      id
      firstname
      lastname
      gender
      customerNumber
      customerNumberPrefix
      email
      userId
      addition
      street
      houseNumber
      postCode
      city
      initialContact
      dsgvo
      newsletter
      healthInsuranceFund
      annotation
      nonDisclosureNotice
      credit
      birthday
      updateDate
      createdBy
      createdByUser {
        id
        email
      }
    }
    matchInfo {
      score
      bestMatchType
      scoreBreakdown {
        exactEmail
        exactName
        fuzzyName
        samePhone
        sameAddress
        sameAttendee
        sameAttendeeMultiple
        differentEmail
        differentPhone
        differentAddress
        differentName
        missingName
        total
      }
    }
  }
}
    `;

/**
 * __useGetDuplicateBookerGroupsQuery__
 *
 * To run a query within a React component, call `useGetDuplicateBookerGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateBookerGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateBookerGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDuplicateBookerGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDuplicateBookerGroupsQuery, GetDuplicateBookerGroupsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDuplicateBookerGroupsQuery, GetDuplicateBookerGroupsQueryVariables>(GetDuplicateBookerGroupsDocument, baseOptions);
      }
export function useGetDuplicateBookerGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDuplicateBookerGroupsQuery, GetDuplicateBookerGroupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDuplicateBookerGroupsQuery, GetDuplicateBookerGroupsQueryVariables>(GetDuplicateBookerGroupsDocument, baseOptions);
        }
export type GetDuplicateBookerGroupsQueryHookResult = ReturnType<typeof useGetDuplicateBookerGroupsQuery>;
export type GetDuplicateBookerGroupsLazyQueryHookResult = ReturnType<typeof useGetDuplicateBookerGroupsLazyQuery>;
export type GetDuplicateBookerGroupsQueryResult = ApolloReactCommon.QueryResult<GetDuplicateBookerGroupsQuery, GetDuplicateBookerGroupsQueryVariables>;
export const GetDuplicateDetectionStatusDocument = gql`
    query GetDuplicateDetectionStatus {
  getDuplicateDetectionStatus {
    id
    status
    startedAt
    completedAt
    totalBookersProcessed
    duplicateMatchesFound
    errorMessage
    durationMs
  }
}
    `;

/**
 * __useGetDuplicateDetectionStatusQuery__
 *
 * To run a query within a React component, call `useGetDuplicateDetectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateDetectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateDetectionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDuplicateDetectionStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDuplicateDetectionStatusQuery, GetDuplicateDetectionStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDuplicateDetectionStatusQuery, GetDuplicateDetectionStatusQueryVariables>(GetDuplicateDetectionStatusDocument, baseOptions);
      }
export function useGetDuplicateDetectionStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDuplicateDetectionStatusQuery, GetDuplicateDetectionStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDuplicateDetectionStatusQuery, GetDuplicateDetectionStatusQueryVariables>(GetDuplicateDetectionStatusDocument, baseOptions);
        }
export type GetDuplicateDetectionStatusQueryHookResult = ReturnType<typeof useGetDuplicateDetectionStatusQuery>;
export type GetDuplicateDetectionStatusLazyQueryHookResult = ReturnType<typeof useGetDuplicateDetectionStatusLazyQuery>;
export type GetDuplicateDetectionStatusQueryResult = ApolloReactCommon.QueryResult<GetDuplicateDetectionStatusQuery, GetDuplicateDetectionStatusQueryVariables>;
export const TriggerDuplicateDetectionDocument = gql`
    mutation TriggerDuplicateDetection {
  triggerDuplicateDetection
}
    `;
export type TriggerDuplicateDetectionMutationFn = ApolloReactCommon.MutationFunction<TriggerDuplicateDetectionMutation, TriggerDuplicateDetectionMutationVariables>;

/**
 * __useTriggerDuplicateDetectionMutation__
 *
 * To run a mutation, you first call `useTriggerDuplicateDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDuplicateDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDuplicateDetectionMutation, { data, loading, error }] = useTriggerDuplicateDetectionMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerDuplicateDetectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerDuplicateDetectionMutation, TriggerDuplicateDetectionMutationVariables>) {
        return ApolloReactHooks.useMutation<TriggerDuplicateDetectionMutation, TriggerDuplicateDetectionMutationVariables>(TriggerDuplicateDetectionDocument, baseOptions);
      }
export type TriggerDuplicateDetectionMutationHookResult = ReturnType<typeof useTriggerDuplicateDetectionMutation>;
export type TriggerDuplicateDetectionMutationResult = ApolloReactCommon.MutationResult<TriggerDuplicateDetectionMutation>;
export type TriggerDuplicateDetectionMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerDuplicateDetectionMutation, TriggerDuplicateDetectionMutationVariables>;
export const GetBookerMergeHistoryDocument = gql`
    query GetBookerMergeHistory($bookerId: String!) {
  bookerMergeHistoryByBookerId(bookerId: $bookerId) {
    id
    description
    winnerBookerId
    userId
    userName
    loserSnapshot
    createDate
  }
}
    `;

/**
 * __useGetBookerMergeHistoryQuery__
 *
 * To run a query within a React component, call `useGetBookerMergeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookerMergeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookerMergeHistoryQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useGetBookerMergeHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookerMergeHistoryQuery, GetBookerMergeHistoryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookerMergeHistoryQuery, GetBookerMergeHistoryQueryVariables>(GetBookerMergeHistoryDocument, baseOptions);
      }
export function useGetBookerMergeHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookerMergeHistoryQuery, GetBookerMergeHistoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookerMergeHistoryQuery, GetBookerMergeHistoryQueryVariables>(GetBookerMergeHistoryDocument, baseOptions);
        }
export type GetBookerMergeHistoryQueryHookResult = ReturnType<typeof useGetBookerMergeHistoryQuery>;
export type GetBookerMergeHistoryLazyQueryHookResult = ReturnType<typeof useGetBookerMergeHistoryLazyQuery>;
export type GetBookerMergeHistoryQueryResult = ApolloReactCommon.QueryResult<GetBookerMergeHistoryQuery, GetBookerMergeHistoryQueryVariables>;
export const MergeAttendeesDocument = gql`
    mutation MergeAttendees($winnerAttendeeId: ID!, $loserAttendeeId: ID!, $selectedFields: AttendeeMergeFieldsInput) {
  mergeAttendees(winnerAttendeeId: $winnerAttendeeId, loserAttendeeId: $loserAttendeeId, selectedFields: $selectedFields) {
    success
    bookingsTransferred
    duplicateBookingsInSameCourse
    winnerAttendeeId
  }
}
    `;
export type MergeAttendeesMutationFn = ApolloReactCommon.MutationFunction<MergeAttendeesMutation, MergeAttendeesMutationVariables>;

/**
 * __useMergeAttendeesMutation__
 *
 * To run a mutation, you first call `useMergeAttendeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeAttendeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeAttendeesMutation, { data, loading, error }] = useMergeAttendeesMutation({
 *   variables: {
 *      winnerAttendeeId: // value for 'winnerAttendeeId'
 *      loserAttendeeId: // value for 'loserAttendeeId'
 *      selectedFields: // value for 'selectedFields'
 *   },
 * });
 */
export function useMergeAttendeesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeAttendeesMutation, MergeAttendeesMutationVariables>) {
        return ApolloReactHooks.useMutation<MergeAttendeesMutation, MergeAttendeesMutationVariables>(MergeAttendeesDocument, baseOptions);
      }
export type MergeAttendeesMutationHookResult = ReturnType<typeof useMergeAttendeesMutation>;
export type MergeAttendeesMutationResult = ApolloReactCommon.MutationResult<MergeAttendeesMutation>;
export type MergeAttendeesMutationOptions = ApolloReactCommon.BaseMutationOptions<MergeAttendeesMutation, MergeAttendeesMutationVariables>;
export const BookingEligibilityDiagnosisDocument = gql`
    query BookingEligibilityDiagnosis($attendeeId: ID!, $courseId: ID!) {
  bookingEligibilityDiagnosis(attendeeId: $attendeeId, courseId: $courseId) {
    attendeeId
    courseId
    canBook
    reason
    blockingCheckKeys
    visibleInStandardList
    visibleViaPrerequisiteLinks {
      courseId
      prefixedCourseNumber
      visible
      link
    }
    checks {
      key
      status
      params
    }
  }
}
    `;

/**
 * __useBookingEligibilityDiagnosisQuery__
 *
 * To run a query within a React component, call `useBookingEligibilityDiagnosisQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEligibilityDiagnosisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEligibilityDiagnosisQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useBookingEligibilityDiagnosisQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingEligibilityDiagnosisQuery, BookingEligibilityDiagnosisQueryVariables>) {
        return ApolloReactHooks.useQuery<BookingEligibilityDiagnosisQuery, BookingEligibilityDiagnosisQueryVariables>(BookingEligibilityDiagnosisDocument, baseOptions);
      }
export function useBookingEligibilityDiagnosisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingEligibilityDiagnosisQuery, BookingEligibilityDiagnosisQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookingEligibilityDiagnosisQuery, BookingEligibilityDiagnosisQueryVariables>(BookingEligibilityDiagnosisDocument, baseOptions);
        }
export type BookingEligibilityDiagnosisQueryHookResult = ReturnType<typeof useBookingEligibilityDiagnosisQuery>;
export type BookingEligibilityDiagnosisLazyQueryHookResult = ReturnType<typeof useBookingEligibilityDiagnosisLazyQuery>;
export type BookingEligibilityDiagnosisQueryResult = ApolloReactCommon.QueryResult<BookingEligibilityDiagnosisQuery, BookingEligibilityDiagnosisQueryVariables>;
export const BookingEligibilityCandidatesDocument = gql`
    query BookingEligibilityCandidates($attendeeId: ID!) {
  bookingEligibilityCandidates(attendeeId: $attendeeId) {
    courseId
    prefixedCourseNumber
    courseTypeName
    courseTypeColor
    locationName
    startDateTime
    freePlaces
    prerequisiteCourseIds
    prerequisitePrefixedCourseNumbers
    satisfiedByAttendeeIds
    diagnosis {
      attendeeId
      courseId
      canBook
      reason
      blockingCheckKeys
      visibleInStandardList
      visibleViaPrerequisiteLinks {
        courseId
        prefixedCourseNumber
        visible
        link
      }
      checks {
        key
        status
        params
      }
    }
  }
}
    `;

/**
 * __useBookingEligibilityCandidatesQuery__
 *
 * To run a query within a React component, call `useBookingEligibilityCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEligibilityCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEligibilityCandidatesQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useBookingEligibilityCandidatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingEligibilityCandidatesQuery, BookingEligibilityCandidatesQueryVariables>) {
        return ApolloReactHooks.useQuery<BookingEligibilityCandidatesQuery, BookingEligibilityCandidatesQueryVariables>(BookingEligibilityCandidatesDocument, baseOptions);
      }
export function useBookingEligibilityCandidatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingEligibilityCandidatesQuery, BookingEligibilityCandidatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookingEligibilityCandidatesQuery, BookingEligibilityCandidatesQueryVariables>(BookingEligibilityCandidatesDocument, baseOptions);
        }
export type BookingEligibilityCandidatesQueryHookResult = ReturnType<typeof useBookingEligibilityCandidatesQuery>;
export type BookingEligibilityCandidatesLazyQueryHookResult = ReturnType<typeof useBookingEligibilityCandidatesLazyQuery>;
export type BookingEligibilityCandidatesQueryResult = ApolloReactCommon.QueryResult<BookingEligibilityCandidatesQuery, BookingEligibilityCandidatesQueryVariables>;
export const GetAttendeeMergeHistoryByBookerIdDocument = gql`
    query GetAttendeeMergeHistoryByBookerId($bookerId: String!) {
  attendeeMergeHistoryByBookerId(bookerId: $bookerId) {
    id
    description
    loserSnapshot
    winnerAttendeeId
    bookerId
    userId
    userName
    createDate
  }
}
    `;

/**
 * __useGetAttendeeMergeHistoryByBookerIdQuery__
 *
 * To run a query within a React component, call `useGetAttendeeMergeHistoryByBookerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeMergeHistoryByBookerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeMergeHistoryByBookerIdQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useGetAttendeeMergeHistoryByBookerIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendeeMergeHistoryByBookerIdQuery, GetAttendeeMergeHistoryByBookerIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendeeMergeHistoryByBookerIdQuery, GetAttendeeMergeHistoryByBookerIdQueryVariables>(GetAttendeeMergeHistoryByBookerIdDocument, baseOptions);
      }
export function useGetAttendeeMergeHistoryByBookerIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendeeMergeHistoryByBookerIdQuery, GetAttendeeMergeHistoryByBookerIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendeeMergeHistoryByBookerIdQuery, GetAttendeeMergeHistoryByBookerIdQueryVariables>(GetAttendeeMergeHistoryByBookerIdDocument, baseOptions);
        }
export type GetAttendeeMergeHistoryByBookerIdQueryHookResult = ReturnType<typeof useGetAttendeeMergeHistoryByBookerIdQuery>;
export type GetAttendeeMergeHistoryByBookerIdLazyQueryHookResult = ReturnType<typeof useGetAttendeeMergeHistoryByBookerIdLazyQuery>;
export type GetAttendeeMergeHistoryByBookerIdQueryResult = ApolloReactCommon.QueryResult<GetAttendeeMergeHistoryByBookerIdQuery, GetAttendeeMergeHistoryByBookerIdQueryVariables>;
export const CustomerTimelineDocument = gql`
    query CustomerTimeline($bookerId: ID!, $since: DateTime, $limit: Int) {
  customerTimeline(bookerId: $bookerId, since: $since, limit: $limit) {
    id
    at
    kind
    type
    code
    source
    params
    actorName
    attendeeId
    courseId
    bookingId
    bookingIsSettled
    bookingAllowsLessonBooking
  }
}
    `;

/**
 * __useCustomerTimelineQuery__
 *
 * To run a query within a React component, call `useCustomerTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTimelineQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerTimelineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomerTimelineQuery, CustomerTimelineQueryVariables>) {
        return ApolloReactHooks.useQuery<CustomerTimelineQuery, CustomerTimelineQueryVariables>(CustomerTimelineDocument, baseOptions);
      }
export function useCustomerTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerTimelineQuery, CustomerTimelineQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CustomerTimelineQuery, CustomerTimelineQueryVariables>(CustomerTimelineDocument, baseOptions);
        }
export type CustomerTimelineQueryHookResult = ReturnType<typeof useCustomerTimelineQuery>;
export type CustomerTimelineLazyQueryHookResult = ReturnType<typeof useCustomerTimelineLazyQuery>;
export type CustomerTimelineQueryResult = ApolloReactCommon.QueryResult<CustomerTimelineQuery, CustomerTimelineQueryVariables>;
export const GetMollieKpisDocument = gql`
    query getMollieKpis {
  getMollieKpis {
    openLinksCount
    openLinksSum
    chargebacks30dCount
    chargebacks30dFee
    successRate30d
    avgCheckoutToPaidHours
  }
}
    `;

/**
 * __useGetMollieKpisQuery__
 *
 * To run a query within a React component, call `useGetMollieKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMollieKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMollieKpisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMollieKpisQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMollieKpisQuery, GetMollieKpisQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMollieKpisQuery, GetMollieKpisQueryVariables>(GetMollieKpisDocument, baseOptions);
      }
export function useGetMollieKpisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMollieKpisQuery, GetMollieKpisQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMollieKpisQuery, GetMollieKpisQueryVariables>(GetMollieKpisDocument, baseOptions);
        }
export type GetMollieKpisQueryHookResult = ReturnType<typeof useGetMollieKpisQuery>;
export type GetMollieKpisLazyQueryHookResult = ReturnType<typeof useGetMollieKpisLazyQuery>;
export type GetMollieKpisQueryResult = ApolloReactCommon.QueryResult<GetMollieKpisQuery, GetMollieKpisQueryVariables>;
export const GetOnlineRegisteredBookersDocument = gql`
    query getOnlineRegisteredBookers($startDateTime: DateTime, $endDateTime: DateTime, $limit: Int, $offset: Int) {
  getOnlineRegisteredBookers(startDateTime: $startDateTime, endDateTime: $endDateTime, limit: $limit, offset: $offset) {
    total
    items {
      id
      firstname
      lastname
      email
      mobileNumber
      createDate
      attendeesCount
      activeBookingsCount
      leadStatus
      attendees {
        id
        firstname
        lastname
      }
    }
  }
}
    `;

/**
 * __useGetOnlineRegisteredBookersQuery__
 *
 * To run a query within a React component, call `useGetOnlineRegisteredBookersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnlineRegisteredBookersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnlineRegisteredBookersQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetOnlineRegisteredBookersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOnlineRegisteredBookersQuery, GetOnlineRegisteredBookersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOnlineRegisteredBookersQuery, GetOnlineRegisteredBookersQueryVariables>(GetOnlineRegisteredBookersDocument, baseOptions);
      }
export function useGetOnlineRegisteredBookersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnlineRegisteredBookersQuery, GetOnlineRegisteredBookersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOnlineRegisteredBookersQuery, GetOnlineRegisteredBookersQueryVariables>(GetOnlineRegisteredBookersDocument, baseOptions);
        }
export type GetOnlineRegisteredBookersQueryHookResult = ReturnType<typeof useGetOnlineRegisteredBookersQuery>;
export type GetOnlineRegisteredBookersLazyQueryHookResult = ReturnType<typeof useGetOnlineRegisteredBookersLazyQuery>;
export type GetOnlineRegisteredBookersQueryResult = ApolloReactCommon.QueryResult<GetOnlineRegisteredBookersQuery, GetOnlineRegisteredBookersQueryVariables>;
export const GetOnlineBookingsByTimeRangeCountDocument = gql`
    query getOnlineBookingsByTimeRangeCount($startDateTime: DateTime!, $endDateTime: DateTime!) {
  getOnlineBookingsByTimeRangeCount(startDateTime: $startDateTime, endDateTime: $endDateTime)
}
    `;

/**
 * __useGetOnlineBookingsByTimeRangeCountQuery__
 *
 * To run a query within a React component, call `useGetOnlineBookingsByTimeRangeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnlineBookingsByTimeRangeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnlineBookingsByTimeRangeCountQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useGetOnlineBookingsByTimeRangeCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOnlineBookingsByTimeRangeCountQuery, GetOnlineBookingsByTimeRangeCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOnlineBookingsByTimeRangeCountQuery, GetOnlineBookingsByTimeRangeCountQueryVariables>(GetOnlineBookingsByTimeRangeCountDocument, baseOptions);
      }
export function useGetOnlineBookingsByTimeRangeCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnlineBookingsByTimeRangeCountQuery, GetOnlineBookingsByTimeRangeCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOnlineBookingsByTimeRangeCountQuery, GetOnlineBookingsByTimeRangeCountQueryVariables>(GetOnlineBookingsByTimeRangeCountDocument, baseOptions);
        }
export type GetOnlineBookingsByTimeRangeCountQueryHookResult = ReturnType<typeof useGetOnlineBookingsByTimeRangeCountQuery>;
export type GetOnlineBookingsByTimeRangeCountLazyQueryHookResult = ReturnType<typeof useGetOnlineBookingsByTimeRangeCountLazyQuery>;
export type GetOnlineBookingsByTimeRangeCountQueryResult = ApolloReactCommon.QueryResult<GetOnlineBookingsByTimeRangeCountQuery, GetOnlineBookingsByTimeRangeCountQueryVariables>;
export const GetOnlineBookingsByTimeRangeSeriesDocument = gql`
    query GetOnlineBookingsByTimeRangeSeries($startDateTime: DateTime!, $endDateTime: DateTime!, $buckets: Int!) {
  getOnlineBookingsByTimeRangeSeries(startDateTime: $startDateTime, endDateTime: $endDateTime, buckets: $buckets)
}
    `;

/**
 * __useGetOnlineBookingsByTimeRangeSeriesQuery__
 *
 * To run a query within a React component, call `useGetOnlineBookingsByTimeRangeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnlineBookingsByTimeRangeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnlineBookingsByTimeRangeSeriesQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      buckets: // value for 'buckets'
 *   },
 * });
 */
export function useGetOnlineBookingsByTimeRangeSeriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOnlineBookingsByTimeRangeSeriesQuery, GetOnlineBookingsByTimeRangeSeriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOnlineBookingsByTimeRangeSeriesQuery, GetOnlineBookingsByTimeRangeSeriesQueryVariables>(GetOnlineBookingsByTimeRangeSeriesDocument, baseOptions);
      }
export function useGetOnlineBookingsByTimeRangeSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnlineBookingsByTimeRangeSeriesQuery, GetOnlineBookingsByTimeRangeSeriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOnlineBookingsByTimeRangeSeriesQuery, GetOnlineBookingsByTimeRangeSeriesQueryVariables>(GetOnlineBookingsByTimeRangeSeriesDocument, baseOptions);
        }
export type GetOnlineBookingsByTimeRangeSeriesQueryHookResult = ReturnType<typeof useGetOnlineBookingsByTimeRangeSeriesQuery>;
export type GetOnlineBookingsByTimeRangeSeriesLazyQueryHookResult = ReturnType<typeof useGetOnlineBookingsByTimeRangeSeriesLazyQuery>;
export type GetOnlineBookingsByTimeRangeSeriesQueryResult = ApolloReactCommon.QueryResult<GetOnlineBookingsByTimeRangeSeriesQuery, GetOnlineBookingsByTimeRangeSeriesQueryVariables>;
export const GetUpcomingCoursesByTimeRangeDocument = gql`
    query GetUpcomingCoursesByTimeRange($startDateTime: DateTime!, $endDateTime: DateTime!, $options: ArrayDataOptions) {
  getUpcomingCoursesByTimeRange(startDateTime: $startDateTime, endDateTime: $endDateTime, options: $options) {
    existsMore
    total
    items {
      id
      startDateTime
      prefixedCourseNumber
      maxAttendees
      minAttendees
      freePlaces
      bookingCount
      waitListCount
      placeReservationsCount
      courseType {
        id
        name
        color
      }
      location {
        id
        name
        city
      }
      instructors {
        id
        firstname
        lastname
      }
    }
  }
}
    `;

/**
 * __useGetUpcomingCoursesByTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetUpcomingCoursesByTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingCoursesByTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingCoursesByTimeRangeQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetUpcomingCoursesByTimeRangeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUpcomingCoursesByTimeRangeQuery, GetUpcomingCoursesByTimeRangeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUpcomingCoursesByTimeRangeQuery, GetUpcomingCoursesByTimeRangeQueryVariables>(GetUpcomingCoursesByTimeRangeDocument, baseOptions);
      }
export function useGetUpcomingCoursesByTimeRangeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUpcomingCoursesByTimeRangeQuery, GetUpcomingCoursesByTimeRangeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUpcomingCoursesByTimeRangeQuery, GetUpcomingCoursesByTimeRangeQueryVariables>(GetUpcomingCoursesByTimeRangeDocument, baseOptions);
        }
export type GetUpcomingCoursesByTimeRangeQueryHookResult = ReturnType<typeof useGetUpcomingCoursesByTimeRangeQuery>;
export type GetUpcomingCoursesByTimeRangeLazyQueryHookResult = ReturnType<typeof useGetUpcomingCoursesByTimeRangeLazyQuery>;
export type GetUpcomingCoursesByTimeRangeQueryResult = ApolloReactCommon.QueryResult<GetUpcomingCoursesByTimeRangeQuery, GetUpcomingCoursesByTimeRangeQueryVariables>;
export const GetUpcomingCoursesOccupancyDocument = gql`
    query GetUpcomingCoursesOccupancy($startDateTime: DateTime!, $endDateTime: DateTime!) {
  getUpcomingCoursesOccupancy(startDateTime: $startDateTime, endDateTime: $endDateTime) {
    courseCount
    bookedPlaces
    totalPlaces
  }
}
    `;

/**
 * __useGetUpcomingCoursesOccupancyQuery__
 *
 * To run a query within a React component, call `useGetUpcomingCoursesOccupancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingCoursesOccupancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingCoursesOccupancyQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useGetUpcomingCoursesOccupancyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUpcomingCoursesOccupancyQuery, GetUpcomingCoursesOccupancyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUpcomingCoursesOccupancyQuery, GetUpcomingCoursesOccupancyQueryVariables>(GetUpcomingCoursesOccupancyDocument, baseOptions);
      }
export function useGetUpcomingCoursesOccupancyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUpcomingCoursesOccupancyQuery, GetUpcomingCoursesOccupancyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUpcomingCoursesOccupancyQuery, GetUpcomingCoursesOccupancyQueryVariables>(GetUpcomingCoursesOccupancyDocument, baseOptions);
        }
export type GetUpcomingCoursesOccupancyQueryHookResult = ReturnType<typeof useGetUpcomingCoursesOccupancyQuery>;
export type GetUpcomingCoursesOccupancyLazyQueryHookResult = ReturnType<typeof useGetUpcomingCoursesOccupancyLazyQuery>;
export type GetUpcomingCoursesOccupancyQueryResult = ApolloReactCommon.QueryResult<GetUpcomingCoursesOccupancyQuery, GetUpcomingCoursesOccupancyQueryVariables>;
export const GetCoursesWithHighDemandDocument = gql`
    query GetCoursesWithHighDemand($options: ArrayDataOptions, $onlyUpcoming: Boolean) {
  getCoursesWithHighDemand(options: $options, onlyUpcoming: $onlyUpcoming) {
    existsMore
    total
    items {
      id
      maxAttendees
      waitListCount
      bookingCount
      prefixedCourseNumber
      startDateTime
      location {
        id
        name
      }
      courseType {
        id
        name
        color
      }
    }
  }
}
    `;

/**
 * __useGetCoursesWithHighDemandQuery__
 *
 * To run a query within a React component, call `useGetCoursesWithHighDemandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesWithHighDemandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesWithHighDemandQuery({
 *   variables: {
 *      options: // value for 'options'
 *      onlyUpcoming: // value for 'onlyUpcoming'
 *   },
 * });
 */
export function useGetCoursesWithHighDemandQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoursesWithHighDemandQuery, GetCoursesWithHighDemandQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoursesWithHighDemandQuery, GetCoursesWithHighDemandQueryVariables>(GetCoursesWithHighDemandDocument, baseOptions);
      }
export function useGetCoursesWithHighDemandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoursesWithHighDemandQuery, GetCoursesWithHighDemandQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoursesWithHighDemandQuery, GetCoursesWithHighDemandQueryVariables>(GetCoursesWithHighDemandDocument, baseOptions);
        }
export type GetCoursesWithHighDemandQueryHookResult = ReturnType<typeof useGetCoursesWithHighDemandQuery>;
export type GetCoursesWithHighDemandLazyQueryHookResult = ReturnType<typeof useGetCoursesWithHighDemandLazyQuery>;
export type GetCoursesWithHighDemandQueryResult = ApolloReactCommon.QueryResult<GetCoursesWithHighDemandQuery, GetCoursesWithHighDemandQueryVariables>;
export const SendSimpleEmailDocument = gql`
    mutation SendSimpleEmail($sendParamsMessageInput: SendParamsMessageInput!, $sandboxMode: Boolean!) {
  sendMail(sendParamsMessageInput: $sendParamsMessageInput, sandboxMode: $sandboxMode)
}
    `;
export type SendSimpleEmailMutationFn = ApolloReactCommon.MutationFunction<SendSimpleEmailMutation, SendSimpleEmailMutationVariables>;

/**
 * __useSendSimpleEmailMutation__
 *
 * To run a mutation, you first call `useSendSimpleEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSimpleEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSimpleEmailMutation, { data, loading, error }] = useSendSimpleEmailMutation({
 *   variables: {
 *      sendParamsMessageInput: // value for 'sendParamsMessageInput'
 *      sandboxMode: // value for 'sandboxMode'
 *   },
 * });
 */
export function useSendSimpleEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSimpleEmailMutation, SendSimpleEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendSimpleEmailMutation, SendSimpleEmailMutationVariables>(SendSimpleEmailDocument, baseOptions);
      }
export type SendSimpleEmailMutationHookResult = ReturnType<typeof useSendSimpleEmailMutation>;
export type SendSimpleEmailMutationResult = ApolloReactCommon.MutationResult<SendSimpleEmailMutation>;
export type SendSimpleEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendSimpleEmailMutation, SendSimpleEmailMutationVariables>;
export const FaUserByEmailDocument = gql`
    query FaUserByEmail($email: String!) {
  faUserByEmail(email: $email) {
    id
    lastLoginInstant
    passwordLastUpdateInstant
    verified
    active
    email
    firstName
    lastName
    fullName
    imageUrl
    insertInstant
    lastUpdateInstant
    registrations {
      applicationId
      data
      id
      insertInstant
      lastLoginInstant
      lastUpdateInstant
      roles
      username
      verified
    }
    tenantId
    timezone
  }
}
    `;

/**
 * __useFaUserByEmailQuery__
 *
 * To run a query within a React component, call `useFaUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFaUserByEmailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FaUserByEmailQuery, FaUserByEmailQueryVariables>) {
        return ApolloReactHooks.useQuery<FaUserByEmailQuery, FaUserByEmailQueryVariables>(FaUserByEmailDocument, baseOptions);
      }
export function useFaUserByEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FaUserByEmailQuery, FaUserByEmailQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FaUserByEmailQuery, FaUserByEmailQueryVariables>(FaUserByEmailDocument, baseOptions);
        }
export type FaUserByEmailQueryHookResult = ReturnType<typeof useFaUserByEmailQuery>;
export type FaUserByEmailLazyQueryHookResult = ReturnType<typeof useFaUserByEmailLazyQuery>;
export type FaUserByEmailQueryResult = ApolloReactCommon.QueryResult<FaUserByEmailQuery, FaUserByEmailQueryVariables>;
export const FaUserByUserIdDocument = gql`
    query FaUserByUserId($userId: String!) {
  faUserByUserId(userId: $userId) {
    id
    lastLoginInstant
    passwordLastUpdateInstant
    verified
    active
    email
    firstName
    lastName
    fullName
    imageUrl
    insertInstant
    lastUpdateInstant
    registrations {
      applicationId
      data
      id
      insertInstant
      lastLoginInstant
      lastUpdateInstant
      roles
      username
      verified
    }
    tenantId
    timezone
  }
}
    `;

/**
 * __useFaUserByUserIdQuery__
 *
 * To run a query within a React component, call `useFaUserByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaUserByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaUserByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFaUserByUserIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FaUserByUserIdQuery, FaUserByUserIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FaUserByUserIdQuery, FaUserByUserIdQueryVariables>(FaUserByUserIdDocument, baseOptions);
      }
export function useFaUserByUserIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FaUserByUserIdQuery, FaUserByUserIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FaUserByUserIdQuery, FaUserByUserIdQueryVariables>(FaUserByUserIdDocument, baseOptions);
        }
export type FaUserByUserIdQueryHookResult = ReturnType<typeof useFaUserByUserIdQuery>;
export type FaUserByUserIdLazyQueryHookResult = ReturnType<typeof useFaUserByUserIdLazyQuery>;
export type FaUserByUserIdQueryResult = ApolloReactCommon.QueryResult<FaUserByUserIdQuery, FaUserByUserIdQueryVariables>;
export const CreateFaUserWithOrAddEndUserRightsDocument = gql`
    mutation CreateFaUserWithOrAddEndUserRights($email: String!) {
  createFaUserWithOrAddEndUserRights(email: $email) {
    id
    lastLoginInstant
    passwordLastUpdateInstant
    verified
    active
    email
    firstName
    lastName
    fullName
    imageUrl
    insertInstant
    lastUpdateInstant
    registrations {
      applicationId
      data
      id
      insertInstant
      lastLoginInstant
      lastUpdateInstant
      roles
      username
      verified
    }
    tenantId
    timezone
  }
}
    `;
export type CreateFaUserWithOrAddEndUserRightsMutationFn = ApolloReactCommon.MutationFunction<CreateFaUserWithOrAddEndUserRightsMutation, CreateFaUserWithOrAddEndUserRightsMutationVariables>;

/**
 * __useCreateFaUserWithOrAddEndUserRightsMutation__
 *
 * To run a mutation, you first call `useCreateFaUserWithOrAddEndUserRightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaUserWithOrAddEndUserRightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaUserWithOrAddEndUserRightsMutation, { data, loading, error }] = useCreateFaUserWithOrAddEndUserRightsMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateFaUserWithOrAddEndUserRightsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFaUserWithOrAddEndUserRightsMutation, CreateFaUserWithOrAddEndUserRightsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFaUserWithOrAddEndUserRightsMutation, CreateFaUserWithOrAddEndUserRightsMutationVariables>(CreateFaUserWithOrAddEndUserRightsDocument, baseOptions);
      }
export type CreateFaUserWithOrAddEndUserRightsMutationHookResult = ReturnType<typeof useCreateFaUserWithOrAddEndUserRightsMutation>;
export type CreateFaUserWithOrAddEndUserRightsMutationResult = ApolloReactCommon.MutationResult<CreateFaUserWithOrAddEndUserRightsMutation>;
export type CreateFaUserWithOrAddEndUserRightsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFaUserWithOrAddEndUserRightsMutation, CreateFaUserWithOrAddEndUserRightsMutationVariables>;
export const AddFaUserByBookerIdDocument = gql`
    mutation AddFaUserByBookerId($bookerId: String!, $linkExistingAccountConfirmed: Boolean) {
  addFaUserByBookerId(bookerId: $bookerId, linkExistingAccountConfirmed: $linkExistingAccountConfirmed) {
    id
    lastLoginInstant
    passwordLastUpdateInstant
    verified
    active
    email
    firstName
    lastName
    fullName
    imageUrl
    insertInstant
    lastUpdateInstant
    registrations {
      applicationId
      data
      id
      insertInstant
      lastLoginInstant
      lastUpdateInstant
      roles
      username
      verified
    }
    tenantId
    timezone
  }
}
    `;
export type AddFaUserByBookerIdMutationFn = ApolloReactCommon.MutationFunction<AddFaUserByBookerIdMutation, AddFaUserByBookerIdMutationVariables>;

/**
 * __useAddFaUserByBookerIdMutation__
 *
 * To run a mutation, you first call `useAddFaUserByBookerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFaUserByBookerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFaUserByBookerIdMutation, { data, loading, error }] = useAddFaUserByBookerIdMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      linkExistingAccountConfirmed: // value for 'linkExistingAccountConfirmed'
 *   },
 * });
 */
export function useAddFaUserByBookerIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFaUserByBookerIdMutation, AddFaUserByBookerIdMutationVariables>) {
        return ApolloReactHooks.useMutation<AddFaUserByBookerIdMutation, AddFaUserByBookerIdMutationVariables>(AddFaUserByBookerIdDocument, baseOptions);
      }
export type AddFaUserByBookerIdMutationHookResult = ReturnType<typeof useAddFaUserByBookerIdMutation>;
export type AddFaUserByBookerIdMutationResult = ApolloReactCommon.MutationResult<AddFaUserByBookerIdMutation>;
export type AddFaUserByBookerIdMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFaUserByBookerIdMutation, AddFaUserByBookerIdMutationVariables>;
export const CheckEmailUniquenessDocument = gql`
    query checkEmailUniqueness($email: String!) {
  checkEmailUniqueness(email: $email)
}
    `;

/**
 * __useCheckEmailUniquenessQuery__
 *
 * To run a query within a React component, call `useCheckEmailUniquenessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailUniquenessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailUniquenessQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckEmailUniquenessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckEmailUniquenessQuery, CheckEmailUniquenessQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckEmailUniquenessQuery, CheckEmailUniquenessQueryVariables>(CheckEmailUniquenessDocument, baseOptions);
      }
export function useCheckEmailUniquenessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckEmailUniquenessQuery, CheckEmailUniquenessQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckEmailUniquenessQuery, CheckEmailUniquenessQueryVariables>(CheckEmailUniquenessDocument, baseOptions);
        }
export type CheckEmailUniquenessQueryHookResult = ReturnType<typeof useCheckEmailUniquenessQuery>;
export type CheckEmailUniquenessLazyQueryHookResult = ReturnType<typeof useCheckEmailUniquenessLazyQuery>;
export type CheckEmailUniquenessQueryResult = ApolloReactCommon.QueryResult<CheckEmailUniquenessQuery, CheckEmailUniquenessQueryVariables>;
export const AccountLinksDocument = gql`
    query AccountLinks($userId: String!) {
  accountLinks(userId: $userId) {
    bookers {
      id
      firstname
      lastname
      customerNumber
    }
    staff {
      id
      firstname
      lastname
      roles
    }
  }
}
    `;

/**
 * __useAccountLinksQuery__
 *
 * To run a query within a React component, call `useAccountLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLinksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountLinksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountLinksQuery, AccountLinksQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountLinksQuery, AccountLinksQueryVariables>(AccountLinksDocument, baseOptions);
      }
export function useAccountLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountLinksQuery, AccountLinksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountLinksQuery, AccountLinksQueryVariables>(AccountLinksDocument, baseOptions);
        }
export type AccountLinksQueryHookResult = ReturnType<typeof useAccountLinksQuery>;
export type AccountLinksLazyQueryHookResult = ReturnType<typeof useAccountLinksLazyQuery>;
export type AccountLinksQueryResult = ApolloReactCommon.QueryResult<AccountLinksQuery, AccountLinksQueryVariables>;
export const AccountForEmailDocument = gql`
    query AccountForEmail($email: String!, $excludeBookerId: String) {
  accountForEmail(email: $email, excludeBookerId: $excludeBookerId) {
    userId
    email
    roles
    displayName
    isStaffAccount
    callerMayLink
    linkedBooker {
      id
      firstname
      lastname
      customerNumber
    }
  }
}
    `;

/**
 * __useAccountForEmailQuery__
 *
 * To run a query within a React component, call `useAccountForEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountForEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountForEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      excludeBookerId: // value for 'excludeBookerId'
 *   },
 * });
 */
export function useAccountForEmailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountForEmailQuery, AccountForEmailQueryVariables>) {
        return ApolloReactHooks.useQuery<AccountForEmailQuery, AccountForEmailQueryVariables>(AccountForEmailDocument, baseOptions);
      }
export function useAccountForEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountForEmailQuery, AccountForEmailQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccountForEmailQuery, AccountForEmailQueryVariables>(AccountForEmailDocument, baseOptions);
        }
export type AccountForEmailQueryHookResult = ReturnType<typeof useAccountForEmailQuery>;
export type AccountForEmailLazyQueryHookResult = ReturnType<typeof useAccountForEmailLazyQuery>;
export type AccountForEmailQueryResult = ApolloReactCommon.QueryResult<AccountForEmailQuery, AccountForEmailQueryVariables>;
export const GetHolidaysByStateCodeDocument = gql`
    query GetHolidaysByStateCode($stateCode: StateCode!) {
  holidaysByStateCode(stateCode: $stateCode) {
    id
    name
    slug
    start
    end
    year
    stateCode
    countryCode
    holidayStateColor
    type
    days
    color
  }
}
    `;

/**
 * __useGetHolidaysByStateCodeQuery__
 *
 * To run a query within a React component, call `useGetHolidaysByStateCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidaysByStateCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidaysByStateCodeQuery({
 *   variables: {
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useGetHolidaysByStateCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHolidaysByStateCodeQuery, GetHolidaysByStateCodeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetHolidaysByStateCodeQuery, GetHolidaysByStateCodeQueryVariables>(GetHolidaysByStateCodeDocument, baseOptions);
      }
export function useGetHolidaysByStateCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHolidaysByStateCodeQuery, GetHolidaysByStateCodeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetHolidaysByStateCodeQuery, GetHolidaysByStateCodeQueryVariables>(GetHolidaysByStateCodeDocument, baseOptions);
        }
export type GetHolidaysByStateCodeQueryHookResult = ReturnType<typeof useGetHolidaysByStateCodeQuery>;
export type GetHolidaysByStateCodeLazyQueryHookResult = ReturnType<typeof useGetHolidaysByStateCodeLazyQuery>;
export type GetHolidaysByStateCodeQueryResult = ApolloReactCommon.QueryResult<GetHolidaysByStateCodeQuery, GetHolidaysByStateCodeQueryVariables>;
export const GetHolidaysByCompanyDocument = gql`
    query GetHolidaysByCompany {
  holidaysByCompany {
    id
    name
    slug
    start
    end
    year
    stateCode
    countryCode
    holidayStateColor
    type
    days
    color
  }
}
    `;

/**
 * __useGetHolidaysByCompanyQuery__
 *
 * To run a query within a React component, call `useGetHolidaysByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidaysByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidaysByCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHolidaysByCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHolidaysByCompanyQuery, GetHolidaysByCompanyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetHolidaysByCompanyQuery, GetHolidaysByCompanyQueryVariables>(GetHolidaysByCompanyDocument, baseOptions);
      }
export function useGetHolidaysByCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHolidaysByCompanyQuery, GetHolidaysByCompanyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetHolidaysByCompanyQuery, GetHolidaysByCompanyQueryVariables>(GetHolidaysByCompanyDocument, baseOptions);
        }
export type GetHolidaysByCompanyQueryHookResult = ReturnType<typeof useGetHolidaysByCompanyQuery>;
export type GetHolidaysByCompanyLazyQueryHookResult = ReturnType<typeof useGetHolidaysByCompanyLazyQuery>;
export type GetHolidaysByCompanyQueryResult = ApolloReactCommon.QueryResult<GetHolidaysByCompanyQuery, GetHolidaysByCompanyQueryVariables>;
export const GetHolidaysByCompanyAndDateRangeDocument = gql`
    query GetHolidaysByCompanyAndDateRange($start: DateTime!, $end: DateTime!) {
  holidaysByCompanyAndDateRange(start: $start, end: $end) {
    id
    name
    slug
    start
    end
    year
    stateCode
    countryCode
    holidayStateColor
    type
    days
    color
  }
}
    `;

/**
 * __useGetHolidaysByCompanyAndDateRangeQuery__
 *
 * To run a query within a React component, call `useGetHolidaysByCompanyAndDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidaysByCompanyAndDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidaysByCompanyAndDateRangeQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetHolidaysByCompanyAndDateRangeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHolidaysByCompanyAndDateRangeQuery, GetHolidaysByCompanyAndDateRangeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetHolidaysByCompanyAndDateRangeQuery, GetHolidaysByCompanyAndDateRangeQueryVariables>(GetHolidaysByCompanyAndDateRangeDocument, baseOptions);
      }
export function useGetHolidaysByCompanyAndDateRangeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHolidaysByCompanyAndDateRangeQuery, GetHolidaysByCompanyAndDateRangeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetHolidaysByCompanyAndDateRangeQuery, GetHolidaysByCompanyAndDateRangeQueryVariables>(GetHolidaysByCompanyAndDateRangeDocument, baseOptions);
        }
export type GetHolidaysByCompanyAndDateRangeQueryHookResult = ReturnType<typeof useGetHolidaysByCompanyAndDateRangeQuery>;
export type GetHolidaysByCompanyAndDateRangeLazyQueryHookResult = ReturnType<typeof useGetHolidaysByCompanyAndDateRangeLazyQuery>;
export type GetHolidaysByCompanyAndDateRangeQueryResult = ApolloReactCommon.QueryResult<GetHolidaysByCompanyAndDateRangeQuery, GetHolidaysByCompanyAndDateRangeQueryVariables>;
export const GetCustomHolidaysByCompanyDocument = gql`
    query GetCustomHolidaysByCompany {
  customHolidaysByCompany {
    id
    name
    slug
    start
    end
    year
    stateCode
    countryCode
    holidayStateColor
    type
    color
  }
}
    `;

/**
 * __useGetCustomHolidaysByCompanyQuery__
 *
 * To run a query within a React component, call `useGetCustomHolidaysByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomHolidaysByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomHolidaysByCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomHolidaysByCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCustomHolidaysByCompanyQuery, GetCustomHolidaysByCompanyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCustomHolidaysByCompanyQuery, GetCustomHolidaysByCompanyQueryVariables>(GetCustomHolidaysByCompanyDocument, baseOptions);
      }
export function useGetCustomHolidaysByCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomHolidaysByCompanyQuery, GetCustomHolidaysByCompanyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCustomHolidaysByCompanyQuery, GetCustomHolidaysByCompanyQueryVariables>(GetCustomHolidaysByCompanyDocument, baseOptions);
        }
export type GetCustomHolidaysByCompanyQueryHookResult = ReturnType<typeof useGetCustomHolidaysByCompanyQuery>;
export type GetCustomHolidaysByCompanyLazyQueryHookResult = ReturnType<typeof useGetCustomHolidaysByCompanyLazyQuery>;
export type GetCustomHolidaysByCompanyQueryResult = ApolloReactCommon.QueryResult<GetCustomHolidaysByCompanyQuery, GetCustomHolidaysByCompanyQueryVariables>;
export const UpdateCustomCompanyHolidaysDocument = gql`
    mutation UpdateCustomCompanyHolidays($holidayInputs: [HolidayInput!]!) {
  updateCustomCompanyHolidays(holidayInputs: $holidayInputs) {
    id
    name
    slug
    start
    end
    year
    stateCode
    countryCode
    holidayStateColor
    type
    color
  }
}
    `;
export type UpdateCustomCompanyHolidaysMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomCompanyHolidaysMutation, UpdateCustomCompanyHolidaysMutationVariables>;

/**
 * __useUpdateCustomCompanyHolidaysMutation__
 *
 * To run a mutation, you first call `useUpdateCustomCompanyHolidaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomCompanyHolidaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomCompanyHolidaysMutation, { data, loading, error }] = useUpdateCustomCompanyHolidaysMutation({
 *   variables: {
 *      holidayInputs: // value for 'holidayInputs'
 *   },
 * });
 */
export function useUpdateCustomCompanyHolidaysMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomCompanyHolidaysMutation, UpdateCustomCompanyHolidaysMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCustomCompanyHolidaysMutation, UpdateCustomCompanyHolidaysMutationVariables>(UpdateCustomCompanyHolidaysDocument, baseOptions);
      }
export type UpdateCustomCompanyHolidaysMutationHookResult = ReturnType<typeof useUpdateCustomCompanyHolidaysMutation>;
export type UpdateCustomCompanyHolidaysMutationResult = ApolloReactCommon.MutationResult<UpdateCustomCompanyHolidaysMutation>;
export type UpdateCustomCompanyHolidaysMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomCompanyHolidaysMutation, UpdateCustomCompanyHolidaysMutationVariables>;
export const GetInterestListsDocument = gql`
    query GetInterestLists {
  interestLists {
    id
    description
    maxEntries
    isActive
    showNoteField
    isFull
    createDate
    courseType {
      id
      name
      color
    }
    location {
      id
      name
      city
    }
    timeSlots {
      id
      weekday
      startTime
      endTime
      sortOrder
    }
  }
}
    `;

/**
 * __useGetInterestListsQuery__
 *
 * To run a query within a React component, call `useGetInterestListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterestListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInterestListsQuery, GetInterestListsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInterestListsQuery, GetInterestListsQueryVariables>(GetInterestListsDocument, baseOptions);
      }
export function useGetInterestListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterestListsQuery, GetInterestListsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInterestListsQuery, GetInterestListsQueryVariables>(GetInterestListsDocument, baseOptions);
        }
export type GetInterestListsQueryHookResult = ReturnType<typeof useGetInterestListsQuery>;
export type GetInterestListsLazyQueryHookResult = ReturnType<typeof useGetInterestListsLazyQuery>;
export type GetInterestListsQueryResult = ApolloReactCommon.QueryResult<GetInterestListsQuery, GetInterestListsQueryVariables>;
export const GetInterestListByIdDocument = gql`
    query GetInterestListById($id: ID!) {
  interestListById(id: $id) {
    id
    description
    maxEntries
    isActive
    showNoteField
    courseType {
      id
      name
      color
    }
    location {
      id
      name
      city
    }
    timeSlots {
      id
      weekday
      startTime
      endTime
      sortOrder
    }
  }
}
    `;

/**
 * __useGetInterestListByIdQuery__
 *
 * To run a query within a React component, call `useGetInterestListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInterestListByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInterestListByIdQuery, GetInterestListByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInterestListByIdQuery, GetInterestListByIdQueryVariables>(GetInterestListByIdDocument, baseOptions);
      }
export function useGetInterestListByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterestListByIdQuery, GetInterestListByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInterestListByIdQuery, GetInterestListByIdQueryVariables>(GetInterestListByIdDocument, baseOptions);
        }
export type GetInterestListByIdQueryHookResult = ReturnType<typeof useGetInterestListByIdQuery>;
export type GetInterestListByIdLazyQueryHookResult = ReturnType<typeof useGetInterestListByIdLazyQuery>;
export type GetInterestListByIdQueryResult = ApolloReactCommon.QueryResult<GetInterestListByIdQuery, GetInterestListByIdQueryVariables>;
export const CreateInterestListDocument = gql`
    mutation CreateInterestList($input: CreateInterestListInput!) {
  createInterestList(input: $input) {
    id
  }
}
    `;
export type CreateInterestListMutationFn = ApolloReactCommon.MutationFunction<CreateInterestListMutation, CreateInterestListMutationVariables>;

/**
 * __useCreateInterestListMutation__
 *
 * To run a mutation, you first call `useCreateInterestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterestListMutation, { data, loading, error }] = useCreateInterestListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInterestListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInterestListMutation, CreateInterestListMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInterestListMutation, CreateInterestListMutationVariables>(CreateInterestListDocument, baseOptions);
      }
export type CreateInterestListMutationHookResult = ReturnType<typeof useCreateInterestListMutation>;
export type CreateInterestListMutationResult = ApolloReactCommon.MutationResult<CreateInterestListMutation>;
export type CreateInterestListMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInterestListMutation, CreateInterestListMutationVariables>;
export const UpdateInterestListDocument = gql`
    mutation UpdateInterestList($input: UpdateInterestListInput!) {
  updateInterestList(input: $input) {
    id
  }
}
    `;
export type UpdateInterestListMutationFn = ApolloReactCommon.MutationFunction<UpdateInterestListMutation, UpdateInterestListMutationVariables>;

/**
 * __useUpdateInterestListMutation__
 *
 * To run a mutation, you first call `useUpdateInterestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterestListMutation, { data, loading, error }] = useUpdateInterestListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterestListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInterestListMutation, UpdateInterestListMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateInterestListMutation, UpdateInterestListMutationVariables>(UpdateInterestListDocument, baseOptions);
      }
export type UpdateInterestListMutationHookResult = ReturnType<typeof useUpdateInterestListMutation>;
export type UpdateInterestListMutationResult = ApolloReactCommon.MutationResult<UpdateInterestListMutation>;
export type UpdateInterestListMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInterestListMutation, UpdateInterestListMutationVariables>;
export const GetInterestListNoteDefaultDocument = gql`
    query GetInterestListNoteDefault {
  settings {
    id
    interestListShowNoteFieldDefault
  }
}
    `;

/**
 * __useGetInterestListNoteDefaultQuery__
 *
 * To run a query within a React component, call `useGetInterestListNoteDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestListNoteDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestListNoteDefaultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterestListNoteDefaultQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInterestListNoteDefaultQuery, GetInterestListNoteDefaultQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInterestListNoteDefaultQuery, GetInterestListNoteDefaultQueryVariables>(GetInterestListNoteDefaultDocument, baseOptions);
      }
export function useGetInterestListNoteDefaultLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterestListNoteDefaultQuery, GetInterestListNoteDefaultQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInterestListNoteDefaultQuery, GetInterestListNoteDefaultQueryVariables>(GetInterestListNoteDefaultDocument, baseOptions);
        }
export type GetInterestListNoteDefaultQueryHookResult = ReturnType<typeof useGetInterestListNoteDefaultQuery>;
export type GetInterestListNoteDefaultLazyQueryHookResult = ReturnType<typeof useGetInterestListNoteDefaultLazyQuery>;
export type GetInterestListNoteDefaultQueryResult = ApolloReactCommon.QueryResult<GetInterestListNoteDefaultQuery, GetInterestListNoteDefaultQueryVariables>;
export const SetInterestListNoteFieldDefaultDocument = gql`
    mutation SetInterestListNoteFieldDefault($showNoteField: Boolean!, $applyToExisting: Boolean!) {
  setInterestListNoteFieldDefault(showNoteField: $showNoteField, applyToExisting: $applyToExisting) {
    id
    interestListShowNoteFieldDefault
  }
}
    `;
export type SetInterestListNoteFieldDefaultMutationFn = ApolloReactCommon.MutationFunction<SetInterestListNoteFieldDefaultMutation, SetInterestListNoteFieldDefaultMutationVariables>;

/**
 * __useSetInterestListNoteFieldDefaultMutation__
 *
 * To run a mutation, you first call `useSetInterestListNoteFieldDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInterestListNoteFieldDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInterestListNoteFieldDefaultMutation, { data, loading, error }] = useSetInterestListNoteFieldDefaultMutation({
 *   variables: {
 *      showNoteField: // value for 'showNoteField'
 *      applyToExisting: // value for 'applyToExisting'
 *   },
 * });
 */
export function useSetInterestListNoteFieldDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetInterestListNoteFieldDefaultMutation, SetInterestListNoteFieldDefaultMutationVariables>) {
        return ApolloReactHooks.useMutation<SetInterestListNoteFieldDefaultMutation, SetInterestListNoteFieldDefaultMutationVariables>(SetInterestListNoteFieldDefaultDocument, baseOptions);
      }
export type SetInterestListNoteFieldDefaultMutationHookResult = ReturnType<typeof useSetInterestListNoteFieldDefaultMutation>;
export type SetInterestListNoteFieldDefaultMutationResult = ApolloReactCommon.MutationResult<SetInterestListNoteFieldDefaultMutation>;
export type SetInterestListNoteFieldDefaultMutationOptions = ApolloReactCommon.BaseMutationOptions<SetInterestListNoteFieldDefaultMutation, SetInterestListNoteFieldDefaultMutationVariables>;
export const RemoveInterestListDocument = gql`
    mutation RemoveInterestList($id: ID!) {
  removeInterestList(id: $id)
}
    `;
export type RemoveInterestListMutationFn = ApolloReactCommon.MutationFunction<RemoveInterestListMutation, RemoveInterestListMutationVariables>;

/**
 * __useRemoveInterestListMutation__
 *
 * To run a mutation, you first call `useRemoveInterestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInterestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInterestListMutation, { data, loading, error }] = useRemoveInterestListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInterestListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveInterestListMutation, RemoveInterestListMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveInterestListMutation, RemoveInterestListMutationVariables>(RemoveInterestListDocument, baseOptions);
      }
export type RemoveInterestListMutationHookResult = ReturnType<typeof useRemoveInterestListMutation>;
export type RemoveInterestListMutationResult = ApolloReactCommon.MutationResult<RemoveInterestListMutation>;
export type RemoveInterestListMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveInterestListMutation, RemoveInterestListMutationVariables>;
export const GetInterestRegistrationsDocument = gql`
    query GetInterestRegistrations($options: ArrayDataOptions) {
  interestRegistrations(options: $options) {
    existsMore
    total
    items {
      id
      allTimesPossible
      note
      status
      internalNote
      createDate
      interestList {
        id
        courseType {
          id
          name
          color
        }
        location {
          id
          name
          city
        }
      }
      booker {
        id
        email
        phoneNumber
        mobileNumber
        customer {
          firstname
          lastname
        }
      }
      attendee {
        id
        customer {
          firstname
          lastname
        }
      }
      selectedTimeSlots {
        id
        weekday
        startTime
        endTime
        sortOrder
      }
    }
  }
}
    `;

/**
 * __useGetInterestRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetInterestRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestRegistrationsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetInterestRegistrationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInterestRegistrationsQuery, GetInterestRegistrationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInterestRegistrationsQuery, GetInterestRegistrationsQueryVariables>(GetInterestRegistrationsDocument, baseOptions);
      }
export function useGetInterestRegistrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterestRegistrationsQuery, GetInterestRegistrationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInterestRegistrationsQuery, GetInterestRegistrationsQueryVariables>(GetInterestRegistrationsDocument, baseOptions);
        }
export type GetInterestRegistrationsQueryHookResult = ReturnType<typeof useGetInterestRegistrationsQuery>;
export type GetInterestRegistrationsLazyQueryHookResult = ReturnType<typeof useGetInterestRegistrationsLazyQuery>;
export type GetInterestRegistrationsQueryResult = ApolloReactCommon.QueryResult<GetInterestRegistrationsQuery, GetInterestRegistrationsQueryVariables>;
export const CreateInterestRegistrationAdminDocument = gql`
    mutation CreateInterestRegistrationAdmin($input: CreateInterestRegistrationInput!, $sendConfirmationMail: Boolean) {
  createInterestRegistration(input: $input, sendConfirmationMail: $sendConfirmationMail) {
    id
  }
}
    `;
export type CreateInterestRegistrationAdminMutationFn = ApolloReactCommon.MutationFunction<CreateInterestRegistrationAdminMutation, CreateInterestRegistrationAdminMutationVariables>;

/**
 * __useCreateInterestRegistrationAdminMutation__
 *
 * To run a mutation, you first call `useCreateInterestRegistrationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterestRegistrationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterestRegistrationAdminMutation, { data, loading, error }] = useCreateInterestRegistrationAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sendConfirmationMail: // value for 'sendConfirmationMail'
 *   },
 * });
 */
export function useCreateInterestRegistrationAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInterestRegistrationAdminMutation, CreateInterestRegistrationAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInterestRegistrationAdminMutation, CreateInterestRegistrationAdminMutationVariables>(CreateInterestRegistrationAdminDocument, baseOptions);
      }
export type CreateInterestRegistrationAdminMutationHookResult = ReturnType<typeof useCreateInterestRegistrationAdminMutation>;
export type CreateInterestRegistrationAdminMutationResult = ApolloReactCommon.MutationResult<CreateInterestRegistrationAdminMutation>;
export type CreateInterestRegistrationAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInterestRegistrationAdminMutation, CreateInterestRegistrationAdminMutationVariables>;
export const GetInterestRegistrationsByAttendeeAndCourseTypeDocument = gql`
    query GetInterestRegistrationsByAttendeeAndCourseType($attendeeId: ID!, $courseTypeId: ID!) {
  interestRegistrationsByAttendeeAndCourseType(attendeeId: $attendeeId, courseTypeId: $courseTypeId) {
    id
    createDate
    allTimesPossible
    interestList {
      id
      courseType {
        id
        name
        color
      }
      location {
        id
        name
        city
      }
    }
    selectedTimeSlots {
      id
      weekday
      startTime
      endTime
      sortOrder
    }
  }
}
    `;

/**
 * __useGetInterestRegistrationsByAttendeeAndCourseTypeQuery__
 *
 * To run a query within a React component, call `useGetInterestRegistrationsByAttendeeAndCourseTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestRegistrationsByAttendeeAndCourseTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestRegistrationsByAttendeeAndCourseTypeQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      courseTypeId: // value for 'courseTypeId'
 *   },
 * });
 */
export function useGetInterestRegistrationsByAttendeeAndCourseTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInterestRegistrationsByAttendeeAndCourseTypeQuery, GetInterestRegistrationsByAttendeeAndCourseTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInterestRegistrationsByAttendeeAndCourseTypeQuery, GetInterestRegistrationsByAttendeeAndCourseTypeQueryVariables>(GetInterestRegistrationsByAttendeeAndCourseTypeDocument, baseOptions);
      }
export function useGetInterestRegistrationsByAttendeeAndCourseTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterestRegistrationsByAttendeeAndCourseTypeQuery, GetInterestRegistrationsByAttendeeAndCourseTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInterestRegistrationsByAttendeeAndCourseTypeQuery, GetInterestRegistrationsByAttendeeAndCourseTypeQueryVariables>(GetInterestRegistrationsByAttendeeAndCourseTypeDocument, baseOptions);
        }
export type GetInterestRegistrationsByAttendeeAndCourseTypeQueryHookResult = ReturnType<typeof useGetInterestRegistrationsByAttendeeAndCourseTypeQuery>;
export type GetInterestRegistrationsByAttendeeAndCourseTypeLazyQueryHookResult = ReturnType<typeof useGetInterestRegistrationsByAttendeeAndCourseTypeLazyQuery>;
export type GetInterestRegistrationsByAttendeeAndCourseTypeQueryResult = ApolloReactCommon.QueryResult<GetInterestRegistrationsByAttendeeAndCourseTypeQuery, GetInterestRegistrationsByAttendeeAndCourseTypeQueryVariables>;
export const UpdateInterestRegistrationDocument = gql`
    mutation UpdateInterestRegistration($input: UpdateInterestRegistrationInput!) {
  updateInterestRegistration(input: $input) {
    id
    status
    internalNote
  }
}
    `;
export type UpdateInterestRegistrationMutationFn = ApolloReactCommon.MutationFunction<UpdateInterestRegistrationMutation, UpdateInterestRegistrationMutationVariables>;

/**
 * __useUpdateInterestRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateInterestRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterestRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterestRegistrationMutation, { data, loading, error }] = useUpdateInterestRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterestRegistrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInterestRegistrationMutation, UpdateInterestRegistrationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateInterestRegistrationMutation, UpdateInterestRegistrationMutationVariables>(UpdateInterestRegistrationDocument, baseOptions);
      }
export type UpdateInterestRegistrationMutationHookResult = ReturnType<typeof useUpdateInterestRegistrationMutation>;
export type UpdateInterestRegistrationMutationResult = ApolloReactCommon.MutationResult<UpdateInterestRegistrationMutation>;
export type UpdateInterestRegistrationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInterestRegistrationMutation, UpdateInterestRegistrationMutationVariables>;
export const RemoveInterestRegistrationDocument = gql`
    mutation RemoveInterestRegistration($id: ID!) {
  removeInterestRegistration(id: $id)
}
    `;
export type RemoveInterestRegistrationMutationFn = ApolloReactCommon.MutationFunction<RemoveInterestRegistrationMutation, RemoveInterestRegistrationMutationVariables>;

/**
 * __useRemoveInterestRegistrationMutation__
 *
 * To run a mutation, you first call `useRemoveInterestRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInterestRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInterestRegistrationMutation, { data, loading, error }] = useRemoveInterestRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInterestRegistrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveInterestRegistrationMutation, RemoveInterestRegistrationMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveInterestRegistrationMutation, RemoveInterestRegistrationMutationVariables>(RemoveInterestRegistrationDocument, baseOptions);
      }
export type RemoveInterestRegistrationMutationHookResult = ReturnType<typeof useRemoveInterestRegistrationMutation>;
export type RemoveInterestRegistrationMutationResult = ApolloReactCommon.MutationResult<RemoveInterestRegistrationMutation>;
export type RemoveInterestRegistrationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveInterestRegistrationMutation, RemoveInterestRegistrationMutationVariables>;
export const GetBookingDunningsDocument = gql`
    query GetBookingDunnings($bookingId: ID!) {
  dunningsByBooking(bookingId: $bookingId) {
    id
    createDate
    level
    dunningNumber
    openAmount
    feeAmount
    totalAmount
    paymentDue
    completedAt
    sentAt
    withdrawnAt
    withdrawnReason
    voidedAt
    feeDeleted
  }
  dunningPause(bookingId: $bookingId) {
    until
    note
  }
  activeDunning(bookingId: $bookingId) {
    id
    level
    createDate
    openAmount
    totalAmount
    currentOpenAmount
    scheduledPaymentId
  }
}
    `;

/**
 * __useGetBookingDunningsQuery__
 *
 * To run a query within a React component, call `useGetBookingDunningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingDunningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingDunningsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingDunningsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingDunningsQuery, GetBookingDunningsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingDunningsQuery, GetBookingDunningsQueryVariables>(GetBookingDunningsDocument, baseOptions);
      }
export function useGetBookingDunningsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingDunningsQuery, GetBookingDunningsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingDunningsQuery, GetBookingDunningsQueryVariables>(GetBookingDunningsDocument, baseOptions);
        }
export type GetBookingDunningsQueryHookResult = ReturnType<typeof useGetBookingDunningsQuery>;
export type GetBookingDunningsLazyQueryHookResult = ReturnType<typeof useGetBookingDunningsLazyQuery>;
export type GetBookingDunningsQueryResult = ApolloReactCommon.QueryResult<GetBookingDunningsQuery, GetBookingDunningsQueryVariables>;
export const GetActiveDunningDocument = gql`
    query GetActiveDunning($bookingId: ID!) {
  activeDunning(bookingId: $bookingId) {
    id
    level
    createDate
    openAmount
    totalAmount
    currentOpenAmount
    scheduledPaymentId
  }
}
    `;

/**
 * __useGetActiveDunningQuery__
 *
 * To run a query within a React component, call `useGetActiveDunningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveDunningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveDunningQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetActiveDunningQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActiveDunningQuery, GetActiveDunningQueryVariables>) {
        return ApolloReactHooks.useQuery<GetActiveDunningQuery, GetActiveDunningQueryVariables>(GetActiveDunningDocument, baseOptions);
      }
export function useGetActiveDunningLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveDunningQuery, GetActiveDunningQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetActiveDunningQuery, GetActiveDunningQueryVariables>(GetActiveDunningDocument, baseOptions);
        }
export type GetActiveDunningQueryHookResult = ReturnType<typeof useGetActiveDunningQuery>;
export type GetActiveDunningLazyQueryHookResult = ReturnType<typeof useGetActiveDunningLazyQuery>;
export type GetActiveDunningQueryResult = ApolloReactCommon.QueryResult<GetActiveDunningQuery, GetActiveDunningQueryVariables>;
export const GetDunningProposalDocument = gql`
    query GetDunningProposal($bookingId: ID!, $level: DunningLevel) {
  dunningProposal(bookingId: $bookingId, level: $level) {
    level
    levelLabel
    dunningNumber
    items {
      scheduledPaymentId
      title
      paymentDue
      openAmount
    }
    openAmount
    feeAmount
    totalAmount
    paymentDue
    earliestDate
    tooEarly
    recipientEmail
    blocker
  }
}
    `;

/**
 * __useGetDunningProposalQuery__
 *
 * To run a query within a React component, call `useGetDunningProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDunningProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDunningProposalQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useGetDunningProposalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDunningProposalQuery, GetDunningProposalQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDunningProposalQuery, GetDunningProposalQueryVariables>(GetDunningProposalDocument, baseOptions);
      }
export function useGetDunningProposalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDunningProposalQuery, GetDunningProposalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDunningProposalQuery, GetDunningProposalQueryVariables>(GetDunningProposalDocument, baseOptions);
        }
export type GetDunningProposalQueryHookResult = ReturnType<typeof useGetDunningProposalQuery>;
export type GetDunningProposalLazyQueryHookResult = ReturnType<typeof useGetDunningProposalLazyQuery>;
export type GetDunningProposalQueryResult = ApolloReactCommon.QueryResult<GetDunningProposalQuery, GetDunningProposalQueryVariables>;
export const GetDunningPdfDocument = gql`
    query GetDunningPdf($id: ID!) {
  dunningPdf(id: $id)
}
    `;

/**
 * __useGetDunningPdfQuery__
 *
 * To run a query within a React component, call `useGetDunningPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDunningPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDunningPdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDunningPdfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDunningPdfQuery, GetDunningPdfQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDunningPdfQuery, GetDunningPdfQueryVariables>(GetDunningPdfDocument, baseOptions);
      }
export function useGetDunningPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDunningPdfQuery, GetDunningPdfQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDunningPdfQuery, GetDunningPdfQueryVariables>(GetDunningPdfDocument, baseOptions);
        }
export type GetDunningPdfQueryHookResult = ReturnType<typeof useGetDunningPdfQuery>;
export type GetDunningPdfLazyQueryHookResult = ReturnType<typeof useGetDunningPdfLazyQuery>;
export type GetDunningPdfQueryResult = ApolloReactCommon.QueryResult<GetDunningPdfQuery, GetDunningPdfQueryVariables>;
export const CreateDunningDocument = gql`
    mutation CreateDunning($input: CreateDunningInput!) {
  createDunning(input: $input) {
    id
    dunningNumber
    sentAt
  }
}
    `;
export type CreateDunningMutationFn = ApolloReactCommon.MutationFunction<CreateDunningMutation, CreateDunningMutationVariables>;

/**
 * __useCreateDunningMutation__
 *
 * To run a mutation, you first call `useCreateDunningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDunningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDunningMutation, { data, loading, error }] = useCreateDunningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDunningMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDunningMutation, CreateDunningMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDunningMutation, CreateDunningMutationVariables>(CreateDunningDocument, baseOptions);
      }
export type CreateDunningMutationHookResult = ReturnType<typeof useCreateDunningMutation>;
export type CreateDunningMutationResult = ApolloReactCommon.MutationResult<CreateDunningMutation>;
export type CreateDunningMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDunningMutation, CreateDunningMutationVariables>;
export const WithdrawDunningDocument = gql`
    mutation WithdrawDunning($id: ID!, $reason: String!) {
  withdrawDunning(id: $id, reason: $reason) {
    id
  }
}
    `;
export type WithdrawDunningMutationFn = ApolloReactCommon.MutationFunction<WithdrawDunningMutation, WithdrawDunningMutationVariables>;

/**
 * __useWithdrawDunningMutation__
 *
 * To run a mutation, you first call `useWithdrawDunningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawDunningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawDunningMutation, { data, loading, error }] = useWithdrawDunningMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWithdrawDunningMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WithdrawDunningMutation, WithdrawDunningMutationVariables>) {
        return ApolloReactHooks.useMutation<WithdrawDunningMutation, WithdrawDunningMutationVariables>(WithdrawDunningDocument, baseOptions);
      }
export type WithdrawDunningMutationHookResult = ReturnType<typeof useWithdrawDunningMutation>;
export type WithdrawDunningMutationResult = ApolloReactCommon.MutationResult<WithdrawDunningMutation>;
export type WithdrawDunningMutationOptions = ApolloReactCommon.BaseMutationOptions<WithdrawDunningMutation, WithdrawDunningMutationVariables>;
export const ResendDunningDocument = gql`
    mutation ResendDunning($id: ID!) {
  resendDunning(id: $id) {
    id
    sentAt
  }
}
    `;
export type ResendDunningMutationFn = ApolloReactCommon.MutationFunction<ResendDunningMutation, ResendDunningMutationVariables>;

/**
 * __useResendDunningMutation__
 *
 * To run a mutation, you first call `useResendDunningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendDunningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendDunningMutation, { data, loading, error }] = useResendDunningMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendDunningMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendDunningMutation, ResendDunningMutationVariables>) {
        return ApolloReactHooks.useMutation<ResendDunningMutation, ResendDunningMutationVariables>(ResendDunningDocument, baseOptions);
      }
export type ResendDunningMutationHookResult = ReturnType<typeof useResendDunningMutation>;
export type ResendDunningMutationResult = ApolloReactCommon.MutationResult<ResendDunningMutation>;
export type ResendDunningMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendDunningMutation, ResendDunningMutationVariables>;
export const SetDunningPauseDocument = gql`
    mutation SetDunningPause($input: SetDunningPauseInput!) {
  setDunningPause(input: $input) {
    until
    note
  }
}
    `;
export type SetDunningPauseMutationFn = ApolloReactCommon.MutationFunction<SetDunningPauseMutation, SetDunningPauseMutationVariables>;

/**
 * __useSetDunningPauseMutation__
 *
 * To run a mutation, you first call `useSetDunningPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDunningPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDunningPauseMutation, { data, loading, error }] = useSetDunningPauseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDunningPauseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDunningPauseMutation, SetDunningPauseMutationVariables>) {
        return ApolloReactHooks.useMutation<SetDunningPauseMutation, SetDunningPauseMutationVariables>(SetDunningPauseDocument, baseOptions);
      }
export type SetDunningPauseMutationHookResult = ReturnType<typeof useSetDunningPauseMutation>;
export type SetDunningPauseMutationResult = ApolloReactCommon.MutationResult<SetDunningPauseMutation>;
export type SetDunningPauseMutationOptions = ApolloReactCommon.BaseMutationOptions<SetDunningPauseMutation, SetDunningPauseMutationVariables>;
export const GetBookingDunningStatusesDocument = gql`
    query GetBookingDunningStatuses($bookingIds: [ID!]!) {
  bookingDunningStatuses(bookingIds: $bookingIds) {
    bookingId
    level
    levelDate
  }
}
    `;

/**
 * __useGetBookingDunningStatusesQuery__
 *
 * To run a query within a React component, call `useGetBookingDunningStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingDunningStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingDunningStatusesQuery({
 *   variables: {
 *      bookingIds: // value for 'bookingIds'
 *   },
 * });
 */
export function useGetBookingDunningStatusesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingDunningStatusesQuery, GetBookingDunningStatusesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingDunningStatusesQuery, GetBookingDunningStatusesQueryVariables>(GetBookingDunningStatusesDocument, baseOptions);
      }
export function useGetBookingDunningStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingDunningStatusesQuery, GetBookingDunningStatusesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingDunningStatusesQuery, GetBookingDunningStatusesQueryVariables>(GetBookingDunningStatusesDocument, baseOptions);
        }
export type GetBookingDunningStatusesQueryHookResult = ReturnType<typeof useGetBookingDunningStatusesQuery>;
export type GetBookingDunningStatusesLazyQueryHookResult = ReturnType<typeof useGetBookingDunningStatusesLazyQuery>;
export type GetBookingDunningStatusesQueryResult = ApolloReactCommon.QueryResult<GetBookingDunningStatusesQuery, GetBookingDunningStatusesQueryVariables>;
export const GetBookingCorrectionContextDocument = gql`
    query GetBookingCorrectionContext($id: ID!) {
  bookingById(id: $id) {
    id
    discount
    discountName
    memberDiscount
    scheduledPayments {
      id
      paymentDue
    }
  }
}
    `;

/**
 * __useGetBookingCorrectionContextQuery__
 *
 * To run a query within a React component, call `useGetBookingCorrectionContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingCorrectionContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingCorrectionContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingCorrectionContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingCorrectionContextQuery, GetBookingCorrectionContextQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingCorrectionContextQuery, GetBookingCorrectionContextQueryVariables>(GetBookingCorrectionContextDocument, baseOptions);
      }
export function useGetBookingCorrectionContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingCorrectionContextQuery, GetBookingCorrectionContextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingCorrectionContextQuery, GetBookingCorrectionContextQueryVariables>(GetBookingCorrectionContextDocument, baseOptions);
        }
export type GetBookingCorrectionContextQueryHookResult = ReturnType<typeof useGetBookingCorrectionContextQuery>;
export type GetBookingCorrectionContextLazyQueryHookResult = ReturnType<typeof useGetBookingCorrectionContextLazyQuery>;
export type GetBookingCorrectionContextQueryResult = ApolloReactCommon.QueryResult<GetBookingCorrectionContextQuery, GetBookingCorrectionContextQueryVariables>;
export const PreviewSettledBookingCorrectionDocument = gql`
    query PreviewSettledBookingCorrection($bookingId: ID!, $input: SettledBookingCorrectionInput!) {
  previewSettledBookingCorrection(bookingId: $bookingId, input: $input) {
    newGrossPrice
    alreadyPaid
    newOpenAmount
    overpayment
    refundAmount
    creditToBooker
    creditedBalanceDelta
    newPaymentLinkAmount
    installmentChanges {
      type
      spId
      title
      oldAmount
      newAmount
      paymentDue
    }
    warnings
    blockers
  }
}
    `;

/**
 * __usePreviewSettledBookingCorrectionQuery__
 *
 * To run a query within a React component, call `usePreviewSettledBookingCorrectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSettledBookingCorrectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSettledBookingCorrectionQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewSettledBookingCorrectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PreviewSettledBookingCorrectionQuery, PreviewSettledBookingCorrectionQueryVariables>) {
        return ApolloReactHooks.useQuery<PreviewSettledBookingCorrectionQuery, PreviewSettledBookingCorrectionQueryVariables>(PreviewSettledBookingCorrectionDocument, baseOptions);
      }
export function usePreviewSettledBookingCorrectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviewSettledBookingCorrectionQuery, PreviewSettledBookingCorrectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PreviewSettledBookingCorrectionQuery, PreviewSettledBookingCorrectionQueryVariables>(PreviewSettledBookingCorrectionDocument, baseOptions);
        }
export type PreviewSettledBookingCorrectionQueryHookResult = ReturnType<typeof usePreviewSettledBookingCorrectionQuery>;
export type PreviewSettledBookingCorrectionLazyQueryHookResult = ReturnType<typeof usePreviewSettledBookingCorrectionLazyQuery>;
export type PreviewSettledBookingCorrectionQueryResult = ApolloReactCommon.QueryResult<PreviewSettledBookingCorrectionQuery, PreviewSettledBookingCorrectionQueryVariables>;
export const ExecuteSettledBookingCorrectionDocument = gql`
    mutation ExecuteSettledBookingCorrection($bookingId: ID!, $input: SettledBookingCorrectionInput!, $sendCorrectionInvoiceMail: Boolean!) {
  executeSettledBookingCorrection(bookingId: $bookingId, input: $input, sendCorrectionInvoiceMail: $sendCorrectionInvoiceMail) {
    booking {
      id
    }
    refundOk
    paymentLinkOk
    correctionInvoiceOk
    messages
  }
}
    `;
export type ExecuteSettledBookingCorrectionMutationFn = ApolloReactCommon.MutationFunction<ExecuteSettledBookingCorrectionMutation, ExecuteSettledBookingCorrectionMutationVariables>;

/**
 * __useExecuteSettledBookingCorrectionMutation__
 *
 * To run a mutation, you first call `useExecuteSettledBookingCorrectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteSettledBookingCorrectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeSettledBookingCorrectionMutation, { data, loading, error }] = useExecuteSettledBookingCorrectionMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      input: // value for 'input'
 *      sendCorrectionInvoiceMail: // value for 'sendCorrectionInvoiceMail'
 *   },
 * });
 */
export function useExecuteSettledBookingCorrectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExecuteSettledBookingCorrectionMutation, ExecuteSettledBookingCorrectionMutationVariables>) {
        return ApolloReactHooks.useMutation<ExecuteSettledBookingCorrectionMutation, ExecuteSettledBookingCorrectionMutationVariables>(ExecuteSettledBookingCorrectionDocument, baseOptions);
      }
export type ExecuteSettledBookingCorrectionMutationHookResult = ReturnType<typeof useExecuteSettledBookingCorrectionMutation>;
export type ExecuteSettledBookingCorrectionMutationResult = ApolloReactCommon.MutationResult<ExecuteSettledBookingCorrectionMutation>;
export type ExecuteSettledBookingCorrectionMutationOptions = ApolloReactCommon.BaseMutationOptions<ExecuteSettledBookingCorrectionMutation, ExecuteSettledBookingCorrectionMutationVariables>;
export const GetBookingFeeLettersDocument = gql`
    query GetBookingFeeLetters($bookingId: ID!) {
  feeLettersByBooking(bookingId: $bookingId) {
    id
    createDate
    letterNumber
    totalAmount
    paymentDue
    sentAt
  }
  feeLetterProposal(bookingId: $bookingId) {
    items {
      scheduledPaymentId
      title
      amount
    }
    totalAmount
    letterNumber
    blocker
    recipientEmail
  }
}
    `;

/**
 * __useGetBookingFeeLettersQuery__
 *
 * To run a query within a React component, call `useGetBookingFeeLettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingFeeLettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingFeeLettersQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingFeeLettersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookingFeeLettersQuery, GetBookingFeeLettersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookingFeeLettersQuery, GetBookingFeeLettersQueryVariables>(GetBookingFeeLettersDocument, baseOptions);
      }
export function useGetBookingFeeLettersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingFeeLettersQuery, GetBookingFeeLettersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookingFeeLettersQuery, GetBookingFeeLettersQueryVariables>(GetBookingFeeLettersDocument, baseOptions);
        }
export type GetBookingFeeLettersQueryHookResult = ReturnType<typeof useGetBookingFeeLettersQuery>;
export type GetBookingFeeLettersLazyQueryHookResult = ReturnType<typeof useGetBookingFeeLettersLazyQuery>;
export type GetBookingFeeLettersQueryResult = ApolloReactCommon.QueryResult<GetBookingFeeLettersQuery, GetBookingFeeLettersQueryVariables>;
export const GetFeeLetterPdfDocument = gql`
    query GetFeeLetterPdf($id: ID!) {
  feeLetterPdf(id: $id)
}
    `;

/**
 * __useGetFeeLetterPdfQuery__
 *
 * To run a query within a React component, call `useGetFeeLetterPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeLetterPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeeLetterPdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFeeLetterPdfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeeLetterPdfQuery, GetFeeLetterPdfQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeeLetterPdfQuery, GetFeeLetterPdfQueryVariables>(GetFeeLetterPdfDocument, baseOptions);
      }
export function useGetFeeLetterPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeeLetterPdfQuery, GetFeeLetterPdfQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeeLetterPdfQuery, GetFeeLetterPdfQueryVariables>(GetFeeLetterPdfDocument, baseOptions);
        }
export type GetFeeLetterPdfQueryHookResult = ReturnType<typeof useGetFeeLetterPdfQuery>;
export type GetFeeLetterPdfLazyQueryHookResult = ReturnType<typeof useGetFeeLetterPdfLazyQuery>;
export type GetFeeLetterPdfQueryResult = ApolloReactCommon.QueryResult<GetFeeLetterPdfQuery, GetFeeLetterPdfQueryVariables>;
export const CreateFeeLetterDocument = gql`
    mutation CreateFeeLetter($input: CreateFeeLetterInput!) {
  createFeeLetter(input: $input) {
    id
    letterNumber
    sentAt
  }
}
    `;
export type CreateFeeLetterMutationFn = ApolloReactCommon.MutationFunction<CreateFeeLetterMutation, CreateFeeLetterMutationVariables>;

/**
 * __useCreateFeeLetterMutation__
 *
 * To run a mutation, you first call `useCreateFeeLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeeLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeeLetterMutation, { data, loading, error }] = useCreateFeeLetterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeeLetterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFeeLetterMutation, CreateFeeLetterMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFeeLetterMutation, CreateFeeLetterMutationVariables>(CreateFeeLetterDocument, baseOptions);
      }
export type CreateFeeLetterMutationHookResult = ReturnType<typeof useCreateFeeLetterMutation>;
export type CreateFeeLetterMutationResult = ApolloReactCommon.MutationResult<CreateFeeLetterMutation>;
export type CreateFeeLetterMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFeeLetterMutation, CreateFeeLetterMutationVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($newInvoiceData: InvoiceInput!, $sendMail: Boolean) {
  createInvoice(newInvoiceData: $newInvoiceData, sendMail: $sendMail) {
    id
  }
}
    `;
export type CreateInvoiceMutationFn = ApolloReactCommon.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      newInvoiceData: // value for 'newInvoiceData'
 *      sendMail: // value for 'sendMail'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, baseOptions);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = ApolloReactCommon.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const CreateInvoicesByCourseIdDocument = gql`
    mutation CreateInvoicesByCourseId($courseId: String!, $sendMail: Boolean) {
  createInvoicesByCourseId(courseId: $courseId, sendMail: $sendMail) {
    id
  }
}
    `;
export type CreateInvoicesByCourseIdMutationFn = ApolloReactCommon.MutationFunction<CreateInvoicesByCourseIdMutation, CreateInvoicesByCourseIdMutationVariables>;

/**
 * __useCreateInvoicesByCourseIdMutation__
 *
 * To run a mutation, you first call `useCreateInvoicesByCourseIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoicesByCourseIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoicesByCourseIdMutation, { data, loading, error }] = useCreateInvoicesByCourseIdMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      sendMail: // value for 'sendMail'
 *   },
 * });
 */
export function useCreateInvoicesByCourseIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvoicesByCourseIdMutation, CreateInvoicesByCourseIdMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInvoicesByCourseIdMutation, CreateInvoicesByCourseIdMutationVariables>(CreateInvoicesByCourseIdDocument, baseOptions);
      }
export type CreateInvoicesByCourseIdMutationHookResult = ReturnType<typeof useCreateInvoicesByCourseIdMutation>;
export type CreateInvoicesByCourseIdMutationResult = ApolloReactCommon.MutationResult<CreateInvoicesByCourseIdMutation>;
export type CreateInvoicesByCourseIdMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvoicesByCourseIdMutation, CreateInvoicesByCourseIdMutationVariables>;
export const CreateInvoicesByBookingIdsDocument = gql`
    mutation CreateInvoicesByBookingIds($bookingIds: [ID!]!, $sendMail: Boolean) {
  createInvoicesByBookingIds(bookingIds: $bookingIds, sendMail: $sendMail) {
    id
    bookingId
  }
}
    `;
export type CreateInvoicesByBookingIdsMutationFn = ApolloReactCommon.MutationFunction<CreateInvoicesByBookingIdsMutation, CreateInvoicesByBookingIdsMutationVariables>;

/**
 * __useCreateInvoicesByBookingIdsMutation__
 *
 * To run a mutation, you first call `useCreateInvoicesByBookingIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoicesByBookingIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoicesByBookingIdsMutation, { data, loading, error }] = useCreateInvoicesByBookingIdsMutation({
 *   variables: {
 *      bookingIds: // value for 'bookingIds'
 *      sendMail: // value for 'sendMail'
 *   },
 * });
 */
export function useCreateInvoicesByBookingIdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvoicesByBookingIdsMutation, CreateInvoicesByBookingIdsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInvoicesByBookingIdsMutation, CreateInvoicesByBookingIdsMutationVariables>(CreateInvoicesByBookingIdsDocument, baseOptions);
      }
export type CreateInvoicesByBookingIdsMutationHookResult = ReturnType<typeof useCreateInvoicesByBookingIdsMutation>;
export type CreateInvoicesByBookingIdsMutationResult = ApolloReactCommon.MutationResult<CreateInvoicesByBookingIdsMutation>;
export type CreateInvoicesByBookingIdsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvoicesByBookingIdsMutation, CreateInvoicesByBookingIdsMutationVariables>;
export const GetInvoicesDocument = gql`
    query GetInvoices($options: ArrayDataOptions) {
  invoices(options: $options) {
    existsMore
    total
    items {
      id
      invoiceBody
      invoiceFileName
    }
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, baseOptions);
      }
export function useGetInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, baseOptions);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesQueryResult = ApolloReactCommon.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoiceBodyByIdDocument = gql`
    query GetInvoiceBodyById($id: String!) {
  invoiceBodyById(id: $id) {
    id
    invoiceBody
    invoiceFileName
  }
}
    `;

/**
 * __useGetInvoiceBodyByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceBodyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceBodyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceBodyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceBodyByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceBodyByIdQuery, GetInvoiceBodyByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceBodyByIdQuery, GetInvoiceBodyByIdQueryVariables>(GetInvoiceBodyByIdDocument, baseOptions);
      }
export function useGetInvoiceBodyByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceBodyByIdQuery, GetInvoiceBodyByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceBodyByIdQuery, GetInvoiceBodyByIdQueryVariables>(GetInvoiceBodyByIdDocument, baseOptions);
        }
export type GetInvoiceBodyByIdQueryHookResult = ReturnType<typeof useGetInvoiceBodyByIdQuery>;
export type GetInvoiceBodyByIdLazyQueryHookResult = ReturnType<typeof useGetInvoiceBodyByIdLazyQuery>;
export type GetInvoiceBodyByIdQueryResult = ApolloReactCommon.QueryResult<GetInvoiceBodyByIdQuery, GetInvoiceBodyByIdQueryVariables>;
export const GetInvoiceBodyByBookingIdDocument = gql`
    query GetInvoiceBodyByBookingId($bookingId: String!) {
  invoiceBodyByBookingId(bookingId: $bookingId) {
    id
    invoiceBody
    invoiceFileName
  }
}
    `;

/**
 * __useGetInvoiceBodyByBookingIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceBodyByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceBodyByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceBodyByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetInvoiceBodyByBookingIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceBodyByBookingIdQuery, GetInvoiceBodyByBookingIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceBodyByBookingIdQuery, GetInvoiceBodyByBookingIdQueryVariables>(GetInvoiceBodyByBookingIdDocument, baseOptions);
      }
export function useGetInvoiceBodyByBookingIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceBodyByBookingIdQuery, GetInvoiceBodyByBookingIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceBodyByBookingIdQuery, GetInvoiceBodyByBookingIdQueryVariables>(GetInvoiceBodyByBookingIdDocument, baseOptions);
        }
export type GetInvoiceBodyByBookingIdQueryHookResult = ReturnType<typeof useGetInvoiceBodyByBookingIdQuery>;
export type GetInvoiceBodyByBookingIdLazyQueryHookResult = ReturnType<typeof useGetInvoiceBodyByBookingIdLazyQuery>;
export type GetInvoiceBodyByBookingIdQueryResult = ApolloReactCommon.QueryResult<GetInvoiceBodyByBookingIdQuery, GetInvoiceBodyByBookingIdQueryVariables>;
export const GetCoursesDetailsDocument = gql`
    query GetCoursesDetails {
  courses {
    id
    settledBookings {
      id
      attendee {
        id
        firstname
        lastname
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          firstname
          lastname
          customerNumberPrefix
          customerNumber
        }
      }
      invoice {
        id
        billed
        createDate
        invoiceNumberPrefix
        invoiceNumber
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      canceled
      bookingType
    }
    unSettledBookings {
      id
      attendee {
        id
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          firstname
          lastname
          customerNumberPrefix
          customerNumber
        }
      }
      bookingNumber
      bookingNumberPrefix
      invoice {
        id
        billed
        createDate
        invoiceNumberPrefix
        invoiceNumber
      }
      canceled
      bookingType
      bookedBy
    }
  }
}
    `;

/**
 * __useGetCoursesDetailsQuery__
 *
 * To run a query within a React component, call `useGetCoursesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoursesDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoursesDetailsQuery, GetCoursesDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoursesDetailsQuery, GetCoursesDetailsQueryVariables>(GetCoursesDetailsDocument, baseOptions);
      }
export function useGetCoursesDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoursesDetailsQuery, GetCoursesDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoursesDetailsQuery, GetCoursesDetailsQueryVariables>(GetCoursesDetailsDocument, baseOptions);
        }
export type GetCoursesDetailsQueryHookResult = ReturnType<typeof useGetCoursesDetailsQuery>;
export type GetCoursesDetailsLazyQueryHookResult = ReturnType<typeof useGetCoursesDetailsLazyQuery>;
export type GetCoursesDetailsQueryResult = ApolloReactCommon.QueryResult<GetCoursesDetailsQuery, GetCoursesDetailsQueryVariables>;
export const GetUnsettledBookingsDocument = gql`
    query GetUnsettledBookings($options: ArrayDataOptions) {
  getUnSettledBookings(options: $options) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      waitListCount
      additionalInfo
      bookedLessonCount
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      paymentMethod {
        id
        type
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
        bankTransfer
        onlinePayment
      }
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        endDateTimeFirstCourseLesson
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        indexOfLessonInCourse
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          email
          city
          credit
          phoneNumber
          mobileNumber
          nonDisclosureNotice
        }
      }
      paymentMethod {
        id
        type
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
    }
  }
}
    `;

/**
 * __useGetUnsettledBookingsQuery__
 *
 * To run a query within a React component, call `useGetUnsettledBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnsettledBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnsettledBookingsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetUnsettledBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnsettledBookingsQuery, GetUnsettledBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUnsettledBookingsQuery, GetUnsettledBookingsQueryVariables>(GetUnsettledBookingsDocument, baseOptions);
      }
export function useGetUnsettledBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnsettledBookingsQuery, GetUnsettledBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUnsettledBookingsQuery, GetUnsettledBookingsQueryVariables>(GetUnsettledBookingsDocument, baseOptions);
        }
export type GetUnsettledBookingsQueryHookResult = ReturnType<typeof useGetUnsettledBookingsQuery>;
export type GetUnsettledBookingsLazyQueryHookResult = ReturnType<typeof useGetUnsettledBookingsLazyQuery>;
export type GetUnsettledBookingsQueryResult = ApolloReactCommon.QueryResult<GetUnsettledBookingsQuery, GetUnsettledBookingsQueryVariables>;
export const GetSettledBookingsDocument = gql`
    query GetSettledBookings($options: ArrayDataOptions) {
  getSettledBookings(options: $options) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      waitListCount
      additionalInfo
      bookedLessonCount
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      paymentMethod {
        id
        type
        cash
        esr
        iban
        bank
        bic
        sepaAccountholder
        bankTransfer
        onlinePayment
      }
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        endDateTimeFirstCourseLesson
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        indexOfLessonInCourse
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
      }
      scheduledPayments {
        paymentProvider
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          email
          city
          credit
          phoneNumber
          mobileNumber
          nonDisclosureNotice
        }
      }
      paymentMethod {
        id
        type
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
    }
  }
}
    `;

/**
 * __useGetSettledBookingsQuery__
 *
 * To run a query within a React component, call `useGetSettledBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettledBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettledBookingsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetSettledBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSettledBookingsQuery, GetSettledBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSettledBookingsQuery, GetSettledBookingsQueryVariables>(GetSettledBookingsDocument, baseOptions);
      }
export function useGetSettledBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSettledBookingsQuery, GetSettledBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSettledBookingsQuery, GetSettledBookingsQueryVariables>(GetSettledBookingsDocument, baseOptions);
        }
export type GetSettledBookingsQueryHookResult = ReturnType<typeof useGetSettledBookingsQuery>;
export type GetSettledBookingsLazyQueryHookResult = ReturnType<typeof useGetSettledBookingsLazyQuery>;
export type GetSettledBookingsQueryResult = ApolloReactCommon.QueryResult<GetSettledBookingsQuery, GetSettledBookingsQueryVariables>;
export const GetCanceledBookingsDocument = gql`
    query GetCanceledBookings($options: ArrayDataOptions) {
  getCanceledBookings(options: $options) {
    existsMore
    total
    items {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      updateDate
      createDate
      startDateTime
      courseId
      noticeStaff
      attendanceListNote
      noticeBooker
      coursePriceId
      payDate
      grossPrice
      netPrice
      vat
      isSpecial
      paymentType
      bookedBy
      canceled
      waitListCount
      additionalInfo
      bookedLessonCount
      bookingConfirmationSent
      waitingListConfirmationSent
      cancelationSent
      invoiceSent
      course {
        id
        prefixedCourseNumber
        allowLessonBooking
        lessonCount
        paymentInterval
        freePlaces
        maxAttendees
        startDateTime
        endDateTime
        endDateTimeFirstCourseLesson
        courseType {
          id
          name
          color
        }
        location {
          id
          city
          name
        }
        instructors {
          id
          firstname
          lastname
        }
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        indexOfLessonInCourse
      }
      courseLessonBookings {
        id
        courseLessonId
        bookingType
        bookingDate
        attendance
      }
      coursePrice {
        id
        grossPrice
        netPrice
        vat
      }
      invoice {
        id
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      reversalInvoice {
        id
        invoiceNumber
        invoiceNumberPrefix
        createDate
      }
      attendee {
        id
        erasedAt
        gender
        firstname
        lastname
        birthday
        customerNumberPrefix
        customerNumber
        member
        booker {
          id
          gender
          firstname
          lastname
          customerNumberPrefix
          customerNumber
          email
          city
          credit
          phoneNumber
          mobileNumber
          nonDisclosureNotice
        }
      }
      paymentMethod {
        id
        type
      }
      emailNotifications {
        id
        templateType
        subject
        createDate
        bookingId
        email
      }
    }
  }
}
    `;

/**
 * __useGetCanceledBookingsQuery__
 *
 * To run a query within a React component, call `useGetCanceledBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanceledBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanceledBookingsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetCanceledBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCanceledBookingsQuery, GetCanceledBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCanceledBookingsQuery, GetCanceledBookingsQueryVariables>(GetCanceledBookingsDocument, baseOptions);
      }
export function useGetCanceledBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCanceledBookingsQuery, GetCanceledBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCanceledBookingsQuery, GetCanceledBookingsQueryVariables>(GetCanceledBookingsDocument, baseOptions);
        }
export type GetCanceledBookingsQueryHookResult = ReturnType<typeof useGetCanceledBookingsQuery>;
export type GetCanceledBookingsLazyQueryHookResult = ReturnType<typeof useGetCanceledBookingsLazyQuery>;
export type GetCanceledBookingsQueryResult = ApolloReactCommon.QueryResult<GetCanceledBookingsQuery, GetCanceledBookingsQueryVariables>;
export const GetBookersByCourseWithBookingTypeDocument = gql`
    query GetBookersByCourseWithBookingType($courseId: String!) {
  getBookersByCourseWithBookingType(courseId: $courseId) {
    id
    customerNumberPrefix
    customerNumber
    firstname
    lastname
    email
    gender
    phoneNumber
    email
    attendees {
      id
      firstname
      lastname
      birthday
    }
  }
}
    `;

/**
 * __useGetBookersByCourseWithBookingTypeQuery__
 *
 * To run a query within a React component, call `useGetBookersByCourseWithBookingTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookersByCourseWithBookingTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookersByCourseWithBookingTypeQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetBookersByCourseWithBookingTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookersByCourseWithBookingTypeQuery, GetBookersByCourseWithBookingTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookersByCourseWithBookingTypeQuery, GetBookersByCourseWithBookingTypeQueryVariables>(GetBookersByCourseWithBookingTypeDocument, baseOptions);
      }
export function useGetBookersByCourseWithBookingTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookersByCourseWithBookingTypeQuery, GetBookersByCourseWithBookingTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookersByCourseWithBookingTypeQuery, GetBookersByCourseWithBookingTypeQueryVariables>(GetBookersByCourseWithBookingTypeDocument, baseOptions);
        }
export type GetBookersByCourseWithBookingTypeQueryHookResult = ReturnType<typeof useGetBookersByCourseWithBookingTypeQuery>;
export type GetBookersByCourseWithBookingTypeLazyQueryHookResult = ReturnType<typeof useGetBookersByCourseWithBookingTypeLazyQuery>;
export type GetBookersByCourseWithBookingTypeQueryResult = ApolloReactCommon.QueryResult<GetBookersByCourseWithBookingTypeQuery, GetBookersByCourseWithBookingTypeQueryVariables>;
export const GetInvoicePreviewDocument = gql`
    query GetInvoicePreview($invoiceId: String!) {
  getInvoicePreview(invoiceId: $invoiceId)
}
    `;

/**
 * __useGetInvoicePreviewQuery__
 *
 * To run a query within a React component, call `useGetInvoicePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePreviewQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoicePreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoicePreviewQuery, GetInvoicePreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoicePreviewQuery, GetInvoicePreviewQueryVariables>(GetInvoicePreviewDocument, baseOptions);
      }
export function useGetInvoicePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoicePreviewQuery, GetInvoicePreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoicePreviewQuery, GetInvoicePreviewQueryVariables>(GetInvoicePreviewDocument, baseOptions);
        }
export type GetInvoicePreviewQueryHookResult = ReturnType<typeof useGetInvoicePreviewQuery>;
export type GetInvoicePreviewLazyQueryHookResult = ReturnType<typeof useGetInvoicePreviewLazyQuery>;
export type GetInvoicePreviewQueryResult = ApolloReactCommon.QueryResult<GetInvoicePreviewQuery, GetInvoicePreviewQueryVariables>;
export const GetInvoiceDummyPreviewDocument = gql`
    query GetInvoiceDummyPreview($editTemplateInput: EditTemplateInput, $reversal: Boolean, $paymentType: PaymentType, $monthlySchedule: MonthlySchedule, $invoiceTemplateSetId: ID) {
  getInvoiceDummyPreview(editTemplateInput: $editTemplateInput, reversal: $reversal, paymentType: $paymentType, monthlySchedule: $monthlySchedule, invoiceTemplateSetId: $invoiceTemplateSetId)
}
    `;

/**
 * __useGetInvoiceDummyPreviewQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDummyPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDummyPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDummyPreviewQuery({
 *   variables: {
 *      editTemplateInput: // value for 'editTemplateInput'
 *      reversal: // value for 'reversal'
 *      paymentType: // value for 'paymentType'
 *      monthlySchedule: // value for 'monthlySchedule'
 *      invoiceTemplateSetId: // value for 'invoiceTemplateSetId'
 *   },
 * });
 */
export function useGetInvoiceDummyPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceDummyPreviewQuery, GetInvoiceDummyPreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceDummyPreviewQuery, GetInvoiceDummyPreviewQueryVariables>(GetInvoiceDummyPreviewDocument, baseOptions);
      }
export function useGetInvoiceDummyPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceDummyPreviewQuery, GetInvoiceDummyPreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceDummyPreviewQuery, GetInvoiceDummyPreviewQueryVariables>(GetInvoiceDummyPreviewDocument, baseOptions);
        }
export type GetInvoiceDummyPreviewQueryHookResult = ReturnType<typeof useGetInvoiceDummyPreviewQuery>;
export type GetInvoiceDummyPreviewLazyQueryHookResult = ReturnType<typeof useGetInvoiceDummyPreviewLazyQuery>;
export type GetInvoiceDummyPreviewQueryResult = ApolloReactCommon.QueryResult<GetInvoiceDummyPreviewQuery, GetInvoiceDummyPreviewQueryVariables>;
export const SendBookingInvoiceDocument = gql`
    mutation SendBookingInvoice($bookingId: ID!, $reversal: Boolean) {
  sendBookingInvoice(bookingId: $bookingId, reversal: $reversal)
}
    `;
export type SendBookingInvoiceMutationFn = ApolloReactCommon.MutationFunction<SendBookingInvoiceMutation, SendBookingInvoiceMutationVariables>;

/**
 * __useSendBookingInvoiceMutation__
 *
 * To run a mutation, you first call `useSendBookingInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingInvoiceMutation, { data, loading, error }] = useSendBookingInvoiceMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      reversal: // value for 'reversal'
 *   },
 * });
 */
export function useSendBookingInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendBookingInvoiceMutation, SendBookingInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<SendBookingInvoiceMutation, SendBookingInvoiceMutationVariables>(SendBookingInvoiceDocument, baseOptions);
      }
export type SendBookingInvoiceMutationHookResult = ReturnType<typeof useSendBookingInvoiceMutation>;
export type SendBookingInvoiceMutationResult = ApolloReactCommon.MutationResult<SendBookingInvoiceMutation>;
export type SendBookingInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<SendBookingInvoiceMutation, SendBookingInvoiceMutationVariables>;
export const SendBookingInvoicesByBookingIdsDocument = gql`
    mutation SendBookingInvoicesByBookingIds($bookingIds: [ID!]!, $reversal: Boolean) {
  sendBookingInvoicesByBookingIds(bookingIds: $bookingIds, reversal: $reversal)
}
    `;
export type SendBookingInvoicesByBookingIdsMutationFn = ApolloReactCommon.MutationFunction<SendBookingInvoicesByBookingIdsMutation, SendBookingInvoicesByBookingIdsMutationVariables>;

/**
 * __useSendBookingInvoicesByBookingIdsMutation__
 *
 * To run a mutation, you first call `useSendBookingInvoicesByBookingIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingInvoicesByBookingIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingInvoicesByBookingIdsMutation, { data, loading, error }] = useSendBookingInvoicesByBookingIdsMutation({
 *   variables: {
 *      bookingIds: // value for 'bookingIds'
 *      reversal: // value for 'reversal'
 *   },
 * });
 */
export function useSendBookingInvoicesByBookingIdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendBookingInvoicesByBookingIdsMutation, SendBookingInvoicesByBookingIdsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendBookingInvoicesByBookingIdsMutation, SendBookingInvoicesByBookingIdsMutationVariables>(SendBookingInvoicesByBookingIdsDocument, baseOptions);
      }
export type SendBookingInvoicesByBookingIdsMutationHookResult = ReturnType<typeof useSendBookingInvoicesByBookingIdsMutation>;
export type SendBookingInvoicesByBookingIdsMutationResult = ApolloReactCommon.MutationResult<SendBookingInvoicesByBookingIdsMutation>;
export type SendBookingInvoicesByBookingIdsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendBookingInvoicesByBookingIdsMutation, SendBookingInvoicesByBookingIdsMutationVariables>;
export const CreateCorrectionInvoiceDocument = gql`
    mutation CreateCorrectionInvoice($bookingId: String!, $sendMail: Boolean) {
  createCorrectionInvoice(bookingId: $bookingId, sendMail: $sendMail) {
    id
    invoiceFileName
  }
}
    `;
export type CreateCorrectionInvoiceMutationFn = ApolloReactCommon.MutationFunction<CreateCorrectionInvoiceMutation, CreateCorrectionInvoiceMutationVariables>;

/**
 * __useCreateCorrectionInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateCorrectionInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCorrectionInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCorrectionInvoiceMutation, { data, loading, error }] = useCreateCorrectionInvoiceMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      sendMail: // value for 'sendMail'
 *   },
 * });
 */
export function useCreateCorrectionInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCorrectionInvoiceMutation, CreateCorrectionInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCorrectionInvoiceMutation, CreateCorrectionInvoiceMutationVariables>(CreateCorrectionInvoiceDocument, baseOptions);
      }
export type CreateCorrectionInvoiceMutationHookResult = ReturnType<typeof useCreateCorrectionInvoiceMutation>;
export type CreateCorrectionInvoiceMutationResult = ApolloReactCommon.MutationResult<CreateCorrectionInvoiceMutation>;
export type CreateCorrectionInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCorrectionInvoiceMutation, CreateCorrectionInvoiceMutationVariables>;
export const GetReversalInvoicesDocument = gql`
    query GetReversalInvoices($options: ArrayDataOptions) {
  reversalInvoices(options: $options) {
    existsMore
    total
    items {
      id
      reversalInvoiceBody
      reversalInvoiceFileName
    }
  }
}
    `;

/**
 * __useGetReversalInvoicesQuery__
 *
 * To run a query within a React component, call `useGetReversalInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReversalInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReversalInvoicesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetReversalInvoicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReversalInvoicesQuery, GetReversalInvoicesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetReversalInvoicesQuery, GetReversalInvoicesQueryVariables>(GetReversalInvoicesDocument, baseOptions);
      }
export function useGetReversalInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReversalInvoicesQuery, GetReversalInvoicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetReversalInvoicesQuery, GetReversalInvoicesQueryVariables>(GetReversalInvoicesDocument, baseOptions);
        }
export type GetReversalInvoicesQueryHookResult = ReturnType<typeof useGetReversalInvoicesQuery>;
export type GetReversalInvoicesLazyQueryHookResult = ReturnType<typeof useGetReversalInvoicesLazyQuery>;
export type GetReversalInvoicesQueryResult = ApolloReactCommon.QueryResult<GetReversalInvoicesQuery, GetReversalInvoicesQueryVariables>;
export const GetReversalInvoiceBodyByIdDocument = gql`
    query GetReversalInvoiceBodyById($id: String!) {
  reversalInvoiceBodyById(id: $id) {
    id
    reversalInvoiceBody
    reversalInvoiceFileName
  }
}
    `;

/**
 * __useGetReversalInvoiceBodyByIdQuery__
 *
 * To run a query within a React component, call `useGetReversalInvoiceBodyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReversalInvoiceBodyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReversalInvoiceBodyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReversalInvoiceBodyByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReversalInvoiceBodyByIdQuery, GetReversalInvoiceBodyByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetReversalInvoiceBodyByIdQuery, GetReversalInvoiceBodyByIdQueryVariables>(GetReversalInvoiceBodyByIdDocument, baseOptions);
      }
export function useGetReversalInvoiceBodyByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReversalInvoiceBodyByIdQuery, GetReversalInvoiceBodyByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetReversalInvoiceBodyByIdQuery, GetReversalInvoiceBodyByIdQueryVariables>(GetReversalInvoiceBodyByIdDocument, baseOptions);
        }
export type GetReversalInvoiceBodyByIdQueryHookResult = ReturnType<typeof useGetReversalInvoiceBodyByIdQuery>;
export type GetReversalInvoiceBodyByIdLazyQueryHookResult = ReturnType<typeof useGetReversalInvoiceBodyByIdLazyQuery>;
export type GetReversalInvoiceBodyByIdQueryResult = ApolloReactCommon.QueryResult<GetReversalInvoiceBodyByIdQuery, GetReversalInvoiceBodyByIdQueryVariables>;
export const CancelBookingAndGenerateReversalInvoiceDocument = gql`
    mutation CancelBookingAndGenerateReversalInvoice($id: String!, $sendMail: Boolean, $options: CancelBookingOptionsInput) {
  cancelBookingAndGenerateReversalInvoice(id: $id, sendMail: $sendMail, options: $options)
}
    `;
export type CancelBookingAndGenerateReversalInvoiceMutationFn = ApolloReactCommon.MutationFunction<CancelBookingAndGenerateReversalInvoiceMutation, CancelBookingAndGenerateReversalInvoiceMutationVariables>;

/**
 * __useCancelBookingAndGenerateReversalInvoiceMutation__
 *
 * To run a mutation, you first call `useCancelBookingAndGenerateReversalInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingAndGenerateReversalInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingAndGenerateReversalInvoiceMutation, { data, loading, error }] = useCancelBookingAndGenerateReversalInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sendMail: // value for 'sendMail'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCancelBookingAndGenerateReversalInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelBookingAndGenerateReversalInvoiceMutation, CancelBookingAndGenerateReversalInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelBookingAndGenerateReversalInvoiceMutation, CancelBookingAndGenerateReversalInvoiceMutationVariables>(CancelBookingAndGenerateReversalInvoiceDocument, baseOptions);
      }
export type CancelBookingAndGenerateReversalInvoiceMutationHookResult = ReturnType<typeof useCancelBookingAndGenerateReversalInvoiceMutation>;
export type CancelBookingAndGenerateReversalInvoiceMutationResult = ApolloReactCommon.MutationResult<CancelBookingAndGenerateReversalInvoiceMutation>;
export type CancelBookingAndGenerateReversalInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelBookingAndGenerateReversalInvoiceMutation, CancelBookingAndGenerateReversalInvoiceMutationVariables>;
export const GetCourseLessonsByDateDocument = gql`
    query GetCourseLessonsByDate($date: DateTime!) {
  courseLessonsByDate(date: $date) {
    id
    startDateTime
    endDateTime
    course {
      id
      courseNumber
      prefixedCourseNumber
      courseType {
        id
        name
        color
      }
      instructors {
        id
        firstname
        lastname
        level
      }
    }
    location {
      id
      city
      name
      abbreviation
    }
    indexOfLessonInCourse
  }
}
    `;

/**
 * __useGetCourseLessonsByDateQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsByDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetCourseLessonsByDateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsByDateQuery, GetCourseLessonsByDateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsByDateQuery, GetCourseLessonsByDateQueryVariables>(GetCourseLessonsByDateDocument, baseOptions);
      }
export function useGetCourseLessonsByDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsByDateQuery, GetCourseLessonsByDateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsByDateQuery, GetCourseLessonsByDateQueryVariables>(GetCourseLessonsByDateDocument, baseOptions);
        }
export type GetCourseLessonsByDateQueryHookResult = ReturnType<typeof useGetCourseLessonsByDateQuery>;
export type GetCourseLessonsByDateLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsByDateLazyQuery>;
export type GetCourseLessonsByDateQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsByDateQuery, GetCourseLessonsByDateQueryVariables>;
export const GetCourseLessonsWithPaginationDocument = gql`
    query GetCourseLessonsWithPagination($date: DateTime, $options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  courseLessonsWithPagination(date: $date, options: $options, onlyCurrentUser: $onlyCurrentUser) {
    existsMore
    total
    items {
      id
      startDateTime
      endDateTime
      course {
        id
        courseNumber
        prefixedCourseNumber
        courseType {
          id
          name
          color
        }
        bookingCount
      }
      location {
        id
        city
        name
        abbreviation
      }
      instructors {
        id
        firstname
        lastname
        level
      }
      indexOfLessonInCourse
    }
  }
}
    `;

/**
 * __useGetCourseLessonsWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsWithPaginationQuery({
 *   variables: {
 *      date: // value for 'date'
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetCourseLessonsWithPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsWithPaginationQuery, GetCourseLessonsWithPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsWithPaginationQuery, GetCourseLessonsWithPaginationQueryVariables>(GetCourseLessonsWithPaginationDocument, baseOptions);
      }
export function useGetCourseLessonsWithPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsWithPaginationQuery, GetCourseLessonsWithPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsWithPaginationQuery, GetCourseLessonsWithPaginationQueryVariables>(GetCourseLessonsWithPaginationDocument, baseOptions);
        }
export type GetCourseLessonsWithPaginationQueryHookResult = ReturnType<typeof useGetCourseLessonsWithPaginationQuery>;
export type GetCourseLessonsWithPaginationLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsWithPaginationLazyQuery>;
export type GetCourseLessonsWithPaginationQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsWithPaginationQuery, GetCourseLessonsWithPaginationQueryVariables>;
export const GetCourseLessonsWithOfMonthPaginationDocument = gql`
    query GetCourseLessonsWithOfMonthPagination($date: DateTime!, $options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  courseLessonsOfMonthWithPagination(date: $date, options: $options, onlyCurrentUser: $onlyCurrentUser) {
    existsMore
    total
    items {
      id
      startDateTime
      endDateTime
      course {
        id
        courseNumber
        prefixedCourseNumber
        courseType {
          id
          name
          color
        }
        bookingCount
      }
      location {
        id
        city
        name
        abbreviation
      }
      instructors {
        id
        firstname
        lastname
        level
      }
      indexOfLessonInCourse
    }
  }
}
    `;

/**
 * __useGetCourseLessonsWithOfMonthPaginationQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsWithOfMonthPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsWithOfMonthPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsWithOfMonthPaginationQuery({
 *   variables: {
 *      date: // value for 'date'
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetCourseLessonsWithOfMonthPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsWithOfMonthPaginationQuery, GetCourseLessonsWithOfMonthPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsWithOfMonthPaginationQuery, GetCourseLessonsWithOfMonthPaginationQueryVariables>(GetCourseLessonsWithOfMonthPaginationDocument, baseOptions);
      }
export function useGetCourseLessonsWithOfMonthPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsWithOfMonthPaginationQuery, GetCourseLessonsWithOfMonthPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsWithOfMonthPaginationQuery, GetCourseLessonsWithOfMonthPaginationQueryVariables>(GetCourseLessonsWithOfMonthPaginationDocument, baseOptions);
        }
export type GetCourseLessonsWithOfMonthPaginationQueryHookResult = ReturnType<typeof useGetCourseLessonsWithOfMonthPaginationQuery>;
export type GetCourseLessonsWithOfMonthPaginationLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsWithOfMonthPaginationLazyQuery>;
export type GetCourseLessonsWithOfMonthPaginationQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsWithOfMonthPaginationQuery, GetCourseLessonsWithOfMonthPaginationQueryVariables>;
export const GetCourseLessonsOfMonthForExportDocument = gql`
    query GetCourseLessonsOfMonthForExport($date: DateTime!, $options: ArrayDataOptions, $onlyCurrentUser: Boolean, $withFinancials: Boolean = false) {
  courseLessonsOfMonthForExport(date: $date, options: $options, onlyCurrentUser: $onlyCurrentUser) {
    id
    startDateTime
    endDateTime
    course {
      id
      courseNumber
      prefixedCourseNumber
      courseType {
        id
        name
        color
      }
      bookingCount
      maxAttendees
      lessonCount
      paymentInterval
      coursePrice @include(if: $withFinancials) {
        id
        grossPrice
        isSpecial
      }
    }
    venue {
      id
      name
      rent @include(if: $withFinancials)
      rentType @include(if: $withFinancials)
    }
    revenueGross @include(if: $withFinancials)
    roomCost @include(if: $withFinancials)
    location {
      id
      city
      name
      abbreviation
    }
    instructors {
      id
      firstname
      lastname
      level
    }
    indexOfLessonInCourse
  }
}
    `;

/**
 * __useGetCourseLessonsOfMonthForExportQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsOfMonthForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsOfMonthForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsOfMonthForExportQuery({
 *   variables: {
 *      date: // value for 'date'
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *      withFinancials: // value for 'withFinancials'
 *   },
 * });
 */
export function useGetCourseLessonsOfMonthForExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsOfMonthForExportQuery, GetCourseLessonsOfMonthForExportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsOfMonthForExportQuery, GetCourseLessonsOfMonthForExportQueryVariables>(GetCourseLessonsOfMonthForExportDocument, baseOptions);
      }
export function useGetCourseLessonsOfMonthForExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsOfMonthForExportQuery, GetCourseLessonsOfMonthForExportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsOfMonthForExportQuery, GetCourseLessonsOfMonthForExportQueryVariables>(GetCourseLessonsOfMonthForExportDocument, baseOptions);
        }
export type GetCourseLessonsOfMonthForExportQueryHookResult = ReturnType<typeof useGetCourseLessonsOfMonthForExportQuery>;
export type GetCourseLessonsOfMonthForExportLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsOfMonthForExportLazyQuery>;
export type GetCourseLessonsOfMonthForExportQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsOfMonthForExportQuery, GetCourseLessonsOfMonthForExportQueryVariables>;
export const GetCourseLessonsForMonthViewDocument = gql`
    query GetCourseLessonsForMonthView($month: Float!, $year: Float!, $options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  courseLessonsForMonthView(month: $month, year: $year, options: $options, onlyCurrentUser: $onlyCurrentUser) {
    id
    startDateTime
    course {
      id
      prefixedCourseNumber
      courseType {
        id
        color
      }
    }
  }
}
    `;

/**
 * __useGetCourseLessonsForMonthViewQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsForMonthViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsForMonthViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsForMonthViewQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetCourseLessonsForMonthViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsForMonthViewQuery, GetCourseLessonsForMonthViewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsForMonthViewQuery, GetCourseLessonsForMonthViewQueryVariables>(GetCourseLessonsForMonthViewDocument, baseOptions);
      }
export function useGetCourseLessonsForMonthViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsForMonthViewQuery, GetCourseLessonsForMonthViewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsForMonthViewQuery, GetCourseLessonsForMonthViewQueryVariables>(GetCourseLessonsForMonthViewDocument, baseOptions);
        }
export type GetCourseLessonsForMonthViewQueryHookResult = ReturnType<typeof useGetCourseLessonsForMonthViewQuery>;
export type GetCourseLessonsForMonthViewLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsForMonthViewLazyQuery>;
export type GetCourseLessonsForMonthViewQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsForMonthViewQuery, GetCourseLessonsForMonthViewQueryVariables>;
export const GetCourseLessonsByCalendarWeekDocument = gql`
    query GetCourseLessonsByCalendarWeek($calendarWeek: Float!, $year: Float!, $options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  courseLessonsByCalendarWeek(calendarWeek: $calendarWeek, year: $year, options: $options, onlyCurrentUser: $onlyCurrentUser) {
    id
    startDateTime
    endDateTime
    course {
      id
      courseNumber
      prefixedCourseNumber
      courseType {
        id
        name
        color
      }
    }
    location {
      id
      city
      name
      abbreviation
    }
    indexOfLessonInCourse
    instructors {
      id
      firstname
      lastname
      level
    }
  }
}
    `;

/**
 * __useGetCourseLessonsByCalendarWeekQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsByCalendarWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsByCalendarWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsByCalendarWeekQuery({
 *   variables: {
 *      calendarWeek: // value for 'calendarWeek'
 *      year: // value for 'year'
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetCourseLessonsByCalendarWeekQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsByCalendarWeekQuery, GetCourseLessonsByCalendarWeekQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsByCalendarWeekQuery, GetCourseLessonsByCalendarWeekQueryVariables>(GetCourseLessonsByCalendarWeekDocument, baseOptions);
      }
export function useGetCourseLessonsByCalendarWeekLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsByCalendarWeekQuery, GetCourseLessonsByCalendarWeekQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsByCalendarWeekQuery, GetCourseLessonsByCalendarWeekQueryVariables>(GetCourseLessonsByCalendarWeekDocument, baseOptions);
        }
export type GetCourseLessonsByCalendarWeekQueryHookResult = ReturnType<typeof useGetCourseLessonsByCalendarWeekQuery>;
export type GetCourseLessonsByCalendarWeekLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsByCalendarWeekLazyQuery>;
export type GetCourseLessonsByCalendarWeekQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsByCalendarWeekQuery, GetCourseLessonsByCalendarWeekQueryVariables>;
export const GetCourseLessonsByCourseIdAttendanceDocument = gql`
    query GetCourseLessonsByCourseIdAttendance($courseId: ID!) {
  courseLessonsByCourseId(courseId: $courseId) {
    id
    startDateTime
    endDateTime
    course {
      id
      courseNumber
      prefixedCourseNumber
      allowLessonBooking
      courseType {
        id
        name
        color
      }
      instructors {
        id
        firstname
        lastname
        level
      }
    }
    location {
      id
      city
      name
      abbreviation
    }
    indexOfLessonInCourse
  }
}
    `;

/**
 * __useGetCourseLessonsByCourseIdAttendanceQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsByCourseIdAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsByCourseIdAttendanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsByCourseIdAttendanceQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseLessonsByCourseIdAttendanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsByCourseIdAttendanceQuery, GetCourseLessonsByCourseIdAttendanceQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsByCourseIdAttendanceQuery, GetCourseLessonsByCourseIdAttendanceQueryVariables>(GetCourseLessonsByCourseIdAttendanceDocument, baseOptions);
      }
export function useGetCourseLessonsByCourseIdAttendanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsByCourseIdAttendanceQuery, GetCourseLessonsByCourseIdAttendanceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsByCourseIdAttendanceQuery, GetCourseLessonsByCourseIdAttendanceQueryVariables>(GetCourseLessonsByCourseIdAttendanceDocument, baseOptions);
        }
export type GetCourseLessonsByCourseIdAttendanceQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdAttendanceQuery>;
export type GetCourseLessonsByCourseIdAttendanceLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdAttendanceLazyQuery>;
export type GetCourseLessonsByCourseIdAttendanceQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsByCourseIdAttendanceQuery, GetCourseLessonsByCourseIdAttendanceQueryVariables>;
export const GetCourseLessonsWithCollitionsDocument = gql`
    query GetCourseLessonsWithCollitions($collitionCheckInput: CollitionCheckInput!) {
  courseLessonsWithCollitions(collitionCheckInput: $collitionCheckInput) {
    id
    startDateTime
    endDateTime
    course {
      id
      prefixedCourseNumber
    }
    indexOfLessonInCourse
    originalCourseLessonId
  }
}
    `;

/**
 * __useGetCourseLessonsWithCollitionsQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsWithCollitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsWithCollitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsWithCollitionsQuery({
 *   variables: {
 *      collitionCheckInput: // value for 'collitionCheckInput'
 *   },
 * });
 */
export function useGetCourseLessonsWithCollitionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsWithCollitionsQuery, GetCourseLessonsWithCollitionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsWithCollitionsQuery, GetCourseLessonsWithCollitionsQueryVariables>(GetCourseLessonsWithCollitionsDocument, baseOptions);
      }
export function useGetCourseLessonsWithCollitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsWithCollitionsQuery, GetCourseLessonsWithCollitionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsWithCollitionsQuery, GetCourseLessonsWithCollitionsQueryVariables>(GetCourseLessonsWithCollitionsDocument, baseOptions);
        }
export type GetCourseLessonsWithCollitionsQueryHookResult = ReturnType<typeof useGetCourseLessonsWithCollitionsQuery>;
export type GetCourseLessonsWithCollitionsLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsWithCollitionsLazyQuery>;
export type GetCourseLessonsWithCollitionsQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsWithCollitionsQuery, GetCourseLessonsWithCollitionsQueryVariables>;
export const GetMultipleCourseLessonsCollisionCheckDocument = gql`
    query GetMultipleCourseLessonsCollisionCheck($collitionCheckInput: [CollitionCheckInput!]!) {
  multipleCourseLessonsCollisionCheck(collitionCheckInput: $collitionCheckInput) {
    id
    startDateTime
    endDateTime
    course {
      id
      prefixedCourseNumber
    }
    indexOfLessonInCourse
    originalCourseLessonId
  }
}
    `;

/**
 * __useGetMultipleCourseLessonsCollisionCheckQuery__
 *
 * To run a query within a React component, call `useGetMultipleCourseLessonsCollisionCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleCourseLessonsCollisionCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleCourseLessonsCollisionCheckQuery({
 *   variables: {
 *      collitionCheckInput: // value for 'collitionCheckInput'
 *   },
 * });
 */
export function useGetMultipleCourseLessonsCollisionCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMultipleCourseLessonsCollisionCheckQuery, GetMultipleCourseLessonsCollisionCheckQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMultipleCourseLessonsCollisionCheckQuery, GetMultipleCourseLessonsCollisionCheckQueryVariables>(GetMultipleCourseLessonsCollisionCheckDocument, baseOptions);
      }
export function useGetMultipleCourseLessonsCollisionCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMultipleCourseLessonsCollisionCheckQuery, GetMultipleCourseLessonsCollisionCheckQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMultipleCourseLessonsCollisionCheckQuery, GetMultipleCourseLessonsCollisionCheckQueryVariables>(GetMultipleCourseLessonsCollisionCheckDocument, baseOptions);
        }
export type GetMultipleCourseLessonsCollisionCheckQueryHookResult = ReturnType<typeof useGetMultipleCourseLessonsCollisionCheckQuery>;
export type GetMultipleCourseLessonsCollisionCheckLazyQueryHookResult = ReturnType<typeof useGetMultipleCourseLessonsCollisionCheckLazyQuery>;
export type GetMultipleCourseLessonsCollisionCheckQueryResult = ApolloReactCommon.QueryResult<GetMultipleCourseLessonsCollisionCheckQuery, GetMultipleCourseLessonsCollisionCheckQueryVariables>;
export const GetCourseLessonByIdDocument = gql`
    query GetCourseLessonById($id: String!) {
  courseLessonById(id: $id) {
    id
    startDateTime
    endDateTime
    course {
      id
      courseNumber
      prefixedCourseNumber
      courseType {
        id
        name
        color
      }
      instructors {
        id
        firstname
        lastname
        level
      }
      freePlaces
      waitListCount
      bookingCount
      placeReservationsCount
      lessonCount
      maxAttendees
      maxWaitlist
      startDateTime
      endDateTime
    }
    location {
      id
      city
      name
      abbreviation
    }
    instructors {
      id
      firstname
      lastname
      level
    }
    indexOfLessonInCourse
  }
}
    `;

/**
 * __useGetCourseLessonByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseLessonByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonByIdQuery, GetCourseLessonByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonByIdQuery, GetCourseLessonByIdQueryVariables>(GetCourseLessonByIdDocument, baseOptions);
      }
export function useGetCourseLessonByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonByIdQuery, GetCourseLessonByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonByIdQuery, GetCourseLessonByIdQueryVariables>(GetCourseLessonByIdDocument, baseOptions);
        }
export type GetCourseLessonByIdQueryHookResult = ReturnType<typeof useGetCourseLessonByIdQuery>;
export type GetCourseLessonByIdLazyQueryHookResult = ReturnType<typeof useGetCourseLessonByIdLazyQuery>;
export type GetCourseLessonByIdQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonByIdQuery, GetCourseLessonByIdQueryVariables>;
export const GetCourseLessonsForInstructorEditorDocument = gql`
    query GetCourseLessonsForInstructorEditor($courseId: ID!) {
  courseLessonsByCourseId(courseId: $courseId) {
    id
    startDateTime
    endDateTime
    billingDate
    instructors {
      id
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useGetCourseLessonsForInstructorEditorQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsForInstructorEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsForInstructorEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsForInstructorEditorQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseLessonsForInstructorEditorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsForInstructorEditorQuery, GetCourseLessonsForInstructorEditorQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsForInstructorEditorQuery, GetCourseLessonsForInstructorEditorQueryVariables>(GetCourseLessonsForInstructorEditorDocument, baseOptions);
      }
export function useGetCourseLessonsForInstructorEditorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsForInstructorEditorQuery, GetCourseLessonsForInstructorEditorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsForInstructorEditorQuery, GetCourseLessonsForInstructorEditorQueryVariables>(GetCourseLessonsForInstructorEditorDocument, baseOptions);
        }
export type GetCourseLessonsForInstructorEditorQueryHookResult = ReturnType<typeof useGetCourseLessonsForInstructorEditorQuery>;
export type GetCourseLessonsForInstructorEditorLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsForInstructorEditorLazyQuery>;
export type GetCourseLessonsForInstructorEditorQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsForInstructorEditorQuery, GetCourseLessonsForInstructorEditorQueryVariables>;
export const UpdateCourseLessonInstructorsDocument = gql`
    mutation UpdateCourseLessonInstructors($courseLessonId: ID!, $instructorIds: [ID!]!, $scope: LessonInstructorScope!) {
  updateCourseLessonInstructors(courseLessonId: $courseLessonId, instructorIds: $instructorIds, scope: $scope) {
    id
  }
}
    `;
export type UpdateCourseLessonInstructorsMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseLessonInstructorsMutation, UpdateCourseLessonInstructorsMutationVariables>;

/**
 * __useUpdateCourseLessonInstructorsMutation__
 *
 * To run a mutation, you first call `useUpdateCourseLessonInstructorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseLessonInstructorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseLessonInstructorsMutation, { data, loading, error }] = useUpdateCourseLessonInstructorsMutation({
 *   variables: {
 *      courseLessonId: // value for 'courseLessonId'
 *      instructorIds: // value for 'instructorIds'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useUpdateCourseLessonInstructorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseLessonInstructorsMutation, UpdateCourseLessonInstructorsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseLessonInstructorsMutation, UpdateCourseLessonInstructorsMutationVariables>(UpdateCourseLessonInstructorsDocument, baseOptions);
      }
export type UpdateCourseLessonInstructorsMutationHookResult = ReturnType<typeof useUpdateCourseLessonInstructorsMutation>;
export type UpdateCourseLessonInstructorsMutationResult = ApolloReactCommon.MutationResult<UpdateCourseLessonInstructorsMutation>;
export type UpdateCourseLessonInstructorsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseLessonInstructorsMutation, UpdateCourseLessonInstructorsMutationVariables>;
export const GetCourseLessonsByCourseIdMinimalDocument = gql`
    query GetCourseLessonsByCourseIdMinimal($courseId: ID!) {
  courseLessonsByCourseId(courseId: $courseId) {
    id
    startDateTime
    endDateTime
    indexOfLessonInCourse
  }
}
    `;

/**
 * __useGetCourseLessonsByCourseIdMinimalQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsByCourseIdMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsByCourseIdMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsByCourseIdMinimalQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseLessonsByCourseIdMinimalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsByCourseIdMinimalQuery, GetCourseLessonsByCourseIdMinimalQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsByCourseIdMinimalQuery, GetCourseLessonsByCourseIdMinimalQueryVariables>(GetCourseLessonsByCourseIdMinimalDocument, baseOptions);
      }
export function useGetCourseLessonsByCourseIdMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsByCourseIdMinimalQuery, GetCourseLessonsByCourseIdMinimalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsByCourseIdMinimalQuery, GetCourseLessonsByCourseIdMinimalQueryVariables>(GetCourseLessonsByCourseIdMinimalDocument, baseOptions);
        }
export type GetCourseLessonsByCourseIdMinimalQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdMinimalQuery>;
export type GetCourseLessonsByCourseIdMinimalLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsByCourseIdMinimalLazyQuery>;
export type GetCourseLessonsByCourseIdMinimalQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsByCourseIdMinimalQuery, GetCourseLessonsByCourseIdMinimalQueryVariables>;
export const GetCourseLessonsForBillingStatusDocument = gql`
    query GetCourseLessonsForBillingStatus($courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput!) {
  courseLessonsForBillingStatus(courseLessonForBillingStatusInput: $courseLessonForBillingStatusInput) {
    id
    courseId
    locationId
    venueId
    startDateTime
    endDateTime
    indexOfLessonInCourse
    course {
      id
      courseNumber
      prefixedCourseNumber
    }
    location {
      id
      city
      name
      abbreviation
    }
    venue {
      id
      name
    }
    instructors {
      id
      firstname
      lastname
      level
    }
  }
}
    `;

/**
 * __useGetCourseLessonsForBillingStatusQuery__
 *
 * To run a query within a React component, call `useGetCourseLessonsForBillingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLessonsForBillingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLessonsForBillingStatusQuery({
 *   variables: {
 *      courseLessonForBillingStatusInput: // value for 'courseLessonForBillingStatusInput'
 *   },
 * });
 */
export function useGetCourseLessonsForBillingStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseLessonsForBillingStatusQuery, GetCourseLessonsForBillingStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseLessonsForBillingStatusQuery, GetCourseLessonsForBillingStatusQueryVariables>(GetCourseLessonsForBillingStatusDocument, baseOptions);
      }
export function useGetCourseLessonsForBillingStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseLessonsForBillingStatusQuery, GetCourseLessonsForBillingStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseLessonsForBillingStatusQuery, GetCourseLessonsForBillingStatusQueryVariables>(GetCourseLessonsForBillingStatusDocument, baseOptions);
        }
export type GetCourseLessonsForBillingStatusQueryHookResult = ReturnType<typeof useGetCourseLessonsForBillingStatusQuery>;
export type GetCourseLessonsForBillingStatusLazyQueryHookResult = ReturnType<typeof useGetCourseLessonsForBillingStatusLazyQuery>;
export type GetCourseLessonsForBillingStatusQueryResult = ApolloReactCommon.QueryResult<GetCourseLessonsForBillingStatusQuery, GetCourseLessonsForBillingStatusQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations {
  locations {
    id
    abbreviation
    city
    name
    venues {
      id
      name
    }
    generalLocationContact {
      email
      phoneNumber
    }
    courses {
      id
      prefixedCourseNumber
    }
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, baseOptions);
      }
export function useGetLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, baseOptions);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = ApolloReactCommon.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetLocationsWithPaginationDocument = gql`
    query GetLocationsWithPagination($options: ArrayDataOptions, $currentUserOnly: Boolean) {
  locationsWithPagination(options: $options, currentUserOnly: $currentUserOnly) {
    existsMore
    total
    items {
      id
      abbreviation
      city
      name
      isPublished
      venues {
        id
        name
      }
      generalLocationContact {
        email
        phoneNumber
      }
      courses {
        id
        prefixedCourseNumber
      }
      instructors {
        id
        firstname
        lastname
      }
    }
  }
}
    `;

/**
 * __useGetLocationsWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetLocationsWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsWithPaginationQuery({
 *   variables: {
 *      options: // value for 'options'
 *      currentUserOnly: // value for 'currentUserOnly'
 *   },
 * });
 */
export function useGetLocationsWithPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationsWithPaginationQuery, GetLocationsWithPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationsWithPaginationQuery, GetLocationsWithPaginationQueryVariables>(GetLocationsWithPaginationDocument, baseOptions);
      }
export function useGetLocationsWithPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationsWithPaginationQuery, GetLocationsWithPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationsWithPaginationQuery, GetLocationsWithPaginationQueryVariables>(GetLocationsWithPaginationDocument, baseOptions);
        }
export type GetLocationsWithPaginationQueryHookResult = ReturnType<typeof useGetLocationsWithPaginationQuery>;
export type GetLocationsWithPaginationLazyQueryHookResult = ReturnType<typeof useGetLocationsWithPaginationLazyQuery>;
export type GetLocationsWithPaginationQueryResult = ApolloReactCommon.QueryResult<GetLocationsWithPaginationQuery, GetLocationsWithPaginationQueryVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($newLocationData: NewLocationInput!) {
  createLocation(newLocationData: $newLocationData) {
    id
    name
    isPublished
    zipCode
    city
    street
    website
    abbreviation
    info
    venues {
      id
      name
      isActive
      rent
      rentType
    }
    generalLocationContact {
      phoneNumber
      mobileNumber
      fax
      email
      note
    }
    locationContacts {
      id
      firstname
      lastname
      phoneNumber
      mobileNumber
      fax
      email
    }
  }
}
    `;
export type CreateLocationMutationFn = ApolloReactCommon.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      newLocationData: // value for 'newLocationData'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, baseOptions);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = ApolloReactCommon.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const GetLocationByIdDocument = gql`
    query GetLocationById($id: ID!) {
  locationById(id: $id) {
    id
    name
    isPublished
    zipCode
    city
    street
    website
    abbreviation
    info
    emailVariableInfo
    venues {
      id
      name
      isActive
      rent
      rentType
    }
    generalLocationContact {
      phoneNumber
      mobileNumber
      fax
      email
      note
    }
    locationContacts {
      id
      salutation
      firstname
      lastname
      department
      phoneNumber
      mobileNumber
      fax
      email
      note
    }
    courses {
      id
      locationId
      venueId
      courseNumber
    }
    customFields
  }
}
    `;

/**
 * __useGetLocationByIdQuery__
 *
 * To run a query within a React component, call `useGetLocationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, baseOptions);
      }
export function useGetLocationByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, baseOptions);
        }
export type GetLocationByIdQueryHookResult = ReturnType<typeof useGetLocationByIdQuery>;
export type GetLocationByIdLazyQueryHookResult = ReturnType<typeof useGetLocationByIdLazyQuery>;
export type GetLocationByIdQueryResult = ApolloReactCommon.QueryResult<GetLocationByIdQuery, GetLocationByIdQueryVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($editLocationData: EditLocationInput!) {
  updateLocation(editLocationData: $editLocationData) {
    id
    name
    isPublished
    zipCode
    city
    street
    website
    abbreviation
    info
    venues {
      id
      name
      isActive
      rent
      rentType
    }
    generalLocationContact {
      phoneNumber
      mobileNumber
      fax
      email
      note
    }
    locationContacts {
      id
      salutation
      firstname
      lastname
      department
      phoneNumber
      mobileNumber
      fax
      email
      note
    }
  }
}
    `;
export type UpdateLocationMutationFn = ApolloReactCommon.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      editLocationData: // value for 'editLocationData'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, baseOptions);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = ApolloReactCommon.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const RemoveLocationByIdDocument = gql`
    mutation RemoveLocationById($id: ID!) {
  removeLocation(id: $id)
}
    `;
export type RemoveLocationByIdMutationFn = ApolloReactCommon.MutationFunction<RemoveLocationByIdMutation, RemoveLocationByIdMutationVariables>;

/**
 * __useRemoveLocationByIdMutation__
 *
 * To run a mutation, you first call `useRemoveLocationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLocationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLocationByIdMutation, { data, loading, error }] = useRemoveLocationByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLocationByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveLocationByIdMutation, RemoveLocationByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveLocationByIdMutation, RemoveLocationByIdMutationVariables>(RemoveLocationByIdDocument, baseOptions);
      }
export type RemoveLocationByIdMutationHookResult = ReturnType<typeof useRemoveLocationByIdMutation>;
export type RemoveLocationByIdMutationResult = ApolloReactCommon.MutationResult<RemoveLocationByIdMutation>;
export type RemoveLocationByIdMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveLocationByIdMutation, RemoveLocationByIdMutationVariables>;
export const CreateLocationContactDocument = gql`
    mutation CreateLocationContact($newLocationContactData: NewLocationContactInput!) {
  createLocationContact(newLocationContactData: $newLocationContactData) {
    id
    salutation
    firstname
    lastname
    department
    phoneNumber
    mobileNumber
    fax
    email
    note
  }
}
    `;
export type CreateLocationContactMutationFn = ApolloReactCommon.MutationFunction<CreateLocationContactMutation, CreateLocationContactMutationVariables>;

/**
 * __useCreateLocationContactMutation__
 *
 * To run a mutation, you first call `useCreateLocationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationContactMutation, { data, loading, error }] = useCreateLocationContactMutation({
 *   variables: {
 *      newLocationContactData: // value for 'newLocationContactData'
 *   },
 * });
 */
export function useCreateLocationContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLocationContactMutation, CreateLocationContactMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLocationContactMutation, CreateLocationContactMutationVariables>(CreateLocationContactDocument, baseOptions);
      }
export type CreateLocationContactMutationHookResult = ReturnType<typeof useCreateLocationContactMutation>;
export type CreateLocationContactMutationResult = ApolloReactCommon.MutationResult<CreateLocationContactMutation>;
export type CreateLocationContactMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLocationContactMutation, CreateLocationContactMutationVariables>;
export const UpdateLocationContactDocument = gql`
    mutation UpdateLocationContact($editLocationContactData: EditLocationContactInput!) {
  updateLocationContact(editLocationContactData: $editLocationContactData) {
    id
    salutation
    firstname
    lastname
    department
    phoneNumber
    mobileNumber
    fax
    email
    note
  }
}
    `;
export type UpdateLocationContactMutationFn = ApolloReactCommon.MutationFunction<UpdateLocationContactMutation, UpdateLocationContactMutationVariables>;

/**
 * __useUpdateLocationContactMutation__
 *
 * To run a mutation, you first call `useUpdateLocationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationContactMutation, { data, loading, error }] = useUpdateLocationContactMutation({
 *   variables: {
 *      editLocationContactData: // value for 'editLocationContactData'
 *   },
 * });
 */
export function useUpdateLocationContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLocationContactMutation, UpdateLocationContactMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLocationContactMutation, UpdateLocationContactMutationVariables>(UpdateLocationContactDocument, baseOptions);
      }
export type UpdateLocationContactMutationHookResult = ReturnType<typeof useUpdateLocationContactMutation>;
export type UpdateLocationContactMutationResult = ApolloReactCommon.MutationResult<UpdateLocationContactMutation>;
export type UpdateLocationContactMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLocationContactMutation, UpdateLocationContactMutationVariables>;
export const GetLocationContactsDocument = gql`
    query GetLocationContacts {
  locationContacts {
    id
    salutation
    firstname
    lastname
    department
    phoneNumber
    mobileNumber
    email
    fax
    note
  }
}
    `;

/**
 * __useGetLocationContactsQuery__
 *
 * To run a query within a React component, call `useGetLocationContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationContactsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationContactsQuery, GetLocationContactsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationContactsQuery, GetLocationContactsQueryVariables>(GetLocationContactsDocument, baseOptions);
      }
export function useGetLocationContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationContactsQuery, GetLocationContactsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationContactsQuery, GetLocationContactsQueryVariables>(GetLocationContactsDocument, baseOptions);
        }
export type GetLocationContactsQueryHookResult = ReturnType<typeof useGetLocationContactsQuery>;
export type GetLocationContactsLazyQueryHookResult = ReturnType<typeof useGetLocationContactsLazyQuery>;
export type GetLocationContactsQueryResult = ApolloReactCommon.QueryResult<GetLocationContactsQuery, GetLocationContactsQueryVariables>;
export const GetLocationsByLocationContactIdDocument = gql`
    query GetLocationsByLocationContactId($id: ID!) {
  locationsByLocationContactId(id: $id) {
    name
  }
}
    `;

/**
 * __useGetLocationsByLocationContactIdQuery__
 *
 * To run a query within a React component, call `useGetLocationsByLocationContactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByLocationContactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByLocationContactIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationsByLocationContactIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationsByLocationContactIdQuery, GetLocationsByLocationContactIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationsByLocationContactIdQuery, GetLocationsByLocationContactIdQueryVariables>(GetLocationsByLocationContactIdDocument, baseOptions);
      }
export function useGetLocationsByLocationContactIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationsByLocationContactIdQuery, GetLocationsByLocationContactIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationsByLocationContactIdQuery, GetLocationsByLocationContactIdQueryVariables>(GetLocationsByLocationContactIdDocument, baseOptions);
        }
export type GetLocationsByLocationContactIdQueryHookResult = ReturnType<typeof useGetLocationsByLocationContactIdQuery>;
export type GetLocationsByLocationContactIdLazyQueryHookResult = ReturnType<typeof useGetLocationsByLocationContactIdLazyQuery>;
export type GetLocationsByLocationContactIdQueryResult = ApolloReactCommon.QueryResult<GetLocationsByLocationContactIdQuery, GetLocationsByLocationContactIdQueryVariables>;
export const RemoveLocationContactDocument = gql`
    mutation RemoveLocationContact($id: ID!) {
  removeLocationContact(id: $id)
}
    `;
export type RemoveLocationContactMutationFn = ApolloReactCommon.MutationFunction<RemoveLocationContactMutation, RemoveLocationContactMutationVariables>;

/**
 * __useRemoveLocationContactMutation__
 *
 * To run a mutation, you first call `useRemoveLocationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLocationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLocationContactMutation, { data, loading, error }] = useRemoveLocationContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLocationContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveLocationContactMutation, RemoveLocationContactMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveLocationContactMutation, RemoveLocationContactMutationVariables>(RemoveLocationContactDocument, baseOptions);
      }
export type RemoveLocationContactMutationHookResult = ReturnType<typeof useRemoveLocationContactMutation>;
export type RemoveLocationContactMutationResult = ApolloReactCommon.MutationResult<RemoveLocationContactMutation>;
export type RemoveLocationContactMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveLocationContactMutation, RemoveLocationContactMutationVariables>;
export const UpdateLocationPublishedStatusDocument = gql`
    mutation UpdateLocationPublishedStatus($locationId: ID!, $isPublished: Boolean!) {
  updateLocationPublishedStatus(locationId: $locationId, isPublished: $isPublished) {
    id
    isPublished
  }
}
    `;
export type UpdateLocationPublishedStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateLocationPublishedStatusMutation, UpdateLocationPublishedStatusMutationVariables>;

/**
 * __useUpdateLocationPublishedStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLocationPublishedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationPublishedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationPublishedStatusMutation, { data, loading, error }] = useUpdateLocationPublishedStatusMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useUpdateLocationPublishedStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLocationPublishedStatusMutation, UpdateLocationPublishedStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLocationPublishedStatusMutation, UpdateLocationPublishedStatusMutationVariables>(UpdateLocationPublishedStatusDocument, baseOptions);
      }
export type UpdateLocationPublishedStatusMutationHookResult = ReturnType<typeof useUpdateLocationPublishedStatusMutation>;
export type UpdateLocationPublishedStatusMutationResult = ApolloReactCommon.MutationResult<UpdateLocationPublishedStatusMutation>;
export type UpdateLocationPublishedStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLocationPublishedStatusMutation, UpdateLocationPublishedStatusMutationVariables>;
export const GetLocationsPublicDocument = gql`
    query GetLocationsPublic {
  locationsPublic {
    id
    abbreviation
    city
    name
    generalLocationContact {
      email
      phoneNumber
    }
  }
}
    `;

/**
 * __useGetLocationsPublicQuery__
 *
 * To run a query within a React component, call `useGetLocationsPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsPublicQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsPublicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLocationsPublicQuery, GetLocationsPublicQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLocationsPublicQuery, GetLocationsPublicQueryVariables>(GetLocationsPublicDocument, baseOptions);
      }
export function useGetLocationsPublicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationsPublicQuery, GetLocationsPublicQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLocationsPublicQuery, GetLocationsPublicQueryVariables>(GetLocationsPublicDocument, baseOptions);
        }
export type GetLocationsPublicQueryHookResult = ReturnType<typeof useGetLocationsPublicQuery>;
export type GetLocationsPublicLazyQueryHookResult = ReturnType<typeof useGetLocationsPublicLazyQuery>;
export type GetLocationsPublicQueryResult = ApolloReactCommon.QueryResult<GetLocationsPublicQuery, GetLocationsPublicQueryVariables>;
export const PasswordlessLoginDocument = gql`
    mutation passwordlessLogin($loginData: PasswordlessLoginInputType!) {
  passwordlessLogin(loginData: $loginData)
}
    `;
export type PasswordlessLoginMutationFn = ApolloReactCommon.MutationFunction<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>;

/**
 * __usePasswordlessLoginMutation__
 *
 * To run a mutation, you first call `usePasswordlessLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordlessLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordlessLoginMutation, { data, loading, error }] = usePasswordlessLoginMutation({
 *   variables: {
 *      loginData: // value for 'loginData'
 *   },
 * });
 */
export function usePasswordlessLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>) {
        return ApolloReactHooks.useMutation<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>(PasswordlessLoginDocument, baseOptions);
      }
export type PasswordlessLoginMutationHookResult = ReturnType<typeof usePasswordlessLoginMutation>;
export type PasswordlessLoginMutationResult = ApolloReactCommon.MutationResult<PasswordlessLoginMutation>;
export type PasswordlessLoginMutationOptions = ApolloReactCommon.BaseMutationOptions<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>;
export const CompletePasswordlessFlowDocument = gql`
    mutation completePasswordlessFlow($loginCode: String!) {
  completePasswordlessFlow(loginCode: $loginCode) {
    id
    roles
    email
  }
}
    `;
export type CompletePasswordlessFlowMutationFn = ApolloReactCommon.MutationFunction<CompletePasswordlessFlowMutation, CompletePasswordlessFlowMutationVariables>;

/**
 * __useCompletePasswordlessFlowMutation__
 *
 * To run a mutation, you first call `useCompletePasswordlessFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePasswordlessFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePasswordlessFlowMutation, { data, loading, error }] = useCompletePasswordlessFlowMutation({
 *   variables: {
 *      loginCode: // value for 'loginCode'
 *   },
 * });
 */
export function useCompletePasswordlessFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompletePasswordlessFlowMutation, CompletePasswordlessFlowMutationVariables>) {
        return ApolloReactHooks.useMutation<CompletePasswordlessFlowMutation, CompletePasswordlessFlowMutationVariables>(CompletePasswordlessFlowDocument, baseOptions);
      }
export type CompletePasswordlessFlowMutationHookResult = ReturnType<typeof useCompletePasswordlessFlowMutation>;
export type CompletePasswordlessFlowMutationResult = ApolloReactCommon.MutationResult<CompletePasswordlessFlowMutation>;
export type CompletePasswordlessFlowMutationOptions = ApolloReactCommon.BaseMutationOptions<CompletePasswordlessFlowMutation, CompletePasswordlessFlowMutationVariables>;
export const RequestAdminOrgDiscoveryDocument = gql`
    mutation requestAdminOrgDiscovery($email: String!) {
  requestAdminOrgDiscovery(email: $email)
}
    `;
export type RequestAdminOrgDiscoveryMutationFn = ApolloReactCommon.MutationFunction<RequestAdminOrgDiscoveryMutation, RequestAdminOrgDiscoveryMutationVariables>;

/**
 * __useRequestAdminOrgDiscoveryMutation__
 *
 * To run a mutation, you first call `useRequestAdminOrgDiscoveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAdminOrgDiscoveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAdminOrgDiscoveryMutation, { data, loading, error }] = useRequestAdminOrgDiscoveryMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestAdminOrgDiscoveryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestAdminOrgDiscoveryMutation, RequestAdminOrgDiscoveryMutationVariables>) {
        return ApolloReactHooks.useMutation<RequestAdminOrgDiscoveryMutation, RequestAdminOrgDiscoveryMutationVariables>(RequestAdminOrgDiscoveryDocument, baseOptions);
      }
export type RequestAdminOrgDiscoveryMutationHookResult = ReturnType<typeof useRequestAdminOrgDiscoveryMutation>;
export type RequestAdminOrgDiscoveryMutationResult = ApolloReactCommon.MutationResult<RequestAdminOrgDiscoveryMutation>;
export type RequestAdminOrgDiscoveryMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestAdminOrgDiscoveryMutation, RequestAdminOrgDiscoveryMutationVariables>;
export const ChangeForgottenPasswordDocument = gql`
    mutation changeForgottenPassword($changePasswordId: String!, $newPassword: String!) {
  changeForgottenPassword(changePasswordId: $changePasswordId, newPassword: $newPassword)
}
    `;
export type ChangeForgottenPasswordMutationFn = ApolloReactCommon.MutationFunction<ChangeForgottenPasswordMutation, ChangeForgottenPasswordMutationVariables>;

/**
 * __useChangeForgottenPasswordMutation__
 *
 * To run a mutation, you first call `useChangeForgottenPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeForgottenPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeForgottenPasswordMutation, { data, loading, error }] = useChangeForgottenPasswordMutation({
 *   variables: {
 *      changePasswordId: // value for 'changePasswordId'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangeForgottenPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeForgottenPasswordMutation, ChangeForgottenPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeForgottenPasswordMutation, ChangeForgottenPasswordMutationVariables>(ChangeForgottenPasswordDocument, baseOptions);
      }
export type ChangeForgottenPasswordMutationHookResult = ReturnType<typeof useChangeForgottenPasswordMutation>;
export type ChangeForgottenPasswordMutationResult = ApolloReactCommon.MutationResult<ChangeForgottenPasswordMutation>;
export type ChangeForgottenPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeForgottenPasswordMutation, ChangeForgottenPasswordMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logoutUser
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const GetMollieRetryQueueEntriesDocument = gql`
    query GetMollieRetryQueueEntries {
  getMollieRetryQueueEntries {
    attemptId
    scheduledPaymentId
    bookingId
    bookerName
    bookerEmail
    amount
    currency
    chargebackReason
    chargebackedAt
    chargebackRetryCount
    sepaDisabled
    isNonRetriable
  }
}
    `;

/**
 * __useGetMollieRetryQueueEntriesQuery__
 *
 * To run a query within a React component, call `useGetMollieRetryQueueEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMollieRetryQueueEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMollieRetryQueueEntriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMollieRetryQueueEntriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMollieRetryQueueEntriesQuery, GetMollieRetryQueueEntriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMollieRetryQueueEntriesQuery, GetMollieRetryQueueEntriesQueryVariables>(GetMollieRetryQueueEntriesDocument, baseOptions);
      }
export function useGetMollieRetryQueueEntriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMollieRetryQueueEntriesQuery, GetMollieRetryQueueEntriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMollieRetryQueueEntriesQuery, GetMollieRetryQueueEntriesQueryVariables>(GetMollieRetryQueueEntriesDocument, baseOptions);
        }
export type GetMollieRetryQueueEntriesQueryHookResult = ReturnType<typeof useGetMollieRetryQueueEntriesQuery>;
export type GetMollieRetryQueueEntriesLazyQueryHookResult = ReturnType<typeof useGetMollieRetryQueueEntriesLazyQuery>;
export type GetMollieRetryQueueEntriesQueryResult = ApolloReactCommon.QueryResult<GetMollieRetryQueueEntriesQuery, GetMollieRetryQueueEntriesQueryVariables>;
export const RetryMolliePaymentManuallyDocument = gql`
    mutation RetryMolliePaymentManually($scheduledPaymentId: ID!) {
  retryMolliePaymentManually(scheduledPaymentId: $scheduledPaymentId)
}
    `;
export type RetryMolliePaymentManuallyMutationFn = ApolloReactCommon.MutationFunction<RetryMolliePaymentManuallyMutation, RetryMolliePaymentManuallyMutationVariables>;

/**
 * __useRetryMolliePaymentManuallyMutation__
 *
 * To run a mutation, you first call `useRetryMolliePaymentManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryMolliePaymentManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryMolliePaymentManuallyMutation, { data, loading, error }] = useRetryMolliePaymentManuallyMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *   },
 * });
 */
export function useRetryMolliePaymentManuallyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetryMolliePaymentManuallyMutation, RetryMolliePaymentManuallyMutationVariables>) {
        return ApolloReactHooks.useMutation<RetryMolliePaymentManuallyMutation, RetryMolliePaymentManuallyMutationVariables>(RetryMolliePaymentManuallyDocument, baseOptions);
      }
export type RetryMolliePaymentManuallyMutationHookResult = ReturnType<typeof useRetryMolliePaymentManuallyMutation>;
export type RetryMolliePaymentManuallyMutationResult = ApolloReactCommon.MutationResult<RetryMolliePaymentManuallyMutation>;
export type RetryMolliePaymentManuallyMutationOptions = ApolloReactCommon.BaseMutationOptions<RetryMolliePaymentManuallyMutation, RetryMolliePaymentManuallyMutationVariables>;
export const GetNewsletterSettingsDocument = gql`
    query GetNewsletterSettings {
  newsletterSettings {
    id
    mailjetApiKeyPublic
    hasMailjetApiSecret
    mailjetApiKeyName
    listRule
    optOutBlocks
    bookingsSince
    assignment
    homeLocationMaxKm
    residenceRadiusKm
    errorEmail
    defaultErrorEmail
    lastConnectionCheckAt
    lastConnectionOk
    lastConnectionError
    webhookUrl
    webhookRegisteredAt
    rulesChangedAt
    rulesChangedByName
  }
}
    `;

/**
 * __useGetNewsletterSettingsQuery__
 *
 * To run a query within a React component, call `useGetNewsletterSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsletterSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsletterSettingsQuery, GetNewsletterSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsletterSettingsQuery, GetNewsletterSettingsQueryVariables>(GetNewsletterSettingsDocument, baseOptions);
      }
export function useGetNewsletterSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsletterSettingsQuery, GetNewsletterSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsletterSettingsQuery, GetNewsletterSettingsQueryVariables>(GetNewsletterSettingsDocument, baseOptions);
        }
export type GetNewsletterSettingsQueryHookResult = ReturnType<typeof useGetNewsletterSettingsQuery>;
export type GetNewsletterSettingsLazyQueryHookResult = ReturnType<typeof useGetNewsletterSettingsLazyQuery>;
export type GetNewsletterSettingsQueryResult = ApolloReactCommon.QueryResult<GetNewsletterSettingsQuery, GetNewsletterSettingsQueryVariables>;
export const UpdateNewsletterSettingsDocument = gql`
    mutation UpdateNewsletterSettings($input: NewsletterSettingsInput!) {
  updateNewsletterSettings(input: $input) {
    id
    mailjetApiKeyPublic
    hasMailjetApiSecret
    mailjetApiKeyName
    listRule
    optOutBlocks
    bookingsSince
    assignment
    homeLocationMaxKm
    residenceRadiusKm
    errorEmail
    defaultErrorEmail
    lastConnectionCheckAt
    lastConnectionOk
    lastConnectionError
    webhookUrl
    webhookRegisteredAt
    rulesChangedAt
    rulesChangedByName
  }
}
    `;
export type UpdateNewsletterSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateNewsletterSettingsMutation, UpdateNewsletterSettingsMutationVariables>;

/**
 * __useUpdateNewsletterSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNewsletterSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsletterSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsletterSettingsMutation, { data, loading, error }] = useUpdateNewsletterSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsletterSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNewsletterSettingsMutation, UpdateNewsletterSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNewsletterSettingsMutation, UpdateNewsletterSettingsMutationVariables>(UpdateNewsletterSettingsDocument, baseOptions);
      }
export type UpdateNewsletterSettingsMutationHookResult = ReturnType<typeof useUpdateNewsletterSettingsMutation>;
export type UpdateNewsletterSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateNewsletterSettingsMutation>;
export type UpdateNewsletterSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNewsletterSettingsMutation, UpdateNewsletterSettingsMutationVariables>;
export const TestNewsletterConnectionDocument = gql`
    mutation TestNewsletterConnection {
  testNewsletterConnection {
    id
    mailjetApiKeyPublic
    hasMailjetApiSecret
    mailjetApiKeyName
    listRule
    optOutBlocks
    bookingsSince
    assignment
    homeLocationMaxKm
    residenceRadiusKm
    errorEmail
    defaultErrorEmail
    lastConnectionCheckAt
    lastConnectionOk
    lastConnectionError
    webhookUrl
    webhookRegisteredAt
    rulesChangedAt
    rulesChangedByName
  }
}
    `;
export type TestNewsletterConnectionMutationFn = ApolloReactCommon.MutationFunction<TestNewsletterConnectionMutation, TestNewsletterConnectionMutationVariables>;

/**
 * __useTestNewsletterConnectionMutation__
 *
 * To run a mutation, you first call `useTestNewsletterConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestNewsletterConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testNewsletterConnectionMutation, { data, loading, error }] = useTestNewsletterConnectionMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestNewsletterConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestNewsletterConnectionMutation, TestNewsletterConnectionMutationVariables>) {
        return ApolloReactHooks.useMutation<TestNewsletterConnectionMutation, TestNewsletterConnectionMutationVariables>(TestNewsletterConnectionDocument, baseOptions);
      }
export type TestNewsletterConnectionMutationHookResult = ReturnType<typeof useTestNewsletterConnectionMutation>;
export type TestNewsletterConnectionMutationResult = ApolloReactCommon.MutationResult<TestNewsletterConnectionMutation>;
export type TestNewsletterConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<TestNewsletterConnectionMutation, TestNewsletterConnectionMutationVariables>;
export const UpdateNewsletterRulesDocument = gql`
    mutation UpdateNewsletterRules($input: NewsletterRulesInput!) {
  updateNewsletterRules(input: $input) {
    id
    mailjetApiKeyPublic
    hasMailjetApiSecret
    mailjetApiKeyName
    listRule
    optOutBlocks
    bookingsSince
    assignment
    homeLocationMaxKm
    residenceRadiusKm
    errorEmail
    defaultErrorEmail
    lastConnectionCheckAt
    lastConnectionOk
    lastConnectionError
    webhookUrl
    webhookRegisteredAt
    rulesChangedAt
    rulesChangedByName
  }
}
    `;
export type UpdateNewsletterRulesMutationFn = ApolloReactCommon.MutationFunction<UpdateNewsletterRulesMutation, UpdateNewsletterRulesMutationVariables>;

/**
 * __useUpdateNewsletterRulesMutation__
 *
 * To run a mutation, you first call `useUpdateNewsletterRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsletterRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsletterRulesMutation, { data, loading, error }] = useUpdateNewsletterRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewsletterRulesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNewsletterRulesMutation, UpdateNewsletterRulesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNewsletterRulesMutation, UpdateNewsletterRulesMutationVariables>(UpdateNewsletterRulesDocument, baseOptions);
      }
export type UpdateNewsletterRulesMutationHookResult = ReturnType<typeof useUpdateNewsletterRulesMutation>;
export type UpdateNewsletterRulesMutationResult = ApolloReactCommon.MutationResult<UpdateNewsletterRulesMutation>;
export type UpdateNewsletterRulesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNewsletterRulesMutation, UpdateNewsletterRulesMutationVariables>;
export const NewsletterRulesPreviewDocument = gql`
    query NewsletterRulesPreview($input: NewsletterRulesInput!) {
  newsletterRulesPreview(input: $input) {
    totalCount
    otherListRuleCount
    multiListCount
    radiusCount
    addedCount
    removedCount
    shrinkingListCount
  }
}
    `;

/**
 * __useNewsletterRulesPreviewQuery__
 *
 * To run a query within a React component, call `useNewsletterRulesPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterRulesPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterRulesPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewsletterRulesPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NewsletterRulesPreviewQuery, NewsletterRulesPreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<NewsletterRulesPreviewQuery, NewsletterRulesPreviewQueryVariables>(NewsletterRulesPreviewDocument, baseOptions);
      }
export function useNewsletterRulesPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewsletterRulesPreviewQuery, NewsletterRulesPreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NewsletterRulesPreviewQuery, NewsletterRulesPreviewQueryVariables>(NewsletterRulesPreviewDocument, baseOptions);
        }
export type NewsletterRulesPreviewQueryHookResult = ReturnType<typeof useNewsletterRulesPreviewQuery>;
export type NewsletterRulesPreviewLazyQueryHookResult = ReturnType<typeof useNewsletterRulesPreviewLazyQuery>;
export type NewsletterRulesPreviewQueryResult = ApolloReactCommon.QueryResult<NewsletterRulesPreviewQuery, NewsletterRulesPreviewQueryVariables>;
export const GetNewsletterLocationListsDocument = gql`
    query GetNewsletterLocationLists {
  newsletterLocationLists {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
  newsletterRecipientCounts {
    listId
    count
    radiusCount
  }
  newsletterOverview {
    addressesEnabled
    lastRunAt
    lastRunDurationMs
  }
}
    `;

/**
 * __useGetNewsletterLocationListsQuery__
 *
 * To run a query within a React component, call `useGetNewsletterLocationListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterLocationListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterLocationListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsletterLocationListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsletterLocationListsQuery, GetNewsletterLocationListsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsletterLocationListsQuery, GetNewsletterLocationListsQueryVariables>(GetNewsletterLocationListsDocument, baseOptions);
      }
export function useGetNewsletterLocationListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsletterLocationListsQuery, GetNewsletterLocationListsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsletterLocationListsQuery, GetNewsletterLocationListsQueryVariables>(GetNewsletterLocationListsDocument, baseOptions);
        }
export type GetNewsletterLocationListsQueryHookResult = ReturnType<typeof useGetNewsletterLocationListsQuery>;
export type GetNewsletterLocationListsLazyQueryHookResult = ReturnType<typeof useGetNewsletterLocationListsLazyQuery>;
export type GetNewsletterLocationListsQueryResult = ApolloReactCommon.QueryResult<GetNewsletterLocationListsQuery, GetNewsletterLocationListsQueryVariables>;
export const GetNewsletterListLogDocument = gql`
    query GetNewsletterListLog($listId: ID!, $limit: Int) {
  newsletterLog(listId: $listId, limit: $limit) {
    id
    createDate
    kind
    listName
    count
    failed
    detail
    durationMs
    userName
    location {
      id
      name
    }
  }
}
    `;

/**
 * __useGetNewsletterListLogQuery__
 *
 * To run a query within a React component, call `useGetNewsletterListLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterListLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterListLogQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetNewsletterListLogQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsletterListLogQuery, GetNewsletterListLogQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsletterListLogQuery, GetNewsletterListLogQueryVariables>(GetNewsletterListLogDocument, baseOptions);
      }
export function useGetNewsletterListLogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsletterListLogQuery, GetNewsletterListLogQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsletterListLogQuery, GetNewsletterListLogQueryVariables>(GetNewsletterListLogDocument, baseOptions);
        }
export type GetNewsletterListLogQueryHookResult = ReturnType<typeof useGetNewsletterListLogQuery>;
export type GetNewsletterListLogLazyQueryHookResult = ReturnType<typeof useGetNewsletterListLogLazyQuery>;
export type GetNewsletterListLogQueryResult = ApolloReactCommon.QueryResult<GetNewsletterListLogQuery, GetNewsletterListLogQueryVariables>;
export const GetNewsletterLocationListRowsDocument = gql`
    query GetNewsletterLocationListRows {
  newsletterLocationLists {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
}
    `;

/**
 * __useGetNewsletterLocationListRowsQuery__
 *
 * To run a query within a React component, call `useGetNewsletterLocationListRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterLocationListRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterLocationListRowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsletterLocationListRowsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsletterLocationListRowsQuery, GetNewsletterLocationListRowsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsletterLocationListRowsQuery, GetNewsletterLocationListRowsQueryVariables>(GetNewsletterLocationListRowsDocument, baseOptions);
      }
export function useGetNewsletterLocationListRowsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsletterLocationListRowsQuery, GetNewsletterLocationListRowsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsletterLocationListRowsQuery, GetNewsletterLocationListRowsQueryVariables>(GetNewsletterLocationListRowsDocument, baseOptions);
        }
export type GetNewsletterLocationListRowsQueryHookResult = ReturnType<typeof useGetNewsletterLocationListRowsQuery>;
export type GetNewsletterLocationListRowsLazyQueryHookResult = ReturnType<typeof useGetNewsletterLocationListRowsLazyQuery>;
export type GetNewsletterLocationListRowsQueryResult = ApolloReactCommon.QueryResult<GetNewsletterLocationListRowsQuery, GetNewsletterLocationListRowsQueryVariables>;
export const SetNewsletterLocationListEnabledDocument = gql`
    mutation SetNewsletterLocationListEnabled($id: ID!, $enabled: Boolean!) {
  setNewsletterLocationListEnabled(id: $id, enabled: $enabled) {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
}
    `;
export type SetNewsletterLocationListEnabledMutationFn = ApolloReactCommon.MutationFunction<SetNewsletterLocationListEnabledMutation, SetNewsletterLocationListEnabledMutationVariables>;

/**
 * __useSetNewsletterLocationListEnabledMutation__
 *
 * To run a mutation, you first call `useSetNewsletterLocationListEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewsletterLocationListEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewsletterLocationListEnabledMutation, { data, loading, error }] = useSetNewsletterLocationListEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetNewsletterLocationListEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNewsletterLocationListEnabledMutation, SetNewsletterLocationListEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<SetNewsletterLocationListEnabledMutation, SetNewsletterLocationListEnabledMutationVariables>(SetNewsletterLocationListEnabledDocument, baseOptions);
      }
export type SetNewsletterLocationListEnabledMutationHookResult = ReturnType<typeof useSetNewsletterLocationListEnabledMutation>;
export type SetNewsletterLocationListEnabledMutationResult = ApolloReactCommon.MutationResult<SetNewsletterLocationListEnabledMutation>;
export type SetNewsletterLocationListEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<SetNewsletterLocationListEnabledMutation, SetNewsletterLocationListEnabledMutationVariables>;
export const SetNewsletterLocationListExcludedDocument = gql`
    mutation SetNewsletterLocationListExcluded($id: ID!, $excluded: Boolean!) {
  setNewsletterLocationListExcluded(id: $id, excluded: $excluded) {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
}
    `;
export type SetNewsletterLocationListExcludedMutationFn = ApolloReactCommon.MutationFunction<SetNewsletterLocationListExcludedMutation, SetNewsletterLocationListExcludedMutationVariables>;

/**
 * __useSetNewsletterLocationListExcludedMutation__
 *
 * To run a mutation, you first call `useSetNewsletterLocationListExcludedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewsletterLocationListExcludedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewsletterLocationListExcludedMutation, { data, loading, error }] = useSetNewsletterLocationListExcludedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      excluded: // value for 'excluded'
 *   },
 * });
 */
export function useSetNewsletterLocationListExcludedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNewsletterLocationListExcludedMutation, SetNewsletterLocationListExcludedMutationVariables>) {
        return ApolloReactHooks.useMutation<SetNewsletterLocationListExcludedMutation, SetNewsletterLocationListExcludedMutationVariables>(SetNewsletterLocationListExcludedDocument, baseOptions);
      }
export type SetNewsletterLocationListExcludedMutationHookResult = ReturnType<typeof useSetNewsletterLocationListExcludedMutation>;
export type SetNewsletterLocationListExcludedMutationResult = ApolloReactCommon.MutationResult<SetNewsletterLocationListExcludedMutation>;
export type SetNewsletterLocationListExcludedMutationOptions = ApolloReactCommon.BaseMutationOptions<SetNewsletterLocationListExcludedMutation, SetNewsletterLocationListExcludedMutationVariables>;
export const SyncNewsletterLocationListDocument = gql`
    mutation SyncNewsletterLocationList($id: ID!, $release: Boolean) {
  syncNewsletterLocationList(id: $id, release: $release) {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
}
    `;
export type SyncNewsletterLocationListMutationFn = ApolloReactCommon.MutationFunction<SyncNewsletterLocationListMutation, SyncNewsletterLocationListMutationVariables>;

/**
 * __useSyncNewsletterLocationListMutation__
 *
 * To run a mutation, you first call `useSyncNewsletterLocationListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncNewsletterLocationListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncNewsletterLocationListMutation, { data, loading, error }] = useSyncNewsletterLocationListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      release: // value for 'release'
 *   },
 * });
 */
export function useSyncNewsletterLocationListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncNewsletterLocationListMutation, SyncNewsletterLocationListMutationVariables>) {
        return ApolloReactHooks.useMutation<SyncNewsletterLocationListMutation, SyncNewsletterLocationListMutationVariables>(SyncNewsletterLocationListDocument, baseOptions);
      }
export type SyncNewsletterLocationListMutationHookResult = ReturnType<typeof useSyncNewsletterLocationListMutation>;
export type SyncNewsletterLocationListMutationResult = ApolloReactCommon.MutationResult<SyncNewsletterLocationListMutation>;
export type SyncNewsletterLocationListMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncNewsletterLocationListMutation, SyncNewsletterLocationListMutationVariables>;
export const SyncAllNewsletterLocationListsDocument = gql`
    mutation SyncAllNewsletterLocationLists {
  syncAllNewsletterLocationLists
}
    `;
export type SyncAllNewsletterLocationListsMutationFn = ApolloReactCommon.MutationFunction<SyncAllNewsletterLocationListsMutation, SyncAllNewsletterLocationListsMutationVariables>;

/**
 * __useSyncAllNewsletterLocationListsMutation__
 *
 * To run a mutation, you first call `useSyncAllNewsletterLocationListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAllNewsletterLocationListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAllNewsletterLocationListsMutation, { data, loading, error }] = useSyncAllNewsletterLocationListsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncAllNewsletterLocationListsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncAllNewsletterLocationListsMutation, SyncAllNewsletterLocationListsMutationVariables>) {
        return ApolloReactHooks.useMutation<SyncAllNewsletterLocationListsMutation, SyncAllNewsletterLocationListsMutationVariables>(SyncAllNewsletterLocationListsDocument, baseOptions);
      }
export type SyncAllNewsletterLocationListsMutationHookResult = ReturnType<typeof useSyncAllNewsletterLocationListsMutation>;
export type SyncAllNewsletterLocationListsMutationResult = ApolloReactCommon.MutationResult<SyncAllNewsletterLocationListsMutation>;
export type SyncAllNewsletterLocationListsMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncAllNewsletterLocationListsMutation, SyncAllNewsletterLocationListsMutationVariables>;
export const ResetNewsletterLocationListLinkDocument = gql`
    mutation ResetNewsletterLocationListLink($id: ID!) {
  resetNewsletterLocationListLink(id: $id) {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
}
    `;
export type ResetNewsletterLocationListLinkMutationFn = ApolloReactCommon.MutationFunction<ResetNewsletterLocationListLinkMutation, ResetNewsletterLocationListLinkMutationVariables>;

/**
 * __useResetNewsletterLocationListLinkMutation__
 *
 * To run a mutation, you first call `useResetNewsletterLocationListLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetNewsletterLocationListLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetNewsletterLocationListLinkMutation, { data, loading, error }] = useResetNewsletterLocationListLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetNewsletterLocationListLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetNewsletterLocationListLinkMutation, ResetNewsletterLocationListLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetNewsletterLocationListLinkMutation, ResetNewsletterLocationListLinkMutationVariables>(ResetNewsletterLocationListLinkDocument, baseOptions);
      }
export type ResetNewsletterLocationListLinkMutationHookResult = ReturnType<typeof useResetNewsletterLocationListLinkMutation>;
export type ResetNewsletterLocationListLinkMutationResult = ApolloReactCommon.MutationResult<ResetNewsletterLocationListLinkMutation>;
export type ResetNewsletterLocationListLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetNewsletterLocationListLinkMutation, ResetNewsletterLocationListLinkMutationVariables>;
export const CreateNewsletterCustomListDocument = gql`
    mutation CreateNewsletterCustomList($name: String!, $locationIds: [ID!]!) {
  createNewsletterCustomList(name: $name, locationIds: $locationIds) {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
}
    `;
export type CreateNewsletterCustomListMutationFn = ApolloReactCommon.MutationFunction<CreateNewsletterCustomListMutation, CreateNewsletterCustomListMutationVariables>;

/**
 * __useCreateNewsletterCustomListMutation__
 *
 * To run a mutation, you first call `useCreateNewsletterCustomListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsletterCustomListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsletterCustomListMutation, { data, loading, error }] = useCreateNewsletterCustomListMutation({
 *   variables: {
 *      name: // value for 'name'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useCreateNewsletterCustomListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewsletterCustomListMutation, CreateNewsletterCustomListMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNewsletterCustomListMutation, CreateNewsletterCustomListMutationVariables>(CreateNewsletterCustomListDocument, baseOptions);
      }
export type CreateNewsletterCustomListMutationHookResult = ReturnType<typeof useCreateNewsletterCustomListMutation>;
export type CreateNewsletterCustomListMutationResult = ApolloReactCommon.MutationResult<CreateNewsletterCustomListMutation>;
export type CreateNewsletterCustomListMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNewsletterCustomListMutation, CreateNewsletterCustomListMutationVariables>;
export const UpdateNewsletterCustomListDocument = gql`
    mutation UpdateNewsletterCustomList($id: ID!, $name: String!, $locationIds: [ID!]!) {
  updateNewsletterCustomList(id: $id, name: $name, locationIds: $locationIds) {
    id
    enabled
    excluded
    mailjetListId
    mailjetListName
    lastSyncAt
    lastSyncOk
    lastSyncError
    lastSyncBlocked
    syncStartedAt
    lastSyncRecipients
    lastSyncInList
    lastSyncUnsubscribed
    lastSyncAdded
    lastSyncRemoved
    name
    locationIds
    location {
      id
      name
      city
    }
  }
}
    `;
export type UpdateNewsletterCustomListMutationFn = ApolloReactCommon.MutationFunction<UpdateNewsletterCustomListMutation, UpdateNewsletterCustomListMutationVariables>;

/**
 * __useUpdateNewsletterCustomListMutation__
 *
 * To run a mutation, you first call `useUpdateNewsletterCustomListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsletterCustomListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsletterCustomListMutation, { data, loading, error }] = useUpdateNewsletterCustomListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useUpdateNewsletterCustomListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNewsletterCustomListMutation, UpdateNewsletterCustomListMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNewsletterCustomListMutation, UpdateNewsletterCustomListMutationVariables>(UpdateNewsletterCustomListDocument, baseOptions);
      }
export type UpdateNewsletterCustomListMutationHookResult = ReturnType<typeof useUpdateNewsletterCustomListMutation>;
export type UpdateNewsletterCustomListMutationResult = ApolloReactCommon.MutationResult<UpdateNewsletterCustomListMutation>;
export type UpdateNewsletterCustomListMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNewsletterCustomListMutation, UpdateNewsletterCustomListMutationVariables>;
export const DeleteNewsletterCustomListDocument = gql`
    mutation DeleteNewsletterCustomList($id: ID!) {
  deleteNewsletterCustomList(id: $id)
}
    `;
export type DeleteNewsletterCustomListMutationFn = ApolloReactCommon.MutationFunction<DeleteNewsletterCustomListMutation, DeleteNewsletterCustomListMutationVariables>;

/**
 * __useDeleteNewsletterCustomListMutation__
 *
 * To run a mutation, you first call `useDeleteNewsletterCustomListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsletterCustomListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewsletterCustomListMutation, { data, loading, error }] = useDeleteNewsletterCustomListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNewsletterCustomListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNewsletterCustomListMutation, DeleteNewsletterCustomListMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteNewsletterCustomListMutation, DeleteNewsletterCustomListMutationVariables>(DeleteNewsletterCustomListDocument, baseOptions);
      }
export type DeleteNewsletterCustomListMutationHookResult = ReturnType<typeof useDeleteNewsletterCustomListMutation>;
export type DeleteNewsletterCustomListMutationResult = ApolloReactCommon.MutationResult<DeleteNewsletterCustomListMutation>;
export type DeleteNewsletterCustomListMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteNewsletterCustomListMutation, DeleteNewsletterCustomListMutationVariables>;
export const SetupNewsletterWebhookDocument = gql`
    mutation SetupNewsletterWebhook {
  setupNewsletterWebhook {
    id
    mailjetApiKeyPublic
    hasMailjetApiSecret
    mailjetApiKeyName
    listRule
    optOutBlocks
    bookingsSince
    assignment
    homeLocationMaxKm
    residenceRadiusKm
    errorEmail
    defaultErrorEmail
    lastConnectionCheckAt
    lastConnectionOk
    lastConnectionError
    webhookUrl
    webhookRegisteredAt
    rulesChangedAt
    rulesChangedByName
  }
}
    `;
export type SetupNewsletterWebhookMutationFn = ApolloReactCommon.MutationFunction<SetupNewsletterWebhookMutation, SetupNewsletterWebhookMutationVariables>;

/**
 * __useSetupNewsletterWebhookMutation__
 *
 * To run a mutation, you first call `useSetupNewsletterWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupNewsletterWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupNewsletterWebhookMutation, { data, loading, error }] = useSetupNewsletterWebhookMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupNewsletterWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetupNewsletterWebhookMutation, SetupNewsletterWebhookMutationVariables>) {
        return ApolloReactHooks.useMutation<SetupNewsletterWebhookMutation, SetupNewsletterWebhookMutationVariables>(SetupNewsletterWebhookDocument, baseOptions);
      }
export type SetupNewsletterWebhookMutationHookResult = ReturnType<typeof useSetupNewsletterWebhookMutation>;
export type SetupNewsletterWebhookMutationResult = ApolloReactCommon.MutationResult<SetupNewsletterWebhookMutation>;
export type SetupNewsletterWebhookMutationOptions = ApolloReactCommon.BaseMutationOptions<SetupNewsletterWebhookMutation, SetupNewsletterWebhookMutationVariables>;
export const GetNewsletterBookerStatusDocument = gql`
    query GetNewsletterBookerStatus($bookerId: ID!) {
  newsletterBookerStatus(bookerId: $bookerId) {
    bookerId
    email
    optIn
    unsubscribe {
      id
      source
      unsubscribedAt
      mailjetListId
    }
  }
}
    `;

/**
 * __useGetNewsletterBookerStatusQuery__
 *
 * To run a query within a React component, call `useGetNewsletterBookerStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterBookerStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterBookerStatusQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useGetNewsletterBookerStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsletterBookerStatusQuery, GetNewsletterBookerStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsletterBookerStatusQuery, GetNewsletterBookerStatusQueryVariables>(GetNewsletterBookerStatusDocument, baseOptions);
      }
export function useGetNewsletterBookerStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsletterBookerStatusQuery, GetNewsletterBookerStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsletterBookerStatusQuery, GetNewsletterBookerStatusQueryVariables>(GetNewsletterBookerStatusDocument, baseOptions);
        }
export type GetNewsletterBookerStatusQueryHookResult = ReturnType<typeof useGetNewsletterBookerStatusQuery>;
export type GetNewsletterBookerStatusLazyQueryHookResult = ReturnType<typeof useGetNewsletterBookerStatusLazyQuery>;
export type GetNewsletterBookerStatusQueryResult = ApolloReactCommon.QueryResult<GetNewsletterBookerStatusQuery, GetNewsletterBookerStatusQueryVariables>;
export const UnsubscribeBookerFromNewsletterDocument = gql`
    mutation UnsubscribeBookerFromNewsletter($bookerId: ID!) {
  unsubscribeBookerFromNewsletter(bookerId: $bookerId) {
    bookerId
    email
    optIn
    unsubscribe {
      id
      source
      unsubscribedAt
      mailjetListId
    }
  }
}
    `;
export type UnsubscribeBookerFromNewsletterMutationFn = ApolloReactCommon.MutationFunction<UnsubscribeBookerFromNewsletterMutation, UnsubscribeBookerFromNewsletterMutationVariables>;

/**
 * __useUnsubscribeBookerFromNewsletterMutation__
 *
 * To run a mutation, you first call `useUnsubscribeBookerFromNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeBookerFromNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeBookerFromNewsletterMutation, { data, loading, error }] = useUnsubscribeBookerFromNewsletterMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useUnsubscribeBookerFromNewsletterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsubscribeBookerFromNewsletterMutation, UnsubscribeBookerFromNewsletterMutationVariables>) {
        return ApolloReactHooks.useMutation<UnsubscribeBookerFromNewsletterMutation, UnsubscribeBookerFromNewsletterMutationVariables>(UnsubscribeBookerFromNewsletterDocument, baseOptions);
      }
export type UnsubscribeBookerFromNewsletterMutationHookResult = ReturnType<typeof useUnsubscribeBookerFromNewsletterMutation>;
export type UnsubscribeBookerFromNewsletterMutationResult = ApolloReactCommon.MutationResult<UnsubscribeBookerFromNewsletterMutation>;
export type UnsubscribeBookerFromNewsletterMutationOptions = ApolloReactCommon.BaseMutationOptions<UnsubscribeBookerFromNewsletterMutation, UnsubscribeBookerFromNewsletterMutationVariables>;
export const ReactivateBookerNewsletterDocument = gql`
    mutation ReactivateBookerNewsletter($bookerId: ID!) {
  reactivateBookerNewsletter(bookerId: $bookerId) {
    bookerId
    email
    optIn
    unsubscribe {
      id
      source
      unsubscribedAt
      mailjetListId
    }
  }
}
    `;
export type ReactivateBookerNewsletterMutationFn = ApolloReactCommon.MutationFunction<ReactivateBookerNewsletterMutation, ReactivateBookerNewsletterMutationVariables>;

/**
 * __useReactivateBookerNewsletterMutation__
 *
 * To run a mutation, you first call `useReactivateBookerNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateBookerNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateBookerNewsletterMutation, { data, loading, error }] = useReactivateBookerNewsletterMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useReactivateBookerNewsletterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactivateBookerNewsletterMutation, ReactivateBookerNewsletterMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactivateBookerNewsletterMutation, ReactivateBookerNewsletterMutationVariables>(ReactivateBookerNewsletterDocument, baseOptions);
      }
export type ReactivateBookerNewsletterMutationHookResult = ReturnType<typeof useReactivateBookerNewsletterMutation>;
export type ReactivateBookerNewsletterMutationResult = ApolloReactCommon.MutationResult<ReactivateBookerNewsletterMutation>;
export type ReactivateBookerNewsletterMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactivateBookerNewsletterMutation, ReactivateBookerNewsletterMutationVariables>;
export const ImportNewsletterUnsubscribesFromMailjetDocument = gql`
    mutation ImportNewsletterUnsubscribesFromMailjet {
  importNewsletterUnsubscribesFromMailjet {
    found
    stored
  }
}
    `;
export type ImportNewsletterUnsubscribesFromMailjetMutationFn = ApolloReactCommon.MutationFunction<ImportNewsletterUnsubscribesFromMailjetMutation, ImportNewsletterUnsubscribesFromMailjetMutationVariables>;

/**
 * __useImportNewsletterUnsubscribesFromMailjetMutation__
 *
 * To run a mutation, you first call `useImportNewsletterUnsubscribesFromMailjetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNewsletterUnsubscribesFromMailjetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNewsletterUnsubscribesFromMailjetMutation, { data, loading, error }] = useImportNewsletterUnsubscribesFromMailjetMutation({
 *   variables: {
 *   },
 * });
 */
export function useImportNewsletterUnsubscribesFromMailjetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportNewsletterUnsubscribesFromMailjetMutation, ImportNewsletterUnsubscribesFromMailjetMutationVariables>) {
        return ApolloReactHooks.useMutation<ImportNewsletterUnsubscribesFromMailjetMutation, ImportNewsletterUnsubscribesFromMailjetMutationVariables>(ImportNewsletterUnsubscribesFromMailjetDocument, baseOptions);
      }
export type ImportNewsletterUnsubscribesFromMailjetMutationHookResult = ReturnType<typeof useImportNewsletterUnsubscribesFromMailjetMutation>;
export type ImportNewsletterUnsubscribesFromMailjetMutationResult = ApolloReactCommon.MutationResult<ImportNewsletterUnsubscribesFromMailjetMutation>;
export type ImportNewsletterUnsubscribesFromMailjetMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportNewsletterUnsubscribesFromMailjetMutation, ImportNewsletterUnsubscribesFromMailjetMutationVariables>;
export const RenewNewsletterWebhookTokenDocument = gql`
    mutation RenewNewsletterWebhookToken {
  renewNewsletterWebhookToken {
    id
    mailjetApiKeyPublic
    hasMailjetApiSecret
    mailjetApiKeyName
    listRule
    optOutBlocks
    bookingsSince
    assignment
    homeLocationMaxKm
    residenceRadiusKm
    errorEmail
    defaultErrorEmail
    lastConnectionCheckAt
    lastConnectionOk
    lastConnectionError
    webhookUrl
    webhookRegisteredAt
    rulesChangedAt
    rulesChangedByName
  }
}
    `;
export type RenewNewsletterWebhookTokenMutationFn = ApolloReactCommon.MutationFunction<RenewNewsletterWebhookTokenMutation, RenewNewsletterWebhookTokenMutationVariables>;

/**
 * __useRenewNewsletterWebhookTokenMutation__
 *
 * To run a mutation, you first call `useRenewNewsletterWebhookTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewNewsletterWebhookTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewNewsletterWebhookTokenMutation, { data, loading, error }] = useRenewNewsletterWebhookTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRenewNewsletterWebhookTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenewNewsletterWebhookTokenMutation, RenewNewsletterWebhookTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<RenewNewsletterWebhookTokenMutation, RenewNewsletterWebhookTokenMutationVariables>(RenewNewsletterWebhookTokenDocument, baseOptions);
      }
export type RenewNewsletterWebhookTokenMutationHookResult = ReturnType<typeof useRenewNewsletterWebhookTokenMutation>;
export type RenewNewsletterWebhookTokenMutationResult = ApolloReactCommon.MutationResult<RenewNewsletterWebhookTokenMutation>;
export type RenewNewsletterWebhookTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<RenewNewsletterWebhookTokenMutation, RenewNewsletterWebhookTokenMutationVariables>;
export const GetNewsletterOverviewDocument = gql`
    query GetNewsletterOverview($limit: Int) {
  newsletterOverview {
    lastSyncAt
    listsOk
    listsFailed
    listsNever
    listsStuck
    listsEnabled
    listsExcluded
    listsTotal
    locationsEnabled
    locationsTotal
    addressesEnabled
    addressesAll
    blockedTotal
    blockedUnsub
    blockedSpam
    blockedBounce
    blockedOffice
    unsubscribedLast7Days
    connectionOk
    webhookRegistered
    unsubscribesImported
  }
  newsletterLog(limit: $limit) {
    id
    createDate
    kind
    listName
    count
    failed
    detail
    durationMs
    userName
    location {
      id
      name
    }
  }
}
    `;

/**
 * __useGetNewsletterOverviewQuery__
 *
 * To run a query within a React component, call `useGetNewsletterOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterOverviewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetNewsletterOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsletterOverviewQuery, GetNewsletterOverviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsletterOverviewQuery, GetNewsletterOverviewQueryVariables>(GetNewsletterOverviewDocument, baseOptions);
      }
export function useGetNewsletterOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsletterOverviewQuery, GetNewsletterOverviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsletterOverviewQuery, GetNewsletterOverviewQueryVariables>(GetNewsletterOverviewDocument, baseOptions);
        }
export type GetNewsletterOverviewQueryHookResult = ReturnType<typeof useGetNewsletterOverviewQuery>;
export type GetNewsletterOverviewLazyQueryHookResult = ReturnType<typeof useGetNewsletterOverviewLazyQuery>;
export type GetNewsletterOverviewQueryResult = ApolloReactCommon.QueryResult<GetNewsletterOverviewQuery, GetNewsletterOverviewQueryVariables>;
export const GetEmailNotificationsDocument = gql`
    query GetEmailNotifications($options: ArrayDataOptions) {
  emailNotifications(options: $options) {
    existsMore
    total
    items {
      id
      createDate
      status
      email
      receiverName
      subject
      templateType
      mailjetTemplateId
      messageHref
      text
      messageID
      templateName
      bookerId
      bookingId
      booking {
        id
        bookingNumber
        bookingNumberPrefix
        bookingType
        canceled
        invoice {
          id
        }
        reversalInvoice {
          id
        }
      }
      messageHistory {
        Count
        Data {
          EventAt
          EventType
          State
        }
      }
      messageStatus {
        ArrivedAt
        Status
      }
      attachments
      lastMessageStatus {
        Data {
          ArrivedAt
          Status
        }
      }
      bookingDeleted
    }
  }
}
    `;

/**
 * __useGetEmailNotificationsQuery__
 *
 * To run a query within a React component, call `useGetEmailNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailNotificationsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetEmailNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailNotificationsQuery, GetEmailNotificationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEmailNotificationsQuery, GetEmailNotificationsQueryVariables>(GetEmailNotificationsDocument, baseOptions);
      }
export function useGetEmailNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailNotificationsQuery, GetEmailNotificationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEmailNotificationsQuery, GetEmailNotificationsQueryVariables>(GetEmailNotificationsDocument, baseOptions);
        }
export type GetEmailNotificationsQueryHookResult = ReturnType<typeof useGetEmailNotificationsQuery>;
export type GetEmailNotificationsLazyQueryHookResult = ReturnType<typeof useGetEmailNotificationsLazyQuery>;
export type GetEmailNotificationsQueryResult = ApolloReactCommon.QueryResult<GetEmailNotificationsQuery, GetEmailNotificationsQueryVariables>;
export const GetEmailNotificationsByBookingIdDocument = gql`
    query GetEmailNotificationsByBookingId($bookingId: ID!) {
  notificationsByBooking(bookingId: $bookingId) {
    id
    createDate
    status
    email
    receiverName
    subject
    templateType
    mailjetTemplateId
    messageHref
    text
    messageID
    templateName
    messageHistory {
      Count
      Data {
        EventAt
        EventType
        State
      }
    }
    messageStatus {
      ArrivedAt
      Status
    }
    attachments
  }
}
    `;

/**
 * __useGetEmailNotificationsByBookingIdQuery__
 *
 * To run a query within a React component, call `useGetEmailNotificationsByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailNotificationsByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailNotificationsByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetEmailNotificationsByBookingIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailNotificationsByBookingIdQuery, GetEmailNotificationsByBookingIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEmailNotificationsByBookingIdQuery, GetEmailNotificationsByBookingIdQueryVariables>(GetEmailNotificationsByBookingIdDocument, baseOptions);
      }
export function useGetEmailNotificationsByBookingIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailNotificationsByBookingIdQuery, GetEmailNotificationsByBookingIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEmailNotificationsByBookingIdQuery, GetEmailNotificationsByBookingIdQueryVariables>(GetEmailNotificationsByBookingIdDocument, baseOptions);
        }
export type GetEmailNotificationsByBookingIdQueryHookResult = ReturnType<typeof useGetEmailNotificationsByBookingIdQuery>;
export type GetEmailNotificationsByBookingIdLazyQueryHookResult = ReturnType<typeof useGetEmailNotificationsByBookingIdLazyQuery>;
export type GetEmailNotificationsByBookingIdQueryResult = ApolloReactCommon.QueryResult<GetEmailNotificationsByBookingIdQuery, GetEmailNotificationsByBookingIdQueryVariables>;
export const GetEmailNotificationsByBookingIdOrEmailDocument = gql`
    query GetEmailNotificationsByBookingIdOrEmail($bookerId: ID!, $email: String, $options: ArrayDataOptions) {
  notificationsByBookerOrEmail(bookerId: $bookerId, email: $email, options: $options) {
    existsMore
    total
    items {
      id
      createDate
      status
      email
      receiverName
      subject
      templateType
      mailjetTemplateId
      messageHref
      text
      messageID
      templateName
      bookerId
      bookingId
      booking {
        id
        bookingNumber
        bookingNumberPrefix
        bookingType
        canceled
        invoice {
          id
        }
        reversalInvoice {
          id
        }
      }
      messageHistory {
        Count
        Data {
          EventAt
          EventType
          State
        }
      }
      messageStatus {
        ArrivedAt
        Status
      }
      attachments
    }
  }
}
    `;

/**
 * __useGetEmailNotificationsByBookingIdOrEmailQuery__
 *
 * To run a query within a React component, call `useGetEmailNotificationsByBookingIdOrEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailNotificationsByBookingIdOrEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailNotificationsByBookingIdOrEmailQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      email: // value for 'email'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetEmailNotificationsByBookingIdOrEmailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailNotificationsByBookingIdOrEmailQuery, GetEmailNotificationsByBookingIdOrEmailQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEmailNotificationsByBookingIdOrEmailQuery, GetEmailNotificationsByBookingIdOrEmailQueryVariables>(GetEmailNotificationsByBookingIdOrEmailDocument, baseOptions);
      }
export function useGetEmailNotificationsByBookingIdOrEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailNotificationsByBookingIdOrEmailQuery, GetEmailNotificationsByBookingIdOrEmailQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEmailNotificationsByBookingIdOrEmailQuery, GetEmailNotificationsByBookingIdOrEmailQueryVariables>(GetEmailNotificationsByBookingIdOrEmailDocument, baseOptions);
        }
export type GetEmailNotificationsByBookingIdOrEmailQueryHookResult = ReturnType<typeof useGetEmailNotificationsByBookingIdOrEmailQuery>;
export type GetEmailNotificationsByBookingIdOrEmailLazyQueryHookResult = ReturnType<typeof useGetEmailNotificationsByBookingIdOrEmailLazyQuery>;
export type GetEmailNotificationsByBookingIdOrEmailQueryResult = ApolloReactCommon.QueryResult<GetEmailNotificationsByBookingIdOrEmailQuery, GetEmailNotificationsByBookingIdOrEmailQueryVariables>;
export const GetSentEmailStatusFromMailjetDocument = gql`
    query GetSentEmailStatusFromMailjet($messageID: String!) {
  sentEmailStatusFromMailjet(messageID: $messageID)
}
    `;

/**
 * __useGetSentEmailStatusFromMailjetQuery__
 *
 * To run a query within a React component, call `useGetSentEmailStatusFromMailjetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentEmailStatusFromMailjetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentEmailStatusFromMailjetQuery({
 *   variables: {
 *      messageID: // value for 'messageID'
 *   },
 * });
 */
export function useGetSentEmailStatusFromMailjetQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSentEmailStatusFromMailjetQuery, GetSentEmailStatusFromMailjetQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSentEmailStatusFromMailjetQuery, GetSentEmailStatusFromMailjetQueryVariables>(GetSentEmailStatusFromMailjetDocument, baseOptions);
      }
export function useGetSentEmailStatusFromMailjetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSentEmailStatusFromMailjetQuery, GetSentEmailStatusFromMailjetQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSentEmailStatusFromMailjetQuery, GetSentEmailStatusFromMailjetQueryVariables>(GetSentEmailStatusFromMailjetDocument, baseOptions);
        }
export type GetSentEmailStatusFromMailjetQueryHookResult = ReturnType<typeof useGetSentEmailStatusFromMailjetQuery>;
export type GetSentEmailStatusFromMailjetLazyQueryHookResult = ReturnType<typeof useGetSentEmailStatusFromMailjetLazyQuery>;
export type GetSentEmailStatusFromMailjetQueryResult = ApolloReactCommon.QueryResult<GetSentEmailStatusFromMailjetQuery, GetSentEmailStatusFromMailjetQueryVariables>;
export const GetEmailNotificationByIdDocument = gql`
    query GetEmailNotificationById($id: String!) {
  emailNotificationById(id: $id) {
    id
    createDate
    status
    email
    receiverName
    subject
    html
    text
    templateType
    templateName
    mailjetTemplateId
    courseDetailsSnapshot
    renderVariablesSnapshot
    messageHref
    messageID
    bookerId
    bookingId
    booking {
      id
      bookingNumber
      bookingNumberPrefix
      bookingType
      canceled
      invoice {
        id
      }
      reversalInvoice {
        id
      }
    }
    attachments
    messageHistory {
      Count
      Data {
        Comment
        EventAt
        EventType
        State
        Useragent
      }
    }
    messageStatus {
      ArrivedAt
      Status
      AttemptCount
    }
  }
}
    `;

/**
 * __useGetEmailNotificationByIdQuery__
 *
 * To run a query within a React component, call `useGetEmailNotificationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailNotificationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailNotificationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailNotificationByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailNotificationByIdQuery, GetEmailNotificationByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEmailNotificationByIdQuery, GetEmailNotificationByIdQueryVariables>(GetEmailNotificationByIdDocument, baseOptions);
      }
export function useGetEmailNotificationByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailNotificationByIdQuery, GetEmailNotificationByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEmailNotificationByIdQuery, GetEmailNotificationByIdQueryVariables>(GetEmailNotificationByIdDocument, baseOptions);
        }
export type GetEmailNotificationByIdQueryHookResult = ReturnType<typeof useGetEmailNotificationByIdQuery>;
export type GetEmailNotificationByIdLazyQueryHookResult = ReturnType<typeof useGetEmailNotificationByIdLazyQuery>;
export type GetEmailNotificationByIdQueryResult = ApolloReactCommon.QueryResult<GetEmailNotificationByIdQuery, GetEmailNotificationByIdQueryVariables>;
export const GetBookerIdMissmatchDocument = gql`
    query GetBookerIdMissmatch($options: ArrayDataOptions) {
  getBookerIdMissmatchesWithPagination(options: $options) {
    total
    existsMore
    items {
      id
      email
      receiverName
      createDate
      subject
      templateName
      bookerId
      bookingId
      currentBooker {
        firstname
        lastname
        email
        id
      }
      foundByMailBooker {
        firstname
        lastname
        email
        id
      }
    }
  }
}
    `;

/**
 * __useGetBookerIdMissmatchQuery__
 *
 * To run a query within a React component, call `useGetBookerIdMissmatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookerIdMissmatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookerIdMissmatchQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetBookerIdMissmatchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookerIdMissmatchQuery, GetBookerIdMissmatchQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookerIdMissmatchQuery, GetBookerIdMissmatchQueryVariables>(GetBookerIdMissmatchDocument, baseOptions);
      }
export function useGetBookerIdMissmatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookerIdMissmatchQuery, GetBookerIdMissmatchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookerIdMissmatchQuery, GetBookerIdMissmatchQueryVariables>(GetBookerIdMissmatchDocument, baseOptions);
        }
export type GetBookerIdMissmatchQueryHookResult = ReturnType<typeof useGetBookerIdMissmatchQuery>;
export type GetBookerIdMissmatchLazyQueryHookResult = ReturnType<typeof useGetBookerIdMissmatchLazyQuery>;
export type GetBookerIdMissmatchQueryResult = ApolloReactCommon.QueryResult<GetBookerIdMissmatchQuery, GetBookerIdMissmatchQueryVariables>;
export const UpdateBookerIdMissmatchDocument = gql`
    mutation UpdateBookerIdMissmatch($notificationId: ID!, $oldBookerId: ID, $newBookerId: ID!) {
  updateBookerIdMissmatch(notificationId: $notificationId, oldBookerId: $oldBookerId, newBookerId: $newBookerId) {
    id
    email
    receiverName
    createDate
    subject
    templateName
    bookerId
    bookingId
  }
}
    `;
export type UpdateBookerIdMissmatchMutationFn = ApolloReactCommon.MutationFunction<UpdateBookerIdMissmatchMutation, UpdateBookerIdMissmatchMutationVariables>;

/**
 * __useUpdateBookerIdMissmatchMutation__
 *
 * To run a mutation, you first call `useUpdateBookerIdMissmatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookerIdMissmatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookerIdMissmatchMutation, { data, loading, error }] = useUpdateBookerIdMissmatchMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      oldBookerId: // value for 'oldBookerId'
 *      newBookerId: // value for 'newBookerId'
 *   },
 * });
 */
export function useUpdateBookerIdMissmatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookerIdMissmatchMutation, UpdateBookerIdMissmatchMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookerIdMissmatchMutation, UpdateBookerIdMissmatchMutationVariables>(UpdateBookerIdMissmatchDocument, baseOptions);
      }
export type UpdateBookerIdMissmatchMutationHookResult = ReturnType<typeof useUpdateBookerIdMissmatchMutation>;
export type UpdateBookerIdMissmatchMutationResult = ApolloReactCommon.MutationResult<UpdateBookerIdMissmatchMutation>;
export type UpdateBookerIdMissmatchMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookerIdMissmatchMutation, UpdateBookerIdMissmatchMutationVariables>;
export const UpdateMultipleBookerIdMissmatchesDocument = gql`
    mutation UpdateMultipleBookerIdMissmatches($updateMultipleBookerIdMissmatchesInput: [UpdateBookerIdMissmatchesInput!]!) {
  updateMultipleBookerIdMissmatches(updateMultipleBookerIdMissmatchesInput: $updateMultipleBookerIdMissmatchesInput) {
    id
    email
    receiverName
    createDate
    subject
    templateName
    bookerId
    bookingId
  }
}
    `;
export type UpdateMultipleBookerIdMissmatchesMutationFn = ApolloReactCommon.MutationFunction<UpdateMultipleBookerIdMissmatchesMutation, UpdateMultipleBookerIdMissmatchesMutationVariables>;

/**
 * __useUpdateMultipleBookerIdMissmatchesMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleBookerIdMissmatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleBookerIdMissmatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleBookerIdMissmatchesMutation, { data, loading, error }] = useUpdateMultipleBookerIdMissmatchesMutation({
 *   variables: {
 *      updateMultipleBookerIdMissmatchesInput: // value for 'updateMultipleBookerIdMissmatchesInput'
 *   },
 * });
 */
export function useUpdateMultipleBookerIdMissmatchesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMultipleBookerIdMissmatchesMutation, UpdateMultipleBookerIdMissmatchesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMultipleBookerIdMissmatchesMutation, UpdateMultipleBookerIdMissmatchesMutationVariables>(UpdateMultipleBookerIdMissmatchesDocument, baseOptions);
      }
export type UpdateMultipleBookerIdMissmatchesMutationHookResult = ReturnType<typeof useUpdateMultipleBookerIdMissmatchesMutation>;
export type UpdateMultipleBookerIdMissmatchesMutationResult = ApolloReactCommon.MutationResult<UpdateMultipleBookerIdMissmatchesMutation>;
export type UpdateMultipleBookerIdMissmatchesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMultipleBookerIdMissmatchesMutation, UpdateMultipleBookerIdMissmatchesMutationVariables>;
export const CreateParticipationPrerequisiteDocument = gql`
    mutation createParticipationPrerequisite($newParticipationPrerequisitesInput: NewParticipationPrerequisitesInput!) {
  createParticipationPrerequisite(newParticipationPrerequisitesInput: $newParticipationPrerequisitesInput) {
    id
    enabled
    groupDescription
    groupLabel
    minCheckCount
    optionalInputFields
    courseTypeId
  }
}
    `;
export type CreateParticipationPrerequisiteMutationFn = ApolloReactCommon.MutationFunction<CreateParticipationPrerequisiteMutation, CreateParticipationPrerequisiteMutationVariables>;

/**
 * __useCreateParticipationPrerequisiteMutation__
 *
 * To run a mutation, you first call `useCreateParticipationPrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParticipationPrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParticipationPrerequisiteMutation, { data, loading, error }] = useCreateParticipationPrerequisiteMutation({
 *   variables: {
 *      newParticipationPrerequisitesInput: // value for 'newParticipationPrerequisitesInput'
 *   },
 * });
 */
export function useCreateParticipationPrerequisiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateParticipationPrerequisiteMutation, CreateParticipationPrerequisiteMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateParticipationPrerequisiteMutation, CreateParticipationPrerequisiteMutationVariables>(CreateParticipationPrerequisiteDocument, baseOptions);
      }
export type CreateParticipationPrerequisiteMutationHookResult = ReturnType<typeof useCreateParticipationPrerequisiteMutation>;
export type CreateParticipationPrerequisiteMutationResult = ApolloReactCommon.MutationResult<CreateParticipationPrerequisiteMutation>;
export type CreateParticipationPrerequisiteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateParticipationPrerequisiteMutation, CreateParticipationPrerequisiteMutationVariables>;
export const UpdateParticipationPrerequisiteDocument = gql`
    mutation updateParticipationPrerequisite($updateParticipationPrerequisitesInput: UpdateParticipationPrerequisitesInput!) {
  updateParticipationPrerequisite(updateParticipationPrerequisitesInput: $updateParticipationPrerequisitesInput) {
    id
    enabled
    groupDescription
    groupLabel
    minCheckCount
    optionalInputFields
    courseTypeId
  }
}
    `;
export type UpdateParticipationPrerequisiteMutationFn = ApolloReactCommon.MutationFunction<UpdateParticipationPrerequisiteMutation, UpdateParticipationPrerequisiteMutationVariables>;

/**
 * __useUpdateParticipationPrerequisiteMutation__
 *
 * To run a mutation, you first call `useUpdateParticipationPrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipationPrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipationPrerequisiteMutation, { data, loading, error }] = useUpdateParticipationPrerequisiteMutation({
 *   variables: {
 *      updateParticipationPrerequisitesInput: // value for 'updateParticipationPrerequisitesInput'
 *   },
 * });
 */
export function useUpdateParticipationPrerequisiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateParticipationPrerequisiteMutation, UpdateParticipationPrerequisiteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateParticipationPrerequisiteMutation, UpdateParticipationPrerequisiteMutationVariables>(UpdateParticipationPrerequisiteDocument, baseOptions);
      }
export type UpdateParticipationPrerequisiteMutationHookResult = ReturnType<typeof useUpdateParticipationPrerequisiteMutation>;
export type UpdateParticipationPrerequisiteMutationResult = ApolloReactCommon.MutationResult<UpdateParticipationPrerequisiteMutation>;
export type UpdateParticipationPrerequisiteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateParticipationPrerequisiteMutation, UpdateParticipationPrerequisiteMutationVariables>;
export const RemoveParticipationPrerequisiteDocument = gql`
    mutation removeParticipationPrerequisite($id: ID!) {
  removeParticipationPrerequisite(id: $id)
}
    `;
export type RemoveParticipationPrerequisiteMutationFn = ApolloReactCommon.MutationFunction<RemoveParticipationPrerequisiteMutation, RemoveParticipationPrerequisiteMutationVariables>;

/**
 * __useRemoveParticipationPrerequisiteMutation__
 *
 * To run a mutation, you first call `useRemoveParticipationPrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveParticipationPrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeParticipationPrerequisiteMutation, { data, loading, error }] = useRemoveParticipationPrerequisiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveParticipationPrerequisiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveParticipationPrerequisiteMutation, RemoveParticipationPrerequisiteMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveParticipationPrerequisiteMutation, RemoveParticipationPrerequisiteMutationVariables>(RemoveParticipationPrerequisiteDocument, baseOptions);
      }
export type RemoveParticipationPrerequisiteMutationHookResult = ReturnType<typeof useRemoveParticipationPrerequisiteMutation>;
export type RemoveParticipationPrerequisiteMutationResult = ApolloReactCommon.MutationResult<RemoveParticipationPrerequisiteMutation>;
export type RemoveParticipationPrerequisiteMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveParticipationPrerequisiteMutation, RemoveParticipationPrerequisiteMutationVariables>;
export const GetParticipationPrerequisitesByCourseTypeIdDocument = gql`
    query getParticipationPrerequisitesByCourseTypeId($courseTypeId: ID!) {
  participationPrerequisitesByCourseTypeId(courseTypeId: $courseTypeId) {
    id
    enabled
    groupDescription
    groupLabel
    minCheckCount
    optionalInputFields
    courseTypeId
  }
}
    `;

/**
 * __useGetParticipationPrerequisitesByCourseTypeIdQuery__
 *
 * To run a query within a React component, call `useGetParticipationPrerequisitesByCourseTypeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipationPrerequisitesByCourseTypeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipationPrerequisitesByCourseTypeIdQuery({
 *   variables: {
 *      courseTypeId: // value for 'courseTypeId'
 *   },
 * });
 */
export function useGetParticipationPrerequisitesByCourseTypeIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetParticipationPrerequisitesByCourseTypeIdQuery, GetParticipationPrerequisitesByCourseTypeIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetParticipationPrerequisitesByCourseTypeIdQuery, GetParticipationPrerequisitesByCourseTypeIdQueryVariables>(GetParticipationPrerequisitesByCourseTypeIdDocument, baseOptions);
      }
export function useGetParticipationPrerequisitesByCourseTypeIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetParticipationPrerequisitesByCourseTypeIdQuery, GetParticipationPrerequisitesByCourseTypeIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetParticipationPrerequisitesByCourseTypeIdQuery, GetParticipationPrerequisitesByCourseTypeIdQueryVariables>(GetParticipationPrerequisitesByCourseTypeIdDocument, baseOptions);
        }
export type GetParticipationPrerequisitesByCourseTypeIdQueryHookResult = ReturnType<typeof useGetParticipationPrerequisitesByCourseTypeIdQuery>;
export type GetParticipationPrerequisitesByCourseTypeIdLazyQueryHookResult = ReturnType<typeof useGetParticipationPrerequisitesByCourseTypeIdLazyQuery>;
export type GetParticipationPrerequisitesByCourseTypeIdQueryResult = ApolloReactCommon.QueryResult<GetParticipationPrerequisitesByCourseTypeIdQuery, GetParticipationPrerequisitesByCourseTypeIdQueryVariables>;
export const GetBankTransactionsDocument = gql`
    query GetBankTransactions($filter: BankTransactionsFilterInput) {
  bankTransactions(filter: $filter) {
    total
    items {
      id
      bankImportFileId
      acctSvcrRef
      bankTransactionCode
      bookingDate
      valueDate
      amount
      currency
      kind
      counterpartName
      counterpartIban
      remittanceText
      endToEndId
      mandateId
      returnReasonCode
      bankText
      isReversal
      status
      matchKind
      proposedScheduledPaymentIds
      proposedScheduledPayments {
        id
        paymentAmount
        paymentDue
        paymentDone
        openAmount
        invoice {
          id
          invoiceNumberPrefix
          invoiceNumber
        }
        booking {
          id
          bookingNumberPrefix
          bookingNumber
          noticeStaff
          attendee {
            id
            firstname
            lastname
          }
        }
      }
      likelyRecordedScheduledPayments {
        id
        paymentAmount
        paymentDue
        paymentDone
        openAmount
        invoice {
          id
          invoiceNumberPrefix
          invoiceNumber
        }
        booking {
          id
          bookingNumberPrefix
          bookingNumber
          noticeStaff
          attendee {
            id
            firstname
            lastname
          }
        }
      }
      matchedExportedSepaXmlId
      likelyRecordedScheduledPaymentIds
      matchNote
      comment
      decision
      decidedAt
      rejectReason
      rejectNote
      settledScheduledPaymentIds
    }
  }
}
    `;

/**
 * __useGetBankTransactionsQuery__
 *
 * To run a query within a React component, call `useGetBankTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBankTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankTransactionsQuery, GetBankTransactionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankTransactionsQuery, GetBankTransactionsQueryVariables>(GetBankTransactionsDocument, baseOptions);
      }
export function useGetBankTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankTransactionsQuery, GetBankTransactionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankTransactionsQuery, GetBankTransactionsQueryVariables>(GetBankTransactionsDocument, baseOptions);
        }
export type GetBankTransactionsQueryHookResult = ReturnType<typeof useGetBankTransactionsQuery>;
export type GetBankTransactionsLazyQueryHookResult = ReturnType<typeof useGetBankTransactionsLazyQuery>;
export type GetBankTransactionsQueryResult = ApolloReactCommon.QueryResult<GetBankTransactionsQuery, GetBankTransactionsQueryVariables>;
export const GetBankTransactionConfirmContextDocument = gql`
    query GetBankTransactionConfirmContext($id: ID!) {
  bankTransaction(id: $id) {
    id
    confirmWarning
    candidateRates {
      id
      paymentAmount
      paymentDue
      paymentDone
      openAmount
      paymentProvider
      invoice {
        id
        invoiceNumberPrefix
        invoiceNumber
      }
      booking {
        id
        bookingNumberPrefix
        bookingNumber
        attendee {
          id
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useGetBankTransactionConfirmContextQuery__
 *
 * To run a query within a React component, call `useGetBankTransactionConfirmContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankTransactionConfirmContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankTransactionConfirmContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankTransactionConfirmContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankTransactionConfirmContextQuery, GetBankTransactionConfirmContextQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankTransactionConfirmContextQuery, GetBankTransactionConfirmContextQueryVariables>(GetBankTransactionConfirmContextDocument, baseOptions);
      }
export function useGetBankTransactionConfirmContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankTransactionConfirmContextQuery, GetBankTransactionConfirmContextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankTransactionConfirmContextQuery, GetBankTransactionConfirmContextQueryVariables>(GetBankTransactionConfirmContextDocument, baseOptions);
        }
export type GetBankTransactionConfirmContextQueryHookResult = ReturnType<typeof useGetBankTransactionConfirmContextQuery>;
export type GetBankTransactionConfirmContextLazyQueryHookResult = ReturnType<typeof useGetBankTransactionConfirmContextLazyQuery>;
export type GetBankTransactionConfirmContextQueryResult = ApolloReactCommon.QueryResult<GetBankTransactionConfirmContextQuery, GetBankTransactionConfirmContextQueryVariables>;
export const GetBankTransactionCandidatesDocument = gql`
    query GetBankTransactionCandidates($id: ID!) {
  bankTransaction(id: $id) {
    id
    candidates {
      bookingId
      bookingLabel
      attendeeName
      bookerName
      courseNumber
      courseName
      noticeStaff
      level
      evidence
      amountMatches
      warning
      rates {
        id
        paymentAmount
        paymentDue
        paymentDone
        openAmount
        paymentProvider
        invoice {
          id
          invoiceNumberPrefix
          invoiceNumber
        }
        booking {
          id
          bookingNumberPrefix
          bookingNumber
          attendee {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBankTransactionCandidatesQuery__
 *
 * To run a query within a React component, call `useGetBankTransactionCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankTransactionCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankTransactionCandidatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankTransactionCandidatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankTransactionCandidatesQuery, GetBankTransactionCandidatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankTransactionCandidatesQuery, GetBankTransactionCandidatesQueryVariables>(GetBankTransactionCandidatesDocument, baseOptions);
      }
export function useGetBankTransactionCandidatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankTransactionCandidatesQuery, GetBankTransactionCandidatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankTransactionCandidatesQuery, GetBankTransactionCandidatesQueryVariables>(GetBankTransactionCandidatesDocument, baseOptions);
        }
export type GetBankTransactionCandidatesQueryHookResult = ReturnType<typeof useGetBankTransactionCandidatesQuery>;
export type GetBankTransactionCandidatesLazyQueryHookResult = ReturnType<typeof useGetBankTransactionCandidatesLazyQuery>;
export type GetBankTransactionCandidatesQueryResult = ApolloReactCommon.QueryResult<GetBankTransactionCandidatesQuery, GetBankTransactionCandidatesQueryVariables>;
export const SearchBankTransactionCandidatesDocument = gql`
    query SearchBankTransactionCandidates($id: ID!, $searchKey: String!) {
  searchBankTransactionCandidates(id: $id, searchKey: $searchKey) {
    bookingId
    bookingLabel
    attendeeName
    bookerName
    courseNumber
    courseName
    noticeStaff
    level
    evidence
    amountMatches
    warning
    hits {
      field
      term
      value
      exact
    }
    rates {
      id
      paymentAmount
      paymentDue
      paymentDone
      openAmount
      paymentProvider
      invoice {
        id
        invoiceNumberPrefix
        invoiceNumber
      }
      booking {
        id
        bookingNumberPrefix
        bookingNumber
        attendee {
          id
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useSearchBankTransactionCandidatesQuery__
 *
 * To run a query within a React component, call `useSearchBankTransactionCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBankTransactionCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBankTransactionCandidatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      searchKey: // value for 'searchKey'
 *   },
 * });
 */
export function useSearchBankTransactionCandidatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchBankTransactionCandidatesQuery, SearchBankTransactionCandidatesQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchBankTransactionCandidatesQuery, SearchBankTransactionCandidatesQueryVariables>(SearchBankTransactionCandidatesDocument, baseOptions);
      }
export function useSearchBankTransactionCandidatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchBankTransactionCandidatesQuery, SearchBankTransactionCandidatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchBankTransactionCandidatesQuery, SearchBankTransactionCandidatesQueryVariables>(SearchBankTransactionCandidatesDocument, baseOptions);
        }
export type SearchBankTransactionCandidatesQueryHookResult = ReturnType<typeof useSearchBankTransactionCandidatesQuery>;
export type SearchBankTransactionCandidatesLazyQueryHookResult = ReturnType<typeof useSearchBankTransactionCandidatesLazyQuery>;
export type SearchBankTransactionCandidatesQueryResult = ApolloReactCommon.QueryResult<SearchBankTransactionCandidatesQuery, SearchBankTransactionCandidatesQueryVariables>;
export const ConfirmBankTransactionDocument = gql`
    mutation ConfirmBankTransaction($id: ID!, $distributions: [BankTransactionDistributionInput!]!, $guardWarned: Boolean) {
  confirmBankTransaction(id: $id, distributions: $distributions, guardWarned: $guardWarned) {
    id
    status
    decision
  }
}
    `;
export type ConfirmBankTransactionMutationFn = ApolloReactCommon.MutationFunction<ConfirmBankTransactionMutation, ConfirmBankTransactionMutationVariables>;

/**
 * __useConfirmBankTransactionMutation__
 *
 * To run a mutation, you first call `useConfirmBankTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBankTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBankTransactionMutation, { data, loading, error }] = useConfirmBankTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      distributions: // value for 'distributions'
 *      guardWarned: // value for 'guardWarned'
 *   },
 * });
 */
export function useConfirmBankTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmBankTransactionMutation, ConfirmBankTransactionMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmBankTransactionMutation, ConfirmBankTransactionMutationVariables>(ConfirmBankTransactionDocument, baseOptions);
      }
export type ConfirmBankTransactionMutationHookResult = ReturnType<typeof useConfirmBankTransactionMutation>;
export type ConfirmBankTransactionMutationResult = ApolloReactCommon.MutationResult<ConfirmBankTransactionMutation>;
export type ConfirmBankTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmBankTransactionMutation, ConfirmBankTransactionMutationVariables>;
export const RejectBankTransactionDocument = gql`
    mutation RejectBankTransaction($id: ID!, $reason: BankTransactionRejectReason!, $note: String, $recordedScheduledPaymentId: ID) {
  rejectBankTransaction(id: $id, reason: $reason, note: $note, recordedScheduledPaymentId: $recordedScheduledPaymentId) {
    id
    status
    rejectReason
  }
}
    `;
export type RejectBankTransactionMutationFn = ApolloReactCommon.MutationFunction<RejectBankTransactionMutation, RejectBankTransactionMutationVariables>;

/**
 * __useRejectBankTransactionMutation__
 *
 * To run a mutation, you first call `useRejectBankTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectBankTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectBankTransactionMutation, { data, loading, error }] = useRejectBankTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      note: // value for 'note'
 *      recordedScheduledPaymentId: // value for 'recordedScheduledPaymentId'
 *   },
 * });
 */
export function useRejectBankTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectBankTransactionMutation, RejectBankTransactionMutationVariables>) {
        return ApolloReactHooks.useMutation<RejectBankTransactionMutation, RejectBankTransactionMutationVariables>(RejectBankTransactionDocument, baseOptions);
      }
export type RejectBankTransactionMutationHookResult = ReturnType<typeof useRejectBankTransactionMutation>;
export type RejectBankTransactionMutationResult = ApolloReactCommon.MutationResult<RejectBankTransactionMutation>;
export type RejectBankTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<RejectBankTransactionMutation, RejectBankTransactionMutationVariables>;
export const GetBankImportFilesDocument = gql`
    query GetBankImportFiles {
  bankImportFiles {
    id
    createDate
    filename
    format
    accountIban
    periodFrom
    periodTo
    openingBalance
    closingBalance
    balanceGap
    balanceGapFrom
    balanceGapTo
    entryCount
    newCount
    knownCount
  }
}
    `;

/**
 * __useGetBankImportFilesQuery__
 *
 * To run a query within a React component, call `useGetBankImportFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankImportFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankImportFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankImportFilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankImportFilesQuery, GetBankImportFilesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankImportFilesQuery, GetBankImportFilesQueryVariables>(GetBankImportFilesDocument, baseOptions);
      }
export function useGetBankImportFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankImportFilesQuery, GetBankImportFilesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankImportFilesQuery, GetBankImportFilesQueryVariables>(GetBankImportFilesDocument, baseOptions);
        }
export type GetBankImportFilesQueryHookResult = ReturnType<typeof useGetBankImportFilesQuery>;
export type GetBankImportFilesLazyQueryHookResult = ReturnType<typeof useGetBankImportFilesLazyQuery>;
export type GetBankImportFilesQueryResult = ApolloReactCommon.QueryResult<GetBankImportFilesQuery, GetBankImportFilesQueryVariables>;
export const UpdateBankTransactionCommentDocument = gql`
    mutation UpdateBankTransactionComment($id: ID!, $comment: String) {
  updateBankTransactionComment(id: $id, comment: $comment) {
    id
    comment
  }
}
    `;
export type UpdateBankTransactionCommentMutationFn = ApolloReactCommon.MutationFunction<UpdateBankTransactionCommentMutation, UpdateBankTransactionCommentMutationVariables>;

/**
 * __useUpdateBankTransactionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateBankTransactionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankTransactionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankTransactionCommentMutation, { data, loading, error }] = useUpdateBankTransactionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateBankTransactionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBankTransactionCommentMutation, UpdateBankTransactionCommentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBankTransactionCommentMutation, UpdateBankTransactionCommentMutationVariables>(UpdateBankTransactionCommentDocument, baseOptions);
      }
export type UpdateBankTransactionCommentMutationHookResult = ReturnType<typeof useUpdateBankTransactionCommentMutation>;
export type UpdateBankTransactionCommentMutationResult = ApolloReactCommon.MutationResult<UpdateBankTransactionCommentMutation>;
export type UpdateBankTransactionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBankTransactionCommentMutation, UpdateBankTransactionCommentMutationVariables>;
export const RematchBankImportFileDocument = gql`
    mutation RematchBankImportFile($id: ID!) {
  rematchBankImportFile(id: $id) {
    id
  }
}
    `;
export type RematchBankImportFileMutationFn = ApolloReactCommon.MutationFunction<RematchBankImportFileMutation, RematchBankImportFileMutationVariables>;

/**
 * __useRematchBankImportFileMutation__
 *
 * To run a mutation, you first call `useRematchBankImportFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRematchBankImportFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rematchBankImportFileMutation, { data, loading, error }] = useRematchBankImportFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRematchBankImportFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RematchBankImportFileMutation, RematchBankImportFileMutationVariables>) {
        return ApolloReactHooks.useMutation<RematchBankImportFileMutation, RematchBankImportFileMutationVariables>(RematchBankImportFileDocument, baseOptions);
      }
export type RematchBankImportFileMutationHookResult = ReturnType<typeof useRematchBankImportFileMutation>;
export type RematchBankImportFileMutationResult = ApolloReactCommon.MutationResult<RematchBankImportFileMutation>;
export type RematchBankImportFileMutationOptions = ApolloReactCommon.BaseMutationOptions<RematchBankImportFileMutation, RematchBankImportFileMutationVariables>;
export const RematchAllBankImportFilesDocument = gql`
    mutation RematchAllBankImportFiles($after: String) {
  rematchAllBankImportFiles(after: $after) {
    rematched
    failed
    cursor
    total
  }
}
    `;
export type RematchAllBankImportFilesMutationFn = ApolloReactCommon.MutationFunction<RematchAllBankImportFilesMutation, RematchAllBankImportFilesMutationVariables>;

/**
 * __useRematchAllBankImportFilesMutation__
 *
 * To run a mutation, you first call `useRematchAllBankImportFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRematchAllBankImportFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rematchAllBankImportFilesMutation, { data, loading, error }] = useRematchAllBankImportFilesMutation({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRematchAllBankImportFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RematchAllBankImportFilesMutation, RematchAllBankImportFilesMutationVariables>) {
        return ApolloReactHooks.useMutation<RematchAllBankImportFilesMutation, RematchAllBankImportFilesMutationVariables>(RematchAllBankImportFilesDocument, baseOptions);
      }
export type RematchAllBankImportFilesMutationHookResult = ReturnType<typeof useRematchAllBankImportFilesMutation>;
export type RematchAllBankImportFilesMutationResult = ApolloReactCommon.MutationResult<RematchAllBankImportFilesMutation>;
export type RematchAllBankImportFilesMutationOptions = ApolloReactCommon.BaseMutationOptions<RematchAllBankImportFilesMutation, RematchAllBankImportFilesMutationVariables>;
export const GetBankImportSepaExportDocument = gql`
    query GetBankImportSepaExport($id: String!) {
  exportedSepaXml(id: $id) {
    id
    fileName
    createDate
    object
  }
}
    `;

/**
 * __useGetBankImportSepaExportQuery__
 *
 * To run a query within a React component, call `useGetBankImportSepaExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankImportSepaExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankImportSepaExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankImportSepaExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankImportSepaExportQuery, GetBankImportSepaExportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankImportSepaExportQuery, GetBankImportSepaExportQueryVariables>(GetBankImportSepaExportDocument, baseOptions);
      }
export function useGetBankImportSepaExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankImportSepaExportQuery, GetBankImportSepaExportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankImportSepaExportQuery, GetBankImportSepaExportQueryVariables>(GetBankImportSepaExportDocument, baseOptions);
        }
export type GetBankImportSepaExportQueryHookResult = ReturnType<typeof useGetBankImportSepaExportQuery>;
export type GetBankImportSepaExportLazyQueryHookResult = ReturnType<typeof useGetBankImportSepaExportLazyQuery>;
export type GetBankImportSepaExportQueryResult = ApolloReactCommon.QueryResult<GetBankImportSepaExportQuery, GetBankImportSepaExportQueryVariables>;
export const GetBankTransactionsForScheduledPaymentDocument = gql`
    query GetBankTransactionsForScheduledPayment($scheduledPaymentId: ID!) {
  bankTransactionsForScheduledPayment(scheduledPaymentId: $scheduledPaymentId) {
    id
    bookingDate
    valueDate
    amount
    currency
    counterpartName
    proposedScheduledPayments {
      id
      paymentAmount
      openAmount
    }
  }
}
    `;

/**
 * __useGetBankTransactionsForScheduledPaymentQuery__
 *
 * To run a query within a React component, call `useGetBankTransactionsForScheduledPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankTransactionsForScheduledPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankTransactionsForScheduledPaymentQuery({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *   },
 * });
 */
export function useGetBankTransactionsForScheduledPaymentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankTransactionsForScheduledPaymentQuery, GetBankTransactionsForScheduledPaymentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankTransactionsForScheduledPaymentQuery, GetBankTransactionsForScheduledPaymentQueryVariables>(GetBankTransactionsForScheduledPaymentDocument, baseOptions);
      }
export function useGetBankTransactionsForScheduledPaymentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankTransactionsForScheduledPaymentQuery, GetBankTransactionsForScheduledPaymentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankTransactionsForScheduledPaymentQuery, GetBankTransactionsForScheduledPaymentQueryVariables>(GetBankTransactionsForScheduledPaymentDocument, baseOptions);
        }
export type GetBankTransactionsForScheduledPaymentQueryHookResult = ReturnType<typeof useGetBankTransactionsForScheduledPaymentQuery>;
export type GetBankTransactionsForScheduledPaymentLazyQueryHookResult = ReturnType<typeof useGetBankTransactionsForScheduledPaymentLazyQuery>;
export type GetBankTransactionsForScheduledPaymentQueryResult = ApolloReactCommon.QueryResult<GetBankTransactionsForScheduledPaymentQuery, GetBankTransactionsForScheduledPaymentQueryVariables>;
export const SetBankTransactionCounterpartDocument = gql`
    mutation SetBankTransactionCounterpart($id: ID!, $treatAs: BankCounterpartKind!) {
  setBankTransactionCounterpart(id: $id, treatAs: $treatAs) {
    id
    status
    matchNote
  }
}
    `;
export type SetBankTransactionCounterpartMutationFn = ApolloReactCommon.MutationFunction<SetBankTransactionCounterpartMutation, SetBankTransactionCounterpartMutationVariables>;

/**
 * __useSetBankTransactionCounterpartMutation__
 *
 * To run a mutation, you first call `useSetBankTransactionCounterpartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBankTransactionCounterpartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBankTransactionCounterpartMutation, { data, loading, error }] = useSetBankTransactionCounterpartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      treatAs: // value for 'treatAs'
 *   },
 * });
 */
export function useSetBankTransactionCounterpartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetBankTransactionCounterpartMutation, SetBankTransactionCounterpartMutationVariables>) {
        return ApolloReactHooks.useMutation<SetBankTransactionCounterpartMutation, SetBankTransactionCounterpartMutationVariables>(SetBankTransactionCounterpartDocument, baseOptions);
      }
export type SetBankTransactionCounterpartMutationHookResult = ReturnType<typeof useSetBankTransactionCounterpartMutation>;
export type SetBankTransactionCounterpartMutationResult = ApolloReactCommon.MutationResult<SetBankTransactionCounterpartMutation>;
export type SetBankTransactionCounterpartMutationOptions = ApolloReactCommon.BaseMutationOptions<SetBankTransactionCounterpartMutation, SetBankTransactionCounterpartMutationVariables>;
export const RecordLikelyBankTransactionsDocument = gql`
    mutation RecordLikelyBankTransactions($after: String) {
  recordLikelyBankTransactions(after: $after) {
    recorded
    skipped
    cursor
  }
}
    `;
export type RecordLikelyBankTransactionsMutationFn = ApolloReactCommon.MutationFunction<RecordLikelyBankTransactionsMutation, RecordLikelyBankTransactionsMutationVariables>;

/**
 * __useRecordLikelyBankTransactionsMutation__
 *
 * To run a mutation, you first call `useRecordLikelyBankTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordLikelyBankTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordLikelyBankTransactionsMutation, { data, loading, error }] = useRecordLikelyBankTransactionsMutation({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRecordLikelyBankTransactionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecordLikelyBankTransactionsMutation, RecordLikelyBankTransactionsMutationVariables>) {
        return ApolloReactHooks.useMutation<RecordLikelyBankTransactionsMutation, RecordLikelyBankTransactionsMutationVariables>(RecordLikelyBankTransactionsDocument, baseOptions);
      }
export type RecordLikelyBankTransactionsMutationHookResult = ReturnType<typeof useRecordLikelyBankTransactionsMutation>;
export type RecordLikelyBankTransactionsMutationResult = ApolloReactCommon.MutationResult<RecordLikelyBankTransactionsMutation>;
export type RecordLikelyBankTransactionsMutationOptions = ApolloReactCommon.BaseMutationOptions<RecordLikelyBankTransactionsMutation, RecordLikelyBankTransactionsMutationVariables>;
export const GetBankCollectionRunsDocument = gql`
    query GetBankCollectionRuns {
  bankCollectionRuns {
    exportedSepaXmlId
    fileName
    createDate
    collectionDate
    debitCount
    total
    linkedRates
    collectedRates
    returnedRates
    returnedAmount
    openReturns
    creditId
    creditBookingDate
    creditAmount
    creditStatus
    creditMissing
    returnDeadline
  }
}
    `;

/**
 * __useGetBankCollectionRunsQuery__
 *
 * To run a query within a React component, call `useGetBankCollectionRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankCollectionRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankCollectionRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankCollectionRunsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankCollectionRunsQuery, GetBankCollectionRunsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankCollectionRunsQuery, GetBankCollectionRunsQueryVariables>(GetBankCollectionRunsDocument, baseOptions);
      }
export function useGetBankCollectionRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankCollectionRunsQuery, GetBankCollectionRunsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankCollectionRunsQuery, GetBankCollectionRunsQueryVariables>(GetBankCollectionRunsDocument, baseOptions);
        }
export type GetBankCollectionRunsQueryHookResult = ReturnType<typeof useGetBankCollectionRunsQuery>;
export type GetBankCollectionRunsLazyQueryHookResult = ReturnType<typeof useGetBankCollectionRunsLazyQuery>;
export type GetBankCollectionRunsQueryResult = ApolloReactCommon.QueryResult<GetBankCollectionRunsQuery, GetBankCollectionRunsQueryVariables>;
export const GetChargebacksDocument = gql`
    query getChargebacks($filter: ChargebackFilterInput!, $limit: Int, $offset: Int) {
  getChargebacks(filter: $filter, limit: $limit, offset: $offset) {
    id
    scheduledPaymentId
    chargebackId
    chargebackReason
    chargebackFee
    chargebackedAt
    chargebackResolvedAt
    chargebackResolvedByUserId
    requiresManualRetry
    mollieMethod
    status
    isCurrentAttempt
    createDate
    scheduledPayment {
      id
      paymentAmount
      booking {
        id
        bookingNumber
        bookingNumberPrefix
        bookingType
        canceled
        invoice {
          id
        }
        courseLessons {
          id
          course {
            id
            allowLessonBooking
          }
        }
        attendee {
          id
          booker {
            id
            email
            firstname
            lastname
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetChargebacksQuery__
 *
 * To run a query within a React component, call `useGetChargebacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargebacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargebacksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetChargebacksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetChargebacksQuery, GetChargebacksQueryVariables>) {
        return ApolloReactHooks.useQuery<GetChargebacksQuery, GetChargebacksQueryVariables>(GetChargebacksDocument, baseOptions);
      }
export function useGetChargebacksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChargebacksQuery, GetChargebacksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetChargebacksQuery, GetChargebacksQueryVariables>(GetChargebacksDocument, baseOptions);
        }
export type GetChargebacksQueryHookResult = ReturnType<typeof useGetChargebacksQuery>;
export type GetChargebacksLazyQueryHookResult = ReturnType<typeof useGetChargebacksLazyQuery>;
export type GetChargebacksQueryResult = ApolloReactCommon.QueryResult<GetChargebacksQuery, GetChargebacksQueryVariables>;
export const GetChargebackSummaryDocument = gql`
    query getChargebackSummary {
  getChargebackSummary {
    totalChargebackFee30d
    totalChargebackCount30d
  }
}
    `;

/**
 * __useGetChargebackSummaryQuery__
 *
 * To run a query within a React component, call `useGetChargebackSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargebackSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargebackSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChargebackSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetChargebackSummaryQuery, GetChargebackSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetChargebackSummaryQuery, GetChargebackSummaryQueryVariables>(GetChargebackSummaryDocument, baseOptions);
      }
export function useGetChargebackSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChargebackSummaryQuery, GetChargebackSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetChargebackSummaryQuery, GetChargebackSummaryQueryVariables>(GetChargebackSummaryDocument, baseOptions);
        }
export type GetChargebackSummaryQueryHookResult = ReturnType<typeof useGetChargebackSummaryQuery>;
export type GetChargebackSummaryLazyQueryHookResult = ReturnType<typeof useGetChargebackSummaryLazyQuery>;
export type GetChargebackSummaryQueryResult = ApolloReactCommon.QueryResult<GetChargebackSummaryQuery, GetChargebackSummaryQueryVariables>;
export const ResolveChargebackDocument = gql`
    mutation resolveChargeback($attemptId: String!) {
  resolveChargeback(attemptId: $attemptId) {
    id
    chargebackResolvedAt
    chargebackResolvedByUserId
  }
}
    `;
export type ResolveChargebackMutationFn = ApolloReactCommon.MutationFunction<ResolveChargebackMutation, ResolveChargebackMutationVariables>;

/**
 * __useResolveChargebackMutation__
 *
 * To run a mutation, you first call `useResolveChargebackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveChargebackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveChargebackMutation, { data, loading, error }] = useResolveChargebackMutation({
 *   variables: {
 *      attemptId: // value for 'attemptId'
 *   },
 * });
 */
export function useResolveChargebackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveChargebackMutation, ResolveChargebackMutationVariables>) {
        return ApolloReactHooks.useMutation<ResolveChargebackMutation, ResolveChargebackMutationVariables>(ResolveChargebackDocument, baseOptions);
      }
export type ResolveChargebackMutationHookResult = ReturnType<typeof useResolveChargebackMutation>;
export type ResolveChargebackMutationResult = ApolloReactCommon.MutationResult<ResolveChargebackMutation>;
export type ResolveChargebackMutationOptions = ApolloReactCommon.BaseMutationOptions<ResolveChargebackMutation, ResolveChargebackMutationVariables>;
export const GetChargebackCountDocument = gql`
    query getChargebackCount($filter: ChargebackFilterInput!) {
  getChargebackCount(filter: $filter)
}
    `;

/**
 * __useGetChargebackCountQuery__
 *
 * To run a query within a React component, call `useGetChargebackCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargebackCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargebackCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetChargebackCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetChargebackCountQuery, GetChargebackCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetChargebackCountQuery, GetChargebackCountQueryVariables>(GetChargebackCountDocument, baseOptions);
      }
export function useGetChargebackCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChargebackCountQuery, GetChargebackCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetChargebackCountQuery, GetChargebackCountQueryVariables>(GetChargebackCountDocument, baseOptions);
        }
export type GetChargebackCountQueryHookResult = ReturnType<typeof useGetChargebackCountQuery>;
export type GetChargebackCountLazyQueryHookResult = ReturnType<typeof useGetChargebackCountLazyQuery>;
export type GetChargebackCountQueryResult = ApolloReactCommon.QueryResult<GetChargebackCountQuery, GetChargebackCountQueryVariables>;
export const RefundMolliePaymentFromAdminDocument = gql`
    mutation RefundMolliePaymentFromAdmin($scheduledPaymentId: ID!, $amount: Float!, $reason: String, $notifyBooker: Boolean) {
  refundMolliePaymentFromAdmin(scheduledPaymentId: $scheduledPaymentId, amount: $amount, reason: $reason, notifyBooker: $notifyBooker) {
    id
    scheduledPaymentId
    mollieRefundId
    amount
    reason
    status
    createDate
  }
}
    `;
export type RefundMolliePaymentFromAdminMutationFn = ApolloReactCommon.MutationFunction<RefundMolliePaymentFromAdminMutation, RefundMolliePaymentFromAdminMutationVariables>;

/**
 * __useRefundMolliePaymentFromAdminMutation__
 *
 * To run a mutation, you first call `useRefundMolliePaymentFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundMolliePaymentFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundMolliePaymentFromAdminMutation, { data, loading, error }] = useRefundMolliePaymentFromAdminMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *      amount: // value for 'amount'
 *      reason: // value for 'reason'
 *      notifyBooker: // value for 'notifyBooker'
 *   },
 * });
 */
export function useRefundMolliePaymentFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefundMolliePaymentFromAdminMutation, RefundMolliePaymentFromAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<RefundMolliePaymentFromAdminMutation, RefundMolliePaymentFromAdminMutationVariables>(RefundMolliePaymentFromAdminDocument, baseOptions);
      }
export type RefundMolliePaymentFromAdminMutationHookResult = ReturnType<typeof useRefundMolliePaymentFromAdminMutation>;
export type RefundMolliePaymentFromAdminMutationResult = ApolloReactCommon.MutationResult<RefundMolliePaymentFromAdminMutation>;
export type RefundMolliePaymentFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<RefundMolliePaymentFromAdminMutation, RefundMolliePaymentFromAdminMutationVariables>;
export const GetMollieRefundsDocument = gql`
    query GetMollieRefunds($options: ArrayDataOptions) {
  mollieRefunds(options: $options) {
    existsMore
    total
    items {
      id
      createDate
      mollieRefundId
      amount
      reason
      status
      canceledAtProvider
      mollieCreatedAt
      adminUserId
      bookingNumberSnapshot
      bookingIdSnapshot
      bookerNameSnapshot
      attendeeNameSnapshot
      courseNumberSnapshot
      paymentAmountSnapshot
      scheduledPayment {
        id
        paymentAmount
        refundedAmount
        paymentDone
        booking {
          id
          bookingNumber
          bookingNumberPrefix
          bookingType
          canceled
          invoice {
            id
          }
          attendee {
            id
            firstname
            lastname
            booker {
              id
              firstname
              lastname
              email
            }
          }
          courseLessons {
            id
            course {
              id
              prefixedCourseNumber
              allowLessonBooking
              courseType {
                id
                name
                color
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMollieRefundsQuery__
 *
 * To run a query within a React component, call `useGetMollieRefundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMollieRefundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMollieRefundsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetMollieRefundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMollieRefundsQuery, GetMollieRefundsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMollieRefundsQuery, GetMollieRefundsQueryVariables>(GetMollieRefundsDocument, baseOptions);
      }
export function useGetMollieRefundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMollieRefundsQuery, GetMollieRefundsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMollieRefundsQuery, GetMollieRefundsQueryVariables>(GetMollieRefundsDocument, baseOptions);
        }
export type GetMollieRefundsQueryHookResult = ReturnType<typeof useGetMollieRefundsQuery>;
export type GetMollieRefundsLazyQueryHookResult = ReturnType<typeof useGetMollieRefundsLazyQuery>;
export type GetMollieRefundsQueryResult = ApolloReactCommon.QueryResult<GetMollieRefundsQuery, GetMollieRefundsQueryVariables>;
export const ListYearEndExportsDocument = gql`
    query ListYearEndExports {
  listYearEndExports {
    id
    createdAt
    koOrganizationId
    totalSize
    status
    errorMessage
    createdBy
    recordCount
    progress
    year
  }
}
    `;

/**
 * __useListYearEndExportsQuery__
 *
 * To run a query within a React component, call `useListYearEndExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListYearEndExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListYearEndExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListYearEndExportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListYearEndExportsQuery, ListYearEndExportsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListYearEndExportsQuery, ListYearEndExportsQueryVariables>(ListYearEndExportsDocument, baseOptions);
      }
export function useListYearEndExportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListYearEndExportsQuery, ListYearEndExportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListYearEndExportsQuery, ListYearEndExportsQueryVariables>(ListYearEndExportsDocument, baseOptions);
        }
export type ListYearEndExportsQueryHookResult = ReturnType<typeof useListYearEndExportsQuery>;
export type ListYearEndExportsLazyQueryHookResult = ReturnType<typeof useListYearEndExportsLazyQuery>;
export type ListYearEndExportsQueryResult = ApolloReactCommon.QueryResult<ListYearEndExportsQuery, ListYearEndExportsQueryVariables>;
export const GetYearEndExportDownloadUrlDocument = gql`
    query GetYearEndExportDownloadUrl($exportId: ID!) {
  getYearEndExportDownloadUrl(exportId: $exportId)
}
    `;

/**
 * __useGetYearEndExportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetYearEndExportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYearEndExportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYearEndExportDownloadUrlQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetYearEndExportDownloadUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetYearEndExportDownloadUrlQuery, GetYearEndExportDownloadUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetYearEndExportDownloadUrlQuery, GetYearEndExportDownloadUrlQueryVariables>(GetYearEndExportDownloadUrlDocument, baseOptions);
      }
export function useGetYearEndExportDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetYearEndExportDownloadUrlQuery, GetYearEndExportDownloadUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetYearEndExportDownloadUrlQuery, GetYearEndExportDownloadUrlQueryVariables>(GetYearEndExportDownloadUrlDocument, baseOptions);
        }
export type GetYearEndExportDownloadUrlQueryHookResult = ReturnType<typeof useGetYearEndExportDownloadUrlQuery>;
export type GetYearEndExportDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetYearEndExportDownloadUrlLazyQuery>;
export type GetYearEndExportDownloadUrlQueryResult = ApolloReactCommon.QueryResult<GetYearEndExportDownloadUrlQuery, GetYearEndExportDownloadUrlQueryVariables>;
export const CreateYearEndExportDocument = gql`
    mutation CreateYearEndExport($year: Int!) {
  createYearEndExport(year: $year) {
    id
    createdAt
    koOrganizationId
    totalSize
    status
    errorMessage
    createdBy
    recordCount
    progress
    year
  }
}
    `;
export type CreateYearEndExportMutationFn = ApolloReactCommon.MutationFunction<CreateYearEndExportMutation, CreateYearEndExportMutationVariables>;

/**
 * __useCreateYearEndExportMutation__
 *
 * To run a mutation, you first call `useCreateYearEndExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateYearEndExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createYearEndExportMutation, { data, loading, error }] = useCreateYearEndExportMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useCreateYearEndExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateYearEndExportMutation, CreateYearEndExportMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateYearEndExportMutation, CreateYearEndExportMutationVariables>(CreateYearEndExportDocument, baseOptions);
      }
export type CreateYearEndExportMutationHookResult = ReturnType<typeof useCreateYearEndExportMutation>;
export type CreateYearEndExportMutationResult = ApolloReactCommon.MutationResult<CreateYearEndExportMutation>;
export type CreateYearEndExportMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateYearEndExportMutation, CreateYearEndExportMutationVariables>;
export const DeleteYearEndExportDocument = gql`
    mutation DeleteYearEndExport($exportId: ID!) {
  deleteYearEndExport(exportId: $exportId)
}
    `;
export type DeleteYearEndExportMutationFn = ApolloReactCommon.MutationFunction<DeleteYearEndExportMutation, DeleteYearEndExportMutationVariables>;

/**
 * __useDeleteYearEndExportMutation__
 *
 * To run a mutation, you first call `useDeleteYearEndExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteYearEndExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteYearEndExportMutation, { data, loading, error }] = useDeleteYearEndExportMutation({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useDeleteYearEndExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteYearEndExportMutation, DeleteYearEndExportMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteYearEndExportMutation, DeleteYearEndExportMutationVariables>(DeleteYearEndExportDocument, baseOptions);
      }
export type DeleteYearEndExportMutationHookResult = ReturnType<typeof useDeleteYearEndExportMutation>;
export type DeleteYearEndExportMutationResult = ApolloReactCommon.MutationResult<DeleteYearEndExportMutation>;
export type DeleteYearEndExportMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteYearEndExportMutation, DeleteYearEndExportMutationVariables>;
export const GetExportedSepaXmlsDocument = gql`
    query GetExportedSepaXmls($options: ArrayDataOptions) {
  exportedSepaXmls(options: $options) {
    existsMore
    total
    items {
      id
      object
      xml
      createDate
      createdByUserId
      updateDate
      updatedByUserId
      fileName
    }
  }
}
    `;

/**
 * __useGetExportedSepaXmlsQuery__
 *
 * To run a query within a React component, call `useGetExportedSepaXmlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportedSepaXmlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportedSepaXmlsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetExportedSepaXmlsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExportedSepaXmlsQuery, GetExportedSepaXmlsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExportedSepaXmlsQuery, GetExportedSepaXmlsQueryVariables>(GetExportedSepaXmlsDocument, baseOptions);
      }
export function useGetExportedSepaXmlsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExportedSepaXmlsQuery, GetExportedSepaXmlsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExportedSepaXmlsQuery, GetExportedSepaXmlsQueryVariables>(GetExportedSepaXmlsDocument, baseOptions);
        }
export type GetExportedSepaXmlsQueryHookResult = ReturnType<typeof useGetExportedSepaXmlsQuery>;
export type GetExportedSepaXmlsLazyQueryHookResult = ReturnType<typeof useGetExportedSepaXmlsLazyQuery>;
export type GetExportedSepaXmlsQueryResult = ApolloReactCommon.QueryResult<GetExportedSepaXmlsQuery, GetExportedSepaXmlsQueryVariables>;
export const GetExportedSepaXmlDocument = gql`
    query GetExportedSepaXml($id: String!) {
  exportedSepaXml(id: $id) {
    id
    object
    xml
    createDate
    createdByUserId
    updateDate
    updatedByUserId
    fileName
  }
}
    `;

/**
 * __useGetExportedSepaXmlQuery__
 *
 * To run a query within a React component, call `useGetExportedSepaXmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportedSepaXmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportedSepaXmlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExportedSepaXmlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExportedSepaXmlQuery, GetExportedSepaXmlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExportedSepaXmlQuery, GetExportedSepaXmlQueryVariables>(GetExportedSepaXmlDocument, baseOptions);
      }
export function useGetExportedSepaXmlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExportedSepaXmlQuery, GetExportedSepaXmlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExportedSepaXmlQuery, GetExportedSepaXmlQueryVariables>(GetExportedSepaXmlDocument, baseOptions);
        }
export type GetExportedSepaXmlQueryHookResult = ReturnType<typeof useGetExportedSepaXmlQuery>;
export type GetExportedSepaXmlLazyQueryHookResult = ReturnType<typeof useGetExportedSepaXmlLazyQuery>;
export type GetExportedSepaXmlQueryResult = ApolloReactCommon.QueryResult<GetExportedSepaXmlQuery, GetExportedSepaXmlQueryVariables>;
export const SendMolliePaymentLinkFromAdminDocument = gql`
    mutation SendMolliePaymentLinkFromAdmin($scheduledPaymentId: ID!, $locale: String) {
  sendMolliePaymentLinkFromAdmin(scheduledPaymentId: $scheduledPaymentId, locale: $locale) {
    molliePaymentId
    checkoutUrl
    status
    linkExpiresAt
    bookerEmail
    dispatchKind
  }
}
    `;
export type SendMolliePaymentLinkFromAdminMutationFn = ApolloReactCommon.MutationFunction<SendMolliePaymentLinkFromAdminMutation, SendMolliePaymentLinkFromAdminMutationVariables>;

/**
 * __useSendMolliePaymentLinkFromAdminMutation__
 *
 * To run a mutation, you first call `useSendMolliePaymentLinkFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMolliePaymentLinkFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMolliePaymentLinkFromAdminMutation, { data, loading, error }] = useSendMolliePaymentLinkFromAdminMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useSendMolliePaymentLinkFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMolliePaymentLinkFromAdminMutation, SendMolliePaymentLinkFromAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<SendMolliePaymentLinkFromAdminMutation, SendMolliePaymentLinkFromAdminMutationVariables>(SendMolliePaymentLinkFromAdminDocument, baseOptions);
      }
export type SendMolliePaymentLinkFromAdminMutationHookResult = ReturnType<typeof useSendMolliePaymentLinkFromAdminMutation>;
export type SendMolliePaymentLinkFromAdminMutationResult = ApolloReactCommon.MutationResult<SendMolliePaymentLinkFromAdminMutation>;
export type SendMolliePaymentLinkFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<SendMolliePaymentLinkFromAdminMutation, SendMolliePaymentLinkFromAdminMutationVariables>;
export const SendMolliePaymentLinkForBookingFromAdminDocument = gql`
    mutation SendMolliePaymentLinkForBookingFromAdmin($bookingId: ID!, $locale: String) {
  sendMolliePaymentLinkForBookingFromAdmin(bookingId: $bookingId, locale: $locale) {
    molliePaymentId
    checkoutUrl
    status
    linkExpiresAt
    bookerEmail
    dispatchKind
  }
}
    `;
export type SendMolliePaymentLinkForBookingFromAdminMutationFn = ApolloReactCommon.MutationFunction<SendMolliePaymentLinkForBookingFromAdminMutation, SendMolliePaymentLinkForBookingFromAdminMutationVariables>;

/**
 * __useSendMolliePaymentLinkForBookingFromAdminMutation__
 *
 * To run a mutation, you first call `useSendMolliePaymentLinkForBookingFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMolliePaymentLinkForBookingFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMolliePaymentLinkForBookingFromAdminMutation, { data, loading, error }] = useSendMolliePaymentLinkForBookingFromAdminMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useSendMolliePaymentLinkForBookingFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMolliePaymentLinkForBookingFromAdminMutation, SendMolliePaymentLinkForBookingFromAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<SendMolliePaymentLinkForBookingFromAdminMutation, SendMolliePaymentLinkForBookingFromAdminMutationVariables>(SendMolliePaymentLinkForBookingFromAdminDocument, baseOptions);
      }
export type SendMolliePaymentLinkForBookingFromAdminMutationHookResult = ReturnType<typeof useSendMolliePaymentLinkForBookingFromAdminMutation>;
export type SendMolliePaymentLinkForBookingFromAdminMutationResult = ApolloReactCommon.MutationResult<SendMolliePaymentLinkForBookingFromAdminMutation>;
export type SendMolliePaymentLinkForBookingFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<SendMolliePaymentLinkForBookingFromAdminMutation, SendMolliePaymentLinkForBookingFromAdminMutationVariables>;
export const DetectBundleConflictsFromAdminDocument = gql`
    query DetectBundleConflictsFromAdmin($bookingId: ID!) {
  detectBundleConflictsFromAdmin(bookingId: $bookingId)
}
    `;

/**
 * __useDetectBundleConflictsFromAdminQuery__
 *
 * To run a query within a React component, call `useDetectBundleConflictsFromAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectBundleConflictsFromAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectBundleConflictsFromAdminQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useDetectBundleConflictsFromAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DetectBundleConflictsFromAdminQuery, DetectBundleConflictsFromAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<DetectBundleConflictsFromAdminQuery, DetectBundleConflictsFromAdminQueryVariables>(DetectBundleConflictsFromAdminDocument, baseOptions);
      }
export function useDetectBundleConflictsFromAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DetectBundleConflictsFromAdminQuery, DetectBundleConflictsFromAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DetectBundleConflictsFromAdminQuery, DetectBundleConflictsFromAdminQueryVariables>(DetectBundleConflictsFromAdminDocument, baseOptions);
        }
export type DetectBundleConflictsFromAdminQueryHookResult = ReturnType<typeof useDetectBundleConflictsFromAdminQuery>;
export type DetectBundleConflictsFromAdminLazyQueryHookResult = ReturnType<typeof useDetectBundleConflictsFromAdminLazyQuery>;
export type DetectBundleConflictsFromAdminQueryResult = ApolloReactCommon.QueryResult<DetectBundleConflictsFromAdminQuery, DetectBundleConflictsFromAdminQueryVariables>;
export const CancelMolliePaymentFromAdminDocument = gql`
    mutation CancelMolliePaymentFromAdmin($scheduledPaymentId: ID!) {
  cancelMolliePaymentFromAdmin(scheduledPaymentId: $scheduledPaymentId) {
    molliePaymentId
    checkoutUrl
    status
  }
}
    `;
export type CancelMolliePaymentFromAdminMutationFn = ApolloReactCommon.MutationFunction<CancelMolliePaymentFromAdminMutation, CancelMolliePaymentFromAdminMutationVariables>;

/**
 * __useCancelMolliePaymentFromAdminMutation__
 *
 * To run a mutation, you first call `useCancelMolliePaymentFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMolliePaymentFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMolliePaymentFromAdminMutation, { data, loading, error }] = useCancelMolliePaymentFromAdminMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *   },
 * });
 */
export function useCancelMolliePaymentFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelMolliePaymentFromAdminMutation, CancelMolliePaymentFromAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelMolliePaymentFromAdminMutation, CancelMolliePaymentFromAdminMutationVariables>(CancelMolliePaymentFromAdminDocument, baseOptions);
      }
export type CancelMolliePaymentFromAdminMutationHookResult = ReturnType<typeof useCancelMolliePaymentFromAdminMutation>;
export type CancelMolliePaymentFromAdminMutationResult = ApolloReactCommon.MutationResult<CancelMolliePaymentFromAdminMutation>;
export type CancelMolliePaymentFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelMolliePaymentFromAdminMutation, CancelMolliePaymentFromAdminMutationVariables>;
export const RefreshMolliePaymentStatusFromAdminDocument = gql`
    mutation RefreshMolliePaymentStatusFromAdmin($scheduledPaymentId: ID!) {
  refreshMolliePaymentStatusFromAdmin(scheduledPaymentId: $scheduledPaymentId) {
    id
    status
    paidAt
    molliePaymentId
  }
}
    `;
export type RefreshMolliePaymentStatusFromAdminMutationFn = ApolloReactCommon.MutationFunction<RefreshMolliePaymentStatusFromAdminMutation, RefreshMolliePaymentStatusFromAdminMutationVariables>;

/**
 * __useRefreshMolliePaymentStatusFromAdminMutation__
 *
 * To run a mutation, you first call `useRefreshMolliePaymentStatusFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMolliePaymentStatusFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMolliePaymentStatusFromAdminMutation, { data, loading, error }] = useRefreshMolliePaymentStatusFromAdminMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *   },
 * });
 */
export function useRefreshMolliePaymentStatusFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshMolliePaymentStatusFromAdminMutation, RefreshMolliePaymentStatusFromAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<RefreshMolliePaymentStatusFromAdminMutation, RefreshMolliePaymentStatusFromAdminMutationVariables>(RefreshMolliePaymentStatusFromAdminDocument, baseOptions);
      }
export type RefreshMolliePaymentStatusFromAdminMutationHookResult = ReturnType<typeof useRefreshMolliePaymentStatusFromAdminMutation>;
export type RefreshMolliePaymentStatusFromAdminMutationResult = ApolloReactCommon.MutationResult<RefreshMolliePaymentStatusFromAdminMutation>;
export type RefreshMolliePaymentStatusFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<RefreshMolliePaymentStatusFromAdminMutation, RefreshMolliePaymentStatusFromAdminMutationVariables>;
export const CaptureMolliePaymentFromAdminDocument = gql`
    mutation CaptureMolliePaymentFromAdmin($scheduledPaymentId: ID!, $amount: Float) {
  captureMolliePaymentFromAdmin(scheduledPaymentId: $scheduledPaymentId, amount: $amount) {
    molliePaymentId
    checkoutUrl
    status
  }
}
    `;
export type CaptureMolliePaymentFromAdminMutationFn = ApolloReactCommon.MutationFunction<CaptureMolliePaymentFromAdminMutation, CaptureMolliePaymentFromAdminMutationVariables>;

/**
 * __useCaptureMolliePaymentFromAdminMutation__
 *
 * To run a mutation, you first call `useCaptureMolliePaymentFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureMolliePaymentFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureMolliePaymentFromAdminMutation, { data, loading, error }] = useCaptureMolliePaymentFromAdminMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCaptureMolliePaymentFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CaptureMolliePaymentFromAdminMutation, CaptureMolliePaymentFromAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<CaptureMolliePaymentFromAdminMutation, CaptureMolliePaymentFromAdminMutationVariables>(CaptureMolliePaymentFromAdminDocument, baseOptions);
      }
export type CaptureMolliePaymentFromAdminMutationHookResult = ReturnType<typeof useCaptureMolliePaymentFromAdminMutation>;
export type CaptureMolliePaymentFromAdminMutationResult = ApolloReactCommon.MutationResult<CaptureMolliePaymentFromAdminMutation>;
export type CaptureMolliePaymentFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<CaptureMolliePaymentFromAdminMutation, CaptureMolliePaymentFromAdminMutationVariables>;
export const CreateNewMolliePaymentAttemptFromAdminDocument = gql`
    mutation CreateNewMolliePaymentAttemptFromAdmin($scheduledPaymentId: ID!, $locale: String) {
  createNewMolliePaymentAttemptFromAdmin(scheduledPaymentId: $scheduledPaymentId, locale: $locale) {
    molliePaymentId
    checkoutUrl
    status
    linkExpiresAt
  }
}
    `;
export type CreateNewMolliePaymentAttemptFromAdminMutationFn = ApolloReactCommon.MutationFunction<CreateNewMolliePaymentAttemptFromAdminMutation, CreateNewMolliePaymentAttemptFromAdminMutationVariables>;

/**
 * __useCreateNewMolliePaymentAttemptFromAdminMutation__
 *
 * To run a mutation, you first call `useCreateNewMolliePaymentAttemptFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewMolliePaymentAttemptFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewMolliePaymentAttemptFromAdminMutation, { data, loading, error }] = useCreateNewMolliePaymentAttemptFromAdminMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateNewMolliePaymentAttemptFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewMolliePaymentAttemptFromAdminMutation, CreateNewMolliePaymentAttemptFromAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNewMolliePaymentAttemptFromAdminMutation, CreateNewMolliePaymentAttemptFromAdminMutationVariables>(CreateNewMolliePaymentAttemptFromAdminDocument, baseOptions);
      }
export type CreateNewMolliePaymentAttemptFromAdminMutationHookResult = ReturnType<typeof useCreateNewMolliePaymentAttemptFromAdminMutation>;
export type CreateNewMolliePaymentAttemptFromAdminMutationResult = ApolloReactCommon.MutationResult<CreateNewMolliePaymentAttemptFromAdminMutation>;
export type CreateNewMolliePaymentAttemptFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNewMolliePaymentAttemptFromAdminMutation, CreateNewMolliePaymentAttemptFromAdminMutationVariables>;
export const RecordExternalPaymentForScheduledPaymentDocument = gql`
    mutation RecordExternalPaymentForScheduledPayment($input: RecordExternalPaymentForScheduledPaymentInput!) {
  recordExternalPaymentForScheduledPayment(input: $input) {
    id
    bookingId
    paymentProvider
    paymentDone
    paymentTransferType
    paymentAmount
    openAmount
    molliePaymentUrl
    molliePaymentStatus
    methodChangedAt
    note
  }
}
    `;
export type RecordExternalPaymentForScheduledPaymentMutationFn = ApolloReactCommon.MutationFunction<RecordExternalPaymentForScheduledPaymentMutation, RecordExternalPaymentForScheduledPaymentMutationVariables>;

/**
 * __useRecordExternalPaymentForScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useRecordExternalPaymentForScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordExternalPaymentForScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordExternalPaymentForScheduledPaymentMutation, { data, loading, error }] = useRecordExternalPaymentForScheduledPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordExternalPaymentForScheduledPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecordExternalPaymentForScheduledPaymentMutation, RecordExternalPaymentForScheduledPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<RecordExternalPaymentForScheduledPaymentMutation, RecordExternalPaymentForScheduledPaymentMutationVariables>(RecordExternalPaymentForScheduledPaymentDocument, baseOptions);
      }
export type RecordExternalPaymentForScheduledPaymentMutationHookResult = ReturnType<typeof useRecordExternalPaymentForScheduledPaymentMutation>;
export type RecordExternalPaymentForScheduledPaymentMutationResult = ApolloReactCommon.MutationResult<RecordExternalPaymentForScheduledPaymentMutation>;
export type RecordExternalPaymentForScheduledPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<RecordExternalPaymentForScheduledPaymentMutation, RecordExternalPaymentForScheduledPaymentMutationVariables>;
export const GetBilledBookingsDocument = gql`
    query GetBilledBookings($courseType: Boolean!, $courseNumber: Boolean!, $booker: Boolean!, $attendee: Boolean!, $location: Boolean!, $firstCourse: Boolean!, $paymentType: Boolean!, $amount: Boolean!, $paymentDate: Boolean!, $invoice: Boolean!, $due: Boolean!, $discount: Boolean!) {
  getBilledBookings {
    id
    bookingNumber
    bookingNumberPrefix
    courseLessons {
      id
      startDateTime @include(if: $firstCourse)
      endDateTime @include(if: $firstCourse)
      course {
        id
        prefixedCourseNumber @include(if: $courseNumber)
        courseType @include(if: $courseType) {
          id
          name
          color
        }
      }
    }
    attendee {
      firstname @include(if: $attendee)
      lastname @include(if: $attendee)
      id
      booker {
        id
        firstname @include(if: $booker)
        lastname @include(if: $booker)
        city @include(if: $location)
      }
    }
    paymentType @include(if: $paymentType)
    coursePrice {
      id
      grossPrice @include(if: $amount)
      discount @include(if: $discount)
    }
    invoice {
      id
      billed @include(if: $paymentDate)
      paymentDue @include(if: $due)
      invoiceNumber @include(if: $invoice)
      invoiceNumberPrefix @include(if: $invoice)
    }
  }
}
    `;

/**
 * __useGetBilledBookingsQuery__
 *
 * To run a query within a React component, call `useGetBilledBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBilledBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBilledBookingsQuery({
 *   variables: {
 *      courseType: // value for 'courseType'
 *      courseNumber: // value for 'courseNumber'
 *      booker: // value for 'booker'
 *      attendee: // value for 'attendee'
 *      location: // value for 'location'
 *      firstCourse: // value for 'firstCourse'
 *      paymentType: // value for 'paymentType'
 *      amount: // value for 'amount'
 *      paymentDate: // value for 'paymentDate'
 *      invoice: // value for 'invoice'
 *      due: // value for 'due'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useGetBilledBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBilledBookingsQuery, GetBilledBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBilledBookingsQuery, GetBilledBookingsQueryVariables>(GetBilledBookingsDocument, baseOptions);
      }
export function useGetBilledBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBilledBookingsQuery, GetBilledBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBilledBookingsQuery, GetBilledBookingsQueryVariables>(GetBilledBookingsDocument, baseOptions);
        }
export type GetBilledBookingsQueryHookResult = ReturnType<typeof useGetBilledBookingsQuery>;
export type GetBilledBookingsLazyQueryHookResult = ReturnType<typeof useGetBilledBookingsLazyQuery>;
export type GetBilledBookingsQueryResult = ApolloReactCommon.QueryResult<GetBilledBookingsQuery, GetBilledBookingsQueryVariables>;
export const GetUnBilledBookingsDocument = gql`
    query GetUnBilledBookings($courseType: Boolean!, $courseNumber: Boolean!, $booker: Boolean!, $attendee: Boolean!, $location: Boolean!, $firstCourse: Boolean!, $paymentType: Boolean!, $amount: Boolean!, $paymentDate: Boolean!, $invoice: Boolean!, $due: Boolean!, $discount: Boolean!, $place: Boolean!, $invoiceDate: Boolean!) {
  getUnBilledBookings {
    id
    bookingNumber
    bookingNumberPrefix
    courseLessons {
      id
      startDateTime @include(if: $firstCourse)
      endDateTime @include(if: $firstCourse)
      location @include(if: $place) {
        id
        city
      }
      course {
        id
        prefixedCourseNumber @include(if: $courseNumber)
        courseType @include(if: $courseType) {
          id
          name
          color
        }
      }
    }
    attendee {
      firstname @include(if: $attendee)
      lastname @include(if: $attendee)
      id
      booker {
        id
        firstname @include(if: $booker)
        lastname @include(if: $booker)
        city @include(if: $location)
      }
    }
    paymentType @include(if: $paymentType)
    coursePrice {
      id
      grossPrice @include(if: $amount)
      discount @include(if: $discount)
    }
    payDate @include(if: $invoiceDate)
    paymentMethod {
      id
      type
    }
    invoice {
      id
      billed @include(if: $paymentDate)
      paymentDue @include(if: $due)
      invoiceNumber @include(if: $invoice)
      invoiceNumberPrefix @include(if: $invoice)
    }
  }
}
    `;

/**
 * __useGetUnBilledBookingsQuery__
 *
 * To run a query within a React component, call `useGetUnBilledBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnBilledBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnBilledBookingsQuery({
 *   variables: {
 *      courseType: // value for 'courseType'
 *      courseNumber: // value for 'courseNumber'
 *      booker: // value for 'booker'
 *      attendee: // value for 'attendee'
 *      location: // value for 'location'
 *      firstCourse: // value for 'firstCourse'
 *      paymentType: // value for 'paymentType'
 *      amount: // value for 'amount'
 *      paymentDate: // value for 'paymentDate'
 *      invoice: // value for 'invoice'
 *      due: // value for 'due'
 *      discount: // value for 'discount'
 *      place: // value for 'place'
 *      invoiceDate: // value for 'invoiceDate'
 *   },
 * });
 */
export function useGetUnBilledBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnBilledBookingsQuery, GetUnBilledBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUnBilledBookingsQuery, GetUnBilledBookingsQueryVariables>(GetUnBilledBookingsDocument, baseOptions);
      }
export function useGetUnBilledBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnBilledBookingsQuery, GetUnBilledBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUnBilledBookingsQuery, GetUnBilledBookingsQueryVariables>(GetUnBilledBookingsDocument, baseOptions);
        }
export type GetUnBilledBookingsQueryHookResult = ReturnType<typeof useGetUnBilledBookingsQuery>;
export type GetUnBilledBookingsLazyQueryHookResult = ReturnType<typeof useGetUnBilledBookingsLazyQuery>;
export type GetUnBilledBookingsQueryResult = ApolloReactCommon.QueryResult<GetUnBilledBookingsQuery, GetUnBilledBookingsQueryVariables>;
export const GetUnBilledBookingsMinimalDocument = gql`
    query GetUnBilledBookingsMinimal {
  getUnBilledBookings {
    id
    bookingNumber
    bookingNumberPrefix
  }
}
    `;

/**
 * __useGetUnBilledBookingsMinimalQuery__
 *
 * To run a query within a React component, call `useGetUnBilledBookingsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnBilledBookingsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnBilledBookingsMinimalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnBilledBookingsMinimalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnBilledBookingsMinimalQuery, GetUnBilledBookingsMinimalQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUnBilledBookingsMinimalQuery, GetUnBilledBookingsMinimalQueryVariables>(GetUnBilledBookingsMinimalDocument, baseOptions);
      }
export function useGetUnBilledBookingsMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnBilledBookingsMinimalQuery, GetUnBilledBookingsMinimalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUnBilledBookingsMinimalQuery, GetUnBilledBookingsMinimalQueryVariables>(GetUnBilledBookingsMinimalDocument, baseOptions);
        }
export type GetUnBilledBookingsMinimalQueryHookResult = ReturnType<typeof useGetUnBilledBookingsMinimalQuery>;
export type GetUnBilledBookingsMinimalLazyQueryHookResult = ReturnType<typeof useGetUnBilledBookingsMinimalLazyQuery>;
export type GetUnBilledBookingsMinimalQueryResult = ApolloReactCommon.QueryResult<GetUnBilledBookingsMinimalQuery, GetUnBilledBookingsMinimalQueryVariables>;
export const GetBilledBookingsMinimalDocument = gql`
    query GetBilledBookingsMinimal {
  getBilledBookings {
    id
    bookingNumber
    bookingNumberPrefix
  }
}
    `;

/**
 * __useGetBilledBookingsMinimalQuery__
 *
 * To run a query within a React component, call `useGetBilledBookingsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBilledBookingsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBilledBookingsMinimalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBilledBookingsMinimalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBilledBookingsMinimalQuery, GetBilledBookingsMinimalQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBilledBookingsMinimalQuery, GetBilledBookingsMinimalQueryVariables>(GetBilledBookingsMinimalDocument, baseOptions);
      }
export function useGetBilledBookingsMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBilledBookingsMinimalQuery, GetBilledBookingsMinimalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBilledBookingsMinimalQuery, GetBilledBookingsMinimalQueryVariables>(GetBilledBookingsMinimalDocument, baseOptions);
        }
export type GetBilledBookingsMinimalQueryHookResult = ReturnType<typeof useGetBilledBookingsMinimalQuery>;
export type GetBilledBookingsMinimalLazyQueryHookResult = ReturnType<typeof useGetBilledBookingsMinimalLazyQuery>;
export type GetBilledBookingsMinimalQueryResult = ApolloReactCommon.QueryResult<GetBilledBookingsMinimalQuery, GetBilledBookingsMinimalQueryVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($id: String!, $editInvoiceData: EditInvoiceInput!) {
  updateInvoice(editInvoiceData: $editInvoiceData, id: $id) {
    id
  }
}
    `;
export type UpdateInvoiceMutationFn = ApolloReactCommon.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      editInvoiceData: // value for 'editInvoiceData'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, baseOptions);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = ApolloReactCommon.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const GetScheduledPaymentsDocument = gql`
    query GetScheduledPayments($options: ArrayDataOptions) {
  scheduledPayments(options: $options) {
    existsMore
    total
    items {
      id
      paymentDue
      paymentAmount
      refundedAmount
      providerRefundedAmount
      molliePaidAmount
      surplusMolliePaymentCount
      openAmount
      createDate
      paymentDone
      note
      invoice {
        billed
        invoiceNumber
        invoiceNumberPrefix
        createDate
        updateDate
        id
      }
      booking {
        id
        courseId
        bookingNumberPrefix
        bookingNumber
        bookingType
        isSpecial
        vat
        netPrice
        grossPrice
        bookedBy
        paymentType
        invoice {
          id
        }
        paymentMethod {
          id
          cash
          esr
          creditCardAccountholder
          creditcardNumber
          expirationDate
          validFrom
          cvc
          paypalAccountholder
          email
          iban
          bank
          bic
          sepaAccountholder
          type
          bankTransfer
          onlinePayment
        }
        attendee {
          id
          erasedAt
          firstname
          lastname
          booker {
            id
            firstname
            lastname
            email
            nonDisclosureNotice
          }
        }
        courseLessons {
          id
          startDateTime
          endDateTime
          course {
            id
            startDateTime
            paymentInterval
            prefixedCourseNumber
            courseType {
              id
              name
              color
            }
          }
          location {
            id
            city
            name
          }
        }
        canceled
        bookingType
        noticeStaff
      }
      paymentTransferType
      paymentMethodId
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      title
      type
      note
      paymentProvider
      mollieMethod
      molliePaymentStatus
      molliePaymentUrl
      mollieErrorMessage
      mollieRetryCount
      methodChangedAt
      methodChangedBy {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useGetScheduledPaymentsQuery__
 *
 * To run a query within a React component, call `useGetScheduledPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPaymentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetScheduledPaymentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduledPaymentsQuery, GetScheduledPaymentsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetScheduledPaymentsQuery, GetScheduledPaymentsQueryVariables>(GetScheduledPaymentsDocument, baseOptions);
      }
export function useGetScheduledPaymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduledPaymentsQuery, GetScheduledPaymentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetScheduledPaymentsQuery, GetScheduledPaymentsQueryVariables>(GetScheduledPaymentsDocument, baseOptions);
        }
export type GetScheduledPaymentsQueryHookResult = ReturnType<typeof useGetScheduledPaymentsQuery>;
export type GetScheduledPaymentsLazyQueryHookResult = ReturnType<typeof useGetScheduledPaymentsLazyQuery>;
export type GetScheduledPaymentsQueryResult = ApolloReactCommon.QueryResult<GetScheduledPaymentsQuery, GetScheduledPaymentsQueryVariables>;
export const GetUnpaidScheduledPaymentsDocument = gql`
    query getUnpaidScheduledPayments($options: ArrayDataOptions, $bookingId: ID, $includeDeleted: Boolean, $respectArchiveSetting: Boolean, $dunningDue: Boolean) {
  unpaidScheduledPayments(options: $options, bookingId: $bookingId, includeDeleted: $includeDeleted, respectArchiveSetting: $respectArchiveSetting, dunningDue: $dunningDue) {
    existsMore
    total
    items {
      id
      dunningStatus {
        bookingId
        level
        levelDate
        nextLevel
        nextDate
        due
        pausedUntil
      }
      paymentDue
      paymentAmount
      refundedAmount
      providerRefundedAmount
      molliePaidAmount
      openAmount
      createDate
      paymentDone
      invoice {
        id
        createDate
        updateDate
        invoiceNumber
        invoiceNumberPrefix
      }
      booking {
        id
        courseId
        bookingNumberPrefix
        bookingNumber
        bookingType
        isSpecial
        vat
        netPrice
        grossPrice
        bookedBy
        paymentType
        invoice {
          id
        }
        paymentMethod {
          id
          cash
          esr
          creditCardAccountholder
          creditcardNumber
          expirationDate
          validFrom
          cvc
          paypalAccountholder
          email
          iban
          bank
          bic
          sepaAccountholder
          type
          bankTransfer
          onlinePayment
        }
        attendee {
          id
          erasedAt
          firstname
          lastname
          booker {
            id
            firstname
            lastname
            email
            nonDisclosureNotice
          }
        }
        courseLessons {
          id
          startDateTime
          endDateTime
          course {
            id
            startDateTime
            paymentInterval
            prefixedCourseNumber
            courseType {
              id
              name
              color
            }
          }
          location {
            id
            city
            name
          }
        }
        canceled
        bookingType
        noticeStaff
      }
      sepaClearance
      paymentTransferType
      paymentMethodId
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      title
      type
      note
      paymentProvider
      mollieMethod
      molliePaymentStatus
      molliePaymentUrl
      mollieErrorMessage
      mollieRetryCount
      methodChangedAt
      methodChangedBy {
        id
        email
      }
      manuallyAdjustedAt
      manuallyAdjustedByUserId
      manuallyAddedAt
      transferFromBookingNumber
      transferPaidAmount
      manuallyAdjustedBy {
        id
        email
      }
      deletedAt
      deletedByUserId
      deletedBy {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useGetUnpaidScheduledPaymentsQuery__
 *
 * To run a query within a React component, call `useGetUnpaidScheduledPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnpaidScheduledPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnpaidScheduledPaymentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      bookingId: // value for 'bookingId'
 *      includeDeleted: // value for 'includeDeleted'
 *      respectArchiveSetting: // value for 'respectArchiveSetting'
 *      dunningDue: // value for 'dunningDue'
 *   },
 * });
 */
export function useGetUnpaidScheduledPaymentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnpaidScheduledPaymentsQuery, GetUnpaidScheduledPaymentsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUnpaidScheduledPaymentsQuery, GetUnpaidScheduledPaymentsQueryVariables>(GetUnpaidScheduledPaymentsDocument, baseOptions);
      }
export function useGetUnpaidScheduledPaymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnpaidScheduledPaymentsQuery, GetUnpaidScheduledPaymentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUnpaidScheduledPaymentsQuery, GetUnpaidScheduledPaymentsQueryVariables>(GetUnpaidScheduledPaymentsDocument, baseOptions);
        }
export type GetUnpaidScheduledPaymentsQueryHookResult = ReturnType<typeof useGetUnpaidScheduledPaymentsQuery>;
export type GetUnpaidScheduledPaymentsLazyQueryHookResult = ReturnType<typeof useGetUnpaidScheduledPaymentsLazyQuery>;
export type GetUnpaidScheduledPaymentsQueryResult = ApolloReactCommon.QueryResult<GetUnpaidScheduledPaymentsQuery, GetUnpaidScheduledPaymentsQueryVariables>;
export const GetUnpaidScheduledPaymentsZeroValuesDocument = gql`
    query GetUnpaidScheduledPaymentsZeroValues($options: ArrayDataOptions) {
  unpaidScheduledPaymentsZeroValues(options: $options) {
    id
    paymentDue
    paymentAmount
    refundedAmount
    providerRefundedAmount
    molliePaidAmount
    openAmount
    createDate
    paymentDone
    invoice {
      id
      createDate
      updateDate
      invoiceNumber
      invoiceNumberPrefix
    }
    booking {
      id
      courseId
      bookingNumberPrefix
      bookingNumber
      bookingType
      isSpecial
      vat
      netPrice
      grossPrice
      bookedBy
      paymentType
      invoice {
        id
      }
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      attendee {
        id
        erasedAt
        firstname
        lastname
        booker {
          id
          firstname
          lastname
          email
          nonDisclosureNotice
        }
      }
      courseLessons {
        id
        startDateTime
        endDateTime
        course {
          id
          startDateTime
          paymentInterval
          prefixedCourseNumber
          courseType {
            id
            name
            color
          }
        }
        location {
          id
          city
          name
        }
      }
      canceled
      bookingType
      noticeStaff
    }
    sepaClearance
    paymentTransferType
    paymentMethodId
    paymentMethod {
      id
      cash
      esr
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      type
      bankTransfer
      onlinePayment
    }
    title
    type
    note
    paymentProvider
    mollieMethod
    molliePaymentStatus
    molliePaymentUrl
    mollieErrorMessage
    mollieRetryCount
    methodChangedAt
    methodChangedBy {
      id
      email
    }
  }
}
    `;

/**
 * __useGetUnpaidScheduledPaymentsZeroValuesQuery__
 *
 * To run a query within a React component, call `useGetUnpaidScheduledPaymentsZeroValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnpaidScheduledPaymentsZeroValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnpaidScheduledPaymentsZeroValuesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetUnpaidScheduledPaymentsZeroValuesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnpaidScheduledPaymentsZeroValuesQuery, GetUnpaidScheduledPaymentsZeroValuesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUnpaidScheduledPaymentsZeroValuesQuery, GetUnpaidScheduledPaymentsZeroValuesQueryVariables>(GetUnpaidScheduledPaymentsZeroValuesDocument, baseOptions);
      }
export function useGetUnpaidScheduledPaymentsZeroValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnpaidScheduledPaymentsZeroValuesQuery, GetUnpaidScheduledPaymentsZeroValuesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUnpaidScheduledPaymentsZeroValuesQuery, GetUnpaidScheduledPaymentsZeroValuesQueryVariables>(GetUnpaidScheduledPaymentsZeroValuesDocument, baseOptions);
        }
export type GetUnpaidScheduledPaymentsZeroValuesQueryHookResult = ReturnType<typeof useGetUnpaidScheduledPaymentsZeroValuesQuery>;
export type GetUnpaidScheduledPaymentsZeroValuesLazyQueryHookResult = ReturnType<typeof useGetUnpaidScheduledPaymentsZeroValuesLazyQuery>;
export type GetUnpaidScheduledPaymentsZeroValuesQueryResult = ApolloReactCommon.QueryResult<GetUnpaidScheduledPaymentsZeroValuesQuery, GetUnpaidScheduledPaymentsZeroValuesQueryVariables>;
export const ResolveSurplusMolliePaymentsDocument = gql`
    mutation ResolveSurplusMolliePayments($scheduledPaymentId: ID!) {
  resolveSurplusMolliePayments(scheduledPaymentId: $scheduledPaymentId)
}
    `;
export type ResolveSurplusMolliePaymentsMutationFn = ApolloReactCommon.MutationFunction<ResolveSurplusMolliePaymentsMutation, ResolveSurplusMolliePaymentsMutationVariables>;

/**
 * __useResolveSurplusMolliePaymentsMutation__
 *
 * To run a mutation, you first call `useResolveSurplusMolliePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveSurplusMolliePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveSurplusMolliePaymentsMutation, { data, loading, error }] = useResolveSurplusMolliePaymentsMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *   },
 * });
 */
export function useResolveSurplusMolliePaymentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveSurplusMolliePaymentsMutation, ResolveSurplusMolliePaymentsMutationVariables>) {
        return ApolloReactHooks.useMutation<ResolveSurplusMolliePaymentsMutation, ResolveSurplusMolliePaymentsMutationVariables>(ResolveSurplusMolliePaymentsDocument, baseOptions);
      }
export type ResolveSurplusMolliePaymentsMutationHookResult = ReturnType<typeof useResolveSurplusMolliePaymentsMutation>;
export type ResolveSurplusMolliePaymentsMutationResult = ApolloReactCommon.MutationResult<ResolveSurplusMolliePaymentsMutation>;
export type ResolveSurplusMolliePaymentsMutationOptions = ApolloReactCommon.BaseMutationOptions<ResolveSurplusMolliePaymentsMutation, ResolveSurplusMolliePaymentsMutationVariables>;
export const GetPaidScheduledPaymentsDocument = gql`
    query getPaidScheduledPayments($options: ArrayDataOptions, $bookingId: ID, $includeDeleted: Boolean, $respectArchiveSetting: Boolean) {
  paidScheduledPayments(options: $options, bookingId: $bookingId, includeDeleted: $includeDeleted, respectArchiveSetting: $respectArchiveSetting) {
    existsMore
    total
    items {
      id
      paymentDue
      paymentAmount
      refundedAmount
      providerRefundedAmount
      molliePaidAmount
      surplusMolliePaymentCount
      openAmount
      createDate
      paymentDone
      note
      invoice {
        id
        createDate
        updateDate
        invoiceNumber
        invoiceNumberPrefix
      }
      booking {
        id
        courseId
        bookingNumberPrefix
        bookingNumber
        bookingType
        isSpecial
        vat
        netPrice
        grossPrice
        bookedBy
        paymentType
        invoice {
          id
        }
        paymentMethod {
          id
          cash
          esr
          creditCardAccountholder
          creditcardNumber
          expirationDate
          validFrom
          cvc
          paypalAccountholder
          email
          iban
          bank
          bic
          sepaAccountholder
          type
          bankTransfer
          onlinePayment
        }
        attendee {
          id
          erasedAt
          firstname
          lastname
          booker {
            id
            firstname
            lastname
            email
            nonDisclosureNotice
          }
        }
        courseLessons {
          id
          startDateTime
          endDateTime
          course {
            id
            startDateTime
            paymentInterval
            prefixedCourseNumber
            courseType {
              id
              name
              color
            }
          }
          location {
            id
            city
            name
          }
        }
        canceled
        bookingType
        noticeStaff
      }
      sepaClearance
      paymentTransferType
      paymentMethodId
      paymentMethod {
        id
        cash
        esr
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        type
        bankTransfer
        onlinePayment
      }
      title
      type
      note
      paymentProvider
      mollieMethod
      molliePaymentStatus
      molliePaymentUrl
      mollieErrorMessage
      mollieRetryCount
      methodChangedAt
      methodChangedBy {
        id
        email
      }
      manuallyAdjustedAt
      manuallyAdjustedByUserId
      manuallyAddedAt
      transferFromBookingNumber
      transferPaidAmount
      manuallyAdjustedBy {
        id
        email
      }
      deletedAt
      deletedByUserId
      deletedBy {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useGetPaidScheduledPaymentsQuery__
 *
 * To run a query within a React component, call `useGetPaidScheduledPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaidScheduledPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaidScheduledPaymentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      bookingId: // value for 'bookingId'
 *      includeDeleted: // value for 'includeDeleted'
 *      respectArchiveSetting: // value for 'respectArchiveSetting'
 *   },
 * });
 */
export function useGetPaidScheduledPaymentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaidScheduledPaymentsQuery, GetPaidScheduledPaymentsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPaidScheduledPaymentsQuery, GetPaidScheduledPaymentsQueryVariables>(GetPaidScheduledPaymentsDocument, baseOptions);
      }
export function useGetPaidScheduledPaymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaidScheduledPaymentsQuery, GetPaidScheduledPaymentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPaidScheduledPaymentsQuery, GetPaidScheduledPaymentsQueryVariables>(GetPaidScheduledPaymentsDocument, baseOptions);
        }
export type GetPaidScheduledPaymentsQueryHookResult = ReturnType<typeof useGetPaidScheduledPaymentsQuery>;
export type GetPaidScheduledPaymentsLazyQueryHookResult = ReturnType<typeof useGetPaidScheduledPaymentsLazyQuery>;
export type GetPaidScheduledPaymentsQueryResult = ApolloReactCommon.QueryResult<GetPaidScheduledPaymentsQuery, GetPaidScheduledPaymentsQueryVariables>;
export const GetScheduledPaymentsSummaryDocument = gql`
    query GetScheduledPaymentsSummary($paymentDone: Boolean!, $options: ArrayDataOptions, $respectArchiveSetting: Boolean) {
  scheduledPaymentSummary(paymentDone: $paymentDone, options: $options, respectArchiveSetting: $respectArchiveSetting) {
    filtered {
      count
      sum
    }
    total {
      count
      sum
    }
  }
}
    `;

/**
 * __useGetScheduledPaymentsSummaryQuery__
 *
 * To run a query within a React component, call `useGetScheduledPaymentsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPaymentsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPaymentsSummaryQuery({
 *   variables: {
 *      paymentDone: // value for 'paymentDone'
 *      options: // value for 'options'
 *      respectArchiveSetting: // value for 'respectArchiveSetting'
 *   },
 * });
 */
export function useGetScheduledPaymentsSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduledPaymentsSummaryQuery, GetScheduledPaymentsSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetScheduledPaymentsSummaryQuery, GetScheduledPaymentsSummaryQueryVariables>(GetScheduledPaymentsSummaryDocument, baseOptions);
      }
export function useGetScheduledPaymentsSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduledPaymentsSummaryQuery, GetScheduledPaymentsSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetScheduledPaymentsSummaryQuery, GetScheduledPaymentsSummaryQueryVariables>(GetScheduledPaymentsSummaryDocument, baseOptions);
        }
export type GetScheduledPaymentsSummaryQueryHookResult = ReturnType<typeof useGetScheduledPaymentsSummaryQuery>;
export type GetScheduledPaymentsSummaryLazyQueryHookResult = ReturnType<typeof useGetScheduledPaymentsSummaryLazyQuery>;
export type GetScheduledPaymentsSummaryQueryResult = ApolloReactCommon.QueryResult<GetScheduledPaymentsSummaryQuery, GetScheduledPaymentsSummaryQueryVariables>;
export const GetScheduledPaymentsMinDocument = gql`
    query GetScheduledPaymentsMin($options: ArrayDataOptions) {
  scheduledPayments(options: $options) {
    existsMore
    total
    items {
      id
      paymentDue
      paymentAmount
      openAmount
      paymentTransferType
      title
    }
  }
}
    `;

/**
 * __useGetScheduledPaymentsMinQuery__
 *
 * To run a query within a React component, call `useGetScheduledPaymentsMinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPaymentsMinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPaymentsMinQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetScheduledPaymentsMinQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduledPaymentsMinQuery, GetScheduledPaymentsMinQueryVariables>) {
        return ApolloReactHooks.useQuery<GetScheduledPaymentsMinQuery, GetScheduledPaymentsMinQueryVariables>(GetScheduledPaymentsMinDocument, baseOptions);
      }
export function useGetScheduledPaymentsMinLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduledPaymentsMinQuery, GetScheduledPaymentsMinQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetScheduledPaymentsMinQuery, GetScheduledPaymentsMinQueryVariables>(GetScheduledPaymentsMinDocument, baseOptions);
        }
export type GetScheduledPaymentsMinQueryHookResult = ReturnType<typeof useGetScheduledPaymentsMinQuery>;
export type GetScheduledPaymentsMinLazyQueryHookResult = ReturnType<typeof useGetScheduledPaymentsMinLazyQuery>;
export type GetScheduledPaymentsMinQueryResult = ApolloReactCommon.QueryResult<GetScheduledPaymentsMinQuery, GetScheduledPaymentsMinQueryVariables>;
export const GetScheduledPaymentByIdDocument = gql`
    query getScheduledPaymentById($id: ID!) {
  scheduledPaymentById(id: $id) {
    id
  }
}
    `;

/**
 * __useGetScheduledPaymentByIdQuery__
 *
 * To run a query within a React component, call `useGetScheduledPaymentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPaymentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPaymentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScheduledPaymentByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduledPaymentByIdQuery, GetScheduledPaymentByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetScheduledPaymentByIdQuery, GetScheduledPaymentByIdQueryVariables>(GetScheduledPaymentByIdDocument, baseOptions);
      }
export function useGetScheduledPaymentByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduledPaymentByIdQuery, GetScheduledPaymentByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetScheduledPaymentByIdQuery, GetScheduledPaymentByIdQueryVariables>(GetScheduledPaymentByIdDocument, baseOptions);
        }
export type GetScheduledPaymentByIdQueryHookResult = ReturnType<typeof useGetScheduledPaymentByIdQuery>;
export type GetScheduledPaymentByIdLazyQueryHookResult = ReturnType<typeof useGetScheduledPaymentByIdLazyQuery>;
export type GetScheduledPaymentByIdQueryResult = ApolloReactCommon.QueryResult<GetScheduledPaymentByIdQuery, GetScheduledPaymentByIdQueryVariables>;
export const DeleteScheduledPaymentDocument = gql`
    mutation DeleteScheduledPayment($id: String!) {
  deleteScheduledPayment(id: $id) {
    id
  }
}
    `;
export type DeleteScheduledPaymentMutationFn = ApolloReactCommon.MutationFunction<DeleteScheduledPaymentMutation, DeleteScheduledPaymentMutationVariables>;

/**
 * __useDeleteScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledPaymentMutation, { data, loading, error }] = useDeleteScheduledPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduledPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteScheduledPaymentMutation, DeleteScheduledPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteScheduledPaymentMutation, DeleteScheduledPaymentMutationVariables>(DeleteScheduledPaymentDocument, baseOptions);
      }
export type DeleteScheduledPaymentMutationHookResult = ReturnType<typeof useDeleteScheduledPaymentMutation>;
export type DeleteScheduledPaymentMutationResult = ApolloReactCommon.MutationResult<DeleteScheduledPaymentMutation>;
export type DeleteScheduledPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteScheduledPaymentMutation, DeleteScheduledPaymentMutationVariables>;
export const UpdateScheduledPaymentDocument = gql`
    mutation UpdateScheduledPayment($editScheduledPaymentData: EditScheduledPaymentInput!, $id: String!) {
  updateScheduledPayment(editScheduledPaymentData: $editScheduledPaymentData, id: $id) {
    id
    paymentDone
  }
}
    `;
export type UpdateScheduledPaymentMutationFn = ApolloReactCommon.MutationFunction<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>;

/**
 * __useUpdateScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledPaymentMutation, { data, loading, error }] = useUpdateScheduledPaymentMutation({
 *   variables: {
 *      editScheduledPaymentData: // value for 'editScheduledPaymentData'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateScheduledPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>(UpdateScheduledPaymentDocument, baseOptions);
      }
export type UpdateScheduledPaymentMutationHookResult = ReturnType<typeof useUpdateScheduledPaymentMutation>;
export type UpdateScheduledPaymentMutationResult = ApolloReactCommon.MutationResult<UpdateScheduledPaymentMutation>;
export type UpdateScheduledPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>;
export const UpdateManyScheduledPaymentIdsDocument = gql`
    mutation UpdateManyScheduledPaymentIds($paymentIds: [ID!]!, $editScheduledPaymentData: EditScheduledPaymentInput!) {
  updateManyScheduledPaymentIds(paymentIds: $paymentIds, editScheduledPaymentData: $editScheduledPaymentData) {
    id
    paymentDone
  }
}
    `;
export type UpdateManyScheduledPaymentIdsMutationFn = ApolloReactCommon.MutationFunction<UpdateManyScheduledPaymentIdsMutation, UpdateManyScheduledPaymentIdsMutationVariables>;

/**
 * __useUpdateManyScheduledPaymentIdsMutation__
 *
 * To run a mutation, you first call `useUpdateManyScheduledPaymentIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManyScheduledPaymentIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManyScheduledPaymentIdsMutation, { data, loading, error }] = useUpdateManyScheduledPaymentIdsMutation({
 *   variables: {
 *      paymentIds: // value for 'paymentIds'
 *      editScheduledPaymentData: // value for 'editScheduledPaymentData'
 *   },
 * });
 */
export function useUpdateManyScheduledPaymentIdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateManyScheduledPaymentIdsMutation, UpdateManyScheduledPaymentIdsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateManyScheduledPaymentIdsMutation, UpdateManyScheduledPaymentIdsMutationVariables>(UpdateManyScheduledPaymentIdsDocument, baseOptions);
      }
export type UpdateManyScheduledPaymentIdsMutationHookResult = ReturnType<typeof useUpdateManyScheduledPaymentIdsMutation>;
export type UpdateManyScheduledPaymentIdsMutationResult = ApolloReactCommon.MutationResult<UpdateManyScheduledPaymentIdsMutation>;
export type UpdateManyScheduledPaymentIdsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateManyScheduledPaymentIdsMutation, UpdateManyScheduledPaymentIdsMutationVariables>;
export const SetMultipleScheduledPaymentsPaidDocument = gql`
    mutation SetMultipleScheduledPaymentsPaid($paymentIds: [ID!]!, $paymentDone: DateTime!) {
  setMultipleScheduledPaymentsPaid(paymentIds: $paymentIds, paymentDone: $paymentDone)
}
    `;
export type SetMultipleScheduledPaymentsPaidMutationFn = ApolloReactCommon.MutationFunction<SetMultipleScheduledPaymentsPaidMutation, SetMultipleScheduledPaymentsPaidMutationVariables>;

/**
 * __useSetMultipleScheduledPaymentsPaidMutation__
 *
 * To run a mutation, you first call `useSetMultipleScheduledPaymentsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMultipleScheduledPaymentsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMultipleScheduledPaymentsPaidMutation, { data, loading, error }] = useSetMultipleScheduledPaymentsPaidMutation({
 *   variables: {
 *      paymentIds: // value for 'paymentIds'
 *      paymentDone: // value for 'paymentDone'
 *   },
 * });
 */
export function useSetMultipleScheduledPaymentsPaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMultipleScheduledPaymentsPaidMutation, SetMultipleScheduledPaymentsPaidMutationVariables>) {
        return ApolloReactHooks.useMutation<SetMultipleScheduledPaymentsPaidMutation, SetMultipleScheduledPaymentsPaidMutationVariables>(SetMultipleScheduledPaymentsPaidDocument, baseOptions);
      }
export type SetMultipleScheduledPaymentsPaidMutationHookResult = ReturnType<typeof useSetMultipleScheduledPaymentsPaidMutation>;
export type SetMultipleScheduledPaymentsPaidMutationResult = ApolloReactCommon.MutationResult<SetMultipleScheduledPaymentsPaidMutation>;
export type SetMultipleScheduledPaymentsPaidMutationOptions = ApolloReactCommon.BaseMutationOptions<SetMultipleScheduledPaymentsPaidMutation, SetMultipleScheduledPaymentsPaidMutationVariables>;
export const SetSepaClearanceDocument = gql`
    mutation setSepaClearance($id: ID!, $sepaClearance: Boolean!) {
  setSepaClearance(id: $id, sepaClearance: $sepaClearance) {
    id
    sepaClearance
  }
}
    `;
export type SetSepaClearanceMutationFn = ApolloReactCommon.MutationFunction<SetSepaClearanceMutation, SetSepaClearanceMutationVariables>;

/**
 * __useSetSepaClearanceMutation__
 *
 * To run a mutation, you first call `useSetSepaClearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSepaClearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSepaClearanceMutation, { data, loading, error }] = useSetSepaClearanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sepaClearance: // value for 'sepaClearance'
 *   },
 * });
 */
export function useSetSepaClearanceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetSepaClearanceMutation, SetSepaClearanceMutationVariables>) {
        return ApolloReactHooks.useMutation<SetSepaClearanceMutation, SetSepaClearanceMutationVariables>(SetSepaClearanceDocument, baseOptions);
      }
export type SetSepaClearanceMutationHookResult = ReturnType<typeof useSetSepaClearanceMutation>;
export type SetSepaClearanceMutationResult = ApolloReactCommon.MutationResult<SetSepaClearanceMutation>;
export type SetSepaClearanceMutationOptions = ApolloReactCommon.BaseMutationOptions<SetSepaClearanceMutation, SetSepaClearanceMutationVariables>;
export const GetScheduledPaymentsByBookingIdDocument = gql`
    query GetScheduledPaymentsByBookingId($bookingId: ID!) {
  scheduledPaymentsByBookingId(bookingId: $bookingId) {
    id
    paymentDue
    paymentAmount
    openAmount
    createDate
    paymentDone
    paymentTransferType
    invoice {
      id
      createDate
      invoiceNumber
      invoiceNumberPrefix
    }
    title
  }
}
    `;

/**
 * __useGetScheduledPaymentsByBookingIdQuery__
 *
 * To run a query within a React component, call `useGetScheduledPaymentsByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPaymentsByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPaymentsByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetScheduledPaymentsByBookingIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduledPaymentsByBookingIdQuery, GetScheduledPaymentsByBookingIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetScheduledPaymentsByBookingIdQuery, GetScheduledPaymentsByBookingIdQueryVariables>(GetScheduledPaymentsByBookingIdDocument, baseOptions);
      }
export function useGetScheduledPaymentsByBookingIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduledPaymentsByBookingIdQuery, GetScheduledPaymentsByBookingIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetScheduledPaymentsByBookingIdQuery, GetScheduledPaymentsByBookingIdQueryVariables>(GetScheduledPaymentsByBookingIdDocument, baseOptions);
        }
export type GetScheduledPaymentsByBookingIdQueryHookResult = ReturnType<typeof useGetScheduledPaymentsByBookingIdQuery>;
export type GetScheduledPaymentsByBookingIdLazyQueryHookResult = ReturnType<typeof useGetScheduledPaymentsByBookingIdLazyQuery>;
export type GetScheduledPaymentsByBookingIdQueryResult = ApolloReactCommon.QueryResult<GetScheduledPaymentsByBookingIdQuery, GetScheduledPaymentsByBookingIdQueryVariables>;
export const GeneratePaymentSchedulePreviewDocument = gql`
    mutation GeneratePaymentSchedulePreview($lessonDates: [DateTime!]!, $bookingPrice: Float!, $monthlySchedule: MonthlySchedule!, $paymentType: PaymentType!, $courseId: ID) {
  generatePaymentSchedulePreview(lessonDates: $lessonDates, bookingPrice: $bookingPrice, monthlySchedule: $monthlySchedule, paymentType: $paymentType, courseId: $courseId)
}
    `;
export type GeneratePaymentSchedulePreviewMutationFn = ApolloReactCommon.MutationFunction<GeneratePaymentSchedulePreviewMutation, GeneratePaymentSchedulePreviewMutationVariables>;

/**
 * __useGeneratePaymentSchedulePreviewMutation__
 *
 * To run a mutation, you first call `useGeneratePaymentSchedulePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaymentSchedulePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePaymentSchedulePreviewMutation, { data, loading, error }] = useGeneratePaymentSchedulePreviewMutation({
 *   variables: {
 *      lessonDates: // value for 'lessonDates'
 *      bookingPrice: // value for 'bookingPrice'
 *      monthlySchedule: // value for 'monthlySchedule'
 *      paymentType: // value for 'paymentType'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGeneratePaymentSchedulePreviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GeneratePaymentSchedulePreviewMutation, GeneratePaymentSchedulePreviewMutationVariables>) {
        return ApolloReactHooks.useMutation<GeneratePaymentSchedulePreviewMutation, GeneratePaymentSchedulePreviewMutationVariables>(GeneratePaymentSchedulePreviewDocument, baseOptions);
      }
export type GeneratePaymentSchedulePreviewMutationHookResult = ReturnType<typeof useGeneratePaymentSchedulePreviewMutation>;
export type GeneratePaymentSchedulePreviewMutationResult = ApolloReactCommon.MutationResult<GeneratePaymentSchedulePreviewMutation>;
export type GeneratePaymentSchedulePreviewMutationOptions = ApolloReactCommon.BaseMutationOptions<GeneratePaymentSchedulePreviewMutation, GeneratePaymentSchedulePreviewMutationVariables>;
export const GenerateUpdatedSchedulesNewBookingPriceDocument = gql`
    mutation GenerateUpdatedSchedulesNewBookingPrice($scheduledPayments: [UpdateScheduledPaymentByBookingInput!]!, $bookingPrice: Float!) {
  generateUpdatedSchedulesNewBookingPrice(scheduledPayments: $scheduledPayments, bookingPrice: $bookingPrice) {
    id
    paymentAmount
    openAmount
    paymentDue
  }
}
    `;
export type GenerateUpdatedSchedulesNewBookingPriceMutationFn = ApolloReactCommon.MutationFunction<GenerateUpdatedSchedulesNewBookingPriceMutation, GenerateUpdatedSchedulesNewBookingPriceMutationVariables>;

/**
 * __useGenerateUpdatedSchedulesNewBookingPriceMutation__
 *
 * To run a mutation, you first call `useGenerateUpdatedSchedulesNewBookingPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUpdatedSchedulesNewBookingPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUpdatedSchedulesNewBookingPriceMutation, { data, loading, error }] = useGenerateUpdatedSchedulesNewBookingPriceMutation({
 *   variables: {
 *      scheduledPayments: // value for 'scheduledPayments'
 *      bookingPrice: // value for 'bookingPrice'
 *   },
 * });
 */
export function useGenerateUpdatedSchedulesNewBookingPriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateUpdatedSchedulesNewBookingPriceMutation, GenerateUpdatedSchedulesNewBookingPriceMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateUpdatedSchedulesNewBookingPriceMutation, GenerateUpdatedSchedulesNewBookingPriceMutationVariables>(GenerateUpdatedSchedulesNewBookingPriceDocument, baseOptions);
      }
export type GenerateUpdatedSchedulesNewBookingPriceMutationHookResult = ReturnType<typeof useGenerateUpdatedSchedulesNewBookingPriceMutation>;
export type GenerateUpdatedSchedulesNewBookingPriceMutationResult = ApolloReactCommon.MutationResult<GenerateUpdatedSchedulesNewBookingPriceMutation>;
export type GenerateUpdatedSchedulesNewBookingPriceMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateUpdatedSchedulesNewBookingPriceMutation, GenerateUpdatedSchedulesNewBookingPriceMutationVariables>;
export const ResetScheduledPaymentsOfBookingDocument = gql`
    mutation ResetScheduledPaymentsOfBooking($bookingId: ID!, $preview: Boolean) {
  resetScheduledPaymentsOfBooking(bookingId: $bookingId, preview: $preview) {
    bookingId
    bookingNumber
    bookingPrice
    coursePrice
    creditedBalance
    currentScheduledPaymentsCount
    newScheduledPaymentsCount
    currentScheduledPaymnetsCount
    installmentPlanAmountsAndDueDates {
      key
      value {
        due
        amount
      }
    }
    newScheduledPaymentsAmountsAndDueDates {
      key
      value {
        due
        amount
      }
    }
    currentScheduledPaymentsAmountsAndDueDates {
      key
      value {
        due
        amount
      }
    }
  }
}
    `;
export type ResetScheduledPaymentsOfBookingMutationFn = ApolloReactCommon.MutationFunction<ResetScheduledPaymentsOfBookingMutation, ResetScheduledPaymentsOfBookingMutationVariables>;

/**
 * __useResetScheduledPaymentsOfBookingMutation__
 *
 * To run a mutation, you first call `useResetScheduledPaymentsOfBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetScheduledPaymentsOfBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetScheduledPaymentsOfBookingMutation, { data, loading, error }] = useResetScheduledPaymentsOfBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useResetScheduledPaymentsOfBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetScheduledPaymentsOfBookingMutation, ResetScheduledPaymentsOfBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetScheduledPaymentsOfBookingMutation, ResetScheduledPaymentsOfBookingMutationVariables>(ResetScheduledPaymentsOfBookingDocument, baseOptions);
      }
export type ResetScheduledPaymentsOfBookingMutationHookResult = ReturnType<typeof useResetScheduledPaymentsOfBookingMutation>;
export type ResetScheduledPaymentsOfBookingMutationResult = ApolloReactCommon.MutationResult<ResetScheduledPaymentsOfBookingMutation>;
export type ResetScheduledPaymentsOfBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetScheduledPaymentsOfBookingMutation, ResetScheduledPaymentsOfBookingMutationVariables>;
export const ResetAllUnsetteledScheduledPaymentsOfCourseDocument = gql`
    mutation ResetAllUnsetteledScheduledPaymentsOfCourse($courseId: ID!, $preview: Boolean) {
  resetAllUnsetteledScheduledPaymentsOfCourse(courseId: $courseId, preview: $preview) {
    courseId
    coursePrice
    courseDueDates {
      key
      value {
        due
        amount
      }
    }
    bookings {
      bookingId
      bookingNumber
      bookingPrice
      creditedBalance
      currentScheduledPaymentsCount
      newScheduledPaymentsCount
      currentScheduledPaymnetsCount
      newScheduledPaymentsAmountsAndDueDates {
        key
        value {
          due
          amount
        }
      }
      currentScheduledPaymentsAmountsAndDueDates {
        key
        value {
          due
          amount
        }
      }
    }
  }
}
    `;
export type ResetAllUnsetteledScheduledPaymentsOfCourseMutationFn = ApolloReactCommon.MutationFunction<ResetAllUnsetteledScheduledPaymentsOfCourseMutation, ResetAllUnsetteledScheduledPaymentsOfCourseMutationVariables>;

/**
 * __useResetAllUnsetteledScheduledPaymentsOfCourseMutation__
 *
 * To run a mutation, you first call `useResetAllUnsetteledScheduledPaymentsOfCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAllUnsetteledScheduledPaymentsOfCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAllUnsetteledScheduledPaymentsOfCourseMutation, { data, loading, error }] = useResetAllUnsetteledScheduledPaymentsOfCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useResetAllUnsetteledScheduledPaymentsOfCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetAllUnsetteledScheduledPaymentsOfCourseMutation, ResetAllUnsetteledScheduledPaymentsOfCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetAllUnsetteledScheduledPaymentsOfCourseMutation, ResetAllUnsetteledScheduledPaymentsOfCourseMutationVariables>(ResetAllUnsetteledScheduledPaymentsOfCourseDocument, baseOptions);
      }
export type ResetAllUnsetteledScheduledPaymentsOfCourseMutationHookResult = ReturnType<typeof useResetAllUnsetteledScheduledPaymentsOfCourseMutation>;
export type ResetAllUnsetteledScheduledPaymentsOfCourseMutationResult = ApolloReactCommon.MutationResult<ResetAllUnsetteledScheduledPaymentsOfCourseMutation>;
export type ResetAllUnsetteledScheduledPaymentsOfCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetAllUnsetteledScheduledPaymentsOfCourseMutation, ResetAllUnsetteledScheduledPaymentsOfCourseMutationVariables>;
export const ScheduledPaymentsByBookerIdDocument = gql`
    query ScheduledPaymentsByBookerId($bookerId: ID!) {
  scheduledPaymentsByBookerId(bookerId: $bookerId) {
    id
    paymentDue
    paymentAmount
    openAmount
    paymentDone
    createDate
    sepaClearance
    paymentMethodId
  }
}
    `;

/**
 * __useScheduledPaymentsByBookerIdQuery__
 *
 * To run a query within a React component, call `useScheduledPaymentsByBookerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledPaymentsByBookerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledPaymentsByBookerIdQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useScheduledPaymentsByBookerIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduledPaymentsByBookerIdQuery, ScheduledPaymentsByBookerIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ScheduledPaymentsByBookerIdQuery, ScheduledPaymentsByBookerIdQueryVariables>(ScheduledPaymentsByBookerIdDocument, baseOptions);
      }
export function useScheduledPaymentsByBookerIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduledPaymentsByBookerIdQuery, ScheduledPaymentsByBookerIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ScheduledPaymentsByBookerIdQuery, ScheduledPaymentsByBookerIdQueryVariables>(ScheduledPaymentsByBookerIdDocument, baseOptions);
        }
export type ScheduledPaymentsByBookerIdQueryHookResult = ReturnType<typeof useScheduledPaymentsByBookerIdQuery>;
export type ScheduledPaymentsByBookerIdLazyQueryHookResult = ReturnType<typeof useScheduledPaymentsByBookerIdLazyQuery>;
export type ScheduledPaymentsByBookerIdQueryResult = ApolloReactCommon.QueryResult<ScheduledPaymentsByBookerIdQuery, ScheduledPaymentsByBookerIdQueryVariables>;
export const SetScheduledPaymentPaidDocument = gql`
    mutation SetScheduledPaymentPaid($id: String!, $paymentDone: DateTime!) {
  setScheduledPaymentPaid(id: $id, paymentDone: $paymentDone) {
    id
    paymentDone
  }
}
    `;
export type SetScheduledPaymentPaidMutationFn = ApolloReactCommon.MutationFunction<SetScheduledPaymentPaidMutation, SetScheduledPaymentPaidMutationVariables>;

/**
 * __useSetScheduledPaymentPaidMutation__
 *
 * To run a mutation, you first call `useSetScheduledPaymentPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetScheduledPaymentPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setScheduledPaymentPaidMutation, { data, loading, error }] = useSetScheduledPaymentPaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentDone: // value for 'paymentDone'
 *   },
 * });
 */
export function useSetScheduledPaymentPaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetScheduledPaymentPaidMutation, SetScheduledPaymentPaidMutationVariables>) {
        return ApolloReactHooks.useMutation<SetScheduledPaymentPaidMutation, SetScheduledPaymentPaidMutationVariables>(SetScheduledPaymentPaidDocument, baseOptions);
      }
export type SetScheduledPaymentPaidMutationHookResult = ReturnType<typeof useSetScheduledPaymentPaidMutation>;
export type SetScheduledPaymentPaidMutationResult = ApolloReactCommon.MutationResult<SetScheduledPaymentPaidMutation>;
export type SetScheduledPaymentPaidMutationOptions = ApolloReactCommon.BaseMutationOptions<SetScheduledPaymentPaidMutation, SetScheduledPaymentPaidMutationVariables>;
export const SetScheduledPaymentUnpaidDocument = gql`
    mutation SetScheduledPaymentUnpaid($id: String!) {
  setScheduledPaymentUnpaid(id: $id) {
    id
    paymentDone
  }
}
    `;
export type SetScheduledPaymentUnpaidMutationFn = ApolloReactCommon.MutationFunction<SetScheduledPaymentUnpaidMutation, SetScheduledPaymentUnpaidMutationVariables>;

/**
 * __useSetScheduledPaymentUnpaidMutation__
 *
 * To run a mutation, you first call `useSetScheduledPaymentUnpaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetScheduledPaymentUnpaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setScheduledPaymentUnpaidMutation, { data, loading, error }] = useSetScheduledPaymentUnpaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetScheduledPaymentUnpaidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetScheduledPaymentUnpaidMutation, SetScheduledPaymentUnpaidMutationVariables>) {
        return ApolloReactHooks.useMutation<SetScheduledPaymentUnpaidMutation, SetScheduledPaymentUnpaidMutationVariables>(SetScheduledPaymentUnpaidDocument, baseOptions);
      }
export type SetScheduledPaymentUnpaidMutationHookResult = ReturnType<typeof useSetScheduledPaymentUnpaidMutation>;
export type SetScheduledPaymentUnpaidMutationResult = ApolloReactCommon.MutationResult<SetScheduledPaymentUnpaidMutation>;
export type SetScheduledPaymentUnpaidMutationOptions = ApolloReactCommon.BaseMutationOptions<SetScheduledPaymentUnpaidMutation, SetScheduledPaymentUnpaidMutationVariables>;
export const SetNewPaymentDoneDateDocument = gql`
    mutation SetNewPaymentDoneDate($id: String!, $paymentDoneDate: DateTime!) {
  setNewPaymentDoneDate(id: $id, paymentDoneDate: $paymentDoneDate) {
    id
    paymentDone
  }
}
    `;
export type SetNewPaymentDoneDateMutationFn = ApolloReactCommon.MutationFunction<SetNewPaymentDoneDateMutation, SetNewPaymentDoneDateMutationVariables>;

/**
 * __useSetNewPaymentDoneDateMutation__
 *
 * To run a mutation, you first call `useSetNewPaymentDoneDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewPaymentDoneDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewPaymentDoneDateMutation, { data, loading, error }] = useSetNewPaymentDoneDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentDoneDate: // value for 'paymentDoneDate'
 *   },
 * });
 */
export function useSetNewPaymentDoneDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNewPaymentDoneDateMutation, SetNewPaymentDoneDateMutationVariables>) {
        return ApolloReactHooks.useMutation<SetNewPaymentDoneDateMutation, SetNewPaymentDoneDateMutationVariables>(SetNewPaymentDoneDateDocument, baseOptions);
      }
export type SetNewPaymentDoneDateMutationHookResult = ReturnType<typeof useSetNewPaymentDoneDateMutation>;
export type SetNewPaymentDoneDateMutationResult = ApolloReactCommon.MutationResult<SetNewPaymentDoneDateMutation>;
export type SetNewPaymentDoneDateMutationOptions = ApolloReactCommon.BaseMutationOptions<SetNewPaymentDoneDateMutation, SetNewPaymentDoneDateMutationVariables>;
export const SetNewPaymentAmountDocument = gql`
    mutation SetNewPaymentAmount($id: String!, $paymentAmount: Float!) {
  setNewPaymentAmount(id: $id, paymentAmount: $paymentAmount) {
    id
    paymentAmount
    openAmount
  }
}
    `;
export type SetNewPaymentAmountMutationFn = ApolloReactCommon.MutationFunction<SetNewPaymentAmountMutation, SetNewPaymentAmountMutationVariables>;

/**
 * __useSetNewPaymentAmountMutation__
 *
 * To run a mutation, you first call `useSetNewPaymentAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewPaymentAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewPaymentAmountMutation, { data, loading, error }] = useSetNewPaymentAmountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentAmount: // value for 'paymentAmount'
 *   },
 * });
 */
export function useSetNewPaymentAmountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNewPaymentAmountMutation, SetNewPaymentAmountMutationVariables>) {
        return ApolloReactHooks.useMutation<SetNewPaymentAmountMutation, SetNewPaymentAmountMutationVariables>(SetNewPaymentAmountDocument, baseOptions);
      }
export type SetNewPaymentAmountMutationHookResult = ReturnType<typeof useSetNewPaymentAmountMutation>;
export type SetNewPaymentAmountMutationResult = ApolloReactCommon.MutationResult<SetNewPaymentAmountMutation>;
export type SetNewPaymentAmountMutationOptions = ApolloReactCommon.BaseMutationOptions<SetNewPaymentAmountMutation, SetNewPaymentAmountMutationVariables>;
export const ModifyScheduledPaymentDocument = gql`
    mutation ModifyScheduledPayment($modifyScheduledPaymentInput: ModifyScheduledPaymentInput!) {
  modifyScheduledPayment(modifyScheduledPaymentInput: $modifyScheduledPaymentInput) {
    id
    paymentAmount
    openAmount
    paymentDue
    paymentDone
    paymentMethodId
    sepaClearance
    title
    type
  }
}
    `;
export type ModifyScheduledPaymentMutationFn = ApolloReactCommon.MutationFunction<ModifyScheduledPaymentMutation, ModifyScheduledPaymentMutationVariables>;

/**
 * __useModifyScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useModifyScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyScheduledPaymentMutation, { data, loading, error }] = useModifyScheduledPaymentMutation({
 *   variables: {
 *      modifyScheduledPaymentInput: // value for 'modifyScheduledPaymentInput'
 *   },
 * });
 */
export function useModifyScheduledPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyScheduledPaymentMutation, ModifyScheduledPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<ModifyScheduledPaymentMutation, ModifyScheduledPaymentMutationVariables>(ModifyScheduledPaymentDocument, baseOptions);
      }
export type ModifyScheduledPaymentMutationHookResult = ReturnType<typeof useModifyScheduledPaymentMutation>;
export type ModifyScheduledPaymentMutationResult = ApolloReactCommon.MutationResult<ModifyScheduledPaymentMutation>;
export type ModifyScheduledPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyScheduledPaymentMutation, ModifyScheduledPaymentMutationVariables>;
export const GenerateScheduledPaymentsForSettledBookingDocument = gql`
    mutation GenerateScheduledPaymentsForSettledBooking($bookingId: ID!, $savePayments: Boolean) {
  generateScheduledPaymentsForSettledBooking(bookingId: $bookingId, savePayments: $savePayments) {
    id
    paymentAmount
    openAmount
    paymentDue
    paymentDone
    paymentMethodId
    sepaClearance
  }
}
    `;
export type GenerateScheduledPaymentsForSettledBookingMutationFn = ApolloReactCommon.MutationFunction<GenerateScheduledPaymentsForSettledBookingMutation, GenerateScheduledPaymentsForSettledBookingMutationVariables>;

/**
 * __useGenerateScheduledPaymentsForSettledBookingMutation__
 *
 * To run a mutation, you first call `useGenerateScheduledPaymentsForSettledBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateScheduledPaymentsForSettledBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateScheduledPaymentsForSettledBookingMutation, { data, loading, error }] = useGenerateScheduledPaymentsForSettledBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      savePayments: // value for 'savePayments'
 *   },
 * });
 */
export function useGenerateScheduledPaymentsForSettledBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateScheduledPaymentsForSettledBookingMutation, GenerateScheduledPaymentsForSettledBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateScheduledPaymentsForSettledBookingMutation, GenerateScheduledPaymentsForSettledBookingMutationVariables>(GenerateScheduledPaymentsForSettledBookingDocument, baseOptions);
      }
export type GenerateScheduledPaymentsForSettledBookingMutationHookResult = ReturnType<typeof useGenerateScheduledPaymentsForSettledBookingMutation>;
export type GenerateScheduledPaymentsForSettledBookingMutationResult = ApolloReactCommon.MutationResult<GenerateScheduledPaymentsForSettledBookingMutation>;
export type GenerateScheduledPaymentsForSettledBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateScheduledPaymentsForSettledBookingMutation, GenerateScheduledPaymentsForSettledBookingMutationVariables>;
export const AddNamedScheduledPaymentDocument = gql`
    mutation AddNamedScheduledPayment($addNamedScheduledPaymentInput: AddNamedScheduledPaymentInput!) {
  addNamedScheduledPayment(addNamedScheduledPaymentInput: $addNamedScheduledPaymentInput) {
    id
    paymentAmount
    openAmount
    paymentDue
    paymentDone
    paymentMethodId
    sepaClearance
  }
}
    `;
export type AddNamedScheduledPaymentMutationFn = ApolloReactCommon.MutationFunction<AddNamedScheduledPaymentMutation, AddNamedScheduledPaymentMutationVariables>;

/**
 * __useAddNamedScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useAddNamedScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNamedScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNamedScheduledPaymentMutation, { data, loading, error }] = useAddNamedScheduledPaymentMutation({
 *   variables: {
 *      addNamedScheduledPaymentInput: // value for 'addNamedScheduledPaymentInput'
 *   },
 * });
 */
export function useAddNamedScheduledPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNamedScheduledPaymentMutation, AddNamedScheduledPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddNamedScheduledPaymentMutation, AddNamedScheduledPaymentMutationVariables>(AddNamedScheduledPaymentDocument, baseOptions);
      }
export type AddNamedScheduledPaymentMutationHookResult = ReturnType<typeof useAddNamedScheduledPaymentMutation>;
export type AddNamedScheduledPaymentMutationResult = ApolloReactCommon.MutationResult<AddNamedScheduledPaymentMutation>;
export type AddNamedScheduledPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNamedScheduledPaymentMutation, AddNamedScheduledPaymentMutationVariables>;
export const UpdateSettledBookingDiscountDocument = gql`
    mutation UpdateSettledBookingDiscount($bookingId: ID!, $discount: Float, $discountName: String, $memberDiscount: Float, $creditedBalance: Float) {
  updateSettledBookingDiscount(bookingId: $bookingId, discount: $discount, discountName: $discountName, memberDiscount: $memberDiscount, creditedBalance: $creditedBalance) {
    id
    discount
    discountName
    memberDiscount
    creditedBalance
    grossPrice
    netPrice
    scheduledPayments {
      id
      paymentAmount
      openAmount
      paymentDone
      type
    }
  }
}
    `;
export type UpdateSettledBookingDiscountMutationFn = ApolloReactCommon.MutationFunction<UpdateSettledBookingDiscountMutation, UpdateSettledBookingDiscountMutationVariables>;

/**
 * __useUpdateSettledBookingDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateSettledBookingDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettledBookingDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettledBookingDiscountMutation, { data, loading, error }] = useUpdateSettledBookingDiscountMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      discount: // value for 'discount'
 *      discountName: // value for 'discountName'
 *      memberDiscount: // value for 'memberDiscount'
 *      creditedBalance: // value for 'creditedBalance'
 *   },
 * });
 */
export function useUpdateSettledBookingDiscountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSettledBookingDiscountMutation, UpdateSettledBookingDiscountMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSettledBookingDiscountMutation, UpdateSettledBookingDiscountMutationVariables>(UpdateSettledBookingDiscountDocument, baseOptions);
      }
export type UpdateSettledBookingDiscountMutationHookResult = ReturnType<typeof useUpdateSettledBookingDiscountMutation>;
export type UpdateSettledBookingDiscountMutationResult = ApolloReactCommon.MutationResult<UpdateSettledBookingDiscountMutation>;
export type UpdateSettledBookingDiscountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSettledBookingDiscountMutation, UpdateSettledBookingDiscountMutationVariables>;
export const GenerateScheduledPaymentsByCourseDocument = gql`
    mutation GenerateScheduledPaymentsByCourse($courseId: ID!, $attendeeId: ID, $omitMemberDiscount: Boolean, $creditedBalance: Float, $currentScheduledPayments: [ScheduledPaymentSimpleInput!], $paymentType: PaymentType, $memberDiscount: Float, $discount: Float, $additionalItemIds: [ID!], $discountCode: String) {
  generateScheduledPaymentsByCourse(courseId: $courseId, attendeeId: $attendeeId, omitMemberDiscount: $omitMemberDiscount, creditedBalance: $creditedBalance, currentScheduledPayments: $currentScheduledPayments, paymentType: $paymentType, memberDiscount: $memberDiscount, discount: $discount, additionalItemIds: $additionalItemIds, discountCode: $discountCode) {
    scheduledPayments {
      id
      paymentAmount
      paymentDue
      type
      title
      additionalItemId
      vat
    }
    grossPrice
    netPrice
    memberDiscount
    discountCode
    discount
    discountName
  }
}
    `;
export type GenerateScheduledPaymentsByCourseMutationFn = ApolloReactCommon.MutationFunction<GenerateScheduledPaymentsByCourseMutation, GenerateScheduledPaymentsByCourseMutationVariables>;

/**
 * __useGenerateScheduledPaymentsByCourseMutation__
 *
 * To run a mutation, you first call `useGenerateScheduledPaymentsByCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateScheduledPaymentsByCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateScheduledPaymentsByCourseMutation, { data, loading, error }] = useGenerateScheduledPaymentsByCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      attendeeId: // value for 'attendeeId'
 *      omitMemberDiscount: // value for 'omitMemberDiscount'
 *      creditedBalance: // value for 'creditedBalance'
 *      currentScheduledPayments: // value for 'currentScheduledPayments'
 *      paymentType: // value for 'paymentType'
 *      memberDiscount: // value for 'memberDiscount'
 *      discount: // value for 'discount'
 *      additionalItemIds: // value for 'additionalItemIds'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useGenerateScheduledPaymentsByCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateScheduledPaymentsByCourseMutation, GenerateScheduledPaymentsByCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateScheduledPaymentsByCourseMutation, GenerateScheduledPaymentsByCourseMutationVariables>(GenerateScheduledPaymentsByCourseDocument, baseOptions);
      }
export type GenerateScheduledPaymentsByCourseMutationHookResult = ReturnType<typeof useGenerateScheduledPaymentsByCourseMutation>;
export type GenerateScheduledPaymentsByCourseMutationResult = ApolloReactCommon.MutationResult<GenerateScheduledPaymentsByCourseMutation>;
export type GenerateScheduledPaymentsByCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateScheduledPaymentsByCourseMutation, GenerateScheduledPaymentsByCourseMutationVariables>;
export const GetScheduledPaymentsWithMissingInvoiceIdsDocument = gql`
    query GetScheduledPaymentsWithMissingInvoiceIds {
  scheduledPaymentsWithMissingInvoiceIds {
    id
    bookingId
    paymentAmount
    paymentDue
    invoiceId
    booking {
      id
      bookingNumber
      bookingNumberPrefix
      courseLessons {
        course {
          prefixedCourseNumber
        }
      }
    }
  }
}
    `;

/**
 * __useGetScheduledPaymentsWithMissingInvoiceIdsQuery__
 *
 * To run a query within a React component, call `useGetScheduledPaymentsWithMissingInvoiceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPaymentsWithMissingInvoiceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPaymentsWithMissingInvoiceIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScheduledPaymentsWithMissingInvoiceIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduledPaymentsWithMissingInvoiceIdsQuery, GetScheduledPaymentsWithMissingInvoiceIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetScheduledPaymentsWithMissingInvoiceIdsQuery, GetScheduledPaymentsWithMissingInvoiceIdsQueryVariables>(GetScheduledPaymentsWithMissingInvoiceIdsDocument, baseOptions);
      }
export function useGetScheduledPaymentsWithMissingInvoiceIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduledPaymentsWithMissingInvoiceIdsQuery, GetScheduledPaymentsWithMissingInvoiceIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetScheduledPaymentsWithMissingInvoiceIdsQuery, GetScheduledPaymentsWithMissingInvoiceIdsQueryVariables>(GetScheduledPaymentsWithMissingInvoiceIdsDocument, baseOptions);
        }
export type GetScheduledPaymentsWithMissingInvoiceIdsQueryHookResult = ReturnType<typeof useGetScheduledPaymentsWithMissingInvoiceIdsQuery>;
export type GetScheduledPaymentsWithMissingInvoiceIdsLazyQueryHookResult = ReturnType<typeof useGetScheduledPaymentsWithMissingInvoiceIdsLazyQuery>;
export type GetScheduledPaymentsWithMissingInvoiceIdsQueryResult = ApolloReactCommon.QueryResult<GetScheduledPaymentsWithMissingInvoiceIdsQuery, GetScheduledPaymentsWithMissingInvoiceIdsQueryVariables>;
export const FixMissingInvoiceIdsDocument = gql`
    mutation FixMissingInvoiceIds($scheduledPaymentIds: [ID!]) {
  fixMissingInvoiceIds(scheduledPaymentIds: $scheduledPaymentIds)
}
    `;
export type FixMissingInvoiceIdsMutationFn = ApolloReactCommon.MutationFunction<FixMissingInvoiceIdsMutation, FixMissingInvoiceIdsMutationVariables>;

/**
 * __useFixMissingInvoiceIdsMutation__
 *
 * To run a mutation, you first call `useFixMissingInvoiceIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFixMissingInvoiceIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fixMissingInvoiceIdsMutation, { data, loading, error }] = useFixMissingInvoiceIdsMutation({
 *   variables: {
 *      scheduledPaymentIds: // value for 'scheduledPaymentIds'
 *   },
 * });
 */
export function useFixMissingInvoiceIdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FixMissingInvoiceIdsMutation, FixMissingInvoiceIdsMutationVariables>) {
        return ApolloReactHooks.useMutation<FixMissingInvoiceIdsMutation, FixMissingInvoiceIdsMutationVariables>(FixMissingInvoiceIdsDocument, baseOptions);
      }
export type FixMissingInvoiceIdsMutationHookResult = ReturnType<typeof useFixMissingInvoiceIdsMutation>;
export type FixMissingInvoiceIdsMutationResult = ApolloReactCommon.MutationResult<FixMissingInvoiceIdsMutation>;
export type FixMissingInvoiceIdsMutationOptions = ApolloReactCommon.BaseMutationOptions<FixMissingInvoiceIdsMutation, FixMissingInvoiceIdsMutationVariables>;
export const ClearManuallyAdjustedDocument = gql`
    mutation ClearManuallyAdjusted($id: String!) {
  clearManuallyAdjusted(id: $id) {
    id
    manuallyAdjustedAt
    manuallyAdjustedByUserId
    paymentAmount
    paymentDue
  }
}
    `;
export type ClearManuallyAdjustedMutationFn = ApolloReactCommon.MutationFunction<ClearManuallyAdjustedMutation, ClearManuallyAdjustedMutationVariables>;

/**
 * __useClearManuallyAdjustedMutation__
 *
 * To run a mutation, you first call `useClearManuallyAdjustedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearManuallyAdjustedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearManuallyAdjustedMutation, { data, loading, error }] = useClearManuallyAdjustedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearManuallyAdjustedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClearManuallyAdjustedMutation, ClearManuallyAdjustedMutationVariables>) {
        return ApolloReactHooks.useMutation<ClearManuallyAdjustedMutation, ClearManuallyAdjustedMutationVariables>(ClearManuallyAdjustedDocument, baseOptions);
      }
export type ClearManuallyAdjustedMutationHookResult = ReturnType<typeof useClearManuallyAdjustedMutation>;
export type ClearManuallyAdjustedMutationResult = ApolloReactCommon.MutationResult<ClearManuallyAdjustedMutation>;
export type ClearManuallyAdjustedMutationOptions = ApolloReactCommon.BaseMutationOptions<ClearManuallyAdjustedMutation, ClearManuallyAdjustedMutationVariables>;
export const RestoreScheduledPaymentDocument = gql`
    mutation RestoreScheduledPayment($id: String!) {
  restoreScheduledPayment(id: $id) {
    id
    deletedAt
    deletedByUserId
    paymentAmount
    paymentDue
  }
}
    `;
export type RestoreScheduledPaymentMutationFn = ApolloReactCommon.MutationFunction<RestoreScheduledPaymentMutation, RestoreScheduledPaymentMutationVariables>;

/**
 * __useRestoreScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useRestoreScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreScheduledPaymentMutation, { data, loading, error }] = useRestoreScheduledPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreScheduledPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreScheduledPaymentMutation, RestoreScheduledPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<RestoreScheduledPaymentMutation, RestoreScheduledPaymentMutationVariables>(RestoreScheduledPaymentDocument, baseOptions);
      }
export type RestoreScheduledPaymentMutationHookResult = ReturnType<typeof useRestoreScheduledPaymentMutation>;
export type RestoreScheduledPaymentMutationResult = ApolloReactCommon.MutationResult<RestoreScheduledPaymentMutation>;
export type RestoreScheduledPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<RestoreScheduledPaymentMutation, RestoreScheduledPaymentMutationVariables>;
export const CreateSepaXmlByIdDocument = gql`
    mutation createSepaXmlById($createSingleSepaXmlInput: CreateSingleSepaXmlInput!) {
  createSepaXmlById(createSingleSepaXmlInput: $createSingleSepaXmlInput)
}
    `;
export type CreateSepaXmlByIdMutationFn = ApolloReactCommon.MutationFunction<CreateSepaXmlByIdMutation, CreateSepaXmlByIdMutationVariables>;

/**
 * __useCreateSepaXmlByIdMutation__
 *
 * To run a mutation, you first call `useCreateSepaXmlByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSepaXmlByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSepaXmlByIdMutation, { data, loading, error }] = useCreateSepaXmlByIdMutation({
 *   variables: {
 *      createSingleSepaXmlInput: // value for 'createSingleSepaXmlInput'
 *   },
 * });
 */
export function useCreateSepaXmlByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSepaXmlByIdMutation, CreateSepaXmlByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSepaXmlByIdMutation, CreateSepaXmlByIdMutationVariables>(CreateSepaXmlByIdDocument, baseOptions);
      }
export type CreateSepaXmlByIdMutationHookResult = ReturnType<typeof useCreateSepaXmlByIdMutation>;
export type CreateSepaXmlByIdMutationResult = ApolloReactCommon.MutationResult<CreateSepaXmlByIdMutation>;
export type CreateSepaXmlByIdMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSepaXmlByIdMutation, CreateSepaXmlByIdMutationVariables>;
export const CreateSepaXmlByTimeRangeDocument = gql`
    mutation createSepaXmlByTimeRange($createSepaXmlByTimeRangeInput: CreateSepaXmlByTimeRangeInput!) {
  createSepaXmlByTimeRange(createSepaXmlByTimeRangeInput: $createSepaXmlByTimeRangeInput)
}
    `;
export type CreateSepaXmlByTimeRangeMutationFn = ApolloReactCommon.MutationFunction<CreateSepaXmlByTimeRangeMutation, CreateSepaXmlByTimeRangeMutationVariables>;

/**
 * __useCreateSepaXmlByTimeRangeMutation__
 *
 * To run a mutation, you first call `useCreateSepaXmlByTimeRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSepaXmlByTimeRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSepaXmlByTimeRangeMutation, { data, loading, error }] = useCreateSepaXmlByTimeRangeMutation({
 *   variables: {
 *      createSepaXmlByTimeRangeInput: // value for 'createSepaXmlByTimeRangeInput'
 *   },
 * });
 */
export function useCreateSepaXmlByTimeRangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSepaXmlByTimeRangeMutation, CreateSepaXmlByTimeRangeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSepaXmlByTimeRangeMutation, CreateSepaXmlByTimeRangeMutationVariables>(CreateSepaXmlByTimeRangeDocument, baseOptions);
      }
export type CreateSepaXmlByTimeRangeMutationHookResult = ReturnType<typeof useCreateSepaXmlByTimeRangeMutation>;
export type CreateSepaXmlByTimeRangeMutationResult = ApolloReactCommon.MutationResult<CreateSepaXmlByTimeRangeMutation>;
export type CreateSepaXmlByTimeRangeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSepaXmlByTimeRangeMutation, CreateSepaXmlByTimeRangeMutationVariables>;
export const GetBankDataDocument = gql`
    query getBankData($iban: String!) {
  getBankData(iban: $iban)
}
    `;

/**
 * __useGetBankDataQuery__
 *
 * To run a query within a React component, call `useGetBankDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankDataQuery({
 *   variables: {
 *      iban: // value for 'iban'
 *   },
 * });
 */
export function useGetBankDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBankDataQuery, GetBankDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBankDataQuery, GetBankDataQueryVariables>(GetBankDataDocument, baseOptions);
      }
export function useGetBankDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBankDataQuery, GetBankDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBankDataQuery, GetBankDataQueryVariables>(GetBankDataDocument, baseOptions);
        }
export type GetBankDataQueryHookResult = ReturnType<typeof useGetBankDataQuery>;
export type GetBankDataLazyQueryHookResult = ReturnType<typeof useGetBankDataLazyQuery>;
export type GetBankDataQueryResult = ApolloReactCommon.QueryResult<GetBankDataQuery, GetBankDataQueryVariables>;
export const GetRestrictiveBookingsByCourseIdDocument = gql`
    query GetRestrictiveBookingsByCourseId($courseId: String!) {
  getBookingRestrictionByCourseId(courseId: $courseId) {
    id
    courseId
    active
    visibleForAll
    blockedPlaces
    startDateTime
    endDateTime
    includeWaitingList
    includeBookingList
    membersOnly
    allowWaitlistWithoutPrerequisite
    prerequisiteCourses {
      id
    }
    expireAction
  }
}
    `;

/**
 * __useGetRestrictiveBookingsByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetRestrictiveBookingsByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestrictiveBookingsByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestrictiveBookingsByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetRestrictiveBookingsByCourseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRestrictiveBookingsByCourseIdQuery, GetRestrictiveBookingsByCourseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRestrictiveBookingsByCourseIdQuery, GetRestrictiveBookingsByCourseIdQueryVariables>(GetRestrictiveBookingsByCourseIdDocument, baseOptions);
      }
export function useGetRestrictiveBookingsByCourseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRestrictiveBookingsByCourseIdQuery, GetRestrictiveBookingsByCourseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRestrictiveBookingsByCourseIdQuery, GetRestrictiveBookingsByCourseIdQueryVariables>(GetRestrictiveBookingsByCourseIdDocument, baseOptions);
        }
export type GetRestrictiveBookingsByCourseIdQueryHookResult = ReturnType<typeof useGetRestrictiveBookingsByCourseIdQuery>;
export type GetRestrictiveBookingsByCourseIdLazyQueryHookResult = ReturnType<typeof useGetRestrictiveBookingsByCourseIdLazyQuery>;
export type GetRestrictiveBookingsByCourseIdQueryResult = ApolloReactCommon.QueryResult<GetRestrictiveBookingsByCourseIdQuery, GetRestrictiveBookingsByCourseIdQueryVariables>;
export const CreateBookingRestrictionDocument = gql`
    mutation CreateBookingRestriction($newBookingRestrictionInput: NewBookingRestrictionInput!) {
  createBookingRestriction(newBookingRestrictionInput: $newBookingRestrictionInput) {
    id
    active
    visibleForAll
    blockedPlaces
    startDateTime
    endDateTime
    includeWaitingList
    includeBookingList
    membersOnly
    allowWaitlistWithoutPrerequisite
    prerequisiteCourses {
      id
    }
    expireAction
  }
}
    `;
export type CreateBookingRestrictionMutationFn = ApolloReactCommon.MutationFunction<CreateBookingRestrictionMutation, CreateBookingRestrictionMutationVariables>;

/**
 * __useCreateBookingRestrictionMutation__
 *
 * To run a mutation, you first call `useCreateBookingRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingRestrictionMutation, { data, loading, error }] = useCreateBookingRestrictionMutation({
 *   variables: {
 *      newBookingRestrictionInput: // value for 'newBookingRestrictionInput'
 *   },
 * });
 */
export function useCreateBookingRestrictionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookingRestrictionMutation, CreateBookingRestrictionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBookingRestrictionMutation, CreateBookingRestrictionMutationVariables>(CreateBookingRestrictionDocument, baseOptions);
      }
export type CreateBookingRestrictionMutationHookResult = ReturnType<typeof useCreateBookingRestrictionMutation>;
export type CreateBookingRestrictionMutationResult = ApolloReactCommon.MutationResult<CreateBookingRestrictionMutation>;
export type CreateBookingRestrictionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBookingRestrictionMutation, CreateBookingRestrictionMutationVariables>;
export const UpdateBookingRestrictionDocument = gql`
    mutation UpdateBookingRestriction($updateBookingRestrictionInput: UpdateBookingRestrictionInput!) {
  updateBookingRestriction(updateBookingRestrictionInput: $updateBookingRestrictionInput) {
    id
    active
    visibleForAll
    blockedPlaces
    startDateTime
    endDateTime
    includeWaitingList
    includeBookingList
    membersOnly
    allowWaitlistWithoutPrerequisite
    prerequisiteCourses {
      id
    }
    expireAction
  }
}
    `;
export type UpdateBookingRestrictionMutationFn = ApolloReactCommon.MutationFunction<UpdateBookingRestrictionMutation, UpdateBookingRestrictionMutationVariables>;

/**
 * __useUpdateBookingRestrictionMutation__
 *
 * To run a mutation, you first call `useUpdateBookingRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingRestrictionMutation, { data, loading, error }] = useUpdateBookingRestrictionMutation({
 *   variables: {
 *      updateBookingRestrictionInput: // value for 'updateBookingRestrictionInput'
 *   },
 * });
 */
export function useUpdateBookingRestrictionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookingRestrictionMutation, UpdateBookingRestrictionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookingRestrictionMutation, UpdateBookingRestrictionMutationVariables>(UpdateBookingRestrictionDocument, baseOptions);
      }
export type UpdateBookingRestrictionMutationHookResult = ReturnType<typeof useUpdateBookingRestrictionMutation>;
export type UpdateBookingRestrictionMutationResult = ApolloReactCommon.MutationResult<UpdateBookingRestrictionMutation>;
export type UpdateBookingRestrictionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookingRestrictionMutation, UpdateBookingRestrictionMutationVariables>;
export const DeleteBookingRestrictionDocument = gql`
    mutation DeleteBookingRestriction($bookingRestrictionId: String!) {
  deleteBookingRestriction(bookingRestrictionId: $bookingRestrictionId)
}
    `;
export type DeleteBookingRestrictionMutationFn = ApolloReactCommon.MutationFunction<DeleteBookingRestrictionMutation, DeleteBookingRestrictionMutationVariables>;

/**
 * __useDeleteBookingRestrictionMutation__
 *
 * To run a mutation, you first call `useDeleteBookingRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingRestrictionMutation, { data, loading, error }] = useDeleteBookingRestrictionMutation({
 *   variables: {
 *      bookingRestrictionId: // value for 'bookingRestrictionId'
 *   },
 * });
 */
export function useDeleteBookingRestrictionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBookingRestrictionMutation, DeleteBookingRestrictionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBookingRestrictionMutation, DeleteBookingRestrictionMutationVariables>(DeleteBookingRestrictionDocument, baseOptions);
      }
export type DeleteBookingRestrictionMutationHookResult = ReturnType<typeof useDeleteBookingRestrictionMutation>;
export type DeleteBookingRestrictionMutationResult = ApolloReactCommon.MutationResult<DeleteBookingRestrictionMutation>;
export type DeleteBookingRestrictionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBookingRestrictionMutation, DeleteBookingRestrictionMutationVariables>;
export const AddBookableCoursesDocument = gql`
    mutation AddBookableCourses($prerequisiteCourseId: String!, $bookableCourseIds: [String!]!) {
  addBookableCourses(prerequisiteCourseId: $prerequisiteCourseId, bookableCourseIds: $bookableCourseIds)
}
    `;
export type AddBookableCoursesMutationFn = ApolloReactCommon.MutationFunction<AddBookableCoursesMutation, AddBookableCoursesMutationVariables>;

/**
 * __useAddBookableCoursesMutation__
 *
 * To run a mutation, you first call `useAddBookableCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBookableCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBookableCoursesMutation, { data, loading, error }] = useAddBookableCoursesMutation({
 *   variables: {
 *      prerequisiteCourseId: // value for 'prerequisiteCourseId'
 *      bookableCourseIds: // value for 'bookableCourseIds'
 *   },
 * });
 */
export function useAddBookableCoursesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddBookableCoursesMutation, AddBookableCoursesMutationVariables>) {
        return ApolloReactHooks.useMutation<AddBookableCoursesMutation, AddBookableCoursesMutationVariables>(AddBookableCoursesDocument, baseOptions);
      }
export type AddBookableCoursesMutationHookResult = ReturnType<typeof useAddBookableCoursesMutation>;
export type AddBookableCoursesMutationResult = ApolloReactCommon.MutationResult<AddBookableCoursesMutation>;
export type AddBookableCoursesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddBookableCoursesMutation, AddBookableCoursesMutationVariables>;
export const RemoveBookableCourseDocument = gql`
    mutation RemoveBookableCourse($bookableCourseId: String!, $prerquisiteCourseId: String!) {
  removeBookableCourse(bookableCourseId: $bookableCourseId, prerquisiteCourseId: $prerquisiteCourseId)
}
    `;
export type RemoveBookableCourseMutationFn = ApolloReactCommon.MutationFunction<RemoveBookableCourseMutation, RemoveBookableCourseMutationVariables>;

/**
 * __useRemoveBookableCourseMutation__
 *
 * To run a mutation, you first call `useRemoveBookableCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookableCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookableCourseMutation, { data, loading, error }] = useRemoveBookableCourseMutation({
 *   variables: {
 *      bookableCourseId: // value for 'bookableCourseId'
 *      prerquisiteCourseId: // value for 'prerquisiteCourseId'
 *   },
 * });
 */
export function useRemoveBookableCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBookableCourseMutation, RemoveBookableCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveBookableCourseMutation, RemoveBookableCourseMutationVariables>(RemoveBookableCourseDocument, baseOptions);
      }
export type RemoveBookableCourseMutationHookResult = ReturnType<typeof useRemoveBookableCourseMutation>;
export type RemoveBookableCourseMutationResult = ApolloReactCommon.MutationResult<RemoveBookableCourseMutation>;
export type RemoveBookableCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveBookableCourseMutation, RemoveBookableCourseMutationVariables>;
export const Ko9TestConnectionDocument = gql`
    mutation Ko9TestConnection($credentials: Ko9DbCredentialsInput!) {
  ko9TestConnection(credentials: $credentials) {
    success
    error
  }
}
    `;
export type Ko9TestConnectionMutationFn = ApolloReactCommon.MutationFunction<Ko9TestConnectionMutation, Ko9TestConnectionMutationVariables>;

/**
 * __useKo9TestConnectionMutation__
 *
 * To run a mutation, you first call `useKo9TestConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKo9TestConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ko9TestConnectionMutation, { data, loading, error }] = useKo9TestConnectionMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useKo9TestConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Ko9TestConnectionMutation, Ko9TestConnectionMutationVariables>) {
        return ApolloReactHooks.useMutation<Ko9TestConnectionMutation, Ko9TestConnectionMutationVariables>(Ko9TestConnectionDocument, baseOptions);
      }
export type Ko9TestConnectionMutationHookResult = ReturnType<typeof useKo9TestConnectionMutation>;
export type Ko9TestConnectionMutationResult = ApolloReactCommon.MutationResult<Ko9TestConnectionMutation>;
export type Ko9TestConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<Ko9TestConnectionMutation, Ko9TestConnectionMutationVariables>;
export const Ko9DetectSchemaDocument = gql`
    mutation Ko9DetectSchema($credentials: Ko9DbCredentialsInput!) {
  ko9DetectSchema(credentials: $credentials) {
    hasKinder
    hasTeilnehmer
    hasAdressen
    hasKonto
    hasAbzeichen
    hasTeilnahme
    hasKursBezeichnungen
    hasKursstandorte
    allTables
  }
}
    `;
export type Ko9DetectSchemaMutationFn = ApolloReactCommon.MutationFunction<Ko9DetectSchemaMutation, Ko9DetectSchemaMutationVariables>;

/**
 * __useKo9DetectSchemaMutation__
 *
 * To run a mutation, you first call `useKo9DetectSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKo9DetectSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ko9DetectSchemaMutation, { data, loading, error }] = useKo9DetectSchemaMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useKo9DetectSchemaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Ko9DetectSchemaMutation, Ko9DetectSchemaMutationVariables>) {
        return ApolloReactHooks.useMutation<Ko9DetectSchemaMutation, Ko9DetectSchemaMutationVariables>(Ko9DetectSchemaDocument, baseOptions);
      }
export type Ko9DetectSchemaMutationHookResult = ReturnType<typeof useKo9DetectSchemaMutation>;
export type Ko9DetectSchemaMutationResult = ApolloReactCommon.MutationResult<Ko9DetectSchemaMutation>;
export type Ko9DetectSchemaMutationOptions = ApolloReactCommon.BaseMutationOptions<Ko9DetectSchemaMutation, Ko9DetectSchemaMutationVariables>;
export const Ko9FetchPreviewDocument = gql`
    mutation Ko9FetchPreview($credentials: Ko9DbCredentialsInput!, $config: Ko9ImportConfigInput!, $limit: Int) {
  ko9FetchPreview(credentials: $credentials, config: $config, limit: $limit) {
    totalRows
    totalBookers
    totalAttendees
    previewRows {
      bookerName
      email
      attendeeName
      birthday
      city
      sepaInfo
      badgesCount
      bookingsCount
    }
    schema {
      hasKinder
      hasTeilnehmer
      hasAdressen
      hasKonto
      hasAbzeichen
      hasTeilnahme
      hasKursBezeichnungen
      hasKursstandorte
      allTables
    }
  }
}
    `;
export type Ko9FetchPreviewMutationFn = ApolloReactCommon.MutationFunction<Ko9FetchPreviewMutation, Ko9FetchPreviewMutationVariables>;

/**
 * __useKo9FetchPreviewMutation__
 *
 * To run a mutation, you first call `useKo9FetchPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKo9FetchPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ko9FetchPreviewMutation, { data, loading, error }] = useKo9FetchPreviewMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *      config: // value for 'config'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useKo9FetchPreviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Ko9FetchPreviewMutation, Ko9FetchPreviewMutationVariables>) {
        return ApolloReactHooks.useMutation<Ko9FetchPreviewMutation, Ko9FetchPreviewMutationVariables>(Ko9FetchPreviewDocument, baseOptions);
      }
export type Ko9FetchPreviewMutationHookResult = ReturnType<typeof useKo9FetchPreviewMutation>;
export type Ko9FetchPreviewMutationResult = ApolloReactCommon.MutationResult<Ko9FetchPreviewMutation>;
export type Ko9FetchPreviewMutationOptions = ApolloReactCommon.BaseMutationOptions<Ko9FetchPreviewMutation, Ko9FetchPreviewMutationVariables>;
export const Ko9DryRunDocument = gql`
    mutation Ko9DryRun($credentials: Ko9DbCredentialsInput!, $config: Ko9ImportConfigInput!) {
  ko9DryRun(credentials: $credentials, config: $config)
}
    `;
export type Ko9DryRunMutationFn = ApolloReactCommon.MutationFunction<Ko9DryRunMutation, Ko9DryRunMutationVariables>;

/**
 * __useKo9DryRunMutation__
 *
 * To run a mutation, you first call `useKo9DryRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKo9DryRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ko9DryRunMutation, { data, loading, error }] = useKo9DryRunMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useKo9DryRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Ko9DryRunMutation, Ko9DryRunMutationVariables>) {
        return ApolloReactHooks.useMutation<Ko9DryRunMutation, Ko9DryRunMutationVariables>(Ko9DryRunDocument, baseOptions);
      }
export type Ko9DryRunMutationHookResult = ReturnType<typeof useKo9DryRunMutation>;
export type Ko9DryRunMutationResult = ApolloReactCommon.MutationResult<Ko9DryRunMutation>;
export type Ko9DryRunMutationOptions = ApolloReactCommon.BaseMutationOptions<Ko9DryRunMutation, Ko9DryRunMutationVariables>;
export const Ko9ExecuteImportDocument = gql`
    mutation Ko9ExecuteImport($credentials: Ko9DbCredentialsInput!, $config: Ko9ImportConfigInput!) {
  ko9ExecuteImport(credentials: $credentials, config: $config)
}
    `;
export type Ko9ExecuteImportMutationFn = ApolloReactCommon.MutationFunction<Ko9ExecuteImportMutation, Ko9ExecuteImportMutationVariables>;

/**
 * __useKo9ExecuteImportMutation__
 *
 * To run a mutation, you first call `useKo9ExecuteImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKo9ExecuteImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ko9ExecuteImportMutation, { data, loading, error }] = useKo9ExecuteImportMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useKo9ExecuteImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Ko9ExecuteImportMutation, Ko9ExecuteImportMutationVariables>) {
        return ApolloReactHooks.useMutation<Ko9ExecuteImportMutation, Ko9ExecuteImportMutationVariables>(Ko9ExecuteImportDocument, baseOptions);
      }
export type Ko9ExecuteImportMutationHookResult = ReturnType<typeof useKo9ExecuteImportMutation>;
export type Ko9ExecuteImportMutationResult = ApolloReactCommon.MutationResult<Ko9ExecuteImportMutation>;
export type Ko9ExecuteImportMutationOptions = ApolloReactCommon.BaseMutationOptions<Ko9ExecuteImportMutation, Ko9ExecuteImportMutationVariables>;
export const Ko9SaveCredentialsDocument = gql`
    mutation Ko9SaveCredentials($credentials: Ko9DbCredentialsInput!) {
  ko9SaveCredentials(credentials: $credentials) {
    success
  }
}
    `;
export type Ko9SaveCredentialsMutationFn = ApolloReactCommon.MutationFunction<Ko9SaveCredentialsMutation, Ko9SaveCredentialsMutationVariables>;

/**
 * __useKo9SaveCredentialsMutation__
 *
 * To run a mutation, you first call `useKo9SaveCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKo9SaveCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ko9SaveCredentialsMutation, { data, loading, error }] = useKo9SaveCredentialsMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useKo9SaveCredentialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Ko9SaveCredentialsMutation, Ko9SaveCredentialsMutationVariables>) {
        return ApolloReactHooks.useMutation<Ko9SaveCredentialsMutation, Ko9SaveCredentialsMutationVariables>(Ko9SaveCredentialsDocument, baseOptions);
      }
export type Ko9SaveCredentialsMutationHookResult = ReturnType<typeof useKo9SaveCredentialsMutation>;
export type Ko9SaveCredentialsMutationResult = ApolloReactCommon.MutationResult<Ko9SaveCredentialsMutation>;
export type Ko9SaveCredentialsMutationOptions = ApolloReactCommon.BaseMutationOptions<Ko9SaveCredentialsMutation, Ko9SaveCredentialsMutationVariables>;
export const Ko9LoadCredentialsDocument = gql`
    query Ko9LoadCredentials {
  ko9LoadCredentials {
    host
    port
    user
    database
  }
}
    `;

/**
 * __useKo9LoadCredentialsQuery__
 *
 * To run a query within a React component, call `useKo9LoadCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKo9LoadCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKo9LoadCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKo9LoadCredentialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Ko9LoadCredentialsQuery, Ko9LoadCredentialsQueryVariables>) {
        return ApolloReactHooks.useQuery<Ko9LoadCredentialsQuery, Ko9LoadCredentialsQueryVariables>(Ko9LoadCredentialsDocument, baseOptions);
      }
export function useKo9LoadCredentialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Ko9LoadCredentialsQuery, Ko9LoadCredentialsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<Ko9LoadCredentialsQuery, Ko9LoadCredentialsQueryVariables>(Ko9LoadCredentialsDocument, baseOptions);
        }
export type Ko9LoadCredentialsQueryHookResult = ReturnType<typeof useKo9LoadCredentialsQuery>;
export type Ko9LoadCredentialsLazyQueryHookResult = ReturnType<typeof useKo9LoadCredentialsLazyQuery>;
export type Ko9LoadCredentialsQueryResult = ApolloReactCommon.QueryResult<Ko9LoadCredentialsQuery, Ko9LoadCredentialsQueryVariables>;
export const Ko9ImportProgressDocument = gql`
    query Ko9ImportProgress {
  ko9ImportProgress {
    phase
    totalBookers
    importedBookers
    totalAttendees
    importedAttendees
    skippedBookers
    errorMessage
    result
  }
}
    `;

/**
 * __useKo9ImportProgressQuery__
 *
 * To run a query within a React component, call `useKo9ImportProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useKo9ImportProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKo9ImportProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useKo9ImportProgressQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Ko9ImportProgressQuery, Ko9ImportProgressQueryVariables>) {
        return ApolloReactHooks.useQuery<Ko9ImportProgressQuery, Ko9ImportProgressQueryVariables>(Ko9ImportProgressDocument, baseOptions);
      }
export function useKo9ImportProgressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Ko9ImportProgressQuery, Ko9ImportProgressQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<Ko9ImportProgressQuery, Ko9ImportProgressQueryVariables>(Ko9ImportProgressDocument, baseOptions);
        }
export type Ko9ImportProgressQueryHookResult = ReturnType<typeof useKo9ImportProgressQuery>;
export type Ko9ImportProgressLazyQueryHookResult = ReturnType<typeof useKo9ImportProgressLazyQuery>;
export type Ko9ImportProgressQueryResult = ApolloReactCommon.QueryResult<Ko9ImportProgressQuery, Ko9ImportProgressQueryVariables>;
export const Ko9RollbackImportDocument = gql`
    mutation Ko9RollbackImport($bookerIds: [String!]!) {
  ko9RollbackImport(bookerIds: $bookerIds) {
    success
    deletedBookers
    deletedAttendees
    deletedPaymentMethods
    error
  }
}
    `;
export type Ko9RollbackImportMutationFn = ApolloReactCommon.MutationFunction<Ko9RollbackImportMutation, Ko9RollbackImportMutationVariables>;

/**
 * __useKo9RollbackImportMutation__
 *
 * To run a mutation, you first call `useKo9RollbackImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKo9RollbackImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ko9RollbackImportMutation, { data, loading, error }] = useKo9RollbackImportMutation({
 *   variables: {
 *      bookerIds: // value for 'bookerIds'
 *   },
 * });
 */
export function useKo9RollbackImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Ko9RollbackImportMutation, Ko9RollbackImportMutationVariables>) {
        return ApolloReactHooks.useMutation<Ko9RollbackImportMutation, Ko9RollbackImportMutationVariables>(Ko9RollbackImportDocument, baseOptions);
      }
export type Ko9RollbackImportMutationHookResult = ReturnType<typeof useKo9RollbackImportMutation>;
export type Ko9RollbackImportMutationResult = ApolloReactCommon.MutationResult<Ko9RollbackImportMutation>;
export type Ko9RollbackImportMutationOptions = ApolloReactCommon.BaseMutationOptions<Ko9RollbackImportMutation, Ko9RollbackImportMutationVariables>;
export const GetBookerAndAttendeeCountDocument = gql`
    query GetBookerAndAttendeeCount {
  getBookerAndAttendeeCount {
    bookerCount
    attendeeCount
  }
}
    `;

/**
 * __useGetBookerAndAttendeeCountQuery__
 *
 * To run a query within a React component, call `useGetBookerAndAttendeeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookerAndAttendeeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookerAndAttendeeCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookerAndAttendeeCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookerAndAttendeeCountQuery, GetBookerAndAttendeeCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookerAndAttendeeCountQuery, GetBookerAndAttendeeCountQueryVariables>(GetBookerAndAttendeeCountDocument, baseOptions);
      }
export function useGetBookerAndAttendeeCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookerAndAttendeeCountQuery, GetBookerAndAttendeeCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookerAndAttendeeCountQuery, GetBookerAndAttendeeCountQueryVariables>(GetBookerAndAttendeeCountDocument, baseOptions);
        }
export type GetBookerAndAttendeeCountQueryHookResult = ReturnType<typeof useGetBookerAndAttendeeCountQuery>;
export type GetBookerAndAttendeeCountLazyQueryHookResult = ReturnType<typeof useGetBookerAndAttendeeCountLazyQuery>;
export type GetBookerAndAttendeeCountQueryResult = ApolloReactCommon.QueryResult<GetBookerAndAttendeeCountQuery, GetBookerAndAttendeeCountQueryVariables>;
export const BookerDeletionProgressDocument = gql`
    query BookerDeletionProgress {
  bookerDeletionProgress {
    phase
    totalBookers
    deletedBookers
    totalAttendees
    deletedAttendees
    errorMessage
  }
}
    `;

/**
 * __useBookerDeletionProgressQuery__
 *
 * To run a query within a React component, call `useBookerDeletionProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerDeletionProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerDeletionProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookerDeletionProgressQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookerDeletionProgressQuery, BookerDeletionProgressQueryVariables>) {
        return ApolloReactHooks.useQuery<BookerDeletionProgressQuery, BookerDeletionProgressQueryVariables>(BookerDeletionProgressDocument, baseOptions);
      }
export function useBookerDeletionProgressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookerDeletionProgressQuery, BookerDeletionProgressQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookerDeletionProgressQuery, BookerDeletionProgressQueryVariables>(BookerDeletionProgressDocument, baseOptions);
        }
export type BookerDeletionProgressQueryHookResult = ReturnType<typeof useBookerDeletionProgressQuery>;
export type BookerDeletionProgressLazyQueryHookResult = ReturnType<typeof useBookerDeletionProgressLazyQuery>;
export type BookerDeletionProgressQueryResult = ApolloReactCommon.QueryResult<BookerDeletionProgressQuery, BookerDeletionProgressQueryVariables>;
export const GetAnnouncementsDocument = gql`
    query GetAnnouncements($input: GetAnnouncementsInput) {
  announcements(input: $input) {
    id
    title
    message
    type
    priority
    isActive
    validFrom
    validUntil
    isDismissible
    isMinimizable
    koOrganizationId
    targetUrl
    targetUrlLabel
    createDate
    updateDate
    createdByUserId
    updatedByUserId
  }
}
    `;

/**
 * __useGetAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAnnouncementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, baseOptions);
      }
export function useGetAnnouncementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, baseOptions);
        }
export type GetAnnouncementsQueryHookResult = ReturnType<typeof useGetAnnouncementsQuery>;
export type GetAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsLazyQuery>;
export type GetAnnouncementsQueryResult = ApolloReactCommon.QueryResult<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>;
export const GetActiveAnnouncementsDocument = gql`
    query GetActiveAnnouncements {
  activeAnnouncements {
    id
    title
    message
    type
    priority
    isActive
    validFrom
    validUntil
    isDismissible
    isMinimizable
    koOrganizationId
    targetUrl
    targetUrlLabel
    createDate
  }
}
    `;

/**
 * __useGetActiveAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetActiveAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveAnnouncementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveAnnouncementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActiveAnnouncementsQuery, GetActiveAnnouncementsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetActiveAnnouncementsQuery, GetActiveAnnouncementsQueryVariables>(GetActiveAnnouncementsDocument, baseOptions);
      }
export function useGetActiveAnnouncementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveAnnouncementsQuery, GetActiveAnnouncementsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetActiveAnnouncementsQuery, GetActiveAnnouncementsQueryVariables>(GetActiveAnnouncementsDocument, baseOptions);
        }
export type GetActiveAnnouncementsQueryHookResult = ReturnType<typeof useGetActiveAnnouncementsQuery>;
export type GetActiveAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetActiveAnnouncementsLazyQuery>;
export type GetActiveAnnouncementsQueryResult = ApolloReactCommon.QueryResult<GetActiveAnnouncementsQuery, GetActiveAnnouncementsQueryVariables>;
export const CreateAnnouncementDocument = gql`
    mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    id
    title
    message
    type
    priority
    isActive
    validFrom
    validUntil
    isDismissible
    isMinimizable
    koOrganizationId
    targetUrl
    targetUrlLabel
  }
}
    `;
export type CreateAnnouncementMutationFn = ApolloReactCommon.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, baseOptions);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = ApolloReactCommon.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const UpdateAnnouncementDocument = gql`
    mutation UpdateAnnouncement($id: String!, $input: UpdateAnnouncementInput!) {
  updateAnnouncement(id: $id, input: $input) {
    id
    title
    message
    type
    priority
    isActive
    validFrom
    validUntil
    isDismissible
    isMinimizable
    koOrganizationId
    targetUrl
    targetUrlLabel
  }
}
    `;
export type UpdateAnnouncementMutationFn = ApolloReactCommon.MutationFunction<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;

/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementDocument, baseOptions);
      }
export type UpdateAnnouncementMutationHookResult = ReturnType<typeof useUpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationResult = ApolloReactCommon.MutationResult<UpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const DeleteAnnouncementDocument = gql`
    mutation DeleteAnnouncement($id: String!) {
  deleteAnnouncement(id: $id)
}
    `;
export type DeleteAnnouncementMutationFn = ApolloReactCommon.MutationFunction<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;

/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>(DeleteAnnouncementDocument, baseOptions);
      }
export type DeleteAnnouncementMutationHookResult = ReturnType<typeof useDeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationResult = ApolloReactCommon.MutationResult<DeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const GetBundesbankBlzImportInfoDocument = gql`
    query getBundesbankBlzImportInfo {
  bundesbankBlzImportInfo {
    count
    lastImport
  }
}
    `;

/**
 * __useGetBundesbankBlzImportInfoQuery__
 *
 * To run a query within a React component, call `useGetBundesbankBlzImportInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundesbankBlzImportInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundesbankBlzImportInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBundesbankBlzImportInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBundesbankBlzImportInfoQuery, GetBundesbankBlzImportInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBundesbankBlzImportInfoQuery, GetBundesbankBlzImportInfoQueryVariables>(GetBundesbankBlzImportInfoDocument, baseOptions);
      }
export function useGetBundesbankBlzImportInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBundesbankBlzImportInfoQuery, GetBundesbankBlzImportInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBundesbankBlzImportInfoQuery, GetBundesbankBlzImportInfoQueryVariables>(GetBundesbankBlzImportInfoDocument, baseOptions);
        }
export type GetBundesbankBlzImportInfoQueryHookResult = ReturnType<typeof useGetBundesbankBlzImportInfoQuery>;
export type GetBundesbankBlzImportInfoLazyQueryHookResult = ReturnType<typeof useGetBundesbankBlzImportInfoLazyQuery>;
export type GetBundesbankBlzImportInfoQueryResult = ApolloReactCommon.QueryResult<GetBundesbankBlzImportInfoQuery, GetBundesbankBlzImportInfoQueryVariables>;
export const UploadBundesbankBlzDocument = gql`
    mutation uploadBundesbankBlz($file: Upload!) {
  uploadBundesbankBlz(file: $file) {
    success
    count
    importedAt
    message
  }
}
    `;
export type UploadBundesbankBlzMutationFn = ApolloReactCommon.MutationFunction<UploadBundesbankBlzMutation, UploadBundesbankBlzMutationVariables>;

/**
 * __useUploadBundesbankBlzMutation__
 *
 * To run a mutation, you first call `useUploadBundesbankBlzMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBundesbankBlzMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBundesbankBlzMutation, { data, loading, error }] = useUploadBundesbankBlzMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadBundesbankBlzMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadBundesbankBlzMutation, UploadBundesbankBlzMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadBundesbankBlzMutation, UploadBundesbankBlzMutationVariables>(UploadBundesbankBlzDocument, baseOptions);
      }
export type UploadBundesbankBlzMutationHookResult = ReturnType<typeof useUploadBundesbankBlzMutation>;
export type UploadBundesbankBlzMutationResult = ApolloReactCommon.MutationResult<UploadBundesbankBlzMutation>;
export type UploadBundesbankBlzMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadBundesbankBlzMutation, UploadBundesbankBlzMutationVariables>;
export const GetCustomBankDataDocument = gql`
    query getCustomBankData($id: String!) {
  customBankData(id: $id) {
    id
    bankCode
    countryCode
    name
    zip
    city
    bic
    createDate
    updateDate
    createdByUserId
    updatedByUserId
  }
}
    `;

/**
 * __useGetCustomBankDataQuery__
 *
 * To run a query within a React component, call `useGetCustomBankDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomBankDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomBankDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomBankDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCustomBankDataQuery, GetCustomBankDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCustomBankDataQuery, GetCustomBankDataQueryVariables>(GetCustomBankDataDocument, baseOptions);
      }
export function useGetCustomBankDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomBankDataQuery, GetCustomBankDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCustomBankDataQuery, GetCustomBankDataQueryVariables>(GetCustomBankDataDocument, baseOptions);
        }
export type GetCustomBankDataQueryHookResult = ReturnType<typeof useGetCustomBankDataQuery>;
export type GetCustomBankDataLazyQueryHookResult = ReturnType<typeof useGetCustomBankDataLazyQuery>;
export type GetCustomBankDataQueryResult = ApolloReactCommon.QueryResult<GetCustomBankDataQuery, GetCustomBankDataQueryVariables>;
export const GetCustomBankDataListDocument = gql`
    query getCustomBankDataList {
  customBankDataList {
    id
    bankCode
    countryCode
    name
    zip
    city
    bic
    createDate
    updateDate
    createdByUserId
    updatedByUserId
  }
}
    `;

/**
 * __useGetCustomBankDataListQuery__
 *
 * To run a query within a React component, call `useGetCustomBankDataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomBankDataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomBankDataListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomBankDataListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCustomBankDataListQuery, GetCustomBankDataListQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCustomBankDataListQuery, GetCustomBankDataListQueryVariables>(GetCustomBankDataListDocument, baseOptions);
      }
export function useGetCustomBankDataListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomBankDataListQuery, GetCustomBankDataListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCustomBankDataListQuery, GetCustomBankDataListQueryVariables>(GetCustomBankDataListDocument, baseOptions);
        }
export type GetCustomBankDataListQueryHookResult = ReturnType<typeof useGetCustomBankDataListQuery>;
export type GetCustomBankDataListLazyQueryHookResult = ReturnType<typeof useGetCustomBankDataListLazyQuery>;
export type GetCustomBankDataListQueryResult = ApolloReactCommon.QueryResult<GetCustomBankDataListQuery, GetCustomBankDataListQueryVariables>;
export const CreateCustomBankDataDocument = gql`
    mutation createCustomBankData($newCustomBankDataInput: NewCustomBankDataInput!) {
  createCustomBankData(newCustomBankDataInput: $newCustomBankDataInput) {
    id
    bankCode
    countryCode
    name
    zip
    city
    bic
    createDate
    updateDate
    createdByUserId
    updatedByUserId
  }
}
    `;
export type CreateCustomBankDataMutationFn = ApolloReactCommon.MutationFunction<CreateCustomBankDataMutation, CreateCustomBankDataMutationVariables>;

/**
 * __useCreateCustomBankDataMutation__
 *
 * To run a mutation, you first call `useCreateCustomBankDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomBankDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomBankDataMutation, { data, loading, error }] = useCreateCustomBankDataMutation({
 *   variables: {
 *      newCustomBankDataInput: // value for 'newCustomBankDataInput'
 *   },
 * });
 */
export function useCreateCustomBankDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomBankDataMutation, CreateCustomBankDataMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCustomBankDataMutation, CreateCustomBankDataMutationVariables>(CreateCustomBankDataDocument, baseOptions);
      }
export type CreateCustomBankDataMutationHookResult = ReturnType<typeof useCreateCustomBankDataMutation>;
export type CreateCustomBankDataMutationResult = ApolloReactCommon.MutationResult<CreateCustomBankDataMutation>;
export type CreateCustomBankDataMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomBankDataMutation, CreateCustomBankDataMutationVariables>;
export const UpdateCustomBankDataDocument = gql`
    mutation updateCustomBankData($updateCustomBankDataInput: UpdateCustomBankDataInput!) {
  updateCustomBankData(updateCustomBankDataInput: $updateCustomBankDataInput) {
    id
    bankCode
    countryCode
    name
    zip
    city
    bic
    createDate
    updateDate
    createdByUserId
    updatedByUserId
  }
}
    `;
export type UpdateCustomBankDataMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomBankDataMutation, UpdateCustomBankDataMutationVariables>;

/**
 * __useUpdateCustomBankDataMutation__
 *
 * To run a mutation, you first call `useUpdateCustomBankDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomBankDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomBankDataMutation, { data, loading, error }] = useUpdateCustomBankDataMutation({
 *   variables: {
 *      updateCustomBankDataInput: // value for 'updateCustomBankDataInput'
 *   },
 * });
 */
export function useUpdateCustomBankDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomBankDataMutation, UpdateCustomBankDataMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCustomBankDataMutation, UpdateCustomBankDataMutationVariables>(UpdateCustomBankDataDocument, baseOptions);
      }
export type UpdateCustomBankDataMutationHookResult = ReturnType<typeof useUpdateCustomBankDataMutation>;
export type UpdateCustomBankDataMutationResult = ApolloReactCommon.MutationResult<UpdateCustomBankDataMutation>;
export type UpdateCustomBankDataMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomBankDataMutation, UpdateCustomBankDataMutationVariables>;
export const DeleteCustomBankDataDocument = gql`
    mutation deleteCustomBankData($id: String!) {
  deleteCustomBankData(id: $id)
}
    `;
export type DeleteCustomBankDataMutationFn = ApolloReactCommon.MutationFunction<DeleteCustomBankDataMutation, DeleteCustomBankDataMutationVariables>;

/**
 * __useDeleteCustomBankDataMutation__
 *
 * To run a mutation, you first call `useDeleteCustomBankDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomBankDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomBankDataMutation, { data, loading, error }] = useDeleteCustomBankDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomBankDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCustomBankDataMutation, DeleteCustomBankDataMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCustomBankDataMutation, DeleteCustomBankDataMutationVariables>(DeleteCustomBankDataDocument, baseOptions);
      }
export type DeleteCustomBankDataMutationHookResult = ReturnType<typeof useDeleteCustomBankDataMutation>;
export type DeleteCustomBankDataMutationResult = ApolloReactCommon.MutationResult<DeleteCustomBankDataMutation>;
export type DeleteCustomBankDataMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCustomBankDataMutation, DeleteCustomBankDataMutationVariables>;
export const IsCustomBankCodeUniqueDocument = gql`
    query isCustomBankCodeUnique($bankCode: String!, $id: String, $countryCode: String) {
  isCustomBankCodeUnique(bankCode: $bankCode, id: $id, countryCode: $countryCode)
}
    `;

/**
 * __useIsCustomBankCodeUniqueQuery__
 *
 * To run a query within a React component, call `useIsCustomBankCodeUniqueQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCustomBankCodeUniqueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCustomBankCodeUniqueQuery({
 *   variables: {
 *      bankCode: // value for 'bankCode'
 *      id: // value for 'id'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useIsCustomBankCodeUniqueQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsCustomBankCodeUniqueQuery, IsCustomBankCodeUniqueQueryVariables>) {
        return ApolloReactHooks.useQuery<IsCustomBankCodeUniqueQuery, IsCustomBankCodeUniqueQueryVariables>(IsCustomBankCodeUniqueDocument, baseOptions);
      }
export function useIsCustomBankCodeUniqueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsCustomBankCodeUniqueQuery, IsCustomBankCodeUniqueQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IsCustomBankCodeUniqueQuery, IsCustomBankCodeUniqueQueryVariables>(IsCustomBankCodeUniqueDocument, baseOptions);
        }
export type IsCustomBankCodeUniqueQueryHookResult = ReturnType<typeof useIsCustomBankCodeUniqueQuery>;
export type IsCustomBankCodeUniqueLazyQueryHookResult = ReturnType<typeof useIsCustomBankCodeUniqueLazyQuery>;
export type IsCustomBankCodeUniqueQueryResult = ApolloReactCommon.QueryResult<IsCustomBankCodeUniqueQuery, IsCustomBankCodeUniqueQueryVariables>;
export const ListDataExportsDocument = gql`
    query ListDataExports {
  listDataExports {
    id
    createdAt
    totalSize
    status
    errorMessage
    createdBy
    recordCount
    progress
  }
}
    `;

/**
 * __useListDataExportsQuery__
 *
 * To run a query within a React component, call `useListDataExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDataExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDataExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDataExportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListDataExportsQuery, ListDataExportsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListDataExportsQuery, ListDataExportsQueryVariables>(ListDataExportsDocument, baseOptions);
      }
export function useListDataExportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListDataExportsQuery, ListDataExportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListDataExportsQuery, ListDataExportsQueryVariables>(ListDataExportsDocument, baseOptions);
        }
export type ListDataExportsQueryHookResult = ReturnType<typeof useListDataExportsQuery>;
export type ListDataExportsLazyQueryHookResult = ReturnType<typeof useListDataExportsLazyQuery>;
export type ListDataExportsQueryResult = ApolloReactCommon.QueryResult<ListDataExportsQuery, ListDataExportsQueryVariables>;
export const CreateDataExportDocument = gql`
    mutation CreateDataExport {
  createDataExport {
    id
    createdAt
    status
  }
}
    `;
export type CreateDataExportMutationFn = ApolloReactCommon.MutationFunction<CreateDataExportMutation, CreateDataExportMutationVariables>;

/**
 * __useCreateDataExportMutation__
 *
 * To run a mutation, you first call `useCreateDataExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataExportMutation, { data, loading, error }] = useCreateDataExportMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDataExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDataExportMutation, CreateDataExportMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDataExportMutation, CreateDataExportMutationVariables>(CreateDataExportDocument, baseOptions);
      }
export type CreateDataExportMutationHookResult = ReturnType<typeof useCreateDataExportMutation>;
export type CreateDataExportMutationResult = ApolloReactCommon.MutationResult<CreateDataExportMutation>;
export type CreateDataExportMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDataExportMutation, CreateDataExportMutationVariables>;
export const DeleteDataExportDocument = gql`
    mutation DeleteDataExport($exportId: ID!) {
  deleteDataExport(exportId: $exportId)
}
    `;
export type DeleteDataExportMutationFn = ApolloReactCommon.MutationFunction<DeleteDataExportMutation, DeleteDataExportMutationVariables>;

/**
 * __useDeleteDataExportMutation__
 *
 * To run a mutation, you first call `useDeleteDataExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataExportMutation, { data, loading, error }] = useDeleteDataExportMutation({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useDeleteDataExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDataExportMutation, DeleteDataExportMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteDataExportMutation, DeleteDataExportMutationVariables>(DeleteDataExportDocument, baseOptions);
      }
export type DeleteDataExportMutationHookResult = ReturnType<typeof useDeleteDataExportMutation>;
export type DeleteDataExportMutationResult = ApolloReactCommon.MutationResult<DeleteDataExportMutation>;
export type DeleteDataExportMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDataExportMutation, DeleteDataExportMutationVariables>;
export const GetDataExportDownloadUrlDocument = gql`
    query GetDataExportDownloadUrl($exportId: ID!) {
  getDataExportDownloadUrl(exportId: $exportId)
}
    `;

/**
 * __useGetDataExportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDataExportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataExportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataExportDownloadUrlQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetDataExportDownloadUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataExportDownloadUrlQuery, GetDataExportDownloadUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataExportDownloadUrlQuery, GetDataExportDownloadUrlQueryVariables>(GetDataExportDownloadUrlDocument, baseOptions);
      }
export function useGetDataExportDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataExportDownloadUrlQuery, GetDataExportDownloadUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataExportDownloadUrlQuery, GetDataExportDownloadUrlQueryVariables>(GetDataExportDownloadUrlDocument, baseOptions);
        }
export type GetDataExportDownloadUrlQueryHookResult = ReturnType<typeof useGetDataExportDownloadUrlQuery>;
export type GetDataExportDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDataExportDownloadUrlLazyQuery>;
export type GetDataExportDownloadUrlQueryResult = ApolloReactCommon.QueryResult<GetDataExportDownloadUrlQuery, GetDataExportDownloadUrlQueryVariables>;
export const ListDatabaseBackupsDocument = gql`
    query ListDatabaseBackups {
  listDatabaseBackups {
    id
    createdAt
    koOrganizationId
    koDbPlainKey
    koDbCustomKey
    fusionDbPlainKey
    fusionDbCustomKey
    totalSize
    status
    errorMessage
    createdBy
    fusionAuthIncluded
  }
}
    `;

/**
 * __useListDatabaseBackupsQuery__
 *
 * To run a query within a React component, call `useListDatabaseBackupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDatabaseBackupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDatabaseBackupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDatabaseBackupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListDatabaseBackupsQuery, ListDatabaseBackupsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListDatabaseBackupsQuery, ListDatabaseBackupsQueryVariables>(ListDatabaseBackupsDocument, baseOptions);
      }
export function useListDatabaseBackupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListDatabaseBackupsQuery, ListDatabaseBackupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListDatabaseBackupsQuery, ListDatabaseBackupsQueryVariables>(ListDatabaseBackupsDocument, baseOptions);
        }
export type ListDatabaseBackupsQueryHookResult = ReturnType<typeof useListDatabaseBackupsQuery>;
export type ListDatabaseBackupsLazyQueryHookResult = ReturnType<typeof useListDatabaseBackupsLazyQuery>;
export type ListDatabaseBackupsQueryResult = ApolloReactCommon.QueryResult<ListDatabaseBackupsQuery, ListDatabaseBackupsQueryVariables>;
export const CreateDatabaseBackupDocument = gql`
    mutation CreateDatabaseBackup {
  createDatabaseBackup {
    id
    createdAt
    status
  }
}
    `;
export type CreateDatabaseBackupMutationFn = ApolloReactCommon.MutationFunction<CreateDatabaseBackupMutation, CreateDatabaseBackupMutationVariables>;

/**
 * __useCreateDatabaseBackupMutation__
 *
 * To run a mutation, you first call `useCreateDatabaseBackupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDatabaseBackupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDatabaseBackupMutation, { data, loading, error }] = useCreateDatabaseBackupMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDatabaseBackupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDatabaseBackupMutation, CreateDatabaseBackupMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDatabaseBackupMutation, CreateDatabaseBackupMutationVariables>(CreateDatabaseBackupDocument, baseOptions);
      }
export type CreateDatabaseBackupMutationHookResult = ReturnType<typeof useCreateDatabaseBackupMutation>;
export type CreateDatabaseBackupMutationResult = ApolloReactCommon.MutationResult<CreateDatabaseBackupMutation>;
export type CreateDatabaseBackupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDatabaseBackupMutation, CreateDatabaseBackupMutationVariables>;
export const RestoreDatabaseBackupDocument = gql`
    mutation RestoreDatabaseBackup($input: RestoreBackupInput!) {
  restoreDatabaseBackup(input: $input) {
    id
    status
  }
}
    `;
export type RestoreDatabaseBackupMutationFn = ApolloReactCommon.MutationFunction<RestoreDatabaseBackupMutation, RestoreDatabaseBackupMutationVariables>;

/**
 * __useRestoreDatabaseBackupMutation__
 *
 * To run a mutation, you first call `useRestoreDatabaseBackupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDatabaseBackupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDatabaseBackupMutation, { data, loading, error }] = useRestoreDatabaseBackupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreDatabaseBackupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreDatabaseBackupMutation, RestoreDatabaseBackupMutationVariables>) {
        return ApolloReactHooks.useMutation<RestoreDatabaseBackupMutation, RestoreDatabaseBackupMutationVariables>(RestoreDatabaseBackupDocument, baseOptions);
      }
export type RestoreDatabaseBackupMutationHookResult = ReturnType<typeof useRestoreDatabaseBackupMutation>;
export type RestoreDatabaseBackupMutationResult = ApolloReactCommon.MutationResult<RestoreDatabaseBackupMutation>;
export type RestoreDatabaseBackupMutationOptions = ApolloReactCommon.BaseMutationOptions<RestoreDatabaseBackupMutation, RestoreDatabaseBackupMutationVariables>;
export const DeleteDatabaseBackupDocument = gql`
    mutation DeleteDatabaseBackup($backupId: ID!) {
  deleteDatabaseBackup(backupId: $backupId)
}
    `;
export type DeleteDatabaseBackupMutationFn = ApolloReactCommon.MutationFunction<DeleteDatabaseBackupMutation, DeleteDatabaseBackupMutationVariables>;

/**
 * __useDeleteDatabaseBackupMutation__
 *
 * To run a mutation, you first call `useDeleteDatabaseBackupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatabaseBackupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatabaseBackupMutation, { data, loading, error }] = useDeleteDatabaseBackupMutation({
 *   variables: {
 *      backupId: // value for 'backupId'
 *   },
 * });
 */
export function useDeleteDatabaseBackupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDatabaseBackupMutation, DeleteDatabaseBackupMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteDatabaseBackupMutation, DeleteDatabaseBackupMutationVariables>(DeleteDatabaseBackupDocument, baseOptions);
      }
export type DeleteDatabaseBackupMutationHookResult = ReturnType<typeof useDeleteDatabaseBackupMutation>;
export type DeleteDatabaseBackupMutationResult = ApolloReactCommon.MutationResult<DeleteDatabaseBackupMutation>;
export type DeleteDatabaseBackupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDatabaseBackupMutation, DeleteDatabaseBackupMutationVariables>;
export const GetDatabaseBackupDownloadUrlDocument = gql`
    query GetDatabaseBackupDownloadUrl($input: DownloadBackupInput!) {
  getDatabaseBackupDownloadUrl(input: $input)
}
    `;

/**
 * __useGetDatabaseBackupDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDatabaseBackupDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatabaseBackupDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatabaseBackupDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDatabaseBackupDownloadUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDatabaseBackupDownloadUrlQuery, GetDatabaseBackupDownloadUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDatabaseBackupDownloadUrlQuery, GetDatabaseBackupDownloadUrlQueryVariables>(GetDatabaseBackupDownloadUrlDocument, baseOptions);
      }
export function useGetDatabaseBackupDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDatabaseBackupDownloadUrlQuery, GetDatabaseBackupDownloadUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDatabaseBackupDownloadUrlQuery, GetDatabaseBackupDownloadUrlQueryVariables>(GetDatabaseBackupDownloadUrlDocument, baseOptions);
        }
export type GetDatabaseBackupDownloadUrlQueryHookResult = ReturnType<typeof useGetDatabaseBackupDownloadUrlQuery>;
export type GetDatabaseBackupDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDatabaseBackupDownloadUrlLazyQuery>;
export type GetDatabaseBackupDownloadUrlQueryResult = ApolloReactCommon.QueryResult<GetDatabaseBackupDownloadUrlQuery, GetDatabaseBackupDownloadUrlQueryVariables>;
export const ListInvoiceExportsDocument = gql`
    query ListInvoiceExports {
  listInvoiceExports {
    id
    createdAt
    status
    totalSize
    recordCount
    progress
    errorMessage
    year
    month
    includeReversals
    courseLabel
    s3Key
  }
}
    `;

/**
 * __useListInvoiceExportsQuery__
 *
 * To run a query within a React component, call `useListInvoiceExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvoiceExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvoiceExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListInvoiceExportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListInvoiceExportsQuery, ListInvoiceExportsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListInvoiceExportsQuery, ListInvoiceExportsQueryVariables>(ListInvoiceExportsDocument, baseOptions);
      }
export function useListInvoiceExportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListInvoiceExportsQuery, ListInvoiceExportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListInvoiceExportsQuery, ListInvoiceExportsQueryVariables>(ListInvoiceExportsDocument, baseOptions);
        }
export type ListInvoiceExportsQueryHookResult = ReturnType<typeof useListInvoiceExportsQuery>;
export type ListInvoiceExportsLazyQueryHookResult = ReturnType<typeof useListInvoiceExportsLazyQuery>;
export type ListInvoiceExportsQueryResult = ApolloReactCommon.QueryResult<ListInvoiceExportsQuery, ListInvoiceExportsQueryVariables>;
export const GetInvoiceExportCoursesDocument = gql`
    query GetInvoiceExportCourses($year: Int!, $month: Int, $includeReversals: Boolean!) {
  invoiceExportCourses(year: $year, month: $month, includeReversals: $includeReversals) {
    id
    prefixedCourseNumber
    courseType {
      id
      name
    }
  }
}
    `;

/**
 * __useGetInvoiceExportCoursesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceExportCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceExportCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceExportCoursesQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      includeReversals: // value for 'includeReversals'
 *   },
 * });
 */
export function useGetInvoiceExportCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceExportCoursesQuery, GetInvoiceExportCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceExportCoursesQuery, GetInvoiceExportCoursesQueryVariables>(GetInvoiceExportCoursesDocument, baseOptions);
      }
export function useGetInvoiceExportCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceExportCoursesQuery, GetInvoiceExportCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceExportCoursesQuery, GetInvoiceExportCoursesQueryVariables>(GetInvoiceExportCoursesDocument, baseOptions);
        }
export type GetInvoiceExportCoursesQueryHookResult = ReturnType<typeof useGetInvoiceExportCoursesQuery>;
export type GetInvoiceExportCoursesLazyQueryHookResult = ReturnType<typeof useGetInvoiceExportCoursesLazyQuery>;
export type GetInvoiceExportCoursesQueryResult = ApolloReactCommon.QueryResult<GetInvoiceExportCoursesQuery, GetInvoiceExportCoursesQueryVariables>;
export const CreateInvoiceExportDocument = gql`
    mutation CreateInvoiceExport($year: Int, $month: Int, $includeReversals: Boolean!, $courseId: ID) {
  createInvoiceExport(year: $year, month: $month, includeReversals: $includeReversals, courseId: $courseId) {
    id
    createdAt
    status
    year
    month
    includeReversals
    courseLabel
  }
}
    `;
export type CreateInvoiceExportMutationFn = ApolloReactCommon.MutationFunction<CreateInvoiceExportMutation, CreateInvoiceExportMutationVariables>;

/**
 * __useCreateInvoiceExportMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceExportMutation, { data, loading, error }] = useCreateInvoiceExportMutation({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      includeReversals: // value for 'includeReversals'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCreateInvoiceExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvoiceExportMutation, CreateInvoiceExportMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInvoiceExportMutation, CreateInvoiceExportMutationVariables>(CreateInvoiceExportDocument, baseOptions);
      }
export type CreateInvoiceExportMutationHookResult = ReturnType<typeof useCreateInvoiceExportMutation>;
export type CreateInvoiceExportMutationResult = ApolloReactCommon.MutationResult<CreateInvoiceExportMutation>;
export type CreateInvoiceExportMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvoiceExportMutation, CreateInvoiceExportMutationVariables>;
export const DeleteInvoiceExportDocument = gql`
    mutation DeleteInvoiceExport($exportId: ID!) {
  deleteInvoiceExport(exportId: $exportId)
}
    `;
export type DeleteInvoiceExportMutationFn = ApolloReactCommon.MutationFunction<DeleteInvoiceExportMutation, DeleteInvoiceExportMutationVariables>;

/**
 * __useDeleteInvoiceExportMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceExportMutation, { data, loading, error }] = useDeleteInvoiceExportMutation({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useDeleteInvoiceExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInvoiceExportMutation, DeleteInvoiceExportMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteInvoiceExportMutation, DeleteInvoiceExportMutationVariables>(DeleteInvoiceExportDocument, baseOptions);
      }
export type DeleteInvoiceExportMutationHookResult = ReturnType<typeof useDeleteInvoiceExportMutation>;
export type DeleteInvoiceExportMutationResult = ApolloReactCommon.MutationResult<DeleteInvoiceExportMutation>;
export type DeleteInvoiceExportMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInvoiceExportMutation, DeleteInvoiceExportMutationVariables>;
export const GetInvoiceExportDownloadUrlDocument = gql`
    query GetInvoiceExportDownloadUrl($exportId: ID!) {
  getInvoiceExportDownloadUrl(exportId: $exportId)
}
    `;

/**
 * __useGetInvoiceExportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetInvoiceExportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceExportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceExportDownloadUrlQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetInvoiceExportDownloadUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceExportDownloadUrlQuery, GetInvoiceExportDownloadUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceExportDownloadUrlQuery, GetInvoiceExportDownloadUrlQueryVariables>(GetInvoiceExportDownloadUrlDocument, baseOptions);
      }
export function useGetInvoiceExportDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceExportDownloadUrlQuery, GetInvoiceExportDownloadUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceExportDownloadUrlQuery, GetInvoiceExportDownloadUrlQueryVariables>(GetInvoiceExportDownloadUrlDocument, baseOptions);
        }
export type GetInvoiceExportDownloadUrlQueryHookResult = ReturnType<typeof useGetInvoiceExportDownloadUrlQuery>;
export type GetInvoiceExportDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetInvoiceExportDownloadUrlLazyQuery>;
export type GetInvoiceExportDownloadUrlQueryResult = ApolloReactCommon.QueryResult<GetInvoiceExportDownloadUrlQuery, GetInvoiceExportDownloadUrlQueryVariables>;
export const GetMissingBankDataListDocument = gql`
    query getMissingBankDataList {
  missingBankDataList {
    id
    bankCode
    iban
    hitCount
    firstSeen
    lastSeen
    createDate
    updateDate
  }
}
    `;

/**
 * __useGetMissingBankDataListQuery__
 *
 * To run a query within a React component, call `useGetMissingBankDataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingBankDataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingBankDataListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMissingBankDataListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMissingBankDataListQuery, GetMissingBankDataListQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMissingBankDataListQuery, GetMissingBankDataListQueryVariables>(GetMissingBankDataListDocument, baseOptions);
      }
export function useGetMissingBankDataListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMissingBankDataListQuery, GetMissingBankDataListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMissingBankDataListQuery, GetMissingBankDataListQueryVariables>(GetMissingBankDataListDocument, baseOptions);
        }
export type GetMissingBankDataListQueryHookResult = ReturnType<typeof useGetMissingBankDataListQuery>;
export type GetMissingBankDataListLazyQueryHookResult = ReturnType<typeof useGetMissingBankDataListLazyQuery>;
export type GetMissingBankDataListQueryResult = ApolloReactCommon.QueryResult<GetMissingBankDataListQuery, GetMissingBankDataListQueryVariables>;
export const DeleteMissingBankDataDocument = gql`
    mutation deleteMissingBankData($id: String!) {
  deleteMissingBankData(id: $id)
}
    `;
export type DeleteMissingBankDataMutationFn = ApolloReactCommon.MutationFunction<DeleteMissingBankDataMutation, DeleteMissingBankDataMutationVariables>;

/**
 * __useDeleteMissingBankDataMutation__
 *
 * To run a mutation, you first call `useDeleteMissingBankDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMissingBankDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMissingBankDataMutation, { data, loading, error }] = useDeleteMissingBankDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMissingBankDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMissingBankDataMutation, DeleteMissingBankDataMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteMissingBankDataMutation, DeleteMissingBankDataMutationVariables>(DeleteMissingBankDataDocument, baseOptions);
      }
export type DeleteMissingBankDataMutationHookResult = ReturnType<typeof useDeleteMissingBankDataMutation>;
export type DeleteMissingBankDataMutationResult = ApolloReactCommon.MutationResult<DeleteMissingBankDataMutation>;
export type DeleteMissingBankDataMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMissingBankDataMutation, DeleteMissingBankDataMutationVariables>;
export const DeleteAllMissingBankDataDocument = gql`
    mutation deleteAllMissingBankData {
  deleteAllMissingBankData
}
    `;
export type DeleteAllMissingBankDataMutationFn = ApolloReactCommon.MutationFunction<DeleteAllMissingBankDataMutation, DeleteAllMissingBankDataMutationVariables>;

/**
 * __useDeleteAllMissingBankDataMutation__
 *
 * To run a mutation, you first call `useDeleteAllMissingBankDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllMissingBankDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllMissingBankDataMutation, { data, loading, error }] = useDeleteAllMissingBankDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAllMissingBankDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAllMissingBankDataMutation, DeleteAllMissingBankDataMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAllMissingBankDataMutation, DeleteAllMissingBankDataMutationVariables>(DeleteAllMissingBankDataDocument, baseOptions);
      }
export type DeleteAllMissingBankDataMutationHookResult = ReturnType<typeof useDeleteAllMissingBankDataMutation>;
export type DeleteAllMissingBankDataMutationResult = ApolloReactCommon.MutationResult<DeleteAllMissingBankDataMutation>;
export type DeleteAllMissingBankDataMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAllMissingBankDataMutation, DeleteAllMissingBankDataMutationVariables>;
export const RestoreOrphanBookingDocument = gql`
    mutation RestoreOrphanBooking($bookingId: ID!, $koOrganizationId: String!) {
  restoreOrphanBooking(bookingId: $bookingId, koOrganizationId: $koOrganizationId) {
    id
    bookingNumber
    bookingNumberPrefix
  }
}
    `;
export type RestoreOrphanBookingMutationFn = ApolloReactCommon.MutationFunction<RestoreOrphanBookingMutation, RestoreOrphanBookingMutationVariables>;

/**
 * __useRestoreOrphanBookingMutation__
 *
 * To run a mutation, you first call `useRestoreOrphanBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreOrphanBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreOrphanBookingMutation, { data, loading, error }] = useRestoreOrphanBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useRestoreOrphanBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreOrphanBookingMutation, RestoreOrphanBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<RestoreOrphanBookingMutation, RestoreOrphanBookingMutationVariables>(RestoreOrphanBookingDocument, baseOptions);
      }
export type RestoreOrphanBookingMutationHookResult = ReturnType<typeof useRestoreOrphanBookingMutation>;
export type RestoreOrphanBookingMutationResult = ApolloReactCommon.MutationResult<RestoreOrphanBookingMutation>;
export type RestoreOrphanBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<RestoreOrphanBookingMutation, RestoreOrphanBookingMutationVariables>;
export const GetPerformanceStatsDocument = gql`
    query GetPerformanceStats {
  getPerformanceStats {
    slowQueries {
      query
      calls
      totalTimeMs
      avgTimeMs
      maxTimeMs
      percentTotal
    }
    tableStats {
      schemaname
      tablename
      size
      inserts
      updates
      deletes
      seqScan
      idxScan
      indexUsagePercent
    }
    missingIndexCandidates {
      schemaname
      tablename
      seqScan
      seqTupRead
      idxScan
      avgRowsPerScan
    }
    cacheStats {
      sharedBuffersSize
      cacheHitRatio
      totalReads
      diskReads
    }
  }
}
    `;

/**
 * __useGetPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useGetPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformanceStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPerformanceStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPerformanceStatsQuery, GetPerformanceStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPerformanceStatsQuery, GetPerformanceStatsQueryVariables>(GetPerformanceStatsDocument, baseOptions);
      }
export function useGetPerformanceStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPerformanceStatsQuery, GetPerformanceStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPerformanceStatsQuery, GetPerformanceStatsQueryVariables>(GetPerformanceStatsDocument, baseOptions);
        }
export type GetPerformanceStatsQueryHookResult = ReturnType<typeof useGetPerformanceStatsQuery>;
export type GetPerformanceStatsLazyQueryHookResult = ReturnType<typeof useGetPerformanceStatsLazyQuery>;
export type GetPerformanceStatsQueryResult = ApolloReactCommon.QueryResult<GetPerformanceStatsQuery, GetPerformanceStatsQueryVariables>;
export const ResetPerformanceStatsDocument = gql`
    mutation ResetPerformanceStats {
  resetPerformanceStats
}
    `;
export type ResetPerformanceStatsMutationFn = ApolloReactCommon.MutationFunction<ResetPerformanceStatsMutation, ResetPerformanceStatsMutationVariables>;

/**
 * __useResetPerformanceStatsMutation__
 *
 * To run a mutation, you first call `useResetPerformanceStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPerformanceStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPerformanceStatsMutation, { data, loading, error }] = useResetPerformanceStatsMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetPerformanceStatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPerformanceStatsMutation, ResetPerformanceStatsMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetPerformanceStatsMutation, ResetPerformanceStatsMutationVariables>(ResetPerformanceStatsDocument, baseOptions);
      }
export type ResetPerformanceStatsMutationHookResult = ReturnType<typeof useResetPerformanceStatsMutation>;
export type ResetPerformanceStatsMutationResult = ApolloReactCommon.MutationResult<ResetPerformanceStatsMutation>;
export type ResetPerformanceStatsMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPerformanceStatsMutation, ResetPerformanceStatsMutationVariables>;
export const GetExportedSepaXmlsWithOrgDocument = gql`
    query GetExportedSepaXmlsWithOrg($options: ArrayDataOptions) {
  exportedSepaXmls(options: $options) {
    existsMore
    total
    items {
      id
      createDate
      fileName
      koOrganizationId
    }
  }
}
    `;

/**
 * __useGetExportedSepaXmlsWithOrgQuery__
 *
 * To run a query within a React component, call `useGetExportedSepaXmlsWithOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportedSepaXmlsWithOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportedSepaXmlsWithOrgQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetExportedSepaXmlsWithOrgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExportedSepaXmlsWithOrgQuery, GetExportedSepaXmlsWithOrgQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExportedSepaXmlsWithOrgQuery, GetExportedSepaXmlsWithOrgQueryVariables>(GetExportedSepaXmlsWithOrgDocument, baseOptions);
      }
export function useGetExportedSepaXmlsWithOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExportedSepaXmlsWithOrgQuery, GetExportedSepaXmlsWithOrgQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExportedSepaXmlsWithOrgQuery, GetExportedSepaXmlsWithOrgQueryVariables>(GetExportedSepaXmlsWithOrgDocument, baseOptions);
        }
export type GetExportedSepaXmlsWithOrgQueryHookResult = ReturnType<typeof useGetExportedSepaXmlsWithOrgQuery>;
export type GetExportedSepaXmlsWithOrgLazyQueryHookResult = ReturnType<typeof useGetExportedSepaXmlsWithOrgLazyQuery>;
export type GetExportedSepaXmlsWithOrgQueryResult = ApolloReactCommon.QueryResult<GetExportedSepaXmlsWithOrgQuery, GetExportedSepaXmlsWithOrgQueryVariables>;
export const FindUnpaidScheduledPaymentsInSepaExportsDocument = gql`
    query FindUnpaidScheduledPaymentsInSepaExports($input: FindUnpaidInSepaInput!) {
  findUnpaidScheduledPaymentsInSepaExports(input: $input) {
    matches {
      scheduledPaymentId
      bookingId
      bookingNumber
      bookingNumberPrefix
      invoiceNumber
      invoiceNumberPrefix
      paymentAmount
      paymentDue
      attendeeName
      courseNumber
      allowLessonBooking
      sepaExportId
      sepaExportFileName
      sepaExportDate
      mandateId
      confidence
      koOrganizationId
    }
    totalSepaExportsSearched
    totalMatchesFound
  }
}
    `;

/**
 * __useFindUnpaidScheduledPaymentsInSepaExportsQuery__
 *
 * To run a query within a React component, call `useFindUnpaidScheduledPaymentsInSepaExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUnpaidScheduledPaymentsInSepaExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUnpaidScheduledPaymentsInSepaExportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindUnpaidScheduledPaymentsInSepaExportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindUnpaidScheduledPaymentsInSepaExportsQuery, FindUnpaidScheduledPaymentsInSepaExportsQueryVariables>) {
        return ApolloReactHooks.useQuery<FindUnpaidScheduledPaymentsInSepaExportsQuery, FindUnpaidScheduledPaymentsInSepaExportsQueryVariables>(FindUnpaidScheduledPaymentsInSepaExportsDocument, baseOptions);
      }
export function useFindUnpaidScheduledPaymentsInSepaExportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindUnpaidScheduledPaymentsInSepaExportsQuery, FindUnpaidScheduledPaymentsInSepaExportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindUnpaidScheduledPaymentsInSepaExportsQuery, FindUnpaidScheduledPaymentsInSepaExportsQueryVariables>(FindUnpaidScheduledPaymentsInSepaExportsDocument, baseOptions);
        }
export type FindUnpaidScheduledPaymentsInSepaExportsQueryHookResult = ReturnType<typeof useFindUnpaidScheduledPaymentsInSepaExportsQuery>;
export type FindUnpaidScheduledPaymentsInSepaExportsLazyQueryHookResult = ReturnType<typeof useFindUnpaidScheduledPaymentsInSepaExportsLazyQuery>;
export type FindUnpaidScheduledPaymentsInSepaExportsQueryResult = ApolloReactCommon.QueryResult<FindUnpaidScheduledPaymentsInSepaExportsQuery, FindUnpaidScheduledPaymentsInSepaExportsQueryVariables>;
export const MarkScheduledPaymentsAsPaidFromSepaExportDocument = gql`
    mutation MarkScheduledPaymentsAsPaidFromSepaExport($input: MarkPaidFromSepaInput!) {
  markScheduledPaymentsAsPaidFromSepaExport(input: $input)
}
    `;
export type MarkScheduledPaymentsAsPaidFromSepaExportMutationFn = ApolloReactCommon.MutationFunction<MarkScheduledPaymentsAsPaidFromSepaExportMutation, MarkScheduledPaymentsAsPaidFromSepaExportMutationVariables>;

/**
 * __useMarkScheduledPaymentsAsPaidFromSepaExportMutation__
 *
 * To run a mutation, you first call `useMarkScheduledPaymentsAsPaidFromSepaExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkScheduledPaymentsAsPaidFromSepaExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markScheduledPaymentsAsPaidFromSepaExportMutation, { data, loading, error }] = useMarkScheduledPaymentsAsPaidFromSepaExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkScheduledPaymentsAsPaidFromSepaExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkScheduledPaymentsAsPaidFromSepaExportMutation, MarkScheduledPaymentsAsPaidFromSepaExportMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkScheduledPaymentsAsPaidFromSepaExportMutation, MarkScheduledPaymentsAsPaidFromSepaExportMutationVariables>(MarkScheduledPaymentsAsPaidFromSepaExportDocument, baseOptions);
      }
export type MarkScheduledPaymentsAsPaidFromSepaExportMutationHookResult = ReturnType<typeof useMarkScheduledPaymentsAsPaidFromSepaExportMutation>;
export type MarkScheduledPaymentsAsPaidFromSepaExportMutationResult = ApolloReactCommon.MutationResult<MarkScheduledPaymentsAsPaidFromSepaExportMutation>;
export type MarkScheduledPaymentsAsPaidFromSepaExportMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkScheduledPaymentsAsPaidFromSepaExportMutation, MarkScheduledPaymentsAsPaidFromSepaExportMutationVariables>;
export const ResolveTenantRecipientsDocument = gql`
    query ResolveTenantRecipients($tenantIds: [ID!]!) {
  resolveTenantRecipients(tenantIds: $tenantIds) {
    tenantId
    tenantName
    ownerEmail
    isDefaultRecipient
  }
}
    `;

/**
 * __useResolveTenantRecipientsQuery__
 *
 * To run a query within a React component, call `useResolveTenantRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveTenantRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveTenantRecipientsQuery({
 *   variables: {
 *      tenantIds: // value for 'tenantIds'
 *   },
 * });
 */
export function useResolveTenantRecipientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResolveTenantRecipientsQuery, ResolveTenantRecipientsQueryVariables>) {
        return ApolloReactHooks.useQuery<ResolveTenantRecipientsQuery, ResolveTenantRecipientsQueryVariables>(ResolveTenantRecipientsDocument, baseOptions);
      }
export function useResolveTenantRecipientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResolveTenantRecipientsQuery, ResolveTenantRecipientsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ResolveTenantRecipientsQuery, ResolveTenantRecipientsQueryVariables>(ResolveTenantRecipientsDocument, baseOptions);
        }
export type ResolveTenantRecipientsQueryHookResult = ReturnType<typeof useResolveTenantRecipientsQuery>;
export type ResolveTenantRecipientsLazyQueryHookResult = ReturnType<typeof useResolveTenantRecipientsLazyQuery>;
export type ResolveTenantRecipientsQueryResult = ApolloReactCommon.QueryResult<ResolveTenantRecipientsQuery, ResolveTenantRecipientsQueryVariables>;
export const BroadcastTenantNotificationDocument = gql`
    mutation BroadcastTenantNotification($input: BroadcastTenantNotificationInput!) {
  broadcastTenantNotification(input: $input) {
    successCount
    failureCount
    skippedCount
    results {
      tenantId
      tenantName
      email
      status
      errorMessage
    }
  }
}
    `;
export type BroadcastTenantNotificationMutationFn = ApolloReactCommon.MutationFunction<BroadcastTenantNotificationMutation, BroadcastTenantNotificationMutationVariables>;

/**
 * __useBroadcastTenantNotificationMutation__
 *
 * To run a mutation, you first call `useBroadcastTenantNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastTenantNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastTenantNotificationMutation, { data, loading, error }] = useBroadcastTenantNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBroadcastTenantNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BroadcastTenantNotificationMutation, BroadcastTenantNotificationMutationVariables>) {
        return ApolloReactHooks.useMutation<BroadcastTenantNotificationMutation, BroadcastTenantNotificationMutationVariables>(BroadcastTenantNotificationDocument, baseOptions);
      }
export type BroadcastTenantNotificationMutationHookResult = ReturnType<typeof useBroadcastTenantNotificationMutation>;
export type BroadcastTenantNotificationMutationResult = ApolloReactCommon.MutationResult<BroadcastTenantNotificationMutation>;
export type BroadcastTenantNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<BroadcastTenantNotificationMutation, BroadcastTenantNotificationMutationVariables>;
export const TenantNotificationsDocument = gql`
    query TenantNotifications($limit: Int, $offset: Int) {
  tenantNotifications(limit: $limit, offset: $offset) {
    id
    koOrganizationId
    tenantName
    recipientEmail
    subject
    status
    errorMessage
    senderId
    broadcastId
    sendDate
    createDate
  }
}
    `;

/**
 * __useTenantNotificationsQuery__
 *
 * To run a query within a React component, call `useTenantNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useTenantNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TenantNotificationsQuery, TenantNotificationsQueryVariables>) {
        return ApolloReactHooks.useQuery<TenantNotificationsQuery, TenantNotificationsQueryVariables>(TenantNotificationsDocument, baseOptions);
      }
export function useTenantNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TenantNotificationsQuery, TenantNotificationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TenantNotificationsQuery, TenantNotificationsQueryVariables>(TenantNotificationsDocument, baseOptions);
        }
export type TenantNotificationsQueryHookResult = ReturnType<typeof useTenantNotificationsQuery>;
export type TenantNotificationsLazyQueryHookResult = ReturnType<typeof useTenantNotificationsLazyQuery>;
export type TenantNotificationsQueryResult = ApolloReactCommon.QueryResult<TenantNotificationsQuery, TenantNotificationsQueryVariables>;
export const AddCourseIdAndStartDateTimeDocument = gql`
    mutation AddCourseIdAndStartDateTime {
  addCourseIdAndStartDateTime {
    success
    updatedCount
    message
  }
}
    `;
export type AddCourseIdAndStartDateTimeMutationFn = ApolloReactCommon.MutationFunction<AddCourseIdAndStartDateTimeMutation, AddCourseIdAndStartDateTimeMutationVariables>;

/**
 * __useAddCourseIdAndStartDateTimeMutation__
 *
 * To run a mutation, you first call `useAddCourseIdAndStartDateTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCourseIdAndStartDateTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCourseIdAndStartDateTimeMutation, { data, loading, error }] = useAddCourseIdAndStartDateTimeMutation({
 *   variables: {
 *   },
 * });
 */
export function useAddCourseIdAndStartDateTimeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddCourseIdAndStartDateTimeMutation, AddCourseIdAndStartDateTimeMutationVariables>) {
        return ApolloReactHooks.useMutation<AddCourseIdAndStartDateTimeMutation, AddCourseIdAndStartDateTimeMutationVariables>(AddCourseIdAndStartDateTimeDocument, baseOptions);
      }
export type AddCourseIdAndStartDateTimeMutationHookResult = ReturnType<typeof useAddCourseIdAndStartDateTimeMutation>;
export type AddCourseIdAndStartDateTimeMutationResult = ApolloReactCommon.MutationResult<AddCourseIdAndStartDateTimeMutation>;
export type AddCourseIdAndStartDateTimeMutationOptions = ApolloReactCommon.BaseMutationOptions<AddCourseIdAndStartDateTimeMutation, AddCourseIdAndStartDateTimeMutationVariables>;
export const GetMaintenanceStatusDocument = gql`
    query GetMaintenanceStatus {
  maintenanceStatus {
    enabled
    message
    untilIso
    updatedAtIso
  }
}
    `;

/**
 * __useGetMaintenanceStatusQuery__
 *
 * To run a query within a React component, call `useGetMaintenanceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenanceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenanceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaintenanceStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>(GetMaintenanceStatusDocument, baseOptions);
      }
export function useGetMaintenanceStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>(GetMaintenanceStatusDocument, baseOptions);
        }
export type GetMaintenanceStatusQueryHookResult = ReturnType<typeof useGetMaintenanceStatusQuery>;
export type GetMaintenanceStatusLazyQueryHookResult = ReturnType<typeof useGetMaintenanceStatusLazyQuery>;
export type GetMaintenanceStatusQueryResult = ApolloReactCommon.QueryResult<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>;
export const EnableMaintenanceDocument = gql`
    mutation EnableMaintenance($input: MaintenanceEnableInput) {
  enableMaintenance(input: $input) {
    enabled
    message
    untilIso
    updatedAtIso
  }
}
    `;
export type EnableMaintenanceMutationFn = ApolloReactCommon.MutationFunction<EnableMaintenanceMutation, EnableMaintenanceMutationVariables>;

/**
 * __useEnableMaintenanceMutation__
 *
 * To run a mutation, you first call `useEnableMaintenanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMaintenanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMaintenanceMutation, { data, loading, error }] = useEnableMaintenanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableMaintenanceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableMaintenanceMutation, EnableMaintenanceMutationVariables>) {
        return ApolloReactHooks.useMutation<EnableMaintenanceMutation, EnableMaintenanceMutationVariables>(EnableMaintenanceDocument, baseOptions);
      }
export type EnableMaintenanceMutationHookResult = ReturnType<typeof useEnableMaintenanceMutation>;
export type EnableMaintenanceMutationResult = ApolloReactCommon.MutationResult<EnableMaintenanceMutation>;
export type EnableMaintenanceMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableMaintenanceMutation, EnableMaintenanceMutationVariables>;
export const DisableMaintenanceDocument = gql`
    mutation DisableMaintenance {
  disableMaintenance {
    enabled
    message
    untilIso
    updatedAtIso
  }
}
    `;
export type DisableMaintenanceMutationFn = ApolloReactCommon.MutationFunction<DisableMaintenanceMutation, DisableMaintenanceMutationVariables>;

/**
 * __useDisableMaintenanceMutation__
 *
 * To run a mutation, you first call `useDisableMaintenanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMaintenanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMaintenanceMutation, { data, loading, error }] = useDisableMaintenanceMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableMaintenanceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableMaintenanceMutation, DisableMaintenanceMutationVariables>) {
        return ApolloReactHooks.useMutation<DisableMaintenanceMutation, DisableMaintenanceMutationVariables>(DisableMaintenanceDocument, baseOptions);
      }
export type DisableMaintenanceMutationHookResult = ReturnType<typeof useDisableMaintenanceMutation>;
export type DisableMaintenanceMutationResult = ApolloReactCommon.MutationResult<DisableMaintenanceMutation>;
export type DisableMaintenanceMutationOptions = ApolloReactCommon.BaseMutationOptions<DisableMaintenanceMutation, DisableMaintenanceMutationVariables>;
export const DeleteFusionAuthUsersByEmailsDocument = gql`
    mutation DeleteFusionAuthUsersByEmails($emailAddresses: [String!]!) {
  deleteFusionAuthUsersByEmails(emailAddresses: $emailAddresses)
}
    `;
export type DeleteFusionAuthUsersByEmailsMutationFn = ApolloReactCommon.MutationFunction<DeleteFusionAuthUsersByEmailsMutation, DeleteFusionAuthUsersByEmailsMutationVariables>;

/**
 * __useDeleteFusionAuthUsersByEmailsMutation__
 *
 * To run a mutation, you first call `useDeleteFusionAuthUsersByEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFusionAuthUsersByEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFusionAuthUsersByEmailsMutation, { data, loading, error }] = useDeleteFusionAuthUsersByEmailsMutation({
 *   variables: {
 *      emailAddresses: // value for 'emailAddresses'
 *   },
 * });
 */
export function useDeleteFusionAuthUsersByEmailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFusionAuthUsersByEmailsMutation, DeleteFusionAuthUsersByEmailsMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteFusionAuthUsersByEmailsMutation, DeleteFusionAuthUsersByEmailsMutationVariables>(DeleteFusionAuthUsersByEmailsDocument, baseOptions);
      }
export type DeleteFusionAuthUsersByEmailsMutationHookResult = ReturnType<typeof useDeleteFusionAuthUsersByEmailsMutation>;
export type DeleteFusionAuthUsersByEmailsMutationResult = ApolloReactCommon.MutationResult<DeleteFusionAuthUsersByEmailsMutation>;
export type DeleteFusionAuthUsersByEmailsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFusionAuthUsersByEmailsMutation, DeleteFusionAuthUsersByEmailsMutationVariables>;
export const SuperuserDocsIndexDocument = gql`
    query SuperuserDocsIndex {
  superuserDocsIndex
}
    `;

/**
 * __useSuperuserDocsIndexQuery__
 *
 * To run a query within a React component, call `useSuperuserDocsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDocsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserDocsIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperuserDocsIndexQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperuserDocsIndexQuery, SuperuserDocsIndexQueryVariables>) {
        return ApolloReactHooks.useQuery<SuperuserDocsIndexQuery, SuperuserDocsIndexQueryVariables>(SuperuserDocsIndexDocument, baseOptions);
      }
export function useSuperuserDocsIndexLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperuserDocsIndexQuery, SuperuserDocsIndexQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SuperuserDocsIndexQuery, SuperuserDocsIndexQueryVariables>(SuperuserDocsIndexDocument, baseOptions);
        }
export type SuperuserDocsIndexQueryHookResult = ReturnType<typeof useSuperuserDocsIndexQuery>;
export type SuperuserDocsIndexLazyQueryHookResult = ReturnType<typeof useSuperuserDocsIndexLazyQuery>;
export type SuperuserDocsIndexQueryResult = ApolloReactCommon.QueryResult<SuperuserDocsIndexQuery, SuperuserDocsIndexQueryVariables>;
export const SuperuserDocDocument = gql`
    query SuperuserDoc($slug: String!) {
  superuserDocs(slug: $slug)
}
    `;

/**
 * __useSuperuserDocQuery__
 *
 * To run a query within a React component, call `useSuperuserDocQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserDocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserDocQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSuperuserDocQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperuserDocQuery, SuperuserDocQueryVariables>) {
        return ApolloReactHooks.useQuery<SuperuserDocQuery, SuperuserDocQueryVariables>(SuperuserDocDocument, baseOptions);
      }
export function useSuperuserDocLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperuserDocQuery, SuperuserDocQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SuperuserDocQuery, SuperuserDocQueryVariables>(SuperuserDocDocument, baseOptions);
        }
export type SuperuserDocQueryHookResult = ReturnType<typeof useSuperuserDocQuery>;
export type SuperuserDocLazyQueryHookResult = ReturnType<typeof useSuperuserDocLazyQuery>;
export type SuperuserDocQueryResult = ApolloReactCommon.QueryResult<SuperuserDocQuery, SuperuserDocQueryVariables>;
export const SettingEndUserAppDocument = gql`
    query SettingEndUserApp {
  settingEndUserApp {
    colors
    courseTable
    courseDetails
    filters
    textEntries
    optionalInputFields
    i18n
    hideAfterDays
    passwordlessLoginEnabled
    withdrawalButtonEnabled
    creditRedemptionEnabled
    showTotalPriceInCheckout
    showInterestListsByDefault
    passwordlessIdCodeLength
    courseSearchDisplayMode
    courseSearchPageSize
    courseSearchGridMaxColumns
    courseSearchGridGap
  }
}
    `;

/**
 * __useSettingEndUserAppQuery__
 *
 * To run a query within a React component, call `useSettingEndUserAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingEndUserAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingEndUserAppQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingEndUserAppQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettingEndUserAppQuery, SettingEndUserAppQueryVariables>) {
        return ApolloReactHooks.useQuery<SettingEndUserAppQuery, SettingEndUserAppQueryVariables>(SettingEndUserAppDocument, baseOptions);
      }
export function useSettingEndUserAppLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettingEndUserAppQuery, SettingEndUserAppQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SettingEndUserAppQuery, SettingEndUserAppQueryVariables>(SettingEndUserAppDocument, baseOptions);
        }
export type SettingEndUserAppQueryHookResult = ReturnType<typeof useSettingEndUserAppQuery>;
export type SettingEndUserAppLazyQueryHookResult = ReturnType<typeof useSettingEndUserAppLazyQuery>;
export type SettingEndUserAppQueryResult = ApolloReactCommon.QueryResult<SettingEndUserAppQuery, SettingEndUserAppQueryVariables>;
export const SettingEndUserAppPublicDocument = gql`
    query SettingEndUserAppPublic {
  settingEndUserAppPublic {
    hideAfterDays
    withdrawalButtonEnabled
    creditRedemptionEnabled
    showTotalPriceInCheckout
    showInterestListsByDefault
  }
}
    `;

/**
 * __useSettingEndUserAppPublicQuery__
 *
 * To run a query within a React component, call `useSettingEndUserAppPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingEndUserAppPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingEndUserAppPublicQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingEndUserAppPublicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettingEndUserAppPublicQuery, SettingEndUserAppPublicQueryVariables>) {
        return ApolloReactHooks.useQuery<SettingEndUserAppPublicQuery, SettingEndUserAppPublicQueryVariables>(SettingEndUserAppPublicDocument, baseOptions);
      }
export function useSettingEndUserAppPublicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettingEndUserAppPublicQuery, SettingEndUserAppPublicQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SettingEndUserAppPublicQuery, SettingEndUserAppPublicQueryVariables>(SettingEndUserAppPublicDocument, baseOptions);
        }
export type SettingEndUserAppPublicQueryHookResult = ReturnType<typeof useSettingEndUserAppPublicQuery>;
export type SettingEndUserAppPublicLazyQueryHookResult = ReturnType<typeof useSettingEndUserAppPublicLazyQuery>;
export type SettingEndUserAppPublicQueryResult = ApolloReactCommon.QueryResult<SettingEndUserAppPublicQuery, SettingEndUserAppPublicQueryVariables>;
export const SettingEndUserAppHistoryDocument = gql`
    query SettingEndUserAppHistory {
  settingEndUserAppHistory {
    id
    createDate
    userId
    userName
    oldValues
    newValues
  }
}
    `;

/**
 * __useSettingEndUserAppHistoryQuery__
 *
 * To run a query within a React component, call `useSettingEndUserAppHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingEndUserAppHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingEndUserAppHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingEndUserAppHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettingEndUserAppHistoryQuery, SettingEndUserAppHistoryQueryVariables>) {
        return ApolloReactHooks.useQuery<SettingEndUserAppHistoryQuery, SettingEndUserAppHistoryQueryVariables>(SettingEndUserAppHistoryDocument, baseOptions);
      }
export function useSettingEndUserAppHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettingEndUserAppHistoryQuery, SettingEndUserAppHistoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SettingEndUserAppHistoryQuery, SettingEndUserAppHistoryQueryVariables>(SettingEndUserAppHistoryDocument, baseOptions);
        }
export type SettingEndUserAppHistoryQueryHookResult = ReturnType<typeof useSettingEndUserAppHistoryQuery>;
export type SettingEndUserAppHistoryLazyQueryHookResult = ReturnType<typeof useSettingEndUserAppHistoryLazyQuery>;
export type SettingEndUserAppHistoryQueryResult = ApolloReactCommon.QueryResult<SettingEndUserAppHistoryQuery, SettingEndUserAppHistoryQueryVariables>;
export const LateEntryPricingConfigurationDocument = gql`
    query LateEntryPricingConfiguration {
  lateEntryPricingConfiguration {
    id
    lateEntryPricingPolicy
    minimumPartialBookingLessonCount
    updateDate
  }
}
    `;

/**
 * __useLateEntryPricingConfigurationQuery__
 *
 * To run a query within a React component, call `useLateEntryPricingConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLateEntryPricingConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLateEntryPricingConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useLateEntryPricingConfigurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LateEntryPricingConfigurationQuery, LateEntryPricingConfigurationQueryVariables>) {
        return ApolloReactHooks.useQuery<LateEntryPricingConfigurationQuery, LateEntryPricingConfigurationQueryVariables>(LateEntryPricingConfigurationDocument, baseOptions);
      }
export function useLateEntryPricingConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LateEntryPricingConfigurationQuery, LateEntryPricingConfigurationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LateEntryPricingConfigurationQuery, LateEntryPricingConfigurationQueryVariables>(LateEntryPricingConfigurationDocument, baseOptions);
        }
export type LateEntryPricingConfigurationQueryHookResult = ReturnType<typeof useLateEntryPricingConfigurationQuery>;
export type LateEntryPricingConfigurationLazyQueryHookResult = ReturnType<typeof useLateEntryPricingConfigurationLazyQuery>;
export type LateEntryPricingConfigurationQueryResult = ApolloReactCommon.QueryResult<LateEntryPricingConfigurationQuery, LateEntryPricingConfigurationQueryVariables>;
export const UpdateLateEntryPricingConfigurationDocument = gql`
    mutation UpdateLateEntryPricingConfiguration($input: UpdateLateEntryPricingConfigurationInput!) {
  updateLateEntryPricingConfiguration(input: $input) {
    id
    lateEntryPricingPolicy
    minimumPartialBookingLessonCount
    updateDate
  }
}
    `;
export type UpdateLateEntryPricingConfigurationMutationFn = ApolloReactCommon.MutationFunction<UpdateLateEntryPricingConfigurationMutation, UpdateLateEntryPricingConfigurationMutationVariables>;

/**
 * __useUpdateLateEntryPricingConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateLateEntryPricingConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLateEntryPricingConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLateEntryPricingConfigurationMutation, { data, loading, error }] = useUpdateLateEntryPricingConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLateEntryPricingConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLateEntryPricingConfigurationMutation, UpdateLateEntryPricingConfigurationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLateEntryPricingConfigurationMutation, UpdateLateEntryPricingConfigurationMutationVariables>(UpdateLateEntryPricingConfigurationDocument, baseOptions);
      }
export type UpdateLateEntryPricingConfigurationMutationHookResult = ReturnType<typeof useUpdateLateEntryPricingConfigurationMutation>;
export type UpdateLateEntryPricingConfigurationMutationResult = ApolloReactCommon.MutationResult<UpdateLateEntryPricingConfigurationMutation>;
export type UpdateLateEntryPricingConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLateEntryPricingConfigurationMutation, UpdateLateEntryPricingConfigurationMutationVariables>;
export const UpdateSettingEndUserAppDocument = gql`
    mutation UpdateSettingEndUserApp($updateSettingEndUserAppInput: UpdateSettingEndUserAppInput!) {
  updateSettingEndUserApp(updateSettingEndUserAppInput: $updateSettingEndUserAppInput) {
    id
    colors
    courseTable
    courseDetails
    filters
    textEntries
    optionalInputFields
    i18n
    hideAfterDays
    passwordlessLoginEnabled
    withdrawalButtonEnabled
    creditRedemptionEnabled
    showTotalPriceInCheckout
    showInterestListsByDefault
    passwordlessIdCodeLength
    courseSearchDisplayMode
    courseSearchPageSize
    courseSearchGridMaxColumns
    courseSearchGridGap
  }
}
    `;
export type UpdateSettingEndUserAppMutationFn = ApolloReactCommon.MutationFunction<UpdateSettingEndUserAppMutation, UpdateSettingEndUserAppMutationVariables>;

/**
 * __useUpdateSettingEndUserAppMutation__
 *
 * To run a mutation, you first call `useUpdateSettingEndUserAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingEndUserAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingEndUserAppMutation, { data, loading, error }] = useUpdateSettingEndUserAppMutation({
 *   variables: {
 *      updateSettingEndUserAppInput: // value for 'updateSettingEndUserAppInput'
 *   },
 * });
 */
export function useUpdateSettingEndUserAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSettingEndUserAppMutation, UpdateSettingEndUserAppMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSettingEndUserAppMutation, UpdateSettingEndUserAppMutationVariables>(UpdateSettingEndUserAppDocument, baseOptions);
      }
export type UpdateSettingEndUserAppMutationHookResult = ReturnType<typeof useUpdateSettingEndUserAppMutation>;
export type UpdateSettingEndUserAppMutationResult = ApolloReactCommon.MutationResult<UpdateSettingEndUserAppMutation>;
export type UpdateSettingEndUserAppMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSettingEndUserAppMutation, UpdateSettingEndUserAppMutationVariables>;
export const CreateSettingEndUserAppWithDefaultValuesDocument = gql`
    mutation CreateSettingEndUserAppWithDefaultValues {
  createSettingEndUserAppWithDefaultValues {
    id
    colors
    courseTable
    courseDetails
    filters
    textEntries
    optionalInputFields
    i18n
    hideAfterDays
    passwordlessLoginEnabled
    withdrawalButtonEnabled
    creditRedemptionEnabled
    showTotalPriceInCheckout
    showInterestListsByDefault
    passwordlessIdCodeLength
    courseSearchDisplayMode
    courseSearchPageSize
    courseSearchGridMaxColumns
    courseSearchGridGap
  }
}
    `;
export type CreateSettingEndUserAppWithDefaultValuesMutationFn = ApolloReactCommon.MutationFunction<CreateSettingEndUserAppWithDefaultValuesMutation, CreateSettingEndUserAppWithDefaultValuesMutationVariables>;

/**
 * __useCreateSettingEndUserAppWithDefaultValuesMutation__
 *
 * To run a mutation, you first call `useCreateSettingEndUserAppWithDefaultValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSettingEndUserAppWithDefaultValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSettingEndUserAppWithDefaultValuesMutation, { data, loading, error }] = useCreateSettingEndUserAppWithDefaultValuesMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSettingEndUserAppWithDefaultValuesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSettingEndUserAppWithDefaultValuesMutation, CreateSettingEndUserAppWithDefaultValuesMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSettingEndUserAppWithDefaultValuesMutation, CreateSettingEndUserAppWithDefaultValuesMutationVariables>(CreateSettingEndUserAppWithDefaultValuesDocument, baseOptions);
      }
export type CreateSettingEndUserAppWithDefaultValuesMutationHookResult = ReturnType<typeof useCreateSettingEndUserAppWithDefaultValuesMutation>;
export type CreateSettingEndUserAppWithDefaultValuesMutationResult = ApolloReactCommon.MutationResult<CreateSettingEndUserAppWithDefaultValuesMutation>;
export type CreateSettingEndUserAppWithDefaultValuesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSettingEndUserAppWithDefaultValuesMutation, CreateSettingEndUserAppWithDefaultValuesMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($file: Upload!) {
  uploadCompanyLogo(file: $file)
}
    `;
export type UploadFileMutationFn = ApolloReactCommon.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, baseOptions);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = ApolloReactCommon.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const DeleteCompanyLogoDocument = gql`
    mutation DeleteCompanyLogo {
  deleteCompanyLogo {
    id
    logo
  }
}
    `;
export type DeleteCompanyLogoMutationFn = ApolloReactCommon.MutationFunction<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>;

/**
 * __useDeleteCompanyLogoMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyLogoMutation, { data, loading, error }] = useDeleteCompanyLogoMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteCompanyLogoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>(DeleteCompanyLogoDocument, baseOptions);
      }
export type DeleteCompanyLogoMutationHookResult = ReturnType<typeof useDeleteCompanyLogoMutation>;
export type DeleteCompanyLogoMutationResult = ApolloReactCommon.MutationResult<DeleteCompanyLogoMutation>;
export type DeleteCompanyLogoMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>;
export const MollieConnectionStatusDocument = gql`
    query MollieConnectionStatus {
  mollieConnectionStatus {
    isConnected
    canReceivePayments
    canReceiveSettlements
    connectedAt
    mollieOrganizationId
    mollieProfileId
    capabilitiesHint
    isTestMode
    needsReconnect
    onboardingStatus
    dashboardUrl
  }
}
    `;

/**
 * __useMollieConnectionStatusQuery__
 *
 * To run a query within a React component, call `useMollieConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMollieConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMollieConnectionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMollieConnectionStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MollieConnectionStatusQuery, MollieConnectionStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<MollieConnectionStatusQuery, MollieConnectionStatusQueryVariables>(MollieConnectionStatusDocument, baseOptions);
      }
export function useMollieConnectionStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MollieConnectionStatusQuery, MollieConnectionStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MollieConnectionStatusQuery, MollieConnectionStatusQueryVariables>(MollieConnectionStatusDocument, baseOptions);
        }
export type MollieConnectionStatusQueryHookResult = ReturnType<typeof useMollieConnectionStatusQuery>;
export type MollieConnectionStatusLazyQueryHookResult = ReturnType<typeof useMollieConnectionStatusLazyQuery>;
export type MollieConnectionStatusQueryResult = ApolloReactCommon.QueryResult<MollieConnectionStatusQuery, MollieConnectionStatusQueryVariables>;
export const MollieAvailableMethodsDocument = gql`
    query MollieAvailableMethods {
  mollieAvailableMethods {
    id
    description
    imageUrl
    isEnabled
    isAvailableInProfile
    profileStatus
  }
}
    `;

/**
 * __useMollieAvailableMethodsQuery__
 *
 * To run a query within a React component, call `useMollieAvailableMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMollieAvailableMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMollieAvailableMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMollieAvailableMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MollieAvailableMethodsQuery, MollieAvailableMethodsQueryVariables>) {
        return ApolloReactHooks.useQuery<MollieAvailableMethodsQuery, MollieAvailableMethodsQueryVariables>(MollieAvailableMethodsDocument, baseOptions);
      }
export function useMollieAvailableMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MollieAvailableMethodsQuery, MollieAvailableMethodsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MollieAvailableMethodsQuery, MollieAvailableMethodsQueryVariables>(MollieAvailableMethodsDocument, baseOptions);
        }
export type MollieAvailableMethodsQueryHookResult = ReturnType<typeof useMollieAvailableMethodsQuery>;
export type MollieAvailableMethodsLazyQueryHookResult = ReturnType<typeof useMollieAvailableMethodsLazyQuery>;
export type MollieAvailableMethodsQueryResult = ApolloReactCommon.QueryResult<MollieAvailableMethodsQuery, MollieAvailableMethodsQueryVariables>;
export const MolliePaymentStatusDocument = gql`
    query MolliePaymentStatus($scheduledPaymentId: ID!) {
  molliePaymentStatus(scheduledPaymentId: $scheduledPaymentId) {
    molliePaymentId
    status
    paidAt
    amount
  }
}
    `;

/**
 * __useMolliePaymentStatusQuery__
 *
 * To run a query within a React component, call `useMolliePaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMolliePaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMolliePaymentStatusQuery({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *   },
 * });
 */
export function useMolliePaymentStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MolliePaymentStatusQuery, MolliePaymentStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<MolliePaymentStatusQuery, MolliePaymentStatusQueryVariables>(MolliePaymentStatusDocument, baseOptions);
      }
export function useMolliePaymentStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MolliePaymentStatusQuery, MolliePaymentStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MolliePaymentStatusQuery, MolliePaymentStatusQueryVariables>(MolliePaymentStatusDocument, baseOptions);
        }
export type MolliePaymentStatusQueryHookResult = ReturnType<typeof useMolliePaymentStatusQuery>;
export type MolliePaymentStatusLazyQueryHookResult = ReturnType<typeof useMolliePaymentStatusLazyQuery>;
export type MolliePaymentStatusQueryResult = ApolloReactCommon.QueryResult<MolliePaymentStatusQuery, MolliePaymentStatusQueryVariables>;
export const MollieGetConnectUrlDocument = gql`
    mutation MollieGetConnectUrl {
  mollieGetConnectUrl
}
    `;
export type MollieGetConnectUrlMutationFn = ApolloReactCommon.MutationFunction<MollieGetConnectUrlMutation, MollieGetConnectUrlMutationVariables>;

/**
 * __useMollieGetConnectUrlMutation__
 *
 * To run a mutation, you first call `useMollieGetConnectUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMollieGetConnectUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mollieGetConnectUrlMutation, { data, loading, error }] = useMollieGetConnectUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useMollieGetConnectUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MollieGetConnectUrlMutation, MollieGetConnectUrlMutationVariables>) {
        return ApolloReactHooks.useMutation<MollieGetConnectUrlMutation, MollieGetConnectUrlMutationVariables>(MollieGetConnectUrlDocument, baseOptions);
      }
export type MollieGetConnectUrlMutationHookResult = ReturnType<typeof useMollieGetConnectUrlMutation>;
export type MollieGetConnectUrlMutationResult = ApolloReactCommon.MutationResult<MollieGetConnectUrlMutation>;
export type MollieGetConnectUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<MollieGetConnectUrlMutation, MollieGetConnectUrlMutationVariables>;
export const MollieDisconnectDocument = gql`
    mutation MollieDisconnect {
  mollieDisconnect
}
    `;
export type MollieDisconnectMutationFn = ApolloReactCommon.MutationFunction<MollieDisconnectMutation, MollieDisconnectMutationVariables>;

/**
 * __useMollieDisconnectMutation__
 *
 * To run a mutation, you first call `useMollieDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMollieDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mollieDisconnectMutation, { data, loading, error }] = useMollieDisconnectMutation({
 *   variables: {
 *   },
 * });
 */
export function useMollieDisconnectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MollieDisconnectMutation, MollieDisconnectMutationVariables>) {
        return ApolloReactHooks.useMutation<MollieDisconnectMutation, MollieDisconnectMutationVariables>(MollieDisconnectDocument, baseOptions);
      }
export type MollieDisconnectMutationHookResult = ReturnType<typeof useMollieDisconnectMutation>;
export type MollieDisconnectMutationResult = ApolloReactCommon.MutationResult<MollieDisconnectMutation>;
export type MollieDisconnectMutationOptions = ApolloReactCommon.BaseMutationOptions<MollieDisconnectMutation, MollieDisconnectMutationVariables>;
export const MollieCreateClientLinkDocument = gql`
    mutation MollieCreateClientLink($input: MollieCreateClientLinkInput!, $returnTo: String) {
  mollieCreateClientLink(input: $input, returnTo: $returnTo) {
    clientLinkUrl
    clientLinkId
  }
}
    `;
export type MollieCreateClientLinkMutationFn = ApolloReactCommon.MutationFunction<MollieCreateClientLinkMutation, MollieCreateClientLinkMutationVariables>;

/**
 * __useMollieCreateClientLinkMutation__
 *
 * To run a mutation, you first call `useMollieCreateClientLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMollieCreateClientLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mollieCreateClientLinkMutation, { data, loading, error }] = useMollieCreateClientLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *      returnTo: // value for 'returnTo'
 *   },
 * });
 */
export function useMollieCreateClientLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MollieCreateClientLinkMutation, MollieCreateClientLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<MollieCreateClientLinkMutation, MollieCreateClientLinkMutationVariables>(MollieCreateClientLinkDocument, baseOptions);
      }
export type MollieCreateClientLinkMutationHookResult = ReturnType<typeof useMollieCreateClientLinkMutation>;
export type MollieCreateClientLinkMutationResult = ApolloReactCommon.MutationResult<MollieCreateClientLinkMutation>;
export type MollieCreateClientLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<MollieCreateClientLinkMutation, MollieCreateClientLinkMutationVariables>;
export const CreateMolliePaymentDocument = gql`
    mutation CreateMolliePayment($scheduledPaymentId: ID!, $method: String!) {
  createMolliePayment(scheduledPaymentId: $scheduledPaymentId, method: $method) {
    molliePaymentId
    checkoutUrl
    status
  }
}
    `;
export type CreateMolliePaymentMutationFn = ApolloReactCommon.MutationFunction<CreateMolliePaymentMutation, CreateMolliePaymentMutationVariables>;

/**
 * __useCreateMolliePaymentMutation__
 *
 * To run a mutation, you first call `useCreateMolliePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMolliePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMolliePaymentMutation, { data, loading, error }] = useCreateMolliePaymentMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useCreateMolliePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMolliePaymentMutation, CreateMolliePaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMolliePaymentMutation, CreateMolliePaymentMutationVariables>(CreateMolliePaymentDocument, baseOptions);
      }
export type CreateMolliePaymentMutationHookResult = ReturnType<typeof useCreateMolliePaymentMutation>;
export type CreateMolliePaymentMutationResult = ApolloReactCommon.MutationResult<CreateMolliePaymentMutation>;
export type CreateMolliePaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMolliePaymentMutation, CreateMolliePaymentMutationVariables>;
export const RetryMolliePaymentDocument = gql`
    mutation RetryMolliePayment($scheduledPaymentId: ID!) {
  retryMolliePayment(scheduledPaymentId: $scheduledPaymentId) {
    molliePaymentId
    checkoutUrl
    status
  }
}
    `;
export type RetryMolliePaymentMutationFn = ApolloReactCommon.MutationFunction<RetryMolliePaymentMutation, RetryMolliePaymentMutationVariables>;

/**
 * __useRetryMolliePaymentMutation__
 *
 * To run a mutation, you first call `useRetryMolliePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryMolliePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryMolliePaymentMutation, { data, loading, error }] = useRetryMolliePaymentMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *   },
 * });
 */
export function useRetryMolliePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetryMolliePaymentMutation, RetryMolliePaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<RetryMolliePaymentMutation, RetryMolliePaymentMutationVariables>(RetryMolliePaymentDocument, baseOptions);
      }
export type RetryMolliePaymentMutationHookResult = ReturnType<typeof useRetryMolliePaymentMutation>;
export type RetryMolliePaymentMutationResult = ApolloReactCommon.MutationResult<RetryMolliePaymentMutation>;
export type RetryMolliePaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<RetryMolliePaymentMutation, RetryMolliePaymentMutationVariables>;
export const UpdateMollieEnabledMethodsDocument = gql`
    mutation UpdateMollieEnabledMethods($methodIds: [String!]!) {
  updateMollieEnabledMethods(methodIds: $methodIds) {
    id
    description
    imageUrl
    isEnabled
    isAvailableInProfile
    profileStatus
  }
}
    `;
export type UpdateMollieEnabledMethodsMutationFn = ApolloReactCommon.MutationFunction<UpdateMollieEnabledMethodsMutation, UpdateMollieEnabledMethodsMutationVariables>;

/**
 * __useUpdateMollieEnabledMethodsMutation__
 *
 * To run a mutation, you first call `useUpdateMollieEnabledMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMollieEnabledMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMollieEnabledMethodsMutation, { data, loading, error }] = useUpdateMollieEnabledMethodsMutation({
 *   variables: {
 *      methodIds: // value for 'methodIds'
 *   },
 * });
 */
export function useUpdateMollieEnabledMethodsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMollieEnabledMethodsMutation, UpdateMollieEnabledMethodsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMollieEnabledMethodsMutation, UpdateMollieEnabledMethodsMutationVariables>(UpdateMollieEnabledMethodsDocument, baseOptions);
      }
export type UpdateMollieEnabledMethodsMutationHookResult = ReturnType<typeof useUpdateMollieEnabledMethodsMutation>;
export type UpdateMollieEnabledMethodsMutationResult = ApolloReactCommon.MutationResult<UpdateMollieEnabledMethodsMutation>;
export type UpdateMollieEnabledMethodsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMollieEnabledMethodsMutation, UpdateMollieEnabledMethodsMutationVariables>;
export const MollieAllMethodsForWhitelistDocument = gql`
    query MollieAllMethodsForWhitelist {
  mollieAllMethodsForWhitelist {
    id
    description
    imageUrl
    isEnabled
    isAvailableInProfile
    profileStatus
  }
}
    `;

/**
 * __useMollieAllMethodsForWhitelistQuery__
 *
 * To run a query within a React component, call `useMollieAllMethodsForWhitelistQuery` and pass it any options that fit your needs.
 * When your component renders, `useMollieAllMethodsForWhitelistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMollieAllMethodsForWhitelistQuery({
 *   variables: {
 *   },
 * });
 */
export function useMollieAllMethodsForWhitelistQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MollieAllMethodsForWhitelistQuery, MollieAllMethodsForWhitelistQueryVariables>) {
        return ApolloReactHooks.useQuery<MollieAllMethodsForWhitelistQuery, MollieAllMethodsForWhitelistQueryVariables>(MollieAllMethodsForWhitelistDocument, baseOptions);
      }
export function useMollieAllMethodsForWhitelistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MollieAllMethodsForWhitelistQuery, MollieAllMethodsForWhitelistQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MollieAllMethodsForWhitelistQuery, MollieAllMethodsForWhitelistQueryVariables>(MollieAllMethodsForWhitelistDocument, baseOptions);
        }
export type MollieAllMethodsForWhitelistQueryHookResult = ReturnType<typeof useMollieAllMethodsForWhitelistQuery>;
export type MollieAllMethodsForWhitelistLazyQueryHookResult = ReturnType<typeof useMollieAllMethodsForWhitelistLazyQuery>;
export type MollieAllMethodsForWhitelistQueryResult = ApolloReactCommon.QueryResult<MollieAllMethodsForWhitelistQuery, MollieAllMethodsForWhitelistQueryVariables>;
export const UpdateAllowedMollieMethodsDocument = gql`
    mutation UpdateAllowedMollieMethods($methods: [String!]!) {
  updateAllowedMollieMethods(methods: $methods) {
    id
    allowedMollieMethods
  }
}
    `;
export type UpdateAllowedMollieMethodsMutationFn = ApolloReactCommon.MutationFunction<UpdateAllowedMollieMethodsMutation, UpdateAllowedMollieMethodsMutationVariables>;

/**
 * __useUpdateAllowedMollieMethodsMutation__
 *
 * To run a mutation, you first call `useUpdateAllowedMollieMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowedMollieMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowedMollieMethodsMutation, { data, loading, error }] = useUpdateAllowedMollieMethodsMutation({
 *   variables: {
 *      methods: // value for 'methods'
 *   },
 * });
 */
export function useUpdateAllowedMollieMethodsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAllowedMollieMethodsMutation, UpdateAllowedMollieMethodsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAllowedMollieMethodsMutation, UpdateAllowedMollieMethodsMutationVariables>(UpdateAllowedMollieMethodsDocument, baseOptions);
      }
export type UpdateAllowedMollieMethodsMutationHookResult = ReturnType<typeof useUpdateAllowedMollieMethodsMutation>;
export type UpdateAllowedMollieMethodsMutationResult = ApolloReactCommon.MutationResult<UpdateAllowedMollieMethodsMutation>;
export type UpdateAllowedMollieMethodsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAllowedMollieMethodsMutation, UpdateAllowedMollieMethodsMutationVariables>;
export const MollieDowngradeImpactDocument = gql`
    query MollieDowngradeImpact($koOrganizationId: ID!) {
  mollieDowngradeImpact(koOrganizationId: $koOrganizationId) {
    openMolliePayments
    activePaymentLinks
    affectedBookers
  }
}
    `;

/**
 * __useMollieDowngradeImpactQuery__
 *
 * To run a query within a React component, call `useMollieDowngradeImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useMollieDowngradeImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMollieDowngradeImpactQuery({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useMollieDowngradeImpactQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MollieDowngradeImpactQuery, MollieDowngradeImpactQueryVariables>) {
        return ApolloReactHooks.useQuery<MollieDowngradeImpactQuery, MollieDowngradeImpactQueryVariables>(MollieDowngradeImpactDocument, baseOptions);
      }
export function useMollieDowngradeImpactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MollieDowngradeImpactQuery, MollieDowngradeImpactQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MollieDowngradeImpactQuery, MollieDowngradeImpactQueryVariables>(MollieDowngradeImpactDocument, baseOptions);
        }
export type MollieDowngradeImpactQueryHookResult = ReturnType<typeof useMollieDowngradeImpactQuery>;
export type MollieDowngradeImpactLazyQueryHookResult = ReturnType<typeof useMollieDowngradeImpactLazyQuery>;
export type MollieDowngradeImpactQueryResult = ApolloReactCommon.QueryResult<MollieDowngradeImpactQuery, MollieDowngradeImpactQueryVariables>;
export const GetAppSettingsDocument = gql`
    query GetAppSettings {
  settings {
    id
    courseNumberFormat
    customerNumberPrefix
    invoiceNumberPrefix
    currency
    grossNet
    defaultVat
    cash
    bankTransfer
    sepaDebit
    esr
    restrictStaffPaymentMethods
    newCustomerDetectionEnabled
    featureMollie
    invoiceDueDays
    firstInstallmentDayOfMonth
    firstInstallmentMonth
    vatAppearance
    holidayStateCode
    holidayStateColor
    holidayCountryCode
    sevenIoApiKey
    smsSenderName
    sendReversalInvoice
    sepaDebitProvider
    bankTransferProvider
    enabledMollieMethods
    timezone
    mollieInvoiceSendMode
    mollieRefundMode
    sendPaymentLinkOnAdminBooking
    autoSendMollieReminderMails
    autoIssuePaymentLinkOnExpiry
    paymentLinkValidityDays
    dunningReminderEnabled
    dunningReminderDays
    dunningLevel1Enabled
    dunningLevel1Days
    dunningLevel1Fee
    dunningLevel2Enabled
    dunningLevel2Days
    dunningLevel2Fee
    dunningLevel3Enabled
    dunningLevel3Days
    dunningLevel3Fee
    dunningNewDueDays
    dunningAttachInvoice
    cancelationFeeDefault
    courseEditCorrectionInvoice
    courseEditCorrectionInvoiceMail
    transferMode
    transferDefaultPriceOption
    transferDefaultOldBookingOption
    transferSendMail
  }
}
    `;

/**
 * __useGetAppSettingsQuery__
 *
 * To run a query within a React component, call `useGetAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAppSettingsQuery, GetAppSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAppSettingsQuery, GetAppSettingsQueryVariables>(GetAppSettingsDocument, baseOptions);
      }
export function useGetAppSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAppSettingsQuery, GetAppSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAppSettingsQuery, GetAppSettingsQueryVariables>(GetAppSettingsDocument, baseOptions);
        }
export type GetAppSettingsQueryHookResult = ReturnType<typeof useGetAppSettingsQuery>;
export type GetAppSettingsLazyQueryHookResult = ReturnType<typeof useGetAppSettingsLazyQuery>;
export type GetAppSettingsQueryResult = ApolloReactCommon.QueryResult<GetAppSettingsQuery, GetAppSettingsQueryVariables>;
export const GetAppSettingsInvoiceDueDaysDocument = gql`
    query GetAppSettingsInvoiceDueDays {
  settings {
    id
    invoiceDueDays
  }
}
    `;

/**
 * __useGetAppSettingsInvoiceDueDaysQuery__
 *
 * To run a query within a React component, call `useGetAppSettingsInvoiceDueDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppSettingsInvoiceDueDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppSettingsInvoiceDueDaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppSettingsInvoiceDueDaysQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAppSettingsInvoiceDueDaysQuery, GetAppSettingsInvoiceDueDaysQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAppSettingsInvoiceDueDaysQuery, GetAppSettingsInvoiceDueDaysQueryVariables>(GetAppSettingsInvoiceDueDaysDocument, baseOptions);
      }
export function useGetAppSettingsInvoiceDueDaysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAppSettingsInvoiceDueDaysQuery, GetAppSettingsInvoiceDueDaysQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAppSettingsInvoiceDueDaysQuery, GetAppSettingsInvoiceDueDaysQueryVariables>(GetAppSettingsInvoiceDueDaysDocument, baseOptions);
        }
export type GetAppSettingsInvoiceDueDaysQueryHookResult = ReturnType<typeof useGetAppSettingsInvoiceDueDaysQuery>;
export type GetAppSettingsInvoiceDueDaysLazyQueryHookResult = ReturnType<typeof useGetAppSettingsInvoiceDueDaysLazyQuery>;
export type GetAppSettingsInvoiceDueDaysQueryResult = ApolloReactCommon.QueryResult<GetAppSettingsInvoiceDueDaysQuery, GetAppSettingsInvoiceDueDaysQueryVariables>;
export const GetCourseNumberFormatDocument = gql`
    query GetCourseNumberFormat {
  settings {
    courseNumberFormat
  }
}
    `;

/**
 * __useGetCourseNumberFormatQuery__
 *
 * To run a query within a React component, call `useGetCourseNumberFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseNumberFormatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseNumberFormatQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseNumberFormatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCourseNumberFormatQuery, GetCourseNumberFormatQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCourseNumberFormatQuery, GetCourseNumberFormatQueryVariables>(GetCourseNumberFormatDocument, baseOptions);
      }
export function useGetCourseNumberFormatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseNumberFormatQuery, GetCourseNumberFormatQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCourseNumberFormatQuery, GetCourseNumberFormatQueryVariables>(GetCourseNumberFormatDocument, baseOptions);
        }
export type GetCourseNumberFormatQueryHookResult = ReturnType<typeof useGetCourseNumberFormatQuery>;
export type GetCourseNumberFormatLazyQueryHookResult = ReturnType<typeof useGetCourseNumberFormatLazyQuery>;
export type GetCourseNumberFormatQueryResult = ApolloReactCommon.QueryResult<GetCourseNumberFormatQuery, GetCourseNumberFormatQueryVariables>;
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($newSettingsData: SettingInput!) {
  updateSettings(newSettingsData: $newSettingsData) {
    id
    courseNumberFormat
    customerNumberPrefix
    invoiceNumberPrefix
    currency
    grossNet
    defaultVat
    cash
    bankTransfer
    sepaDebit
    esr
    restrictStaffPaymentMethods
    newCustomerDetectionEnabled
    invoiceDueDays
    holidayStateCode
    holidayStateColor
    holidayCountryCode
    sendReversalInvoice
    sepaDebitProvider
    bankTransferProvider
    enabledMollieMethods
    timezone
    mollieInvoiceSendMode
    mollieRefundMode
    sendPaymentLinkOnAdminBooking
    autoSendMollieReminderMails
    autoIssuePaymentLinkOnExpiry
    paymentLinkValidityDays
    dunningReminderEnabled
    dunningReminderDays
    dunningLevel1Enabled
    dunningLevel1Days
    dunningLevel1Fee
    dunningLevel2Enabled
    dunningLevel2Days
    dunningLevel2Fee
    dunningLevel3Enabled
    dunningLevel3Days
    dunningLevel3Fee
    dunningNewDueDays
    dunningAttachInvoice
    cancelationFeeDefault
    courseEditCorrectionInvoice
    courseEditCorrectionInvoiceMail
    transferMode
    transferDefaultPriceOption
    transferDefaultOldBookingOption
    transferSendMail
  }
}
    `;
export type UpdateSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      newSettingsData: // value for 'newSettingsData'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, baseOptions);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const GetCompanySettingsDocument = gql`
    query GetCompanySettings {
  companySettings {
    id
    name
    businessForm
    website
    agb
    privacyStatement
    ownerFirstName
    ownerLastName
    ownerStreet
    ownerStreetNumber
    ownerZip
    ownerCity
    ownerCountry
    ownerPhone
    ownerFax
    ownerEmail
    industry
    localCourt
    commercialRegister
    taxId
    taxNumber
    bank
    bankAccountHolder
    IBAN
    BIC
    creditorId
    qrIban
    logo
    koOrganization {
      id
    }
  }
}
    `;

/**
 * __useGetCompanySettingsQuery__
 *
 * To run a query within a React component, call `useGetCompanySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanySettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, baseOptions);
      }
export function useGetCompanySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, baseOptions);
        }
export type GetCompanySettingsQueryHookResult = ReturnType<typeof useGetCompanySettingsQuery>;
export type GetCompanySettingsLazyQueryHookResult = ReturnType<typeof useGetCompanySettingsLazyQuery>;
export type GetCompanySettingsQueryResult = ApolloReactCommon.QueryResult<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>;
export const UpdateCompanySettingsDocument = gql`
    mutation updateCompanySettings($editCompanyData: CompanySettingInput!) {
  updateCompanySettings(newCompanyData: $editCompanyData) {
    id
    name
    businessForm
    website
    agb
    privacyStatement
    ownerFirstName
    ownerLastName
    ownerStreet
    ownerStreetNumber
    ownerZip
    ownerCity
    ownerCountry
    ownerPhone
    ownerFax
    ownerEmail
    industry
    localCourt
    commercialRegister
    taxId
    taxNumber
    bank
    bankAccountHolder
    IBAN
    BIC
    creditorId
    qrIban
  }
}
    `;
export type UpdateCompanySettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>;

/**
 * __useUpdateCompanySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanySettingsMutation, { data, loading, error }] = useUpdateCompanySettingsMutation({
 *   variables: {
 *      editCompanyData: // value for 'editCompanyData'
 *   },
 * });
 */
export function useUpdateCompanySettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>(UpdateCompanySettingsDocument, baseOptions);
      }
export type UpdateCompanySettingsMutationHookResult = ReturnType<typeof useUpdateCompanySettingsMutation>;
export type UpdateCompanySettingsMutationResult = ApolloReactCommon.MutationResult<UpdateCompanySettingsMutation>;
export type UpdateCompanySettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCompanySettingsMutation, UpdateCompanySettingsMutationVariables>;
export const CreateTenantDocument = gql`
    mutation createTenant($koOrganizationData: KoOrganizationInputType!) {
  createOrganization(koOrganizationData: $koOrganizationData) {
    organizationId
    host
    sendFromEmail
    createdAdmins
    adminErrors
  }
}
    `;
export type CreateTenantMutationFn = ApolloReactCommon.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>;

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      koOrganizationData: // value for 'koOrganizationData'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, baseOptions);
      }
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>;
export type CreateTenantMutationResult = ApolloReactCommon.MutationResult<CreateTenantMutation>;
export type CreateTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTenantMutation, CreateTenantMutationVariables>;
export const CreateAndRegisterAdminUserDocument = gql`
    mutation createAndRegisterAdminUser($userInput: UserInput!, $tenantId: String!) {
  createAndRegisterAdmin(userInput: $userInput, tenantId: $tenantId) {
    id
  }
}
    `;
export type CreateAndRegisterAdminUserMutationFn = ApolloReactCommon.MutationFunction<CreateAndRegisterAdminUserMutation, CreateAndRegisterAdminUserMutationVariables>;

/**
 * __useCreateAndRegisterAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAndRegisterAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndRegisterAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndRegisterAdminUserMutation, { data, loading, error }] = useCreateAndRegisterAdminUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCreateAndRegisterAdminUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndRegisterAdminUserMutation, CreateAndRegisterAdminUserMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAndRegisterAdminUserMutation, CreateAndRegisterAdminUserMutationVariables>(CreateAndRegisterAdminUserDocument, baseOptions);
      }
export type CreateAndRegisterAdminUserMutationHookResult = ReturnType<typeof useCreateAndRegisterAdminUserMutation>;
export type CreateAndRegisterAdminUserMutationResult = ApolloReactCommon.MutationResult<CreateAndRegisterAdminUserMutation>;
export type CreateAndRegisterAdminUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAndRegisterAdminUserMutation, CreateAndRegisterAdminUserMutationVariables>;
export const GetTenantsDocument = gql`
    query getTenants {
  koOrganizations {
    id
    name
    subscriptionType
    subscription {
      id
      featureSms
      featureStaffLogin
      featureRefactoredCourseDetails
      featureWeekPlaner
      featurePrerequisiteCourses
      featureExportInstructorLessons
      featureExport
      featureLessonBooking
      featureBillingStatus
      featureAttendanceListBulk
      featureCalendarFeed
      featureAssistantApp
      featureDataExport
      featureWebModulAdminAccess
      featureAreaManager
      featureMailMerge
      featureExtendedBadges
      featureInterestList
      featureHelpLinks
      featureAdditionalItems
      featureAdminManagement
      featureMollie
      featureTransferWizard
      featureDataErasure
      featureBankImport
      featureDiscountCodes
      featureNewsletter
      featureLiveRefresh
      featureDunning
      featureInvoicePdfPuppeteer
      mollieApplicationFeePercent
      mollieApplicationFeeFixed
      holidays
      seatsAdmin
      seatsInstructor
      maxBookingsPerYear
      maxLocations
      monthlyFee
    }
  }
}
    `;

/**
 * __useGetTenantsQuery__
 *
 * To run a query within a React component, call `useGetTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, baseOptions);
      }
export function useGetTenantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, baseOptions);
        }
export type GetTenantsQueryHookResult = ReturnType<typeof useGetTenantsQuery>;
export type GetTenantsLazyQueryHookResult = ReturnType<typeof useGetTenantsLazyQuery>;
export type GetTenantsQueryResult = ApolloReactCommon.QueryResult<GetTenantsQuery, GetTenantsQueryVariables>;
export const GetTenantsWithPaginationDocument = gql`
    query getTenantsWithPagination($options: ArrayDataOptions, $koOrganizationId: String, $searchTerm: String) {
  tenantsWithPagination(options: $options, koOrganizationId: $koOrganizationId, searchTerm: $searchTerm) {
    existsMore
    total
    items {
      id
      name
      subscriptionType
      deletionState
      deactivatedAt
      scheduledDeletionAt
      companySettings {
        host
      }
      subscription {
        id
        featureSms
        featureStaffLogin
        featureRefactoredCourseDetails
        featureWeekPlaner
        featurePrerequisiteCourses
        featureExportInstructorLessons
        featureExport
        featureLessonBooking
        featureBillingStatus
        featureAttendanceListBulk
        featureCalendarFeed
        featureAssistantApp
        featureDataExport
        featureWebModulAdminAccess
        featureAreaManager
        featureMailMerge
        featureExtendedBadges
        featureInterestList
        featureHelpLinks
        featureAdditionalItems
        featureAdminManagement
        featureMollie
        featureTransferWizard
        featureDataErasure
        featureBankImport
        featureDiscountCodes
        featureNewsletter
        featureLiveRefresh
        featureDunning
        featureInvoicePdfPuppeteer
        mollieApplicationFeePercent
        mollieApplicationFeeFixed
        holidays
        seatsAdmin
        seatsInstructor
        maxBookingsPerYear
        maxLocations
        monthlyFee
      }
    }
  }
}
    `;

/**
 * __useGetTenantsWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetTenantsWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsWithPaginationQuery({
 *   variables: {
 *      options: // value for 'options'
 *      koOrganizationId: // value for 'koOrganizationId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetTenantsWithPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantsWithPaginationQuery, GetTenantsWithPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantsWithPaginationQuery, GetTenantsWithPaginationQueryVariables>(GetTenantsWithPaginationDocument, baseOptions);
      }
export function useGetTenantsWithPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantsWithPaginationQuery, GetTenantsWithPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantsWithPaginationQuery, GetTenantsWithPaginationQueryVariables>(GetTenantsWithPaginationDocument, baseOptions);
        }
export type GetTenantsWithPaginationQueryHookResult = ReturnType<typeof useGetTenantsWithPaginationQuery>;
export type GetTenantsWithPaginationLazyQueryHookResult = ReturnType<typeof useGetTenantsWithPaginationLazyQuery>;
export type GetTenantsWithPaginationQueryResult = ApolloReactCommon.QueryResult<GetTenantsWithPaginationQuery, GetTenantsWithPaginationQueryVariables>;
export const GetCompanyDocument = gql`
    query GetCompany {
  companySettings {
    id
    name
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
      }
export function useGetCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = ApolloReactCommon.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyInfoDocument = gql`
    query GetCompanyInfo {
  companyInfo {
    id
    name
    subscriptionType
    subscription {
      seatsAdmin
      seatsInstructor
      featureSms
      featureRefactoredCourseDetails
      featureStaffLogin
      featureWeekPlaner
      featurePrerequisiteCourses
      featureExportInstructorLessons
      featureBillingStatus
      featureAttendanceListBulk
      featureCalendarFeed
      featureExport
      featureLessonBooking
      featureAssistantApp
      featureDataExport
      featureWebModulAdminAccess
      featureAreaManager
      featureMailMerge
      featureExtendedBadges
      featureInterestList
      featureHelpLinks
      featureAdditionalItems
      featureAdminManagement
      featureMollie
      featureTransferWizard
      featureDataErasure
      featureBankImport
      featureDiscountCodes
      featureNewsletter
      featureLiveRefresh
      featureDunning
      featureInvoicePdfPuppeteer
      holidays
      mollieApplicationFeePercent
      mollieApplicationFeeFixed
      monthlyFee
    }
    companySettings {
      logo
    }
  }
}
    `;

/**
 * __useGetCompanyInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, baseOptions);
      }
export function useGetCompanyInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, baseOptions);
        }
export type GetCompanyInfoQueryHookResult = ReturnType<typeof useGetCompanyInfoQuery>;
export type GetCompanyInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoLazyQuery>;
export type GetCompanyInfoQueryResult = ApolloReactCommon.QueryResult<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>;
export const GetOwnerEmailDocument = gql`
    query GetOwnerEmail {
  ownerEmail {
    id
    ownerEmail
  }
}
    `;

/**
 * __useGetOwnerEmailQuery__
 *
 * To run a query within a React component, call `useGetOwnerEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnerEmailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOwnerEmailQuery, GetOwnerEmailQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOwnerEmailQuery, GetOwnerEmailQueryVariables>(GetOwnerEmailDocument, baseOptions);
      }
export function useGetOwnerEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOwnerEmailQuery, GetOwnerEmailQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOwnerEmailQuery, GetOwnerEmailQueryVariables>(GetOwnerEmailDocument, baseOptions);
        }
export type GetOwnerEmailQueryHookResult = ReturnType<typeof useGetOwnerEmailQuery>;
export type GetOwnerEmailLazyQueryHookResult = ReturnType<typeof useGetOwnerEmailLazyQuery>;
export type GetOwnerEmailQueryResult = ApolloReactCommon.QueryResult<GetOwnerEmailQuery, GetOwnerEmailQueryVariables>;
export const GetCompanyPublicDocument = gql`
    query GetCompanyPublic {
  companyPublic {
    name
    host
    website
    agb
    privacyStatement
  }
}
    `;

/**
 * __useGetCompanyPublicQuery__
 *
 * To run a query within a React component, call `useGetCompanyPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPublicQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyPublicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyPublicQuery, GetCompanyPublicQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyPublicQuery, GetCompanyPublicQueryVariables>(GetCompanyPublicDocument, baseOptions);
      }
export function useGetCompanyPublicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyPublicQuery, GetCompanyPublicQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyPublicQuery, GetCompanyPublicQueryVariables>(GetCompanyPublicDocument, baseOptions);
        }
export type GetCompanyPublicQueryHookResult = ReturnType<typeof useGetCompanyPublicQuery>;
export type GetCompanyPublicLazyQueryHookResult = ReturnType<typeof useGetCompanyPublicLazyQuery>;
export type GetCompanyPublicQueryResult = ApolloReactCommon.QueryResult<GetCompanyPublicQuery, GetCompanyPublicQueryVariables>;
export const GetCurrencySettingDocument = gql`
    query GetCurrencySetting {
  settings {
    currency
  }
}
    `;

/**
 * __useGetCurrencySettingQuery__
 *
 * To run a query within a React component, call `useGetCurrencySettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencySettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencySettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencySettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrencySettingQuery, GetCurrencySettingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrencySettingQuery, GetCurrencySettingQueryVariables>(GetCurrencySettingDocument, baseOptions);
      }
export function useGetCurrencySettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrencySettingQuery, GetCurrencySettingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrencySettingQuery, GetCurrencySettingQueryVariables>(GetCurrencySettingDocument, baseOptions);
        }
export type GetCurrencySettingQueryHookResult = ReturnType<typeof useGetCurrencySettingQuery>;
export type GetCurrencySettingLazyQueryHookResult = ReturnType<typeof useGetCurrencySettingLazyQuery>;
export type GetCurrencySettingQueryResult = ApolloReactCommon.QueryResult<GetCurrencySettingQuery, GetCurrencySettingQueryVariables>;
export const UpdateCompanyAgbDocument = gql`
    mutation UpdateCompanyAgb($agb: String!) {
  updateCompanyAgb(agb: $agb) {
    agb
  }
}
    `;
export type UpdateCompanyAgbMutationFn = ApolloReactCommon.MutationFunction<UpdateCompanyAgbMutation, UpdateCompanyAgbMutationVariables>;

/**
 * __useUpdateCompanyAgbMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAgbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAgbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAgbMutation, { data, loading, error }] = useUpdateCompanyAgbMutation({
 *   variables: {
 *      agb: // value for 'agb'
 *   },
 * });
 */
export function useUpdateCompanyAgbMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompanyAgbMutation, UpdateCompanyAgbMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCompanyAgbMutation, UpdateCompanyAgbMutationVariables>(UpdateCompanyAgbDocument, baseOptions);
      }
export type UpdateCompanyAgbMutationHookResult = ReturnType<typeof useUpdateCompanyAgbMutation>;
export type UpdateCompanyAgbMutationResult = ApolloReactCommon.MutationResult<UpdateCompanyAgbMutation>;
export type UpdateCompanyAgbMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCompanyAgbMutation, UpdateCompanyAgbMutationVariables>;
export const UpdateCompanyPrivacyStatementDocument = gql`
    mutation UpdateCompanyPrivacyStatement($privacyStatement: String!) {
  updateCompanyPrivacyStatement(privacyStatement: $privacyStatement) {
    privacyStatement
  }
}
    `;
export type UpdateCompanyPrivacyStatementMutationFn = ApolloReactCommon.MutationFunction<UpdateCompanyPrivacyStatementMutation, UpdateCompanyPrivacyStatementMutationVariables>;

/**
 * __useUpdateCompanyPrivacyStatementMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyPrivacyStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyPrivacyStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyPrivacyStatementMutation, { data, loading, error }] = useUpdateCompanyPrivacyStatementMutation({
 *   variables: {
 *      privacyStatement: // value for 'privacyStatement'
 *   },
 * });
 */
export function useUpdateCompanyPrivacyStatementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompanyPrivacyStatementMutation, UpdateCompanyPrivacyStatementMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCompanyPrivacyStatementMutation, UpdateCompanyPrivacyStatementMutationVariables>(UpdateCompanyPrivacyStatementDocument, baseOptions);
      }
export type UpdateCompanyPrivacyStatementMutationHookResult = ReturnType<typeof useUpdateCompanyPrivacyStatementMutation>;
export type UpdateCompanyPrivacyStatementMutationResult = ApolloReactCommon.MutationResult<UpdateCompanyPrivacyStatementMutation>;
export type UpdateCompanyPrivacyStatementMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCompanyPrivacyStatementMutation, UpdateCompanyPrivacyStatementMutationVariables>;
export const UpdateSubscriptionFeaturesDocument = gql`
    mutation UpdateSubscriptionFeatures($subscriptionId: ID!, $features: SubscriptionFeaturesInput!) {
  updateSubscriptionFeatures(subscriptionId: $subscriptionId, features: $features) {
    id
    featureSms
    featureStaffLogin
    featureRefactoredCourseDetails
    featureWeekPlaner
    featurePrerequisiteCourses
    featureExportInstructorLessons
    featureExport
    featureBillingStatus
    featureAttendanceListBulk
    featureCalendarFeed
    featureAssistantApp
    featureDataExport
    featureWebModulAdminAccess
    featureAreaManager
    featureMailMerge
    featureExtendedBadges
    featureInterestList
    featureHelpLinks
    featureAdditionalItems
    featureAdminManagement
    featureMollie
    featureTransferWizard
    featureDataErasure
    featureBankImport
    featureDiscountCodes
    featureNewsletter
    featureLiveRefresh
    featureDunning
    featureInvoicePdfPuppeteer
    mollieApplicationFeePercent
    mollieApplicationFeeFixed
    holidays
    seatsAdmin
    seatsInstructor
    maxBookingsPerYear
    maxLocations
    monthlyFee
  }
}
    `;
export type UpdateSubscriptionFeaturesMutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionFeaturesMutation, UpdateSubscriptionFeaturesMutationVariables>;

/**
 * __useUpdateSubscriptionFeaturesMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionFeaturesMutation, { data, loading, error }] = useUpdateSubscriptionFeaturesMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      features: // value for 'features'
 *   },
 * });
 */
export function useUpdateSubscriptionFeaturesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionFeaturesMutation, UpdateSubscriptionFeaturesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSubscriptionFeaturesMutation, UpdateSubscriptionFeaturesMutationVariables>(UpdateSubscriptionFeaturesDocument, baseOptions);
      }
export type UpdateSubscriptionFeaturesMutationHookResult = ReturnType<typeof useUpdateSubscriptionFeaturesMutation>;
export type UpdateSubscriptionFeaturesMutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionFeaturesMutation>;
export type UpdateSubscriptionFeaturesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionFeaturesMutation, UpdateSubscriptionFeaturesMutationVariables>;
export const GetTenantUsersDocument = gql`
    query GetTenantUsers($tenantId: ID!) {
  getTenantUsers(tenantId: $tenantId) {
    id
    firstName
    lastName
    email
    roles
  }
}
    `;

/**
 * __useGetTenantUsersQuery__
 *
 * To run a query within a React component, call `useGetTenantUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantUsersQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetTenantUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantUsersQuery, GetTenantUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantUsersQuery, GetTenantUsersQueryVariables>(GetTenantUsersDocument, baseOptions);
      }
export function useGetTenantUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantUsersQuery, GetTenantUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantUsersQuery, GetTenantUsersQueryVariables>(GetTenantUsersDocument, baseOptions);
        }
export type GetTenantUsersQueryHookResult = ReturnType<typeof useGetTenantUsersQuery>;
export type GetTenantUsersLazyQueryHookResult = ReturnType<typeof useGetTenantUsersLazyQuery>;
export type GetTenantUsersQueryResult = ApolloReactCommon.QueryResult<GetTenantUsersQuery, GetTenantUsersQueryVariables>;
export const UpdateOrganizationSubscriptionTypeDocument = gql`
    mutation UpdateOrganizationSubscriptionType($koOrganizationId: ID!, $subscriptionType: SubscriptionType!) {
  updateOrganizationSubscriptionType(koOrganizationId: $koOrganizationId, subscriptionType: $subscriptionType) {
    id
    subscriptionType
  }
}
    `;
export type UpdateOrganizationSubscriptionTypeMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationSubscriptionTypeMutation, UpdateOrganizationSubscriptionTypeMutationVariables>;

/**
 * __useUpdateOrganizationSubscriptionTypeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSubscriptionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSubscriptionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSubscriptionTypeMutation, { data, loading, error }] = useUpdateOrganizationSubscriptionTypeMutation({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *      subscriptionType: // value for 'subscriptionType'
 *   },
 * });
 */
export function useUpdateOrganizationSubscriptionTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationSubscriptionTypeMutation, UpdateOrganizationSubscriptionTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrganizationSubscriptionTypeMutation, UpdateOrganizationSubscriptionTypeMutationVariables>(UpdateOrganizationSubscriptionTypeDocument, baseOptions);
      }
export type UpdateOrganizationSubscriptionTypeMutationHookResult = ReturnType<typeof useUpdateOrganizationSubscriptionTypeMutation>;
export type UpdateOrganizationSubscriptionTypeMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationSubscriptionTypeMutation>;
export type UpdateOrganizationSubscriptionTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationSubscriptionTypeMutation, UpdateOrganizationSubscriptionTypeMutationVariables>;
export const GetTenantActivitySummariesDocument = gql`
    query GetTenantActivitySummaries {
  tenantActivitySummaries {
    koOrganizationId
    tenantName
    totalCourses
    activeCourses
    totalBookings
    totalAttendees
    totalInvoices
    lastLoginDate
    lastDataModification
    lastBookingCreated
    lastInvoiceCreated
    lastCourseCreated
    activityStatus
    daysSinceLastActivity
  }
}
    `;

/**
 * __useGetTenantActivitySummariesQuery__
 *
 * To run a query within a React component, call `useGetTenantActivitySummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantActivitySummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantActivitySummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantActivitySummariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantActivitySummariesQuery, GetTenantActivitySummariesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantActivitySummariesQuery, GetTenantActivitySummariesQueryVariables>(GetTenantActivitySummariesDocument, baseOptions);
      }
export function useGetTenantActivitySummariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantActivitySummariesQuery, GetTenantActivitySummariesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantActivitySummariesQuery, GetTenantActivitySummariesQueryVariables>(GetTenantActivitySummariesDocument, baseOptions);
        }
export type GetTenantActivitySummariesQueryHookResult = ReturnType<typeof useGetTenantActivitySummariesQuery>;
export type GetTenantActivitySummariesLazyQueryHookResult = ReturnType<typeof useGetTenantActivitySummariesLazyQuery>;
export type GetTenantActivitySummariesQueryResult = ApolloReactCommon.QueryResult<GetTenantActivitySummariesQuery, GetTenantActivitySummariesQueryVariables>;
export const GetTenantActivitySummaryDocument = gql`
    query GetTenantActivitySummary($koOrganizationId: ID!) {
  tenantActivitySummary(koOrganizationId: $koOrganizationId) {
    koOrganizationId
    tenantName
    totalCourses
    activeCourses
    totalBookings
    totalAttendees
    totalInvoices
    lastLoginDate
    lastDataModification
    lastBookingCreated
    lastInvoiceCreated
    lastCourseCreated
    activityStatus
    daysSinceLastActivity
  }
}
    `;

/**
 * __useGetTenantActivitySummaryQuery__
 *
 * To run a query within a React component, call `useGetTenantActivitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantActivitySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantActivitySummaryQuery({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useGetTenantActivitySummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantActivitySummaryQuery, GetTenantActivitySummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantActivitySummaryQuery, GetTenantActivitySummaryQueryVariables>(GetTenantActivitySummaryDocument, baseOptions);
      }
export function useGetTenantActivitySummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantActivitySummaryQuery, GetTenantActivitySummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantActivitySummaryQuery, GetTenantActivitySummaryQueryVariables>(GetTenantActivitySummaryDocument, baseOptions);
        }
export type GetTenantActivitySummaryQueryHookResult = ReturnType<typeof useGetTenantActivitySummaryQuery>;
export type GetTenantActivitySummaryLazyQueryHookResult = ReturnType<typeof useGetTenantActivitySummaryLazyQuery>;
export type GetTenantActivitySummaryQueryResult = ApolloReactCommon.QueryResult<GetTenantActivitySummaryQuery, GetTenantActivitySummaryQueryVariables>;
export const GetTenantDeletionImpactDocument = gql`
    query GetTenantDeletionImpact($koOrganizationId: ID!) {
  tenantDeletionImpact(koOrganizationId: $koOrganizationId) {
    koOrganizationId
    tenantName
    totalDatabaseRecords
    entityCounts {
      name
      count
    }
  }
}
    `;

/**
 * __useGetTenantDeletionImpactQuery__
 *
 * To run a query within a React component, call `useGetTenantDeletionImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantDeletionImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantDeletionImpactQuery({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useGetTenantDeletionImpactQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantDeletionImpactQuery, GetTenantDeletionImpactQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantDeletionImpactQuery, GetTenantDeletionImpactQueryVariables>(GetTenantDeletionImpactDocument, baseOptions);
      }
export function useGetTenantDeletionImpactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantDeletionImpactQuery, GetTenantDeletionImpactQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantDeletionImpactQuery, GetTenantDeletionImpactQueryVariables>(GetTenantDeletionImpactDocument, baseOptions);
        }
export type GetTenantDeletionImpactQueryHookResult = ReturnType<typeof useGetTenantDeletionImpactQuery>;
export type GetTenantDeletionImpactLazyQueryHookResult = ReturnType<typeof useGetTenantDeletionImpactLazyQuery>;
export type GetTenantDeletionImpactQueryResult = ApolloReactCommon.QueryResult<GetTenantDeletionImpactQuery, GetTenantDeletionImpactQueryVariables>;
export const DeactivateTenantDocument = gql`
    mutation DeactivateTenant($koOrganizationId: ID!) {
  deactivateTenant(koOrganizationId: $koOrganizationId) {
    id
    name
    isActive
    deletionState
    deactivatedAt
    scheduledDeletionAt
  }
}
    `;
export type DeactivateTenantMutationFn = ApolloReactCommon.MutationFunction<DeactivateTenantMutation, DeactivateTenantMutationVariables>;

/**
 * __useDeactivateTenantMutation__
 *
 * To run a mutation, you first call `useDeactivateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTenantMutation, { data, loading, error }] = useDeactivateTenantMutation({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useDeactivateTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateTenantMutation, DeactivateTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<DeactivateTenantMutation, DeactivateTenantMutationVariables>(DeactivateTenantDocument, baseOptions);
      }
export type DeactivateTenantMutationHookResult = ReturnType<typeof useDeactivateTenantMutation>;
export type DeactivateTenantMutationResult = ApolloReactCommon.MutationResult<DeactivateTenantMutation>;
export type DeactivateTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateTenantMutation, DeactivateTenantMutationVariables>;
export const ReactivateTenantDocument = gql`
    mutation ReactivateTenant($koOrganizationId: ID!) {
  reactivateTenant(koOrganizationId: $koOrganizationId) {
    id
    name
    isActive
    deletionState
  }
}
    `;
export type ReactivateTenantMutationFn = ApolloReactCommon.MutationFunction<ReactivateTenantMutation, ReactivateTenantMutationVariables>;

/**
 * __useReactivateTenantMutation__
 *
 * To run a mutation, you first call `useReactivateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateTenantMutation, { data, loading, error }] = useReactivateTenantMutation({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useReactivateTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactivateTenantMutation, ReactivateTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactivateTenantMutation, ReactivateTenantMutationVariables>(ReactivateTenantDocument, baseOptions);
      }
export type ReactivateTenantMutationHookResult = ReturnType<typeof useReactivateTenantMutation>;
export type ReactivateTenantMutationResult = ApolloReactCommon.MutationResult<ReactivateTenantMutation>;
export type ReactivateTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactivateTenantMutation, ReactivateTenantMutationVariables>;
export const HardDeleteTenantDocument = gql`
    mutation HardDeleteTenant($koOrganizationId: ID!, $confirmationCode: String!) {
  hardDeleteTenant(koOrganizationId: $koOrganizationId, confirmationCode: $confirmationCode) {
    success
    tenantName
    deletedRecordCounts {
      name
      count
    }
    errors
    startedAsync
  }
}
    `;
export type HardDeleteTenantMutationFn = ApolloReactCommon.MutationFunction<HardDeleteTenantMutation, HardDeleteTenantMutationVariables>;

/**
 * __useHardDeleteTenantMutation__
 *
 * To run a mutation, you first call `useHardDeleteTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHardDeleteTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hardDeleteTenantMutation, { data, loading, error }] = useHardDeleteTenantMutation({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *      confirmationCode: // value for 'confirmationCode'
 *   },
 * });
 */
export function useHardDeleteTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HardDeleteTenantMutation, HardDeleteTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<HardDeleteTenantMutation, HardDeleteTenantMutationVariables>(HardDeleteTenantDocument, baseOptions);
      }
export type HardDeleteTenantMutationHookResult = ReturnType<typeof useHardDeleteTenantMutation>;
export type HardDeleteTenantMutationResult = ApolloReactCommon.MutationResult<HardDeleteTenantMutation>;
export type HardDeleteTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<HardDeleteTenantMutation, HardDeleteTenantMutationVariables>;
export const GetTenantDeletionStatusDocument = gql`
    query GetTenantDeletionStatus($koOrganizationId: ID!) {
  tenantDeletionStatus(koOrganizationId: $koOrganizationId) {
    deletionState
    lastAction
    lastStepName
    lastErrorMessage
    deletedRecordCounts {
      name
      count
    }
    externalErrors
  }
}
    `;

/**
 * __useGetTenantDeletionStatusQuery__
 *
 * To run a query within a React component, call `useGetTenantDeletionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantDeletionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantDeletionStatusQuery({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *   },
 * });
 */
export function useGetTenantDeletionStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantDeletionStatusQuery, GetTenantDeletionStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantDeletionStatusQuery, GetTenantDeletionStatusQueryVariables>(GetTenantDeletionStatusDocument, baseOptions);
      }
export function useGetTenantDeletionStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantDeletionStatusQuery, GetTenantDeletionStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantDeletionStatusQuery, GetTenantDeletionStatusQueryVariables>(GetTenantDeletionStatusDocument, baseOptions);
        }
export type GetTenantDeletionStatusQueryHookResult = ReturnType<typeof useGetTenantDeletionStatusQuery>;
export type GetTenantDeletionStatusLazyQueryHookResult = ReturnType<typeof useGetTenantDeletionStatusLazyQuery>;
export type GetTenantDeletionStatusQueryResult = ApolloReactCommon.QueryResult<GetTenantDeletionStatusQuery, GetTenantDeletionStatusQueryVariables>;
export const GetTenantMetricsDocument = gql`
    query GetTenantMetrics($from: DateTime!, $to: DateTime!) {
  tenantMetrics(from: $from, to: $to) {
    koOrganizationId
    tenantName
    subscriptionType
    monthlyFee
    courses
    bookings
    bookingsOnline
    bookingsAdmin
    waitlist
    cancellations
    emailsSent
    revenuePaid
    bookingVolume
    bookersTotal
    bookersTotalOnline
    newBookers
    newBookersOnline
    seatsAdmin
    seatsInstructor
    maxBookingsPerYear
    maxLocations
    bookingsCurrentYear
    locationsCount
  }
}
    `;

/**
 * __useGetTenantMetricsQuery__
 *
 * To run a query within a React component, call `useGetTenantMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetTenantMetricsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantMetricsQuery, GetTenantMetricsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantMetricsQuery, GetTenantMetricsQueryVariables>(GetTenantMetricsDocument, baseOptions);
      }
export function useGetTenantMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantMetricsQuery, GetTenantMetricsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantMetricsQuery, GetTenantMetricsQueryVariables>(GetTenantMetricsDocument, baseOptions);
        }
export type GetTenantMetricsQueryHookResult = ReturnType<typeof useGetTenantMetricsQuery>;
export type GetTenantMetricsLazyQueryHookResult = ReturnType<typeof useGetTenantMetricsLazyQuery>;
export type GetTenantMetricsQueryResult = ApolloReactCommon.QueryResult<GetTenantMetricsQuery, GetTenantMetricsQueryVariables>;
export const GetTenantSeatUsageDocument = gql`
    query GetTenantSeatUsage {
  tenantSeatUsage {
    koOrganizationId
    adminCount
    instructorCount
  }
}
    `;

/**
 * __useGetTenantSeatUsageQuery__
 *
 * To run a query within a React component, call `useGetTenantSeatUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSeatUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSeatUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantSeatUsageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantSeatUsageQuery, GetTenantSeatUsageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantSeatUsageQuery, GetTenantSeatUsageQueryVariables>(GetTenantSeatUsageDocument, baseOptions);
      }
export function useGetTenantSeatUsageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantSeatUsageQuery, GetTenantSeatUsageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantSeatUsageQuery, GetTenantSeatUsageQueryVariables>(GetTenantSeatUsageDocument, baseOptions);
        }
export type GetTenantSeatUsageQueryHookResult = ReturnType<typeof useGetTenantSeatUsageQuery>;
export type GetTenantSeatUsageLazyQueryHookResult = ReturnType<typeof useGetTenantSeatUsageLazyQuery>;
export type GetTenantSeatUsageQueryResult = ApolloReactCommon.QueryResult<GetTenantSeatUsageQuery, GetTenantSeatUsageQueryVariables>;
export const GetTenantStaffMetricsDocument = gql`
    query GetTenantStaffMetrics($koOrganizationId: ID!, $from: DateTime!, $to: DateTime!) {
  tenantStaffMetrics(koOrganizationId: $koOrganizationId, from: $from, to: $to) {
    userId
    email
    firstName
    lastName
    roles
    lastLogin
    activeDays
    actionCount
  }
}
    `;

/**
 * __useGetTenantStaffMetricsQuery__
 *
 * To run a query within a React component, call `useGetTenantStaffMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantStaffMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantStaffMetricsQuery({
 *   variables: {
 *      koOrganizationId: // value for 'koOrganizationId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetTenantStaffMetricsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantStaffMetricsQuery, GetTenantStaffMetricsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantStaffMetricsQuery, GetTenantStaffMetricsQueryVariables>(GetTenantStaffMetricsDocument, baseOptions);
      }
export function useGetTenantStaffMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantStaffMetricsQuery, GetTenantStaffMetricsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantStaffMetricsQuery, GetTenantStaffMetricsQueryVariables>(GetTenantStaffMetricsDocument, baseOptions);
        }
export type GetTenantStaffMetricsQueryHookResult = ReturnType<typeof useGetTenantStaffMetricsQuery>;
export type GetTenantStaffMetricsLazyQueryHookResult = ReturnType<typeof useGetTenantStaffMetricsLazyQuery>;
export type GetTenantStaffMetricsQueryResult = ApolloReactCommon.QueryResult<GetTenantStaffMetricsQuery, GetTenantStaffMetricsQueryVariables>;
export const GetTenantMetricsAiSummaryDocument = gql`
    query GetTenantMetricsAiSummary {
  tenantMetricsAiSummary {
    status
    message
    headline
    generatedAt
    dataThrough
    isAiGenerated
    insights {
      observationRef
      category
      severity
      title
      explanation
      tenantName
      evidence {
        factRef
        scope
        tenantId
        tenantName
        metric
        windowDays
        currentValue
        previousValue
        changePercent
        direction
        unit
        currency
      }
    }
    caveats
  }
}
    `;

/**
 * __useGetTenantMetricsAiSummaryQuery__
 *
 * To run a query within a React component, call `useGetTenantMetricsAiSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantMetricsAiSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantMetricsAiSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantMetricsAiSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantMetricsAiSummaryQuery, GetTenantMetricsAiSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantMetricsAiSummaryQuery, GetTenantMetricsAiSummaryQueryVariables>(GetTenantMetricsAiSummaryDocument, baseOptions);
      }
export function useGetTenantMetricsAiSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantMetricsAiSummaryQuery, GetTenantMetricsAiSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantMetricsAiSummaryQuery, GetTenantMetricsAiSummaryQueryVariables>(GetTenantMetricsAiSummaryDocument, baseOptions);
        }
export type GetTenantMetricsAiSummaryQueryHookResult = ReturnType<typeof useGetTenantMetricsAiSummaryQuery>;
export type GetTenantMetricsAiSummaryLazyQueryHookResult = ReturnType<typeof useGetTenantMetricsAiSummaryLazyQuery>;
export type GetTenantMetricsAiSummaryQueryResult = ApolloReactCommon.QueryResult<GetTenantMetricsAiSummaryQuery, GetTenantMetricsAiSummaryQueryVariables>;
export const RetryTenantMetricsAiSummaryDocument = gql`
    mutation RetryTenantMetricsAiSummary {
  retryTenantMetricsAiSummary {
    status
    message
  }
}
    `;
export type RetryTenantMetricsAiSummaryMutationFn = ApolloReactCommon.MutationFunction<RetryTenantMetricsAiSummaryMutation, RetryTenantMetricsAiSummaryMutationVariables>;

/**
 * __useRetryTenantMetricsAiSummaryMutation__
 *
 * To run a mutation, you first call `useRetryTenantMetricsAiSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryTenantMetricsAiSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryTenantMetricsAiSummaryMutation, { data, loading, error }] = useRetryTenantMetricsAiSummaryMutation({
 *   variables: {
 *   },
 * });
 */
export function useRetryTenantMetricsAiSummaryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetryTenantMetricsAiSummaryMutation, RetryTenantMetricsAiSummaryMutationVariables>) {
        return ApolloReactHooks.useMutation<RetryTenantMetricsAiSummaryMutation, RetryTenantMetricsAiSummaryMutationVariables>(RetryTenantMetricsAiSummaryDocument, baseOptions);
      }
export type RetryTenantMetricsAiSummaryMutationHookResult = ReturnType<typeof useRetryTenantMetricsAiSummaryMutation>;
export type RetryTenantMetricsAiSummaryMutationResult = ApolloReactCommon.MutationResult<RetryTenantMetricsAiSummaryMutation>;
export type RetryTenantMetricsAiSummaryMutationOptions = ApolloReactCommon.BaseMutationOptions<RetryTenantMetricsAiSummaryMutation, RetryTenantMetricsAiSummaryMutationVariables>;
export const GetStaffVisibilityRulesDocument = gql`
    query GetStaffVisibilityRules {
  staffVisibilityRules {
    version
    courses {
      instructor
      assistant
    }
    customers {
      instructor
      assistant
    }
    invoices {
      instructor
      assistant
    }
    staff {
      instructor
      assistant
    }
    locations {
      instructor
      assistant
    }
    courseTypes {
      instructor
      assistant
    }
    interestLists {
      instructor
      assistant
    }
    bookingActions {
      instructor
      assistant
    }
  }
}
    `;

/**
 * __useGetStaffVisibilityRulesQuery__
 *
 * To run a query within a React component, call `useGetStaffVisibilityRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffVisibilityRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffVisibilityRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffVisibilityRulesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaffVisibilityRulesQuery, GetStaffVisibilityRulesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStaffVisibilityRulesQuery, GetStaffVisibilityRulesQueryVariables>(GetStaffVisibilityRulesDocument, baseOptions);
      }
export function useGetStaffVisibilityRulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffVisibilityRulesQuery, GetStaffVisibilityRulesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStaffVisibilityRulesQuery, GetStaffVisibilityRulesQueryVariables>(GetStaffVisibilityRulesDocument, baseOptions);
        }
export type GetStaffVisibilityRulesQueryHookResult = ReturnType<typeof useGetStaffVisibilityRulesQuery>;
export type GetStaffVisibilityRulesLazyQueryHookResult = ReturnType<typeof useGetStaffVisibilityRulesLazyQuery>;
export type GetStaffVisibilityRulesQueryResult = ApolloReactCommon.QueryResult<GetStaffVisibilityRulesQuery, GetStaffVisibilityRulesQueryVariables>;
export const UpdateStaffVisibilityRulesDocument = gql`
    mutation UpdateStaffVisibilityRules($input: StaffVisibilityRulesInput!) {
  updateStaffVisibilityRules(input: $input) {
    version
    courses {
      instructor
      assistant
    }
    customers {
      instructor
      assistant
    }
    invoices {
      instructor
      assistant
    }
    staff {
      instructor
      assistant
    }
    locations {
      instructor
      assistant
    }
    courseTypes {
      instructor
      assistant
    }
    interestLists {
      instructor
      assistant
    }
    bookingActions {
      instructor
      assistant
    }
  }
}
    `;
export type UpdateStaffVisibilityRulesMutationFn = ApolloReactCommon.MutationFunction<UpdateStaffVisibilityRulesMutation, UpdateStaffVisibilityRulesMutationVariables>;

/**
 * __useUpdateStaffVisibilityRulesMutation__
 *
 * To run a mutation, you first call `useUpdateStaffVisibilityRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffVisibilityRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaffVisibilityRulesMutation, { data, loading, error }] = useUpdateStaffVisibilityRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStaffVisibilityRulesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStaffVisibilityRulesMutation, UpdateStaffVisibilityRulesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateStaffVisibilityRulesMutation, UpdateStaffVisibilityRulesMutationVariables>(UpdateStaffVisibilityRulesDocument, baseOptions);
      }
export type UpdateStaffVisibilityRulesMutationHookResult = ReturnType<typeof useUpdateStaffVisibilityRulesMutation>;
export type UpdateStaffVisibilityRulesMutationResult = ApolloReactCommon.MutationResult<UpdateStaffVisibilityRulesMutation>;
export type UpdateStaffVisibilityRulesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStaffVisibilityRulesMutation, UpdateStaffVisibilityRulesMutationVariables>;
export const GetStaffVisibilityRulesHistoryDocument = gql`
    query GetStaffVisibilityRulesHistory {
  staffVisibilityRulesHistory {
    id
    createDate
    userId
    userName
    oldValues
    newValues
  }
}
    `;

/**
 * __useGetStaffVisibilityRulesHistoryQuery__
 *
 * To run a query within a React component, call `useGetStaffVisibilityRulesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffVisibilityRulesHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffVisibilityRulesHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffVisibilityRulesHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaffVisibilityRulesHistoryQuery, GetStaffVisibilityRulesHistoryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStaffVisibilityRulesHistoryQuery, GetStaffVisibilityRulesHistoryQueryVariables>(GetStaffVisibilityRulesHistoryDocument, baseOptions);
      }
export function useGetStaffVisibilityRulesHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffVisibilityRulesHistoryQuery, GetStaffVisibilityRulesHistoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStaffVisibilityRulesHistoryQuery, GetStaffVisibilityRulesHistoryQueryVariables>(GetStaffVisibilityRulesHistoryDocument, baseOptions);
        }
export type GetStaffVisibilityRulesHistoryQueryHookResult = ReturnType<typeof useGetStaffVisibilityRulesHistoryQuery>;
export type GetStaffVisibilityRulesHistoryLazyQueryHookResult = ReturnType<typeof useGetStaffVisibilityRulesHistoryLazyQuery>;
export type GetStaffVisibilityRulesHistoryQueryResult = ApolloReactCommon.QueryResult<GetStaffVisibilityRulesHistoryQuery, GetStaffVisibilityRulesHistoryQueryVariables>;
export const SaveAdminDocument = gql`
    mutation saveAdmin($adminInput: SaveAdminInput!) {
  saveAdmin(saveAdminData: $adminInput) {
    id
  }
}
    `;
export type SaveAdminMutationFn = ApolloReactCommon.MutationFunction<SaveAdminMutation, SaveAdminMutationVariables>;

/**
 * __useSaveAdminMutation__
 *
 * To run a mutation, you first call `useSaveAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAdminMutation, { data, loading, error }] = useSaveAdminMutation({
 *   variables: {
 *      adminInput: // value for 'adminInput'
 *   },
 * });
 */
export function useSaveAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveAdminMutation, SaveAdminMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveAdminMutation, SaveAdminMutationVariables>(SaveAdminDocument, baseOptions);
      }
export type SaveAdminMutationHookResult = ReturnType<typeof useSaveAdminMutation>;
export type SaveAdminMutationResult = ApolloReactCommon.MutationResult<SaveAdminMutation>;
export type SaveAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveAdminMutation, SaveAdminMutationVariables>;
export const CheckSmsApiKeyDocument = gql`
    query CheckSmsApiKey($apiKey: String!) {
  checkSmsApiKey(apiKey: $apiKey) {
    balance
  }
}
    `;

/**
 * __useCheckSmsApiKeyQuery__
 *
 * To run a query within a React component, call `useCheckSmsApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSmsApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSmsApiKeyQuery({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useCheckSmsApiKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckSmsApiKeyQuery, CheckSmsApiKeyQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckSmsApiKeyQuery, CheckSmsApiKeyQueryVariables>(CheckSmsApiKeyDocument, baseOptions);
      }
export function useCheckSmsApiKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckSmsApiKeyQuery, CheckSmsApiKeyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckSmsApiKeyQuery, CheckSmsApiKeyQueryVariables>(CheckSmsApiKeyDocument, baseOptions);
        }
export type CheckSmsApiKeyQueryHookResult = ReturnType<typeof useCheckSmsApiKeyQuery>;
export type CheckSmsApiKeyLazyQueryHookResult = ReturnType<typeof useCheckSmsApiKeyLazyQuery>;
export type CheckSmsApiKeyQueryResult = ApolloReactCommon.QueryResult<CheckSmsApiKeyQuery, CheckSmsApiKeyQueryVariables>;
export const GetSmsAccountBalanceDocument = gql`
    query GetSmsAccountBalance {
  getSmsAccountBalance {
    balance
  }
}
    `;

/**
 * __useGetSmsAccountBalanceQuery__
 *
 * To run a query within a React component, call `useGetSmsAccountBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsAccountBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsAccountBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSmsAccountBalanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSmsAccountBalanceQuery, GetSmsAccountBalanceQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSmsAccountBalanceQuery, GetSmsAccountBalanceQueryVariables>(GetSmsAccountBalanceDocument, baseOptions);
      }
export function useGetSmsAccountBalanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSmsAccountBalanceQuery, GetSmsAccountBalanceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSmsAccountBalanceQuery, GetSmsAccountBalanceQueryVariables>(GetSmsAccountBalanceDocument, baseOptions);
        }
export type GetSmsAccountBalanceQueryHookResult = ReturnType<typeof useGetSmsAccountBalanceQuery>;
export type GetSmsAccountBalanceLazyQueryHookResult = ReturnType<typeof useGetSmsAccountBalanceLazyQuery>;
export type GetSmsAccountBalanceQueryResult = ApolloReactCommon.QueryResult<GetSmsAccountBalanceQuery, GetSmsAccountBalanceQueryVariables>;
export const GetSmsReceiversDocument = gql`
    query GetSmsReceivers($mailDataType: MailDataType!, $selectedIds: [String!]!) {
  getSmsReceivers(mailDataType: $mailDataType, selectedIds: $selectedIds) {
    bookerId
    fullName
    mobileNumber
    valid
    prefixedBookingNumber
  }
}
    `;

/**
 * __useGetSmsReceiversQuery__
 *
 * To run a query within a React component, call `useGetSmsReceiversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsReceiversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsReceiversQuery({
 *   variables: {
 *      mailDataType: // value for 'mailDataType'
 *      selectedIds: // value for 'selectedIds'
 *   },
 * });
 */
export function useGetSmsReceiversQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSmsReceiversQuery, GetSmsReceiversQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSmsReceiversQuery, GetSmsReceiversQueryVariables>(GetSmsReceiversDocument, baseOptions);
      }
export function useGetSmsReceiversLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSmsReceiversQuery, GetSmsReceiversQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSmsReceiversQuery, GetSmsReceiversQueryVariables>(GetSmsReceiversDocument, baseOptions);
        }
export type GetSmsReceiversQueryHookResult = ReturnType<typeof useGetSmsReceiversQuery>;
export type GetSmsReceiversLazyQueryHookResult = ReturnType<typeof useGetSmsReceiversLazyQuery>;
export type GetSmsReceiversQueryResult = ApolloReactCommon.QueryResult<GetSmsReceiversQuery, GetSmsReceiversQueryVariables>;
export const GetSmsReceiversCourseDocument = gql`
    query GetSmsReceiversCourse($getReceiversForCourseInput: GetReceiversForCourseInput!) {
  getSmsReceiversCourse(getReceiversForCourseInput: $getReceiversForCourseInput) {
    bookerId
    fullName
    mobileNumber
    valid
    prefixedBookingNumber
  }
}
    `;

/**
 * __useGetSmsReceiversCourseQuery__
 *
 * To run a query within a React component, call `useGetSmsReceiversCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsReceiversCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsReceiversCourseQuery({
 *   variables: {
 *      getReceiversForCourseInput: // value for 'getReceiversForCourseInput'
 *   },
 * });
 */
export function useGetSmsReceiversCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSmsReceiversCourseQuery, GetSmsReceiversCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSmsReceiversCourseQuery, GetSmsReceiversCourseQueryVariables>(GetSmsReceiversCourseDocument, baseOptions);
      }
export function useGetSmsReceiversCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSmsReceiversCourseQuery, GetSmsReceiversCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSmsReceiversCourseQuery, GetSmsReceiversCourseQueryVariables>(GetSmsReceiversCourseDocument, baseOptions);
        }
export type GetSmsReceiversCourseQueryHookResult = ReturnType<typeof useGetSmsReceiversCourseQuery>;
export type GetSmsReceiversCourseLazyQueryHookResult = ReturnType<typeof useGetSmsReceiversCourseLazyQuery>;
export type GetSmsReceiversCourseQueryResult = ApolloReactCommon.QueryResult<GetSmsReceiversCourseQuery, GetSmsReceiversCourseQueryVariables>;
export const SendSmsDocument = gql`
    mutation SendSms($smsParams: SendSmsInput!) {
  sendSms(smsParams: $smsParams) {
    success
    totalPrice
    balance
  }
}
    `;
export type SendSmsMutationFn = ApolloReactCommon.MutationFunction<SendSmsMutation, SendSmsMutationVariables>;

/**
 * __useSendSmsMutation__
 *
 * To run a mutation, you first call `useSendSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsMutation, { data, loading, error }] = useSendSmsMutation({
 *   variables: {
 *      smsParams: // value for 'smsParams'
 *   },
 * });
 */
export function useSendSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSmsMutation, SendSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument, baseOptions);
      }
export type SendSmsMutationHookResult = ReturnType<typeof useSendSmsMutation>;
export type SendSmsMutationResult = ApolloReactCommon.MutationResult<SendSmsMutation>;
export type SendSmsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendSmsMutation, SendSmsMutationVariables>;
export const CourseLessonsForBillingStatusByInstructorDocument = gql`
    query CourseLessonsForBillingStatusByInstructor($courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput!) {
  courseLessonsForBillingStatusByInstructor(courseLessonForBillingStatusInput: $courseLessonForBillingStatusInput) {
    instructorId
    courseLessonCount
    instructorCost
    sumBillingAmount
    billedLessonCount
    billedTotalAmount
    lastBillingDate
    instructor {
      id
      staff {
        id
        firstname
        lastname
        rate
      }
    }
    courseLessons {
      id
      startDateTime
      endDateTime
      costForLesson
      durationInMinutes
      billingDate
      billingAmount
      course {
        id
        prefixedCourseNumber
        courseType {
          id
          name
        }
        location {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useCourseLessonsForBillingStatusByInstructorQuery__
 *
 * To run a query within a React component, call `useCourseLessonsForBillingStatusByInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonsForBillingStatusByInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonsForBillingStatusByInstructorQuery({
 *   variables: {
 *      courseLessonForBillingStatusInput: // value for 'courseLessonForBillingStatusInput'
 *   },
 * });
 */
export function useCourseLessonsForBillingStatusByInstructorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseLessonsForBillingStatusByInstructorQuery, CourseLessonsForBillingStatusByInstructorQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseLessonsForBillingStatusByInstructorQuery, CourseLessonsForBillingStatusByInstructorQueryVariables>(CourseLessonsForBillingStatusByInstructorDocument, baseOptions);
      }
export function useCourseLessonsForBillingStatusByInstructorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseLessonsForBillingStatusByInstructorQuery, CourseLessonsForBillingStatusByInstructorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseLessonsForBillingStatusByInstructorQuery, CourseLessonsForBillingStatusByInstructorQueryVariables>(CourseLessonsForBillingStatusByInstructorDocument, baseOptions);
        }
export type CourseLessonsForBillingStatusByInstructorQueryHookResult = ReturnType<typeof useCourseLessonsForBillingStatusByInstructorQuery>;
export type CourseLessonsForBillingStatusByInstructorLazyQueryHookResult = ReturnType<typeof useCourseLessonsForBillingStatusByInstructorLazyQuery>;
export type CourseLessonsForBillingStatusByInstructorQueryResult = ApolloReactCommon.QueryResult<CourseLessonsForBillingStatusByInstructorQuery, CourseLessonsForBillingStatusByInstructorQueryVariables>;
export const UpdateBillingAmountForCourseLessonDocument = gql`
    mutation UpdateBillingAmountForCourseLesson($courseLessonId: ID!, $billingAmount: Float) {
  updateBillingAmountForCourseLesson(courseLessonId: $courseLessonId, billingAmount: $billingAmount) {
    id
    billingAmount
  }
}
    `;
export type UpdateBillingAmountForCourseLessonMutationFn = ApolloReactCommon.MutationFunction<UpdateBillingAmountForCourseLessonMutation, UpdateBillingAmountForCourseLessonMutationVariables>;

/**
 * __useUpdateBillingAmountForCourseLessonMutation__
 *
 * To run a mutation, you first call `useUpdateBillingAmountForCourseLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingAmountForCourseLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingAmountForCourseLessonMutation, { data, loading, error }] = useUpdateBillingAmountForCourseLessonMutation({
 *   variables: {
 *      courseLessonId: // value for 'courseLessonId'
 *      billingAmount: // value for 'billingAmount'
 *   },
 * });
 */
export function useUpdateBillingAmountForCourseLessonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBillingAmountForCourseLessonMutation, UpdateBillingAmountForCourseLessonMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBillingAmountForCourseLessonMutation, UpdateBillingAmountForCourseLessonMutationVariables>(UpdateBillingAmountForCourseLessonDocument, baseOptions);
      }
export type UpdateBillingAmountForCourseLessonMutationHookResult = ReturnType<typeof useUpdateBillingAmountForCourseLessonMutation>;
export type UpdateBillingAmountForCourseLessonMutationResult = ApolloReactCommon.MutationResult<UpdateBillingAmountForCourseLessonMutation>;
export type UpdateBillingAmountForCourseLessonMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBillingAmountForCourseLessonMutation, UpdateBillingAmountForCourseLessonMutationVariables>;
export const UpdateBillingAmountForCourseDocument = gql`
    mutation UpdateBillingAmountForCourse($courseId: ID!, $billingAmount: Float) {
  updateBillingAmountForCourse(courseId: $courseId, billingAmount: $billingAmount)
}
    `;
export type UpdateBillingAmountForCourseMutationFn = ApolloReactCommon.MutationFunction<UpdateBillingAmountForCourseMutation, UpdateBillingAmountForCourseMutationVariables>;

/**
 * __useUpdateBillingAmountForCourseMutation__
 *
 * To run a mutation, you first call `useUpdateBillingAmountForCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingAmountForCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingAmountForCourseMutation, { data, loading, error }] = useUpdateBillingAmountForCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      billingAmount: // value for 'billingAmount'
 *   },
 * });
 */
export function useUpdateBillingAmountForCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBillingAmountForCourseMutation, UpdateBillingAmountForCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBillingAmountForCourseMutation, UpdateBillingAmountForCourseMutationVariables>(UpdateBillingAmountForCourseDocument, baseOptions);
      }
export type UpdateBillingAmountForCourseMutationHookResult = ReturnType<typeof useUpdateBillingAmountForCourseMutation>;
export type UpdateBillingAmountForCourseMutationResult = ApolloReactCommon.MutationResult<UpdateBillingAmountForCourseMutation>;
export type UpdateBillingAmountForCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBillingAmountForCourseMutation, UpdateBillingAmountForCourseMutationVariables>;
export const CreateInstructorInvoiceDocument = gql`
    mutation CreateInstructorInvoice($input: CreateInstructorInvoiceInput!) {
  createInstructorInvoice(input: $input)
}
    `;
export type CreateInstructorInvoiceMutationFn = ApolloReactCommon.MutationFunction<CreateInstructorInvoiceMutation, CreateInstructorInvoiceMutationVariables>;

/**
 * __useCreateInstructorInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInstructorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstructorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstructorInvoiceMutation, { data, loading, error }] = useCreateInstructorInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInstructorInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInstructorInvoiceMutation, CreateInstructorInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInstructorInvoiceMutation, CreateInstructorInvoiceMutationVariables>(CreateInstructorInvoiceDocument, baseOptions);
      }
export type CreateInstructorInvoiceMutationHookResult = ReturnType<typeof useCreateInstructorInvoiceMutation>;
export type CreateInstructorInvoiceMutationResult = ApolloReactCommon.MutationResult<CreateInstructorInvoiceMutation>;
export type CreateInstructorInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInstructorInvoiceMutation, CreateInstructorInvoiceMutationVariables>;
export const PreviewInstructorInvoiceDocument = gql`
    mutation PreviewInstructorInvoice($input: CreateInstructorInvoiceInput!) {
  previewInstructorInvoice(input: $input)
}
    `;
export type PreviewInstructorInvoiceMutationFn = ApolloReactCommon.MutationFunction<PreviewInstructorInvoiceMutation, PreviewInstructorInvoiceMutationVariables>;

/**
 * __usePreviewInstructorInvoiceMutation__
 *
 * To run a mutation, you first call `usePreviewInstructorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewInstructorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewInstructorInvoiceMutation, { data, loading, error }] = usePreviewInstructorInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewInstructorInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PreviewInstructorInvoiceMutation, PreviewInstructorInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<PreviewInstructorInvoiceMutation, PreviewInstructorInvoiceMutationVariables>(PreviewInstructorInvoiceDocument, baseOptions);
      }
export type PreviewInstructorInvoiceMutationHookResult = ReturnType<typeof usePreviewInstructorInvoiceMutation>;
export type PreviewInstructorInvoiceMutationResult = ApolloReactCommon.MutationResult<PreviewInstructorInvoiceMutation>;
export type PreviewInstructorInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<PreviewInstructorInvoiceMutation, PreviewInstructorInvoiceMutationVariables>;
export const CourseLessonsForBillingStatusByInstructorGroupedDocument = gql`
    query CourseLessonsForBillingStatusByInstructorGrouped($courseLessonForBillingStatusInput: CourseLessonForBillingStatusInput!) {
  courseLessonsForBillingStatusByInstructorGrouped(courseLessonForBillingStatusInput: $courseLessonForBillingStatusInput) {
    instructorId
    courseLessonCount
    instructorCost
    sumBillingAmount
    billedLessonCount
    billedTotalAmount
    lastBillingDate
    instructor {
      id
      staff {
        id
        firstname
        lastname
        rate
      }
    }
    courseGroups {
      courseId
      coursePrefixedNumber
      courseTypeName
      courseTypeColor
      locationName
      lessonCount
      periodStart
      periodEnd
      totalAmount
      totalMinutes
      hourlyRate
    }
  }
}
    `;

/**
 * __useCourseLessonsForBillingStatusByInstructorGroupedQuery__
 *
 * To run a query within a React component, call `useCourseLessonsForBillingStatusByInstructorGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonsForBillingStatusByInstructorGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonsForBillingStatusByInstructorGroupedQuery({
 *   variables: {
 *      courseLessonForBillingStatusInput: // value for 'courseLessonForBillingStatusInput'
 *   },
 * });
 */
export function useCourseLessonsForBillingStatusByInstructorGroupedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseLessonsForBillingStatusByInstructorGroupedQuery, CourseLessonsForBillingStatusByInstructorGroupedQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseLessonsForBillingStatusByInstructorGroupedQuery, CourseLessonsForBillingStatusByInstructorGroupedQueryVariables>(CourseLessonsForBillingStatusByInstructorGroupedDocument, baseOptions);
      }
export function useCourseLessonsForBillingStatusByInstructorGroupedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseLessonsForBillingStatusByInstructorGroupedQuery, CourseLessonsForBillingStatusByInstructorGroupedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseLessonsForBillingStatusByInstructorGroupedQuery, CourseLessonsForBillingStatusByInstructorGroupedQueryVariables>(CourseLessonsForBillingStatusByInstructorGroupedDocument, baseOptions);
        }
export type CourseLessonsForBillingStatusByInstructorGroupedQueryHookResult = ReturnType<typeof useCourseLessonsForBillingStatusByInstructorGroupedQuery>;
export type CourseLessonsForBillingStatusByInstructorGroupedLazyQueryHookResult = ReturnType<typeof useCourseLessonsForBillingStatusByInstructorGroupedLazyQuery>;
export type CourseLessonsForBillingStatusByInstructorGroupedQueryResult = ApolloReactCommon.QueryResult<CourseLessonsForBillingStatusByInstructorGroupedQuery, CourseLessonsForBillingStatusByInstructorGroupedQueryVariables>;
export const CourseLessonsByCourseAndInstructorDocument = gql`
    query CourseLessonsByCourseAndInstructor($courseId: ID!, $instructorId: ID!, $options: ArrayDataOptions) {
  courseLessonsByCourseAndInstructor(courseId: $courseId, instructorId: $instructorId, options: $options) {
    id
    startDateTime
    endDateTime
    costForLesson
    durationInMinutes
    billingDate
    billingAmount
    course {
      id
      prefixedCourseNumber
      courseType {
        id
        name
      }
      location {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCourseLessonsByCourseAndInstructorQuery__
 *
 * To run a query within a React component, call `useCourseLessonsByCourseAndInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonsByCourseAndInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonsByCourseAndInstructorQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      instructorId: // value for 'instructorId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCourseLessonsByCourseAndInstructorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseLessonsByCourseAndInstructorQuery, CourseLessonsByCourseAndInstructorQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseLessonsByCourseAndInstructorQuery, CourseLessonsByCourseAndInstructorQueryVariables>(CourseLessonsByCourseAndInstructorDocument, baseOptions);
      }
export function useCourseLessonsByCourseAndInstructorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseLessonsByCourseAndInstructorQuery, CourseLessonsByCourseAndInstructorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseLessonsByCourseAndInstructorQuery, CourseLessonsByCourseAndInstructorQueryVariables>(CourseLessonsByCourseAndInstructorDocument, baseOptions);
        }
export type CourseLessonsByCourseAndInstructorQueryHookResult = ReturnType<typeof useCourseLessonsByCourseAndInstructorQuery>;
export type CourseLessonsByCourseAndInstructorLazyQueryHookResult = ReturnType<typeof useCourseLessonsByCourseAndInstructorLazyQuery>;
export type CourseLessonsByCourseAndInstructorQueryResult = ApolloReactCommon.QueryResult<CourseLessonsByCourseAndInstructorQuery, CourseLessonsByCourseAndInstructorQueryVariables>;
export const CourseLessonsByInstructorChronologicalDocument = gql`
    query CourseLessonsByInstructorChronological($instructorId: ID!, $options: ArrayDataOptions) {
  courseLessonsByInstructorChronological(instructorId: $instructorId, options: $options) {
    total
    lessons {
      id
      startDateTime
      endDateTime
      costForLesson
      durationInMinutes
      billingDate
      billingAmount
      course {
        id
        prefixedCourseNumber
        courseType {
          id
          name
        }
        location {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useCourseLessonsByInstructorChronologicalQuery__
 *
 * To run a query within a React component, call `useCourseLessonsByInstructorChronologicalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonsByInstructorChronologicalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonsByInstructorChronologicalQuery({
 *   variables: {
 *      instructorId: // value for 'instructorId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCourseLessonsByInstructorChronologicalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CourseLessonsByInstructorChronologicalQuery, CourseLessonsByInstructorChronologicalQueryVariables>) {
        return ApolloReactHooks.useQuery<CourseLessonsByInstructorChronologicalQuery, CourseLessonsByInstructorChronologicalQueryVariables>(CourseLessonsByInstructorChronologicalDocument, baseOptions);
      }
export function useCourseLessonsByInstructorChronologicalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourseLessonsByInstructorChronologicalQuery, CourseLessonsByInstructorChronologicalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CourseLessonsByInstructorChronologicalQuery, CourseLessonsByInstructorChronologicalQueryVariables>(CourseLessonsByInstructorChronologicalDocument, baseOptions);
        }
export type CourseLessonsByInstructorChronologicalQueryHookResult = ReturnType<typeof useCourseLessonsByInstructorChronologicalQuery>;
export type CourseLessonsByInstructorChronologicalLazyQueryHookResult = ReturnType<typeof useCourseLessonsByInstructorChronologicalLazyQuery>;
export type CourseLessonsByInstructorChronologicalQueryResult = ApolloReactCommon.QueryResult<CourseLessonsByInstructorChronologicalQuery, CourseLessonsByInstructorChronologicalQueryVariables>;
export const InstructorInvoicesDocument = gql`
    query InstructorInvoices {
  instructorInvoices {
    id
    instructorId
    lessonCount
    totalAmount
    periodStart
    periodEnd
    invoiceDate
    createdByUserId
    pdfPath
    pdfUrl
    fileSize
    createDate
    instructor {
      id
      staff {
        id
        firstname
        lastname
      }
    }
  }
}
    `;

/**
 * __useInstructorInvoicesQuery__
 *
 * To run a query within a React component, call `useInstructorInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructorInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructorInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInstructorInvoicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstructorInvoicesQuery, InstructorInvoicesQueryVariables>) {
        return ApolloReactHooks.useQuery<InstructorInvoicesQuery, InstructorInvoicesQueryVariables>(InstructorInvoicesDocument, baseOptions);
      }
export function useInstructorInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstructorInvoicesQuery, InstructorInvoicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<InstructorInvoicesQuery, InstructorInvoicesQueryVariables>(InstructorInvoicesDocument, baseOptions);
        }
export type InstructorInvoicesQueryHookResult = ReturnType<typeof useInstructorInvoicesQuery>;
export type InstructorInvoicesLazyQueryHookResult = ReturnType<typeof useInstructorInvoicesLazyQuery>;
export type InstructorInvoicesQueryResult = ApolloReactCommon.QueryResult<InstructorInvoicesQuery, InstructorInvoicesQueryVariables>;
export const DeleteInstructorInvoiceDocument = gql`
    mutation DeleteInstructorInvoice($invoiceId: ID!) {
  deleteInstructorInvoice(invoiceId: $invoiceId)
}
    `;
export type DeleteInstructorInvoiceMutationFn = ApolloReactCommon.MutationFunction<DeleteInstructorInvoiceMutation, DeleteInstructorInvoiceMutationVariables>;

/**
 * __useDeleteInstructorInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInstructorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInstructorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInstructorInvoiceMutation, { data, loading, error }] = useDeleteInstructorInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDeleteInstructorInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInstructorInvoiceMutation, DeleteInstructorInvoiceMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteInstructorInvoiceMutation, DeleteInstructorInvoiceMutationVariables>(DeleteInstructorInvoiceDocument, baseOptions);
      }
export type DeleteInstructorInvoiceMutationHookResult = ReturnType<typeof useDeleteInstructorInvoiceMutation>;
export type DeleteInstructorInvoiceMutationResult = ApolloReactCommon.MutationResult<DeleteInstructorInvoiceMutation>;
export type DeleteInstructorInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInstructorInvoiceMutation, DeleteInstructorInvoiceMutationVariables>;
export const InstructorInvoicesByInstructorAndDateRangeDocument = gql`
    query InstructorInvoicesByInstructorAndDateRange($input: InstructorInvoicesByDateRangeInput!) {
  instructorInvoicesByInstructorAndDateRange(input: $input) {
    id
    invoiceDate
    lessonCount
    totalAmount
    periodStart
    periodEnd
    pdfUrl
  }
}
    `;

/**
 * __useInstructorInvoicesByInstructorAndDateRangeQuery__
 *
 * To run a query within a React component, call `useInstructorInvoicesByInstructorAndDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructorInvoicesByInstructorAndDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructorInvoicesByInstructorAndDateRangeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInstructorInvoicesByInstructorAndDateRangeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstructorInvoicesByInstructorAndDateRangeQuery, InstructorInvoicesByInstructorAndDateRangeQueryVariables>) {
        return ApolloReactHooks.useQuery<InstructorInvoicesByInstructorAndDateRangeQuery, InstructorInvoicesByInstructorAndDateRangeQueryVariables>(InstructorInvoicesByInstructorAndDateRangeDocument, baseOptions);
      }
export function useInstructorInvoicesByInstructorAndDateRangeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstructorInvoicesByInstructorAndDateRangeQuery, InstructorInvoicesByInstructorAndDateRangeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<InstructorInvoicesByInstructorAndDateRangeQuery, InstructorInvoicesByInstructorAndDateRangeQueryVariables>(InstructorInvoicesByInstructorAndDateRangeDocument, baseOptions);
        }
export type InstructorInvoicesByInstructorAndDateRangeQueryHookResult = ReturnType<typeof useInstructorInvoicesByInstructorAndDateRangeQuery>;
export type InstructorInvoicesByInstructorAndDateRangeLazyQueryHookResult = ReturnType<typeof useInstructorInvoicesByInstructorAndDateRangeLazyQuery>;
export type InstructorInvoicesByInstructorAndDateRangeQueryResult = ApolloReactCommon.QueryResult<InstructorInvoicesByInstructorAndDateRangeQuery, InstructorInvoicesByInstructorAndDateRangeQueryVariables>;
export const InstructorInvoiceByIdDocument = gql`
    query InstructorInvoiceById($invoiceId: ID!) {
  instructorInvoiceById(invoiceId: $invoiceId) {
    id
    instructorId
    lessonCount
    totalAmount
    periodStart
    periodEnd
    invoiceDate
    createdByUserId
    pdfPath
    pdfUrl
    fileSize
    createDate
    instructor {
      id
      staff {
        id
        firstname
        lastname
        rate
      }
    }
    courseLessons {
      id
      startDateTime
      endDateTime
      billingDate
      billingAmount
      course {
        id
        prefixedCourseNumber
        courseType {
          id
          name
        }
        location {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useInstructorInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useInstructorInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructorInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructorInvoiceByIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInstructorInvoiceByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstructorInvoiceByIdQuery, InstructorInvoiceByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<InstructorInvoiceByIdQuery, InstructorInvoiceByIdQueryVariables>(InstructorInvoiceByIdDocument, baseOptions);
      }
export function useInstructorInvoiceByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstructorInvoiceByIdQuery, InstructorInvoiceByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<InstructorInvoiceByIdQuery, InstructorInvoiceByIdQueryVariables>(InstructorInvoiceByIdDocument, baseOptions);
        }
export type InstructorInvoiceByIdQueryHookResult = ReturnType<typeof useInstructorInvoiceByIdQuery>;
export type InstructorInvoiceByIdLazyQueryHookResult = ReturnType<typeof useInstructorInvoiceByIdLazyQuery>;
export type InstructorInvoiceByIdQueryResult = ApolloReactCommon.QueryResult<InstructorInvoiceByIdQuery, InstructorInvoiceByIdQueryVariables>;
export const AdminManagementOverviewDocument = gql`
    query AdminManagementOverview {
  adminManagementOverview {
    users {
      userId
      email
      roles
      firstName
      lastName
      staffNames
      isSelf
    }
    adminSeatsUsed
    adminSeatsLimit
  }
}
    `;

/**
 * __useAdminManagementOverviewQuery__
 *
 * To run a query within a React component, call `useAdminManagementOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminManagementOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminManagementOverviewQuery, AdminManagementOverviewQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminManagementOverviewQuery, AdminManagementOverviewQueryVariables>(AdminManagementOverviewDocument, baseOptions);
      }
export function useAdminManagementOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminManagementOverviewQuery, AdminManagementOverviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminManagementOverviewQuery, AdminManagementOverviewQueryVariables>(AdminManagementOverviewDocument, baseOptions);
        }
export type AdminManagementOverviewQueryHookResult = ReturnType<typeof useAdminManagementOverviewQuery>;
export type AdminManagementOverviewLazyQueryHookResult = ReturnType<typeof useAdminManagementOverviewLazyQuery>;
export type AdminManagementOverviewQueryResult = ApolloReactCommon.QueryResult<AdminManagementOverviewQuery, AdminManagementOverviewQueryVariables>;
export const AdminManagementEmailStatusDocument = gql`
    query AdminManagementEmailStatus($email: String!) {
  adminManagementEmailStatus(email: $email) {
    status
    displayName
  }
}
    `;

/**
 * __useAdminManagementEmailStatusQuery__
 *
 * To run a query within a React component, call `useAdminManagementEmailStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementEmailStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementEmailStatusQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAdminManagementEmailStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminManagementEmailStatusQuery, AdminManagementEmailStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminManagementEmailStatusQuery, AdminManagementEmailStatusQueryVariables>(AdminManagementEmailStatusDocument, baseOptions);
      }
export function useAdminManagementEmailStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminManagementEmailStatusQuery, AdminManagementEmailStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminManagementEmailStatusQuery, AdminManagementEmailStatusQueryVariables>(AdminManagementEmailStatusDocument, baseOptions);
        }
export type AdminManagementEmailStatusQueryHookResult = ReturnType<typeof useAdminManagementEmailStatusQuery>;
export type AdminManagementEmailStatusLazyQueryHookResult = ReturnType<typeof useAdminManagementEmailStatusLazyQuery>;
export type AdminManagementEmailStatusQueryResult = ApolloReactCommon.QueryResult<AdminManagementEmailStatusQuery, AdminManagementEmailStatusQueryVariables>;
export const AdminManagementStaffOptionsDocument = gql`
    query AdminManagementStaffOptions {
  instructors {
    id
    userId
    firstname
    lastname
    email
  }
}
    `;

/**
 * __useAdminManagementStaffOptionsQuery__
 *
 * To run a query within a React component, call `useAdminManagementStaffOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementStaffOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementStaffOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminManagementStaffOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminManagementStaffOptionsQuery, AdminManagementStaffOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminManagementStaffOptionsQuery, AdminManagementStaffOptionsQueryVariables>(AdminManagementStaffOptionsDocument, baseOptions);
      }
export function useAdminManagementStaffOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminManagementStaffOptionsQuery, AdminManagementStaffOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminManagementStaffOptionsQuery, AdminManagementStaffOptionsQueryVariables>(AdminManagementStaffOptionsDocument, baseOptions);
        }
export type AdminManagementStaffOptionsQueryHookResult = ReturnType<typeof useAdminManagementStaffOptionsQuery>;
export type AdminManagementStaffOptionsLazyQueryHookResult = ReturnType<typeof useAdminManagementStaffOptionsLazyQuery>;
export type AdminManagementStaffOptionsQueryResult = ApolloReactCommon.QueryResult<AdminManagementStaffOptionsQuery, AdminManagementStaffOptionsQueryVariables>;
export const CreateAdminManagementUserDocument = gql`
    mutation CreateAdminManagementUser($input: CreateAdminManagementUserInput!) {
  createAdminManagementUser(input: $input)
}
    `;
export type CreateAdminManagementUserMutationFn = ApolloReactCommon.MutationFunction<CreateAdminManagementUserMutation, CreateAdminManagementUserMutationVariables>;

/**
 * __useCreateAdminManagementUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminManagementUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminManagementUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminManagementUserMutation, { data, loading, error }] = useCreateAdminManagementUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminManagementUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdminManagementUserMutation, CreateAdminManagementUserMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAdminManagementUserMutation, CreateAdminManagementUserMutationVariables>(CreateAdminManagementUserDocument, baseOptions);
      }
export type CreateAdminManagementUserMutationHookResult = ReturnType<typeof useCreateAdminManagementUserMutation>;
export type CreateAdminManagementUserMutationResult = ApolloReactCommon.MutationResult<CreateAdminManagementUserMutation>;
export type CreateAdminManagementUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdminManagementUserMutation, CreateAdminManagementUserMutationVariables>;
export const UpdateAdminManagementUserEmailDocument = gql`
    mutation UpdateAdminManagementUserEmail($input: UpdateAdminManagementUserEmailInput!) {
  updateAdminManagementUserEmail(input: $input)
}
    `;
export type UpdateAdminManagementUserEmailMutationFn = ApolloReactCommon.MutationFunction<UpdateAdminManagementUserEmailMutation, UpdateAdminManagementUserEmailMutationVariables>;

/**
 * __useUpdateAdminManagementUserEmailMutation__
 *
 * To run a mutation, you first call `useUpdateAdminManagementUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminManagementUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminManagementUserEmailMutation, { data, loading, error }] = useUpdateAdminManagementUserEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminManagementUserEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdminManagementUserEmailMutation, UpdateAdminManagementUserEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAdminManagementUserEmailMutation, UpdateAdminManagementUserEmailMutationVariables>(UpdateAdminManagementUserEmailDocument, baseOptions);
      }
export type UpdateAdminManagementUserEmailMutationHookResult = ReturnType<typeof useUpdateAdminManagementUserEmailMutation>;
export type UpdateAdminManagementUserEmailMutationResult = ApolloReactCommon.MutationResult<UpdateAdminManagementUserEmailMutation>;
export type UpdateAdminManagementUserEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdminManagementUserEmailMutation, UpdateAdminManagementUserEmailMutationVariables>;
export const UpdateAdminManagementUserNameDocument = gql`
    mutation UpdateAdminManagementUserName($input: UpdateAdminManagementUserNameInput!) {
  updateAdminManagementUserName(input: $input)
}
    `;
export type UpdateAdminManagementUserNameMutationFn = ApolloReactCommon.MutationFunction<UpdateAdminManagementUserNameMutation, UpdateAdminManagementUserNameMutationVariables>;

/**
 * __useUpdateAdminManagementUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateAdminManagementUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminManagementUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminManagementUserNameMutation, { data, loading, error }] = useUpdateAdminManagementUserNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminManagementUserNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdminManagementUserNameMutation, UpdateAdminManagementUserNameMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAdminManagementUserNameMutation, UpdateAdminManagementUserNameMutationVariables>(UpdateAdminManagementUserNameDocument, baseOptions);
      }
export type UpdateAdminManagementUserNameMutationHookResult = ReturnType<typeof useUpdateAdminManagementUserNameMutation>;
export type UpdateAdminManagementUserNameMutationResult = ApolloReactCommon.MutationResult<UpdateAdminManagementUserNameMutation>;
export type UpdateAdminManagementUserNameMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdminManagementUserNameMutation, UpdateAdminManagementUserNameMutationVariables>;
export const RemoveAdminManagementUserDocument = gql`
    mutation RemoveAdminManagementUser($input: RemoveAdminManagementUserInput!) {
  removeAdminManagementUser(input: $input)
}
    `;
export type RemoveAdminManagementUserMutationFn = ApolloReactCommon.MutationFunction<RemoveAdminManagementUserMutation, RemoveAdminManagementUserMutationVariables>;

/**
 * __useRemoveAdminManagementUserMutation__
 *
 * To run a mutation, you first call `useRemoveAdminManagementUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminManagementUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminManagementUserMutation, { data, loading, error }] = useRemoveAdminManagementUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminManagementUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAdminManagementUserMutation, RemoveAdminManagementUserMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveAdminManagementUserMutation, RemoveAdminManagementUserMutationVariables>(RemoveAdminManagementUserDocument, baseOptions);
      }
export type RemoveAdminManagementUserMutationHookResult = ReturnType<typeof useRemoveAdminManagementUserMutation>;
export type RemoveAdminManagementUserMutationResult = ApolloReactCommon.MutationResult<RemoveAdminManagementUserMutation>;
export type RemoveAdminManagementUserMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAdminManagementUserMutation, RemoveAdminManagementUserMutationVariables>;
export const ToggleAreaManagerRoleFromAdminManagementDocument = gql`
    mutation ToggleAreaManagerRoleFromAdminManagement($input: ToggleAreaManagerRoleInput!) {
  toggleAreaManagerRoleFromAdminManagement(input: $input)
}
    `;
export type ToggleAreaManagerRoleFromAdminManagementMutationFn = ApolloReactCommon.MutationFunction<ToggleAreaManagerRoleFromAdminManagementMutation, ToggleAreaManagerRoleFromAdminManagementMutationVariables>;

/**
 * __useToggleAreaManagerRoleFromAdminManagementMutation__
 *
 * To run a mutation, you first call `useToggleAreaManagerRoleFromAdminManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAreaManagerRoleFromAdminManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAreaManagerRoleFromAdminManagementMutation, { data, loading, error }] = useToggleAreaManagerRoleFromAdminManagementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleAreaManagerRoleFromAdminManagementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleAreaManagerRoleFromAdminManagementMutation, ToggleAreaManagerRoleFromAdminManagementMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleAreaManagerRoleFromAdminManagementMutation, ToggleAreaManagerRoleFromAdminManagementMutationVariables>(ToggleAreaManagerRoleFromAdminManagementDocument, baseOptions);
      }
export type ToggleAreaManagerRoleFromAdminManagementMutationHookResult = ReturnType<typeof useToggleAreaManagerRoleFromAdminManagementMutation>;
export type ToggleAreaManagerRoleFromAdminManagementMutationResult = ApolloReactCommon.MutationResult<ToggleAreaManagerRoleFromAdminManagementMutation>;
export type ToggleAreaManagerRoleFromAdminManagementMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleAreaManagerRoleFromAdminManagementMutation, ToggleAreaManagerRoleFromAdminManagementMutationVariables>;
export const GetAreaManagerLocationsByStaffIdDocument = gql`
    query GetAreaManagerLocationsByStaffId($staffId: String!) {
  getAreaManagerLocationsByStaffId(staffId: $staffId) {
    id
    name
  }
}
    `;

/**
 * __useGetAreaManagerLocationsByStaffIdQuery__
 *
 * To run a query within a React component, call `useGetAreaManagerLocationsByStaffIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaManagerLocationsByStaffIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaManagerLocationsByStaffIdQuery({
 *   variables: {
 *      staffId: // value for 'staffId'
 *   },
 * });
 */
export function useGetAreaManagerLocationsByStaffIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAreaManagerLocationsByStaffIdQuery, GetAreaManagerLocationsByStaffIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAreaManagerLocationsByStaffIdQuery, GetAreaManagerLocationsByStaffIdQueryVariables>(GetAreaManagerLocationsByStaffIdDocument, baseOptions);
      }
export function useGetAreaManagerLocationsByStaffIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAreaManagerLocationsByStaffIdQuery, GetAreaManagerLocationsByStaffIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAreaManagerLocationsByStaffIdQuery, GetAreaManagerLocationsByStaffIdQueryVariables>(GetAreaManagerLocationsByStaffIdDocument, baseOptions);
        }
export type GetAreaManagerLocationsByStaffIdQueryHookResult = ReturnType<typeof useGetAreaManagerLocationsByStaffIdQuery>;
export type GetAreaManagerLocationsByStaffIdLazyQueryHookResult = ReturnType<typeof useGetAreaManagerLocationsByStaffIdLazyQuery>;
export type GetAreaManagerLocationsByStaffIdQueryResult = ApolloReactCommon.QueryResult<GetAreaManagerLocationsByStaffIdQuery, GetAreaManagerLocationsByStaffIdQueryVariables>;
export const AssignAreaManagerLocationsDocument = gql`
    mutation AssignAreaManagerLocations($input: AssignAreaManagerLocationsInput!) {
  assignAreaManagerLocations(input: $input)
}
    `;
export type AssignAreaManagerLocationsMutationFn = ApolloReactCommon.MutationFunction<AssignAreaManagerLocationsMutation, AssignAreaManagerLocationsMutationVariables>;

/**
 * __useAssignAreaManagerLocationsMutation__
 *
 * To run a mutation, you first call `useAssignAreaManagerLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAreaManagerLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAreaManagerLocationsMutation, { data, loading, error }] = useAssignAreaManagerLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignAreaManagerLocationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignAreaManagerLocationsMutation, AssignAreaManagerLocationsMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignAreaManagerLocationsMutation, AssignAreaManagerLocationsMutationVariables>(AssignAreaManagerLocationsDocument, baseOptions);
      }
export type AssignAreaManagerLocationsMutationHookResult = ReturnType<typeof useAssignAreaManagerLocationsMutation>;
export type AssignAreaManagerLocationsMutationResult = ApolloReactCommon.MutationResult<AssignAreaManagerLocationsMutation>;
export type AssignAreaManagerLocationsMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignAreaManagerLocationsMutation, AssignAreaManagerLocationsMutationVariables>;
export const StaffSaveInstructorDocument = gql`
    mutation StaffSaveInstructor($saveInstructorData: SaveInstructorInput!) {
  saveInstructor(saveInstructorData: $saveInstructorData) {
    id
    level
    salutation
    assignedLocations {
      id
    }
    firstname
    lastname
    active
    showInWeb
    birthDate
    birthPlace
    annotation
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    joinDate
    leaveDate
    socialSecurityNumber
    healthInsuranceFund
    rate
    vat
    accountHolder
    iban
    bic
    bank
    taxId
    allowLogin
  }
}
    `;
export type StaffSaveInstructorMutationFn = ApolloReactCommon.MutationFunction<StaffSaveInstructorMutation, StaffSaveInstructorMutationVariables>;

/**
 * __useStaffSaveInstructorMutation__
 *
 * To run a mutation, you first call `useStaffSaveInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStaffSaveInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [staffSaveInstructorMutation, { data, loading, error }] = useStaffSaveInstructorMutation({
 *   variables: {
 *      saveInstructorData: // value for 'saveInstructorData'
 *   },
 * });
 */
export function useStaffSaveInstructorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StaffSaveInstructorMutation, StaffSaveInstructorMutationVariables>) {
        return ApolloReactHooks.useMutation<StaffSaveInstructorMutation, StaffSaveInstructorMutationVariables>(StaffSaveInstructorDocument, baseOptions);
      }
export type StaffSaveInstructorMutationHookResult = ReturnType<typeof useStaffSaveInstructorMutation>;
export type StaffSaveInstructorMutationResult = ApolloReactCommon.MutationResult<StaffSaveInstructorMutation>;
export type StaffSaveInstructorMutationOptions = ApolloReactCommon.BaseMutationOptions<StaffSaveInstructorMutation, StaffSaveInstructorMutationVariables>;
export const StaffGetInstructorDocument = gql`
    query StaffGetInstructor($id: String!) {
  instructor(id: $id) {
    id
    userId
    staffId
    level
    assignedLocations {
      id
    }
    salutation
    firstname
    lastname
    active
    showInWeb
    birthDate
    birthPlace
    annotation
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    joinDate
    leaveDate
    socialSecurityNumber
    healthInsuranceFund
    rate
    vat
    accountHolder
    iban
    bic
    bank
    email
    taxId
    allowLogin
    customFields
  }
}
    `;

/**
 * __useStaffGetInstructorQuery__
 *
 * To run a query within a React component, call `useStaffGetInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffGetInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffGetInstructorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStaffGetInstructorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StaffGetInstructorQuery, StaffGetInstructorQueryVariables>) {
        return ApolloReactHooks.useQuery<StaffGetInstructorQuery, StaffGetInstructorQueryVariables>(StaffGetInstructorDocument, baseOptions);
      }
export function useStaffGetInstructorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StaffGetInstructorQuery, StaffGetInstructorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StaffGetInstructorQuery, StaffGetInstructorQueryVariables>(StaffGetInstructorDocument, baseOptions);
        }
export type StaffGetInstructorQueryHookResult = ReturnType<typeof useStaffGetInstructorQuery>;
export type StaffGetInstructorLazyQueryHookResult = ReturnType<typeof useStaffGetInstructorLazyQuery>;
export type StaffGetInstructorQueryResult = ApolloReactCommon.QueryResult<StaffGetInstructorQuery, StaffGetInstructorQueryVariables>;
export const StaffGetInstructorsDocument = gql`
    query StaffGetInstructors {
  instructors {
    id
    firstname
    lastname
    email
    active
  }
}
    `;

/**
 * __useStaffGetInstructorsQuery__
 *
 * To run a query within a React component, call `useStaffGetInstructorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffGetInstructorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffGetInstructorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStaffGetInstructorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StaffGetInstructorsQuery, StaffGetInstructorsQueryVariables>) {
        return ApolloReactHooks.useQuery<StaffGetInstructorsQuery, StaffGetInstructorsQueryVariables>(StaffGetInstructorsDocument, baseOptions);
      }
export function useStaffGetInstructorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StaffGetInstructorsQuery, StaffGetInstructorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StaffGetInstructorsQuery, StaffGetInstructorsQueryVariables>(StaffGetInstructorsDocument, baseOptions);
        }
export type StaffGetInstructorsQueryHookResult = ReturnType<typeof useStaffGetInstructorsQuery>;
export type StaffGetInstructorsLazyQueryHookResult = ReturnType<typeof useStaffGetInstructorsLazyQuery>;
export type StaffGetInstructorsQueryResult = ApolloReactCommon.QueryResult<StaffGetInstructorsQuery, StaffGetInstructorsQueryVariables>;
export const GetInstructorsByStaffIdsDocument = gql`
    query GetInstructorsByStaffIds($staffIds: [ID!]!) {
  instructorsByStaffIds(staffIds: $staffIds) {
    id
    userId
    activeCourseCount
    level
    assignedLocations {
      id
      name
    }
    salutation
    firstname
    lastname
    active
    showInWeb
    birthDate
    birthPlace
    annotation
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    joinDate
    leaveDate
    socialSecurityNumber
    healthInsuranceFund
    rate
    vat
    accountHolder
    iban
    bic
    bank
    email
    allowLogin
  }
}
    `;

/**
 * __useGetInstructorsByStaffIdsQuery__
 *
 * To run a query within a React component, call `useGetInstructorsByStaffIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorsByStaffIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorsByStaffIdsQuery({
 *   variables: {
 *      staffIds: // value for 'staffIds'
 *   },
 * });
 */
export function useGetInstructorsByStaffIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInstructorsByStaffIdsQuery, GetInstructorsByStaffIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInstructorsByStaffIdsQuery, GetInstructorsByStaffIdsQueryVariables>(GetInstructorsByStaffIdsDocument, baseOptions);
      }
export function useGetInstructorsByStaffIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstructorsByStaffIdsQuery, GetInstructorsByStaffIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInstructorsByStaffIdsQuery, GetInstructorsByStaffIdsQueryVariables>(GetInstructorsByStaffIdsDocument, baseOptions);
        }
export type GetInstructorsByStaffIdsQueryHookResult = ReturnType<typeof useGetInstructorsByStaffIdsQuery>;
export type GetInstructorsByStaffIdsLazyQueryHookResult = ReturnType<typeof useGetInstructorsByStaffIdsLazyQuery>;
export type GetInstructorsByStaffIdsQueryResult = ApolloReactCommon.QueryResult<GetInstructorsByStaffIdsQuery, GetInstructorsByStaffIdsQueryVariables>;
export const GetInstructorsWithPaginationDocument = gql`
    query GetInstructorsWithPagination($options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  instructorsWithPagination(options: $options, onlyCurrentUser: $onlyCurrentUser) {
    existsMore
    total
    items {
      id
      userId
      activeCourseCount
      level
      isAreaManager
      assignedLocations {
        id
        name
      }
      salutation
      firstname
      lastname
      active
      showInWeb
      birthDate
      birthPlace
      annotation
      street
      houseNumber
      postCode
      city
      phoneNumber
      mobileNumber
      email
      joinDate
      leaveDate
      socialSecurityNumber
      healthInsuranceFund
      rate
      vat
      accountHolder
      iban
      bic
      bank
      email
      assignedLocations {
        id
        name
      }
      allowLogin
    }
  }
}
    `;

/**
 * __useGetInstructorsWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetInstructorsWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorsWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorsWithPaginationQuery({
 *   variables: {
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetInstructorsWithPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInstructorsWithPaginationQuery, GetInstructorsWithPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInstructorsWithPaginationQuery, GetInstructorsWithPaginationQueryVariables>(GetInstructorsWithPaginationDocument, baseOptions);
      }
export function useGetInstructorsWithPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstructorsWithPaginationQuery, GetInstructorsWithPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInstructorsWithPaginationQuery, GetInstructorsWithPaginationQueryVariables>(GetInstructorsWithPaginationDocument, baseOptions);
        }
export type GetInstructorsWithPaginationQueryHookResult = ReturnType<typeof useGetInstructorsWithPaginationQuery>;
export type GetInstructorsWithPaginationLazyQueryHookResult = ReturnType<typeof useGetInstructorsWithPaginationLazyQuery>;
export type GetInstructorsWithPaginationQueryResult = ApolloReactCommon.QueryResult<GetInstructorsWithPaginationQuery, GetInstructorsWithPaginationQueryVariables>;
export const GetInstructorsWithPaginationInstructorDocument = gql`
    query GetInstructorsWithPaginationInstructor($options: ArrayDataOptions, $onlyCurrentUser: Boolean) {
  instructorsWithPagination(options: $options, onlyCurrentUser: $onlyCurrentUser) {
    existsMore
    total
    items {
      id
      level
      assignedLocations {
        id
        name
      }
      firstname
      lastname
      active
      birthDate
      annotation
      phoneNumber
      mobileNumber
      email
      allowLogin
    }
  }
}
    `;

/**
 * __useGetInstructorsWithPaginationInstructorQuery__
 *
 * To run a query within a React component, call `useGetInstructorsWithPaginationInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorsWithPaginationInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorsWithPaginationInstructorQuery({
 *   variables: {
 *      options: // value for 'options'
 *      onlyCurrentUser: // value for 'onlyCurrentUser'
 *   },
 * });
 */
export function useGetInstructorsWithPaginationInstructorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInstructorsWithPaginationInstructorQuery, GetInstructorsWithPaginationInstructorQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInstructorsWithPaginationInstructorQuery, GetInstructorsWithPaginationInstructorQueryVariables>(GetInstructorsWithPaginationInstructorDocument, baseOptions);
      }
export function useGetInstructorsWithPaginationInstructorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstructorsWithPaginationInstructorQuery, GetInstructorsWithPaginationInstructorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInstructorsWithPaginationInstructorQuery, GetInstructorsWithPaginationInstructorQueryVariables>(GetInstructorsWithPaginationInstructorDocument, baseOptions);
        }
export type GetInstructorsWithPaginationInstructorQueryHookResult = ReturnType<typeof useGetInstructorsWithPaginationInstructorQuery>;
export type GetInstructorsWithPaginationInstructorLazyQueryHookResult = ReturnType<typeof useGetInstructorsWithPaginationInstructorLazyQuery>;
export type GetInstructorsWithPaginationInstructorQueryResult = ApolloReactCommon.QueryResult<GetInstructorsWithPaginationInstructorQuery, GetInstructorsWithPaginationInstructorQueryVariables>;
export const IsInstructorDocument = gql`
    query IsInstructor {
  isInstructor
}
    `;

/**
 * __useIsInstructorQuery__
 *
 * To run a query within a React component, call `useIsInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsInstructorQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsInstructorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsInstructorQuery, IsInstructorQueryVariables>) {
        return ApolloReactHooks.useQuery<IsInstructorQuery, IsInstructorQueryVariables>(IsInstructorDocument, baseOptions);
      }
export function useIsInstructorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsInstructorQuery, IsInstructorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IsInstructorQuery, IsInstructorQueryVariables>(IsInstructorDocument, baseOptions);
        }
export type IsInstructorQueryHookResult = ReturnType<typeof useIsInstructorQuery>;
export type IsInstructorLazyQueryHookResult = ReturnType<typeof useIsInstructorLazyQuery>;
export type IsInstructorQueryResult = ApolloReactCommon.QueryResult<IsInstructorQuery, IsInstructorQueryVariables>;
export const CanBecomeInstructorDocument = gql`
    query canBecomeInstructor($email: String!) {
  canBecomeInstructor(email: $email)
}
    `;

/**
 * __useCanBecomeInstructorQuery__
 *
 * To run a query within a React component, call `useCanBecomeInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanBecomeInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanBecomeInstructorQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCanBecomeInstructorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CanBecomeInstructorQuery, CanBecomeInstructorQueryVariables>) {
        return ApolloReactHooks.useQuery<CanBecomeInstructorQuery, CanBecomeInstructorQueryVariables>(CanBecomeInstructorDocument, baseOptions);
      }
export function useCanBecomeInstructorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CanBecomeInstructorQuery, CanBecomeInstructorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CanBecomeInstructorQuery, CanBecomeInstructorQueryVariables>(CanBecomeInstructorDocument, baseOptions);
        }
export type CanBecomeInstructorQueryHookResult = ReturnType<typeof useCanBecomeInstructorQuery>;
export type CanBecomeInstructorLazyQueryHookResult = ReturnType<typeof useCanBecomeInstructorLazyQuery>;
export type CanBecomeInstructorQueryResult = ApolloReactCommon.QueryResult<CanBecomeInstructorQuery, CanBecomeInstructorQueryVariables>;
export const StaffGetLocationsDocument = gql`
    query StaffGetLocations {
  locations {
    id
    name
    city
    zipCode
  }
}
    `;

/**
 * __useStaffGetLocationsQuery__
 *
 * To run a query within a React component, call `useStaffGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStaffGetLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StaffGetLocationsQuery, StaffGetLocationsQueryVariables>) {
        return ApolloReactHooks.useQuery<StaffGetLocationsQuery, StaffGetLocationsQueryVariables>(StaffGetLocationsDocument, baseOptions);
      }
export function useStaffGetLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StaffGetLocationsQuery, StaffGetLocationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StaffGetLocationsQuery, StaffGetLocationsQueryVariables>(StaffGetLocationsDocument, baseOptions);
        }
export type StaffGetLocationsQueryHookResult = ReturnType<typeof useStaffGetLocationsQuery>;
export type StaffGetLocationsLazyQueryHookResult = ReturnType<typeof useStaffGetLocationsLazyQuery>;
export type StaffGetLocationsQueryResult = ApolloReactCommon.QueryResult<StaffGetLocationsQuery, StaffGetLocationsQueryVariables>;
export const RemoveInstructorDocument = gql`
    mutation RemoveInstructor($id: String!) {
  removeInstructor(id: $id)
}
    `;
export type RemoveInstructorMutationFn = ApolloReactCommon.MutationFunction<RemoveInstructorMutation, RemoveInstructorMutationVariables>;

/**
 * __useRemoveInstructorMutation__
 *
 * To run a mutation, you first call `useRemoveInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInstructorMutation, { data, loading, error }] = useRemoveInstructorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInstructorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveInstructorMutation, RemoveInstructorMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveInstructorMutation, RemoveInstructorMutationVariables>(RemoveInstructorDocument, baseOptions);
      }
export type RemoveInstructorMutationHookResult = ReturnType<typeof useRemoveInstructorMutation>;
export type RemoveInstructorMutationResult = ApolloReactCommon.MutationResult<RemoveInstructorMutation>;
export type RemoveInstructorMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveInstructorMutation, RemoveInstructorMutationVariables>;
export const StaffSharingLoginDocument = gql`
    query StaffSharingLogin($userId: String!) {
  staffSharingLogin(userId: $userId) {
    id
    firstname
    lastname
    active
  }
}
    `;

/**
 * __useStaffSharingLoginQuery__
 *
 * To run a query within a React component, call `useStaffSharingLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffSharingLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffSharingLoginQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStaffSharingLoginQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StaffSharingLoginQuery, StaffSharingLoginQueryVariables>) {
        return ApolloReactHooks.useQuery<StaffSharingLoginQuery, StaffSharingLoginQueryVariables>(StaffSharingLoginDocument, baseOptions);
      }
export function useStaffSharingLoginLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StaffSharingLoginQuery, StaffSharingLoginQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StaffSharingLoginQuery, StaffSharingLoginQueryVariables>(StaffSharingLoginDocument, baseOptions);
        }
export type StaffSharingLoginQueryHookResult = ReturnType<typeof useStaffSharingLoginQuery>;
export type StaffSharingLoginLazyQueryHookResult = ReturnType<typeof useStaffSharingLoginLazyQuery>;
export type StaffSharingLoginQueryResult = ApolloReactCommon.QueryResult<StaffSharingLoginQuery, StaffSharingLoginQueryVariables>;
export const GetContentOfBucketDoDocument = gql`
    query GetContentOfBucketDo {
  getContentOfBucketDo {
    ContentOfBucketResponse {
      IsTruncated
      Marker
      NextMarker
      Name
      Prefix
      Delimiter
      MaxKeys
      CommonPrefixes
      EncodingType
    }
    Folders {
      Name
      Key
      LastModified
      ETag
      Size
    }
    Files {
      Name
      Key
      LastModified
      ETag
      Size
      signedImageUrl
    }
  }
}
    `;

/**
 * __useGetContentOfBucketDoQuery__
 *
 * To run a query within a React component, call `useGetContentOfBucketDoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentOfBucketDoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentOfBucketDoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentOfBucketDoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContentOfBucketDoQuery, GetContentOfBucketDoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContentOfBucketDoQuery, GetContentOfBucketDoQueryVariables>(GetContentOfBucketDoDocument, baseOptions);
      }
export function useGetContentOfBucketDoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContentOfBucketDoQuery, GetContentOfBucketDoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContentOfBucketDoQuery, GetContentOfBucketDoQueryVariables>(GetContentOfBucketDoDocument, baseOptions);
        }
export type GetContentOfBucketDoQueryHookResult = ReturnType<typeof useGetContentOfBucketDoQuery>;
export type GetContentOfBucketDoLazyQueryHookResult = ReturnType<typeof useGetContentOfBucketDoLazyQuery>;
export type GetContentOfBucketDoQueryResult = ApolloReactCommon.QueryResult<GetContentOfBucketDoQuery, GetContentOfBucketDoQueryVariables>;
export const GetContentOfFolderDoDocument = gql`
    query GetContentOfFolderDo($folderName: String) {
  getContentOfFolderDo(folderName: $folderName) {
    ContentOfBucketResponse {
      IsTruncated
      Marker
      NextMarker
      Name
      Prefix
      Delimiter
      MaxKeys
      CommonPrefixes
      EncodingType
    }
    Folders {
      Name
      Key
      LastModified
      ETag
      Size
    }
    Files {
      Name
      Key
      LastModified
      ETag
      Size
      signedImageUrl
    }
  }
}
    `;

/**
 * __useGetContentOfFolderDoQuery__
 *
 * To run a query within a React component, call `useGetContentOfFolderDoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentOfFolderDoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentOfFolderDoQuery({
 *   variables: {
 *      folderName: // value for 'folderName'
 *   },
 * });
 */
export function useGetContentOfFolderDoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContentOfFolderDoQuery, GetContentOfFolderDoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContentOfFolderDoQuery, GetContentOfFolderDoQueryVariables>(GetContentOfFolderDoDocument, baseOptions);
      }
export function useGetContentOfFolderDoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContentOfFolderDoQuery, GetContentOfFolderDoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContentOfFolderDoQuery, GetContentOfFolderDoQueryVariables>(GetContentOfFolderDoDocument, baseOptions);
        }
export type GetContentOfFolderDoQueryHookResult = ReturnType<typeof useGetContentOfFolderDoQuery>;
export type GetContentOfFolderDoLazyQueryHookResult = ReturnType<typeof useGetContentOfFolderDoLazyQuery>;
export type GetContentOfFolderDoQueryResult = ApolloReactCommon.QueryResult<GetContentOfFolderDoQuery, GetContentOfFolderDoQueryVariables>;
export const GetContentByPathDoDocument = gql`
    query GetContentByPathDo($path: String!, $options: ArrayDataOptions) {
  getContentByPathDo(path: $path, options: $options) {
    ContentOfBucketResponse {
      IsTruncated
      Marker
      NextMarker
      Name
      Prefix
      Delimiter
      MaxKeys
      CommonPrefixes
      EncodingType
    }
    Folders {
      Name
      Key
      LastModified
      ETag
      Size
    }
    Files {
      Name
      Key
      LastModified
      ETag
      Size
      signedImageUrl
    }
  }
}
    `;

/**
 * __useGetContentByPathDoQuery__
 *
 * To run a query within a React component, call `useGetContentByPathDoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByPathDoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentByPathDoQuery({
 *   variables: {
 *      path: // value for 'path'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetContentByPathDoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContentByPathDoQuery, GetContentByPathDoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContentByPathDoQuery, GetContentByPathDoQueryVariables>(GetContentByPathDoDocument, baseOptions);
      }
export function useGetContentByPathDoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContentByPathDoQuery, GetContentByPathDoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContentByPathDoQuery, GetContentByPathDoQueryVariables>(GetContentByPathDoDocument, baseOptions);
        }
export type GetContentByPathDoQueryHookResult = ReturnType<typeof useGetContentByPathDoQuery>;
export type GetContentByPathDoLazyQueryHookResult = ReturnType<typeof useGetContentByPathDoLazyQuery>;
export type GetContentByPathDoQueryResult = ApolloReactCommon.QueryResult<GetContentByPathDoQuery, GetContentByPathDoQueryVariables>;
export const GetPdfDoDocument = gql`
    query GetPdfDo($fileName: String!) {
  getFileDo(fileName: $fileName) {
    Name
    Key
    LastModified
    ETag
    Size
    pdfBlob
    signedImageUrl
  }
}
    `;

/**
 * __useGetPdfDoQuery__
 *
 * To run a query within a React component, call `useGetPdfDoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfDoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfDoQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetPdfDoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPdfDoQuery, GetPdfDoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPdfDoQuery, GetPdfDoQueryVariables>(GetPdfDoDocument, baseOptions);
      }
export function useGetPdfDoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPdfDoQuery, GetPdfDoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPdfDoQuery, GetPdfDoQueryVariables>(GetPdfDoDocument, baseOptions);
        }
export type GetPdfDoQueryHookResult = ReturnType<typeof useGetPdfDoQuery>;
export type GetPdfDoLazyQueryHookResult = ReturnType<typeof useGetPdfDoLazyQuery>;
export type GetPdfDoQueryResult = ApolloReactCommon.QueryResult<GetPdfDoQuery, GetPdfDoQueryVariables>;
export const GetFileDoDocument = gql`
    query GetFileDo($fileName: String!) {
  getFileDo(fileName: $fileName) {
    Name
    Key
    LastModified
    ETag
    Size
    pdfBlob
    signedImageUrl
  }
}
    `;

/**
 * __useGetFileDoQuery__
 *
 * To run a query within a React component, call `useGetFileDoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileDoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileDoQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetFileDoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFileDoQuery, GetFileDoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFileDoQuery, GetFileDoQueryVariables>(GetFileDoDocument, baseOptions);
      }
export function useGetFileDoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFileDoQuery, GetFileDoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFileDoQuery, GetFileDoQueryVariables>(GetFileDoDocument, baseOptions);
        }
export type GetFileDoQueryHookResult = ReturnType<typeof useGetFileDoQuery>;
export type GetFileDoLazyQueryHookResult = ReturnType<typeof useGetFileDoLazyQuery>;
export type GetFileDoQueryResult = ApolloReactCommon.QueryResult<GetFileDoQuery, GetFileDoQueryVariables>;
export const AddFolderDoDocument = gql`
    mutation AddFolderDo($folderName: String!) {
  addFolderDo(folderName: $folderName)
}
    `;
export type AddFolderDoMutationFn = ApolloReactCommon.MutationFunction<AddFolderDoMutation, AddFolderDoMutationVariables>;

/**
 * __useAddFolderDoMutation__
 *
 * To run a mutation, you first call `useAddFolderDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFolderDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFolderDoMutation, { data, loading, error }] = useAddFolderDoMutation({
 *   variables: {
 *      folderName: // value for 'folderName'
 *   },
 * });
 */
export function useAddFolderDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFolderDoMutation, AddFolderDoMutationVariables>) {
        return ApolloReactHooks.useMutation<AddFolderDoMutation, AddFolderDoMutationVariables>(AddFolderDoDocument, baseOptions);
      }
export type AddFolderDoMutationHookResult = ReturnType<typeof useAddFolderDoMutation>;
export type AddFolderDoMutationResult = ApolloReactCommon.MutationResult<AddFolderDoMutation>;
export type AddFolderDoMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFolderDoMutation, AddFolderDoMutationVariables>;
export const DeleteFolderDoDocument = gql`
    mutation DeleteFolderDo($folderName: String!) {
  deleteFolderDo(folderName: $folderName)
}
    `;
export type DeleteFolderDoMutationFn = ApolloReactCommon.MutationFunction<DeleteFolderDoMutation, DeleteFolderDoMutationVariables>;

/**
 * __useDeleteFolderDoMutation__
 *
 * To run a mutation, you first call `useDeleteFolderDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderDoMutation, { data, loading, error }] = useDeleteFolderDoMutation({
 *   variables: {
 *      folderName: // value for 'folderName'
 *   },
 * });
 */
export function useDeleteFolderDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFolderDoMutation, DeleteFolderDoMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteFolderDoMutation, DeleteFolderDoMutationVariables>(DeleteFolderDoDocument, baseOptions);
      }
export type DeleteFolderDoMutationHookResult = ReturnType<typeof useDeleteFolderDoMutation>;
export type DeleteFolderDoMutationResult = ApolloReactCommon.MutationResult<DeleteFolderDoMutation>;
export type DeleteFolderDoMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFolderDoMutation, DeleteFolderDoMutationVariables>;
export const UploadFilesDoDocument = gql`
    mutation UploadFilesDo($fileArray: [Upload!]!, $path: String!, $metadata: UploadMetadataInput!) {
  uploadFilesDo(fileArray: $fileArray, path: $path, metadata: $metadata)
}
    `;
export type UploadFilesDoMutationFn = ApolloReactCommon.MutationFunction<UploadFilesDoMutation, UploadFilesDoMutationVariables>;

/**
 * __useUploadFilesDoMutation__
 *
 * To run a mutation, you first call `useUploadFilesDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFilesDoMutation, { data, loading, error }] = useUploadFilesDoMutation({
 *   variables: {
 *      fileArray: // value for 'fileArray'
 *      path: // value for 'path'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUploadFilesDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadFilesDoMutation, UploadFilesDoMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadFilesDoMutation, UploadFilesDoMutationVariables>(UploadFilesDoDocument, baseOptions);
      }
export type UploadFilesDoMutationHookResult = ReturnType<typeof useUploadFilesDoMutation>;
export type UploadFilesDoMutationResult = ApolloReactCommon.MutationResult<UploadFilesDoMutation>;
export type UploadFilesDoMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadFilesDoMutation, UploadFilesDoMutationVariables>;
export const UploadSingleFileDoDocument = gql`
    mutation UploadSingleFileDo($file: Upload!, $path: String!) {
  uploadSingleFileDo(file: $file, path: $path)
}
    `;
export type UploadSingleFileDoMutationFn = ApolloReactCommon.MutationFunction<UploadSingleFileDoMutation, UploadSingleFileDoMutationVariables>;

/**
 * __useUploadSingleFileDoMutation__
 *
 * To run a mutation, you first call `useUploadSingleFileDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSingleFileDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSingleFileDoMutation, { data, loading, error }] = useUploadSingleFileDoMutation({
 *   variables: {
 *      file: // value for 'file'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useUploadSingleFileDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadSingleFileDoMutation, UploadSingleFileDoMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadSingleFileDoMutation, UploadSingleFileDoMutationVariables>(UploadSingleFileDoDocument, baseOptions);
      }
export type UploadSingleFileDoMutationHookResult = ReturnType<typeof useUploadSingleFileDoMutation>;
export type UploadSingleFileDoMutationResult = ApolloReactCommon.MutationResult<UploadSingleFileDoMutation>;
export type UploadSingleFileDoMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadSingleFileDoMutation, UploadSingleFileDoMutationVariables>;
export const DeleteFileDoDocument = gql`
    mutation DeleteFileDo($fileName: String!) {
  deleteFileDo(fileName: $fileName)
}
    `;
export type DeleteFileDoMutationFn = ApolloReactCommon.MutationFunction<DeleteFileDoMutation, DeleteFileDoMutationVariables>;

/**
 * __useDeleteFileDoMutation__
 *
 * To run a mutation, you first call `useDeleteFileDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileDoMutation, { data, loading, error }] = useDeleteFileDoMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useDeleteFileDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFileDoMutation, DeleteFileDoMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteFileDoMutation, DeleteFileDoMutationVariables>(DeleteFileDoDocument, baseOptions);
      }
export type DeleteFileDoMutationHookResult = ReturnType<typeof useDeleteFileDoMutation>;
export type DeleteFileDoMutationResult = ApolloReactCommon.MutationResult<DeleteFileDoMutation>;
export type DeleteFileDoMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFileDoMutation, DeleteFileDoMutationVariables>;
export const RenameFileDoDocument = gql`
    mutation RenameFileDo($fileName: String!, $newFileName: String!) {
  renameFileDo(fileName: $fileName, newFileName: $newFileName)
}
    `;
export type RenameFileDoMutationFn = ApolloReactCommon.MutationFunction<RenameFileDoMutation, RenameFileDoMutationVariables>;

/**
 * __useRenameFileDoMutation__
 *
 * To run a mutation, you first call `useRenameFileDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFileDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFileDoMutation, { data, loading, error }] = useRenameFileDoMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      newFileName: // value for 'newFileName'
 *   },
 * });
 */
export function useRenameFileDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenameFileDoMutation, RenameFileDoMutationVariables>) {
        return ApolloReactHooks.useMutation<RenameFileDoMutation, RenameFileDoMutationVariables>(RenameFileDoDocument, baseOptions);
      }
export type RenameFileDoMutationHookResult = ReturnType<typeof useRenameFileDoMutation>;
export type RenameFileDoMutationResult = ApolloReactCommon.MutationResult<RenameFileDoMutation>;
export type RenameFileDoMutationOptions = ApolloReactCommon.BaseMutationOptions<RenameFileDoMutation, RenameFileDoMutationVariables>;
export const RenameFolderDoDocument = gql`
    mutation RenameFolderDo($folderName: String!, $newFolderName: String!) {
  renameFolderDo(folderName: $folderName, newFolderName: $newFolderName)
}
    `;
export type RenameFolderDoMutationFn = ApolloReactCommon.MutationFunction<RenameFolderDoMutation, RenameFolderDoMutationVariables>;

/**
 * __useRenameFolderDoMutation__
 *
 * To run a mutation, you first call `useRenameFolderDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFolderDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFolderDoMutation, { data, loading, error }] = useRenameFolderDoMutation({
 *   variables: {
 *      folderName: // value for 'folderName'
 *      newFolderName: // value for 'newFolderName'
 *   },
 * });
 */
export function useRenameFolderDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenameFolderDoMutation, RenameFolderDoMutationVariables>) {
        return ApolloReactHooks.useMutation<RenameFolderDoMutation, RenameFolderDoMutationVariables>(RenameFolderDoDocument, baseOptions);
      }
export type RenameFolderDoMutationHookResult = ReturnType<typeof useRenameFolderDoMutation>;
export type RenameFolderDoMutationResult = ApolloReactCommon.MutationResult<RenameFolderDoMutation>;
export type RenameFolderDoMutationOptions = ApolloReactCommon.BaseMutationOptions<RenameFolderDoMutation, RenameFolderDoMutationVariables>;
export const GetSignedUrlDoDocument = gql`
    query GetSignedUrlDo($fileName: String!) {
  getSignedUrlDo(fileName: $fileName)
}
    `;

/**
 * __useGetSignedUrlDoQuery__
 *
 * To run a query within a React component, call `useGetSignedUrlDoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlDoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUrlDoQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetSignedUrlDoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSignedUrlDoQuery, GetSignedUrlDoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSignedUrlDoQuery, GetSignedUrlDoQueryVariables>(GetSignedUrlDoDocument, baseOptions);
      }
export function useGetSignedUrlDoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSignedUrlDoQuery, GetSignedUrlDoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSignedUrlDoQuery, GetSignedUrlDoQueryVariables>(GetSignedUrlDoDocument, baseOptions);
        }
export type GetSignedUrlDoQueryHookResult = ReturnType<typeof useGetSignedUrlDoQuery>;
export type GetSignedUrlDoLazyQueryHookResult = ReturnType<typeof useGetSignedUrlDoLazyQuery>;
export type GetSignedUrlDoQueryResult = ApolloReactCommon.QueryResult<GetSignedUrlDoQuery, GetSignedUrlDoQueryVariables>;
export const DownloadFileDoDocument = gql`
    mutation DownloadFileDo($fileName: String!) {
  downloadFileDo(fileName: $fileName)
}
    `;
export type DownloadFileDoMutationFn = ApolloReactCommon.MutationFunction<DownloadFileDoMutation, DownloadFileDoMutationVariables>;

/**
 * __useDownloadFileDoMutation__
 *
 * To run a mutation, you first call `useDownloadFileDoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileDoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFileDoMutation, { data, loading, error }] = useDownloadFileDoMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useDownloadFileDoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadFileDoMutation, DownloadFileDoMutationVariables>) {
        return ApolloReactHooks.useMutation<DownloadFileDoMutation, DownloadFileDoMutationVariables>(DownloadFileDoDocument, baseOptions);
      }
export type DownloadFileDoMutationHookResult = ReturnType<typeof useDownloadFileDoMutation>;
export type DownloadFileDoMutationResult = ApolloReactCommon.MutationResult<DownloadFileDoMutation>;
export type DownloadFileDoMutationOptions = ApolloReactCommon.BaseMutationOptions<DownloadFileDoMutation, DownloadFileDoMutationVariables>;
export const GetPagesDocument = gql`
    query GetPages {
  getPages {
    pages {
      id
      url
      content {
        title
        subTitle
        body
      }
    }
  }
}
    `;

/**
 * __useGetPagesQuery__
 *
 * To run a query within a React component, call `useGetPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPagesQuery, GetPagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPagesQuery, GetPagesQueryVariables>(GetPagesDocument, baseOptions);
      }
export function useGetPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPagesQuery, GetPagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPagesQuery, GetPagesQueryVariables>(GetPagesDocument, baseOptions);
        }
export type GetPagesQueryHookResult = ReturnType<typeof useGetPagesQuery>;
export type GetPagesLazyQueryHookResult = ReturnType<typeof useGetPagesLazyQuery>;
export type GetPagesQueryResult = ApolloReactCommon.QueryResult<GetPagesQuery, GetPagesQueryVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($editPageInput: EditPageInput!) {
  updatePage(editPageInput: $editPageInput) {
    pages {
      id
      url
      content {
        title
        subTitle
        body
      }
    }
  }
}
    `;
export type UpdatePageMutationFn = ApolloReactCommon.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      editPageInput: // value for 'editPageInput'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, baseOptions);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = ApolloReactCommon.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const AddPageDocument = gql`
    mutation AddPage($newPageInput: NewPageInput!) {
  addPage(newPageInput: $newPageInput) {
    pages {
      id
      url
      content {
        title
        subTitle
        body
      }
    }
  }
}
    `;
export type AddPageMutationFn = ApolloReactCommon.MutationFunction<AddPageMutation, AddPageMutationVariables>;

/**
 * __useAddPageMutation__
 *
 * To run a mutation, you first call `useAddPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPageMutation, { data, loading, error }] = useAddPageMutation({
 *   variables: {
 *      newPageInput: // value for 'newPageInput'
 *   },
 * });
 */
export function useAddPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPageMutation, AddPageMutationVariables>) {
        return ApolloReactHooks.useMutation<AddPageMutation, AddPageMutationVariables>(AddPageDocument, baseOptions);
      }
export type AddPageMutationHookResult = ReturnType<typeof useAddPageMutation>;
export type AddPageMutationResult = ApolloReactCommon.MutationResult<AddPageMutation>;
export type AddPageMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPageMutation, AddPageMutationVariables>;
export const DeletePageDocument = gql`
    mutation DeletePage($pageId: String!) {
  deletePage(pageId: $pageId) {
    pages {
      id
      url
      content {
        title
        subTitle
        body
      }
    }
  }
}
    `;
export type DeletePageMutationFn = ApolloReactCommon.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, baseOptions);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = ApolloReactCommon.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const SubmitSupportReportDocument = gql`
    mutation SubmitSupportReport($input: SupportReportInput!) {
  submitSupportReport(input: $input)
}
    `;
export type SubmitSupportReportMutationFn = ApolloReactCommon.MutationFunction<SubmitSupportReportMutation, SubmitSupportReportMutationVariables>;

/**
 * __useSubmitSupportReportMutation__
 *
 * To run a mutation, you first call `useSubmitSupportReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSupportReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSupportReportMutation, { data, loading, error }] = useSubmitSupportReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSupportReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitSupportReportMutation, SubmitSupportReportMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitSupportReportMutation, SubmitSupportReportMutationVariables>(SubmitSupportReportDocument, baseOptions);
      }
export type SubmitSupportReportMutationHookResult = ReturnType<typeof useSubmitSupportReportMutation>;
export type SubmitSupportReportMutationResult = ApolloReactCommon.MutationResult<SubmitSupportReportMutation>;
export type SubmitSupportReportMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitSupportReportMutation, SubmitSupportReportMutationVariables>;
export const UploadSingleCamtFileDocument = gql`
    mutation UploadSingleCamtFile($file: Upload!, $analysis: Boolean) {
  singleUpload(file: $file, analysis: $analysis)
}
    `;
export type UploadSingleCamtFileMutationFn = ApolloReactCommon.MutationFunction<UploadSingleCamtFileMutation, UploadSingleCamtFileMutationVariables>;

/**
 * __useUploadSingleCamtFileMutation__
 *
 * To run a mutation, you first call `useUploadSingleCamtFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSingleCamtFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSingleCamtFileMutation, { data, loading, error }] = useUploadSingleCamtFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      analysis: // value for 'analysis'
 *   },
 * });
 */
export function useUploadSingleCamtFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadSingleCamtFileMutation, UploadSingleCamtFileMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadSingleCamtFileMutation, UploadSingleCamtFileMutationVariables>(UploadSingleCamtFileDocument, baseOptions);
      }
export type UploadSingleCamtFileMutationHookResult = ReturnType<typeof useUploadSingleCamtFileMutation>;
export type UploadSingleCamtFileMutationResult = ApolloReactCommon.MutationResult<UploadSingleCamtFileMutation>;
export type UploadSingleCamtFileMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadSingleCamtFileMutation, UploadSingleCamtFileMutationVariables>;
export const GetSwissQrFilesDocument = gql`
    query GetSwissQRFiles {
  swissQRFiles {
    id
    fileId
    filename
    createDate
    createdByUserId
    records {
      id
      amount
      result
      valutaDate
      swissQrRef
      successful
      comment
      creditAmount
      originalOpenAmount
      scheduledPayment {
        id
        bookingId
        paymentAmount
        openAmount
      }
    }
  }
}
    `;

/**
 * __useGetSwissQrFilesQuery__
 *
 * To run a query within a React component, call `useGetSwissQrFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissQrFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissQrFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSwissQrFilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSwissQrFilesQuery, GetSwissQrFilesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSwissQrFilesQuery, GetSwissQrFilesQueryVariables>(GetSwissQrFilesDocument, baseOptions);
      }
export function useGetSwissQrFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSwissQrFilesQuery, GetSwissQrFilesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSwissQrFilesQuery, GetSwissQrFilesQueryVariables>(GetSwissQrFilesDocument, baseOptions);
        }
export type GetSwissQrFilesQueryHookResult = ReturnType<typeof useGetSwissQrFilesQuery>;
export type GetSwissQrFilesLazyQueryHookResult = ReturnType<typeof useGetSwissQrFilesLazyQuery>;
export type GetSwissQrFilesQueryResult = ApolloReactCommon.QueryResult<GetSwissQrFilesQuery, GetSwissQrFilesQueryVariables>;
export const UpdateSwissQrFileNoteDocument = gql`
    mutation UpdateSwissQRFileNote($id: ID!, $note: String) {
  updateSwissQRFileNote(id: $id, note: $note) {
    id
    note
  }
}
    `;
export type UpdateSwissQrFileNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateSwissQrFileNoteMutation, UpdateSwissQrFileNoteMutationVariables>;

/**
 * __useUpdateSwissQrFileNoteMutation__
 *
 * To run a mutation, you first call `useUpdateSwissQrFileNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSwissQrFileNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSwissQrFileNoteMutation, { data, loading, error }] = useUpdateSwissQrFileNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateSwissQrFileNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSwissQrFileNoteMutation, UpdateSwissQrFileNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSwissQrFileNoteMutation, UpdateSwissQrFileNoteMutationVariables>(UpdateSwissQrFileNoteDocument, baseOptions);
      }
export type UpdateSwissQrFileNoteMutationHookResult = ReturnType<typeof useUpdateSwissQrFileNoteMutation>;
export type UpdateSwissQrFileNoteMutationResult = ApolloReactCommon.MutationResult<UpdateSwissQrFileNoteMutation>;
export type UpdateSwissQrFileNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSwissQrFileNoteMutation, UpdateSwissQrFileNoteMutationVariables>;
export const GetSwissQrFilesOverviewDocument = gql`
    query GetSwissQRFilesOverview($limit: Int, $offset: Int, $onlyOpen: Boolean) {
  swissQRFilesOverview(limit: $limit, offset: $offset, onlyOpen: $onlyOpen) {
    items {
      id
      fileId
      filename
      createDate
      createdByUserId
      note
      totalRecords
      paidCount
      overpaidCount
      underpaidCount
      ambiguousCount
      resolvedCount
      errorCount
      totalAmount
    }
    total
    openRecordCount
  }
}
    `;

/**
 * __useGetSwissQrFilesOverviewQuery__
 *
 * To run a query within a React component, call `useGetSwissQrFilesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissQrFilesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissQrFilesOverviewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      onlyOpen: // value for 'onlyOpen'
 *   },
 * });
 */
export function useGetSwissQrFilesOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSwissQrFilesOverviewQuery, GetSwissQrFilesOverviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSwissQrFilesOverviewQuery, GetSwissQrFilesOverviewQueryVariables>(GetSwissQrFilesOverviewDocument, baseOptions);
      }
export function useGetSwissQrFilesOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSwissQrFilesOverviewQuery, GetSwissQrFilesOverviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSwissQrFilesOverviewQuery, GetSwissQrFilesOverviewQueryVariables>(GetSwissQrFilesOverviewDocument, baseOptions);
        }
export type GetSwissQrFilesOverviewQueryHookResult = ReturnType<typeof useGetSwissQrFilesOverviewQuery>;
export type GetSwissQrFilesOverviewLazyQueryHookResult = ReturnType<typeof useGetSwissQrFilesOverviewLazyQuery>;
export type GetSwissQrFilesOverviewQueryResult = ApolloReactCommon.QueryResult<GetSwissQrFilesOverviewQuery, GetSwissQrFilesOverviewQueryVariables>;
export const GetSwissQrFileByIdDocument = gql`
    query GetSwissQRFileById($id: ID!) {
  swissQRFileById(id: $id) {
    id
    fileId
    filename
    createDate
    records {
      id
      amount
      result
      valutaDate
      swissQrRef
      successful
      comment
      creditAmount
      originalOpenAmount
      scheduledPayment {
        id
        bookingId
        paymentAmount
        openAmount
        invoice {
          id
          invoiceNumberPrefix
          invoiceNumber
        }
        booking {
          id
          bookingNumberPrefix
          bookingNumber
          bookingType
          canceled
          attendee {
            id
            customerId
            firstname
            lastname
            booker {
              id
              customerId
              firstname
              lastname
            }
          }
          course {
            id
            prefixedCourseNumber
            courseType {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSwissQrFileByIdQuery__
 *
 * To run a query within a React component, call `useGetSwissQrFileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissQrFileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissQrFileByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSwissQrFileByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSwissQrFileByIdQuery, GetSwissQrFileByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSwissQrFileByIdQuery, GetSwissQrFileByIdQueryVariables>(GetSwissQrFileByIdDocument, baseOptions);
      }
export function useGetSwissQrFileByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSwissQrFileByIdQuery, GetSwissQrFileByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSwissQrFileByIdQuery, GetSwissQrFileByIdQueryVariables>(GetSwissQrFileByIdDocument, baseOptions);
        }
export type GetSwissQrFileByIdQueryHookResult = ReturnType<typeof useGetSwissQrFileByIdQuery>;
export type GetSwissQrFileByIdLazyQueryHookResult = ReturnType<typeof useGetSwissQrFileByIdLazyQuery>;
export type GetSwissQrFileByIdQueryResult = ApolloReactCommon.QueryResult<GetSwissQrFileByIdQuery, GetSwissQrFileByIdQueryVariables>;
export const AssignAmbiguousSwissQrPaymentDocument = gql`
    mutation AssignAmbiguousSwissQRPayment($recordId: ID!, $distributions: [AssignAmbiguousPaymentDistributionInput!]!) {
  assignAmbiguousSwissQRPayment(recordId: $recordId, distributions: $distributions) {
    id
    result
    comment
    creditAmount
  }
}
    `;
export type AssignAmbiguousSwissQrPaymentMutationFn = ApolloReactCommon.MutationFunction<AssignAmbiguousSwissQrPaymentMutation, AssignAmbiguousSwissQrPaymentMutationVariables>;

/**
 * __useAssignAmbiguousSwissQrPaymentMutation__
 *
 * To run a mutation, you first call `useAssignAmbiguousSwissQrPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAmbiguousSwissQrPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAmbiguousSwissQrPaymentMutation, { data, loading, error }] = useAssignAmbiguousSwissQrPaymentMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      distributions: // value for 'distributions'
 *   },
 * });
 */
export function useAssignAmbiguousSwissQrPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignAmbiguousSwissQrPaymentMutation, AssignAmbiguousSwissQrPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignAmbiguousSwissQrPaymentMutation, AssignAmbiguousSwissQrPaymentMutationVariables>(AssignAmbiguousSwissQrPaymentDocument, baseOptions);
      }
export type AssignAmbiguousSwissQrPaymentMutationHookResult = ReturnType<typeof useAssignAmbiguousSwissQrPaymentMutation>;
export type AssignAmbiguousSwissQrPaymentMutationResult = ApolloReactCommon.MutationResult<AssignAmbiguousSwissQrPaymentMutation>;
export type AssignAmbiguousSwissQrPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignAmbiguousSwissQrPaymentMutation, AssignAmbiguousSwissQrPaymentMutationVariables>;
export const ResolveAmbiguousSwissQrPaymentDocument = gql`
    mutation ResolveAmbiguousSwissQRPayment($recordId: ID!, $comment: String!) {
  resolveAmbiguousSwissQRPayment(recordId: $recordId, comment: $comment) {
    id
    result
    comment
  }
}
    `;
export type ResolveAmbiguousSwissQrPaymentMutationFn = ApolloReactCommon.MutationFunction<ResolveAmbiguousSwissQrPaymentMutation, ResolveAmbiguousSwissQrPaymentMutationVariables>;

/**
 * __useResolveAmbiguousSwissQrPaymentMutation__
 *
 * To run a mutation, you first call `useResolveAmbiguousSwissQrPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveAmbiguousSwissQrPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveAmbiguousSwissQrPaymentMutation, { data, loading, error }] = useResolveAmbiguousSwissQrPaymentMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useResolveAmbiguousSwissQrPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveAmbiguousSwissQrPaymentMutation, ResolveAmbiguousSwissQrPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<ResolveAmbiguousSwissQrPaymentMutation, ResolveAmbiguousSwissQrPaymentMutationVariables>(ResolveAmbiguousSwissQrPaymentDocument, baseOptions);
      }
export type ResolveAmbiguousSwissQrPaymentMutationHookResult = ReturnType<typeof useResolveAmbiguousSwissQrPaymentMutation>;
export type ResolveAmbiguousSwissQrPaymentMutationResult = ApolloReactCommon.MutationResult<ResolveAmbiguousSwissQrPaymentMutation>;
export type ResolveAmbiguousSwissQrPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<ResolveAmbiguousSwissQrPaymentMutation, ResolveAmbiguousSwissQrPaymentMutationVariables>;
export const GetSwissQrRecordContextDocument = gql`
    query GetSwissQRRecordContext($recordId: ID!) {
  swissQRRecordContext(recordId: $recordId) {
    invoiceEvents {
      kind
      date
      amount
      source
    }
    otherRates {
      scheduledPaymentId
      bookingId
      bookingNumber
      invoiceNumber
      attendeeName
      amount
      openAmount
      paymentDue
      paymentDone
      paidWithoutReceipt
    }
  }
}
    `;

/**
 * __useGetSwissQrRecordContextQuery__
 *
 * To run a query within a React component, call `useGetSwissQrRecordContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissQrRecordContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissQrRecordContextQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useGetSwissQrRecordContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSwissQrRecordContextQuery, GetSwissQrRecordContextQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSwissQrRecordContextQuery, GetSwissQrRecordContextQueryVariables>(GetSwissQrRecordContextDocument, baseOptions);
      }
export function useGetSwissQrRecordContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSwissQrRecordContextQuery, GetSwissQrRecordContextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSwissQrRecordContextQuery, GetSwissQrRecordContextQueryVariables>(GetSwissQrRecordContextDocument, baseOptions);
        }
export type GetSwissQrRecordContextQueryHookResult = ReturnType<typeof useGetSwissQrRecordContextQuery>;
export type GetSwissQrRecordContextLazyQueryHookResult = ReturnType<typeof useGetSwissQrRecordContextLazyQuery>;
export type GetSwissQrRecordContextQueryResult = ApolloReactCommon.QueryResult<GetSwissQrRecordContextQuery, GetSwissQrRecordContextQueryVariables>;
export const CreateDummyCamtFileForMultiplePaymentsDocument = gql`
    mutation CreateDummyCamtFileForMultiplePayments($createDummySwissCamtByScheduledPaymentsInput: CreateDummySwissCamtByScheduledPaymentsInput!) {
  createDummyCamtFileForMultiplePayments(createDummySwissCamtByScheduledPaymentsInput: $createDummySwissCamtByScheduledPaymentsInput)
}
    `;
export type CreateDummyCamtFileForMultiplePaymentsMutationFn = ApolloReactCommon.MutationFunction<CreateDummyCamtFileForMultiplePaymentsMutation, CreateDummyCamtFileForMultiplePaymentsMutationVariables>;

/**
 * __useCreateDummyCamtFileForMultiplePaymentsMutation__
 *
 * To run a mutation, you first call `useCreateDummyCamtFileForMultiplePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDummyCamtFileForMultiplePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDummyCamtFileForMultiplePaymentsMutation, { data, loading, error }] = useCreateDummyCamtFileForMultiplePaymentsMutation({
 *   variables: {
 *      createDummySwissCamtByScheduledPaymentsInput: // value for 'createDummySwissCamtByScheduledPaymentsInput'
 *   },
 * });
 */
export function useCreateDummyCamtFileForMultiplePaymentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDummyCamtFileForMultiplePaymentsMutation, CreateDummyCamtFileForMultiplePaymentsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDummyCamtFileForMultiplePaymentsMutation, CreateDummyCamtFileForMultiplePaymentsMutationVariables>(CreateDummyCamtFileForMultiplePaymentsDocument, baseOptions);
      }
export type CreateDummyCamtFileForMultiplePaymentsMutationHookResult = ReturnType<typeof useCreateDummyCamtFileForMultiplePaymentsMutation>;
export type CreateDummyCamtFileForMultiplePaymentsMutationResult = ApolloReactCommon.MutationResult<CreateDummyCamtFileForMultiplePaymentsMutation>;
export type CreateDummyCamtFileForMultiplePaymentsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDummyCamtFileForMultiplePaymentsMutation, CreateDummyCamtFileForMultiplePaymentsMutationVariables>;
export const SendEmailToSelectionOfCourseDocument = gql`
    mutation SendEmailToSelectionOfCourse($sendMailToSelectionOfCourseInput: SendMailToSelectionOfCourseInput!) {
  sendEmailsToSelectionOfCourse(sendMailToSelectionOfCourseInput: $sendMailToSelectionOfCourseInput)
}
    `;
export type SendEmailToSelectionOfCourseMutationFn = ApolloReactCommon.MutationFunction<SendEmailToSelectionOfCourseMutation, SendEmailToSelectionOfCourseMutationVariables>;

/**
 * __useSendEmailToSelectionOfCourseMutation__
 *
 * To run a mutation, you first call `useSendEmailToSelectionOfCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToSelectionOfCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToSelectionOfCourseMutation, { data, loading, error }] = useSendEmailToSelectionOfCourseMutation({
 *   variables: {
 *      sendMailToSelectionOfCourseInput: // value for 'sendMailToSelectionOfCourseInput'
 *   },
 * });
 */
export function useSendEmailToSelectionOfCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailToSelectionOfCourseMutation, SendEmailToSelectionOfCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailToSelectionOfCourseMutation, SendEmailToSelectionOfCourseMutationVariables>(SendEmailToSelectionOfCourseDocument, baseOptions);
      }
export type SendEmailToSelectionOfCourseMutationHookResult = ReturnType<typeof useSendEmailToSelectionOfCourseMutation>;
export type SendEmailToSelectionOfCourseMutationResult = ApolloReactCommon.MutationResult<SendEmailToSelectionOfCourseMutation>;
export type SendEmailToSelectionOfCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailToSelectionOfCourseMutation, SendEmailToSelectionOfCourseMutationVariables>;
export const SendEmailToSelectionOfBookingsDocument = gql`
    mutation SendEmailToSelectionOfBookings($sendMailToSelectionOfBookingInput: SendMailToSelectionOfBookingInput!) {
  sendMailToSelectionOfBookings(sendMailToSelectionOfBookingInput: $sendMailToSelectionOfBookingInput)
}
    `;
export type SendEmailToSelectionOfBookingsMutationFn = ApolloReactCommon.MutationFunction<SendEmailToSelectionOfBookingsMutation, SendEmailToSelectionOfBookingsMutationVariables>;

/**
 * __useSendEmailToSelectionOfBookingsMutation__
 *
 * To run a mutation, you first call `useSendEmailToSelectionOfBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToSelectionOfBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToSelectionOfBookingsMutation, { data, loading, error }] = useSendEmailToSelectionOfBookingsMutation({
 *   variables: {
 *      sendMailToSelectionOfBookingInput: // value for 'sendMailToSelectionOfBookingInput'
 *   },
 * });
 */
export function useSendEmailToSelectionOfBookingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailToSelectionOfBookingsMutation, SendEmailToSelectionOfBookingsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailToSelectionOfBookingsMutation, SendEmailToSelectionOfBookingsMutationVariables>(SendEmailToSelectionOfBookingsDocument, baseOptions);
      }
export type SendEmailToSelectionOfBookingsMutationHookResult = ReturnType<typeof useSendEmailToSelectionOfBookingsMutation>;
export type SendEmailToSelectionOfBookingsMutationResult = ApolloReactCommon.MutationResult<SendEmailToSelectionOfBookingsMutation>;
export type SendEmailToSelectionOfBookingsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailToSelectionOfBookingsMutation, SendEmailToSelectionOfBookingsMutationVariables>;
export const SendEmailToSelectionOfBookersDocument = gql`
    mutation SendEmailToSelectionOfBookers($sendMailToSelectionOfBookersInput: SendMailToSelectionOfBookersInput!) {
  sendEmailToSelectionOfBookers(sendMailToSelectionOfBookersInput: $sendMailToSelectionOfBookersInput)
}
    `;
export type SendEmailToSelectionOfBookersMutationFn = ApolloReactCommon.MutationFunction<SendEmailToSelectionOfBookersMutation, SendEmailToSelectionOfBookersMutationVariables>;

/**
 * __useSendEmailToSelectionOfBookersMutation__
 *
 * To run a mutation, you first call `useSendEmailToSelectionOfBookersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToSelectionOfBookersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToSelectionOfBookersMutation, { data, loading, error }] = useSendEmailToSelectionOfBookersMutation({
 *   variables: {
 *      sendMailToSelectionOfBookersInput: // value for 'sendMailToSelectionOfBookersInput'
 *   },
 * });
 */
export function useSendEmailToSelectionOfBookersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailToSelectionOfBookersMutation, SendEmailToSelectionOfBookersMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailToSelectionOfBookersMutation, SendEmailToSelectionOfBookersMutationVariables>(SendEmailToSelectionOfBookersDocument, baseOptions);
      }
export type SendEmailToSelectionOfBookersMutationHookResult = ReturnType<typeof useSendEmailToSelectionOfBookersMutation>;
export type SendEmailToSelectionOfBookersMutationResult = ApolloReactCommon.MutationResult<SendEmailToSelectionOfBookersMutation>;
export type SendEmailToSelectionOfBookersMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailToSelectionOfBookersMutation, SendEmailToSelectionOfBookersMutationVariables>;
export const SendEmailToSelectionOfStaffDocument = gql`
    mutation SendEmailToSelectionOfStaff($sendMailToSelectionOfStaffInput: SendMailToSelectionOfStaffInput!) {
  sendEmailToSelectionOfStaff(sendMailToSelectionOfStaffInput: $sendMailToSelectionOfStaffInput)
}
    `;
export type SendEmailToSelectionOfStaffMutationFn = ApolloReactCommon.MutationFunction<SendEmailToSelectionOfStaffMutation, SendEmailToSelectionOfStaffMutationVariables>;

/**
 * __useSendEmailToSelectionOfStaffMutation__
 *
 * To run a mutation, you first call `useSendEmailToSelectionOfStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToSelectionOfStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToSelectionOfStaffMutation, { data, loading, error }] = useSendEmailToSelectionOfStaffMutation({
 *   variables: {
 *      sendMailToSelectionOfStaffInput: // value for 'sendMailToSelectionOfStaffInput'
 *   },
 * });
 */
export function useSendEmailToSelectionOfStaffMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailToSelectionOfStaffMutation, SendEmailToSelectionOfStaffMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailToSelectionOfStaffMutation, SendEmailToSelectionOfStaffMutationVariables>(SendEmailToSelectionOfStaffDocument, baseOptions);
      }
export type SendEmailToSelectionOfStaffMutationHookResult = ReturnType<typeof useSendEmailToSelectionOfStaffMutation>;
export type SendEmailToSelectionOfStaffMutationResult = ApolloReactCommon.MutationResult<SendEmailToSelectionOfStaffMutation>;
export type SendEmailToSelectionOfStaffMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailToSelectionOfStaffMutation, SendEmailToSelectionOfStaffMutationVariables>;
export const SendEmailToSelectionOfAttendeesDocument = gql`
    mutation SendEmailToSelectionOfAttendees($sendMailToSelectionOfAttendeesInput: SendMailToSelectionOfAttendeesInput!) {
  sendEmailToSelectionOfAttendees(sendMailToSelectionOfAttendeesInput: $sendMailToSelectionOfAttendeesInput)
}
    `;
export type SendEmailToSelectionOfAttendeesMutationFn = ApolloReactCommon.MutationFunction<SendEmailToSelectionOfAttendeesMutation, SendEmailToSelectionOfAttendeesMutationVariables>;

/**
 * __useSendEmailToSelectionOfAttendeesMutation__
 *
 * To run a mutation, you first call `useSendEmailToSelectionOfAttendeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToSelectionOfAttendeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToSelectionOfAttendeesMutation, { data, loading, error }] = useSendEmailToSelectionOfAttendeesMutation({
 *   variables: {
 *      sendMailToSelectionOfAttendeesInput: // value for 'sendMailToSelectionOfAttendeesInput'
 *   },
 * });
 */
export function useSendEmailToSelectionOfAttendeesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailToSelectionOfAttendeesMutation, SendEmailToSelectionOfAttendeesMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailToSelectionOfAttendeesMutation, SendEmailToSelectionOfAttendeesMutationVariables>(SendEmailToSelectionOfAttendeesDocument, baseOptions);
      }
export type SendEmailToSelectionOfAttendeesMutationHookResult = ReturnType<typeof useSendEmailToSelectionOfAttendeesMutation>;
export type SendEmailToSelectionOfAttendeesMutationResult = ApolloReactCommon.MutationResult<SendEmailToSelectionOfAttendeesMutation>;
export type SendEmailToSelectionOfAttendeesMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailToSelectionOfAttendeesMutation, SendEmailToSelectionOfAttendeesMutationVariables>;
export const SendEmailToSelectionOfScheduledPaymentsDocument = gql`
    mutation SendEmailToSelectionOfScheduledPayments($sendMailToSelectionOfScheduledPaymentsInput: SendMailToSelectionOfScheduledPaymentsInput!) {
  sendEmailToSelectionOfScheduledPayments(sendMailToSelectionOfScheduledPaymentsInput: $sendMailToSelectionOfScheduledPaymentsInput)
}
    `;
export type SendEmailToSelectionOfScheduledPaymentsMutationFn = ApolloReactCommon.MutationFunction<SendEmailToSelectionOfScheduledPaymentsMutation, SendEmailToSelectionOfScheduledPaymentsMutationVariables>;

/**
 * __useSendEmailToSelectionOfScheduledPaymentsMutation__
 *
 * To run a mutation, you first call `useSendEmailToSelectionOfScheduledPaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToSelectionOfScheduledPaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToSelectionOfScheduledPaymentsMutation, { data, loading, error }] = useSendEmailToSelectionOfScheduledPaymentsMutation({
 *   variables: {
 *      sendMailToSelectionOfScheduledPaymentsInput: // value for 'sendMailToSelectionOfScheduledPaymentsInput'
 *   },
 * });
 */
export function useSendEmailToSelectionOfScheduledPaymentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailToSelectionOfScheduledPaymentsMutation, SendEmailToSelectionOfScheduledPaymentsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailToSelectionOfScheduledPaymentsMutation, SendEmailToSelectionOfScheduledPaymentsMutationVariables>(SendEmailToSelectionOfScheduledPaymentsDocument, baseOptions);
      }
export type SendEmailToSelectionOfScheduledPaymentsMutationHookResult = ReturnType<typeof useSendEmailToSelectionOfScheduledPaymentsMutation>;
export type SendEmailToSelectionOfScheduledPaymentsMutationResult = ApolloReactCommon.MutationResult<SendEmailToSelectionOfScheduledPaymentsMutation>;
export type SendEmailToSelectionOfScheduledPaymentsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailToSelectionOfScheduledPaymentsMutation, SendEmailToSelectionOfScheduledPaymentsMutationVariables>;
export const SendInvoicesToSelectionOfBookingsDocument = gql`
    mutation SendInvoicesToSelectionOfBookings($sendInvoicesToSelectionOfBookingsInput: SendInvoicesToSelectionOfBookingInput!) {
  sendInvoicesToSelectionOfBookings(sendInvoicesToSelectionOfBookingsInput: $sendInvoicesToSelectionOfBookingsInput)
}
    `;
export type SendInvoicesToSelectionOfBookingsMutationFn = ApolloReactCommon.MutationFunction<SendInvoicesToSelectionOfBookingsMutation, SendInvoicesToSelectionOfBookingsMutationVariables>;

/**
 * __useSendInvoicesToSelectionOfBookingsMutation__
 *
 * To run a mutation, you first call `useSendInvoicesToSelectionOfBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoicesToSelectionOfBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoicesToSelectionOfBookingsMutation, { data, loading, error }] = useSendInvoicesToSelectionOfBookingsMutation({
 *   variables: {
 *      sendInvoicesToSelectionOfBookingsInput: // value for 'sendInvoicesToSelectionOfBookingsInput'
 *   },
 * });
 */
export function useSendInvoicesToSelectionOfBookingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInvoicesToSelectionOfBookingsMutation, SendInvoicesToSelectionOfBookingsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendInvoicesToSelectionOfBookingsMutation, SendInvoicesToSelectionOfBookingsMutationVariables>(SendInvoicesToSelectionOfBookingsDocument, baseOptions);
      }
export type SendInvoicesToSelectionOfBookingsMutationHookResult = ReturnType<typeof useSendInvoicesToSelectionOfBookingsMutation>;
export type SendInvoicesToSelectionOfBookingsMutationResult = ApolloReactCommon.MutationResult<SendInvoicesToSelectionOfBookingsMutation>;
export type SendInvoicesToSelectionOfBookingsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendInvoicesToSelectionOfBookingsMutation, SendInvoicesToSelectionOfBookingsMutationVariables>;
export const RenderTemplateForLetterPdfDocument = gql`
    query RenderTemplateForLetterPdf($input: RenderTemplateForLetterPdfInput!) {
  renderTemplateForLetterPdf(input: $input) {
    subject
    headerText
    footerText
    signature
    recipientFirstName
    recipientLastName
    recipientStreet
    recipientHouseNumber
    recipientPostCode
    recipientCity
    recipientAddition
    senderName
    senderStreet
    senderStreetNumber
    senderZip
    senderCity
    senderLogoBase64
    senderPhone
    senderEmail
    senderWebsite
    senderBankName
    senderIban
    senderBic
    senderTaxId
    senderTaxNumber
    courseDetails {
      courseName
      courseNumber
      locationName
      locationStreet
      locationCity
      courseStartDate
      courseEndDate
      courseTime
      coursePrice
      courseLessonsCount
      attendeeName
    }
  }
}
    `;

/**
 * __useRenderTemplateForLetterPdfQuery__
 *
 * To run a query within a React component, call `useRenderTemplateForLetterPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderTemplateForLetterPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderTemplateForLetterPdfQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderTemplateForLetterPdfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RenderTemplateForLetterPdfQuery, RenderTemplateForLetterPdfQueryVariables>) {
        return ApolloReactHooks.useQuery<RenderTemplateForLetterPdfQuery, RenderTemplateForLetterPdfQueryVariables>(RenderTemplateForLetterPdfDocument, baseOptions);
      }
export function useRenderTemplateForLetterPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RenderTemplateForLetterPdfQuery, RenderTemplateForLetterPdfQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RenderTemplateForLetterPdfQuery, RenderTemplateForLetterPdfQueryVariables>(RenderTemplateForLetterPdfDocument, baseOptions);
        }
export type RenderTemplateForLetterPdfQueryHookResult = ReturnType<typeof useRenderTemplateForLetterPdfQuery>;
export type RenderTemplateForLetterPdfLazyQueryHookResult = ReturnType<typeof useRenderTemplateForLetterPdfLazyQuery>;
export type RenderTemplateForLetterPdfQueryResult = ApolloReactCommon.QueryResult<RenderTemplateForLetterPdfQuery, RenderTemplateForLetterPdfQueryVariables>;
export const RenderBatchTemplateForCourseLetterPdfDocument = gql`
    query RenderBatchTemplateForCourseLetterPdf($input: RenderBatchLetterPdfForCourseInput!) {
  renderBatchTemplateForCourseLetterPdf(input: $input) {
    totalCount
    items {
      subject
      headerText
      footerText
      signature
      recipientFirstName
      recipientLastName
      recipientStreet
      recipientHouseNumber
      recipientPostCode
      recipientCity
      recipientAddition
      senderName
      senderStreet
      senderStreetNumber
      senderZip
      senderCity
      senderLogoBase64
      senderPhone
      senderEmail
      senderWebsite
      senderBankName
      senderIban
      senderBic
      senderTaxId
      senderTaxNumber
      courseDetails {
        courseName
        courseNumber
        locationName
        locationStreet
        locationCity
        courseStartDate
        courseEndDate
        courseTime
        coursePrice
        courseLessonsCount
        attendeeName
      }
    }
  }
}
    `;

/**
 * __useRenderBatchTemplateForCourseLetterPdfQuery__
 *
 * To run a query within a React component, call `useRenderBatchTemplateForCourseLetterPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderBatchTemplateForCourseLetterPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderBatchTemplateForCourseLetterPdfQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderBatchTemplateForCourseLetterPdfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RenderBatchTemplateForCourseLetterPdfQuery, RenderBatchTemplateForCourseLetterPdfQueryVariables>) {
        return ApolloReactHooks.useQuery<RenderBatchTemplateForCourseLetterPdfQuery, RenderBatchTemplateForCourseLetterPdfQueryVariables>(RenderBatchTemplateForCourseLetterPdfDocument, baseOptions);
      }
export function useRenderBatchTemplateForCourseLetterPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RenderBatchTemplateForCourseLetterPdfQuery, RenderBatchTemplateForCourseLetterPdfQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RenderBatchTemplateForCourseLetterPdfQuery, RenderBatchTemplateForCourseLetterPdfQueryVariables>(RenderBatchTemplateForCourseLetterPdfDocument, baseOptions);
        }
export type RenderBatchTemplateForCourseLetterPdfQueryHookResult = ReturnType<typeof useRenderBatchTemplateForCourseLetterPdfQuery>;
export type RenderBatchTemplateForCourseLetterPdfLazyQueryHookResult = ReturnType<typeof useRenderBatchTemplateForCourseLetterPdfLazyQuery>;
export type RenderBatchTemplateForCourseLetterPdfQueryResult = ApolloReactCommon.QueryResult<RenderBatchTemplateForCourseLetterPdfQuery, RenderBatchTemplateForCourseLetterPdfQueryVariables>;
export const RenderBatchTemplateForBookingsLetterPdfDocument = gql`
    query RenderBatchTemplateForBookingsLetterPdf($input: RenderBatchLetterPdfForBookingsInput!) {
  renderBatchTemplateForBookingsLetterPdf(input: $input) {
    totalCount
    items {
      subject
      headerText
      footerText
      signature
      recipientFirstName
      recipientLastName
      recipientStreet
      recipientHouseNumber
      recipientPostCode
      recipientCity
      recipientAddition
      senderName
      senderStreet
      senderStreetNumber
      senderZip
      senderCity
      senderLogoBase64
      senderPhone
      senderEmail
      senderWebsite
      senderBankName
      senderIban
      senderBic
      senderTaxId
      senderTaxNumber
      courseDetails {
        courseName
        courseNumber
        locationName
        locationStreet
        locationCity
        courseStartDate
        courseEndDate
        courseTime
        coursePrice
        courseLessonsCount
        attendeeName
      }
    }
  }
}
    `;

/**
 * __useRenderBatchTemplateForBookingsLetterPdfQuery__
 *
 * To run a query within a React component, call `useRenderBatchTemplateForBookingsLetterPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderBatchTemplateForBookingsLetterPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderBatchTemplateForBookingsLetterPdfQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderBatchTemplateForBookingsLetterPdfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RenderBatchTemplateForBookingsLetterPdfQuery, RenderBatchTemplateForBookingsLetterPdfQueryVariables>) {
        return ApolloReactHooks.useQuery<RenderBatchTemplateForBookingsLetterPdfQuery, RenderBatchTemplateForBookingsLetterPdfQueryVariables>(RenderBatchTemplateForBookingsLetterPdfDocument, baseOptions);
      }
export function useRenderBatchTemplateForBookingsLetterPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RenderBatchTemplateForBookingsLetterPdfQuery, RenderBatchTemplateForBookingsLetterPdfQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RenderBatchTemplateForBookingsLetterPdfQuery, RenderBatchTemplateForBookingsLetterPdfQueryVariables>(RenderBatchTemplateForBookingsLetterPdfDocument, baseOptions);
        }
export type RenderBatchTemplateForBookingsLetterPdfQueryHookResult = ReturnType<typeof useRenderBatchTemplateForBookingsLetterPdfQuery>;
export type RenderBatchTemplateForBookingsLetterPdfLazyQueryHookResult = ReturnType<typeof useRenderBatchTemplateForBookingsLetterPdfLazyQuery>;
export type RenderBatchTemplateForBookingsLetterPdfQueryResult = ApolloReactCommon.QueryResult<RenderBatchTemplateForBookingsLetterPdfQuery, RenderBatchTemplateForBookingsLetterPdfQueryVariables>;
export const SendEmailTemplateDocument = gql`
    mutation SendEmailTemplate($sendTemplateInput: SendTemplateInput!) {
  sendEmailTemplate(sendTemplateInput: $sendTemplateInput)
}
    `;
export type SendEmailTemplateMutationFn = ApolloReactCommon.MutationFunction<SendEmailTemplateMutation, SendEmailTemplateMutationVariables>;

/**
 * __useSendEmailTemplateMutation__
 *
 * To run a mutation, you first call `useSendEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailTemplateMutation, { data, loading, error }] = useSendEmailTemplateMutation({
 *   variables: {
 *      sendTemplateInput: // value for 'sendTemplateInput'
 *   },
 * });
 */
export function useSendEmailTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailTemplateMutation, SendEmailTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEmailTemplateMutation, SendEmailTemplateMutationVariables>(SendEmailTemplateDocument, baseOptions);
      }
export type SendEmailTemplateMutationHookResult = ReturnType<typeof useSendEmailTemplateMutation>;
export type SendEmailTemplateMutationResult = ApolloReactCommon.MutationResult<SendEmailTemplateMutation>;
export type SendEmailTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailTemplateMutation, SendEmailTemplateMutationVariables>;
export const GetDefaultInvoiceTemplateSetDocument = gql`
    query GetDefaultInvoiceTemplateSet {
  defaultInvoiceTemplateSet {
    id
    name
    isDefault
    layoutVariant
    logoPosition
    customLogo
    secondLogo
  }
}
    `;

/**
 * __useGetDefaultInvoiceTemplateSetQuery__
 *
 * To run a query within a React component, call `useGetDefaultInvoiceTemplateSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultInvoiceTemplateSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultInvoiceTemplateSetQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultInvoiceTemplateSetQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDefaultInvoiceTemplateSetQuery, GetDefaultInvoiceTemplateSetQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDefaultInvoiceTemplateSetQuery, GetDefaultInvoiceTemplateSetQueryVariables>(GetDefaultInvoiceTemplateSetDocument, baseOptions);
      }
export function useGetDefaultInvoiceTemplateSetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDefaultInvoiceTemplateSetQuery, GetDefaultInvoiceTemplateSetQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDefaultInvoiceTemplateSetQuery, GetDefaultInvoiceTemplateSetQueryVariables>(GetDefaultInvoiceTemplateSetDocument, baseOptions);
        }
export type GetDefaultInvoiceTemplateSetQueryHookResult = ReturnType<typeof useGetDefaultInvoiceTemplateSetQuery>;
export type GetDefaultInvoiceTemplateSetLazyQueryHookResult = ReturnType<typeof useGetDefaultInvoiceTemplateSetLazyQuery>;
export type GetDefaultInvoiceTemplateSetQueryResult = ApolloReactCommon.QueryResult<GetDefaultInvoiceTemplateSetQuery, GetDefaultInvoiceTemplateSetQueryVariables>;
export const UpdateInvoiceTemplateSetDocument = gql`
    mutation UpdateInvoiceTemplateSet($input: UpdateInvoiceTemplateSetInput!) {
  updateInvoiceTemplateSet(input: $input) {
    id
    name
    isDefault
    layoutVariant
    logoPosition
    customLogo
    secondLogo
  }
}
    `;
export type UpdateInvoiceTemplateSetMutationFn = ApolloReactCommon.MutationFunction<UpdateInvoiceTemplateSetMutation, UpdateInvoiceTemplateSetMutationVariables>;

/**
 * __useUpdateInvoiceTemplateSetMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceTemplateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceTemplateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceTemplateSetMutation, { data, loading, error }] = useUpdateInvoiceTemplateSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceTemplateSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInvoiceTemplateSetMutation, UpdateInvoiceTemplateSetMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateInvoiceTemplateSetMutation, UpdateInvoiceTemplateSetMutationVariables>(UpdateInvoiceTemplateSetDocument, baseOptions);
      }
export type UpdateInvoiceTemplateSetMutationHookResult = ReturnType<typeof useUpdateInvoiceTemplateSetMutation>;
export type UpdateInvoiceTemplateSetMutationResult = ApolloReactCommon.MutationResult<UpdateInvoiceTemplateSetMutation>;
export type UpdateInvoiceTemplateSetMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInvoiceTemplateSetMutation, UpdateInvoiceTemplateSetMutationVariables>;
export const GetInvoiceTemplateSetByIdDocument = gql`
    query GetInvoiceTemplateSetById($id: ID!) {
  invoiceTemplateSet(id: $id) {
    id
    name
    isDefault
    layoutVariant
    logoPosition
    customLogo
    secondLogo
  }
}
    `;

/**
 * __useGetInvoiceTemplateSetByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceTemplateSetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceTemplateSetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceTemplateSetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceTemplateSetByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceTemplateSetByIdQuery, GetInvoiceTemplateSetByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceTemplateSetByIdQuery, GetInvoiceTemplateSetByIdQueryVariables>(GetInvoiceTemplateSetByIdDocument, baseOptions);
      }
export function useGetInvoiceTemplateSetByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceTemplateSetByIdQuery, GetInvoiceTemplateSetByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceTemplateSetByIdQuery, GetInvoiceTemplateSetByIdQueryVariables>(GetInvoiceTemplateSetByIdDocument, baseOptions);
        }
export type GetInvoiceTemplateSetByIdQueryHookResult = ReturnType<typeof useGetInvoiceTemplateSetByIdQuery>;
export type GetInvoiceTemplateSetByIdLazyQueryHookResult = ReturnType<typeof useGetInvoiceTemplateSetByIdLazyQuery>;
export type GetInvoiceTemplateSetByIdQueryResult = ApolloReactCommon.QueryResult<GetInvoiceTemplateSetByIdQuery, GetInvoiceTemplateSetByIdQueryVariables>;
export const GetInvoiceTemplateSetsDocument = gql`
    query GetInvoiceTemplateSets {
  invoiceTemplateSets {
    id
    name
    isDefault
    layoutVariant
    logoPosition
  }
}
    `;

/**
 * __useGetInvoiceTemplateSetsQuery__
 *
 * To run a query within a React component, call `useGetInvoiceTemplateSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceTemplateSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceTemplateSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvoiceTemplateSetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceTemplateSetsQuery, GetInvoiceTemplateSetsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceTemplateSetsQuery, GetInvoiceTemplateSetsQueryVariables>(GetInvoiceTemplateSetsDocument, baseOptions);
      }
export function useGetInvoiceTemplateSetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceTemplateSetsQuery, GetInvoiceTemplateSetsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceTemplateSetsQuery, GetInvoiceTemplateSetsQueryVariables>(GetInvoiceTemplateSetsDocument, baseOptions);
        }
export type GetInvoiceTemplateSetsQueryHookResult = ReturnType<typeof useGetInvoiceTemplateSetsQuery>;
export type GetInvoiceTemplateSetsLazyQueryHookResult = ReturnType<typeof useGetInvoiceTemplateSetsLazyQuery>;
export type GetInvoiceTemplateSetsQueryResult = ApolloReactCommon.QueryResult<GetInvoiceTemplateSetsQuery, GetInvoiceTemplateSetsQueryVariables>;
export const CreateInvoiceTemplateSetDocument = gql`
    mutation CreateInvoiceTemplateSet($name: String!) {
  createInvoiceTemplateSet(name: $name) {
    id
    name
    isDefault
  }
}
    `;
export type CreateInvoiceTemplateSetMutationFn = ApolloReactCommon.MutationFunction<CreateInvoiceTemplateSetMutation, CreateInvoiceTemplateSetMutationVariables>;

/**
 * __useCreateInvoiceTemplateSetMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceTemplateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceTemplateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceTemplateSetMutation, { data, loading, error }] = useCreateInvoiceTemplateSetMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateInvoiceTemplateSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvoiceTemplateSetMutation, CreateInvoiceTemplateSetMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateInvoiceTemplateSetMutation, CreateInvoiceTemplateSetMutationVariables>(CreateInvoiceTemplateSetDocument, baseOptions);
      }
export type CreateInvoiceTemplateSetMutationHookResult = ReturnType<typeof useCreateInvoiceTemplateSetMutation>;
export type CreateInvoiceTemplateSetMutationResult = ApolloReactCommon.MutationResult<CreateInvoiceTemplateSetMutation>;
export type CreateInvoiceTemplateSetMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvoiceTemplateSetMutation, CreateInvoiceTemplateSetMutationVariables>;
export const DeleteInvoiceTemplateSetDocument = gql`
    mutation DeleteInvoiceTemplateSet($id: ID!) {
  deleteInvoiceTemplateSet(id: $id)
}
    `;
export type DeleteInvoiceTemplateSetMutationFn = ApolloReactCommon.MutationFunction<DeleteInvoiceTemplateSetMutation, DeleteInvoiceTemplateSetMutationVariables>;

/**
 * __useDeleteInvoiceTemplateSetMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceTemplateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceTemplateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceTemplateSetMutation, { data, loading, error }] = useDeleteInvoiceTemplateSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvoiceTemplateSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInvoiceTemplateSetMutation, DeleteInvoiceTemplateSetMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteInvoiceTemplateSetMutation, DeleteInvoiceTemplateSetMutationVariables>(DeleteInvoiceTemplateSetDocument, baseOptions);
      }
export type DeleteInvoiceTemplateSetMutationHookResult = ReturnType<typeof useDeleteInvoiceTemplateSetMutation>;
export type DeleteInvoiceTemplateSetMutationResult = ApolloReactCommon.MutationResult<DeleteInvoiceTemplateSetMutation>;
export type DeleteInvoiceTemplateSetMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInvoiceTemplateSetMutation, DeleteInvoiceTemplateSetMutationVariables>;
export const AssignCourseTypeToInvoiceTemplateSetDocument = gql`
    mutation AssignCourseTypeToInvoiceTemplateSet($courseTypeId: ID!, $invoiceTemplateSetId: ID) {
  assignCourseTypeToInvoiceTemplateSet(courseTypeId: $courseTypeId, invoiceTemplateSetId: $invoiceTemplateSetId) {
    id
    name
    invoiceTemplateSetId
  }
}
    `;
export type AssignCourseTypeToInvoiceTemplateSetMutationFn = ApolloReactCommon.MutationFunction<AssignCourseTypeToInvoiceTemplateSetMutation, AssignCourseTypeToInvoiceTemplateSetMutationVariables>;

/**
 * __useAssignCourseTypeToInvoiceTemplateSetMutation__
 *
 * To run a mutation, you first call `useAssignCourseTypeToInvoiceTemplateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCourseTypeToInvoiceTemplateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCourseTypeToInvoiceTemplateSetMutation, { data, loading, error }] = useAssignCourseTypeToInvoiceTemplateSetMutation({
 *   variables: {
 *      courseTypeId: // value for 'courseTypeId'
 *      invoiceTemplateSetId: // value for 'invoiceTemplateSetId'
 *   },
 * });
 */
export function useAssignCourseTypeToInvoiceTemplateSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignCourseTypeToInvoiceTemplateSetMutation, AssignCourseTypeToInvoiceTemplateSetMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignCourseTypeToInvoiceTemplateSetMutation, AssignCourseTypeToInvoiceTemplateSetMutationVariables>(AssignCourseTypeToInvoiceTemplateSetDocument, baseOptions);
      }
export type AssignCourseTypeToInvoiceTemplateSetMutationHookResult = ReturnType<typeof useAssignCourseTypeToInvoiceTemplateSetMutation>;
export type AssignCourseTypeToInvoiceTemplateSetMutationResult = ApolloReactCommon.MutationResult<AssignCourseTypeToInvoiceTemplateSetMutation>;
export type AssignCourseTypeToInvoiceTemplateSetMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignCourseTypeToInvoiceTemplateSetMutation, AssignCourseTypeToInvoiceTemplateSetMutationVariables>;
export const GetInvoiceTemplateSetOverridesDocument = gql`
    query GetInvoiceTemplateSetOverrides($invoiceTemplateSetId: ID!) {
  templates(invoiceTemplateSetId: $invoiceTemplateSetId) {
    id
    templateType
  }
}
    `;

/**
 * __useGetInvoiceTemplateSetOverridesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceTemplateSetOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceTemplateSetOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceTemplateSetOverridesQuery({
 *   variables: {
 *      invoiceTemplateSetId: // value for 'invoiceTemplateSetId'
 *   },
 * });
 */
export function useGetInvoiceTemplateSetOverridesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoiceTemplateSetOverridesQuery, GetInvoiceTemplateSetOverridesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInvoiceTemplateSetOverridesQuery, GetInvoiceTemplateSetOverridesQueryVariables>(GetInvoiceTemplateSetOverridesDocument, baseOptions);
      }
export function useGetInvoiceTemplateSetOverridesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoiceTemplateSetOverridesQuery, GetInvoiceTemplateSetOverridesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInvoiceTemplateSetOverridesQuery, GetInvoiceTemplateSetOverridesQueryVariables>(GetInvoiceTemplateSetOverridesDocument, baseOptions);
        }
export type GetInvoiceTemplateSetOverridesQueryHookResult = ReturnType<typeof useGetInvoiceTemplateSetOverridesQuery>;
export type GetInvoiceTemplateSetOverridesLazyQueryHookResult = ReturnType<typeof useGetInvoiceTemplateSetOverridesLazyQuery>;
export type GetInvoiceTemplateSetOverridesQueryResult = ApolloReactCommon.QueryResult<GetInvoiceTemplateSetOverridesQuery, GetInvoiceTemplateSetOverridesQueryVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates {
  templates {
    id
    templateType
    name
    isDefault
    mailDataType
    createDate
    updateDate
    includeCourseDetails
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, baseOptions);
      }
export function useGetTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, baseOptions);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesQueryResult = ApolloReactCommon.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetTemplatesWithPaginationDocument = gql`
    query GetTemplatesWithPagination($options: ArrayDataOptions) {
  templatesWithPagination(options: $options) {
    existsMore
    items {
      id
      templateType
      name
      subject
      isDefault
      mailDataType
      createDate
      updateDate
      includeCourseDetails
    }
    total
  }
}
    `;

/**
 * __useGetTemplatesWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetTemplatesWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesWithPaginationQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetTemplatesWithPaginationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTemplatesWithPaginationQuery, GetTemplatesWithPaginationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTemplatesWithPaginationQuery, GetTemplatesWithPaginationQueryVariables>(GetTemplatesWithPaginationDocument, baseOptions);
      }
export function useGetTemplatesWithPaginationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTemplatesWithPaginationQuery, GetTemplatesWithPaginationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTemplatesWithPaginationQuery, GetTemplatesWithPaginationQueryVariables>(GetTemplatesWithPaginationDocument, baseOptions);
        }
export type GetTemplatesWithPaginationQueryHookResult = ReturnType<typeof useGetTemplatesWithPaginationQuery>;
export type GetTemplatesWithPaginationLazyQueryHookResult = ReturnType<typeof useGetTemplatesWithPaginationLazyQuery>;
export type GetTemplatesWithPaginationQueryResult = ApolloReactCommon.QueryResult<GetTemplatesWithPaginationQuery, GetTemplatesWithPaginationQueryVariables>;
export const CheckIfTemplateOfTypeExistsDocument = gql`
    query CheckIfTemplateOfTypeExists($templateType: TemplateType!, $invoiceTemplateSetId: ID) {
  checkIfTemplateOfTypeExists(templateType: $templateType, invoiceTemplateSetId: $invoiceTemplateSetId)
}
    `;

/**
 * __useCheckIfTemplateOfTypeExistsQuery__
 *
 * To run a query within a React component, call `useCheckIfTemplateOfTypeExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfTemplateOfTypeExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfTemplateOfTypeExistsQuery({
 *   variables: {
 *      templateType: // value for 'templateType'
 *      invoiceTemplateSetId: // value for 'invoiceTemplateSetId'
 *   },
 * });
 */
export function useCheckIfTemplateOfTypeExistsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckIfTemplateOfTypeExistsQuery, CheckIfTemplateOfTypeExistsQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckIfTemplateOfTypeExistsQuery, CheckIfTemplateOfTypeExistsQueryVariables>(CheckIfTemplateOfTypeExistsDocument, baseOptions);
      }
export function useCheckIfTemplateOfTypeExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckIfTemplateOfTypeExistsQuery, CheckIfTemplateOfTypeExistsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckIfTemplateOfTypeExistsQuery, CheckIfTemplateOfTypeExistsQueryVariables>(CheckIfTemplateOfTypeExistsDocument, baseOptions);
        }
export type CheckIfTemplateOfTypeExistsQueryHookResult = ReturnType<typeof useCheckIfTemplateOfTypeExistsQuery>;
export type CheckIfTemplateOfTypeExistsLazyQueryHookResult = ReturnType<typeof useCheckIfTemplateOfTypeExistsLazyQuery>;
export type CheckIfTemplateOfTypeExistsQueryResult = ApolloReactCommon.QueryResult<CheckIfTemplateOfTypeExistsQuery, CheckIfTemplateOfTypeExistsQueryVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($newTemplateData: NewTemplateInput!) {
  createTemplate(newTemplateData: $newTemplateData) {
    id
  }
}
    `;
export type CreateTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      newTemplateData: // value for 'newTemplateData'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, baseOptions);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = ApolloReactCommon.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const DeleteTemplateDocument = gql`
    mutation DeleteTemplate($id: String!) {
  deleteTemplate(id: $id)
}
    `;
export type DeleteTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, baseOptions);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const GetTemplateByIdDocument = gql`
    query GetTemplateById($id: String!) {
  template(id: $id) {
    id
    name
    templateType
    headerText
    footerText
    signature
    subject
    isDefault
    includeCourseDetails
  }
}
    `;

/**
 * __useGetTemplateByIdQuery__
 *
 * To run a query within a React component, call `useGetTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTemplateByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>(GetTemplateByIdDocument, baseOptions);
      }
export function useGetTemplateByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>(GetTemplateByIdDocument, baseOptions);
        }
export type GetTemplateByIdQueryHookResult = ReturnType<typeof useGetTemplateByIdQuery>;
export type GetTemplateByIdLazyQueryHookResult = ReturnType<typeof useGetTemplateByIdLazyQuery>;
export type GetTemplateByIdQueryResult = ApolloReactCommon.QueryResult<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($editTemplateData: EditTemplateInput!, $id: String!) {
  updateTemplate(editTemplateData: $editTemplateData, id: $id) {
    id
    name
    templateType
    headerText
    footerText
    signature
    subject
    includeCourseDetails
    isDefault
  }
}
    `;
export type UpdateTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      editTemplateData: // value for 'editTemplateData'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, baseOptions);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const GetTemplateByTypeDocument = gql`
    query GetTemplateByType($templateType: TemplateType!, $invoiceTemplateSetId: ID) {
  templateByType(templateType: $templateType, invoiceTemplateSetId: $invoiceTemplateSetId) {
    id
    name
    templateType
    headerText
    footerText
    signature
    subject
    includeCourseDetails
    isDefault
  }
}
    `;

/**
 * __useGetTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useGetTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateByTypeQuery({
 *   variables: {
 *      templateType: // value for 'templateType'
 *      invoiceTemplateSetId: // value for 'invoiceTemplateSetId'
 *   },
 * });
 */
export function useGetTemplateByTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, baseOptions);
      }
export function useGetTemplateByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, baseOptions);
        }
export type GetTemplateByTypeQueryHookResult = ReturnType<typeof useGetTemplateByTypeQuery>;
export type GetTemplateByTypeLazyQueryHookResult = ReturnType<typeof useGetTemplateByTypeLazyQuery>;
export type GetTemplateByTypeQueryResult = ApolloReactCommon.QueryResult<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>;
export const SetIncludeCourseDetailsDocument = gql`
    mutation SetIncludeCourseDetails($templateId: ID!, $includeCourseDetails: Boolean!) {
  setIncludeCourseDetails(templateId: $templateId, includeCourseDetails: $includeCourseDetails) {
    id
    includeCourseDetails
  }
}
    `;
export type SetIncludeCourseDetailsMutationFn = ApolloReactCommon.MutationFunction<SetIncludeCourseDetailsMutation, SetIncludeCourseDetailsMutationVariables>;

/**
 * __useSetIncludeCourseDetailsMutation__
 *
 * To run a mutation, you first call `useSetIncludeCourseDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIncludeCourseDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIncludeCourseDetailsMutation, { data, loading, error }] = useSetIncludeCourseDetailsMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      includeCourseDetails: // value for 'includeCourseDetails'
 *   },
 * });
 */
export function useSetIncludeCourseDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetIncludeCourseDetailsMutation, SetIncludeCourseDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<SetIncludeCourseDetailsMutation, SetIncludeCourseDetailsMutationVariables>(SetIncludeCourseDetailsDocument, baseOptions);
      }
export type SetIncludeCourseDetailsMutationHookResult = ReturnType<typeof useSetIncludeCourseDetailsMutation>;
export type SetIncludeCourseDetailsMutationResult = ApolloReactCommon.MutationResult<SetIncludeCourseDetailsMutation>;
export type SetIncludeCourseDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetIncludeCourseDetailsMutation, SetIncludeCourseDetailsMutationVariables>;
export const RenderTextBlockPreviewDocument = gql`
    query RenderTextBlockPreview($input: TextBlockPreviewInput!) {
  renderTextBlockPreview(input: $input) {
    recipients {
      id
      name
      email
    }
    current {
      index
      subject
      headerText
      footerText
      signature
      replaced
      empty
      unknown
    }
    summary {
      recipientsWithEmpty
      recipientsWithUnknown
      emptyVariables
      total
    }
  }
}
    `;

/**
 * __useRenderTextBlockPreviewQuery__
 *
 * To run a query within a React component, call `useRenderTextBlockPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderTextBlockPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderTextBlockPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderTextBlockPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RenderTextBlockPreviewQuery, RenderTextBlockPreviewQueryVariables>) {
        return ApolloReactHooks.useQuery<RenderTextBlockPreviewQuery, RenderTextBlockPreviewQueryVariables>(RenderTextBlockPreviewDocument, baseOptions);
      }
export function useRenderTextBlockPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RenderTextBlockPreviewQuery, RenderTextBlockPreviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RenderTextBlockPreviewQuery, RenderTextBlockPreviewQueryVariables>(RenderTextBlockPreviewDocument, baseOptions);
        }
export type RenderTextBlockPreviewQueryHookResult = ReturnType<typeof useRenderTextBlockPreviewQuery>;
export type RenderTextBlockPreviewLazyQueryHookResult = ReturnType<typeof useRenderTextBlockPreviewLazyQuery>;
export type RenderTextBlockPreviewQueryResult = ApolloReactCommon.QueryResult<RenderTextBlockPreviewQuery, RenderTextBlockPreviewQueryVariables>;
export const WithdrawalsDocument = gql`
    query Withdrawals {
  withdrawals {
    id
    name
    bookingReference
    email
    reason
    receivedAt
    status
    matchedBookingId
    source
  }
}
    `;

/**
 * __useWithdrawalsQuery__
 *
 * To run a query within a React component, call `useWithdrawalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithdrawalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithdrawalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWithdrawalsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WithdrawalsQuery, WithdrawalsQueryVariables>) {
        return ApolloReactHooks.useQuery<WithdrawalsQuery, WithdrawalsQueryVariables>(WithdrawalsDocument, baseOptions);
      }
export function useWithdrawalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WithdrawalsQuery, WithdrawalsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WithdrawalsQuery, WithdrawalsQueryVariables>(WithdrawalsDocument, baseOptions);
        }
export type WithdrawalsQueryHookResult = ReturnType<typeof useWithdrawalsQuery>;
export type WithdrawalsLazyQueryHookResult = ReturnType<typeof useWithdrawalsLazyQuery>;
export type WithdrawalsQueryResult = ApolloReactCommon.QueryResult<WithdrawalsQuery, WithdrawalsQueryVariables>;
export const UpdateWithdrawalStatusDocument = gql`
    mutation UpdateWithdrawalStatus($input: UpdateWithdrawalStatusInput!) {
  updateWithdrawalStatus(input: $input) {
    id
    name
    bookingReference
    email
    reason
    receivedAt
    status
    matchedBookingId
    source
  }
}
    `;
export type UpdateWithdrawalStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateWithdrawalStatusMutation, UpdateWithdrawalStatusMutationVariables>;

/**
 * __useUpdateWithdrawalStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWithdrawalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWithdrawalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWithdrawalStatusMutation, { data, loading, error }] = useUpdateWithdrawalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWithdrawalStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWithdrawalStatusMutation, UpdateWithdrawalStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWithdrawalStatusMutation, UpdateWithdrawalStatusMutationVariables>(UpdateWithdrawalStatusDocument, baseOptions);
      }
export type UpdateWithdrawalStatusMutationHookResult = ReturnType<typeof useUpdateWithdrawalStatusMutation>;
export type UpdateWithdrawalStatusMutationResult = ApolloReactCommon.MutationResult<UpdateWithdrawalStatusMutation>;
export type UpdateWithdrawalStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWithdrawalStatusMutation, UpdateWithdrawalStatusMutationVariables>;
export const CreateAndRegisterThirdPartyUserAndBookerDocument = gql`
    mutation createAndRegisterThirdPartyUserAndBooker($newBookingData: BookerInput!, $thirdPartyUserInput: ThirdPartyUserInput!) {
  createAndRegisterThirdPartyUserAndBooker(newBookingData: $newBookingData, thirdPartyUserInput: $thirdPartyUserInput) {
    id
    roles
    email
    booker {
      id
      firstname
      lastname
      gender
      createDate
      updateDate
      customerId
      addition
      street
      houseNumber
      postCode
      city
      phoneNumber
      mobileNumber
      email
      birthday
      initialContact
      dsgvo
      newsletter
      paymentMethods {
        id
        cash
        creditCardAccountholder
        creditcardNumber
        expirationDate
        validFrom
        cvc
        paypalAccountholder
        email
        iban
        bank
        bic
        sepaAccountholder
        bankTransfer
        onlinePayment
        esr
      }
      attendees {
        id
        customer {
          id
        }
        gender
        lastname
        firstname
        birthday
        member
        defaultPaymentMethod {
          id
        }
        bookings {
          id
          courseLessons {
            id
          }
          paymentMethod {
            id
          }
          paymentType
          payDate
        }
      }
      healthInsuranceFund
      annotation
      createdBy
    }
    refreshToken
    accessToken
  }
}
    `;
export type CreateAndRegisterThirdPartyUserAndBookerMutationFn = ApolloReactCommon.MutationFunction<CreateAndRegisterThirdPartyUserAndBookerMutation, CreateAndRegisterThirdPartyUserAndBookerMutationVariables>;

/**
 * __useCreateAndRegisterThirdPartyUserAndBookerMutation__
 *
 * To run a mutation, you first call `useCreateAndRegisterThirdPartyUserAndBookerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndRegisterThirdPartyUserAndBookerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndRegisterThirdPartyUserAndBookerMutation, { data, loading, error }] = useCreateAndRegisterThirdPartyUserAndBookerMutation({
 *   variables: {
 *      newBookingData: // value for 'newBookingData'
 *      thirdPartyUserInput: // value for 'thirdPartyUserInput'
 *   },
 * });
 */
export function useCreateAndRegisterThirdPartyUserAndBookerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndRegisterThirdPartyUserAndBookerMutation, CreateAndRegisterThirdPartyUserAndBookerMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAndRegisterThirdPartyUserAndBookerMutation, CreateAndRegisterThirdPartyUserAndBookerMutationVariables>(CreateAndRegisterThirdPartyUserAndBookerDocument, baseOptions);
      }
export type CreateAndRegisterThirdPartyUserAndBookerMutationHookResult = ReturnType<typeof useCreateAndRegisterThirdPartyUserAndBookerMutation>;
export type CreateAndRegisterThirdPartyUserAndBookerMutationResult = ApolloReactCommon.MutationResult<CreateAndRegisterThirdPartyUserAndBookerMutation>;
export type CreateAndRegisterThirdPartyUserAndBookerMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAndRegisterThirdPartyUserAndBookerMutation, CreateAndRegisterThirdPartyUserAndBookerMutationVariables>;
export const UpdateBookerFromEndUserAppDocument = gql`
    mutation UpdateBookerFromEndUserApp($updateBookerData: BookerInput!, $fromEndUserApp: Boolean!) {
  updateBooker(updateBookerData: $updateBookerData, fromEndUserApp: $fromEndUserApp) {
    id
    gender
    firstname
    lastname
    street
    houseNumber
    postCode
    city
    phoneNumber
    mobileNumber
    email
    birthday
    initialContact
    dsgvo
    newsletter
    healthInsuranceFund
    annotation
    paymentMethods {
      id
      cash
      creditCardAccountholder
      creditcardNumber
      expirationDate
      validFrom
      cvc
      paypalAccountholder
      email
      iban
      bank
      bic
      sepaAccountholder
      bankTransfer
      onlinePayment
    }
    attendees {
      id
      customer {
        id
      }
      gender
      lastname
      firstname
      birthday
      member
      deletable
      startedCourses {
        id
        prefixedCourseNumber
      }
      defaultPaymentMethod {
        id
      }
      bookings {
        id
        courseLessons {
          id
        }
        paymentMethod {
          id
        }
        paymentType
        payDate
      }
    }
    userId
  }
}
    `;
export type UpdateBookerFromEndUserAppMutationFn = ApolloReactCommon.MutationFunction<UpdateBookerFromEndUserAppMutation, UpdateBookerFromEndUserAppMutationVariables>;

/**
 * __useUpdateBookerFromEndUserAppMutation__
 *
 * To run a mutation, you first call `useUpdateBookerFromEndUserAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookerFromEndUserAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookerFromEndUserAppMutation, { data, loading, error }] = useUpdateBookerFromEndUserAppMutation({
 *   variables: {
 *      updateBookerData: // value for 'updateBookerData'
 *      fromEndUserApp: // value for 'fromEndUserApp'
 *   },
 * });
 */
export function useUpdateBookerFromEndUserAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookerFromEndUserAppMutation, UpdateBookerFromEndUserAppMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookerFromEndUserAppMutation, UpdateBookerFromEndUserAppMutationVariables>(UpdateBookerFromEndUserAppDocument, baseOptions);
      }
export type UpdateBookerFromEndUserAppMutationHookResult = ReturnType<typeof useUpdateBookerFromEndUserAppMutation>;
export type UpdateBookerFromEndUserAppMutationResult = ApolloReactCommon.MutationResult<UpdateBookerFromEndUserAppMutation>;
export type UpdateBookerFromEndUserAppMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookerFromEndUserAppMutation, UpdateBookerFromEndUserAppMutationVariables>;
export const CreateBookingFromEndUserAppDocument = gql`
    mutation CreateBookingFromEndUserApp($newBookingData: NewBookingInput!, $sendMail: Boolean!) {
  createBooking(newBookingData: $newBookingData, sendMail: $sendMail) {
    id
    bookingType
  }
}
    `;
export type CreateBookingFromEndUserAppMutationFn = ApolloReactCommon.MutationFunction<CreateBookingFromEndUserAppMutation, CreateBookingFromEndUserAppMutationVariables>;

/**
 * __useCreateBookingFromEndUserAppMutation__
 *
 * To run a mutation, you first call `useCreateBookingFromEndUserAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingFromEndUserAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingFromEndUserAppMutation, { data, loading, error }] = useCreateBookingFromEndUserAppMutation({
 *   variables: {
 *      newBookingData: // value for 'newBookingData'
 *      sendMail: // value for 'sendMail'
 *   },
 * });
 */
export function useCreateBookingFromEndUserAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookingFromEndUserAppMutation, CreateBookingFromEndUserAppMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBookingFromEndUserAppMutation, CreateBookingFromEndUserAppMutationVariables>(CreateBookingFromEndUserAppDocument, baseOptions);
      }
export type CreateBookingFromEndUserAppMutationHookResult = ReturnType<typeof useCreateBookingFromEndUserAppMutation>;
export type CreateBookingFromEndUserAppMutationResult = ApolloReactCommon.MutationResult<CreateBookingFromEndUserAppMutation>;
export type CreateBookingFromEndUserAppMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBookingFromEndUserAppMutation, CreateBookingFromEndUserAppMutationVariables>;
export const TenantChangeVersionDocument = gql`
    query TenantChangeVersion {
  tenantChangeVersion
}
    `;

/**
 * __useTenantChangeVersionQuery__
 *
 * To run a query within a React component, call `useTenantChangeVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantChangeVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantChangeVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantChangeVersionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TenantChangeVersionQuery, TenantChangeVersionQueryVariables>) {
        return ApolloReactHooks.useQuery<TenantChangeVersionQuery, TenantChangeVersionQueryVariables>(TenantChangeVersionDocument, baseOptions);
      }
export function useTenantChangeVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TenantChangeVersionQuery, TenantChangeVersionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TenantChangeVersionQuery, TenantChangeVersionQueryVariables>(TenantChangeVersionDocument, baseOptions);
        }
export type TenantChangeVersionQueryHookResult = ReturnType<typeof useTenantChangeVersionQuery>;
export type TenantChangeVersionLazyQueryHookResult = ReturnType<typeof useTenantChangeVersionLazyQuery>;
export type TenantChangeVersionQueryResult = ApolloReactCommon.QueryResult<TenantChangeVersionQuery, TenantChangeVersionQueryVariables>;
export const LoggerDocument = gql`
    mutation logger($input: LoggingInput!) {
  logging(input: $input)
}
    `;
export type LoggerMutationFn = ApolloReactCommon.MutationFunction<LoggerMutation, LoggerMutationVariables>;

/**
 * __useLoggerMutation__
 *
 * To run a mutation, you first call `useLoggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loggerMutation, { data, loading, error }] = useLoggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoggerMutation, LoggerMutationVariables>) {
        return ApolloReactHooks.useMutation<LoggerMutation, LoggerMutationVariables>(LoggerDocument, baseOptions);
      }
export type LoggerMutationHookResult = ReturnType<typeof useLoggerMutation>;
export type LoggerMutationResult = ApolloReactCommon.MutationResult<LoggerMutation>;
export type LoggerMutationOptions = ApolloReactCommon.BaseMutationOptions<LoggerMutation, LoggerMutationVariables>;
export const GetUserSettingDocument = gql`
    query getUserSetting {
  userSettings {
    id
    language
    profilePictureUrl
    columnSettings
    showArchivedCourses
  }
}
    `;

/**
 * __useGetUserSettingQuery__
 *
 * To run a query within a React component, call `useGetUserSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserSettingQuery, GetUserSettingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserSettingQuery, GetUserSettingQueryVariables>(GetUserSettingDocument, baseOptions);
      }
export function useGetUserSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSettingQuery, GetUserSettingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserSettingQuery, GetUserSettingQueryVariables>(GetUserSettingDocument, baseOptions);
        }
export type GetUserSettingQueryHookResult = ReturnType<typeof useGetUserSettingQuery>;
export type GetUserSettingLazyQueryHookResult = ReturnType<typeof useGetUserSettingLazyQuery>;
export type GetUserSettingQueryResult = ApolloReactCommon.QueryResult<GetUserSettingQuery, GetUserSettingQueryVariables>;
export const GetUserSettingByIdAllDocument = gql`
    query getUserSettingByIdAll {
  userSettings {
    id
    language
    profilePictureUrl
    columnSettings
    optimizedCourseCalendar
  }
}
    `;

/**
 * __useGetUserSettingByIdAllQuery__
 *
 * To run a query within a React component, call `useGetUserSettingByIdAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingByIdAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingByIdAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSettingByIdAllQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserSettingByIdAllQuery, GetUserSettingByIdAllQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserSettingByIdAllQuery, GetUserSettingByIdAllQueryVariables>(GetUserSettingByIdAllDocument, baseOptions);
      }
export function useGetUserSettingByIdAllLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSettingByIdAllQuery, GetUserSettingByIdAllQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserSettingByIdAllQuery, GetUserSettingByIdAllQueryVariables>(GetUserSettingByIdAllDocument, baseOptions);
        }
export type GetUserSettingByIdAllQueryHookResult = ReturnType<typeof useGetUserSettingByIdAllQuery>;
export type GetUserSettingByIdAllLazyQueryHookResult = ReturnType<typeof useGetUserSettingByIdAllLazyQuery>;
export type GetUserSettingByIdAllQueryResult = ApolloReactCommon.QueryResult<GetUserSettingByIdAllQuery, GetUserSettingByIdAllQueryVariables>;
export const SetOptimizedCourseCalendarDocument = gql`
    mutation setOptimizedCourseCalendar($optimize: Boolean!) {
  userSettingSetOptimizedCourseCalendar(optimize: $optimize) {
    id
  }
}
    `;
export type SetOptimizedCourseCalendarMutationFn = ApolloReactCommon.MutationFunction<SetOptimizedCourseCalendarMutation, SetOptimizedCourseCalendarMutationVariables>;

/**
 * __useSetOptimizedCourseCalendarMutation__
 *
 * To run a mutation, you first call `useSetOptimizedCourseCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOptimizedCourseCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOptimizedCourseCalendarMutation, { data, loading, error }] = useSetOptimizedCourseCalendarMutation({
 *   variables: {
 *      optimize: // value for 'optimize'
 *   },
 * });
 */
export function useSetOptimizedCourseCalendarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOptimizedCourseCalendarMutation, SetOptimizedCourseCalendarMutationVariables>) {
        return ApolloReactHooks.useMutation<SetOptimizedCourseCalendarMutation, SetOptimizedCourseCalendarMutationVariables>(SetOptimizedCourseCalendarDocument, baseOptions);
      }
export type SetOptimizedCourseCalendarMutationHookResult = ReturnType<typeof useSetOptimizedCourseCalendarMutation>;
export type SetOptimizedCourseCalendarMutationResult = ApolloReactCommon.MutationResult<SetOptimizedCourseCalendarMutation>;
export type SetOptimizedCourseCalendarMutationOptions = ApolloReactCommon.BaseMutationOptions<SetOptimizedCourseCalendarMutation, SetOptimizedCourseCalendarMutationVariables>;
export const UpdateUserSettingDocument = gql`
    mutation updateUserSetting($userSettingsInput: UserSettingsInputTypes!) {
  userSettingsUpdateOrCreate(userSettingsInput: $userSettingsInput) {
    id
    language
    profilePictureUrl
    columnSettings
  }
}
    `;
export type UpdateUserSettingMutationFn = ApolloReactCommon.MutationFunction<UpdateUserSettingMutation, UpdateUserSettingMutationVariables>;

/**
 * __useUpdateUserSettingMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingMutation, { data, loading, error }] = useUpdateUserSettingMutation({
 *   variables: {
 *      userSettingsInput: // value for 'userSettingsInput'
 *   },
 * });
 */
export function useUpdateUserSettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserSettingMutation, UpdateUserSettingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserSettingMutation, UpdateUserSettingMutationVariables>(UpdateUserSettingDocument, baseOptions);
      }
export type UpdateUserSettingMutationHookResult = ReturnType<typeof useUpdateUserSettingMutation>;
export type UpdateUserSettingMutationResult = ApolloReactCommon.MutationResult<UpdateUserSettingMutation>;
export type UpdateUserSettingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserSettingMutation, UpdateUserSettingMutationVariables>;
export const UpdateTableColumnSettingsDocument = gql`
    mutation updateTableColumnSettings($updateTableColumnSettingsInput: UpdateTableColumnSettingsInput!) {
  updateTableColumnSettings(updateTableColumnSettingsInput: $updateTableColumnSettingsInput) {
    id
    columnSettings
  }
}
    `;
export type UpdateTableColumnSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateTableColumnSettingsMutation, UpdateTableColumnSettingsMutationVariables>;

/**
 * __useUpdateTableColumnSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTableColumnSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableColumnSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableColumnSettingsMutation, { data, loading, error }] = useUpdateTableColumnSettingsMutation({
 *   variables: {
 *      updateTableColumnSettingsInput: // value for 'updateTableColumnSettingsInput'
 *   },
 * });
 */
export function useUpdateTableColumnSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTableColumnSettingsMutation, UpdateTableColumnSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTableColumnSettingsMutation, UpdateTableColumnSettingsMutationVariables>(UpdateTableColumnSettingsDocument, baseOptions);
      }
export type UpdateTableColumnSettingsMutationHookResult = ReturnType<typeof useUpdateTableColumnSettingsMutation>;
export type UpdateTableColumnSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateTableColumnSettingsMutation>;
export type UpdateTableColumnSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTableColumnSettingsMutation, UpdateTableColumnSettingsMutationVariables>;
export const GetColumnsForTableDocument = gql`
    query getColumnsForTable($table: TablesEnum!) {
  getColumnsForTable(table: $table)
}
    `;

/**
 * __useGetColumnsForTableQuery__
 *
 * To run a query within a React component, call `useGetColumnsForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnsForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnsForTableQuery({
 *   variables: {
 *      table: // value for 'table'
 *   },
 * });
 */
export function useGetColumnsForTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetColumnsForTableQuery, GetColumnsForTableQueryVariables>) {
        return ApolloReactHooks.useQuery<GetColumnsForTableQuery, GetColumnsForTableQueryVariables>(GetColumnsForTableDocument, baseOptions);
      }
export function useGetColumnsForTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetColumnsForTableQuery, GetColumnsForTableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetColumnsForTableQuery, GetColumnsForTableQueryVariables>(GetColumnsForTableDocument, baseOptions);
        }
export type GetColumnsForTableQueryHookResult = ReturnType<typeof useGetColumnsForTableQuery>;
export type GetColumnsForTableLazyQueryHookResult = ReturnType<typeof useGetColumnsForTableLazyQuery>;
export type GetColumnsForTableQueryResult = ApolloReactCommon.QueryResult<GetColumnsForTableQuery, GetColumnsForTableQueryVariables>;
export const GetAttendanceListSettingsDocument = gql`
    query getAttendanceListSettings {
  userSettings {
    id
    attendanceListSettings
  }
}
    `;

/**
 * __useGetAttendanceListSettingsQuery__
 *
 * To run a query within a React component, call `useGetAttendanceListSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceListSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceListSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAttendanceListSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttendanceListSettingsQuery, GetAttendanceListSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttendanceListSettingsQuery, GetAttendanceListSettingsQueryVariables>(GetAttendanceListSettingsDocument, baseOptions);
      }
export function useGetAttendanceListSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttendanceListSettingsQuery, GetAttendanceListSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttendanceListSettingsQuery, GetAttendanceListSettingsQueryVariables>(GetAttendanceListSettingsDocument, baseOptions);
        }
export type GetAttendanceListSettingsQueryHookResult = ReturnType<typeof useGetAttendanceListSettingsQuery>;
export type GetAttendanceListSettingsLazyQueryHookResult = ReturnType<typeof useGetAttendanceListSettingsLazyQuery>;
export type GetAttendanceListSettingsQueryResult = ApolloReactCommon.QueryResult<GetAttendanceListSettingsQuery, GetAttendanceListSettingsQueryVariables>;
export const UpdateAttendanceListSettingsDocument = gql`
    mutation updateAttendanceListSettings($updateAttendanceListSettingsInput: UpdateAttendanceListSettingsInput!) {
  updateAttendanceListSettings(updateAttendanceListSettingsInput: $updateAttendanceListSettingsInput) {
    id
    attendanceListSettings
  }
}
    `;
export type UpdateAttendanceListSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateAttendanceListSettingsMutation, UpdateAttendanceListSettingsMutationVariables>;

/**
 * __useUpdateAttendanceListSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAttendanceListSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendanceListSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttendanceListSettingsMutation, { data, loading, error }] = useUpdateAttendanceListSettingsMutation({
 *   variables: {
 *      updateAttendanceListSettingsInput: // value for 'updateAttendanceListSettingsInput'
 *   },
 * });
 */
export function useUpdateAttendanceListSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAttendanceListSettingsMutation, UpdateAttendanceListSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAttendanceListSettingsMutation, UpdateAttendanceListSettingsMutationVariables>(UpdateAttendanceListSettingsDocument, baseOptions);
      }
export type UpdateAttendanceListSettingsMutationHookResult = ReturnType<typeof useUpdateAttendanceListSettingsMutation>;
export type UpdateAttendanceListSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateAttendanceListSettingsMutation>;
export type UpdateAttendanceListSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAttendanceListSettingsMutation, UpdateAttendanceListSettingsMutationVariables>;
export const UpdateShowArchivedCoursesDocument = gql`
    mutation updateShowArchivedCourses($showArchivedCourses: Boolean!) {
  updateShowArchivedCourses(showArchivedCourses: $showArchivedCourses) {
    id
    showArchivedCourses
  }
}
    `;
export type UpdateShowArchivedCoursesMutationFn = ApolloReactCommon.MutationFunction<UpdateShowArchivedCoursesMutation, UpdateShowArchivedCoursesMutationVariables>;

/**
 * __useUpdateShowArchivedCoursesMutation__
 *
 * To run a mutation, you first call `useUpdateShowArchivedCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShowArchivedCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShowArchivedCoursesMutation, { data, loading, error }] = useUpdateShowArchivedCoursesMutation({
 *   variables: {
 *      showArchivedCourses: // value for 'showArchivedCourses'
 *   },
 * });
 */
export function useUpdateShowArchivedCoursesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShowArchivedCoursesMutation, UpdateShowArchivedCoursesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateShowArchivedCoursesMutation, UpdateShowArchivedCoursesMutationVariables>(UpdateShowArchivedCoursesDocument, baseOptions);
      }
export type UpdateShowArchivedCoursesMutationHookResult = ReturnType<typeof useUpdateShowArchivedCoursesMutation>;
export type UpdateShowArchivedCoursesMutationResult = ApolloReactCommon.MutationResult<UpdateShowArchivedCoursesMutation>;
export type UpdateShowArchivedCoursesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShowArchivedCoursesMutation, UpdateShowArchivedCoursesMutationVariables>;
export const LocationsDocument = gql`
    query Locations {
  locations {
    id
    name
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        return ApolloReactHooks.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, baseOptions);
      }
export function useLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, baseOptions);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = ApolloReactCommon.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const CreateAttendanceListBulkByLocationDocument = gql`
    mutation CreateAttendanceListBulkByLocation($input: CreateAttendanceListBulkByLocationInput!) {
  createAttendanceListBulkByLocation(input: $input) {
    jobGroupId
    courseCount
    estimatedDurationSeconds
    message
  }
}
    `;
export type CreateAttendanceListBulkByLocationMutationFn = ApolloReactCommon.MutationFunction<CreateAttendanceListBulkByLocationMutation, CreateAttendanceListBulkByLocationMutationVariables>;

/**
 * __useCreateAttendanceListBulkByLocationMutation__
 *
 * To run a mutation, you first call `useCreateAttendanceListBulkByLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttendanceListBulkByLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttendanceListBulkByLocationMutation, { data, loading, error }] = useCreateAttendanceListBulkByLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttendanceListBulkByLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAttendanceListBulkByLocationMutation, CreateAttendanceListBulkByLocationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAttendanceListBulkByLocationMutation, CreateAttendanceListBulkByLocationMutationVariables>(CreateAttendanceListBulkByLocationDocument, baseOptions);
      }
export type CreateAttendanceListBulkByLocationMutationHookResult = ReturnType<typeof useCreateAttendanceListBulkByLocationMutation>;
export type CreateAttendanceListBulkByLocationMutationResult = ApolloReactCommon.MutationResult<CreateAttendanceListBulkByLocationMutation>;
export type CreateAttendanceListBulkByLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAttendanceListBulkByLocationMutation, CreateAttendanceListBulkByLocationMutationVariables>;
export const CreateAttendanceListBulkByInstructorDocument = gql`
    mutation CreateAttendanceListBulkByInstructor($input: CreateAttendanceListBulkByInstructorInput!) {
  createAttendanceListBulkByInstructor(input: $input) {
    jobGroupId
    courseCount
    estimatedDurationSeconds
    message
  }
}
    `;
export type CreateAttendanceListBulkByInstructorMutationFn = ApolloReactCommon.MutationFunction<CreateAttendanceListBulkByInstructorMutation, CreateAttendanceListBulkByInstructorMutationVariables>;

/**
 * __useCreateAttendanceListBulkByInstructorMutation__
 *
 * To run a mutation, you first call `useCreateAttendanceListBulkByInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttendanceListBulkByInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttendanceListBulkByInstructorMutation, { data, loading, error }] = useCreateAttendanceListBulkByInstructorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttendanceListBulkByInstructorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAttendanceListBulkByInstructorMutation, CreateAttendanceListBulkByInstructorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAttendanceListBulkByInstructorMutation, CreateAttendanceListBulkByInstructorMutationVariables>(CreateAttendanceListBulkByInstructorDocument, baseOptions);
      }
export type CreateAttendanceListBulkByInstructorMutationHookResult = ReturnType<typeof useCreateAttendanceListBulkByInstructorMutation>;
export type CreateAttendanceListBulkByInstructorMutationResult = ApolloReactCommon.MutationResult<CreateAttendanceListBulkByInstructorMutation>;
export type CreateAttendanceListBulkByInstructorMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAttendanceListBulkByInstructorMutation, CreateAttendanceListBulkByInstructorMutationVariables>;
export const AttendanceListBulkJobStatusDocument = gql`
    query AttendanceListBulkJobStatus($jobGroupId: ID!) {
  attendanceListBulkJobStatus(jobGroupId: $jobGroupId) {
    jobGroupId
    total
    completed
    failed
    active
    downloadUrl
    expiresAt
  }
}
    `;

/**
 * __useAttendanceListBulkJobStatusQuery__
 *
 * To run a query within a React component, call `useAttendanceListBulkJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceListBulkJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceListBulkJobStatusQuery({
 *   variables: {
 *      jobGroupId: // value for 'jobGroupId'
 *   },
 * });
 */
export function useAttendanceListBulkJobStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttendanceListBulkJobStatusQuery, AttendanceListBulkJobStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<AttendanceListBulkJobStatusQuery, AttendanceListBulkJobStatusQueryVariables>(AttendanceListBulkJobStatusDocument, baseOptions);
      }
export function useAttendanceListBulkJobStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttendanceListBulkJobStatusQuery, AttendanceListBulkJobStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AttendanceListBulkJobStatusQuery, AttendanceListBulkJobStatusQueryVariables>(AttendanceListBulkJobStatusDocument, baseOptions);
        }
export type AttendanceListBulkJobStatusQueryHookResult = ReturnType<typeof useAttendanceListBulkJobStatusQuery>;
export type AttendanceListBulkJobStatusLazyQueryHookResult = ReturnType<typeof useAttendanceListBulkJobStatusLazyQuery>;
export type AttendanceListBulkJobStatusQueryResult = ApolloReactCommon.QueryResult<AttendanceListBulkJobStatusQuery, AttendanceListBulkJobStatusQueryVariables>;
export const AttendanceListArchivesDocument = gql`
    query AttendanceListArchives {
  attendanceListArchives {
    jobGroupId
    createdAt
    expiresAt
    downloadUrl
    courseCount
    fileSize
    locationName
    instructorNames
    dateRangeStart
    dateRangeEnd
    createdByUserId
    createdByUserEmail
    createdByUserName
  }
}
    `;

/**
 * __useAttendanceListArchivesQuery__
 *
 * To run a query within a React component, call `useAttendanceListArchivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceListArchivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceListArchivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttendanceListArchivesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttendanceListArchivesQuery, AttendanceListArchivesQueryVariables>) {
        return ApolloReactHooks.useQuery<AttendanceListArchivesQuery, AttendanceListArchivesQueryVariables>(AttendanceListArchivesDocument, baseOptions);
      }
export function useAttendanceListArchivesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttendanceListArchivesQuery, AttendanceListArchivesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AttendanceListArchivesQuery, AttendanceListArchivesQueryVariables>(AttendanceListArchivesDocument, baseOptions);
        }
export type AttendanceListArchivesQueryHookResult = ReturnType<typeof useAttendanceListArchivesQuery>;
export type AttendanceListArchivesLazyQueryHookResult = ReturnType<typeof useAttendanceListArchivesLazyQuery>;
export type AttendanceListArchivesQueryResult = ApolloReactCommon.QueryResult<AttendanceListArchivesQuery, AttendanceListArchivesQueryVariables>;
export const GetArchiveInstructorsDocument = gql`
    query GetArchiveInstructors($jobGroupId: ID!) {
  attendanceListArchiveInstructors(jobGroupId: $jobGroupId) {
    instructorId
    instructorName
    instructorEmail
    courseIds
    courseCount
  }
}
    `;

/**
 * __useGetArchiveInstructorsQuery__
 *
 * To run a query within a React component, call `useGetArchiveInstructorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchiveInstructorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchiveInstructorsQuery({
 *   variables: {
 *      jobGroupId: // value for 'jobGroupId'
 *   },
 * });
 */
export function useGetArchiveInstructorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetArchiveInstructorsQuery, GetArchiveInstructorsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetArchiveInstructorsQuery, GetArchiveInstructorsQueryVariables>(GetArchiveInstructorsDocument, baseOptions);
      }
export function useGetArchiveInstructorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetArchiveInstructorsQuery, GetArchiveInstructorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetArchiveInstructorsQuery, GetArchiveInstructorsQueryVariables>(GetArchiveInstructorsDocument, baseOptions);
        }
export type GetArchiveInstructorsQueryHookResult = ReturnType<typeof useGetArchiveInstructorsQuery>;
export type GetArchiveInstructorsLazyQueryHookResult = ReturnType<typeof useGetArchiveInstructorsLazyQuery>;
export type GetArchiveInstructorsQueryResult = ApolloReactCommon.QueryResult<GetArchiveInstructorsQuery, GetArchiveInstructorsQueryVariables>;
export const SendAttendanceListArchiveDocument = gql`
    mutation SendAttendanceListArchive($input: SendAttendanceListArchiveInput!) {
  sendAttendanceListArchive(input: $input)
}
    `;
export type SendAttendanceListArchiveMutationFn = ApolloReactCommon.MutationFunction<SendAttendanceListArchiveMutation, SendAttendanceListArchiveMutationVariables>;

/**
 * __useSendAttendanceListArchiveMutation__
 *
 * To run a mutation, you first call `useSendAttendanceListArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAttendanceListArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAttendanceListArchiveMutation, { data, loading, error }] = useSendAttendanceListArchiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAttendanceListArchiveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendAttendanceListArchiveMutation, SendAttendanceListArchiveMutationVariables>) {
        return ApolloReactHooks.useMutation<SendAttendanceListArchiveMutation, SendAttendanceListArchiveMutationVariables>(SendAttendanceListArchiveDocument, baseOptions);
      }
export type SendAttendanceListArchiveMutationHookResult = ReturnType<typeof useSendAttendanceListArchiveMutation>;
export type SendAttendanceListArchiveMutationResult = ApolloReactCommon.MutationResult<SendAttendanceListArchiveMutation>;
export type SendAttendanceListArchiveMutationOptions = ApolloReactCommon.BaseMutationOptions<SendAttendanceListArchiveMutation, SendAttendanceListArchiveMutationVariables>;
export const SendAttendanceListArchiveTestEmailDocument = gql`
    mutation SendAttendanceListArchiveTestEmail($input: SendAttendanceListArchiveInput!) {
  sendAttendanceListArchiveTestEmail(input: $input)
}
    `;
export type SendAttendanceListArchiveTestEmailMutationFn = ApolloReactCommon.MutationFunction<SendAttendanceListArchiveTestEmailMutation, SendAttendanceListArchiveTestEmailMutationVariables>;

/**
 * __useSendAttendanceListArchiveTestEmailMutation__
 *
 * To run a mutation, you first call `useSendAttendanceListArchiveTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAttendanceListArchiveTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAttendanceListArchiveTestEmailMutation, { data, loading, error }] = useSendAttendanceListArchiveTestEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAttendanceListArchiveTestEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendAttendanceListArchiveTestEmailMutation, SendAttendanceListArchiveTestEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendAttendanceListArchiveTestEmailMutation, SendAttendanceListArchiveTestEmailMutationVariables>(SendAttendanceListArchiveTestEmailDocument, baseOptions);
      }
export type SendAttendanceListArchiveTestEmailMutationHookResult = ReturnType<typeof useSendAttendanceListArchiveTestEmailMutation>;
export type SendAttendanceListArchiveTestEmailMutationResult = ApolloReactCommon.MutationResult<SendAttendanceListArchiveTestEmailMutation>;
export type SendAttendanceListArchiveTestEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendAttendanceListArchiveTestEmailMutation, SendAttendanceListArchiveTestEmailMutationVariables>;
export const DeleteAttendanceListArchiveDocument = gql`
    mutation DeleteAttendanceListArchive($jobGroupId: ID!) {
  deleteAttendanceListArchive(jobGroupId: $jobGroupId)
}
    `;
export type DeleteAttendanceListArchiveMutationFn = ApolloReactCommon.MutationFunction<DeleteAttendanceListArchiveMutation, DeleteAttendanceListArchiveMutationVariables>;

/**
 * __useDeleteAttendanceListArchiveMutation__
 *
 * To run a mutation, you first call `useDeleteAttendanceListArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendanceListArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendanceListArchiveMutation, { data, loading, error }] = useDeleteAttendanceListArchiveMutation({
 *   variables: {
 *      jobGroupId: // value for 'jobGroupId'
 *   },
 * });
 */
export function useDeleteAttendanceListArchiveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAttendanceListArchiveMutation, DeleteAttendanceListArchiveMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAttendanceListArchiveMutation, DeleteAttendanceListArchiveMutationVariables>(DeleteAttendanceListArchiveDocument, baseOptions);
      }
export type DeleteAttendanceListArchiveMutationHookResult = ReturnType<typeof useDeleteAttendanceListArchiveMutation>;
export type DeleteAttendanceListArchiveMutationResult = ApolloReactCommon.MutationResult<DeleteAttendanceListArchiveMutation>;
export type DeleteAttendanceListArchiveMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAttendanceListArchiveMutation, DeleteAttendanceListArchiveMutationVariables>;
export const DeleteAllAttendanceListArchivesDocument = gql`
    mutation DeleteAllAttendanceListArchives {
  deleteAllAttendanceListArchives
}
    `;
export type DeleteAllAttendanceListArchivesMutationFn = ApolloReactCommon.MutationFunction<DeleteAllAttendanceListArchivesMutation, DeleteAllAttendanceListArchivesMutationVariables>;

/**
 * __useDeleteAllAttendanceListArchivesMutation__
 *
 * To run a mutation, you first call `useDeleteAllAttendanceListArchivesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllAttendanceListArchivesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllAttendanceListArchivesMutation, { data, loading, error }] = useDeleteAllAttendanceListArchivesMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAllAttendanceListArchivesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAllAttendanceListArchivesMutation, DeleteAllAttendanceListArchivesMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAllAttendanceListArchivesMutation, DeleteAllAttendanceListArchivesMutationVariables>(DeleteAllAttendanceListArchivesDocument, baseOptions);
      }
export type DeleteAllAttendanceListArchivesMutationHookResult = ReturnType<typeof useDeleteAllAttendanceListArchivesMutation>;
export type DeleteAllAttendanceListArchivesMutationResult = ApolloReactCommon.MutationResult<DeleteAllAttendanceListArchivesMutation>;
export type DeleteAllAttendanceListArchivesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAllAttendanceListArchivesMutation, DeleteAllAttendanceListArchivesMutationVariables>;
export const GetMjmlTemplateByIdDocument = gql`
    query GetMjmlTemplateById($templateId: String!) {
  getEmailTemplateById(templateId: $templateId) {
    Count
    Data
    Total
  }
}
    `;

/**
 * __useGetMjmlTemplateByIdQuery__
 *
 * To run a query within a React component, call `useGetMjmlTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMjmlTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMjmlTemplateByIdQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetMjmlTemplateByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMjmlTemplateByIdQuery, GetMjmlTemplateByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMjmlTemplateByIdQuery, GetMjmlTemplateByIdQueryVariables>(GetMjmlTemplateByIdDocument, baseOptions);
      }
export function useGetMjmlTemplateByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMjmlTemplateByIdQuery, GetMjmlTemplateByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMjmlTemplateByIdQuery, GetMjmlTemplateByIdQueryVariables>(GetMjmlTemplateByIdDocument, baseOptions);
        }
export type GetMjmlTemplateByIdQueryHookResult = ReturnType<typeof useGetMjmlTemplateByIdQuery>;
export type GetMjmlTemplateByIdLazyQueryHookResult = ReturnType<typeof useGetMjmlTemplateByIdLazyQuery>;
export type GetMjmlTemplateByIdQueryResult = ApolloReactCommon.QueryResult<GetMjmlTemplateByIdQuery, GetMjmlTemplateByIdQueryVariables>;
export const GetPaymentActionLogsDocument = gql`
    query getPaymentActionLogs($scheduledPaymentId: String!, $limit: Int, $offset: Int) {
  getPaymentActionLogs(scheduledPaymentId: $scheduledPaymentId, limit: $limit, offset: $offset) {
    id
    scheduledPaymentId
    userId
    action
    metadata
    timestamp
  }
}
    `;

/**
 * __useGetPaymentActionLogsQuery__
 *
 * To run a query within a React component, call `useGetPaymentActionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentActionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentActionLogsQuery({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPaymentActionLogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentActionLogsQuery, GetPaymentActionLogsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPaymentActionLogsQuery, GetPaymentActionLogsQueryVariables>(GetPaymentActionLogsDocument, baseOptions);
      }
export function useGetPaymentActionLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentActionLogsQuery, GetPaymentActionLogsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPaymentActionLogsQuery, GetPaymentActionLogsQueryVariables>(GetPaymentActionLogsDocument, baseOptions);
        }
export type GetPaymentActionLogsQueryHookResult = ReturnType<typeof useGetPaymentActionLogsQuery>;
export type GetPaymentActionLogsLazyQueryHookResult = ReturnType<typeof useGetPaymentActionLogsLazyQuery>;
export type GetPaymentActionLogsQueryResult = ApolloReactCommon.QueryResult<GetPaymentActionLogsQuery, GetPaymentActionLogsQueryVariables>;


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']>;
  AccountForEmail: ResolverTypeWrapper<AccountForEmail>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  AccountForEmailLinkedBooker: ResolverTypeWrapper<AccountForEmailLinkedBooker>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  AccountLinks: ResolverTypeWrapper<AccountLinks>;
  AccountLinksStaff: ResolverTypeWrapper<AccountLinksStaff>;
  Announcement: ResolverTypeWrapper<Announcement>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  AnnouncementPriority: AnnouncementPriority;
  AnnouncementType: AnnouncementType;
  ActiveDunning: ResolverTypeWrapper<ActiveDunning>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  DunningLevel: DunningLevel;
  AdminManagementEmailInfo: ResolverTypeWrapper<AdminManagementEmailInfo>;
  AdminManagementEmailStatus: AdminManagementEmailStatus;
  AdminManagementOverview: ResolverTypeWrapper<AdminManagementOverview>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  AdminManagementUser: ResolverTypeWrapper<AdminManagementUser>;
  GetAnnouncementsInput: GetAnnouncementsInput;
  InstructorCourseGroup: ResolverTypeWrapper<InstructorCourseGroup>;
  AttendanceListArchive: ResolverTypeWrapper<AttendanceListArchive>;
  BulkJobStatus: ResolverTypeWrapper<BulkJobStatus>;
  Booking: ResolverTypeWrapper<Booking>;
  Attendee: ResolverTypeWrapper<Attendee>;
  AttendeeBadge: ResolverTypeWrapper<AttendeeBadge>;
  AttendeeBadgeRequirement: ResolverTypeWrapper<AttendeeBadgeRequirement>;
  BadgeRequirement: ResolverTypeWrapper<BadgeRequirement>;
  Badge: ResolverTypeWrapper<Badge>;
  Booker: ResolverTypeWrapper<Booker>;
  CreatedBy: CreatedBy;
  UserType: ResolverTypeWrapper<UserType>;
  Customer: ResolverTypeWrapper<Customer>;
  Gender: Gender;
  PaymentMethod: ResolverTypeWrapper<PaymentMethod>;
  ScheduledPayment: ResolverTypeWrapper<ScheduledPayment>;
  ScheduledPaymentMethodChangeUser: ResolverTypeWrapper<ScheduledPaymentMethodChangeUser>;
  BookingDunningStatus: ResolverTypeWrapper<BookingDunningStatus>;
  Invoice: ResolverTypeWrapper<Invoice>;
  KoOrganization: ResolverTypeWrapper<KoOrganization>;
  CompanySetting: ResolverTypeWrapper<CompanySetting>;
  Setting: ResolverTypeWrapper<Setting>;
  PaymentProvider: PaymentProvider;
  CourseNumberFormat: CourseNumberFormat;
  Currency: Currency;
  GrossNet: GrossNet;
  CountryCode: CountryCode;
  StateCode: StateCode;
  TransferOldBookingDefault: TransferOldBookingDefault;
  TransferPriceDefault: TransferPriceDefault;
  TransferMode: TransferMode;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionType: SubscriptionType;
  LatestMollieAttemptBadge: ResolverTypeWrapper<LatestMollieAttemptBadge>;
  PaymentTransferType: PaymentTransferType;
  BookingPostKind: BookingPostKind;
  SepaCollectionStatus: SepaCollectionStatus;
  ScheduledPaymentType: ScheduledPaymentType;
  BookingsKo9: ResolverTypeWrapper<BookingsKo9>;
  Course: ResolverTypeWrapper<Course>;
  CourseAdditionalItem: ResolverTypeWrapper<CourseAdditionalItem>;
  AdditionalItemMode: AdditionalItemMode;
  CourseBookingPriceQuote: ResolverTypeWrapper<CourseBookingPriceQuote>;
  CourseBookingBasePriceBlockingReason: CourseBookingBasePriceBlockingReason;
  CourseLateEntryPricingMode: CourseLateEntryPricingMode;
  BookingRestriction: ResolverTypeWrapper<BookingRestriction>;
  ExpireAction: ExpireAction;
  CoursePrice: ResolverTypeWrapper<CoursePrice>;
  CourseType: ResolverTypeWrapper<CourseType>;
  CourseCategory: ResolverTypeWrapper<CourseCategory>;
  ParticipationPrerequisites: ResolverTypeWrapper<ParticipationPrerequisites>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']>;
  PaymentInterval: PaymentInterval;
  CourseCycle: CourseCycle;
  EnabledCourse: ResolverTypeWrapper<EnabledCourse>;
  CourseVisibilityResult: ResolverTypeWrapper<CourseVisibilityResult>;
  CourseNotVisibleReason: CourseNotVisibleReason;
  CourseVisibilityRestriction: ResolverTypeWrapper<CourseVisibilityRestriction>;
  InstallmentRate: ResolverTypeWrapper<InstallmentRate>;
  InstallmentType: InstallmentType;
  Instructor: ResolverTypeWrapper<Instructor>;
  Location: ResolverTypeWrapper<Location>;
  GeneralLocationContact: ResolverTypeWrapper<GeneralLocationContact>;
  CourseLesson: ResolverTypeWrapper<CourseLesson>;
  CourseLessonAssistant: ResolverTypeWrapper<CourseLessonAssistant>;
  CourseLessonBooking: ResolverTypeWrapper<CourseLessonBooking>;
  BookingType: BookingType;
  InstructorInvoice: ResolverTypeWrapper<InstructorInvoice>;
  Venue: ResolverTypeWrapper<Venue>;
  LocationContact: ResolverTypeWrapper<LocationContact>;
  SalutationType: SalutationType;
  Staff: ResolverTypeWrapper<Staff>;
  MonthlySchedule: MonthlySchedule;
  PaymentType: PaymentType;
  BookedBy: BookedBy;
  BookingHistory: ResolverTypeWrapper<BookingHistory>;
  BookingHistoryAction: BookingHistoryAction;
  UserDetailsType: ResolverTypeWrapper<UserDetailsType>;
  InstructorDetailsView: ResolverTypeWrapper<InstructorDetailsView>;
  LoginAttempt: ResolverTypeWrapper<LoginAttempt>;
  LoginStatus: LoginStatus;
  RecentLoginEntry: ResolverTypeWrapper<RecentLoginEntry>;
  UserSetting: ResolverTypeWrapper<UserSetting>;
  Language: Language;
  DiscountCode: ResolverTypeWrapper<DiscountCode>;
  DiscountUnit: DiscountUnit;
  DiscountCodeScopeType: DiscountCodeScopeType;
  EmailNotification: ResolverTypeWrapper<EmailNotification>;
  MessageStatus: ResolverTypeWrapper<MessageStatus>;
  MessageStatusData: ResolverTypeWrapper<MessageStatusData>;
  MailjetStatus: MailjetStatus;
  MessageHistory: ResolverTypeWrapper<MessageHistory>;
  MessageHistoryData: ResolverTypeWrapper<MessageHistoryData>;
  LessonPricingMode: LessonPricingMode;
  BookingLessonSelectionMode: BookingLessonSelectionMode;
  MolliePaymentAttempt: ResolverTypeWrapper<MolliePaymentAttempt>;
  Chargeback: ResolverTypeWrapper<Chargeback>;
  MollieRefund: ResolverTypeWrapper<MollieRefund>;
  MollieRefundOrigin: MollieRefundOrigin;
  MollieRefundStatus: MollieRefundStatus;
  BookingPricingReason: BookingPricingReason;
  ReversalInvoice: ResolverTypeWrapper<ReversalInvoice>;
  BookingTransferIn: ResolverTypeWrapper<BookingTransferIn>;
  ArrayDataOptions: ArrayDataOptions;
  FilterOption: FilterOption;
  filterCompareOperation: FilterCompareOperation;
  filterOperation: FilterOperation;
  SortOrder: SortOrder;
  AttendeeMergeHistory: ResolverTypeWrapper<AttendeeMergeHistory>;
  AttendeeWithPagination: ResolverTypeWrapper<AttendeeWithPagination>;
  BadgeGroup: ResolverTypeWrapper<BadgeGroup>;
  BadgeGroupType: BadgeGroupType;
  BankCollectionRun: ResolverTypeWrapper<BankCollectionRun>;
  BankTransactionStatus: BankTransactionStatus;
  BankImportFile: ResolverTypeWrapper<BankImportFile>;
  BankTransaction: ResolverTypeWrapper<BankTransaction>;
  BankTransactionCandidate: ResolverTypeWrapper<BankTransactionCandidate>;
  BankTransactionCandidateEvidence: BankTransactionCandidateEvidence;
  BankTransactionSearchHit: ResolverTypeWrapper<BankTransactionSearchHit>;
  BankTransactionSearchField: BankTransactionSearchField;
  BankTransactionCandidateLevel: BankTransactionCandidateLevel;
  BankTransactionDecision: BankTransactionDecision;
  BankTransactionKind: BankTransactionKind;
  BankTransactionMatchKind: BankTransactionMatchKind;
  BankTransactionRejectReason: BankTransactionRejectReason;
  BankTransactionsFilterInput: BankTransactionsFilterInput;
  BankTransactionsPage: ResolverTypeWrapper<BankTransactionsPage>;
  BillingAddressTemplate: ResolverTypeWrapper<BillingAddressTemplate>;
  BookerDeletionProgressType: ResolverTypeWrapper<BookerDeletionProgressType>;
  BookerMergeHistory: ResolverTypeWrapper<BookerMergeHistory>;
  BookerWithPagination: ResolverTypeWrapper<BookerWithPagination>;
  BookingEligibilityCandidate: ResolverTypeWrapper<BookingEligibilityCandidate>;
  BookingEligibilityDiagnosis: ResolverTypeWrapper<BookingEligibilityDiagnosis>;
  EligibilityCheckKey: EligibilityCheckKey;
  EligibilityCheck: ResolverTypeWrapper<EligibilityCheck>;
  EligibilityCheckStatus: EligibilityCheckStatus;
  BookingRestrictionErrors: BookingRestrictionErrors;
  PrerequisiteLinkVisibility: ResolverTypeWrapper<PrerequisiteLinkVisibility>;
  BookingWithPagination: ResolverTypeWrapper<BookingWithPagination>;
  BundesbankImportInfo: ResolverTypeWrapper<BundesbankImportInfo>;
  CertificateIssuePreflightInput: CertificateIssuePreflightInput;
  CertificateIssuePreflightResult: ResolverTypeWrapper<CertificateIssuePreflightResult>;
  CertificateIssuePreflightAttendee: ResolverTypeWrapper<CertificateIssuePreflightAttendee>;
  CertificateTemplate: ResolverTypeWrapper<CertificateTemplate>;
  CertificateBlockLayout: ResolverTypeWrapper<CertificateBlockLayout>;
  CertificateBlockAlignments: ResolverTypeWrapper<CertificateBlockAlignments>;
  CertificateBlockSpacing: ResolverTypeWrapper<CertificateBlockSpacing>;
  CertificateDesignVariant: CertificateDesignVariant;
  CertificateDocFields: ResolverTypeWrapper<CertificateDocFields>;
  CertificateDocText: ResolverTypeWrapper<CertificateDocText>;
  CertificateAlign: ResolverTypeWrapper<CertificateAlign>;
  CertificateLetterFields: ResolverTypeWrapper<CertificateLetterFields>;
  CertificateSigner: ResolverTypeWrapper<CertificateSigner>;
  CertificateSizes: ResolverTypeWrapper<CertificateSizes>;
  CertificateTemplateVisibility: ResolverTypeWrapper<CertificateTemplateVisibility>;
  AttendeesAgeAtCourseStart: ResolverTypeWrapper<AttendeesAgeAtCourseStart>;
  AgeError: AgeError;
  DiscountCodeCheckResult: ResolverTypeWrapper<DiscountCodeCheckResult>;
  DiscountCodeRejectReason: DiscountCodeRejectReason;
  TemplateType: TemplateType;
  SmsBalanceResponse: ResolverTypeWrapper<SmsBalanceResponse>;
  LocationCity: ResolverTypeWrapper<LocationCity>;
  CourseDetails: ResolverTypeWrapper<CourseDetails>;
  CourseHistory: ResolverTypeWrapper<CourseHistory>;
  CourseHistoryAction: CourseHistoryAction;
  BillingStatusCoursLessons: ResolverTypeWrapper<BillingStatusCoursLessons>;
  ChronologicalLessonsResult: ResolverTypeWrapper<ChronologicalLessonsResult>;
  CourseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
  GroupBillingStatusBy: GroupBillingStatusBy;
  BillingStatusByInstructor: ResolverTypeWrapper<BillingStatusByInstructor>;
  BillingStatusByInstructorWithCourseGroups: ResolverTypeWrapper<BillingStatusByInstructorWithCourseGroups>;
  CourseSummaryForBilling: ResolverTypeWrapper<CourseSummaryForBilling>;
  CourseLessonWithPagination: ResolverTypeWrapper<CourseLessonWithPagination>;
  CollitionCheckInput: CollitionCheckInput;
  CourseLessonWithIndexOfCourseLessonInCourse: ResolverTypeWrapper<CourseLessonWithIndexOfCourseLessonInCourse>;
  FilterExpressionInput: FilterExpressionInput;
  FilterInput: FilterInput;
  Operation: Operation;
  Operator: Operator;
  DayFilter: DayFilter;
  CourseWithPagination: ResolverTypeWrapper<CourseWithPagination>;
  CourseListFilters: CourseListFilters;
  MonthFilter: MonthFilter;
  RestrictiveCourses: RestrictiveCourses;
  CourseTypeWithPagination: ResolverTypeWrapper<CourseTypeWithPagination>;
  CreditEntry: ResolverTypeWrapper<CreditEntry>;
  CreditEntryReason: CreditEntryReason;
  CustomBankData: ResolverTypeWrapper<CustomBankData>;
  CustomerTimelineEntry: ResolverTypeWrapper<CustomerTimelineEntry>;
  CustomerTimelineKind: CustomerTimelineKind;
  Holiday: ResolverTypeWrapper<Holiday>;
  HolidayType: HolidayType;
  InvoiceTemplateSet: ResolverTypeWrapper<InvoiceTemplateSet>;
  InvoiceLayoutVariant: InvoiceLayoutVariant;
  InvoiceLogoPosition: InvoiceLogoPosition;
  DunningPause: ResolverTypeWrapper<DunningPause>;
  DunningProposal: ResolverTypeWrapper<DunningProposal>;
  DunningProposalItem: ResolverTypeWrapper<DunningProposalItem>;
  Dunning: ResolverTypeWrapper<Dunning>;
  EmailNotificationWithPagination: ResolverTypeWrapper<EmailNotificationWithPagination>;
  EndUserEmailRegistrationStatus: EndUserEmailRegistrationStatus;
  ExportedSepaXml: ResolverTypeWrapper<ExportedSepaXml>;
  ExportedSepaXmlWithPagination: ResolverTypeWrapper<ExportedSepaXmlWithPagination>;
  FaUser: ResolverTypeWrapper<FaUser>;
  UserRegistration: ResolverTypeWrapper<UserRegistration>;
  FeeLetterProposal: ResolverTypeWrapper<FeeLetterProposal>;
  FeeLetterItem: ResolverTypeWrapper<FeeLetterItem>;
  FeeLetter: ResolverTypeWrapper<FeeLetter>;
  SimilarBookerResult: ResolverTypeWrapper<SimilarBookerResult>;
  FindUnpaidInSepaInput: FindUnpaidInSepaInput;
  UnpaidScheduledPaymentMatchResult: ResolverTypeWrapper<UnpaidScheduledPaymentMatchResult>;
  UnpaidScheduledPaymentMatch: ResolverTypeWrapper<UnpaidScheduledPaymentMatch>;
  MatchConfidence: MatchConfidence;
  Sms77AnalyticGroupByDate: ResolverTypeWrapper<Sms77AnalyticGroupByDate>;
  AreaIssue: ResolverTypeWrapper<AreaIssue>;
  AreaIssueLesson: ResolverTypeWrapper<AreaIssueLesson>;
  AreaIssueLocation: ResolverTypeWrapper<AreaIssueLocation>;
  AreaIssuePerson: ResolverTypeWrapper<AreaIssuePerson>;
  AreaManagerAssistantHierarchyResult: ResolverTypeWrapper<AreaManagerAssistantHierarchyResult>;
  AreaManagerAssistantLocationGroup: ResolverTypeWrapper<AreaManagerAssistantLocationGroup>;
  AreaManagerAssistantCourseGroup: ResolverTypeWrapper<AreaManagerAssistantCourseGroup>;
  AreaManagerAssistantLessonsInput: AreaManagerAssistantLessonsInput;
  AreaManagerAssistantOverview: ResolverTypeWrapper<AreaManagerAssistantOverview>;
  AreaManagerAssignedAssistant: ResolverTypeWrapper<AreaManagerAssignedAssistant>;
  AreaManagerStatsInput: AreaManagerStatsInput;
  AreaManagerAssistantOverviewResult: ResolverTypeWrapper<AreaManagerAssistantOverviewResult>;
  AreaManagerCourseStatsResult: ResolverTypeWrapper<AreaManagerCourseStatsResult>;
  AreaManagerCourseStats: ResolverTypeWrapper<AreaManagerCourseStats>;
  AreaManagerInstructorStatsResult: ResolverTypeWrapper<AreaManagerInstructorStatsResult>;
  AreaManagerInstructorStats: ResolverTypeWrapper<AreaManagerInstructorStats>;
  AreaManagerLocationStatsResult: ResolverTypeWrapper<AreaManagerLocationStatsResult>;
  AreaManagerLocationStats: ResolverTypeWrapper<AreaManagerLocationStats>;
  AreaManagerUpcomingLesson: ResolverTypeWrapper<AreaManagerUpcomingLesson>;
  AreaManagerVenueUtilizationResult: ResolverTypeWrapper<AreaManagerVenueUtilizationResult>;
  AreaManagerVenueUtilization: ResolverTypeWrapper<AreaManagerVenueUtilization>;
  AreaOverviewResult: ResolverTypeWrapper<AreaOverviewResult>;
  AreaOverviewPool: ResolverTypeWrapper<AreaOverviewPool>;
  AreaOverviewWeek: ResolverTypeWrapper<AreaOverviewWeek>;
  AreaPerson: ResolverTypeWrapper<AreaPerson>;
  AreaPersonLocation: ResolverTypeWrapper<AreaPersonLocation>;
  AutoMergeStatus: ResolverTypeWrapper<AutoMergeStatus>;
  AutoMergeFailureType: ResolverTypeWrapper<AutoMergeFailureType>;
  AutoMergeRunStatus: AutoMergeRunStatus;
  MollieMethodInfo: ResolverTypeWrapper<MollieMethodInfo>;
  PaginationInput: PaginationInput;
  BookerAttendeeCount: ResolverTypeWrapper<BookerAttendeeCount>;
  BookerIdMissmatchWithPagination: ResolverTypeWrapper<BookerIdMissmatchWithPagination>;
  BookerIdMissmatch: ResolverTypeWrapper<BookerIdMissmatch>;
  CacheStatsOutput: ResolverTypeWrapper<CacheStatsOutput>;
  ChargebackFilterInput: ChargebackFilterInput;
  ChargebackSummary: ResolverTypeWrapper<ChargebackSummary>;
  TablesEnum: TablesEnum;
  ContentOfBucket: ResolverTypeWrapper<ContentOfBucket>;
  ContentOfBucketResponse: ResolverTypeWrapper<ContentOfBucketResponse>;
  Content: ResolverTypeWrapper<Content>;
  AssistantCourseLessonFilterInput: AssistantCourseLessonFilterInput;
  AssistantCourseLesson: ResolverTypeWrapper<AssistantCourseLesson>;
  AssistantInfo: ResolverTypeWrapper<AssistantInfo>;
  DownloadBackupInput: DownloadBackupInput;
  DuplicateGroupWithMetadata: ResolverTypeWrapper<DuplicateGroupWithMetadata>;
  DuplicateGroupMatchInfo: ResolverTypeWrapper<DuplicateGroupMatchInfo>;
  DuplicateMatchType: DuplicateMatchType;
  ScoreBreakdownType: ResolverTypeWrapper<ScoreBreakdownType>;
  DuplicateDetectionRun: ResolverTypeWrapper<DuplicateDetectionRun>;
  DetectionRunStatus: DetectionRunStatus;
  DuplicateException: ResolverTypeWrapper<DuplicateException>;
  DuplicateMatchStats: ResolverTypeWrapper<DuplicateMatchStats>;
  MjmlTemplate: ResolverTypeWrapper<MjmlTemplate>;
  NewInstallmentPlanInput: NewInstallmentPlanInput;
  EditTemplateInput: EditTemplateInput;
  MailjetSenderResponse: ResolverTypeWrapper<MailjetSenderResponse>;
  MailjetSender: ResolverTypeWrapper<MailjetSender>;
  MailjetSenderQueryParams: MailjetSenderQueryParams;
  MissingIndexCandidateOutput: ResolverTypeWrapper<MissingIndexCandidateOutput>;
  MollieKpis: ResolverTypeWrapper<MollieKpis>;
  MolliePaymentFilterInput: MolliePaymentFilterInput;
  MolliePaymentTab: MolliePaymentTab;
  MolliePaymentsPage: ResolverTypeWrapper<MolliePaymentsPage>;
  MolliePaymentTabCounts: ResolverTypeWrapper<MolliePaymentTabCounts>;
  MollieRetryQueueEntry: ResolverTypeWrapper<MollieRetryQueueEntry>;
  ScheduledPaymentPreviewInput: ScheduledPaymentPreviewInput;
  OnlineRegisteredBookersResult: ResolverTypeWrapper<OnlineRegisteredBookersResult>;
  OnlineRegisteredBooker: ResolverTypeWrapper<OnlineRegisteredBooker>;
  OnlineRegisteredBookerAttendee: ResolverTypeWrapper<OnlineRegisteredBookerAttendee>;
  OpenAttendanceSummary: ResolverTypeWrapper<OpenAttendanceSummary>;
  PageStructure: ResolverTypeWrapper<PageStructure>;
  Page: ResolverTypeWrapper<Page>;
  PageContent: ResolverTypeWrapper<PageContent>;
  PaymentActionLog: ResolverTypeWrapper<PaymentActionLog>;
  PerformanceStatsOutput: ResolverTypeWrapper<PerformanceStatsOutput>;
  SlowQueryOutput: ResolverTypeWrapper<SlowQueryOutput>;
  TableStatsOutput: ResolverTypeWrapper<TableStatsOutput>;
  AssistantSelectableLocation: ResolverTypeWrapper<AssistantSelectableLocation>;
  JournalParams: JournalParams;
  JournalType: JournalType;
  Sms77JournalOutbound: ResolverTypeWrapper<Sms77JournalOutbound>;
  Sms77PricingResponse: ResolverTypeWrapper<Sms77PricingResponse>;
  Sms77CountryPricing: ResolverTypeWrapper<Sms77CountryPricing>;
  CountryNetwork: ResolverTypeWrapper<CountryNetwork>;
  MailDataType: MailDataType;
  SmsReceiver: ResolverTypeWrapper<SmsReceiver>;
  GetReceiversForCourseInput: GetReceiversForCourseInput;
  UpcomingCoursesOccupancy: ResolverTypeWrapper<UpcomingCoursesOccupancy>;
  HolidayWithDays: ResolverTypeWrapper<HolidayWithDays>;
  InstructorInvoicesByDateRangeInput: InstructorInvoicesByDateRangeInput;
  InstructorsWithPagination: ResolverTypeWrapper<InstructorsWithPagination>;
  InterestList: ResolverTypeWrapper<InterestList>;
  InterestListTimeSlot: ResolverTypeWrapper<InterestListTimeSlot>;
  InterestRegistrationWithPagination: ResolverTypeWrapper<InterestRegistrationWithPagination>;
  InterestRegistration: ResolverTypeWrapper<InterestRegistration>;
  InterestRegistrationStatus: InterestRegistrationStatus;
  InvoiceWithPagination: ResolverTypeWrapper<InvoiceWithPagination>;
  IssuedCertificatesFilterInput: IssuedCertificatesFilterInput;
  IssuedCertificate: ResolverTypeWrapper<IssuedCertificate>;
  Ko9ImportProgressType: ResolverTypeWrapper<Ko9ImportProgressType>;
  Ko9LoadedCredentials: ResolverTypeWrapper<Ko9LoadedCredentials>;
  SettingEndUserApp: ResolverTypeWrapper<SettingEndUserApp>;
  CourseSearchDisplayMode: CourseSearchDisplayMode;
  I18n: I18n;
  TenantLateEntryPricingPolicy: TenantLateEntryPricingPolicy;
  LessonBookingIntentInput: LessonBookingIntentInput;
  UpdateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
  CourseAdditionalItemInput: CourseAdditionalItemInput;
  EditCoursePriceInput: EditCoursePriceInput;
  HistorySource: HistorySource;
  UpdateInstallmentRateInput: UpdateInstallmentRateInput;
  CourseInstructorIdInput: CourseInstructorIdInput;
  EditCourseLessonInput: EditCourseLessonInput;
  EditBookingInputBookableLessons: EditBookingInputBookableLessons;
  UpdateScheduledPaymentByBookingInput: UpdateScheduledPaymentByBookingInput;
  LessonBookingPlannerPreview: ResolverTypeWrapper<LessonBookingPlannerPreview>;
  LessonBookingPlannerComponent: ResolverTypeWrapper<LessonBookingPlannerComponent>;
  LessonBookingPlannerRate: ResolverTypeWrapper<LessonBookingPlannerRate>;
  LessonBookingPlannerAdjustment: ResolverTypeWrapper<LessonBookingPlannerAdjustment>;
  LessonBookingPlannerRateStatus: LessonBookingPlannerRateStatus;
  LessonBookingPlannerUnit: ResolverTypeWrapper<LessonBookingPlannerUnit>;
  LessonBookingPlannerUnitStatus: LessonBookingPlannerUnitStatus;
  LessonBookingPlanSummary: ResolverTypeWrapper<LessonBookingPlanSummary>;
  LessonBookingPlanApplies: LessonBookingPlanApplies;
  DatabaseBackup: ResolverTypeWrapper<DatabaseBackup>;
  DataExport: ResolverTypeWrapper<DataExport>;
  InvoiceExport: ResolverTypeWrapper<InvoiceExport>;
  YearEndExport: ResolverTypeWrapper<YearEndExport>;
  LocalState: ResolverTypeWrapper<LocalState>;
  BookAttendees: ResolverTypeWrapper<BookAttendees>;
  SelectedAttendee: ResolverTypeWrapper<SelectedAttendee>;
  CreateCourse: ResolverTypeWrapper<CreateCourse>;
  LocationsGroupedByCity: ResolverTypeWrapper<LocationsGroupedByCity>;
  LocationGroupedByCityLocation: ResolverTypeWrapper<LocationGroupedByCityLocation>;
  LocationGroupedByCityVenue: ResolverTypeWrapper<LocationGroupedByCityVenue>;
  LocationsWithPagination: ResolverTypeWrapper<LocationsWithPagination>;
  MaintenanceStatus: ResolverTypeWrapper<MaintenanceStatus>;
  MissingBankData: ResolverTypeWrapper<MissingBankData>;
  MollieConnectionStatus: ResolverTypeWrapper<MollieConnectionStatus>;
  MollieDowngradeImpact: ResolverTypeWrapper<MollieDowngradeImpact>;
  MolliePaymentStatus: ResolverTypeWrapper<MolliePaymentStatus>;
  MollieAmount: ResolverTypeWrapper<MollieAmount>;
  MollieBankDetails: ResolverTypeWrapper<MollieBankDetails>;
  MolliePaymentStatusPublic: ResolverTypeWrapper<MolliePaymentStatusPublic>;
  MollieRefundsWithPagination: ResolverTypeWrapper<MollieRefundsWithPagination>;
  MyProfileType: ResolverTypeWrapper<MyProfileType>;
  NewsletterBookerStatus: ResolverTypeWrapper<NewsletterBookerStatus>;
  NewsletterUnsubscribe: ResolverTypeWrapper<NewsletterUnsubscribe>;
  NewsletterUnsubscribeSource: NewsletterUnsubscribeSource;
  NewsletterLocationList: ResolverTypeWrapper<NewsletterLocationList>;
  NewsletterLog: ResolverTypeWrapper<NewsletterLog>;
  NewsletterLogKind: NewsletterLogKind;
  NewsletterOverviewResult: ResolverTypeWrapper<NewsletterOverviewResult>;
  NewsletterRecipientCount: ResolverTypeWrapper<NewsletterRecipientCount>;
  NewsletterRulesInput: NewsletterRulesInput;
  NewsletterAssignment: NewsletterAssignment;
  NewsletterListRule: NewsletterListRule;
  NewsletterRulesPreview: ResolverTypeWrapper<NewsletterRulesPreview>;
  NewsletterSettings: ResolverTypeWrapper<NewsletterSettings>;
  ScheduledPaymentsWithPagination: ResolverTypeWrapper<ScheduledPaymentsWithPagination>;
  Payment: ResolverTypeWrapper<Payment>;
  SwissQRFile: ResolverTypeWrapper<SwissQrFile>;
  SwissQRFileRecord: ResolverTypeWrapper<SwissQrFileRecord>;
  PlatformConfig: ResolverTypeWrapper<PlatformConfig>;
  CreateCertificateTemplateInput: CreateCertificateTemplateInput;
  CertificateBlockLayoutInput: CertificateBlockLayoutInput;
  CertificateBlockAlignmentsInput: CertificateBlockAlignmentsInput;
  CertificateBlockSpacingInput: CertificateBlockSpacingInput;
  CertificateDocFieldsInput: CertificateDocFieldsInput;
  CertificateDocTextInput: CertificateDocTextInput;
  CertificateAlignInput: CertificateAlignInput;
  CertificateLetterFieldsInput: CertificateLetterFieldsInput;
  CertificateSignerInput: CertificateSignerInput;
  CertificateSizesInput: CertificateSizesInput;
  CertificateTemplateVisibilityInput: CertificateTemplateVisibilityInput;
  SettledBookingCorrectionInput: SettledBookingCorrectionInput;
  CorrectionRefundMode: CorrectionRefundMode;
  SettledBookingCorrectionPreview: ResolverTypeWrapper<SettledBookingCorrectionPreview>;
  InstallmentChangePreview: ResolverTypeWrapper<InstallmentChangePreview>;
  InstallmentChangeType: InstallmentChangeType;
  RenderBatchLetterPdfForBookingsInput: RenderBatchLetterPdfForBookingsInput;
  RenderedBatchLetterPdfData: ResolverTypeWrapper<RenderedBatchLetterPdfData>;
  RenderedLetterPdfData: ResolverTypeWrapper<RenderedLetterPdfData>;
  LetterPdfCourseDetails: ResolverTypeWrapper<LetterPdfCourseDetails>;
  RenderBatchLetterPdfForCourseInput: RenderBatchLetterPdfForCourseInput;
  RenderTemplateForLetterPdfInput: RenderTemplateForLetterPdfInput;
  TextBlockPreviewInput: TextBlockPreviewInput;
  TextBlockPreviewResult: ResolverTypeWrapper<TextBlockPreviewResult>;
  TextBlockPreviewCurrent: ResolverTypeWrapper<TextBlockPreviewCurrent>;
  TextBlockPreviewRecipient: ResolverTypeWrapper<TextBlockPreviewRecipient>;
  TextBlockPreviewSummary: ResolverTypeWrapper<TextBlockPreviewSummary>;
  TenantRecipientType: ResolverTypeWrapper<TenantRecipientType>;
  ReversalInvoiceWithPagination: ResolverTypeWrapper<ReversalInvoiceWithPagination>;
  ScheduledPaymentSummary: ResolverTypeWrapper<ScheduledPaymentSummary>;
  ScheduledPaymentSummaryPart: ResolverTypeWrapper<ScheduledPaymentSummaryPart>;
  CourseHistoryFilterInput: CourseHistoryFilterInput;
  CourseHistoryPaginationInput: CourseHistoryPaginationInput;
  CourseHistoryWithPagination: ResolverTypeWrapper<CourseHistoryWithPagination>;
  SettingEndUserAppHistory: ResolverTypeWrapper<SettingEndUserAppHistory>;
  SharedLoginStaff: ResolverTypeWrapper<SharedLoginStaff>;
  StaffVisibilityRules: ResolverTypeWrapper<StaffVisibilityRules>;
  StaffVisibilityRow: ResolverTypeWrapper<StaffVisibilityRow>;
  StaffVisibilityLevel: StaffVisibilityLevel;
  StaffVisibilityRulesHistoryEntry: ResolverTypeWrapper<StaffVisibilityRulesHistoryEntry>;
  SwissQRFileOverviewWithPagination: ResolverTypeWrapper<SwissQrFileOverviewWithPagination>;
  SwissQRFileOverview: ResolverTypeWrapper<SwissQrFileOverview>;
  SwissQRRecordContext: ResolverTypeWrapper<SwissQrRecordContext>;
  SwissQRRecordContextEvent: ResolverTypeWrapper<SwissQrRecordContextEvent>;
  SwissQRRecordContextRate: ResolverTypeWrapper<SwissQrRecordContextRate>;
  Template: ResolverTypeWrapper<Template>;
  TemplatesWithPagination: ResolverTypeWrapper<TemplatesWithPagination>;
  TenantActivitySummary: ResolverTypeWrapper<TenantActivitySummary>;
  TenantDeletionImpact: ResolverTypeWrapper<TenantDeletionImpact>;
  EntityCount: ResolverTypeWrapper<EntityCount>;
  TenantDeletionStatus: ResolverTypeWrapper<TenantDeletionStatus>;
  TenantMetrics: ResolverTypeWrapper<TenantMetrics>;
  TenantMetricsAiSummary: ResolverTypeWrapper<TenantMetricsAiSummary>;
  TenantMetricsAiInsight: ResolverTypeWrapper<TenantMetricsAiInsight>;
  TenantMetricsAiEvidence: ResolverTypeWrapper<TenantMetricsAiEvidence>;
  TenantMetricsAiSummaryStatus: TenantMetricsAiSummaryStatus;
  TenantNotification: ResolverTypeWrapper<TenantNotification>;
  TenantNotificationStatus: TenantNotificationStatus;
  TenantSeatUsage: ResolverTypeWrapper<TenantSeatUsage>;
  TenantStaffMember: ResolverTypeWrapper<TenantStaffMember>;
  KoOrganizationWithPagination: ResolverTypeWrapper<KoOrganizationWithPagination>;
  TransferBulkPlanInput: TransferBulkPlanInput;
  TransferOldBookingOption: TransferOldBookingOption;
  TransferPriceOptionInput: TransferPriceOptionInput;
  TransferPriceKind: TransferPriceKind;
  TransferBulkPlanPreview: ResolverTypeWrapper<TransferBulkPlanPreview>;
  TransferBulkPlanRow: ResolverTypeWrapper<TransferBulkPlanRow>;
  TransferPlanPreview: ResolverTypeWrapper<TransferPlanPreview>;
  TransferAttendedLessonsPreview: ResolverTypeWrapper<TransferAttendedLessonsPreview>;
  TransferCarriedOverItem: ResolverTypeWrapper<TransferCarriedOverItem>;
  TransferCommunicationDefaults: ResolverTypeWrapper<TransferCommunicationDefaults>;
  TransferCutoffPreview: ResolverTypeWrapper<TransferCutoffPreview>;
  TransferCutoffRatePreview: ResolverTypeWrapper<TransferCutoffRatePreview>;
  TransferItemReview: ResolverTypeWrapper<TransferItemReview>;
  TransferOldBookingPlan: ResolverTypeWrapper<TransferOldBookingPlan>;
  TransferOldBookingTreatment: TransferOldBookingTreatment;
  TransferOldBookingOptionPreview: ResolverTypeWrapper<TransferOldBookingOptionPreview>;
  TransferPartialSourcePreview: ResolverTypeWrapper<TransferPartialSourcePreview>;
  TransferPriceOptionPreview: ResolverTypeWrapper<TransferPriceOptionPreview>;
  TransferPlannedRate: ResolverTypeWrapper<TransferPlannedRate>;
  TransferSurplusHandlingPreview: ResolverTypeWrapper<TransferSurplusHandlingPreview>;
  TransferSurplusHandling: TransferSurplusHandling;
  TransferSurplusMollieRefundPreview: ResolverTypeWrapper<TransferSurplusMollieRefundPreview>;
  TransferSurplusRefundPayment: ResolverTypeWrapper<TransferSurplusRefundPayment>;
  TransferPlanInput: TransferPlanInput;
  TransferCreditedBalanceHandling: TransferCreditedBalanceHandling;
  TransferItemDecisionInput: TransferItemDecisionInput;
  TransferSurplusHandlingInput: TransferSurplusHandlingInput;
  WithdrawalRequest: ResolverTypeWrapper<WithdrawalRequest>;
  WithdrawalStatus: WithdrawalStatus;
  Mutation: ResolverTypeWrapper<{}>;
  SetupScriptResult: ResolverTypeWrapper<SetupScriptResult>;
  NewTemplateInput: NewTemplateInput;
  AddNamedScheduledPaymentInput: AddNamedScheduledPaymentInput;
  NewPageInput: NewPageInput;
  SepaDebitIntput: SepaDebitIntput;
  LessonBookingPlanFingerprintInput: LessonBookingPlanFingerprintInput;
  AssignAmbiguousPaymentDistributionInput: AssignAmbiguousPaymentDistributionInput;
  AssignAreaManagerLocationsInput: AssignAreaManagerLocationsInput;
  AssignAssistantInput: AssignAssistantInput;
  AssignInstructorToLessonInput: AssignInstructorToLessonInput;
  AutoMergeInput: AutoMergeInput;
  AutoMergeStartResult: ResolverTypeWrapper<AutoMergeStartResult>;
  AutoMergeDryRunInput: AutoMergeDryRunInput;
  AutoMergeDryRunResult: ResolverTypeWrapper<AutoMergeDryRunResult>;
  AutoMergeDryRunPair: ResolverTypeWrapper<AutoMergeDryRunPair>;
  BroadcastTenantNotificationInput: BroadcastTenantNotificationInput;
  Attachment: Attachment;
  TenantRecipientInput: TenantRecipientInput;
  BroadcastTenantNotificationResult: ResolverTypeWrapper<BroadcastTenantNotificationResult>;
  TenantNotificationResultType: ResolverTypeWrapper<TenantNotificationResultType>;
  BulkCreateAttendeeBadgeInput: BulkCreateAttendeeBadgeInput;
  BulkToggleAttendeeBadgeRequirementInput: BulkToggleAttendeeBadgeRequirementInput;
  CancelBookingOptionsInput: CancelBookingOptionsInput;
  CancelFeeDecisionInput: CancelFeeDecisionInput;
  CancelRestHandling: CancelRestHandling;
  MolliePaymentResult: ResolverTypeWrapper<MolliePaymentResult>;
  BankTransactionDistributionInput: BankTransactionDistributionInput;
  Sms77FormatApiResponse: ResolverTypeWrapper<Sms77FormatApiResponse>;
  CreateAdminManagementUserInput: CreateAdminManagementUserInput;
  UserInput: UserInput;
  ThirdPartyUserInput: ThirdPartyUserInput;
  BookerInput: BookerInput;
  BookerAttendeeInput: BookerAttendeeInput;
  NewAttendeeBadgeInput: NewAttendeeBadgeInput;
  BookerAttendeeBookingInput: BookerAttendeeBookingInput;
  BaseInput: BaseInput;
  NewBookingsKo9Input: NewBookingsKo9Input;
  BookerPaymentMethodInput: BookerPaymentMethodInput;
  CreateAnnouncementInput: CreateAnnouncementInput;
  CreateAttendanceListBulkByInstructorInput: CreateAttendanceListBulkByInstructorInput;
  BulkJobResult: ResolverTypeWrapper<BulkJobResult>;
  CreateAttendanceListBulkByLocationInput: CreateAttendanceListBulkByLocationInput;
  NewAttendeeBadgeByBadgeNameInput: NewAttendeeBadgeByBadgeNameInput;
  NewBadgeInput: NewBadgeInput;
  BadgeRequirementInlineInput: BadgeRequirementInlineInput;
  NewBadgeGroupInput: NewBadgeGroupInput;
  CreateBillingAddressTemplateInput: CreateBillingAddressTemplateInput;
  NewBookingInput: NewBookingInput;
  NewBookingRestrictionInput: NewBookingRestrictionInput;
  NewBookingInputBookableLessons: NewBookingInputBookableLessons;
  NewCourseInput: NewCourseInput;
  NewCoursePriceInput: NewCoursePriceInput;
  CreateInstallmentRateByCourseCreateInput: CreateInstallmentRateByCourseCreateInput;
  NewCourseLessonInput: NewCourseLessonInput;
  NewCourseCategoryInput: NewCourseCategoryInput;
  NewCourseLessonBookingInput: NewCourseLessonBookingInput;
  NewCourseTypeInput: NewCourseTypeInput;
  UpdateParticipationPrerequisitesInput: UpdateParticipationPrerequisitesInput;
  OptionalInputFieldsInput: OptionalInputFieldsInput;
  NewCustomBankDataInput: NewCustomBankDataInput;
  DiscountCodeInput: DiscountCodeInput;
  CreateDummySwissCamtByScheduledPaymentsInput: CreateDummySwissCamtByScheduledPaymentsInput;
  CamtScheduledPaymentInput: CamtScheduledPaymentInput;
  CreateDunningInput: CreateDunningInput;
  CreateFeeLetterInput: CreateFeeLetterInput;
  NewInstallmentRateInput: NewInstallmentRateInput;
  CreateInstructorInvoiceInput: CreateInstructorInvoiceInput;
  CreateInterestListInput: CreateInterestListInput;
  InterestListTimeSlotInput: InterestListTimeSlotInput;
  CreateInterestRegistrationInput: CreateInterestRegistrationInput;
  InvoiceInput: InvoiceInput;
  BookingWithCourseLessons: ResolverTypeWrapper<BookingWithCourseLessons>;
  NewLocationInput: NewLocationInput;
  GeneralLocationContactInput: GeneralLocationContactInput;
  LocationContactIdInput: LocationContactIdInput;
  NewVenueInput: NewVenueInput;
  RentType: RentType;
  NewLocationContactInput: NewLocationContactInput;
  CreateMailjetSenderInput: CreateMailjetSenderInput;
  EmailTypeEnum: EmailTypeEnum;
  CreateMailjetSenderOutput: ResolverTypeWrapper<CreateMailjetSenderOutput>;
  KoOrganizationInputType: KoOrganizationInputType;
  TenantAdminInput: TenantAdminInput;
  CreateOrganizationResult: ResolverTypeWrapper<CreateOrganizationResult>;
  NewParticipationPrerequisitesInput: NewParticipationPrerequisitesInput;
  CreateSingleSepaXmlInput: CreateSingleSepaXmlInput;
  CreateSepaXmlByTimeRangeInput: CreateSepaXmlByTimeRangeInput;
  SettingEndUserAppInput: SettingEndUserAppInput;
  ColorsInput: ColorsInput;
  CourseDetailsInput: CourseDetailsInput;
  CourseTableInput: CourseTableInput;
  FiltersInput: FiltersInput;
  TextEntriesInput: TextEntriesInput;
  CreateWithdrawalEndUserAppInput: CreateWithdrawalEndUserAppInput;
  WithdrawalEndUserAppResult: ResolverTypeWrapper<WithdrawalEndUserAppResult>;
  DismissDuplicatePairInput: DismissDuplicatePairInput;
  MaintenanceEnableInput: MaintenanceEnableInput;
  ErasureReportType: ResolverTypeWrapper<ErasureReportType>;
  ErasureCounterType: ResolverTypeWrapper<ErasureCounterType>;
  ErasureLinkedBookerType: ResolverTypeWrapper<ErasureLinkedBookerType>;
  ErasureWarningType: ResolverTypeWrapper<ErasureWarningType>;
  ExecuteBulkTransferInput: ExecuteBulkTransferInput;
  TransferCommunicationInput: TransferCommunicationInput;
  TransferBulkRowExpectationInput: TransferBulkRowExpectationInput;
  TransferCarriedOverItemInput: TransferCarriedOverItemInput;
  ExecuteBulkTransferResult: ResolverTypeWrapper<ExecuteBulkTransferResult>;
  ExecuteBulkTransferRowResult: ResolverTypeWrapper<ExecuteBulkTransferRowResult>;
  TransferInvoiceRef: ResolverTypeWrapper<TransferInvoiceRef>;
  TransferSurplusOutcome: ResolverTypeWrapper<TransferSurplusOutcome>;
  TransferSurplusRefundResult: ResolverTypeWrapper<TransferSurplusRefundResult>;
  SettledBookingCorrectionResult: ResolverTypeWrapper<SettledBookingCorrectionResult>;
  ExecuteTransferInput: ExecuteTransferInput;
  TransferSourceDeleteActionInput: TransferSourceDeleteActionInput;
  BookingDeleteActionType: BookingDeleteActionType;
  ExecuteTransferResult: ResolverTypeWrapper<ExecuteTransferResult>;
  ForgotPasswordWithStateInput: ForgotPasswordWithStateInput;
  ResetPasswordStateType: ResetPasswordStateType;
  PasswordResetLinkType: ResolverTypeWrapper<PasswordResetLinkType>;
  ScheduledPaymentSimpleInput: ScheduledPaymentSimpleInput;
  ScheduledPaymentPreview: ResolverTypeWrapper<ScheduledPaymentPreview>;
  ScheduledPaymentSimple: ResolverTypeWrapper<ScheduledPaymentSimple>;
  TenantDeletionResult: ResolverTypeWrapper<TenantDeletionResult>;
  ImportBookersInput: ImportBookersInput;
  ImportBookerInput: ImportBookerInput;
  NewsletterUnsubscribeImportResult: ResolverTypeWrapper<NewsletterUnsubscribeImportResult>;
  IssueCertificateInput: IssueCertificateInput;
  IssueCertificatesByAttendeesInput: IssueCertificatesByAttendeesInput;
  IssueCertificatesByCourseInput: IssueCertificatesByCourseInput;
  Ko9DbCredentialsInput: Ko9DbCredentialsInput;
  Ko9SchemaInfoType: ResolverTypeWrapper<Ko9SchemaInfoType>;
  Ko9ImportConfigInput: Ko9ImportConfigInput;
  Ko9PreviewResultType: ResolverTypeWrapper<Ko9PreviewResultType>;
  Ko9PreviewRowType: ResolverTypeWrapper<Ko9PreviewRowType>;
  Ko9RollbackResultType: ResolverTypeWrapper<Ko9RollbackResultType>;
  Ko9SaveResult: ResolverTypeWrapper<Ko9SaveResult>;
  Ko9ConnectionTestResult: ResolverTypeWrapper<Ko9ConnectionTestResult>;
  LoggingInput: LoggingInput;
  LogLevelType: LogLevelType;
  PasswordLoginInputType: PasswordLoginInputType;
  MarkPaidFromSepaInput: MarkPaidFromSepaInput;
  AttendeeMergeFieldsInput: AttendeeMergeFieldsInput;
  AttendeeMergeResult: ResolverTypeWrapper<AttendeeMergeResult>;
  ModifyScheduledPaymentInput: ModifyScheduledPaymentInput;
  MollieCreateClientLinkInput: MollieCreateClientLinkInput;
  MollieClientLinkAddressInput: MollieClientLinkAddressInput;
  MollieClientLinkOwnerInput: MollieClientLinkOwnerInput;
  MollieCreateClientLinkResult: ResolverTypeWrapper<MollieCreateClientLinkResult>;
  PasswordlessLoginInputType: PasswordlessLoginInputType;
  EndUserPasswordlessLoginInputType: EndUserPasswordlessLoginInputType;
  RecordExternalPaymentForScheduledPaymentInput: RecordExternalPaymentForScheduledPaymentInput;
  BankTransactionRecordAllResult: ResolverTypeWrapper<BankTransactionRecordAllResult>;
  BankImportRematchAllResult: ResolverTypeWrapper<BankImportRematchAllResult>;
  RemoveAdminManagementUserInput: RemoveAdminManagementUserInput;
  BookingDeleteAction: BookingDeleteAction;
  EndUserEventInput: EndUserEventInput;
  CheckoutBlockerCode: CheckoutBlockerCode;
  EndUserEventCourseFilterInput: EndUserEventCourseFilterInput;
  EndUserEventStep: EndUserEventStep;
  EndUserReportedEventType: EndUserReportedEventType;
  ResetScheduledPaymentsOfCourseResult: ResolverTypeWrapper<ResetScheduledPaymentsOfCourseResult>;
  ResetScheduledPaymentsOfBookingResult: ResolverTypeWrapper<ResetScheduledPaymentsOfBookingResult>;
  Rate: ResolverTypeWrapper<Rate>;
  RateDetail: ResolverTypeWrapper<RateDetail>;
  ResetPaymentPlanOfInvoicedLessonBookingResult: ResolverTypeWrapper<ResetPaymentPlanOfInvoicedLessonBookingResult>;
  ResetPaymentPlanBlockedReason: ResetPaymentPlanBlockedReason;
  ResetPaymentPlanRateSnapshot: ResolverTypeWrapper<ResetPaymentPlanRateSnapshot>;
  RestoreBackupInput: RestoreBackupInput;
  MollieManualReconciliationResult: ResolverTypeWrapper<MollieManualReconciliationResult>;
  SaveAdminInput: SaveAdminInput;
  Admin: ResolverTypeWrapper<Admin>;
  SaveInstructorInput: SaveInstructorInput;
  AssignedLocationIdInput: AssignedLocationIdInput;
  SendAttendanceListArchiveInput: SendAttendanceListArchiveInput;
  SendArchiveRecipientInput: SendArchiveRecipientInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  BlankMailInputTypes: BlankMailInputTypes;
  BlankMailReceiversInput: BlankMailReceiversInput;
  BlankMailTypes: BlankMailTypes;
  SendMailToSelectionOfCourseInput: SendMailToSelectionOfCourseInput;
  SendTemplateInput: SendTemplateInput;
  EmailData: EmailData;
  MailjetEmailTemplates: MailjetEmailTemplates;
  SendParamsMessageInput: SendParamsMessageInput;
  SendParamsRecipient: SendParamsRecipient;
  InlinedAttachment: InlinedAttachment;
  MailjetVariables: MailjetVariables;
  KeyValue: KeyValue;
  SendMailToSelectionOfAttendeesInput: SendMailToSelectionOfAttendeesInput;
  SendMailToSelectionOfBookersInput: SendMailToSelectionOfBookersInput;
  SendMailToSelectionOfScheduledPaymentsInput: SendMailToSelectionOfScheduledPaymentsInput;
  SendMailToSelectionOfStaffInput: SendMailToSelectionOfStaffInput;
  SendInvoicesToSelectionOfBookingInput: SendInvoicesToSelectionOfBookingInput;
  SendMailToSelectionOfBookingInput: SendMailToSelectionOfBookingInput;
  SendPasswordResetLinkEmailInput: SendPasswordResetLinkEmailInput;
  SendSmsInput: SendSmsInput;
  Sms77JsonResponse: ResolverTypeWrapper<Sms77JsonResponse>;
  Sms77Message: ResolverTypeWrapper<Sms77Message>;
  BankCounterpartKind: BankCounterpartKind;
  SetDunningPauseInput: SetDunningPauseInput;
  SupportReportInput: SupportReportInput;
  SupportReportKind: SupportReportKind;
  ThirdPartyLoginInput: ThirdPartyLoginInput;
  ToggleAreaManagerRoleInput: ToggleAreaManagerRoleInput;
  ToggleAttendeeBadgeRequirementInput: ToggleAttendeeBadgeRequirementInput;
  ToggleUserRoleInput: ToggleUserRoleInput;
  TransferMultipleBookingsInput: TransferMultipleBookingsInput;
  TransferBookingInput: TransferBookingInput;
  UpdateAdminManagementUserEmailInput: UpdateAdminManagementUserEmailInput;
  UpdateAdminManagementUserNameInput: UpdateAdminManagementUserNameInput;
  UpdateAnnouncementInput: UpdateAnnouncementInput;
  UpdateAttendanceListSettingsInput: UpdateAttendanceListSettingsInput;
  AttendanceListFontSize: AttendanceListFontSize;
  EditAttendeeBadgeInput: EditAttendeeBadgeInput;
  UpdateBadgeInput: UpdateBadgeInput;
  UpdateBadgeGroupInput: UpdateBadgeGroupInput;
  UpdateBillingAddressTemplateInput: UpdateBillingAddressTemplateInput;
  UpdateBookerAccountEndUserAppInput: UpdateBookerAccountEndUserAppInput;
  EditBookingInput: EditBookingInput;
  UpdateBookingRestrictionInput: UpdateBookingRestrictionInput;
  UpdateCertificateTemplateInput: UpdateCertificateTemplateInput;
  CompanySettingInput: CompanySettingInput;
  LogoInput: LogoInput;
  EditCourseInput: EditCourseInput;
  UpdateCourseAndBookingsResult: ResolverTypeWrapper<UpdateCourseAndBookingsResult>;
  CourseLessonBookingsPreview: ResolverTypeWrapper<CourseLessonBookingsPreview>;
  UpdateCourseLessonBookingInput: UpdateCourseLessonBookingInput;
  LessonInstructorScope: LessonInstructorScope;
  UpdateCustomBankDataInput: UpdateCustomBankDataInput;
  HolidayInput: HolidayInput;
  DiscountCodeUpdateInput: DiscountCodeUpdateInput;
  UpdateInterestListInput: UpdateInterestListInput;
  UpdateInterestRegistrationInput: UpdateInterestRegistrationInput;
  EditInvoiceInput: EditInvoiceInput;
  UpdateInvoiceTemplateSetInput: UpdateInvoiceTemplateSetInput;
  UpdateLateEntryPricingConfigurationInput: UpdateLateEntryPricingConfigurationInput;
  EditLocationInput: EditLocationInput;
  EditVenueInput: EditVenueInput;
  EditLocationContactInput: EditLocationContactInput;
  EditScheduledPaymentInput: EditScheduledPaymentInput;
  UpdateBookerIdMissmatchesInput: UpdateBookerIdMissmatchesInput;
  UpdateMyProfileInput: UpdateMyProfileInput;
  NewsletterSettingsInput: NewsletterSettingsInput;
  EditPageInput: EditPageInput;
  UpdatePaymentMethodInput: UpdatePaymentMethodInput;
  UpdateSettingEndUserAppInput: UpdateSettingEndUserAppInput;
  SettingInput: SettingInput;
  MollieInvoiceSendMode: MollieInvoiceSendMode;
  MollieRefundMode: MollieRefundMode;
  VatAppearance: VatAppearance;
  StaffVisibilityRulesInput: StaffVisibilityRulesInput;
  StaffVisibilityRowInput: StaffVisibilityRowInput;
  SubscriptionFeaturesInput: SubscriptionFeaturesInput;
  UpdateTableColumnSettingsInput: UpdateTableColumnSettingsInput;
  UpdateWithdrawalStatusInput: UpdateWithdrawalStatusInput;
  BundesbankImportResult: ResolverTypeWrapper<BundesbankImportResult>;
  UploadedContentImage: ResolverTypeWrapper<UploadedContentImage>;
  UploadMetadataInput: UploadMetadataInput;
  UpsertAttendeeBadgesWithRequirementsInput: UpsertAttendeeBadgesWithRequirementsInput;
  AttendeeBadgeAssignmentInput: AttendeeBadgeAssignmentInput;
  AttendeeRequirementFulfillmentInput: AttendeeRequirementFulfillmentInput;
  UserSettingsInputTypes: UserSettingsInputTypes;
  VoidPaymentLinkResult: ResolverTypeWrapper<VoidPaymentLinkResult>;
  AddPaymentMethodInput: AddPaymentMethodInput;
  AnalyticsParams: AnalyticsParams;
  AutoMergeRun: ResolverTypeWrapper<AutoMergeRun>;
  Base: ResolverTypeWrapper<Base>;
  BaseLookupInput: BaseLookupInput;
  LookupType: LookupType;
  BasicEmailVariables: BasicEmailVariables;
  BookableOptions: ResolverTypeWrapper<BookableOptions>;
  BookableOptionsError: BookableOptionsError;
  BookableOptionsResult: ResolverTypeWrapper<BookableOptionsResult>;
  BookerCustomerInput: BookerCustomerInput;
  BookerCustomerUpdateInput: BookerCustomerUpdateInput;
  BookingHistoryWithPagination: ResolverTypeWrapper<BookingHistoryWithPagination>;
  BookingOptions: BookingOptions;
  BookingRestrictionError: ResolverTypeWrapper<BookingRestrictionError>;
  BookingWithPaymentAction: ResolverTypeWrapper<BookingWithPaymentAction>;
  MolliePaymentAction: ResolverTypeWrapper<MolliePaymentAction>;
  CamtGeneratorInput: CamtGeneratorInput;
  CamtGeneratorTransactionInput: CamtGeneratorTransactionInput;
  CheckboxItemInput: CheckboxItemInput;
  CourseDetailsLessonBookings: ResolverTypeWrapper<CourseDetailsLessonBookings>;
  CourseIdInput: CourseIdInput;
  CourseLessonBookingAttendanceList: ResolverTypeWrapper<CourseLessonBookingAttendanceList>;
  CourseLessonIdInput: CourseLessonIdInput;
  CoursePriceIdInput: CoursePriceIdInput;
  CourseWithPaginationWithEnabledCourses: ResolverTypeWrapper<CourseWithPaginationWithEnabledCourses>;
  CreateMultipleSepaXmlInput: CreateMultipleSepaXmlInput;
  CreatePrefixedCourseNumberInput: CreatePrefixedCourseNumberInput;
  DetailsCheckboxInput: DetailsCheckboxInput;
  DuplicateMatch: ResolverTypeWrapper<DuplicateMatch>;
  ForgotPasswordInput: ForgotPasswordInput;
  ForgotPasswordWithApiKeyInput: ForgotPasswordWithApiKeyInput;
  GetBookableOptionsInput: GetBookableOptionsInput;
  Ko9ImportCredentials: ResolverTypeWrapper<Ko9ImportCredentials>;
  LessonBookingScheduledPaymentPreviewInput: LessonBookingScheduledPaymentPreviewInput;
  MailReplacementData: MailReplacementData;
  MailSentStatus: MailSentStatus;
  MollieConnection: ResolverTypeWrapper<MollieConnection>;
  NewLessonBookingInput: NewLessonBookingInput;
  NewMultipleLessonBookingInput: NewMultipleLessonBookingInput;
  NewNotificationInput: NewNotificationInput;
  PostInputTo: PostInputTo;
  NewSepaXmlInput: NewSepaXmlInput;
  SepaXmlPositionInput: SepaXmlPositionInput;
  SepaXmlPaymentInput: SepaXmlPaymentInput;
  PageContentInput: PageContentInput;
  PaymentInput: PaymentInput;
  PricingParams: PricingParams;
  SecureIdentity: ResolverTypeWrapper<SecureIdentity>;
  Sms77AnalyticBase: ResolverTypeWrapper<Sms77AnalyticBase>;
  Sms77JournalBase: ResolverTypeWrapper<Sms77JournalBase>;
  StaffLogin: ResolverTypeWrapper<StaffLogin>;
  TableColumnsInput: TableColumnsInput;
  TenantDeletionLog: ResolverTypeWrapper<TenantDeletionLog>;
  UploadFileInput: UploadFileInput;
  WithEnabledCourse: ResolverTypeWrapper<WithEnabledCourse>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {};
  String: Scalars['String'];
  AccountForEmail: AccountForEmail;
  Boolean: Scalars['Boolean'];
  AccountForEmailLinkedBooker: AccountForEmailLinkedBooker;
  ID: Scalars['ID'];
  AccountLinks: AccountLinks;
  AccountLinksStaff: AccountLinksStaff;
  Announcement: Announcement;
  DateTime: Scalars['DateTime'];
  ActiveDunning: ActiveDunning;
  Float: Scalars['Float'];
  AdminManagementEmailInfo: AdminManagementEmailInfo;
  AdminManagementOverview: AdminManagementOverview;
  Int: Scalars['Int'];
  AdminManagementUser: AdminManagementUser;
  GetAnnouncementsInput: GetAnnouncementsInput;
  InstructorCourseGroup: InstructorCourseGroup;
  AttendanceListArchive: AttendanceListArchive;
  BulkJobStatus: BulkJobStatus;
  Booking: Booking;
  Attendee: Attendee;
  AttendeeBadge: AttendeeBadge;
  AttendeeBadgeRequirement: AttendeeBadgeRequirement;
  BadgeRequirement: BadgeRequirement;
  Badge: Badge;
  Booker: Booker;
  UserType: UserType;
  Customer: Customer;
  PaymentMethod: PaymentMethod;
  ScheduledPayment: ScheduledPayment;
  ScheduledPaymentMethodChangeUser: ScheduledPaymentMethodChangeUser;
  BookingDunningStatus: BookingDunningStatus;
  Invoice: Invoice;
  KoOrganization: KoOrganization;
  CompanySetting: CompanySetting;
  Setting: Setting;
  Subscription: {};
  LatestMollieAttemptBadge: LatestMollieAttemptBadge;
  BookingsKo9: BookingsKo9;
  Course: Course;
  CourseAdditionalItem: CourseAdditionalItem;
  CourseBookingPriceQuote: CourseBookingPriceQuote;
  BookingRestriction: BookingRestriction;
  CoursePrice: CoursePrice;
  CourseType: CourseType;
  CourseCategory: CourseCategory;
  ParticipationPrerequisites: ParticipationPrerequisites;
  JSONObject: Scalars['JSONObject'];
  EnabledCourse: EnabledCourse;
  CourseVisibilityResult: CourseVisibilityResult;
  CourseVisibilityRestriction: CourseVisibilityRestriction;
  InstallmentRate: InstallmentRate;
  Instructor: Instructor;
  Location: Location;
  GeneralLocationContact: GeneralLocationContact;
  CourseLesson: CourseLesson;
  CourseLessonAssistant: CourseLessonAssistant;
  CourseLessonBooking: CourseLessonBooking;
  InstructorInvoice: InstructorInvoice;
  Venue: Venue;
  LocationContact: LocationContact;
  Staff: Staff;
  BookingHistory: BookingHistory;
  UserDetailsType: UserDetailsType;
  InstructorDetailsView: InstructorDetailsView;
  LoginAttempt: LoginAttempt;
  RecentLoginEntry: RecentLoginEntry;
  UserSetting: UserSetting;
  DiscountCode: DiscountCode;
  EmailNotification: EmailNotification;
  MessageStatus: MessageStatus;
  MessageStatusData: MessageStatusData;
  MessageHistory: MessageHistory;
  MessageHistoryData: MessageHistoryData;
  MolliePaymentAttempt: MolliePaymentAttempt;
  Chargeback: Chargeback;
  MollieRefund: MollieRefund;
  ReversalInvoice: ReversalInvoice;
  BookingTransferIn: BookingTransferIn;
  ArrayDataOptions: ArrayDataOptions;
  FilterOption: FilterOption;
  AttendeeMergeHistory: AttendeeMergeHistory;
  AttendeeWithPagination: AttendeeWithPagination;
  BadgeGroup: BadgeGroup;
  BankCollectionRun: BankCollectionRun;
  BankImportFile: BankImportFile;
  BankTransaction: BankTransaction;
  BankTransactionCandidate: BankTransactionCandidate;
  BankTransactionSearchHit: BankTransactionSearchHit;
  BankTransactionsFilterInput: BankTransactionsFilterInput;
  BankTransactionsPage: BankTransactionsPage;
  BillingAddressTemplate: BillingAddressTemplate;
  BookerDeletionProgressType: BookerDeletionProgressType;
  BookerMergeHistory: BookerMergeHistory;
  BookerWithPagination: BookerWithPagination;
  BookingEligibilityCandidate: BookingEligibilityCandidate;
  BookingEligibilityDiagnosis: BookingEligibilityDiagnosis;
  EligibilityCheck: EligibilityCheck;
  PrerequisiteLinkVisibility: PrerequisiteLinkVisibility;
  BookingWithPagination: BookingWithPagination;
  BundesbankImportInfo: BundesbankImportInfo;
  CertificateIssuePreflightInput: CertificateIssuePreflightInput;
  CertificateIssuePreflightResult: CertificateIssuePreflightResult;
  CertificateIssuePreflightAttendee: CertificateIssuePreflightAttendee;
  CertificateTemplate: CertificateTemplate;
  CertificateBlockLayout: CertificateBlockLayout;
  CertificateBlockAlignments: CertificateBlockAlignments;
  CertificateBlockSpacing: CertificateBlockSpacing;
  CertificateDocFields: CertificateDocFields;
  CertificateDocText: CertificateDocText;
  CertificateAlign: CertificateAlign;
  CertificateLetterFields: CertificateLetterFields;
  CertificateSigner: CertificateSigner;
  CertificateSizes: CertificateSizes;
  CertificateTemplateVisibility: CertificateTemplateVisibility;
  AttendeesAgeAtCourseStart: AttendeesAgeAtCourseStart;
  DiscountCodeCheckResult: DiscountCodeCheckResult;
  SmsBalanceResponse: SmsBalanceResponse;
  LocationCity: LocationCity;
  CourseDetails: CourseDetails;
  CourseHistory: CourseHistory;
  BillingStatusCoursLessons: BillingStatusCoursLessons;
  ChronologicalLessonsResult: ChronologicalLessonsResult;
  CourseLessonForBillingStatusInput: CourseLessonForBillingStatusInput;
  BillingStatusByInstructor: BillingStatusByInstructor;
  BillingStatusByInstructorWithCourseGroups: BillingStatusByInstructorWithCourseGroups;
  CourseSummaryForBilling: CourseSummaryForBilling;
  CourseLessonWithPagination: CourseLessonWithPagination;
  CollitionCheckInput: CollitionCheckInput;
  CourseLessonWithIndexOfCourseLessonInCourse: CourseLessonWithIndexOfCourseLessonInCourse;
  FilterExpressionInput: FilterExpressionInput;
  FilterInput: FilterInput;
  CourseWithPagination: CourseWithPagination;
  CourseListFilters: CourseListFilters;
  CourseTypeWithPagination: CourseTypeWithPagination;
  CreditEntry: CreditEntry;
  CustomBankData: CustomBankData;
  CustomerTimelineEntry: CustomerTimelineEntry;
  Holiday: Holiday;
  InvoiceTemplateSet: InvoiceTemplateSet;
  DunningPause: DunningPause;
  DunningProposal: DunningProposal;
  DunningProposalItem: DunningProposalItem;
  Dunning: Dunning;
  EmailNotificationWithPagination: EmailNotificationWithPagination;
  ExportedSepaXml: ExportedSepaXml;
  ExportedSepaXmlWithPagination: ExportedSepaXmlWithPagination;
  FaUser: FaUser;
  UserRegistration: UserRegistration;
  FeeLetterProposal: FeeLetterProposal;
  FeeLetterItem: FeeLetterItem;
  FeeLetter: FeeLetter;
  SimilarBookerResult: SimilarBookerResult;
  FindUnpaidInSepaInput: FindUnpaidInSepaInput;
  UnpaidScheduledPaymentMatchResult: UnpaidScheduledPaymentMatchResult;
  UnpaidScheduledPaymentMatch: UnpaidScheduledPaymentMatch;
  Sms77AnalyticGroupByDate: Sms77AnalyticGroupByDate;
  AreaIssue: AreaIssue;
  AreaIssueLesson: AreaIssueLesson;
  AreaIssueLocation: AreaIssueLocation;
  AreaIssuePerson: AreaIssuePerson;
  AreaManagerAssistantHierarchyResult: AreaManagerAssistantHierarchyResult;
  AreaManagerAssistantLocationGroup: AreaManagerAssistantLocationGroup;
  AreaManagerAssistantCourseGroup: AreaManagerAssistantCourseGroup;
  AreaManagerAssistantLessonsInput: AreaManagerAssistantLessonsInput;
  AreaManagerAssistantOverview: AreaManagerAssistantOverview;
  AreaManagerAssignedAssistant: AreaManagerAssignedAssistant;
  AreaManagerStatsInput: AreaManagerStatsInput;
  AreaManagerAssistantOverviewResult: AreaManagerAssistantOverviewResult;
  AreaManagerCourseStatsResult: AreaManagerCourseStatsResult;
  AreaManagerCourseStats: AreaManagerCourseStats;
  AreaManagerInstructorStatsResult: AreaManagerInstructorStatsResult;
  AreaManagerInstructorStats: AreaManagerInstructorStats;
  AreaManagerLocationStatsResult: AreaManagerLocationStatsResult;
  AreaManagerLocationStats: AreaManagerLocationStats;
  AreaManagerUpcomingLesson: AreaManagerUpcomingLesson;
  AreaManagerVenueUtilizationResult: AreaManagerVenueUtilizationResult;
  AreaManagerVenueUtilization: AreaManagerVenueUtilization;
  AreaOverviewResult: AreaOverviewResult;
  AreaOverviewPool: AreaOverviewPool;
  AreaOverviewWeek: AreaOverviewWeek;
  AreaPerson: AreaPerson;
  AreaPersonLocation: AreaPersonLocation;
  AutoMergeStatus: AutoMergeStatus;
  AutoMergeFailureType: AutoMergeFailureType;
  MollieMethodInfo: MollieMethodInfo;
  PaginationInput: PaginationInput;
  BookerAttendeeCount: BookerAttendeeCount;
  BookerIdMissmatchWithPagination: BookerIdMissmatchWithPagination;
  BookerIdMissmatch: BookerIdMissmatch;
  CacheStatsOutput: CacheStatsOutput;
  ChargebackFilterInput: ChargebackFilterInput;
  ChargebackSummary: ChargebackSummary;
  ContentOfBucket: ContentOfBucket;
  ContentOfBucketResponse: ContentOfBucketResponse;
  Content: Content;
  AssistantCourseLessonFilterInput: AssistantCourseLessonFilterInput;
  AssistantCourseLesson: AssistantCourseLesson;
  AssistantInfo: AssistantInfo;
  DownloadBackupInput: DownloadBackupInput;
  DuplicateGroupWithMetadata: DuplicateGroupWithMetadata;
  DuplicateGroupMatchInfo: DuplicateGroupMatchInfo;
  ScoreBreakdownType: ScoreBreakdownType;
  DuplicateDetectionRun: DuplicateDetectionRun;
  DuplicateException: DuplicateException;
  DuplicateMatchStats: DuplicateMatchStats;
  MjmlTemplate: MjmlTemplate;
  NewInstallmentPlanInput: NewInstallmentPlanInput;
  EditTemplateInput: EditTemplateInput;
  MailjetSenderResponse: MailjetSenderResponse;
  MailjetSender: MailjetSender;
  MailjetSenderQueryParams: MailjetSenderQueryParams;
  MissingIndexCandidateOutput: MissingIndexCandidateOutput;
  MollieKpis: MollieKpis;
  MolliePaymentFilterInput: MolliePaymentFilterInput;
  MolliePaymentsPage: MolliePaymentsPage;
  MolliePaymentTabCounts: MolliePaymentTabCounts;
  MollieRetryQueueEntry: MollieRetryQueueEntry;
  ScheduledPaymentPreviewInput: ScheduledPaymentPreviewInput;
  OnlineRegisteredBookersResult: OnlineRegisteredBookersResult;
  OnlineRegisteredBooker: OnlineRegisteredBooker;
  OnlineRegisteredBookerAttendee: OnlineRegisteredBookerAttendee;
  OpenAttendanceSummary: OpenAttendanceSummary;
  PageStructure: PageStructure;
  Page: Page;
  PageContent: PageContent;
  PaymentActionLog: PaymentActionLog;
  PerformanceStatsOutput: PerformanceStatsOutput;
  SlowQueryOutput: SlowQueryOutput;
  TableStatsOutput: TableStatsOutput;
  AssistantSelectableLocation: AssistantSelectableLocation;
  JournalParams: JournalParams;
  Sms77JournalOutbound: Sms77JournalOutbound;
  Sms77PricingResponse: Sms77PricingResponse;
  Sms77CountryPricing: Sms77CountryPricing;
  CountryNetwork: CountryNetwork;
  SmsReceiver: SmsReceiver;
  GetReceiversForCourseInput: GetReceiversForCourseInput;
  UpcomingCoursesOccupancy: UpcomingCoursesOccupancy;
  HolidayWithDays: HolidayWithDays;
  InstructorInvoicesByDateRangeInput: InstructorInvoicesByDateRangeInput;
  InstructorsWithPagination: InstructorsWithPagination;
  InterestList: InterestList;
  InterestListTimeSlot: InterestListTimeSlot;
  InterestRegistrationWithPagination: InterestRegistrationWithPagination;
  InterestRegistration: InterestRegistration;
  InvoiceWithPagination: InvoiceWithPagination;
  IssuedCertificatesFilterInput: IssuedCertificatesFilterInput;
  IssuedCertificate: IssuedCertificate;
  Ko9ImportProgressType: Ko9ImportProgressType;
  Ko9LoadedCredentials: Ko9LoadedCredentials;
  SettingEndUserApp: SettingEndUserApp;
  LessonBookingIntentInput: LessonBookingIntentInput;
  UpdateCourseAndBookingsInput: UpdateCourseAndBookingsInput;
  CourseAdditionalItemInput: CourseAdditionalItemInput;
  EditCoursePriceInput: EditCoursePriceInput;
  UpdateInstallmentRateInput: UpdateInstallmentRateInput;
  CourseInstructorIdInput: CourseInstructorIdInput;
  EditCourseLessonInput: EditCourseLessonInput;
  EditBookingInputBookableLessons: EditBookingInputBookableLessons;
  UpdateScheduledPaymentByBookingInput: UpdateScheduledPaymentByBookingInput;
  LessonBookingPlannerPreview: LessonBookingPlannerPreview;
  LessonBookingPlannerComponent: LessonBookingPlannerComponent;
  LessonBookingPlannerRate: LessonBookingPlannerRate;
  LessonBookingPlannerAdjustment: LessonBookingPlannerAdjustment;
  LessonBookingPlannerUnit: LessonBookingPlannerUnit;
  LessonBookingPlanSummary: LessonBookingPlanSummary;
  DatabaseBackup: DatabaseBackup;
  DataExport: DataExport;
  InvoiceExport: InvoiceExport;
  YearEndExport: YearEndExport;
  LocalState: LocalState;
  BookAttendees: BookAttendees;
  SelectedAttendee: SelectedAttendee;
  CreateCourse: CreateCourse;
  LocationsGroupedByCity: LocationsGroupedByCity;
  LocationGroupedByCityLocation: LocationGroupedByCityLocation;
  LocationGroupedByCityVenue: LocationGroupedByCityVenue;
  LocationsWithPagination: LocationsWithPagination;
  MaintenanceStatus: MaintenanceStatus;
  MissingBankData: MissingBankData;
  MollieConnectionStatus: MollieConnectionStatus;
  MollieDowngradeImpact: MollieDowngradeImpact;
  MolliePaymentStatus: MolliePaymentStatus;
  MollieAmount: MollieAmount;
  MollieBankDetails: MollieBankDetails;
  MolliePaymentStatusPublic: MolliePaymentStatusPublic;
  MollieRefundsWithPagination: MollieRefundsWithPagination;
  MyProfileType: MyProfileType;
  NewsletterBookerStatus: NewsletterBookerStatus;
  NewsletterUnsubscribe: NewsletterUnsubscribe;
  NewsletterLocationList: NewsletterLocationList;
  NewsletterLog: NewsletterLog;
  NewsletterOverviewResult: NewsletterOverviewResult;
  NewsletterRecipientCount: NewsletterRecipientCount;
  NewsletterRulesInput: NewsletterRulesInput;
  NewsletterRulesPreview: NewsletterRulesPreview;
  NewsletterSettings: NewsletterSettings;
  ScheduledPaymentsWithPagination: ScheduledPaymentsWithPagination;
  Payment: Payment;
  SwissQRFile: SwissQrFile;
  SwissQRFileRecord: SwissQrFileRecord;
  PlatformConfig: PlatformConfig;
  CreateCertificateTemplateInput: CreateCertificateTemplateInput;
  CertificateBlockLayoutInput: CertificateBlockLayoutInput;
  CertificateBlockAlignmentsInput: CertificateBlockAlignmentsInput;
  CertificateBlockSpacingInput: CertificateBlockSpacingInput;
  CertificateDocFieldsInput: CertificateDocFieldsInput;
  CertificateDocTextInput: CertificateDocTextInput;
  CertificateAlignInput: CertificateAlignInput;
  CertificateLetterFieldsInput: CertificateLetterFieldsInput;
  CertificateSignerInput: CertificateSignerInput;
  CertificateSizesInput: CertificateSizesInput;
  CertificateTemplateVisibilityInput: CertificateTemplateVisibilityInput;
  SettledBookingCorrectionInput: SettledBookingCorrectionInput;
  SettledBookingCorrectionPreview: SettledBookingCorrectionPreview;
  InstallmentChangePreview: InstallmentChangePreview;
  RenderBatchLetterPdfForBookingsInput: RenderBatchLetterPdfForBookingsInput;
  RenderedBatchLetterPdfData: RenderedBatchLetterPdfData;
  RenderedLetterPdfData: RenderedLetterPdfData;
  LetterPdfCourseDetails: LetterPdfCourseDetails;
  RenderBatchLetterPdfForCourseInput: RenderBatchLetterPdfForCourseInput;
  RenderTemplateForLetterPdfInput: RenderTemplateForLetterPdfInput;
  TextBlockPreviewInput: TextBlockPreviewInput;
  TextBlockPreviewResult: TextBlockPreviewResult;
  TextBlockPreviewCurrent: TextBlockPreviewCurrent;
  TextBlockPreviewRecipient: TextBlockPreviewRecipient;
  TextBlockPreviewSummary: TextBlockPreviewSummary;
  TenantRecipientType: TenantRecipientType;
  ReversalInvoiceWithPagination: ReversalInvoiceWithPagination;
  ScheduledPaymentSummary: ScheduledPaymentSummary;
  ScheduledPaymentSummaryPart: ScheduledPaymentSummaryPart;
  CourseHistoryFilterInput: CourseHistoryFilterInput;
  CourseHistoryPaginationInput: CourseHistoryPaginationInput;
  CourseHistoryWithPagination: CourseHistoryWithPagination;
  SettingEndUserAppHistory: SettingEndUserAppHistory;
  SharedLoginStaff: SharedLoginStaff;
  StaffVisibilityRules: StaffVisibilityRules;
  StaffVisibilityRow: StaffVisibilityRow;
  StaffVisibilityRulesHistoryEntry: StaffVisibilityRulesHistoryEntry;
  SwissQRFileOverviewWithPagination: SwissQrFileOverviewWithPagination;
  SwissQRFileOverview: SwissQrFileOverview;
  SwissQRRecordContext: SwissQrRecordContext;
  SwissQRRecordContextEvent: SwissQrRecordContextEvent;
  SwissQRRecordContextRate: SwissQrRecordContextRate;
  Template: Template;
  TemplatesWithPagination: TemplatesWithPagination;
  TenantActivitySummary: TenantActivitySummary;
  TenantDeletionImpact: TenantDeletionImpact;
  EntityCount: EntityCount;
  TenantDeletionStatus: TenantDeletionStatus;
  TenantMetrics: TenantMetrics;
  TenantMetricsAiSummary: TenantMetricsAiSummary;
  TenantMetricsAiInsight: TenantMetricsAiInsight;
  TenantMetricsAiEvidence: TenantMetricsAiEvidence;
  TenantNotification: TenantNotification;
  TenantSeatUsage: TenantSeatUsage;
  TenantStaffMember: TenantStaffMember;
  KoOrganizationWithPagination: KoOrganizationWithPagination;
  TransferBulkPlanInput: TransferBulkPlanInput;
  TransferPriceOptionInput: TransferPriceOptionInput;
  TransferBulkPlanPreview: TransferBulkPlanPreview;
  TransferBulkPlanRow: TransferBulkPlanRow;
  TransferPlanPreview: TransferPlanPreview;
  TransferAttendedLessonsPreview: TransferAttendedLessonsPreview;
  TransferCarriedOverItem: TransferCarriedOverItem;
  TransferCommunicationDefaults: TransferCommunicationDefaults;
  TransferCutoffPreview: TransferCutoffPreview;
  TransferCutoffRatePreview: TransferCutoffRatePreview;
  TransferItemReview: TransferItemReview;
  TransferOldBookingPlan: TransferOldBookingPlan;
  TransferOldBookingOptionPreview: TransferOldBookingOptionPreview;
  TransferPartialSourcePreview: TransferPartialSourcePreview;
  TransferPriceOptionPreview: TransferPriceOptionPreview;
  TransferPlannedRate: TransferPlannedRate;
  TransferSurplusHandlingPreview: TransferSurplusHandlingPreview;
  TransferSurplusMollieRefundPreview: TransferSurplusMollieRefundPreview;
  TransferSurplusRefundPayment: TransferSurplusRefundPayment;
  TransferPlanInput: TransferPlanInput;
  TransferItemDecisionInput: TransferItemDecisionInput;
  TransferSurplusHandlingInput: TransferSurplusHandlingInput;
  WithdrawalRequest: WithdrawalRequest;
  Mutation: {};
  SetupScriptResult: SetupScriptResult;
  NewTemplateInput: NewTemplateInput;
  AddNamedScheduledPaymentInput: AddNamedScheduledPaymentInput;
  NewPageInput: NewPageInput;
  SepaDebitIntput: SepaDebitIntput;
  LessonBookingPlanFingerprintInput: LessonBookingPlanFingerprintInput;
  AssignAmbiguousPaymentDistributionInput: AssignAmbiguousPaymentDistributionInput;
  AssignAreaManagerLocationsInput: AssignAreaManagerLocationsInput;
  AssignAssistantInput: AssignAssistantInput;
  AssignInstructorToLessonInput: AssignInstructorToLessonInput;
  AutoMergeInput: AutoMergeInput;
  AutoMergeStartResult: AutoMergeStartResult;
  AutoMergeDryRunInput: AutoMergeDryRunInput;
  AutoMergeDryRunResult: AutoMergeDryRunResult;
  AutoMergeDryRunPair: AutoMergeDryRunPair;
  BroadcastTenantNotificationInput: BroadcastTenantNotificationInput;
  Attachment: Attachment;
  TenantRecipientInput: TenantRecipientInput;
  BroadcastTenantNotificationResult: BroadcastTenantNotificationResult;
  TenantNotificationResultType: TenantNotificationResultType;
  BulkCreateAttendeeBadgeInput: BulkCreateAttendeeBadgeInput;
  BulkToggleAttendeeBadgeRequirementInput: BulkToggleAttendeeBadgeRequirementInput;
  CancelBookingOptionsInput: CancelBookingOptionsInput;
  CancelFeeDecisionInput: CancelFeeDecisionInput;
  MolliePaymentResult: MolliePaymentResult;
  BankTransactionDistributionInput: BankTransactionDistributionInput;
  Sms77FormatApiResponse: Sms77FormatApiResponse;
  CreateAdminManagementUserInput: CreateAdminManagementUserInput;
  UserInput: UserInput;
  ThirdPartyUserInput: ThirdPartyUserInput;
  BookerInput: BookerInput;
  BookerAttendeeInput: BookerAttendeeInput;
  NewAttendeeBadgeInput: NewAttendeeBadgeInput;
  BookerAttendeeBookingInput: BookerAttendeeBookingInput;
  BaseInput: BaseInput;
  NewBookingsKo9Input: NewBookingsKo9Input;
  BookerPaymentMethodInput: BookerPaymentMethodInput;
  CreateAnnouncementInput: CreateAnnouncementInput;
  CreateAttendanceListBulkByInstructorInput: CreateAttendanceListBulkByInstructorInput;
  BulkJobResult: BulkJobResult;
  CreateAttendanceListBulkByLocationInput: CreateAttendanceListBulkByLocationInput;
  NewAttendeeBadgeByBadgeNameInput: NewAttendeeBadgeByBadgeNameInput;
  NewBadgeInput: NewBadgeInput;
  BadgeRequirementInlineInput: BadgeRequirementInlineInput;
  NewBadgeGroupInput: NewBadgeGroupInput;
  CreateBillingAddressTemplateInput: CreateBillingAddressTemplateInput;
  NewBookingInput: NewBookingInput;
  NewBookingRestrictionInput: NewBookingRestrictionInput;
  NewBookingInputBookableLessons: NewBookingInputBookableLessons;
  NewCourseInput: NewCourseInput;
  NewCoursePriceInput: NewCoursePriceInput;
  CreateInstallmentRateByCourseCreateInput: CreateInstallmentRateByCourseCreateInput;
  NewCourseLessonInput: NewCourseLessonInput;
  NewCourseCategoryInput: NewCourseCategoryInput;
  NewCourseLessonBookingInput: NewCourseLessonBookingInput;
  NewCourseTypeInput: NewCourseTypeInput;
  UpdateParticipationPrerequisitesInput: UpdateParticipationPrerequisitesInput;
  OptionalInputFieldsInput: OptionalInputFieldsInput;
  NewCustomBankDataInput: NewCustomBankDataInput;
  DiscountCodeInput: DiscountCodeInput;
  CreateDummySwissCamtByScheduledPaymentsInput: CreateDummySwissCamtByScheduledPaymentsInput;
  CamtScheduledPaymentInput: CamtScheduledPaymentInput;
  CreateDunningInput: CreateDunningInput;
  CreateFeeLetterInput: CreateFeeLetterInput;
  NewInstallmentRateInput: NewInstallmentRateInput;
  CreateInstructorInvoiceInput: CreateInstructorInvoiceInput;
  CreateInterestListInput: CreateInterestListInput;
  InterestListTimeSlotInput: InterestListTimeSlotInput;
  CreateInterestRegistrationInput: CreateInterestRegistrationInput;
  InvoiceInput: InvoiceInput;
  BookingWithCourseLessons: BookingWithCourseLessons;
  NewLocationInput: NewLocationInput;
  GeneralLocationContactInput: GeneralLocationContactInput;
  LocationContactIdInput: LocationContactIdInput;
  NewVenueInput: NewVenueInput;
  NewLocationContactInput: NewLocationContactInput;
  CreateMailjetSenderInput: CreateMailjetSenderInput;
  CreateMailjetSenderOutput: CreateMailjetSenderOutput;
  KoOrganizationInputType: KoOrganizationInputType;
  TenantAdminInput: TenantAdminInput;
  CreateOrganizationResult: CreateOrganizationResult;
  NewParticipationPrerequisitesInput: NewParticipationPrerequisitesInput;
  CreateSingleSepaXmlInput: CreateSingleSepaXmlInput;
  CreateSepaXmlByTimeRangeInput: CreateSepaXmlByTimeRangeInput;
  SettingEndUserAppInput: SettingEndUserAppInput;
  ColorsInput: ColorsInput;
  CourseDetailsInput: CourseDetailsInput;
  CourseTableInput: CourseTableInput;
  FiltersInput: FiltersInput;
  TextEntriesInput: TextEntriesInput;
  CreateWithdrawalEndUserAppInput: CreateWithdrawalEndUserAppInput;
  WithdrawalEndUserAppResult: WithdrawalEndUserAppResult;
  DismissDuplicatePairInput: DismissDuplicatePairInput;
  MaintenanceEnableInput: MaintenanceEnableInput;
  ErasureReportType: ErasureReportType;
  ErasureCounterType: ErasureCounterType;
  ErasureLinkedBookerType: ErasureLinkedBookerType;
  ErasureWarningType: ErasureWarningType;
  ExecuteBulkTransferInput: ExecuteBulkTransferInput;
  TransferCommunicationInput: TransferCommunicationInput;
  TransferBulkRowExpectationInput: TransferBulkRowExpectationInput;
  TransferCarriedOverItemInput: TransferCarriedOverItemInput;
  ExecuteBulkTransferResult: ExecuteBulkTransferResult;
  ExecuteBulkTransferRowResult: ExecuteBulkTransferRowResult;
  TransferInvoiceRef: TransferInvoiceRef;
  TransferSurplusOutcome: TransferSurplusOutcome;
  TransferSurplusRefundResult: TransferSurplusRefundResult;
  SettledBookingCorrectionResult: SettledBookingCorrectionResult;
  ExecuteTransferInput: ExecuteTransferInput;
  TransferSourceDeleteActionInput: TransferSourceDeleteActionInput;
  ExecuteTransferResult: ExecuteTransferResult;
  ForgotPasswordWithStateInput: ForgotPasswordWithStateInput;
  ResetPasswordStateType: ResetPasswordStateType;
  PasswordResetLinkType: PasswordResetLinkType;
  ScheduledPaymentSimpleInput: ScheduledPaymentSimpleInput;
  ScheduledPaymentPreview: ScheduledPaymentPreview;
  ScheduledPaymentSimple: ScheduledPaymentSimple;
  TenantDeletionResult: TenantDeletionResult;
  ImportBookersInput: ImportBookersInput;
  ImportBookerInput: ImportBookerInput;
  NewsletterUnsubscribeImportResult: NewsletterUnsubscribeImportResult;
  IssueCertificateInput: IssueCertificateInput;
  IssueCertificatesByAttendeesInput: IssueCertificatesByAttendeesInput;
  IssueCertificatesByCourseInput: IssueCertificatesByCourseInput;
  Ko9DbCredentialsInput: Ko9DbCredentialsInput;
  Ko9SchemaInfoType: Ko9SchemaInfoType;
  Ko9ImportConfigInput: Ko9ImportConfigInput;
  Ko9PreviewResultType: Ko9PreviewResultType;
  Ko9PreviewRowType: Ko9PreviewRowType;
  Ko9RollbackResultType: Ko9RollbackResultType;
  Ko9SaveResult: Ko9SaveResult;
  Ko9ConnectionTestResult: Ko9ConnectionTestResult;
  LoggingInput: LoggingInput;
  PasswordLoginInputType: PasswordLoginInputType;
  MarkPaidFromSepaInput: MarkPaidFromSepaInput;
  AttendeeMergeFieldsInput: AttendeeMergeFieldsInput;
  AttendeeMergeResult: AttendeeMergeResult;
  ModifyScheduledPaymentInput: ModifyScheduledPaymentInput;
  MollieCreateClientLinkInput: MollieCreateClientLinkInput;
  MollieClientLinkAddressInput: MollieClientLinkAddressInput;
  MollieClientLinkOwnerInput: MollieClientLinkOwnerInput;
  MollieCreateClientLinkResult: MollieCreateClientLinkResult;
  PasswordlessLoginInputType: PasswordlessLoginInputType;
  EndUserPasswordlessLoginInputType: EndUserPasswordlessLoginInputType;
  RecordExternalPaymentForScheduledPaymentInput: RecordExternalPaymentForScheduledPaymentInput;
  BankTransactionRecordAllResult: BankTransactionRecordAllResult;
  BankImportRematchAllResult: BankImportRematchAllResult;
  RemoveAdminManagementUserInput: RemoveAdminManagementUserInput;
  BookingDeleteAction: BookingDeleteAction;
  EndUserEventInput: EndUserEventInput;
  EndUserEventCourseFilterInput: EndUserEventCourseFilterInput;
  ResetScheduledPaymentsOfCourseResult: ResetScheduledPaymentsOfCourseResult;
  ResetScheduledPaymentsOfBookingResult: ResetScheduledPaymentsOfBookingResult;
  Rate: Rate;
  RateDetail: RateDetail;
  ResetPaymentPlanOfInvoicedLessonBookingResult: ResetPaymentPlanOfInvoicedLessonBookingResult;
  ResetPaymentPlanRateSnapshot: ResetPaymentPlanRateSnapshot;
  RestoreBackupInput: RestoreBackupInput;
  MollieManualReconciliationResult: MollieManualReconciliationResult;
  SaveAdminInput: SaveAdminInput;
  Admin: Admin;
  SaveInstructorInput: SaveInstructorInput;
  AssignedLocationIdInput: AssignedLocationIdInput;
  SendAttendanceListArchiveInput: SendAttendanceListArchiveInput;
  SendArchiveRecipientInput: SendArchiveRecipientInput;
  Upload: Scalars['Upload'];
  BlankMailInputTypes: BlankMailInputTypes;
  BlankMailReceiversInput: BlankMailReceiversInput;
  SendMailToSelectionOfCourseInput: SendMailToSelectionOfCourseInput;
  SendTemplateInput: SendTemplateInput;
  EmailData: EmailData;
  SendParamsMessageInput: SendParamsMessageInput;
  SendParamsRecipient: SendParamsRecipient;
  InlinedAttachment: InlinedAttachment;
  MailjetVariables: MailjetVariables;
  KeyValue: KeyValue;
  SendMailToSelectionOfAttendeesInput: SendMailToSelectionOfAttendeesInput;
  SendMailToSelectionOfBookersInput: SendMailToSelectionOfBookersInput;
  SendMailToSelectionOfScheduledPaymentsInput: SendMailToSelectionOfScheduledPaymentsInput;
  SendMailToSelectionOfStaffInput: SendMailToSelectionOfStaffInput;
  SendInvoicesToSelectionOfBookingInput: SendInvoicesToSelectionOfBookingInput;
  SendMailToSelectionOfBookingInput: SendMailToSelectionOfBookingInput;
  SendPasswordResetLinkEmailInput: SendPasswordResetLinkEmailInput;
  SendSmsInput: SendSmsInput;
  Sms77JsonResponse: Sms77JsonResponse;
  Sms77Message: Sms77Message;
  SetDunningPauseInput: SetDunningPauseInput;
  SupportReportInput: SupportReportInput;
  ThirdPartyLoginInput: ThirdPartyLoginInput;
  ToggleAreaManagerRoleInput: ToggleAreaManagerRoleInput;
  ToggleAttendeeBadgeRequirementInput: ToggleAttendeeBadgeRequirementInput;
  ToggleUserRoleInput: ToggleUserRoleInput;
  TransferMultipleBookingsInput: TransferMultipleBookingsInput;
  TransferBookingInput: TransferBookingInput;
  UpdateAdminManagementUserEmailInput: UpdateAdminManagementUserEmailInput;
  UpdateAdminManagementUserNameInput: UpdateAdminManagementUserNameInput;
  UpdateAnnouncementInput: UpdateAnnouncementInput;
  UpdateAttendanceListSettingsInput: UpdateAttendanceListSettingsInput;
  EditAttendeeBadgeInput: EditAttendeeBadgeInput;
  UpdateBadgeInput: UpdateBadgeInput;
  UpdateBadgeGroupInput: UpdateBadgeGroupInput;
  UpdateBillingAddressTemplateInput: UpdateBillingAddressTemplateInput;
  UpdateBookerAccountEndUserAppInput: UpdateBookerAccountEndUserAppInput;
  EditBookingInput: EditBookingInput;
  UpdateBookingRestrictionInput: UpdateBookingRestrictionInput;
  UpdateCertificateTemplateInput: UpdateCertificateTemplateInput;
  CompanySettingInput: CompanySettingInput;
  LogoInput: LogoInput;
  EditCourseInput: EditCourseInput;
  UpdateCourseAndBookingsResult: UpdateCourseAndBookingsResult;
  CourseLessonBookingsPreview: CourseLessonBookingsPreview;
  UpdateCourseLessonBookingInput: UpdateCourseLessonBookingInput;
  UpdateCustomBankDataInput: UpdateCustomBankDataInput;
  HolidayInput: HolidayInput;
  DiscountCodeUpdateInput: DiscountCodeUpdateInput;
  UpdateInterestListInput: UpdateInterestListInput;
  UpdateInterestRegistrationInput: UpdateInterestRegistrationInput;
  EditInvoiceInput: EditInvoiceInput;
  UpdateInvoiceTemplateSetInput: UpdateInvoiceTemplateSetInput;
  UpdateLateEntryPricingConfigurationInput: UpdateLateEntryPricingConfigurationInput;
  EditLocationInput: EditLocationInput;
  EditVenueInput: EditVenueInput;
  EditLocationContactInput: EditLocationContactInput;
  EditScheduledPaymentInput: EditScheduledPaymentInput;
  UpdateBookerIdMissmatchesInput: UpdateBookerIdMissmatchesInput;
  UpdateMyProfileInput: UpdateMyProfileInput;
  NewsletterSettingsInput: NewsletterSettingsInput;
  EditPageInput: EditPageInput;
  UpdatePaymentMethodInput: UpdatePaymentMethodInput;
  UpdateSettingEndUserAppInput: UpdateSettingEndUserAppInput;
  SettingInput: SettingInput;
  StaffVisibilityRulesInput: StaffVisibilityRulesInput;
  StaffVisibilityRowInput: StaffVisibilityRowInput;
  SubscriptionFeaturesInput: SubscriptionFeaturesInput;
  UpdateTableColumnSettingsInput: UpdateTableColumnSettingsInput;
  UpdateWithdrawalStatusInput: UpdateWithdrawalStatusInput;
  BundesbankImportResult: BundesbankImportResult;
  UploadedContentImage: UploadedContentImage;
  UploadMetadataInput: UploadMetadataInput;
  UpsertAttendeeBadgesWithRequirementsInput: UpsertAttendeeBadgesWithRequirementsInput;
  AttendeeBadgeAssignmentInput: AttendeeBadgeAssignmentInput;
  AttendeeRequirementFulfillmentInput: AttendeeRequirementFulfillmentInput;
  UserSettingsInputTypes: UserSettingsInputTypes;
  VoidPaymentLinkResult: VoidPaymentLinkResult;
  AddPaymentMethodInput: AddPaymentMethodInput;
  AnalyticsParams: AnalyticsParams;
  AutoMergeRun: AutoMergeRun;
  Base: Base;
  BaseLookupInput: BaseLookupInput;
  BasicEmailVariables: BasicEmailVariables;
  BookableOptions: BookableOptions;
  BookableOptionsResult: BookableOptionsResult;
  BookerCustomerInput: BookerCustomerInput;
  BookerCustomerUpdateInput: BookerCustomerUpdateInput;
  BookingHistoryWithPagination: BookingHistoryWithPagination;
  BookingOptions: BookingOptions;
  BookingRestrictionError: BookingRestrictionError;
  BookingWithPaymentAction: BookingWithPaymentAction;
  MolliePaymentAction: MolliePaymentAction;
  CamtGeneratorInput: CamtGeneratorInput;
  CamtGeneratorTransactionInput: CamtGeneratorTransactionInput;
  CheckboxItemInput: CheckboxItemInput;
  CourseDetailsLessonBookings: CourseDetailsLessonBookings;
  CourseIdInput: CourseIdInput;
  CourseLessonBookingAttendanceList: CourseLessonBookingAttendanceList;
  CourseLessonIdInput: CourseLessonIdInput;
  CoursePriceIdInput: CoursePriceIdInput;
  CourseWithPaginationWithEnabledCourses: CourseWithPaginationWithEnabledCourses;
  CreateMultipleSepaXmlInput: CreateMultipleSepaXmlInput;
  CreatePrefixedCourseNumberInput: CreatePrefixedCourseNumberInput;
  DetailsCheckboxInput: DetailsCheckboxInput;
  DuplicateMatch: DuplicateMatch;
  ForgotPasswordInput: ForgotPasswordInput;
  ForgotPasswordWithApiKeyInput: ForgotPasswordWithApiKeyInput;
  GetBookableOptionsInput: GetBookableOptionsInput;
  Ko9ImportCredentials: Ko9ImportCredentials;
  LessonBookingScheduledPaymentPreviewInput: LessonBookingScheduledPaymentPreviewInput;
  MailReplacementData: MailReplacementData;
  MollieConnection: MollieConnection;
  NewLessonBookingInput: NewLessonBookingInput;
  NewMultipleLessonBookingInput: NewMultipleLessonBookingInput;
  NewNotificationInput: NewNotificationInput;
  PostInputTo: PostInputTo;
  NewSepaXmlInput: NewSepaXmlInput;
  SepaXmlPositionInput: SepaXmlPositionInput;
  SepaXmlPaymentInput: SepaXmlPaymentInput;
  PageContentInput: PageContentInput;
  PaymentInput: PaymentInput;
  PricingParams: PricingParams;
  SecureIdentity: SecureIdentity;
  Sms77AnalyticBase: Sms77AnalyticBase;
  Sms77JournalBase: Sms77JournalBase;
  StaffLogin: StaffLogin;
  TableColumnsInput: TableColumnsInput;
  TenantDeletionLog: TenantDeletionLog;
  UploadFileInput: UploadFileInput;
  WithEnabledCourse: WithEnabledCourse;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  accountForEmail?: Resolver<Maybe<ResolversTypes['AccountForEmail']>, ParentType, ContextType, RequireFields<QueryAccountForEmailArgs, 'email'>>;
  accountLinks?: Resolver<ResolversTypes['AccountLinks'], ParentType, ContextType, RequireFields<QueryAccountLinksArgs, 'userId'>>;
  activeAnnouncements?: Resolver<Array<ResolversTypes['Announcement']>, ParentType, ContextType>;
  activeDunning?: Resolver<Maybe<ResolversTypes['ActiveDunning']>, ParentType, ContextType, RequireFields<QueryActiveDunningArgs, 'bookingId'>>;
  adminManagementEmailStatus?: Resolver<ResolversTypes['AdminManagementEmailInfo'], ParentType, ContextType, RequireFields<QueryAdminManagementEmailStatusArgs, 'email'>>;
  adminManagementOverview?: Resolver<ResolversTypes['AdminManagementOverview'], ParentType, ContextType>;
  announcement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType, RequireFields<QueryAnnouncementArgs, 'id'>>;
  announcements?: Resolver<Array<ResolversTypes['Announcement']>, ParentType, ContextType, Partial<QueryAnnouncementsArgs>>;
  attendanceListArchiveInstructors?: Resolver<Array<ResolversTypes['InstructorCourseGroup']>, ParentType, ContextType, RequireFields<QueryAttendanceListArchiveInstructorsArgs, 'jobGroupId'>>;
  attendanceListArchives?: Resolver<Array<ResolversTypes['AttendanceListArchive']>, ParentType, ContextType>;
  attendanceListBulkJobStatus?: Resolver<ResolversTypes['BulkJobStatus'], ParentType, ContextType, RequireFields<QueryAttendanceListBulkJobStatusArgs, 'jobGroupId'>>;
  attendanceListByCourse?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryAttendanceListByCourseArgs, 'courseId'>>;
  attendee?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType, RequireFields<QueryAttendeeArgs, 'id'>>;
  attendeeCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryAttendeeCountArgs>>;
  attendeeMergeHistoryByBookerId?: Resolver<Array<ResolversTypes['AttendeeMergeHistory']>, ParentType, ContextType, RequireFields<QueryAttendeeMergeHistoryByBookerIdArgs, 'bookerId'>>;
  attendees?: Resolver<ResolversTypes['AttendeeWithPagination'], ParentType, ContextType, Partial<QueryAttendeesArgs>>;
  attendeesByBookerFirstLast?: Resolver<ResolversTypes['AttendeeWithPagination'], ParentType, ContextType, RequireFields<QueryAttendeesByBookerFirstLastArgs, 'searchKey'>>;
  attendeesByIds?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType, RequireFields<QueryAttendeesByIdsArgs, 'attendeeIds'>>;
  authenticate?: Resolver<ResolversTypes['UserType'], ParentType, ContextType>;
  badge?: Resolver<ResolversTypes['Badge'], ParentType, ContextType, RequireFields<QueryBadgeArgs, 'id'>>;
  badgeGroups?: Resolver<Array<ResolversTypes['BadgeGroup']>, ParentType, ContextType>;
  badges?: Resolver<Array<ResolversTypes['Badge']>, ParentType, ContextType>;
  bankCollectionRuns?: Resolver<Array<ResolversTypes['BankCollectionRun']>, ParentType, ContextType>;
  bankImportFiles?: Resolver<Array<ResolversTypes['BankImportFile']>, ParentType, ContextType>;
  bankTransaction?: Resolver<ResolversTypes['BankTransaction'], ParentType, ContextType, RequireFields<QueryBankTransactionArgs, 'id'>>;
  bankTransactions?: Resolver<ResolversTypes['BankTransactionsPage'], ParentType, ContextType, Partial<QueryBankTransactionsArgs>>;
  bankTransactionsForScheduledPayment?: Resolver<Array<ResolversTypes['BankTransaction']>, ParentType, ContextType, RequireFields<QueryBankTransactionsForScheduledPaymentArgs, 'scheduledPaymentId'>>;
  billingAddressTemplates?: Resolver<Array<ResolversTypes['BillingAddressTemplate']>, ParentType, ContextType>;
  bookedAttendeesByCourseId?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType, RequireFields<QueryBookedAttendeesByCourseIdArgs, 'courseId'>>;
  bookedSpots?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryBookedSpotsArgs, 'courseId'>>;
  booker?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<QueryBookerArgs, 'id'>>;
  bookerByUserId?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<QueryBookerByUserIdArgs, 'id'>>;
  bookerDeletionProgress?: Resolver<Maybe<ResolversTypes['BookerDeletionProgressType']>, ParentType, ContextType>;
  bookerExistsAsAttendeeEndUserApp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryBookerExistsAsAttendeeEndUserAppArgs, 'bookerId'>>;
  bookerMergeHistoryByBookerId?: Resolver<Array<ResolversTypes['BookerMergeHistory']>, ParentType, ContextType, RequireFields<QueryBookerMergeHistoryByBookerIdArgs, 'bookerId'>>;
  bookers?: Resolver<ResolversTypes['BookerWithPagination'], ParentType, ContextType, Partial<QueryBookersArgs>>;
  bookersById?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QueryBookersByIdArgs, 'bookerIds'>>;
  bookersDynamic?: Resolver<ResolversTypes['BookerWithPagination'], ParentType, ContextType, Partial<QueryBookersDynamicArgs>>;
  bookersExport?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, Partial<QueryBookersExportArgs>>;
  booking?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryBookingArgs, 'id'>>;
  bookingById?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<QueryBookingByIdArgs, 'id'>>;
  bookingByIdWithCourseLessonBookings?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<QueryBookingByIdWithCourseLessonBookingsArgs, 'id'>>;
  bookingDunningStatuses?: Resolver<Array<ResolversTypes['BookingDunningStatus']>, ParentType, ContextType, RequireFields<QueryBookingDunningStatusesArgs, 'bookingIds'>>;
  bookingEligibilityCandidates?: Resolver<Array<ResolversTypes['BookingEligibilityCandidate']>, ParentType, ContextType, RequireFields<QueryBookingEligibilityCandidatesArgs, 'attendeeId'>>;
  bookingEligibilityDiagnosis?: Resolver<ResolversTypes['BookingEligibilityDiagnosis'], ParentType, ContextType, RequireFields<QueryBookingEligibilityDiagnosisArgs, 'attendeeId' | 'courseId'>>;
  bookingHistoryByBookingId?: Resolver<Array<ResolversTypes['BookingHistory']>, ParentType, ContextType, RequireFields<QueryBookingHistoryByBookingIdArgs, 'bookingId'>>;
  bookingHistoryByCourseId?: Resolver<Array<ResolversTypes['BookingHistory']>, ParentType, ContextType, RequireFields<QueryBookingHistoryByCourseIdArgs, 'courseId'>>;
  bookingHistoryByIdWithBookingInfo?: Resolver<Array<ResolversTypes['BookingHistory']>, ParentType, ContextType, RequireFields<QueryBookingHistoryByIdWithBookingInfoArgs, 'bookingId'>>;
  bookingHistoryDetailsByBookingIdAndOrganizationId?: Resolver<Array<ResolversTypes['BookingHistory']>, ParentType, ContextType, RequireFields<QueryBookingHistoryDetailsByBookingIdAndOrganizationIdArgs, 'bookingId' | 'koOrganizationId'>>;
  bookingHistoryOrphanBookings?: Resolver<Array<ResolversTypes['BookingHistory']>, ParentType, ContextType, RequireFields<QueryBookingHistoryOrphanBookingsArgs, 'koOrganizationId'>>;
  bookingRestrictions?: Resolver<Array<ResolversTypes['BookingRestriction']>, ParentType, ContextType>;
  bookings?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, Partial<QueryBookingsArgs>>;
  bookingsByCourseIdWithCourseLessonBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryBookingsByCourseIdWithCourseLessonBookingsArgs, 'courseId'>>;
  bookingsByUser?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryBookingsByUserArgs, 'userId'>>;
  bookingsDynamic?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, Partial<QueryBookingsDynamicArgs>>;
  bookingsInStartedCourses?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, Partial<QueryBookingsInStartedCoursesArgs>>;
  bookingsKo9?: Resolver<Array<ResolversTypes['BookingsKo9']>, ParentType, ContextType>;
  bookingsKo9ByAttendeeId?: Resolver<Array<ResolversTypes['BookingsKo9']>, ParentType, ContextType, RequireFields<QueryBookingsKo9ByAttendeeIdArgs, 'attendeeId'>>;
  bundesbankBlzImportInfo?: Resolver<ResolversTypes['BundesbankImportInfo'], ParentType, ContextType>;
  canBecomeInstructor?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCanBecomeInstructorArgs, 'email'>>;
  certificateIssuePreflight?: Resolver<ResolversTypes['CertificateIssuePreflightResult'], ParentType, ContextType, RequireFields<QueryCertificateIssuePreflightArgs, 'input'>>;
  certificateTemplate?: Resolver<ResolversTypes['CertificateTemplate'], ParentType, ContextType, RequireFields<QueryCertificateTemplateArgs, 'id'>>;
  certificateTemplates?: Resolver<Array<ResolversTypes['CertificateTemplate']>, ParentType, ContextType>;
  checkAttendeesAgeAtCourseStart?: Resolver<ResolversTypes['AttendeesAgeAtCourseStart'], ParentType, ContextType, RequireFields<QueryCheckAttendeesAgeAtCourseStartArgs, 'attendeeId' | 'courseId'>>;
  checkDiscountCode?: Resolver<ResolversTypes['DiscountCodeCheckResult'], ParentType, ContextType, RequireFields<QueryCheckDiscountCodeArgs, 'code' | 'courseId'>>;
  checkEmailUniqueness?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCheckEmailUniquenessArgs, 'email'>>;
  checkIfIsBookedIntoCourse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCheckIfIsBookedIntoCourseArgs, 'attendeeId' | 'courseId'>>;
  checkIfTemplateOfTypeExists?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QueryCheckIfTemplateOfTypeExistsArgs, 'templateType'>>;
  checkSmsApiKey?: Resolver<ResolversTypes['SmsBalanceResponse'], ParentType, ContextType, RequireFields<QueryCheckSmsApiKeyArgs, 'apiKey'>>;
  cities?: Resolver<Array<ResolversTypes['LocationCity']>, ParentType, ContextType>;
  companyCurrencyPublic?: Resolver<ResolversTypes['Setting'], ParentType, ContextType>;
  companyInfo?: Resolver<ResolversTypes['KoOrganization'], ParentType, ContextType>;
  companyPublic?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType>;
  companySettings?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType>;
  courseById?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<QueryCourseByIdArgs, 'id'>>;
  courseByIdPublic?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<QueryCourseByIdPublicArgs, 'id'>>;
  courseByLocationId?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QueryCourseByLocationIdArgs, 'id'>>;
  courseCategories?: Resolver<Array<ResolversTypes['CourseCategory']>, ParentType, ContextType>;
  courseCategoriesPublic?: Resolver<Array<ResolversTypes['CourseType']>, ParentType, ContextType>;
  courseCategoryById?: Resolver<ResolversTypes['CourseCategory'], ParentType, ContextType, RequireFields<QueryCourseCategoryByIdArgs, 'id'>>;
  courseDetailsById?: Resolver<ResolversTypes['CourseDetails'], ParentType, ContextType, RequireFields<QueryCourseDetailsByIdArgs, 'id'>>;
  courseHasAtLeastOneCourseLessonBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCourseHasAtLeastOneCourseLessonBookingArgs, 'courseId'>>;
  courseHistoryByCourseId?: Resolver<Array<ResolversTypes['CourseHistory']>, ParentType, ContextType, RequireFields<QueryCourseHistoryByCourseIdArgs, 'courseId'>>;
  courseHistoryByCourseIdAndOrganizationId?: Resolver<Array<ResolversTypes['CourseHistory']>, ParentType, ContextType, RequireFields<QueryCourseHistoryByCourseIdAndOrganizationIdArgs, 'courseId' | 'koOrganizationId'>>;
  courseIsPrerequisiteCourseFor?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QueryCourseIsPrerequisiteCourseForArgs, 'courseId'>>;
  courseLessonBooking?: Resolver<ResolversTypes['CourseLessonBooking'], ParentType, ContextType, RequireFields<QueryCourseLessonBookingArgs, 'id'>>;
  courseLessonBookingByCourseLessonAndBooking?: Resolver<ResolversTypes['CourseLessonBooking'], ParentType, ContextType, RequireFields<QueryCourseLessonBookingByCourseLessonAndBookingArgs, 'bookingId' | 'courseLessonId'>>;
  courseLessonBookingsByBookingId?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType, RequireFields<QueryCourseLessonBookingsByBookingIdArgs, 'bookingId'>>;
  courseLessonBookingsByCourse?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType, RequireFields<QueryCourseLessonBookingsByCourseArgs, 'courseId'>>;
  courseLessonById?: Resolver<ResolversTypes['CourseLesson'], ParentType, ContextType, RequireFields<QueryCourseLessonByIdArgs, 'id'>>;
  courseLessons?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, Partial<QueryCourseLessonsArgs>>;
  courseLessonsByCalendarWeek?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<QueryCourseLessonsByCalendarWeekArgs, 'calendarWeek' | 'year'>>;
  courseLessonsByCourseAndInstructor?: Resolver<Array<ResolversTypes['BillingStatusCoursLessons']>, ParentType, ContextType, RequireFields<QueryCourseLessonsByCourseAndInstructorArgs, 'courseId' | 'instructorId'>>;
  courseLessonsByCourseId?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<QueryCourseLessonsByCourseIdArgs, 'courseId'>>;
  courseLessonsByCourseIdPublic?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<QueryCourseLessonsByCourseIdPublicArgs, 'courseId'>>;
  courseLessonsByDate?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<QueryCourseLessonsByDateArgs, 'date'>>;
  courseLessonsByInstructorChronological?: Resolver<ResolversTypes['ChronologicalLessonsResult'], ParentType, ContextType, RequireFields<QueryCourseLessonsByInstructorChronologicalArgs, 'instructorId'>>;
  courseLessonsForBillingStatus?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<QueryCourseLessonsForBillingStatusArgs, 'courseLessonForBillingStatusInput'>>;
  courseLessonsForBillingStatusByInstructor?: Resolver<Array<ResolversTypes['BillingStatusByInstructor']>, ParentType, ContextType, RequireFields<QueryCourseLessonsForBillingStatusByInstructorArgs, 'courseLessonForBillingStatusInput'>>;
  courseLessonsForBillingStatusByInstructorGrouped?: Resolver<Array<ResolversTypes['BillingStatusByInstructorWithCourseGroups']>, ParentType, ContextType, RequireFields<QueryCourseLessonsForBillingStatusByInstructorGroupedArgs, 'courseLessonForBillingStatusInput'>>;
  courseLessonsForMonthView?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<QueryCourseLessonsForMonthViewArgs, 'month' | 'year'>>;
  courseLessonsOfMonthForExport?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<QueryCourseLessonsOfMonthForExportArgs, 'date'>>;
  courseLessonsOfMonthWithPagination?: Resolver<ResolversTypes['CourseLessonWithPagination'], ParentType, ContextType, RequireFields<QueryCourseLessonsOfMonthWithPaginationArgs, 'date'>>;
  courseLessonsWithCollitions?: Resolver<Array<ResolversTypes['CourseLessonWithIndexOfCourseLessonInCourse']>, ParentType, ContextType, RequireFields<QueryCourseLessonsWithCollitionsArgs, 'collitionCheckInput'>>;
  courseLessonsWithPagination?: Resolver<ResolversTypes['CourseLessonWithPagination'], ParentType, ContextType, Partial<QueryCourseLessonsWithPaginationArgs>>;
  courses?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, Partial<QueryCoursesArgs>>;
  coursesByIds?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QueryCoursesByIdsArgs, 'ids'>>;
  coursesPublic?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, Partial<QueryCoursesPublicArgs>>;
  coursesWithPagination?: Resolver<ResolversTypes['CourseWithPagination'], ParentType, ContextType, Partial<QueryCoursesWithPaginationArgs>>;
  coursesWithPaginationPublic?: Resolver<ResolversTypes['CourseWithPagination'], ParentType, ContextType, RequireFields<QueryCoursesWithPaginationPublicArgs, 'filters'>>;
  coursesWithPrerequisiteCourses?: Resolver<ResolversTypes['CourseWithPagination'], ParentType, ContextType, Partial<QueryCoursesWithPrerequisiteCoursesArgs>>;
  courseTypeById?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType, RequireFields<QueryCourseTypeByIdArgs, 'id'>>;
  courseTypes?: Resolver<Array<ResolversTypes['CourseType']>, ParentType, ContextType>;
  courseTypesPublic?: Resolver<Array<ResolversTypes['CourseType']>, ParentType, ContextType>;
  courseTypeStateById?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType, RequireFields<QueryCourseTypeStateByIdArgs, 'id'>>;
  courseTypesWithPagination?: Resolver<ResolversTypes['CourseTypeWithPagination'], ParentType, ContextType, Partial<QueryCourseTypesWithPaginationArgs>>;
  creditEntriesByBookerId?: Resolver<Array<ResolversTypes['CreditEntry']>, ParentType, ContextType, RequireFields<QueryCreditEntriesByBookerIdArgs, 'bookerId'>>;
  currentUser?: Resolver<ResolversTypes['UserType'], ParentType, ContextType>;
  customBankData?: Resolver<Maybe<ResolversTypes['CustomBankData']>, ParentType, ContextType, RequireFields<QueryCustomBankDataArgs, 'id'>>;
  customBankDataList?: Resolver<Array<ResolversTypes['CustomBankData']>, ParentType, ContextType>;
  customerById?: Resolver<ResolversTypes['Customer'], ParentType, ContextType, RequireFields<QueryCustomerByIdArgs, 'id'>>;
  customerTimeline?: Resolver<Array<ResolversTypes['CustomerTimelineEntry']>, ParentType, ContextType, RequireFields<QueryCustomerTimelineArgs, 'bookerId'>>;
  customHolidaysByCompany?: Resolver<Array<ResolversTypes['Holiday']>, ParentType, ContextType>;
  defaultInvoiceTemplateSet?: Resolver<ResolversTypes['InvoiceTemplateSet'], ParentType, ContextType>;
  detectBundleConflictsFromAdmin?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<QueryDetectBundleConflictsFromAdminArgs, 'bookingId'>>;
  discountCode?: Resolver<ResolversTypes['DiscountCode'], ParentType, ContextType, RequireFields<QueryDiscountCodeArgs, 'id'>>;
  discountCodes?: Resolver<Array<ResolversTypes['DiscountCode']>, ParentType, ContextType>;
  downloadCertificate?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryDownloadCertificateArgs, 'issuedCertificateId'>>;
  dunningPause?: Resolver<ResolversTypes['DunningPause'], ParentType, ContextType, RequireFields<QueryDunningPauseArgs, 'bookingId'>>;
  dunningPdf?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryDunningPdfArgs, 'id'>>;
  dunningProposal?: Resolver<ResolversTypes['DunningProposal'], ParentType, ContextType, RequireFields<QueryDunningProposalArgs, 'bookingId'>>;
  dunningsByBooking?: Resolver<Array<ResolversTypes['Dunning']>, ParentType, ContextType, RequireFields<QueryDunningsByBookingArgs, 'bookingId'>>;
  emailNotificationById?: Resolver<ResolversTypes['EmailNotification'], ParentType, ContextType, RequireFields<QueryEmailNotificationByIdArgs, 'id'>>;
  emailNotifications?: Resolver<ResolversTypes['EmailNotificationWithPagination'], ParentType, ContextType, Partial<QueryEmailNotificationsArgs>>;
  emailRegistrationStatusForEndUserApp?: Resolver<ResolversTypes['EndUserEmailRegistrationStatus'], ParentType, ContextType, RequireFields<QueryEmailRegistrationStatusForEndUserAppArgs, 'email'>>;
  exportedSepaXml?: Resolver<ResolversTypes['ExportedSepaXml'], ParentType, ContextType, RequireFields<QueryExportedSepaXmlArgs, 'id'>>;
  exportedSepaXmls?: Resolver<ResolversTypes['ExportedSepaXmlWithPagination'], ParentType, ContextType, Partial<QueryExportedSepaXmlsArgs>>;
  faUserByEmail?: Resolver<ResolversTypes['FaUser'], ParentType, ContextType, RequireFields<QueryFaUserByEmailArgs, 'email'>>;
  faUserByUserId?: Resolver<Maybe<ResolversTypes['FaUser']>, ParentType, ContextType, RequireFields<QueryFaUserByUserIdArgs, 'userId'>>;
  feeLetterPdf?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryFeeLetterPdfArgs, 'id'>>;
  feeLetterProposal?: Resolver<ResolversTypes['FeeLetterProposal'], ParentType, ContextType, RequireFields<QueryFeeLetterProposalArgs, 'bookingId'>>;
  feeLettersByBooking?: Resolver<Array<ResolversTypes['FeeLetter']>, ParentType, ContextType, RequireFields<QueryFeeLettersByBookingArgs, 'bookingId'>>;
  findByCourseId?: Resolver<ResolversTypes['Instructor'], ParentType, ContextType, RequireFields<QueryFindByCourseIdArgs, 'id'>>;
  findInstructorById?: Resolver<ResolversTypes['Instructor'], ParentType, ContextType, RequireFields<QueryFindInstructorByIdArgs, 'instructorId'>>;
  findInstructorByIds?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType, RequireFields<QueryFindInstructorByIdsArgs, 'instructorIds'>>;
  findInstructorsByLocation?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType, RequireFields<QueryFindInstructorsByLocationArgs, 'locationId'>>;
  findSimilarBookers?: Resolver<Array<ResolversTypes['SimilarBookerResult']>, ParentType, ContextType, RequireFields<QueryFindSimilarBookersArgs, 'firstname' | 'lastname'>>;
  findUnpaidScheduledPaymentsInSepaExports?: Resolver<ResolversTypes['UnpaidScheduledPaymentMatchResult'], ParentType, ContextType, RequireFields<QueryFindUnpaidScheduledPaymentsInSepaExportsArgs, 'input'>>;
  getAdminAndInstructorUsers?: Resolver<Array<ResolversTypes['UserType']>, ParentType, ContextType, RequireFields<QueryGetAdminAndInstructorUsersArgs, 'koOrganizationId'>>;
  getAllBookingsByAttendeeIdAndCourseId?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType, RequireFields<QueryGetAllBookingsByAttendeeIdAndCourseIdArgs, 'attendeeId' | 'courseId'>>;
  getAllCoursesWithAllowMonthlyPayment?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType>;
  getAnalyticsByDate?: Resolver<Array<ResolversTypes['Sms77AnalyticGroupByDate']>, ParentType, ContextType, Partial<QueryGetAnalyticsByDateArgs>>;
  getAreaIssuesForAreaManagerApp?: Resolver<Array<ResolversTypes['AreaIssue']>, ParentType, ContextType>;
  getAreaManagerAssistantHierarchy?: Resolver<ResolversTypes['AreaManagerAssistantHierarchyResult'], ParentType, ContextType>;
  getAreaManagerAssistantLessonsByCourse?: Resolver<Array<ResolversTypes['AreaManagerAssistantOverview']>, ParentType, ContextType, RequireFields<QueryGetAreaManagerAssistantLessonsByCourseArgs, 'input'>>;
  getAreaManagerAssistantOverview?: Resolver<ResolversTypes['AreaManagerAssistantOverviewResult'], ParentType, ContextType, Partial<QueryGetAreaManagerAssistantOverviewArgs>>;
  getAreaManagerCourses?: Resolver<ResolversTypes['AreaManagerCourseStatsResult'], ParentType, ContextType, Partial<QueryGetAreaManagerCoursesArgs>>;
  getAreaManagerInstructorStats?: Resolver<ResolversTypes['AreaManagerInstructorStatsResult'], ParentType, ContextType, Partial<QueryGetAreaManagerInstructorStatsArgs>>;
  getAreaManagerLocations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  getAreaManagerLocationsByStaffId?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<QueryGetAreaManagerLocationsByStaffIdArgs, 'staffId'>>;
  getAreaManagerLocationStats?: Resolver<ResolversTypes['AreaManagerLocationStatsResult'], ParentType, ContextType, Partial<QueryGetAreaManagerLocationStatsArgs>>;
  getAreaManagerUpcomingLessons?: Resolver<Array<ResolversTypes['AreaManagerUpcomingLesson']>, ParentType, ContextType, Partial<QueryGetAreaManagerUpcomingLessonsArgs>>;
  getAreaManagerVenueUtilization?: Resolver<ResolversTypes['AreaManagerVenueUtilizationResult'], ParentType, ContextType, Partial<QueryGetAreaManagerVenueUtilizationArgs>>;
  getAreaOverviewForAreaManagerApp?: Resolver<ResolversTypes['AreaOverviewResult'], ParentType, ContextType>;
  getAreaPeopleForAreaManagerApp?: Resolver<Array<ResolversTypes['AreaPerson']>, ParentType, ContextType>;
  getAssistantAssignedLocations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  getAttendanceListSettings?: Resolver<ResolversTypes['UserSetting'], ParentType, ContextType>;
  getAttendeeBadge?: Resolver<ResolversTypes['AttendeeBadge'], ParentType, ContextType, RequireFields<QueryGetAttendeeBadgeArgs, 'id'>>;
  getAttendeeBadges?: Resolver<Array<ResolversTypes['AttendeeBadge']>, ParentType, ContextType>;
  getAttendeeBadgesByAttendeeId?: Resolver<Array<ResolversTypes['AttendeeBadge']>, ParentType, ContextType, RequireFields<QueryGetAttendeeBadgesByAttendeeIdArgs, 'attendeeId'>>;
  getAttendeeBadgesByBadgeId?: Resolver<Array<ResolversTypes['AttendeeBadge']>, ParentType, ContextType, RequireFields<QueryGetAttendeeBadgesByBadgeIdArgs, 'badgeId'>>;
  getAttendeeInfosForBooking?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType, RequireFields<QueryGetAttendeeInfosForBookingArgs, 'attendeeId'>>;
  getAttendeesWithByStandardPaymentMethod?: Resolver<ResolversTypes['AttendeeWithPagination'], ParentType, ContextType, RequireFields<QueryGetAttendeesWithByStandardPaymentMethodArgs, 'koOrganizationId' | 'paymentTransferType' | 'targetPaymentTransferType'>>;
  getAutoMergeStatus?: Resolver<Maybe<ResolversTypes['AutoMergeStatus']>, ParentType, ContextType>;
  getAvailablePaymentMethodsFromEndUserApp?: Resolver<Array<ResolversTypes['MollieMethodInfo']>, ParentType, ContextType, Partial<QueryGetAvailablePaymentMethodsFromEndUserAppArgs>>;
  getBankData?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QueryGetBankDataArgs, 'iban'>>;
  getBilledBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, Partial<QueryGetBilledBookingsArgs>>;
  getBookerAndAttendeeCount?: Resolver<ResolversTypes['BookerAttendeeCount'], ParentType, ContextType>;
  getBookerByEmail?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QueryGetBookerByEmailArgs, 'email'>>;
  getBookerIdMissmatchesWithPagination?: Resolver<ResolversTypes['BookerIdMissmatchWithPagination'], ParentType, ContextType, Partial<QueryGetBookerIdMissmatchesWithPaginationArgs>>;
  getBookersByBookingIds?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QueryGetBookersByBookingIdsArgs, 'bookingIds'>>;
  getBookersByCourseIds?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QueryGetBookersByCourseIdsArgs, 'courseIds'>>;
  getBookersByCourseWithBookingType?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QueryGetBookersByCourseWithBookingTypeArgs, 'courseId'>>;
  getBookingRestrictionByCourseId?: Resolver<Maybe<ResolversTypes['BookingRestriction']>, ParentType, ContextType, RequireFields<QueryGetBookingRestrictionByCourseIdArgs, 'courseId'>>;
  getBookingsAsCsv?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetBookingsAsCsvArgs, 'bookingIds' | 'filterFields'>>;
  getBookingsByAttendeeId?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryGetBookingsByAttendeeIdArgs, 'id'>>;
  getBookingsByAttendeeIdWithOptions?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryGetBookingsByAttendeeIdWithOptionsArgs, 'id'>>;
  getBookingsByCourse?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, RequireFields<QueryGetBookingsByCourseArgs, 'id'>>;
  getBookingsByCourseAndAttendee?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<QueryGetBookingsByCourseAndAttendeeArgs, 'attendeeId' | 'courseId'>>;
  getBookingsByCourseIds?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, RequireFields<QueryGetBookingsByCourseIdsArgs, 'ids'>>;
  getBookingsByIds?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryGetBookingsByIdsArgs, 'ids'>>;
  getBookingsByInvoiceIds?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryGetBookingsByInvoiceIdsArgs, 'invoiceIds'>>;
  getBookingsByScheduledPaymentIds?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QueryGetBookingsByScheduledPaymentIdsArgs, 'scheduledPaymentIds'>>;
  getCacheStats?: Resolver<ResolversTypes['CacheStatsOutput'], ParentType, ContextType>;
  getCanceledBookings?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, Partial<QueryGetCanceledBookingsArgs>>;
  getChargebackCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetChargebackCountArgs, 'filter'>>;
  getChargebacks?: Resolver<Array<ResolversTypes['MolliePaymentAttempt']>, ParentType, ContextType, RequireFields<QueryGetChargebacksArgs, 'filter'>>;
  getChargebackSummary?: Resolver<ResolversTypes['ChargebackSummary'], ParentType, ContextType>;
  getColumnsForTable?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetColumnsForTableArgs, 'table'>>;
  getContentByPathDo?: Resolver<ResolversTypes['ContentOfBucket'], ParentType, ContextType, RequireFields<QueryGetContentByPathDoArgs, 'path'>>;
  getContentOfBucketDo?: Resolver<ResolversTypes['ContentOfBucket'], ParentType, ContextType>;
  getContentOfFolderDo?: Resolver<ResolversTypes['ContentOfBucket'], ParentType, ContextType, Partial<QueryGetContentOfFolderDoArgs>>;
  getCourseInfosForBooking?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<QueryGetCourseInfosForBookingArgs, 'courseId'>>;
  getCourseLessonBookingsByBookingId?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType, RequireFields<QueryGetCourseLessonBookingsByBookingIdArgs, 'bookingId'>>;
  getCourseLessonsForAssistantApp?: Resolver<Array<ResolversTypes['AssistantCourseLesson']>, ParentType, ContextType, Partial<QueryGetCourseLessonsForAssistantAppArgs>>;
  getCourseMinMaxAge?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QueryGetCourseMinMaxAgeArgs, 'courseId'>>;
  getCoursesWithHighDemand?: Resolver<ResolversTypes['CourseWithPagination'], ParentType, ContextType, Partial<QueryGetCoursesWithHighDemandArgs>>;
  getCourseVisibility?: Resolver<ResolversTypes['CourseVisibilityResult'], ParentType, ContextType, RequireFields<QueryGetCourseVisibilityArgs, 'courseId'>>;
  getDatabaseBackupDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetDatabaseBackupDownloadUrlArgs, 'input'>>;
  getDataExportDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetDataExportDownloadUrlArgs, 'exportId'>>;
  getDuplicateBookerGroups?: Resolver<Array<ResolversTypes['DuplicateGroupWithMetadata']>, ParentType, ContextType, RequireFields<QueryGetDuplicateBookerGroupsArgs, 'limit'>>;
  getDuplicateBookers?: Resolver<Array<Array<ResolversTypes['Booker']>>, ParentType, ContextType, Partial<QueryGetDuplicateBookersArgs>>;
  getDuplicateDetectionStatus?: Resolver<Maybe<ResolversTypes['DuplicateDetectionRun']>, ParentType, ContextType>;
  getDuplicateExceptions?: Resolver<Array<ResolversTypes['DuplicateException']>, ParentType, ContextType>;
  getDuplicateMatchStats?: Resolver<ResolversTypes['DuplicateMatchStats'], ParentType, ContextType>;
  getEmailTemplateById?: Resolver<ResolversTypes['MjmlTemplate'], ParentType, ContextType, RequireFields<QueryGetEmailTemplateByIdArgs, 'templateId'>>;
  getFileDo?: Resolver<ResolversTypes['Content'], ParentType, ContextType, RequireFields<QueryGetFileDoArgs, 'fileName'>>;
  getInfoUserByUserId?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<QueryGetInfoUserByUserIdArgs, 'userId'>>;
  getInstallmentPlanPreview?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QueryGetInstallmentPlanPreviewArgs, 'newInstallmentPlanInput'>>;
  getInvoiceDummyPreview?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, Partial<QueryGetInvoiceDummyPreviewArgs>>;
  getInvoiceExportDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetInvoiceExportDownloadUrlArgs, 'exportId'>>;
  getInvoicePreview?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QueryGetInvoicePreviewArgs, 'invoiceId'>>;
  getLastCustomer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  getLessonsThatAreNotDeletable?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetLessonsThatAreNotDeletableArgs, 'courseLessonIds'>>;
  getMailjetSenderById?: Resolver<ResolversTypes['MailjetSenderResponse'], ParentType, ContextType, RequireFields<QueryGetMailjetSenderByIdArgs, 'mailjetSenderId'>>;
  getMailjetSenders?: Resolver<ResolversTypes['MailjetSenderResponse'], ParentType, ContextType, Partial<QueryGetMailjetSendersArgs>>;
  getMissingIndexCandidates?: Resolver<Array<ResolversTypes['MissingIndexCandidateOutput']>, ParentType, ContextType>;
  getMollieKpis?: Resolver<ResolversTypes['MollieKpis'], ParentType, ContextType>;
  getMolliePayments?: Resolver<ResolversTypes['MolliePaymentsPage'], ParentType, ContextType, RequireFields<QueryGetMolliePaymentsArgs, 'filter' | 'limit' | 'offset'>>;
  getMolliePaymentTabCounts?: Resolver<ResolversTypes['MolliePaymentTabCounts'], ParentType, ContextType, RequireFields<QueryGetMolliePaymentTabCountsArgs, 'filter'>>;
  getMollieRetryQueueEntries?: Resolver<Array<ResolversTypes['MollieRetryQueueEntry']>, ParentType, ContextType>;
  getMonthlyPaymentPreview?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QueryGetMonthlyPaymentPreviewArgs, 'monthlyPaymentPreviewOptions'>>;
  getMyAssignmentsAssistantApp?: Resolver<Array<ResolversTypes['AssistantCourseLesson']>, ParentType, ContextType, Partial<QueryGetMyAssignmentsAssistantAppArgs>>;
  getOnlineBookingsByTimeRangeCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetOnlineBookingsByTimeRangeCountArgs>>;
  getOnlineBookingsByTimeRangeSeries?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<QueryGetOnlineBookingsByTimeRangeSeriesArgs, 'buckets' | 'endDateTime' | 'startDateTime'>>;
  getOnlineRegisteredBookers?: Resolver<ResolversTypes['OnlineRegisteredBookersResult'], ParentType, ContextType, RequireFields<QueryGetOnlineRegisteredBookersArgs, 'limit' | 'offset'>>;
  getOpenAttendanceSummaryForStaffApp?: Resolver<ResolversTypes['OpenAttendanceSummary'], ParentType, ContextType>;
  getPages?: Resolver<ResolversTypes['PageStructure'], ParentType, ContextType>;
  getPasswordlessLoginSettings?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  getPaymentActionLogs?: Resolver<Array<ResolversTypes['PaymentActionLog']>, ParentType, ContextType, RequireFields<QueryGetPaymentActionLogsArgs, 'limit' | 'offset' | 'scheduledPaymentId'>>;
  getPaymentMethodsByBookerId?: Resolver<Array<ResolversTypes['PaymentMethod']>, ParentType, ContextType, RequireFields<QueryGetPaymentMethodsByBookerIdArgs, 'bookerId'>>;
  getPaymentMethodTypeById?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetPaymentMethodTypeByIdArgs, 'paymentMethodId'>>;
  getPerformanceStats?: Resolver<ResolversTypes['PerformanceStatsOutput'], ParentType, ContextType>;
  getReferenceCoursesLink?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetReferenceCoursesLinkArgs, 'courseId'>>;
  getSelectableLocationsForAssistantApp?: Resolver<Array<ResolversTypes['AssistantSelectableLocation']>, ParentType, ContextType>;
  getSentSmsMessages?: Resolver<Array<ResolversTypes['Sms77JournalOutbound']>, ParentType, ContextType, RequireFields<QueryGetSentSmsMessagesArgs, 'journalParams'>>;
  getSettledBookings?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, Partial<QueryGetSettledBookingsArgs>>;
  getSignedUrlDo?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetSignedUrlDoArgs, 'fileName'>>;
  getSlowQueries?: Resolver<Array<ResolversTypes['SlowQueryOutput']>, ParentType, ContextType>;
  getSmsAccountBalance?: Resolver<ResolversTypes['SmsBalanceResponse'], ParentType, ContextType>;
  getSmsPricing?: Resolver<ResolversTypes['Sms77PricingResponse'], ParentType, ContextType, Partial<QueryGetSmsPricingArgs>>;
  getSmsPricingByCountryCode?: Resolver<ResolversTypes['Sms77PricingResponse'], ParentType, ContextType, RequireFields<QueryGetSmsPricingByCountryCodeArgs, 'countryCode'>>;
  getSmsReceivers?: Resolver<Array<ResolversTypes['SmsReceiver']>, ParentType, ContextType, RequireFields<QueryGetSmsReceiversArgs, 'mailDataType' | 'selectedIds'>>;
  getSmsReceiversCourse?: Resolver<Array<ResolversTypes['SmsReceiver']>, ParentType, ContextType, RequireFields<QueryGetSmsReceiversCourseArgs, 'getReceiversForCourseInput'>>;
  getTableStats?: Resolver<Array<ResolversTypes['TableStatsOutput']>, ParentType, ContextType>;
  getTenantUsers?: Resolver<Array<ResolversTypes['UserType']>, ParentType, ContextType, RequireFields<QueryGetTenantUsersArgs, 'tenantId'>>;
  getUnBilledBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, Partial<QueryGetUnBilledBookingsArgs>>;
  getUnSettledBookings?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, Partial<QueryGetUnSettledBookingsArgs>>;
  getUpcomingCoursesByTimeRange?: Resolver<ResolversTypes['CourseWithPagination'], ParentType, ContextType, RequireFields<QueryGetUpcomingCoursesByTimeRangeArgs, 'endDateTime' | 'startDateTime'>>;
  getUpcomingCoursesOccupancy?: Resolver<ResolversTypes['UpcomingCoursesOccupancy'], ParentType, ContextType, RequireFields<QueryGetUpcomingCoursesOccupancyArgs, 'endDateTime' | 'startDateTime'>>;
  getUserDetails?: Resolver<ResolversTypes['UserDetailsType'], ParentType, ContextType, RequireFields<QueryGetUserDetailsArgs, 'userId'>>;
  getUserRoles?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  getWaitlistByCourse?: Resolver<ResolversTypes['BookingWithPagination'], ParentType, ContextType, RequireFields<QueryGetWaitlistByCourseArgs, 'id'>>;
  getWaitlistCountOfCourse?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryGetWaitlistCountOfCourseArgs, 'id'>>;
  getYearEndExportDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetYearEndExportDownloadUrlArgs, 'exportId'>>;
  holidays?: Resolver<Array<ResolversTypes['Holiday']>, ParentType, ContextType>;
  holidaysByCompany?: Resolver<Array<ResolversTypes['HolidayWithDays']>, ParentType, ContextType>;
  holidaysByCompanyAndDateRange?: Resolver<Array<ResolversTypes['HolidayWithDays']>, ParentType, ContextType, RequireFields<QueryHolidaysByCompanyAndDateRangeArgs, 'end' | 'start'>>;
  holidaysByStateCode?: Resolver<Array<ResolversTypes['HolidayWithDays']>, ParentType, ContextType, RequireFields<QueryHolidaysByStateCodeArgs, 'stateCode'>>;
  installmentRate?: Resolver<ResolversTypes['InstallmentRate'], ParentType, ContextType, RequireFields<QueryInstallmentRateArgs, 'id'>>;
  installmentRates?: Resolver<Array<ResolversTypes['InstallmentRate']>, ParentType, ContextType>;
  installmentRatesByCourseId?: Resolver<Array<ResolversTypes['InstallmentRate']>, ParentType, ContextType, RequireFields<QueryInstallmentRatesByCourseIdArgs, 'courseId'>>;
  instructor?: Resolver<ResolversTypes['Instructor'], ParentType, ContextType, RequireFields<QueryInstructorArgs, 'id'>>;
  instructorInvoiceById?: Resolver<Maybe<ResolversTypes['InstructorInvoice']>, ParentType, ContextType, RequireFields<QueryInstructorInvoiceByIdArgs, 'invoiceId'>>;
  instructorInvoices?: Resolver<Array<ResolversTypes['InstructorInvoice']>, ParentType, ContextType, Partial<QueryInstructorInvoicesArgs>>;
  instructorInvoicesByInstructorAndDateRange?: Resolver<Array<ResolversTypes['InstructorInvoice']>, ParentType, ContextType, RequireFields<QueryInstructorInvoicesByInstructorAndDateRangeArgs, 'input'>>;
  instructors?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  instructorsByStaffIds?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType, RequireFields<QueryInstructorsByStaffIdsArgs, 'staffIds'>>;
  instructorsPublic?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  instructorsWithPagination?: Resolver<ResolversTypes['InstructorsWithPagination'], ParentType, ContextType, Partial<QueryInstructorsWithPaginationArgs>>;
  interestListById?: Resolver<ResolversTypes['InterestList'], ParentType, ContextType, RequireFields<QueryInterestListByIdArgs, 'id'>>;
  interestLists?: Resolver<Array<ResolversTypes['InterestList']>, ParentType, ContextType>;
  interestListsPublic?: Resolver<Array<ResolversTypes['InterestList']>, ParentType, ContextType>;
  interestRegistrations?: Resolver<ResolversTypes['InterestRegistrationWithPagination'], ParentType, ContextType, Partial<QueryInterestRegistrationsArgs>>;
  interestRegistrationsByAttendeeAndCourseType?: Resolver<Array<ResolversTypes['InterestRegistration']>, ParentType, ContextType, RequireFields<QueryInterestRegistrationsByAttendeeAndCourseTypeArgs, 'attendeeId' | 'courseTypeId'>>;
  invoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<QueryInvoiceArgs, 'id'>>;
  invoiceBodyByBookingId?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<QueryInvoiceBodyByBookingIdArgs, 'bookingId'>>;
  invoiceBodyById?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<QueryInvoiceBodyByIdArgs, 'id'>>;
  invoiceExportCourses?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QueryInvoiceExportCoursesArgs, 'includeReversals' | 'year'>>;
  invoices?: Resolver<ResolversTypes['InvoiceWithPagination'], ParentType, ContextType, Partial<QueryInvoicesArgs>>;
  invoiceTemplateSet?: Resolver<ResolversTypes['InvoiceTemplateSet'], ParentType, ContextType, RequireFields<QueryInvoiceTemplateSetArgs, 'id'>>;
  invoiceTemplateSets?: Resolver<Array<ResolversTypes['InvoiceTemplateSet']>, ParentType, ContextType>;
  isBadgeNameUnique?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsBadgeNameUniqueArgs, 'name'>>;
  isCourseNameUnique?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsCourseNameUniqueArgs, 'courseId' | 'customCourseNumberPrefix'>>;
  isCustomBankCodeUnique?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsCustomBankCodeUniqueArgs, 'bankCode'>>;
  isInstructor?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuedCertificates?: Resolver<Array<ResolversTypes['IssuedCertificate']>, ParentType, ContextType, Partial<QueryIssuedCertificatesArgs>>;
  issuedCertificatesByAttendee?: Resolver<Array<ResolversTypes['IssuedCertificate']>, ParentType, ContextType, RequireFields<QueryIssuedCertificatesByAttendeeArgs, 'attendeeId'>>;
  issuedCertificatesByCourse?: Resolver<Array<ResolversTypes['IssuedCertificate']>, ParentType, ContextType, RequireFields<QueryIssuedCertificatesByCourseArgs, 'courseId'>>;
  isUniqueEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsUniqueEmailArgs, 'email'>>;
  isUserEmailVerified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsUserEmailVerifiedArgs, 'userId'>>;
  ko9ImportProgress?: Resolver<Maybe<ResolversTypes['Ko9ImportProgressType']>, ParentType, ContextType>;
  ko9LoadCredentials?: Resolver<Maybe<ResolversTypes['Ko9LoadedCredentials']>, ParentType, ContextType>;
  koOrganizations?: Resolver<Array<ResolversTypes['KoOrganization']>, ParentType, ContextType>;
  lateEntryPricingConfiguration?: Resolver<ResolversTypes['SettingEndUserApp'], ParentType, ContextType>;
  lateEntryPricingConfigurationPublic?: Resolver<ResolversTypes['SettingEndUserApp'], ParentType, ContextType>;
  lessonBookingPlannerPreview?: Resolver<ResolversTypes['LessonBookingPlannerPreview'], ParentType, ContextType, RequireFields<QueryLessonBookingPlannerPreviewArgs, 'bookingId' | 'updateCourseAndBookingsInput'>>;
  lessonBookingPlanSummary?: Resolver<Array<ResolversTypes['LessonBookingPlanSummary']>, ParentType, ContextType, RequireFields<QueryLessonBookingPlanSummaryArgs, 'updateCourseAndBookingsInput'>>;
  listBucketsDO?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  listDatabaseBackups?: Resolver<Array<ResolversTypes['DatabaseBackup']>, ParentType, ContextType>;
  listDataExports?: Resolver<Array<ResolversTypes['DataExport']>, ParentType, ContextType>;
  listInvoiceExports?: Resolver<Array<ResolversTypes['InvoiceExport']>, ParentType, ContextType>;
  listYearEndExports?: Resolver<Array<ResolversTypes['YearEndExport']>, ParentType, ContextType>;
  LocalState?: Resolver<ResolversTypes['LocalState'], ParentType, ContextType>;
  locationById?: Resolver<ResolversTypes['Location'], ParentType, ContextType, RequireFields<QueryLocationByIdArgs, 'id'>>;
  locationContactById?: Resolver<ResolversTypes['LocationContact'], ParentType, ContextType, RequireFields<QueryLocationContactByIdArgs, 'id'>>;
  locationContacts?: Resolver<Array<ResolversTypes['LocationContact']>, ParentType, ContextType>;
  locationContactsByLocation?: Resolver<Array<ResolversTypes['LocationContact']>, ParentType, ContextType, RequireFields<QueryLocationContactsByLocationArgs, 'locationId'>>;
  locations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  locationsByCity?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<QueryLocationsByCityArgs, 'city'>>;
  locationsByLocationContactId?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<QueryLocationsByLocationContactIdArgs, 'id'>>;
  locationsPublic?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  locationsSortedByCity?: Resolver<Array<ResolversTypes['LocationsGroupedByCity']>, ParentType, ContextType>;
  locationsWithPagination?: Resolver<ResolversTypes['LocationsWithPagination'], ParentType, ContextType, Partial<QueryLocationsWithPaginationArgs>>;
  maintenanceStatus?: Resolver<ResolversTypes['MaintenanceStatus'], ParentType, ContextType>;
  missingBankDataList?: Resolver<Array<ResolversTypes['MissingBankData']>, ParentType, ContextType>;
  mollieAllMethodsForWhitelist?: Resolver<Array<ResolversTypes['MollieMethodInfo']>, ParentType, ContextType>;
  mollieAvailableMethods?: Resolver<Array<ResolversTypes['MollieMethodInfo']>, ParentType, ContextType>;
  mollieConnectionStatus?: Resolver<ResolversTypes['MollieConnectionStatus'], ParentType, ContextType>;
  mollieDowngradeImpact?: Resolver<ResolversTypes['MollieDowngradeImpact'], ParentType, ContextType, RequireFields<QueryMollieDowngradeImpactArgs, 'koOrganizationId'>>;
  molliePaymentStatus?: Resolver<Maybe<ResolversTypes['MolliePaymentStatus']>, ParentType, ContextType, RequireFields<QueryMolliePaymentStatusArgs, 'scheduledPaymentId'>>;
  molliePaymentStatusFromEndUserApp?: Resolver<Maybe<ResolversTypes['MolliePaymentStatus']>, ParentType, ContextType, RequireFields<QueryMolliePaymentStatusFromEndUserAppArgs, 'scheduledPaymentId'>>;
  molliePaymentStatusFromEndUserAppPublic?: Resolver<Maybe<ResolversTypes['MolliePaymentStatusPublic']>, ParentType, ContextType, RequireFields<QueryMolliePaymentStatusFromEndUserAppPublicArgs, 'scheduledPaymentId'>>;
  mollieRefunds?: Resolver<ResolversTypes['MollieRefundsWithPagination'], ParentType, ContextType, Partial<QueryMollieRefundsArgs>>;
  multipleCourseLessonsCollisionCheck?: Resolver<Array<ResolversTypes['CourseLessonWithIndexOfCourseLessonInCourse']>, ParentType, ContextType, RequireFields<QueryMultipleCourseLessonsCollisionCheckArgs, 'collitionCheckInput'>>;
  myProfile?: Resolver<ResolversTypes['MyProfileType'], ParentType, ContextType>;
  newsletterBookerStatus?: Resolver<ResolversTypes['NewsletterBookerStatus'], ParentType, ContextType, RequireFields<QueryNewsletterBookerStatusArgs, 'bookerId'>>;
  newsletterLocationLists?: Resolver<Array<ResolversTypes['NewsletterLocationList']>, ParentType, ContextType>;
  newsletterLog?: Resolver<Array<ResolversTypes['NewsletterLog']>, ParentType, ContextType, Partial<QueryNewsletterLogArgs>>;
  newsletterOverview?: Resolver<ResolversTypes['NewsletterOverviewResult'], ParentType, ContextType>;
  newsletterRecipientCounts?: Resolver<Array<ResolversTypes['NewsletterRecipientCount']>, ParentType, ContextType>;
  newsletterRulesPreview?: Resolver<ResolversTypes['NewsletterRulesPreview'], ParentType, ContextType, RequireFields<QueryNewsletterRulesPreviewArgs, 'input'>>;
  newsletterSettings?: Resolver<ResolversTypes['NewsletterSettings'], ParentType, ContextType>;
  notificationsByBookerId?: Resolver<ResolversTypes['EmailNotificationWithPagination'], ParentType, ContextType, RequireFields<QueryNotificationsByBookerIdArgs, 'bookerId'>>;
  notificationsByBookerOrEmail?: Resolver<ResolversTypes['EmailNotificationWithPagination'], ParentType, ContextType, RequireFields<QueryNotificationsByBookerOrEmailArgs, 'bookerId'>>;
  notificationsByBooking?: Resolver<Array<ResolversTypes['EmailNotification']>, ParentType, ContextType, RequireFields<QueryNotificationsByBookingArgs, 'bookingId'>>;
  ownerEmail?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType>;
  paidScheduledPayments?: Resolver<ResolversTypes['ScheduledPaymentsWithPagination'], ParentType, ContextType, RequireFields<QueryPaidScheduledPaymentsArgs, 'includeDeleted' | 'respectArchiveSetting'>>;
  participationPrerequisite?: Resolver<ResolversTypes['ParticipationPrerequisites'], ParentType, ContextType, RequireFields<QueryParticipationPrerequisiteArgs, 'id'>>;
  participationPrerequisites?: Resolver<Array<ResolversTypes['ParticipationPrerequisites']>, ParentType, ContextType>;
  participationPrerequisitesByCourseTypeId?: Resolver<Array<ResolversTypes['ParticipationPrerequisites']>, ParentType, ContextType, RequireFields<QueryParticipationPrerequisitesByCourseTypeIdArgs, 'courseTypeId'>>;
  paymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType, RequireFields<QueryPaymentMethodArgs, 'id'>>;
  paymentMethods?: Resolver<Array<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType>;
  platformConfig?: Resolver<ResolversTypes['PlatformConfig'], ParentType, ContextType>;
  prerequisiteCourses?: Resolver<ResolversTypes['CourseWithPagination'], ParentType, ContextType, Partial<QueryPrerequisiteCoursesArgs>>;
  previewCertificatePdf?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryPreviewCertificatePdfArgs, 'input'>>;
  previewSettledBookingCorrection?: Resolver<ResolversTypes['SettledBookingCorrectionPreview'], ParentType, ContextType, RequireFields<QueryPreviewSettledBookingCorrectionArgs, 'bookingId' | 'input'>>;
  renderBatchTemplateForBookingsLetterPdf?: Resolver<ResolversTypes['RenderedBatchLetterPdfData'], ParentType, ContextType, RequireFields<QueryRenderBatchTemplateForBookingsLetterPdfArgs, 'input'>>;
  renderBatchTemplateForCourseLetterPdf?: Resolver<ResolversTypes['RenderedBatchLetterPdfData'], ParentType, ContextType, RequireFields<QueryRenderBatchTemplateForCourseLetterPdfArgs, 'input'>>;
  renderTemplateForLetterPdf?: Resolver<ResolversTypes['RenderedLetterPdfData'], ParentType, ContextType, RequireFields<QueryRenderTemplateForLetterPdfArgs, 'input'>>;
  renderTextBlockPreview?: Resolver<ResolversTypes['TextBlockPreviewResult'], ParentType, ContextType, RequireFields<QueryRenderTextBlockPreviewArgs, 'input'>>;
  resolveTenantRecipients?: Resolver<Array<ResolversTypes['TenantRecipientType']>, ParentType, ContextType, RequireFields<QueryResolveTenantRecipientsArgs, 'tenantIds'>>;
  reversalInvoiceBodyById?: Resolver<ResolversTypes['ReversalInvoice'], ParentType, ContextType, RequireFields<QueryReversalInvoiceBodyByIdArgs, 'id'>>;
  reversalInvoices?: Resolver<ResolversTypes['ReversalInvoiceWithPagination'], ParentType, ContextType, Partial<QueryReversalInvoicesArgs>>;
  scheduledPayment?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType, RequireFields<QueryScheduledPaymentArgs, 'id'>>;
  scheduledPaymentById?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<QueryScheduledPaymentByIdArgs, 'id'>>;
  scheduledPayments?: Resolver<ResolversTypes['ScheduledPaymentsWithPagination'], ParentType, ContextType, Partial<QueryScheduledPaymentsArgs>>;
  scheduledPaymentsByBookerId?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType, RequireFields<QueryScheduledPaymentsByBookerIdArgs, 'bookerId'>>;
  scheduledPaymentsByBookingId?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType, RequireFields<QueryScheduledPaymentsByBookingIdArgs, 'bookingId'>>;
  scheduledPaymentSummary?: Resolver<ResolversTypes['ScheduledPaymentSummary'], ParentType, ContextType, RequireFields<QueryScheduledPaymentSummaryArgs, 'paymentDone' | 'respectArchiveSetting'>>;
  scheduledPaymentsWithMissingInvoiceIds?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  searchAttendeesByFullName?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType, RequireFields<QuerySearchAttendeesByFullNameArgs, 'name'>>;
  searchBankTransactionCandidates?: Resolver<Array<ResolversTypes['BankTransactionCandidate']>, ParentType, ContextType, RequireFields<QuerySearchBankTransactionCandidatesArgs, 'id' | 'searchKey'>>;
  searchBilledPayments?: Resolver<Array<ResolversTypes['PaymentMethod']>, ParentType, ContextType, RequireFields<QuerySearchBilledPaymentsArgs, 'searchKey'>>;
  searchBookerByStreetAndHouseNumberAndPpostCodeAndCity?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QuerySearchBookerByStreetAndHouseNumberAndPpostCodeAndCityArgs, 'searchKey'>>;
  searchBookersByFirstAndLastName?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QuerySearchBookersByFirstAndLastNameArgs, 'searchKey'>>;
  searchBookersByStreetAndHouseNumberAndPostCodeAndCity?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType, RequireFields<QuerySearchBookersByStreetAndHouseNumberAndPostCodeAndCityArgs, 'searchKey'>>;
  searchBookingByBookingNumberAndBookingNumberPrefix?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QuerySearchBookingByBookingNumberAndBookingNumberPrefixArgs, 'searchKey'>>;
  searchBookingByCourseLocationPrefixAndCourseNumber?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QuerySearchBookingByCourseLocationPrefixAndCourseNumberArgs, 'searchKey'>>;
  searchCourseByCourseLocationPrefixAndCourseNumber?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QuerySearchCourseByCourseLocationPrefixAndCourseNumberArgs, 'searchKey'>>;
  searchCourseByInstructorFirstNameAndLastName?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QuerySearchCourseByInstructorFirstNameAndLastNameArgs, 'searchKey'>>;
  searchCourseHistory?: Resolver<ResolversTypes['CourseHistoryWithPagination'], ParentType, ContextType, Partial<QuerySearchCourseHistoryArgs>>;
  searchCustomerByCustomerNumberPrefixAndCustomerNumber?: Resolver<Array<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<QuerySearchCustomerByCustomerNumberPrefixAndCustomerNumberArgs, 'searchKey'>>;
  searchCustomerByFirstNameAndLastName?: Resolver<Array<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<QuerySearchCustomerByFirstNameAndLastNameArgs, 'searchKey'>>;
  searchInvoicesByCourseNumber?: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<QuerySearchInvoicesByCourseNumberArgs, 'courseNumber'>>;
  searchInvoicesByInvoiceNumberAndInvoiceNumberPrefix?: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<QuerySearchInvoicesByInvoiceNumberAndInvoiceNumberPrefixArgs, 'searchKey'>>;
  searchLocationsByName?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<QuerySearchLocationsByNameArgs, 'name'>>;
  searchLocationsByPhoneNumberAndEmail?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<QuerySearchLocationsByPhoneNumberAndEmailArgs, 'searchKey'>>;
  searchStaffByFullnameAndAddress?: Resolver<Array<ResolversTypes['Staff']>, ParentType, ContextType, RequireFields<QuerySearchStaffByFullnameAndAddressArgs, 'searchKey'>>;
  searchUnBilledPayments?: Resolver<Array<ResolversTypes['PaymentMethod']>, ParentType, ContextType, RequireFields<QuerySearchUnBilledPaymentsArgs, 'searchKey'>>;
  searchUnSettledBooking?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<QuerySearchUnSettledBookingArgs, 'searchKey'>>;
  sentEmailStatusFromMailjet?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QuerySentEmailStatusFromMailjetArgs, 'messageID'>>;
  settingEndUserApp?: Resolver<ResolversTypes['SettingEndUserApp'], ParentType, ContextType>;
  settingEndUserAppHistory?: Resolver<Array<ResolversTypes['SettingEndUserAppHistory']>, ParentType, ContextType>;
  settingEndUserAppPublic?: Resolver<ResolversTypes['SettingEndUserApp'], ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['Setting'], ParentType, ContextType>;
  staffSharingLogin?: Resolver<Array<ResolversTypes['SharedLoginStaff']>, ParentType, ContextType, RequireFields<QueryStaffSharingLoginArgs, 'userId'>>;
  staffVisibilityRules?: Resolver<ResolversTypes['StaffVisibilityRules'], ParentType, ContextType>;
  staffVisibilityRulesHistory?: Resolver<Array<ResolversTypes['StaffVisibilityRulesHistoryEntry']>, ParentType, ContextType>;
  stressTestUserQuery?: Resolver<Array<ResolversTypes['UserType']>, ParentType, ContextType, RequireFields<QueryStressTestUserQueryArgs, 'tenantId'>>;
  superuserDocs?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QuerySuperuserDocsArgs, 'slug'>>;
  superuserDocsIndex?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  swissQRFileById?: Resolver<Maybe<ResolversTypes['SwissQRFile']>, ParentType, ContextType, RequireFields<QuerySwissQrFileByIdArgs, 'id'>>;
  swissQRFiles?: Resolver<Array<ResolversTypes['SwissQRFile']>, ParentType, ContextType>;
  swissQRFilesOverview?: Resolver<ResolversTypes['SwissQRFileOverviewWithPagination'], ParentType, ContextType, Partial<QuerySwissQrFilesOverviewArgs>>;
  swissQRRecordContext?: Resolver<ResolversTypes['SwissQRRecordContext'], ParentType, ContextType, RequireFields<QuerySwissQrRecordContextArgs, 'recordId'>>;
  template?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<QueryTemplateArgs, 'id'>>;
  templateByType?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<QueryTemplateByTypeArgs, 'templateType'>>;
  templates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType, Partial<QueryTemplatesArgs>>;
  templatesWithPagination?: Resolver<ResolversTypes['TemplatesWithPagination'], ParentType, ContextType, Partial<QueryTemplatesWithPaginationArgs>>;
  tenantActivitySummaries?: Resolver<Array<ResolversTypes['TenantActivitySummary']>, ParentType, ContextType>;
  tenantActivitySummary?: Resolver<ResolversTypes['TenantActivitySummary'], ParentType, ContextType, RequireFields<QueryTenantActivitySummaryArgs, 'koOrganizationId'>>;
  tenantChangeVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tenantDeletionImpact?: Resolver<ResolversTypes['TenantDeletionImpact'], ParentType, ContextType, RequireFields<QueryTenantDeletionImpactArgs, 'koOrganizationId'>>;
  tenantDeletionStatus?: Resolver<ResolversTypes['TenantDeletionStatus'], ParentType, ContextType, RequireFields<QueryTenantDeletionStatusArgs, 'koOrganizationId'>>;
  tenantMetrics?: Resolver<Array<ResolversTypes['TenantMetrics']>, ParentType, ContextType, RequireFields<QueryTenantMetricsArgs, 'from' | 'to'>>;
  tenantMetricsAiSummary?: Resolver<ResolversTypes['TenantMetricsAiSummary'], ParentType, ContextType>;
  tenantNotifications?: Resolver<Array<ResolversTypes['TenantNotification']>, ParentType, ContextType, Partial<QueryTenantNotificationsArgs>>;
  tenantSeatUsage?: Resolver<Array<ResolversTypes['TenantSeatUsage']>, ParentType, ContextType>;
  tenantStaffMetrics?: Resolver<Array<ResolversTypes['TenantStaffMember']>, ParentType, ContextType, RequireFields<QueryTenantStaffMetricsArgs, 'from' | 'koOrganizationId' | 'to'>>;
  tenantsWithPagination?: Resolver<ResolversTypes['KoOrganizationWithPagination'], ParentType, ContextType, Partial<QueryTenantsWithPaginationArgs>>;
  testFusioAuthFunctions?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<QueryTestFusioAuthFunctionsArgs, 'userId'>>;
  transferBulkPlanPreview?: Resolver<ResolversTypes['TransferBulkPlanPreview'], ParentType, ContextType, RequireFields<QueryTransferBulkPlanPreviewArgs, 'input'>>;
  transferPlanPreview?: Resolver<ResolversTypes['TransferPlanPreview'], ParentType, ContextType, RequireFields<QueryTransferPlanPreviewArgs, 'input'>>;
  unpaidScheduledPayments?: Resolver<ResolversTypes['ScheduledPaymentsWithPagination'], ParentType, ContextType, RequireFields<QueryUnpaidScheduledPaymentsArgs, 'dunningDue' | 'includeDeleted' | 'respectArchiveSetting'>>;
  unpaidScheduledPaymentsZeroValues?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType, Partial<QueryUnpaidScheduledPaymentsZeroValuesArgs>>;
  userSettings?: Resolver<Maybe<ResolversTypes['UserSetting']>, ParentType, ContextType>;
  withdrawals?: Resolver<Array<ResolversTypes['WithdrawalRequest']>, ParentType, ContextType>;
};

export type AccountForEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountForEmail'] = ResolversParentTypes['AccountForEmail']> = {
  callerMayLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isStaffAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedBooker?: Resolver<Maybe<ResolversTypes['AccountForEmailLinkedBooker']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountForEmailLinkedBookerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountForEmailLinkedBooker'] = ResolversParentTypes['AccountForEmailLinkedBooker']> = {
  customerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountLinksResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountLinks'] = ResolversParentTypes['AccountLinks']> = {
  bookers?: Resolver<Array<ResolversTypes['AccountForEmailLinkedBooker']>, ParentType, ContextType>;
  staff?: Resolver<Array<ResolversTypes['AccountLinksStaff']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountLinksStaffResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountLinksStaff'] = ResolversParentTypes['AccountLinksStaff']> = {
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnnouncementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDismissible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMinimizable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  koOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['AnnouncementPriority'], ParentType, ContextType>;
  targetUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetUrlLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnnouncementType'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type AnnouncementPriorityResolvers = { High: 'undefined', Low: 'undefined', Medium: 'undefined' };

export type AnnouncementTypeResolvers = { Error: 'undefined', Info: 'undefined', Success: 'undefined', Warning: 'undefined' };

export type ActiveDunningResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveDunning'] = ResolversParentTypes['ActiveDunning']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentOpenAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['DunningLevel'], ParentType, ContextType>;
  openAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DunningLevelResolvers = { Level1: 'undefined', Level2: 'undefined', Level3: 'undefined', Reminder: 'undefined' };

export type AdminManagementEmailInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminManagementEmailInfo'] = ResolversParentTypes['AdminManagementEmailInfo']> = {
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AdminManagementEmailStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminManagementEmailStatusResolvers = { ALREADY_ADMIN: 'undefined', EXISTING_ACCOUNT: 'undefined', EXISTING_STAFF: 'undefined', FREE: 'undefined', UNAVAILABLE: 'undefined' };

export type AdminManagementOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminManagementOverview'] = ResolversParentTypes['AdminManagementOverview']> = {
  adminSeatsLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  adminSeatsUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['AdminManagementUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminManagementUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminManagementUser'] = ResolversParentTypes['AdminManagementUser']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSelf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  staffNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstructorCourseGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstructorCourseGroup'] = ResolversParentTypes['InstructorCourseGroup']> = {
  courseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  courseIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  instructorEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instructorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  instructorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendanceListArchiveResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendanceListArchive'] = ResolversParentTypes['AttendanceListArchive']> = {
  courseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateRangeEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  dateRangeStart?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fileSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  instructorNames?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobGroupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  locationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkJobStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkJobStatus'] = ResolversParentTypes['BulkJobStatus']> = {
  active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  downloadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  jobGroupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Booking'] = ResolversParentTypes['Booking']> = {
  additionalInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agbConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attendanceListNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attendee?: Resolver<Maybe<ResolversTypes['Attendee']>, ParentType, ContextType>;
  attendeeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookedBy?: Resolver<ResolversTypes['BookedBy'], ParentType, ContextType>;
  bookedLessonCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bookingConfirmationSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookingHistory?: Resolver<Maybe<Array<ResolversTypes['BookingHistory']>>, ParentType, ContextType>;
  bookingNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelationSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  canceled?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancelRestAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cancelRestHandling?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelSettledAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  courseLessonBookings?: Resolver<Maybe<Array<ResolversTypes['CourseLessonBooking']>>, ParentType, ContextType>;
  courseLessons?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType>;
  coursePrice?: Resolver<ResolversTypes['CoursePrice'], ParentType, ContextType>;
  coursePriceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditedBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountCode?: Resolver<Maybe<ResolversTypes['DiscountCode']>, ParentType, ContextType>;
  discountCodeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  discountCodeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailNotifications?: Resolver<Maybe<Array<ResolversTypes['EmailNotification']>>, ParentType, ContextType>;
  foundUs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hasDiscountCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType>;
  invoiceSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  isSettled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSpecial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lessonLegacyGap?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lessonPricingMode?: Resolver<Maybe<ResolversTypes['LessonPricingMode']>, ParentType, ContextType>;
  lessonRateMonthOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lessonSelectionMode?: Resolver<Maybe<ResolversTypes['BookingLessonSelectionMode']>, ParentType, ContextType>;
  lessonUnitPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  memberDiscount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mergedBookingIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  molliePaymentAttempts?: Resolver<Array<ResolversTypes['MolliePaymentAttempt']>, ParentType, ContextType>;
  monthlySchedule?: Resolver<ResolversTypes['MonthlySchedule'], ParentType, ContextType>;
  netPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  noticeBooker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noticeStaff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  paymentType?: Resolver<Maybe<ResolversTypes['PaymentType']>, ParentType, ContextType>;
  pricingCalculatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  pricingCalculationVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pricingFingerprint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pricingReason?: Resolver<Maybe<ResolversTypes['BookingPricingReason']>, ParentType, ContextType>;
  pricingSnapshot?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  privacyStatementConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reversalInvoice?: Resolver<Maybe<ResolversTypes['ReversalInvoice']>, ParentType, ContextType>;
  scheduledPayments?: Resolver<Maybe<Array<ResolversTypes['ScheduledPayment']>>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  transferIn?: Resolver<Maybe<ResolversTypes['BookingTransferIn']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  utmSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  waitingListConfirmationSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  waitListCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attendee'] = ResolversParentTypes['Attendee']> = {
  addition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  annotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeXAttendee?: Resolver<Maybe<Array<ResolversTypes['AttendeeBadge']>>, ParentType, ContextType>;
  billingAddition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCompanyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingFirstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingLastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingPostCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthday?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  booker?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  bookerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookings?: Resolver<Maybe<Array<ResolversTypes['Booking']>>, ParentType, ContextType>;
  bookingsKo9?: Resolver<Maybe<Array<ResolversTypes['BookingsKo9']>>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['CreatedBy']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  customerNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  customerNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultPaymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  defaultPaymentMethodId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  deletable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  erasedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['Gender'], ParentType, ContextType>;
  hasBillingAddress?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  member?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startedCourses?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeeBadgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendeeBadge'] = ResolversParentTypes['AttendeeBadge']> = {
  allRequirementsFulfilled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attendee?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType>;
  attendeeBadgeRequirements?: Resolver<Maybe<Array<ResolversTypes['AttendeeBadgeRequirement']>>, ParentType, ContextType>;
  attendeeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  badge?: Resolver<ResolversTypes['Badge'], ParentType, ContextType>;
  badgeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfAchivement?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeeBadgeRequirementResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendeeBadgeRequirement'] = ResolversParentTypes['AttendeeBadgeRequirement']> = {
  attendeeBadgeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  badgeRequirement?: Resolver<ResolversTypes['BadgeRequirement'], ParentType, ContextType>;
  badgeRequirementId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfFulfillment?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BadgeRequirementResolvers<ContextType = any, ParentType extends ResolversParentTypes['BadgeRequirement'] = ResolversParentTypes['BadgeRequirement']> = {
  badgeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BadgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Badge'] = ResolversParentTypes['Badge']> = {
  abbreviation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  badgeRequirements?: Resolver<Maybe<Array<ResolversTypes['BadgeRequirement']>>, ParentType, ContextType>;
  badgeXAttendee?: Resolver<Maybe<Array<ResolversTypes['AttendeeBadge']>>, ParentType, ContextType>;
  certificateTemplateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  graphicUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  signedGraphicUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Booker'] = ResolversParentTypes['Booker']> = {
  addition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  annotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attendees?: Resolver<Maybe<Array<ResolversTypes['Attendee']>>, ParentType, ContextType>;
  billingAddition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCompanyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingFirstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingLastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingPostCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthday?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['CreatedBy']>, ParentType, ContextType>;
  createdByUser?: Resolver<Maybe<ResolversTypes['UserType']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  customer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  customerNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  customerNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dsgvo?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erasedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['Gender']>, ParentType, ContextType>;
  hasBillingAddress?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  healthInsuranceFund?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialContact?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newsletter?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nonDisclosureNotice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethods?: Resolver<Maybe<Array<ResolversTypes['PaymentMethod']>>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatedByResolvers = { ADMIN_APP: 'undefined', DUMMY_DATA: 'undefined', END_USER_APP: 'undefined', IMPORT: 'undefined' };

export type UserTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserType'] = ResolversParentTypes['UserType']> = {
  accessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  booker?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  customerNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  erasedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['Gender'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenderResolvers = { Diverse: 'undefined', Female: 'undefined', Male: 'undefined', NotDefined: 'undefined' };

export type PaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethod'] = ResolversParentTypes['PaymentMethod']> = {
  bank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankTransfer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  booker?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  bookerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookings?: Resolver<Maybe<Array<ResolversTypes['Booking']>>, ParentType, ContextType>;
  cash?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['CreatedBy']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditCardAccountholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditcardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cvc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  esr?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  iban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  onlinePayment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  paypalAccountholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheduledPayments?: Resolver<Maybe<Array<ResolversTypes['ScheduledPayment']>>, ParentType, ContextType>;
  sepaAccountholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PaymentTransferType']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledPayment'] = ResolversParentTypes['ScheduledPayment']> = {
  additionalItemId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  booking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  carriedOverAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['ScheduledPaymentMethodChangeUser']>, ParentType, ContextType>;
  deletedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dunningStatus?: Resolver<Maybe<ResolversTypes['BookingDunningStatus']>, ParentType, ContextType>;
  exportedSepaXmlId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType>;
  invoiceId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isWaitlistBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  keptOnCancelAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  latestMolliePaymentAttempt?: Resolver<Maybe<ResolversTypes['LatestMollieAttemptBadge']>, ParentType, ContextType>;
  manuallyAddedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  manuallyAdjustedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  manuallyAdjustedBy?: Resolver<Maybe<ResolversTypes['ScheduledPaymentMethodChangeUser']>, ParentType, ContextType>;
  manuallyAdjustedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  methodChangedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  methodChangedBy?: Resolver<Maybe<ResolversTypes['ScheduledPaymentMethodChangeUser']>, ParentType, ContextType>;
  methodChangedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mollieErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mollieManagedFlow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mollieMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  molliePaidAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  molliePaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  molliePaymentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  molliePaymentUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mollieRetryCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  openAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDone?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  paymentTransferType?: Resolver<Maybe<ResolversTypes['PaymentTransferType']>, ParentType, ContextType>;
  postKind?: Resolver<ResolversTypes['BookingPostKind'], ParentType, ContextType>;
  providerRefundedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refundedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sepaClearance?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sepaCollectionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  sepaCollectionStatus?: Resolver<Maybe<ResolversTypes['SepaCollectionStatus']>, ParentType, ContextType>;
  surplusMolliePaymentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferFromBookingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferPaidAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ScheduledPaymentType'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPaymentMethodChangeUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledPaymentMethodChangeUser'] = ResolversParentTypes['ScheduledPaymentMethodChangeUser']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingDunningStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingDunningStatus'] = ResolversParentTypes['BookingDunningStatus']> = {
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  due?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['DunningLevel']>, ParentType, ContextType>;
  levelDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  nextDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextLevel?: Resolver<Maybe<ResolversTypes['DunningLevel']>, ParentType, ContextType>;
  pausedUntil?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  billed?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  booking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  correctionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoiceFileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  invoiceNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  koOrganization?: Resolver<ResolversTypes['KoOrganization'], ParentType, ContextType>;
  mollieGenerated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  qrReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheduledPayments?: Resolver<Maybe<Array<ResolversTypes['ScheduledPayment']>>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KoOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['KoOrganization'] = ResolversParentTypes['KoOrganization']> = {
  companySettings?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType>;
  companySettingsId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deactivatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletionState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailSignature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledDeletionAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['Setting'], ParentType, ContextType>;
  settingsId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['Subscription']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  subscriptionType?: Resolver<ResolversTypes['SubscriptionType'], ParentType, ContextType>;
  updatedByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanySettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanySetting'] = ResolversParentTypes['CompanySetting']> = {
  agb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankAccountHolder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BIC?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessForm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commercialRegister?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creditorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  host?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IBAN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  koOrganization?: Resolver<ResolversTypes['KoOrganization'], ParentType, ContextType>;
  localCourt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mailjetSenderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerCity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerCountry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerFax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerLastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerStreet?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerStreetNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerZip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privacyStatement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  qrIban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendFromEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Setting'] = ResolversParentTypes['Setting']> = {
  autoIssuePaymentLinkOnExpiry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  autoSendMollieReminderMails?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bankTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bankTransferProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  cancelationFeeDefault?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cash?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  courseEditCorrectionInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  courseEditCorrectionInvoiceMail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  courseNumberFormat?: Resolver<ResolversTypes['CourseNumberFormat'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  customerNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultVat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningAttachInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dunningLevel1Days?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningLevel1Enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dunningLevel1Fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningLevel2Days?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningLevel2Enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dunningLevel2Fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningLevel3Days?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningLevel3Enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dunningLevel3Fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningNewDueDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningReminderDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dunningReminderEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  enabledMollieMethods?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  esr?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  featureMollie?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstInstallmentDayOfMonth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  firstInstallmentMonth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  grossNet?: Resolver<ResolversTypes['GrossNet'], ParentType, ContextType>;
  holidayCountryCode?: Resolver<Maybe<ResolversTypes['CountryCode']>, ParentType, ContextType>;
  holidayStateCode?: Resolver<Maybe<ResolversTypes['StateCode']>, ParentType, ContextType>;
  holidayStateColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interestListShowNoteFieldDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  invoiceDueDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  invoiceNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mollieAutoInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mollieChargebackFeePassthrough?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mollieInvoiceSendMode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mollieRefundMode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  newCustomerDetectionEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentLinkValidityDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  restrictStaffPaymentMethods?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sendPaymentLinkOnAdminBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sendReversalInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sepaDebit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sepaDebitProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  sevenIoApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smsSenderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transferDefaultOldBookingOption?: Resolver<ResolversTypes['TransferOldBookingDefault'], ParentType, ContextType>;
  transferDefaultPriceOption?: Resolver<ResolversTypes['TransferPriceDefault'], ParentType, ContextType>;
  transferMode?: Resolver<ResolversTypes['TransferMode'], ParentType, ContextType>;
  transferSendMail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vatAppearance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentProviderResolvers = { Manual: 'undefined', Mollie: 'undefined' };

export type CourseNumberFormatResolvers = { CourseLocationPrefix: 'undefined', CourseTypePrefix: 'undefined', CustomPrefix: 'undefined', NoPrefix: 'undefined' };

export type CurrencyResolvers = { Chf: 'undefined', Eur: 'undefined', Gbp: 'undefined', Usd: 'undefined' };

export type GrossNetResolvers = { Gross: 'undefined', Net: 'undefined' };

export type CountryCodeResolvers = { At: 'undefined', Be: 'undefined', Ch: 'undefined', De: 'undefined', Dk: 'undefined', Nl: 'undefined' };

export type StateCodeResolvers = { AtKae: 'undefined', AtNoe: 'undefined', AtOoe: 'undefined', BL: 'undefined', CUSTOM: 'undefined', DeBb: 'undefined', DeBe: 'undefined', DeBw: 'undefined', DeBy: 'undefined', DeHb: 'undefined', DeHe: 'undefined', DeHh: 'undefined', DeMv: 'undefined', DeNi: 'undefined', DeNw: 'undefined', DeRp: 'undefined', DeSh: 'undefined', DeSl: 'undefined', DeSn: 'undefined', DeSt: 'undefined', DeTh: 'undefined', NATIONAL: 'undefined', SB: 'undefined', SM: 'undefined', TI: 'undefined', VA: 'undefined', WI: 'undefined' };

export type TransferOldBookingDefaultResolvers = { Auto: 'undefined', MoneyFollowsBooking: 'undefined' };

export type TransferPriceDefaultResolvers = { CoursePrice: 'undefined', KeepSourceDiscount: 'undefined' };

export type TransferModeResolvers = { Legacy: 'undefined', Wizard: 'undefined' };

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  createDate?: SubscriptionResolver<ResolversTypes['DateTime'], "createDate", ParentType, ContextType>;
  featureAdditionalItems?: SubscriptionResolver<ResolversTypes['Boolean'], "featureAdditionalItems", ParentType, ContextType>;
  featureAdminManagement?: SubscriptionResolver<ResolversTypes['Boolean'], "featureAdminManagement", ParentType, ContextType>;
  featureAreaManager?: SubscriptionResolver<ResolversTypes['Boolean'], "featureAreaManager", ParentType, ContextType>;
  featureAssistantApp?: SubscriptionResolver<ResolversTypes['Boolean'], "featureAssistantApp", ParentType, ContextType>;
  featureAttendanceListBulk?: SubscriptionResolver<ResolversTypes['Boolean'], "featureAttendanceListBulk", ParentType, ContextType>;
  featureBankImport?: SubscriptionResolver<ResolversTypes['Boolean'], "featureBankImport", ParentType, ContextType>;
  featureBillingStatus?: SubscriptionResolver<ResolversTypes['Boolean'], "featureBillingStatus", ParentType, ContextType>;
  featureCalendarFeed?: SubscriptionResolver<ResolversTypes['Boolean'], "featureCalendarFeed", ParentType, ContextType>;
  featureDataErasure?: SubscriptionResolver<ResolversTypes['Boolean'], "featureDataErasure", ParentType, ContextType>;
  featureDataExport?: SubscriptionResolver<ResolversTypes['Boolean'], "featureDataExport", ParentType, ContextType>;
  featureDiscountCodes?: SubscriptionResolver<ResolversTypes['Boolean'], "featureDiscountCodes", ParentType, ContextType>;
  featureDunning?: SubscriptionResolver<ResolversTypes['Boolean'], "featureDunning", ParentType, ContextType>;
  featureExport?: SubscriptionResolver<ResolversTypes['Boolean'], "featureExport", ParentType, ContextType>;
  featureExportInstructorLessons?: SubscriptionResolver<ResolversTypes['Boolean'], "featureExportInstructorLessons", ParentType, ContextType>;
  featureExtendedBadges?: SubscriptionResolver<ResolversTypes['Boolean'], "featureExtendedBadges", ParentType, ContextType>;
  featureHelpLinks?: SubscriptionResolver<ResolversTypes['Boolean'], "featureHelpLinks", ParentType, ContextType>;
  featureInterestList?: SubscriptionResolver<ResolversTypes['Boolean'], "featureInterestList", ParentType, ContextType>;
  featureInvoicePdfPuppeteer?: SubscriptionResolver<ResolversTypes['Boolean'], "featureInvoicePdfPuppeteer", ParentType, ContextType>;
  featureLessonBooking?: SubscriptionResolver<ResolversTypes['Boolean'], "featureLessonBooking", ParentType, ContextType>;
  featureLiveRefresh?: SubscriptionResolver<ResolversTypes['Boolean'], "featureLiveRefresh", ParentType, ContextType>;
  featureMailMerge?: SubscriptionResolver<ResolversTypes['Boolean'], "featureMailMerge", ParentType, ContextType>;
  featureMollie?: SubscriptionResolver<ResolversTypes['Boolean'], "featureMollie", ParentType, ContextType>;
  featureNewsletter?: SubscriptionResolver<ResolversTypes['Boolean'], "featureNewsletter", ParentType, ContextType>;
  featurePrerequisiteCourses?: SubscriptionResolver<ResolversTypes['Boolean'], "featurePrerequisiteCourses", ParentType, ContextType>;
  featureRefactoredCourseDetails?: SubscriptionResolver<ResolversTypes['Boolean'], "featureRefactoredCourseDetails", ParentType, ContextType>;
  featureSms?: SubscriptionResolver<ResolversTypes['Boolean'], "featureSms", ParentType, ContextType>;
  featureStaffLogin?: SubscriptionResolver<ResolversTypes['Boolean'], "featureStaffLogin", ParentType, ContextType>;
  featureTransferWizard?: SubscriptionResolver<ResolversTypes['Boolean'], "featureTransferWizard", ParentType, ContextType>;
  featureWebModulAdminAccess?: SubscriptionResolver<ResolversTypes['Boolean'], "featureWebModulAdminAccess", ParentType, ContextType>;
  featureWeekPlaner?: SubscriptionResolver<ResolversTypes['Boolean'], "featureWeekPlaner", ParentType, ContextType>;
  holidays?: SubscriptionResolver<ResolversTypes['Boolean'], "holidays", ParentType, ContextType>;
  id?: SubscriptionResolver<ResolversTypes['ID'], "id", ParentType, ContextType>;
  maxBookingsPerYear?: SubscriptionResolver<Maybe<ResolversTypes['Int']>, "maxBookingsPerYear", ParentType, ContextType>;
  maxLocations?: SubscriptionResolver<Maybe<ResolversTypes['Int']>, "maxLocations", ParentType, ContextType>;
  mollieApplicationFeeFixed?: SubscriptionResolver<ResolversTypes['Float'], "mollieApplicationFeeFixed", ParentType, ContextType>;
  mollieApplicationFeePercent?: SubscriptionResolver<ResolversTypes['Float'], "mollieApplicationFeePercent", ParentType, ContextType>;
  monthlyFee?: SubscriptionResolver<ResolversTypes['Float'], "monthlyFee", ParentType, ContextType>;
  seatsAdmin?: SubscriptionResolver<ResolversTypes['Float'], "seatsAdmin", ParentType, ContextType>;
  seatsInstructor?: SubscriptionResolver<ResolversTypes['Float'], "seatsInstructor", ParentType, ContextType>;
  subscriptionType?: SubscriptionResolver<ResolversTypes['SubscriptionType'], "subscriptionType", ParentType, ContextType>;
  updateDate?: SubscriptionResolver<ResolversTypes['DateTime'], "updateDate", ParentType, ContextType>;
};

export type SubscriptionTypeResolvers = { StandardSubscription: 'undefined', TestSubscription: 'undefined' };

export type LatestMollieAttemptBadgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LatestMollieAttemptBadge'] = ResolversParentTypes['LatestMollieAttemptBadge']> = {
  linkExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  mollieMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentTransferTypeResolvers = { BankTransfer: 'undefined', Cash: 'undefined', Creditcard: 'undefined', Esr: 'undefined', None: 'undefined', Online: 'undefined', Paypal: 'undefined', SepaDebit: 'undefined' };

export type BookingPostKindResolvers = { AdditionalItem: 'undefined', CourseFee: 'undefined', Fee: 'undefined' };

export type SepaCollectionStatusResolvers = { Collected: 'undefined', Requested: 'undefined', Returned: 'undefined' };

export type ScheduledPaymentTypeResolvers = { AdditionalItem: 'undefined', CancelationFee: 'undefined', Chargeback: 'undefined', Custom: 'undefined', Discount: 'undefined', DunningLevel1: 'undefined', DunningLevel2: 'undefined', DunningLevel3: 'undefined', Standard: 'undefined' };

export type BookingsKo9Resolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingsKo9'] = ResolversParentTypes['BookingsKo9']> = {
  attendee?: Resolver<Maybe<ResolversTypes['Attendee']>, ParentType, ContextType>;
  attendeeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstCourseLesson?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  teilnahmeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Course'] = ResolversParentTypes['Course']> = {
  additionalItems?: Resolver<Array<ResolversTypes['CourseAdditionalItem']>, ParentType, ContextType>;
  additionalShortInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allowLessonBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowMolliePayment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowMonthlyPayment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowUpFrontPayment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  annotation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  billedBookingCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  blockBookingOnline?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bookingCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingCountWithoutWaitlist?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingPriceQuote?: Resolver<Maybe<ResolversTypes['CourseBookingPriceQuote']>, ParentType, ContextType>;
  bookingRestriction?: Resolver<Maybe<ResolversTypes['BookingRestriction']>, ParentType, ContextType>;
  bookingRestrictionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  canceledBookingsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseNumberFormat?: Resolver<ResolversTypes['CourseNumberFormat'], ParentType, ContextType>;
  coursePrice?: Resolver<Array<ResolversTypes['CoursePrice']>, ParentType, ContextType>;
  coursePrices?: Resolver<Array<ResolversTypes['CoursePrice']>, ParentType, ContextType>;
  courseType?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customCourseNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customInvoiceDueDays?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cycle?: Resolver<ResolversTypes['CourseCycle'], ParentType, ContextType>;
  dateOfFirstInstallment?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  enabledCourses?: Resolver<Maybe<Array<ResolversTypes['EnabledCourse']>>, ParentType, ContextType>;
  endDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  endDateTimeFirstCourseLesson?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  freePlaces?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  installmentRates?: Resolver<Array<ResolversTypes['InstallmentRate']>, ParentType, ContextType>;
  instructors?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrerequisiteForCourseCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lateEntryPricingMode?: Resolver<ResolversTypes['CourseLateEntryPricingMode'], ParentType, ContextType>;
  lessonCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lessons?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxAssistantsPerLesson?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxAttendees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  maxWaitlist?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minAttendees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minimumPartialBookingLessonCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mollieOptional?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  monthlySchedule?: Resolver<ResolversTypes['MonthlySchedule'], ParentType, ContextType>;
  paymentInterval?: Resolver<Maybe<ResolversTypes['PaymentInterval']>, ParentType, ContextType>;
  paymentType?: Resolver<Maybe<ResolversTypes['PaymentType']>, ParentType, ContextType>;
  placeReservationsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  prefixedCourseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prerequisiteCourses?: Resolver<Maybe<Array<ResolversTypes['Course']>>, ParentType, ContextType>;
  settledBookingCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  settledBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  showInWeb?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  unSettledBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue?: Resolver<ResolversTypes['Venue'], ParentType, ContextType>;
  venueId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['CourseVisibilityResult'], ParentType, ContextType>;
  waitListCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  websiteInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseAdditionalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseAdditionalItem'] = ResolversParentTypes['CourseAdditionalItem']> = {
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  courseTypeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['AdditionalItemMode'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalItemModeResolvers = { Mandatory: 'undefined', MandatoryFirstBooking: 'undefined', Optional: 'undefined' };

export type CourseBookingPriceQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseBookingPriceQuote'] = ResolversParentTypes['CourseBookingPriceQuote']> = {
  blockingReason?: Resolver<Maybe<ResolversTypes['CourseBookingBasePriceBlockingReason']>, ParentType, ContextType>;
  calculationVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  coursePriceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  effectiveMinimum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  effectiveMode?: Resolver<ResolversTypes['CourseLateEntryPricingMode'], ParentType, ContextType>;
  eligibleLessonCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  eligibleLessonIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  fingerprint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isBookable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPartialBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  originalGrossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pricedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  reduction?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  serviceGrossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalLessonCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalLessonIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseBookingBasePriceBlockingReasonResolvers = { MinimumPartialBookingLessonCountNotReached: 'undefined', NoEligibleLessons: 'undefined' };

export type CourseLateEntryPricingModeResolvers = { ORIGINAL_PRICE: 'undefined', REMAINING_LESSONS: 'undefined' };

export type BookingRestrictionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingRestriction'] = ResolversParentTypes['BookingRestriction']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowWaitlistWithoutPrerequisite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  blockedPlaces?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  expireAction?: Resolver<Maybe<ResolversTypes['ExpireAction']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includeBookingList?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeWaitingList?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  membersOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  prerequisiteCourses?: Resolver<Maybe<Array<ResolversTypes['Course']>>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibleForAll?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpireActionResolvers = { HideFromAll: 'undefined', ShowToAll: 'undefined' };

export type CoursePriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoursePrice'] = ResolversParentTypes['CoursePrice']> = {
  bookings?: Resolver<Maybe<Array<ResolversTypes['Booking']>>, ParentType, ContextType>;
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includedEntranceFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isSpecial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  netPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseType'] = ResolversParentTypes['CourseType']> = {
  additionalItems?: Resolver<Array<ResolversTypes['CourseAdditionalItem']>, ParentType, ContextType>;
  annotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bold?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['CourseCategory']>, ParentType, ContextType>;
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courses?: Resolver<Maybe<Array<ResolversTypes['Course']>>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceTemplateSetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  inWeekPlanner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxAge?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxAttendees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minAge?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minAttendees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  participationPrerequisites?: Resolver<Maybe<Array<ResolversTypes['ParticipationPrerequisites']>>, ParentType, ContextType>;
  paymentInterval?: Resolver<Maybe<ResolversTypes['PaymentInterval']>, ParentType, ContextType>;
  selfBookerCourse?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shortHandId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showInWeb?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  websiteInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseCategory'] = ResolversParentTypes['CourseCategory']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedCourseTypes?: Resolver<Array<ResolversTypes['CourseType']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ParticipationPrerequisitesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParticipationPrerequisites'] = ResolversParentTypes['ParticipationPrerequisites']> = {
  courseType?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType>;
  courseTypeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  minCheckCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  optionalInputFields?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type PaymentIntervalResolvers = { PerCourse: 'undefined', PerLesson: 'undefined' };

export type CourseCycleResolvers = { Custom: 'undefined', EveryTwoWeeks: 'undefined', Monthly: 'undefined', Weekly: 'undefined' };

export type EnabledCourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnabledCourse'] = ResolversParentTypes['EnabledCourse']> = {
  bookingRestriction?: Resolver<Maybe<ResolversTypes['BookingRestriction']>, ParentType, ContextType>;
  courseType?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType>;
  enabledPrerequisites?: Resolver<Maybe<Array<ResolversTypes['Course']>>, ParentType, ContextType>;
  enabledRestriction?: Resolver<Maybe<ResolversTypes['BookingRestriction']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  prefixedCourseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visibility?: Resolver<Maybe<ResolversTypes['CourseVisibilityResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseVisibilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseVisibilityResult'] = ResolversParentTypes['CourseVisibilityResult']> = {
  hideAfterDays?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reason?: Resolver<Array<ResolversTypes['CourseNotVisibleReason']>, ParentType, ContextType>;
  restriction?: Resolver<ResolversTypes['CourseVisibilityRestriction'], ParentType, ContextType>;
  visibleForAll?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseNotVisibleReasonResolvers = { CourseShowInWeb: 'undefined', CourseTypeShowInWeb: 'undefined', HideAfterDays: 'undefined', HideAfterRestrictionEnd: 'undefined', IsArchived: 'undefined', LocationIsPublic: 'undefined', MembersOnly: 'undefined', PrerequisiteCourses: 'undefined' };

export type CourseVisibilityRestrictionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseVisibilityRestriction'] = ResolversParentTypes['CourseVisibilityRestriction']> = {
  endDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  expireAction?: Resolver<ResolversTypes['ExpireAction'], ParentType, ContextType>;
  inTimeRange?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  membersOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  prerequisiteCourses?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallmentRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstallmentRate'] = ResolversParentTypes['InstallmentRate']> = {
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  installmentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  installmentDue?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  installmentType?: Resolver<ResolversTypes['InstallmentType'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallmentTypeResolvers = { Discount: 'undefined', Standard: 'undefined' };

export type InstructorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Instructor'] = ResolversParentTypes['Instructor']> = {
  accountHolder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  activeCourseCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  allowLogin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  annotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedLocations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  bank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthPlace?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customFields?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  healthInsuranceFund?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['InstructorInvoice']>, ParentType, ContextType>;
  isAreaManager?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  joinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leaveDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salutation?: Resolver<ResolversTypes['SalutationType'], ParentType, ContextType>;
  showInWeb?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  socialSecurityNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  staff?: Resolver<ResolversTypes['Staff'], ParentType, ContextType>;
  staffId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  testColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  abbreviation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courses?: Resolver<Maybe<Array<ResolversTypes['Course']>>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customFields?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  emailVariableInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generalLocationContact?: Resolver<ResolversTypes['GeneralLocationContact'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructors?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  isPublished?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lessons?: Resolver<Maybe<Array<ResolversTypes['CourseLesson']>>, ParentType, ContextType>;
  locationContacts?: Resolver<Array<ResolversTypes['LocationContact']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venues?: Resolver<Array<ResolversTypes['Venue']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneralLocationContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneralLocationContact'] = ResolversParentTypes['GeneralLocationContact']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLessonResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLesson'] = ResolversParentTypes['CourseLesson']> = {
  billingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  billingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookings?: Resolver<Maybe<Array<ResolversTypes['Booking']>>, ParentType, ContextType>;
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseLessonAssistants?: Resolver<Maybe<Array<ResolversTypes['CourseLessonAssistant']>>, ParentType, ContextType>;
  courseLessonBookingCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseLessonBookings?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  freePlaces?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indexOfLessonInCourse?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instructorInvoice?: Resolver<Maybe<ResolversTypes['InstructorInvoice']>, ParentType, ContextType>;
  instructorInvoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructors?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revenueGross?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  roomCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue?: Resolver<ResolversTypes['Venue'], ParentType, ContextType>;
  venueId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLessonAssistantResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLessonAssistant'] = ResolversParentTypes['CourseLessonAssistant']> = {
  assignedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  assistantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseLessonId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLessonBookingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLessonBooking'] = ResolversParentTypes['CourseLessonBooking']> = {
  attendance?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  booking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType>;
  bookingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookingType?: Resolver<Maybe<ResolversTypes['BookingType']>, ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseLesson?: Resolver<ResolversTypes['CourseLesson'], ParentType, ContextType>;
  courseLessonId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingTypeResolvers = { Booking: 'undefined', PlaceReservation: 'undefined', Waitlist: 'undefined' };

export type InstructorInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstructorInvoice'] = ResolversParentTypes['InstructorInvoice']> = {
  courseLessons?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  instructor?: Resolver<ResolversTypes['Instructor'], ParentType, ContextType>;
  instructorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lessonCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pdfPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pdfUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  periodEnd?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  periodStart?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VenueResolvers<ContextType = any, ParentType extends ResolversParentTypes['Venue'] = ResolversParentTypes['Venue']> = {
  courses?: Resolver<Maybe<Array<ResolversTypes['Course']>>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lessons?: Resolver<Maybe<Array<ResolversTypes['CourseLesson']>>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationContact'] = ResolversParentTypes['LocationContact']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salutation?: Resolver<ResolversTypes['SalutationType'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalutationTypeResolvers = { Mr: 'undefined', Ms: 'undefined', Mx: 'undefined' };

export type StaffResolvers<ContextType = any, ParentType extends ResolversParentTypes['Staff'] = ResolversParentTypes['Staff']> = {
  accountHolder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  annotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  areaManagerLocations?: Resolver<Maybe<Array<ResolversTypes['Location']>>, ParentType, ContextType>;
  bank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthPlace?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  healthInsuranceFund?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  joinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leaveDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salutation?: Resolver<Maybe<ResolversTypes['SalutationType']>, ParentType, ContextType>;
  socialSecurityNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonthlyScheduleResolvers = { Consistent: 'undefined', Custom: 'undefined', Dynamic: 'undefined' };

export type PaymentTypeResolvers = { Bill: 'undefined', Custom: 'undefined', Monthly: 'undefined', OnTheSpot: 'undefined', PrePaid: 'undefined' };

export type BookedByResolvers = { Booker: 'undefined', Staff: 'undefined' };

export type BookingHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingHistory'] = ResolversParentTypes['BookingHistory']> = {
  action?: Resolver<ResolversTypes['BookingHistoryAction'], ParentType, ContextType>;
  attendee?: Resolver<Maybe<ResolversTypes['Attendee']>, ParentType, ContextType>;
  attendeeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookedBy?: Resolver<ResolversTypes['BookedBy'], ParentType, ContextType>;
  bookerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  booking?: Resolver<Maybe<ResolversTypes['Booking']>, ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookingNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bookingNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingType?: Resolver<ResolversTypes['BookingType'], ParentType, ContextType>;
  canceled?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  correlationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['UserDetailsType']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  netPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  newValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  oldValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserDetailsType']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingHistoryActionResolvers = { AttendanceChanged: 'undefined', BookingCancle: 'undefined', BookingCorrected: 'undefined', BookingCreate: 'undefined', BookingCreateTransfer: 'undefined', BookingCreateTransferCopy: 'undefined', BookingCreateTransferMove: 'undefined', BookingDelete: 'undefined', BookingDeleteTransfer: 'undefined', BookingOrphanDelete: 'undefined', BookingOrphanRestore: 'undefined', BookingSettle: 'undefined', BookingToWaitlist: 'undefined', Canceled: 'undefined', CorrectionInvoice: 'undefined', Created: 'undefined', Custom: 'undefined', DiscountChanged: 'undefined', EmailSent: 'undefined', LessonAdded: 'undefined', LessonRemoved: 'undefined', MolliePaymentLinkVoided: 'undefined', PaymentChanged: 'undefined', PaymentLinkSent: 'undefined', PaymentMethodChanged: 'undefined', PaymentPlanReset: 'undefined', PlaceReservationCreate: 'undefined', PlaceReservationCreateByMaxAttendeesIncrease: 'undefined', PlaceReservationDelete: 'undefined', PlaceReservationToBooking: 'undefined', PriceChanged: 'undefined', RefundCompleted: 'undefined', RefundInitiated: 'undefined', ScheduledPaymentCreated: 'undefined', ScheduledPaymentDeleted: 'undefined', ScheduledPaymentPaid: 'undefined', ScheduledPaymentUnpaid: 'undefined', ScheduledPaymentUpdated: 'undefined', SendBookingConfirmation: 'undefined', SendInvoice: 'undefined', SendWaitlistConfirmation: 'undefined', StatusChanged: 'undefined', Unknown: 'undefined', Updated: 'undefined', WaitlistCreate: 'undefined', WaitlistCreateTransfer: 'undefined', WaitlistCreateTransferCopy: 'undefined', WaitlistCreateTransferMove: 'undefined', WaitlistDelete: 'undefined', WaitlistDeleteTransfer: 'undefined', WaitlistToBooking: 'undefined', WaitlistToBookingByMaxAttendeesIncrease: 'undefined' };

export type UserDetailsTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDetailsType'] = ResolversParentTypes['UserDetailsType']> = {
  birthDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  insertInstant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instructorDetails?: Resolver<Maybe<ResolversTypes['InstructorDetailsView']>, ParentType, ContextType>;
  lastLoginInstant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loginAttempts?: Resolver<Maybe<Array<ResolversTypes['LoginAttempt']>>, ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recentLogins?: Resolver<Maybe<Array<ResolversTypes['RecentLoginEntry']>>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userSettings?: Resolver<Maybe<ResolversTypes['UserSetting']>, ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstructorDetailsViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstructorDetailsView'] = ResolversParentTypes['InstructorDetailsView']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  joinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leaveDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  showInWeb?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoginAttemptResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginAttempt'] = ResolversParentTypes['LoginAttempt']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loginCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LoginStatus'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoginStatusResolvers = { AlreadyUsed: 'undefined', Created: 'undefined', Expired: 'undefined', Invalid: 'undefined', Used: 'undefined' };

export type RecentLoginEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecentLoginEntry'] = ResolversParentTypes['RecentLoginEntry']> = {
  applicationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSetting'] = ResolversParentTypes['UserSetting']> = {
  attendanceListSettings?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  columnSettings?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['Language']>, ParentType, ContextType>;
  optimizedCourseCalendar?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  profilePictureUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showArchivedCourses?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LanguageResolvers = { DE: 'undefined' };

export type DiscountCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCode'] = ResolversParentTypes['DiscountCode']> = {
  allowWithMemberDiscount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deactivatedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountUnit?: Resolver<ResolversTypes['DiscountUnit'], ParentType, ContextType>;
  discountValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  effectiveValidUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxRedemptions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  redemptionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  referenceCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scopeIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  scopeLabels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  scopeType?: Resolver<ResolversTypes['DiscountCodeScopeType'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  validUntilCourseEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountUnitResolvers = { Euro: 'undefined', Percentage: 'undefined' };

export type DiscountCodeScopeTypeResolvers = { All: 'undefined', Courses: 'undefined', CourseTypes: 'undefined', Locations: 'undefined' };

export type EmailNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailNotification'] = ResolversParentTypes['EmailNotification']> = {
  attachments?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  bookerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  booking?: Resolver<Maybe<ResolversTypes['Booking']>, ParentType, ContextType>;
  bookingDeleted?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  courseDetailsSnapshot?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastMessageStatus?: Resolver<Maybe<ResolversTypes['MessageStatus']>, ParentType, ContextType>;
  mailjetTemplateId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  messageHistory?: Resolver<Maybe<ResolversTypes['MessageHistory']>, ParentType, ContextType>;
  messageHref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageID?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  messageStatus?: Resolver<Maybe<ResolversTypes['MessageStatusData']>, ParentType, ContextType>;
  receiverName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  renderVariablesSnapshot?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageStatus'] = ResolversParentTypes['MessageStatus']> = {
  Count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Data?: Resolver<Array<ResolversTypes['MessageStatusData']>, ParentType, ContextType>;
  Total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageStatusDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageStatusData'] = ResolversParentTypes['MessageStatusData']> = {
  ArrivedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  AttachmentCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  AttemptCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  ContactAlt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ContactID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Delay?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  DestinationID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  FilterTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  ID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  IsClickTracked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  IsHTMLPartIncluded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  IsOpenTracked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  IsTextPartIncluded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  IsUnsubTracked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  MessageSize?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  SenderID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  SpamassassinScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  SpamassRules?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  StatePermanent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  Status?: Resolver<ResolversTypes['MailjetStatus'], ParentType, ContextType>;
  Subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  UUID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MailjetStatusResolvers = { blocked: 'undefined', bookingDeleted: 'undefined', bounce: 'undefined', clicked: 'undefined', deferred: 'undefined', hardbounced: 'undefined', opened: 'undefined', queued: 'undefined', sent: 'undefined', softbounced: 'undefined', spam: 'undefined', unknown: 'undefined', unsub: 'undefined' };

export type MessageHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageHistory'] = ResolversParentTypes['MessageHistory']> = {
  Count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Data?: Resolver<Array<ResolversTypes['MessageHistoryData']>, ParentType, ContextType>;
  Total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageHistoryDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageHistoryData'] = ResolversParentTypes['MessageHistoryData']> = {
  Comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  EventAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  EventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  State?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Useragent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  UseragentID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonPricingModeResolvers = { Formula: 'undefined', Individual: 'undefined' };

export type BookingLessonSelectionModeResolvers = { EXPLICIT_SELECTION: 'undefined', FULL_COURSE: 'undefined', REMAINING_AT_BOOKING: 'undefined' };

export type MolliePaymentAttemptResolvers<ContextType = any, ParentType extends ResolversParentTypes['MolliePaymentAttempt'] = ResolversParentTypes['MolliePaymentAttempt']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bundleScheduledPaymentIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  chargebackedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  chargebackFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  chargebackId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargebackReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargebackResolvedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  chargebackResolvedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargebacks?: Resolver<Array<ResolversTypes['Chargeback']>, ParentType, ContextType>;
  checkoutUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCurrentAttempt?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTestPayment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastWebhookAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  linkExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  mollieMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  molliePaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  molliePaymentLinkId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refunds?: Resolver<Array<ResolversTypes['MollieRefund']>, ParentType, ContextType>;
  requiresManualRetry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  scheduledPayment?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chargeback'] = ResolversParentTypes['Chargeback']> = {
  chargebackedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mollieChargebackId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieRefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieRefund'] = ResolversParentTypes['MollieRefund']> = {
  adminUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  attendeeNameSnapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookerNameSnapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookingIdSnapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookingNumberSnapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canceledAtProvider?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  courseNumberSnapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mollieCreatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  mollieRefundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<ResolversTypes['MollieRefundOrigin'], ParentType, ContextType>;
  paymentAmountSnapshot?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheduledPayment?: Resolver<Maybe<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  scheduledPaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MollieRefundStatus'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieRefundOriginResolvers = { External: 'undefined', Internal: 'undefined' };

export type MollieRefundStatusResolvers = { Failed: 'undefined', Pending: 'undefined', Processed: 'undefined' };

export type BookingPricingReasonResolvers = { EXPLICIT_LESSON_SELECTION: 'undefined', LATE_ENTRY_REMAINING_LESSONS: 'undefined', STANDARD: 'undefined' };

export type ReversalInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReversalInvoice'] = ResolversParentTypes['ReversalInvoice']> = {
  booking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  invoiceNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  koOrganization?: Resolver<ResolversTypes['KoOrganization'], ParentType, ContextType>;
  mollieGenerated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  qrReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reversalInvoiceBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reversalInvoiceFileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledPayments?: Resolver<Maybe<Array<ResolversTypes['ScheduledPayment']>>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingTransferInResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingTransferIn'] = ResolversParentTypes['BookingTransferIn']> = {
  appliedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sourceBookingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilterCompareOperationResolvers = { EQ: 'undefined', GR: 'undefined', GREQ: 'undefined', LO: 'undefined', LOEQ: 'undefined' };

export type FilterOperationResolvers = { COMPARE: 'undefined', SEARCH: 'undefined' };

export type SortOrderResolvers = { Ascending: 'undefined', Descending: 'undefined' };

export type AttendeeMergeHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendeeMergeHistory'] = ResolversParentTypes['AttendeeMergeHistory']> = {
  booker?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  bookerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loserSnapshot?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  winnerAttendee?: Resolver<Maybe<ResolversTypes['Attendee']>, ParentType, ContextType>;
  winnerAttendeeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeeWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendeeWithPagination'] = ResolversParentTypes['AttendeeWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BadgeGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['BadgeGroup'] = ResolversParentTypes['BadgeGroup']> = {
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BadgeGroupType'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BadgeGroupTypeResolvers = { KATEGORIE: 'undefined', STUFENFOLGE: 'undefined' };

export type BankCollectionRunResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCollectionRun'] = ResolversParentTypes['BankCollectionRun']> = {
  collectedRates?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  collectionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  creditAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creditBookingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  creditId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  creditMissing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  creditStatus?: Resolver<Maybe<ResolversTypes['BankTransactionStatus']>, ParentType, ContextType>;
  debitCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  exportedSepaXmlId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedRates?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openReturns?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnDeadline?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  returnedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  returnedRates?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionStatusResolvers = { AlreadySettled: 'undefined', Confirmed: 'undefined', Irrelevant: 'undefined', Proposed: 'undefined', Rejected: 'undefined', Unmatched: 'undefined' };

export type BankImportFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankImportFile'] = ResolversParentTypes['BankImportFile']> = {
  accountIban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balanceGap?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceGapFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  balanceGapTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closingBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entryCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  knownCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  newCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openingBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  periodFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  periodTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<ResolversTypes['BankTransaction']>>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransaction'] = ResolversParentTypes['BankTransaction']> = {
  accountIban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  acctSvcrRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bankImportFileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bankText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankTransactionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookingDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  candidateRates?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  candidates?: Resolver<Array<ResolversTypes['BankTransactionCandidate']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confirmWarning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  counterpartIban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  counterpartName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decidedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  decidedByUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  decision?: Resolver<Maybe<ResolversTypes['BankTransactionDecision']>, ParentType, ContextType>;
  endToEndId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isReversal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['BankTransactionKind'], ParentType, ContextType>;
  likelyRecordedScheduledPaymentIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  likelyRecordedScheduledPayments?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  mandateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchedExportedSepaXmlId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  matchKind?: Resolver<ResolversTypes['BankTransactionMatchKind'], ParentType, ContextType>;
  matchNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proposedScheduledPaymentIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  proposedScheduledPayments?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  rejectNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectReason?: Resolver<Maybe<ResolversTypes['BankTransactionRejectReason']>, ParentType, ContextType>;
  remittanceText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returnReasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settledScheduledPaymentIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankTransactionStatus'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionCandidate'] = ResolversParentTypes['BankTransactionCandidate']> = {
  amountMatches?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  attendeeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookingLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evidence?: Resolver<Array<ResolversTypes['BankTransactionCandidateEvidence']>, ParentType, ContextType>;
  hits?: Resolver<Maybe<Array<ResolversTypes['BankTransactionSearchHit']>>, ParentType, ContextType>;
  level?: Resolver<ResolversTypes['BankTransactionCandidateLevel'], ParentType, ContextType>;
  noticeStaff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rates?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  warning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionCandidateEvidenceResolvers = { CourseNumber: 'undefined', CustomerNumber: 'undefined', FirstName: 'undefined', InvoiceNumber: 'undefined', LastName: 'undefined', PayerIban: 'undefined' };

export type BankTransactionSearchHitResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionSearchHit'] = ResolversParentTypes['BankTransactionSearchHit']> = {
  exact?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  field?: Resolver<ResolversTypes['BankTransactionSearchField'], ParentType, ContextType>;
  term?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionSearchFieldResolvers = { AttendeeName: 'undefined', BookerName: 'undefined', BookingNumber: 'undefined', CourseNumber: 'undefined', InvoiceNumber: 'undefined' };

export type BankTransactionCandidateLevelResolvers = { Certain: 'undefined', Likely: 'undefined', Possible: 'undefined' };

export type BankTransactionDecisionResolvers = { ConfirmedAsProposed: 'undefined', ConfirmedOtherTarget: 'undefined', Rejected: 'undefined' };

export type BankTransactionKindResolvers = { CollectionBatch: 'undefined', Credit: 'undefined', Debit: 'undefined', Return: 'undefined' };

export type BankTransactionMatchKindResolvers = { CollectionBatch: 'undefined', CourseNumber: 'undefined', CustomerNumber: 'undefined', None: 'undefined', PayerIban: 'undefined', PayerName: 'undefined', Reference: 'undefined', ReferenceAmountDiffers: 'undefined', Return: 'undefined' };

export type BankTransactionRejectReasonResolvers = { AlreadyRecorded: 'undefined', Clarify: 'undefined', NotCourseRelated: 'undefined', Other: 'undefined' };

export type BankTransactionsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionsPage'] = ResolversParentTypes['BankTransactionsPage']> = {
  items?: Resolver<Array<ResolversTypes['BankTransaction']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingAddressTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingAddressTemplate'] = ResolversParentTypes['BillingAddressTemplate']> = {
  addition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookerDeletionProgressTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookerDeletionProgressType'] = ResolversParentTypes['BookerDeletionProgressType']> = {
  deletedAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deletedBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phase?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookerMergeHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookerMergeHistory'] = ResolversParentTypes['BookerMergeHistory']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loserSnapshot?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  winnerBooker?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  winnerBookerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookerWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookerWithPagination'] = ResolversParentTypes['BookerWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingEligibilityCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingEligibilityCandidate'] = ResolversParentTypes['BookingEligibilityCandidate']> = {
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseTypeColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  diagnosis?: Resolver<ResolversTypes['BookingEligibilityDiagnosis'], ParentType, ContextType>;
  freePlaces?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  locationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefixedCourseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prerequisiteCourseIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  prerequisitePrefixedCourseNumbers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  satisfiedByAttendeeIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingEligibilityDiagnosisResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingEligibilityDiagnosis'] = ResolversParentTypes['BookingEligibilityDiagnosis']> = {
  attendeeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  blockingCheckKeys?: Resolver<Array<ResolversTypes['EligibilityCheckKey']>, ParentType, ContextType>;
  canBook?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  checks?: Resolver<Array<ResolversTypes['EligibilityCheck']>, ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['BookingRestrictionErrors'], ParentType, ContextType>;
  visibleInStandardList?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  visibleViaPrerequisiteLinks?: Resolver<Array<ResolversTypes['PrerequisiteLinkVisibility']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityCheckKeyResolvers = { AgeAtCourseStart: 'undefined', AttendeeAlreadyBooked: 'undefined', AttendeeCustomerMatchesBooker: 'undefined', BookerHasPaymentMethod: 'undefined', CourseHasFreePlaces: 'undefined', CourseOnlineBookable: 'undefined', DuplicateAttendeesOnBooker: 'undefined', MembersOnly: 'undefined', MolliePaymentAvailable: 'undefined', PrerequisiteBookingOnOtherAttendee: 'undefined', PrerequisiteBookingPresent: 'undefined', RestrictionActive: 'undefined', RestrictionTimeWindow: 'undefined' };

export type EligibilityCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityCheck'] = ResolversParentTypes['EligibilityCheck']> = {
  key?: Resolver<ResolversTypes['EligibilityCheckKey'], ParentType, ContextType>;
  params?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EligibilityCheckStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityCheckStatusResolvers = { Fail: 'undefined', NotApplicable: 'undefined', Ok: 'undefined', Warn: 'undefined' };

export type BookingRestrictionErrorsResolvers = { AllowedToBook: 'undefined', AttendeeHasBookingInPrerequisiteCourse: 'undefined', AttendeeHasNoBookingInPrerequisiteCourse: 'undefined', AttendeeHasWaitlistBookingInPrerequisiteCourse: 'undefined', AttendeeIsNotAMember: 'undefined', BookingRestrictionExpiredAndShowToAllIsSet: 'undefined', BookingRestrictionNotWithinTimeFrame: 'undefined', NoBookingRestrictionFound: 'undefined' };

export type PrerequisiteLinkVisibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrerequisiteLinkVisibility'] = ResolversParentTypes['PrerequisiteLinkVisibility']> = {
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prefixedCourseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingWithPagination'] = ResolversParentTypes['BookingWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundesbankImportInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundesbankImportInfo'] = ResolversParentTypes['BundesbankImportInfo']> = {
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lastImport?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateIssuePreflightResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateIssuePreflightResult'] = ResolversParentTypes['CertificateIssuePreflightResult']> = {
  attendeesWithMissingValues?: Resolver<Array<ResolversTypes['CertificateIssuePreflightAttendee']>, ParentType, ContextType>;
  usedVariableKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateIssuePreflightAttendeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateIssuePreflightAttendee'] = ResolversParentTypes['CertificateIssuePreflightAttendee']> = {
  attendeeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  attendeeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  missingKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateTemplate'] = ResolversParentTypes['CertificateTemplate']> = {
  accentColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockLayout?: Resolver<Maybe<ResolversTypes['CertificateBlockLayout']>, ParentType, ContextType>;
  congratulationText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  designVariant?: Resolver<ResolversTypes['CertificateDesignVariant'], ParentType, ContextType>;
  docFields?: Resolver<Maybe<ResolversTypes['CertificateDocFields']>, ParentType, ContextType>;
  footerText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  instructorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  introText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterFields?: Resolver<Maybe<ResolversTypes['CertificateLetterFields']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signers?: Resolver<Maybe<Array<ResolversTypes['CertificateSigner']>>, ParentType, ContextType>;
  sizes?: Resolver<Maybe<ResolversTypes['CertificateSizes']>, ParentType, ContextType>;
  titleText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<Maybe<ResolversTypes['CertificateTemplateVisibility']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateBlockLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateBlockLayout'] = ResolversParentTypes['CertificateBlockLayout']> = {
  alignments?: Resolver<Maybe<ResolversTypes['CertificateBlockAlignments']>, ParentType, ContextType>;
  density?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  spacing?: Resolver<Maybe<ResolversTypes['CertificateBlockSpacing']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateBlockAlignmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateBlockAlignments'] = ResolversParentTypes['CertificateBlockAlignments']> = {
  abschluss?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  akkreditierung?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beilage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beschreibung?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docMid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geburtsdatum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intro?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kurs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kursSub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterHead?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterSalutation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterSig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterZert?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mittel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ortDatum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teilnCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teilnehmer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  untertitel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zert?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateBlockSpacingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateBlockSpacing'] = ResolversParentTypes['CertificateBlockSpacing']> = {
  abschluss?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  akkreditierung?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bandContact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bandStufen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bandTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beilage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beschreibung?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docMid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geburtsdatum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intro?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kurs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kursSub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterHead?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterSalutation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterSig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  letterZert?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mittel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ortDatum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teilnCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teilnehmer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  untertitel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zert?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateDesignVariantResolvers = { BESCHEINIGUNG: 'undefined', BRIEF: 'undefined', CLASSIC: 'undefined', ELEGANT: 'undefined', MARITIME: 'undefined', MODERN: 'undefined', PLAYFUL: 'undefined', VIBRANT: 'undefined' };

export type CertificateDocFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateDocFields'] = ResolversParentTypes['CertificateDocFields']> = {
  abschluss?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  akkreditierung?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  align?: Resolver<ResolversTypes['CertificateAlign'], ParentType, ContextType>;
  beschreibung?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  docMid?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  kursSub?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  ort?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  teilnCaption?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  untertitel?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  veranstalter?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateDocTextResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateDocText'] = ResolversParentTypes['CertificateDocText']> = {
  show?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  v?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateAlignResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateAlign'] = ResolversParentTypes['CertificateAlign']> = {
  footer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateLetterFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateLetterFields'] = ResolversParentTypes['CertificateLetterFields']> = {
  beilage?: Resolver<ResolversTypes['CertificateDocText'], ParentType, ContextType>;
  contactLine?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contactShow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  senderLine?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stufenList?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stufenShow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stufenTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  window?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateSignerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateSigner'] = ResolversParentTypes['CertificateSigner']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateSizesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateSizes'] = ResolversParentTypes['CertificateSizes']> = {
  abschluss?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  akkreditierung?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bandContact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bandStufen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bandTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beschreibung?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docMid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fuss?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intro?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kurs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kursSub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mittel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  org?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  untertitel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  veranstalter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zert?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateTemplateVisibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateTemplateVisibility'] = ResolversParentTypes['CertificateTemplateVisibility']> = {
  datum?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fuss?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  geburtsdatum?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  grat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  intro?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kl?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kurs?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mittel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nummer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organisation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  signers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  titel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  zertifikat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeesAgeAtCourseStartResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendeesAgeAtCourseStart'] = ResolversParentTypes['AttendeesAgeAtCourseStart']> = {
  ageError?: Resolver<Maybe<ResolversTypes['AgeError']>, ParentType, ContextType>;
  attendeeAge?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  attendeeBirthday?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  attendeesAgeAtFirstCourseLessonDate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  firstCourseLessonDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  maxAge?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxAgeAnniversary?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  minAge?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minAgeAnniversary?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgeErrorResolvers = { TooOld: 'undefined', TooYoung: 'undefined' };

export type DiscountCodeCheckResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountCodeCheckResult'] = ResolversParentTypes['DiscountCodeCheckResult']> = {
  discountCode?: Resolver<Maybe<ResolversTypes['DiscountCode']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['DiscountCodeRejectReason']>, ParentType, ContextType>;
  redemptionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountCodeRejectReasonResolvers = { Deactivated: 'undefined', Exhausted: 'undefined', Expired: 'undefined', NotYetValid: 'undefined', Unknown: 'undefined', WrongCourse: 'undefined' };

export type TemplateTypeResolvers = { AttendanceList: 'undefined', BookingCancellation: 'undefined', BookingConfirmation: 'undefined', BookingConfirmationMollie: 'undefined', DunningLevel1: 'undefined', DunningLevel2: 'undefined', DunningLevel3: 'undefined', DunningReminder: 'undefined', FreeText: 'undefined', InterestListConfirmation: 'undefined', Invoice: 'undefined', InvoiceMonthly: 'undefined', InvoiceMonthlyConsistent: 'undefined', InvoiceReversal: 'undefined', InvoiceReversalMonthly: 'undefined', InvoiceReversalMonthlyConsistent: 'undefined', MolliePaymentCanceled: 'undefined', MolliePaymentExpired: 'undefined', MolliePaymentFailed: 'undefined', NoTemplate: 'undefined', Reminder: 'undefined', SettledBookingCancellation: 'undefined', SettlementConfirmation: 'undefined', Transfer: 'undefined', WaitingListConfirmation: 'undefined', Warning: 'undefined' };

export type SmsBalanceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SmsBalanceResponse'] = ResolversParentTypes['SmsBalanceResponse']> = {
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationCityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationCity'] = ResolversParentTypes['LocationCity']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseDetails'] = ResolversParentTypes['CourseDetails']> = {
  billedBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  canceledBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  placeReservations?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  unbilledBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  waitlistBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseHistory'] = ResolversParentTypes['CourseHistory']> = {
  action?: Resolver<ResolversTypes['CourseHistoryAction'], ParentType, ContextType>;
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseStartDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['UserDetailsType']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  newValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  oldValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  prefixedCourseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserDetailsType']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseHistoryActionResolvers = { CourseArchive: 'undefined', CourseCreate: 'undefined', CourseDelete: 'undefined', CourseLessonAdded: 'undefined', CourseLessonDeleted: 'undefined', CourseLessonsAdded: 'undefined', CourseLessonsDeleted: 'undefined', CourseLessonUpdated: 'undefined', CoursePriceAdded: 'undefined', CoursePriceDeleted: 'undefined', CoursePricesBulkChanged: 'undefined', CoursePriceUpdated: 'undefined', CourseUnarchive: 'undefined', CourseUpdate: 'undefined', InstallmentRateAdded: 'undefined', InstallmentRateDeleted: 'undefined', InstallmentRatesAdded: 'undefined', InstallmentRatesDeleted: 'undefined', InstallmentRatesRecalculated: 'undefined', InstallmentRateUpdated: 'undefined', InstructorsChanged: 'undefined', Unknown: 'undefined', Updated: 'undefined', VisibilityChanged: 'undefined' };

export type BillingStatusCoursLessonsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingStatusCoursLessons'] = ResolversParentTypes['BillingStatusCoursLessons']> = {
  billingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  billingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookings?: Resolver<Maybe<Array<ResolversTypes['Booking']>>, ParentType, ContextType>;
  costForLesson?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseLessonAssistants?: Resolver<Maybe<Array<ResolversTypes['CourseLessonAssistant']>>, ParentType, ContextType>;
  courseLessonBookingCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseLessonBookings?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationInMinutes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  endDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  freePlaces?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indexOfLessonInCourse?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instructorInvoice?: Resolver<Maybe<ResolversTypes['InstructorInvoice']>, ParentType, ContextType>;
  instructorInvoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructors?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revenueGross?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  roomCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue?: Resolver<ResolversTypes['Venue'], ParentType, ContextType>;
  venueId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChronologicalLessonsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChronologicalLessonsResult'] = ResolversParentTypes['ChronologicalLessonsResult']> = {
  lessons?: Resolver<Array<ResolversTypes['BillingStatusCoursLessons']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupBillingStatusByResolvers = { INSTRUCTOR: 'undefined' };

export type BillingStatusByInstructorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingStatusByInstructor'] = ResolversParentTypes['BillingStatusByInstructor']> = {
  billedLessonCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  billedTotalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  courseLessonCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseLessons?: Resolver<Array<ResolversTypes['BillingStatusCoursLessons']>, ParentType, ContextType>;
  instructor?: Resolver<ResolversTypes['Instructor'], ParentType, ContextType>;
  instructorCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instructorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastBillingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  sumBillingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingStatusByInstructorWithCourseGroupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingStatusByInstructorWithCourseGroups'] = ResolversParentTypes['BillingStatusByInstructorWithCourseGroups']> = {
  billedLessonCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  billedTotalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  courseGroups?: Resolver<Array<ResolversTypes['CourseSummaryForBilling']>, ParentType, ContextType>;
  courseLessonCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  instructor?: Resolver<ResolversTypes['Instructor'], ParentType, ContextType>;
  instructorCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instructorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastBillingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  sumBillingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseSummaryForBillingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseSummaryForBilling'] = ResolversParentTypes['CourseSummaryForBilling']> = {
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  coursePrefixedNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseTypeColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hourlyRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lessonCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  locationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  periodEnd?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  periodStart?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalMinutes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLessonWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLessonWithPagination'] = ResolversParentTypes['CourseLessonWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLessonWithIndexOfCourseLessonInCourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLessonWithIndexOfCourseLessonInCourse'] = ResolversParentTypes['CourseLessonWithIndexOfCourseLessonInCourse']> = {
  billingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  billingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookings?: Resolver<Maybe<Array<ResolversTypes['Booking']>>, ParentType, ContextType>;
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseLessonAssistants?: Resolver<Maybe<Array<ResolversTypes['CourseLessonAssistant']>>, ParentType, ContextType>;
  courseLessonBookingCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseLessonBookings?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  freePlaces?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indexOfLessonInCourse?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  instructorInvoice?: Resolver<Maybe<ResolversTypes['InstructorInvoice']>, ParentType, ContextType>;
  instructorInvoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructors?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  originalCourseLessonId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  revenueGross?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  roomCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue?: Resolver<ResolversTypes['Venue'], ParentType, ContextType>;
  venueId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OperationResolvers = { EQ: 'undefined', GTE: 'undefined', IN: 'undefined', LIKE: 'undefined', LTE: 'undefined' };

export type OperatorResolvers = { AND: 'undefined', OR: 'undefined' };

export type DayFilterResolvers = { Dienstag: 'undefined', Donnerstag: 'undefined', Freitag: 'undefined', Mittwoch: 'undefined', Montag: 'undefined', Samstag: 'undefined', Sonntag: 'undefined' };

export type CourseWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseWithPagination'] = ResolversParentTypes['CourseWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hiddenMembersOnlyCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hiddenPrerequisiteCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonthFilterResolvers = { April: 'undefined', August: 'undefined', December: 'undefined', February: 'undefined', January: 'undefined', July: 'undefined', June: 'undefined', March: 'undefined', May: 'undefined', November: 'undefined', October: 'undefined', September: 'undefined' };

export type RestrictiveCoursesResolvers = { All: 'undefined', MembersOnly: 'undefined', PrerequisiteCourses: 'undefined', StandardCourses: 'undefined' };

export type CourseTypeWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseTypeWithPagination'] = ResolversParentTypes['CourseTypeWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CourseType']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditEntry'] = ResolversParentTypes['CreditEntry']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balanceAfter?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  booking?: Resolver<Maybe<ResolversTypes['Booking']>, ParentType, ContextType>;
  bookingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mollieRefundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['CreditEntryReason'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sourceBookerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditEntryReasonResolvers = { BookingCredited: 'undefined', BookingReleased: 'undefined', CancelRest: 'undefined', CancelRestKept: 'undefined', CancelRestManualRefund: 'undefined', Correction: 'undefined', EditOverpayment: 'undefined', Manual: 'undefined', Merge: 'undefined', OpeningBalance: 'undefined', Overpayment: 'undefined', Transfer: 'undefined', TransferSurplus: 'undefined', TransferSurplusManualRefund: 'undefined', TransferSurplusRefund: 'undefined', TransferSurplusRefundReverted: 'undefined' };

export type CustomBankDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomBankData'] = ResolversParentTypes['CustomBankData']> = {
  bankCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerTimelineEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerTimelineEntry'] = ResolversParentTypes['CustomerTimelineEntry']> = {
  actorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  attendeeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookingAllowsLessonBooking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bookingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookingIsSettled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['CustomerTimelineKind'], ParentType, ContextType>;
  params?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerTimelineKindResolvers = { AttendeeMerge: 'undefined', BookerMerge: 'undefined', BookingHistory: 'undefined', CreditEntry: 'undefined', CustomerEvent: 'undefined', EmailSent: 'undefined', MagicLinkLogin: 'undefined', Milestone: 'undefined' };

export type HolidayResolvers<ContextType = any, ParentType extends ResolversParentTypes['Holiday'] = ResolversParentTypes['Holiday']> = {
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['CountryCode']>, ParentType, ContextType>;
  end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  holidayStateColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  stateCode?: Resolver<ResolversTypes['StateCode'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['HolidayType'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HolidayTypeResolvers = { CUSTOM: 'undefined', PUBLIC: 'undefined', SCHOOL: 'undefined' };

export type InvoiceTemplateSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceTemplateSet'] = ResolversParentTypes['InvoiceTemplateSet']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  layoutVariant?: Resolver<ResolversTypes['InvoiceLayoutVariant'], ParentType, ContextType>;
  logoPosition?: Resolver<ResolversTypes['InvoiceLogoPosition'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secondLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceLayoutVariantResolvers = { DIN_5008: 'undefined', SWISS_SN_010_130: 'undefined' };

export type InvoiceLogoPositionResolvers = { LEFT: 'undefined', RIGHT: 'undefined' };

export type DunningPauseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DunningPause'] = ResolversParentTypes['DunningPause']> = {
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  until?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DunningProposalResolvers<ContextType = any, ParentType extends ResolversParentTypes['DunningProposal'] = ResolversParentTypes['DunningProposal']> = {
  blocker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dunningNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  earliestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['DunningProposalItem']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['DunningLevel']>, ParentType, ContextType>;
  levelLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  openAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooEarly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DunningProposalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DunningProposalItem'] = ResolversParentTypes['DunningProposalItem']> = {
  openAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DunningResolvers<ContextType = any, ParentType extends ResolversParentTypes['Dunning'] = ResolversParentTypes['Dunning']> = {
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dunningNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  feeDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['DunningLevel'], ParentType, ContextType>;
  openAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  voidedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  withdrawnAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  withdrawnReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailNotificationWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailNotificationWithPagination'] = ResolversParentTypes['EmailNotificationWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['EmailNotification']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EndUserEmailRegistrationStatusResolvers = { AVAILABLE: 'undefined', CONFIRMABLE: 'undefined', TAKEN: 'undefined', TAKEN_BY_STAFF: 'undefined' };

export type ExportedSepaXmlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportedSepaXml'] = ResolversParentTypes['ExportedSepaXml']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  xml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportedSepaXmlWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportedSepaXmlWithPagination'] = ResolversParentTypes['ExportedSepaXmlWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ExportedSepaXml']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaUser'] = ResolversParentTypes['FaUser']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  breachedPasswordLastCheckedInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cleanSpeakId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  connectorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  encryptionScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  insertInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastLoginInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdateInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passwordChangeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passwordChangeRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  passwordLastUpdateInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferredLanguages?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  registrations?: Resolver<Maybe<Array<ResolversTypes['UserRegistration']>>, ParentType, ContextType>;
  salt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uniqueUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRegistrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRegistration'] = ResolversParentTypes['UserRegistration']> = {
  applicationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  authenticationToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cleanSpeakId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  insertInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastLoginInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastUpdateInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferredLanguages?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeLetterProposalResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeLetterProposal'] = ResolversParentTypes['FeeLetterProposal']> = {
  blocker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['FeeLetterItem']>, ParentType, ContextType>;
  letterNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeLetterItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeLetterItem'] = ResolversParentTypes['FeeLetterItem']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeLetterResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeLetter'] = ResolversParentTypes['FeeLetter']> = {
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  letterNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimilarBookerResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimilarBookerResult'] = ResolversParentTypes['SimilarBookerResult']> = {
  booker?: Resolver<ResolversTypes['Booker'], ParentType, ContextType>;
  matchReason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnpaidScheduledPaymentMatchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnpaidScheduledPaymentMatchResult'] = ResolversParentTypes['UnpaidScheduledPaymentMatchResult']> = {
  matches?: Resolver<Array<ResolversTypes['UnpaidScheduledPaymentMatch']>, ParentType, ContextType>;
  totalMatchesFound?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalSepaExportsSearched?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnpaidScheduledPaymentMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnpaidScheduledPaymentMatch'] = ResolversParentTypes['UnpaidScheduledPaymentMatch']> = {
  allowLessonBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  attendeeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookingNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['MatchConfidence'], ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  invoiceNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mandateId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sepaExportDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  sepaExportFileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sepaExportId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchConfidenceResolvers = { HIGH: 'undefined', MEDIUM: 'undefined' };

export type Sms77AnalyticGroupByDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77AnalyticGroupByDate'] = ResolversParentTypes['Sms77AnalyticGroupByDate']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hlr?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  inbound?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mnp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sms?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  usageEur?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaIssueResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaIssue'] = ResolversParentTypes['AreaIssue']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lesson?: Resolver<ResolversTypes['AreaIssueLesson'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['AreaIssueLocation'], ParentType, ContextType>;
  person?: Resolver<Maybe<ResolversTypes['AreaIssuePerson']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaIssueLessonResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaIssueLesson'] = ResolversParentTypes['AreaIssueLesson']> = {
  courseName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaIssueLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaIssueLocation'] = ResolversParentTypes['AreaIssueLocation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaIssuePersonResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaIssuePerson'] = ResolversParentTypes['AreaIssuePerson']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerAssistantHierarchyResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerAssistantHierarchyResult'] = ResolversParentTypes['AreaManagerAssistantHierarchyResult']> = {
  locations?: Resolver<Array<ResolversTypes['AreaManagerAssistantLocationGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerAssistantLocationGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerAssistantLocationGroup'] = ResolversParentTypes['AreaManagerAssistantLocationGroup']> = {
  courseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  courseGroups?: Resolver<Array<ResolversTypes['AreaManagerAssistantCourseGroup']>, ParentType, ContextType>;
  filledSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsFullyStaffed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsPartiallyStaffed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsWithAssistants?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  locationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  openSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerAssistantCourseGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerAssistantCourseGroup'] = ResolversParentTypes['AreaManagerAssistantCourseGroup']> = {
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseTypeColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateRangeEnd?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  dateRangeStart?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  filledSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsFullyStaffed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsPartiallyStaffed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsWithAssistants?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxAssistantsPerLesson?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  needsAssistants?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  openSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerAssistantOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerAssistantOverview'] = ResolversParentTypes['AreaManagerAssistantOverview']> = {
  assignedAssistants?: Resolver<Array<ResolversTypes['AreaManagerAssignedAssistant']>, ParentType, ContextType>;
  courseLessonId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filledSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  totalSlots?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerAssignedAssistantResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerAssignedAssistant'] = ResolversParentTypes['AreaManagerAssignedAssistant']> = {
  assistantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerAssistantOverviewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerAssistantOverviewResult'] = ResolversParentTypes['AreaManagerAssistantOverviewResult']> = {
  items?: Resolver<Array<ResolversTypes['AreaManagerAssistantOverview']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerCourseStatsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerCourseStatsResult'] = ResolversParentTypes['AreaManagerCourseStatsResult']> = {
  items?: Resolver<Array<ResolversTypes['AreaManagerCourseStats']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerCourseStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerCourseStats'] = ResolversParentTypes['AreaManagerCourseStats']> = {
  bookedAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  locationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  utilizationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerInstructorStatsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerInstructorStatsResult'] = ResolversParentTypes['AreaManagerInstructorStatsResult']> = {
  items?: Resolver<Array<ResolversTypes['AreaManagerInstructorStats']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerInstructorStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerInstructorStats'] = ResolversParentTypes['AreaManagerInstructorStats']> = {
  courseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instructorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lessonCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalHours?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerLocationStatsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerLocationStatsResult'] = ResolversParentTypes['AreaManagerLocationStatsResult']> = {
  items?: Resolver<Array<ResolversTypes['AreaManagerLocationStats']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerLocationStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerLocationStats'] = ResolversParentTypes['AreaManagerLocationStats']> = {
  activeCourseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  totalBookedAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalMaxAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  utilizationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerUpcomingLessonResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerUpcomingLesson'] = ResolversParentTypes['AreaManagerUpcomingLesson']> = {
  courseName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  prefixedCourseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerVenueUtilizationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerVenueUtilizationResult'] = ResolversParentTypes['AreaManagerVenueUtilizationResult']> = {
  items?: Resolver<Array<ResolversTypes['AreaManagerVenueUtilization']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaManagerVenueUtilizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaManagerVenueUtilization'] = ResolversParentTypes['AreaManagerVenueUtilization']> = {
  locationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usedHours?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  venue?: Resolver<ResolversTypes['Venue'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaOverviewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaOverviewResult'] = ResolversParentTypes['AreaOverviewResult']> = {
  pools?: Resolver<Array<ResolversTypes['AreaOverviewPool']>, ParentType, ContextType>;
  week?: Resolver<ResolversTypes['AreaOverviewWeek'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaOverviewPoolResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaOverviewPool'] = ResolversParentTypes['AreaOverviewPool']> = {
  attendanceRecordedRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issueCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsToday?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  peopleCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaOverviewWeekResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaOverviewWeek'] = ResolversParentTypes['AreaOverviewWeek']> = {
  attendanceRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lessonCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  staffedRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaPersonResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaPerson'] = ResolversParentTypes['AreaPerson']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasOpenSubstitution?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['AreaPersonLocation']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AreaPersonLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AreaPersonLocation'] = ResolversParentTypes['AreaPersonLocation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoMergeStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoMergeStatus'] = ResolversParentTypes['AutoMergeStatus']> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  confidenceThreshold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  durationMs?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  failedMerges?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  failures?: Resolver<Maybe<Array<ResolversTypes['AutoMergeFailureType']>>, ParentType, ContextType>;
  mergedSoFar?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  skippedMerges?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AutoMergeRunStatus'], ParentType, ContextType>;
  totalGroupsToMerge?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoMergeFailureTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoMergeFailureType'] = ResolversParentTypes['AutoMergeFailureType']> = {
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  loserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  loserName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  winnerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  winnerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoMergeRunStatusResolvers = { COMPLETED: 'undefined', COMPLETED_WITH_ERRORS: 'undefined', FAILED: 'undefined', PENDING: 'undefined', RUNNING: 'undefined' };

export type MollieMethodInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieMethodInfo'] = ResolversParentTypes['MollieMethodInfo']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAvailableInProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  profileStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookerAttendeeCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookerAttendeeCount'] = ResolversParentTypes['BookerAttendeeCount']> = {
  attendeeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bookerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookerIdMissmatchWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookerIdMissmatchWithPagination'] = ResolversParentTypes['BookerIdMissmatchWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['BookerIdMissmatch']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookerIdMissmatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookerIdMissmatch'] = ResolversParentTypes['BookerIdMissmatch']> = {
  attachments?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  bookerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  booking?: Resolver<Maybe<ResolversTypes['Booking']>, ParentType, ContextType>;
  bookingDeleted?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  courseDetailsSnapshot?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentBooker?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  foundByMailBooker?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastMessageStatus?: Resolver<Maybe<ResolversTypes['MessageStatus']>, ParentType, ContextType>;
  mailjetTemplateId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  messageHistory?: Resolver<Maybe<ResolversTypes['MessageHistory']>, ParentType, ContextType>;
  messageHref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageID?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  messageStatus?: Resolver<Maybe<ResolversTypes['MessageStatusData']>, ParentType, ContextType>;
  receiverName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  renderVariablesSnapshot?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CacheStatsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CacheStatsOutput'] = ResolversParentTypes['CacheStatsOutput']> = {
  cacheHitRatio?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  diskReads?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sharedBuffersSize?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalReads?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargebackSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargebackSummary'] = ResolversParentTypes['ChargebackSummary']> = {
  totalChargebackCount30d?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalChargebackFee30d?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TablesEnumResolvers = { AreaManagerAssistantOverview: 'undefined', AreaManagerCourseUtilization: 'undefined', AreaManagerInstructorUtilization: 'undefined', AreaManagerLocationOverview: 'undefined', AreaManagerVenueUtilization: 'undefined', AttendanceList: 'undefined', AttendanceListBulk: 'undefined', Attendees: 'undefined', AttendeesOverview: 'undefined', AttendeeTransferToBooker: 'undefined', BillingStatusByInstructor: 'undefined', BillingStatusChronological: 'undefined', BookerExportModal: 'undefined', BookerOverview: 'undefined', Bookers: 'undefined', Bookings: 'undefined', BookingsAttendeeDetails: 'undefined', BookingsByCourse: 'undefined', BookingsByCourseExpandedBookings: 'undefined', BookingsInStartedCourses: 'undefined', BookingsOverview: 'undefined', BookingsShow: 'undefined', BookingsShowall: 'undefined', BookingsShowlastMonth: 'undefined', BookingsShowlastWeek: 'undefined', BookingsShowthisMonth: 'undefined', BookingsShowthisWeek: 'undefined', BookingsShowthisYear: 'undefined', BookingsShowtoday: 'undefined', BookingsShowtwentyFour: 'undefined', BookingsShowyesterday: 'undefined', CanceledBookingsListExport: 'undefined', CertificateAssignByAttendeeColumns: 'undefined', CertificateAssignByCourseAttendeeColumns: 'undefined', CertificateAssignCourseSelector: 'undefined', CourseCategories: 'undefined', CourseDetailsCanceledBookingsList: 'undefined', CourseDetailsCanceledBookingsList2: 'undefined', CourseDetailsPlaceReservations: 'undefined', CourseDetailsPlacereservationsList2: 'undefined', CourseDetailsSettledBookings: 'undefined', CourseDetailsSettledBookingsList2: 'undefined', CourseDetailsSettledPlacereservations: 'undefined', CourseDetailsUnsettledBookings: 'undefined', CourseDetailsUnsettledBookingsList2: 'undefined', CourseDetailsWaitlist: 'undefined', CourseDetailsWaitlistList2: 'undefined', CourseLessonTable: 'undefined', CourseOverview: 'undefined', CourseOverviewExport: 'undefined', Courses: 'undefined', CourseSelectPrerequisiteCourses: 'undefined', CourseTransferAttendeeToCourse: 'undefined', CourseTypes: 'undefined', CreateLessonBookingAttendeeList: 'undefined', CreateLessonBookingCourseList: 'undefined', DonePaymentsList: 'undefined', DonePaymentsListExport: 'undefined', EmailTemplatePicker: 'undefined', EmailTemplatesList: 'undefined', Instructors: 'undefined', InterestLists: 'undefined', InterestRegistrations: 'undefined', InvoiceListByBookingUnsetteled: 'undefined', InvoiceListByCourse: 'undefined', InvoicesByCourse: 'undefined', InvoicesReversals: 'undefined', InvoicesSettled: 'undefined', InvoicesUnsetteled: 'undefined', LessonBookingDetails: 'undefined', LessonBookings: 'undefined', LocationOverviewTable: 'undefined', Locations: 'undefined', MolliePaymentsList: 'undefined', MyBookings: 'undefined', MyBookingsByCourse: 'undefined', MyBookingsOverview: 'undefined', NotificationBookerMissmatch: 'undefined', NotificationsByBookerId: 'undefined', NotificationsByBookingId: 'undefined', NotificationsSent: 'undefined', OpenPaymentsList: 'undefined', OpenPaymentsListExport: 'undefined', PaymentsOpen: 'undefined', PaymentsPaid: 'undefined', PrerequisiteCourses: 'undefined', SelectAttendee: 'undefined', SettledBookingDonePaymentsList: 'undefined', SettledBookingOpenPaymentsList: 'undefined', SettledBookingsListExport: 'undefined', Staff: 'undefined', StaffAll: 'undefined', StaffAllInstructor: 'undefined', StepSelectCourse: 'undefined', TodaysCourseLessonsExport: 'undefined', TodaysCourseLessonsList: 'undefined', TransferCourseSelector: 'undefined', TransferMultipleAttendeesSelectCourse: 'undefined', TransferSimpleCourseSelector: 'undefined', UnsettledBookingsListExport: 'undefined', ZeroValuePayments: 'undefined' };

export type ContentOfBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentOfBucket'] = ResolversParentTypes['ContentOfBucket']> = {
  ContentOfBucketResponse?: Resolver<Maybe<ResolversTypes['ContentOfBucketResponse']>, ParentType, ContextType>;
  Files?: Resolver<Maybe<Array<ResolversTypes['Content']>>, ParentType, ContextType>;
  Folders?: Resolver<Maybe<Array<ResolversTypes['Content']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentOfBucketResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentOfBucketResponse'] = ResolversParentTypes['ContentOfBucketResponse']> = {
  CommonPrefixes?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  Contents?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  Delimiter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EncodingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IsTruncated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Marker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxKeys?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NextMarker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Content'] = ResolversParentTypes['Content']> = {
  ETag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  LastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdfBlob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signedImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  StorageClass?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantCourseLessonResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantCourseLesson'] = ResolversParentTypes['AssistantCourseLesson']> = {
  assignedAssistants?: Resolver<Array<ResolversTypes['AssistantInfo']>, ParentType, ContextType>;
  assistantSlotsMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  assistantSlotsUsed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseLesson?: Resolver<ResolversTypes['CourseLesson'], ParentType, ContextType>;
  isAssignedToMe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantInfo'] = ResolversParentTypes['AssistantInfo']> = {
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateGroupWithMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateGroupWithMetadata'] = ResolversParentTypes['DuplicateGroupWithMetadata']> = {
  bookers?: Resolver<Array<ResolversTypes['Booker']>, ParentType, ContextType>;
  matchInfo?: Resolver<ResolversTypes['DuplicateGroupMatchInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateGroupMatchInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateGroupMatchInfo'] = ResolversParentTypes['DuplicateGroupMatchInfo']> = {
  bestMatchType?: Resolver<ResolversTypes['DuplicateMatchType'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreBreakdown?: Resolver<Maybe<ResolversTypes['ScoreBreakdownType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateMatchTypeResolvers = { COMPOSITE: 'undefined', EXACT_EMAIL: 'undefined', EXACT_NAME: 'undefined', FUZZY_NAME: 'undefined' };

export type ScoreBreakdownTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreBreakdownType'] = ResolversParentTypes['ScoreBreakdownType']> = {
  differentAddress?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  differentEmail?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  differentName?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  differentPhone?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  exactEmail?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  exactName?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fuzzyName?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  missingName?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sameAddress?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sameAttendee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sameAttendeeMultiple?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  samePhone?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateDetectionRunResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateDetectionRun'] = ResolversParentTypes['DuplicateDetectionRun']> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duplicateMatchesFound?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  durationMs?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DetectionRunStatus'], ParentType, ContextType>;
  totalBookersProcessed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionRunStatusResolvers = { COMPLETED: 'undefined', FAILED: 'undefined', PENDING: 'undefined', RUNNING: 'undefined' };

export type DuplicateExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateException'] = ResolversParentTypes['DuplicateException']> = {
  booker1?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  booker2?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  bookerId1?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookerId2?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateMatchStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateMatchStats'] = ResolversParentTypes['DuplicateMatchStats']> = {
  affectedBookerCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  autoMergeableGroups?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalGroups?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MjmlTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MjmlTemplate'] = ResolversParentTypes['MjmlTemplate']> = {
  Count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MailjetSenderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MailjetSenderResponse'] = ResolversParentTypes['MailjetSenderResponse']> = {
  Count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Data?: Resolver<Array<ResolversTypes['MailjetSender']>, ParentType, ContextType>;
  Total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MailjetSenderResolvers<ContextType = any, ParentType extends ResolversParentTypes['MailjetSender'] = ResolversParentTypes['MailjetSender']> = {
  CreatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  DNSID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  EmailType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  IsDefaultSender?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingIndexCandidateOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingIndexCandidateOutput'] = ResolversParentTypes['MissingIndexCandidateOutput']> = {
  avgRowsPerScan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  idxScan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  schemaname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seqScan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  seqTupRead?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tablename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieKpisResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieKpis'] = ResolversParentTypes['MollieKpis']> = {
  avgCheckoutToPaidHours?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  chargebacks30dCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  chargebacks30dFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  openLinksCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openLinksSum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  successRate30d?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MolliePaymentTabResolvers = { All: 'undefined', Chargebacks: 'undefined', Failed: 'undefined', OpenLinks: 'undefined', Paid: 'undefined', Refunds: 'undefined' };

export type MolliePaymentsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MolliePaymentsPage'] = ResolversParentTypes['MolliePaymentsPage']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MolliePaymentTabCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MolliePaymentTabCounts'] = ResolversParentTypes['MolliePaymentTabCounts']> = {
  all?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  chargebacks?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openLinks?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refunds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieRetryQueueEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieRetryQueueEntry'] = ResolversParentTypes['MollieRetryQueueEntry']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  attemptId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookerEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  chargebackedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  chargebackReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargebackRetryCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isNonRetriable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sepaDisabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnlineRegisteredBookersResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnlineRegisteredBookersResult'] = ResolversParentTypes['OnlineRegisteredBookersResult']> = {
  items?: Resolver<Array<ResolversTypes['OnlineRegisteredBooker']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnlineRegisteredBookerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnlineRegisteredBooker'] = ResolversParentTypes['OnlineRegisteredBooker']> = {
  activeBookingsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  attendees?: Resolver<Array<ResolversTypes['OnlineRegisteredBookerAttendee']>, ParentType, ContextType>;
  attendeesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leadStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnlineRegisteredBookerAttendeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnlineRegisteredBookerAttendee'] = ResolversParentTypes['OnlineRegisteredBookerAttendee']> = {
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenAttendanceSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenAttendanceSummary'] = ResolversParentTypes['OpenAttendanceSummary']> = {
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lessonIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageStructureResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageStructure'] = ResolversParentTypes['PageStructure']> = {
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = {
  content?: Resolver<ResolversTypes['PageContent'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageContent'] = ResolversParentTypes['PageContent']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subPages?: Resolver<Maybe<Array<ResolversTypes['Page']>>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentActionLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentActionLog'] = ResolversParentTypes['PaymentActionLog']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  scheduledPaymentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceStatsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceStatsOutput'] = ResolversParentTypes['PerformanceStatsOutput']> = {
  cacheStats?: Resolver<ResolversTypes['CacheStatsOutput'], ParentType, ContextType>;
  missingIndexCandidates?: Resolver<Array<ResolversTypes['MissingIndexCandidateOutput']>, ParentType, ContextType>;
  slowQueries?: Resolver<Array<ResolversTypes['SlowQueryOutput']>, ParentType, ContextType>;
  tableStats?: Resolver<Array<ResolversTypes['TableStatsOutput']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlowQueryOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlowQueryOutput'] = ResolversParentTypes['SlowQueryOutput']> = {
  avgTimeMs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  calls?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  maxTimeMs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  percentTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  query?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalTimeMs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TableStatsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TableStatsOutput'] = ResolversParentTypes['TableStatsOutput']> = {
  deletes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  idxScan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  indexUsagePercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  inserts?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  schemaname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seqScan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tablename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updates?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantSelectableLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantSelectableLocation'] = ResolversParentTypes['AssistantSelectableLocation']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAssigned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JournalTypeResolvers = { Inbound: 'undefined', Outbound: 'undefined', Replies: 'undefined', Voice: 'undefined' };

export type Sms77JournalOutboundResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77JournalOutbound'] = ResolversParentTypes['Sms77JournalOutbound']> = {
  channel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dlr?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dlrTimestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  foreignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mccmnc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Sms77PricingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77PricingResponse'] = ResolversParentTypes['Sms77PricingResponse']> = {
  countCountries?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  countNetworks?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  countries?: Resolver<Array<ResolversTypes['Sms77CountryPricing']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Sms77CountryPricingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77CountryPricing'] = ResolversParentTypes['Sms77CountryPricing']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networks?: Resolver<Array<ResolversTypes['CountryNetwork']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryNetworkResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryNetwork'] = ResolversParentTypes['CountryNetwork']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  features?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  mcc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mncs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  networkName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MailDataTypeResolvers = { AttendanceList: 'undefined', Attendee: 'undefined', Booker: 'undefined', Booking: 'undefined', Course: 'undefined', Invoice: 'undefined', InvoicePdf: 'undefined', ScheduledPayment: 'undefined', Staff: 'undefined' };

export type SmsReceiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['SmsReceiver'] = ResolversParentTypes['SmsReceiver']> = {
  bookerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefixedBookingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpcomingCoursesOccupancyResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpcomingCoursesOccupancy'] = ResolversParentTypes['UpcomingCoursesOccupancy']> = {
  bookedPlaces?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  courseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPlaces?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HolidayWithDaysResolvers<ContextType = any, ParentType extends ResolversParentTypes['HolidayWithDays'] = ResolversParentTypes['HolidayWithDays']> = {
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['CountryCode']>, ParentType, ContextType>;
  days?: Resolver<Array<ResolversTypes['DateTime']>, ParentType, ContextType>;
  end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  holidayStateColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  stateCode?: Resolver<ResolversTypes['StateCode'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['HolidayType'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstructorsWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstructorsWithPagination'] = ResolversParentTypes['InstructorsWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Instructor']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestListResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestList'] = ResolversParentTypes['InterestList']> = {
  courseType?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFull?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  maxEntries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showNoteField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  timeSlots?: Resolver<Maybe<Array<ResolversTypes['InterestListTimeSlot']>>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestListTimeSlotResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestListTimeSlot'] = ResolversParentTypes['InterestListTimeSlot']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interestList?: Resolver<ResolversTypes['InterestList'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weekday?: Resolver<ResolversTypes['DayFilter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestRegistrationWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestRegistrationWithPagination'] = ResolversParentTypes['InterestRegistrationWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['InterestRegistration']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestRegistrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestRegistration'] = ResolversParentTypes['InterestRegistration']> = {
  allTimesPossible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  attendee?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType>;
  booker?: Resolver<ResolversTypes['Booker'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interestList?: Resolver<ResolversTypes['InterestList'], ParentType, ContextType>;
  internalNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selectedTimeSlots?: Resolver<Array<ResolversTypes['InterestListTimeSlot']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InterestRegistrationStatus'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestRegistrationStatusResolvers = { Contacted: 'undefined', Done: 'undefined', New: 'undefined' };

export type InvoiceWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceWithPagination'] = ResolversParentTypes['InvoiceWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IssuedCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['IssuedCertificate'] = ResolversParentTypes['IssuedCertificate']> = {
  attendeeBadgeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  attendeeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  certificateTemplateId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  courseName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailSentAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  issuedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9ImportProgressTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9ImportProgressType'] = ResolversParentTypes['Ko9ImportProgressType']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  importedAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  importedBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phase?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  skippedBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9LoadedCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9LoadedCredentials'] = ResolversParentTypes['Ko9LoadedCredentials']> = {
  database?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  port?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettingEndUserAppResolvers<ContextType = any, ParentType extends ResolversParentTypes['SettingEndUserApp'] = ResolversParentTypes['SettingEndUserApp']> = {
  additionalItemsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  calendarFeedEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  colors?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  courseDetails?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  courseSearchDisplayMode?: Resolver<ResolversTypes['CourseSearchDisplayMode'], ParentType, ContextType>;
  courseSearchGridGap?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseSearchGridMaxColumns?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseSearchPageSize?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courseTable?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditRedemptionEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  discountCodesEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  filters?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  hideAfterDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  i18n?: Resolver<Maybe<ResolversTypes['I18n']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lateEntryPricingPolicy?: Resolver<ResolversTypes['TenantLateEntryPricingPolicy'], ParentType, ContextType>;
  minimumPartialBookingLessonCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  optionalInputFields?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  passwordlessIdCodeLength?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  passwordlessLoginEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showInterestListsByDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showTotalPriceInCheckout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  textEntries?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withdrawalButtonEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseSearchDisplayModeResolvers = { Grid: 'undefined', Table: 'undefined' };

export type I18nResolvers = { De: 'undefined', DeDU: 'undefined', DeSIE: 'undefined', En: 'undefined' };

export type TenantLateEntryPricingPolicyResolvers = { INDIVIDUAL: 'undefined', ORIGINAL_PRICE: 'undefined', REMAINING_LESSONS: 'undefined' };

export type HistorySourceResolvers = { BookingAdjustment: 'undefined', CourseEdit: 'undefined' };

export type LessonBookingPlannerPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonBookingPlannerPreview'] = ResolversParentTypes['LessonBookingPlannerPreview']> = {
  ambiguousOffset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bookedUnitsAfter?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bookedUnitsBefore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  canceled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  components?: Resolver<Array<ResolversTypes['LessonBookingPlannerComponent']>, ParentType, ContextType>;
  credit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  legacyGap?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nonCoursePostsSum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  priceAfter?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  priceBefore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pricingMode?: Resolver<ResolversTypes['LessonPricingMode'], ParentType, ContextType>;
  rateMonthOffset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rates?: Resolver<Array<ResolversTypes['LessonBookingPlannerRate']>, ParentType, ContextType>;
  regenerated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unitPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  units?: Resolver<Array<ResolversTypes['LessonBookingPlannerUnit']>, ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonBookingPlannerComponentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonBookingPlannerComponent'] = ResolversParentTypes['LessonBookingPlannerComponent']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lessonDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonBookingPlannerRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonBookingPlannerRate'] = ResolversParentTypes['LessonBookingPlannerRate']> = {
  adjustments?: Resolver<Array<ResolversTypes['LessonBookingPlannerAdjustment']>, ParentType, ContextType>;
  amountAfter?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountBefore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  boundReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LessonBookingPlannerRateStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonBookingPlannerAdjustmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonBookingPlannerAdjustment'] = ResolversParentTypes['LessonBookingPlannerAdjustment']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonBookingPlannerRateStatusResolvers = { Bound: 'undefined', New: 'undefined', Open: 'undefined' };

export type LessonBookingPlannerUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonBookingPlannerUnit'] = ResolversParentTypes['LessonBookingPlannerUnit']> = {
  lessonDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lessonId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  movedTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LessonBookingPlannerUnitStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonBookingPlannerUnitStatusResolvers = { Added: 'undefined', Kept: 'undefined', Removed: 'undefined' };

export type LessonBookingPlanSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonBookingPlanSummary'] = ResolversParentTypes['LessonBookingPlanSummary']> = {
  applies?: Resolver<ResolversTypes['LessonBookingPlanApplies'], ParentType, ContextType>;
  blocker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookingLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  correctionInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  correctionInvoiceMail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  credit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fingerprint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceAfter?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  priceBefore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  ratesChanged?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  regenerated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  staffNoteChanged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unitsAdded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unitsRemoved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonBookingPlanAppliesResolvers = { Money: 'undefined', None: 'undefined', Units: 'undefined' };

export type DatabaseBackupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DatabaseBackup'] = ResolversParentTypes['DatabaseBackup']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fusionAuthIncluded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fusionDbCustomKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fusionDbPlainKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koDbCustomKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  koDbPlainKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataExportResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataExport'] = ResolversParentTypes['DataExport']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceExportResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceExport'] = ResolversParentTypes['InvoiceExport']> = {
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  courseLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includeReversals?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YearEndExportResolvers<ContextType = any, ParentType extends ResolversParentTypes['YearEndExport'] = ResolversParentTypes['YearEndExport']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalSize?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocalStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalState'] = ResolversParentTypes['LocalState']> = {
  bookAttendees?: Resolver<ResolversTypes['BookAttendees'], ParentType, ContextType>;
  createCourse?: Resolver<ResolversTypes['CreateCourse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookAttendeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookAttendees'] = ResolversParentTypes['BookAttendees']> = {
  selectedAttendee?: Resolver<Maybe<ResolversTypes['SelectedAttendee']>, ParentType, ContextType>;
  selectedCourseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedAttendeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedAttendee'] = ResolversParentTypes['SelectedAttendee']> = {
  bookedCourseIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['ID']>>>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCourse'] = ResolversParentTypes['CreateCourse']> = {
  locationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationsGroupedByCityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationsGroupedByCity'] = ResolversParentTypes['LocationsGroupedByCity']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['LocationGroupedByCityLocation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationGroupedByCityLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationGroupedByCityLocation'] = ResolversParentTypes['LocationGroupedByCityLocation']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  venues?: Resolver<Array<ResolversTypes['LocationGroupedByCityVenue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationGroupedByCityVenueResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationGroupedByCityVenue'] = ResolversParentTypes['LocationGroupedByCityVenue']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationsWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationsWithPagination'] = ResolversParentTypes['LocationsWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MaintenanceStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['MaintenanceStatus'] = ResolversParentTypes['MaintenanceStatus']> = {
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  untilIso?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAtIso?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingBankDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingBankData'] = ResolversParentTypes['MissingBankData']> = {
  bankCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstSeen?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  hitCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  iban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastSeen?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieConnectionStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieConnectionStatus'] = ResolversParentTypes['MollieConnectionStatus']> = {
  canReceivePayments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canReceiveSettlements?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  capabilitiesHint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connectedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  dashboardUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isConnected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTestMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mollieOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mollieProfileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  needsReconnect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  needsReconnectForPaymentLinks?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  onboardingStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieDowngradeImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieDowngradeImpact'] = ResolversParentTypes['MollieDowngradeImpact']> = {
  activePaymentLinks?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  affectedBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openMolliePayments?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MolliePaymentStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['MolliePaymentStatus'] = ResolversParentTypes['MolliePaymentStatus']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountDetails?: Resolver<Maybe<ResolversTypes['MollieAmount']>, ParentType, ContextType>;
  availableMollieMethods?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  bankTransferDetails?: Resolver<Maybe<ResolversTypes['MollieBankDetails']>, ParentType, ContextType>;
  bookingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkoutUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseStartDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  courseTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  molliePaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  payOnlineUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieAmount'] = ResolversParentTypes['MollieAmount']> = {
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieBankDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieBankDetails'] = ResolversParentTypes['MollieBankDetails']> = {
  bic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MolliePaymentStatusPublicResolvers<ContextType = any, ParentType extends ResolversParentTypes['MolliePaymentStatusPublic'] = ResolversParentTypes['MolliePaymentStatusPublic']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountDetails?: Resolver<Maybe<ResolversTypes['MollieAmount']>, ParentType, ContextType>;
  bankTransferDetails?: Resolver<Maybe<ResolversTypes['MollieBankDetails']>, ParentType, ContextType>;
  checkoutUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseStartDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  courseTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  molliePaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  payOnlineUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieRefundsWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieRefundsWithPagination'] = ResolversParentTypes['MollieRefundsWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['MollieRefund']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyProfileTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyProfileType'] = ResolversParentTypes['MyProfileType']> = {
  birthDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salutation?: Resolver<Maybe<ResolversTypes['SalutationType']>, ParentType, ContextType>;
  signedProfilePictureUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterBookerStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterBookerStatus'] = ResolversParentTypes['NewsletterBookerStatus']> = {
  bookerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optIn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unsubscribe?: Resolver<Maybe<ResolversTypes['NewsletterUnsubscribe']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterUnsubscribeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterUnsubscribe'] = ResolversParentTypes['NewsletterUnsubscribe']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mailjetListId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reactivatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['NewsletterUnsubscribeSource'], ParentType, ContextType>;
  unsubscribedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterUnsubscribeSourceResolvers = { MailjetBounce: 'undefined', MailjetSpam: 'undefined', MailjetUnsub: 'undefined', Office: 'undefined' };

export type NewsletterLocationListResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterLocationList'] = ResolversParentTypes['NewsletterLocationList']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  excluded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastSyncAdded?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSyncAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastSyncBlocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSyncInList?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSyncOk?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastSyncRecipients?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSyncRemoved?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSyncUnsubscribed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  locationIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  mailjetListId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mailjetListName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  syncStartedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterLog'] = ResolversParentTypes['NewsletterLog']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  failed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['NewsletterLogKind'], ParentType, ContextType>;
  listId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  listName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterLogKindResolvers = { ErrorMail: 'undefined', ListDisabled: 'undefined', ListEnabled: 'undefined', ListExcluded: 'undefined', ListIncluded: 'undefined', ListLinkReset: 'undefined', OfficeUnsubscribe: 'undefined', Reactivated: 'undefined', RulesChanged: 'undefined', SyncFailed: 'undefined', SyncRun: 'undefined', UnsubscribeImport: 'undefined', WebhookRegistered: 'undefined', WebhookUnsubscribe: 'undefined' };

export type NewsletterOverviewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterOverviewResult'] = ResolversParentTypes['NewsletterOverviewResult']> = {
  addressesAll?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  addressesEnabled?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedBounce?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedOffice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedSpam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedUnsub?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  connectionOk?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastRunAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastRunDurationMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSyncAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  listsEnabled?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listsExcluded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listsFailed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listsNever?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listsOk?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listsStuck?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listsTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  locationsEnabled?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  locationsTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unsubscribedLast7Days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unsubscribesImported?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  webhookRegistered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterRecipientCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterRecipientCount'] = ResolversParentTypes['NewsletterRecipientCount']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  locationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  radiusCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterAssignmentResolvers = { EveryList: 'undefined', HomeLocation: 'undefined' };

export type NewsletterListRuleResolvers = { AllBookers: 'undefined', OptInOnly: 'undefined' };

export type NewsletterRulesPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterRulesPreview'] = ResolversParentTypes['NewsletterRulesPreview']> = {
  addedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  multiListCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  otherListRuleCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  radiusCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  removedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shrinkingListCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterSettings'] = ResolversParentTypes['NewsletterSettings']> = {
  assignment?: Resolver<ResolversTypes['NewsletterAssignment'], ParentType, ContextType>;
  bookingsSince?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultErrorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasMailjetApiSecret?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  homeLocationMaxKm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastConnectionCheckAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastConnectionError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastConnectionOk?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listRule?: Resolver<ResolversTypes['NewsletterListRule'], ParentType, ContextType>;
  mailjetApiKeyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mailjetApiKeyPublic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optOutBlocks?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  residenceRadiusKm?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rulesChangedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rulesChangedByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unsubscribesImportedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookRegisteredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  webhookUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPaymentsWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledPaymentsWithPagination'] = ResolversParentTypes['ScheduledPaymentsWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payment'] = ResolversParentTypes['Payment']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bankTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  molliePaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mollieStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledPayment?: Resolver<Maybe<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  scheduledPaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  swissQRFile?: Resolver<Maybe<ResolversTypes['SwissQRFile']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valutaDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwissQrFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwissQRFile'] = ResolversParentTypes['SwissQRFile']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileContent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  records?: Resolver<Maybe<Array<ResolversTypes['SwissQRFileRecord']>>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwissQrFileRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwissQRFileRecord'] = ResolversParentTypes['SwissQRFileRecord']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  originalOpenAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['Payment']>, ParentType, ContextType>;
  paymentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledPayment?: Resolver<Maybe<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  scheduledPaymentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  successful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  swissQRFile?: Resolver<Maybe<ResolversTypes['SwissQRFile']>, ParentType, ContextType>;
  swissQRFileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  swissQrRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valutaDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformConfig'] = ResolversParentTypes['PlatformConfig']> = {
  allowedMollieMethods?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CorrectionRefundModeResolvers = { BookerCredit: 'undefined', MollieRefund: 'undefined' };

export type SettledBookingCorrectionPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['SettledBookingCorrectionPreview'] = ResolversParentTypes['SettledBookingCorrectionPreview']> = {
  alreadyPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  blockers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  creditedBalanceDelta?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  creditToBooker?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  installmentChanges?: Resolver<Array<ResolversTypes['InstallmentChangePreview']>, ParentType, ContextType>;
  newGrossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  newOpenAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  newPaymentLinkAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  overpayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refundAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallmentChangePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstallmentChangePreview'] = ResolversParentTypes['InstallmentChangePreview']> = {
  newAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oldAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paymentDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  spId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['InstallmentChangeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallmentChangeTypeResolvers = { Adjust: 'undefined', Create: 'undefined', NewLink: 'undefined', Refund: 'undefined', Remove: 'undefined', Settle: 'undefined', VoidLink: 'undefined' };

export type RenderedBatchLetterPdfDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['RenderedBatchLetterPdfData'] = ResolversParentTypes['RenderedBatchLetterPdfData']> = {
  items?: Resolver<Array<ResolversTypes['RenderedLetterPdfData']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RenderedLetterPdfDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['RenderedLetterPdfData'] = ResolversParentTypes['RenderedLetterPdfData']> = {
  courseDetails?: Resolver<Maybe<ResolversTypes['LetterPdfCourseDetails']>, ParentType, ContextType>;
  footerText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headerText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipientAddition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientHouseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientPostCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderBankName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderBic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderIban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderLogoBase64?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderStreetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderTaxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderTaxNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderWebsite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LetterPdfCourseDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LetterPdfCourseDetails'] = ResolversParentTypes['LetterPdfCourseDetails']> = {
  attendeeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseLessonsCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coursePrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextBlockPreviewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextBlockPreviewResult'] = ResolversParentTypes['TextBlockPreviewResult']> = {
  current?: Resolver<Maybe<ResolversTypes['TextBlockPreviewCurrent']>, ParentType, ContextType>;
  recipients?: Resolver<Array<ResolversTypes['TextBlockPreviewRecipient']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['TextBlockPreviewSummary']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextBlockPreviewCurrentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextBlockPreviewCurrent'] = ResolversParentTypes['TextBlockPreviewCurrent']> = {
  empty?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  footerText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headerText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  index?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  replaced?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unknown?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextBlockPreviewRecipientResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextBlockPreviewRecipient'] = ResolversParentTypes['TextBlockPreviewRecipient']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextBlockPreviewSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextBlockPreviewSummary'] = ResolversParentTypes['TextBlockPreviewSummary']> = {
  emptyVariables?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  recipientsWithEmpty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recipientsWithUnknown?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantRecipientTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantRecipientType'] = ResolversParentTypes['TenantRecipientType']> = {
  isDefaultRecipient?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ownerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReversalInvoiceWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReversalInvoiceWithPagination'] = ResolversParentTypes['ReversalInvoiceWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ReversalInvoice']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPaymentSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledPaymentSummary'] = ResolversParentTypes['ScheduledPaymentSummary']> = {
  filtered?: Resolver<ResolversTypes['ScheduledPaymentSummaryPart'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['ScheduledPaymentSummaryPart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPaymentSummaryPartResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledPaymentSummaryPart'] = ResolversParentTypes['ScheduledPaymentSummaryPart']> = {
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseHistoryWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseHistoryWithPagination'] = ResolversParentTypes['CourseHistoryWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CourseHistory']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettingEndUserAppHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SettingEndUserAppHistory'] = ResolversParentTypes['SettingEndUserAppHistory']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  newValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  oldValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedLoginStaffResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedLoginStaff'] = ResolversParentTypes['SharedLoginStaff']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffVisibilityRulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffVisibilityRules'] = ResolversParentTypes['StaffVisibilityRules']> = {
  bookingActions?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  courses?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  courseTypes?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  customers?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  interestLists?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  invoices?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  locations?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  staff?: Resolver<ResolversTypes['StaffVisibilityRow'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffVisibilityRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffVisibilityRow'] = ResolversParentTypes['StaffVisibilityRow']> = {
  assistant?: Resolver<ResolversTypes['StaffVisibilityLevel'], ParentType, ContextType>;
  instructor?: Resolver<ResolversTypes['StaffVisibilityLevel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffVisibilityLevelResolvers = { All: 'undefined', ColleagueList: 'undefined', NoAccess: 'undefined', OwnCourses: 'undefined' };

export type StaffVisibilityRulesHistoryEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffVisibilityRulesHistoryEntry'] = ResolversParentTypes['StaffVisibilityRulesHistoryEntry']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  newValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  oldValues?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwissQrFileOverviewWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwissQRFileOverviewWithPagination'] = ResolversParentTypes['SwissQRFileOverviewWithPagination']> = {
  items?: Resolver<Array<ResolversTypes['SwissQRFileOverview']>, ParentType, ContextType>;
  openRecordCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwissQrFileOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwissQRFileOverview'] = ResolversParentTypes['SwissQRFileOverview']> = {
  ambiguousCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overpaidCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paidCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  resolvedCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalRecords?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  underpaidCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwissQrRecordContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwissQRRecordContext'] = ResolversParentTypes['SwissQRRecordContext']> = {
  invoiceEvents?: Resolver<Array<ResolversTypes['SwissQRRecordContextEvent']>, ParentType, ContextType>;
  otherRates?: Resolver<Array<ResolversTypes['SwissQRRecordContextRate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwissQrRecordContextEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwissQRRecordContextEvent'] = ResolversParentTypes['SwissQRRecordContextEvent']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwissQrRecordContextRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwissQRRecordContextRate'] = ResolversParentTypes['SwissQRRecordContextRate']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  attendeeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  bookingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoiceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  openAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paidWithoutReceipt?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentDone?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Template'] = ResolversParentTypes['Template']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  footerText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headerText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includeCourseDetails?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  invoiceTemplateSetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mailDataType?: Resolver<Maybe<ResolversTypes['MailDataType']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplatesWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplatesWithPagination'] = ResolversParentTypes['TemplatesWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantActivitySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantActivitySummary'] = ResolversParentTypes['TenantActivitySummary']> = {
  activeCourses?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  activityStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  daysSinceLastActivity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastBookingCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastCourseCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastDataModification?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastInvoiceCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastLoginDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalBookings?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCourses?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalInvoices?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantDeletionImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantDeletionImpact'] = ResolversParentTypes['TenantDeletionImpact']> = {
  entityCounts?: Resolver<Array<ResolversTypes['EntityCount']>, ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalDatabaseRecords?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntityCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntityCount'] = ResolversParentTypes['EntityCount']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantDeletionStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantDeletionStatus'] = ResolversParentTypes['TenantDeletionStatus']> = {
  deletedRecordCounts?: Resolver<Maybe<Array<ResolversTypes['EntityCount']>>, ParentType, ContextType>;
  deletionState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalErrors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  lastAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastStepName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMetricsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantMetrics'] = ResolversParentTypes['TenantMetrics']> = {
  bookersTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookersTotalOnline?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookings?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingsAdmin?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingsCurrentYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bookingsOnline?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingVolume?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cancellations?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  courses?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  emailsSent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locationsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxBookingsPerYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxLocations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  monthlyFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  newBookers?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  newBookersOnline?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  revenuePaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  seatsAdmin?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seatsInstructor?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscriptionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  waitlist?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMetricsAiSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantMetricsAiSummary'] = ResolversParentTypes['TenantMetricsAiSummary']> = {
  caveats?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  dataThrough?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  headline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  insights?: Resolver<Array<ResolversTypes['TenantMetricsAiInsight']>, ParentType, ContextType>;
  isAiGenerated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TenantMetricsAiSummaryStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMetricsAiInsightResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantMetricsAiInsight'] = ResolversParentTypes['TenantMetricsAiInsight']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  evidence?: Resolver<Array<ResolversTypes['TenantMetricsAiEvidence']>, ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  observationRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMetricsAiEvidenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantMetricsAiEvidence'] = ResolversParentTypes['TenantMetricsAiEvidence']> = {
  changePercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  factRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metric?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  previousValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  tenantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  windowDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMetricsAiSummaryStatusResolvers = { DISABLED: 'undefined', FAILED: 'undefined', PENDING: 'undefined', READY: 'undefined', STALE: 'undefined' };

export type TenantNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantNotification'] = ResolversParentTypes['TenantNotification']> = {
  broadcastId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  senderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TenantNotificationStatus'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantNotificationStatusResolvers = { Failed: 'undefined', Sent: 'undefined', Skipped: 'undefined' };

export type TenantSeatUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantSeatUsage'] = ResolversParentTypes['TenantSeatUsage']> = {
  adminCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  instructorCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantStaffMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantStaffMember'] = ResolversParentTypes['TenantStaffMember']> = {
  actionCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  activeDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastLogin?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KoOrganizationWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['KoOrganizationWithPagination'] = ResolversParentTypes['KoOrganizationWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['KoOrganization']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferOldBookingOptionResolvers = { Auto: 'undefined', ChargeAttendedLessons: 'undefined', CutoffRule: 'undefined' };

export type TransferPriceKindResolvers = { CoursePrice: 'undefined', KeepSourceDiscount: 'undefined', Manual: 'undefined', ProRataRemainingLessons: 'undefined' };

export type TransferBulkPlanPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferBulkPlanPreview'] = ResolversParentTypes['TransferBulkPlanPreview']> = {
  blockers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  maxBookings?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rows?: Resolver<Array<ResolversTypes['TransferBulkPlanRow']>, ParentType, ContextType>;
  templateAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferBulkPlanRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferBulkPlanRow'] = ResolversParentTypes['TransferBulkPlanRow']> = {
  attendeeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['TransferPlanPreview'], ParentType, ContextType>;
  sourceBookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceBookingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferPlanPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferPlanPreview'] = ResolversParentTypes['TransferPlanPreview']> = {
  appliedToB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  attendedLessons?: Resolver<Maybe<ResolversTypes['TransferAttendedLessonsPreview']>, ParentType, ContextType>;
  blockers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  carriedOverItems?: Resolver<Array<ResolversTypes['TransferCarriedOverItem']>, ParentType, ContextType>;
  communicationDefaults?: Resolver<Maybe<ResolversTypes['TransferCommunicationDefaults']>, ParentType, ContextType>;
  confirmationToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coursePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  creditAfter?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  creditReapplied?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cutoff?: Resolver<ResolversTypes['TransferCutoffPreview'], ParentType, ContextType>;
  cutoffApplied?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  discountB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  discountReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasActivePaymentLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hints?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  itemReview?: Resolver<Array<ResolversTypes['TransferItemReview']>, ParentType, ContextType>;
  memberDiscountB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  oldBooking?: Resolver<ResolversTypes['TransferOldBookingPlan'], ParentType, ContextType>;
  oldBookingOptions?: Resolver<Array<ResolversTypes['TransferOldBookingOptionPreview']>, ParentType, ContextType>;
  paidA?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  partialSource?: Resolver<Maybe<ResolversTypes['TransferPartialSourcePreview']>, ParentType, ContextType>;
  priceB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  priceOptions?: Resolver<Array<ResolversTypes['TransferPriceOptionPreview']>, ParentType, ContextType>;
  rates?: Resolver<Array<ResolversTypes['TransferPlannedRate']>, ParentType, ContextType>;
  sourceCreditedBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sourceDiscount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sourceDiscountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surplus?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  surplusHandling?: Resolver<ResolversTypes['TransferSurplusHandlingPreview'], ParentType, ContextType>;
  surplusMollieRefund?: Resolver<ResolversTypes['TransferSurplusMollieRefundPreview'], ParentType, ContextType>;
  transferDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  vatB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferAttendedLessonsPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferAttendedLessonsPreview'] = ResolversParentTypes['TransferAttendedLessonsPreview']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lessonsAttended?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonsTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferCarriedOverItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferCarriedOverItem'] = ResolversParentTypes['TransferCarriedOverItem']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ScheduledPaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferCommunicationDefaultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferCommunicationDefaults'] = ResolversParentTypes['TransferCommunicationDefaults']> = {
  attachInvoiceB?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  attachReversalInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createInvoiceBNow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sendMail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  templateAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferCutoffPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferCutoffPreview'] = ResolversParentTypes['TransferCutoffPreview']> = {
  applicable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  carriedOpen?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lessonsAttended?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lessonsTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rates?: Resolver<Array<ResolversTypes['TransferCutoffRatePreview']>, ParentType, ContextType>;
  retainedPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferCutoffRatePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferCutoffRatePreview'] = ResolversParentTypes['TransferCutoffRatePreview']> = {
  carriedOpen?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  consumed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  due?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  retainedPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sourceRateId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferItemReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferItemReview'] = ResolversParentTypes['TransferItemReview']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  carried?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  carry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceRateId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ScheduledPaymentType'], ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  waived?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferOldBookingPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferOldBookingPlan'] = ResolversParentTypes['TransferOldBookingPlan']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  treatment?: Resolver<ResolversTypes['TransferOldBookingTreatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferOldBookingTreatmentResolvers = { CancelWithoutReceipt: 'undefined', CancelWithReceipt: 'undefined', Delete: 'undefined' };

export type TransferOldBookingOptionPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferOldBookingOptionPreview'] = ResolversParentTypes['TransferOldBookingOptionPreview']> = {
  bookingPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  firstDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['TransferOldBookingOption'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  surplus?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  transferred?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferPartialSourcePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferPartialSourcePreview'] = ResolversParentTypes['TransferPartialSourcePreview']> = {
  attended?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cardLessons?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  chosen?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessonPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  remaining?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferPriceOptionPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferPriceOptionPreview'] = ResolversParentTypes['TransferPriceOptionPreview']> = {
  discountB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['TransferPriceKind'], ParentType, ContextType>;
  lessonsRemaining?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lessonsTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  memberDiscountB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  priceB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferPlannedRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferPlannedRate'] = ResolversParentTypes['TransferPlannedRate']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  due?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fullyCovered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  origin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settledByTransfer?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ScheduledPaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferSurplusHandlingPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferSurplusHandlingPreview'] = ResolversParentTypes['TransferSurplusHandlingPreview']> = {
  creditAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['TransferSurplusHandling'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferSurplusHandlingResolvers = { Credit: 'undefined', ManualRefund: 'undefined', MollieRefund: 'undefined' };

export type TransferSurplusMollieRefundPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferSurplusMollieRefundPreview'] = ResolversParentTypes['TransferSurplusMollieRefundPreview']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['TransferSurplusRefundPayment']>, ParentType, ContextType>;
  possible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remainingCredit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferSurplusRefundPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferSurplusRefundPayment'] = ResolversParentTypes['TransferSurplusRefundPayment']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  capacity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  molliePaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferCreditedBalanceHandlingResolvers = { KeepAsCredit: 'undefined', ReapplyToTarget: 'undefined' };

export type WithdrawalRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalRequest'] = ResolversParentTypes['WithdrawalRequest']> = {
  bookingReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  matchedBookingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WithdrawalStatus'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalStatusResolvers = { Done: 'undefined', InProgress: 'undefined', New: 'undefined', Rejected: 'undefined' };

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addBookableCourses?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddBookableCoursesArgs, 'bookableCourseIds' | 'prerequisiteCourseId'>>;
  addBookerAsAttendee?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<MutationAddBookerAsAttendeeArgs, 'bookerId'>>;
  addCourseIdAndStartDateTime?: Resolver<ResolversTypes['SetupScriptResult'], ParentType, ContextType>;
  addDefaultTemplate?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationAddDefaultTemplateArgs, 'newTemplateData'>>;
  addFaUserByBookerId?: Resolver<ResolversTypes['FaUser'], ParentType, ContextType, RequireFields<MutationAddFaUserByBookerIdArgs, 'bookerId'>>;
  addFolderDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationAddFolderDoArgs, 'folderName'>>;
  addMultiplePlaceReservations?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<MutationAddMultiplePlaceReservationsArgs, 'count' | 'courseId'>>;
  addNamedScheduledPayment?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationAddNamedScheduledPaymentArgs, 'addNamedScheduledPaymentInput'>>;
  addPage?: Resolver<ResolversTypes['PageStructure'], ParentType, ContextType, RequireFields<MutationAddPageArgs, 'newPageInput'>>;
  addPaymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType, RequireFields<MutationAddPaymentMethodArgs, 'bookerId' | 'paymentMethodType'>>;
  addRoleToOrganization?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddRoleToOrganizationArgs, 'role'>>;
  applyLessonBookingPlan?: Resolver<Array<ResolversTypes['LessonBookingPlanSummary']>, ParentType, ContextType, RequireFields<MutationApplyLessonBookingPlanArgs, 'fingerprints' | 'updateCourseAndBookingsInput'>>;
  assignAmbiguousSwissQRPayment?: Resolver<ResolversTypes['SwissQRFileRecord'], ParentType, ContextType, RequireFields<MutationAssignAmbiguousSwissQrPaymentArgs, 'distributions' | 'recordId'>>;
  assignAreaManagerLocations?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAssignAreaManagerLocationsArgs, 'input'>>;
  assignAssistantFromControlBoard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAssignAssistantFromControlBoardArgs, 'input'>>;
  assignCourseTypeToInvoiceTemplateSet?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType, RequireFields<MutationAssignCourseTypeToInvoiceTemplateSetArgs, 'courseTypeId'>>;
  assignInstructorToLessonFromControlBoard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAssignInstructorToLessonFromControlBoardArgs, 'input'>>;
  assignMyselfToCourseLessonAssistantApp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAssignMyselfToCourseLessonAssistantAppArgs, 'courseLessonId'>>;
  autoMergeDuplicates?: Resolver<ResolversTypes['AutoMergeStartResult'], ParentType, ContextType, RequireFields<MutationAutoMergeDuplicatesArgs, 'input'>>;
  autoMergeDuplicatesDryRun?: Resolver<ResolversTypes['AutoMergeDryRunResult'], ParentType, ContextType, RequireFields<MutationAutoMergeDuplicatesDryRunArgs, 'input'>>;
  bookAttendeeSetSelectedAttendee?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, Partial<MutationBookAttendeeSetSelectedAttendeeArgs>>;
  bookAttendeeSetSelectedCourse?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, Partial<MutationBookAttendeeSetSelectedCourseArgs>>;
  broadcastTenantNotification?: Resolver<ResolversTypes['BroadcastTenantNotificationResult'], ParentType, ContextType, RequireFields<MutationBroadcastTenantNotificationArgs, 'input'>>;
  bulkCreateAttendeeBadges?: Resolver<Array<ResolversTypes['AttendeeBadge']>, ParentType, ContextType, RequireFields<MutationBulkCreateAttendeeBadgesArgs, 'input'>>;
  bulkToggleAttendeeBadgeRequirement?: Resolver<Array<ResolversTypes['AttendeeBadgeRequirement']>, ParentType, ContextType, RequireFields<MutationBulkToggleAttendeeBadgeRequirementArgs, 'input'>>;
  cancelBookingAndGenerateReversalInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCancelBookingAndGenerateReversalInvoiceArgs, 'id' | 'sendMail'>>;
  cancelMolliePaymentFromAdmin?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationCancelMolliePaymentFromAdminArgs, 'scheduledPaymentId'>>;
  captureMolliePaymentFromAdmin?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationCaptureMolliePaymentFromAdminArgs, 'scheduledPaymentId'>>;
  changeAttendeeMemberStatus?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType, RequireFields<MutationChangeAttendeeMemberStatusArgs, 'id' | 'member'>>;
  changeDefaultPaymentMethod?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType, RequireFields<MutationChangeDefaultPaymentMethodArgs, 'attendeeId' | 'paymentMethodId'>>;
  changeForgottenPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChangeForgottenPasswordArgs, 'changePasswordId' | 'newPassword'>>;
  changeMultipleAttendeesDefaultPaymentMethods?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType, RequireFields<MutationChangeMultipleAttendeesDefaultPaymentMethodsArgs, 'attendeeIds' | 'koOrganizationId' | 'targetPaymentTransferType'>>;
  clearManuallyAdjusted?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationClearManuallyAdjustedArgs, 'id'>>;
  completeBookerLinkRegistration?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationCompleteBookerLinkRegistrationArgs, 'password' | 'token'>>;
  completePasswordlessFlow?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationCompletePasswordlessFlowArgs, 'loginCode'>>;
  completePasswordlessFlowEndUserApp?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationCompletePasswordlessFlowEndUserAppArgs, 'loginCode'>>;
  confirmAGB?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationConfirmAgbArgs, 'agbConfirmed' | 'bookingId'>>;
  confirmBankTransaction?: Resolver<ResolversTypes['BankTransaction'], ParentType, ContextType, RequireFields<MutationConfirmBankTransactionArgs, 'distributions' | 'id'>>;
  confirmPrivacyStatement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationConfirmPrivacyStatementArgs, 'bookingId' | 'privacyStatementConfirmed'>>;
  convertBookingToWaitlist?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationConvertBookingToWaitlistArgs, 'bookingId'>>;
  convertPhoneNumbersToInternationalFormat?: Resolver<Array<ResolversTypes['Sms77FormatApiResponse']>, ParentType, ContextType, RequireFields<MutationConvertPhoneNumbersToInternationalFormatArgs, 'phoneNumber'>>;
  convertWaitlistToBooking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationConvertWaitlistToBookingArgs, 'bookingId'>>;
  copyAttendeeToCourse?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationCopyAttendeeToCourseArgs, 'bookingId' | 'targetCourseId'>>;
  createAdminManagementUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateAdminManagementUserArgs, 'input'>>;
  createAndRegisterAdmin?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationCreateAndRegisterAdminArgs, 'tenantId' | 'userInput'>>;
  createAndRegisterThirdPartyUser?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationCreateAndRegisterThirdPartyUserArgs, 'tenantId' | 'thirdPartyUserInput'>>;
  createAndRegisterThirdPartyUserAndBooker?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationCreateAndRegisterThirdPartyUserAndBookerArgs, 'newBookingData' | 'thirdPartyUserInput'>>;
  createAnnouncement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType, RequireFields<MutationCreateAnnouncementArgs, 'input'>>;
  createAttendanceListBulkByInstructor?: Resolver<ResolversTypes['BulkJobResult'], ParentType, ContextType, RequireFields<MutationCreateAttendanceListBulkByInstructorArgs, 'input'>>;
  createAttendanceListBulkByLocation?: Resolver<ResolversTypes['BulkJobResult'], ParentType, ContextType, RequireFields<MutationCreateAttendanceListBulkByLocationArgs, 'input'>>;
  createAttendeeBadge?: Resolver<ResolversTypes['AttendeeBadge'], ParentType, ContextType, RequireFields<MutationCreateAttendeeBadgeArgs, 'newAttendeeBadgeInput'>>;
  createAttendeeBadgeByBadgeName?: Resolver<ResolversTypes['AttendeeBadge'], ParentType, ContextType, RequireFields<MutationCreateAttendeeBadgeByBadgeNameArgs, 'newAttendeeBadgeByBadgeNameInput'>>;
  createBadge?: Resolver<ResolversTypes['Badge'], ParentType, ContextType, RequireFields<MutationCreateBadgeArgs, 'newBadgeInput'>>;
  createBadgeGroup?: Resolver<ResolversTypes['BadgeGroup'], ParentType, ContextType, RequireFields<MutationCreateBadgeGroupArgs, 'newBadgeGroupInput'>>;
  createBillingAddressTemplate?: Resolver<ResolversTypes['BillingAddressTemplate'], ParentType, ContextType, RequireFields<MutationCreateBillingAddressTemplateArgs, 'input'>>;
  createBooker?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<MutationCreateBookerArgs, 'newBookerData'>>;
  createBooking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationCreateBookingArgs, 'newBookingData' | 'sendMail'>>;
  createBookingRestriction?: Resolver<ResolversTypes['BookingRestriction'], ParentType, ContextType, RequireFields<MutationCreateBookingRestrictionArgs, 'newBookingRestrictionInput'>>;
  createBookingWithCourseLessonBookings?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationCreateBookingWithCourseLessonBookingsArgs, 'newBookingInputBookableLessons'>>;
  createCertificateTemplate?: Resolver<ResolversTypes['CertificateTemplate'], ParentType, ContextType, RequireFields<MutationCreateCertificateTemplateArgs, 'input'>>;
  createCorrectionInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationCreateCorrectionInvoiceArgs, 'bookingId' | 'sendMail'>>;
  createCourse?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<MutationCreateCourseArgs, 'newCourseData'>>;
  createCourseCategory?: Resolver<ResolversTypes['CourseCategory'], ParentType, ContextType, RequireFields<MutationCreateCourseCategoryArgs, 'newCourseCategoryData'>>;
  createCourseLesson?: Resolver<ResolversTypes['CourseLesson'], ParentType, ContextType, RequireFields<MutationCreateCourseLessonArgs, 'newCourseLessonData'>>;
  createCourseLessonBooking?: Resolver<ResolversTypes['CourseLessonBooking'], ParentType, ContextType, RequireFields<MutationCreateCourseLessonBookingArgs, 'newCourseLessonBookingInput'>>;
  createCourseLessonBookingsByCourseId?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationCreateCourseLessonBookingsByCourseIdArgs, 'courseId'>>;
  createCourseLessons?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<MutationCreateCourseLessonsArgs, 'newCourseLessonData'>>;
  createCourseType?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType, RequireFields<MutationCreateCourseTypeArgs, 'newCourseTypeData'>>;
  createCustomBankData?: Resolver<ResolversTypes['CustomBankData'], ParentType, ContextType, RequireFields<MutationCreateCustomBankDataArgs, 'newCustomBankDataInput'>>;
  createDatabaseBackup?: Resolver<ResolversTypes['DatabaseBackup'], ParentType, ContextType>;
  createDataExport?: Resolver<ResolversTypes['DataExport'], ParentType, ContextType>;
  createDiscountCode?: Resolver<ResolversTypes['DiscountCode'], ParentType, ContextType, RequireFields<MutationCreateDiscountCodeArgs, 'input'>>;
  createDummyCamtFileForMultiplePayments?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateDummyCamtFileForMultiplePaymentsArgs, 'createDummySwissCamtByScheduledPaymentsInput'>>;
  createDunning?: Resolver<ResolversTypes['Dunning'], ParentType, ContextType, RequireFields<MutationCreateDunningArgs, 'input'>>;
  createFaUserWithOrAddEndUserRights?: Resolver<ResolversTypes['FaUser'], ParentType, ContextType, RequireFields<MutationCreateFaUserWithOrAddEndUserRightsArgs, 'email'>>;
  createFeeLetter?: Resolver<ResolversTypes['FeeLetter'], ParentType, ContextType, RequireFields<MutationCreateFeeLetterArgs, 'input'>>;
  createInstallmentRate?: Resolver<ResolversTypes['InstallmentRate'], ParentType, ContextType, RequireFields<MutationCreateInstallmentRateArgs, 'newInstallmentRateInput'>>;
  createInstructorInvoice?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateInstructorInvoiceArgs, 'input'>>;
  createInterestList?: Resolver<ResolversTypes['InterestList'], ParentType, ContextType, RequireFields<MutationCreateInterestListArgs, 'input'>>;
  createInterestRegistration?: Resolver<ResolversTypes['InterestRegistration'], ParentType, ContextType, RequireFields<MutationCreateInterestRegistrationArgs, 'input' | 'sendConfirmationMail'>>;
  createInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationCreateInvoiceArgs, 'newInvoiceData' | 'sendMail'>>;
  createInvoiceExport?: Resolver<ResolversTypes['InvoiceExport'], ParentType, ContextType, RequireFields<MutationCreateInvoiceExportArgs, 'includeReversals'>>;
  createInvoicesByBookingIds?: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<MutationCreateInvoicesByBookingIdsArgs, 'bookingIds' | 'sendMail'>>;
  createInvoicesByCourseId?: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<MutationCreateInvoicesByCourseIdArgs, 'courseId' | 'sendMail'>>;
  createInvoiceTemplateSet?: Resolver<ResolversTypes['InvoiceTemplateSet'], ParentType, ContextType, RequireFields<MutationCreateInvoiceTemplateSetArgs, 'name'>>;
  createLessonBooking?: Resolver<ResolversTypes['BookingWithCourseLessons'], ParentType, ContextType, RequireFields<MutationCreateLessonBookingArgs, 'newBookingData' | 'sendMail'>>;
  createLocation?: Resolver<ResolversTypes['Location'], ParentType, ContextType, RequireFields<MutationCreateLocationArgs, 'newLocationData'>>;
  createLocationContact?: Resolver<ResolversTypes['LocationContact'], ParentType, ContextType, RequireFields<MutationCreateLocationContactArgs, 'newLocationContactData'>>;
  createMailjetSender?: Resolver<ResolversTypes['CreateMailjetSenderOutput'], ParentType, ContextType, RequireFields<MutationCreateMailjetSenderArgs, 'createMailjetSenderInput'>>;
  createMolliePayment?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationCreateMolliePaymentArgs, 'method' | 'scheduledPaymentId'>>;
  createNewMolliePaymentAttemptFromAdmin?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationCreateNewMolliePaymentAttemptFromAdminArgs, 'scheduledPaymentId'>>;
  createNewsletterCustomList?: Resolver<ResolversTypes['NewsletterLocationList'], ParentType, ContextType, RequireFields<MutationCreateNewsletterCustomListArgs, 'locationIds' | 'name'>>;
  createOrganization?: Resolver<ResolversTypes['CreateOrganizationResult'], ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'koOrganizationData'>>;
  createParticipationPrerequisite?: Resolver<ResolversTypes['ParticipationPrerequisites'], ParentType, ContextType, RequireFields<MutationCreateParticipationPrerequisiteArgs, 'newParticipationPrerequisitesInput'>>;
  createSepaXmlById?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateSepaXmlByIdArgs, 'createSingleSepaXmlInput'>>;
  createSepaXmlByTimeRange?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationCreateSepaXmlByTimeRangeArgs, 'createSepaXmlByTimeRangeInput'>>;
  createSettingEndUserApp?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationCreateSettingEndUserAppArgs, 'settingEndUserAppInput'>>;
  createSettingEndUserAppWithDefaultValues?: Resolver<ResolversTypes['SettingEndUserApp'], ParentType, ContextType>;
  createTemplate?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationCreateTemplateArgs, 'newTemplateData'>>;
  createWithdrawalEndUserApp?: Resolver<ResolversTypes['WithdrawalEndUserAppResult'], ParentType, ContextType, RequireFields<MutationCreateWithdrawalEndUserAppArgs, 'input'>>;
  createYearEndExport?: Resolver<ResolversTypes['YearEndExport'], ParentType, ContextType, RequireFields<MutationCreateYearEndExportArgs, 'year'>>;
  deactivateCoursesAllowLessonBooking?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<MutationDeactivateCoursesAllowLessonBookingArgs, 'subscriptionId'>>;
  deactivateDiscountCode?: Resolver<ResolversTypes['DiscountCode'], ParentType, ContextType, RequireFields<MutationDeactivateDiscountCodeArgs, 'id'>>;
  deactivateTenant?: Resolver<ResolversTypes['KoOrganization'], ParentType, ContextType, RequireFields<MutationDeactivateTenantArgs, 'koOrganizationId'>>;
  deleteAllAttendanceListArchives?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deleteAllMissingBankData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deleteAllPlaceReservationsByCourseId?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<MutationDeleteAllPlaceReservationsByCourseIdArgs, 'courseId'>>;
  deleteAnnouncement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAnnouncementArgs, 'id'>>;
  deleteAttendanceListArchive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAttendanceListArchiveArgs, 'jobGroupId'>>;
  deleteAttendee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAttendeeArgs, 'id'>>;
  deleteAttendeeBadge?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAttendeeBadgeArgs, 'id'>>;
  deleteBadge?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteBadgeArgs, 'id'>>;
  deleteBadgeGraphic?: Resolver<ResolversTypes['Badge'], ParentType, ContextType, RequireFields<MutationDeleteBadgeGraphicArgs, 'badgeId'>>;
  deleteBadgeGroup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteBadgeGroupArgs, 'id'>>;
  deleteBillingAddressTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteBillingAddressTemplateArgs, 'id'>>;
  deleteBooker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteBookerArgs, 'id'>>;
  deleteBookingRestriction?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteBookingRestrictionArgs, 'bookingRestrictionId'>>;
  deleteCategoryById?: Resolver<ResolversTypes['CourseCategory'], ParentType, ContextType, RequireFields<MutationDeleteCategoryByIdArgs, 'id'>>;
  deleteCertificateTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteCertificateTemplateArgs, 'id'>>;
  deleteCompanyLogo?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType>;
  deleteCourseLessonBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteCourseLessonBookingArgs, 'id'>>;
  deleteCustomBankData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteCustomBankDataArgs, 'id'>>;
  deleteDatabaseBackup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDatabaseBackupArgs, 'backupId'>>;
  deleteDataExport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDataExportArgs, 'exportId'>>;
  deleteDiscountCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDiscountCodeArgs, 'id'>>;
  deleteFileDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationDeleteFileDoArgs, 'fileName'>>;
  deleteFolderDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationDeleteFolderDoArgs, 'folderName'>>;
  deleteFusionAuthUserByIds?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteFusionAuthUserByIdsArgs, 'koOrganizationId' | 'userIds'>>;
  deleteFusionAuthUsersByEmails?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationDeleteFusionAuthUsersByEmailsArgs, 'emailAddresses'>>;
  deleteInstallmentRate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteInstallmentRateArgs, 'id'>>;
  deleteInstallmentRatesByCourseId?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<MutationDeleteInstallmentRatesByCourseIdArgs, 'courseId'>>;
  deleteInstructorInvoice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteInstructorInvoiceArgs, 'invoiceId'>>;
  deleteInvoiceExport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteInvoiceExportArgs, 'exportId'>>;
  deleteInvoiceTemplateSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteInvoiceTemplateSetArgs, 'id'>>;
  deleteMissingBankData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteMissingBankDataArgs, 'id'>>;
  deleteNewsletterCustomList?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteNewsletterCustomListArgs, 'id'>>;
  deletePage?: Resolver<ResolversTypes['PageStructure'], ParentType, ContextType, RequireFields<MutationDeletePageArgs, 'pageId'>>;
  deleteScheduledPayment?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationDeleteScheduledPaymentArgs, 'id'>>;
  deleteSelectionOfWaitlist?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<MutationDeleteSelectionOfWaitlistArgs, 'bookingIds'>>;
  deleteTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteTemplateArgs, 'id'>>;
  deleteYearEndExport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteYearEndExportArgs, 'exportId'>>;
  disableMaintenance?: Resolver<ResolversTypes['MaintenanceStatus'], ParentType, ContextType>;
  disablePasswordlessLoginEndUserApp?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  dismissDuplicatePair?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDismissDuplicatePairArgs, 'input'>>;
  downloadFileDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationDownloadFileDoArgs, 'fileName'>>;
  editLessonBooking?: Resolver<ResolversTypes['BookingWithCourseLessons'], ParentType, ContextType, RequireFields<MutationEditLessonBookingArgs, 'editBookingInputBookableLessons'>>;
  enableMaintenance?: Resolver<ResolversTypes['MaintenanceStatus'], ParentType, ContextType, Partial<MutationEnableMaintenanceArgs>>;
  enablePasswordlessLoginEndUserApp?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationEnablePasswordlessLoginEndUserAppArgs, 'passwordlessIdCodeLength'>>;
  eraseBookerData?: Resolver<ResolversTypes['ErasureReportType'], ParentType, ContextType, RequireFields<MutationEraseBookerDataArgs, 'bookerId'>>;
  erasurePreview?: Resolver<ResolversTypes['ErasureReportType'], ParentType, ContextType, RequireFields<MutationErasurePreviewArgs, 'bookerId'>>;
  executeBulkTransfer?: Resolver<ResolversTypes['ExecuteBulkTransferResult'], ParentType, ContextType, RequireFields<MutationExecuteBulkTransferArgs, 'input'>>;
  executeSettledBookingCorrection?: Resolver<ResolversTypes['SettledBookingCorrectionResult'], ParentType, ContextType, RequireFields<MutationExecuteSettledBookingCorrectionArgs, 'bookingId' | 'input' | 'sendCorrectionInvoiceMail'>>;
  executeTransfer?: Resolver<ResolversTypes['ExecuteTransferResult'], ParentType, ContextType, RequireFields<MutationExecuteTransferArgs, 'input'>>;
  fetchByYear?: Resolver<Array<ResolversTypes['Holiday']>, ParentType, ContextType, RequireFields<MutationFetchByYearArgs, 'year'>>;
  fetchByYearAndStateCode?: Resolver<Array<ResolversTypes['Holiday']>, ParentType, ContextType, RequireFields<MutationFetchByYearAndStateCodeArgs, 'stateCode' | 'year'>>;
  fetchPublicHolidaysByYear?: Resolver<Array<ResolversTypes['Holiday']>, ParentType, ContextType, RequireFields<MutationFetchPublicHolidaysByYearArgs, 'year'>>;
  fixMissingInvoiceIds?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<MutationFixMissingInvoiceIdsArgs>>;
  forceRollbackAllowMolliePayment?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<MutationForceRollbackAllowMolliePaymentArgs, 'courseId' | 'reason'>>;
  forgetPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationForgetPasswordArgs, 'email'>>;
  forgotPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationForgotPasswordArgs, 'forgotPasswordWithStateInput'>>;
  generatePasswordResetLink?: Resolver<ResolversTypes['PasswordResetLinkType'], ParentType, ContextType, RequireFields<MutationGeneratePasswordResetLinkArgs, 'forgotPasswordWithStateInput'>>;
  generatePaymentSchedulePreview?: Resolver<Array<ResolversTypes['JSONObject']>, ParentType, ContextType, RequireFields<MutationGeneratePaymentSchedulePreviewArgs, 'bookingPrice' | 'lessonDates' | 'monthlySchedule' | 'paymentType'>>;
  generateScheduledPaymentsByCourse?: Resolver<ResolversTypes['ScheduledPaymentPreview'], ParentType, ContextType, RequireFields<MutationGenerateScheduledPaymentsByCourseArgs, 'courseId'>>;
  generateScheduledPaymentsForSettledBooking?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType, RequireFields<MutationGenerateScheduledPaymentsForSettledBookingArgs, 'bookingId'>>;
  generateUpdatedSchedulesNewBookingPrice?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType, RequireFields<MutationGenerateUpdatedSchedulesNewBookingPriceArgs, 'bookingPrice' | 'scheduledPayments'>>;
  getMyCalendarFeedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hardDeleteTenant?: Resolver<ResolversTypes['TenantDeletionResult'], ParentType, ContextType, RequireFields<MutationHardDeleteTenantArgs, 'confirmationCode' | 'koOrganizationId'>>;
  importBookers?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationImportBookersArgs, 'importBookersInput'>>;
  importNewsletterUnsubscribesFromMailjet?: Resolver<ResolversTypes['NewsletterUnsubscribeImportResult'], ParentType, ContextType>;
  initiateMolliePaymentForBookingFromEndUserApp?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationInitiateMolliePaymentForBookingFromEndUserAppArgs, 'bookingId' | 'method'>>;
  issueCertificate?: Resolver<ResolversTypes['IssuedCertificate'], ParentType, ContextType, RequireFields<MutationIssueCertificateArgs, 'input'>>;
  issueCertificatesByAttendees?: Resolver<Array<ResolversTypes['IssuedCertificate']>, ParentType, ContextType, RequireFields<MutationIssueCertificatesByAttendeesArgs, 'input'>>;
  issueCertificatesByCourse?: Resolver<Array<ResolversTypes['IssuedCertificate']>, ParentType, ContextType, RequireFields<MutationIssueCertificatesByCourseArgs, 'input'>>;
  ko9DetectSchema?: Resolver<ResolversTypes['Ko9SchemaInfoType'], ParentType, ContextType, RequireFields<MutationKo9DetectSchemaArgs, 'credentials'>>;
  ko9DryRun?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationKo9DryRunArgs, 'config' | 'credentials'>>;
  ko9ExecuteImport?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationKo9ExecuteImportArgs, 'config' | 'credentials'>>;
  ko9FetchPreview?: Resolver<ResolversTypes['Ko9PreviewResultType'], ParentType, ContextType, RequireFields<MutationKo9FetchPreviewArgs, 'config' | 'credentials'>>;
  ko9RollbackImport?: Resolver<ResolversTypes['Ko9RollbackResultType'], ParentType, ContextType, RequireFields<MutationKo9RollbackImportArgs, 'bookerIds'>>;
  ko9SaveCredentials?: Resolver<ResolversTypes['Ko9SaveResult'], ParentType, ContextType, RequireFields<MutationKo9SaveCredentialsArgs, 'credentials'>>;
  ko9TestConnection?: Resolver<ResolversTypes['Ko9ConnectionTestResult'], ParentType, ContextType, RequireFields<MutationKo9TestConnectionArgs, 'credentials'>>;
  linkAttendeeToBooker?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType, RequireFields<MutationLinkAttendeeToBookerArgs, 'attendeeId'>>;
  logging?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationLoggingArgs, 'input'>>;
  loginWithPassword?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationLoginWithPasswordArgs, 'loginInput'>>;
  logoutUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  markScheduledPaymentsAsPaidFromSepaExport?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<MutationMarkScheduledPaymentsAsPaidFromSepaExportArgs, 'input'>>;
  mergeAttendees?: Resolver<ResolversTypes['AttendeeMergeResult'], ParentType, ContextType, RequireFields<MutationMergeAttendeesArgs, 'loserAttendeeId' | 'winnerAttendeeId'>>;
  mergeBookers?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<MutationMergeBookersArgs, 'mergedBookerId' | 'updateBookerData'>>;
  modifyScheduledPayment?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationModifyScheduledPaymentArgs, 'modifyScheduledPaymentInput'>>;
  mollieCreateClientLink?: Resolver<ResolversTypes['MollieCreateClientLinkResult'], ParentType, ContextType, RequireFields<MutationMollieCreateClientLinkArgs, 'input'>>;
  mollieDisconnect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mollieGetConnectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  moveBadge?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationMoveBadgeArgs, 'movedBadgeId'>>;
  passwordlessLogin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPasswordlessLoginArgs, 'loginData'>>;
  passwordlessLoginEndUserApp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPasswordlessLoginEndUserAppArgs, 'endUserPasswordlessLoginInput'>>;
  previewInstructorInvoice?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationPreviewInstructorInvoiceArgs, 'input'>>;
  reactivateBookerNewsletter?: Resolver<ResolversTypes['NewsletterBookerStatus'], ParentType, ContextType, RequireFields<MutationReactivateBookerNewsletterArgs, 'bookerId'>>;
  reactivateDiscountCode?: Resolver<ResolversTypes['DiscountCode'], ParentType, ContextType, RequireFields<MutationReactivateDiscountCodeArgs, 'id'>>;
  reactivateTenant?: Resolver<ResolversTypes['KoOrganization'], ParentType, ContextType, RequireFields<MutationReactivateTenantArgs, 'koOrganizationId'>>;
  recordExternalPaymentForScheduledPayment?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationRecordExternalPaymentForScheduledPaymentArgs, 'input'>>;
  recordLikelyBankTransactions?: Resolver<ResolversTypes['BankTransactionRecordAllResult'], ParentType, ContextType, Partial<MutationRecordLikelyBankTransactionsArgs>>;
  refactoredCourseDetails?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRefactoredCourseDetailsArgs, 'courseId'>>;
  refreshAccessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRefreshAccessTokenArgs, 'refreshToken'>>;
  refreshMolliePaymentStatusFromAdmin?: Resolver<Maybe<ResolversTypes['MolliePaymentAttempt']>, ParentType, ContextType, RequireFields<MutationRefreshMolliePaymentStatusFromAdminArgs, 'scheduledPaymentId'>>;
  refundMolliePaymentFromAdmin?: Resolver<ResolversTypes['MollieRefund'], ParentType, ContextType, RequireFields<MutationRefundMolliePaymentFromAdminArgs, 'amount' | 'scheduledPaymentId'>>;
  rejectBankTransaction?: Resolver<ResolversTypes['BankTransaction'], ParentType, ContextType, RequireFields<MutationRejectBankTransactionArgs, 'id' | 'reason'>>;
  rematchAllBankImportFiles?: Resolver<ResolversTypes['BankImportRematchAllResult'], ParentType, ContextType, Partial<MutationRematchAllBankImportFilesArgs>>;
  rematchBankImportFile?: Resolver<ResolversTypes['BankImportFile'], ParentType, ContextType, RequireFields<MutationRematchBankImportFileArgs, 'id'>>;
  removeAdminManagementUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveAdminManagementUserArgs, 'input'>>;
  removeAllBookersOfTenant?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  removeAllBookings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  removeAssistantFromControlBoard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveAssistantFromControlBoardArgs, 'input'>>;
  removeBookableCourse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveBookableCourseArgs, 'bookableCourseId' | 'prerquisiteCourseId'>>;
  removeBooking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveBookingArgs, 'id'>>;
  removeBookings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveBookingsArgs, 'ids'>>;
  removeCourse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveCourseArgs, 'id'>>;
  removeCourseLesson?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveCourseLessonArgs, 'id'>>;
  removeCourseType?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveCourseTypeArgs, 'id'>>;
  removeInstructor?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveInstructorArgs, 'id'>>;
  removeInterestList?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveInterestListArgs, 'id'>>;
  removeInterestRegistration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveInterestRegistrationArgs, 'id'>>;
  removeLocation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveLocationArgs, 'id'>>;
  removeLocationContact?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveLocationContactArgs, 'id'>>;
  removeParticipationPrerequisite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveParticipationPrerequisiteArgs, 'id'>>;
  renameFileDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationRenameFileDoArgs, 'fileName' | 'newFileName'>>;
  renameFolderDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationRenameFolderDoArgs, 'folderName' | 'newFolderName'>>;
  renewNewsletterWebhookToken?: Resolver<ResolversTypes['NewsletterSettings'], ParentType, ContextType>;
  reOrderBadgeGroups?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationReOrderBadgeGroupsArgs, 'movedGroupId' | 'targetGroupId'>>;
  reOrderBadges?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationReOrderBadgesArgs, 'movedBadgeId' | 'targetBadgeId'>>;
  reportEmbedConversion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationReportEmbedConversionArgs, 'reported'>>;
  reportEndUserEvent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationReportEndUserEventArgs, 'input'>>;
  requestAdminOrgDiscovery?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRequestAdminOrgDiscoveryArgs, 'email'>>;
  requestBookerLinkRegistration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRequestBookerLinkRegistrationArgs, 'email'>>;
  requestStaffMobileOrgDiscovery?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRequestStaffMobileOrgDiscoveryArgs, 'email'>>;
  requestStaffMobilePasswordReset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRequestStaffMobilePasswordResetArgs, 'email'>>;
  resendBookingConfirmation?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationResendBookingConfirmationArgs, 'bookingId'>>;
  resendCertificateEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResendCertificateEmailArgs, 'issuedCertificateId'>>;
  resendDunning?: Resolver<ResolversTypes['Dunning'], ParentType, ContextType, RequireFields<MutationResendDunningArgs, 'id'>>;
  resendEmailVerification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResendEmailVerificationArgs, 'userId'>>;
  resetAllUnsetteledScheduledPaymentsOfCourse?: Resolver<ResolversTypes['ResetScheduledPaymentsOfCourseResult'], ParentType, ContextType, RequireFields<MutationResetAllUnsetteledScheduledPaymentsOfCourseArgs, 'courseId'>>;
  resetMyCalendarFeedToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resetNewsletterLocationListLink?: Resolver<ResolversTypes['NewsletterLocationList'], ParentType, ContextType, RequireFields<MutationResetNewsletterLocationListLinkArgs, 'id'>>;
  resetPaymentPlanOfInvoicedLessonBooking?: Resolver<ResolversTypes['ResetPaymentPlanOfInvoicedLessonBookingResult'], ParentType, ContextType, RequireFields<MutationResetPaymentPlanOfInvoicedLessonBookingArgs, 'bookingId'>>;
  resetPerformanceStats?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  resetScheduledPaymentsOfBooking?: Resolver<ResolversTypes['ResetScheduledPaymentsOfBookingResult'], ParentType, ContextType, RequireFields<MutationResetScheduledPaymentsOfBookingArgs, 'bookingId'>>;
  resolveAmbiguousSwissQRPayment?: Resolver<ResolversTypes['SwissQRFileRecord'], ParentType, ContextType, RequireFields<MutationResolveAmbiguousSwissQrPaymentArgs, 'comment' | 'recordId'>>;
  resolveChargeback?: Resolver<ResolversTypes['MolliePaymentAttempt'], ParentType, ContextType, RequireFields<MutationResolveChargebackArgs, 'attemptId'>>;
  resolveSurplusMolliePayments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResolveSurplusMolliePaymentsArgs, 'scheduledPaymentId'>>;
  restoreDatabaseBackup?: Resolver<ResolversTypes['DatabaseBackup'], ParentType, ContextType, RequireFields<MutationRestoreDatabaseBackupArgs, 'input'>>;
  restoreOrphanBooking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationRestoreOrphanBookingArgs, 'bookingId' | 'koOrganizationId'>>;
  restoreScheduledPayment?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationRestoreScheduledPaymentArgs, 'id'>>;
  retryMolliePayment?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationRetryMolliePaymentArgs, 'scheduledPaymentId'>>;
  retryMolliePaymentManually?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRetryMolliePaymentManuallyArgs, 'scheduledPaymentId'>>;
  retryTenantMetricsAiSummary?: Resolver<ResolversTypes['TenantMetricsAiSummary'], ParentType, ContextType>;
  rollbackPaymentStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRollbackPaymentStatusArgs, 'id'>>;
  runMollieReconciliationNow?: Resolver<ResolversTypes['MollieManualReconciliationResult'], ParentType, ContextType>;
  saveAdmin?: Resolver<ResolversTypes['Admin'], ParentType, ContextType, RequireFields<MutationSaveAdminArgs, 'saveAdminData'>>;
  saveInstructor?: Resolver<ResolversTypes['Instructor'], ParentType, ContextType, RequireFields<MutationSaveInstructorArgs, 'saveInstructorData'>>;
  sendAttendanceListArchive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendAttendanceListArchiveArgs, 'input'>>;
  sendAttendanceListArchiveTestEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendAttendanceListArchiveTestEmailArgs, 'input'>>;
  sendBlankMailToMultipleBookers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendBlankMailToMultipleBookersArgs, 'input'>>;
  sendBookingConfirmation?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendBookingConfirmationArgs, 'bookingId'>>;
  sendBookingInvoice?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendBookingInvoiceArgs, 'bookingId'>>;
  sendBookingInvoicesByBookingIds?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendBookingInvoicesByBookingIdsArgs, 'bookingIds'>>;
  sendEmailsToSelectionOfCourse?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendEmailsToSelectionOfCourseArgs, 'sendMailToSelectionOfCourseInput'>>;
  sendEmailTemplate?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendEmailTemplateArgs, 'sendTemplateInput'>>;
  sendEmailToSelectionOfAttendees?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendEmailToSelectionOfAttendeesArgs, 'sendMailToSelectionOfAttendeesInput'>>;
  sendEmailToSelectionOfBookers?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendEmailToSelectionOfBookersArgs, 'sendMailToSelectionOfBookersInput'>>;
  sendEmailToSelectionOfScheduledPayments?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendEmailToSelectionOfScheduledPaymentsArgs, 'sendMailToSelectionOfScheduledPaymentsInput'>>;
  sendEmailToSelectionOfStaff?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendEmailToSelectionOfStaffArgs, 'sendMailToSelectionOfStaffInput'>>;
  sendInvoicesToSelectionOfBookings?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendInvoicesToSelectionOfBookingsArgs, 'sendInvoicesToSelectionOfBookingsInput'>>;
  sendMail?: Resolver<Array<ResolversTypes['JSONObject']>, ParentType, ContextType, RequireFields<MutationSendMailArgs, 'sendParamsMessageInput'>>;
  sendMailToSelectionOfBookings?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendMailToSelectionOfBookingsArgs, 'sendMailToSelectionOfBookingInput'>>;
  sendMolliePaymentLinkForBookingFromAdmin?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationSendMolliePaymentLinkForBookingFromAdminArgs, 'bookingId' | 'locale'>>;
  sendMolliePaymentLinkFromAdmin?: Resolver<Maybe<ResolversTypes['MolliePaymentResult']>, ParentType, ContextType, RequireFields<MutationSendMolliePaymentLinkFromAdminArgs, 'locale' | 'scheduledPaymentId'>>;
  sendPasswordResetLinkEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendPasswordResetLinkEmailArgs, 'input'>>;
  sendSms?: Resolver<ResolversTypes['Sms77JsonResponse'], ParentType, ContextType, RequireFields<MutationSendSmsArgs, 'smsParams'>>;
  sendTestMail?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, Partial<MutationSendTestMailArgs>>;
  sendTestMailBooker?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSendTestMailBookerArgs, 'bookerId'>>;
  setBankTransactionCounterpart?: Resolver<ResolversTypes['BankTransaction'], ParentType, ContextType, RequireFields<MutationSetBankTransactionCounterpartArgs, 'id' | 'treatAs'>>;
  setDunningPause?: Resolver<ResolversTypes['DunningPause'], ParentType, ContextType, RequireFields<MutationSetDunningPauseArgs, 'input'>>;
  setIncludeCourseDetails?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationSetIncludeCourseDetailsArgs, 'includeCourseDetails' | 'templateId'>>;
  setInterestListNoteFieldDefault?: Resolver<ResolversTypes['Setting'], ParentType, ContextType, RequireFields<MutationSetInterestListNoteFieldDefaultArgs, 'applyToExisting' | 'showNoteField'>>;
  setMultipleScheduledPaymentsPaid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetMultipleScheduledPaymentsPaidArgs, 'paymentIds'>>;
  setNewCustomerNumber?: Resolver<ResolversTypes['Customer'], ParentType, ContextType, RequireFields<MutationSetNewCustomerNumberArgs, 'newCustomerNumber'>>;
  setNewPaymentAmount?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationSetNewPaymentAmountArgs, 'id' | 'paymentAmount'>>;
  setNewPaymentDoneDate?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationSetNewPaymentDoneDateArgs, 'id' | 'paymentDoneDate'>>;
  setNewsletterLocationListEnabled?: Resolver<ResolversTypes['NewsletterLocationList'], ParentType, ContextType, RequireFields<MutationSetNewsletterLocationListEnabledArgs, 'enabled' | 'id'>>;
  setNewsletterLocationListExcluded?: Resolver<ResolversTypes['NewsletterLocationList'], ParentType, ContextType, RequireFields<MutationSetNewsletterLocationListExcludedArgs, 'excluded' | 'id'>>;
  setScheduledPaymentPaid?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationSetScheduledPaymentPaidArgs, 'id'>>;
  setScheduledPaymentUnpaid?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationSetScheduledPaymentUnpaidArgs, 'id'>>;
  setSepaClearance?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationSetSepaClearanceArgs, 'id' | 'sepaClearance'>>;
  setupNewsletterWebhook?: Resolver<ResolversTypes['NewsletterSettings'], ParentType, ContextType>;
  simulateMollieLinkWebhookForTesting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSimulateMollieLinkWebhookForTestingArgs, 'attemptId' | 'simulatedStatus'>>;
  simulateMollieWebhookForTesting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSimulateMollieWebhookForTestingArgs, 'molliePaymentId' | 'simulatedStatus'>>;
  singleUpload?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationSingleUploadArgs, 'file'>>;
  softDeleteBadge?: Resolver<ResolversTypes['Badge'], ParentType, ContextType, RequireFields<MutationSoftDeleteBadgeArgs, 'id'>>;
  submitSupportReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSubmitSupportReportArgs, 'input'>>;
  syncAllNewsletterLocationLists?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  syncNewsletterLocationList?: Resolver<ResolversTypes['NewsletterLocationList'], ParentType, ContextType, RequireFields<MutationSyncNewsletterLocationListArgs, 'id'>>;
  testLogin?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationTestLoginArgs, 'email'>>;
  testNewsletterConnection?: Resolver<ResolversTypes['NewsletterSettings'], ParentType, ContextType>;
  thirdPartyLogin?: Resolver<ResolversTypes['UserType'], ParentType, ContextType, RequireFields<MutationThirdPartyLoginArgs, 'thirdPartyLoginInput'>>;
  toggleAreaManagerRoleFromAdminManagement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationToggleAreaManagerRoleFromAdminManagementArgs, 'input'>>;
  toggleAttendeeBadgeRequirement?: Resolver<ResolversTypes['AttendeeBadgeRequirement'], ParentType, ContextType, RequireFields<MutationToggleAttendeeBadgeRequirementArgs, 'input'>>;
  toggleUserRole?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationToggleUserRoleArgs, 'toggleUserRoleInput'>>;
  transferAttendeeToBooker?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType, RequireFields<MutationTransferAttendeeToBookerArgs, 'attendeeId' | 'newBookerId'>>;
  transferAttendeeToCourse?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationTransferAttendeeToCourseArgs, 'bookingId' | 'targetCourseId'>>;
  transferMultipleBookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType, RequireFields<MutationTransferMultipleBookingsArgs, 'transferMultipleBookingsInput'>>;
  triggerDuplicateDetection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unassignMyselfFromCourseLessonAssistantApp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUnassignMyselfFromCourseLessonAssistantAppArgs, 'courseLessonId'>>;
  undoDuplicateException?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUndoDuplicateExceptionArgs, 'id'>>;
  unsubscribeBookerFromNewsletter?: Resolver<ResolversTypes['NewsletterBookerStatus'], ParentType, ContextType, RequireFields<MutationUnsubscribeBookerFromNewsletterArgs, 'bookerId'>>;
  updateAdminManagementUserEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateAdminManagementUserEmailArgs, 'input'>>;
  updateAdminManagementUserName?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateAdminManagementUserNameArgs, 'input'>>;
  updateAllowedMollieMethods?: Resolver<ResolversTypes['PlatformConfig'], ParentType, ContextType, RequireFields<MutationUpdateAllowedMollieMethodsArgs, 'methods'>>;
  updateAnnouncement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType, RequireFields<MutationUpdateAnnouncementArgs, 'id' | 'input'>>;
  updateAttendanceListNote?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationUpdateAttendanceListNoteArgs, 'bookingId'>>;
  updateAttendanceListSettings?: Resolver<ResolversTypes['UserSetting'], ParentType, ContextType, RequireFields<MutationUpdateAttendanceListSettingsArgs, 'updateAttendanceListSettingsInput'>>;
  updateAttendeeBadge?: Resolver<ResolversTypes['AttendeeBadge'], ParentType, ContextType, RequireFields<MutationUpdateAttendeeBadgeArgs, 'editAttendeeBadgeInput'>>;
  updateBadge?: Resolver<ResolversTypes['Badge'], ParentType, ContextType, RequireFields<MutationUpdateBadgeArgs, 'updateBadgeInput'>>;
  updateBadgeGroup?: Resolver<ResolversTypes['BadgeGroup'], ParentType, ContextType, RequireFields<MutationUpdateBadgeGroupArgs, 'updateBadgeGroupInput'>>;
  updateBankTransactionComment?: Resolver<ResolversTypes['BankTransaction'], ParentType, ContextType, RequireFields<MutationUpdateBankTransactionCommentArgs, 'id'>>;
  updateBillingAddressTemplate?: Resolver<ResolversTypes['BillingAddressTemplate'], ParentType, ContextType, RequireFields<MutationUpdateBillingAddressTemplateArgs, 'input'>>;
  updateBillingAmountForCourse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateBillingAmountForCourseArgs, 'courseId'>>;
  updateBillingAmountForCourseLesson?: Resolver<ResolversTypes['CourseLesson'], ParentType, ContextType, RequireFields<MutationUpdateBillingAmountForCourseLessonArgs, 'courseLessonId'>>;
  updateBooker?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<MutationUpdateBookerArgs, 'fromEndUserApp' | 'updateBookerData'>>;
  updateBookerAccountEndUserApp?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<MutationUpdateBookerAccountEndUserAppArgs, 'fromEndUserApp' | 'updateBookerEndUserAppData'>>;
  updateBookerCredit?: Resolver<ResolversTypes['Booker'], ParentType, ContextType, RequireFields<MutationUpdateBookerCreditArgs, 'amount' | 'bookerId' | 'note'>>;
  updateBookerIdMissmatch?: Resolver<ResolversTypes['EmailNotification'], ParentType, ContextType, RequireFields<MutationUpdateBookerIdMissmatchArgs, 'newBookerId' | 'notificationId'>>;
  updateBooking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationUpdateBookingArgs, 'editBookingData' | 'id'>>;
  updateBookingPaymentMethod?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationUpdateBookingPaymentMethodArgs, 'bookingId' | 'paymentMethodId'>>;
  updateBookingRestriction?: Resolver<ResolversTypes['BookingRestriction'], ParentType, ContextType, RequireFields<MutationUpdateBookingRestrictionArgs, 'updateBookingRestrictionInput'>>;
  updateCertificateTemplate?: Resolver<ResolversTypes['CertificateTemplate'], ParentType, ContextType, RequireFields<MutationUpdateCertificateTemplateArgs, 'input'>>;
  updateCompanyAgb?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType, RequireFields<MutationUpdateCompanyAgbArgs, 'agb'>>;
  updateCompanyPrivacyStatement?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType, RequireFields<MutationUpdateCompanyPrivacyStatementArgs, 'privacyStatement'>>;
  updateCompanySettings?: Resolver<ResolversTypes['CompanySetting'], ParentType, ContextType, RequireFields<MutationUpdateCompanySettingsArgs, 'newCompanyData'>>;
  updateCourse?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<MutationUpdateCourseArgs, 'editCourseData' | 'id'>>;
  updateCourseAndBookings?: Resolver<ResolversTypes['UpdateCourseAndBookingsResult'], ParentType, ContextType, RequireFields<MutationUpdateCourseAndBookingsArgs, 'dryRun' | 'updateCourseAndBookingsInput'>>;
  updateCourseAnnotation?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<MutationUpdateCourseAnnotationArgs, 'id'>>;
  updateCourseArchived?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<MutationUpdateCourseArchivedArgs, 'courseId' | 'isArchived'>>;
  updateCourseBlockBookingOnline?: Resolver<ResolversTypes['Course'], ParentType, ContextType, RequireFields<MutationUpdateCourseBlockBookingOnlineArgs, 'blockBookingOnline' | 'courseId'>>;
  updateCourseCategory?: Resolver<ResolversTypes['CourseCategory'], ParentType, ContextType, RequireFields<MutationUpdateCourseCategoryArgs, 'id' | 'newCourseCategoryData'>>;
  updateCourseLessonBooking?: Resolver<ResolversTypes['CourseLessonBooking'], ParentType, ContextType, RequireFields<MutationUpdateCourseLessonBookingArgs, 'updateCourseLessonBookingInput'>>;
  updateCourseLessonInstructors?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType, RequireFields<MutationUpdateCourseLessonInstructorsArgs, 'courseLessonId' | 'instructorIds' | 'scope'>>;
  updateCoursesStartDateTime?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, Partial<MutationUpdateCoursesStartDateTimeArgs>>;
  updateCourseType?: Resolver<ResolversTypes['CourseType'], ParentType, ContextType, RequireFields<MutationUpdateCourseTypeArgs, 'id' | 'newCourseTypeData'>>;
  updateCustomBankData?: Resolver<ResolversTypes['CustomBankData'], ParentType, ContextType, RequireFields<MutationUpdateCustomBankDataArgs, 'updateCustomBankDataInput'>>;
  updateCustomCompanyHolidays?: Resolver<Array<ResolversTypes['Holiday']>, ParentType, ContextType, RequireFields<MutationUpdateCustomCompanyHolidaysArgs, 'holidayInputs'>>;
  updateDiscountCode?: Resolver<ResolversTypes['DiscountCode'], ParentType, ContextType, RequireFields<MutationUpdateDiscountCodeArgs, 'id' | 'input'>>;
  updateInstallmentRate?: Resolver<ResolversTypes['InstallmentRate'], ParentType, ContextType, RequireFields<MutationUpdateInstallmentRateArgs, 'updateInstallmentRateInput'>>;
  updateInterestList?: Resolver<ResolversTypes['InterestList'], ParentType, ContextType, RequireFields<MutationUpdateInterestListArgs, 'input'>>;
  updateInterestRegistration?: Resolver<ResolversTypes['InterestRegistration'], ParentType, ContextType, RequireFields<MutationUpdateInterestRegistrationArgs, 'input'>>;
  updateInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationUpdateInvoiceArgs, 'editInvoiceData' | 'id'>>;
  updateInvoiceTemplateSet?: Resolver<ResolversTypes['InvoiceTemplateSet'], ParentType, ContextType, RequireFields<MutationUpdateInvoiceTemplateSetArgs, 'input'>>;
  updateLateEntryPricingConfiguration?: Resolver<ResolversTypes['SettingEndUserApp'], ParentType, ContextType, RequireFields<MutationUpdateLateEntryPricingConfigurationArgs, 'input'>>;
  updateLocalLocationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, Partial<MutationUpdateLocalLocationIdArgs>>;
  updateLocation?: Resolver<ResolversTypes['Location'], ParentType, ContextType, RequireFields<MutationUpdateLocationArgs, 'editLocationData'>>;
  updateLocationContact?: Resolver<ResolversTypes['LocationContact'], ParentType, ContextType, RequireFields<MutationUpdateLocationContactArgs, 'editLocationContactData'>>;
  updateLocationPublishedStatus?: Resolver<ResolversTypes['Location'], ParentType, ContextType, RequireFields<MutationUpdateLocationPublishedStatusArgs, 'isPublished' | 'locationId'>>;
  updateManyScheduledPaymentIds?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType, RequireFields<MutationUpdateManyScheduledPaymentIdsArgs, 'editScheduledPaymentData' | 'paymentIds'>>;
  updateMollieEnabledMethods?: Resolver<Array<ResolversTypes['MollieMethodInfo']>, ParentType, ContextType, RequireFields<MutationUpdateMollieEnabledMethodsArgs, 'methodIds'>>;
  updateMultipleBookerIdMissmatches?: Resolver<Array<ResolversTypes['EmailNotification']>, ParentType, ContextType, RequireFields<MutationUpdateMultipleBookerIdMissmatchesArgs, 'updateMultipleBookerIdMissmatchesInput'>>;
  updateMultipleCoursesArchived?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<MutationUpdateMultipleCoursesArchivedArgs, 'courseIds' | 'isArchived'>>;
  updateMultipleCoursesShowInWeb?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<MutationUpdateMultipleCoursesShowInWebArgs, 'courseIds' | 'showInWeb'>>;
  updateMyProfile?: Resolver<ResolversTypes['MyProfileType'], ParentType, ContextType, RequireFields<MutationUpdateMyProfileArgs, 'input'>>;
  updateNewsletterCustomList?: Resolver<ResolversTypes['NewsletterLocationList'], ParentType, ContextType, RequireFields<MutationUpdateNewsletterCustomListArgs, 'id' | 'locationIds' | 'name'>>;
  updateNewsletterRules?: Resolver<ResolversTypes['NewsletterSettings'], ParentType, ContextType, RequireFields<MutationUpdateNewsletterRulesArgs, 'input'>>;
  updateNewsletterSettings?: Resolver<ResolversTypes['NewsletterSettings'], ParentType, ContextType, RequireFields<MutationUpdateNewsletterSettingsArgs, 'input'>>;
  updateNoticeStaff?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationUpdateNoticeStaffArgs, 'id' | 'noticeStaff'>>;
  updateOrganizationSubscriptionType?: Resolver<ResolversTypes['KoOrganization'], ParentType, ContextType, RequireFields<MutationUpdateOrganizationSubscriptionTypeArgs, 'koOrganizationId' | 'subscriptionType'>>;
  updatePage?: Resolver<ResolversTypes['PageStructure'], ParentType, ContextType, RequireFields<MutationUpdatePageArgs, 'editPageInput'>>;
  updateParticipationPrerequisite?: Resolver<ResolversTypes['ParticipationPrerequisites'], ParentType, ContextType, RequireFields<MutationUpdateParticipationPrerequisiteArgs, 'updateParticipationPrerequisitesInput'>>;
  updateScheduledPayment?: Resolver<ResolversTypes['ScheduledPayment'], ParentType, ContextType, RequireFields<MutationUpdateScheduledPaymentArgs, 'editScheduledPaymentData' | 'id'>>;
  updateSepaPaymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType, RequireFields<MutationUpdateSepaPaymentMethodArgs, 'input'>>;
  updateSettingEndUserApp?: Resolver<ResolversTypes['SettingEndUserApp'], ParentType, ContextType, RequireFields<MutationUpdateSettingEndUserAppArgs, 'updateSettingEndUserAppInput'>>;
  updateSettings?: Resolver<ResolversTypes['Setting'], ParentType, ContextType, RequireFields<MutationUpdateSettingsArgs, 'newSettingsData'>>;
  updateSettledBookingDiscount?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationUpdateSettledBookingDiscountArgs, 'bookingId'>>;
  updateShowArchivedCourses?: Resolver<ResolversTypes['UserSetting'], ParentType, ContextType, RequireFields<MutationUpdateShowArchivedCoursesArgs, 'showArchivedCourses'>>;
  updateStaffVisibilityRules?: Resolver<ResolversTypes['StaffVisibilityRules'], ParentType, ContextType, RequireFields<MutationUpdateStaffVisibilityRulesArgs, 'input'>>;
  updateSubscriptionFeatures?: Resolver<ResolversTypes['Subscription'], ParentType, ContextType, RequireFields<MutationUpdateSubscriptionFeaturesArgs, 'features' | 'subscriptionId'>>;
  updateSwissQRFileNote?: Resolver<ResolversTypes['SwissQRFile'], ParentType, ContextType, RequireFields<MutationUpdateSwissQrFileNoteArgs, 'id'>>;
  updateTableColumnSettings?: Resolver<ResolversTypes['UserSetting'], ParentType, ContextType, RequireFields<MutationUpdateTableColumnSettingsArgs, 'updateTableColumnSettingsInput'>>;
  updateTemplate?: Resolver<ResolversTypes['Template'], ParentType, ContextType, RequireFields<MutationUpdateTemplateArgs, 'editTemplateData' | 'id'>>;
  updateWithdrawalStatus?: Resolver<ResolversTypes['WithdrawalRequest'], ParentType, ContextType, RequireFields<MutationUpdateWithdrawalStatusArgs, 'input'>>;
  uploadBadgeGraphic?: Resolver<ResolversTypes['Badge'], ParentType, ContextType, RequireFields<MutationUploadBadgeGraphicArgs, 'badgeId' | 'file'>>;
  uploadBankImportFile?: Resolver<ResolversTypes['BankImportFile'], ParentType, ContextType, RequireFields<MutationUploadBankImportFileArgs, 'file'>>;
  uploadBundesbankBlz?: Resolver<ResolversTypes['BundesbankImportResult'], ParentType, ContextType, RequireFields<MutationUploadBundesbankBlzArgs, 'file'>>;
  uploadCompanyLogo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationUploadCompanyLogoArgs, 'file'>>;
  uploadContentImage?: Resolver<ResolversTypes['UploadedContentImage'], ParentType, ContextType, RequireFields<MutationUploadContentImageArgs, 'file'>>;
  uploadDummyFile?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  uploadFilesDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationUploadFilesDoArgs, 'fileArray' | 'path'>>;
  uploadProfilePicture?: Resolver<ResolversTypes['MyProfileType'], ParentType, ContextType, RequireFields<MutationUploadProfilePictureArgs, 'file'>>;
  uploadSingleFileDo?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationUploadSingleFileDoArgs, 'file' | 'path'>>;
  upsertAttendeeBadgesWithRequirements?: Resolver<Array<ResolversTypes['AttendeeBadge']>, ParentType, ContextType, RequireFields<MutationUpsertAttendeeBadgesWithRequirementsArgs, 'input'>>;
  userSettingSetOptimizedCourseCalendar?: Resolver<ResolversTypes['UserSetting'], ParentType, ContextType, RequireFields<MutationUserSettingSetOptimizedCourseCalendarArgs, 'optimize'>>;
  userSettingsUpdateOrCreate?: Resolver<ResolversTypes['UserSetting'], ParentType, ContextType, RequireFields<MutationUserSettingsUpdateOrCreateArgs, 'userSettingsInput'>>;
  verifyBookersData?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType, RequireFields<MutationVerifyBookersDataArgs, 'importBookersInput'>>;
  voidMolliePaymentLinkForBooking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType, RequireFields<MutationVoidMolliePaymentLinkForBookingArgs, 'bookingId'>>;
  voidMolliePaymentLinksForBookings?: Resolver<Array<ResolversTypes['VoidPaymentLinkResult']>, ParentType, ContextType, RequireFields<MutationVoidMolliePaymentLinksForBookingsArgs, 'bookingIds'>>;
  withdrawDunning?: Resolver<ResolversTypes['Dunning'], ParentType, ContextType, RequireFields<MutationWithdrawDunningArgs, 'id' | 'reason'>>;
};

export type SetupScriptResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetupScriptResult'] = ResolversParentTypes['SetupScriptResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoMergeStartResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoMergeStartResult'] = ResolversParentTypes['AutoMergeStartResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoMergeDryRunResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoMergeDryRunResult'] = ResolversParentTypes['AutoMergeDryRunResult']> = {
  pairs?: Resolver<Array<ResolversTypes['AutoMergeDryRunPair']>, ParentType, ContextType>;
  totalBookersAffected?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPairs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoMergeDryRunPairResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoMergeDryRunPair'] = ResolversParentTypes['AutoMergeDryRunPair']> = {
  loserEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loserId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loserName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  matchScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreBreakdown?: Resolver<Maybe<ResolversTypes['ScoreBreakdownType']>, ParentType, ContextType>;
  winnerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  winnerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  winnerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastTenantNotificationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastTenantNotificationResult'] = ResolversParentTypes['BroadcastTenantNotificationResult']> = {
  failureCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['TenantNotificationResultType']>, ParentType, ContextType>;
  skippedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  successCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantNotificationResultTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantNotificationResultType'] = ResolversParentTypes['TenantNotificationResultType']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TenantNotificationStatus'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelRestHandlingResolvers = { Credit: 'undefined', KeptBySchool: 'undefined', ManualRefund: 'undefined', MollieRefund: 'undefined' };

export type MolliePaymentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MolliePaymentResult'] = ResolversParentTypes['MolliePaymentResult']> = {
  bookerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkoutUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dispatchKind?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  molliePaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Sms77FormatApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77FormatApiResponse'] = ResolversParentTypes['Sms77FormatApiResponse']> = {
  carrier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryIso?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  international?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  internationalFormatted?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  national?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkJobResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkJobResult'] = ResolversParentTypes['BulkJobResult']> = {
  courseCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  estimatedDurationSeconds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  jobGroupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingWithCourseLessonsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingWithCourseLessons'] = ResolversParentTypes['BookingWithCourseLessons']> = {
  additionalInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agbConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attendanceListNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attendee?: Resolver<Maybe<ResolversTypes['Attendee']>, ParentType, ContextType>;
  attendeeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookedBy?: Resolver<ResolversTypes['BookedBy'], ParentType, ContextType>;
  bookedLessonCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bookingConfirmationSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bookingHistory?: Resolver<Maybe<Array<ResolversTypes['BookingHistory']>>, ParentType, ContextType>;
  bookingNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bookingNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelationSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  canceled?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancelRestAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cancelRestHandling?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelSettledAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  courseLessonBookings?: Resolver<Maybe<Array<ResolversTypes['CourseLessonBooking']>>, ParentType, ContextType>;
  courseLessons?: Resolver<Array<ResolversTypes['CourseLesson']>, ParentType, ContextType>;
  coursePrice?: Resolver<ResolversTypes['CoursePrice'], ParentType, ContextType>;
  coursePriceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditedBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountCode?: Resolver<Maybe<ResolversTypes['DiscountCode']>, ParentType, ContextType>;
  discountCodeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  discountCodeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailNotifications?: Resolver<Maybe<Array<ResolversTypes['EmailNotification']>>, ParentType, ContextType>;
  foundUs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hasDiscountCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType>;
  invoiceSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  isSettled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSpecial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lessonLegacyGap?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lessonPricingMode?: Resolver<Maybe<ResolversTypes['LessonPricingMode']>, ParentType, ContextType>;
  lessonRateMonthOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lessonSelectionMode?: Resolver<Maybe<ResolversTypes['BookingLessonSelectionMode']>, ParentType, ContextType>;
  lessonUnitPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  memberDiscount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mergedBookingIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  molliePaymentAttempts?: Resolver<Array<ResolversTypes['MolliePaymentAttempt']>, ParentType, ContextType>;
  monthlySchedule?: Resolver<ResolversTypes['MonthlySchedule'], ParentType, ContextType>;
  netPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  noticeBooker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noticeStaff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overpaymentCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  paymentType?: Resolver<Maybe<ResolversTypes['PaymentType']>, ParentType, ContextType>;
  pricingCalculatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  pricingCalculationVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pricingFingerprint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pricingReason?: Resolver<Maybe<ResolversTypes['BookingPricingReason']>, ParentType, ContextType>;
  pricingSnapshot?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  privacyStatementConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reversalInvoice?: Resolver<Maybe<ResolversTypes['ReversalInvoice']>, ParentType, ContextType>;
  scheduledPayments?: Resolver<Array<ResolversTypes['ScheduledPayment']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  transferIn?: Resolver<Maybe<ResolversTypes['BookingTransferIn']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  utmSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  waitingListConfirmationSent?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  waitListCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentTypeResolvers = { Per45Minutes: 'undefined', Per60Minutes: 'undefined', PerCourse: 'undefined', PerCourseHour: 'undefined', PerDay: 'undefined' };

export type EmailTypeEnumResolvers = { Bulk: 'undefined', Transactional: 'undefined', Unknown: 'undefined' };

export type CreateMailjetSenderOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMailjetSenderOutput'] = ResolversParentTypes['CreateMailjetSenderOutput']> = {
  CreatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  DNSID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  EmailType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  IsDefaultSender?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOrganizationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOrganizationResult'] = ResolversParentTypes['CreateOrganizationResult']> = {
  adminErrors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAdmins?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  host?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sendFromEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalEndUserAppResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalEndUserAppResult'] = ResolversParentTypes['WithdrawalEndUserAppResult']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ErasureReportTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ErasureReportType'] = ResolversParentTypes['ErasureReportType']> = {
  attendeeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bookerIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  bookingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  counters?: Resolver<Array<ResolversTypes['ErasureCounterType']>, ParentType, ContextType>;
  customerNumbers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  deletedWaitlistBookingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dryRun?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  erasedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fusionAuthAccountDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasLoginAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  invoiceNumbers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  linkedBookers?: Resolver<Array<ResolversTypes['ErasureLinkedBookerType']>, ParentType, ContextType>;
  retentionEndsAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['ErasureWarningType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ErasureCounterTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ErasureCounterType'] = ResolversParentTypes['ErasureCounterType']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  table?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ErasureLinkedBookerTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ErasureLinkedBookerType'] = ResolversParentTypes['ErasureLinkedBookerType']> = {
  customerNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  customerNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ErasureWarningTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ErasureWarningType'] = ResolversParentTypes['ErasureWarningType']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  blocking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteBulkTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteBulkTransferResult'] = ResolversParentTypes['ExecuteBulkTransferResult']> = {
  results?: Resolver<Array<ResolversTypes['ExecuteBulkTransferRowResult']>, ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteBulkTransferRowResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteBulkTransferRowResult'] = ResolversParentTypes['ExecuteBulkTransferRowResult']> = {
  booking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType>;
  invoiceB?: Resolver<Maybe<ResolversTypes['TransferInvoiceRef']>, ParentType, ContextType>;
  mailSent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  oldBookingDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['TransferPlanPreview'], ParentType, ContextType>;
  promotedBookingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reversalInvoice?: Resolver<Maybe<ResolversTypes['TransferInvoiceRef']>, ParentType, ContextType>;
  sourceBookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceBookingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  surplusOutcome?: Resolver<Maybe<ResolversTypes['TransferSurplusOutcome']>, ParentType, ContextType>;
  transferOperationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferInvoiceRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferInvoiceRef'] = ResolversParentTypes['TransferInvoiceRef']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  invoiceNumberPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferSurplusOutcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferSurplusOutcome'] = ResolversParentTypes['TransferSurplusOutcome']> = {
  creditRemaining?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['TransferSurplusHandling'], ParentType, ContextType>;
  mollieRefundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refunded?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refunds?: Resolver<Array<ResolversTypes['TransferSurplusRefundResult']>, ParentType, ContextType>;
  requestedRefund?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferSurplusRefundResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferSurplusRefundResult'] = ResolversParentTypes['TransferSurplusRefundResult']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  molliePaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mollieRefundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheduledPaymentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettledBookingCorrectionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SettledBookingCorrectionResult'] = ResolversParentTypes['SettledBookingCorrectionResult']> = {
  booking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType>;
  correctionInvoiceOk?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  paymentLinkOk?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  refundOk?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingDeleteActionTypeResolvers = { DO_NOTHING: 'undefined', NEXT_FROM_WAITING_LIST: 'undefined', PLACE_RESERVATION: 'undefined', SELECT_FROM_WAITING_LIST: 'undefined' };

export type ExecuteTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteTransferResult'] = ResolversParentTypes['ExecuteTransferResult']> = {
  booking?: Resolver<ResolversTypes['Booking'], ParentType, ContextType>;
  invoiceB?: Resolver<Maybe<ResolversTypes['TransferInvoiceRef']>, ParentType, ContextType>;
  mailSent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  oldBookingDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['TransferPlanPreview'], ParentType, ContextType>;
  promotedBookingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reversalInvoice?: Resolver<Maybe<ResolversTypes['TransferInvoiceRef']>, ParentType, ContextType>;
  surplusOutcome?: Resolver<Maybe<ResolversTypes['TransferSurplusOutcome']>, ParentType, ContextType>;
  transferOperationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordResetLinkTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordResetLinkType'] = ResolversParentTypes['PasswordResetLinkType']> = {
  changePasswordId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resetLink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPaymentPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledPaymentPreview'] = ResolversParentTypes['ScheduledPaymentPreview']> = {
  blockingReason?: Resolver<Maybe<ResolversTypes['CourseBookingBasePriceBlockingReason']>, ParentType, ContextType>;
  calculationVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effectiveMinimum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  effectiveMode?: Resolver<Maybe<ResolversTypes['CourseLateEntryPricingMode']>, ParentType, ContextType>;
  eligibleLessonCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eligibleLessonIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  fingerprint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isBookable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPartialBooking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  memberDiscount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  netPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  originalGrossPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pricedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  reduction?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scheduledPayments?: Resolver<Array<ResolversTypes['ScheduledPaymentSimple']>, ParentType, ContextType>;
  serviceGrossPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalLessonCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalLessonIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPaymentSimpleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledPaymentSimple'] = ResolversParentTypes['ScheduledPaymentSimple']> = {
  additionalItemId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  molliePaymentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDone?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['PaymentProvider']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ScheduledPaymentType'], ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantDeletionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantDeletionResult'] = ResolversParentTypes['TenantDeletionResult']> = {
  deletedRecordCounts?: Resolver<Array<ResolversTypes['EntityCount']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  startedAsync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsletterUnsubscribeImportResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterUnsubscribeImportResult'] = ResolversParentTypes['NewsletterUnsubscribeImportResult']> = {
  found?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stored?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9SchemaInfoTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9SchemaInfoType'] = ResolversParentTypes['Ko9SchemaInfoType']> = {
  adressenPkColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allTables?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  hasAbzeichen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasAdressen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasKinder?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasKonto?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasKursBezeichnungen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasKursstandorte?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasTeilnahme?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasTeilnehmer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kinderPkColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9PreviewResultTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9PreviewResultType'] = ResolversParentTypes['Ko9PreviewResultType']> = {
  previewRows?: Resolver<Array<ResolversTypes['Ko9PreviewRowType']>, ParentType, ContextType>;
  schema?: Resolver<ResolversTypes['Ko9SchemaInfoType'], ParentType, ContextType>;
  totalAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9PreviewRowTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9PreviewRowType'] = ResolversParentTypes['Ko9PreviewRowType']> = {
  attendeeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  badgesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  birthday?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sepaInfo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9RollbackResultTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9RollbackResultType'] = ResolversParentTypes['Ko9RollbackResultType']> = {
  deletedAttendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deletedBookers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deletedPaymentMethods?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9SaveResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9SaveResult'] = ResolversParentTypes['Ko9SaveResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9ConnectionTestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9ConnectionTestResult'] = ResolversParentTypes['Ko9ConnectionTestResult']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogLevelTypeResolvers = { DEBUG: 'undefined', ERROR: 'undefined', INFO: 'undefined', SILLY: 'undefined', VERBOSE: 'undefined', WARN: 'undefined' };

export type AttendeeMergeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendeeMergeResult'] = ResolversParentTypes['AttendeeMergeResult']> = {
  bookingsTransferred?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  duplicateBookingsInSameCourse?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  winnerAttendeeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieCreateClientLinkResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieCreateClientLinkResult'] = ResolversParentTypes['MollieCreateClientLinkResult']> = {
  clientLinkId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientLinkUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionRecordAllResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionRecordAllResult'] = ResolversParentTypes['BankTransactionRecordAllResult']> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recorded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankImportRematchAllResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankImportRematchAllResult'] = ResolversParentTypes['BankImportRematchAllResult']> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rematched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutBlockerCodeResolvers = { AgbUnconfirmed: 'undefined', AllAttendeesAlreadyBooked: 'undefined', AttendeeAgeDoesNotFit: 'undefined', AttendeeCreationPending: 'undefined', AttendeeMissing: 'undefined', BookerBirthdayMissing: 'undefined', BookerHasNoAttendees: 'undefined', LateEntryGate: 'undefined', MollieMethodMissing: 'undefined', NoAttendeeFitsCourse: 'undefined', PaymentMethodMissing: 'undefined', PrivacyUnconfirmed: 'undefined', RequiredInputMissing: 'undefined', RequirementGroupsUnmet: 'undefined', SepaDataInvalid: 'undefined' };

export type EndUserEventStepResolvers = { BookingSummary: 'undefined', CourseList: 'undefined' };

export type EndUserReportedEventTypeResolvers = { CheckoutAbandoned: 'undefined', CheckoutBlocked: 'undefined', CourseListEmpty: 'undefined' };

export type ResetScheduledPaymentsOfCourseResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetScheduledPaymentsOfCourseResult'] = ResolversParentTypes['ResetScheduledPaymentsOfCourseResult']> = {
  bookings?: Resolver<Array<ResolversTypes['ResetScheduledPaymentsOfBookingResult']>, ParentType, ContextType>;
  courseDueDates?: Resolver<Array<ResolversTypes['Rate']>, ParentType, ContextType>;
  courseId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coursePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetScheduledPaymentsOfBookingResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetScheduledPaymentsOfBookingResult'] = ResolversParentTypes['ResetScheduledPaymentsOfBookingResult']> = {
  bookingId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bookingPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  coursePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  creditedBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currentScheduledPaymentsAmountsAndDueDates?: Resolver<Array<ResolversTypes['Rate']>, ParentType, ContextType>;
  currentScheduledPaymentsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currentScheduledPaymnetsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  installmentPlanAmountsAndDueDates?: Resolver<Array<ResolversTypes['Rate']>, ParentType, ContextType>;
  newScheduledPaymentsAmountsAndDueDates?: Resolver<Array<ResolversTypes['Rate']>, ParentType, ContextType>;
  newScheduledPaymentsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rate'] = ResolversParentTypes['Rate']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['RateDetail'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RateDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['RateDetail'] = ResolversParentTypes['RateDetail']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  due?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPaymentPlanOfInvoicedLessonBookingResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPaymentPlanOfInvoicedLessonBookingResult'] = ResolversParentTypes['ResetPaymentPlanOfInvoicedLessonBookingResult']> = {
  blockedMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockedReason?: Resolver<Maybe<ResolversTypes['ResetPaymentPlanBlockedReason']>, ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  newScheduledPayments?: Resolver<Array<ResolversTypes['ResetPaymentPlanRateSnapshot']>, ParentType, ContextType>;
  newTotalGrossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  oldCreditedBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oldDiscount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oldScheduledPayments?: Resolver<Array<ResolversTypes['ResetPaymentPlanRateSnapshot']>, ParentType, ContextType>;
  oldTotalGrossPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  previewOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPaymentPlanBlockedReasonResolvers = { ACTIVE_MOLLIE: 'undefined', NO_BOOKED_LESSONS: 'undefined', PAID_EXCEEDS_STANDARD: 'undefined', PARTIALLY_PAID: 'undefined', UNSUPPORTED_PAYMENT_TYPE: 'undefined' };

export type ResetPaymentPlanRateSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPaymentPlanRateSnapshot'] = ResolversParentTypes['ResetPaymentPlanRateSnapshot']> = {
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  manuallyAdjustedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDone?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentDue?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  refundedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MollieManualReconciliationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieManualReconciliationResult'] = ResolversParentTypes['MollieManualReconciliationResult']> = {
  checked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  errors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['Admin'] = ResolversParentTypes['Admin']> = {
  accountHolder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  annotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthPlace?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  healthInsuranceFund?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  joinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leaveDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salutation?: Resolver<Maybe<ResolversTypes['SalutationType']>, ParentType, ContextType>;
  socialSecurityNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type BlankMailTypesResolvers = { Attendee: 'undefined', Booker: 'undefined', Booking: 'undefined', Course: 'undefined', Invoice: 'undefined' };

export type MailjetEmailTemplatesResolvers = { Blank: 'undefined', BookingCancellation: 'undefined', BookingConfirmation: 'undefined', FreeText: 'undefined', InvoiceSettlement: 'undefined', StandardTemplateWithoutCourseDetails: 'undefined', WaitingListConfirmation: 'undefined' };

export type Sms77JsonResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77JsonResponse'] = ResolversParentTypes['Sms77JsonResponse']> = {
  balance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  debug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Sms77Message']>, ParentType, ContextType>;
  smsType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Sms77MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77Message'] = ResolversParentTypes['Sms77Message']> = {
  encoding?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isBinary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parts?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  udh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCounterpartKindResolvers = { Customer: 'undefined', Other: 'undefined' };

export type SupportReportKindResolvers = { Bug: 'undefined', Idea: 'undefined', Question: 'undefined' };

export type AttendanceListFontSizeResolvers = { Large: 'undefined', Medium: 'undefined', Small: 'undefined' };

export type UpdateCourseAndBookingsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCourseAndBookingsResult'] = ResolversParentTypes['UpdateCourseAndBookingsResult']> = {
  bookings?: Resolver<Array<ResolversTypes['Booking']>, ParentType, ContextType>;
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  courseLessonBookingsPreview?: Resolver<Maybe<Array<ResolversTypes['CourseLessonBookingsPreview']>>, ParentType, ContextType>;
  courseLessonsPreview?: Resolver<Maybe<Array<ResolversTypes['CourseLesson']>>, ParentType, ContextType>;
  dryRun?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLessonBookingsPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLessonBookingsPreview'] = ResolversParentTypes['CourseLessonBookingsPreview']> = {
  bookingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  courseLessonBookings?: Resolver<Maybe<Array<ResolversTypes['CourseLessonBooking']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonInstructorScopeResolvers = { ThisAndFollowing: 'undefined', ThisLesson: 'undefined' };

export type MollieInvoiceSendModeResolvers = { AfterPaid: 'undefined', Immediately: 'undefined' };

export type MollieRefundModeResolvers = { Auto: 'undefined', Manual: 'undefined' };

export type VatAppearanceResolvers = { Hide: 'undefined', Mention: 'undefined', Show: 'undefined' };

export type BundesbankImportResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundesbankImportResult'] = ResolversParentTypes['BundesbankImportResult']> = {
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  importedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadedContentImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadedContentImage'] = ResolversParentTypes['UploadedContentImage']> = {
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoidPaymentLinkResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoidPaymentLinkResult'] = ResolversParentTypes['VoidPaymentLinkResult']> = {
  bookingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  voided?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoMergeRunResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoMergeRun'] = ResolversParentTypes['AutoMergeRun']> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  confidenceThreshold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationMs?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  failedMerges?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mergedSoFar?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  skippedMerges?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AutoMergeRunStatus'], ParentType, ContextType>;
  totalGroupsToMerge?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  triggeredByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Base'] = ResolversParentTypes['Base']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupTypeResolvers = { CallingNameDelivery: 'undefined', Format: 'undefined', HomeLocationRegister: 'undefined', MobileNumberPortability: 'undefined' };

export type BookableOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookableOptions'] = ResolversParentTypes['BookableOptions']> = {
  hasFreeSlots?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasWaitlistSlots?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookableOptionsErrorResolvers = { BookingNotPossible: 'undefined', DuplicateBooking: 'undefined', NoFreeSlots: 'undefined', PlaceReservationNotPossible: 'undefined', WaitlistFull: 'undefined', WaitlistNotPossible: 'undefined' };

export type BookableOptionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookableOptionsResult'] = ResolversParentTypes['BookableOptionsResult']> = {
  errors?: Resolver<Array<ResolversTypes['BookableOptionsError']>, ParentType, ContextType>;
  options?: Resolver<ResolversTypes['BookableOptions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingHistoryWithPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingHistoryWithPagination'] = ResolversParentTypes['BookingHistoryWithPagination']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['BookingHistory']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingRestrictionErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingRestrictionError'] = ResolversParentTypes['BookingRestrictionError']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['BookingRestrictionErrors']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BookingWithPaymentActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookingWithPaymentAction'] = ResolversParentTypes['BookingWithPaymentAction']> = {
  bookingId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentAction?: Resolver<Maybe<ResolversTypes['MolliePaymentAction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MolliePaymentActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MolliePaymentAction'] = ResolversParentTypes['MolliePaymentAction']> = {
  bankDetails?: Resolver<Maybe<ResolversTypes['MollieBankDetails']>, ParentType, ContextType>;
  checkoutUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  molliePaymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  molliePaymentStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseDetailsLessonBookingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseDetailsLessonBookings'] = ResolversParentTypes['CourseDetailsLessonBookings']> = {
  bookings?: Resolver<Maybe<Array<ResolversTypes['Booking']>>, ParentType, ContextType>;
  bookingType?: Resolver<ResolversTypes['BookingType'], ParentType, ContextType>;
  courseLessonBookings?: Resolver<Maybe<Array<ResolversTypes['CourseLessonBooking']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLessonBookingAttendanceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLessonBookingAttendanceList'] = ResolversParentTypes['CourseLessonBookingAttendanceList']> = {
  attendee?: Resolver<ResolversTypes['Attendee'], ParentType, ContextType>;
  booker?: Resolver<ResolversTypes['Booker'], ParentType, ContextType>;
  bookingId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courseLessonBooking?: Resolver<Array<ResolversTypes['CourseLessonBooking']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseWithPaginationWithEnabledCoursesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseWithPaginationWithEnabledCourses'] = ResolversParentTypes['CourseWithPaginationWithEnabledCourses']> = {
  existsMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateMatch'] = ResolversParentTypes['DuplicateMatch']> = {
  booker1?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  booker2?: Resolver<Maybe<ResolversTypes['Booker']>, ParentType, ContextType>;
  bookerId1?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bookerId2?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detectedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  matchType?: Resolver<ResolversTypes['DuplicateMatchType'], ParentType, ContextType>;
  resolvedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreBreakdown?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Ko9ImportCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ko9ImportCredentials'] = ResolversParentTypes['Ko9ImportCredentials']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  database?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  port?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MailSentStatusResolvers = { Error: 'undefined', Pending: 'undefined', Success: 'undefined' };

export type MollieConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MollieConnection'] = ResolversParentTypes['MollieConnection']> = {
  canReceivePayments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canReceiveSettlements?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  connectedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disconnectedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  hasNextGenPaymentWebhook?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasNextGenWebhook?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDisconnected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mollieOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mollieProfileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenExpiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecureIdentityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecureIdentity'] = ResolversParentTypes['SecureIdentity']> = {
  breachedPasswordLastCheckedInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  connectorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  encryptionScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastLoginInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passwordChangeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passwordChangeRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  passwordLastUpdateInstant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uniqueUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Sms77AnalyticBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77AnalyticBase'] = ResolversParentTypes['Sms77AnalyticBase']> = {
  hlr?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  inbound?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mnp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sms?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  usageEur?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Sms77JournalBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sms77JournalBase'] = ResolversParentTypes['Sms77JournalBase']> = {
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffLoginResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffLogin'] = ResolversParentTypes['StaffLogin']> = {
  createDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pages?: Resolver<Array<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  updateDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantDeletionLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantDeletionLog'] = ResolversParentTypes['TenantDeletionLog']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  koOrganizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  performedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  performedByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stepName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithEnabledCourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithEnabledCourse'] = ResolversParentTypes['WithEnabledCourse']> = {
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  enabledCourses?: Resolver<Array<ResolversTypes['EnabledCourse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Query?: QueryResolvers<ContextType>;
  AccountForEmail?: AccountForEmailResolvers<ContextType>;
  AccountForEmailLinkedBooker?: AccountForEmailLinkedBookerResolvers<ContextType>;
  AccountLinks?: AccountLinksResolvers<ContextType>;
  AccountLinksStaff?: AccountLinksStaffResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  AnnouncementPriority?: AnnouncementPriorityResolvers;
  AnnouncementType?: AnnouncementTypeResolvers;
  ActiveDunning?: ActiveDunningResolvers<ContextType>;
  DunningLevel?: DunningLevelResolvers;
  AdminManagementEmailInfo?: AdminManagementEmailInfoResolvers<ContextType>;
  AdminManagementEmailStatus?: AdminManagementEmailStatusResolvers;
  AdminManagementOverview?: AdminManagementOverviewResolvers<ContextType>;
  AdminManagementUser?: AdminManagementUserResolvers<ContextType>;
  InstructorCourseGroup?: InstructorCourseGroupResolvers<ContextType>;
  AttendanceListArchive?: AttendanceListArchiveResolvers<ContextType>;
  BulkJobStatus?: BulkJobStatusResolvers<ContextType>;
  Booking?: BookingResolvers<ContextType>;
  Attendee?: AttendeeResolvers<ContextType>;
  AttendeeBadge?: AttendeeBadgeResolvers<ContextType>;
  AttendeeBadgeRequirement?: AttendeeBadgeRequirementResolvers<ContextType>;
  BadgeRequirement?: BadgeRequirementResolvers<ContextType>;
  Badge?: BadgeResolvers<ContextType>;
  Booker?: BookerResolvers<ContextType>;
  CreatedBy?: CreatedByResolvers;
  UserType?: UserTypeResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  Gender?: GenderResolvers;
  PaymentMethod?: PaymentMethodResolvers<ContextType>;
  ScheduledPayment?: ScheduledPaymentResolvers<ContextType>;
  ScheduledPaymentMethodChangeUser?: ScheduledPaymentMethodChangeUserResolvers<ContextType>;
  BookingDunningStatus?: BookingDunningStatusResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  KoOrganization?: KoOrganizationResolvers<ContextType>;
  CompanySetting?: CompanySettingResolvers<ContextType>;
  Setting?: SettingResolvers<ContextType>;
  PaymentProvider?: PaymentProviderResolvers;
  CourseNumberFormat?: CourseNumberFormatResolvers;
  Currency?: CurrencyResolvers;
  GrossNet?: GrossNetResolvers;
  CountryCode?: CountryCodeResolvers;
  StateCode?: StateCodeResolvers;
  TransferOldBookingDefault?: TransferOldBookingDefaultResolvers;
  TransferPriceDefault?: TransferPriceDefaultResolvers;
  TransferMode?: TransferModeResolvers;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionType?: SubscriptionTypeResolvers;
  LatestMollieAttemptBadge?: LatestMollieAttemptBadgeResolvers<ContextType>;
  PaymentTransferType?: PaymentTransferTypeResolvers;
  BookingPostKind?: BookingPostKindResolvers;
  SepaCollectionStatus?: SepaCollectionStatusResolvers;
  ScheduledPaymentType?: ScheduledPaymentTypeResolvers;
  BookingsKo9?: BookingsKo9Resolvers<ContextType>;
  Course?: CourseResolvers<ContextType>;
  CourseAdditionalItem?: CourseAdditionalItemResolvers<ContextType>;
  AdditionalItemMode?: AdditionalItemModeResolvers;
  CourseBookingPriceQuote?: CourseBookingPriceQuoteResolvers<ContextType>;
  CourseBookingBasePriceBlockingReason?: CourseBookingBasePriceBlockingReasonResolvers;
  CourseLateEntryPricingMode?: CourseLateEntryPricingModeResolvers;
  BookingRestriction?: BookingRestrictionResolvers<ContextType>;
  ExpireAction?: ExpireActionResolvers;
  CoursePrice?: CoursePriceResolvers<ContextType>;
  CourseType?: CourseTypeResolvers<ContextType>;
  CourseCategory?: CourseCategoryResolvers<ContextType>;
  ParticipationPrerequisites?: ParticipationPrerequisitesResolvers<ContextType>;
  JSONObject?: GraphQLScalarType;
  PaymentInterval?: PaymentIntervalResolvers;
  CourseCycle?: CourseCycleResolvers;
  EnabledCourse?: EnabledCourseResolvers<ContextType>;
  CourseVisibilityResult?: CourseVisibilityResultResolvers<ContextType>;
  CourseNotVisibleReason?: CourseNotVisibleReasonResolvers;
  CourseVisibilityRestriction?: CourseVisibilityRestrictionResolvers<ContextType>;
  InstallmentRate?: InstallmentRateResolvers<ContextType>;
  InstallmentType?: InstallmentTypeResolvers;
  Instructor?: InstructorResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  GeneralLocationContact?: GeneralLocationContactResolvers<ContextType>;
  CourseLesson?: CourseLessonResolvers<ContextType>;
  CourseLessonAssistant?: CourseLessonAssistantResolvers<ContextType>;
  CourseLessonBooking?: CourseLessonBookingResolvers<ContextType>;
  BookingType?: BookingTypeResolvers;
  InstructorInvoice?: InstructorInvoiceResolvers<ContextType>;
  Venue?: VenueResolvers<ContextType>;
  LocationContact?: LocationContactResolvers<ContextType>;
  SalutationType?: SalutationTypeResolvers;
  Staff?: StaffResolvers<ContextType>;
  MonthlySchedule?: MonthlyScheduleResolvers;
  PaymentType?: PaymentTypeResolvers;
  BookedBy?: BookedByResolvers;
  BookingHistory?: BookingHistoryResolvers<ContextType>;
  BookingHistoryAction?: BookingHistoryActionResolvers;
  UserDetailsType?: UserDetailsTypeResolvers<ContextType>;
  InstructorDetailsView?: InstructorDetailsViewResolvers<ContextType>;
  LoginAttempt?: LoginAttemptResolvers<ContextType>;
  LoginStatus?: LoginStatusResolvers;
  RecentLoginEntry?: RecentLoginEntryResolvers<ContextType>;
  UserSetting?: UserSettingResolvers<ContextType>;
  Language?: LanguageResolvers;
  DiscountCode?: DiscountCodeResolvers<ContextType>;
  DiscountUnit?: DiscountUnitResolvers;
  DiscountCodeScopeType?: DiscountCodeScopeTypeResolvers;
  EmailNotification?: EmailNotificationResolvers<ContextType>;
  MessageStatus?: MessageStatusResolvers<ContextType>;
  MessageStatusData?: MessageStatusDataResolvers<ContextType>;
  MailjetStatus?: MailjetStatusResolvers;
  MessageHistory?: MessageHistoryResolvers<ContextType>;
  MessageHistoryData?: MessageHistoryDataResolvers<ContextType>;
  LessonPricingMode?: LessonPricingModeResolvers;
  BookingLessonSelectionMode?: BookingLessonSelectionModeResolvers;
  MolliePaymentAttempt?: MolliePaymentAttemptResolvers<ContextType>;
  Chargeback?: ChargebackResolvers<ContextType>;
  MollieRefund?: MollieRefundResolvers<ContextType>;
  MollieRefundOrigin?: MollieRefundOriginResolvers;
  MollieRefundStatus?: MollieRefundStatusResolvers;
  BookingPricingReason?: BookingPricingReasonResolvers;
  ReversalInvoice?: ReversalInvoiceResolvers<ContextType>;
  BookingTransferIn?: BookingTransferInResolvers<ContextType>;
  filterCompareOperation?: FilterCompareOperationResolvers;
  filterOperation?: FilterOperationResolvers;
  SortOrder?: SortOrderResolvers;
  AttendeeMergeHistory?: AttendeeMergeHistoryResolvers<ContextType>;
  AttendeeWithPagination?: AttendeeWithPaginationResolvers<ContextType>;
  BadgeGroup?: BadgeGroupResolvers<ContextType>;
  BadgeGroupType?: BadgeGroupTypeResolvers;
  BankCollectionRun?: BankCollectionRunResolvers<ContextType>;
  BankTransactionStatus?: BankTransactionStatusResolvers;
  BankImportFile?: BankImportFileResolvers<ContextType>;
  BankTransaction?: BankTransactionResolvers<ContextType>;
  BankTransactionCandidate?: BankTransactionCandidateResolvers<ContextType>;
  BankTransactionCandidateEvidence?: BankTransactionCandidateEvidenceResolvers;
  BankTransactionSearchHit?: BankTransactionSearchHitResolvers<ContextType>;
  BankTransactionSearchField?: BankTransactionSearchFieldResolvers;
  BankTransactionCandidateLevel?: BankTransactionCandidateLevelResolvers;
  BankTransactionDecision?: BankTransactionDecisionResolvers;
  BankTransactionKind?: BankTransactionKindResolvers;
  BankTransactionMatchKind?: BankTransactionMatchKindResolvers;
  BankTransactionRejectReason?: BankTransactionRejectReasonResolvers;
  BankTransactionsPage?: BankTransactionsPageResolvers<ContextType>;
  BillingAddressTemplate?: BillingAddressTemplateResolvers<ContextType>;
  BookerDeletionProgressType?: BookerDeletionProgressTypeResolvers<ContextType>;
  BookerMergeHistory?: BookerMergeHistoryResolvers<ContextType>;
  BookerWithPagination?: BookerWithPaginationResolvers<ContextType>;
  BookingEligibilityCandidate?: BookingEligibilityCandidateResolvers<ContextType>;
  BookingEligibilityDiagnosis?: BookingEligibilityDiagnosisResolvers<ContextType>;
  EligibilityCheckKey?: EligibilityCheckKeyResolvers;
  EligibilityCheck?: EligibilityCheckResolvers<ContextType>;
  EligibilityCheckStatus?: EligibilityCheckStatusResolvers;
  BookingRestrictionErrors?: BookingRestrictionErrorsResolvers;
  PrerequisiteLinkVisibility?: PrerequisiteLinkVisibilityResolvers<ContextType>;
  BookingWithPagination?: BookingWithPaginationResolvers<ContextType>;
  BundesbankImportInfo?: BundesbankImportInfoResolvers<ContextType>;
  CertificateIssuePreflightResult?: CertificateIssuePreflightResultResolvers<ContextType>;
  CertificateIssuePreflightAttendee?: CertificateIssuePreflightAttendeeResolvers<ContextType>;
  CertificateTemplate?: CertificateTemplateResolvers<ContextType>;
  CertificateBlockLayout?: CertificateBlockLayoutResolvers<ContextType>;
  CertificateBlockAlignments?: CertificateBlockAlignmentsResolvers<ContextType>;
  CertificateBlockSpacing?: CertificateBlockSpacingResolvers<ContextType>;
  CertificateDesignVariant?: CertificateDesignVariantResolvers;
  CertificateDocFields?: CertificateDocFieldsResolvers<ContextType>;
  CertificateDocText?: CertificateDocTextResolvers<ContextType>;
  CertificateAlign?: CertificateAlignResolvers<ContextType>;
  CertificateLetterFields?: CertificateLetterFieldsResolvers<ContextType>;
  CertificateSigner?: CertificateSignerResolvers<ContextType>;
  CertificateSizes?: CertificateSizesResolvers<ContextType>;
  CertificateTemplateVisibility?: CertificateTemplateVisibilityResolvers<ContextType>;
  AttendeesAgeAtCourseStart?: AttendeesAgeAtCourseStartResolvers<ContextType>;
  AgeError?: AgeErrorResolvers;
  DiscountCodeCheckResult?: DiscountCodeCheckResultResolvers<ContextType>;
  DiscountCodeRejectReason?: DiscountCodeRejectReasonResolvers;
  TemplateType?: TemplateTypeResolvers;
  SmsBalanceResponse?: SmsBalanceResponseResolvers<ContextType>;
  LocationCity?: LocationCityResolvers<ContextType>;
  CourseDetails?: CourseDetailsResolvers<ContextType>;
  CourseHistory?: CourseHistoryResolvers<ContextType>;
  CourseHistoryAction?: CourseHistoryActionResolvers;
  BillingStatusCoursLessons?: BillingStatusCoursLessonsResolvers<ContextType>;
  ChronologicalLessonsResult?: ChronologicalLessonsResultResolvers<ContextType>;
  GroupBillingStatusBy?: GroupBillingStatusByResolvers;
  BillingStatusByInstructor?: BillingStatusByInstructorResolvers<ContextType>;
  BillingStatusByInstructorWithCourseGroups?: BillingStatusByInstructorWithCourseGroupsResolvers<ContextType>;
  CourseSummaryForBilling?: CourseSummaryForBillingResolvers<ContextType>;
  CourseLessonWithPagination?: CourseLessonWithPaginationResolvers<ContextType>;
  CourseLessonWithIndexOfCourseLessonInCourse?: CourseLessonWithIndexOfCourseLessonInCourseResolvers<ContextType>;
  Operation?: OperationResolvers;
  Operator?: OperatorResolvers;
  DayFilter?: DayFilterResolvers;
  CourseWithPagination?: CourseWithPaginationResolvers<ContextType>;
  MonthFilter?: MonthFilterResolvers;
  RestrictiveCourses?: RestrictiveCoursesResolvers;
  CourseTypeWithPagination?: CourseTypeWithPaginationResolvers<ContextType>;
  CreditEntry?: CreditEntryResolvers<ContextType>;
  CreditEntryReason?: CreditEntryReasonResolvers;
  CustomBankData?: CustomBankDataResolvers<ContextType>;
  CustomerTimelineEntry?: CustomerTimelineEntryResolvers<ContextType>;
  CustomerTimelineKind?: CustomerTimelineKindResolvers;
  Holiday?: HolidayResolvers<ContextType>;
  HolidayType?: HolidayTypeResolvers;
  InvoiceTemplateSet?: InvoiceTemplateSetResolvers<ContextType>;
  InvoiceLayoutVariant?: InvoiceLayoutVariantResolvers;
  InvoiceLogoPosition?: InvoiceLogoPositionResolvers;
  DunningPause?: DunningPauseResolvers<ContextType>;
  DunningProposal?: DunningProposalResolvers<ContextType>;
  DunningProposalItem?: DunningProposalItemResolvers<ContextType>;
  Dunning?: DunningResolvers<ContextType>;
  EmailNotificationWithPagination?: EmailNotificationWithPaginationResolvers<ContextType>;
  EndUserEmailRegistrationStatus?: EndUserEmailRegistrationStatusResolvers;
  ExportedSepaXml?: ExportedSepaXmlResolvers<ContextType>;
  ExportedSepaXmlWithPagination?: ExportedSepaXmlWithPaginationResolvers<ContextType>;
  FaUser?: FaUserResolvers<ContextType>;
  UserRegistration?: UserRegistrationResolvers<ContextType>;
  FeeLetterProposal?: FeeLetterProposalResolvers<ContextType>;
  FeeLetterItem?: FeeLetterItemResolvers<ContextType>;
  FeeLetter?: FeeLetterResolvers<ContextType>;
  SimilarBookerResult?: SimilarBookerResultResolvers<ContextType>;
  UnpaidScheduledPaymentMatchResult?: UnpaidScheduledPaymentMatchResultResolvers<ContextType>;
  UnpaidScheduledPaymentMatch?: UnpaidScheduledPaymentMatchResolvers<ContextType>;
  MatchConfidence?: MatchConfidenceResolvers;
  Sms77AnalyticGroupByDate?: Sms77AnalyticGroupByDateResolvers<ContextType>;
  AreaIssue?: AreaIssueResolvers<ContextType>;
  AreaIssueLesson?: AreaIssueLessonResolvers<ContextType>;
  AreaIssueLocation?: AreaIssueLocationResolvers<ContextType>;
  AreaIssuePerson?: AreaIssuePersonResolvers<ContextType>;
  AreaManagerAssistantHierarchyResult?: AreaManagerAssistantHierarchyResultResolvers<ContextType>;
  AreaManagerAssistantLocationGroup?: AreaManagerAssistantLocationGroupResolvers<ContextType>;
  AreaManagerAssistantCourseGroup?: AreaManagerAssistantCourseGroupResolvers<ContextType>;
  AreaManagerAssistantOverview?: AreaManagerAssistantOverviewResolvers<ContextType>;
  AreaManagerAssignedAssistant?: AreaManagerAssignedAssistantResolvers<ContextType>;
  AreaManagerAssistantOverviewResult?: AreaManagerAssistantOverviewResultResolvers<ContextType>;
  AreaManagerCourseStatsResult?: AreaManagerCourseStatsResultResolvers<ContextType>;
  AreaManagerCourseStats?: AreaManagerCourseStatsResolvers<ContextType>;
  AreaManagerInstructorStatsResult?: AreaManagerInstructorStatsResultResolvers<ContextType>;
  AreaManagerInstructorStats?: AreaManagerInstructorStatsResolvers<ContextType>;
  AreaManagerLocationStatsResult?: AreaManagerLocationStatsResultResolvers<ContextType>;
  AreaManagerLocationStats?: AreaManagerLocationStatsResolvers<ContextType>;
  AreaManagerUpcomingLesson?: AreaManagerUpcomingLessonResolvers<ContextType>;
  AreaManagerVenueUtilizationResult?: AreaManagerVenueUtilizationResultResolvers<ContextType>;
  AreaManagerVenueUtilization?: AreaManagerVenueUtilizationResolvers<ContextType>;
  AreaOverviewResult?: AreaOverviewResultResolvers<ContextType>;
  AreaOverviewPool?: AreaOverviewPoolResolvers<ContextType>;
  AreaOverviewWeek?: AreaOverviewWeekResolvers<ContextType>;
  AreaPerson?: AreaPersonResolvers<ContextType>;
  AreaPersonLocation?: AreaPersonLocationResolvers<ContextType>;
  AutoMergeStatus?: AutoMergeStatusResolvers<ContextType>;
  AutoMergeFailureType?: AutoMergeFailureTypeResolvers<ContextType>;
  AutoMergeRunStatus?: AutoMergeRunStatusResolvers;
  MollieMethodInfo?: MollieMethodInfoResolvers<ContextType>;
  BookerAttendeeCount?: BookerAttendeeCountResolvers<ContextType>;
  BookerIdMissmatchWithPagination?: BookerIdMissmatchWithPaginationResolvers<ContextType>;
  BookerIdMissmatch?: BookerIdMissmatchResolvers<ContextType>;
  CacheStatsOutput?: CacheStatsOutputResolvers<ContextType>;
  ChargebackSummary?: ChargebackSummaryResolvers<ContextType>;
  TablesEnum?: TablesEnumResolvers;
  ContentOfBucket?: ContentOfBucketResolvers<ContextType>;
  ContentOfBucketResponse?: ContentOfBucketResponseResolvers<ContextType>;
  Content?: ContentResolvers<ContextType>;
  AssistantCourseLesson?: AssistantCourseLessonResolvers<ContextType>;
  AssistantInfo?: AssistantInfoResolvers<ContextType>;
  DuplicateGroupWithMetadata?: DuplicateGroupWithMetadataResolvers<ContextType>;
  DuplicateGroupMatchInfo?: DuplicateGroupMatchInfoResolvers<ContextType>;
  DuplicateMatchType?: DuplicateMatchTypeResolvers;
  ScoreBreakdownType?: ScoreBreakdownTypeResolvers<ContextType>;
  DuplicateDetectionRun?: DuplicateDetectionRunResolvers<ContextType>;
  DetectionRunStatus?: DetectionRunStatusResolvers;
  DuplicateException?: DuplicateExceptionResolvers<ContextType>;
  DuplicateMatchStats?: DuplicateMatchStatsResolvers<ContextType>;
  MjmlTemplate?: MjmlTemplateResolvers<ContextType>;
  MailjetSenderResponse?: MailjetSenderResponseResolvers<ContextType>;
  MailjetSender?: MailjetSenderResolvers<ContextType>;
  MissingIndexCandidateOutput?: MissingIndexCandidateOutputResolvers<ContextType>;
  MollieKpis?: MollieKpisResolvers<ContextType>;
  MolliePaymentTab?: MolliePaymentTabResolvers;
  MolliePaymentsPage?: MolliePaymentsPageResolvers<ContextType>;
  MolliePaymentTabCounts?: MolliePaymentTabCountsResolvers<ContextType>;
  MollieRetryQueueEntry?: MollieRetryQueueEntryResolvers<ContextType>;
  OnlineRegisteredBookersResult?: OnlineRegisteredBookersResultResolvers<ContextType>;
  OnlineRegisteredBooker?: OnlineRegisteredBookerResolvers<ContextType>;
  OnlineRegisteredBookerAttendee?: OnlineRegisteredBookerAttendeeResolvers<ContextType>;
  OpenAttendanceSummary?: OpenAttendanceSummaryResolvers<ContextType>;
  PageStructure?: PageStructureResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageContent?: PageContentResolvers<ContextType>;
  PaymentActionLog?: PaymentActionLogResolvers<ContextType>;
  PerformanceStatsOutput?: PerformanceStatsOutputResolvers<ContextType>;
  SlowQueryOutput?: SlowQueryOutputResolvers<ContextType>;
  TableStatsOutput?: TableStatsOutputResolvers<ContextType>;
  AssistantSelectableLocation?: AssistantSelectableLocationResolvers<ContextType>;
  JournalType?: JournalTypeResolvers;
  Sms77JournalOutbound?: Sms77JournalOutboundResolvers<ContextType>;
  Sms77PricingResponse?: Sms77PricingResponseResolvers<ContextType>;
  Sms77CountryPricing?: Sms77CountryPricingResolvers<ContextType>;
  CountryNetwork?: CountryNetworkResolvers<ContextType>;
  MailDataType?: MailDataTypeResolvers;
  SmsReceiver?: SmsReceiverResolvers<ContextType>;
  UpcomingCoursesOccupancy?: UpcomingCoursesOccupancyResolvers<ContextType>;
  HolidayWithDays?: HolidayWithDaysResolvers<ContextType>;
  InstructorsWithPagination?: InstructorsWithPaginationResolvers<ContextType>;
  InterestList?: InterestListResolvers<ContextType>;
  InterestListTimeSlot?: InterestListTimeSlotResolvers<ContextType>;
  InterestRegistrationWithPagination?: InterestRegistrationWithPaginationResolvers<ContextType>;
  InterestRegistration?: InterestRegistrationResolvers<ContextType>;
  InterestRegistrationStatus?: InterestRegistrationStatusResolvers;
  InvoiceWithPagination?: InvoiceWithPaginationResolvers<ContextType>;
  IssuedCertificate?: IssuedCertificateResolvers<ContextType>;
  Ko9ImportProgressType?: Ko9ImportProgressTypeResolvers<ContextType>;
  Ko9LoadedCredentials?: Ko9LoadedCredentialsResolvers<ContextType>;
  SettingEndUserApp?: SettingEndUserAppResolvers<ContextType>;
  CourseSearchDisplayMode?: CourseSearchDisplayModeResolvers;
  I18n?: I18nResolvers;
  TenantLateEntryPricingPolicy?: TenantLateEntryPricingPolicyResolvers;
  HistorySource?: HistorySourceResolvers;
  LessonBookingPlannerPreview?: LessonBookingPlannerPreviewResolvers<ContextType>;
  LessonBookingPlannerComponent?: LessonBookingPlannerComponentResolvers<ContextType>;
  LessonBookingPlannerRate?: LessonBookingPlannerRateResolvers<ContextType>;
  LessonBookingPlannerAdjustment?: LessonBookingPlannerAdjustmentResolvers<ContextType>;
  LessonBookingPlannerRateStatus?: LessonBookingPlannerRateStatusResolvers;
  LessonBookingPlannerUnit?: LessonBookingPlannerUnitResolvers<ContextType>;
  LessonBookingPlannerUnitStatus?: LessonBookingPlannerUnitStatusResolvers;
  LessonBookingPlanSummary?: LessonBookingPlanSummaryResolvers<ContextType>;
  LessonBookingPlanApplies?: LessonBookingPlanAppliesResolvers;
  DatabaseBackup?: DatabaseBackupResolvers<ContextType>;
  DataExport?: DataExportResolvers<ContextType>;
  InvoiceExport?: InvoiceExportResolvers<ContextType>;
  YearEndExport?: YearEndExportResolvers<ContextType>;
  LocalState?: LocalStateResolvers<ContextType>;
  BookAttendees?: BookAttendeesResolvers<ContextType>;
  SelectedAttendee?: SelectedAttendeeResolvers<ContextType>;
  CreateCourse?: CreateCourseResolvers<ContextType>;
  LocationsGroupedByCity?: LocationsGroupedByCityResolvers<ContextType>;
  LocationGroupedByCityLocation?: LocationGroupedByCityLocationResolvers<ContextType>;
  LocationGroupedByCityVenue?: LocationGroupedByCityVenueResolvers<ContextType>;
  LocationsWithPagination?: LocationsWithPaginationResolvers<ContextType>;
  MaintenanceStatus?: MaintenanceStatusResolvers<ContextType>;
  MissingBankData?: MissingBankDataResolvers<ContextType>;
  MollieConnectionStatus?: MollieConnectionStatusResolvers<ContextType>;
  MollieDowngradeImpact?: MollieDowngradeImpactResolvers<ContextType>;
  MolliePaymentStatus?: MolliePaymentStatusResolvers<ContextType>;
  MollieAmount?: MollieAmountResolvers<ContextType>;
  MollieBankDetails?: MollieBankDetailsResolvers<ContextType>;
  MolliePaymentStatusPublic?: MolliePaymentStatusPublicResolvers<ContextType>;
  MollieRefundsWithPagination?: MollieRefundsWithPaginationResolvers<ContextType>;
  MyProfileType?: MyProfileTypeResolvers<ContextType>;
  NewsletterBookerStatus?: NewsletterBookerStatusResolvers<ContextType>;
  NewsletterUnsubscribe?: NewsletterUnsubscribeResolvers<ContextType>;
  NewsletterUnsubscribeSource?: NewsletterUnsubscribeSourceResolvers;
  NewsletterLocationList?: NewsletterLocationListResolvers<ContextType>;
  NewsletterLog?: NewsletterLogResolvers<ContextType>;
  NewsletterLogKind?: NewsletterLogKindResolvers;
  NewsletterOverviewResult?: NewsletterOverviewResultResolvers<ContextType>;
  NewsletterRecipientCount?: NewsletterRecipientCountResolvers<ContextType>;
  NewsletterAssignment?: NewsletterAssignmentResolvers;
  NewsletterListRule?: NewsletterListRuleResolvers;
  NewsletterRulesPreview?: NewsletterRulesPreviewResolvers<ContextType>;
  NewsletterSettings?: NewsletterSettingsResolvers<ContextType>;
  ScheduledPaymentsWithPagination?: ScheduledPaymentsWithPaginationResolvers<ContextType>;
  Payment?: PaymentResolvers<ContextType>;
  SwissQRFile?: SwissQrFileResolvers<ContextType>;
  SwissQRFileRecord?: SwissQrFileRecordResolvers<ContextType>;
  PlatformConfig?: PlatformConfigResolvers<ContextType>;
  CorrectionRefundMode?: CorrectionRefundModeResolvers;
  SettledBookingCorrectionPreview?: SettledBookingCorrectionPreviewResolvers<ContextType>;
  InstallmentChangePreview?: InstallmentChangePreviewResolvers<ContextType>;
  InstallmentChangeType?: InstallmentChangeTypeResolvers;
  RenderedBatchLetterPdfData?: RenderedBatchLetterPdfDataResolvers<ContextType>;
  RenderedLetterPdfData?: RenderedLetterPdfDataResolvers<ContextType>;
  LetterPdfCourseDetails?: LetterPdfCourseDetailsResolvers<ContextType>;
  TextBlockPreviewResult?: TextBlockPreviewResultResolvers<ContextType>;
  TextBlockPreviewCurrent?: TextBlockPreviewCurrentResolvers<ContextType>;
  TextBlockPreviewRecipient?: TextBlockPreviewRecipientResolvers<ContextType>;
  TextBlockPreviewSummary?: TextBlockPreviewSummaryResolvers<ContextType>;
  TenantRecipientType?: TenantRecipientTypeResolvers<ContextType>;
  ReversalInvoiceWithPagination?: ReversalInvoiceWithPaginationResolvers<ContextType>;
  ScheduledPaymentSummary?: ScheduledPaymentSummaryResolvers<ContextType>;
  ScheduledPaymentSummaryPart?: ScheduledPaymentSummaryPartResolvers<ContextType>;
  CourseHistoryWithPagination?: CourseHistoryWithPaginationResolvers<ContextType>;
  SettingEndUserAppHistory?: SettingEndUserAppHistoryResolvers<ContextType>;
  SharedLoginStaff?: SharedLoginStaffResolvers<ContextType>;
  StaffVisibilityRules?: StaffVisibilityRulesResolvers<ContextType>;
  StaffVisibilityRow?: StaffVisibilityRowResolvers<ContextType>;
  StaffVisibilityLevel?: StaffVisibilityLevelResolvers;
  StaffVisibilityRulesHistoryEntry?: StaffVisibilityRulesHistoryEntryResolvers<ContextType>;
  SwissQRFileOverviewWithPagination?: SwissQrFileOverviewWithPaginationResolvers<ContextType>;
  SwissQRFileOverview?: SwissQrFileOverviewResolvers<ContextType>;
  SwissQRRecordContext?: SwissQrRecordContextResolvers<ContextType>;
  SwissQRRecordContextEvent?: SwissQrRecordContextEventResolvers<ContextType>;
  SwissQRRecordContextRate?: SwissQrRecordContextRateResolvers<ContextType>;
  Template?: TemplateResolvers<ContextType>;
  TemplatesWithPagination?: TemplatesWithPaginationResolvers<ContextType>;
  TenantActivitySummary?: TenantActivitySummaryResolvers<ContextType>;
  TenantDeletionImpact?: TenantDeletionImpactResolvers<ContextType>;
  EntityCount?: EntityCountResolvers<ContextType>;
  TenantDeletionStatus?: TenantDeletionStatusResolvers<ContextType>;
  TenantMetrics?: TenantMetricsResolvers<ContextType>;
  TenantMetricsAiSummary?: TenantMetricsAiSummaryResolvers<ContextType>;
  TenantMetricsAiInsight?: TenantMetricsAiInsightResolvers<ContextType>;
  TenantMetricsAiEvidence?: TenantMetricsAiEvidenceResolvers<ContextType>;
  TenantMetricsAiSummaryStatus?: TenantMetricsAiSummaryStatusResolvers;
  TenantNotification?: TenantNotificationResolvers<ContextType>;
  TenantNotificationStatus?: TenantNotificationStatusResolvers;
  TenantSeatUsage?: TenantSeatUsageResolvers<ContextType>;
  TenantStaffMember?: TenantStaffMemberResolvers<ContextType>;
  KoOrganizationWithPagination?: KoOrganizationWithPaginationResolvers<ContextType>;
  TransferOldBookingOption?: TransferOldBookingOptionResolvers;
  TransferPriceKind?: TransferPriceKindResolvers;
  TransferBulkPlanPreview?: TransferBulkPlanPreviewResolvers<ContextType>;
  TransferBulkPlanRow?: TransferBulkPlanRowResolvers<ContextType>;
  TransferPlanPreview?: TransferPlanPreviewResolvers<ContextType>;
  TransferAttendedLessonsPreview?: TransferAttendedLessonsPreviewResolvers<ContextType>;
  TransferCarriedOverItem?: TransferCarriedOverItemResolvers<ContextType>;
  TransferCommunicationDefaults?: TransferCommunicationDefaultsResolvers<ContextType>;
  TransferCutoffPreview?: TransferCutoffPreviewResolvers<ContextType>;
  TransferCutoffRatePreview?: TransferCutoffRatePreviewResolvers<ContextType>;
  TransferItemReview?: TransferItemReviewResolvers<ContextType>;
  TransferOldBookingPlan?: TransferOldBookingPlanResolvers<ContextType>;
  TransferOldBookingTreatment?: TransferOldBookingTreatmentResolvers;
  TransferOldBookingOptionPreview?: TransferOldBookingOptionPreviewResolvers<ContextType>;
  TransferPartialSourcePreview?: TransferPartialSourcePreviewResolvers<ContextType>;
  TransferPriceOptionPreview?: TransferPriceOptionPreviewResolvers<ContextType>;
  TransferPlannedRate?: TransferPlannedRateResolvers<ContextType>;
  TransferSurplusHandlingPreview?: TransferSurplusHandlingPreviewResolvers<ContextType>;
  TransferSurplusHandling?: TransferSurplusHandlingResolvers;
  TransferSurplusMollieRefundPreview?: TransferSurplusMollieRefundPreviewResolvers<ContextType>;
  TransferSurplusRefundPayment?: TransferSurplusRefundPaymentResolvers<ContextType>;
  TransferCreditedBalanceHandling?: TransferCreditedBalanceHandlingResolvers;
  WithdrawalRequest?: WithdrawalRequestResolvers<ContextType>;
  WithdrawalStatus?: WithdrawalStatusResolvers;
  Mutation?: MutationResolvers<ContextType>;
  SetupScriptResult?: SetupScriptResultResolvers<ContextType>;
  AutoMergeStartResult?: AutoMergeStartResultResolvers<ContextType>;
  AutoMergeDryRunResult?: AutoMergeDryRunResultResolvers<ContextType>;
  AutoMergeDryRunPair?: AutoMergeDryRunPairResolvers<ContextType>;
  BroadcastTenantNotificationResult?: BroadcastTenantNotificationResultResolvers<ContextType>;
  TenantNotificationResultType?: TenantNotificationResultTypeResolvers<ContextType>;
  CancelRestHandling?: CancelRestHandlingResolvers;
  MolliePaymentResult?: MolliePaymentResultResolvers<ContextType>;
  Sms77FormatApiResponse?: Sms77FormatApiResponseResolvers<ContextType>;
  BulkJobResult?: BulkJobResultResolvers<ContextType>;
  BookingWithCourseLessons?: BookingWithCourseLessonsResolvers<ContextType>;
  RentType?: RentTypeResolvers;
  EmailTypeEnum?: EmailTypeEnumResolvers;
  CreateMailjetSenderOutput?: CreateMailjetSenderOutputResolvers<ContextType>;
  CreateOrganizationResult?: CreateOrganizationResultResolvers<ContextType>;
  WithdrawalEndUserAppResult?: WithdrawalEndUserAppResultResolvers<ContextType>;
  ErasureReportType?: ErasureReportTypeResolvers<ContextType>;
  ErasureCounterType?: ErasureCounterTypeResolvers<ContextType>;
  ErasureLinkedBookerType?: ErasureLinkedBookerTypeResolvers<ContextType>;
  ErasureWarningType?: ErasureWarningTypeResolvers<ContextType>;
  ExecuteBulkTransferResult?: ExecuteBulkTransferResultResolvers<ContextType>;
  ExecuteBulkTransferRowResult?: ExecuteBulkTransferRowResultResolvers<ContextType>;
  TransferInvoiceRef?: TransferInvoiceRefResolvers<ContextType>;
  TransferSurplusOutcome?: TransferSurplusOutcomeResolvers<ContextType>;
  TransferSurplusRefundResult?: TransferSurplusRefundResultResolvers<ContextType>;
  SettledBookingCorrectionResult?: SettledBookingCorrectionResultResolvers<ContextType>;
  BookingDeleteActionType?: BookingDeleteActionTypeResolvers;
  ExecuteTransferResult?: ExecuteTransferResultResolvers<ContextType>;
  PasswordResetLinkType?: PasswordResetLinkTypeResolvers<ContextType>;
  ScheduledPaymentPreview?: ScheduledPaymentPreviewResolvers<ContextType>;
  ScheduledPaymentSimple?: ScheduledPaymentSimpleResolvers<ContextType>;
  TenantDeletionResult?: TenantDeletionResultResolvers<ContextType>;
  NewsletterUnsubscribeImportResult?: NewsletterUnsubscribeImportResultResolvers<ContextType>;
  Ko9SchemaInfoType?: Ko9SchemaInfoTypeResolvers<ContextType>;
  Ko9PreviewResultType?: Ko9PreviewResultTypeResolvers<ContextType>;
  Ko9PreviewRowType?: Ko9PreviewRowTypeResolvers<ContextType>;
  Ko9RollbackResultType?: Ko9RollbackResultTypeResolvers<ContextType>;
  Ko9SaveResult?: Ko9SaveResultResolvers<ContextType>;
  Ko9ConnectionTestResult?: Ko9ConnectionTestResultResolvers<ContextType>;
  LogLevelType?: LogLevelTypeResolvers;
  AttendeeMergeResult?: AttendeeMergeResultResolvers<ContextType>;
  MollieCreateClientLinkResult?: MollieCreateClientLinkResultResolvers<ContextType>;
  BankTransactionRecordAllResult?: BankTransactionRecordAllResultResolvers<ContextType>;
  BankImportRematchAllResult?: BankImportRematchAllResultResolvers<ContextType>;
  CheckoutBlockerCode?: CheckoutBlockerCodeResolvers;
  EndUserEventStep?: EndUserEventStepResolvers;
  EndUserReportedEventType?: EndUserReportedEventTypeResolvers;
  ResetScheduledPaymentsOfCourseResult?: ResetScheduledPaymentsOfCourseResultResolvers<ContextType>;
  ResetScheduledPaymentsOfBookingResult?: ResetScheduledPaymentsOfBookingResultResolvers<ContextType>;
  Rate?: RateResolvers<ContextType>;
  RateDetail?: RateDetailResolvers<ContextType>;
  ResetPaymentPlanOfInvoicedLessonBookingResult?: ResetPaymentPlanOfInvoicedLessonBookingResultResolvers<ContextType>;
  ResetPaymentPlanBlockedReason?: ResetPaymentPlanBlockedReasonResolvers;
  ResetPaymentPlanRateSnapshot?: ResetPaymentPlanRateSnapshotResolvers<ContextType>;
  MollieManualReconciliationResult?: MollieManualReconciliationResultResolvers<ContextType>;
  Admin?: AdminResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  BlankMailTypes?: BlankMailTypesResolvers;
  MailjetEmailTemplates?: MailjetEmailTemplatesResolvers;
  Sms77JsonResponse?: Sms77JsonResponseResolvers<ContextType>;
  Sms77Message?: Sms77MessageResolvers<ContextType>;
  BankCounterpartKind?: BankCounterpartKindResolvers;
  SupportReportKind?: SupportReportKindResolvers;
  AttendanceListFontSize?: AttendanceListFontSizeResolvers;
  UpdateCourseAndBookingsResult?: UpdateCourseAndBookingsResultResolvers<ContextType>;
  CourseLessonBookingsPreview?: CourseLessonBookingsPreviewResolvers<ContextType>;
  LessonInstructorScope?: LessonInstructorScopeResolvers;
  MollieInvoiceSendMode?: MollieInvoiceSendModeResolvers;
  MollieRefundMode?: MollieRefundModeResolvers;
  VatAppearance?: VatAppearanceResolvers;
  BundesbankImportResult?: BundesbankImportResultResolvers<ContextType>;
  UploadedContentImage?: UploadedContentImageResolvers<ContextType>;
  VoidPaymentLinkResult?: VoidPaymentLinkResultResolvers<ContextType>;
  AutoMergeRun?: AutoMergeRunResolvers<ContextType>;
  Base?: BaseResolvers<ContextType>;
  LookupType?: LookupTypeResolvers;
  BookableOptions?: BookableOptionsResolvers<ContextType>;
  BookableOptionsError?: BookableOptionsErrorResolvers;
  BookableOptionsResult?: BookableOptionsResultResolvers<ContextType>;
  BookingHistoryWithPagination?: BookingHistoryWithPaginationResolvers<ContextType>;
  BookingRestrictionError?: BookingRestrictionErrorResolvers<ContextType>;
  BookingWithPaymentAction?: BookingWithPaymentActionResolvers<ContextType>;
  MolliePaymentAction?: MolliePaymentActionResolvers<ContextType>;
  CourseDetailsLessonBookings?: CourseDetailsLessonBookingsResolvers<ContextType>;
  CourseLessonBookingAttendanceList?: CourseLessonBookingAttendanceListResolvers<ContextType>;
  CourseWithPaginationWithEnabledCourses?: CourseWithPaginationWithEnabledCoursesResolvers<ContextType>;
  DuplicateMatch?: DuplicateMatchResolvers<ContextType>;
  Ko9ImportCredentials?: Ko9ImportCredentialsResolvers<ContextType>;
  MailSentStatus?: MailSentStatusResolvers;
  MollieConnection?: MollieConnectionResolvers<ContextType>;
  SecureIdentity?: SecureIdentityResolvers<ContextType>;
  Sms77AnalyticBase?: Sms77AnalyticBaseResolvers<ContextType>;
  Sms77JournalBase?: Sms77JournalBaseResolvers<ContextType>;
  StaffLogin?: StaffLoginResolvers<ContextType>;
  TenantDeletionLog?: TenantDeletionLogResolvers<ContextType>;
  WithEnabledCourse?: WithEnabledCourseResolvers<ContextType>;
};

